import { Directive, ElementRef, Renderer2, NgModule, Injectable, Pipe, EventEmitter, ɵɵdefineInjectable, Inject, ɵɵinject, forwardRef, Input, SecurityContext, TemplateRef, ViewContainerRef, Component, Output, ViewChild, ViewEncapsulation, HostBinding, ViewChildren, ChangeDetectionStrategy, ChangeDetectorRef, ContentChild, HostListener, RendererStyleFlags2, Optional, NgZone, Injector, ComponentFactoryResolver, ApplicationRef, INJECTOR, ContentChildren, Version, RendererFactory2 } from '@angular/core';
import { FocusMonitor, A11yModule, CdkTrapFocus } from '@angular/cdk/a11y';
import { CommonModule, DOCUMENT, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, fromEvent, Subscription, ReplaySubject, BehaviorSubject } from 'rxjs';
import { map, debounceTime, filter } from 'rxjs/operators';
import { __spread, __extends, __values, __assign } from 'tslib';
import { Platform } from '@angular/cdk/platform';
import { NgbTabset, NgbDropdown, NgbTooltip, NgbTooltipModule, NgbDatepickerConfig, NgbDateParserFormatter, NgbProgressbarModule, NgbDropdownItem, NgbDropdownMenu, NgbActiveModal, NgbModal, NgbModalModule, NgbModalConfig, NgbPopover, NgbDropdownModule, NgbTypeaheadModule, NgbTimepicker, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { Directionality } from '@angular/cdk/bidi';
import { trigger, transition, animate, keyframes, style, state } from '@angular/animations';
import { NG_VALUE_ACCESSOR, FormsModule, NG_VALIDATORS, FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { NavigationEnd, Router, RouterLinkActive, RouterModule } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/focus-monitor/focus-monitor.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable directive-selector */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/a11y';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from '@angular/cdk/platform';
import * as ɵngcc4 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc5 from '@angular/platform-browser';
import * as ɵngcc6 from '@angular/cdk/bidi';
import * as ɵngcc7 from '@angular/common';
import * as ɵngcc8 from '@angular/forms';
import * as ɵngcc9 from '@angular/cdk/scrolling';
import * as ɵngcc10 from '@angular/router';

var _c0 = ["alert"];
function BentoAlertItemComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c1 = function (a0, a1) { return { options: a0, index: a1 }; };
function BentoAlertItemComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, BentoAlertItemComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.options.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c1, ctx_r1.options, ctx_r1.index));
} }
function BentoAlertItemComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function BentoAlertItemComponent_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.closeAlert(); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind2(1, 1, "BENTO_UI_ALERT_CLOSE_BUTTON", _r0.closeButtonLabel));
} }
function BentoAlertItemComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r4.options.msg, ɵngcc0.ɵɵsanitizeHtml);
} }
var _c2 = function (a0, a1) { return [a0, a1]; };
function BentoAlertComponent_bento_alert_item_2_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-alert-item", 2);
    ɵngcc0.ɵɵlistener("close", function BentoAlertComponent_bento_alert_item_2_Template_bento_alert_item_close_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); var ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onAlertClose($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var alert_r1 = ctx.$implicit;
    var i_r2 = ctx.index;
    ɵngcc0.ɵɵproperty("@fadeInOut", undefined)("options", alert_r1)("index", i_r2);
    ɵngcc0.ɵɵattribute("rel", "bento-alert-" + i_r2);
} }
var _c3 = ["class", "badge"];
var _c4 = ["*"];
var _c5 = ["checkbox"];
var _c6 = ["icon"];
var _c7 = ["rowTemplate"];
var _c8 = ["defaultRowTemp"];
function BentoListComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c9 = function (a0, a1) { return { _data: a0, row: a1 }; };
var _c10 = function (a0, a1, a2, a3) { return { row: a0, options: a1, data: a2, index: a3 }; };
function BentoListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BentoListComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var row_r3 = ctx.$implicit;
    var index_r4 = ctx.index;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rowTemp)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(5, _c10, row_r3, ctx_r0.options, ɵngcc0.ɵɵpureFunction2(2, _c9, ctx_r0._data, row_r3), index_r4));
} }
function BentoListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var $row_r6 = ctx.row;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", $row_r6, " ");
} }
var _c11 = ["defaultRowTemplate"];
var _c12 = function (a0) { return { width: a0 }; };
function BentoComboboxListComponent_div_0_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r10 = ctx.$implicit;
    var i_r11 = ctx.index;
    var ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c12, column_r10.width));
    ɵngcc0.ɵɵattribute("id", ctx_r8.uid + "-header-" + i_r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8._listOptions.comboboxOptions.headerTranslation[column_r10.name ? column_r10.name : column_r10], " ");
} }
function BentoComboboxListComponent_div_0_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    var ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵstyleProp("width", ctx_r9._scrollBarWidth, "px");
} }
function BentoComboboxListComponent_div_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoComboboxListComponent_div_0_ng_template_1_div_0_Template, 2, 5, "div", 8);
    ɵngcc0.ɵɵtemplate(1, BentoComboboxListComponent_div_0_ng_template_1_div_1_Template, 1, 2, "div", 9);
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6._listOptions.comboboxOptions.columns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6._scrollBarWidth);
} }
function BentoComboboxListComponent_div_0_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r13 = ctx.$implicit;
    var i_r14 = ctx.index;
    var ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵattribute("id", ctx_r12.uid + "-header-" + i_r14);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r13.name ? column_r13.name : column_r13, " ");
} }
function BentoComboboxListComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoComboboxListComponent_div_0_ng_template_2_div_0_Template, 2, 2, "div", 12);
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7._listOptions.comboboxOptions.columns);
} }
function BentoComboboxListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, BentoComboboxListComponent_div_0_ng_template_1_Template, 2, 2, "ng-template", 7);
    ɵngcc0.ɵɵtemplate(2, BentoComboboxListComponent_div_0_ng_template_2_Template, 1, 1, "ng-template", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0._listOptions.comboboxOptions.headerTranslation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0._listOptions.comboboxOptions.headerTranslation);
} }
function BentoComboboxListComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c13 = function (a0, a1, a2) { return { options: a0, data: a1, index: a2 }; };
function BentoComboboxListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    var _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵlistener("click", function BentoComboboxListComponent_ng_template_3_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); var $data_r15 = ctx.data; var $i_r17 = ctx.index; var $o_r16 = ctx.options; return $o_r16.onRowClick($event, $data_r15.row, $i_r17); });
    ɵngcc0.ɵɵtemplate(1, BentoComboboxListComponent_ng_template_3_ng_container_1_Template, 1, 0, "ng-container", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var $data_r15 = ctx.data;
    var $o_r16 = ctx.options;
    var $i_r17 = ctx.index;
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("height", ctx_r2._listOptions.comboboxOptions.itemHeight, "px");
    ɵngcc0.ɵɵproperty("ngClass", ($i_r17 == $o_r16.selectedIndex ? "selected " : "") + ($i_r17 == $o_r16.highlightedIndex ? "highlighted " : ""));
    ɵngcc0.ɵɵattribute("id", ctx_r2.uid + "-" + $i_r17)("aria-setsize", ctx_r2._dataSize)("aria-posinset", $i_r17 + 1)("role", ctx_r2._isGrid ? "row" : "option")("aria-selected", $i_r17 == $o_r16.selectedIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", $o_r16.rowTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(10, _c13, $o_r16.comboboxOptions, $data_r15, $i_r17));
} }
function BentoComboboxListComponent_ng_template_5_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r27 = ctx.$implicit;
    var i_r28 = ctx.index;
    var $data_r21 = ɵngcc0.ɵɵnextContext(2).data;
    var ctx_r26 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c12, column_r27.width));
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r26.uid + "-header-" + i_r28);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", $data_r21.row[column_r27.name ? column_r27.name : column_r27], " ");
} }
function BentoComboboxListComponent_ng_template_5_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoComboboxListComponent_ng_template_5_ng_template_0_div_0_Template, 2, 5, "div", 17);
} if (rf & 2) {
    var $options_r22 = ɵngcc0.ɵɵnextContext().options;
    ɵngcc0.ɵɵproperty("ngForOf", $options_r22.columns);
} }
function BentoComboboxListComponent_ng_template_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r31 = ɵngcc0.ɵɵnextContext();
    var $options_r22 = ctx_r31.options;
    var $data_r21 = ctx_r31.data;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", $options_r22.label ? $data_r21.row[$options_r22.label] : $data_r21.row, " ");
} }
function BentoComboboxListComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoComboboxListComponent_ng_template_5_ng_template_0_Template, 1, 1, "ng-template", 7);
    ɵngcc0.ɵɵtemplate(1, BentoComboboxListComponent_ng_template_5_div_1_Template, 2, 1, "div", 16);
} if (rf & 2) {
    var $options_r22 = ctx.options;
    ɵngcc0.ɵɵproperty("ngIf", $options_r22.columns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !$options_r22.columns);
} }
function BentoComboboxListComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 20);
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
} if (rf & 2) {
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 1, "BENTO_UI_CBOX_A11Y_NO_RESULTS"));
} }
var _c14 = ["input"];
var _c15 = ["listContainer"];
var _c16 = ["footerContainer"];
function BentoComboboxComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "BENTO_UI_CBOX_INPUT_LABEL"), "\n");
} }
function BentoComboboxComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "i", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2._isDisabled ? "disabled " : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("bento-icon-caret-up-filled", ctx_r2.isListVisible && !ctx_r2.up || !ctx_r2.isListVisible && ctx_r2.up)("bento-icon-caret-down-filled", !ctx_r2.isListVisible && !ctx_r2.up || ctx_r2.isListVisible && ctx_r2.up);
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r2.uid + "-dropdown-aria")("tabindex", ctx_r2._isDisabled ? "-1" : "0")("aria-hidden", ctx_r2._isDisabled);
} }
function BentoComboboxComponent_div_12_div_4_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 24);
} if (rf & 2) {
    var button_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", button_r8.icon);
} }
function BentoComboboxComponent_div_12_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "bentoStringReplace");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(2, 1, button_r8.label, "_ITEM_", ctx_r10._inputLabel || button_r8.defaultItemText), " ");
} }
function BentoComboboxComponent_div_12_div_4_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵelementStart(2, "button", 21);
    ɵngcc0.ɵɵlistener("click", function BentoComboboxComponent_div_12_div_4_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r14); var button_r8 = ctx.$implicit; var ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13._onFooterButtonClick(button_r8); })("keydown", function BentoComboboxComponent_div_12_div_4_Template_button_keydown_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var button_r8 = ctx.$implicit; var ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15._onFooterItemKeydown($event, button_r8); });
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(4, BentoComboboxComponent_div_12_div_4_i_4_Template, 1, 1, "i", 22);
    ɵngcc0.ɵɵtemplate(5, BentoComboboxComponent_div_12_div_4_span_5_Template, 3, 5, "span", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r8 = ctx.$implicit;
    var ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind1(3, 6, "BENTO_UI_CBOX_OPTIONS"));
    ɵngcc0.ɵɵproperty("disabled", button_r8.disableWhenHasResult && ctx_r7._list.length > 0);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r7.isListVisible ? "0" : "-1")("aria-label", button_r8.ariaLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", button_r8.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (button_r8.label == null ? null : button_r8.label.length) > 0);
} }
function BentoComboboxComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14, 15);
    ɵngcc0.ɵɵelementStart(2, "div", 16);
    ɵngcc0.ɵɵelementStart(3, "div", 17);
    ɵngcc0.ɵɵtemplate(4, BentoComboboxComponent_div_12_div_4_Template, 6, 8, "div", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.options.footerItems);
} }
function BentoContextualHeaderComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function BentoContextualHeaderComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); var ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3._onBackButtonClick(); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelement(3, "i", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind1(2, 5, "BENTO_UI_CONTEXTUAL_HEADER_BACK"));
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.backButtonDisabled);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 3, "BENTO_UI_CONTEXTUAL_HEADER_BACK"));
} }
function BentoContextualHeaderComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function BentoContextualHeaderComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function BentoContextualHeaderComponent_div_4_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "figure", 15);
    ɵngcc0.ɵɵelement(1, "img", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", item_r5.icon, ɵngcc0.ɵɵsanitizeUrl);
} }
function BentoContextualHeaderComponent_div_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "figure", 15);
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(item_r5.icon);
} }
function BentoContextualHeaderComponent_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r16 = ɵngcc0.ɵɵnextContext();
    var $index_r6 = ctx_r16.index;
    var item_r5 = ctx_r16.$implicit;
    ɵngcc0.ɵɵattribute("rel", "sub-" + $index_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r5.subtitle);
} }
function BentoContextualHeaderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, BentoContextualHeaderComponent_div_4_div_1_Template, 1, 0, "div", 9);
    ɵngcc0.ɵɵtemplate(2, BentoContextualHeaderComponent_div_4_div_2_Template, 1, 0, "div", 9);
    ɵngcc0.ɵɵtemplate(3, BentoContextualHeaderComponent_div_4_ng_template_3_Template, 2, 1, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, BentoContextualHeaderComponent_div_4_ng_template_5_Template, 2, 2, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementStart(7, "div", 12);
    ɵngcc0.ɵɵelementStart(8, "div", 13);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, BentoContextualHeaderComponent_div_4_div_10_Template, 2, 2, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r5 = ctx.$implicit;
    var $index_r6 = ctx.index;
    var _r9 = ɵngcc0.ɵɵreference(4);
    var _r11 = ɵngcc0.ɵɵreference(6);
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngbTooltip", ctx_r1._getTooltipFromHeader($index_r6));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.icon && !ctx_r1._isImage(item_r5.icon))("ngIfThen", _r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.icon && ctx_r1._isImage(item_r5.icon))("ngIfThen", _r9);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵattribute("rel", $index_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r5.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.subtitle);
} }
function BentoContextualHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "button", 19);
    ɵngcc0.ɵɵlistener("click", function BentoContextualHeaderComponent_div_5_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17._onCustomButtonClick($event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.customButton.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.customButton.label, " ");
} }
var _c17 = ["postRemovalMessage"];
function BentoFileSelectorComponent_ng_template_20_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵlistener("@fileFadeIn.start", function BentoFileSelectorComponent_ng_template_20_div_0_Template_div_animation_fileFadeIn_start_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7._animateNext($event); });
    ɵngcc0.ɵɵpipe(1, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(2, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(3, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵpipe(5, "bentoFileSizeFilter");
    ɵngcc0.ɵɵpipe(6, "bentoTranslate");
    ɵngcc0.ɵɵpipe(7, "bentoTranslate");
    ɵngcc0.ɵɵelementStart(8, "span");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "bentoFileSizeFilter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "button", 17);
    ɵngcc0.ɵɵlistener("click", function BentoFileSelectorComponent_ng_template_20_div_0_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r8); var i_r6 = ctx.index; var ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9._onRemoveClick(i_r6); });
    ɵngcc0.ɵɵpipe(12, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(13, "bentoTranslate");
    ɵngcc0.ɵɵelement(14, "i", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(15, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var file_r5 = ctx.$implicit;
    var i_r6 = ctx.index;
    var ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r4._disabledFiles[i_r6] && ctx_r4.disableDuringUpload)("loading", ctx_r4._disabledFiles[i_r6]);
    ɵngcc0.ɵɵproperty("@fileFadeIn", ctx_r4._animateSquenceCounter >= i_r6 ? "in" : "hidden");
    ɵngcc0.ɵɵattribute("rel", "file_" + i_r6)("aria-busy", ctx_r4._disabledFiles[i_r6])("aria-label", ɵngcc0.ɵɵpipeBind3(1, 13, ɵngcc0.ɵɵpipeBind3(2, 17, ɵngcc0.ɵɵpipeBind3(3, 21, ɵngcc0.ɵɵpipeBind1(4, 25, "BENTO_UI_FILE_SELECTOR_FILE_NAME"), "_FILE_NAME_", file_r5.name), "_NUM_FILES_", ctx_r4._fileList.length), "_FILE_NUMBER_", i_r6 + 1) + " " + (ctx_r4.showFileSize ? "(" + ɵngcc0.ɵɵpipeBind1(5, 27, file_r5.size) + ")" : "") + " " + (ctx_r4._fileProgressList[i_r6] >= 0 && ctx_r4._fileProgressList[i_r6] < 100 ? ɵngcc0.ɵɵpipeBind1(6, 29, "BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS") : ctx_r4._fileProgressList[i_r6] ? ɵngcc0.ɵɵpipeBind1(7, 31, "BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE") : ""));
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵtextInterpolate2("", file_r5.name, "", ctx_r4.showFileSize ? " (" + ɵngcc0.ɵɵpipeBind1(10, 33, file_r5.size) + ")" : "", "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4._disabledFiles[i_r6] && ctx_r4.disableDuringUpload);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(12, 35, ɵngcc0.ɵɵpipeBind1(13, 39, "BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON"), "_FILE_NAME_", file_r5.name));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(41, _c12, ctx_r4._fileProgressList[i_r6] + "%"));
} }
function BentoFileSelectorComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoFileSelectorComponent_ng_template_20_div_0_Template, 16, 43, "div", 15);
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1._fileList);
} }
function BentoFileSelectorComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("@FadeInOut", undefined);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "BENTO_UI_FILE_SELECTOR_DROP_FILED_ACTION_LABEL"), " ");
} }
function BentoFileSelectorComponent_div_29_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 25);
    ɵngcc0.ɵɵpipe(1, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
} if (rf & 2) {
    var ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind3(1, 1, ɵngcc0.ɵɵpipeBind1(2, 5, "BENTO_UI_FILE_SELECTOR_FILE_EXT_ERROR"), "_ACCEPT_", ctx_r11.accept), ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoFileSelectorComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "span", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "i", 23);
    ɵngcc0.ɵɵelementStart(5, "span", 24);
    ɵngcc0.ɵɵelement(6, "span", 25);
    ɵngcc0.ɵɵpipe(7, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(8, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(9, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(10, BentoFileSelectorComponent_div_29_span_10_Template, 3, 7, "span", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var file_r10 = ctx.$implicit;
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 3, "BENTO_UI_FILE_SELECTOR_A11Y_CAUTION"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind3(7, 5, ɵngcc0.ɵɵpipeBind3(8, 9, ɵngcc0.ɵɵpipeBind1(9, 13, "BENTO_UI_FILE_SELECTOR_FILE_ERROR"), "_DISPLAY_TYPE_", file_r10.displayType), "_NAME_", file_r10.name), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.accept);
} }
function BentoMegamenuDefaultComponent_div_1_a_1_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 7);
} if (rf & 2) {
    var item_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", item_r3.icon + (ctx_r5.isRtl ? " ml-1" : " mr-1"));
} }
function BentoMegamenuDefaultComponent_div_1_a_1_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function BentoMegamenuDefaultComponent_div_1_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); var item_r3 = ctx.$implicit; var column_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onMenuClick($event, item_r3, column_r1); });
    ɵngcc0.ɵɵtemplate(1, BentoMegamenuDefaultComponent_div_1_a_1_i_1_Template, 1, 1, "i", 5);
    ɵngcc0.ɵɵelement(2, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r3 = ctx.$implicit;
    var itemIndex_r4 = ctx.index;
    var column_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("active", item_r3.active)("disabled", item_r3.disabled || column_r1.disabled);
    ɵngcc0.ɵɵattribute("id", item_r3.id ? item_r3.id : null)("href", (item_r3.anchor == null ? null : item_r3.anchor.href) || "#", ɵngcc0.ɵɵsanitizeUrl)("aria-describedby", column_r1.id && itemIndex_r4 === 0 ? column_r1.id : null)("aria-disabled", item_r3.disabled || column_r1.disabled)("aria-selected", item_r3.active)("aria-current", item_r3.useAriaCurrent && item_r3.active ? "page" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r3.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", (item_r3.anchor == null ? null : item_r3.anchor.text) || item_r3.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoMegamenuDefaultComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, BentoMegamenuDefaultComponent_div_1_a_1_Template, 3, 12, "a", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r1 = ctx.$implicit;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("item", column_r1)("hTagRank", ctx_r0.hTagRank);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", column_r1.menu);
} }
function BentoMegaMenuFlowComponent_div_0_a_1_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    var item_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", item_r3.icon + (ctx_r5.isRtl ? " ml-1" : " mr-1"));
} }
function BentoMegaMenuFlowComponent_div_0_a_1_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 3);
    ɵngcc0.ɵɵlistener("click", function BentoMegaMenuFlowComponent_div_0_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); var item_r3 = ctx.$implicit; var column_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onMenuClick($event, item_r3, column_r1); });
    ɵngcc0.ɵɵtemplate(1, BentoMegaMenuFlowComponent_div_0_a_1_i_1_Template, 1, 1, "i", 4);
    ɵngcc0.ɵɵelement(2, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r3 = ctx.$implicit;
    var itemIndex_r4 = ctx.index;
    var column_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("active", item_r3.active)("disabled", item_r3.disabled || column_r1.disabled);
    ɵngcc0.ɵɵattribute("id", item_r3.id ? item_r3.id : null)("href", (item_r3.anchor == null ? null : item_r3.anchor.href) || "#", ɵngcc0.ɵɵsanitizeUrl)("aria-describedby", column_r1.id && itemIndex_r4 === 0 ? column_r1.id : null)("aria-disabled", item_r3.disabled || column_r1.disabled)("aria-selected", item_r3.active)("aria-current", item_r3.useAriaCurrent && item_r3.active ? "page" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r3.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", (item_r3.anchor == null ? null : item_r3.anchor.text) || item_r3.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoMegaMenuFlowComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, BentoMegaMenuFlowComponent_div_0_a_1_Template, 3, 12, "a", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r1 = ctx.$implicit;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", column_r1.label ? "bento-megamenu-whole-column " : "")("item", column_r1)("hTagRank", ctx_r0.hTagRank);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", column_r1.menu);
} }
var _c18 = ["takeoverMenus"];
var _c19 = ["takeoverHeaders"];
function BentoMegamenuTakeoverComponent_li_3_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 12);
} }
function BentoMegamenuTakeoverComponent_li_3_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    var column_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", column_r4.icon + (ctx_r6.isRtl ? " ml-1" : " mr-1"));
} }
function BentoMegamenuTakeoverComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵlistener("keydown", function BentoMegamenuTakeoverComponent_li_3_Template_li_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onHeaderKeydown($event); });
    ɵngcc0.ɵɵelementStart(1, "a", 8);
    ɵngcc0.ɵɵlistener("click", function BentoMegamenuTakeoverComponent_li_3_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var column_r4 = ctx.$implicit; var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onHeaderFocus($event, column_r4); })("focus", function BentoMegamenuTakeoverComponent_li_3_Template_a_focus_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var column_r4 = ctx.$implicit; var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onHeaderFocus($event, column_r4); })("mouseenter", function BentoMegamenuTakeoverComponent_li_3_Template_a_mouseenter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var column_r4 = ctx.$implicit; var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onHeaderFocus($event, column_r4); });
    ɵngcc0.ɵɵtemplate(2, BentoMegamenuTakeoverComponent_li_3_i_2_Template, 1, 0, "i", 9);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtemplate(4, BentoMegamenuTakeoverComponent_li_3_i_4_Template, 1, 1, "i", 10);
    ɵngcc0.ɵɵelement(5, "span", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r4 = ctx.$implicit;
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r1.currentColumn === column_r4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r4.menu);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", column_r4.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", column_r4.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoMegamenuTakeoverComponent_li_6_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    var item_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", item_r13.icon + (ctx_r14.isRtl ? " ml-1" : " mr-1"));
} }
function BentoMegamenuTakeoverComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    var _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵlistener("keydown", function BentoMegamenuTakeoverComponent_li_6_Template_li_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onSubMenuKeydown($event); });
    ɵngcc0.ɵɵelementStart(1, "a", 14);
    ɵngcc0.ɵɵlistener("click", function BentoMegamenuTakeoverComponent_li_6_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); var item_r13 = ctx.$implicit; var ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onMenuClick($event, item_r13, ctx_r18.currentColumn); });
    ɵngcc0.ɵɵtemplate(2, BentoMegamenuTakeoverComponent_li_6_i_2_Template, 1, 1, "i", 10);
    ɵngcc0.ɵɵelement(3, "span", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r13 = ctx.$implicit;
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", item_r13.disabled || ctx_r3.currentColumn.disabled);
    ɵngcc0.ɵɵattribute("href", (item_r13.anchor == null ? null : item_r13.anchor.href) || "#", ɵngcc0.ɵɵsanitizeUrl)("aria-disabled", item_r13.disabled || ctx_r3.currentColumn.disabled)("aria-current", item_r13.useAriaCurrent && item_r13.active ? "page" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r13.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", (item_r13.anchor == null ? null : item_r13.anchor.text) || item_r13.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoMegamenuComponent_bento_megamenu_takeover_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bento-megamenu-takeover", 4);
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("widthElRef", ctx_r0.widthElRef)("items", ctx_r0.items)("isRtl", ctx_r0.isRtl)("appendToEl", ctx_r0.bentoAppendTo);
} }
function BentoMegamenuComponent_bento_megamenu_flow_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bento-megamenu-flow", 5);
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("widthElRef", ctx_r1.widthElRef)("width", ctx_r1.maxWidth)("columnWidth", ctx_r1.flowColumnWidth)("items", ctx_r1.items)("isRtl", ctx_r1.isRtl)("appendToEl", ctx_r1.bentoAppendTo)("hTagRank", ctx_r1.hTagRank);
} }
function BentoMegamenuComponent_bento_megamenu_default_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bento-megamenu-default", 6);
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("widthElRef", ctx_r2.widthElRef)("maxWidth", ctx_r2.maxWidth)("items", ctx_r2.items)("appendToEl", ctx_r2.bentoAppendTo)("isRtl", ctx_r2.isRtl)("hTagRank", ctx_r2.hTagRank);
} }
var _c20 = ["closeButton"];
var _c21 = ["cancelButton"];
function BentoModalConfirmationComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8, 9);
    ɵngcc0.ɵɵlistener("click", function BentoModalConfirmationComponent_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.activeModal.dismiss("Close"); });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelement(3, "i", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind2(2, 1, "BENTO_UI_MODAL_CONFIRMATION_CLOSE", ctx_r0.closeButtonText));
} }
function BentoModalConfirmationComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate2("modal-confirmation-icon ", ctx_r1.iconName, " text-", ctx_r1.iconColorType, "");
} }
var _c22 = ["topPanel"];
var _c23 = ["list"];
var _c24 = ["searchField"];
var _c25 = ["showAll"];
function BentoMultiselectListComponent_ng_template_23_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c26 = function (a0, a1, a2) { return { item: a0, index: a1, options: a2 }; };
function BentoMultiselectListComponent_ng_template_23_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵlistener("click", function BentoMultiselectListComponent_ng_template_23_ng_container_0_Template_div_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r15 = ɵngcc0.ɵɵnextContext(); var $row_r7 = ctx_r15.row; var $index_r6 = ctx_r15.index; var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13._onRowClick($event, $row_r7, $index_r6); });
    ɵngcc0.ɵɵelement(2, "bento-checkbox", 17);
    ɵngcc0.ɵɵelementStart(3, "div", 18);
    ɵngcc0.ɵɵtemplate(4, BentoMultiselectListComponent_ng_template_23_ng_container_0_ng_container_4_Template, 1, 0, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r16 = ɵngcc0.ɵɵnextContext();
    var $index_r6 = ctx_r16.index;
    var $row_r7 = ctx_r16.row;
    var $o_r8 = ctx_r16.options;
    var ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", "row" + ctx_r9._uid + $index_r6)("aria-selected", !!$o_r8.checkStatusRef.get($row_r7))("aria-setsize", ctx_r9._dataSize)("aria-posinset", $index_r6 + 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", $o_r8.checkStatusRef.get($row_r7));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.listItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(7, _c26, $row_r7, $index_r6, $o_r8));
} }
function BentoMultiselectListComponent_ng_template_23_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    var _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵlistener("click", function BentoMultiselectListComponent_ng_template_23_ng_template_1_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r19 = ɵngcc0.ɵɵnextContext(); var $row_r7 = ctx_r19.row; var $index_r6 = ctx_r19.index; var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17._onRowClick($event, $row_r7, $index_r6); });
    ɵngcc0.ɵɵelement(1, "bento-checkbox", 17);
    ɵngcc0.ɵɵelementStart(2, "div", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r20 = ɵngcc0.ɵɵnextContext();
    var $index_r6 = ctx_r20.index;
    var $row_r7 = ctx_r20.row;
    var $o_r8 = ctx_r20.options;
    var ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", $index_r6 === ctx_r11._activeIndex ? "focused " : "");
    ɵngcc0.ɵɵattribute("id", "row" + ctx_r11._uid + $index_r6)("aria-selected", !!$o_r8.checkStatusRef.get($row_r7))("aria-setsize", ctx_r11._dataSize)("aria-posinset", $index_r6 + 1)("title", $row_r7.isSelectAll ? "" : $row_r7.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", $o_r8.checkStatusRef.get($row_r7));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", $row_r7.isSelectAll ? ɵngcc0.ɵɵpipeBind2(4, 8, $row_r7.name, ctx_r11.selectAllText) : $row_r7.name, " ");
} }
function BentoMultiselectListComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoMultiselectListComponent_ng_template_23_ng_container_0_Template, 5, 11, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(1, BentoMultiselectListComponent_ng_template_23_ng_template_1_Template, 5, 11, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    var $row_r7 = ctx.row;
    var _r10 = ɵngcc0.ɵɵreference(2);
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.listItemTemplate && !$row_r7.isSelectAll)("ngIfElse", _r10);
} }
var _c27 = ["overlay"];
var _c28 = ["toggleButton"];
var _c29 = ["containerWrapper"];
var _c30 = ["doneButton"];
var _c31 = ["overlayContainer"];
var _c32 = ["overlayFooter"];
var _c33 = ["label"];
function BentoMultiselectOverlayComponent_button_19_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22, 23);
    ɵngcc0.ɵɵlistener("click", function BentoMultiselectOverlayComponent_button_19_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9._onDoneClick($event, true); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(3, 1, "BENTO_UI_MULTISELECT_OVERLAY_CANCEL", ctx_r6.cancelButtonText || ctx_r6.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_CANCEL), " ");
} }
var _c34 = ["buttonUp"];
var _c35 = ["buttonDown"];
var _c36 = ["leftPanel"];
var _c37 = ["rightPanel"];
var _c38 = ["leftPanelWrapper"];
var _c39 = ["rightPanelWrapper"];
var _c40 = ["content"];
var _c41 = ["topbar"];
var _c42 = ["leftPanelFocus"];
var _c43 = ["rightPanelFocus"];
function BentoOffCanvasMenuComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function BentoOffCanvasMenuComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10._toggleLeft(); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelement(2, "i", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 1, "BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON"));
} }
function BentoOffCanvasMenuComponent_div_8_button_3_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function BentoOffCanvasMenuComponent_div_8_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.isOpen = false; });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngbTooltip", ɵngcc0.ɵɵpipeBind1(2, 5, "BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON"))("placement", ctx_r13._isRTL ? "right" : "left");
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 3, "BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON"));
} }
function BentoOffCanvasMenuComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20, 21);
    ɵngcc0.ɵɵelementStart(2, "div", 22);
    ɵngcc0.ɵɵtemplate(3, BentoOffCanvasMenuComponent_div_8_button_3_Template, 3, 7, "button", 23);
    ɵngcc0.ɵɵelementStart(4, "h2", 24, 25);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(8, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("cdkTrapFocusAutoCapture", !ctx_r4._alwaysOpen);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4._alwaysOpen);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(7, 3, "BENTO_UI_OFF_CANVAS_MENU_ASIDE_TITLE ", ctx_r4.menuTitle), " ");
} }
function BentoOffCanvasMenuComponent_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "button", 26);
    ɵngcc0.ɵɵlistener("click", function BentoOffCanvasMenuComponent_div_14_div_2_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); var ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.rightIsOpen = false; });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "h2", 24, 30);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngbTooltip", ɵngcc0.ɵɵpipeBind1(3, 6, "BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON"))("placement", ctx_r18._isRTL ? "right" : "left");
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 4, "BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(7, 8, "BENTO_UI_OFF_CANVAS_MENU_RIGHT_ASIDE_TITLE", ctx_r18.rightMenuTitle), " ");
} }
function BentoOffCanvasMenuComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27, 28);
    ɵngcc0.ɵɵtemplate(2, BentoOffCanvasMenuComponent_div_14_div_2_Template, 8, 11, "div", 29);
    ɵngcc0.ɵɵprojection(3, 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.showRightPanelHeader);
} }
var _c44 = [[["", "bento-off-canvas-menu-topbar", ""]], [["", "bento-off-canvas-menu-content", ""]], [["", "bento-off-canvas-menu-aside", ""]], [["", "bento-off-canvas-menu-aside-right", ""]]];
var _c45 = ["[bento-off-canvas-menu-topbar]", "[bento-off-canvas-menu-content]", "[bento-off-canvas-menu-aside]", "[bento-off-canvas-menu-aside-right]"];
function BentoPaginationComponent_div_2_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} }
function BentoPaginationComponent_div_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
} if (rf & 2) {
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(1, 1, "BENTO_UI_PAGINATION_A11Y_FIRST_BUTTON"), " ");
} }
function BentoPaginationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function BentoPaginationComponent_div_2_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10._goToPage(1, $event); });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(4, BentoPaginationComponent_div_2_i_4_Template, 1, 0, "i", 11);
    ɵngcc0.ɵɵtemplate(5, BentoPaginationComponent_div_2_ng_template_5_Template, 2, 3, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r8 = ɵngcc0.ɵɵreference(6);
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.page === 1 || ctx_r0.maxPage === 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.page === 1 || ctx_r0.maxPage === 1)("ngbTooltip", !ctx_r0.useStrings ? ɵngcc0.ɵɵpipeBind2(2, 7, "BENTO_UI_PAGINATION_A11Y_FIRST", ctx_r0.customTranslation["BENTO_UI_PAGINATION_A11Y_FIRST"]) : "");
    ɵngcc0.ɵɵattribute("aria-label", !ctx_r0.useStrings ? ɵngcc0.ɵɵpipeBind2(3, 10, "BENTO_UI_PAGINATION_A11Y_FIRST", ctx_r0.customTranslation["BENTO_UI_PAGINATION_A11Y_FIRST"]) : "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.useStrings)("ngIfElse", _r8);
} }
function BentoPaginationComponent_div_3_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 17);
} }
function BentoPaginationComponent_div_3_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
} if (rf & 2) {
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(1, 1, "BENTO_UI_PAGINATION_A11Y_PREVIOUS_BUTTON"), " ");
} }
function BentoPaginationComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "button", 15);
    ɵngcc0.ɵɵlistener("click", function BentoPaginationComponent_div_3_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15._goToPage(ctx_r15.page - 1, $event); });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(4, BentoPaginationComponent_div_3_i_4_Template, 1, 0, "i", 16);
    ɵngcc0.ɵɵtemplate(5, BentoPaginationComponent_div_3_ng_template_5_Template, 2, 3, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r13 = ɵngcc0.ɵɵreference(6);
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("first-button", !ctx_r1.boundaryLinks)("disabled", ctx_r1.page === 1 || ctx_r1.maxPage === 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.page === 1 || ctx_r1.maxPage === 1)("ngbTooltip", !ctx_r1.useStrings ? ɵngcc0.ɵɵpipeBind2(2, 9, "BENTO_UI_PAGINATION_A11Y_PREVIOUS", ctx_r1.customTranslation["BENTO_UI_PAGINATION_A11Y_PREVIOUS"]) : "");
    ɵngcc0.ɵɵattribute("aria-label", !ctx_r1.useStrings ? ɵngcc0.ɵɵpipeBind2(3, 12, "BENTO_UI_PAGINATION_A11Y_PREVIOUS", ctx_r1.customTranslation["BENTO_UI_PAGINATION_A11Y_PREVIOUS"]) : "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.useStrings)("ngIfElse", _r13);
} }
function BentoPaginationComponent_div_4_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 20);
} }
function BentoPaginationComponent_div_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
} if (rf & 2) {
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(1, 1, "BENTO_UI_PAGINATION_A11Y_NEXT_BUTTON"), " ");
} }
function BentoPaginationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    var _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function BentoPaginationComponent_div_4_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); var ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20._goToPage(ctx_r20.page + 1, $event); });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(4, BentoPaginationComponent_div_4_i_4_Template, 1, 0, "i", 19);
    ɵngcc0.ɵɵtemplate(5, BentoPaginationComponent_div_4_ng_template_5_Template, 2, 3, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r18 = ɵngcc0.ɵɵreference(6);
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("last-button", !ctx_r2.boundaryLinks)("small_margin", ctx_r2.lastButtonSmallMargin)("disabled", ctx_r2.page === ctx_r2.maxPage || ctx_r2.maxPage <= 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.page === ctx_r2.maxPage || ctx_r2.maxPage <= 1)("ngbTooltip", !ctx_r2.useStrings ? ɵngcc0.ɵɵpipeBind2(2, 11, "BENTO_UI_PAGINATION_A11Y_NEXT", ctx_r2.customTranslation["BENTO_UI_PAGINATION_A11Y_NEXT"]) : "");
    ɵngcc0.ɵɵattribute("aria-label", !ctx_r2.useStrings ? ɵngcc0.ɵɵpipeBind2(3, 14, "BENTO_UI_PAGINATION_A11Y_NEXT", ctx_r2.customTranslation["BENTO_UI_PAGINATION_A11Y_NEXT"]) : "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.useStrings)("ngIfElse", _r18);
} }
function BentoPaginationComponent_div_5_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 23);
} }
function BentoPaginationComponent_div_5_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
} if (rf & 2) {
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(1, 1, "BENTO_UI_PAGINATION_A11Y_LAST_BUTTON"), " ");
} }
function BentoPaginationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function BentoPaginationComponent_div_5_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); var ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25._goToPage(ctx_r25._getTotalPages(), $event); });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(4, BentoPaginationComponent_div_5_i_4_Template, 1, 0, "i", 22);
    ɵngcc0.ɵɵtemplate(5, BentoPaginationComponent_div_5_ng_template_5_Template, 2, 3, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r23 = ɵngcc0.ɵɵreference(6);
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r3.page === ctx_r3.maxPage || ctx_r3.maxPage <= 1)("small_margin", ctx_r3.lastButtonSmallMargin);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.page === ctx_r3.maxPage || ctx_r3.maxPage <= 1)("ngbTooltip", !ctx_r3.useStrings ? ɵngcc0.ɵɵpipeBind2(2, 9, "BENTO_UI_PAGINATION_A11Y_LAST", ctx_r3.customTranslation["BENTO_UI_PAGINATION_A11Y_LAST"]) : "");
    ɵngcc0.ɵɵattribute("aria-label", !ctx_r3.useStrings ? ɵngcc0.ɵɵpipeBind2(3, 12, "BENTO_UI_PAGINATION_A11Y_LAST", ctx_r3.customTranslation["BENTO_UI_PAGINATION_A11Y_LAST"]) : "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.useStrings)("ngIfElse", _r23);
} }
function BentoPaginationComponent_div_6_i_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 30);
} }
function BentoPaginationComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    var _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵelementStart(2, "input", 26, 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoPaginationComponent_div_6_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); var ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.paginationInputModel = $event; })("keypress", function BentoPaginationComponent_div_6_Template_input_keypress_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); var ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31._goToPage($event.target.value, $event); });
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 28);
    ɵngcc0.ɵɵlistener("click", function BentoPaginationComponent_div_6_Template_button_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); var _r27 = ɵngcc0.ɵɵreference(3); var ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32._goToPage(_r27.value, $event); });
    ɵngcc0.ɵɵpipe(6, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(7, "bentoTranslate");
    ɵngcc0.ɵɵpipe(8, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(9, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(10, BentoPaginationComponent_div_6_i_10_Template, 1, 0, "i", 29);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r4.page);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.paginationInputModel)("ngbTooltip", ɵngcc0.ɵɵpipeBind2(4, 7, "BENTO_UI_PAGINATION_A11Y_PAGE_NUM", ctx_r4.customTranslation["BENTO_UI_PAGINATION_A11Y_PAGE_NUM"]));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngbTooltip", ɵngcc0.ɵɵpipeBind3(6, 10, ɵngcc0.ɵɵpipeBind2(7, 14, "BENTO_UI_PAGINATION_A11Y_GOTO_PAGE", ctx_r4.customTranslation["BENTO_UI_PAGINATION_A11Y_GOTO_PAGE"]), "_PAGE_", ctx_r4.paginationInputModel || ctx_r4.page));
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(8, 17, ɵngcc0.ɵɵpipeBind2(9, 21, "BENTO_UI_PAGINATION_A11Y_GOTO_PAGE", ctx_r4.customTranslation["BENTO_UI_PAGINATION_A11Y_GOTO_PAGE"]), "_PAGE_", ctx_r4.paginationInputModel || ctx_r4.page));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.goIconVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.goIconVisible ? "" : ctx_r4.goToText || ɵngcc0.ɵɵpipeBind2(12, 24, "BENTO_UI_PAGINATION_GO_BUTTON", ctx_r4.customTranslation["BENTO_UI_PAGINATION_GO_BUTTON"]), " ");
} }
function BentoPaginationComponent_div_7_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 35);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r35 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", item_r35);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r35);
} }
function BentoPaginationComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    var _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "select", 32, 33);
    ɵngcc0.ɵɵlistener("change", function BentoPaginationComponent_div_7_Template_select_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r37); var _r33 = ɵngcc0.ɵɵreference(2); var ctx_r36 = ɵngcc0.ɵɵnextContext(); return ctx_r36._onItemsPerPageChange(_r33.value); });
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(4, BentoPaginationComponent_div_7_option_4_Template, 2, 2, "option", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.itemsPerPage)("ngbTooltip", ɵngcc0.ɵɵpipeBind2(3, 3, "BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE", ctx_r5.customTranslation["BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE"]));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.itemsArray);
} }
function BentoPaginationComponent_div_8_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 38);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(4, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(5, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(6, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r38 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(3, 1, ɵngcc0.ɵɵpipeBind3(4, 5, ɵngcc0.ɵɵpipeBind3(5, 9, ctx_r38.infoText || ɵngcc0.ɵɵpipeBind2(6, 13, "BENTO_UI_PAGINATION_INFO_TEXT", ctx_r38.customTranslation["BENTO_UI_PAGINATION_INFO_TEXT"]), "_START_", ctx_r38._getStartIndex()), "_END_", ctx_r38._getEndIndex()), "_MAX_", ctx_r38.totalItems), " ");
} }
function BentoPaginationComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 36);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(5, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(6, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, BentoPaginationComponent_div_8_div_7_Template, 7, 16, "div", 37);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(4, 2, ɵngcc0.ɵɵpipeBind3(5, 6, ctx_r6.infoPageText || ɵngcc0.ɵɵpipeBind2(6, 10, "BENTO_UI_PAGINATION_INFO_PAGE_TEXT", ctx_r6.customTranslation["BENTO_UI_PAGINATION_INFO_PAGE_TEXT"]), "_PAGE_", ctx_r6.page), "_PAGES_", ctx_r6._getTotalPages()), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.hideItemsPerPage !== true);
} }
function BentoScrollableToolbarItemComponent_div_0_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("class", ctx_r7.item.icon);
} }
function BentoScrollableToolbarItemComponent_div_0_button_5_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    var dropdownItem_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵattribute("class", dropdownItem_r9.icon);
} }
function BentoScrollableToolbarItemComponent_div_0_button_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function BentoScrollableToolbarItemComponent_div_0_button_5_Template_button_click_0_listener() { var dropdownItem_r9 = ctx.$implicit; return dropdownItem_r9.action && dropdownItem_r9.action(); });
    ɵngcc0.ɵɵtemplate(1, BentoScrollableToolbarItemComponent_div_0_button_5_i_1_Template, 1, 1, "i", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var dropdownItem_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", dropdownItem_r9.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dropdownItem_r9.label, " ");
} }
function BentoScrollableToolbarItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "button", 5);
    ɵngcc0.ɵɵlistener("click", function BentoScrollableToolbarItemComponent_div_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.item.action && ctx_r13.item.action(); });
    ɵngcc0.ɵɵtemplate(2, BentoScrollableToolbarItemComponent_div_0_i_2_Template, 1, 1, "i", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵtemplate(5, BentoScrollableToolbarItemComponent_div_0_button_5_Template, 3, 2, "button", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.item.disabled);
    ɵngcc0.ɵɵattribute("id", "toggleDropdown" + ctx_r0.item.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.item.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.item.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("bentoAppendTo", ctx_r0.appendTo)("autoRealign", true);
    ɵngcc0.ɵɵattribute("aria-labelledby", "toggleDropdown" + ctx_r0.item.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.item.dropdown);
} }
function BentoScrollableToolbarItemComponent_ng_template_1_div_0_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    var ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵattribute("class", ctx_r16.item.icon);
} }
function BentoScrollableToolbarItemComponent_ng_template_1_div_0_bento_megamenu_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bento-megamenu", 12);
} if (rf & 2) {
    var ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("bentoAppendTo", ctx_r17.appendTo)("autoRealign", true)("items", ctx_r17.item.megamenu)("type", ctx_r17.item.type)("maxWidth", ctx_r17.item.maxWidth)("flowColumnWidth", ctx_r17.item.flowColumnWidth)("widthElRef", ctx_r17.appendTo)("hTagRank", "3");
    ɵngcc0.ɵɵattribute("aria-label", ctx_r17.item.ariaLabel ? ctx_r17.item.ariaLabel : null);
} }
function BentoScrollableToolbarItemComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "button", 5);
    ɵngcc0.ɵɵlistener("click", function BentoScrollableToolbarItemComponent_ng_template_1_div_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); var ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.item.action && ctx_r18.item.action(); });
    ɵngcc0.ɵɵtemplate(2, BentoScrollableToolbarItemComponent_ng_template_1_div_0_i_2_Template, 1, 1, "i", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BentoScrollableToolbarItemComponent_ng_template_1_div_0_bento_megamenu_4_Template, 1, 9, "bento-megamenu", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r15.item.disabled);
    ɵngcc0.ɵɵattribute("id", "toggleDropdown" + ctx_r15.item.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.item.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r15.item.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.item.megamenu);
} }
function BentoScrollableToolbarItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoScrollableToolbarItemComponent_ng_template_1_div_0_Template, 5, 5, "div", 0);
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.item.megamenu)("ngIfElse", _r3);
} }
function BentoScrollableToolbarItemComponent_ng_template_3_ng_container_0_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngTemplateOutlet", "item.templateRef; context: {control: this.item.control}"]);
} }
var _c46 = function (a0) { return { control: a0 }; };
function BentoScrollableToolbarItemComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵtemplate(2, BentoScrollableToolbarItemComponent_ng_template_3_ng_container_0_2_Template, 1, 0, undefined, 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r20.item.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c46, ctx_r20.item.control));
} }
function BentoScrollableToolbarItemComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoScrollableToolbarItemComponent_ng_template_3_ng_container_0_Template, 3, 4, "ng-container", 13);
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    var _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.item.templateRef)("ngIfElse", _r5);
} }
function BentoScrollableToolbarItemComponent_ng_template_5_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    var ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("class", ctx_r22.item.icon);
} }
function BentoScrollableToolbarItemComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    var _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function BentoScrollableToolbarItemComponent_ng_template_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); var ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.item.action && ctx_r23.item.action(); });
    ɵngcc0.ɵɵtemplate(1, BentoScrollableToolbarItemComponent_ng_template_5_i_1_Template, 1, 1, "i", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r6.item.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.item.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.item.label, " ");
} }
function BentoScrollableToolbarComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelement(1, "bento-scrollable-toolbar-item", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r1 = ctx.$implicit;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", item_r1)("appendTo", ctx_r0.el);
} }
var _c47 = [[["", 8, "navbar-left"]], [["", 8, "navbar-right"]]];
var _c48 = [".navbar-left", ".navbar-right"];
function BentoSideNavComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("for", ctx_r0.uid + "-input");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "BENTO_UI_SIDE_NAV_SEARCH"), "\n");
} }
function BentoSideNavComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    var _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoSideNavComponent_input_1_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); var ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3._onSearchValueChange($event); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.searchValue);
    ɵngcc0.ɵɵattribute("id", ctx_r1.uid + "-input")("placeholder", ɵngcc0.ɵɵpipeBind1(1, 3, "BENTO_UI_SIDE_NAV_SEARCH"));
} }
function BentoSideNavComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 5);
} if (rf & 2) {
    var item_r5 = ctx.$implicit;
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("item", item_r5)("depth", 0)("sideNav", ctx_r2._self)("collapsible", ctx_r2.collapsible)("searchValue", ctx_r2.searchValue);
} }
var _c49 = ["rla"];
var _c50 = ["bentoSideNavItem", ""];
function BentoSideNavItemComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function BentoSideNavItemComponent_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.toggleCollapse(); });
    ɵngcc0.ɵɵelement(1, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("left", ctx_r0.isRTL ? 0 : ctx_r0.depth * 16 + 6, "px")("right", ctx_r0.isRTL ? ctx_r0.depth * 16 + 6 : 0, "px");
    ɵngcc0.ɵɵattribute("aria-controls", ctx_r0.uid + "-li")("aria-expanded", ctx_r0.isBranch && ctx_r0.collapsible ? !ctx_r0.collapsed : null)("aria-labelledby", ctx_r0.uid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.collapsed ? "bento-icon-plus-plain " : "bento-icon-minus-plain ");
} }
function BentoSideNavItemComponent_a_2_span_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c51 = function (a0) { return { item: a0 }; };
function BentoSideNavItemComponent_a_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, BentoSideNavItemComponent_a_2_span_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.sideNav.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c51, ctx_r10.item));
} }
function BentoSideNavItemComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8, 9);
    ɵngcc0.ɵɵtemplate(2, BentoSideNavItemComponent_a_2_span_2_Template, 2, 4, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r9 = ɵngcc0.ɵɵreference(1);
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r1.item == null ? null : ctx_r1.item.routerLink.href)("rel", ctx_r1.renderAriaCurrent(_r9));
    ɵngcc0.ɵɵattribute("id", ctx_r1.uid)("aria-disabled", ctx_r1.disabled)("aria-current", ctx_r1.renderAriaCurrent(_r9));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.sideNav.itemTemplate)("ngIfElse", _r3);
} }
function BentoSideNavItemComponent_ul_3_li_1_Template(rf, ctx) { if (rf & 1) {
    var _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 14);
    ɵngcc0.ɵɵlistener("selectedChange", function BentoSideNavItemComponent_ul_3_li_1_Template_li_selectedChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); var ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onChildSelectedChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subItem_r13 = ctx.$implicit;
    var ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("item", subItem_r13)("depth", ctx_r12.depth + 1)("sideNav", ctx_r12.sideNav)("collapsible", ctx_r12.collapsible);
} }
function BentoSideNavItemComponent_ul_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 12);
    ɵngcc0.ɵɵtemplate(1, BentoSideNavItemComponent_ul_3_li_1_Template, 1, 4, "li", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r2.collapsed);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.items);
} }
function BentoSideNavItemComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "span", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("branch-root", ctx_r4.isBranch);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r4.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoSideNavItemComponent_ng_template_6_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BentoSideNavItemComponent_ng_template_6_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, BentoSideNavItemComponent_ng_template_6_span_1_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.sideNav.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c51, ctx_r16.item));
} }
function BentoSideNavItemComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    var _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 16);
    ɵngcc0.ɵɵlistener("click", function BentoSideNavItemComponent_ng_template_6_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); var ctx_r18 = ɵngcc0.ɵɵnextContext(); $event.preventDefault(); return ctx_r18.onItemClick($event); });
    ɵngcc0.ɵɵtemplate(1, BentoSideNavItemComponent_ng_template_6_span_1_Template, 2, 4, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r6.disabled);
    ɵngcc0.ɵɵattribute("id", ctx_r6.uid)("href", ctx_r6.disabled || ctx_r6.isBranch && !ctx_r6.sideNav.selectableCategories ? null : "#", ɵngcc0.ɵɵsanitizeUrl)("aria-disabled", ctx_r6.disabled)("aria-current", ctx_r6.renderAriaCurrent(null))("aria-expanded", ctx_r6.isBranch && ctx_r6.collapsible ? !ctx_r6.collapsed : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.sideNav.itemTemplate)("ngIfElse", _r3);
} }
function BentoSkipLinksComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} }
function BentoSkipLinksComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, BentoSkipLinksComponent_div_0_div_1_Template, 1, 0, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "a", 2);
    ɵngcc0.ɵɵlistener("click", function BentoSkipLinksComponent_div_0_Template_a_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); var link_r1 = ctx.$implicit; var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onLinkClick($event, link_r1); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var link_r1 = ctx.$implicit;
    var i_r2 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r2 > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(link_r1.text);
} }
var _c52 = ["smartBadgeHost"];
function BentoSmartBadgeComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1, 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0._badgeDynamicClass)("ngStyle", ctx_r0._customStyle);
    ɵngcc0.ɵɵattribute("aria-live", !ctx_r0.details.staticIndicator ? "polite" : null)("aria-label", ctx_r0.ariaLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0._badgeContent, "\n");
} }
var _c53 = ["handle"];
var _c54 = ["truncatedTooltip"];
function BentoTabsLabelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} }
function BentoTabsLabelComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoTabsLabelComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4, 5);
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngbTooltip", ctx_r4.label)("placement", "top")("innerHTML", ctx_r4.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoTabsScrollComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "button", 2);
    ɵngcc0.ɵɵlistener("click", function BentoTabsScrollComponent_div_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onLeftMostClick(); });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelement(3, "i", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 4);
    ɵngcc0.ɵɵlistener("click", function BentoTabsScrollComponent_div_0_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onLeftClick(); });
    ɵngcc0.ɵɵpipe(5, "bentoTranslate");
    ɵngcc0.ɵɵelement(6, "i", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 6);
    ɵngcc0.ɵɵlistener("click", function BentoTabsScrollComponent_div_0_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onRightClick(); });
    ɵngcc0.ɵɵpipe(8, "bentoTranslate");
    ɵngcc0.ɵɵelement(9, "i", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "button", 8);
    ɵngcc0.ɵɵlistener("click", function BentoTabsScrollComponent_div_0_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onRightMostClick(); });
    ɵngcc0.ɵɵpipe(11, "bentoTranslate");
    ɵngcc0.ɵɵelement(12, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disableLeftArrows);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 8, "BENTO_UI_TABSET_SCROLL_LEFTMOST"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disableLeftArrows);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(5, 10, ctx_r0._scrollLeftLabel));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disableRightArrows);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(8, 12, ctx_r0._scrollRightLabel));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disableRightArrows);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(11, 14, "BENTO_UI_TABSET_SCROLL_RIGHTMOST"));
} }
var _c55 = ["typeaheadPill"];
var _c56 = ["pillEmptyInfo"];
function BentoTagsInputPillComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTagsInputPillComponent_div_0_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9._onInputChange($event); });
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0._isEditing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("invalid", ctx_r0._invalid);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0._isEditing)("ngModel", ctx_r0._inputText);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 6, "BENTO_UI_TAGS_INPUT_EDIT_ELEMENT"));
} }
function BentoTagsInputPillComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    var _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "input", 10, 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTagsInputPillComponent_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12._onInputChange($event); })("selectItem", function BentoTagsInputPillComponent_div_1_Template_input_selectItem_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); var ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14._onTypeaheadSelectItem($event); });
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1._isEditing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("invalid", ctx_r1._invalid);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1._inputText)("ngbTypeahead", ctx_r1.typeahead)("editable", ctx_r1.typeheadEditable)("focusFirst", ctx_r1.typeheadFocusFirst)("inputFormatter", ctx_r1.typeaheadInputFormatter)("resultFormatter", ctx_r1.typeaheadResultFormatter)("showHint", ctx_r1.typeaheadShowHint)("container", "body");
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(3, 12, "BENTO_UI_TAGS_INPUT_EDIT_ELEMENT"));
} }
function BentoTagsInputPillComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r3._isEditing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3._formatTag(ctx_r3._data[ctx_r3.tagPropertyName]), "\n");
} }
function BentoTagsInputPillComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13, 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r5._isEditing)("ngbTooltip", ctx_r5._formatTag(ctx_r5._data[ctx_r5.tagPropertyName]));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5._formatTag(ctx_r5._data[ctx_r5.tagPropertyName]), " ");
} }
function BentoTagsInputPillComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    var _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("mousedown", function BentoTagsInputPillComponent_button_7_Template_button_mousedown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16._onEditClick($event); })("keydown", function BentoTagsInputPillComponent_button_7_Template_button_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18._onKeydownEdit($event); });
    ɵngcc0.ɵɵpipe(1, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelement(3, "i", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(1, 1, ɵngcc0.ɵɵpipeBind1(2, 5, "BENTO_UI_TAGS_INPUT_EDIT"), "_LABEL_", ctx_r6._data[ctx_r6.tagPropertyName]));
} }
function BentoTagsInputPillComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    var _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function BentoTagsInputPillComponent_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); var ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19._onCloseClick(); })("keydown", function BentoTagsInputPillComponent_button_8_Template_button_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21._onKeydownClose($event); });
    ɵngcc0.ɵɵpipe(1, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelement(3, "i", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(1, 1, ɵngcc0.ɵɵpipeBind1(2, 5, "BENTO_UI_TAGS_INPUT_CLOSE"), "_LABEL_", ctx_r7._data[ctx_r7.tagPropertyName]));
} }
function BentoTagsInputPillComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 19);
} }
var _c57 = ["inputSizeRef"];
function BentoTagsInputComponent_bento_tags_input_pill_0_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-tags-input-pill", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTagsInputComponent_bento_tags_input_pill_0_Template_bento_tags_input_pill_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var i_r5 = ctx.index; var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6._onPillUpdate($event, i_r5); })("remove", function BentoTagsInputComponent_bento_tags_input_pill_0_Template_bento_tags_input_pill_remove_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8._onPillRemove($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var pill_r4 = ctx.$implicit;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-width", ctx_r0.tagMaxWidth);
    ɵngcc0.ɵɵproperty("ngModel", pill_r4)("tagEditCancel", ctx_r0.tagEditCancel)("tagEditStart", ctx_r0.tagEditStart)("disableRemove", ctx_r0.disableTagRemove)("tagPropertyName", ctx_r0.tagPropertyName)("editable", ctx_r0._editable)("validations", ctx_r0._validations)("tagFormatter", ctx_r0.tagFormatter)("typeahead", ctx_r0._typeahead)("typeheadEditable", ctx_r0.typeheadEditable)("typeheadFocusFirst", ctx_r0.typeheadFocusFirst)("typeaheadInputFormatter", ctx_r0.typeaheadInputFormatter)("typeaheadResultFormatter", ctx_r0.typeaheadResultFormatter)("typeaheadShowHint", ctx_r0.typeaheadShowHint)("typeaheadSelectItem", ctx_r0.typeaheadSelectItem)("disabled", ctx_r0._disabled)("readonly", ctx_r0.readonly);
} }
function BentoTagsInputComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTagsInputComponent_input_1_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9._onInputTextChange($event); })("keydown", function BentoTagsInputComponent_input_1_Template_input_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11._onInputKeydown($event); })("blur", function BentoTagsInputComponent_input_1_Template_input_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12._onInputBlur($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("invalid", !ctx_r1._isInputValid);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r1.placeholder);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.disableInput)("ngModel", ctx_r1._inputText);
    ɵngcc0.ɵɵattribute("id", ctx_r1._inputID)("aria-label", ctx_r1.ariaLabel ? ctx_r1.ariaLabel : null)("aria-describedby", ctx_r1.ariaDescribedby ? ctx_r1.ariaDescribedby : null)("aria-labelledby", ctx_r1.ariaLabelledby ? ctx_r1.ariaLabelledby : null);
} }
function BentoTagsInputComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTagsInputComponent_div_2_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13._onInputTextChange($event); })("keydown", function BentoTagsInputComponent_div_2_Template_input_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15._onInputKeydown($event); })("blur", function BentoTagsInputComponent_div_2_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16._onInputBlurWithTypeahead($event); })("selectItem", function BentoTagsInputComponent_div_2_Template_input_selectItem_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17._onTypeaheadSelectItem($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("invalid", !ctx_r2._isInputValid);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.placeholder);
    ɵngcc0.ɵɵproperty("hidden", ctx_r2.disableInput)("ngModel", ctx_r2._inputText)("ngbTypeahead", ctx_r2._typeahead)("editable", ctx_r2.typeheadEditable)("focusFirst", ctx_r2.typeheadFocusFirst)("inputFormatter", ctx_r2._typeaheadTagsInputFieldFormatter)("resultFormatter", ctx_r2.typeaheadResultFormatter)("showHint", ctx_r2.typeaheadShowHint);
    ɵngcc0.ɵɵattribute("id", ctx_r2._inputID)("aria-label", ctx_r2.ariaLabel ? ctx_r2.ariaLabel : null)("aria-describedby", ctx_r2.ariaDescribedby ? ctx_r2.ariaDescribedby : null)("aria-labelledby", ctx_r2.ariaLabelledby ? ctx_r2.ariaLabelledby : null);
} }
var _c58 = ["inner"];
var _c59 = ["panel"];
function BentoTileRibbonComponent_h1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
function BentoTileRibbonComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function BentoTileRibbonComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.toggleVisibility(); });
    ɵngcc0.ɵɵelement(1, "i", 16);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("bento-icon-minus-plain", !ctx_r1.ribbonHidden)("bento-icon-plus-plain", ctx_r1.ribbonHidden);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 5, ctx_r1.ribbonHidden ? "BENTO_UI_TILE_RIBBON_TOGGLE_SHOW" : "BENTO_UI_TILE_RIBBON_TOGGLE_HIDE"), " ");
} }
function BentoTileRibbonComponent_bento_ribbon_tile_12_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-ribbon-tile", 17);
    ɵngcc0.ɵɵlistener("select", function BentoTileRibbonComponent_bento_ribbon_tile_12_Template_bento_ribbon_tile_select_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8._onTileSelect($event); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r7 = ctx.$implicit;
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("item", item_r7)("width", ctx_r4.itemWidth)("template", ctx_r4.tileTemplate);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.tileAriaLabel ? ctx_r4.tileAriaLabel : ɵngcc0.ɵɵpipeBind1(1, 4, "tile"));
} }
function BentoRibbonTileComponent_ng_template_1_a_3_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵlistener("click", function BentoRibbonTileComponent_ng_template_1_a_3_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6._onLinkclick($event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.item.linkTitle, " ");
} }
function BentoRibbonTileComponent_ng_template_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c2, ctx_r4.item.indicator.icon, ctx_r4.item.indicator.class));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.item.ariaLabel || ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r4.item.indicator.i18nLabel));
} }
function BentoRibbonTileComponent_ng_template_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.item.description);
} }
function BentoRibbonTileComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, BentoRibbonTileComponent_ng_template_1_a_3_Template, 2, 1, "a", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtemplate(5, BentoRibbonTileComponent_ng_template_1_div_5_Template, 2, 7, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "p", 8);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, BentoRibbonTileComponent_ng_template_1_div_8_Template, 2, 1, "div", 9);
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.item.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.item.linkTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.item.indicator);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.item.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.item.description);
} }
function BentoRibbonTileComponent_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BentoRibbonTileComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoRibbonTileComponent_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 13);
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c51, ctx_r2.item));
} }
function BentoToastContainerComponent_ngb_toast_1_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c60 = function (a0) { return { toast: a0 }; };
function BentoToastContainerComponent_ngb_toast_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, BentoToastContainerComponent_ngb_toast_1_div_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var toast_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", toast_r1.instance.config.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c60, toast_r1.instance));
} }
function BentoToastContainerComponent_ngb_toast_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    var toast_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", toast_r1.instance.message, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToastContainerComponent_ngb_toast_1_button_4_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function BentoToastContainerComponent_ngb_toast_1_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); var toast_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.dismiss(toast_r1, true); });
    ɵngcc0.ɵɵelementStart(1, "span", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var toast_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", "btn btn-outline-" + (toast_r1.instance.config.type ? toast_r1.instance.config.type : "primary"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(toast_r1.instance.config.action);
} }
function BentoToastContainerComponent_ngb_toast_1_button_5_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function BentoToastContainerComponent_ngb_toast_1_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); var toast_r1 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.dismiss(toast_r1); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelement(2, "i", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 1, "BENTO_UI_TOAST_CLOSE_BUTTON"));
} }
function BentoToastContainerComponent_ngb_toast_1_Template(rf, ctx) { if (rf & 1) {
    var _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-toast", 2);
    ɵngcc0.ɵɵlistener("hide", function BentoToastContainerComponent_ngb_toast_1_Template_ngb_toast_hide_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); var toast_r1 = ctx.$implicit; var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.dismiss(toast_r1); });
    ɵngcc0.ɵɵtemplate(1, BentoToastContainerComponent_ngb_toast_1_div_1_Template, 2, 4, "div", 3);
    ɵngcc0.ɵɵtemplate(2, BentoToastContainerComponent_ngb_toast_1_ng_template_2_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, BentoToastContainerComponent_ngb_toast_1_button_4_Template, 3, 2, "button", 5);
    ɵngcc0.ɵɵtemplate(5, BentoToastContainerComponent_ngb_toast_1_button_5_Template, 3, 3, "button", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var toast_r1 = ctx.$implicit;
    var _r3 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("autohide", toast_r1.instance.config.duration !== 0)("delay", toast_r1.instance.config.duration || 5000)("ngClass", "bento-toast-" + toast_r1.instance.config.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", toast_r1.instance.config.template)("ngIfElse", _r3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", toast_r1.instance.hasAction);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", toast_r1.instance.showClose);
} }
var _c61 = ["bentoToolbarDropdown", ""];
function BentoToolbarDropdownComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.toolbarbutton.icon);
} }
function BentoToolbarDropdownComponent_li_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 12);
} }
function BentoToolbarDropdownComponent_li_5_ng_container_2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngTemplateOutlet", "subBtn.templateRef; context: {control: subBtn.control}"]);
} }
function BentoToolbarDropdownComponent_li_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarDropdownComponent_li_5_ng_container_2_1_Template, 1, 0, undefined, 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var subBtn_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", subBtn_r2.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c46, subBtn_r2.control));
} }
function BentoToolbarDropdownComponent_li_5_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵelement(1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subBtn_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", subBtn_r2.disabled)("active", subBtn_r2.active);
    ɵngcc0.ɵɵproperty("ngClass", subBtn_r2.class || subBtn_r2.cssClass)("details", subBtn_r2.smartbadge);
    ɵngcc0.ɵɵattribute("href", subBtn_r2.disabled ? null : subBtn_r2.anchor.href, ɵngcc0.ɵɵsanitizeUrl)("target", subBtn_r2.anchor.target)("id", subBtn_r2.id ? subBtn_r2.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", subBtn_r2.anchor.text || subBtn_r2.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarDropdownComponent_li_5_button_4_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    var subBtn_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(subBtn_r2.icon);
} }
function BentoToolbarDropdownComponent_li_5_button_4_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function BentoToolbarDropdownComponent_li_5_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); var subBtn_r2 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.clickAction(subBtn_r2); });
    ɵngcc0.ɵɵtemplate(1, BentoToolbarDropdownComponent_li_5_button_4_i_1_Template, 1, 2, "i", 1);
    ɵngcc0.ɵɵelementStart(2, "span", 2);
    ɵngcc0.ɵɵelement(3, "span", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subBtn_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", subBtn_r2.disabled ? "disabled " : "")("disabled", subBtn_r2.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("details", subBtn_r2.smartbadge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", subBtn_r2.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarDropdownComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarDropdownComponent_li_5_span_1_Template, 1, 0, "span", 8);
    ɵngcc0.ɵɵtemplate(2, BentoToolbarDropdownComponent_li_5_ng_container_2_Template, 2, 4, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(3, BentoToolbarDropdownComponent_li_5_a_3_Template, 2, 10, "a", 10);
    ɵngcc0.ɵɵtemplate(4, BentoToolbarDropdownComponent_li_5_button_4_Template, 4, 5, "button", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subBtn_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r2.separated);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r2.templateRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r2.anchor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !subBtn_r2.anchor && !subBtn_r2.templateRef);
} }
function BentoToolbarComponent_li_4_ng_container_1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 3, ["*ngTemplateOutlet", "button.templateRef; context: {control: button.control}"]);
} }
function BentoToolbarComponent_li_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_4_ng_container_1_1_Template, 1, 0, undefined, 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var button_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", button_r2.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c46, button_r2.control));
} }
function BentoToolbarComponent_li_4_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 11);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", button_r2.disabled)("active", button_r2.active);
    ɵngcc0.ɵɵproperty("ngClass", button_r2.class || button_r2.cssClass)("details", button_r2.smartbadge);
    ɵngcc0.ɵɵattribute("href", button_r2.disabled ? null : button_r2.anchor.href, ɵngcc0.ɵɵsanitizeUrl)("target", button_r2.anchor.target)("aria-selected", button_r2.active)("aria-current", button_r2.useAriaCurrent && button_r2.active ? "page" : null)("id", button_r2.id ? button_r2.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", button_r2.anchor.text || button_r2.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_4_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", button_r2.disabled)("active", button_r2.active);
    ɵngcc0.ɵɵproperty("ngClass", button_r2.class || button_r2.cssClass)("routerLink", button_r2.disabled ? null : button_r2.routerLink.href)("queryParams", button_r2.routerLink.queryParams)("fragment", button_r2.routerLink.fragment)("details", button_r2.smartbadge);
    ɵngcc0.ɵɵattribute("aria-selected", button_r2.active)("aria-current", button_r2.useAriaCurrent && button_r2.active ? "page" : null)("id", button_r2.id ? button_r2.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", button_r2.routerLink.text || button_r2.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_4_button_4_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 17);
} if (rf & 2) {
    var button_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(button_r2.icon);
} }
function BentoToolbarComponent_li_4_button_4_Template(rf, ctx) { if (rf & 1) {
    var _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function BentoToolbarComponent_li_4_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); var button_r2 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r15 = ɵngcc0.ɵɵnextContext(); button_r2.action(); return ctx_r15.moreIsOpen = false; });
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_4_button_4_i_1_Template, 1, 2, "i", 15);
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵelement(3, "span", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", button_r2.disabled)("active", button_r2.active);
    ɵngcc0.ɵɵproperty("ngClass", button_r2.class || button_r2.cssClass)("disabled", button_r2.disabled);
    ɵngcc0.ɵɵattribute("aria-selected", button_r2.active)("aria-current", button_r2.useAriaCurrent && button_r2.active ? "page" : null)("id", button_r2.id ? button_r2.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("details", button_r2.smartbadge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", button_r2.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_4_div_5_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 17);
} if (rf & 2) {
    var button_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(button_r2.icon);
} }
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 30);
} }
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_ng_container_2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 4, ["*ngTemplateOutlet", "subBtn.templateRef; context: {control: subBtn.control}"]);
} }
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_4_div_5_ul_6_li_1_ng_container_2_1_Template, 1, 0, undefined, 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var subBtn_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", subBtn_r25.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c46, subBtn_r25.control));
} }
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 31);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subBtn_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", subBtn_r25.disabled)("active", subBtn_r25.active);
    ɵngcc0.ɵɵproperty("ngClass", subBtn_r25.class || subBtn_r25.cssClass)("details", subBtn_r25.smartbadge);
    ɵngcc0.ɵɵattribute("href", subBtn_r25.disabled ? null : subBtn_r25.anchor.href, ɵngcc0.ɵɵsanitizeUrl)("target", subBtn_r25.anchor.target)("aria-selected", subBtn_r25.active)("id", subBtn_r25.id ? subBtn_r25.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", subBtn_r25.anchor.text || subBtn_r25.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 32);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subBtn_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", subBtn_r25.disabled)("active", subBtn_r25.active);
    ɵngcc0.ɵɵproperty("ngClass", subBtn_r25.class || subBtn_r25.cssClass)("routerLink", subBtn_r25.disabled ? null : subBtn_r25.routerLink.href)("queryParams", subBtn_r25.routerLink.queryParams)("fragment", subBtn_r25.routerLink.fragment)("details", subBtn_r25.smartbadge);
    ɵngcc0.ɵɵattribute("aria-selected", subBtn_r25.active)("id", subBtn_r25.id ? subBtn_r25.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", subBtn_r25.routerLink.text || subBtn_r25.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_button_5_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 17);
} if (rf & 2) {
    var subBtn_r25 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(subBtn_r25.icon);
} }
var _c62 = function (a0) { return { disabled: a0 }; };
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_button_5_Template(rf, ctx) { if (rf & 1) {
    var _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 33);
    ɵngcc0.ɵɵlistener("click", function BentoToolbarComponent_li_4_div_5_ul_6_li_1_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r39); var subBtn_r25 = ɵngcc0.ɵɵnextContext().$implicit; return subBtn_r25.action(); });
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_4_div_5_ul_6_li_1_button_5_i_1_Template, 1, 2, "i", 15);
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵelement(3, "span", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subBtn_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", subBtn_r25.class || ɵngcc0.ɵɵpureFunction1(6, _c62, subBtn_r25.disabled))("disabled", subBtn_r25.disabled);
    ɵngcc0.ɵɵattribute("id", subBtn_r25.id ? subBtn_r25.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r25.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("details", subBtn_r25.smartbadge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", subBtn_r25.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_4_div_5_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 25);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_4_div_5_ul_6_li_1_span_1_Template, 1, 0, "span", 26);
    ɵngcc0.ɵɵtemplate(2, BentoToolbarComponent_li_4_div_5_ul_6_li_1_ng_container_2_Template, 2, 4, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(3, BentoToolbarComponent_li_4_div_5_ul_6_li_1_a_3_Template, 2, 11, "a", 27);
    ɵngcc0.ɵɵtemplate(4, BentoToolbarComponent_li_4_div_5_ul_6_li_1_a_4_Template, 2, 12, "a", 28);
    ɵngcc0.ɵɵtemplate(5, BentoToolbarComponent_li_4_div_5_ul_6_li_1_button_5_Template, 4, 8, "button", 29);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var subBtn_r25 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r25.separated);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r25.templateRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r25.anchor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", subBtn_r25.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !subBtn_r25.anchor && !subBtn_r25.routerLink && !subBtn_r25.templateRef);
} }
function BentoToolbarComponent_li_4_div_5_ul_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 23);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_4_div_5_ul_6_li_1_Template, 6, 5, "li", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r41 = ɵngcc0.ɵɵnextContext(2);
    var i_r3 = ctx_r41.index;
    var button_r2 = ctx_r41.$implicit;
    var ctx_r21 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate2("id", "dropdown-menu-", ctx_r21.uniqueID, "-", i_r3, "");
    ɵngcc0.ɵɵproperty("ngClass", ctx_r21.isRTL ? "dropdown-menu-right " : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", button_r2.dropdown);
} }
function BentoToolbarComponent_li_4_div_5_bento_megamenu_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bento-megamenu", 34);
} if (rf & 2) {
    var button_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    var ctx_r22 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("bentoAppendTo", button_r2.type === "takeover" ? null : ctx_r22.elRef)("autoVerticalAlignment", false)("autoHideOnContainerScroll", false)("autoRealign", true)("items", button_r2.megamenu)("type", button_r2.type)("maxWidth", button_r2.maxWidth)("ngClass", ctx_r22.isRTL ? "dropdown-menu-right " : "")("flowColumnWidth", button_r2.flowColumnWidth)("widthElRef", ctx_r22.elRef);
    ɵngcc0.ɵɵattribute("aria-label", button_r2.ariaLabel ? button_r2.ariaLabel : null);
} }
function BentoToolbarComponent_li_4_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r45 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18, 19);
    ɵngcc0.ɵɵlistener("openChange", function BentoToolbarComponent_li_4_div_5_Template_div_openChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); var _r19 = ɵngcc0.ɵɵreference(1); var i_r3 = ɵngcc0.ɵɵnextContext().index; var ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.onDropdownOpenChange(i_r3, $event, _r19); });
    ɵngcc0.ɵɵelementStart(2, "button", 20);
    ɵngcc0.ɵɵlistener("click", function BentoToolbarComponent_li_4_div_5_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r45); var button_r2 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r46 = ɵngcc0.ɵɵnextContext(); button_r2.action ? button_r2.action() : 0; return ctx_r46.moreIsOpen = false; });
    ɵngcc0.ɵɵtemplate(3, BentoToolbarComponent_li_4_div_5_i_3_Template, 1, 2, "i", 15);
    ɵngcc0.ɵɵelementStart(4, "span", 16);
    ɵngcc0.ɵɵelement(5, "span", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, BentoToolbarComponent_li_4_div_5_ul_6_Template, 2, 4, "ul", 21);
    ɵngcc0.ɵɵtemplate(7, BentoToolbarComponent_li_4_div_5_bento_megamenu_7_Template, 1, 11, "bento-megamenu", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r48 = ɵngcc0.ɵɵnextContext();
    var button_r2 = ctx_r48.$implicit;
    var i_r3 = ctx_r48.index;
    var ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("megamenu-dropdown", button_r2.megamenu);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "dropdown-", ctx_r8.uniqueID, "-", i_r3, "");
    ɵngcc0.ɵɵproperty("placement", ctx_r8.isRTL ? "bottom right" : "bottom left");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("disabled", button_r2.disabled)("active", button_r2.active);
    ɵngcc0.ɵɵproperty("ngClass", button_r2.class || button_r2.cssClass)("disabled", button_r2.disabled);
    ɵngcc0.ɵɵattribute("aria-selected", button_r2.active)("id", button_r2.id ? button_r2.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("details", button_r2.smartbadge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", button_r2.label, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.dropdown);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.megamenu);
} }
function BentoToolbarComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_4_ng_container_1_Template, 2, 4, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, BentoToolbarComponent_li_4_a_2_Template, 2, 12, "a", 6);
    ɵngcc0.ɵɵtemplate(3, BentoToolbarComponent_li_4_a_3_Template, 2, 13, "a", 7);
    ɵngcc0.ɵɵtemplate(4, BentoToolbarComponent_li_4_button_4_Template, 4, 12, "button", 8);
    ɵngcc0.ɵɵtemplate(5, BentoToolbarComponent_li_4_div_5_Template, 8, 18, "div", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.templateRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.anchor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !button_r2.templateRef && !button_r2.anchor && !button_r2.routerLink && !button_r2.dropdown && !button_r2.megamenu);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r2.dropdown || button_r2.megamenu);
} }
function BentoToolbarComponent_li_6_li_8_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 30);
} }
function BentoToolbarComponent_li_6_li_8_ng_container_2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 5, ["*ngTemplateOutlet", "button.templateRef; context: {control: button.control}"]);
} }
function BentoToolbarComponent_li_6_li_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_6_li_8_ng_container_2_1_Template, 1, 0, undefined, 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var button_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", button_r51.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c46, button_r51.control));
} }
function BentoToolbarComponent_li_6_li_8_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 31);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", button_r51.disabled)("active", button_r51.active);
    ɵngcc0.ɵɵproperty("ngClass", button_r51.class || button_r51.cssClass)("details", button_r51.smartbadge);
    ɵngcc0.ɵɵattribute("href", button_r51.disabled ? null : button_r51.anchor.href, ɵngcc0.ɵɵsanitizeUrl)("target", button_r51.anchor.target)("aria-selected", button_r51.active)("aria-current", button_r51.useAriaCurrent && button_r51.active ? "page" : null)("id", button_r51.id ? button_r51.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", button_r51.anchor.text || button_r51.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_6_li_8_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 32);
    ɵngcc0.ɵɵelement(1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", button_r51.disabled)("active", button_r51.active);
    ɵngcc0.ɵɵproperty("ngClass", button_r51.class || button_r51.cssClass)("routerLink", button_r51.disabled ? null : button_r51.routerLink.href)("queryParams", button_r51.routerLink.queryParams)("fragment", button_r51.routerLink.fragment)("details", button_r51.smartbadge);
    ɵngcc0.ɵɵattribute("aria-selected", button_r51.active)("aria-current", button_r51.useAriaCurrent && button_r51.active ? "page" : null)("id", button_r51.id ? button_r51.id : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", button_r51.routerLink.text || button_r51.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_6_li_8_button_5_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 17);
} if (rf & 2) {
    var button_r51 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(button_r51.icon);
} }
function BentoToolbarComponent_li_6_li_8_button_5_Template(rf, ctx) { if (rf & 1) {
    var _r68 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 33);
    ɵngcc0.ɵɵlistener("click", function BentoToolbarComponent_li_6_li_8_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r68); var button_r51 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r66 = ɵngcc0.ɵɵnextContext(2); button_r51.action(); return ctx_r66.moreIsOpen = false; });
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_6_li_8_button_5_i_1_Template, 1, 2, "i", 15);
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵelement(3, "span", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("disabled", button_r51.disabled)("active", button_r51.active);
    ɵngcc0.ɵɵproperty("ngClass", button_r51.class || button_r51.cssClass)("disabled", button_r51.disabled);
    ɵngcc0.ɵɵattribute("aria-selected", button_r51.active)("aria-current", button_r51.useAriaCurrent && button_r51.active ? "page" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r51.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("details", button_r51.smartbadge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", button_r51.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function BentoToolbarComponent_li_6_li_8_div_6_Template(rf, ctx) { if (rf & 1) {
    var _r71 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵlistener("closeMore", function BentoToolbarComponent_li_6_li_8_div_6_Template_div_closeMore_0_listener() { ɵngcc0.ɵɵrestoreView(_r71); var ctx_r70 = ɵngcc0.ɵɵnextContext(3); return ctx_r70.closeMoreDropdown(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("button", button_r51);
} }
function BentoToolbarComponent_li_6_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 25);
    ɵngcc0.ɵɵtemplate(1, BentoToolbarComponent_li_6_li_8_span_1_Template, 1, 0, "span", 26);
    ɵngcc0.ɵɵtemplate(2, BentoToolbarComponent_li_6_li_8_ng_container_2_Template, 2, 4, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(3, BentoToolbarComponent_li_6_li_8_a_3_Template, 2, 12, "a", 27);
    ɵngcc0.ɵɵtemplate(4, BentoToolbarComponent_li_6_li_8_a_4_Template, 2, 13, "a", 28);
    ɵngcc0.ɵɵtemplate(5, BentoToolbarComponent_li_6_li_8_button_5_Template, 4, 11, "button", 40);
    ɵngcc0.ɵɵtemplate(6, BentoToolbarComponent_li_6_li_8_div_6_Template, 1, 1, "div", 41);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var button_r51 = ctx.$implicit;
    var i_r52 = ctx.index;
    var last_r53 = ctx.last;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r51.separated && !(i_r52 === 0 && last_r53));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r51.templateRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r51.anchor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r51.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !button_r51.anchor && !button_r51.routerLink && !button_r51.dropdown && !button_r51.templateRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r51.dropdown);
} }
function BentoToolbarComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    var _r74 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 35);
    ɵngcc0.ɵɵelementStart(1, "div", 36, 37);
    ɵngcc0.ɵɵlistener("openChange", function BentoToolbarComponent_li_6_Template_div_openChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r74); var _r49 = ɵngcc0.ɵɵreference(2); var ctx_r73 = ɵngcc0.ɵɵnextContext(); return ctx_r73.onDropdownOpenChange(ctx_r73.uniqueID, $event, _r49); });
    ɵngcc0.ɵɵelementStart(3, "button", 38);
    ɵngcc0.ɵɵlistener("click", function BentoToolbarComponent_li_6_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r74); var ctx_r75 = ɵngcc0.ɵɵnextContext(); return ctx_r75.moreIsOpen = !ctx_r75.moreIsOpen; });
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul", 39);
    ɵngcc0.ɵɵtemplate(8, BentoToolbarComponent_li_6_li_8_Template, 7, 6, "li", 24);
    ɵngcc0.ɵɵpipe(9, "bentoToolbarFilter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("visible", ctx_r1.moreVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "more-dropdown-", ctx_r1.uniqueID, "");
    ɵngcc0.ɵɵproperty("autoClose", "outside")("open", ctx_r1.moreIsOpen);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "more-button-", ctx_r1.uniqueID, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(6, 10, "BENTO_UI_NAV_TOOLBAR_MORE", ctx_r1.moreText));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.moreIsLast && !ctx_r1.isRTL ? "dropdown-menu-right " : "");
    ɵngcc0.ɵɵattribute("aria-labelledby", "more-button-" + ctx_r1.uniqueID);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(9, 13, ctx_r1.items, false));
} }
var _c63 = [[["", 8, "navbar-header"]], [["", 8, "navbar-left"]], [["", 8, "navbar-right"]], "*", "*", "*"];
var _c64 = [".navbar-header", ".navbar-left", ".navbar-right", "*", "*", "*"];
var _c65 = ["filter"];
function BentoTransferlistComponent_ul_1_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 18);
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵelementStart(2, "button", 19);
    ɵngcc0.ɵɵlistener("click", function BentoTransferlistComponent_ul_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r9); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.transferItemsClick(); });
    ɵngcc0.ɵɵelement(3, "i", 20);
    ɵngcc0.ɵɵelementStart(4, "span", 21);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.totalSelected === 0 || ctx_r0.disableTransfer);
    ɵngcc0.ɵɵattribute("aria-keyshortcuts", ctx_r0.isRtl ? "Alt+ArrowRight Enter" : "Alt+ArrowLeft Enter")("aria-describedby", "tblabel" + ctx_r0.uniqueID)("aria-disabled", ctx_r0.totalSelected === 0 || ctx_r0.disableTransfer);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(6, 5, "BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE", ctx_r0.transferBtnText), " ");
} }
function BentoTransferlistComponent_ul_9_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 18);
    ɵngcc0.ɵɵelementStart(1, "li");
    ɵngcc0.ɵɵelementStart(2, "button", 19);
    ɵngcc0.ɵɵlistener("click", function BentoTransferlistComponent_ul_9_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.transferItemsClick(); });
    ɵngcc0.ɵɵelementStart(3, "span", 21);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "i", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.totalSelected === 0 || ctx_r2.disableTransfer);
    ɵngcc0.ɵɵattribute("aria-keyshortcuts", !ctx_r2.isRtl ? "Alt+ArrowRight Enter" : "Alt+ArrowLeft Enter")("aria-describedby", "tblabel" + ctx_r2.uniqueID)("aria-disabled", ctx_r2.totalSelected === 0 || ctx_r2.disableTransfer);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(5, 5, "BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD", ctx_r2.transferBtnText), " ");
} }
function BentoTransferlistComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "p", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 25);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(6, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(7, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", "tblabel" + ctx_r3.uniqueID);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.title, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.totalSelected > 0 ? ɵngcc0.ɵɵpipeBind3(5, 3, ɵngcc0.ɵɵpipeBind3(6, 7, ɵngcc0.ɵɵpipeBind2(7, 11, "BENTO_UI_TRANSFER_BOX_SUB_TITLE", ctx_r3.subTitle), "_SELECTED_", ctx_r3.totalSelected), "_TOTAL_", ctx_r3.pageInfo.totalItems) : ctx_r3.pageInfo.totalItems, " ");
} }
function BentoTransferlistComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 26);
    ɵngcc0.ɵɵlistener("click", function BentoTransferlistComponent_span_16_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); var col_r12 = ctx.$implicit; var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onHeaderClick(col_r12); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "i", 27);
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var col_r12 = ctx.$implicit;
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", col_r12.header, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattributeInterpolate2("aria-label", "", ɵngcc0.ɵɵpipeBind1(3, 4, "BENTO_UI_TRANSFER_BOX_BASIC_A11Y_SORT_BY"), " ", col_r12.header, "");
    ɵngcc0.ɵɵproperty("ngClass", ((ctx_r5.colHeaderSort[col_r12.binding] == null ? null : ctx_r5.colHeaderSort[col_r12.binding].sortDirection) === "asc" ? "bento-icon-chevron-up " : "") + ((ctx_r5.colHeaderSort[col_r12.binding] == null ? null : ctx_r5.colHeaderSort[col_r12.binding].sortDirection) === "desc" ? "bento-icon-chevron-down " : ""));
} }
function BentoTransferlistComponent_div_18_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var col_r18 = ctx.$implicit;
    var item_r15 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r15[col_r18.binding]);
} }
function BentoTransferlistComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    var _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵlistener("click", function BentoTransferlistComponent_div_18_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); var item_r15 = ctx.$implicit; var i_r16 = ctx.index; var ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onRowClick(item_r15, i_r16); });
    ɵngcc0.ɵɵelementStart(1, "label", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "bento-checkbox", 29);
    ɵngcc0.ɵɵlistener("click", function BentoTransferlistComponent_div_18_Template_bento_checkbox_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r21); var item_r15 = ctx.$implicit; var i_r16 = ctx.index; var ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.onRowClick(item_r15, i_r16); })("ngModelChange", function BentoTransferlistComponent_div_18_Template_bento_checkbox_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); var item_r15 = ctx.$implicit; var ctx_r23 = ɵngcc0.ɵɵnextContext(); return (ctx_r23.selection[item_r15[ctx_r23.columnKey]] = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, BentoTransferlistComponent_div_18_span_6_Template, 2, 1, "span", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r15 = ctx.$implicit;
    var i_r16 = ctx.index;
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r6.selection[item_r15[ctx_r6.columnKey]] ? "selected " : "") + (ctx_r6.focusID === i_r16 ? "focused " : ""));
    ɵngcc0.ɵɵattribute("id", "tb" + ctx_r6.uniqueID + "opt" + i_r16)("aria-selected", !!ctx_r6.selection[item_r15[ctx_r6.columnKey]])("aria-setsize", ctx_r6.renderData.length)("aria-posinset", i_r16 + 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "cb-", ctx_r6.uniqueID, "-i");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(3, 12, ɵngcc0.ɵɵpipeBind1(4, 16, "BENTO_UI_TRANSFER_BOX_BASIC_A11Y_CHECKBOX_LABEL"), "_ROW_ID_", item_r15[ctx_r6.columnKey]), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "cb-", ctx_r6.uniqueID, "-i");
    ɵngcc0.ɵɵproperty("tabIndex", 0 - 1)("ngModel", ctx_r6.selection[item_r15[ctx_r6.columnKey]]);
    ɵngcc0.ɵɵattribute("aria-labelledby", "cb" + ctx_r6.uniqueID + "-i");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.columnDefinitions);
} }
function BentoTransferlistComponent_bento_pagination_19_Template(rf, ctx) { if (rf & 1) {
    var _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-pagination", 31, 32);
    ɵngcc0.ɵɵlistener("pageChange", function BentoTransferlistComponent_bento_pagination_19_Template_bento_pagination_pageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); var ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.pageInfo.page = $event; })("pageChange", function BentoTransferlistComponent_bento_pagination_19_Template_bento_pagination_pageChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); var ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.onPageChange(); })("itemsPerPageChange", function BentoTransferlistComponent_bento_pagination_19_Template_bento_pagination_itemsPerPageChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); var ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.onItemsPerPageChange(); })("itemsPerPageChange", function BentoTransferlistComponent_bento_pagination_19_Template_bento_pagination_itemsPerPageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); var ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.pageInfo.pageSize = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("page", ctx_r7.pageInfo.page)("goToLink", false)("directionLinks", true)("boundaryLinks", false)("totalItems", ctx_r7.pageInfo.totalItems)("itemsPerPage", ctx_r7.pageInfo.pageSize);
} }
var _c66 = ["boxOne"];
var _c67 = ["boxTwo"];
var _c68 = function (a0) { return { height: a0 }; };
var _c69 = ["itemLabel"];
var _c70 = ["componentEl"];
function BentoTreeItemComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function BentoTreeItemComponent_button_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onExpandClick($event); });
    ɵngcc0.ɵɵpipe(1, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵpipe(4, "bentoStringReplace");
    ɵngcc0.ɵɵpipe(5, "bentoTranslate");
    ɵngcc0.ɵɵpipe(6, "bentoTranslate");
    ɵngcc0.ɵɵelement(7, "i", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind3(4, 12, ctx_r1.options.getCollapsed(ctx_r1.root.id) ? ɵngcc0.ɵɵpipeBind1(5, 16, "BENTO_UI_TREE_EXPAND") : ɵngcc0.ɵɵpipeBind1(6, 18, "BENTO_UI_TREE_COLLAPSE"), "_LABEL_", ctx_r1.itemLabelString));
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.options.disabled);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind3(1, 4, ctx_r1.options.getCollapsed(ctx_r1.root.id) ? ɵngcc0.ɵɵpipeBind1(2, 8, "BENTO_UI_TREE_EXPAND") : ɵngcc0.ɵɵpipeBind1(3, 10, "BENTO_UI_TREE_COLLAPSE"), "_LABEL_", ctx_r1.itemLabelString));
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.options.getCollapsed(ctx_r1.root.id) ? "bento-icon-plus-plain" : "bento-icon-minus-plain");
} }
function BentoTreeItemComponent_bento_checkbox_3_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-checkbox", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTreeItemComponent_bento_checkbox_3_Template_bento_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onCheckChanged($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.options.getChecked(ctx_r2.root.id))("indeterminate", ctx_r2.options.getIndeterminate(ctx_r2.root.id))("disabled", ctx_r2.options.disabled);
    ɵngcc0.ɵɵattribute("id", "checkbox-" + ctx_r2.uid)("aria-describedby", "label-" + ctx_r2.uid);
} }
function BentoTreeItemComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 13);
    ɵngcc0.ɵɵlistener("click", function BentoTreeItemComponent_i_4_Template_i_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onItemClick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r3.treeItem[ctx_r3.root.itemIconProp]);
} }
function BentoTreeItemComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BentoTreeItemComponent_div_9_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    var _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-tree-item", 17);
    ɵngcc0.ɵɵlistener("itemCheckChange", function BentoTreeItemComponent_div_9_ng_template_2_Template_bento_tree_item_itemCheckChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onChildItemCheckChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r14 = ctx.$implicit;
    var isLast_r15 = ctx.last;
    var i_r16 = ctx.index;
    var ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", item_r14.$bentoTreeItemOption && item_r14.$bentoTreeItemOption.isHidden)("root", ctx_r13.root)("parent", ctx_r13.self)("treeItem", item_r14)("labelTemplateRef", ctx_r13.labelTemplateRef)("isLast", isLast_r15)("showCheckbox", ctx_r13.showCheckbox)("ariaLevel", ctx_r13.ariaLevel + 1)("ariaIndex", i_r16 + 1)("ariaSiblings", ctx_r13.treeItem[ctx_r13.root.itemChildrenProp]);
} }
function BentoTreeItemComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵtemplate(2, BentoTreeItemComponent_div_9_ng_template_2_Template, 1, 10, "ng-template", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r6.options.getCollapsed(ctx_r6.root.id));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.treeItem[ctx_r6.root.itemChildrenProp]);
} }
var _c71 = function (a0, a1, a2) { return { item: a0, itemUID: a1, treeRoot: a2 }; };
var _c72 = ["defaultItemLabelTemplate"];
function BentoTreeComponent_bento_expand_collapse_button_group_0_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-expand-collapse-button-group", 3);
    ɵngcc0.ɵɵlistener("expand", function BentoTreeComponent_bento_expand_collapse_button_group_0_Template_bento_expand_collapse_button_group_expand_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.expandAll(); })("collapse", function BentoTreeComponent_bento_expand_collapse_button_group_0_Template_bento_expand_collapse_button_group_collapse_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.collapseAll(); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("expandAllTitle", ɵngcc0.ɵɵpipeBind1(1, 2, "BENTO_UI_TREE_EXPAND_ALL"))("collapseAllTitle", ɵngcc0.ɵɵpipeBind1(2, 4, "BENTO_UI_TREE_COLLAPSE_ALL"));
} }
function BentoTreeComponent_div_1_bento_tree_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bento-tree-item", 7);
} if (rf & 2) {
    var item_r8 = ctx.$implicit;
    var i_r9 = ctx.index;
    var ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    var _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("hidden", item_r8.$bentoTreeItemOption && item_r8.$bentoTreeItemOption.isHidden)("root", ctx_r7._self)("treeItem", item_r8)("showCheckbox", ctx_r7.showCheckboxes)("labelTemplateRef", ctx_r7.itemLabelTemplate || _r2)("ariaLevel", 1)("ariaIndex", i_r9 + 1)("ariaSiblings", ctx_r7.treeItems);
} }
function BentoTreeComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵtemplate(2, BentoTreeComponent_div_1_bento_tree_item_2_Template, 1, 8, "bento-tree-item", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.treeItems);
} }
function BentoTreeComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var n_r10 = ctx.item;
    var r_r11 = ctx.treeRoot;
    var uid_r12 = ctx.itemUID;
    ɵngcc0.ɵɵattribute("id", "label-" + uid_r12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", n_r10[r_r11.itemLabelProp], " ");
} }
var _c73 = ["viewport"];
function BentoTreeViewComponent_bento_expand_collapse_button_group_0_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-expand-collapse-button-group", 5);
    ɵngcc0.ɵɵlistener("expand", function BentoTreeViewComponent_bento_expand_collapse_button_group_0_Template_bento_expand_collapse_button_group_expand_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.expandAllGroups(); })("collapse", function BentoTreeViewComponent_bento_expand_collapse_button_group_0_Template_bento_expand_collapse_button_group_collapse_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.collapseAllGroups(); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("expandAllTitle", ɵngcc0.ɵɵpipeBind1(1, 2, "BENTO_UI_TREE_VIEW_EXPAND_ALL"))("collapseAllTitle", ɵngcc0.ɵɵpipeBind1(2, 4, "BENTO_UI_TREE_VIEW_COLLAPSE_ALL"));
} }
function BentoTreeViewComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c74 = function (a0, a1, a2, a3) { return { item: a0, options: a1, index: a2, rowID: a3 }; };
function BentoTreeViewComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BentoTreeViewComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var item_r8 = ctx.$implicit;
    var i_r9 = ctx.index;
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c74, item_r8, item_r8.$bentoTreeItemOption, i_r9, ctx_r2.uid + "-" + i_r9));
} }
function BentoTreeViewComponent_ng_template_4_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function BentoTreeViewComponent_ng_template_4_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); var item_r11 = ɵngcc0.ɵɵnextContext().item; var ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20._onExpandCollapseClick(item_r11); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵpipe(3, "bentoTranslate");
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelement(5, "i", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r23 = ɵngcc0.ɵɵnextContext();
    var options_r12 = ctx_r23.options;
    var rowID_r13 = ctx_r23.rowID;
    var ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", options_r12.disabled)("ngbTooltip", options_r12.getCollapsed(ctx_r14.id) ? ɵngcc0.ɵɵpipeBind1(3, 9, "BENTO_UI_TREE_VIEW_EXPAND") : ɵngcc0.ɵɵpipeBind1(4, 11, "BENTO_UI_TREE_VIEW_COLLAPSE"));
    ɵngcc0.ɵɵattribute("aria-label", options_r12.getCollapsed(ctx_r14.id) ? ɵngcc0.ɵɵpipeBind1(1, 5, "BENTO_UI_TREE_VIEW_EXPAND") : ɵngcc0.ɵɵpipeBind1(2, 7, "BENTO_UI_TREE_VIEW_COLLAPSE"))("aria-describedby", "label-" + rowID_r13);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngClass", options_r12.getCollapsed(ctx_r14.id) ? "bento-icon-plus-plain" : "bento-icon-minus-plain");
} }
function BentoTreeViewComponent_ng_template_4_bento_checkbox_4_Template(rf, ctx) { if (rf & 1) {
    var _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-checkbox", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function BentoTreeViewComponent_ng_template_4_bento_checkbox_4_Template_bento_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); var item_r11 = ɵngcc0.ɵɵnextContext().item; var ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24._onCheckChanged($event, item_r11); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r27 = ɵngcc0.ɵɵnextContext();
    var options_r12 = ctx_r27.options;
    var rowID_r13 = ctx_r27.rowID;
    var ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", options_r12.getChecked(ctx_r15.id))("indeterminate", options_r12.getIndeterminate(ctx_r15.id))("disabled", options_r12.disabled);
    ɵngcc0.ɵɵattribute("id", "checkbox-" + rowID_r13);
} }
var _c75 = function (a1) { return ["bui-tree-item-cta-icon", a1]; };
function BentoTreeViewComponent_ng_template_4_i_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 16);
} if (rf & 2) {
    var item_r11 = ɵngcc0.ɵɵnextContext().item;
    var ctx_r16 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c75, item_r11[ctx_r16.itemIconProp]));
} }
function BentoTreeViewComponent_ng_template_4_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c76 = function (a0, a1, a2) { return { item: a0, options: a1, rowID: a2 }; };
function BentoTreeViewComponent_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtemplate(1, BentoTreeViewComponent_ng_template_4_div_7_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r30 = ɵngcc0.ɵɵnextContext();
    var item_r11 = ctx_r30.item;
    var options_r12 = ctx_r30.options;
    var rowID_r13 = ctx_r30.rowID;
    var ctx_r17 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r17.itemLabelTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c76, item_r11, options_r12, rowID_r13));
} }
function BentoTreeViewComponent_ng_template_4_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r11 = ɵngcc0.ɵɵnextContext().item;
    var ctx_r19 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r11[ctx_r19.itemLabelProp], " ");
} }
function BentoTreeViewComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    var _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, BentoTreeViewComponent_ng_template_4_button_1_Template, 6, 13, "button", 8);
    ɵngcc0.ɵɵelementStart(2, "label", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BentoTreeViewComponent_ng_template_4_bento_checkbox_4_Template, 1, 4, "bento-checkbox", 10);
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵlistener("click", function BentoTreeViewComponent_ng_template_4_Template_div_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); var item_r11 = ctx.item; var ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32._onItemCTAClick($event.target, item_r11); });
    ɵngcc0.ɵɵtemplate(6, BentoTreeViewComponent_ng_template_4_i_6_Template, 1, 3, "i", 12);
    ɵngcc0.ɵɵtemplate(7, BentoTreeViewComponent_ng_template_4_div_7_Template, 2, 6, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, BentoTreeViewComponent_ng_template_4_ng_template_8_Template, 2, 1, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    var item_r11 = ctx.item;
    var options_r12 = ctx.options;
    var rowID_r13 = ctx.rowID;
    var _r18 = ɵngcc0.ɵɵreference(9);
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("padding-left", !ctx_r4.isRTL ? options_r12.level * ctx_r4._paddingLeft : 0, "px")("padding-right", ctx_r4.isRTL ? options_r12.level * ctx_r4._paddingLeft : 0, "px");
    ɵngcc0.ɵɵproperty("ngClass", options_r12.getSelected(ctx_r4.id) ? "selected" : "");
    ɵngcc0.ɵɵattribute("id", rowID_r13)("aria-checked", ctx_r4.showCheckboxes ? options_r12.getChecked(ctx_r4.id) : null)("aria-selected", options_r12.getSelected(ctx_r4.id) ? options_r12.getSelected(ctx_r4.id) : null)("aria-expanded", item_r11[ctx_r4.itemChildrenProp] ? !options_r12.getCollapsed(ctx_r4.id) : null)("aria-level", options_r12.level)("aria-posinset", options_r12.index)("aria-setsize", options_r12.siblingSize);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r11[ctx_r4.itemChildrenProp]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", "label-" + rowID_r13)("for", "checkbox-" + rowID_r13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r11[ctx_r4.itemLabelProp], " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.showCheckboxes && !options_r12.hideCheckbox);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", "cta-" + rowID_r13)("tabindex", ctx_r4.disableFocusOnLeaves && !item_r11[ctx_r4.itemChildrenProp] ? null : "-1");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r11[ctx_r4.itemIconProp]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.itemLabelTemplate)("ngIfElse", _r18);
} }
var _c77 = ["dropdownMenu"];
function BentoUniverseFilterDropdownComponent_button_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
} }
function BentoUniverseFilterDropdownComponent_button_2_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 10);
} }
function BentoUniverseFilterDropdownComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function BentoUniverseFilterDropdownComponent_button_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7._onBackButtonClick($event); })("keypress", function BentoUniverseFilterDropdownComponent_button_2_Template_button_keypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return $event.which === 13 ? ctx_r9._onBackButtonClick($event) : 0; });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵtemplate(2, BentoUniverseFilterDropdownComponent_button_2_i_2_Template, 1, 0, "i", 7);
    ɵngcc0.ɵɵtemplate(3, BentoUniverseFilterDropdownComponent_button_2_i_3_Template, 1, 0, "i", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.backBtnDisabled);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 4, "BENTO_UI_UNIVERSAL_FILTER_BACK"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isRtl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isRtl);
} }
function BentoUniverseFilterDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("openChange", function BentoUniverseFilterDropdownComponent_div_3_Template_div_openChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var i_r10 = ctx.index; var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onOpenChange($event, i_r10); });
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "button", 14);
    ɵngcc0.ɵɵelement(5, "i", 15);
    ɵngcc0.ɵɵpipe(6, "bentoTranslate");
    ɵngcc0.ɵɵpipe(7, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 16, 17);
    ɵngcc0.ɵɵelementStart(10, "bento-universe-filter-dropdown-menu", 18);
    ɵngcc0.ɵɵlistener("onClose", function BentoUniverseFilterDropdownComponent_div_3_Template_bento_universe_filter_dropdown_menu_onClose_10_listener() { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.close(); })("onSelect", function BentoUniverseFilterDropdownComponent_div_3_Template_bento_universe_filter_dropdown_menu_onSelect_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onSelect($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var i_r10 = ctx.index;
    var item_r11 = ctx.$implicit;
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(1);
    var _r3 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r2.selectedName === item_r11.title ? "selected " : "") + (ctx_r2.items.length >= 4 ? "col-3" : ctx_r2.items.length === 3 ? "col-4" : ctx_r2.items.length === 2 ? "col-6" : "col-12"))("autoClose", "outside")("bentoUniverseFilterDropdownPosition", _r0);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r11.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", item_r11.selectedName || ctx_r2.selectText || "Select");
    ɵngcc0.ɵɵpropertyInterpolate("bentoEllipsisText", item_r11.selectedName || item_r11.selectText || ctx_r2.selectText || "Select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattributeInterpolate2("aria-label", "", ctx_r2.isOpenArr[i_r10] ? ɵngcc0.ɵɵpipeBind1(6, 11, "BENTO_UI_UNIVERSAL_FILTER_COLLAPSE") : ɵngcc0.ɵɵpipeBind1(7, 13, "BENTO_UI_UNIVERSAL_FILTER_EXPAND"), " ", item_r11.title, "");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("item", item_r11)("menuindex", i_r10)("defaultTemplate", _r3);
} }
function BentoUniverseFilterDropdownComponent_ng_template_6_li_1_Template(rf, ctx) { if (rf & 1) {
    var _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 21);
    ɵngcc0.ɵɵlistener("click", function BentoUniverseFilterDropdownComponent_ng_template_6_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); var item_r21 = ctx.$implicit; var s_r18 = ɵngcc0.ɵɵnextContext().selectItem; return s_r18(item_r21); })("keydown", function BentoUniverseFilterDropdownComponent_ng_template_6_li_1_Template_li_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); var item_r21 = ctx.$implicit; var s_r18 = ɵngcc0.ɵɵnextContext().selectItem; return $event.which === 13 ? s_r18(item_r21) : 0; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r21 = ctx.$implicit;
    var i_r19 = ɵngcc0.ɵɵnextContext().filterItem;
    ɵngcc0.ɵɵproperty("ngClass", item_r21.title === i_r19.selectedName ? "selected" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r21.title, " ");
} }
function BentoUniverseFilterDropdownComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 19);
    ɵngcc0.ɵɵtemplate(1, BentoUniverseFilterDropdownComponent_ng_template_6_li_1_Template, 2, 2, "li", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var i_r19 = ctx.filterItem;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", i_r19.items);
} }
function BentoUniverseFilterComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function BentoUniverseFilterComponent_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4._onBackButtonClick($event); })("keypress", function BentoUniverseFilterComponent_button_1_Template_button_keypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return $event.which === 13 ? ctx_r6._onBackButtonClick($event) : 0; });
    ɵngcc0.ɵɵelement(1, "i", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.backBtnDisabled);
} }
function BentoUniverseFilterComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵlistener("click", function BentoUniverseFilterComponent_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); var item_r7 = ctx.$implicit; var ctx_r8 = ɵngcc0.ɵɵnextContext(); var _r2 = ɵngcc0.ɵɵreference(5); return ctx_r8._openModal(_r2, item_r7, ctx_r8.items); })("keypress", function BentoUniverseFilterComponent_div_2_Template_div_keypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var item_r7 = ctx.$implicit; var ctx_r10 = ɵngcc0.ɵɵnextContext(); var _r2 = ɵngcc0.ɵɵreference(5); return $event.which === 13 ? ctx_r10._openModal(_r2, item_r7, ctx_r10.items) : 0; });
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 8);
    ɵngcc0.ɵɵelement(4, "i", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r7 = ctx.$implicit;
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r1.selectedName === item_r7.title ? "selected " : "") + (ctx_r1.items.length >= 4 ? "col-3" : ctx_r1.items.length === 3 ? "col-4" : ctx_r1.items.length === 2 ? "col-6" : "col-12"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r7.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("bentoEllipsisText", item_r7.selectedName || item_r7.selectText || ctx_r1.selectText || "Select");
    ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", item_r7.selectedName || ctx_r1.selectText || "Select");
} }
function BentoUniverseFilterComponent_ng_template_4_li_6_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 16);
    ɵngcc0.ɵɵlistener("click", function BentoUniverseFilterComponent_ng_template_4_li_6_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); var item_r14 = ctx.$implicit; var ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15._modalSelectItem(item_r14, ctx_r15.modalFilterItem); })("keypress", function BentoUniverseFilterComponent_ng_template_4_li_6_Template_li_keypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var item_r14 = ctx.$implicit; var ctx_r17 = ɵngcc0.ɵɵnextContext(2); return $event.which === 13 ? ctx_r17._modalSelectItem(item_r14, ctx_r17.modalFilterItem) : 0; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r14.title, " ");
} }
function BentoUniverseFilterComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    var _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function BentoUniverseFilterComponent_ng_template_4_Template_button_click_0_listener() { var d_r12 = ctx.dismiss; return d_r12(); })("keypress", function BentoUniverseFilterComponent_ng_template_4_Template_button_keypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); var d_r12 = ctx.dismiss; return $event.which === 13 ? d_r12() : 0; });
    ɵngcc0.ɵɵelement(1, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 13);
    ɵngcc0.ɵɵelementStart(5, "ul", 14);
    ɵngcc0.ɵɵtemplate(6, BentoUniverseFilterComponent_ng_template_4_li_6_Template, 2, 1, "li", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Select ", ctx_r3.modalFilterItem.title, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.modalFilterItem.items);
} }
function BentoWizardComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "bento-sticky-footer", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementContainer(3, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("showOnElementVisible", ctx_r0._el)("fullWidth", ctx_r0.stickyFooterFullWidth);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function BentoWizardComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 9);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function BentoWizardComponent_ng_template_7_button_0_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function BentoWizardComponent_ng_template_7_button_0_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9._onButtonStepChanging($event, ctx_r9._currentStep - 1); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelement(2, "i", 15);
    ɵngcc0.ɵɵelementStart(3, "span", 16);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r5._stepsArray && ctx_r5._stepsArray[ctx_r5._currentStep - 1].disabled);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 3, "BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 5, "BENTO_UI_WIZARD_BUTTON_PREVIOUS"));
} }
function BentoWizardComponent_ng_template_7_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function BentoWizardComponent_ng_template_7_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11._onButtonStepChanging($event, ctx_r11._currentStep + 1); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "i", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r6._stepsArray && ctx_r6._stepsArray[ctx_r6._currentStep + 1].disabled);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 3, "BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 5, "BENTO_UI_WIZARD_BUTTON_NEXT"));
} }
function BentoWizardComponent_ng_template_7_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 19);
    ɵngcc0.ɵɵlistener("click", function BentoWizardComponent_ng_template_7_button_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13._onDoneClick($event); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 2, "BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, "BENTO_UI_WIZARD_BUTTON_DONE"));
} }
function BentoWizardComponent_ng_template_7_button_3_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function BentoWizardComponent_ng_template_7_button_3_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15._onCancelClick($event); });
    ɵngcc0.ɵɵpipe(1, "bentoTranslate");
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "bentoTranslate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 2, "BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, "BENTO_UI_WIZARD_BUTTON_CANCEL"));
} }
function BentoWizardComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, BentoWizardComponent_ng_template_7_button_0_Template, 6, 7, "button", 10);
    ɵngcc0.ɵɵtemplate(1, BentoWizardComponent_ng_template_7_button_1_Template, 6, 7, "button", 11);
    ɵngcc0.ɵɵtemplate(2, BentoWizardComponent_ng_template_7_button_2_Template, 5, 6, "button", 12);
    ɵngcc0.ɵɵtemplate(3, BentoWizardComponent_ng_template_7_button_3_Template, 5, 6, "button", 13);
    ɵngcc0.ɵɵprojection(4, 1);
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4._currentStep > 0 && !ctx_r4.hideDefaultButtons && !ctx_r4.hidePreviousButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4._currentStep < ctx_r4._steps.length - 1 && !ctx_r4.hideDefaultButtons && !ctx_r4.hideNextButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4._currentStep === ctx_r4._steps.length - 1 && !ctx_r4.hideDefaultButtons && !ctx_r4.hideDoneButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.showCancelButton);
} }
var _c78 = [[["bento-wizard-step"]], [["bento-wizard-custom-button-group"]]];
var _c79 = ["bento-wizard-step", "bento-wizard-custom-button-group"];
function BentoWizardComponentStripComponent_button_10_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵelement(1, "i", 13);
    ɵngcc0.ɵɵpipe(2, "bentoTranslate");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var step_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "BENTO_UI_WIZARD_COMPLETE_LABEL"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r1.title, " ");
} }
function BentoWizardComponentStripComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    var _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("keydown", function BentoWizardComponentStripComponent_button_10_Template_button_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); var i_r2 = ctx.index; var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5._onKeydown($event, i_r2); })("click", function BentoWizardComponentStripComponent_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); var i_r2 = ctx.index; var step_r1 = ctx.$implicit; var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7._onStepClick(i_r2, step_r1.disabled); });
    ɵngcc0.ɵɵelement(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, BentoWizardComponentStripComponent_button_10_span_2_Template, 4, 4, "span", 9);
    ɵngcc0.ɵɵelement(3, "span", 10);
    ɵngcc0.ɵɵelement(4, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var step_r1 = ctx.$implicit;
    var i_r2 = ctx.index;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("width", ctx_r0._boxWidth, "px");
    ɵngcc0.ɵɵproperty("ngClass", (i_r2 === ctx_r0._currentStep ? "selected " : "") + (step_r1.disabled ? "disabled " : "") + (step_r1.completed ? "completed " : ""))("disabled", step_r1.disabled);
    ɵngcc0.ɵɵattribute("tabindex", i_r2 === ctx_r0._currentStep ? "0" : "-1")("aria-selected", i_r2 === ctx_r0._currentStep)("id", ctx_r0.stepUIDs[i_r2])("aria-controls", "tab-" + ctx_r0.stepUIDs[i_r2]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("replaceTag", ctx_r0.hTag);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("bentoWizardComponentEllipsis", ctx_r0.checkEllipsis)("bentoEllipsisText", step_r1.description);
} }
var BentoFocusMonitorDirective = /** @class */ (function () {
    function BentoFocusMonitorDirective(elementRef, r, focusMonitor) {
        this.elementRef = elementRef;
        this.focusMonitor = focusMonitor;
        this.focusMonitor.monitor(elementRef, true);
    }
    /**
     * @return {?}
     */
    BentoFocusMonitorDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.focusMonitor.stopMonitoring(this.elementRef);
    };
    /** @nocollapse */
    BentoFocusMonitorDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: FocusMonitor }
    ]; };
BentoFocusMonitorDirective.ɵfac = function BentoFocusMonitorDirective_Factory(t) { return new (t || BentoFocusMonitorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FocusMonitor)); };
BentoFocusMonitorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoFocusMonitorDirective, selectors: [["a"], ["button", 8, "btn"], ["button", 8, "close"], ["button", 8, "dropdown-item"], ["a", 8, "dropdown-item"]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFocusMonitorDirective, [{
        type: Directive,
        args: [{
                selector: 'a, button.btn, button.close, button.dropdown-item, a.dropdown-item'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.FocusMonitor }]; }, null); })();
    return BentoFocusMonitorDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoFocusMonitorDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    BentoFocusMonitorDirective.prototype.focusMonitor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/focus-monitor/focus-monitor.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoFocusMonitorModule = /** @class */ (function () {
    function BentoFocusMonitorModule() {
    }
BentoFocusMonitorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoFocusMonitorModule });
BentoFocusMonitorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoFocusMonitorModule_Factory(t) { return new (t || BentoFocusMonitorModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoFocusMonitorModule, { declarations: function () { return [BentoFocusMonitorDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BentoFocusMonitorDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFocusMonitorModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoFocusMonitorDirective],
                imports: [CommonModule],
                exports: [BentoFocusMonitorDirective],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoFocusMonitorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/i18n/translate.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTranslate = /** @class */ (function () {
    // Constructor
    function BentoTranslate(http) {
        this.http = http;
        this._isLoading = false;
    }
    /**
     * Load JSON translations from an URL within the same domain
     */
    /**
     * Load JSON translations from an URL within the same domain
     * @param {?} url
     * @return {?}
     */
    BentoTranslate.prototype.load = /**
     * Load JSON translations from an URL within the same domain
     * @param {?} url
     * @return {?}
     */
    function (url) {
        var _this = this;
        this._isLoading = true;
        this._httpObservable = this.http.get(url).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            /** @type {?} */
            var json = response;
            _this.setTranslation(json);
            return json;
        })));
        this._httpObservable.subscribe((/**
         * @param {?} json
         * @return {?}
         */
        function (json) { return _this._onTranslationLoad(json); }));
        return this._httpObservable;
    };
    Object.defineProperty(BentoTranslate.prototype, "translationChange", {
        /**
         * Translation change subscribable
         */
        get: /**
         * Translation change subscribable
         * @return {?}
         */
        function () {
            return BentoTranslate.change;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Add or update a translation
     */
    /**
     * Add or update a translation
     * @param {?} key
     * @param {?} translation
     * @return {?}
     */
    BentoTranslate.prototype.add = /**
     * Add or update a translation
     * @param {?} key
     * @param {?} translation
     * @return {?}
     */
    function (key, translation) {
        BentoTranslate.defaultTranslation[key] = translation;
        BentoTranslate.change.next(BentoTranslate.defaultTranslation);
    };
    /**
     * Set translation with a new JSON {key:string,translation:string}
     */
    /**
     * Set translation with a new JSON {key:string,translation:string}
     * @param {?} json
     * @return {?}
     */
    BentoTranslate.prototype.setTranslation = /**
     * Set translation with a new JSON {key:string,translation:string}
     * @param {?} json
     * @return {?}
     */
    function (json) {
        for (var label in json) {
            if (json.hasOwnProperty(label)) {
                BentoTranslate.defaultTranslation[label] = json[label];
            }
        }
        BentoTranslate.change.next(BentoTranslate.defaultTranslation);
    };
    /**
     * Get the current translation set
     */
    /**
     * Get the current translation set
     * @return {?}
     */
    BentoTranslate.prototype.getTranslation = /**
     * Get the current translation set
     * @return {?}
     */
    function () {
        return BentoTranslate.defaultTranslation;
    };
    /**
     * Translate a label with an observable as return
     * This is suitable for retrieving translations from servers asynchronously
     */
    /**
     * Translate a label with an observable as return
     * This is suitable for retrieving translations from servers asynchronously
     * @param {?} label
     * @return {?}
     */
    BentoTranslate.prototype.translate = /**
     * Translate a label with an observable as return
     * This is suitable for retrieving translations from servers asynchronously
     * @param {?} label
     * @return {?}
     */
    function (label) {
        var _this = this;
        if (this._isLoading) {
            return this._httpObservable;
        }
        else {
            /** @type {?} */
            var observable = new Observable((/**
             * @param {?} observer
             * @return {?}
             */
            function (observer) {
                observer.next(_this.instantTranslate(label));
                /* istanbul ignore next */
                return (/**
                 * @return {?}
                 */
                function () { });
            }));
            return observable;
        }
    };
    /**
     * Translates a label and return its instant translation
     * Note: This ONLY returns the translation which exists in the translation
     * JSON, otherwise the original label is returned
     */
    /**
     * Translates a label and return its instant translation
     * Note: This ONLY returns the translation which exists in the translation
     * JSON, otherwise the original label is returned
     * @param {?} label
     * @return {?}
     */
    BentoTranslate.prototype.instantTranslate = /**
     * Translates a label and return its instant translation
     * Note: This ONLY returns the translation which exists in the translation
     * JSON, otherwise the original label is returned
     * @param {?} label
     * @return {?}
     */
    function (label) {
        return BentoTranslate.defaultTranslation[label] || label;
    };
    // Private methods
    // On translation loaded from the http observable
    // Private methods
    // On translation loaded from the http observable
    /**
     * @param {?} json
     * @return {?}
     */
    BentoTranslate.prototype._onTranslationLoad = 
    // Private methods
    // On translation loaded from the http observable
    /**
     * @param {?} json
     * @return {?}
     */
    function (json) {
        this._isLoading = false;
        this._httpObservable = null;
    };
    BentoTranslate.defaultTranslation = {
        // Component Translations
        BENTO_UI_ALERT_DESCRIPTION: 'You have alerts, press tab key to continue',
        BENTO_UI_ALERT_CLOSE_BUTTON: 'Dismiss alert',
        BENTO_UI_BUSY_LOADER_LOADING: 'Loading content',
        BENTO_UI_BUSY_LOADER_LOADED: 'Content loaded',
        BENTO_UI_EXPAND_ALL: 'Expand all',
        BENTO_UI_COLLAPSE_ALL: 'Collapse all',
        BENTO_UI_FILE_SELECTOR_A11Y_CAUTION: 'Caution',
        BENTO_UI_FILE_SELECTOR_DESCRIPTION: 'This is file selector, press Tab key to proceed to the browse button',
        BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON: 'Press enter key to Browse file',
        BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL: 'Browse for File',
        BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL: 'Drag a File Here or',
        BENTO_UI_FILE_SELECTOR_DROP_FILED_ACTION_LABEL: 'Drop Here',
        BENTO_UI_FILE_SELECTOR_FILE_NAME: 'File _FILE_NUMBER_ of _NUM_FILES_, file name: _FILE_NAME_',
        BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE: ' loading complete',
        BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_MESSAGE: 'Uploading files',
        BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS: ' loading',
        BENTO_UI_FILE_SELECTOR_FILE_ERROR: ' The _DISPLAY_TYPE_ <em>_NAME_</em> could not be uploaded. ',
        BENTO_UI_FILE_SELECTOR_FILE_EXT_ERROR: 'Only files with the following extensions are allowed: <em>_ACCEPT_</em>',
        BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON: 'Remove _FILE_NAME_',
        BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE: '_FILE_NAME_ is removed',
        BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO: 'All (_NUMBER_) selected',
        BENTO_UI_MULTISELECT_OVERLAY_CANCEL: 'Cancel',
        BENTO_UI_MULTISELECT_OVERLAY_DONE: 'Done',
        BENTO_UI_MULTISELECT_OVERLAY_EDIT: 'Edit',
        BENTO_UI_MULTISELECT_OVERLAY_SELECT: 'Select',
        BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL: 'Select All',
        BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO: '_NUMBER_ selected',
        BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL: 'Show All',
        BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED: 'Show Selected',
        BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL: 'Search Item Text Field',
        BENTO_UI_NAV_TOOLBAR_MORE: 'More',
        BENTO_UI_NUMBER_INPUT_INCREASE: 'Increase Number',
        BENTO_UI_NUMBER_INPUT_DECREASE: 'Decrease Number',
        BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON: 'Open menu',
        BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON: 'Close menu',
        BENTO_UI_OFF_CANVAS_MENU_ASIDE_TITLE: 'Menu',
        BENTO_UI_OFF_CANVAS_MENU_RIGHT_ASIDE_TITLE: 'Menu',
        BENTO_UI_PAGINATION_GO_BUTTON: 'Go',
        BENTO_UI_PAGINATION_INFO_PAGE_TEXT: 'Page _PAGE_ of _PAGES_',
        BENTO_UI_PAGINATION_INFO_TEXT: '_START_ to _END_ of _MAX_',
        BENTO_UI_RESET_ARIA_LABEL: 'Reset _LABEL_',
        BENTO_UI_SIDE_NAV_EXPAND: 'expand',
        BENTO_UI_SIDE_NAV_COLLAPSE: 'collapse',
        BENTO_UI_SIDE_NAV_SEARCH: 'Filter',
        BENTO_UI_SPLITTER_GROUP: 'This is a splitter group, press Tab key to proceed to its contents.',
        BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND: 'Expand',
        BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE: 'Collapse',
        BENTO_UI_SPLITTER_GROUP_TOP_BAR: '_ACTION_ top panel',
        BENTO_UI_SPLITTER_GROUP_BOTTOM_BAR: '_ACTION_ bottom panel',
        BENTO_UI_SPLITTER_GROUP_LEFT_BAR: '_ACTION_ left panel',
        BENTO_UI_SPLITTER_GROUP_RIGHT_BAR: '_ACTION_ right panel',
        BENTO_UI_TAGS_INPUT_EDIT_TEXT: 'Press enter to edit the label. ',
        BENTO_UI_TAGS_INPUT_REMOVE_TEXT: 'Press delete or backspace to remove the label. ',
        BENTO_UI_TAGS_INPUT_EDIT: 'Edit _LABEL_',
        BENTO_UI_TAGS_INPUT_CLOSE: 'Remove _LABEL_',
        BENTO_UI_TAGS_INPUT_EDIT_ELEMENT: 'Edit the label and press enter to save it or press esc key to cancel the edit',
        BENTO_UI_TAGS_INPUT_EMPTY_PILL: 
        // tslint:disable-next-line max-line-length
        'Error: Pill text cannot be empty. Provide some meaningful pill value and press enter key to save or press esc key to cancel the edit ',
        BENTO_UI_TILE_RIBBON_TOGGLE_SHOW: 'Show',
        BENTO_UI_TILE_RIBBON_TOGGLE_HIDE: 'Hide',
        BENTO_UI_TILE_RIBBON_SCROLL_LEFT: 'Scroll left',
        BENTO_UI_TILE_RIBBON_SCROLL_RIGHT: 'Scroll right',
        BENTO_UI_TILE_SUCCESS: 'Success icon',
        BENTO_UI_TILE_INFO: 'Info icon',
        BENTO_UI_TILE_WARNING: 'Warning icon',
        BENTO_UI_TILE_DANGER: 'Danger icon',
        BENTO_UI_TOAST_CLOSE_BUTTON: 'Close',
        BENTO_UI_TOGGLE_ON: 'Toggle is on. Space bar to turn it off',
        BENTO_UI_TOGGLE_OFF: 'Toggle is off. Space bar to turn it on',
        BENTO_UI_TOOLBAR_MORE: 'More',
        BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE: 'Add',
        BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO: 'Remove',
        BENTO_UI_TRANSFER_BOX_BTN_TEXT: 'Transfer',
        BENTO_UI_TRANSFER_BOX_SUB_TITLE: '_SELECTED_ of _TOTAL_ Checked',
        BENTO_UI_TRANSFER_BOX_LEFT_PANEL: 'Left panel',
        BENTO_UI_TRANSFER_BOX_RIGHT_PANEL: 'Right panel',
        BENTO_UI_TRANSFER_BOX_MIDDLE_BAR: 'Drag to resize',
        BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD: 'Add',
        BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE: 'Remove',
        BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT: 'Filter',
        BENTO_UI_TRANSFER_BOX_BASIC_A11Y_SORT_BY: 'Sort by',
        BENTO_UI_TREE_EXPAND: 'expand _LABEL_',
        BENTO_UI_TREE_COLLAPSE: 'collapse _LABEL_',
        BENTO_UI_TREE_EXPAND_ALL: 'Expand All',
        BENTO_UI_TREE_COLLAPSE_ALL: 'Collapse All',
        BENTO_UI_TREE_VIEW_EXPAND: 'expand',
        BENTO_UI_TREE_VIEW_COLLAPSE: 'collapse',
        BENTO_UI_TREE_VIEW_EXPAND_ALL: 'Expand All',
        BENTO_UI_TREE_VIEW_COLLAPSE_ALL: 'Collapse All',
        BENTO_UI_WIZARD_DESCRIPTION: 'Wizard to complete a process. Tab key to proceed to wizard steps. ' +
            'Enter key to select each wizard step and its content.',
        BENTO_UI_WIZARD_STEP_NAME: 'Wizard Step Title.',
        BENTO_UI_WIZARD_COMPLETE_LABEL: 'Completed',
        BENTO_UI_WIZARD_BUTTON_CANCEL: 'Cancel',
        BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION: 'Cancel',
        BENTO_UI_WIZARD_BUTTON_DONE: 'Done',
        BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION: 'Done with the last step.',
        BENTO_UI_WIZARD_BUTTON_NEXT: 'Next',
        BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION: 'Proceed to next wizard step.',
        BENTO_UI_WIZARD_BUTTON_PREVIOUS: 'Previous',
        BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION: 'Back to the previous wizard step.',
        // Static translations
        BENTO_UI_TODAY: 'Today',
        BENTO_UI_TOMORROW: 'Tomorrow',
        BENTO_UI_YESTERDAY: 'Yesterday',
        BENTO_UI_N_DAY_AGO: '_NUMBER_ Days Ago',
        // A11Y translations
        // Transferbox
        BENTO_UI_TRANSFER_BOX_BTN_A11Y_ADD_BUTTON: 'Add items from _TITLE_',
        BENTO_UI_TRANSFER_BOX_BTN_A11Y_REMOVE_BUTTON: 'Remove items from _TITLE_',
        BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_ON_FILTERS: 'Turn on filters for _TITLE_',
        BENTO_UI_TRANSFER_BOX_A11Y_TOGGLE_OFF_FILTERS: 'Turn off filters for _TITLE_',
        BENTO_UI_TRANSFER_BOX_A11Y_SEARCH_TEXT: 'Search _TITLE_',
        BENTO_UI_TRANSFER_BOX_A11Y_CHECKBOX_LABEL: '_TITLE_ _COLUMN_KEY_: _COLUMN_KEY_VALUE_',
        BENTO_UI_TRANSFER_BOX_A11Y_HEADER_CHECKBOX_LABEL: 'Toggle All _TITLE_',
        BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_FIRST: 'Go to First Page of _TITLE_',
        BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_NEXT: 'Go to Next Page of _TITLE_',
        BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_PREVIOUS: 'Go to Previous Page of _TITLE_',
        BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_LAST: 'Go to Last Page of _TITLE_',
        BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_PAGE_NUM: 'Enter Page number to go to',
        BENTO_UI_TRANSFER_BOX_PAGINATION_A11Y_GOTO_PAGE: 'Go to Page _PAGE_ of _TITLE_',
        BENTO_TRANSFER_BOX_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items Per Page of _TITLE_',
        // Transferbox Basic
        BENTO_UI_TRANSFER_BOX_BASIC_A11Y_DESCRIPTION: 'The Transferbox is a tool to move items between two lists,' +
            ' typically using the left side as the source for a new list as the desination on the right.',
        BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_ADDED: 'Added _NUMBER_ to _LABEL_',
        BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_REMOVED: 'Removed _NUMBER_ from _LABEL_',
        BENTO_UI_TRANSFER_BOX_BASIC_A11Y_HEADER_CHECKBOX_LABEL: 'Toggle All',
        BENTO_UI_TRANSFER_BOX_BASIC_A11Y_CHECKBOX_LABEL: 'Row _ROW_ID_',
        // Pagination
        BENTO_UI_PAGINATION_A11Y_FIRST_BUTTON: 'First',
        BENTO_UI_PAGINATION_A11Y_PREVIOUS_BUTTON: 'Previous',
        BENTO_UI_PAGINATION_A11Y_NEXT_BUTTON: 'Next',
        BENTO_UI_PAGINATION_A11Y_LAST_BUTTON: 'Last',
        BENTO_UI_PAGINATION_A11Y_FIRST: 'Go to First Page',
        BENTO_UI_PAGINATION_A11Y_NEXT: 'Go to Next Page',
        BENTO_UI_PAGINATION_A11Y_PREVIOUS: 'Go to Previous Page',
        BENTO_UI_PAGINATION_A11Y_LAST: 'Go to Last Page',
        BENTO_UI_PAGINATION_A11Y_PAGE_NUM: 'Enter Page number to go to',
        BENTO_UI_PAGINATION_A11Y_GOTO_PAGE: 'Go to Page',
        BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items Per Page',
        // scrollable bar
        BENTO_UI_SCROLLABLE_BAR_SCROLL_LEFT: 'Scroll Left',
        BENTO_UI_SCROLLABLE_BAR_SCROLL_RIGHT: 'Scroll Right',
        // combobox
        BENTO_UI_CBOX_A11Y_NO_RESULTS: 'No results found',
        BENTO_UI_CBOX_DROPDOWN_ICON_OPEN: 'Enter to expand',
        BENTO_UI_CBOX_DROPDOWN_ICON_CLOSE: 'Enter to collapse',
        BENTO_UI_CBOX_INPUT_LABEL: 'Select Here',
        BENTO_UI_CBOX_OPTIONS: 'Options',
        // contextual-header
        BENTO_UI_CONTEXTUAL_HEADER_BACK: 'Go Back',
        // multiselect-overlay
        BENTO_UI_MULTISELECT_OLAY_ALL_DESC: 'Shows list of all items (both selected and non-selected)',
        BENTO_UI_MULTISELECT_OLAY_SELECTED_DESC: 'Shows list of only selected items',
        // universal-filter
        BENTO_UI_UNIVERSAL_FILTER_BACK: 'Go Back',
        BENTO_UI_UNIVERSAL_FILTER_EXPAND: 'Expand',
        BENTO_UI_UNIVERSAL_FILTER_COLLAPSE: 'Collapse',
        // wizard
        BENTO_UI_WIZARD_LEFT: 'previous step',
        BENTO_UI_WIZARD_RIGHT: 'next step',
        // tabs scroll
        BENTO_UI_TABSET_SCROLL_LEFTMOST: 'Scroll to the start',
        BENTO_UI_TABSET_SCROLL_LEFT: 'Scroll left',
        BENTO_UI_TABSET_SCROLL_RIGHT: 'Scroll right',
        BENTO_UI_TABSET_SCROLL_RIGHTMOST: 'Scroll to the end',
        // timepicker
        BENTO_UI_TIMEPICKER_LEGEND: 'Timepicker',
        // tree view
        BENTO_UI_TREEVIEW_PRINT: 'Print',
        BENTO_UI_TREEVIEW_CONFIGURE: 'Configure',
        // modal confirmation
        BENTO_UI_MODAL_CONFIRMATION_CLOSE: 'Close'
    };
    BentoTranslate.change = new Subject();
    /** @nocollapse */
    BentoTranslate.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
BentoTranslate.ɵfac = function BentoTranslate_Factory(t) { return new (t || BentoTranslate)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
BentoTranslate.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoTranslate, factory: function (t) { return BentoTranslate.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTranslate, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.HttpClient }]; }, null); })();
    return BentoTranslate;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoTranslate.defaultTranslation;
    /**
     * @type {?}
     * @private
     */
    BentoTranslate.change;
    /** @type {?} */
    BentoTranslate.prototype._isLoading;
    /** @type {?} */
    BentoTranslate.prototype._httpObservable;
    /**
     * @type {?}
     * @private
     */
    BentoTranslate.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/i18n/translate.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Translate Pipe
 *
 * Usage: `'TEXT_LABEL_TO_BE_TRANSLATED` | bentoTranslate`
 */
var BentoTranslatePipe = /** @class */ (function () {
    function BentoTranslatePipe(translate) {
        this._translation = '';
        this._translate = translate;
    }
    /**
     * @param {?} label
     * @param {?=} translateOverride
     * @return {?}
     */
    BentoTranslatePipe.prototype.transform = /**
     * @param {?} label
     * @param {?=} translateOverride
     * @return {?}
     */
    function (label, translateOverride) {
        if (translateOverride && translateOverride.length > 0) {
            this._translation = translateOverride;
        }
        else {
            this._translation = this._translate.instantTranslate(label);
        }
        return this._translation;
    };
    /** @nocollapse */
    BentoTranslatePipe.ctorParameters = function () { return [
        { type: BentoTranslate }
    ]; };
BentoTranslatePipe.ɵfac = function BentoTranslatePipe_Factory(t) { return new (t || BentoTranslatePipe)(ɵngcc0.ɵɵdirectiveInject(BentoTranslate)); };
BentoTranslatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bentoTranslate", type: BentoTranslatePipe, pure: false });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTranslatePipe, [{
        type: Pipe,
        args: [{ name: 'bentoTranslate', pure: false }]
    }], function () { return [{ type: BentoTranslate }]; }, null); })();
    return BentoTranslatePipe;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoTranslatePipe.prototype._translate;
    /**
     * @type {?}
     * @private
     */
    BentoTranslatePipe.prototype._translation;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/i18n/translate.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTranslateModule = /** @class */ (function () {
    function BentoTranslateModule() {
    }
BentoTranslateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTranslateModule });
BentoTranslateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTranslateModule_Factory(t) { return new (t || BentoTranslateModule)(); }, providers: [BentoTranslate] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTranslateModule, { declarations: [BentoTranslatePipe], exports: [BentoTranslatePipe] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTranslateModule, [{
        type: NgModule,
        args: [{ declarations: [BentoTranslatePipe], exports: [BentoTranslatePipe], providers: [BentoTranslate] }]
    }], function () { return []; }, null); })();
    return BentoTranslateModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/file-size.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A pipe to replace number into string file size representations
 */
var BentoFileSizePipe = /** @class */ (function () {
    function BentoFileSizePipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    BentoFileSizePipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var output = '0 Byte';
        if (value < 1000) {
            output = value + 'B';
        }
        else if (value < 100000) {
            output = Math.round(value / 100) / 10 + 'KB';
        }
        else if (value < 1000000) {
            output = Math.round(value / 1000) + 'KB';
        }
        else if (value < 100000000) {
            output = Math.round(value / 100000) / 10 + 'MB';
        }
        else if (value < 1000000000) {
            output = Math.round(value / 1000000) + 'MB';
        }
        else if (value < 100000000000) {
            output = Math.round(value / 100000000) / 10 + 'GB';
        }
        else if (value < 1000000000000) {
            output = Math.round(value / 1000000000) + 'GB';
        }
        else if (value < 100000000000000) {
            output = Math.round(value / 100000000000) / 10 + 'TB';
        }
        else if (value < 1000000000000000) {
            output = Math.round(value / 1000000000000) + 'TB';
        }
        return output;
    };
BentoFileSizePipe.ɵfac = function BentoFileSizePipe_Factory(t) { return new (t || BentoFileSizePipe)(); };
BentoFileSizePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bentoFileSizeFilter", type: BentoFileSizePipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFileSizePipe, [{
        type: Pipe,
        args: [{ name: 'bentoFileSizeFilter' }]
    }], function () { return []; }, null); })();
    return BentoFileSizePipe;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/log.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable no-console */
var BentoLogService = /** @class */ (function () {
    function BentoLogService() {
    }
    /**
     * @param {...?} params
     * @return {?}
     */
    BentoLogService.prototype.log = /**
     * @param {...?} params
     * @return {?}
     */
    function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        console.log.apply(console, __spread(params));
    };
    /**
     * @param {...?} params
     * @return {?}
     */
    BentoLogService.prototype.warn = /**
     * @param {...?} params
     * @return {?}
     */
    function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        console.warn.apply(console, __spread(params));
    };
    /**
     * @param {...?} params
     * @return {?}
     */
    BentoLogService.prototype.error = /**
     * @param {...?} params
     * @return {?}
     */
    function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        console.error.apply(console, __spread(params));
    };
BentoLogService.ɵfac = function BentoLogService_Factory(t) { return new (t || BentoLogService)(); };
BentoLogService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoLogService, factory: function (t) { return BentoLogService.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoLogService, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return BentoLogService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/notification.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Main debounce time
 * @type {?}
 */
var DEBOUNCE_TIME = 110;
// Default transition duration is 100ms for Bento
var BentoNotification = /** @class */ (function () {
    function BentoNotification() {
    }
    /**
     * Emit resize to broadcast
     */
    /**
     * Emit resize to broadcast
     * @param {?=} component
     * @return {?}
     */
    BentoNotification.prototype.emitResize = /**
     * Emit resize to broadcast
     * @param {?=} component
     * @return {?}
     */
    function (component) {
        if (BentoNotification._initialized && BentoNotification.resizeEvent) {
            // Only broadcast if there is at least one notification subscribed
            BentoNotification.resizeObserver.next(component);
        }
    };
    Object.defineProperty(BentoNotification.prototype, "resizeNotification", {
        /**
         * Get resize notification subsctibable
         */
        get: /**
         * Get resize notification subsctibable
         * @return {?}
         */
        function () {
            if (!BentoNotification._initialized) {
                BentoNotification._initialized = true;
                // For broadcasting
                Observable.create((/**
                 * @param {?} o
                 * @return {?}
                 */
                function (o) {
                    BentoNotification.resizeObserver = o;
                }))
                    .pipe(debounceTime(DEBOUNCE_TIME))
                    .subscribe((/**
                 * @param {?} c
                 * @return {?}
                 */
                function (c) {
                    BentoNotification.resizeEvent.emit(c);
                }));
                try {
                    // Add an event listener to the window object to listen browser window resize
                    fromEvent(window, 'resize')
                        .pipe(debounceTime(DEBOUNCE_TIME))
                        .subscribe((/**
                     * @param {?} e
                     * @return {?}
                     */
                    function (e) {
                        BentoNotification.resizeEvent.emit(window);
                    }));
                }
                catch (e) {
                    // Running in SSR mode no need to listen to window
                }
            }
            return BentoNotification.resizeEvent;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Main event emitter for resizes
     */
    BentoNotification.resizeEvent = new EventEmitter();
    /**
     * Resize observer for global resize broadcasts
     */
    BentoNotification.resizeObserver = null;
    BentoNotification._initialized = false;
    /** @nocollapse */ BentoNotification.ɵprov = ɵɵdefineInjectable({ factory: function BentoNotification_Factory() { return new BentoNotification(); }, token: BentoNotification, providedIn: "root" });
BentoNotification.ɵfac = function BentoNotification_Factory(t) { return new (t || BentoNotification)(); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNotification, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();
    return BentoNotification;
}());
if (false) {
    /**
     * Main event emitter for resizes
     * @type {?}
     * @private
     */
    BentoNotification.resizeEvent;
    /**
     * Resize observer for global resize broadcasts
     * @type {?}
     * @private
     */
    BentoNotification.resizeObserver;
    /**
     * @type {?}
     * @private
     */
    BentoNotification._initialized;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/window.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var scrollbarWidth;
/**
 * Is used to inject window objects
 */
var WindowRef = /** @class */ (function () {
    function WindowRef(document, platform) {
        this.document = document;
        this.platform = platform;
        try {
            this.window = window;
        }
        catch (e) {
            // We are in SSR mode
            this.window = (/** @type {?} */ ({}));
        }
    }
    Object.defineProperty(WindowRef.prototype, "nativeWindow", {
        /**
         * Return window object
         */
        get: /**
         * Return window object
         * @return {?}
         */
        function () {
            return this.window;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowRef.prototype, "nativeDocument", {
        /**
         * Return document objext
         */
        get: /**
         * Return document objext
         * @return {?}
         */
        function () {
            return this.document;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowRef.prototype, "scrollbarWidth", {
        /**
         * Return a scrollbar width
         */
        get: /**
         * Return a scrollbar width
         * @return {?}
         */
        function () {
            if (scrollbarWidth == null) {
                try {
                    // Scrollbar width is not defined yet
                    /** @type {?} */
                    var outter = this.document.createElement('div');
                    /** @type {?} */
                    var inner = this.document.createElement('div');
                    /** @type {?} */
                    var width = void 0;
                    outter.style.width = '100px';
                    outter.style.height = '100px';
                    outter.style.overflow = 'auto';
                    outter.style.position = 'fixed';
                    outter.style.top = '-200px';
                    inner.style.height = '110px';
                    outter.appendChild(inner);
                    this.document.body.appendChild(outter);
                    width = 100 - inner.offsetWidth;
                    this.document.body.removeChild(outter);
                    scrollbarWidth = width;
                }
                catch (e) {
                    // Nope, we are running in SSR mode
                }
            }
            return scrollbarWidth || 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowRef.prototype, "isFF", {
        /**
         * Return if browser is FF
         */
        get: /**
         * Return if browser is FF
         * @return {?}
         */
        function () {
            return this.platform.FIREFOX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowRef.prototype, "isIEEdge", {
        /**
         * Return if browser is IE and Edge
         */
        get: /**
         * Return if browser is IE and Edge
         * @return {?}
         */
        function () {
            return this.platform.EDGE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowRef.prototype, "isIE", {
        get: /**
         * @return {?}
         */
        function () {
            return this.platform.TRIDENT;
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */
    WindowRef.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: Platform }
    ]; };
WindowRef.ɵfac = function WindowRef_Factory(t) { return new (t || WindowRef)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc3.Platform)); };
WindowRef.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: WindowRef, factory: function (t) { return WindowRef.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WindowRef, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc3.Platform }]; }, null); })();
    return WindowRef;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WindowRef.prototype.window;
    /**
     * @type {?}
     * @private
     */
    WindowRef.prototype.document;
    /**
     * @type {?}
     * @private
     */
    WindowRef.prototype.platform;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/pointer.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Helper service to normallize all pointer tapes and help to translate  pointer locations
 */
var BentoPointerService = /** @class */ (function () {
    function BentoPointerService(winRef) {
        var _this = this;
        /**
         * Pointer down event type name
         */
        this.pointerDown = 'mousedown';
        /**
         * Pointer move event type name
         */
        this.pointerMove = 'mousemove';
        /**
         * Pointer up event type name
         */
        this.pointerUp = 'mouseup';
        /**
         * Pointer out event type name
         */
        this.pointerOut = 'mouseout';
        /**
         * Pointer cancel event type name
         */
        this.pointerCancel = 'pointercancel';
        /**
         * Indicates if there is touch
         */
        this.hasTouch = false;
        this.exitSubscription = Subscription.EMPTY;
        this.emptyFunc = (/**
         * @return {?}
         */
        function () { });
        /** @type {?} */
        var win = winRef.nativeWindow;
        if (win.hasOwnProperty('PointerEvent')) {
            // Only update where supported.  Ex. Surface
            this.pointerDown = 'pointerdown';
            this.pointerMove = 'pointermove';
            this.pointerUp = 'pointerup';
            this.pointerOut = 'pointerout';
        }
        if (win.hasOwnProperty('TouchEvent')) {
            this.hasTouch = true;
        }
        // Create observable for pointer exit
        this.documentExit = Observable.create((/**
         * @param {?} sub
         * @return {?}
         */
        function (sub) {
            _this.exitSubscription = fromEvent(winRef.nativeDocument, _this.pointerOut).subscribe((/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                /** @type {?} */
                var from = e.relatedTarget;
                if (!from || from.nodeName === 'HTML') {
                    sub.next();
                }
            }));
        }));
    }
    /**
     * @return {?}
     */
    BentoPointerService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.exitSubscription.unsubscribe();
    };
    /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    BentoPointerService.prototype.listenPointerDown = /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    function (r, el, func) {
        return this.listenPointerEvent(r, this.pointerDown, 'touchstart', el, func);
    };
    /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    BentoPointerService.prototype.listenPointerMove = /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    function (r, el, func) {
        return this.listenPointerEvent(r, this.pointerMove, 'touchmove', el, func);
    };
    /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    BentoPointerService.prototype.listenPointerUp = /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    function (r, el, func) {
        return this.listenPointerEvent(r, this.pointerUp, 'touchup', el, func);
    };
    /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    BentoPointerService.prototype.listenPointerCancel = /**
     * @param {?} r
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    function (r, el, func) {
        return this.listenPointerEvent(r, this.pointerCancel, 'touchcacel', el, func);
    };
    /**
     * Get pointer X and Y values from an pointer event
     */
    /**
     * Get pointer X and Y values from an pointer event
     * @param {?} e
     * @return {?}
     */
    BentoPointerService.prototype.getPointerXY = /**
     * Get pointer X and Y values from an pointer event
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var pointer = e.hasOwnProperty('changedTouches') // `changedTouches` is available on Windows touch surfaces
            ? e['changedTouches'][0]
            : e;
        /** @type {?} */
        var pointerX = pointer.clientX ? pointer.clientX : pointer.pageX;
        /** @type {?} */
        var pointerY = pointer.clientY ? pointer.clientY : pointer.pageY;
        return { x: pointerX, y: pointerY };
    };
    /**
     * @private
     * @param {?} r
     * @param {?} pointerEventType
     * @param {?} touchEventType
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    BentoPointerService.prototype.listenPointerEvent = /**
     * @private
     * @param {?} r
     * @param {?} pointerEventType
     * @param {?} touchEventType
     * @param {?} el
     * @param {?} func
     * @return {?}
     */
    function (r, pointerEventType, touchEventType, el, func) {
        /** @type {?} */
        var callback = (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            func(e);
            e.stopImmediatePropagation();
        });
        /** @type {?} */
        var pointDownCancel = r.listen(el, pointerEventType, callback);
        /** @type {?} */
        var touchStartCancel = this.hasTouch ? r.listen(el, touchEventType, callback) : this.emptyFunc;
        return (/**
         * @return {?}
         */
        function () {
            pointDownCancel();
            touchStartCancel();
        });
    };
    /** @nocollapse */
    BentoPointerService.ctorParameters = function () { return [
        { type: WindowRef }
    ]; };
    /** @nocollapse */ BentoPointerService.ɵprov = ɵɵdefineInjectable({ factory: function BentoPointerService_Factory() { return new BentoPointerService(ɵɵinject(WindowRef)); }, token: BentoPointerService, providedIn: "root" });
BentoPointerService.ɵfac = function BentoPointerService_Factory(t) { return new (t || BentoPointerService)(ɵngcc0.ɵɵinject(WindowRef)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoPointerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WindowRef }]; }, null); })();
    return BentoPointerService;
}());
if (false) {
    /**
     * Pointer down event type name
     * @type {?}
     */
    BentoPointerService.prototype.pointerDown;
    /**
     * Pointer move event type name
     * @type {?}
     */
    BentoPointerService.prototype.pointerMove;
    /**
     * Pointer up event type name
     * @type {?}
     */
    BentoPointerService.prototype.pointerUp;
    /**
     * Pointer out event type name
     * @type {?}
     */
    BentoPointerService.prototype.pointerOut;
    /**
     * Pointer cancel event type name
     * @type {?}
     */
    BentoPointerService.prototype.pointerCancel;
    /**
     * Indicates if there is touch
     * @type {?}
     */
    BentoPointerService.prototype.hasTouch;
    /**
     * Subsctibable to when pointer exits the document
     * @type {?}
     */
    BentoPointerService.prototype.documentExit;
    /**
     * @type {?}
     * @private
     */
    BentoPointerService.prototype.exitSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoPointerService.prototype.emptyFunc;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/positioning.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoPositioning = /** @class */ (function () {
    function BentoPositioning(windowRef) {
    }
    /**
     * Reset the width of an element
     * @param r Renderer2 object
     * @param el Element to be reset
     */
    /**
     * Reset the width of an element
     * @param {?} r Renderer2 object
     * @param {?} el Element to be reset
     * @return {?}
     */
    BentoPositioning.resetWidth = /**
     * Reset the width of an element
     * @param {?} r Renderer2 object
     * @param {?} el Element to be reset
     * @return {?}
     */
    function (r, el) {
        r.removeStyle(el, 'width');
        r.removeStyle(el, 'max-width');
    };
    /**
     * Main method to position a target element against the host element included in a container
     * @param renderer Angular Renderer2 for rendering
     * @param host The HTMLElement that is to be aligned to
     * @param target The HTMLElement that is to be placed to align with the `host`
     * @param container Container HTMLElement to host the `target` element
     * @param placement Only work for 'top' and 'bottom' at this point
     * @param alignment Horizontal alignment 'left' and 'right' TODO: 'center' to come later
     * @param offset Offset in pixels to fine tune the placement location
     * @param autoRealign Auto relaign to the container with the `target` is out of boundary
     */
    /**
     * Main method to position a target element against the host element included in a container
     * @param {?} renderer Angular Renderer2 for rendering
     * @param {?} host The HTMLElement that is to be aligned to
     * @param {?} target The HTMLElement that is to be placed to align with the `host`
     * @param {?} container Container HTMLElement to host the `target` element
     * @param {?=} placement Only work for 'top' and 'bottom' at this point
     * @param {?=} alignment Horizontal alignment 'left' and 'right' TODO: 'center' to come later
     * @param {?=} offset Offset in pixels to fine tune the placement location
     * @param {?=} autoRealign Auto relaign to the container with the `target` is out of boundary
     * @return {?}
     */
    BentoPositioning.prototype.positionElement = /**
     * Main method to position a target element against the host element included in a container
     * @param {?} renderer Angular Renderer2 for rendering
     * @param {?} host The HTMLElement that is to be aligned to
     * @param {?} target The HTMLElement that is to be placed to align with the `host`
     * @param {?} container Container HTMLElement to host the `target` element
     * @param {?=} placement Only work for 'top' and 'bottom' at this point
     * @param {?=} alignment Horizontal alignment 'left' and 'right' TODO: 'center' to come later
     * @param {?=} offset Offset in pixels to fine tune the placement location
     * @param {?=} autoRealign Auto relaign to the container with the `target` is out of boundary
     * @return {?}
     */
    function (renderer, host, target, container, placement, alignment, offset, autoRealign) {
        if (placement === void 0) { placement = 'bottom'; }
        if (alignment === void 0) { alignment = 'left'; }
        if (offset === void 0) { offset = 0; }
        if (autoRealign === void 0) { autoRealign = false; }
        /** @type {?} */
        var containerClientWidth = container.clientWidth;
        this.r = renderer;
        this.r.setStyle(target, 'visibility', 'hidden');
        if (placement === 'bottom') {
            this.r.setStyle(target, 'top', '0');
            this.r.setStyle(target, 'bottom', 'auto');
        }
        else {
            this.r.setStyle(target, 'bottom', '0');
            this.r.setStyle(target, 'top', 'auto');
        }
        if (alignment === 'left') {
            this.r.setStyle(target, 'left', '0');
            this.r.setStyle(target, 'right', 'auto');
        }
        else {
            this.r.setStyle(target, 'right', '0');
            this.r.setStyle(target, 'left', 'auto');
        }
        if (autoRealign) {
            // Set max width to the target el if there is an auto-relaignment
            this.r.setStyle(target, 'max-width', containerClientWidth + 'px');
        }
        this.r.appendChild(container, target);
        /** @type {?} */
        var hostRect = host.getBoundingClientRect();
        /** @type {?} */
        var targetRect = target.getBoundingClientRect();
        /** @type {?} */
        var containerRect = container.getBoundingClientRect();
        /** @type {?} */
        var dTop = hostRect.bottom - targetRect.top;
        /** @type {?} */
        var dBottom = hostRect.top - targetRect.bottom;
        /** @type {?} */
        var dLeft = Math.max(hostRect.left - targetRect.left, containerRect.left - targetRect.left);
        /** @type {?} */
        var dRight = hostRect.right - targetRect.right;
        if (autoRealign) {
            // We still need a temporary element to measure the content location against
            // the viewport so that we can conpensate gaps with all borders and scrollbars(in RTL)
            // without having gaps
            /** @type {?} */
            var tempEl = this.r.createElement('div');
            /** @type {?} */
            var tempRect = void 0;
            this.r.setStyle(tempEl, 'visibility', 'hidden');
            this.r.setStyle(tempEl, 'height', '0');
            this.r.appendChild(container, tempEl);
            tempRect = tempEl.getBoundingClientRect();
            // Remove and clean temporary element
            this.r.removeChild(container, tempEl);
            tempEl = null;
            if (alignment === 'left' && hostRect.left + targetRect.width > tempRect.right) {
                // `target` is out of boundary on the right need to move it back
                dLeft = tempRect.right - targetRect.width - targetRect.left;
            }
            else if (alignment === 'right' && hostRect.right - targetRect.width < tempRect.left) {
                // `target` is out of boundary on the left and need to align left
                dRight = tempRect.left + targetRect.width - targetRect.right;
            }
        }
        // There are only two case for now 'top' and 'bottom'
        // Will exrtend to 'left' and 'right' when required
        switch (placement) {
            case 'top':
                if (alignment === 'left') {
                    this.updatePositionStyles(target, 'auto', 'auto', -dBottom + offset + 'px', dLeft + 'px');
                }
                else {
                    this.updatePositionStyles(target, 'auto', -dRight + 'px', -dBottom + offset + 'px', 'auto');
                }
                break;
            default:
                if (alignment === 'left') {
                    this.updatePositionStyles(target, dTop + offset + 'px', 'auto', 'auto', dLeft + 'px');
                }
                else {
                    this.updatePositionStyles(target, dTop + offset + 'px', -dRight + 'px', 'auto', 'auto');
                }
        }
        // Show element
        this.r.removeStyle(target, 'visibility');
    };
    /**
     * Reset style positioning values previously assigned by `.positionElement(...)`
     * @param r Renderer2 used to render
     * @param el HTMLElement to be reset
     */
    /**
     * Reset style positioning values previously assigned by `.positionElement(...)`
     * @param {?} r Renderer2 used to render
     * @param {?} el HTMLElement to be reset
     * @return {?}
     */
    BentoPositioning.prototype.resetPosition = /**
     * Reset style positioning values previously assigned by `.positionElement(...)`
     * @param {?} r Renderer2 used to render
     * @param {?} el HTMLElement to be reset
     * @return {?}
     */
    function (r, el) {
        r.removeStyle(el, 'top');
        r.removeStyle(el, 'left');
        r.removeStyle(el, 'right');
        r.removeStyle(el, 'bottom');
    };
    /**
     * Update positioning CSS styles
     */
    /**
     * Update positioning CSS styles
     * @private
     * @param {?} el
     * @param {?} top
     * @param {?} right
     * @param {?} bottom
     * @param {?} left
     * @param {?=} width
     * @return {?}
     */
    BentoPositioning.prototype.updatePositionStyles = /**
     * Update positioning CSS styles
     * @private
     * @param {?} el
     * @param {?} top
     * @param {?} right
     * @param {?} bottom
     * @param {?} left
     * @param {?=} width
     * @return {?}
     */
    function (el, top, right, bottom, left, width) {
        this.r.setStyle(el, 'top', top);
        this.r.setStyle(el, 'right', right);
        this.r.setStyle(el, 'bottom', bottom);
        this.r.setStyle(el, 'left', left);
        if (width) {
            this.r.setStyle(el, 'width', width);
        }
    };
    /** @nocollapse */
    BentoPositioning.ctorParameters = function () { return [
        { type: WindowRef }
    ]; };
    /** @nocollapse */ BentoPositioning.ɵprov = ɵɵdefineInjectable({ factory: function BentoPositioning_Factory() { return new BentoPositioning(ɵɵinject(WindowRef)); }, token: BentoPositioning, providedIn: "root" });
BentoPositioning.ɵfac = function BentoPositioning_Factory(t) { return new (t || BentoPositioning)(ɵngcc0.ɵɵinject(WindowRef)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoPositioning, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WindowRef }]; }, null); })();
    return BentoPositioning;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoPositioning.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/refresh-notifier.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoRefreshNotifierDirective = /** @class */ (function () {
    function BentoRefreshNotifierDirective(tabset, notification) {
        this.tabset = tabset;
        this.notification = notification;
        this.changeSubscription = Subscription.EMPTY;
    }
    /**
     * @return {?}
     */
    BentoRefreshNotifierDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.changeSubscription = this.tabset.tabChange.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var condition = true;
            if (event && _this.notificationCondition && _this.notificationCondition.name && _this.notificationCondition.value) {
                /**
                 * The `name` property of `notificationCondition` matches to `NgbTabChangeEvent`'s `nextId` property
                 * In the below logic `event[this.notificationCondition.name]` is same as `event.nextId`
                 */
                condition = event[_this.notificationCondition.name] === _this.notificationCondition.value;
            }
            if (event && condition) {
                _this.notification.emitResize();
            }
        }));
    };
    /**
     * @return {?}
     */
    BentoRefreshNotifierDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.changeSubscription.unsubscribe();
    };
    /** @nocollapse */
    BentoRefreshNotifierDirective.ctorParameters = function () { return [
        { type: NgbTabset, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbTabset; })),] }] },
        { type: BentoNotification }
    ]; };
    BentoRefreshNotifierDirective.propDecorators = {
        notificationCondition: [{ type: Input }]
    };
BentoRefreshNotifierDirective.ɵfac = function BentoRefreshNotifierDirective_Factory(t) { return new (t || BentoRefreshNotifierDirective)(ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbTabset; }))), ɵngcc0.ɵɵdirectiveInject(BentoNotification)); };
BentoRefreshNotifierDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoRefreshNotifierDirective, selectors: [["ngb-tabset", "bentoRefreshNotifier", ""]], inputs: { notificationCondition: "notificationCondition" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoRefreshNotifierDirective, [{
        type: Directive,
        args: [{ selector: 'ngb-tabset[bentoRefreshNotifier]' }]
    }], function () { return [{ type: ɵngcc4.NgbTabset, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbTabset; }))]
            }] }, { type: BentoNotification }]; }, { notificationCondition: [{
            type: Input
        }] }); })();
    return BentoRefreshNotifierDirective;
}());
if (false) {
    /**
     * Condition to emit resize event
     * It's an object with `name` and `value` {name: 'nextId', value: 'demos'}
     * @type {?}
     */
    BentoRefreshNotifierDirective.prototype.notificationCondition;
    /**
     * @type {?}
     * @private
     */
    BentoRefreshNotifierDirective.prototype.changeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoRefreshNotifierDirective.prototype.tabset;
    /**
     * @type {?}
     * @private
     */
    BentoRefreshNotifierDirective.prototype.notification;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/replace-tag.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoReplaceTagDirective = /** @class */ (function () {
    function BentoReplaceTagDirective(winRef, el, templateRef, vcf, sanitizer) {
        this.el = el;
        this.templateRef = templateRef;
        this.vcf = vcf;
        this.sanitizer = sanitizer;
        this.document = winRef.nativeDocument;
    }
    Object.defineProperty(BentoReplaceTagDirective.prototype, "tag", {
        set: /**
         * @param {?} t
         * @return {?}
         */
        function (t) {
            this._tag = t;
            this.vcf.clear();
            this.vcf.createEmbeddedView(this.templateRef);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoReplaceTagDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this._updateTemplate();
    };
    /**
     * @private
     * @return {?}
     */
    BentoReplaceTagDirective.prototype._updateTemplate = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var template = this.el.nativeElement.nextElementSibling;
        if (template) {
            /** @type {?} */
            var r_1 = this.document.createElement(this._tag);
            template.getAttributeNames().forEach((/**
             * @param {?} attrName
             * @return {?}
             */
            function (attrName) {
                r_1.setAttribute(attrName, template.getAttribute(attrName));
            }));
            r_1.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, template.innerHTML);
            this.el.nativeElement.parentNode.replaceChild(r_1, template);
        }
    };
    /** @nocollapse */
    BentoReplaceTagDirective.ctorParameters = function () { return [
        { type: WindowRef },
        { type: ElementRef },
        { type: TemplateRef },
        { type: ViewContainerRef },
        { type: DomSanitizer }
    ]; };
    BentoReplaceTagDirective.propDecorators = {
        tag: [{ type: Input, args: ['replaceTag',] }]
    };
BentoReplaceTagDirective.ɵfac = function BentoReplaceTagDirective_Factory(t) { return new (t || BentoReplaceTagDirective)(ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
BentoReplaceTagDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoReplaceTagDirective, selectors: [["", "replaceTag", ""]], inputs: { tag: ["replaceTag", "tag"] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoReplaceTagDirective, [{
        type: Directive,
        args: [{
                selector: '[replaceTag]'
            }]
    }], function () { return [{ type: WindowRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc5.DomSanitizer }]; }, { tag: [{
            type: Input,
            args: ['replaceTag']
        }] }); })();
    return BentoReplaceTagDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoReplaceTagDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoReplaceTagDirective.prototype._tag;
    /**
     * @type {?}
     * @private
     */
    BentoReplaceTagDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoReplaceTagDirective.prototype.templateRef;
    /**
     * @type {?}
     * @private
     */
    BentoReplaceTagDirective.prototype.vcf;
    /**
     * @type {?}
     * @private
     */
    BentoReplaceTagDirective.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/string.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A pipe used to replace strings
 */
var BentoStringReplacePipe = /** @class */ (function () {
    function BentoStringReplacePipe() {
    }
    /**
     * @param {?} value
     * @param {?} find
     * @param {?} replaceWith
     * @return {?}
     */
    BentoStringReplacePipe.prototype.transform = /**
     * @param {?} value
     * @param {?} find
     * @param {?} replaceWith
     * @return {?}
     */
    function (value, find, replaceWith) {
        /** @type {?} */
        var re = new RegExp(find, 'g');
        return value.replace(re, replaceWith);
    };
BentoStringReplacePipe.ɵfac = function BentoStringReplacePipe_Factory(t) { return new (t || BentoStringReplacePipe)(); };
BentoStringReplacePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bentoStringReplace", type: BentoStringReplacePipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoStringReplacePipe, [{
        type: Pipe,
        args: [{ name: 'bentoStringReplace' }]
    }], function () { return []; }, null); })();
    return BentoStringReplacePipe;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/tab.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTabService = /** @class */ (function () {
    function BentoTabService() {
    }
    /**
     * Find focussable elements in an element
     */
    /**
     * Find focussable elements in an element
     * @param {?} element
     * @return {?}
     */
    BentoTabService.prototype.findFocussable = /**
     * Find focussable elements in an element
     * @param {?} element
     * @return {?}
     */
    function (element) {
        /** @type {?} */
        var els = element.querySelectorAll('a,input,select,textarea,button,[tabindex]:not(.cdk-visually-hidden)');
        /** @type {?} */
        var elArray = [];
        /** @type {?} */
        var el;
        for (var i = 0, len = els.length; i < len; i++) {
            el = els[i];
            if (this.isVisible(el) && (!el.hasAttribute('disabled') || el.nodeName === 'A') && el.tabIndex > -1) {
                elArray.push(el);
            }
        }
        return elArray;
    };
    /**
     * Find tabbable element in an element
     */
    /**
     * Find tabbable element in an element
     * @param {?} element
     * @return {?}
     */
    BentoTabService.prototype.findTabbable = /**
     * Find tabbable element in an element
     * @param {?} element
     * @return {?}
     */
    function (element) {
        /** @type {?} */
        var elArray = this.findFocussable(element);
        return elArray.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            /** @type {?} */
            var a = item.getAttribute('tabindex');
            if (!a || a !== -1) {
                return true;
            }
        }));
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BentoTabService.prototype.isVisible = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        return !(element.offsetWidth === 0 && element.offsetHeight === 0);
    };
    /** @nocollapse */ BentoTabService.ɵprov = ɵɵdefineInjectable({ factory: function BentoTabService_Factory() { return new BentoTabService(); }, token: BentoTabService, providedIn: "root" });
BentoTabService.ɵfac = function BentoTabService_Factory(t) { return new (t || BentoTabService)(); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTabService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();
    return BentoTabService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/uid.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A service to create UIDs
 */
var BentoUidService = /** @class */ (function () {
    function BentoUidService() {
    }
    /**
     * @return {?}
     */
    BentoUidService.prototype.generate = /**
     * @return {?}
     */
    function () {
        /**
         * @return {?}
         */
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
    };
    /** @nocollapse */ BentoUidService.ɵprov = ɵɵdefineInjectable({ factory: function BentoUidService_Factory() { return new BentoUidService(); }, token: BentoUidService, providedIn: "root" });
BentoUidService.ɵfac = function BentoUidService_Factory(t) { return new (t || BentoUidService)(); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUidService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();
    return BentoUidService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/utils.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoUtilsModule = /** @class */ (function () {
    function BentoUtilsModule() {
    }
BentoUtilsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoUtilsModule });
BentoUtilsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoUtilsModule_Factory(t) { return new (t || BentoUtilsModule)(); }, providers: [
        BentoTabService,
        BentoUidService,
        WindowRef,
        BentoNotification,
        BentoPositioning,
        BentoLogService,
        BentoPointerService
    ] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoUtilsModule, { declarations: [BentoStringReplacePipe,
        BentoFileSizePipe,
        BentoReplaceTagDirective,
        BentoRefreshNotifierDirective], exports: [BentoStringReplacePipe,
        BentoFileSizePipe,
        BentoReplaceTagDirective,
        BentoRefreshNotifierDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUtilsModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoStringReplacePipe, BentoFileSizePipe, BentoReplaceTagDirective, BentoRefreshNotifierDirective],
                providers: [
                    BentoTabService,
                    BentoUidService,
                    WindowRef,
                    BentoNotification,
                    BentoPositioning,
                    BentoLogService,
                    BentoPointerService
                ],
                exports: [BentoStringReplacePipe, BentoFileSizePipe, BentoReplaceTagDirective, BentoRefreshNotifierDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoUtilsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/alert/alert-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoAlertItemComponent = /** @class */ (function () {
    function BentoAlertItemComponent(elRef, windowRef, dir) {
        var _this = this;
        this.elRef = elRef;
        /**
         * Emit event when this instance is closed
         */
        this.close = new EventEmitter();
        /**
         * Flag to determine if this alert is in RTL mode or not
         */
        this.isRTL = false;
        this.document = windowRef.nativeDocument;
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRTL = dir.value === 'rtl';
        }));
    }
    /**
     * @return {?}
     */
    BentoAlertItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.options.timeout) {
            /** @type {?} */
            var time = this.options.timeout;
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.closeAlert();
            }), time);
        }
    };
    /**
     * @return {?}
     */
    BentoAlertItemComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.lastActiveElement = (/** @type {?} */ (this.document.activeElement));
        this.focusBentoAlert();
    };
    /**
     * @return {?}
     */
    BentoAlertItemComponent.prototype.isActiveElement = /**
     * @return {?}
     */
    function () {
        return this.elRef.nativeElement.contains(this.document.activeElement);
    };
    /**
     * Close the current alert UI instance
     */
    /**
     * Close the current alert UI instance
     * @return {?}
     */
    BentoAlertItemComponent.prototype.closeAlert = /**
     * Close the current alert UI instance
     * @return {?}
     */
    function () {
        this.close.emit({ alert: this.options, index: this.index, focusedEl: this.lastActiveElement });
    };
    /**
     * @return {?}
     */
    BentoAlertItemComponent.prototype.focusBentoAlert = /**
     * @return {?}
     */
    function () {
        this.alertRef.nativeElement.focus();
    };
    /** @nocollapse */
    BentoAlertItemComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: WindowRef },
        { type: Directionality }
    ]; };
    BentoAlertItemComponent.propDecorators = {
        options: [{ type: Input }],
        index: [{ type: Input }],
        close: [{ type: Output }],
        alertRef: [{ type: ViewChild, args: ['alert', { static: true },] }]
    };
BentoAlertItemComponent.ɵfac = function BentoAlertItemComponent_Factory(t) { return new (t || BentoAlertItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoAlertItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoAlertItemComponent, selectors: [["bento-alert-item"]], viewQuery: function BentoAlertItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.alertRef = _t.first);
    } }, inputs: { options: "options", index: "index" }, outputs: { close: "close" }, decls: 6, vars: 8, consts: [["tabindex", "0", "role", "alert", 1, "alert", "bento-alert", 3, "ngClass"], ["alert", ""], [4, "ngIf", "ngIfElse"], ["type", "button", "class", "close", "cdkMonitorElementFocus", "", 3, "click", 4, "ngIf"], ["defaultTemplate", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", "cdkMonitorElementFocus", "", 1, "close", 3, "click"], ["aria-hidden", "true", 1, "bui-alert-close-indicator"], [3, "innerHTML"]], template: function BentoAlertItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, BentoAlertItemComponent_div_2_Template, 2, 5, "div", 2);
        ɵngcc0.ɵɵtemplate(3, BentoAlertItemComponent_button_3_Template, 3, 4, "button", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, BentoAlertItemComponent_ng_template_4_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r3 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c2, "alert-" + (ctx.options.type || "warning"), ctx.options.closeable ? "alert-dismissable" : ""));
        ɵngcc0.ɵɵattribute("bento-alert-index", ctx.index);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.options.template)("ngIfElse", _r3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.options.closeable);
    } }, directives: [ɵngcc7.NgClass, ɵngcc7.NgIf, ɵngcc7.NgTemplateOutlet, BentoFocusMonitorDirective, ɵngcc1.CdkMonitorFocus], pipes: [BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoAlertItemComponent, [{
        type: Component,
        args: [{ selector: 'bento-alert-item', template: "<div\n  class=\"alert bento-alert\"\n  [attr.bento-alert-index]=\"index\"\n  [ngClass]=\"['alert-' + (options.type || 'warning'), options.closeable ? 'alert-dismissable' : '']\"\n  tabindex=\"0\"\n  role=\"alert\"\n  #alert\n>\n  <div *ngIf=\"options.template; else defaultTemplate\">\n    <ng-container *ngTemplateOutlet=\"options.template; context: {options: options, index: index}\"> </ng-container>\n  </div>\n  <button\n    *ngIf=\"options.closeable\"\n    type=\"button\"\n    class=\"close\"\n    cdkMonitorElementFocus\n    (click)=\"closeAlert()\"\n    [attr.aria-label]=\"'BENTO_UI_ALERT_CLOSE_BUTTON' | bentoTranslate: alert.closeButtonLabel\"\n  >\n    <i class=\"bui-alert-close-indicator\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n<ng-template #defaultTemplate>\n  <span [innerHTML]=\"options.msg\"></span>\n</ng-template>\n" }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: ɵngcc6.Directionality }]; }, { close: [{
            type: Output
        }], options: [{
            type: Input
        }], index: [{
            type: Input
        }], alertRef: [{
            type: ViewChild,
            args: ['alert', { static: true }]
        }] }); })();
    return BentoAlertItemComponent;
}());
if (false) {
    /**
     * Alert item options
     * @type {?}
     */
    BentoAlertItemComponent.prototype.options;
    /**
     * Index number to specify this Alert instance
     * @type {?}
     */
    BentoAlertItemComponent.prototype.index;
    /**
     * Emit event when this instance is closed
     * @type {?}
     */
    BentoAlertItemComponent.prototype.close;
    /**
     * Element reference to the child HTMLElement
     * @type {?}
     */
    BentoAlertItemComponent.prototype.alertRef;
    /**
     * Flag to determine if this alert is in RTL mode or not
     * @type {?}
     */
    BentoAlertItemComponent.prototype.isRTL;
    /**
     * @type {?}
     * @private
     */
    BentoAlertItemComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoAlertItemComponent.prototype.lastActiveElement;
    /**
     * @type {?}
     * @private
     */
    BentoAlertItemComponent.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/keyboard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Keyboard Constant Variables
 * CAPS_LOCK: number; ESC: number; SPACE: number; PAGE_UP: number; PAGE_DOWN: number; END: number; HOME: number;
 * LEFT: number; UP: number; RIGHT: number; DOWN: number; INSERT: number; DELETE: number; COMMAND: number}}
 */
/** @type {?} */
var Keyboard = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    INSERT: 45,
    DELETE: 46,
    COMMAND: 91,
    RIGHT_COMMAND: 92,
    NUM_0: 96,
    NUM_1: 97,
    NUM_2: 98,
    NUM_3: 99,
    NUM_4: 100,
    NUM_5: 101,
    NUM_6: 102,
    NUM_7: 103,
    NUM_8: 104,
    NUM_9: 105,
    NUM_ASTERISK: 106,
    NUM_ADD: 107,
    NUM_MINUS: 109,
    NUM_POINT: 110,
    NUM_DIVIDE: 111,
    COMMA: 188
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/alert/alert.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoAlertComponent = /** @class */ (function () {
    function BentoAlertComponent() {
        /**
         * An event emitted when the close button is clicked. This event returns a payload with the alert item's index number.
         * Only relevant for dismissible alerts.
         */
        this.close = new EventEmitter();
        /**
         * Flag to determine of all Bento Alert items are displayed inline with other elements
         */
        this.inline = false;
    }
    /**
     * Init hook
     */
    /**
     * Init hook
     * @return {?}
     */
    BentoAlertComponent.prototype.ngOnInit = /**
     * Init hook
     * @return {?}
     */
    function () {
        var _this = this;
        // bind keyup events to handler, only if there are alert items.
        this._windowClickSubscription = fromEvent(window, 'keyup')
            .pipe(filter((/**
         * @param {?} e
         * @return {?}
         */
        function (e) { return _this.items.length > 0; })))
            .subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            _this._onAlertKeyPress(e);
        }));
    };
    /**
     * Destroy event hook
     */
    /**
     * Destroy event hook
     * @return {?}
     */
    BentoAlertComponent.prototype.ngOnDestroy = /**
     * Destroy event hook
     * @return {?}
     */
    function () {
        this._windowClickSubscription.unsubscribe();
    };
    /**
     * on close alert
     */
    /**
     * on close alert
     * @param {?} $event
     * @return {?}
     */
    BentoAlertComponent.prototype.onAlertClose = /**
     * on close alert
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        // remove alert from array
        /** @type {?} */
        var index = this.items.indexOf($event.alert);
        if (index > -1) {
            this.items.splice(index, 1);
        }
        // bubble emit
        this.close.emit($event.index);
        // after closing, focus on previous alert item
        /** @type {?} */
        var nextAlertIndex = index > 0 ? index - 1 : 1;
        /** @type {?} */
        var alertItem = this._bentoAlertItems.find((/**
         * @param {?} item
         * @param {?} id
         * @return {?}
         */
        function (item, id) { return id === nextAlertIndex; }));
        if (alertItem) {
            alertItem.focusBentoAlert();
        }
        else if ($event.focusedEl) {
            $event.focusedEl.focus();
        }
    };
    /**
     * KeyPress Event handling for A11y
     */
    /**
     * KeyPress Event handling for A11y
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoAlertComponent.prototype._onAlertKeyPress = /**
     * KeyPress Event handling for A11y
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var BreakException = {};
        /** @type {?} */
        var previousItem = this._bentoAlertItems.first;
        switch (e.keyCode) {
            case Keyboard.DOWN: {
                try {
                    this._bentoAlertItems.forEach((/**
                     * @param {?} item
                     * @param {?} index
                     * @return {?}
                     */
                    function (item, index) {
                        if (previousItem.isActiveElement() && previousItem !== item) {
                            item.focusBentoAlert();
                            throw BreakException;
                        }
                        previousItem = item;
                    }));
                }
                catch (e) {
                    if (e !== BreakException) {
                        /* istanbul ignore next */
                        throw e;
                    }
                }
                break;
            }
            case Keyboard.UP: {
                try {
                    this._bentoAlertItems.forEach((/**
                     * @param {?} item
                     * @param {?} index
                     * @return {?}
                     */
                    function (item, index) {
                        if (item.isActiveElement()) {
                            if (index > 0) {
                                previousItem.focusBentoAlert();
                                throw BreakException;
                            }
                        }
                        previousItem = item;
                    }));
                }
                catch (e) {
                    if (e !== BreakException) {
                        /* istanbul ignore next */
                        throw e;
                    }
                }
                break;
            }
            case Keyboard.DELETE:
            case Keyboard.BACKSPACE: {
                try {
                    this._bentoAlertItems.forEach((/**
                     * @param {?} item
                     * @param {?} index
                     * @return {?}
                     */
                    function (item, index) {
                        if (item.isActiveElement()) {
                            item.closeAlert();
                            throw BreakException;
                        }
                    }));
                }
                catch (e) {
                    if (e !== BreakException) {
                        /* istanbul ignore next */
                        throw e;
                    }
                }
                break;
            }
        }
    };
    BentoAlertComponent.propDecorators = {
        items: [{ type: Input }],
        close: [{ type: Output }],
        inline: [{ type: Input }, { type: HostBinding, args: ['class.bento-alert-inline',] }],
        _bentoAlertItems: [{ type: ViewChildren, args: [BentoAlertItemComponent,] }]
    };
BentoAlertComponent.ɵfac = function BentoAlertComponent_Factory(t) { return new (t || BentoAlertComponent)(); };
BentoAlertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoAlertComponent, selectors: [["bento-alert"]], viewQuery: function BentoAlertComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoAlertItemComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._bentoAlertItems = _t);
    } }, hostVars: 2, hostBindings: function BentoAlertComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bento-alert-inline", ctx.inline);
    } }, inputs: { inline: "inline", items: "items" }, outputs: { close: "close" }, decls: 3, vars: 4, consts: [["tabindex", "-1", "cdkTrapFocus", "", 1, "alert-container", "refresh-data"], ["class", "bento-alert-container", 3, "options", "index", "close", 4, "ngFor", "ngForOf"], [1, "bento-alert-container", 3, "options", "index", "close"]], template: function BentoAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "bentoTranslate");
        ɵngcc0.ɵɵtemplate(2, BentoAlertComponent_bento_alert_item_2_Template, 1, 4, "bento-alert-item", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 2, "BENTO_UI_ALERT_DESCRIPTION"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [ɵngcc1.CdkTrapFocus, ɵngcc7.NgForOf, BentoAlertItemComponent], pipes: [BentoTranslatePipe], styles: ["bento-alert .alert{text-align:left;box-sizing:border-box;border:none;position:relative;font-size:1.071rem;padding:11px 62px 10px 50px;min-height:44px}[dir=rtl] bento-alert .alert{text-align:right;padding:11px 50px 10px 62px}bento-alert .alert a{text-decoration:underline}bento-alert .alert a:hover{opacity:.9}bento-alert .alert:before{font-family:bento-icons;font-style:normal;font-weight:400;font-size:1.429rem;line-height:1;position:absolute;left:5px;width:40px;text-align:center;-webkit-font-smoothing:antialiased}[dir=rtl] bento-alert .alert:before{left:auto;right:5px}bento-alert .alert button.close{align-items:center;background:0 0;border-radius:15px;border:none;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;position:absolute;right:10px;text-align:center;text-shadow:none;top:10px;width:24px}[dir=rtl] bento-alert .alert button.close{right:auto;left:10px}bento-alert .alert button.close i{font-family:bento-icons;top:0;font-style:normal}bento-alert .alert button.close:focus{outline:0}bento-alert .alert button.close:hover{transition:background .3s}bento-alert .alert button.close:hover i{transition:color .1s}bento-alert .alert-dismissable .close{top:0}bento-alert .bento-alert{margin-bottom:5px;transition:opacity .5s,filter .5s;box-shadow:2px 2px 6px 0 rgba(0,0,0,.3)}bento-alert-inline bento-alert .bento-alert{box-shadow:none}bento-alert .alert-container{z-index:1000000;position:fixed;top:37px;left:50%;min-width:300px;transform:translate(-50%,0);-ms-transform:translate(-50%,0);-webkit-transform:translate(-50%,0)}bento-alert .alert-container:focus{outline:0}bento-alert .alert-container.right{left:auto;right:20px;transform:translate(0,0);-ms-transform:translate(0,0);-webkit-transform:translate(0,0)}[dir=rtl] bento-alert .alert-container.right{left:20px;right:auto}bento-alert .alert-container.right>div{width:auto;max-width:100%;display:inline-block}bento-alert .alert-container.left{left:20px;transform:translate(0,0);-ms-transform:translate(0,0);-webkit-transform:translate(0,0)}[dir=rtl] bento-alert .alert-container.left{left:auto;right:20px}bento-alert.bento-alert-inline .alert-container{z-index:auto;display:block;position:relative;top:auto;left:auto;width:100%;min-width:0;transform:none;-ms-transform:none;-webkit-transform:none}@media (min-width:1200px){bento-alert .alert-container{width:40%}}@media (min-width:992px) and (max-width:1199px){bento-alert .alert-container{width:55%}}@media (min-width:768px) and (max-width:991px){bento-alert .alert-container{width:75%}}@media (max-width:767px){bento-alert .alert-container{width:80%}}bento-alert .bento-alert-container{display:block;transition:.2s linear}bento-alert .bento-alert-container.ng-enter{opacity:0}bento-alert .bento-alert-container.ng-enter.ng-enter-active{opacity:1}bento-alert .bento-alert-container.ng-leave{overflow:hidden;opacity:1}bento-alert .bento-alert-container.ng-leave.ng-leave-active{opacity:0}bento-alert .bento-alert-container.ng-leave.ng-leave-active:not(:last-child){height:0!important}"], encapsulation: 2, data: { animation: [
            trigger('fadeInOut', [
                transition('void => *', [animate(100, keyframes([style({ opacity: 0 }), style({ opacity: 1 })]))]),
                transition('* => void', [animate(100, keyframes([style({ opacity: 1 }), style({ opacity: 0, height: 0 })]))])
            ])
        ] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoAlertComponent, [{
        type: Component,
        args: [{
                selector: 'bento-alert',
                template: "<div\n  class=\"alert-container refresh-data\"\n  [attr.aria-label]=\"'BENTO_UI_ALERT_DESCRIPTION' | bentoTranslate\"\n  tabindex=\"-1\"\n  cdkTrapFocus\n>\n  <bento-alert-item\n    *ngFor=\"let alert of items; let i = index\"\n    class=\"bento-alert-container\"\n    [@fadeInOut]\n    [options]=\"alert\"\n    [index]=\"i\"\n    (close)=\"onAlertClose($event)\"\n    [attr.rel]=\"'bento-alert-' + i\"\n  >\n  </bento-alert-item>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('fadeInOut', [
                        transition('void => *', [animate(100, keyframes([style({ opacity: 0 }), style({ opacity: 1 })]))]),
                        transition('* => void', [animate(100, keyframes([style({ opacity: 1 }), style({ opacity: 0, height: 0 })]))])
                    ])
                ],
                styles: ["bento-alert .alert{text-align:left;box-sizing:border-box;border:none;position:relative;font-size:1.071rem;padding:11px 62px 10px 50px;min-height:44px}[dir=rtl] bento-alert .alert{text-align:right;padding:11px 50px 10px 62px}bento-alert .alert a{text-decoration:underline}bento-alert .alert a:hover{opacity:.9}bento-alert .alert:before{font-family:bento-icons;font-style:normal;font-weight:400;font-size:1.429rem;line-height:1;position:absolute;left:5px;width:40px;text-align:center;-webkit-font-smoothing:antialiased}[dir=rtl] bento-alert .alert:before{left:auto;right:5px}bento-alert .alert button.close{align-items:center;background:0 0;border-radius:15px;border:none;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;position:absolute;right:10px;text-align:center;text-shadow:none;top:10px;width:24px}[dir=rtl] bento-alert .alert button.close{right:auto;left:10px}bento-alert .alert button.close i{font-family:bento-icons;top:0;font-style:normal}bento-alert .alert button.close:focus{outline:0}bento-alert .alert button.close:hover{transition:background .3s}bento-alert .alert button.close:hover i{transition:color .1s}bento-alert .alert-dismissable .close{top:0}bento-alert .bento-alert{margin-bottom:5px;transition:opacity .5s,filter .5s;box-shadow:2px 2px 6px 0 rgba(0,0,0,.3)}bento-alert-inline bento-alert .bento-alert{box-shadow:none}bento-alert .alert-container{z-index:1000000;position:fixed;top:37px;left:50%;min-width:300px;transform:translate(-50%,0);-ms-transform:translate(-50%,0);-webkit-transform:translate(-50%,0)}bento-alert .alert-container:focus{outline:0}bento-alert .alert-container.right{left:auto;right:20px;transform:translate(0,0);-ms-transform:translate(0,0);-webkit-transform:translate(0,0)}[dir=rtl] bento-alert .alert-container.right{left:20px;right:auto}bento-alert .alert-container.right>div{width:auto;max-width:100%;display:inline-block}bento-alert .alert-container.left{left:20px;transform:translate(0,0);-ms-transform:translate(0,0);-webkit-transform:translate(0,0)}[dir=rtl] bento-alert .alert-container.left{left:auto;right:20px}bento-alert.bento-alert-inline .alert-container{z-index:auto;display:block;position:relative;top:auto;left:auto;width:100%;min-width:0;transform:none;-ms-transform:none;-webkit-transform:none}@media (min-width:1200px){bento-alert .alert-container{width:40%}}@media (min-width:992px) and (max-width:1199px){bento-alert .alert-container{width:55%}}@media (min-width:768px) and (max-width:991px){bento-alert .alert-container{width:75%}}@media (max-width:767px){bento-alert .alert-container{width:80%}}bento-alert .bento-alert-container{display:block;transition:.2s linear}bento-alert .bento-alert-container.ng-enter{opacity:0}bento-alert .bento-alert-container.ng-enter.ng-enter-active{opacity:1}bento-alert .bento-alert-container.ng-leave{overflow:hidden;opacity:1}bento-alert .bento-alert-container.ng-leave.ng-leave-active{opacity:0}bento-alert .bento-alert-container.ng-leave.ng-leave-active:not(:last-child){height:0!important}"]
            }]
    }], function () { return []; }, { close: [{
            type: Output
        }], inline: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.bento-alert-inline']
        }], items: [{
            type: Input
        }], _bentoAlertItems: [{
            type: ViewChildren,
            args: [BentoAlertItemComponent]
        }] }); })();
    return BentoAlertComponent;
}());
if (false) {
    /**
     * Array of Alert Items
     * @type {?}
     */
    BentoAlertComponent.prototype.items;
    /**
     * An event emitted when the close button is clicked. This event returns a payload with the alert item's index number.
     * Only relevant for dismissible alerts.
     * @type {?}
     */
    BentoAlertComponent.prototype.close;
    /**
     * Flag to determine of all Bento Alert items are displayed inline with other elements
     * @type {?}
     */
    BentoAlertComponent.prototype.inline;
    /**
     * @type {?}
     * @private
     */
    BentoAlertComponent.prototype._bentoAlertItems;
    /**
     * Window click subscription to check keypress
     * @type {?}
     * @private
     */
    BentoAlertComponent.prototype._windowClickSubscription;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/alert/alert.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoAlertModule = /** @class */ (function () {
    function BentoAlertModule() {
    }
BentoAlertModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoAlertModule });
BentoAlertModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoAlertModule_Factory(t) { return new (t || BentoAlertModule)(); }, imports: [[CommonModule, BentoTranslateModule, A11yModule, BentoUtilsModule, BentoFocusMonitorModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoAlertModule, { declarations: function () { return [BentoAlertComponent,
        BentoAlertItemComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        A11yModule,
        BentoUtilsModule,
        BentoFocusMonitorModule]; }, exports: function () { return [BentoAlertComponent,
        BentoAlertItemComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoAlertModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoAlertComponent, BentoAlertItemComponent],
                imports: [CommonModule, BentoTranslateModule, A11yModule, BentoUtilsModule, BentoFocusMonitorModule],
                exports: [BentoAlertComponent, BentoAlertItemComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoAlertModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/append-to/append-to.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A bento version of append to parent
 */
var BentoAppendToDirective = /** @class */ (function () {
    /**
     *
     */
    function BentoAppendToDirective(elementRef, _bentoNotification, r, windowRef, bentoPositioning, logService, dir) {
        this._bentoNotification = _bentoNotification;
        this.r = r;
        this.bentoPositioning = bentoPositioning;
        this.logService = logService;
        this.dir = dir;
        /**
         * Input to get the reference of the container that this element is appended to
         */
        this.bentoAppendTo = false;
        /**
         * Resize width to the reference
         */
        this.reszieWidthToReference = false;
        /**
         * Flag to determin of dropdown auto hides when window scrolls
         */
        this.autoHideOnContainerScroll = true;
        /**
         * Alignment of this element based on its side
         */
        this.alignment = 'left';
        /**
         * Flag to determine if vertical alignment is set to auto
         */
        this.autoVerticalAlignment = true;
        /**
         * Event emitter when the open attribute is changed
         */
        this.openChange = new EventEmitter();
        /**
         * Flag to determine if el is open
         */
        this.isOpen = false;
        /**
         * Variable of side
         */
        this._side = 'bottom';
        this._el = elementRef.nativeElement;
        this.window = windowRef.nativeWindow;
        this.document = windowRef.nativeDocument;
    }
    Object.defineProperty(BentoAppendToDirective.prototype, "open", {
        /**
         * Input to show/hide dropdown
         */
        set: /**
         * Input to show/hide dropdown
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v) {
                this.show();
            }
            else {
                this.hide();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoAppendToDirective.prototype, "side", {
        get: /**
         * @return {?}
         */
        function () {
            return this._side;
        },
        /**
         * Determine if this is a dropup menu. Default `'bottom'`
         */
        set: /**
         * Determine if this is a dropup menu. Default `'bottom'`
         * @param {?} s
         * @return {?}
         */
        function (s) {
            /** @type {?} */
            var el = this._el;
            this._side = s || 'bottom';
            switch (s) {
                case 'top':
                    this.r.addClass(el, 'dropdown-menu-up');
                    this.r.removeClass(el, 'dropdown-menu-left');
                    this.r.removeClass(el, 'dropdown-menu-right');
                    break;
                case 'left':
                    this.r.addClass(el, 'dropdown-menu-left');
                    this.r.removeClass(el, 'dropdown-menu-top');
                    this.r.removeClass(el, 'dropdown-menu-right');
                    break;
                case 'right':
                    this.r.addClass(el, 'dropdown-menu-right');
                    this.r.removeClass(el, 'dropdown-menu-left');
                    this.r.removeClass(el, 'dropdown-menu-up');
                    break;
                default:
                    this.r.removeClass(el, 'dropdown-menu-up');
                    this.r.removeClass(el, 'dropdown-menu-left');
                    this.r.removeClass(el, 'dropdown-menu-right');
                    break;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Logic when the view is initiated
     */
    /**
     * Logic when the view is initiated
     * @return {?}
     */
    BentoAppendToDirective.prototype.ngAfterViewInit = /**
     * Logic when the view is initiated
     * @return {?}
     */
    function () {
        // Assign `_appendToEl` reference for appending
        if (!this.bentoAppendTo || this.bentoAppendTo === '') {
            this._appendToEl = null;
            return;
        }
        else if (typeof this.bentoAppendTo === 'string') {
            this._appendToEl = (/** @type {?} */ (this.document.querySelector(this.bentoAppendTo)));
            if (!this._appendToEl) {
                // The original query is not correct
                this.logService.warn(
                // tslint:disable-next-line quotemark
                "BentoAppendTo: HTMLElement '", this.bentoAppendTo, 
                // tslint:disable-next-line quotemark
                "' does not exist. Default to" + ' <BODY>');
                this._appendToEl = (/** @type {?} */ (this.document.querySelector('body')));
            }
            if (!this._appendToEl) {
                this.logService.error('[bentoAppendTo]: Selector', this.bentoAppendTo, 'does not exit in the DOM structure.');
                return;
            }
        }
        else if (this.bentoAppendTo instanceof Element) {
            // This is an ElementRef
            this._appendToEl = (/** @type {?} */ (this.bentoAppendTo));
        }
        else {
            // This is an ElementRef
            this._appendToEl = ((/** @type {?} */ (this.bentoAppendTo))).nativeElement;
        }
        this._nextSibling = (/** @type {?} */ (this._el.nextElementSibling));
        this._parentEl = this._el.parentElement;
    };
    /**
     * Cleanup
     */
    /**
     * Cleanup
     * @return {?}
     */
    BentoAppendToDirective.prototype.ngOnDestroy = /**
     * Cleanup
     * @return {?}
     */
    function () {
        if (this._onScrollSubscription) {
            this._onScrollSubscription.unsubscribe();
        }
        if (this._onResizeSubscription) {
            this._onResizeSubscription.unsubscribe();
        }
    };
    /**
     * Show component element
     */
    /**
     * Show component element
     * @return {?}
     */
    BentoAppendToDirective.prototype.show = /**
     * Show component element
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this._appendToEl || this.isOpen) {
            return;
        }
        if (!this.referenceTo && this._appendToEl) {
            this.logService.error('[bentoAppendTo]:', 'missing reference element');
            return;
        }
        if (this.autoHideOnContainerScroll) {
            // Add scroll subscription
            this._onScrollSubscription = fromEvent(this.window, 'scroll', { capture: true, once: true }).subscribe((/**
             * @param {?} event
             * @return {?}
             */
            function (event) {
                /** @type {?} */
                var target = (/** @type {?} */ (event.target));
                /** @type {?} */
                var hostIncluded = target.contains((/** @type {?} */ (_this.referenceTo)));
                /** @type {?} */
                var targetIncluded = _this._el.contains(target);
                if ((!hostIncluded && !targetIncluded) || (hostIncluded && !targetIncluded)) {
                    // Need to hide dropdown
                    if (target !== _this._el) {
                        _this.hide();
                        _this.openChange.emit(false);
                    }
                }
            }));
        }
        // Add resize subscription
        this._onResizeSubscription = this._bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () {
            // Need to hide dropdown when some where of the screen is resized
            _this.hide();
            _this.openChange.emit(false);
        }));
        /** @type {?} */
        var refEl = this.getReference();
        if (this.reszieWidthToReference) {
            this.r.setStyle(this._el, 'width', refEl.offsetWidth + 'px');
            this.r.setStyle(this._el, 'min-width', refEl.offsetWidth + 'px');
        }
        this.r.addClass(this._el, 'bento-append-to');
        this.positionElement();
        if (this.reszieWidthToReference) {
            // There can be a new scroll bar that alters the width of the reference element
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.setStyle(_this._el, 'width', refEl.offsetWidth + 'px');
                _this.r.setStyle(_this._el, 'min-width', refEl.offsetWidth + 'px');
            }));
        }
        this.isOpen = true;
    };
    /**
     * Hide component element
     */
    /**
     * Hide component element
     * @return {?}
     */
    BentoAppendToDirective.prototype.hide = /**
     * Hide component element
     * @return {?}
     */
    function () {
        if (!this._appendToEl || !this.isOpen) {
            return;
        }
        if (!this.referenceTo && this._appendToEl) {
            this.logService.error('[bentoAppendTo]:', 'missing reference element');
            return;
        }
        // Clean subscriptions
        if (this._onResizeSubscription) {
            this._onResizeSubscription.unsubscribe();
        }
        if (this._onScrollSubscription) {
            this._onScrollSubscription.unsubscribe();
        }
        this._onResizeSubscription = null;
        this._onScrollSubscription = null;
        if (this._nextSibling) {
            this.r.insertBefore(this._parentEl, this._el, this._nextSibling);
        }
        else {
            this.r.appendChild(this._parentEl, this._el);
        }
        this.r.removeClass(this._el, 'bento-append-to');
        this.bentoPositioning.resetPosition(this.r, this._el);
        this.isOpen = false;
    };
    /**
     * Position component element to the designated HTMLElement
     */
    /**
     * Position component element to the designated HTMLElement
     * @protected
     * @return {?}
     */
    BentoAppendToDirective.prototype.positionElement = /**
     * Position component element to the designated HTMLElement
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var referenceEl = this.getReference();
        /** @type {?} */
        var side = this.side;
        /** @type {?} */
        var referenceElRect = referenceEl.getBoundingClientRect();
        /** @type {?} */
        var viewportHeight = Math.max(this.document.documentElement.clientHeight, this.window.innerHeight || 0);
        /** @type {?} */
        var bottom = viewportHeight - referenceElRect.bottom;
        /** @type {?} */
        var alignment = this.alignment;
        if (this.dir.value === 'rtl') {
            // Swap left and right when app is in RTL mode
            if (alignment === 'left') {
                alignment = 'right';
            }
            else if (alignment === 'right') {
                alignment = 'left';
            }
        }
        if (this.autoVerticalAlignment) {
            if (side === 'bottom' && bottom < this._el.offsetHeight && referenceElRect.top >= this._el.offsetHeight) {
                // Automatically invert side from bottom to top when there is not enough space under
                // the reference
                side = 'top';
            }
            else if (side === 'top' && referenceElRect.top < this._el.offsetHeight && bottom >= this._el.offsetHeight) {
                // Automatically invert side from top to bottom when there is not enough space above
                // the reference
                side = 'bottom';
            }
        }
        this.r.removeClass(this._el, 'top');
        this.r.removeClass(this._el, 'bottom');
        this.r.removeClass(this._el, 'left');
        this.r.removeClass(this._el, 'right');
        this.r.addClass(this._el, side);
        this.bentoPositioning.positionElement(this.r, this.getReference(), this._el, (/** @type {?} */ (this._appendToEl)), side, alignment, -1);
    };
    /**
     * Get HTMLElement from the reference element
     */
    /**
     * Get HTMLElement from the reference element
     * @protected
     * @return {?}
     */
    BentoAppendToDirective.prototype.getReference = /**
     * Get HTMLElement from the reference element
     * @protected
     * @return {?}
     */
    function () {
        return ((/** @type {?} */ (this.referenceTo))).nativeElement
            ? ((/** @type {?} */ (this.referenceTo))).nativeElement
            : this.referenceTo;
    };
    /** @nocollapse */
    BentoAppendToDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification },
        { type: Renderer2 },
        { type: WindowRef },
        { type: BentoPositioning },
        { type: BentoLogService },
        { type: Directionality }
    ]; };
    BentoAppendToDirective.propDecorators = {
        bentoAppendTo: [{ type: Input }],
        referenceTo: [{ type: Input }],
        reszieWidthToReference: [{ type: Input }],
        autoHideOnContainerScroll: [{ type: Input }],
        alignment: [{ type: Input }],
        autoVerticalAlignment: [{ type: Input }],
        openChange: [{ type: Output }],
        open: [{ type: Input }],
        side: [{ type: Input }]
    };
BentoAppendToDirective.ɵfac = function BentoAppendToDirective_Factory(t) { return new (t || BentoAppendToDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoPositioning), ɵngcc0.ɵɵdirectiveInject(BentoLogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoAppendToDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoAppendToDirective, selectors: [["", "bentoAppendTo", "", 9, "dropdown-menu"]], inputs: { bentoAppendTo: "bentoAppendTo", reszieWidthToReference: "reszieWidthToReference", autoHideOnContainerScroll: "autoHideOnContainerScroll", alignment: "alignment", autoVerticalAlignment: "autoVerticalAlignment", open: "open", side: "side", referenceTo: "referenceTo" }, outputs: { openChange: "openChange" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoAppendToDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoAppendTo]:not(.dropdown-menu)',
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: ɵngcc0.Renderer2 }, { type: WindowRef }, { type: BentoPositioning }, { type: BentoLogService }, { type: ɵngcc6.Directionality }]; }, { bentoAppendTo: [{
            type: Input
        }], reszieWidthToReference: [{
            type: Input
        }], autoHideOnContainerScroll: [{
            type: Input
        }], alignment: [{
            type: Input
        }], autoVerticalAlignment: [{
            type: Input
        }], openChange: [{
            type: Output
        }], open: [{
            type: Input
        }], side: [{
            type: Input
        }], referenceTo: [{
            type: Input
        }] }); })();
    return BentoAppendToDirective;
}());
if (false) {
    /**
     * Input to get the reference of the container that this element is appended to
     * @type {?}
     */
    BentoAppendToDirective.prototype.bentoAppendTo;
    /**
     * Referent where the element is appended to
     * @type {?}
     */
    BentoAppendToDirective.prototype.referenceTo;
    /**
     * Resize width to the reference
     * @type {?}
     */
    BentoAppendToDirective.prototype.reszieWidthToReference;
    /**
     * Flag to determin of dropdown auto hides when window scrolls
     * @type {?}
     */
    BentoAppendToDirective.prototype.autoHideOnContainerScroll;
    /**
     * Alignment of this element based on its side
     * @type {?}
     */
    BentoAppendToDirective.prototype.alignment;
    /**
     * Flag to determine if vertical alignment is set to auto
     * @type {?}
     */
    BentoAppendToDirective.prototype.autoVerticalAlignment;
    /**
     * Event emitter when the open attribute is changed
     * @type {?}
     */
    BentoAppendToDirective.prototype.openChange;
    /**
     * Native HTMLElement reference
     * @type {?}
     */
    BentoAppendToDirective.prototype._el;
    /**
     * Parent element to be appended to
     * @type {?}
     */
    BentoAppendToDirective.prototype._appendToEl;
    /**
     * Window and document reference
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype.window;
    /**
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype.document;
    /**
     * Flag to determine if el is open
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype.isOpen;
    /**
     * Next sibling at the original location
     * @type {?}
     * @private
     */
    BentoAppendToDirective.prototype._nextSibling;
    /**
     * Parent element at the original location
     * @type {?}
     * @private
     */
    BentoAppendToDirective.prototype._parentEl;
    /**
     * Window scroll subscription
     * @type {?}
     * @private
     */
    BentoAppendToDirective.prototype._onScrollSubscription;
    /**
     * Resize Subscription
     * @type {?}
     * @private
     */
    BentoAppendToDirective.prototype._onResizeSubscription;
    /**
     * Variable of side
     * @type {?}
     * @private
     */
    BentoAppendToDirective.prototype._side;
    /**
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype._bentoNotification;
    /**
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype.bentoPositioning;
    /**
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype.logService;
    /**
     * @type {?}
     * @protected
     */
    BentoAppendToDirective.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/append-to/ngb-dropdown-append-to.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Similar to `BentoAppendToDirective` this directive supports `NgbDropdown` components
 */
var BentoNgbDropdownAppendToDirective = /** @class */ (function (_super) {
    __extends(BentoNgbDropdownAppendToDirective, _super);
    /**
     */
    function BentoNgbDropdownAppendToDirective(elementRef, _ngbDropdown, _bentoNotification, r, windowRef, bentoPositioning, logService, dir) {
        var _this = _super.call(this, elementRef, _bentoNotification, r, windowRef, bentoPositioning, logService, dir) || this;
        _this._ngbDropdown = _ngbDropdown;
        _this._bentoNotification = _bentoNotification;
        _this.r = r;
        _this.logService = logService;
        _this.dir = dir;
        /**
         * Flag to determine if the dropdown should be horizontally auto re-aligned
         */
        _this.autoRealign = false;
        /**
         * Offset for the dropdow for fine tuning
         */
        _this.offset = 0;
        /**
         * Subscription on the _ngbDropdown change
         */
        _this._onNgbChangeSubscription = Subscription.EMPTY;
        return _this;
    }
    /**
     * Init code
     */
    /**
     * Init code
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.ngOnInit = /**
     * Init code
     * @return {?}
     */
    function () {
        var _this = this;
        this._onNgbChangeSubscription = this._ngbDropdown.openChange.subscribe((/**
         * @param {?} isOpen
         * @return {?}
         */
        function (isOpen) {
            _this._onDropdownChange(isOpen);
        }));
        // Since v4.1.0 NgbDropdown._positionMenu interferes our positionElement() method
        // We need to override it with not doing anything
        this._ngbDropdown['_positionMenu'] = (/**
         * @return {?}
         */
        function () { });
    };
    /**
     * Logic when component view is initiated
     */
    /**
     * Logic when component view is initiated
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.ngAfterViewInit = /**
     * Logic when component view is initiated
     * @return {?}
     */
    function () {
        this.referenceTo = this._findNgbToggle();
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
     * Destroy code
     */
    /**
     * Destroy code
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.ngOnDestroy = /**
     * Destroy code
     * @return {?}
     */
    function () {
        _super.prototype.ngOnDestroy.call(this);
        this._onNgbChangeSubscription.unsubscribe();
    };
    /**
     * Extend the hide method from super class
     */
    /**
     * Extend the hide method from super class
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.hide = /**
     * Extend the hide method from super class
     * @return {?}
     */
    function () {
        _super.prototype.hide.call(this);
        /** @type {?} */
        var placement = (/** @type {?} */ (this._ngbDropdown.placement));
        this._ngbDropdown.close();
        if (placement.indexOf('top') > -1) {
            this.r.addClass(this._el, 'dropdown-menu-up');
        }
        else {
            this.r.removeClass(this._el, 'dropdown-menu-up');
        }
        if (this.autoRealign) {
            // Need to reset width when auto relaign is applied
            BentoPositioning.resetWidth(this.r, this._el);
        }
        this.isOpen = false;
    };
    /**
     * Position component element to the designated HTMLElement
     */
    /**
     * Position component element to the designated HTMLElement
     * @protected
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.positionElement = /**
     * Position component element to the designated HTMLElement
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var referenceTo = ((/** @type {?} */ (this.referenceTo))).nativeElement
            ? ((/** @type {?} */ (this.referenceTo))).nativeElement
            : this.referenceTo;
        /** @type {?} */
        var alignment = 'center';
        /** @type {?} */
        var referenceEl = this.getReference();
        /** @type {?} */
        var placement = (/** @type {?} */ (this._ngbDropdown.placement));
        /** @type {?} */
        var side = placement.indexOf('top') > -1 ? 'top' : 'bottom';
        /** @type {?} */
        var referenceElRect = referenceEl.getBoundingClientRect();
        /** @type {?} */
        var viewportHeight = Math.max(this.document.documentElement.clientHeight, this.window.innerHeight || 0);
        /** @type {?} */
        var styles = this.window.getComputedStyle(this._el);
        /** @type {?} */
        var bottom = viewportHeight - referenceElRect.bottom;
        /** @type {?} */
        var isRTL = this.dir.value === 'rtl';
        // Horizontal Alignment
        if (placement.indexOf('right') > -1) {
            alignment = isRTL ? 'left' : 'right';
        }
        else if (placement.indexOf('left') > -1) {
            alignment = isRTL ? 'right' : 'left';
        }
        if (this.autoVerticalAlignment) {
            // Top & Bottom
            if (side === 'bottom' && bottom < this._el.offsetHeight && referenceElRect.top >= this._el.offsetHeight) {
                // Automatically invert side from bottom to top when there is not enough space under
                // the reference
                side = 'top';
            }
            if (side === 'top' && referenceElRect.top < this._el.offsetHeight && bottom >= this._el.offsetHeight) {
                // Automatically invert side from top to bottom when there is not enough space above
                // the reference
                side = 'bottom';
            }
        }
        // When offset is set through CSS
        // we need to know what the offset is
        /** @type {?} */
        var calculatedOffSet;
        if (side === 'bottom' && styles.marginTop !== '0px') {
            calculatedOffSet = parseFloat(styles.marginTop.replace('px', ''));
        }
        else if (side === 'top' && styles.marginBottom !== '0px') {
            calculatedOffSet = parseFloat(styles.marginBottom.replace('px', ''));
        }
        // Update host CSS class
        if (side === 'bottom') {
            this.r.removeClass(this._el, 'dropdown-menu-up');
        }
        else {
            this.r.addClass(this._el, 'dropdown-menu-up');
        }
        this.bentoPositioning.positionElement(this.r, referenceTo, this._el, (/** @type {?} */ (this._appendToEl)), side, alignment, this.offset || calculatedOffSet, this.autoRealign);
    };
    /**
     * Callback when the dropdown toggle is updated
     */
    /**
     * Callback when the dropdown toggle is updated
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype._onDropdownChange = /**
     * Callback when the dropdown toggle is updated
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    function (isOpen) {
        if (isOpen && !this.isOpen) {
            this.show();
        }
        else if (this.isOpen) {
            this.hide();
        }
    };
    /**
     * Look for the toggle that belongs to this dropdown menu
     */
    /**
     * Look for the toggle that belongs to this dropdown menu
     * @private
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype._findNgbToggle = /**
     * Look for the toggle that belongs to this dropdown menu
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var ngbDropdownEl = this._findNgbDropdownEl();
        if (!ngbDropdownEl) {
            this.logService.warn('[bentoAppendTo]:', '[NgbDropdown] is undefined');
            return;
        }
        return ngbDropdownEl.querySelector('[NgbDropdownToggle]');
    };
    /**
     * Look for NgbDropdown main HTMLElement
     */
    /**
     * Look for NgbDropdown main HTMLElement
     * @private
     * @param {?=} el
     * @return {?}
     */
    BentoNgbDropdownAppendToDirective.prototype._findNgbDropdownEl = /**
     * Look for NgbDropdown main HTMLElement
     * @private
     * @param {?=} el
     * @return {?}
     */
    function (el) {
        if (el === void 0) { el = this._el; }
        if (el.nodeName === 'BODY') {
            return false;
        }
        else if (el.hasAttribute('ngbDropdown')) {
            return el;
        }
        else {
            return this._findNgbDropdownEl(el.parentElement);
        }
    };
    /** @nocollapse */
    BentoNgbDropdownAppendToDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgbDropdown },
        { type: BentoNotification },
        { type: Renderer2 },
        { type: WindowRef },
        { type: BentoPositioning },
        { type: BentoLogService },
        { type: Directionality }
    ]; };
    BentoNgbDropdownAppendToDirective.propDecorators = {
        bentoAppendTo: [{ type: Input }],
        autoRealign: [{ type: Input }],
        offset: [{ type: Input }]
    };
BentoNgbDropdownAppendToDirective.ɵfac = function BentoNgbDropdownAppendToDirective_Factory(t) { return new (t || BentoNgbDropdownAppendToDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbDropdown), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoPositioning), ɵngcc0.ɵɵdirectiveInject(BentoLogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoNgbDropdownAppendToDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoNgbDropdownAppendToDirective, selectors: [["", "bentoAppendTo", "", 8, "dropdown-menu"], ["bento-megamenu", "bentoAppendTo", ""]], inputs: { bentoAppendTo: "bentoAppendTo", autoRealign: "autoRealign", offset: "offset" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNgbDropdownAppendToDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoAppendTo].dropdown-menu, bento-megamenu[bentoAppendTo]',
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc4.NgbDropdown }, { type: BentoNotification }, { type: ɵngcc0.Renderer2 }, { type: WindowRef }, { type: BentoPositioning }, { type: BentoLogService }, { type: ɵngcc6.Directionality }]; }, { bentoAppendTo: [{
            type: Input
        }], autoRealign: [{
            type: Input
        }], offset: [{
            type: Input
        }] }); })();
    return BentoNgbDropdownAppendToDirective;
}(BentoAppendToDirective));
if (false) {
    /**
     * Element where this dropdown is appended to
     * @type {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.bentoAppendTo;
    /**
     * Flag to determine if the dropdown should be horizontally auto re-aligned
     * @type {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.autoRealign;
    /**
     * Offset for the dropdow for fine tuning
     * @type {?}
     */
    BentoNgbDropdownAppendToDirective.prototype.offset;
    /**
     * Subscription on the _ngbDropdown change
     * @type {?}
     * @private
     */
    BentoNgbDropdownAppendToDirective.prototype._onNgbChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoNgbDropdownAppendToDirective.prototype._ngbDropdown;
    /**
     * @type {?}
     * @protected
     */
    BentoNgbDropdownAppendToDirective.prototype._bentoNotification;
    /**
     * @type {?}
     * @protected
     */
    BentoNgbDropdownAppendToDirective.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoNgbDropdownAppendToDirective.prototype.logService;
    /**
     * @type {?}
     * @protected
     */
    BentoNgbDropdownAppendToDirective.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/append-to/append-to.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoAppendToModule = /** @class */ (function () {
    function BentoAppendToModule() {
    }
BentoAppendToModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoAppendToModule });
BentoAppendToModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoAppendToModule_Factory(t) { return new (t || BentoAppendToModule)(); }, imports: [[BentoUtilsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoAppendToModule, { declarations: [BentoAppendToDirective,
        BentoNgbDropdownAppendToDirective], imports: [BentoUtilsModule], exports: [BentoAppendToDirective,
        BentoNgbDropdownAppendToDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoAppendToModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoAppendToDirective, BentoNgbDropdownAppendToDirective],
                imports: [BentoUtilsModule],
                exports: [BentoAppendToDirective, BentoNgbDropdownAppendToDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoAppendToModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/badge/badge.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*tslint:disable component-selector */
var BentoBadgeComponent = /** @class */ (function () {
    function BentoBadgeComponent() {
    }
    /**
     * @return {?}
     */
    BentoBadgeComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /** @nocollapse */
    BentoBadgeComponent.ctorParameters = function () { return []; };
BentoBadgeComponent.ɵfac = function BentoBadgeComponent_Factory(t) { return new (t || BentoBadgeComponent)(); };
BentoBadgeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoBadgeComponent, selectors: [["a", 8, "badge"]], attrs: _c3, ngContentSelectors: _c4, decls: 2, vars: 0, template: function BentoBadgeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoBadgeComponent, [{
        type: Component,
        args: [{
                selector: 'a.badge',
                template: "<span>\n  <ng-content></ng-content>\n</span>\n"
            }]
    }], function () { return []; }, null); })();
    return BentoBadgeComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/badge/badge.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoBadgeModule = /** @class */ (function () {
    function BentoBadgeModule() {
    }
BentoBadgeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoBadgeModule });
BentoBadgeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoBadgeModule_Factory(t) { return new (t || BentoBadgeModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoBadgeModule, { declarations: function () { return [BentoBadgeComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BentoBadgeComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoBadgeModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoBadgeComponent],
                imports: [CommonModule],
                exports: [BentoBadgeComponent],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoBadgeModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/busyloader/busyloader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BusyLoader = /** @class */ (function () {
    /**
     *
     */
    function BusyLoader(dom, r, windowRef) {
        this.r = r;
        this.isPositionedStatic = false;
        // Spinner default variables
        this.currentArcIndex = 0;
        this.CSSDelay = 600;
        this.arcs = [];
        this.spinnerStrokeGap = 7; // in degree
        // in degree
        this.intervalDefaultDelay = 150;
        this.defaultNumSegments = 8;
        this.document = windowRef.nativeDocument;
        this.window = windowRef.nativeWindow;
        this.mainDom = typeof dom === 'string' ? this.document.querySelector(dom) : dom;
    }
    /**
     * Helper method to convert degree into radian for calculations
     */
    /**
     * Helper method to convert degree into radian for calculations
     * @param {?} degrees
     * @return {?}
     */
    BusyLoader.getRadianFromDegree = /**
     * Helper method to convert degree into radian for calculations
     * @param {?} degrees
     * @return {?}
     */
    function (degrees) {
        return degrees * (Math.PI / 180);
    };
    /**
     * Show and insert loader into DOM
     */
    /**
     * Show and insert loader into DOM
     * @param {?} delay
     * @param {?} size
     * @return {?}
     */
    BusyLoader.prototype.show = /**
     * Show and insert loader into DOM
     * @param {?} delay
     * @param {?} size
     * @return {?}
     */
    function (delay, size) {
        var _this = this;
        this.clearTimeout();
        this.showTimeoutID = setTimeout((/**
         * @return {?}
         */
        function () {
            if (!_this.loader) {
                _this.init(size);
            }
            /** @type {?} */
            var firstChild = _this.mainDom.children[0];
            // Adding loader
            _this.r.appendChild(_this.mainDom, _this.loader);
            _this.r.insertBefore(_this.mainDom, _this.blocker, firstChild);
            try {
                // Make parent container 'relative' when it is static
                /** @type {?} */
                var mainDomPosition = _this.window.getComputedStyle(_this.mainDom).position;
                // Check and assign `relative` position where it is at default, `static`
                if (mainDomPosition.length === 0 || mainDomPosition === 'static') {
                    _this.r.setStyle(_this.mainDom, 'position', 'relative');
                    _this.isPositionedStatic = true;
                }
            }
            catch (e) {
                // Running in SSR mode
            }
            // svg render disabled
            _this.startAnimate();
            /*
             Gain focus if necessary and
             ONLY gains focus when this loader is an overlay
             */
            _this.activeElement = _this.document.activeElement;
            if (_this.mainDom.contains(_this.activeElement) && _this.mainDom !== _this.activeElement) {
                _this.loader.focus();
            }
            else {
                _this.activeElement = undefined;
            }
            // Callback
            _this.onBusyLoaderChange(true);
        }), delay);
    };
    /**
     * Hide loader from DOM
     */
    /**
     * Hide loader from DOM
     * @param {?} delay
     * @return {?}
     */
    BusyLoader.prototype.hide = /**
     * Hide loader from DOM
     * @param {?} delay
     * @return {?}
     */
    function (delay) {
        var _this = this;
        this.clearTimeout();
        // Loader is not ready
        if (!this.loader) {
            return;
        }
        this.hideTimeoutID = setTimeout((/**
         * @return {?}
         */
        function () {
            // Put static positioning back
            if (_this.isPositionedStatic) {
                _this.r.removeStyle(_this.mainDom, 'position');
            }
            _this.stopAnimate();
            /*
             Return focus if necessary
             */
            if (_this.activeElement &&
                (_this.document.activeElement === _this.loader || _this.document.activeElement === _this.blocker)) {
                ((/** @type {?} */ (_this.activeElement))).focus();
            }
            _this.r.removeChild(_this.loader.parentElement, _this.loader);
            _this.r.removeChild(_this.blocker.parentElement, _this.blocker);
            // clear memory and who knows when this loader is going to be called again
            _this.loader = null;
            _this.blocker = null;
            _this.arcs = [];
            // Callback
            _this.onBusyLoaderChange(false);
        }), delay);
    };
    /**
     * Initialize loader
     */
    /**
     * Initialize loader
     * @private
     * @param {?} size
     * @return {?}
     */
    BusyLoader.prototype.init = /**
     * Initialize loader
     * @private
     * @param {?} size
     * @return {?}
     */
    function (size) {
        var _this = this;
        this.size = size ? size : 'md';
        // Now we can set the size of the spinner animation
        switch (this.size) {
            case 'sm':
                this.canvasSize = 24;
                this.intervalDelay = this.intervalDefaultDelay;
                this.spinnerStroke = 5;
                this.spinnerSegments = this.defaultNumSegments;
                break;
            default:
                this.canvasSize = 75;
                this.intervalDelay = this.intervalDefaultDelay;
                this.spinnerStroke = 15;
                this.spinnerSegments = this.defaultNumSegments;
                break;
        }
        this.spinnerRadius = this.canvasSize / 2;
        // Create loader dom elements
        this.loader = this.r.createElement('div');
        this.r.setAttribute(this.loader, 'tabindex', '0');
        this.r.addClass(this.loader, 'bento-busyloader-blocker');
        this.r.addClass(this.loader, this.size);
        this.loader.innerHTML = "<div class=\"bento-busyloader-wrapper\">\n      <div class=\"bento-busyloader-inner\">\n      <svg\n      class=\"bento-busyloader-svg bento-busyloader-svg-" + this.size + "\" preserveAspectRatio=\"none\"\n      viewBox=\"0 0 " + this.canvasSize + " " + this.canvasSize + "\"\n      ></svg>\n      </div></div>";
        this.blocker = this.r.createElement('div');
        this.r.setAttribute(this.blocker, 'tabindex', '0');
        this.r.addClass(this.blocker, 'bento-busyloader-front-blocker');
        // SR Support
        /*applySR();
         function applySR() {
         $bentoTranslate.translate('BENTO_UI_BUSY_LOADER_LOADING')
         .then(function (value) {
         loader.attr('aria-label', value);
         blocker.attr('aria-label', value);
         });
         }*/
        /*$bentoTranslate.onChange(applySR);
         loader.on('$destroy', function () {
         $bentoTranslate.removeOnChange(applySR);
         });*/
        // Add event listeners
        this.loader.addEventListener('keydown', (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // Bypass the content from tabbing
            if (event.shiftKey && event.keyCode === 9) {
                _this.blocker.focus();
            }
        }));
        this.blocker.addEventListener('keydown', (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // Bypass the content from tabbing
            if (!event.shiftKey && event.keyCode === 9) {
                _this.loader.focus();
            }
        }));
        this.initSpinner();
    };
    /**
     * Clear any previous timeout IDs
     */
    /**
     * Clear any previous timeout IDs
     * @private
     * @return {?}
     */
    BusyLoader.prototype.clearTimeout = /**
     * Clear any previous timeout IDs
     * @private
     * @return {?}
     */
    function () {
        if (this.showTimeoutID) {
            clearTimeout(this.showTimeoutID);
        }
        if (this.hideTimeoutID) {
            clearTimeout(this.hideTimeoutID);
        }
    };
    // svg spinner animation code
    // rFA is used for animation part to minimize CPU load
    /**
     * Start animation
     */
    // svg spinner animation code
    // rFA is used for animation part to minimize CPU load
    /**
     * Start animation
     * @private
     * @return {?}
     */
    BusyLoader.prototype.startAnimate = 
    // svg spinner animation code
    // rFA is used for animation part to minimize CPU load
    /**
     * Start animation
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        clearInterval(this.intervalID);
        this.intervalID = setInterval((/**
         * @return {?}
         */
        function () {
            _this.tick();
        }), this.intervalDelay);
    };
    /**
     * Stop animation
     */
    /**
     * Stop animation
     * @private
     * @return {?}
     */
    BusyLoader.prototype.stopAnimate = /**
     * Stop animation
     * @private
     * @return {?}
     */
    function () {
        clearInterval(this.intervalID);
    };
    /**
     * Tick
     */
    /**
     * Tick
     * @private
     * @return {?}
     */
    BusyLoader.prototype.tick = /**
     * Tick
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var arc = this.arcs[this.currentArcIndex];
        this.currentArcIndex = (this.currentArcIndex - 1 + this.arcs.length) % this.arcs.length;
        this.r.setAttribute(arc, 'class', 'bento-busyloader-arc bento-busyloader-arc-alt');
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.r.setAttribute(arc, 'class', 'bento-busyloader-arc');
        }), this.CSSDelay);
    };
    // Spinner init
    // Spinner init
    /**
     * @private
     * @return {?}
     */
    BusyLoader.prototype.initSpinner = 
    // Spinner init
    /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var arcSize = 360 / this.spinnerSegments;
        /** @type {?} */
        var arc;
        this.svg = this.loader.getElementsByTagName('svg')[0];
        // svg is not ready when render is called by apps
        if (!this.svg) {
            return;
        }
        for (var i = 0; i < this.spinnerSegments; i++) {
            arc = this.getSegment(i, arcSize);
            this.arcs.push(arc);
            this.r.appendChild(this.svg, arc);
        }
    };
    /**
     * Get a segment of the loader by its segment index and arc size
     */
    /**
     * Get a segment of the loader by its segment index and arc size
     * @private
     * @param {?} segNum
     * @param {?} arcSize
     * @return {?}
     */
    BusyLoader.prototype.getSegment = /**
     * Get a segment of the loader by its segment index and arc size
     * @private
     * @param {?} segNum
     * @param {?} arcSize
     * @return {?}
     */
    function (segNum, arcSize) {
        /** @type {?} */
        var nRadius = this.spinnerRadius - this.spinnerStroke * 0.5;
        /** @type {?} */
        var startD = BusyLoader.getRadianFromDegree(segNum * arcSize + this.spinnerStrokeGap * 0.5);
        /** @type {?} */
        var endD = BusyLoader.getRadianFromDegree(segNum * arcSize + arcSize - this.spinnerStrokeGap * 0.5);
        /** @type {?} */
        var d = this.spinnerRadius +
            Math.sin(startD) * (this.spinnerRadius - this.spinnerStroke * 0.5) +
            ' ' + // X1
            (this.spinnerRadius + Math.cos(startD) * (this.spinnerRadius - this.spinnerStroke * 0.5)) +
            ' ' + // Y1
            'A ' +
            nRadius +
            ' ' +
            nRadius +
            ' 0 0 0 ' + // min point
            (this.spinnerRadius + Math.sin(endD) * nRadius) +
            ' ' + // X2
            (this.spinnerRadius + Math.cos(endD) * nRadius);
        // Y1
        /** @type {?} */
        var path = this.document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.r.setAttribute(path, 'd', 'M' + d);
        this.r.setAttribute(path, 'stroke-width', String(this.spinnerStroke));
        this.r.setAttribute(path, 'fill', 'none');
        this.r.setAttribute(path, 'class', 'bento-busyloader-arc');
        return path;
    };
    return BusyLoader;
}());
if (false) {
    /** @type {?} */
    BusyLoader.prototype.onBusyLoaderChange;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.mainDom;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.size;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.canvasSize;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.isPositionedStatic;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.activeElement;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.showTimeoutID;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.hideTimeoutID;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.loader;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.blocker;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.currentArcIndex;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.CSSDelay;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.arcs;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.spinnerStrokeGap;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.intervalDefaultDelay;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.defaultNumSegments;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.svg;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.intervalID;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.spinnerRadius;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.spinnerStroke;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.spinnerSegments;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.intervalDelay;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.window;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BusyLoader.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/busyloader/busyloader.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The Busy Loader is a "take-over" DOM blocker displaying a spinner to signify an unavailable, waiting state.
 * This helps applications to block user interaction during the processing of background data,
 * avoiding front-end interruption.
 */
var BentoBusyLoaderDirective = /** @class */ (function () {
    /**
     */
    function BentoBusyLoaderDirective(elementRef, r, windowRef, translate, sanitizer) {
        var _this = this;
        this.r = r;
        this.translate = translate;
        this.sanitizer = sanitizer;
        /**
         * Defines the size of the busyloader
         * * `'sm'` - Small with five segments
         * * `'md'` - Medium with seven segments
         */
        this.size = 'md';
        /**
         * Delay in milliseconds to show the busyloader
         */
        this.showDelay = 0;
        /**
         * Delay in milliseconds to hide the busyloader
         */
        this.hideDelay = 0;
        /**
         * Event emitter to notify when loader becomes visible
         */
        this.show = new EventEmitter();
        /**
         * Event emitter to notify when loader hides
         */
        this.hide = new EventEmitter();
        /**
         * Flag to show if this directive view is ready
         */
        this.viewReady = false;
        /**
         * Should show busyloader when this directive is ready
         */
        this.shouldShowWhenReady = false;
        /**
         * Timeout ID from the previous timeout
         */
        this.timeoutID = 0;
        this.el = elementRef.nativeElement;
        this._busyLoader = new BusyLoader(this.el, r, windowRef);
        this._busyLoader.onBusyLoaderChange = (/**
         * @param {?} show
         * @return {?}
         */
        function (show) {
            show ? _this.show.emit() : _this.hide.emit();
        });
        // <div class="sr-only" aria-live="assertive">
        //   loading
        // </div>
        this.srEl = r.createElement('div');
        r.setAttribute(this.srEl, 'class', 'sr-only');
        r.setAttribute(this.srEl, 'aria-live', 'assertive');
        r.setProperty(this.srEl, 'innerHTML', '');
    }
    Object.defineProperty(BentoBusyLoaderDirective.prototype, "bentoBusyLoader", {
        /**
         * Main flag to show/hide this busyloader
         */
        set: /**
         * Main flag to show/hide this busyloader
         * @param {?} val
         * @return {?}
         */
        function (val) {
            if (this.viewReady) {
                // Only show when main view is ready
                this.showBusyLoader(val);
            }
            else {
                // This directive view is not ready, will put in an order to show
                // when view is ready
                this.shouldShowWhenReady = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Implements AfterViewInit interface methods
     */
    /**
     * Implements AfterViewInit interface methods
     * @return {?}
     */
    BentoBusyLoaderDirective.prototype.ngAfterViewInit = /**
     * Implements AfterViewInit interface methods
     * @return {?}
     */
    function () {
        this.viewReady = true;
        this.r.appendChild(this.el.parentElement, this.srEl);
        if (this.shouldShowWhenReady) {
            // Order is in already!!
            this.showBusyLoader(true);
        }
    };
    /**
     * @return {?}
     */
    BentoBusyLoaderDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._busyLoader.hide(0);
        this._busyLoader = null;
        if (this.srEl.parentElement) {
            // Remove screen reader help element
            this.r.removeChild(this.srEl.parentElement, this.srEl);
        }
        clearTimeout(this.timeoutID);
    };
    /**
     * Show/Hide BusyLoader
     */
    /**
     * Show/Hide BusyLoader
     * @param {?} val
     * @return {?}
     */
    BentoBusyLoaderDirective.prototype.showBusyLoader = /**
     * Show/Hide BusyLoader
     * @param {?} val
     * @return {?}
     */
    function (val) {
        var _this = this;
        /** @type {?} */
        var el = this.el;
        if (el.tagName.toLowerCase() === 'bento-toolbar' ||
            el.tagName.toLowerCase() === 'button' ||
            (el.classList && el.classList.contains('btn'))) {
            this.size = 'sm';
        }
        clearTimeout(this.timeoutID);
        if (val) {
            this._busyLoader.show(this.showDelay, this.size);
            this.timeoutID = setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.setProperty(_this.srEl, 'innerHTML', _this.sanitizer.sanitize(SecurityContext.HTML, _this.translate.instantTranslate('BENTO_UI_BUSY_LOADER_LOADING')));
            }), this.showDelay);
        }
        else {
            this._busyLoader.hide(this.hideDelay);
            this.timeoutID = setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.setProperty(_this.srEl, 'innerHTML', _this.sanitizer.sanitize(SecurityContext.HTML, _this.translate.instantTranslate('BENTO_UI_BUSY_LOADER_LOADED')));
            }), this.showDelay);
        }
    };
    /** @nocollapse */
    BentoBusyLoaderDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: WindowRef },
        { type: BentoTranslate },
        { type: DomSanitizer }
    ]; };
    BentoBusyLoaderDirective.propDecorators = {
        bentoBusyLoader: [{ type: Input }],
        size: [{ type: Input }],
        showDelay: [{ type: Input }],
        hideDelay: [{ type: Input }],
        show: [{ type: Output }],
        hide: [{ type: Output }]
    };
BentoBusyLoaderDirective.ɵfac = function BentoBusyLoaderDirective_Factory(t) { return new (t || BentoBusyLoaderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoTranslate), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
BentoBusyLoaderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoBusyLoaderDirective, selectors: [["", "bentoBusyLoader", ""]], inputs: { size: "size", showDelay: "showDelay", hideDelay: "hideDelay", bentoBusyLoader: "bentoBusyLoader" }, outputs: { show: "show", hide: "hide" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoTranslate])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoBusyLoaderDirective, [{
        type: Directive,
        args: [{ selector: '[bentoBusyLoader]', providers: [BentoTranslate] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: WindowRef }, { type: BentoTranslate }, { type: ɵngcc5.DomSanitizer }]; }, { size: [{
            type: Input
        }], showDelay: [{
            type: Input
        }], hideDelay: [{
            type: Input
        }], show: [{
            type: Output
        }], hide: [{
            type: Output
        }], bentoBusyLoader: [{
            type: Input
        }] }); })();
    return BentoBusyLoaderDirective;
}());
if (false) {
    /**
     * Defines the size of the busyloader
     * * `'sm'` - Small with five segments
     * * `'md'` - Medium with seven segments
     * @type {?}
     */
    BentoBusyLoaderDirective.prototype.size;
    /**
     * Delay in milliseconds to show the busyloader
     * @type {?}
     */
    BentoBusyLoaderDirective.prototype.showDelay;
    /**
     * Delay in milliseconds to hide the busyloader
     * @type {?}
     */
    BentoBusyLoaderDirective.prototype.hideDelay;
    /**
     * Event emitter to notify when loader becomes visible
     * @type {?}
     */
    BentoBusyLoaderDirective.prototype.show;
    /**
     * Event emitter to notify when loader hides
     * @type {?}
     */
    BentoBusyLoaderDirective.prototype.hide;
    /**
     * Private BusyLoader reference
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype._busyLoader;
    /**
     * Flag to show if this directive view is ready
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.viewReady;
    /**
     * Should show busyloader when this directive is ready
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.shouldShowWhenReady;
    /**
     * Element used for screen readers to announce this directive's progress
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.srEl;
    /**
     * HTMLElement of this directive
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.el;
    /**
     * Timeout ID from the previous timeout
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.timeoutID;
    /**
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    BentoBusyLoaderDirective.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/busyloader/busyloader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoBusyLoaderModule = /** @class */ (function () {
    function BentoBusyLoaderModule() {
    }
BentoBusyLoaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoBusyLoaderModule });
BentoBusyLoaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoBusyLoaderModule_Factory(t) { return new (t || BentoBusyLoaderModule)(); }, imports: [[BentoUtilsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoBusyLoaderModule, { declarations: [BentoBusyLoaderDirective], imports: [BentoUtilsModule], exports: [BentoBusyLoaderDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoBusyLoaderModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoBusyLoaderDirective],
                imports: [BentoUtilsModule],
                exports: [BentoBusyLoaderDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoBusyLoaderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/checkbox/checkbox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BENTO_CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoCheckboxComponent; })),
    multi: true
};
/**
 * This "tri-state" Checkbox is a new component that doesn't have a predecessor in Bento.UI 1.x.
 * Use this wherever you need to support both the "indeterminate" state, and the Bento checkbox style seen in FlexGrid.
 */
var BentoCheckboxComponent = /** @class */ (function () {
    function BentoCheckboxComponent(elRef, r, changeDetector, focusMonitor) {
        this.elRef = elRef;
        this.r = r;
        this.changeDetector = changeDetector;
        this.focusMonitor = focusMonitor;
        /**
         * Callback when indeterminate state is changed
         */
        this.indeterminateChange = new EventEmitter();
        this.iconOptions = { checked: 'bui-checkbox-checked', indeterminate: 'bui-checkbox-indeterminate' };
        this._value = false;
        this.onTouchedCallback = (/**
         * @return {?}
         */
        function () { });
        this.onChangeCallback = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    Object.defineProperty(BentoCheckboxComponent.prototype, "indeterminate", {
        get: /**
         * @return {?}
         */
        function () {
            return this._indeterminate;
        },
        /**
         * Set checkbox's indeterminate state
         */
        set: /**
         * Set checkbox's indeterminate state
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (!this._indeterminate === !v) {
                return;
            }
            this._indeterminate = v;
            this.updateIconClass();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Implements ControlValueAccessor
     */
    /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    BentoCheckboxComponent.prototype.registerOnChange = /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChangeCallback = fn;
    };
    /**
     * From ControlValueAccessor interface
     */
    /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    BentoCheckboxComponent.prototype.registerOnTouched = /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onTouchedCallback = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.changeDetector.markForCheck();
        });
    };
    /**
     * NgModel setter
     */
    /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    BentoCheckboxComponent.prototype.writeValue = /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this.value = v;
        /* In case one of the parent components is using ChangeDetectoionStarategy.OnPush */
        this.changeDetector.markForCheck();
    };
    /**
     * Set Disabled state for ngModel
     */
    /**
     * Set Disabled state for ngModel
     * @param {?} v
     * @return {?}
     */
    BentoCheckboxComponent.prototype.setDisabledState = /**
     * Set Disabled state for ngModel
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._disabled = v;
        this.updateIconClass();
        /* In case one of the parent components is using ChangeDetectoionStarategy.OnPush */
        this.changeDetector.markForCheck();
    };
    Object.defineProperty(BentoCheckboxComponent.prototype, "value", {
        /**
         * Class value getter
         */
        get: /**
         * Class value getter
         * @return {?}
         */
        function () {
            return this._value;
        },
        /**
         * Class value setter
         */
        set: /**
         * Class value setter
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._value = v;
            this.updateIconClass();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoCheckboxComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.updateIconClass();
        /** @type {?} */
        var attributes = ['id', 'role', 'aria-describedby', 'aria-label', 'tabindex'];
        this.focusMonitor.monitor(this.elRef.nativeElement, true);
        attributes.forEach((/**
         * @param {?} attribute
         * @return {?}
         */
        function (attribute) {
            /** @type {?} */
            var property = _this.elRef.nativeElement.getAttribute(attribute);
            if (property && property.length) {
                // Pass the aria tag to the actual checkbox
                _this.r.setAttribute(_this.cbRef.nativeElement, attribute, property);
                _this.r.removeAttribute(_this.elRef.nativeElement, attribute);
            }
        }));
    };
    /**
     * @return {?}
     */
    BentoCheckboxComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.focusMonitor.stopMonitoring(this.elRef.nativeElement);
        this.changeDetector.detach();
    };
    /**
     * On checkbox click
     */
    /**
     * On checkbox click
     * @param {?} value
     * @return {?}
     */
    BentoCheckboxComponent.prototype.onCheckBoxChange = /**
     * On checkbox click
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._indeterminate = false;
        this.indeterminateChange.emit(false);
        // gain focus to the component
        this.elRef.nativeElement.focus();
        this.value = value;
        this.onChangeCallback(value);
    };
    /**
     * On checkbox blur
     */
    /**
     * On checkbox blur
     * @param {?} e
     * @return {?}
     */
    BentoCheckboxComponent.prototype.onCheckboxBlur = /**
     * On checkbox blur
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onTouchedCallback();
    };
    /**
     * Update icon HTML view
     */
    /**
     * Update icon HTML view
     * @private
     * @return {?}
     */
    BentoCheckboxComponent.prototype.updateIconClass = /**
     * Update icon HTML view
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var el = this.iconRef.nativeElement;
        /** @type {?} */
        var iconOptions = this.iconOptions;
        if (this._indeterminate) {
            this.r.removeClass(el, iconOptions.checked);
            this.r.addClass(el, this.iconOptions.indeterminate);
        }
        else {
            this.r.removeClass(el, this.iconOptions.indeterminate);
            if (this._value) {
                this.r.addClass(el, iconOptions.checked);
            }
        }
        if (this._disabled) {
            this.r.addClass(el, 'disabled');
            this.r.addClass(this.elRef.nativeElement, 'disabled');
        }
        else {
            this.r.removeClass(el, 'disabled');
            this.r.removeClass(this.elRef.nativeElement, 'disabled');
        }
    };
    /** @nocollapse */
    BentoCheckboxComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: FocusMonitor }
    ]; };
    BentoCheckboxComponent.propDecorators = {
        indeterminate: [{ type: Input }],
        indeterminateChange: [{ type: Output }],
        cbRef: [{ type: ViewChild, args: ['checkbox', { static: true },] }],
        iconRef: [{ type: ViewChild, args: ['icon', { static: true },] }]
    };
BentoCheckboxComponent.ɵfac = function BentoCheckboxComponent_Factory(t) { return new (t || BentoCheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FocusMonitor)); };
BentoCheckboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoCheckboxComponent, selectors: [["bento-checkbox"]], viewQuery: function BentoCheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
        ɵngcc0.ɵɵstaticViewQuery(_c6, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cbRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.iconRef = _t.first);
    } }, inputs: { indeterminate: "indeterminate" }, outputs: { indeterminateChange: "indeterminateChange" }, features: [ɵngcc0.ɵɵProvidersFeature([BENTO_CHECKBOX_VALUE_ACCESSOR])], decls: 5, vars: 4, consts: [["type", "checkbox", 3, "ngModel", "disabled", "ngModelChange", "blur"], ["checkbox", ""], ["aria-hidden", "true", 1, "bui-checkbox-unchecked"], ["aria-hidden", "true"], ["icon", ""]], template: function BentoCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function BentoCheckboxComponent_Template_input_ngModelChange_0_listener($event) { return ctx.onCheckBoxChange($event); })("blur", function BentoCheckboxComponent_Template_input_blur_0_listener($event) { return ctx.onCheckboxBlur($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelement(3, "i", 3, 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("disabled", ctx._disabled);
        ɵngcc0.ɵɵattribute("aria-checked", ctx._indeterminate ? "mixed" : ctx.value)("aria-disabled", ctx._disabled);
    } }, directives: [ɵngcc8.CheckboxControlValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.NgModel], styles: ["bento-checkbox{display:inline-block;background:#fff;position:relative;font-size:1rem;height:1em;width:1em;line-height:1em;margin-right:.5rem;vertical-align:text-bottom}bento-checkbox.disabled{pointer-events:none}[dir=rtl] bento-checkbox{margin-left:.5rem;margin-right:0}bento-checkbox i{margin:0;top:0;pointer-events:none;position:absolute;left:0;font-size:1em;height:1rem;line-height:1rem;width:0;overflow:hidden;direction:ltr;transition:background-color .2s,border-color .1s}bento-checkbox i.bui-checkbox-unchecked{width:1rem}bento-checkbox i:before{display:block;height:1rem;width:1rem;text-align:center}bento-checkbox [aria-checked=mixed]~i.bui-checkbox-checked,bento-checkbox [aria-checked=mixed]~i.bui-checkbox-indeterminate,bento-checkbox [aria-checked=true]~i.bui-checkbox-checked,bento-checkbox [aria-checked=true]~i.bui-checkbox-indeterminate{width:1rem;transition:width .4s}bento-checkbox input{top:0;left:0;position:absolute;width:1em;height:1em;z-index:1;opacity:0}[dir=rtl] bento-checkbox input{left:auto;right:0}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'bento-checkbox',
                template: "<input\n  #checkbox\n  [ngModel]=\"value\"\n  (ngModelChange)=\"onCheckBoxChange($event)\"\n  type=\"checkbox\"\n  (blur)=\"onCheckboxBlur($event)\"\n  [disabled]=\"_disabled\"\n  [attr.aria-checked]=\"_indeterminate ? 'mixed' : value\"\n  [attr.aria-disabled]=\"_disabled\"\n/>\n<i class=\"bui-checkbox-unchecked\" aria-hidden=\"true\"></i>\n<i #icon aria-hidden=\"true\"></i>\n",
                providers: [BENTO_CHECKBOX_VALUE_ACCESSOR],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-checkbox{display:inline-block;background:#fff;position:relative;font-size:1rem;height:1em;width:1em;line-height:1em;margin-right:.5rem;vertical-align:text-bottom}bento-checkbox.disabled{pointer-events:none}[dir=rtl] bento-checkbox{margin-left:.5rem;margin-right:0}bento-checkbox i{margin:0;top:0;pointer-events:none;position:absolute;left:0;font-size:1em;height:1rem;line-height:1rem;width:0;overflow:hidden;direction:ltr;transition:background-color .2s,border-color .1s}bento-checkbox i.bui-checkbox-unchecked{width:1rem}bento-checkbox i:before{display:block;height:1rem;width:1rem;text-align:center}bento-checkbox [aria-checked=mixed]~i.bui-checkbox-checked,bento-checkbox [aria-checked=mixed]~i.bui-checkbox-indeterminate,bento-checkbox [aria-checked=true]~i.bui-checkbox-checked,bento-checkbox [aria-checked=true]~i.bui-checkbox-indeterminate{width:1rem;transition:width .4s}bento-checkbox input{top:0;left:0;position:absolute;width:1em;height:1em;z-index:1;opacity:0}[dir=rtl] bento-checkbox input{left:auto;right:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.FocusMonitor }]; }, { indeterminateChange: [{
            type: Output
        }], indeterminate: [{
            type: Input
        }], cbRef: [{
            type: ViewChild,
            args: ['checkbox', { static: true }]
        }], iconRef: [{
            type: ViewChild,
            args: ['icon', { static: true }]
        }] }); })();
    return BentoCheckboxComponent;
}());
if (false) {
    /** @type {?} */
    BentoCheckboxComponent.prototype._indeterminate;
    /** @type {?} */
    BentoCheckboxComponent.prototype._disabled;
    /**
     * Callback when indeterminate state is changed
     * @type {?}
     */
    BentoCheckboxComponent.prototype.indeterminateChange;
    /** @type {?} */
    BentoCheckboxComponent.prototype.iconOptions;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.cbRef;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.iconRef;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype._value;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.onTouchedCallback;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.onChangeCallback;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoCheckboxComponent.prototype.focusMonitor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/checkbox/checkbox.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoCheckboxModule = /** @class */ (function () {
    function BentoCheckboxModule() {
    }
BentoCheckboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoCheckboxModule });
BentoCheckboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoCheckboxModule_Factory(t) { return new (t || BentoCheckboxModule)(); }, imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoCheckboxModule, { declarations: function () { return [BentoCheckboxComponent]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [BentoCheckboxComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                declarations: [BentoCheckboxComponent],
                exports: [BentoCheckboxComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoCheckboxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/list/list-data-subscribable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This Class is designed to be extended to stream data without constant detection cycle checks
 */
var BentoListSubscribable = /** @class */ (function () {
    function BentoListSubscribable() {
        /**
         * Main data
         */
        this._data = [];
        /**
         * Event Emitter when this class is ready
         */
        this.ready = new EventEmitter();
    }
    /**
     * Used when view is initialized
     */
    /**
     * Used when view is initialized
     * @return {?}
     */
    BentoListSubscribable.prototype.ngAfterViewInit = /**
     * Used when view is initialized
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.ready.emit();
        }), 100);
    };
    /**
     * Logic to control data
     */
    /**
     * Logic to control data
     * @param {?} observable
     * @return {?}
     */
    BentoListSubscribable.prototype._setDataObservable = /**
     * Logic to control data
     * @param {?} observable
     * @return {?}
     */
    function (observable) {
        // Reset the main data array
        this._data = [];
        if (this._dataSubscription) {
            // Un-subscribe the previous data stream subscription
            // and reset data before the new subscription starts
            this._dataSubscription.unsubscribe();
        }
        // Declare first initial data stream subscription
        // Fire interface callback
        this._onDataReload(this._data);
        if (observable) {
            // Subscribe the recurrent subscription
            this._subscribeDataUpdate(observable);
        }
    };
    /**
     * Subscribe to when data is on update
     */
    /**
     * Subscribe to when data is on update
     * @param {?} observable
     * @return {?}
     */
    BentoListSubscribable.prototype._subscribeDataUpdate = /**
     * Subscribe to when data is on update
     * @param {?} observable
     * @return {?}
     */
    function (observable) {
        var _this = this;
        this._dataSubscription = observable.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (!value || !Array.isArray(value)) {
                // Invalid data type for `value`
                _this._dataSubscription.unsubscribe();
                throw new Error('[dataObservable]: Invalid data type.  Must be [Array<any>]');
            }
            // Append the new data to the end of the
            // main data
            _this._updateData(value);
            // Fire interface update callback
            _this._onDataUpdate(_this._data);
        }));
    };
    /**
     * Method to update data
     */
    /**
     * Method to update data
     * @param {?} data
     * @return {?}
     */
    BentoListSubscribable.prototype._updateData = /**
     * Method to update data
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this._data = data;
    };
    /**
     * handle data updates
     */
    /**
     * handle data updates
     * @param {?} data
     * @return {?}
     */
    BentoListSubscribable.prototype._onDataUpdate = /**
     * handle data updates
     * @param {?} data
     * @return {?}
     */
    function (data) {
        // To be overridden
    };
    /**
     * Callback to when data is reloaded
     */
    /**
     * Callback to when data is reloaded
     * @param {?} data
     * @return {?}
     */
    BentoListSubscribable.prototype._onDataReload = /**
     * Callback to when data is reloaded
     * @param {?} data
     * @return {?}
     */
    function (data) {
        // to be overridden
    };
    BentoListSubscribable.propDecorators = {
        ready: [{ type: Output }]
    };
BentoListSubscribable.ɵfac = function BentoListSubscribable_Factory(t) { return new (t || BentoListSubscribable)(); };
BentoListSubscribable.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoListSubscribable, outputs: { ready: "ready" } });

    return BentoListSubscribable;
}());
if (false) {
    /**
     * Main data
     * @type {?}
     */
    BentoListSubscribable.prototype._data;
    /**
     * Main data subscription
     * @type {?}
     */
    BentoListSubscribable.prototype._dataSubscription;
    /**
     * Event Emitter when this class is ready
     * @type {?}
     */
    BentoListSubscribable.prototype.ready;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/list/list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Default variables for the width and height of this element
 * @type {?}
 */
var DEFAULT_LIST_WIDTH = 300;
/** @type {?} */
var DEFAULT_LIST_HEIGHT = 300;
/** @type {?} */
var DEFAULT_ROW_HEIGHT = 30;
/** @type {?} */
var DEFAULT_LIST_MAX_HEIGHT = Number.POSITIVE_INFINITY;
var BentoListComponent = /** @class */ (function (_super) {
    __extends(BentoListComponent, _super);
    function BentoListComponent(r, elRef, changeDetector) {
        var _this = _super.call(this) || this;
        _this.r = r;
        _this.changeDetector = changeDetector;
        _this.autoHeightResize = false;
        _this.minWidth = 0;
        _this.endOfScroll = new EventEmitter();
        _this.heightChange = new EventEmitter();
        _this.scrollBarChange = new EventEmitter();
        _this.itemHeight = DEFAULT_ROW_HEIGHT;
        _this.lastRenderedEnd = 0;
        _this.el = elRef.nativeElement;
        _this.onElementScroll = _this.onElementScroll.bind(_this);
        return _this;
    }
    Object.defineProperty(BentoListComponent.prototype, "width", {
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoListComponent.prototype, "height", {
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._height = v || DEFAULT_LIST_HEIGHT;
            this.r.setStyle(this.el, 'height', this._height + 'px');
            this.vScroll.checkViewportSize();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoListComponent.prototype, "dataObservable", {
        set: /**
         * @param {?} observable
         * @return {?}
         */
        function (observable) {
            this._setDataObservable(observable);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoListComponent.prototype, "maxHeight", {
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._maxHeight = v || DEFAULT_LIST_MAX_HEIGHT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoListComponent.prototype, "_itemHeight", {
        /**
         * Row height that is used here (default: 30px)
         */
        set: /**
         * Row height that is used here (default: 30px)
         * @param {?} h
         * @return {?}
         */
        function (h) {
            // Make sure that there is no `undefined` for `h`
            this.itemHeight = h || DEFAULT_ROW_HEIGHT;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // Use custom template if available
        this.rowTemp = this.customRowTemp || this.defaultRowTemp;
        // Scroll Listener
        this.vScroll.elementScrolled().subscribe(this.onElementScroll);
        this.listEl = this.vScroll.getElementRef().nativeElement;
    };
    /**
     * @return {?}
     */
    BentoListComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        clearTimeout(this.timeoutID);
    };
    /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    BentoListComponent.prototype.trackByFn = /**
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    function (index, item) {
        return index;
    };
    /**
     * @return {?}
     */
    BentoListComponent.prototype.getScrollTop = /**
     * @return {?}
     */
    function () {
        return this.vScroll.getViewportSize();
    };
    /**
     * @param {?} row
     * @return {?}
     */
    BentoListComponent.prototype.scrollToRow = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        this.vScroll.scrollToIndex(this._data.indexOf(row));
    };
    /**
     * @return {?}
     */
    BentoListComponent.prototype.checkViewportSize = /**
     * @return {?}
     */
    function () {
        this.vScroll.checkViewportSize();
    };
    /**
     * @return {?}
     */
    BentoListComponent.prototype.getRowRangeInView = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var scrollTop = this.vScroll.measureScrollOffset('top');
        /** @type {?} */
        var height = this.vScroll.getViewportSize();
        /** @type {?} */
        var start = Math.ceil(scrollTop / this.itemHeight);
        /** @type {?} */
        var end = Math.floor((scrollTop + height) / this.itemHeight);
        return { from: start, to: end };
    };
    /**
     * @param {?} index
     * @return {?}
     */
    BentoListComponent.prototype.scrollToRowIndex = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.vScroll.scrollToIndex(index);
    };
    /**
     * Make a row visible in the scroll pane
     */
    /**
     * Make a row visible in the scroll pane
     * @param {?} row
     * @return {?}
     */
    BentoListComponent.prototype.showRow = /**
     * Make a row visible in the scroll pane
     * @param {?} row
     * @return {?}
     */
    function (row) {
        this.showRowIndex(this._data.indexOf(row));
    };
    /**
     * Make a row visible in thescroll pane by its index
     */
    /**
     * Make a row visible in thescroll pane by its index
     * @param {?} index
     * @return {?}
     */
    BentoListComponent.prototype.showRowIndex = /**
     * Make a row visible in thescroll pane by its index
     * @param {?} index
     * @return {?}
     */
    function (index) {
        /** @type {?} */
        var rowOffsetTop = index * this.itemHeight;
        /** @type {?} */
        var listHeight = this.listEl.offsetHeight;
        /** @type {?} */
        var scrollTop = this.listEl.scrollTop;
        if (rowOffsetTop + this.itemHeight > listHeight + scrollTop) {
            this.vScroll.scrollTo({ top: rowOffsetTop - listHeight + this.itemHeight });
        }
        else if (rowOffsetTop < scrollTop) {
            this.vScroll.scrollTo({ top: rowOffsetTop });
        }
    };
    /**
     * Data reload callback
     */
    /**
     * Data reload callback
     * @param {?} data
     * @return {?}
     */
    BentoListComponent.prototype._onDataReload = /**
     * Data reload callback
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.lastRenderedEnd = 0;
    };
    /**
     * Update callback
     */
    /**
     * Update callback
     * @param {?} data
     * @return {?}
     */
    BentoListComponent.prototype._onDataUpdate = /**
     * Update callback
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        this._dataSize = data.length;
        this.timeoutID = setTimeout((/**
         * @return {?}
         */
        function () {
            // Data update sometimes comes faster than UI
            // need to wait here
            if (_this.autoHeightResize) {
                // Set the height of this list accordingly
                _this.height = Math.min(_this._maxHeight, _this._dataSize * _this.itemHeight);
                _this.heightChange.emit(_this._height);
            }
            _this.scrollBarChange.emit(_this.vScroll.getViewportSize() < _this._dataSize * _this.itemHeight);
            _this.changeDetector.detectChanges();
        }));
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoListComponent.prototype.onElementScroll = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var range = this.vScroll.getRenderedRange();
        if (range.end === this._dataSize && this.lastRenderedEnd < range.end) {
            this.lastRenderedEnd = range.end;
            this.endOfScroll.emit();
        }
    };
    /** @nocollapse */
    BentoListComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ]; };
    BentoListComponent.propDecorators = {
        autoHeightResize: [{ type: Input }],
        width: [{ type: Input }],
        height: [{ type: Input }],
        dataObservable: [{ type: Input }],
        maxHeight: [{ type: Input }],
        options: [{ type: Input }],
        minWidth: [{ type: HostBinding, args: ['style.min-width.px',] }, { type: Input }],
        endOfScroll: [{ type: Output }],
        heightChange: [{ type: Output }],
        scrollBarChange: [{ type: Output }],
        vScroll: [{ type: ViewChild, args: [CdkVirtualScrollViewport, { static: true },] }],
        defaultRowTemp: [{ type: ViewChild, args: ['defaultRowTemp', { static: true },] }],
        customRowTemp: [{ type: ContentChild, args: ['rowTemplate', { static: true },] }],
        _itemHeight: [{ type: Input, args: ['itemHeight',] }]
    };
BentoListComponent.ɵfac = function BentoListComponent_Factory(t) { return new (t || BentoListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoListComponent, selectors: [["bento-list"]], contentQueries: function BentoListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c7, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customRowTemp = _t.first);
    } }, viewQuery: function BentoListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(CdkVirtualScrollViewport, true);
        ɵngcc0.ɵɵstaticViewQuery(_c8, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.vScroll = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultRowTemp = _t.first);
    } }, hostVars: 2, hostBindings: function BentoListComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("min-width", ctx.minWidth, "px");
    } }, inputs: { width: "width", height: "height", dataObservable: "dataObservable", maxHeight: "maxHeight", _itemHeight: ["itemHeight", "_itemHeight"], autoHeightResize: "autoHeightResize", options: "options", minWidth: "minWidth" }, outputs: { endOfScroll: "endOfScroll", heightChange: "heightChange", scrollBarChange: "scrollBarChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [[1, "bento-list-viewport", 3, "itemSize"], [4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy"], ["defaultRowTemp", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "-1", 1, "bento-list-row"]], template: function BentoListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "cdk-virtual-scroll-viewport", 0);
        ɵngcc0.ɵɵtemplate(1, BentoListComponent_ng_container_1_Template, 2, 10, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, BentoListComponent_ng_template_2_Template, 2, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("itemSize", ctx.itemHeight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkVirtualForOf", ctx._data)("cdkVirtualForTrackBy", ctx.trackByFn);
    } }, directives: [ɵngcc9.CdkVirtualScrollViewport, ɵngcc9.CdkFixedSizeVirtualScroll, ɵngcc9.CdkVirtualForOf, ɵngcc7.NgTemplateOutlet], styles: ["bento-list-core{display:block;position:relative;width:100%}bento-list{display:block;min-width:200px;height:200px;border:1px solid transparent}.bento-list-viewport{display:block;height:100%}.bento-list-inner{position:absolute;display:block;width:100%;height:200%}.bento-list-row{height:30px;line-height:29px;border-bottom:1px solid grey;font-size:.879rem}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoListComponent, [{
        type: Component,
        args: [{
                selector: 'bento-list',
                template: "<cdk-virtual-scroll-viewport [itemSize]=\"itemHeight\"\n                             class=\"bento-list-viewport\">\n  <ng-container *cdkVirtualFor=\"let row of _data; let index = index; trackBy:trackByFn\">\n    <ng-container\n                  *ngTemplateOutlet=\"rowTemp; context: {row: row, options: options, data: {_data:_data, row: row},index:index}\">\n    </ng-container>\n  </ng-container>\n\n</cdk-virtual-scroll-viewport>\n\n<ng-template #defaultRowTemp let-$row=\"row\" let-$options=\"options\">\n  <div class=\"bento-list-row\" tabindex=\"-1\">\n    {{$row}}\n  </div>\n</ng-template>",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-list-core{display:block;position:relative;width:100%}bento-list{display:block;min-width:200px;height:200px;border:1px solid transparent}.bento-list-viewport{display:block;height:100%}.bento-list-inner{position:absolute;display:block;width:100%;height:200%}.bento-list-row{height:30px;line-height:29px;border-bottom:1px solid grey;font-size:.879rem}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], dataObservable: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], _itemHeight: [{
            type: Input,
            args: ['itemHeight']
        }], autoHeightResize: [{
            type: Input
        }], options: [{
            type: Input
        }], minWidth: [{
            type: HostBinding,
            args: ['style.min-width.px']
        }, {
            type: Input
        }], endOfScroll: [{
            type: Output
        }], heightChange: [{
            type: Output
        }], scrollBarChange: [{
            type: Output
        }], vScroll: [{
            type: ViewChild,
            args: [CdkVirtualScrollViewport, { static: true }]
        }], defaultRowTemp: [{
            type: ViewChild,
            args: ['defaultRowTemp', { static: true }]
        }], customRowTemp: [{
            type: ContentChild,
            args: ['rowTemplate', { static: true }]
        }] }); })();
    return BentoListComponent;
}(BentoListSubscribable));
if (false) {
    /** @type {?} */
    BentoListComponent.prototype.autoHeightResize;
    /** @type {?} */
    BentoListComponent.prototype.options;
    /** @type {?} */
    BentoListComponent.prototype.minWidth;
    /** @type {?} */
    BentoListComponent.prototype.endOfScroll;
    /** @type {?} */
    BentoListComponent.prototype.heightChange;
    /** @type {?} */
    BentoListComponent.prototype.scrollBarChange;
    /** @type {?} */
    BentoListComponent.prototype.vScroll;
    /**
     * Default row template reference declared in the template file
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.defaultRowTemp;
    /**
     * (Optional) Custom template when wrapped with this component
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.customRowTemp;
    /** @type {?} */
    BentoListComponent.prototype.itemHeight;
    /**
     * Row template reference used internally
     * @type {?}
     */
    BentoListComponent.prototype.rowTemp;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype._height;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype._maxHeight;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype._dataSize;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.listEl;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.lastRenderedEnd;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.timeoutID;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoListComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/combobox/combobox-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Used to create uid
/** @type {?} */
var comboboxListId = 0;
/**
 * @record
 */
function BentoComboboxListRowChangeEvent() { }
if (false) {
    /** @type {?} */
    BentoComboboxListRowChangeEvent.prototype.row;
    /** @type {?|undefined} */
    BentoComboboxListRowChangeEvent.prototype.isClickEvent;
}
var BentoComboboxListComponent = /** @class */ (function (_super) {
    __extends(BentoComboboxListComponent, _super);
    function BentoComboboxListComponent(elRef, windowRef, r, changeDetector) {
        var _this = _super.call(this) || this;
        _this.elRef = elRef;
        _this.windowRef = windowRef;
        _this.r = r;
        _this.changeDetector = changeDetector;
        /**
         * On row change
         */
        _this.selectedRowChange = new EventEmitter();
        /**
         * Emits end of scroll event
         */
        _this.endOfScroll = new EventEmitter();
        _this.highlightedIDChange = new EventEmitter();
        /**
         * ScrollBar width
         */
        _this._scrollBarWidth = 0;
        /**
         * Keep track on what the height of the list is
         */
        _this._listHeight = '0';
        /**
         * Flag to determine if the list has table structure
         */
        _this._isGrid = false;
        /**
         * The size of data
         */
        _this._dataSize = 0;
        /**
         * Unique ID of this component
         */
        _this.uid = "bui-combobox-list-" + comboboxListId++;
        /** @type {?} */
        var comp = _this;
        /** @type {?} */
        var el = elRef.nativeElement;
        r.addClass(el, 'bui-bento-combobox-container-list');
        r.addClass(el, 'bento-combox-container-list');
        _this._listOptions = { _highlightedIndex: -1 };
        _this._listOptions.comboboxOptions = {};
        _this._listOptions.onRowClick = _this.onRowClick.bind(_this);
        /**
         * Define highlightedIndex to include emitter
         */
        Object.defineProperty(_this._listOptions, 'highlightedIndex', {
            get: (/**
             * @return {?}
             */
            function () {
                return this._highlightedIndex;
            }),
            set: (/**
             * @param {?} index
             * @return {?}
             */
            function (index) {
                this._highlightedIndex = index;
                if (index < 0) {
                    comp.highlightedIDChange.emit(null);
                }
                else {
                    comp.highlightedIDChange.emit(comp.uid + "-" + index);
                }
            })
        });
        return _this;
    }
    Object.defineProperty(BentoComboboxListComponent.prototype, "dataObservable", {
        /**
         * API to set observable
         */
        set: /**
         * API to set observable
         * @param {?} observable
         * @return {?}
         */
        function (observable) {
            this._setDataObservable(observable);
            this._list.dataObservable = observable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoComboboxListComponent.prototype, "options", {
        /**
         * List Options
         */
        set: /**
         * List Options
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v) {
                this._listOptions.comboboxOptions = v;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoComboboxListComponent.prototype, "selectedRow", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selectedRow;
        },
        /**
         * Set and get selected row
         */
        set: /**
         * Set and get selected row
         * @param {?} r
         * @return {?}
         */
        function (r) {
            if (r === this._selectedRow) {
                return;
            }
            this._selectedRow = r;
            // reset row highlight
            // this.resetHighlight();
            if (this._data) {
                this._listOptions.selectedIndex = this._data.indexOf(r);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoComboboxListComponent.prototype, "highlightedRow", {
        set: /**
         * @param {?} r
         * @return {?}
         */
        function (r) {
            if (this._data) {
                this._listOptions.highlightedIndex = this._data.indexOf(r);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoComboboxListComponent.prototype, "length", {
        /**
         * Returns the length of the list
         */
        get: /**
         * Returns the length of the list
         * @return {?}
         */
        function () {
            if (this._data) {
                return this._data.length;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Check viewport size and rerender
     */
    /**
     * Check viewport size and rerender
     * @return {?}
     */
    BentoComboboxListComponent.prototype.checkViewportSize = /**
     * Check viewport size and rerender
     * @return {?}
     */
    function () {
        this._list.checkViewportSize();
    };
    /**
     * Highlight next row
     */
    /**
     * Highlight next row
     * @return {?}
     */
    BentoComboboxListComponent.prototype.highlightNext = /**
     * Highlight next row
     * @return {?}
     */
    function () {
        /** @type {?} */
        var length = this._data.length;
        /** @type {?} */
        var index = length > 0 ? (this._listOptions.highlightedIndex + 1) % length : -1;
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    };
    /**
     * Highlight previous row
     */
    /**
     * Highlight previous row
     * @return {?}
     */
    BentoComboboxListComponent.prototype.highlightPrevious = /**
     * Highlight previous row
     * @return {?}
     */
    function () {
        /** @type {?} */
        var length = this._data.length;
        /** @type {?} */
        var index = length > 0 ? (this._listOptions.highlightedIndex - 1 + length) % length : -1;
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    };
    /**
     * Highlight on the currently selected row
     */
    /**
     * Highlight on the currently selected row
     * @return {?}
     */
    BentoComboboxListComponent.prototype.highlightSelectedRow = /**
     * Highlight on the currently selected row
     * @return {?}
     */
    function () {
        /** @type {?} */
        var index = this._data.indexOf(this._selectedRow);
        if (index > -1) {
            this._list.showRowIndex(index);
            this._listOptions.highlightedIndex = index;
        }
    };
    /**
     * Page down
     */
    /**
     * Page down
     * @return {?}
     */
    BentoComboboxListComponent.prototype.pageDown = /**
     * Page down
     * @return {?}
     */
    function () {
        /** @type {?} */
        var range = this._list.getRowRangeInView();
        /** @type {?} */
        var highlightedIndex = this._listOptions.highlightedIndex || 0;
        /** @type {?} */
        var index = Math.min(highlightedIndex + Math.ceil((range.to + range.from) * 0.5), this._dataSize - 1);
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    };
    /**
     * Page up
     */
    /**
     * Page up
     * @return {?}
     */
    BentoComboboxListComponent.prototype.pageUp = /**
     * Page up
     * @return {?}
     */
    function () {
        /** @type {?} */
        var range = this._list.getRowRangeInView();
        /** @type {?} */
        var highlightedIndex = this._listOptions.highlightedIndex || 0;
        /** @type {?} */
        var index = Math.max(0, highlightedIndex - Math.max(0, Math.ceil((range.to + range.from) * 0.5)));
        this._list.showRowIndex(index);
        this._listOptions.highlightedIndex = index;
    };
    /**
     * Scroll to End
     */
    /**
     * Scroll to End
     * @return {?}
     */
    BentoComboboxListComponent.prototype.end = /**
     * Scroll to End
     * @return {?}
     */
    function () {
        this._list.showRowIndex((this._listOptions.highlightedIndex = this._data.length - 1));
    };
    /**
     * Scroll to home
     */
    /**
     * Scroll to home
     * @return {?}
     */
    BentoComboboxListComponent.prototype.home = /**
     * Scroll to home
     * @return {?}
     */
    function () {
        this._list.showRowIndex((this._listOptions.highlightedIndex = 0));
    };
    /**
     * Reset highlighted row
     */
    /**
     * Reset highlighted row
     * @return {?}
     */
    BentoComboboxListComponent.prototype.resetHighlight = /**
     * Reset highlighted row
     * @return {?}
     */
    function () {
        this._listOptions.highlightedIndex = -1;
    };
    /**
     * Select the highlighted row
     * This will fire the `selectedRowChange` callback
     *
     * NOTE: This method will ONLY execute when highlight index is changed
     */
    /**
     * Select the highlighted row
     * This will fire the `selectedRowChange` callback
     *
     * NOTE: This method will ONLY execute when highlight index is changed
     * @return {?}
     */
    BentoComboboxListComponent.prototype.selectHighlightedRow = /**
     * Select the highlighted row
     * This will fire the `selectedRowChange` callback
     *
     * NOTE: This method will ONLY execute when highlight index is changed
     * @return {?}
     */
    function () {
        // Only select a highlighted row when it's changed
        /** @type {?} */
        var options = this._listOptions;
        if (this.selectedRow === this._data[options.highlightedIndex]) {
            // Do nothing when the selection and highlight are the same
            return;
        }
        else if (options.highlightedIndex === -1 || isNaN(options.highlightedIndex)) {
            // Clear selection since there is no highlight
            options.selectedIndex = -1;
            this.selectedRow = null;
            this.selectedRowChange.emit({ row: null });
        }
        else {
            // Update selection based on the current highlight
            options.selectedIndex = options.highlightedIndex;
            this.selectedRow = this._data[options.highlightedIndex];
            this.selectedRowChange.emit({ row: this._data[options.selectedIndex] });
        }
    };
    /**
     * Initialization
     */
    /**
     * Initialization
     * @return {?}
     */
    BentoComboboxListComponent.prototype.ngOnInit = /**
     * Initialization
     * @return {?}
     */
    function () {
        var _this = this;
        // Make sure there is a least one template
        this._listOptions.rowTemplate = this.rowTemplate || this.defaultTemplate;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._isGrid = _this._listOptions.comboboxOptions.columns && _this._listOptions.comboboxOptions.columns.length > 1;
            _this.r.setAttribute(_this.elRef.nativeElement, 'role', _this._isGrid ? 'grid' : 'listbox');
            _this.changeDetector.markForCheck();
        }));
    };
    /**
     * Row click
     */
    /**
     * Row click
     * @param {?} $event
     * @param {?} row
     * @param {?} index
     * @return {?}
     */
    BentoComboboxListComponent.prototype.onRowClick = /**
     * Row click
     * @param {?} $event
     * @param {?} row
     * @param {?} index
     * @return {?}
     */
    function ($event, row, index) {
        if (this._selectedRow === row) {
            return;
        }
        this.selectedRow = row;
        this.selectedRowChange.emit({ row: row, isClickEvent: true });
    };
    /**
     * Data reload - reset scrolling
     */
    /**
     * Data reload - reset scrolling
     * @return {?}
     */
    BentoComboboxListComponent.prototype._onDataReload = /**
     * Data reload - reset scrolling
     * @return {?}
     */
    function () {
        if (typeof this.selectedRow !== 'undefined') {
            this._listOptions.selectedIndex = this._data.indexOf(this.selectedRow);
        }
        this._dataSize = this._data.length;
    };
    /**
     * Data update - keep scroll to top
     */
    /**
     * Data update - keep scroll to top
     * @param {?} data
     * @return {?}
     */
    BentoComboboxListComponent.prototype._onDataUpdate = /**
     * Data update - keep scroll to top
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (typeof this.selectedRow !== 'undefined' || !this.selectedRow) {
            this._listOptions.selectedIndex = data.indexOf(this.selectedRow);
        }
        this._dataSize = this._data.length;
        this.changeDetector.detectChanges();
    };
    /**
     * When the virtual list height has changed
     */
    /**
     * When the virtual list height has changed
     * @param {?} h
     * @return {?}
     */
    BentoComboboxListComponent.prototype._onListHeightChange = /**
     * When the virtual list height has changed
     * @param {?} h
     * @return {?}
     */
    function (h) {
        this._listHeight = (this._data.length === 0 ? 150 : h) + 'px';
        this.changeDetector.markForCheck();
    };
    /**
     * Callback to check scrollbar visibility change
     */
    /**
     * Callback to check scrollbar visibility change
     * @param {?} visible
     * @return {?}
     */
    BentoComboboxListComponent.prototype._onScrollBarVisChange = /**
     * Callback to check scrollbar visibility change
     * @param {?} visible
     * @return {?}
     */
    function (visible) {
        this._scrollBarWidth = visible ? this.windowRef.scrollbarWidth : 0;
        this.changeDetector.markForCheck();
    };
    /**
     * End of scroll listener
     */
    /**
     * End of scroll listener
     * @return {?}
     */
    BentoComboboxListComponent.prototype._onEOS = /**
     * End of scroll listener
     * @return {?}
     */
    function () {
        this.endOfScroll.emit();
    };
    /** @nocollapse */
    BentoComboboxListComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: WindowRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef }
    ]; };
    BentoComboboxListComponent.propDecorators = {
        options: [{ type: Input }],
        rowTemplate: [{ type: Input }],
        selectedRow: [{ type: Input }],
        highlightedRow: [{ type: Input }],
        selectedRowChange: [{ type: Output }],
        endOfScroll: [{ type: Output }],
        highlightedIDChange: [{ type: Output }],
        defaultTemplate: [{ type: ViewChild, args: ['defaultRowTemplate', { static: true },] }],
        _list: [{ type: ViewChild, args: [BentoListComponent, { static: true },] }]
    };
BentoComboboxListComponent.ɵfac = function BentoComboboxListComponent_Factory(t) { return new (t || BentoComboboxListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoComboboxListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoComboboxListComponent, selectors: [["bento-combobox-list"]], viewQuery: function BentoComboboxListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c11, true);
        ɵngcc0.ɵɵstaticViewQuery(BentoListComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._list = _t.first);
    } }, inputs: { options: "options", selectedRow: "selectedRow", highlightedRow: "highlightedRow", rowTemplate: "rowTemplate" }, outputs: { selectedRowChange: "selectedRowChange", endOfScroll: "endOfScroll", highlightedIDChange: "highlightedIDChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 8, consts: [["class", "bui-bento-combobox-container-header bento-combobox-container-header", "role", "row", 4, "ngIf"], [1, "bui-bento-combobox-list-wrapper", "bento-combobox-list-wrapper"], [3, "options", "maxHeight", "itemHeight", "autoHeightResize", "endOfScroll", "scrollBarChange", "heightChange"], ["rowTemplate", ""], ["defaultRowTemplate", ""], ["role", "img", "class", "bento-icon-file-viewer bento-combobox-container-empty-label", 4, "ngIf"], ["role", "row", 1, "bui-bento-combobox-container-header", "bento-combobox-container-header"], [3, "ngIf"], ["role", "columnheader", "class", "bui-bento-combobox-container-header-label", 3, "ngStyle", 4, "ngFor", "ngForOf"], ["class", "bui-bento-combobox-container-header-label bui-bento-combobox-container-header-label-filler", 3, "width", 4, "ngIf"], ["role", "columnheader", 1, "bui-bento-combobox-container-header-label", 3, "ngStyle"], [1, "bui-bento-combobox-container-header-label", "bui-bento-combobox-container-header-label-filler"], ["role", "columnheader", "class", "bui-bento-combobox-container-header-label", 4, "ngFor", "ngForOf"], ["role", "columnheader", 1, "bui-bento-combobox-container-header-label"], [1, "bento-list-row", "bui-bento-combobox-container-item", "bento-combobox-container-item", 3, "ngClass", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "bento-list-item bento-combobox-item", 4, "ngIf"], ["class", "bento-list-cell bento-combobox-item-cell", "role", "cell", 3, "ngStyle", 4, "ngFor", "ngForOf"], ["role", "cell", 1, "bento-list-cell", "bento-combobox-item-cell", 3, "ngStyle"], [1, "bento-list-item", "bento-combobox-item"], ["role", "img", 1, "bento-icon-file-viewer", "bento-combobox-container-empty-label"]], template: function BentoComboboxListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoComboboxListComponent_div_0_Template, 3, 2, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "bento-list", 2);
        ɵngcc0.ɵɵlistener("endOfScroll", function BentoComboboxListComponent_Template_bento_list_endOfScroll_2_listener() { return ctx._onEOS(); })("scrollBarChange", function BentoComboboxListComponent_Template_bento_list_scrollBarChange_2_listener($event) { return ctx._onScrollBarVisChange($event); })("heightChange", function BentoComboboxListComponent_Template_bento_list_heightChange_2_listener($event) { return ctx._onListHeightChange($event); });
        ɵngcc0.ɵɵtemplate(3, BentoComboboxListComponent_ng_template_3_Template, 2, 14, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, BentoComboboxListComponent_ng_template_5_Template, 2, 2, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, BentoComboboxListComponent_i_7_Template, 2, 3, "i", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._isGrid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("height", ctx._listHeight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("options", ctx._listOptions)("maxHeight", 300)("itemHeight", ctx._listOptions.comboboxOptions.itemHeight)("autoHeightResize", true);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !ctx._data.length);
    } }, directives: [ɵngcc7.NgIf, BentoListComponent, ɵngcc7.NgForOf, ɵngcc7.NgStyle, ɵngcc7.NgClass, ɵngcc7.NgTemplateOutlet], pipes: [BentoTranslatePipe], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoComboboxListComponent, [{
        type: Component,
        args: [{
                selector: 'bento-combobox-list',
                template: "<div *ngIf=\"_isGrid\" class=\"bui-bento-combobox-container-header bento-combobox-container-header\" role=\"row\">\n  <ng-template [ngIf]=\"_listOptions.comboboxOptions.headerTranslation\">\n    <div\n      *ngFor=\"let column of _listOptions.comboboxOptions.columns; let i = index\"\n      [attr.id]=\"uid + '-header-' + i\"\n      role=\"columnheader\"\n      [ngStyle]=\"{width: column.width}\"\n      class=\"bui-bento-combobox-container-header-label\"\n    >\n      {{ _listOptions.comboboxOptions.headerTranslation[column.name ? column.name : column] }}\n    </div>\n    <div\n      *ngIf=\"_scrollBarWidth\"\n      [style.width.px]=\"_scrollBarWidth\"\n      class=\"bui-bento-combobox-container-header-label bui-bento-combobox-container-header-label-filler\"\n    ></div>\n  </ng-template>\n  <ng-template [ngIf]=\"!_listOptions.comboboxOptions.headerTranslation\">\n    <div\n      *ngFor=\"let column of _listOptions.comboboxOptions.columns; let i = index\"\n      role=\"columnheader\"\n      [attr.id]=\"uid + '-header-' + i\"\n      class=\"bui-bento-combobox-container-header-label\"\n    >\n      {{ column.name ? column.name : column }}\n    </div>\n  </ng-template>\n</div>\n<div class=\"bui-bento-combobox-list-wrapper bento-combobox-list-wrapper\" [style.height]=\"_listHeight\">\n  <bento-list\n    [options]=\"_listOptions\"\n    [maxHeight]=\"300\"\n    [itemHeight]=\"_listOptions.comboboxOptions.itemHeight\"\n    [autoHeightResize]=\"true\"\n    (endOfScroll)=\"_onEOS()\"\n    (scrollBarChange)=\"_onScrollBarVisChange($event)\"\n    (heightChange)=\"_onListHeightChange($event)\"\n  >\n    <ng-template #rowTemplate let-$data=\"data\" let-$o=\"options\" let-$i=\"index\">\n      <div\n        [attr.id]=\"uid + '-' + $i\"\n        [style.height.px]=\"_listOptions.comboboxOptions.itemHeight\"\n        class=\"bento-list-row bui-bento-combobox-container-item bento-combobox-container-item\"\n        (click)=\"$o.onRowClick($event, $data.row, $i)\"\n        [ngClass]=\"($i == $o.selectedIndex? 'selected ' : '') + ($i == $o.highlightedIndex?'highlighted ' : '')\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$i + 1\"\n        [attr.role]=\"_isGrid ? 'row' : 'option'\"\n        [attr.aria-selected]=\"$i == $o.selectedIndex\"\n      >\n        <ng-container\n          *ngTemplateOutlet=\"$o.rowTemplate; context: {options: $o.comboboxOptions, data: $data, index: $i}\"\n        ></ng-container>\n      </div>\n    </ng-template>\n  </bento-list>\n</div>\n\n<ng-template #defaultRowTemplate let-$data=\"data\" let-$options=\"options\" let-$index=\"index\">\n  <ng-template [ngIf]=\"$options.columns\">\n    <div\n      *ngFor=\"let column of $options.columns; let i = index\"\n      class=\"bento-list-cell bento-combobox-item-cell\"\n      role=\"cell\"\n      [attr.aria-describedby]=\"uid + '-header-' + i\"\n      [ngStyle]=\"{width: column.width}\"\n    >\n      {{ $data.row[column.name ? column.name : column] }}\n    </div>\n  </ng-template>\n  <div class=\"bento-list-item bento-combobox-item\" *ngIf=\"!$options.columns\">\n    {{ $options.label ? $data.row[$options.label] : $data.row }}\n  </div>\n</ng-template>\n<i\n  role=\"img\"\n  [attr.aria-label]=\"'BENTO_UI_CBOX_A11Y_NO_RESULTS' | bentoTranslate\"\n  class=\"bento-icon-file-viewer bento-combobox-container-empty-label\"\n  *ngIf=\"!this._data.length\"\n></i>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { options: [{
            type: Input
        }], selectedRow: [{
            type: Input
        }], highlightedRow: [{
            type: Input
        }], rowTemplate: [{
            type: Input
        }], selectedRowChange: [{
            type: Output
        }], endOfScroll: [{
            type: Output
        }], highlightedIDChange: [{
            type: Output
        }], defaultTemplate: [{
            type: ViewChild,
            args: ['defaultRowTemplate', { static: true }]
        }], _list: [{
            type: ViewChild,
            args: [BentoListComponent, { static: true }]
        }] }); })();
    return BentoComboboxListComponent;
}(BentoListSubscribable));
if (false) {
    /**
     * Row template for the list
     * @type {?}
     */
    BentoComboboxListComponent.prototype.rowTemplate;
    /**
     * On row change
     * @type {?}
     */
    BentoComboboxListComponent.prototype.selectedRowChange;
    /**
     * Emits end of scroll event
     * @type {?}
     */
    BentoComboboxListComponent.prototype.endOfScroll;
    /** @type {?} */
    BentoComboboxListComponent.prototype.highlightedIDChange;
    /**
     * Main option object
     * @type {?}
     */
    BentoComboboxListComponent.prototype._listOptions;
    /**
     * ScrollBar width
     * @type {?}
     */
    BentoComboboxListComponent.prototype._scrollBarWidth;
    /**
     * Keep track on what the height of the list is
     * @type {?}
     */
    BentoComboboxListComponent.prototype._listHeight;
    /**
     * Flag to determine if the list has table structure
     * @type {?}
     */
    BentoComboboxListComponent.prototype._isGrid;
    /**
     * The size of data
     * @type {?}
     */
    BentoComboboxListComponent.prototype._dataSize;
    /**
     * Unique ID of this component
     * @type {?}
     */
    BentoComboboxListComponent.prototype.uid;
    /**
     * Default template
     * @type {?}
     * @private
     */
    BentoComboboxListComponent.prototype.defaultTemplate;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxListComponent.prototype._list;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxListComponent.prototype._selectedRow;
    /** @type {?} */
    BentoComboboxListComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxListComponent.prototype.windowRef;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxListComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxListComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/combobox/combobox-search.event.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Combobox Search Event
 */
var  /**
 * Bento Combobox Search Event
 */
BentoComboboxSearchEvent = /** @class */ (function () {
    function BentoComboboxSearchEvent(search, currentIndex) {
        if (currentIndex === void 0) { currentIndex = 0; }
        this.search = search;
        this.currentIndex = currentIndex;
    }
    return BentoComboboxSearchEvent;
}());
if (false) {
    /**
     * The string that is currently been searched
     * @type {?}
     */
    BentoComboboxSearchEvent.prototype.search;
    /**
     * The amount of results has returned so far
     * @type {?}
     */
    BentoComboboxSearchEvent.prototype.currentIndex;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/combobox/combobox-user-journey.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Defines an user journey in a Combobox
 */
var /**
 * Defines an user journey in a Combobox
 */
ComboboxUserJourney = /** @class */ (function () {
    function ComboboxUserJourney() {
        /**
         * If the user has visited the component
         */
        this._visited = false;
        /**
         * When user finished interaction with this component
         */
        this._finished = false;
        /**
         * When user has interacted in this component
         */
        this._edited = false;
        /**
         * When user has made a selection in this component
         */
        this._selected = false;
        /**
         * When user tried search
         */
        this._searched = false;
        /**
         * When user had a keypress
         */
        this._keypressed = false;
    }
    Object.defineProperty(ComboboxUserJourney.prototype, "visited", {
        get: /**
         * @return {?}
         */
        function () {
            return this._visited;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxUserJourney.prototype, "edited", {
        get: /**
         * @return {?}
         */
        function () {
            return this._edited;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxUserJourney.prototype, "finished", {
        get: /**
         * @return {?}
         */
        function () {
            return this._finished;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxUserJourney.prototype, "selected", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxUserJourney.prototype, "searched", {
        get: /**
         * @return {?}
         */
        function () {
            return this._searched;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboboxUserJourney.prototype, "keypressed", {
        get: /**
         * @return {?}
         */
        function () {
            return this._keypressed;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ComboboxUserJourney.prototype.visit = /**
     * @return {?}
     */
    function () {
        this._visited = true;
    };
    /**
     * @return {?}
     */
    ComboboxUserJourney.prototype.edit = /**
     * @return {?}
     */
    function () {
        this._edited = true;
    };
    /**
     * @return {?}
     */
    ComboboxUserJourney.prototype.finish = /**
     * @return {?}
     */
    function () {
        this._finished = true;
    };
    /**
     * @param {?=} v
     * @return {?}
     */
    ComboboxUserJourney.prototype.search = /**
     * @param {?=} v
     * @return {?}
     */
    function (v) {
        if (v === void 0) { v = true; }
        this._searched = v;
        this._edited = true;
    };
    /**
     * @return {?}
     */
    ComboboxUserJourney.prototype.select = /**
     * @return {?}
     */
    function () {
        this._selected = true;
        this._edited = true;
        // Need to start another search session to flip the flag
        this._searched = false;
    };
    /**
     * @return {?}
     */
    ComboboxUserJourney.prototype.keypress = /**
     * @return {?}
     */
    function () {
        this._keypressed = true;
        this._edited = true;
    };
    /**
     * @return {?}
     */
    ComboboxUserJourney.prototype.reset = /**
     * @return {?}
     */
    function () {
        this._edited = false;
        this._finished = false;
        this._visited = false;
        this._selected = false;
        this._searched = false;
        this._keypressed = false;
    };
    return ComboboxUserJourney;
}());
if (false) {
    /**
     * If the user has visited the component
     * @type {?}
     * @private
     */
    ComboboxUserJourney.prototype._visited;
    /**
     * When user finished interaction with this component
     * @type {?}
     * @private
     */
    ComboboxUserJourney.prototype._finished;
    /**
     * When user has interacted in this component
     * @type {?}
     * @private
     */
    ComboboxUserJourney.prototype._edited;
    /**
     * When user has made a selection in this component
     * @type {?}
     * @private
     */
    ComboboxUserJourney.prototype._selected;
    /**
     * When user tried search
     * @type {?}
     * @private
     */
    ComboboxUserJourney.prototype._searched;
    /**
     * When user had a keypress
     * @type {?}
     * @private
     */
    ComboboxUserJourney.prototype._keypressed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/combobox/combobox-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DEFAULT_DEBOUNCE_TIME = 200;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/combobox/combobox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable use-host-property-decorator no-use-before-declare */
/** @type {?} */
var BENTO_COMBOBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoComboboxComponent; })),
    multi: true
};
/** @type {?} */
var BENTO_COMBOBOX_VALUE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoComboboxComponent; })),
    multi: true
};
/** @type {?} */
var comboboxId = 0;
/* tslint:disable no-host-metadata-property */
/**
 * Similar to native browser dropdown comboboxes, this component presents
 * a list of values in a dropdown list. In addition, it supports input filtering,
 * lazy-loading, and searching.
 */
var BentoComboboxComponent = /** @class */ (function (_super) {
    __extends(BentoComboboxComponent, _super);
    /**
     */
    function BentoComboboxComponent(elRef, r, tabService, logService, translate, cd, winRef) {
        var _this = _super.call(this) || this;
        _this.elRef = elRef;
        _this.r = r;
        _this.tabService = tabService;
        _this.logService = logService;
        _this.translate = translate;
        _this.cd = cd;
        /**
         * Element to append the dropdown to when this component is inside of
         * a container where overflow is hidden
         */
        _this.appendTo = null;
        /**
         * Combobox options to customize its behavior
         */
        _this.options = {};
        /**
         * Determine if the list is a drop-up menu
         */
        _this.up = false;
        /**
         * Flag for `readonly` state
         */
        _this._isReadOnly = false;
        /**
         * Callback when a **server search** needs to be performed. A `BentoComboboxSearchEvent` object is passed in as
         * reference. Each search callback **MUST** emit results back even when it is empty, otherwise Combobox component will
         * wait for all search results to return before it renders the final list
         *
         * **Note**: This event is only emitted when `BentoComboboxOptions.useServerSearch` is set to `true`
         */
        _this.search = new EventEmitter();
        /**
         * Callback when data needs to reset.
         *
         * **Note**: This event is only emitted when `BentoComboboxOptions.useServerSearch` is set to `true`
         */
        _this.resetItems = new EventEmitter();
        /**
         * Callback when end of scroll is reached in dropdown list.  This event is **only**
         * fired when there is a scroll. A `BentoComboboxSearchEvent` object is passed in as reference
         */
        _this.endOfScroll = new EventEmitter();
        /**
         * Callback when the open state is changed in Combobox
         */
        _this.openChange = new EventEmitter();
        /**
         * Flag to decide if this form component is required or not
         */
        _this.required = false;
        /**
         * Revert search input when its entry is invalid. It overrides `BentoComboboxFooterItem.clearInputOnAction`
         */
        _this.revertOnInvalidInput = false;
        /**
         * Disabled flag
         */
        _this._isDisabled = false;
        /**
         * Main Data
         */
        _this._data = [];
        /**
         * Data that is used for the dropdown
         */
        _this._listData = [];
        /**
         * Event Emitter for data change
         */
        _this._listDataChange = new ReplaySubject(1);
        /**
         * Reactive FormControl for the main input
         */
        _this._inputLabelControl = new FormControl();
        /**
         * Define if this component is in searching mode
         */
        _this._isSearching = false;
        /**
         * Unique ID of this component
         */
        _this.uid = "bui-combobox-" + comboboxId++;
        /**
         * This variable is used by `isListVisible`
         */
        _this._isListVisible = false;
        /**
         * User journey to keep tap on how user is interaction with the component
         */
        _this.userJourney = new ComboboxUserJourney();
        /**
         * Keep track on how many requests are sent
         */
        _this.serverRequestCount = 0;
        /* istanbul ignore next */
        _this._changeFunction = (/**
         * @param {?} v
         * @return {?}
         */
        function (v) { });
        /* istanbul ignore next */
        _this._touchFunction = (/**
         * @return {?}
         */
        function () { });
        /* istanbul ignore next */
        _this._windowClickSubscription = (/**
         * @return {?}
         */
        function () { });
        _this.document = winRef.nativeDocument;
        // Add classes
        /** @type {?} */
        var el = elRef.nativeElement;
        r.addClass(el, 'bento-select');
        r.addClass(el, 'form-control');
        _this.showSelectorInputLabel = true;
        return _this;
    }
    Object.defineProperty(BentoComboboxComponent.prototype, "isListVisible", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isListVisible;
        },
        /**
         * Flag to container visibility
         */
        set: /**
         * Flag to container visibility
         * @param {?} v
         * @return {?}
         */
        function (v) {
            var _this = this;
            this.listWillBeVisible = v;
            if (v) {
                this._isListVisible = v;
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.r.addClass(_this._listContainer.nativeElement, 'in');
                    _this.r.removeClass(_this._listContainer.nativeElement, 'out');
                }));
            }
            else {
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.r.addClass(_this._listContainer.nativeElement, 'out');
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this.r.removeClass(_this._listContainer.nativeElement, 'in');
                        _this.r.removeClass(_this._listContainer.nativeElement, 'out');
                        _this._isListVisible = false;
                        _this.cd.markForCheck();
                    }), 200);
                }));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoComboboxComponent.prototype, "open", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isListVisible;
        },
        /**
         * Manually open or close Combobox dropdown
         */
        set: /**
         * Manually open or close Combobox dropdown
         * @param {?} isOpen
         * @return {?}
         */
        function (isOpen) {
            if (isOpen !== this._isListVisible) {
                // Only toggle when it really needs a toggle
                this.toggleContainerVisibility();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoComboboxComponent.prototype, "itemsObservable", {
        /**
         * Data observable object for subscribing to data updates.
         * Changing this Observable instance will rest the dropdown list
         */
        set: /**
         * Data observable object for subscribing to data updates.
         * Changing this Observable instance will rest the dropdown list
         * @param {?} observable
         * @return {?}
         */
        function (observable) {
            if (observable) {
                // Forward the observable to the super class to handle the logic
                this._setDataObservable(observable);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoComboboxComponent.prototype, "id", {
        get: /**
         * @return {?}
         */
        function () {
            return this._id;
        },
        /**
         * HTML element id of this component used for A11y
         */
        set: /**
         * HTML element id of this component used for A11y
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.updateElementID(v);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * When ngModel is udpated
     */
    /**
     * When ngModel is udpated
     * @param {?} row
     * @return {?}
     */
    BentoComboboxComponent.prototype.writeValue = /**
     * When ngModel is udpated
     * @param {?} row
     * @return {?}
     */
    function (row) {
        this._selectedRow = row;
        this.inputLabel = this._formatLabel(row);
        this._isSearching = false;
        this._searchValue = undefined;
        this._list.selectedRow = row;
        if (!row) {
            // Reset dropdown list highlights when a selected item is cleared
            this._list.resetHighlight();
        }
        this.cd.markForCheck();
    };
    /**
     * Validator
     */
    /**
     * Validator
     * @param {?} control
     * @return {?}
     */
    BentoComboboxComponent.prototype.validate = /**
     * Validator
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (this.required && !(this._inputLabel && this._inputLabel.length)) {
            return { required: false };
        }
        return null;
    };
    /**
     * When disabled state is updated
     */
    /**
     * When disabled state is updated
     * @param {?} v
     * @return {?}
     */
    BentoComboboxComponent.prototype.setDisabledState = /**
     * When disabled state is updated
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._isDisabled = v;
        this._isSearching = false;
        this._searchValue = undefined;
        if (v) {
            this._inputLabelControl.disable();
        }
        else {
            this._inputLabelControl.enable();
        }
        this.cd.markForCheck();
    };
    /**
     * Referencing ngModel change function
     */
    /**
     * Referencing ngModel change function
     * @param {?} fn
     * @return {?}
     */
    BentoComboboxComponent.prototype.registerOnChange = /**
     * Referencing ngModel change function
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._changeFunction = fn;
    };
    /**
     * Referencing component touch event
     */
    /**
     * Referencing component touch event
     * @param {?} fn
     * @return {?}
     */
    BentoComboboxComponent.prototype.registerOnTouched = /**
     * Referencing component touch event
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this._touchFunction = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.cd.markForCheck();
        });
    };
    /**
     * Override data update from BentoListSubscribable
     */
    /**
     * Override data update from BentoListSubscribable
     * @param {?} data
     * @return {?}
     */
    BentoComboboxComponent.prototype._updateData = /**
     * Override data update from BentoListSubscribable
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.serverRequestCount = Math.max(this.serverRequestCount - 1, 0);
        if (this.serverRequestCount === 0) {
            // There is no more request in the queue, therefore update data and view
            this._data = this._data.concat(data);
        }
    };
    /**
     * Overriding  BentoListSubscribable
     */
    /**
     * Overriding  BentoListSubscribable
     * @param {?} data
     * @return {?}
     */
    BentoComboboxComponent.prototype._onDataReload = /**
     * Overriding  BentoListSubscribable
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this._listDataChange = new ReplaySubject(1);
        this._list.dataObservable = this._listDataChange;
        this._list.resetHighlight();
        this.serverRequestCount++;
    };
    /**
     * Overriding  BentoListSubscribable
     */
    /**
     * Overriding  BentoListSubscribable
     * @param {?} data
     * @return {?}
     */
    BentoComboboxComponent.prototype._onDataUpdate = /**
     * Overriding  BentoListSubscribable
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this._listData = data.slice();
        // Emit data change to the ComboboxList component
        this._listDataChange.next(this._listData);
        if (this.userJourney.searched && this.options.useServerSearch) {
            // Handles highlight and/or selections when in server search mode
            if (this._inputLabel.trim().length > 0) {
                // Highlight the first item in the result set only when user searched for something
                this._list.highlightNext();
            }
            if (this.userJourney.finished) {
                // User has already tabbed/focused out and the data finally comes in
                this.updateChanges();
            }
        }
    };
    /**
     * Init
     */
    /**
     * Init
     * @return {?}
     */
    BentoComboboxComponent.prototype.ngOnInit = /**
     * Init
     * @return {?}
     */
    function () {
        var _this = this;
        // debounce keystroke events
        this._inputLabelControl.valueChanges
            .pipe(debounceTime(this.options.useServerSearch ? this.options.debounceTime || DEFAULT_DEBOUNCE_TIME : 0))
            .subscribe((/**
         * @param {?} newValue
         * @return {?}
         */
        function (newValue) {
            _this._onInputLabelChange(newValue);
        }));
        this.dropdownAriaLabel = this.translate.instantTranslate('BENTO_UI_CBOX_DROPDOWN_ICON_OPEN');
        this.setupA11y();
    };
    /**
     * Destroy -> cleanup
     */
    /**
     * Destroy -> cleanup
     * @return {?}
     */
    BentoComboboxComponent.prototype.ngOnDestroy = /**
     * Destroy -> cleanup
     * @return {?}
     */
    function () {
        this.cd.detach();
        if (this._dataSubscription) {
            this._dataSubscription.unsubscribe();
        }
        if (this._windowClickSubscription) {
            this._windowClickSubscription();
        }
        // List container can be appended to other containers when this
        // component is destroyed and causing memory leak
        /** @type {?} */
        var el = this._listContainer.nativeElement;
        this.r.removeChild(el.parentElement, el);
    };
    /**
     * Callback when highlighted index is changed
     */
    /**
     * Callback when highlighted index is changed
     * @param {?} id
     * @return {?}
     */
    BentoComboboxComponent.prototype._onHighlightedRowChange = /**
     * Callback when highlighted index is changed
     * @param {?} id
     * @return {?}
     */
    function (id) {
        if (id) {
            this.r.setAttribute(this._inputElRef.nativeElement, 'aria-activedescendant', id);
        }
        else {
            this.r.removeAttribute(this._inputElRef.nativeElement, 'aria-activedescendant');
        }
    };
    /**
     * Callback when a row is selected
     */
    /**
     * Callback when a row is selected
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype._onRowSelect = /**
     * Callback when a row is selected
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var row = e.row;
        // In case the row is null with a random string remaining in the input field
        this.inputLabel = this._formatLabel(row);
        if (row === this._selectedRow) {
            // No need to process selected row
            /* istanbul ignore next */
            return;
        }
        // Notify `ngModel`
        this._changeFunction(row);
        // Update the current row private reference
        this._selectedRow = row;
        // Reset the list data back to normal
        this._resetListData();
        if (this.options.useServerSearch) {
            // The result might not be in the list when data is reset in server search mode
            this._list.resetHighlight();
        }
        else {
            // Move highlighted selection to the current selected row
            this._list.highlightSelectedRow();
        }
        if (e.isClickEvent) {
            // Bring focus back to the input field
            ((/** @type {?} */ (this._inputElRef.nativeElement))).focus();
            // Collapse only when clicked since there is a keyboard management to handle the collapse already
            this.toggleContainerVisibility();
        }
        // Update user journey
        this.userJourney.select();
    };
    Object.defineProperty(BentoComboboxComponent.prototype, "inputLabel", {
        get: /**
         * @return {?}
         */
        function () {
            return this._inputLabel;
        },
        /**
         * Input label input
         */
        set: /**
         * Input label input
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._inputLabel = v;
            // Update input label
            this._inputLabelControl.setValue(v);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * When the main input gains focus
     */
    /**
     * When the main input gains focus
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype._onInputFocus = /**
     * When the main input gains focus
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!this.options.searchable || this._isDisabled || this._isReadOnly) {
            // ignore when disabled
            return;
        }
        /** @type {?} */
        var inputEl = (/** @type {?} */ (this._inputElRef.nativeElement));
        setTimeout((/**
         * @return {?}
         */
        function () { return inputEl.setSelectionRange(0, inputEl.value.length); }));
    };
    /**
     * Format label as specified based on the given row object
     */
    /**
     * Format label as specified based on the given row object
     * @param {?} row
     * @return {?}
     */
    BentoComboboxComponent.prototype._formatLabel = /**
     * Format label as specified based on the given row object
     * @param {?} row
     * @return {?}
     */
    function (row) {
        /** @type {?} */
        var label;
        if (!row) {
            return '';
        }
        else if (this.options.labelFormatter) {
            label = this.options.labelFormatter(row);
        }
        else if (typeof row === 'string' || !this.options.columns || !this.options.columns.length) {
            label = row;
        }
        else {
            /** @type {?} */
            var column = this.options.columns[0];
            label = row[column.name];
        }
        return label;
    };
    /**
     * When the input is changed
     */
    /**
     * When the input is changed
     * @param {?} value
     * @return {?}
     */
    BentoComboboxComponent.prototype._onInputLabelChange = /**
     * When the input is changed
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (this._inputLabel === value) {
            return;
        }
        this._inputLabel = value;
        this.searchData(value);
    };
    /**
     * Reset the view data for the list
     */
    /**
     * Reset the view data for the list
     * @return {?}
     */
    BentoComboboxComponent.prototype._resetListData = /**
     * Reset the view data for the list
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // Need to delay emit since we need make sure that all events are properly captured
            // eg. host:click
            if (_this.options.useServerSearch) {
                // Fire server search
                _this.resetItems.emit();
            }
            else {
                _this._listDataChange.next(_this._data);
            }
        }));
        this._isSearching = false;
        this._searchValue = undefined;
    };
    /**
     * Default Search and Compare the current label against the each row
     */
    /**
     * Default Search and Compare the current label against the each row
     * @param {?} row
     * @param {?} value
     * @return {?}
     */
    BentoComboboxComponent.prototype._defaultSearchCompare = /**
     * Default Search and Compare the current label against the each row
     * @param {?} row
     * @param {?} value
     * @return {?}
     */
    function (row, value) {
        /** @type {?} */
        var label;
        value = value.toLowerCase();
        if (typeof row === 'string') {
            // Row is a string
            return ((/** @type {?} */ (row))).toLowerCase().indexOf(value) > -1;
        }
        else if (this.options.columns && this.options.columns.length) {
            // Row has column definitions
            /** @type {?} */
            var columns = this.options.columns;
            /** @type {?} */
            var column = void 0;
            for (var i = 0, len = columns.length; i < len; i++) {
                column = columns[i];
                label = String(row[column.name ? column.name : column]).toLowerCase();
                if (label.indexOf(value) > -1) {
                    return true;
                }
            }
            return false;
        }
        else {
            // Row is an object with missing column definitions
            this.logService.warn('Bento Combobox: Missing definition for `BentoComboboxOptions.columns`');
            return true;
        }
    };
    /**
     * When a footer button is clicked
     */
    /**
     * When a footer button is clicked
     * @param {?} button
     * @return {?}
     */
    BentoComboboxComponent.prototype._onFooterButtonClick = /**
     * When a footer button is clicked
     * @param {?} button
     * @return {?}
     */
    function (button) {
        if (button.collapseOnAction && this._isListVisible) {
            this.toggleContainerVisibility();
        }
        if (button.action) {
            button.action(this._inputLabel);
        }
        if (button.clearInputOnAction) {
            this.inputLabel = '';
        }
    };
    /**
     * When Space or enter is used on the button
     */
    /**
     * When Space or enter is used on the button
     * @param {?} $event
     * @param {?} button
     * @return {?}
     */
    BentoComboboxComponent.prototype._onFooterItemKeydown = /**
     * When Space or enter is used on the button
     * @param {?} $event
     * @param {?} button
     * @return {?}
     */
    function ($event, button) {
        switch ($event.keyCode) {
            case Keyboard.SPACE:
            case Keyboard.ENTER:
                this._onFooterButtonClick(button);
                $event.preventDefault();
                $event.stopPropagation();
                break;
        }
    };
    /**
     * When end of scroll is reached in the Combobox list
     */
    /**
     * When end of scroll is reached in the Combobox list
     * @return {?}
     */
    BentoComboboxComponent.prototype._onEndOfScroll = /**
     * When end of scroll is reached in the Combobox list
     * @return {?}
     */
    function () {
        this.endOfScroll.emit(new BentoComboboxSearchEvent(this._searchValue, this._data.length));
    };
    /**
     * On list keydown
     */
    /**
     * On list keydown
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype._onListKeydown = /**
     * On list keydown
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.keyCode === Keyboard.TAB) {
            /** @type {?} */
            var footerEl = this.footerContainer ? this.footerContainer.nativeElement : undefined;
            /** @type {?} */
            var tabbables = this.tabService.findTabbable(footerEl);
            /** @type {?} */
            var currentEl = e.target;
            /** @type {?} */
            var currentElIndex = tabbables.indexOf(currentEl);
            if (tabbables.length) {
                if (currentElIndex === 0 && e.shiftKey) {
                    // Focus back to the input
                    this.preventEvent(e);
                    // Focus back to the input
                    this._inputElRef.nativeElement.focus();
                }
                else if (currentElIndex === tabbables.length - 1 && !e.shiftKey) {
                    // Since this is treated as a component focusout event
                    // we need to hide the list and commit change
                    this.isListVisible = false;
                    // Give focus back to input field and let the propagated
                    // tab event to handle the rest
                    this._inputElRef.nativeElement.focus();
                }
                else {
                    // Ordinary focus management within the list
                    this.preventEvent(e);
                    if (e.shiftKey) {
                        tabbables[currentElIndex - 1].focus();
                    }
                    else {
                        tabbables[currentElIndex + 1].focus();
                    }
                }
            }
        }
    };
    /**
     * Listener to deal when Dropdown is not visisble and need to check for changes
     * @param e
     */
    /**
     * Listener to deal when Dropdown is not visisble and need to check for changes
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype.onFocusOut = /**
     * Listener to deal when Dropdown is not visisble and need to check for changes
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            if (!_this.listWillBeVisible &&
                !_this.elRef.nativeElement.contains(_this.document.activeElement) &&
                !_this._list.elRef.nativeElement.contains(_this.document.activeElement)) {
                if (_this.userJourney.edited && !_this.userJourney.finished) {
                    _this.updateChanges();
                    _this.userJourney.finish();
                }
                // Fire touch function to notify form that this element is touched
                _this._touchFunction();
            }
        }));
    };
    /**
     * Setup A11y label and aria relationships
     */
    /**
     * Setup A11y label and aria relationships
     * @private
     * @return {?}
     */
    BentoComboboxComponent.prototype.setupA11y = /**
     * Setup A11y label and aria relationships
     * @private
     * @return {?}
     */
    function () {
        // Dropdown arrow label
        this.dropdownAriaLabel = this.translate.instantTranslate('BENTO_UI_CBOX_DROPDOWN_ICON_OPEN');
        // Give list an ID
        /** @type {?} */
        var listID = this.uid + "-box";
        this.r.setAttribute(this._list.elRef.nativeElement, 'id', listID);
        this.r.setAttribute(this.elRef.nativeElement, 'aria-owns', listID);
        this.r.setAttribute(this._inputElRef.nativeElement, 'aria-controls', listID);
        if (!this.id) {
            // Update element ID when `id` is not assigned
            this.updateElementID(this.id);
        }
    };
    /**
     * Update Element ID
     */
    /**
     * Update Element ID
     * @private
     * @param {?} id
     * @return {?}
     */
    BentoComboboxComponent.prototype.updateElementID = /**
     * Update Element ID
     * @private
     * @param {?} id
     * @return {?}
     */
    function (id) {
        var _this = this;
        var _a;
        if (id) {
            // Component has an ID assigned
            /** @type {?} */
            var labelEl = (/** @type {?} */ (this.document.querySelector("[for=\"" + id + "\"]")));
            /** @type {?} */
            var el = this.elRef.nativeElement;
            this._id = id;
            // dev is using explicit label for the combobox, so hide the internal
            // label element
            this.showSelectorInputLabel = false;
            if (labelEl) {
                /** @type {?} */
                var labelElID = labelEl.getAttribute('id');
                // Check if Label Element has an ID
                if (labelElID == null) {
                    // There is no ID assigned to Label
                    // We are going to create one and assign it
                    labelElID = this.uid + "-label";
                    this.r.setAttribute(labelEl, 'id', labelElID);
                }
                this.r.setAttribute((_a = this._list) === null || _a === void 0 ? void 0 : _a.elRef.nativeElement, 'aria-labelledby', labelElID);
            }
            // Remove id attribute from parent
            this.r.removeAttribute(el, 'id');
        }
        else {
            this.showSelectorInputLabel = true;
            // There is no ID assigned
            setTimeout((/**
             * @return {?}
             */
            function () { return _this.setDefaultLabel(); }), 100);
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoComboboxComponent.prototype.setDefaultLabel = /**
     * @private
     * @return {?}
     */
    function () {
        // make searchbox accessible - a11y
        /** @type {?} */
        var labelEl = this.elRef.nativeElement.querySelector('.selector-input-label');
        /** @type {?} */
        var inputID = this.uid + "-input";
        if (labelEl) {
            this.r.setAttribute(labelEl, 'for', inputID);
            this._id = inputID;
            this.cd.markForCheck();
        }
    };
    /**
     * Search and return an array with the matching condition
     */
    /**
     * Search and return an array with the matching condition
     * @private
     * @param {?} value
     * @param {?=} doNotToggle
     * @return {?}
     */
    BentoComboboxComponent.prototype.searchData = /**
     * Search and return an array with the matching condition
     * @private
     * @param {?} value
     * @param {?=} doNotToggle
     * @return {?}
     */
    function (value, doNotToggle) {
        /** @type {?} */
        var minSearchCharacterCount = this.options.minSearchCharacterCount || 1;
        this._isSearching = true;
        this._searchValue = value;
        if (this.options.useServerSearch) {
            // User input has to meet the minimum search character count
            // Otherwise local search kicks in
            if (value.length >= minSearchCharacterCount) {
                // Fire server search
                this.search.emit(new BentoComboboxSearchEvent(value));
            }
            else if (value.length === 0) {
                // Since there is no value to search, we simply reset the data
                this.resetItems.emit();
                // Reset highlight
                this._list.resetHighlight();
            }
            // Remove highlight
            this._list.resetHighlight();
        }
        else {
            // Do local search
            /** @type {?} */
            var result = [];
            /** @type {?} */
            var row = void 0;
            /** @type {?} */
            var data = this._data;
            /** @type {?} */
            var searchCompareFunc = this.options.searchCompare || this._defaultSearchCompare.bind(this);
            for (var i = 0, len = data.length; i < len; i++) {
                row = data[i];
                if (searchCompareFunc(row, value)) {
                    result.push(row);
                }
            }
            // update searched data
            this._listDataChange.next(result);
            if (value && value.length > 0) {
                this._list.highlightedRow = result[0];
            }
            else {
                // Remove all kinds of highlights
                this._list.resetHighlight();
                this._list.selectedRow = null;
            }
        }
        if (!this._isListVisible && !doNotToggle && !this.userJourney.finished) {
            this.toggleContainerVisibility();
        }
        // Update user journey state
        this.userJourney.search();
    };
    /**
     * Toggle the main container visibility
     */
    /**
     * Toggle the main container visibility
     * @private
     * @return {?}
     */
    BentoComboboxComponent.prototype.toggleContainerVisibility = /**
     * Toggle the main container visibility
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        // Toggle flag
        /** @type {?} */
        var visibility = !this._isListVisible;
        this.isListVisible = visibility;
        if (visibility) {
            this.dropdownAriaLabel = this.translate.instantTranslate('BENTO_UI_CBOX_DROPDOWN_ICON_CLOSE');
            // Move container to the current selected row
            this._list.highlightSelectedRow();
            // Add Window click event listeners
            this._windowClickSubscription = this.r.listen('window', 'click', (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                /** @type {?} */
                var el = _this.elRef.nativeElement;
                /** @type {?} */
                var listEl = _this._list.elRef.nativeElement;
                if (el !== e.target &&
                    !el.contains(e.target) &&
                    !listEl.contains(e.target) &&
                    !el.contains(_this.document.activeElement) &&
                    !listEl.contains(_this.document.activeElement)) {
                    _this.onBlur();
                }
            }));
            this._list.checkViewportSize();
        }
        else {
            this.dropdownAriaLabel = this.translate.instantTranslate('BENTO_UI_CBOX_DROPDOWN_ICON_OPEN');
            this._windowClickSubscription();
        }
        // Emit open state change
        this.openChange.emit(visibility);
    };
    /**
     * Do blur tasks
     */
    /**
     * Do blur tasks
     * @private
     * @return {?}
     */
    BentoComboboxComponent.prototype.onBlur = /**
     * Do blur tasks
     * @private
     * @return {?}
     */
    function () {
        if (this.listWillBeVisible) {
            // hide list if needed
            this.toggleContainerVisibility();
        }
        this.updateChanges();
        this.userJourney.finish();
        this._touchFunction();
    };
    /**
     * Update changes to the component
     */
    /**
     * Update changes to the component
     * @private
     * @return {?}
     */
    BentoComboboxComponent.prototype.updateChanges = /**
     * Update changes to the component
     * @private
     * @return {?}
     */
    function () {
        if (!this.userJourney.edited || this.serverRequestCount > 0 || !this.userJourney.searched) {
            // Nothing needs to be updated since the user didn't do anything
            // Or we are still waiting for the latest server response to come in
            return;
        }
        if (this._list.length === 0) {
            if (Array.isArray(this.options.footerItems)) {
                // ComboboxList holds the search results in the combo.
                // Only trigger add on the fly if the search result is empty.
                /** @type {?} */
                var button = void 0;
                /** @type {?} */
                var footerItem = this.options.footerItems;
                for (var i = 0, len = footerItem.length; i < len; i++) {
                    button = footerItem[i];
                    if (button.actionOnValueUpdate) {
                        this._onFooterButtonClick(button);
                    }
                }
                if (this.revertOnInvalidInput) {
                    // Revert label to the previous selected row
                    // This overrides `BentoComboboxFooterItem.clearInputOnAction`
                    this.inputLabel = this._formatLabel(this._selectedRow);
                }
            }
            else if (this.revertOnInvalidInput) {
                // Revert label to the previous selected row
                this.inputLabel = this._formatLabel(this._selectedRow);
            }
            else {
                // reset input field and list
                this.inputLabel = '';
                this._list.resetHighlight();
                this._list.selectedRow = null;
                // Update value to NULL when user input is incorrect
                this._changeFunction(null);
            }
            this.searchData('', true);
        }
        else if (this.options.autoSelect === false) {
            // autoSelect needs to strickly equal to `false`
            // disable autoselect
            if (this.revertOnInvalidInput) {
                // Revert label to the previous selected row
                this.inputLabel = this._formatLabel(this._selectedRow);
            }
            else {
                // Clear label sicne there is no absolute match
                this.inputLabel = '';
                this._list.resetHighlight();
                this._list.selectedRow = null;
                this._selectedRow = null;
                // Update value to NULL when user input is incorrect
                this._changeFunction(null);
            }
        }
        else {
            if (this.userJourney.searched) {
                // Automatically update highlight or selection when this is result
                // ONLY when user performed a search
                this._list.selectHighlightedRow();
            }
        }
    };
    /**
     * Private:On input label keydown
     */
    /**
     * Private:On input label keydown
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype._onKeydown = /**
     * Private:On input label keydown
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this._isDisabled || this._isReadOnly) {
            // Ignore everything when this component is disabled
            /* istanbul ignore next */
            return;
        }
        /* tslint:disable deprecation */
        switch (e.keyCode) {
            case Keyboard.DOWN:
                if (!this._isListVisible || e.altKey) {
                    this.toggleContainerVisibility();
                }
                else {
                    this._list.highlightNext();
                }
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.UP:
                if (!this._isListVisible || e.altKey) {
                    this.toggleContainerVisibility();
                }
                else {
                    this._list.highlightPrevious();
                }
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.ENTER:
                if (this._isListVisible && this.userJourney.searched) {
                    if (this._list.length === 0 && this.revertOnInvalidInput) {
                        this.inputLabel = this._formatLabel(this._selectedRow);
                    }
                    else {
                        this._list.selectHighlightedRow();
                    }
                    this._resetListData();
                }
                this.toggleContainerVisibility();
                this.preventEvent(e);
                break;
            case Keyboard.PAGE_DOWN:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.pageDown();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.PAGE_UP:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.pageUp();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.END:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.end();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.HOME:
                if (!this._isListVisible) {
                    this.toggleContainerVisibility();
                }
                this._list.home();
                this.preventEvent(e);
                this.userJourney.search();
                break;
            case Keyboard.SPACE:
                if (!this.options.searchable) {
                    this.preventEvent(e);
                }
                break;
            case Keyboard.ESC:
                /** @type {?} */
                var label = this._selectedRow ? this._formatLabel(this._selectedRow) : '';
                if (label !== this._inputLabel) {
                    // Revert the current selection and reset data list
                    this.inputLabel = label;
                    this._resetListData();
                }
                if (this._isListVisible) {
                    // Hide the current dropdown
                    this.toggleContainerVisibility();
                }
                this.userJourney.search(false);
                this.preventEvent(e);
                break;
            case Keyboard.TAB:
                this.processTab(e);
                break;
        }
        this.userJourney.keypress();
    };
    /**
     * Process tab and blur event based on the Element setup
     */
    /**
     * Process tab and blur event based on the Element setup
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype.processTab = /**
     * Process tab and blur event based on the Element setup
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var footerEl = this.footerContainer ? this.footerContainer.nativeElement : undefined;
        if (!footerEl || !this._isListVisible || e.shiftKey) {
            // No need to worry about the buttons in footer when tabbing
            // or the combobox list is not visible
            this.onBlur();
        }
        else {
            /** @type {?} */
            var tabbables = this.tabService.findTabbable(footerEl);
            /** @type {?} */
            var currentElIndex = tabbables.indexOf(e.target);
            if (tabbables.length && currentElIndex === -1 && !e.shiftKey) {
                // Pass focus into the list
                // then let _onListKeydown() to handle the rest
                e.preventDefault();
                tabbables[0].focus();
            }
        }
    };
    /**
     * When host is clicked
     */
    /**
     * When host is clicked
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype._onClick = /**
     * When host is clicked
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this._isDisabled || this._isReadOnly) {
            // ignore when disabled
            /* istanbul ignore next */
            return;
        }
        /** @type {?} */
        var target = e.target;
        /** @type {?} */
        var listComtainerEl = this._listContainer.nativeElement;
        if (target !== listComtainerEl &&
            !listComtainerEl.contains(target) &&
            (target.tagName !== 'INPUT' || !this.options.ignoreInputClick)) {
            this.toggleContainerVisibility();
            this._inputElRef.nativeElement.focus();
            if (!this._isListVisible) {
                // Fire when user closed the dropdown, we need to update changes if there is any
                this.updateChanges();
            }
        }
    };
    /**
     * When host or any of its children is focused
     */
    /**
     * When host or any of its children is focused
     * @param {?} relatedTarget
     * @return {?}
     */
    BentoComboboxComponent.prototype._onFocusin = /**
     * When host or any of its children is focused
     * @param {?} relatedTarget
     * @return {?}
     */
    function (relatedTarget) {
        if (!this.elRef.nativeElement.contains(relatedTarget)) {
            this.userJourney.reset();
            this.userJourney.visit();
        }
    };
    /**
     * Prevent the current event from bubbling up
     */
    /**
     * Prevent the current event from bubbling up
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoComboboxComponent.prototype.preventEvent = /**
     * Prevent the current event from bubbling up
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    /** @nocollapse */
    BentoComboboxComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: BentoTabService },
        { type: BentoLogService },
        { type: BentoTranslate },
        { type: ChangeDetectorRef },
        { type: WindowRef }
    ]; };
    BentoComboboxComponent.propDecorators = {
        isListVisible: [{ type: HostBinding, args: ['class.open',] }, { type: HostBinding, args: ['attr.aria-expanded',] }],
        appendTo: [{ type: Input }],
        options: [{ type: Input }],
        up: [{ type: Input }, { type: HostBinding, args: ['class.dropup',] }],
        _isReadOnly: [{ type: HostBinding, args: ['class.readonly',] }, { type: Input, args: ['readonly',] }],
        search: [{ type: Output }],
        resetItems: [{ type: Output }],
        endOfScroll: [{ type: Output }],
        open: [{ type: Input }],
        openChange: [{ type: Output }],
        itemsObservable: [{ type: Input }],
        placeholder: [{ type: Input }],
        required: [{ type: Input }],
        revertOnInvalidInput: [{ type: Input }],
        rowTemplate: [{ type: Input }],
        id: [{ type: Input }],
        _inputElRef: [{ type: ViewChild, args: ['input', { static: true },] }],
        _list: [{ type: ViewChild, args: [BentoComboboxListComponent, { static: true },] }],
        _isDisabled: [{ type: HostBinding, args: ['class.disabled',] }],
        _listContainer: [{ type: ViewChild, args: ['listContainer', { static: true },] }],
        footerContainer: [{ type: ViewChild, args: ['footerContainer', { static: true },] }],
        onFocusOut: [{ type: HostListener, args: ['focusout', ['$event'],] }],
        _onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
        _onClick: [{ type: HostListener, args: ['click', ['$event'],] }],
        _onFocusin: [{ type: HostListener, args: ['focusin', ['$event.relatedTarget'],] }]
    };
BentoComboboxComponent.ɵfac = function BentoComboboxComponent_Factory(t) { return new (t || BentoComboboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoTabService), ɵngcc0.ɵɵdirectiveInject(BentoLogService), ɵngcc0.ɵɵdirectiveInject(BentoTranslate), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoComboboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoComboboxComponent, selectors: [["bento-combobox"]], viewQuery: function BentoComboboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c14, true);
        ɵngcc0.ɵɵstaticViewQuery(BentoComboboxListComponent, true);
        ɵngcc0.ɵɵstaticViewQuery(_c15, true);
        ɵngcc0.ɵɵstaticViewQuery(_c16, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputElRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._list = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._listContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerContainer = _t.first);
    } }, hostVars: 10, hostBindings: function BentoComboboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusout", function BentoComboboxComponent_focusout_HostBindingHandler($event) { return ctx.onFocusOut($event); })("keydown", function BentoComboboxComponent_keydown_HostBindingHandler($event) { return ctx._onKeydown($event); })("click", function BentoComboboxComponent_click_HostBindingHandler($event) { return ctx._onClick($event); })("focusin", function BentoComboboxComponent_focusin_HostBindingHandler($event) { return ctx._onFocusin($event.relatedTarget); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-haspopup", ctx._list._isGrid ? "grid" : "listbox")("aria-expanded", ctx.isListVisible);
        ɵngcc0.ɵɵclassProp("open", ctx.isListVisible)("disabled", ctx._isDisabled)("dropup", ctx.up)("readonly", ctx._isReadOnly);
    } }, inputs: { open: "open", itemsObservable: "itemsObservable", id: "id", appendTo: "appendTo", options: "options", up: "up", _isReadOnly: ["readonly", "_isReadOnly"], placeholder: "placeholder", required: "required", revertOnInvalidInput: "revertOnInvalidInput", rowTemplate: "rowTemplate" }, outputs: { search: "search", resetItems: "resetItems", endOfScroll: "endOfScroll", openChange: "openChange" }, features: [ɵngcc0.ɵɵProvidersFeature([BENTO_COMBOBOX_VALUE_ACCESSOR, BENTO_COMBOBOX_VALUE_VALIDATOR, BentoStringReplacePipe]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 23, consts: [["class", "selector-input-label d-none", 4, "ngIf"], ["role", "combobox"], ["type", "text", "spellcheck", "false", "autocomplete", "off", 1, "form-control", "bui-menu-item", 3, "placeholder", "formControl", "readonly", "focus"], ["input", ""], ["class", "btn btn-icon", 3, "ngClass", 4, "ngIf"], [1, "sr-only"], [1, "bui-bento-combobox-container", "bento-combobox-container", 3, "bentoAppendTo", "side", "referenceTo", "open", "reszieWidthToReference", "openChange", "keydown"], ["listContainer", ""], [3, "options", "rowTemplate", "highlightedIDChange", "selectedRowChange", "endOfScroll"], ["comboboxList", ""], ["class", "bui-bento-combobox-container-footer bento-combobox-container-footer", 4, "ngIf"], [1, "selector-input-label", "d-none"], [1, "btn", "btn-icon", 3, "ngClass"], ["cdkMonitorElementFocus", "", "role", "button", 1, "bento-combobox-dropdown-button-icon"], [1, "bui-bento-combobox-container-footer", "bento-combobox-container-footer"], ["footerContainer", ""], [1, "bui-bento-combobox-footer-inner", "bento-combobox-footer-inner"], [1, "bui-bento-combobox-footer-row", "bento-combobox-footer-row"], ["class", "bui-bento-combobox-footer-item bento-combobox-footer-item", 4, "ngFor", "ngForOf"], [1, "bui-bento-combobox-footer-item", "bento-combobox-footer-item"], [1, "bui-bento-combobox-footer-item-inner", "bento-combobox-footer-item-inner"], ["type", "button", "container", "body", 1, "btn", "btn-link", 3, "disabled", "ngbTooltip", "click", "keydown"], ["aria-hidden", "true", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], ["aria-hidden", "true", 3, "ngClass"]], template: function BentoComboboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoComboboxComponent_label_0_Template, 3, 3, "label", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("focus", function BentoComboboxComponent_Template_input_focus_2_listener($event) { return ctx._onInputFocus($event); });
        ɵngcc0.ɵɵpipe(4, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, BentoComboboxComponent_div_5_Template, 2, 8, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6, 7);
        ɵngcc0.ɵɵlistener("openChange", function BentoComboboxComponent_Template_div_openChange_8_listener($event) { return ctx.isListVisible = $event; })("keydown", function BentoComboboxComponent_Template_div_keydown_8_listener($event) { return ctx._onListKeydown($event); });
        ɵngcc0.ɵɵelementStart(10, "bento-combobox-list", 8, 9);
        ɵngcc0.ɵɵlistener("highlightedIDChange", function BentoComboboxComponent_Template_bento_combobox_list_highlightedIDChange_10_listener($event) { return ctx._onHighlightedRowChange($event); })("selectedRowChange", function BentoComboboxComponent_Template_bento_combobox_list_selectedRowChange_10_listener($event) { return ctx._onRowSelect($event); })("endOfScroll", function BentoComboboxComponent_Template_bento_combobox_list_endOfScroll_10_listener() { return ctx._onEndOfScroll(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, BentoComboboxComponent_div_12_Template, 5, 1, "div", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSelectorInputLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isListVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("readonly", ctx._isReadOnly);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder === false ? "" : ɵngcc0.ɵɵpipeBind2(4, 20, "BENTO_UI_CBOX_INPUT_LABEL", ctx.placeholder))("formControl", ctx._inputLabelControl)("readonly", ctx._isReadOnly || !ctx.options.searchable);
        ɵngcc0.ɵɵattribute("id", ctx.id)("aria-describedby", ctx.uid + "-dropdown-aria");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx._isReadOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", ctx.uid + "-dropdown-aria");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.dropdownAriaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("bentoAppendTo", ctx.appendTo)("side", ctx.up ? "top" : "bottom")("referenceTo", _r1)("open", ctx.isListVisible)("reszieWidthToReference", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("options", ctx.options)("rowTemplate", ctx.rowTemplate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.options.footerItems && ctx.options.footerItems.length > 0);
    } }, directives: function () { return [ɵngcc7.NgIf, ɵngcc8.DefaultValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.FormControlDirective, BentoAppendToDirective,
        BentoComboboxListComponent, ɵngcc7.NgClass, ɵngcc1.CdkMonitorFocus, ɵngcc7.NgForOf, BentoFocusMonitorDirective, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective]; }, pipes: function () { return [BentoTranslatePipe,
        BentoStringReplacePipe]; }, styles: ["bento-combobox.bento-select{box-sizing:border-box;position:relative;overflow:hidden;cursor:auto;width:100%;border-width:0;z-index:auto;display:inline-block}bento-combobox.bento-select:not(.readonly) .form-control[readonly]:not(:disabled){font-weight:400}bento-combobox.bento-select input.ng-hide-add{display:none}bento-combobox.bento-select.open{overflow:visible}bento-combobox.bento-select.open input{border-bottom-left-radius:0;border-bottom-right-radius:0}bento-combobox.bento-select>.btn{pointer-events:auto;cursor:default;display:flex;align-items:center;justify-content:center}bento-combobox.bento-select>div.input-label.disabled{cursor:not-allowed;pointer-events:none}bento-combobox.bento-select>.btn.disabled{cursor:not-allowed;pointer-events:none;background:0 0}bento-combobox.bento-select input[disabled]:not(.readonly){font-weight:400;cursor:not-allowed;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-combobox.bento-select>.preloader{position:absolute;width:40px;top:0;bottom:0;right:30px;pointer-events:none}bento-combobox.bento-select>.preloader .bento-busyloader-blocker{background:0 0;z-index:auto}bento-combobox.bento-select.input-sm .bento-combobox-container{top:28px}bento-combobox.bento-select.input-sm>.btn [class*=bento-icon]{font-size:.857rem}bento-combobox.bento-select>i{position:absolute;top:9px;right:59px}bento-combobox.bento-select i.preloader{width:24px;height:24px;background-size:24px 24px;display:none}bento-combobox.bento-select div.input-label,bento-combobox.bento-select div.placeholder{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;cursor:default}bento-combobox.bento-select div.placeholder{position:absolute;left:0;top:0}bento-combobox.bento-select div.input-label,bento-combobox.bento-select div.placeholder,bento-combobox.bento-select input[type=text]{box-sizing:border-box;width:100%;font-size:1rem}bento-combobox.bento-select div.input-label:focus,bento-combobox.bento-select div.placeholder:focus,bento-combobox.bento-select input[type=text]:focus{outline:0}bento-combobox.bento-select .btn:hover{box-shadow:none}bento-combobox.bento-select .btn .bento-combobox-dropdown-button-icon{font-size:1rem;top:0}body.touch,body.touch .bento-combobox-container-body{-webkit-overflow-scrolling:touch}.bui-bento-combobox-container{display:block;position:absolute;margin-top:-1px;min-width:100%;min-height:0;z-index:10;border-width:1px;border-style:solid;width:auto;overflow:hidden;visibility:hidden;opacity:0;transition:border .3s,opacity .2s}.bui-bento-combobox-container.bento-append-to,.open .bui-bento-combobox-container{visibility:visible;opacity:1}.bui-bento-combobox-container.out{opacity:0;transition:opacity .2s}.dropup .bui-bento-combobox-container,.up .bui-bento-combobox-container{top:auto;margin:0 0 -1px}.bui-bento-combobox-container bento-list{margin-bottom:-1px;border:none;position:absolute;width:100%}.bui-bento-combobox-container ol,.bui-bento-combobox-container ul{margin:0;padding:0}.bui-bento-combobox-container.dropdown-menu-up{margin:0 0 -1px}.bui-bento-combobox-container.bento-append-to{margin:0}.bui-bento-combobox-list-wrapper{display:table-row}.bui-bento-combobox-container-header{font-weight:700;padding-right:0;text-transform:capitalize;list-style:none;white-space:nowrap;display:table-header-group;width:100%}[dir=rtl] .bui-bento-combobox-container-header{padding-left:0;padding-right:auto}.bui-bento-combobox-container-header-label{padding:5px 10px;white-space:nowrap;display:table-cell;border-bottom-width:1px;border-bottom-style:solid}.bui-bento-combobox-container-header-label-filler{padding:0}.bui-bento-combobox-container-footer{display:block;width:100%;height:35px;border-top-style:solid;border-top-width:1px;position:relative;line-height:normal;font-size:.879rem}.bui-bento-combobox-footer-inner{display:table;width:100%;height:35px}.bui-bento-combobox-footer-row{display:table-row}.bui-bento-combobox-footer-item{display:table-cell;position:relative;vertical-align:middle;text-align:center}.bui-bento-combobox-footer-item .btn{padding:0 .25rem;letter-spacing:0;cursor:pointer}.bui-bento-combobox-footer-item .btn:disabled{pointer-events:none}.bui-bento-combobox-footer-item .btn:disabled:hover span{text-decoration:none}.bui-bento-combobox-footer-item .btn i:first-child,.bui-bento-combobox-footer-item .btn i:last-child{margin:0!important;top:0;vertical-align:baseline}.bui-bento-combobox-footer-item .btn:hover{text-decoration:none}.bui-bento-combobox-footer-item .btn:hover span{text-decoration:underline}.bui-bento-combobox-footer-item:last-child{text-align:right}.bui-bento-combobox-footer-item:first-child,[dir=rtl] .bui-bento-combobox-footer-item:last-child{text-align:left}[dir=rtl] .bui-bento-combobox-footer-item:first-child{text-align:right}.bui-bento-combobox-footer-item-inner{width:100%;vertical-align:middle;white-space:nowrap;padding:0 14px;text-overflow:ellipsis;overflow:visible}bento-combobox-list .bento-combobox-container-empty-label{opacity:.1;position:absolute;top:50%;left:50%;font-size:7.143rem;width:100px;height:100px;transform:translate(-50%,-60px);z-index:-1}.bui-bento-combobox-container-list{display:table;table-layout:fixed;position:relative;width:calc(100% + 1px)}.bui-bento-combobox-container-list .bento-list-viewport .cdk-virtual-scroll-content-wrapper{display:table;table-layout:fixed;width:100%}.bui-bento-combobox-container-item.bento-list-row{display:table-row;cursor:pointer}.bui-bento-combobox-container-item.bento-list-row>div,.bui-bento-combobox-container-item.bento-list-row>span{display:table-cell;padding:6px 10px;line-height:17px;white-space:nowrap;text-overflow:ellipsis;border-bottom-width:1px;border-bottom-style:solid;overflow:hidden;box-sizing:border-box}.bui-bento-combobox-container-item.bento-list-row>div [class*=\" bento-icon-\"],.bui-bento-combobox-container-item.bento-list-row>div [class^=bento-icon-],.bui-bento-combobox-container-item.bento-list-row>span [class*=\" bento-icon-\"],.bui-bento-combobox-container-item.bento-list-row>span [class^=bento-icon-]{line-height:inherit}.bui-bento-combobox-container-item.bento-list-row>div:last-child,.bui-bento-combobox-container-item.bento-list-row>span:last-child{padding-right:23px}[dir=rtl] .bui-bento-combobox-container-item.bento-list-row>div:last-child,[dir=rtl] .bui-bento-combobox-container-item.bento-list-row>span:last-child{padding-right:10px;padding-left:23px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoComboboxComponent, [{
        type: Component,
        args: [{
                selector: 'bento-combobox',
                template: "<label *ngIf=\"showSelectorInputLabel\" class=\"selector-input-label d-none\">\n  {{ 'BENTO_UI_CBOX_INPUT_LABEL' | bentoTranslate }}\n</label>\n<div role=\"combobox\" [attr.aria-expanded]=\"isListVisible\">\n  <input\n    #input\n    type=\"text\"\n    class=\"form-control bui-menu-item\"\n    spellcheck=\"false\"\n    autocomplete=\"off\"\n    [attr.id]=\"id\"\n    [placeholder]=\"placeholder === false ? '' : ('BENTO_UI_CBOX_INPUT_LABEL' | bentoTranslate: placeholder)\"\n    [formControl]=\"_inputLabelControl\"\n    [class.readonly]=\"_isReadOnly\"\n    [readonly]=\"_isReadOnly || !options.searchable\"\n    [attr.aria-describedby]=\"uid + '-dropdown-aria'\"\n    (focus)=\"_onInputFocus($event)\"\n  />\n</div>\n<div class=\"btn btn-icon\" [ngClass]=\"_isDisabled ? 'disabled ' : ''\" *ngIf=\"!_isReadOnly\">\n  <i\n    cdkMonitorElementFocus\n    [attr.aria-describedby]=\"uid + '-dropdown-aria'\"\n    [attr.tabindex]=\"_isDisabled ? '-1' : '0'\"\n    [attr.aria-hidden]=\"_isDisabled\"\n    class=\"bento-combobox-dropdown-button-icon\"\n    [class.bento-icon-caret-up-filled]=\"(isListVisible && !up) || (!isListVisible && up)\"\n    [class.bento-icon-caret-down-filled]=\"(!isListVisible && !up) || (isListVisible && up)\"\n    role=\"button\"\n  ></i>\n</div>\n<span class=\"sr-only\" [attr.id]=\"uid + '-dropdown-aria'\">{{ dropdownAriaLabel }}</span>\n<div\n  #listContainer\n  class=\"bui-bento-combobox-container bento-combobox-container\"\n  [bentoAppendTo]=\"appendTo\"\n  [side]=\"up ? 'top' : 'bottom'\"\n  [referenceTo]=\"input\"\n  [(open)]=\"isListVisible\"\n  [reszieWidthToReference]=\"true\"\n  (keydown)=\"_onListKeydown($event)\"\n>\n  <bento-combobox-list\n    #comboboxList\n    (highlightedIDChange)=\"_onHighlightedRowChange($event)\"\n    (selectedRowChange)=\"_onRowSelect($event)\"\n    [options]=\"options\"\n    [rowTemplate]=\"rowTemplate\"\n    (endOfScroll)=\"_onEndOfScroll()\"\n  ></bento-combobox-list>\n  <div\n    *ngIf=\"options.footerItems && options.footerItems.length > 0\"\n    #footerContainer\n    class=\"bui-bento-combobox-container-footer bento-combobox-container-footer\"\n  >\n    <div class=\"bui-bento-combobox-footer-inner bento-combobox-footer-inner\">\n      <div class=\"bui-bento-combobox-footer-row bento-combobox-footer-row\">\n        <div\n          *ngFor=\"let button of options.footerItems\"\n          class=\"bui-bento-combobox-footer-item bento-combobox-footer-item\"\n        >\n          <div class=\"bui-bento-combobox-footer-item-inner bento-combobox-footer-item-inner\">\n            <button\n              class=\"btn btn-link\"\n              type=\"button\"\n              [attr.tabindex]=\"isListVisible ? '0' : '-1'\"\n              [attr.aria-label]=\"button.ariaLabel\"\n              [disabled]=\"button.disableWhenHasResult && _list.length > 0\"\n              (click)=\"_onFooterButtonClick(button)\"\n              (keydown)=\"_onFooterItemKeydown($event, button)\"\n              ngbTooltip=\"{{ 'BENTO_UI_CBOX_OPTIONS' | bentoTranslate }}\"\n              container=\"body\"\n            >\n              <i *ngIf=\"button.icon\" [ngClass]=\"button.icon\" aria-hidden=\"true\"></i>\n              <span *ngIf=\"button.label?.length > 0\">\n                {{ button.label | bentoStringReplace: '_ITEM_':_inputLabel || button.defaultItemText }}\n              </span>\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                providers: [BENTO_COMBOBOX_VALUE_ACCESSOR, BENTO_COMBOBOX_VALUE_VALIDATOR, BentoStringReplacePipe],
                encapsulation: ViewEncapsulation.None,
                host: {
                    '[attr.aria-haspopup]': "_list._isGrid? 'grid' : 'listbox'"
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-combobox.bento-select{box-sizing:border-box;position:relative;overflow:hidden;cursor:auto;width:100%;border-width:0;z-index:auto;display:inline-block}bento-combobox.bento-select:not(.readonly) .form-control[readonly]:not(:disabled){font-weight:400}bento-combobox.bento-select input.ng-hide-add{display:none}bento-combobox.bento-select.open{overflow:visible}bento-combobox.bento-select.open input{border-bottom-left-radius:0;border-bottom-right-radius:0}bento-combobox.bento-select>.btn{pointer-events:auto;cursor:default;display:flex;align-items:center;justify-content:center}bento-combobox.bento-select>div.input-label.disabled{cursor:not-allowed;pointer-events:none}bento-combobox.bento-select>.btn.disabled{cursor:not-allowed;pointer-events:none;background:0 0}bento-combobox.bento-select input[disabled]:not(.readonly){font-weight:400;cursor:not-allowed;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-combobox.bento-select>.preloader{position:absolute;width:40px;top:0;bottom:0;right:30px;pointer-events:none}bento-combobox.bento-select>.preloader .bento-busyloader-blocker{background:0 0;z-index:auto}bento-combobox.bento-select.input-sm .bento-combobox-container{top:28px}bento-combobox.bento-select.input-sm>.btn [class*=bento-icon]{font-size:.857rem}bento-combobox.bento-select>i{position:absolute;top:9px;right:59px}bento-combobox.bento-select i.preloader{width:24px;height:24px;background-size:24px 24px;display:none}bento-combobox.bento-select div.input-label,bento-combobox.bento-select div.placeholder{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;cursor:default}bento-combobox.bento-select div.placeholder{position:absolute;left:0;top:0}bento-combobox.bento-select div.input-label,bento-combobox.bento-select div.placeholder,bento-combobox.bento-select input[type=text]{box-sizing:border-box;width:100%;font-size:1rem}bento-combobox.bento-select div.input-label:focus,bento-combobox.bento-select div.placeholder:focus,bento-combobox.bento-select input[type=text]:focus{outline:0}bento-combobox.bento-select .btn:hover{box-shadow:none}bento-combobox.bento-select .btn .bento-combobox-dropdown-button-icon{font-size:1rem;top:0}body.touch,body.touch .bento-combobox-container-body{-webkit-overflow-scrolling:touch}.bui-bento-combobox-container{display:block;position:absolute;margin-top:-1px;min-width:100%;min-height:0;z-index:10;border-width:1px;border-style:solid;width:auto;overflow:hidden;visibility:hidden;opacity:0;transition:border .3s,opacity .2s}.bui-bento-combobox-container.bento-append-to,.open .bui-bento-combobox-container{visibility:visible;opacity:1}.bui-bento-combobox-container.out{opacity:0;transition:opacity .2s}.dropup .bui-bento-combobox-container,.up .bui-bento-combobox-container{top:auto;margin:0 0 -1px}.bui-bento-combobox-container bento-list{margin-bottom:-1px;border:none;position:absolute;width:100%}.bui-bento-combobox-container ol,.bui-bento-combobox-container ul{margin:0;padding:0}.bui-bento-combobox-container.dropdown-menu-up{margin:0 0 -1px}.bui-bento-combobox-container.bento-append-to{margin:0}.bui-bento-combobox-list-wrapper{display:table-row}.bui-bento-combobox-container-header{font-weight:700;padding-right:0;text-transform:capitalize;list-style:none;white-space:nowrap;display:table-header-group;width:100%}[dir=rtl] .bui-bento-combobox-container-header{padding-left:0;padding-right:auto}.bui-bento-combobox-container-header-label{padding:5px 10px;white-space:nowrap;display:table-cell;border-bottom-width:1px;border-bottom-style:solid}.bui-bento-combobox-container-header-label-filler{padding:0}.bui-bento-combobox-container-footer{display:block;width:100%;height:35px;border-top-style:solid;border-top-width:1px;position:relative;line-height:normal;font-size:.879rem}.bui-bento-combobox-footer-inner{display:table;width:100%;height:35px}.bui-bento-combobox-footer-row{display:table-row}.bui-bento-combobox-footer-item{display:table-cell;position:relative;vertical-align:middle;text-align:center}.bui-bento-combobox-footer-item .btn{padding:0 .25rem;letter-spacing:0;cursor:pointer}.bui-bento-combobox-footer-item .btn:disabled{pointer-events:none}.bui-bento-combobox-footer-item .btn:disabled:hover span{text-decoration:none}.bui-bento-combobox-footer-item .btn i:first-child,.bui-bento-combobox-footer-item .btn i:last-child{margin:0!important;top:0;vertical-align:baseline}.bui-bento-combobox-footer-item .btn:hover{text-decoration:none}.bui-bento-combobox-footer-item .btn:hover span{text-decoration:underline}.bui-bento-combobox-footer-item:last-child{text-align:right}.bui-bento-combobox-footer-item:first-child,[dir=rtl] .bui-bento-combobox-footer-item:last-child{text-align:left}[dir=rtl] .bui-bento-combobox-footer-item:first-child{text-align:right}.bui-bento-combobox-footer-item-inner{width:100%;vertical-align:middle;white-space:nowrap;padding:0 14px;text-overflow:ellipsis;overflow:visible}bento-combobox-list .bento-combobox-container-empty-label{opacity:.1;position:absolute;top:50%;left:50%;font-size:7.143rem;width:100px;height:100px;transform:translate(-50%,-60px);z-index:-1}.bui-bento-combobox-container-list{display:table;table-layout:fixed;position:relative;width:calc(100% + 1px)}.bui-bento-combobox-container-list .bento-list-viewport .cdk-virtual-scroll-content-wrapper{display:table;table-layout:fixed;width:100%}.bui-bento-combobox-container-item.bento-list-row{display:table-row;cursor:pointer}.bui-bento-combobox-container-item.bento-list-row>div,.bui-bento-combobox-container-item.bento-list-row>span{display:table-cell;padding:6px 10px;line-height:17px;white-space:nowrap;text-overflow:ellipsis;border-bottom-width:1px;border-bottom-style:solid;overflow:hidden;box-sizing:border-box}.bui-bento-combobox-container-item.bento-list-row>div [class*=\" bento-icon-\"],.bui-bento-combobox-container-item.bento-list-row>div [class^=bento-icon-],.bui-bento-combobox-container-item.bento-list-row>span [class*=\" bento-icon-\"],.bui-bento-combobox-container-item.bento-list-row>span [class^=bento-icon-]{line-height:inherit}.bui-bento-combobox-container-item.bento-list-row>div:last-child,.bui-bento-combobox-container-item.bento-list-row>span:last-child{padding-right:23px}[dir=rtl] .bui-bento-combobox-container-item.bento-list-row>div:last-child,[dir=rtl] .bui-bento-combobox-container-item.bento-list-row>span:last-child{padding-right:10px;padding-left:23px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: BentoTabService }, { type: BentoLogService }, { type: BentoTranslate }, { type: ɵngcc0.ChangeDetectorRef }, { type: WindowRef }]; }, { isListVisible: [{
            type: HostBinding,
            args: ['class.open']
        }, {
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], open: [{
            type: Input
        }], itemsObservable: [{
            type: Input
        }], id: [{
            type: Input
        }], _isDisabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }], onFocusOut: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], _onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], _onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], _onFocusin: [{
            type: HostListener,
            args: ['focusin', ['$event.relatedTarget']]
        }], appendTo: [{
            type: Input
        }], options: [{
            type: Input
        }], up: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.dropup']
        }], _isReadOnly: [{
            type: HostBinding,
            args: ['class.readonly']
        }, {
            type: Input,
            args: ['readonly']
        }], search: [{
            type: Output
        }], resetItems: [{
            type: Output
        }], endOfScroll: [{
            type: Output
        }], openChange: [{
            type: Output
        }], placeholder: [{
            type: Input
        }], required: [{
            type: Input
        }], revertOnInvalidInput: [{
            type: Input
        }], rowTemplate: [{
            type: Input
        }], _inputElRef: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], _list: [{
            type: ViewChild,
            args: [BentoComboboxListComponent, { static: true }]
        }], _listContainer: [{
            type: ViewChild,
            args: ['listContainer', { static: true }]
        }], footerContainer: [{
            type: ViewChild,
            args: ['footerContainer', { static: true }]
        }] }); })();
    return BentoComboboxComponent;
}(BentoListSubscribable));
if (false) {
    /**
     * Element to append the dropdown to when this component is inside of
     * a container where overflow is hidden
     * @type {?}
     */
    BentoComboboxComponent.prototype.appendTo;
    /**
     * Combobox options to customize its behavior
     * @type {?}
     */
    BentoComboboxComponent.prototype.options;
    /**
     * Determine if the list is a drop-up menu
     * @type {?}
     */
    BentoComboboxComponent.prototype.up;
    /**
     * Flag for `readonly` state
     * @type {?}
     */
    BentoComboboxComponent.prototype._isReadOnly;
    /**
     * Callback when a **server search** needs to be performed. A `BentoComboboxSearchEvent` object is passed in as
     * reference. Each search callback **MUST** emit results back even when it is empty, otherwise Combobox component will
     * wait for all search results to return before it renders the final list
     *
     * **Note**: This event is only emitted when `BentoComboboxOptions.useServerSearch` is set to `true`
     * @type {?}
     */
    BentoComboboxComponent.prototype.search;
    /**
     * Callback when data needs to reset.
     *
     * **Note**: This event is only emitted when `BentoComboboxOptions.useServerSearch` is set to `true`
     * @type {?}
     */
    BentoComboboxComponent.prototype.resetItems;
    /**
     * Callback when end of scroll is reached in dropdown list.  This event is **only**
     * fired when there is a scroll. A `BentoComboboxSearchEvent` object is passed in as reference
     * @type {?}
     */
    BentoComboboxComponent.prototype.endOfScroll;
    /**
     * Callback when the open state is changed in Combobox
     * @type {?}
     */
    BentoComboboxComponent.prototype.openChange;
    /**
     * Placeholder or use `false` to disable default placeholder test
     * @type {?}
     */
    BentoComboboxComponent.prototype.placeholder;
    /**
     * Flag to decide if this form component is required or not
     * @type {?}
     */
    BentoComboboxComponent.prototype.required;
    /**
     * Revert search input when its entry is invalid. It overrides `BentoComboboxFooterItem.clearInputOnAction`
     * @type {?}
     */
    BentoComboboxComponent.prototype.revertOnInvalidInput;
    /**
     * **[Advanced]** Reference to row template for each dropdown item
     *
     * ```html
     * <ng-template #myTemplate let-$data="data" let-$options="options" let-$index="index">
     *  <div>
     *    <span>{{$index}}</span> - <strong>{{$data.row}}</strong>
     *  </div>
     * </ng-template>
     * ```
     *
     * - `data.row` (any) - references the item object from the dataset
     * - `options` (BentoComboboxOptions) - Combobox options that is assigned to this component
     * - `index` (number) - Index of the current row
     * @type {?}
     */
    BentoComboboxComponent.prototype.rowTemplate;
    /**
     * Element Reference to the input
     * @type {?}
     */
    BentoComboboxComponent.prototype._inputElRef;
    /**
     * Main list component
     * @type {?}
     */
    BentoComboboxComponent.prototype._list;
    /**
     * Main data change subscription
     * @type {?}
     */
    BentoComboboxComponent.prototype._dataSubscription;
    /**
     * Disabled flag
     * @type {?}
     */
    BentoComboboxComponent.prototype._isDisabled;
    /**
     * Main Data
     * @type {?}
     */
    BentoComboboxComponent.prototype._data;
    /**
     * Data that is used for the dropdown
     * @type {?}
     */
    BentoComboboxComponent.prototype._listData;
    /**
     * Event Emitter for data change
     * @type {?}
     */
    BentoComboboxComponent.prototype._listDataChange;
    /**
     * Element Reference to the list container
     * @type {?}
     */
    BentoComboboxComponent.prototype._listContainer;
    /**
     * Reactive FormControl for the main input
     * @type {?}
     */
    BentoComboboxComponent.prototype._inputLabelControl;
    /**
     * Variable for the input field
     * @type {?}
     */
    BentoComboboxComponent.prototype._inputLabel;
    /**
     * Reference to the row that is currently selected
     * @type {?}
     */
    BentoComboboxComponent.prototype._selectedRow;
    /**
     * Window click subscription to check
     * @type {?}
     */
    BentoComboboxComponent.prototype._windowClickSubscription;
    /**
     * Define if this component is in searching mode
     * @type {?}
     */
    BentoComboboxComponent.prototype._isSearching;
    /**
     * Unique ID of this component
     * @type {?}
     */
    BentoComboboxComponent.prototype.uid;
    /**
     * Element Reference to the list container
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.footerContainer;
    /**
     * Arial Label for drop down
     * @type {?}
     */
    BentoComboboxComponent.prototype.dropdownAriaLabel;
    /**
     * This variable is used by `isListVisible`
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype._isListVisible;
    /**
     * Currently searched value
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype._searchValue;
    /**
     * User journey to keep tap on how user is interaction with the component
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.userJourney;
    /**
     * Keep track on how many requests are sent
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.serverRequestCount;
    /**
     * Control Value Accessor funcions
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype._changeFunction;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype._touchFunction;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.listWillBeVisible;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype._id;
    /**
     * Show/Hide label (internal label before input element) based on the usage.
     * For example, if the combobox is properly associated with a label, this
     * internal label can be hidden.
     * @type {?}
     */
    BentoComboboxComponent.prototype.showSelectorInputLabel;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.tabService;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.logService;
    /**
     * @type {?}
     * @private
     */
    BentoComboboxComponent.prototype.translate;
    /** @type {?} */
    BentoComboboxComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/list/list.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoListModule = /** @class */ (function () {
    function BentoListModule() {
    }
BentoListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoListModule });
BentoListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoListModule_Factory(t) { return new (t || BentoListModule)(); }, imports: [[CommonModule, BentoUtilsModule, ScrollingModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoListModule, { declarations: function () { return [BentoListComponent]; }, imports: function () { return [CommonModule,
        BentoUtilsModule,
        ScrollingModule]; }, exports: function () { return [BentoListComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoListModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, BentoUtilsModule, ScrollingModule],
                declarations: [BentoListComponent],
                exports: [BentoListComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoListModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tooltip/tooltip.support.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoNgbTooltipSupportDirective = /** @class */ (function () {
    function BentoNgbTooltipSupportDirective(tooltip, r, winRef, elementRef) {
        this.tooltip = tooltip;
        this.r = r;
        this.shownSub = Subscription.EMPTY;
        this.hiddenSub = Subscription.EMPTY;
        this.document = winRef.nativeDocument;
        this.el = elementRef.nativeElement;
        this.initHoverScreenEl();
    }
    /**
     * @return {?}
     */
    BentoNgbTooltipSupportDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.shownSub = this.tooltip.shown.subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                // Catch when a tooltip is shown
                /** @type {?} */
                var tooltipWindowEl = _this.document.querySelector("#" + _this.tooltip['_ngbTooltipWindowId']);
                if (tooltipWindowEl) {
                    _this.r.addClass(tooltipWindowEl, 'tooltip-shown');
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        // Need to wait for the next CPU computation cycle
                        _this.tooltip.container !== 'body' && _this.calcHoverScreenEl((/** @type {?} */ (tooltipWindowEl)));
                    }));
                }
            }));
        }));
        this.hiddenSub = this.tooltip.hidden.subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) { return _this.resetHoverScreenEl(); }));
    };
    /**
     * @return {?}
     */
    BentoNgbTooltipSupportDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.shownSub.unsubscribe();
        this.hiddenSub.unsubscribe();
    };
    /**
     * Calculate hover screen element to match tooltip
     */
    /**
     * Calculate hover screen element to match tooltip
     * @private
     * @param {?} tooltipWindowEl
     * @return {?}
     */
    BentoNgbTooltipSupportDirective.prototype.calcHoverScreenEl = /**
     * Calculate hover screen element to match tooltip
     * @private
     * @param {?} tooltipWindowEl
     * @return {?}
     */
    function (tooltipWindowEl) {
        /** @type {?} */
        var tooltipRect = tooltipWindowEl.getBoundingClientRect();
        /** @type {?} */
        var hsRect = this.hoverScreenEl.getBoundingClientRect();
        /** @type {?} */
        var hsEl = this.hoverScreenEl;
        this.r.setStyle(hsEl, 'top', tooltipRect.top - hsRect.top - 1 + "px");
        this.r.setStyle(hsEl, 'left', tooltipRect.left - hsRect.left - 1 + "px");
        this.r.setStyle(hsEl, 'width', tooltipRect.width + 2 + "px");
        this.r.setStyle(hsEl, 'height', tooltipRect.height + 2 + "px");
    };
    /**
     * Initialize hover screen element for WCAG 2.1
     */
    /**
     * Initialize hover screen element for WCAG 2.1
     * @private
     * @return {?}
     */
    BentoNgbTooltipSupportDirective.prototype.initHoverScreenEl = /**
     * Initialize hover screen element for WCAG 2.1
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var el = this.r.createElement('div');
        this.r.setStyle(el, 'z-index', '2002');
        this.r.setStyle(el, 'position', 'absolute');
        this.r.setStyle(el, 'background-color', 'transparent');
        this.r.addClass(el, 'bento-tooltip-hover-overlay');
        this.r.setAttribute(el, 'aria-hidden', 'true');
        this.el.appendChild(el);
        this.hoverScreenEl = el;
        this.resetHoverScreenEl();
    };
    /**
     * Reset hover screen element dimension and size to its initial values
     */
    /**
     * Reset hover screen element dimension and size to its initial values
     * @private
     * @return {?}
     */
    BentoNgbTooltipSupportDirective.prototype.resetHoverScreenEl = /**
     * Reset hover screen element dimension and size to its initial values
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var el = this.hoverScreenEl;
        this.r.setStyle(el, 'top', '0');
        this.r.setStyle(el, 'left', '0');
        this.r.setStyle(el, 'width', '0');
        this.r.setStyle(el, 'height', '0');
    };
    /** @nocollapse */
    BentoNgbTooltipSupportDirective.ctorParameters = function () { return [
        { type: NgbTooltip, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbTooltip; })),] }] },
        { type: Renderer2 },
        { type: WindowRef },
        { type: ElementRef }
    ]; };
BentoNgbTooltipSupportDirective.ɵfac = function BentoNgbTooltipSupportDirective_Factory(t) { return new (t || BentoNgbTooltipSupportDirective)(ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbTooltip; }))), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoNgbTooltipSupportDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoNgbTooltipSupportDirective, selectors: [["", "ngbTooltip", ""]], features: [ɵngcc0.ɵɵProvidersFeature([WindowRef])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNgbTooltipSupportDirective, [{
        type: Directive,
        args: [{ selector: '[ngbTooltip]', providers: [WindowRef] }]
    }], function () { return [{ type: ɵngcc4.NgbTooltip, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbTooltip; }))]
            }] }, { type: ɵngcc0.Renderer2 }, { type: WindowRef }, { type: ɵngcc0.ElementRef }]; }, null); })();
    return BentoNgbTooltipSupportDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoNgbTooltipSupportDirective.prototype.shownSub;
    /**
     * @type {?}
     * @private
     */
    BentoNgbTooltipSupportDirective.prototype.hiddenSub;
    /**
     * @type {?}
     * @private
     */
    BentoNgbTooltipSupportDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoNgbTooltipSupportDirective.prototype.hoverScreenEl;
    /**
     * @type {?}
     * @private
     */
    BentoNgbTooltipSupportDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoNgbTooltipSupportDirective.prototype.tooltip;
    /**
     * @type {?}
     * @private
     */
    BentoNgbTooltipSupportDirective.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tooltip/tooltip.support.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoNgbTooltipSupportModule = /** @class */ (function () {
    function BentoNgbTooltipSupportModule() {
    }
BentoNgbTooltipSupportModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoNgbTooltipSupportModule });
BentoNgbTooltipSupportModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoNgbTooltipSupportModule_Factory(t) { return new (t || BentoNgbTooltipSupportModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoNgbTooltipSupportModule, { declarations: function () { return [BentoNgbTooltipSupportDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BentoNgbTooltipSupportDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNgbTooltipSupportModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoNgbTooltipSupportDirective],
                imports: [CommonModule],
                exports: [BentoNgbTooltipSupportDirective],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoNgbTooltipSupportModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reset/reset.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This component adds a delete button at the right end of an input, to clear its current value.
 */
var BentoResetDirective = /** @class */ (function () {
    /**
     */
    function BentoResetDirective(elementRef, r, ngControl, dir, bentoTranslate, focusMonitor, windowRef) {
        var _this = this;
        this.elementRef = elementRef;
        this.r = r;
        this.ngControl = ngControl;
        this.dir = dir;
        this.bentoTranslate = bentoTranslate;
        this.focusMonitor = focusMonitor;
        /**
         * Subscription to the Directionality change EventEmitter.
         */
        this.dirChangeSubscription = Subscription.EMPTY;
        this.translationChangeSubscription = Subscription.EMPTY;
        this.document = windowRef.nativeDocument;
        this.isRtl = dir.value === 'rtl';
        this.dirChangeSubscription = dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
        this.closeBtnEl = this.r.createElement('button');
        this.r.addClass(this.closeBtnEl, 'bento-reset-close-button');
        this.r.setProperty(this.closeBtnEl, 'innerHTML', "<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>");
        this.r.listen(this.closeBtnEl, 'blur', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) { return _this.onResetButtonBlur(e); }));
        this.windowResizeListenerCancel = this.r.listen('window', 'resize', (/**
         * @return {?}
         */
        function () { return _this.alignCloseButton(); }));
        this.focusMonitor.monitor(this.closeBtnEl);
        // Mousedown
        this.r.listen(this.closeBtnEl, 'mousedown', (/**
         * @param {?} $event
         * @return {?}
         */
        function ($event) {
            // Cancel hide button timeout
            clearTimeout(_this.blurTimneoutID);
            _this.reset();
            $event.stopPropagation();
            $event.preventDefault();
        }));
        // Keydown
        this.r.listen(this.closeBtnEl, 'keydown', (/**
         * @param {?} $event
         * @return {?}
         */
        function ($event) {
            if ($event.keyCode === Keyboard.ENTER || $event.keyCode === Keyboard.SPACE) {
                // Cancel hide button timeout
                clearTimeout(_this.blurTimneoutID);
                _this.reset();
                $event.stopPropagation();
                $event.preventDefault();
            }
        }));
        // Touchstart
        this.r.listen(this.closeBtnEl, 'touchstart', (/**
         * @param {?} $event
         * @return {?}
         */
        function ($event) {
            // Cancel hide button timeout
            clearTimeout(_this.blurTimneoutID);
            _this.reset();
            $event.stopPropagation();
            $event.preventDefault();
        }));
    }
    /**
     * Focus event listener to the input
     */
    /**
     * Focus event listener to the input
     * @param {?} input
     * @return {?}
     */
    BentoResetDirective.prototype.onFocus = /**
     * Focus event listener to the input
     * @param {?} input
     * @return {?}
     */
    function (input) {
        this.checkAndUpdateCloseButton();
    };
    /**
     * Blur event listener to the input
     */
    /**
     * Blur event listener to the input
     * @param {?} e
     * @return {?}
     */
    BentoResetDirective.prototype.onBlur = /**
     * Blur event listener to the input
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // In some browsers TAB does not directly move focus to the next tabbable element
            // Instead it focuses to the <body> element first then move on to the next element
            // so we need to wait for a bit to determine
            _this.checkAndUpdateCloseButton();
        }), 1);
    };
    /**
     * Input event listener to the input
     */
    /**
     * Input event listener to the input
     * @param {?} input
     * @return {?}
     */
    BentoResetDirective.prototype.onInput = /**
     * Input event listener to the input
     * @param {?} input
     * @return {?}
     */
    function (input) {
        this.value = input.value;
        this.checkAndUpdateCloseButton();
    };
    /**
     * @return {?}
     */
    BentoResetDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // ngControl Listener
        this.ngControl.valueChanges.subscribe((/**
         * @param {?} v
         * @return {?}
         */
        function (v) { return _this.onValueChange(v); }));
    };
    /**
     * Init when the view is ready
     */
    /**
     * Init when the view is ready
     * @return {?}
     */
    BentoResetDirective.prototype.ngAfterViewInit = /**
     * Init when the view is ready
     * @return {?}
     */
    function () {
        var _this = this;
        this.setCloseButtonTranslation();
        this.checkAndUpdateCloseButton();
        this.translationChangeSubscription = this.bentoTranslate.translationChange.subscribe((/**
         * @return {?}
         */
        function () {
            return _this.setCloseButtonTranslation();
        }));
    };
    /**
     * Clean the close button from memory
     */
    /**
     * Clean the close button from memory
     * @return {?}
     */
    BentoResetDirective.prototype.ngOnDestroy = /**
     * Clean the close button from memory
     * @return {?}
     */
    function () {
        if (this.closeBtnEl.parentElement) {
            this.r.removeChild(this.closeBtnEl.parentElement, this.closeBtnEl);
        }
        this.closeBtnEl = null;
        this.dirChangeSubscription.unsubscribe();
        this.translationChangeSubscription.unsubscribe();
        this.windowResizeListenerCancel();
        this.focusMonitor.stopMonitoring(this.closeBtnEl);
    };
    /**
     * Reset input
     */
    /**
     * Reset input
     * @return {?}
     */
    BentoResetDirective.prototype.reset = /**
     * Reset input
     * @return {?}
     */
    function () {
        this.r.setProperty(this.elementRef.nativeElement, 'value', null);
        this.elementRef.nativeElement.focus();
        this.value = null;
        this.ngControl.reset();
        this.hideCloseButton();
    };
    /**
     * Aligh close button to the input field, this method needs to be manually called in some cases
     */
    /**
     * Aligh close button to the input field, this method needs to be manually called in some cases
     * @return {?}
     */
    BentoResetDirective.prototype.alignCloseButton = /**
     * Aligh close button to the input field, this method needs to be manually called in some cases
     * @return {?}
     */
    function () {
        if (this.closeBtnEl && this.closeBtnEl.parentElement) {
            /** @type {?} */
            var el = this.elementRef.nativeElement;
            /** @type {?} */
            var w = el.offsetWidth;
            /** @type {?} */
            var h = el.offsetHeight;
            /** @type {?} */
            var l = el.offsetLeft;
            /** @type {?} */
            var t = el.offsetTop;
            /** @type {?} */
            var bh = this.closeBtnEl.offsetHeight;
            /** @type {?} */
            var bw = this.closeBtnEl.offsetWidth;
            if (!bh) {
                // Cannot align since the button is not in view
                return;
            }
            this.r.setStyle(this.closeBtnEl, this.isRtl ? 'right' : 'left', l + w - bw - 5 + 'px');
            this.r.setStyle(this.closeBtnEl, 'top', t + (h - bh) * 0.5 + 'px');
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoResetDirective.prototype.checkAndUpdateCloseButton = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var aEl = this.document.activeElement;
        /** @type {?} */
        var el = this.elementRef.nativeElement;
        if (aEl === this.closeBtnEl || aEl === this.elementRef.nativeElement) {
            if ((this.value && String(this.value).length > 0) || this.value === 0) {
                this.showCloseButton();
            }
            else {
                this.hideCloseButton();
            }
            this.r.addClass(el, 'bui-focused');
        }
        else {
            this.hideCloseButton();
            this.r.removeClass(el, 'bui-focused');
        }
    };
    /**
     * Show the close button
     */
    /**
     * Show the close button
     * @private
     * @return {?}
     */
    BentoResetDirective.prototype.showCloseButton = /**
     * Show the close button
     * @private
     * @return {?}
     */
    function () {
        if (this.elementRef.nativeElement.readOnly || this.closeBtnEl.parentElement) {
            // Do not show if this element is readonly
            // Or the close button is already in viewport
            return;
        }
        /** @type {?} */
        var nextSibling = this.r.nextSibling(this.elementRef.nativeElement);
        /** @type {?} */
        var parentElement = this.elementRef.nativeElement.parentElement;
        if (nextSibling) {
            this.r.insertBefore(parentElement, this.closeBtnEl, nextSibling);
        }
        else {
            this.r.appendChild(parentElement, this.closeBtnEl);
        }
        this.alignCloseButton();
    };
    /**
     * Hide the close button
     */
    /**
     * Hide the close button
     * @private
     * @return {?}
     */
    BentoResetDirective.prototype.hideCloseButton = /**
     * Hide the close button
     * @private
     * @return {?}
     */
    function () {
        if (this.closeBtnEl && this.closeBtnEl.parentElement) {
            this.r.removeChild(this.closeBtnEl.parentElement, this.closeBtnEl); // hide from all screens
        }
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoResetDirective.prototype.onResetButtonBlur = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // In some browsers TAB does not directly move focus to the next tabbable element
            // Instead it focuses to the <body> element first then move on to the next element
            // so we need to wait for a bit to determine
            _this.checkAndUpdateCloseButton();
        }), 1);
    };
    /**
     * Close button's aria label needs to be translated
     */
    /**
     * Close button's aria label needs to be translated
     * @private
     * @return {?}
     */
    BentoResetDirective.prototype.setCloseButtonTranslation = /**
     * Close button's aria label needs to be translated
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var resetString = this.bentoTranslate.instantTranslate('BENTO_UI_RESET_ARIA_LABEL');
        /** @type {?} */
        var inputID = this.elementRef.nativeElement.id;
        /** @type {?} */
        var inputLabel = '';
        /** @type {?} */
        var labelEl;
        if (inputID &&
            inputID.length &&
            (labelEl = (/** @type {?} */ (this.document.querySelector('[for="' + inputID + '"]'))))) {
            inputLabel = labelEl.innerText;
        }
        resetString = resetString.replace('_LABEL_', inputLabel);
        this.r.setAttribute(this.closeBtnEl, 'aria-label', resetString);
    };
    /**
     * Callback to catch value change on the formcontrol
     */
    /**
     * Callback to catch value change on the formcontrol
     * @private
     * @param {?} v
     * @return {?}
     */
    BentoResetDirective.prototype.onValueChange = /**
     * Callback to catch value change on the formcontrol
     * @private
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this.value = v;
        this.checkAndUpdateCloseButton();
    };
    /**
     * @private
     * @return {?}
     */
    BentoResetDirective.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
    };
    /** @nocollapse */
    BentoResetDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: NgControl },
        { type: Directionality },
        { type: BentoTranslate },
        { type: FocusMonitor },
        { type: WindowRef }
    ]; };
    BentoResetDirective.propDecorators = {
        onFocus: [{ type: HostListener, args: ['focus', ['$event.target'],] }],
        onBlur: [{ type: HostListener, args: ['blur', ['$event'],] }],
        onInput: [{ type: HostListener, args: ['input', ['$event.target'],] }]
    };
BentoResetDirective.ɵfac = function BentoResetDirective_Factory(t) { return new (t || BentoResetDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.NgControl), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(BentoTranslate), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FocusMonitor), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoResetDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoResetDirective, selectors: [["input", "formControlName", "", "bentoReset", "", 3, "type", "checkbox"], ["input", "formControl", "", "bentoReset", "", 3, "type", "checkbox"], ["input", "ngModel", "", "bentoReset", "", 3, "type", "checkbox"]], hostBindings: function BentoResetDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function BentoResetDirective_focus_HostBindingHandler($event) { return ctx.onFocus($event.target); })("blur", function BentoResetDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event); })("input", function BentoResetDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target); });
    } } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoResetDirective, [{
        type: Directive,
        args: [{
                selector: 'input:not([type=checkbox])[formControlName][bentoReset],' +
                    'input:not([type=checkbox])[formControl][bentoReset],' +
                    'input:not([type=checkbox])[ngModel][bentoReset]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc8.NgControl }, { type: ɵngcc6.Directionality }, { type: BentoTranslate }, { type: ɵngcc1.FocusMonitor }, { type: WindowRef }]; }, { onFocus: [{
            type: HostListener,
            args: ['focus', ['$event.target']]
        }], onBlur: [{
            type: HostListener,
            args: ['blur', ['$event']]
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event.target']]
        }] }); })();
    return BentoResetDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.closeBtnEl;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.value;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.blurTimneoutID;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.isRtl;
    /**
     * Subscription to the Directionality change EventEmitter.
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.dirChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.translationChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.windowResizeListenerCancel;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.ngControl;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.dir;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.bentoTranslate;
    /**
     * @type {?}
     * @private
     */
    BentoResetDirective.prototype.focusMonitor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reset/reset.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoResetModule = /** @class */ (function () {
    function BentoResetModule() {
    }
BentoResetModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoResetModule });
BentoResetModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoResetModule_Factory(t) { return new (t || BentoResetModule)(); }, imports: [[BentoTranslateModule, BentoUtilsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoResetModule, { declarations: [BentoResetDirective], imports: [BentoTranslateModule,
        BentoUtilsModule], exports: [BentoResetDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoResetModule, [{
        type: NgModule,
        args: [{
                imports: [BentoTranslateModule, BentoUtilsModule],
                declarations: [BentoResetDirective],
                exports: [BentoResetDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoResetModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/combobox/combobox.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoComboboxModule = /** @class */ (function () {
    function BentoComboboxModule() {
    }
BentoComboboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoComboboxModule });
BentoComboboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoComboboxModule_Factory(t) { return new (t || BentoComboboxModule)(); }, imports: [[
            CommonModule,
            BentoListModule,
            BentoResetModule,
            FormsModule,
            BentoAppendToModule,
            ReactiveFormsModule,
            BentoUtilsModule,
            BentoTranslateModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule,
            A11yModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoComboboxModule, { declarations: function () { return [BentoComboboxComponent,
        BentoComboboxListComponent]; }, imports: function () { return [CommonModule,
        BentoListModule,
        BentoResetModule,
        FormsModule,
        BentoAppendToModule,
        ReactiveFormsModule,
        BentoUtilsModule,
        BentoTranslateModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule,
        A11yModule]; }, exports: function () { return [BentoComboboxComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoComboboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoListModule,
                    BentoResetModule,
                    FormsModule,
                    BentoAppendToModule,
                    ReactiveFormsModule,
                    BentoUtilsModule,
                    BentoTranslateModule,
                    BentoFocusMonitorModule,
                    NgbTooltipModule,
                    BentoNgbTooltipSupportModule,
                    A11yModule
                ],
                declarations: [BentoComboboxComponent, BentoComboboxListComponent],
                exports: [BentoComboboxComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoComboboxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/actionable-item.class.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A class to define a actionable item that can be consume by various Bento components
 */
var  /**
 * A class to define a actionable item that can be consume by various Bento components
 */
BentoActionableItem = /** @class */ (function () {
    /**
     * Main constructor
     */
    function BentoActionableItem(label, icon, action) {
        /**
         * Flag to determine if this item is disabled
         */
        this.disabled = false;
        this.label = label;
        this.icon = icon;
        this.action = action;
    }
    return BentoActionableItem;
}());
if (false) {
    /**
     * Label of this item
     * @type {?}
     */
    BentoActionableItem.prototype.label;
    /**
     * Icon (CSS class name) that is used for this item
     * @type {?}
     */
    BentoActionableItem.prototype.icon;
    /**
     * Action for this item
     * @type {?}
     */
    BentoActionableItem.prototype.action;
    /**
     * Flag to determine if this item is disabled
     * @type {?}
     */
    BentoActionableItem.prototype.disabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/contextual-header/contextual-header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Contextual Header is an informational component that most of the time is used in conjunction with FlexGrid.
 * Though it resembles Breadcrumbs, nothing is clickable or navigational in it except
 * an optional "Back" button that would take a user to the previous page.
 *
 * Many times users open a page (drill down) in a different browser window instead of using navigation.
 * When multiple windows are opened, it is necessary to show the hierarchy.
 * Contextual Header allows users to easy see the difference between opened pages, and know exactly where they are.
 */
var BentoContextualHeaderComponent = /** @class */ (function () {
    /**
     * Component constructor
     */
    function BentoContextualHeaderComponent(elementRef, cdr) {
        this.cdr = cdr;
        /**
         * Flag to determine if the back button is disabled
         */
        this.backButtonDisabled = false;
        /**
         * Flag to determine if the back button is hidden
         */
        this.backButtonHidden = false;
        /**
         * Callback when the back button is clicked
         */
        this.backButtonClick = new EventEmitter();
        this.el = elementRef.nativeElement;
    }
    /**
     * @return {?}
     */
    BentoContextualHeaderComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.cdr.detectChanges();
    };
    /**
     * Callback when the back button is clicked
     */
    /**
     * Callback when the back button is clicked
     * @return {?}
     */
    BentoContextualHeaderComponent.prototype._onBackButtonClick = /**
     * Callback when the back button is clicked
     * @return {?}
     */
    function () {
        this.backButtonClick.emit();
    };
    /**
     * Check if the string has an image extension
     */
    /**
     * Check if the string has an image extension
     * @param {?} v
     * @return {?}
     */
    BentoContextualHeaderComponent.prototype._isImage = /**
     * Check if the string has an image extension
     * @param {?} v
     * @return {?}
     */
    function (v) {
        return /[^\s]+(\.(jpg|png|gif|bmp|svg)$)/.test(v);
    };
    /**
     * Gets a string for a header by its given index to tooltip when it's needed,
     * otherwise returns `false`
     */
    /**
     * Gets a string for a header by its given index to tooltip when it's needed,
     * otherwise returns `false`
     * @param {?} index
     * @return {?}
     */
    BentoContextualHeaderComponent.prototype._getTooltipFromHeader = /**
     * Gets a string for a header by its given index to tooltip when it's needed,
     * otherwise returns `false`
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (!this.el) {
            return;
        }
        /** @type {?} */
        var headerEl = (/** @type {?} */ (this.el.querySelector('div[rel="' + index + '"]')));
        /** @type {?} */
        var subHeaderEl = (/** @type {?} */ (this.el.querySelector('div[rel="sub-' + index + '"]')));
        if ((headerEl && headerEl.offsetWidth < headerEl.scrollWidth) ||
            (subHeaderEl && subHeaderEl.offsetWidth < subHeaderEl.scrollWidth)) {
            /** @type {?} */
            var item = this.items[index];
            return item.subtitle ? [item.title, item.subtitle].join(' - ') : item.title;
        }
        else {
            return false;
        }
    };
    /**
     * When the custom button is clicked
     */
    /**
     * When the custom button is clicked
     * @param {?} e
     * @return {?}
     */
    BentoContextualHeaderComponent.prototype._onCustomButtonClick = /**
     * When the custom button is clicked
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.customButton) {
            this.customButton.action();
        }
        e.stopPropagation();
        e.preventDefault();
    };
    /** @nocollapse */
    BentoContextualHeaderComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ]; };
    BentoContextualHeaderComponent.propDecorators = {
        items: [{ type: Input }],
        backButtonDisabled: [{ type: Input }],
        backButtonHidden: [{ type: Input }],
        customButton: [{ type: Input }],
        backButtonClick: [{ type: Output }]
    };
BentoContextualHeaderComponent.ɵfac = function BentoContextualHeaderComponent_Factory(t) { return new (t || BentoContextualHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoContextualHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoContextualHeaderComponent, selectors: [["bento-contextual-header"]], inputs: { backButtonDisabled: "backButtonDisabled", backButtonHidden: "backButtonHidden", items: "items", customButton: "customButton" }, outputs: { backButtonClick: "backButtonClick" }, decls: 6, vars: 3, consts: [[1, "bento-contextual-header-inner"], ["class", "bch-back-button btn-flat-secondary", 3, "disabled", "ngbTooltip", "click", 4, "ngIf"], [1, "bch-main-container"], [1, "bch-main-container-inner"], ["class", "bch-header", "triggers", "click", "autoClose", "inside", "placement", "bottom", 3, "ngbTooltip", 4, "ngFor", "ngForOf"], ["class", "bch-right-container", 4, "ngIf"], [1, "bch-back-button", "btn-flat-secondary", 3, "disabled", "ngbTooltip", "click"], ["aria-hidden", "true", 1, "bento-icon-arrow-left"], ["triggers", "click", "autoClose", "inside", "placement", "bottom", 1, "bch-header", 3, "ngbTooltip"], [4, "ngIf", "ngIfThen"], ["itemIconImage", ""], ["itemIconCSSClass", ""], [1, "bch-header-title-container"], [1, "bch-header-title"], ["class", "bch-header-subtitle", 4, "ngIf"], ["aria-hidden", "true", 1, "bch-header-graphic"], [3, "src"], [1, "bch-header-subtitle"], [1, "bch-right-container"], [1, "btn", "btn-primary", "btn-sm", 3, "disabled", "click"]], template: function BentoContextualHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoContextualHeaderComponent_button_1_Template, 4, 7, "button", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, BentoContextualHeaderComponent_div_4_Template, 11, 8, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, BentoContextualHeaderComponent_div_5_Template, 3, 2, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.backButtonHidden);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.customButton);
    } }, directives: [ɵngcc7.NgIf, ɵngcc7.NgForOf, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective,
        BentoFocusMonitorDirective], pipes: [BentoTranslatePipe], styles: ["bento-contextual-header{display:table;position:relative;width:100%;border-bottom-style:solid;box-sizing:content-box}bento-contextual-header .bento-contextual-header-inner{display:table-row}bento-contextual-header .bento-contextual-header-inner>div:last-child .bch-header:last-child{border:none}bento-contextual-header .bch-main-container{display:table-cell;width:100%;vertical-align:middle}bento-contextual-header .bch-main-container-inner{display:flex;position:relative}bento-contextual-header .bch-back-button{display:table-cell;border-width:0 1px 0 0;border-right-style:solid;background:0 0;font-size:1.429rem;padding-top:0;padding-bottom:0;vertical-align:middle}[dir=rtl] bento-contextual-header .bch-back-button{border-right-width:0;border-right-style:none;border-left-width:1px;border-left-style:solid}bento-contextual-header .bch-header{flex-grow:1;position:relative;height:26px;padding:0;border-right-width:1px;border-right-style:solid;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[dir=rtl] bento-contextual-header .bch-header{border-right-width:0;border-right-style:none;border-left-width:1px;border-left-style:solid}bento-contextual-header .bch-header-title-container{position:absolute;top:0;left:5px;bottom:0;right:0;padding:0 7px 0 10px}[dir=rtl] bento-contextual-header .bch-header-title-container{padding:0 10px 0 7px;left:0;right:5px}bento-contextual-header .bch-header-graphic{float:left;width:41px;height:26px;font-size:1.857rem;padding:0 0 0 15px}bento-contextual-header .bch-header-graphic i{display:block;line-height:26px}bento-contextual-header .bch-header-graphic img{display:block;width:26px;max-height:26px;vertical-align:top}bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:41px}[dir=rtl] bento-contextual-header .bch-header-graphic{float:right;padding:0 15px 0 0}[dir=rtl] bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:0;right:41px}bento-contextual-header .bch-header-title{font-size:1.143rem;line-height:16px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis;text-transform:capitalize}bento-contextual-header .bch-header-title:only-child{line-height:26px}bento-contextual-header .bch-header-subtitle{font-size:.786rem;line-height:bento-rem-calc(14);white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}bento-contextual-header .bch-right-container{display:table-cell;vertical-align:middle;width:0;padding:0 15px 1px}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoContextualHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'bento-contextual-header',
                template: "<div class=\"bento-contextual-header-inner\">\n  <button\n    class=\"bch-back-button btn-flat-secondary\"\n    *ngIf=\"!backButtonHidden\"\n    (click)=\"_onBackButtonClick()\"\n    [disabled]=\"backButtonDisabled\"\n    attr.aria-label=\"{{ 'BENTO_UI_CONTEXTUAL_HEADER_BACK' | bentoTranslate }}\"\n    ngbTooltip=\"{{ 'BENTO_UI_CONTEXTUAL_HEADER_BACK' | bentoTranslate }}\"\n  >\n    <i class=\"bento-icon-arrow-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"bch-main-container\">\n    <div class=\"bch-main-container-inner\">\n      <div\n        class=\"bch-header\"\n        *ngFor=\"let item of items; let $index = index\"\n        triggers=\"click\"\n        autoClose=\"inside\"\n        [ngbTooltip]=\"_getTooltipFromHeader($index)\"\n        placement=\"bottom\"\n      >\n        <div *ngIf=\"item.icon && !_isImage(item.icon); then itemIconCSSClass\"></div>\n        <div *ngIf=\"item.icon && _isImage(item.icon); then itemIconImage\"></div>\n        <ng-template #itemIconImage>\n          <figure aria-hidden=\"true\" class=\"bch-header-graphic\">\n            <img [src]=\"item.icon\" />\n          </figure>\n        </ng-template>\n        <ng-template #itemIconCSSClass>\n          <figure aria-hidden=\"true\" class=\"bch-header-graphic\">\n            <i [class]=\"item.icon\"></i>\n          </figure>\n        </ng-template>\n        <div class=\"bch-header-title-container\">\n          <div class=\"bch-header-title\" [attr.rel]=\"$index\">{{ item.title }}</div>\n          <div *ngIf=\"item.subtitle\" [attr.rel]=\"'sub-' + $index\" class=\"bch-header-subtitle\">{{ item.subtitle }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"bch-right-container\" *ngIf=\"customButton\">\n    <button class=\"btn btn-primary btn-sm\" (click)=\"_onCustomButtonClick($event)\" [disabled]=\"customButton.disabled\">\n      {{ customButton.label }}\n    </button>\n  </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["bento-contextual-header{display:table;position:relative;width:100%;border-bottom-style:solid;box-sizing:content-box}bento-contextual-header .bento-contextual-header-inner{display:table-row}bento-contextual-header .bento-contextual-header-inner>div:last-child .bch-header:last-child{border:none}bento-contextual-header .bch-main-container{display:table-cell;width:100%;vertical-align:middle}bento-contextual-header .bch-main-container-inner{display:flex;position:relative}bento-contextual-header .bch-back-button{display:table-cell;border-width:0 1px 0 0;border-right-style:solid;background:0 0;font-size:1.429rem;padding-top:0;padding-bottom:0;vertical-align:middle}[dir=rtl] bento-contextual-header .bch-back-button{border-right-width:0;border-right-style:none;border-left-width:1px;border-left-style:solid}bento-contextual-header .bch-header{flex-grow:1;position:relative;height:26px;padding:0;border-right-width:1px;border-right-style:solid;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[dir=rtl] bento-contextual-header .bch-header{border-right-width:0;border-right-style:none;border-left-width:1px;border-left-style:solid}bento-contextual-header .bch-header-title-container{position:absolute;top:0;left:5px;bottom:0;right:0;padding:0 7px 0 10px}[dir=rtl] bento-contextual-header .bch-header-title-container{padding:0 10px 0 7px;left:0;right:5px}bento-contextual-header .bch-header-graphic{float:left;width:41px;height:26px;font-size:1.857rem;padding:0 0 0 15px}bento-contextual-header .bch-header-graphic i{display:block;line-height:26px}bento-contextual-header .bch-header-graphic img{display:block;width:26px;max-height:26px;vertical-align:top}bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:41px}[dir=rtl] bento-contextual-header .bch-header-graphic{float:right;padding:0 15px 0 0}[dir=rtl] bento-contextual-header .bch-header-graphic+.bch-header-title-container{left:0;right:41px}bento-contextual-header .bch-header-title{font-size:1.143rem;line-height:16px;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis;text-transform:capitalize}bento-contextual-header .bch-header-title:only-child{line-height:26px}bento-contextual-header .bch-header-subtitle{font-size:.786rem;line-height:bento-rem-calc(14);white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}bento-contextual-header .bch-right-container{display:table-cell;vertical-align:middle;width:0;padding:0 15px 1px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { backButtonDisabled: [{
            type: Input
        }], backButtonHidden: [{
            type: Input
        }], backButtonClick: [{
            type: Output
        }], items: [{
            type: Input
        }], customButton: [{
            type: Input
        }] }); })();
    return BentoContextualHeaderComponent;
}());
if (false) {
    /**
     * Items of `BentoContextualHeaderItem` to be populated in this component
     * @type {?}
     */
    BentoContextualHeaderComponent.prototype.items;
    /**
     * Flag to determine if the back button is disabled
     * @type {?}
     */
    BentoContextualHeaderComponent.prototype.backButtonDisabled;
    /**
     * Flag to determine if the back button is hidden
     * @type {?}
     */
    BentoContextualHeaderComponent.prototype.backButtonHidden;
    /**
     * Actionable Item that is used to add a custom button to this Contextual Header
     * @type {?}
     */
    BentoContextualHeaderComponent.prototype.customButton;
    /**
     * Callback when the back button is clicked
     * @type {?}
     */
    BentoContextualHeaderComponent.prototype.backButtonClick;
    /**
     * HTMLElement reference of this component
     * @type {?}
     */
    BentoContextualHeaderComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoContextualHeaderComponent.prototype.cdr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/contextual-header/contextual-header-item.class.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A class that defines the items that are rendered by the `BentoContextualHeaderComponent` component
 */
var  /**
 * A class that defines the items that are rendered by the `BentoContextualHeaderComponent` component
 */
BentoContextualHeaderItem = /** @class */ (function () {
    /**
     * Constructor of `BentoContextualHeaderItem`
     */
    function BentoContextualHeaderItem(title, subtitle, icon) {
        this.title = title;
        this.subtitle = subtitle;
        this.icon = icon;
    }
    return BentoContextualHeaderItem;
}());
if (false) {
    /**
     * Title of this contextual header item
     * @type {?}
     */
    BentoContextualHeaderItem.prototype.title;
    /**
     * Subtitle of this contextual header item
     * @type {?}
     */
    BentoContextualHeaderItem.prototype.subtitle;
    /**
     * Either a path of an image file or a CSS class refers to an icon
     * @type {?}
     */
    BentoContextualHeaderItem.prototype.icon;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/contextual-header/contextual-header.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoContextualHeaderModule = /** @class */ (function () {
    function BentoContextualHeaderModule() {
    }
BentoContextualHeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoContextualHeaderModule });
BentoContextualHeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoContextualHeaderModule_Factory(t) { return new (t || BentoContextualHeaderModule)(); }, imports: [[
            NgbTooltipModule,
            CommonModule,
            BentoTranslateModule,
            BentoNgbTooltipSupportModule,
            BentoFocusMonitorModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoContextualHeaderModule, { declarations: function () { return [BentoContextualHeaderComponent]; }, imports: function () { return [NgbTooltipModule,
        CommonModule,
        BentoTranslateModule,
        BentoNgbTooltipSupportModule,
        BentoFocusMonitorModule]; }, exports: function () { return [BentoContextualHeaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoContextualHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    NgbTooltipModule,
                    CommonModule,
                    BentoTranslateModule,
                    BentoNgbTooltipSupportModule,
                    BentoFocusMonitorModule
                ],
                declarations: [BentoContextualHeaderComponent],
                exports: [BentoContextualHeaderComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoContextualHeaderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-accessibility/datepicker-accessibility.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoDatepickerAccessibilityDirective = /** @class */ (function () {
    function BentoDatepickerAccessibilityDirective(elementRef, r) {
        this.elementRef = elementRef;
        this.r = r;
    }
    /**
     * @return {?}
     */
    BentoDatepickerAccessibilityDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var todayDate = (/** @type {?} */ (this.elementRef.nativeElement.querySelector('.ngb-dp-today')));
        setTimeout((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var selectedDate = (/** @type {?} */ (_this.elementRef.nativeElement.querySelector('div[ng-reflect-selected="true"]')));
            if (!!selectedDate) {
                /** @type {?} */
                var selectParentElement = selectedDate.parentElement;
                selectParentElement.setAttribute('aria-label', selectParentElement.getAttribute('aria-label') + ', selected');
            }
        }));
        this.r.setAttribute(todayDate, 'aria-current', todayDate.getAttribute('aria-label'));
    };
    /**
     * @return {?}
     */
    BentoDatepickerAccessibilityDirective.prototype.onDateSelect = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var selectedDate = (/** @type {?} */ (event.target));
        /** @type {?} */
        var selectParentElement = selectedDate.parentElement;
        if (!selectParentElement.getAttribute('aria-label').includes('selected')) {
            selectParentElement.setAttribute('aria-label', selectParentElement.getAttribute('aria-label') + ', selected');
        }
    };
    /** @nocollapse */
    BentoDatepickerAccessibilityDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    BentoDatepickerAccessibilityDirective.propDecorators = {
        bentoDatepickerAccessibility: [{ type: Input }],
        onDateSelect: [{ type: HostListener, args: ['dateSelect',] }]
    };
BentoDatepickerAccessibilityDirective.ɵfac = function BentoDatepickerAccessibilityDirective_Factory(t) { return new (t || BentoDatepickerAccessibilityDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BentoDatepickerAccessibilityDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoDatepickerAccessibilityDirective, selectors: [["", "bentoDatepickerAccessibility", ""]], hostBindings: function BentoDatepickerAccessibilityDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dateSelect", function BentoDatepickerAccessibilityDirective_dateSelect_HostBindingHandler() { return ctx.onDateSelect(); });
    } }, inputs: { bentoDatepickerAccessibility: "bentoDatepickerAccessibility" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDatepickerAccessibilityDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoDatepickerAccessibility]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { onDateSelect: [{
            type: HostListener,
            args: ['dateSelect']
        }], bentoDatepickerAccessibility: [{
            type: Input
        }] }); })();
    return BentoDatepickerAccessibilityDirective;
}());
if (false) {
    /** @type {?} */
    BentoDatepickerAccessibilityDirective.prototype.bentoDatepickerAccessibility;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerAccessibilityDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerAccessibilityDirective.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-accessibility/datepicker-accessibility.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoDatepickerAccessibilityModule = /** @class */ (function () {
    function BentoDatepickerAccessibilityModule(ngbDatepickerConfig) {
    }
    /** @nocollapse */
    BentoDatepickerAccessibilityModule.ctorParameters = function () { return [
        { type: NgbDatepickerConfig }
    ]; };
BentoDatepickerAccessibilityModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoDatepickerAccessibilityModule });
BentoDatepickerAccessibilityModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoDatepickerAccessibilityModule_Factory(t) { return new (t || BentoDatepickerAccessibilityModule)(ɵngcc0.ɵɵinject(ɵngcc4.NgbDatepickerConfig)); }, providers: [NgbDatepickerConfig] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoDatepickerAccessibilityModule, { declarations: [BentoDatepickerAccessibilityDirective], exports: [BentoDatepickerAccessibilityDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDatepickerAccessibilityModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoDatepickerAccessibilityDirective],
                exports: [BentoDatepickerAccessibilityDirective],
                providers: [NgbDatepickerConfig]
            }]
    }], function () { return [{ type: ɵngcc4.NgbDatepickerConfig }]; }, null); })();
    return BentoDatepickerAccessibilityModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-toggle/datepicker-toggle.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This directive should be used on a button element to toggle datepicker popup visibility.
 * Additionally it hides popup when user clicks outside it.
 * @author <a href="mailto:raman.zhylich\@thomsonreuters.com">Raman Zhylich</a>
 */
var BentoDatepickerToggleDirective = /** @class */ (function () {
    /**
     */
    function BentoDatepickerToggleDirective(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
    }
    /**
     * Init
     */
    /**
     * Init
     * @return {?}
     */
    BentoDatepickerToggleDirective.prototype.ngOnInit = /**
     * Init
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var inputDatepickerElRef = ((/** @type {?} */ (this.bentoDatepickerToggle)))._elRef;
        // Subscribe on focusout of parent element. We don't use document:click to avoid memory leaks.
        this._focusOutEventHandler = this._renderer.listen(inputDatepickerElRef.nativeElement.parentElement, 'focusout', (/**
         * @param {?} $event
         * @return {?}
         */
        function ($event) { return _this.onFocusOut($event); }));
    };
    /**
     * Destroy -> cleanup
     */
    /**
     * Destroy -> cleanup
     * @return {?}
     */
    BentoDatepickerToggleDirective.prototype.ngOnDestroy = /**
     * Destroy -> cleanup
     * @return {?}
     */
    function () {
        if (this._focusOutEventHandler) {
            this._focusOutEventHandler();
        }
    };
    /**
     * Toggle datepicker popup when button is clicked.
     */
    /**
     * Toggle datepicker popup when button is clicked.
     * @return {?}
     */
    BentoDatepickerToggleDirective.prototype._onClick = /**
     * Toggle datepicker popup when button is clicked.
     * @return {?}
     */
    function () {
        var _a;
        this.bentoDatepickerToggle.toggle();
        /** @type {?} */
        var datePicker = (_a = this.bentoDatepickerToggle['_cRef']) === null || _a === void 0 ? void 0 : _a.location.nativeElement;
        if (!!datePicker) {
            datePicker.setAttribute('role', 'dialog');
        }
    };
    /**
     * Triggered when focus is lost on datepicker's parent element or one of its children.
     */
    /**
     * Triggered when focus is lost on datepicker's parent element or one of its children.
     * @private
     * @param {?} $event
     * @return {?}
     */
    BentoDatepickerToggleDirective.prototype.onFocusOut = /**
     * Triggered when focus is lost on datepicker's parent element or one of its children.
     * @private
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var datepickerCmpRef = ((/** @type {?} */ (this.bentoDatepickerToggle)))._cRef;
        if (this.bentoDatepickerToggle.isOpen()) {
            // Ignore cases when user clicks inside popup or on a "toggle" button.
            if (!this._elementRef.nativeElement.contains($event.relatedTarget) &&
                !datepickerCmpRef.location.nativeElement.contains($event.relatedTarget)) {
                this.bentoDatepickerToggle.close();
            }
        }
    };
    /** @nocollapse */
    BentoDatepickerToggleDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    BentoDatepickerToggleDirective.propDecorators = {
        bentoDatepickerToggle: [{ type: Input, args: ['bentoDatepickerToggle',] }],
        _onClick: [{ type: HostListener, args: ['click',] }]
    };
BentoDatepickerToggleDirective.ɵfac = function BentoDatepickerToggleDirective_Factory(t) { return new (t || BentoDatepickerToggleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoDatepickerToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoDatepickerToggleDirective, selectors: [["", "bentoDatepickerToggle", ""]], hostBindings: function BentoDatepickerToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function BentoDatepickerToggleDirective_click_HostBindingHandler() { return ctx._onClick(); });
    } }, inputs: { bentoDatepickerToggle: "bentoDatepickerToggle" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDatepickerToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoDatepickerToggle]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _onClick: [{
            type: HostListener,
            args: ['click']
        }], bentoDatepickerToggle: [{
            type: Input,
            args: ['bentoDatepickerToggle']
        }] }); })();
    return BentoDatepickerToggleDirective;
}());
if (false) {
    /**
     * Reference to target `NgbInputDatepicker` component.
     * @type {?}
     */
    BentoDatepickerToggleDirective.prototype.bentoDatepickerToggle;
    /**
     * Method to unsubscribe from "focusout" event
     * @type {?}
     * @private
     */
    BentoDatepickerToggleDirective.prototype._focusOutEventHandler;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerToggleDirective.prototype._renderer;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerToggleDirective.prototype._elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-toggle/datepicker-toggle.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoDatepickerToggleModule = /** @class */ (function () {
    function BentoDatepickerToggleModule(ngbDatepickerConfig) {
        // Per CUX design request, all outside days should be hidden
        // This also matches with Xavier datepicker UI
        ngbDatepickerConfig.outsideDays = 'hidden';
    }
    /** @nocollapse */
    BentoDatepickerToggleModule.ctorParameters = function () { return [
        { type: NgbDatepickerConfig }
    ]; };
BentoDatepickerToggleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoDatepickerToggleModule });
BentoDatepickerToggleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoDatepickerToggleModule_Factory(t) { return new (t || BentoDatepickerToggleModule)(ɵngcc0.ɵɵinject(ɵngcc4.NgbDatepickerConfig)); }, providers: [NgbDatepickerConfig] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoDatepickerToggleModule, { declarations: [BentoDatepickerToggleDirective], exports: [BentoDatepickerToggleDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDatepickerToggleModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoDatepickerToggleDirective],
                exports: [BentoDatepickerToggleDirective],
                providers: [NgbDatepickerConfig]
            }]
    }], function () { return [{ type: ɵngcc4.NgbDatepickerConfig }]; }, null); })();
    return BentoDatepickerToggleModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-parser-formatter/datepicker-parser-formatter.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoDatePickerConfig = /** @class */ (function () {
    function BentoDatePickerConfig() {
        /**
         * Contains two strings: format and type.
         *
         * type: Date type. Can be 'recent' or 'dob'
         * When type is 'recent', a '20' is inserted at the beginning of the year
         * if the user types in 2 digits for year.
         * When type is 'dob', a '19' is inserted at the beginning if the two digits
         * are greater than or equal to the last two digits of the current year + 1.
         * For example, if '05/25/21' is entered, then '05/25/1921' will be entered
         * when leaving the field.
         *
         * format: Date format. Can be 'mm/dd/yyyy', 'dd/mm/yyyy', 'yyyy-mm-dd', 'yy-mm-dd'.
         * 'yy-mm-dd' corresponds to Canadian date format.
         */
        this.datepickerConfig = { format: '', type: '' };
    }
    /**
     * Sets format property.
     * @param format Input format.
     */
    /**
     * Sets format property.
     * @param {?} format Input format.
     * @return {?}
     */
    BentoDatePickerConfig.prototype.setFormat = /**
     * Sets format property.
     * @param {?} format Input format.
     * @return {?}
     */
    function (format) {
        this.datepickerConfig.format = format;
    };
    /**
     * Sets type property.
     * @param type Input type.
     */
    /**
     * Sets type property.
     * @param {?} type Input type.
     * @return {?}
     */
    BentoDatePickerConfig.prototype.setType = /**
     * Sets type property.
     * @param {?} type Input type.
     * @return {?}
     */
    function (type) {
        this.datepickerConfig.type = type;
    };
    /** @nocollapse */ BentoDatePickerConfig.ɵprov = ɵɵdefineInjectable({ factory: function BentoDatePickerConfig_Factory() { return new BentoDatePickerConfig(); }, token: BentoDatePickerConfig, providedIn: "root" });
BentoDatePickerConfig.ɵfac = function BentoDatePickerConfig_Factory(t) { return new (t || BentoDatePickerConfig)(); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDatePickerConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
    return BentoDatePickerConfig;
}());
if (false) {
    /**
     * Contains two strings: format and type.
     *
     * type: Date type. Can be 'recent' or 'dob'
     * When type is 'recent', a '20' is inserted at the beginning of the year
     * if the user types in 2 digits for year.
     * When type is 'dob', a '19' is inserted at the beginning if the two digits
     * are greater than or equal to the last two digits of the current year + 1.
     * For example, if '05/25/21' is entered, then '05/25/1921' will be entered
     * when leaving the field.
     *
     * format: Date format. Can be 'mm/dd/yyyy', 'dd/mm/yyyy', 'yyyy-mm-dd', 'yy-mm-dd'.
     * 'yy-mm-dd' corresponds to Canadian date format.
     * @type {?}
     */
    BentoDatePickerConfig.prototype.datepickerConfig;
}
/**
 * BentoDefaultNgbDateParserFormatter.
 * Parses and formats depending on what format and type are set.
 * @author <a href="mailto:lisa.schuler\@thomsonreuters.com">Lisa Schuler</a>
 */
var BentoDefaultNgbDateParserFormatter = /** @class */ (function (_super) {
    __extends(BentoDefaultNgbDateParserFormatter, _super);
    /**
     * Ctor
     * @param bentoDatepickerConfig BentoDatePickerConfig
     */
    function BentoDefaultNgbDateParserFormatter(bentoDatepickerConfig) {
        var _this = _super.call(this) || this;
        _this.bentoDatepickerConfig = bentoDatepickerConfig;
        /**
         * Slash delimiter
         */
        _this.SLASH_DELIMITER = '/';
        /**
         * Dash delimiter
         */
        _this.DASH_DELIMITER = '-';
        return _this;
    }
    Object.defineProperty(BentoDefaultNgbDateParserFormatter.prototype, "dateFormat", {
        /**
         * Getter for format
         */
        get: /**
         * Getter for format
         * @return {?}
         */
        function () {
            return this.bentoDatepickerConfig.datepickerConfig.format;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoDefaultNgbDateParserFormatter.prototype, "type", {
        /**
         * Getter for type
         */
        get: /**
         * Getter for type
         * @return {?}
         */
        function () {
            return this.bentoDatepickerConfig.datepickerConfig.type;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Converts input value to an Integer.
     * @param value
     */
    /**
     * Converts input value to an Integer.
     * @param {?} value
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.toInteger = /**
     * Converts input value to an Integer.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return parseInt(value.toString(), 10);
    };
    /**
     * Determines if the given value is a number.
     * @param value
     */
    /**
     * Determines if the given value is a number.
     * @param {?} value
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.isNumber = /**
     * Determines if the given value is a number.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return !isNaN(this.toInteger(value));
    };
    /**
     * Pads number with a 0 if it is a single digit.
     * @param value
     */
    /**
     * Pads number with a 0 if it is a single digit.
     * @param {?} value
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.padNumber = /**
     * Pads number with a 0 if it is a single digit.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (this.isNumber(value)) {
            if (value.toString().length > 1) {
                return value.toString();
            }
            else {
                return '0' + value.toString();
            }
        }
        else {
            return '';
        }
    };
    /**
     * Parses mm/dd/yyyy into NgbDateStruct
     * @param value
     */
    /**
     * Parses mm/dd/yyyy into NgbDateStruct
     * @param {?} value
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.parseUS = /**
     * Parses mm/dd/yyyy into NgbDateStruct
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var result = null;
        if (value) {
            /** @type {?} */
            var slashDate = value.split(this.SLASH_DELIMITER);
            if (slashDate.length === 1) {
                result = {
                    month: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    day: null,
                    year: null
                };
            }
            else if (slashDate.length === 2) {
                result = {
                    month: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    year: null
                };
            }
            else if (slashDate.length === 3) {
                result = {
                    day: parseInt(slashDate[1] ? slashDate[1] : undefined, 10),
                    month: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    year: parseInt(slashDate[2] ? slashDate[2] : undefined, 10)
                };
            }
        }
        return result;
    };
    /**
     * Parses dd/mm/yyyy into NgbDateStruct
     * @param value
     */
    /**
     * Parses dd/mm/yyyy into NgbDateStruct
     * @param {?} value
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.parseDateFirst = /**
     * Parses dd/mm/yyyy into NgbDateStruct
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var result = null;
        if (value) {
            /** @type {?} */
            var slashDate = value.split(this.SLASH_DELIMITER);
            if (slashDate.length === 1) {
                result = {
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    month: null,
                    year: null
                };
            }
            else if (slashDate.length === 2) {
                result = {
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    month: parseInt(slashDate[1] ? slashDate[1] : undefined, 10),
                    year: null
                };
            }
            else if (slashDate.length === 3) {
                result = {
                    day: parseInt(slashDate[0] ? slashDate[0] : undefined, 10),
                    month: parseInt(slashDate[1] ? slashDate[1] : undefined, 10),
                    year: parseInt(slashDate[2] ? slashDate[2] : undefined, 10)
                };
            }
        }
        return result;
    };
    /**
     * Parses yyyy-mm-dd into NgbDateStruct
     * @param value
     */
    /**
     * Parses yyyy-mm-dd into NgbDateStruct
     * @param {?} value
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.parseYearFirst = /**
     * Parses yyyy-mm-dd into NgbDateStruct
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var result = null;
        if (value) {
            /** @type {?} */
            var dashDate = value.split(this.DASH_DELIMITER);
            if (dashDate.length === 1) {
                result = {
                    day: null,
                    month: null,
                    year: parseInt(dashDate[0] ? dashDate[0] : undefined, 10)
                };
            }
            else if (dashDate.length === 2) {
                result = {
                    day: null,
                    month: parseInt(dashDate[1] ? dashDate[1] : undefined, 10),
                    year: parseInt(dashDate[0] ? dashDate[0] : undefined, 10)
                };
            }
            else if (dashDate.length === 3) {
                result = {
                    day: parseInt(dashDate[2] ? dashDate[2] : undefined, 10),
                    month: parseInt(dashDate[1] ? dashDate[1] : undefined, 10),
                    year: parseInt(dashDate[0] ? dashDate[0] : undefined, 10)
                };
            }
        }
        return result;
    };
    /**
     * Parses string depending on dateFormat.
     * @param value
     */
    /**
     * Parses string depending on dateFormat.
     * @param {?} value
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.parse = /**
     * Parses string depending on dateFormat.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (this.dateFormat === 'mm/dd/yyyy') {
            return this.parseUS(value);
        }
        if (this.dateFormat === 'dd/mm/yyyy') {
            return this.parseDateFirst(value);
        }
        if (this.dateFormat === 'yy-mm-dd' || this.dateFormat === 'yyyy-mm-dd') {
            return this.parseYearFirst(value);
        }
        return null;
    };
    /**
     * Formats NgbDateStruct into mm/dd/yyyy.
     * @param date
     */
    /**
     * Formats NgbDateStruct into mm/dd/yyyy.
     * @param {?} date
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.formatUS = /**
     * Formats NgbDateStruct into mm/dd/yyyy.
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var result = '';
        if (date) {
            if (date.month !== undefined) {
                result += this.padNumber(date.month).toString() + this.SLASH_DELIMITER;
            }
            if (date.day !== undefined) {
                result += this.padNumber(date.day).toString() + this.SLASH_DELIMITER;
            }
            if (date.year !== undefined) {
                result += date.year.toString();
            }
            return result;
        }
        return result;
    };
    /**
     * Formats NgbDateStruct into dd/mm/yyyy.
     * @param date
     */
    /**
     * Formats NgbDateStruct into dd/mm/yyyy.
     * @param {?} date
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.formatDateFirst = /**
     * Formats NgbDateStruct into dd/mm/yyyy.
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var result = '';
        if (date) {
            if (date.day !== undefined) {
                result += this.padNumber(date.day).toString() + this.SLASH_DELIMITER;
            }
            if (date.month !== undefined) {
                result += this.padNumber(date.month).toString() + this.SLASH_DELIMITER;
            }
            if (date.year !== undefined) {
                result += date.year.toString();
            }
            return result;
        }
        return result;
    };
    /**
     * Formats NgbDateStruct into yyyy-mm-dd.
     * @param date
     */
    /**
     * Formats NgbDateStruct into yyyy-mm-dd.
     * @param {?} date
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.formatYearFirst = /**
     * Formats NgbDateStruct into yyyy-mm-dd.
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var result = '';
        if (date) {
            if (date.year !== undefined) {
                result += date.year.toString() + this.DASH_DELIMITER;
            }
            if (date.month !== undefined) {
                result += this.padNumber(date.month).toString() + this.DASH_DELIMITER;
            }
            if (date.day !== undefined) {
                result += this.padNumber(date.day).toString();
            }
            return result;
        }
        return result;
    };
    /**
     * Formats NgbDateStruct into string depending on date format.
     * @param date
     */
    /**
     * Formats NgbDateStruct into string depending on date format.
     * @param {?} date
     * @return {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.format = /**
     * Formats NgbDateStruct into string depending on date format.
     * @param {?} date
     * @return {?}
     */
    function (date) {
        if (this.dateFormat === 'mm/dd/yyyy') {
            return this.formatUS(date);
        }
        if (this.dateFormat === 'dd/mm/yyyy') {
            return this.formatDateFirst(date);
        }
        if (this.dateFormat === 'yy-mm-dd' || this.dateFormat === 'yyyy-mm-dd') {
            return this.formatYearFirst(date);
        }
        return '';
    };
    /** @nocollapse */
    BentoDefaultNgbDateParserFormatter.ctorParameters = function () { return [
        { type: BentoDatePickerConfig }
    ]; };
    /** @nocollapse */ BentoDefaultNgbDateParserFormatter.ɵprov = ɵɵdefineInjectable({ factory: function BentoDefaultNgbDateParserFormatter_Factory() { return new BentoDefaultNgbDateParserFormatter(ɵɵinject(BentoDatePickerConfig)); }, token: BentoDefaultNgbDateParserFormatter, providedIn: "root" });
BentoDefaultNgbDateParserFormatter.ɵfac = function BentoDefaultNgbDateParserFormatter_Factory(t) { return new (t || BentoDefaultNgbDateParserFormatter)(ɵngcc0.ɵɵinject(BentoDatePickerConfig)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDefaultNgbDateParserFormatter, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: BentoDatePickerConfig }]; }, null); })();
    return BentoDefaultNgbDateParserFormatter;
}(NgbDateParserFormatter));
if (false) {
    /**
     * Slash delimiter
     * @type {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.SLASH_DELIMITER;
    /**
     * Dash delimiter
     * @type {?}
     */
    BentoDefaultNgbDateParserFormatter.prototype.DASH_DELIMITER;
    /**
     * @type {?}
     * @private
     */
    BentoDefaultNgbDateParserFormatter.prototype.bentoDatepickerConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-mask/datepicker-config.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This directive should be used on an input element for NgbDatepicker.
 * It takes in a DatepickerConfig which consists of a format and a type.
 * It inserts a '/' or '-' as the user types with the exception of CA (format: yy-mm-dd).
 * @author <a href="mailto:lisa.schuler\@thomsonreuters.com">Lisa Schuler</a>
 */
var BentoDatepickerConfigDirective = /** @class */ (function () {
    /**
     * Ctor
     * @param elementRef
     * @param bentoDatepickerConfig
     * @param customDatePicker
     */
    function BentoDatepickerConfigDirective(elementRef, bentoNgbDatepickerConfig, customDatePicker, winRef, platform) {
        this.elementRef = elementRef;
        this.bentoNgbDatepickerConfig = bentoNgbDatepickerConfig;
        this.customDatePicker = customDatePicker;
        this.winRef = winRef;
        this.platform = platform;
        /**
         * Regex for two digits, ie '12', '05', etc.
         */
        this.TWO_DIGIT_REGEX = /^[0-9]{2}$/;
        /**
         * Regex for two digits, a slash and another 2 digits, ie 04/25, 10/22, 21/05, etc.
         */
        this.FOUR_DIGIT_REGEX = /^[0-9]{2}\/[0-9]{2}$/;
        /**
         * Regex for mm/dd/yy or dd/mm/yy.
         */
        this.PARTIAL_YEAR_REGEX = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{1,2}$/;
        /**
         * Regex for yy-mm-dd.
         */
        this.PARTIAL_YEAR_REGEX_CA = /^\d{1,2}\-[0-9]{2}\-[0-9]{2}$/;
        /**
         * Regex for 8 digits dates with no slashes, ie 20201031.
         */
        this.NO_SLASH_REGEX_8_DIGITS = /^[0-9]{8}$/;
        /**
         * Regex for 6 digits dates with no slashes, ie 201031.
         */
        this.NO_SLASH_REGEX_6_DIGITS = /^[0-9]{6}$/;
        /**
         * Regex for 4 digits.
         */
        this.YEAR_REGEX = /^\d{4}$/;
        /**
         * Regex for four digits, a dash and 2 digits, ie 1985-04, 2020-05, etc.
         */
        this.YEAR_MONTH_REGEX = /^\d{4}\-[0-9]{2}$/;
        /**
         * Regex for four digits, a dash and 2 digits, ie 1985-04, 2020-05, etc.
         */
        this.SHORT_YEAR_MONTH_REGEX = /^\d{2}\-[0-9]{2}$/;
        /**
         * datePickerConfig
         */
        this.datepickerConfig = { format: '', type: '' };
        this.el = this.elementRef.nativeElement;
    }
    /**
     * Init
     */
    /**
     * Init
     * @return {?}
     */
    BentoDatepickerConfigDirective.prototype.ngOnInit = /**
     * Init
     * @return {?}
     */
    function () {
        this.datepickerConfig = this.bentoDatepickerConfig;
        this.bentoNgbDatepickerConfig.setFormat(this.datepickerConfig.format);
        this.bentoNgbDatepickerConfig.setType(this.datepickerConfig.type);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoDatepickerConfigDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes['bentoDatepickerConfig']) {
            this.datepickerConfig = this.bentoDatepickerConfig;
            this.bentoNgbDatepickerConfig.setFormat(this.datepickerConfig.format);
            this.bentoNgbDatepickerConfig.setType(this.datepickerConfig.type);
        }
    };
    /**
     * Listens for input events and adds dashes and slashes where appropriate for a given date format.
     * @param $event Input Event
     */
    /**
     * Listens for input events and adds dashes and slashes where appropriate for a given date format.
     * @param {?} $event Input Event
     * @return {?}
     */
    BentoDatepickerConfigDirective.prototype.onInput = /**
     * Listens for input events and adds dashes and slashes where appropriate for a given date format.
     * @param {?} $event Input Event
     * @return {?}
     */
    function ($event) {
        if (this.datepickerConfig.format === 'mm/dd/yyyy' || this.datepickerConfig.format === 'dd/mm/yyyy') {
            if ($event.inputType !== 'deleteContentBackward' &&
                (this.TWO_DIGIT_REGEX.test($event.target.value) || this.FOUR_DIGIT_REGEX.test($event.target.value))) {
                this.el.value = $event.target.value + '/';
            }
        }
        else if (this.datepickerConfig.format === 'yyyy-mm-dd') {
            if ($event.inputType !== 'deleteContentBackward' &&
                (this.YEAR_REGEX.test($event.target.value) || this.YEAR_MONTH_REGEX.test($event.target.value))) {
                this.el.value = $event.target.value + '-';
            }
        }
        /*
        // Per business needs, Canadian date format should not be corrected during user input
        // Uncomment this block when needed again
    
        else if (this.datepickerConfig.format === 'yy-mm-dd') {
          if (
            $event.inputType !== 'deleteContentBackward' &&
            (this.TWO_DIGIT_REGEX.test($event.target.value) || this.SHORT_YEAR_MONTH_REGEX.test($event.target.value))
          ) {
            this.el.value = $event.target.value + '-';
          }
        }
        */
    };
    /**
     * Listens for blur events and handles two digit years for a given date format and type.
     * For mm/dd/yy, dd/mm/yym yy-mm-dd, yymmdd:
     *    If there are 2 digits for year:
     *      If type is recent:
     *        Append a '20' to the front of year.
     *      If type is dob:
     *        If two digit year is greater than or equal to last two digits of current year:
     *          Append a '19' to the front of year.
     *        Else
     *          Append a '20' to the front of year.
     *
     * For yyyymmdd and yymmdd:
     *    Adds dashes.
     * @param value Value of input field when blur event is triggered.
     */
    /**
     * Listens for blur events and handles two digit years for a given date format and type.
     * For mm/dd/yy, dd/mm/yym yy-mm-dd, yymmdd:
     *    If there are 2 digits for year:
     *      If type is recent:
     *        Append a '20' to the front of year.
     *      If type is dob:
     *        If two digit year is greater than or equal to last two digits of current year:
     *          Append a '19' to the front of year.
     *        Else
     *          Append a '20' to the front of year.
     *
     * For yyyymmdd and yymmdd:
     *    Adds dashes.
     * @param {?} value Value of input field when blur event is triggered.
     * @return {?}
     */
    BentoDatepickerConfigDirective.prototype.onBlur = /**
     * Listens for blur events and handles two digit years for a given date format and type.
     * For mm/dd/yy, dd/mm/yym yy-mm-dd, yymmdd:
     *    If there are 2 digits for year:
     *      If type is recent:
     *        Append a '20' to the front of year.
     *      If type is dob:
     *        If two digit year is greater than or equal to last two digits of current year:
     *          Append a '19' to the front of year.
     *        Else
     *          Append a '20' to the front of year.
     *
     * For yyyymmdd and yymmdd:
     *    Adds dashes.
     * @param {?} value Value of input field when blur event is triggered.
     * @return {?}
     */
    function (value) {
        this.formatInput(value);
    };
    /**
     * Handle live format paste events
     */
    /**
     * Handle live format paste events
     * @param {?} e
     * @return {?}
     */
    BentoDatepickerConfigDirective.prototype.onPaste = /**
     * Handle live format paste events
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.platform.isBrowser) {
            /** @type {?} */
            var win = (/** @type {?} */ (this.winRef.nativeWindow));
            /** @type {?} */
            var pastedText = void 0;
            if (win.clipboardData && win.clipboardData.getData) {
                // IE
                pastedText = win.clipboardData.getData('Text');
            }
            else if (e.clipboardData && e.clipboardData.getData) {
                pastedText = e.clipboardData.getData('text/plain');
            }
            e.preventDefault();
            this.formatInput(pastedText);
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoDatepickerConfigDirective.prototype.getLastTwoDigitsOfCurrentYear = /**
     * @private
     * @return {?}
     */
    function () {
        // 2020
        /** @type {?} */
        var currentYear = new Date().getFullYear();
        return currentYear.toString().substr(2, 2);
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    BentoDatepickerConfigDirective.prototype.formatInput = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var dateFormat = this.datepickerConfig.format;
        if (this.PARTIAL_YEAR_REGEX.test(value) && (dateFormat === 'mm/dd/yyyy' || dateFormat === 'dd/mm/yyyy')) {
            /** @type {?} */
            var splitDate = value.split('/');
            if (this.datepickerConfig.type === 'recent') {
                this.el.value = [
                    this.customDatePicker.padNumber(splitDate[0]),
                    this.customDatePicker.padNumber(splitDate[1]),
                    "20" + this.customDatePicker.padNumber(splitDate[2])
                ].join('/');
                this.el.dispatchEvent(new Event('input'));
            }
            else if (this.datepickerConfig.type === 'dob') {
                if (parseInt(splitDate[2], 10) >= parseInt(this.getLastTwoDigitsOfCurrentYear(), 10) + 1) {
                    this.el.value = [
                        this.customDatePicker.padNumber(splitDate[0]),
                        this.customDatePicker.padNumber(splitDate[1]),
                        "19" + this.customDatePicker.padNumber(splitDate[2])
                    ].join('/');
                }
                else {
                    this.el.value = [
                        this.customDatePicker.padNumber(splitDate[0]),
                        this.customDatePicker.padNumber(splitDate[1]),
                        "20" + this.customDatePicker.padNumber(splitDate[2])
                    ].join('/');
                }
                this.el.dispatchEvent(new Event('input'));
            }
        }
        if (dateFormat === 'yy-mm-dd' && this.PARTIAL_YEAR_REGEX_CA.test(value)) {
            /** @type {?} */
            var split = value.split('-');
            if (this.datepickerConfig.type === 'recent') {
                this.el.value = [
                    "20" + this.customDatePicker.padNumber(split[0]),
                    this.customDatePicker.padNumber(split[1]),
                    this.customDatePicker.padNumber(split[2])
                ].join('-');
                this.el.dispatchEvent(new Event('input'));
            }
            else if (this.datepickerConfig.type === 'dob') {
                if (parseInt(split[0], 10) >= parseInt(this.getLastTwoDigitsOfCurrentYear(), 10) + 1) {
                    this.el.value = [
                        "19" + this.customDatePicker.padNumber(split[0]),
                        this.customDatePicker.padNumber(split[1]),
                        this.customDatePicker.padNumber(split[2])
                    ].join('-');
                }
                else {
                    this.el.value = [
                        "20" + this.customDatePicker.padNumber(split[0]),
                        this.customDatePicker.padNumber(split[1]),
                        this.customDatePicker.padNumber(split[2])
                    ].join('-');
                }
                this.el.dispatchEvent(new Event('input'));
            }
        }
        if (dateFormat === 'yy-mm-dd' && this.NO_SLASH_REGEX_6_DIGITS.test(value)) {
            /** @type {?} */
            var year = value.substr(0, 2);
            /** @type {?} */
            var month = value.substr(2, 2);
            /** @type {?} */
            var day = value.substr(4, 2);
            if (this.datepickerConfig.type === 'recent') {
                this.el.value =
                    '20' + year + '-' + this.customDatePicker.padNumber(month) + '-' + this.customDatePicker.padNumber(day);
                this.el.dispatchEvent(new Event('input'));
            }
            else if (this.datepickerConfig.type === 'dob') {
                if (parseInt(year, 10) >= parseInt(this.getLastTwoDigitsOfCurrentYear(), 10) + 1) {
                    this.el.value = [
                        "19" + this.customDatePicker.padNumber(year),
                        this.customDatePicker.padNumber(month),
                        this.customDatePicker.padNumber(day)
                    ].join('-');
                }
                else {
                    this.el.value = [
                        "20" + this.customDatePicker.padNumber(year),
                        this.customDatePicker.padNumber(month),
                        this.customDatePicker.padNumber(day)
                    ].join('-');
                }
                this.el.dispatchEvent(new Event('input'));
            }
        }
        if (this.NO_SLASH_REGEX_8_DIGITS.test(value)) {
            if (dateFormat === 'yy-mm-dd' || dateFormat === 'yyyy-mm-dd') {
                /** @type {?} */
                var year = value.substr(0, 4);
                /** @type {?} */
                var month = value.substr(4, 2);
                /** @type {?} */
                var day = value.substr(6, 2);
                this.el.value = [year, this.customDatePicker.padNumber(month), this.customDatePicker.padNumber(day)].join('-');
                this.el.dispatchEvent(new Event('input'));
            }
            else if (dateFormat === 'mm/dd/yyyy' || dateFormat === 'dd/mm/yyyy') {
                /** @type {?} */
                var year = value.substr(4, 4);
                /** @type {?} */
                var group1 = value.substr(0, 2);
                /** @type {?} */
                var group2 = value.substr(2, 2);
                this.el.value = [this.customDatePicker.padNumber(group1), this.customDatePicker.padNumber(group2), year].join('/');
                this.el.dispatchEvent(new Event('input'));
            }
        }
    };
    /** @nocollapse */
    BentoDatepickerConfigDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoDatePickerConfig },
        { type: BentoDefaultNgbDateParserFormatter },
        { type: WindowRef },
        { type: Platform }
    ]; };
    BentoDatepickerConfigDirective.propDecorators = {
        bentoDatepickerConfig: [{ type: Input }],
        onInput: [{ type: HostListener, args: ['input', ['$event'],] }],
        onBlur: [{ type: HostListener, args: ['blur', ['$event.target.value'],] }],
        onPaste: [{ type: HostListener, args: ['paste', ['$event'],] }]
    };
BentoDatepickerConfigDirective.ɵfac = function BentoDatepickerConfigDirective_Factory(t) { return new (t || BentoDatepickerConfigDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoDatePickerConfig), ɵngcc0.ɵɵdirectiveInject(BentoDefaultNgbDateParserFormatter), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Platform)); };
BentoDatepickerConfigDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoDatepickerConfigDirective, selectors: [["", "bentoDatepickerConfig", ""]], hostBindings: function BentoDatepickerConfigDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function BentoDatepickerConfigDirective_input_HostBindingHandler($event) { return ctx.onInput($event); })("blur", function BentoDatepickerConfigDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("paste", function BentoDatepickerConfigDirective_paste_HostBindingHandler($event) { return ctx.onPaste($event); });
    } }, inputs: { bentoDatepickerConfig: "bentoDatepickerConfig" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NgbDateParserFormatter, useClass: BentoDefaultNgbDateParserFormatter }]), ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDatepickerConfigDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoDatepickerConfig]',
                providers: [{ provide: NgbDateParserFormatter, useClass: BentoDefaultNgbDateParserFormatter }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoDatePickerConfig }, { type: BentoDefaultNgbDateParserFormatter }, { type: WindowRef }, { type: ɵngcc3.Platform }]; }, { onInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onPaste: [{
            type: HostListener,
            args: ['paste', ['$event']]
        }], bentoDatepickerConfig: [{
            type: Input
        }] }); })();
    return BentoDatepickerConfigDirective;
}());
if (false) {
    /**
     * Reference to input element.
     * @type {?}
     * @private
     */
    BentoDatepickerConfigDirective.prototype.el;
    /**
     * Reference to target `NgbInputDatepicker` component.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.bentoDatepickerConfig;
    /**
     * Regex for two digits, ie '12', '05', etc.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.TWO_DIGIT_REGEX;
    /**
     * Regex for two digits, a slash and another 2 digits, ie 04/25, 10/22, 21/05, etc.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.FOUR_DIGIT_REGEX;
    /**
     * Regex for mm/dd/yy or dd/mm/yy.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.PARTIAL_YEAR_REGEX;
    /**
     * Regex for yy-mm-dd.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.PARTIAL_YEAR_REGEX_CA;
    /**
     * Regex for 8 digits dates with no slashes, ie 20201031.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.NO_SLASH_REGEX_8_DIGITS;
    /**
     * Regex for 6 digits dates with no slashes, ie 201031.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.NO_SLASH_REGEX_6_DIGITS;
    /**
     * Regex for 4 digits.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.YEAR_REGEX;
    /**
     * Regex for four digits, a dash and 2 digits, ie 1985-04, 2020-05, etc.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.YEAR_MONTH_REGEX;
    /**
     * Regex for four digits, a dash and 2 digits, ie 1985-04, 2020-05, etc.
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.SHORT_YEAR_MONTH_REGEX;
    /**
     * datePickerConfig
     * @type {?}
     */
    BentoDatepickerConfigDirective.prototype.datepickerConfig;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerConfigDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerConfigDirective.prototype.bentoNgbDatepickerConfig;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerConfigDirective.prototype.customDatePicker;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerConfigDirective.prototype.winRef;
    /**
     * @type {?}
     * @private
     */
    BentoDatepickerConfigDirective.prototype.platform;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-mask/datepicker-mask.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoDatepickerMaskModule = /** @class */ (function () {
    function BentoDatepickerMaskModule() {
    }
BentoDatepickerMaskModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoDatepickerMaskModule });
BentoDatepickerMaskModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoDatepickerMaskModule_Factory(t) { return new (t || BentoDatepickerMaskModule)(); }, providers: [BentoDefaultNgbDateParserFormatter] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoDatepickerMaskModule, { declarations: [BentoDatepickerConfigDirective], exports: [BentoDatepickerConfigDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoDatepickerMaskModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoDatepickerConfigDirective],
                exports: [BentoDatepickerConfigDirective],
                providers: [BentoDefaultNgbDateParserFormatter]
            }]
    }], function () { return []; }, null); })();
    return BentoDatepickerMaskModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/expand-collapse-button-group/expand-collapse-button-group.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This is a UI component to show a standard Expand/Collapse button group
 */
var BentoExpandCollapseButtonGroupComponent = /** @class */ (function () {
    function BentoExpandCollapseButtonGroupComponent() {
        /**
         * HTML "title" attribute for expand all (+) button
         */
        this.expandAllTitle = undefined;
        /**
         * HTML "title" attribute for collapse all (-) button
         */
        this.collapseAllTitle = undefined;
        /**
         * Event emitter for when expand (+) is clicked
         */
        this.expand = new EventEmitter();
        /**
         * Event emitter for when collapse (-) is clicked
         */
        this.collapse = new EventEmitter();
    }
    /**
     * Callback when expand all is clicked
     */
    /**
     * Callback when expand all is clicked
     * @return {?}
     */
    BentoExpandCollapseButtonGroupComponent.prototype._onExpandAll = /**
     * Callback when expand all is clicked
     * @return {?}
     */
    function () {
        this.expand.emit();
    };
    /**
     * Callback when collapse all is clicked
     */
    /**
     * Callback when collapse all is clicked
     * @return {?}
     */
    BentoExpandCollapseButtonGroupComponent.prototype._onCollapseAll = /**
     * Callback when collapse all is clicked
     * @return {?}
     */
    function () {
        this.collapse.emit();
    };
    BentoExpandCollapseButtonGroupComponent.propDecorators = {
        expandAllTitle: [{ type: Input }],
        collapseAllTitle: [{ type: Input }],
        expand: [{ type: Output }],
        collapse: [{ type: Output }]
    };
BentoExpandCollapseButtonGroupComponent.ɵfac = function BentoExpandCollapseButtonGroupComponent_Factory(t) { return new (t || BentoExpandCollapseButtonGroupComponent)(); };
BentoExpandCollapseButtonGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoExpandCollapseButtonGroupComponent, selectors: [["bento-expand-collapse-button-group"]], inputs: { expandAllTitle: "expandAllTitle", collapseAllTitle: "collapseAllTitle" }, outputs: { expand: "expand", collapse: "collapse" }, decls: 9, vars: 12, consts: [["type", "button", 1, "btn", "btn-outline-primary", "btn-xs", "btn-icon", 3, "ngbTooltip", "click"], ["aria-hidden", "true", 1, "bento-icon-plus-plain"], [1, "bento-expand-divider"], ["aria-hidden", "true", 1, "bento-icon-minus-plain"]], template: function BentoExpandCollapseButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function BentoExpandCollapseButtonGroupComponent_Template_button_click_0_listener() { return ctx._onExpandAll(); });
        ɵngcc0.ɵɵpipe(1, "bentoTranslate");
        ɵngcc0.ɵɵpipe(2, "bentoTranslate");
        ɵngcc0.ɵɵelement(3, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 0);
        ɵngcc0.ɵɵlistener("click", function BentoExpandCollapseButtonGroupComponent_Template_button_click_5_listener() { return ctx._onCollapseAll(); });
        ɵngcc0.ɵɵpipe(6, "bentoTranslate");
        ɵngcc0.ɵɵpipe(7, "bentoTranslate");
        ɵngcc0.ɵɵelement(8, "i", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ctx.expandAllTitle || ɵngcc0.ɵɵpipeBind1(2, 6, "BENTO_UI_EXPAND_ALL"));
        ɵngcc0.ɵɵattribute("aria-label", ctx.expandAllTitle || ɵngcc0.ɵɵpipeBind1(1, 4, "BENTO_UI_EXPAND_ALL"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ctx.collapseAllTitle || ɵngcc0.ɵɵpipeBind1(7, 10, "BENTO_UI_COLLAPSE_ALL"));
        ɵngcc0.ɵɵattribute("aria-label", ctx.collapseAllTitle || ɵngcc0.ɵɵpipeBind1(6, 8, "BENTO_UI_COLLAPSE_ALL"));
    } }, directives: [BentoFocusMonitorDirective, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective], pipes: [BentoTranslatePipe], styles: [".bento-expand-collapse-button-group,bento-expand-collapse-button-group{display:block;border-bottom-width:1px;border-bottom-style:solid}.bento-expand-collapse-button-group.no-border,bento-expand-collapse-button-group.no-border{border:none}.bento-expand-collapse-button-group .btn-xs,bento-expand-collapse-button-group .btn-xs{font-size:.75rem}.bento-expand-collapse-button-group .bento-expand-divider,bento-expand-collapse-button-group .bento-expand-divider{display:inline-block;font-size:1.429rem;line-height:0}.bento-expand-collapse-button-group .bento-expand-divider:before,bento-expand-collapse-button-group .bento-expand-divider:before{content:\"/\";margin:0 4px}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoExpandCollapseButtonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'bento-expand-collapse-button-group',
                template: "<button\n  class=\"btn btn-outline-primary btn-xs btn-icon\"\n  type=\"button\"\n  (click)=\"_onExpandAll()\"\n  [attr.aria-label]=\"expandAllTitle || ('BENTO_UI_EXPAND_ALL' | bentoTranslate)\"\n  ngbTooltip=\"{{ expandAllTitle || ('BENTO_UI_EXPAND_ALL' | bentoTranslate) }}\"\n>\n  <i class=\"bento-icon-plus-plain\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-expand-divider\"></div>\n<button\n  class=\"btn btn-outline-primary btn-xs btn-icon\"\n  type=\"button\"\n  (click)=\"_onCollapseAll()\"\n  [attr.aria-label]=\"collapseAllTitle || ('BENTO_UI_COLLAPSE_ALL' | bentoTranslate)\"\n  ngbTooltip=\"{{ collapseAllTitle || ('BENTO_UI_COLLAPSE_ALL' | bentoTranslate) }}\"\n>\n  <i class=\"bento-icon-minus-plain\" aria-hidden=\"true\"></i>\n</button>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bento-expand-collapse-button-group,bento-expand-collapse-button-group{display:block;border-bottom-width:1px;border-bottom-style:solid}.bento-expand-collapse-button-group.no-border,bento-expand-collapse-button-group.no-border{border:none}.bento-expand-collapse-button-group .btn-xs,bento-expand-collapse-button-group .btn-xs{font-size:.75rem}.bento-expand-collapse-button-group .bento-expand-divider,bento-expand-collapse-button-group .bento-expand-divider{display:inline-block;font-size:1.429rem;line-height:0}.bento-expand-collapse-button-group .bento-expand-divider:before,bento-expand-collapse-button-group .bento-expand-divider:before{content:\"/\";margin:0 4px}"]
            }]
    }], function () { return []; }, { expandAllTitle: [{
            type: Input
        }], collapseAllTitle: [{
            type: Input
        }], expand: [{
            type: Output
        }], collapse: [{
            type: Output
        }] }); })();
    return BentoExpandCollapseButtonGroupComponent;
}());
if (false) {
    /**
     * HTML "title" attribute for expand all (+) button
     * @type {?}
     */
    BentoExpandCollapseButtonGroupComponent.prototype.expandAllTitle;
    /**
     * HTML "title" attribute for collapse all (-) button
     * @type {?}
     */
    BentoExpandCollapseButtonGroupComponent.prototype.collapseAllTitle;
    /**
     * Event emitter for when expand (+) is clicked
     * @type {?}
     */
    BentoExpandCollapseButtonGroupComponent.prototype.expand;
    /**
     * Event emitter for when collapse (-) is clicked
     * @type {?}
     */
    BentoExpandCollapseButtonGroupComponent.prototype.collapse;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/expand-collapse-button-group/expand-collapse-button-group.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoExpandCollapseButtonGroupModule = /** @class */ (function () {
    function BentoExpandCollapseButtonGroupModule() {
    }
BentoExpandCollapseButtonGroupModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoExpandCollapseButtonGroupModule });
BentoExpandCollapseButtonGroupModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoExpandCollapseButtonGroupModule_Factory(t) { return new (t || BentoExpandCollapseButtonGroupModule)(); }, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoExpandCollapseButtonGroupModule, { declarations: function () { return [BentoExpandCollapseButtonGroupComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule]; }, exports: function () { return [BentoExpandCollapseButtonGroupComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoExpandCollapseButtonGroupModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoTranslateModule,
                    BentoFocusMonitorModule,
                    NgbTooltipModule,
                    BentoNgbTooltipSupportModule
                ],
                declarations: [BentoExpandCollapseButtonGroupComponent],
                exports: [BentoExpandCollapseButtonGroupComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoExpandCollapseButtonGroupModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/file-selector/file-selector.services.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Injectable BentoFileSelectorComponentServices to supper file selector component
 */
var BentoFileSelectorComponentServices = /** @class */ (function () {
    function BentoFileSelectorComponentServices(r, sanitizer) {
        this.r = r;
        this.sanitizer = sanitizer;
    }
    /**
     * Parse a File out from the file list and forward it back to the callback function
     *
     */
    /**
     * Parse a File out from the file list and forward it back to the callback function
     *
     * @param {?} originalFiles
     * @param {?} newFiles
     * @param {?} fileTypes
     * @param {?} multiple
     * @param {?} appendOnSelection
     * @param {?} accepted
     * @param {?} element
     * @param {?} errorFiles
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.parseFiles = /**
     * Parse a File out from the file list and forward it back to the callback function
     *
     * @param {?} originalFiles
     * @param {?} newFiles
     * @param {?} fileTypes
     * @param {?} multiple
     * @param {?} appendOnSelection
     * @param {?} accepted
     * @param {?} element
     * @param {?} errorFiles
     * @return {?}
     */
    function (originalFiles, newFiles, fileTypes, multiple, appendOnSelection, accepted, element, errorFiles) {
        // Ignore non-file selection
        if (typeof newFiles === 'undefined') {
            return;
        }
        // Determinie how many files are allowed
        /** @type {?} */
        var newFileArray = multiple ? newFiles : [newFiles[0]];
        /** @type {?} */
        var filteredFiles = this.filterFiles(originalFiles, newFileArray, fileTypes, accepted, element, errorFiles);
        /** @type {?} */
        var selectedFiles = filteredFiles.selected;
        // Determine if it needs to append to the existing file array or not
        if (appendOnSelection && Array.isArray(originalFiles) && multiple) {
            newFileArray = originalFiles.concat(selectedFiles);
        }
        else {
            // Add a file reference to scope
            newFileArray = selectedFiles;
        }
        return {
            allFiles: newFileArray,
            newFiles: selectedFiles,
            duplicatedFiles: filteredFiles.duplicated
        };
    };
    /**
     * Determine if the two files are identical
     */
    /**
     * Determine if the two files are identical
     * @param {?} f1
     * @param {?} f2
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.fileEqual = /**
     * Determine if the two files are identical
     * @param {?} f1
     * @param {?} f2
     * @return {?}
     */
    function (f1, f2) {
        return f1.lastModified === f2.lastModified && f1.name === f2.name && f1.size === f2.size;
    };
    /**
     * Determine if a file exist in a file array
     */
    /**
     * Determine if a file exist in a file array
     * @param {?} fileArray
     * @param {?} file
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.hasFileAtIndex = /**
     * Determine if a file exist in a file array
     * @param {?} fileArray
     * @param {?} file
     * @return {?}
     */
    function (fileArray, file) {
        for (var i = 0, len = fileArray.length; i < len; i++) {
            if (this.fileEqual(fileArray[i], file)) {
                return i;
            }
        }
        return -1;
    };
    /**
     * Determine if the first element in files has the right file type
     */
    /**
     * Determine if the first element in files has the right file type
     * @param {?} file
     * @param {?} fileTypes
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.isValidFileType = /**
     * Determine if the first element in files has the right file type
     * @param {?} file
     * @param {?} fileTypes
     * @return {?}
     */
    function (file, fileTypes) {
        /** @type {?} */
        var _ft = !!fileTypes ? fileTypes.trim() : '';
        /** @type {?} */
        var fileNameBreakDown = file.name.split('.');
        /** @type {?} */
        var fileExtension = fileNameBreakDown[fileNameBreakDown.length - 1];
        // This is no filetype specified
        if (typeof _ft === 'undefined' || _ft.length === 0) {
            return true;
        }
        // Check if this file extension exists in fileTypes string
        if (fileTypes.search(fileExtension) !== -1) {
            return true;
        }
        // File extension does not exist in the fileTypes
        return false;
    };
    /**
     * is file accepted
     */
    /**
     * is file accepted
     * @param {?} file
     * @param {?} accepted
     * @param {?} element
     * @param {?} errorFiles
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.isFileAccepted = /**
     * is file accepted
     * @param {?} file
     * @param {?} accepted
     * @param {?} element
     * @param {?} errorFiles
     * @return {?}
     */
    function (file, accepted, element, errorFiles) {
        /** @type {?} */
        var fileAccepted = true;
        if (!file.type && file.size % 4096 === 0) {
            // This is a folder
            file.displayType = 'folder';
            fileAccepted = false;
        }
        else if (file.type === 'unknown') {
            file.displayType = 'unknown';
            file.name = 'file or folder';
            fileAccepted = false;
        }
        else {
            file.displayType = 'file';
        }
        if (fileAccepted) {
            // this file type is not accepted
            /** @type {?} */
            var indexOfExt = file.name.lastIndexOf('.');
            /** @type {?} */
            var selectedFileExtension = indexOfExt < 0 ? '' : file.name.slice(indexOfExt).toLowerCase();
            // list only the files that are accepted
            if (accepted && accepted.length && accepted.indexOf(selectedFileExtension) === -1) {
                fileAccepted = false;
            }
        }
        this.updateFileNotAcceptedUI(file, fileAccepted, element, errorFiles);
        return fileAccepted;
    };
    /**
     *
     * param File
     * returns Boolean true if its a folder else false
     */
    /**
     *
     * param File
     * returns Boolean true if its a folder else false
     * @param {?} file
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.isFolder = /**
     *
     * param File
     * returns Boolean true if its a folder else false
     * @param {?} file
     * @return {?}
     */
    function (file) {
        /** @type {?} */
        var folder = false;
        if (!file.type && file.size % 4096 === 0) {
            // This is a folder
            file.displayType = 'folder';
            folder = true;
        }
        else if (file.type === 'unknown') {
            file.displayType = 'unknown';
            file.name = 'file or folder';
            folder = true;
        }
        return folder;
    };
    /**
     * updateFileNotAcceptedUI
     */
    /**
     * updateFileNotAcceptedUI
     * @param {?} file
     * @param {?} fileAccepted
     * @param {?} element
     * @param {?} errorFiles
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.updateFileNotAcceptedUI = /**
     * updateFileNotAcceptedUI
     * @param {?} file
     * @param {?} fileAccepted
     * @param {?} element
     * @param {?} errorFiles
     * @return {?}
     */
    function (file, fileAccepted, element, errorFiles) {
        /** @type {?} */
        var fsContainer = element;
        /** @type {?} */
        var fsErrorEl = element.querySelector('.bento-file-selector-error');
        if (fileAccepted) {
            // do not reset any old errors, if present
            if (errorFiles.length === 0) {
                if (fsContainer) {
                    fsContainer.classList.remove('selector-has-error');
                }
                if (fsErrorEl) {
                    fsErrorEl.classList.remove('show');
                }
            }
        }
        else {
            if (fsContainer) {
                fsContainer.classList.add('selector-has-error');
            }
            if (fsErrorEl) {
                fsErrorEl.classList.add('show');
            }
            // push the new file
            errorFiles.push(file);
        }
    };
    /**
     * Construct a new HTMLInputElement
     */
    /**
     * Construct a new HTMLInputElement
     * @param {?} accept
     * @param {?} multiple
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.getFileInput = /**
     * Construct a new HTMLInputElement
     * @param {?} accept
     * @param {?} multiple
     * @return {?}
     */
    function (accept, multiple) {
        accept = this.sanitizer.sanitize(SecurityContext.HTML, accept);
        /** @type {?} */
        var attrAccept = accept && accept.length > 1 ? ' accept="' + accept + '"' : '';
        /** @type {?} */
        var fileInputStr = '<input type="file" name="fileselect_' +
            performance.now() +
            '"' +
            ' class="sr-only"' +
            ' tabindex="-1"' +
            attrAccept +
            (multiple ? ' multiple' : '') +
            ' />';
        /** @type {?} */
        var divWrapper = (/** @type {?} */ (this.r.createElement('div')));
        this.r.setProperty(divWrapper, 'innerHTML', fileInputStr);
        return (/** @type {?} */ (divWrapper.children[0]));
    };
    /**
     * Return a valid file list from a FileList
     */
    /**
     * Return a valid file list from a FileList
     * @private
     * @param {?=} originalFileList
     * @param {?=} fileList
     * @param {?=} fileTypes
     * @param {?=} accepted
     * @param {?=} element
     * @param {?=} errorFiles
     * @return {?}
     */
    BentoFileSelectorComponentServices.prototype.filterFiles = /**
     * Return a valid file list from a FileList
     * @private
     * @param {?=} originalFileList
     * @param {?=} fileList
     * @param {?=} fileTypes
     * @param {?=} accepted
     * @param {?=} element
     * @param {?=} errorFiles
     * @return {?}
     */
    function (originalFileList, fileList, fileTypes, accepted, element, errorFiles) {
        var e_1, _a;
        if (originalFileList === void 0) { originalFileList = []; }
        /** @type {?} */
        var selectedFiles = [];
        /** @type {?} */
        var duplicatedFiles = [];
        /** @type {?} */
        var originalList = originalFileList || [];
        try {
            for (var _b = __values((/** @type {?} */ (fileList))), _c = _b.next(); !_c.done; _c = _b.next()) {
                var file = _c.value;
                /** @type {?} */
                var dupeIndex = this.hasFileAtIndex(originalFileList, file);
                if (dupeIndex > -1) {
                    duplicatedFiles.push(originalFileList[dupeIndex]);
                }
                else if (!this.isFolder(file) &&
                    this.isFileAccepted(file, accepted, element, errorFiles) &&
                    this.isValidFileType(file, fileTypes) &&
                    originalList.indexOf(file) === -1) {
                    // only add the current file when it's the valid file type
                    selectedFiles.push(file);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return {
            selected: selectedFiles,
            duplicated: duplicatedFiles
        };
    };
    /** @nocollapse */
    BentoFileSelectorComponentServices.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: DomSanitizer }
    ]; };
BentoFileSelectorComponentServices.ɵfac = function BentoFileSelectorComponentServices_Factory(t) { return new (t || BentoFileSelectorComponentServices)(ɵngcc0.ɵɵinject(ɵngcc0.Renderer2), ɵngcc0.ɵɵinject(ɵngcc5.DomSanitizer)); };
BentoFileSelectorComponentServices.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoFileSelectorComponentServices, factory: function (t) { return BentoFileSelectorComponentServices.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFileSelectorComponentServices, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc5.DomSanitizer }]; }, null); })();
    return BentoFileSelectorComponentServices;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoFileSelectorComponentServices.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoFileSelectorComponentServices.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/animate.trigger.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Default Fade In Out Metadata
 * @type {?}
 */
var FadeInOut = FadeInOutFunc('FadeInOut', 100);
/** @type {?} */
var FadeInOutLong = FadeInOutFunc('FadeInOutLong', 300);
/**
 * Function to delcare Animation Trigger Metadata by its given trigger name and duration
 * @param {?} triggerName
 * @param {?} duration
 * @return {?}
 */
function FadeInOutFunc(triggerName, duration) {
    return trigger(triggerName, [
        state('void', style({ opacity: 0 })),
        transition('void => *', [animate(duration)]),
        transition('* => void', [animate(duration)])
    ]);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/file-selector/file-selector.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BENTO_FILE_SELECTOR_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoFileSelectorComponent; })),
    multi: true
};
/** @type {?} */
var BENTO_FILE_SELECTOR_ID = 0;
var BentoFileSelectorComponent = /** @class */ (function () {
    /**
     */
    function BentoFileSelectorComponent(elementRef, services, r, cd, windowRef) {
        this.services = services;
        this.r = r;
        this.cd = cd;
        /**
         * Event emitter when at least a file is selected from the browser, a `BentoFileSelectorEvent` object will be passed
         * into its callback
         */
        this.fileSelect = new EventEmitter();
        /**
         * Event emitter when at least a file has already been selected, a `BentoFileSelectorEvent` object will be passed
         * into its callback
         */
        this.duplicateSelect = new EventEmitter();
        /**
         * Event emitter when a file is removed from the file list, a `BentoFileSelectorEvent` object will be passed
         * into its callback
         */
        this.fileRemove = new EventEmitter();
        /**
         * File types that are allowed and displayed in file explorers. If the value of the type attribute is file,
         * this attribute indicates the types of files that the server accepts; otherwise it is ignored.
         * The value must be a comma-separated list of unique content type specifiers:
         *
         *   * A file extension starting with the STOP character (`U+002E`). (E.g.: `'.jpg,.png,.doc'`)
         *   * A valid MIME type with no extensions
         *   * `audio/*` representing sound files HTML5
         *   * `video/*` representing video files HTML5
         *   * `image/*` representing image files HTML5
         *
         * Note: The support of this attribute is browser specific.
         * Please refer to this [link](http://caniuse.com/#search=accept) for the browsers that it currently supports.
         *
         */
        this.accept = '';
        /**
         * Allow appending of files to current selection
         */
        this.appendOnSelection = false;
        /**
         * Disable file selector during upload.
         */
        this.disableDuringUpload = true;
        /**
         * Allow multiple file selection
         */
        this.multiple = false;
        /**
         * Show selected files in File Selector Container
         */
        this.showSelectedFiles = false;
        /**
         * Show file size info
         */
        this.showFileSize = false;
        /**
         * show percentage label on the progress bar
         */
        this.showProgressPercentage = false;
        /**
         * UID of this component
         */
        this.uid = "bui-file-selector-" + BENTO_FILE_SELECTOR_ID++;
        /**
         * Model to gage the current upload percentage
         */
        this._uploadProgressPercentage = -1;
        /**
         * List of currently disabled file objects
         */
        this._disabledFiles = [];
        /**
         * List of the file progress
         */
        this._fileProgressList = [];
        this._errorFiles = [];
        /**
         * Sequence counter for animation
         */
        this._animateSquenceCounter = 0;
        /**
         * Disabled flag
         */
        this._isDisabled = false;
        this._el = elementRef.nativeElement;
        this._changeFunction = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.touchedFunction = (/**
         * @return {?}
         */
        function () { });
        this.document = windowRef.nativeDocument;
    }
    Object.defineProperty(BentoFileSelectorComponent.prototype, "_fileSelectorInProgress", {
        get: /**
         * @return {?}
         */
        function () {
            return this._uploadProgressPercentage > 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * When ngModel is udpated
     */
    /**
     * When ngModel is udpated
     * @param {?} v
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.writeValue = /**
     * When ngModel is udpated
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._fileList = v;
        this._disabledFiles = [];
        this._fileProgressList = [];
        this._animateSquenceCounter = 0;
        this.cd.markForCheck();
    };
    /**
     * When disabled state is updated
     */
    /**
     * When disabled state is updated
     * @param {?} v
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.setDisabledState = /**
     * When disabled state is updated
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._isDisabled = v;
        this.cd.markForCheck();
    };
    /**
     * Referencing ngModel change function
     */
    /**
     * Referencing ngModel change function
     * @param {?} fn
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.registerOnChange = /**
     * Referencing ngModel change function
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._changeFunction = fn;
    };
    /**
     * Referencing component touch event
     */
    /**
     * Referencing component touch event
     * @param {?} fn
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.registerOnTouched = /**
     * Referencing component touch event
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.touchedFunction = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.cd.markForCheck();
        });
    };
    /**
     * Initial setups when the view is ready
     */
    /**
     * Initial setups when the view is ready
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.ngAfterViewInit = /**
     * Initial setups when the view is ready
     * @return {?}
     */
    function () {
        var _this = this;
        // Make sure that an input field is in the component
        this.refreshFileInput();
        // Assign upload progress
        if (this.uploadProgress) {
            this._uploadProgressSubscription = this.uploadProgress.subscribe((/**
             * @param {?} p
             * @return {?}
             */
            function (p) {
                _this.updateFileUploadProgress(p);
            }));
        }
        this._progressbarEl = this._el.querySelector('.progress > div');
        // this._accepted = (this.accept && this.accept.length) ? this.accept.replace(/ /g, '').toLowerCase().split(',') :
        // undefined;
        this._accepted = this.parseAcceptFileList(this.accept);
    };
    /**
     * Tasks to execute when this component is destroyed
     */
    /**
     * Tasks to execute when this component is destroyed
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.ngOnDestroy = /**
     * Tasks to execute when this component is destroyed
     * @return {?}
     */
    function () {
        if (this._uploadProgressSubscription) {
            this._uploadProgressSubscription.unsubscribe();
        }
        if (this._fileInputChangeSubscription) {
            this._fileInputChangeSubscription.unsubscribe();
        }
        this.cd.detach();
    };
    /**
     * Callback when the browse button is clicked
     */
    /**
     * Callback when the browse button is clicked
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onBrowseClick = /**
     * Callback when the browse button is clicked
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this._isDisabled) {
            // this component is disabled
            return;
        }
        this._fileInput.click();
        if (e) {
            // Stop the button to make form submissions
            e.stopPropagation();
            e.preventDefault();
        }
    };
    /**
     * On file remove click
     */
    /**
     * On file remove click
     * @param {?} index
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onRemoveClick = /**
     * On file remove click
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (this._isDisabled) {
            // this component is disabled
            return;
        }
        /** @type {?} */
        var fileToBeRemoved = this._fileList.splice(index, 1);
        this._removedFilename = fileToBeRemoved.name;
        // Focus on an aria label for screen reader
        this._postRemovalMessage.nativeElement.focus();
        // Emit remove event
        this.fileRemove.emit({ files: fileToBeRemoved });
        // Call ngModel change
        this._changeFunction(this._fileList.slice());
        // Decrease counter by 1
        this._animateSquenceCounter--;
        // Refresh input for the next batch of selections
        this.refreshFileInput();
    };
    /**
     * Animate next file to enter the view
     */
    /**
     * Animate next file to enter the view
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._animateNext = /**
     * Animate next file to enter the view
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        if (e.toState === 'in') {
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this._animateSquenceCounter++;
                _this.cd.markForCheck();
            }), 100);
        }
    };
    /**
     * Callback
     */
    /**
     * Callback
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onFileInputChange = /**
     * Callback
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var fileList = ((/** @type {?} */ (e.target))).files;
        if (fileList.length > 0) {
            this.parseAndUpdateFiles(fileList);
        }
        // We need to refresh the input every time when there is an interaction with the file input
        this.refreshFileInput();
        // Detect changes
        this.cd.markForCheck();
    };
    /**
     * Update current file upload progress with a given BentoFileProgress array
     */
    /**
     * Update current file upload progress with a given BentoFileProgress array
     * @private
     * @param {?} progressList
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.updateFileUploadProgress = /**
     * Update current file upload progress with a given BentoFileProgress array
     * @private
     * @param {?} progressList
     * @return {?}
     */
    function (progressList) {
        var e_1, _a;
        var _this = this;
        if (progressList && progressList.length > 0) {
            if (!Array.isArray(progressList)) {
                throw new Error('Bento File Selector: incorrect "upload-progress" data structure.\nUse' + ' [<BentoFileProgress>{...},...]');
            }
            else if (progressList.length > 0) {
                /** @type {?} */
                var totalFileSize = 0;
                /** @type {?} */
                var totalPosition = 0;
                /** @type {?} */
                var fileObj = void 0;
                /** @type {?} */
                var fileIndex = void 0;
                try {
                    for (var progressList_1 = __values(progressList), progressList_1_1 = progressList_1.next(); !progressList_1_1.done; progressList_1_1 = progressList_1.next()) {
                        var progress = progressList_1_1.value;
                        // calculate the percentage and file disabled states
                        fileObj = progress;
                        fileIndex = this._fileList.indexOf(fileObj.file);
                        if (fileIndex > -1) {
                            totalFileSize += fileObj.file.size;
                            totalPosition += fileObj.bytes;
                            this._disabledFiles[fileIndex] = fileObj.file.size > fileObj.bytes;
                            this._fileProgressList[fileIndex] = Math.floor((fileObj.bytes / fileObj.file.size) * 100);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (progressList_1_1 && !progressList_1_1.done && (_a = progressList_1.return)) _a.call(progressList_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                this._uploadProgressPercentage = Math.floor((totalPosition / totalFileSize) * 100);
                if (this._uploadProgressPercentage >= 100 ||
                    totalFileSize === 0 // No more files
                ) {
                    // remove all progress references
                    this._fileProgressList = [];
                    this.r.removeAttribute(this._progressbarEl, 'aria-live');
                    // reset progress bar after hiding
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this._uploadProgressPercentage = 0;
                    }), 100);
                }
            }
        }
        else {
            this._uploadProgressPercentage = 0;
            this._disabledFiles = [];
        }
        this.cd.markForCheck();
    };
    /**
     * Parse and update file list
     */
    /**
     * Parse and update file list
     * @private
     * @param {?} files
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.parseAndUpdateFiles = /**
     * Parse and update file list
     * @private
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        this._errorFiles = [];
        /** @type {?} */
        var parsedFileListObj = this.services.parseFiles(this._fileList, files, this.fileType, this.multiple, this.appendOnSelection, this._accepted, this._el, this._errorFiles);
        if (this._errorFiles.length) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                /** @type {?} */
                var errorContainers = _this._el.querySelectorAll('.bento-file-selector-error');
                if (errorContainers) {
                    for (var i = 0; i < errorContainers.length; i++) {
                        _this.r.appendChild(_this._el.parentElement, errorContainers[i]);
                    }
                }
            }));
        }
        else {
            /** @type {?} */
            var errorContainers = this._el.parentElement.querySelectorAll('.bento-file-selector-error');
            if (errorContainers) {
                for (var i = 0; i < errorContainers.length; i++) {
                    this.r.removeChild(this._el.parentElement, errorContainers[i]);
                }
            }
        }
        if (parsedFileListObj.newFiles.length > 0) {
            // When there is a new file that is selected
            this._fileList = parsedFileListObj.allFiles;
            // Fire callbacks
            this.fileSelect.emit({ files: parsedFileListObj.newFiles });
            // update ngModel
            this._changeFunction(this._fileList);
            if (!this.appendOnSelection || !this.multiple) {
                // Renew lists for rendering
                this._disabledFiles = [];
                this._fileProgressList = [];
                this._animateSquenceCounter = 0;
            }
            if (this.showSelectedFiles) {
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    // focus to the first file label
                    /** @type {?} */
                    var firstFileNameEl = _this._el.querySelector('.bento-file-selector-filename');
                    firstFileNameEl && firstFileNameEl.focus();
                }), 100);
            }
        }
        if (parsedFileListObj.duplicatedFiles.length > 0) {
            // Emit when there are duplicated selection
            this.duplicateSelect.emit({ files: parsedFileListObj.duplicatedFiles });
        }
    };
    /**
     * @private
     * @param {?} sAcceptTypes
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.parseAcceptFileList = /**
     * @private
     * @param {?} sAcceptTypes
     * @return {?}
     */
    function (sAcceptTypes) {
        var e_2, _a, e_3, _b;
        /** @type {?} */
        var consolidatedAcceptFileTypeList;
        /** @type {?} */
        var acceptedTypeLists = sAcceptTypes && sAcceptTypes.length
            ? sAcceptTypes
                .replace(/ /g, '')
                .toLowerCase()
                .split(',')
            : undefined;
        if (!acceptedTypeLists) {
            return undefined;
        }
        /** @type {?} */
        var acceptedType;
        try {
            for (var acceptedTypeLists_1 = __values(acceptedTypeLists), acceptedTypeLists_1_1 = acceptedTypeLists_1.next(); !acceptedTypeLists_1_1.done; acceptedTypeLists_1_1 = acceptedTypeLists_1.next()) {
                acceptedType = acceptedTypeLists_1_1.value;
                // if the accept string is a MIME type, then prepare the list, else convert string to array
                /** @type {?} */
                var mime = this.getMime(acceptedType);
                if (mime && mime.type) {
                    /** @type {?} */
                    var acceptedFileList = void 0;
                    switch (mime && mime.type) {
                        case 'audio':
                            acceptedFileList =
                                mime.extension === '*'
                                    ? ['.aac', '.mid', '.midi', '.oga', '.wav', '.weba', '.3gp', '.3g2']
                                    : [mime.extension];
                            break;
                        case 'video':
                            acceptedFileList =
                                mime.extension === '*' ? ['.avi', '.mpeg', '.ogv', '.webm', '.3gp', '.3g2'] : [mime.extension];
                            break;
                        case 'image':
                            acceptedFileList =
                                mime.extension === '*'
                                    ? ['.bmp', '.gif', '.ico', '.jpeg', '.jpg', '.png', '.svg', '.tif', '.tiff', '.webp']
                                    : [mime.extension];
                            break;
                        case 'text':
                            acceptedFileList =
                                mime.extension === '*' ? ['.css', '.csv', '.html', '.calendar', '.plain'] : [mime.extension];
                            break;
                        default:
                            break;
                    }
                    if (acceptedFileList) {
                        !consolidatedAcceptFileTypeList && (consolidatedAcceptFileTypeList = []);
                        try {
                            for (var acceptedFileList_1 = (e_3 = void 0, __values(acceptedFileList)), acceptedFileList_1_1 = acceptedFileList_1.next(); !acceptedFileList_1_1.done; acceptedFileList_1_1 = acceptedFileList_1.next()) {
                                var fileList = acceptedFileList_1_1.value;
                                consolidatedAcceptFileTypeList.push(fileList);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (acceptedFileList_1_1 && !acceptedFileList_1_1.done && (_b = acceptedFileList_1.return)) _b.call(acceptedFileList_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                    }
                }
                else {
                    !consolidatedAcceptFileTypeList && (consolidatedAcceptFileTypeList = []);
                    consolidatedAcceptFileTypeList.push(acceptedType);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (acceptedTypeLists_1_1 && !acceptedTypeLists_1_1.done && (_a = acceptedTypeLists_1.return)) _a.call(acceptedTypeLists_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return consolidatedAcceptFileTypeList;
    };
    /**
     * @private
     * @param {?} sAccept
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.getMime = /**
     * @private
     * @param {?} sAccept
     * @return {?}
     */
    function (sAccept) {
        /** @type {?} */
        var mime;
        if (sAccept && sAccept.length) {
            /** @type {?} */
            var index = sAccept.indexOf('/');
            if (index !== -1) {
                /** @type {?} */
                var extension = sAccept.slice(index + 1, sAccept.length);
                mime = { type: sAccept.slice(0, index), extension: extension === '*' ? extension : '.' + extension };
            }
        }
        return mime;
    };
    /**
     * Callback when files are dropped into the zone
     */
    /**
     * Callback when files are dropped into the zone
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onDrop = /**
     * Callback when files are dropped into the zone
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        e.preventDefault();
        e.stopPropagation();
        if ((!this.appendOnSelection && this._uploadProgressPercentage > -1) || this._isDisabled) {
            // cannot drop and an upload is in progress and there is not appendOnSelection allowed
            // OR this component is disabled
            return;
        }
        this._draggedOver = false;
        /** @type {?} */
        var dataTranfer = this._getDataTransfer(e);
        if (!dataTranfer) {
            return;
        }
        /**
         * IE 11
         * Drag and Drop for Folders behaves little different in IE. Every
         * drop method callback will be supplied with event . This event
         * argument is little different for IE when a folder is dropped.
         * Basically the file list (inside event) comes empty, where as in
         * Chrome or FF, the file list shows up with the folder name and a
         * default size of 4096.
         */
        if (dataTranfer && dataTranfer.files && !dataTranfer.files.length) {
            /** @type {?} */
            var file = { type: 'unknown' };
            this._errorFiles = [];
            this.services.isFileAccepted(file, '', this._el, this._errorFiles);
            setTimeout((/**
             * @return {?}
             */
            function () {
                /** @type {?} */
                var errorContainers = _this._el.querySelectorAll('.bento-file-selector-error');
                if (errorContainers) {
                    for (var i = 0; i < errorContainers.length; i++) {
                        _this.r.appendChild(_this._el.parentElement, errorContainers[i]);
                    }
                }
            }));
            return;
        }
        this.parseAndUpdateFiles(dataTranfer.files);
        for (var i = 0; i < dataTranfer.files.length; i++) {
            /** @type {?} */
            var file = dataTranfer.files[i];
            if (!file.type && file.size % 4096 === 0) {
                this._fileInput.click();
                break;
            }
        }
        // Not sure if drop events are automatically mark for change
        // we are going to mark it just in case
        this.cd.markForCheck();
    };
    /**
     * Callback when files are dragged over
     */
    /**
     * Callback when files are dragged over
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onDragEnter = /**
     * Callback when files are dragged over
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ((!this.appendOnSelection && this._uploadProgressPercentage > -1) || this._isDisabled) {
            // cannot drop and an upload is in progress and there is not appendOnSelection allowed
            // OR this component is disabled
            return;
        }
        /** @type {?} */
        var dataTranfer = this._getDataTransfer(e);
        if (!dataTranfer) {
            return;
        }
        dataTranfer.dropEffect = 'copy';
    };
    /**
     * Callback to constantly check dragging state (every 350ms by browser)
     * This method is REQUIRED in order for 'drop' to work
     */
    /**
     * Callback to constantly check dragging state (every 350ms by browser)
     * This method is REQUIRED in order for 'drop' to work
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onDragOver = /**
     * Callback to constantly check dragging state (every 350ms by browser)
     * This method is REQUIRED in order for 'drop' to work
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ((!this.appendOnSelection && this._uploadProgressPercentage > -1) || this._isDisabled) {
            // cannot drop and an upload is in progress and there is not appendOnSelection allowed
            // OR this component is disabled
            return;
        }
        /** @type {?} */
        var dataTranfer = this._getDataTransfer(e);
        if (!dataTranfer) {
            return;
        }
        this._draggedOver = true;
    };
    /**
     * Handles when files are dragged out of the zone without dropping
     */
    /**
     * Handles when files are dragged out of the zone without dropping
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onDragLeave = /**
     * Handles when files are dragged out of the zone without dropping
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this._draggedOver = false;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._onFocusout = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            if (!_this._el.contains(_this.document.activeElement)) {
                // Fire touch function when focused out
                _this.touchedFunction();
            }
        }));
    };
    /**
     * Refresh file input element
     */
    /**
     * Refresh file input element
     * @private
     * @return {?}
     */
    BentoFileSelectorComponent.prototype.refreshFileInput = /**
     * Refresh file input element
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var newInput = this.services.getFileInput(this.accept, this.multiple);
        /** @type {?} */
        var newInputChangeSubscription;
        newInputChangeSubscription = fromEvent(newInput, 'change').subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            _this._onFileInputChange(e);
        }));
        if (this._fileInput) {
            // Remove the old file selector
            if (this._fileInput.parentElement) {
                this.r.removeChild(this._fileInput.parentElement, this._fileInput);
            }
            this._fileInputChangeSubscription.unsubscribe();
        }
        // Update global object references
        this._fileInput = newInput;
        this._fileInputChangeSubscription = newInputChangeSubscription;
        // Add the element into the component DOM tree
        this.r.appendChild(this._el, this._fileInput);
        // Need to refresh UI based on the new data
        this.cd.markForCheck();
    };
    /**
     * Get a dataTransfer object from DragEvent
     */
    /**
     * Get a dataTransfer object from DragEvent
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoFileSelectorComponent.prototype._getDataTransfer = /**
     * Get a dataTransfer object from DragEvent
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        return e.dataTransfer || e.originalEvent.dataTransfer;
    };
    /** @nocollapse */
    BentoFileSelectorComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoFileSelectorComponentServices },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: WindowRef }
    ]; };
    BentoFileSelectorComponent.propDecorators = {
        fileSelect: [{ type: Output }],
        duplicateSelect: [{ type: Output }],
        fileRemove: [{ type: Output }],
        accept: [{ type: Input }],
        appendOnSelection: [{ type: Input }],
        browseButtonLabel: [{ type: Input }],
        disableDuringUpload: [{ type: Input }],
        dropFieldLabel: [{ type: Input }],
        fileType: [{ type: Input }],
        multiple: [{ type: Input }],
        showSelectedFiles: [{ type: Input }],
        showFileSize: [{ type: Input }],
        showProgressPercentage: [{ type: Input }, { type: HostBinding, args: ['class.bento-file-selector-progress-percentage',] }],
        _fileSelectorInProgress: [{ type: HostBinding, args: ['class.bento-file-selector-in-progress',] }],
        uploadProgress: [{ type: Input }],
        _draggedOver: [{ type: HostBinding, args: ['class.dragover',] }],
        _postRemovalMessage: [{ type: ViewChild, args: ['postRemovalMessage', { static: true },] }],
        _isDisabled: [{ type: HostBinding, args: ['class.disabled',] }],
        _onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }],
        _onDragEnter: [{ type: HostListener, args: ['dragenter', ['$event'],] }],
        _onDragOver: [{ type: HostListener, args: ['dragover', ['$event'],] }],
        _onDragLeave: [{ type: HostListener, args: ['dragleave', ['$event'],] }],
        _onFocusout: [{ type: HostListener, args: ['focusout', ['$event'],] }]
    };
BentoFileSelectorComponent.ɵfac = function BentoFileSelectorComponent_Factory(t) { return new (t || BentoFileSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoFileSelectorComponentServices), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoFileSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoFileSelectorComponent, selectors: [["bento-file-selector"]], viewQuery: function BentoFileSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c17, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._postRemovalMessage = _t.first);
    } }, hostVars: 8, hostBindings: function BentoFileSelectorComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("drop", function BentoFileSelectorComponent_drop_HostBindingHandler($event) { return ctx._onDrop($event); })("dragenter", function BentoFileSelectorComponent_dragenter_HostBindingHandler($event) { return ctx._onDragEnter($event); })("dragover", function BentoFileSelectorComponent_dragover_HostBindingHandler($event) { return ctx._onDragOver($event); })("dragleave", function BentoFileSelectorComponent_dragleave_HostBindingHandler($event) { return ctx._onDragLeave($event); })("focusout", function BentoFileSelectorComponent_focusout_HostBindingHandler($event) { return ctx._onFocusout($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bento-file-selector-progress-percentage", ctx.showProgressPercentage)("disabled", ctx._isDisabled)("bento-file-selector-in-progress", ctx._fileSelectorInProgress)("dragover", ctx._draggedOver);
    } }, inputs: { accept: "accept", appendOnSelection: "appendOnSelection", disableDuringUpload: "disableDuringUpload", multiple: "multiple", showSelectedFiles: "showSelectedFiles", showFileSize: "showFileSize", showProgressPercentage: "showProgressPercentage", browseButtonLabel: "browseButtonLabel", dropFieldLabel: "dropFieldLabel", fileType: "fileType", uploadProgress: "uploadProgress" }, outputs: { fileSelect: "fileSelect", duplicateSelect: "duplicateSelect", fileRemove: "fileRemove" }, features: [ɵngcc0.ɵɵProvidersFeature([BENTO_FILE_SELECTOR_VALUE_ACCESSOR, BentoFileSelectorComponentServices])], decls: 30, vars: 33, consts: [["tabindex", "0", 1, "sr-only"], [1, "header"], [1, "btn", "btn-primary", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-right"], [1, "clearfix"], [1, "filename-container"], ["tabindex", "-1", 1, "sr-only", "bento-file-selector-post-removal-message"], ["postRemovalMessage", ""], [3, "ngIf"], [1, "bento-progressbar"], ["aria-live", "polite", "type", "success", 3, "value", "striped"], [1, "sr-only"], [1, "bento-file-selector-progress-percentage-label"], ["class", "dragover-overlay", 4, "ngIf"], ["class", "bento-file-selector-error", 4, "ngFor", "ngForOf"], ["class", "btn btn-outline-primary bento-file-selector-filename btn-sm", "tabindex", "0", 3, "disabled", "loading", 4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "btn", "btn-outline-primary", "bento-file-selector-filename", "btn-sm"], [3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], [1, "bento-file-selector-file-progress-bg", 3, "ngStyle"], [1, "dragover-overlay"], [1, "dragover-overlay-label"], [1, "bento-file-selector-error"], ["aria-hidden", "true", 1, "bento-icon-warning"], [1, "selector-error-message"], [3, "innerHTML"], [3, "innerHTML", 4, "ngIf"]], template: function BentoFileSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 1);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 2);
        ɵngcc0.ɵɵlistener("click", function BentoFileSelectorComponent_Template_button_click_7_listener($event) { return ctx._onBrowseClick($event); });
        ɵngcc0.ɵɵpipe(8, "bentoTranslate");
        ɵngcc0.ɵɵelementStart(9, "span");
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(13, "div", 4);
        ɵngcc0.ɵɵelementStart(14, "div", 5);
        ɵngcc0.ɵɵelementStart(15, "div", 6, 7);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(19, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(20, BentoFileSelectorComponent_ng_template_20_Template, 1, 1, "ng-template", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 9);
        ɵngcc0.ɵɵelement(22, "ngb-progressbar", 10);
        ɵngcc0.ɵɵelementStart(23, "div", 11);
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 12);
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(28, BentoFileSelectorComponent_div_28_Template, 4, 4, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(29, BentoFileSelectorComponent_div_29_Template, 11, 15, "div", 14);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 15, "BENTO_UI_FILE_SELECTOR_DESCRIPTION"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(6, 17, "BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL", ctx.dropFieldLabel));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.appendOnSelection && ctx._uploadProgressPercentage > 0 || ctx._isDisabled);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(8, 20, "BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(11, 22, "BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL", ctx.browseButtonLabel));
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(18, 25, ɵngcc0.ɵɵpipeBind1(19, 29, "BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE"), "_FILE_NAME_", ctx._removedFilename), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSelectedFiles);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("value", ctx._uploadProgressPercentage)("striped", true);
        ɵngcc0.ɵɵattribute("aria-describedby", "upload-message-" + ctx.uid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", "upload-message-" + ctx.uid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(25, 31, "BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_MESSAGE"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ctx._uploadProgressPercentage, "%");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._draggedOver);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._errorFiles);
    } }, directives: [BentoFocusMonitorDirective, ɵngcc7.NgIf, ɵngcc4.NgbProgressbar, ɵngcc7.NgForOf, ɵngcc7.NgStyle], pipes: [BentoTranslatePipe,
        BentoStringReplacePipe,
        BentoFileSizePipe], styles: ["bento-file-selector{position:relative;width:100%;padding:50px 0 20px;display:block;text-align:center;border-width:1px;border-style:dashed;overflow:hidden}bento-file-selector.disabled{pointer-events:none}bento-file-selector .bento-progressbar{transition:bottom .2s,opacity .2s;position:absolute;width:auto;overflow:hidden;opacity:0}bento-file-selector .bento-file-selector-progress-percentage-label{display:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;opacity:0;transition:opacity .2s}bento-file-selector.bento-file-selector-in-progress .bento-file-selector-progress-percentage-label,bento-file-selector.bento-file-selector-in-progress .bento-progressbar{opacity:1}bento-file-selector.bento-file-selector-progress-percentage .bento-file-selector-progress-percentage-label{position:absolute;width:35px;font-size:.9em;text-align:right;display:block}bento-file-selector>button{margin-top:10px}bento-file-selector .header{display:block}bento-file-selector.dragover button,bento-file-selector.dragover div,bento-file-selector.dragover input,bento-file-selector.dragover span{pointer-events:none}bento-file-selector .dragover-overlay{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;transition:opacity .1s}bento-file-selector .filename-container{position:relative;display:block;padding:10px;max-width:100%;min-height:52px}bento-file-selector .filename-container .bento-file-selector-filename{position:relative;margin:5px 5px 5px 0;text-transform:none;padding-right:20px;white-space:nowrap}[dir=rtl] bento-file-selector .filename-container .bento-file-selector-filename{margin:5px 0 5px 5px;padding-right:7.3px;padding-left:20px}bento-file-selector .filename-container .bento-file-selector-filename span{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis}bento-file-selector .filename-container .bento-file-selector-filename>button{border-radius:7px;border:none;background:0 0;height:14px;width:14px;line-height:14px;text-align:center;position:absolute;right:4px;top:3px;padding:0;display:flex;align-items:center;justify-content:center}[dir=rtl] bento-file-selector .filename-container .bento-file-selector-filename>button{right:auto;left:4px}bento-file-selector .filename-container .bento-file-selector-filename>button i{font-size:.65rem;margin:0;width:100%}bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading{border-color:transparent!important;overflow:hidden;transform:translateZ(0)}bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading[disabled]{pointer-events:none}bento-file-selector .filename-container .bento-file-selector-filename.loading .bento-file-selector-file-progress-bg{display:block}bento-file-selector ngb-progressbar{display:block;width:100%}bento-file-selector ngb-progressbar .progress-bar-striped{transition:width .2s,background-position 2s}.dragover-overlay-label{position:absolute;font-size:2em;width:100%;top:50%;font-weight:700;transform:translateY(-50%)}.bento-file-selector-file-progress-bg{display:none;position:absolute;top:0;left:0;bottom:0;width:0;transition:width .5s}[dir=rtl] .bento-file-selector-file-progress-bg{right:0;left:auto}.selector-has-error{border-width:1px;border-style:solid}.bento-file-selector-error{display:flex;margin-top:20px}.bento-file-selector-error .bento-icon-warning,.bento-file-selector-error .selector-error-message{align-self:flex-start}.bento-file-selector-error .selector-error-message{padding-left:5px}[dir=rtl] .bento-file-selector-error .selector-error-message{padding-right:5px}"], encapsulation: 2, data: { animation: [
            trigger('fileFadeIn', [
                state('in', style({ opacity: 1, transform: 'scale(1)' })),
                state('hidden', style({ opacity: 0, transform: 'scale(1.1)' })),
                state('void', style({ opacity: 0, transform: 'scale(0.9)' })),
                transition('hidden => in', [animate(200)]),
                transition('void => in', [style({ transform: 'scale(1.1)' }), animate(200)])
            ]),
            FadeInOut
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFileSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'bento-file-selector',
                template: "<div>\n  <div class=\"sr-only\" tabindex=\"0\">\n    {{ 'BENTO_UI_FILE_SELECTOR_DESCRIPTION' | bentoTranslate }}\n  </div>\n  <span class=\"header\">{{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL' | bentoTranslate: dropFieldLabel }}</span>\n  <button\n    class=\"btn btn-primary\"\n    (click)=\"_onBrowseClick($event)\"\n    [attr.aria-label]=\"'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON' | bentoTranslate\"\n    [disabled]=\"(!appendOnSelection && _uploadProgressPercentage > 0) || _isDisabled\"\n  >\n    <span>{{ 'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL' | bentoTranslate: browseButtonLabel }}</span>\n    <i class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"clearfix\"></div>\n  <div class=\"filename-container\">\n    <div #postRemovalMessage class=\"sr-only bento-file-selector-post-removal-message\" tabindex=\"-1\">\n      {{\n        'BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE' | bentoTranslate | bentoStringReplace: '_FILE_NAME_':_removedFilename\n      }}\n    </div>\n    <ng-template [ngIf]=\"showSelectedFiles\">\n      <div\n        class=\"btn btn-outline-primary bento-file-selector-filename btn-sm\"\n        *ngFor=\"let file of _fileList; let i = index\"\n        [class.disabled]=\"_disabledFiles[i] && disableDuringUpload\"\n        [class.loading]=\"_disabledFiles[i]\"\n        [attr.rel]=\"'file_' + i\"\n        [attr.aria-busy]=\"_disabledFiles[i]\"\n        [attr.aria-label]=\"\n          ('BENTO_UI_FILE_SELECTOR_FILE_NAME'\n            | bentoTranslate\n            | bentoStringReplace: '_FILE_NAME_':file.name\n            | bentoStringReplace: '_NUM_FILES_':_fileList.length\n            | bentoStringReplace: '_FILE_NUMBER_':i + 1) +\n          ' ' +\n          (showFileSize ? '(' + (file.size | bentoFileSizeFilter) + ')' : '') +\n          ' ' +\n          (_fileProgressList[i] >= 0 && _fileProgressList[i] < 100\n            ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS' | bentoTranslate)\n            : _fileProgressList[i]\n            ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE' | bentoTranslate)\n            : '')\n        \"\n        [@fileFadeIn]=\"_animateSquenceCounter >= i ? 'in' : 'hidden'\"\n        (@fileFadeIn.start)=\"_animateNext($event)\"\n        tabindex=\"0\"\n      >\n        <span>{{ file.name }}{{ showFileSize ? ' (' + (file.size | bentoFileSizeFilter) + ')' : '' }}</span>\n\n        <button\n          (click)=\"_onRemoveClick(i)\"\n          [attr.aria-label]=\"\n            'BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON' | bentoTranslate | bentoStringReplace: '_FILE_NAME_':file.name\n          \"\n          [disabled]=\"_disabledFiles[i] && disableDuringUpload\"\n        >\n          <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n        </button>\n        <div class=\"bento-file-selector-file-progress-bg\" [ngStyle]=\"{width: _fileProgressList[i] + '%'}\"></div>\n      </div>\n    </ng-template>\n  </div>\n  <div class=\"bento-progressbar\">\n    <ngb-progressbar\n      aria-live=\"polite\"\n      [value]=\"_uploadProgressPercentage\"\n      [striped]=\"true\"\n      type=\"success\"\n      [attr.aria-describedby]=\"'upload-message-' + uid\"\n    ></ngb-progressbar>\n    <div class=\"sr-only\" [attr.id]=\"'upload-message-' + uid\">\n      {{ 'BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_MESSAGE' | bentoTranslate }}\n    </div>\n  </div>\n  <div class=\"bento-file-selector-progress-percentage-label\">{{ _uploadProgressPercentage }}%</div>\n  <div [@FadeInOut] *ngIf=\"_draggedOver\" class=\"dragover-overlay\">\n    <div class=\"dragover-overlay-label\">\n      {{ 'BENTO_UI_FILE_SELECTOR_DROP_FILED_ACTION_LABEL' | bentoTranslate }}\n    </div>\n  </div>\n</div>\n<div class=\"bento-file-selector-error\" *ngFor=\"let file of _errorFiles\">\n  <span class=\"sr-only\">{{ 'BENTO_UI_FILE_SELECTOR_A11Y_CAUTION' | bentoTranslate }}</span>\n  <i class=\"bento-icon-warning\" aria-hidden=\"true\"></i>\n  <span class=\"selector-error-message\">\n    <span\n      [innerHTML]=\"\n        'BENTO_UI_FILE_SELECTOR_FILE_ERROR'\n          | bentoTranslate\n          | bentoStringReplace: '_DISPLAY_TYPE_':file.displayType\n          | bentoStringReplace: '_NAME_':file.name\n      \"\n    ></span>\n    <span\n      *ngIf=\"accept\"\n      [innerHTML]=\"'BENTO_UI_FILE_SELECTOR_FILE_EXT_ERROR' | bentoTranslate | bentoStringReplace: '_ACCEPT_':accept\"\n    ></span>\n  </span>\n</div>\n",
                providers: [BENTO_FILE_SELECTOR_VALUE_ACCESSOR, BentoFileSelectorComponentServices],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('fileFadeIn', [
                        state('in', style({ opacity: 1, transform: 'scale(1)' })),
                        state('hidden', style({ opacity: 0, transform: 'scale(1.1)' })),
                        state('void', style({ opacity: 0, transform: 'scale(0.9)' })),
                        transition('hidden => in', [animate(200)]),
                        transition('void => in', [style({ transform: 'scale(1.1)' }), animate(200)])
                    ]),
                    FadeInOut
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-file-selector{position:relative;width:100%;padding:50px 0 20px;display:block;text-align:center;border-width:1px;border-style:dashed;overflow:hidden}bento-file-selector.disabled{pointer-events:none}bento-file-selector .bento-progressbar{transition:bottom .2s,opacity .2s;position:absolute;width:auto;overflow:hidden;opacity:0}bento-file-selector .bento-file-selector-progress-percentage-label{display:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;opacity:0;transition:opacity .2s}bento-file-selector.bento-file-selector-in-progress .bento-file-selector-progress-percentage-label,bento-file-selector.bento-file-selector-in-progress .bento-progressbar{opacity:1}bento-file-selector.bento-file-selector-progress-percentage .bento-file-selector-progress-percentage-label{position:absolute;width:35px;font-size:.9em;text-align:right;display:block}bento-file-selector>button{margin-top:10px}bento-file-selector .header{display:block}bento-file-selector.dragover button,bento-file-selector.dragover div,bento-file-selector.dragover input,bento-file-selector.dragover span{pointer-events:none}bento-file-selector .dragover-overlay{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;transition:opacity .1s}bento-file-selector .filename-container{position:relative;display:block;padding:10px;max-width:100%;min-height:52px}bento-file-selector .filename-container .bento-file-selector-filename{position:relative;margin:5px 5px 5px 0;text-transform:none;padding-right:20px;white-space:nowrap}[dir=rtl] bento-file-selector .filename-container .bento-file-selector-filename{margin:5px 0 5px 5px;padding-right:7.3px;padding-left:20px}bento-file-selector .filename-container .bento-file-selector-filename span{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis}bento-file-selector .filename-container .bento-file-selector-filename>button{border-radius:7px;border:none;background:0 0;height:14px;width:14px;line-height:14px;text-align:center;position:absolute;right:4px;top:3px;padding:0;display:flex;align-items:center;justify-content:center}[dir=rtl] bento-file-selector .filename-container .bento-file-selector-filename>button{right:auto;left:4px}bento-file-selector .filename-container .bento-file-selector-filename>button i{font-size:.65rem;margin:0;width:100%}bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading{border-color:transparent!important;overflow:hidden;transform:translateZ(0)}bento-file-selector .filename-container .bento-file-selector-filename.btn.btn-outline-primary.loading[disabled]{pointer-events:none}bento-file-selector .filename-container .bento-file-selector-filename.loading .bento-file-selector-file-progress-bg{display:block}bento-file-selector ngb-progressbar{display:block;width:100%}bento-file-selector ngb-progressbar .progress-bar-striped{transition:width .2s,background-position 2s}.dragover-overlay-label{position:absolute;font-size:2em;width:100%;top:50%;font-weight:700;transform:translateY(-50%)}.bento-file-selector-file-progress-bg{display:none;position:absolute;top:0;left:0;bottom:0;width:0;transition:width .5s}[dir=rtl] .bento-file-selector-file-progress-bg{right:0;left:auto}.selector-has-error{border-width:1px;border-style:solid}.bento-file-selector-error{display:flex;margin-top:20px}.bento-file-selector-error .bento-icon-warning,.bento-file-selector-error .selector-error-message{align-self:flex-start}.bento-file-selector-error .selector-error-message{padding-left:5px}[dir=rtl] .bento-file-selector-error .selector-error-message{padding-right:5px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoFileSelectorComponentServices }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: WindowRef }]; }, { fileSelect: [{
            type: Output
        }], duplicateSelect: [{
            type: Output
        }], fileRemove: [{
            type: Output
        }], accept: [{
            type: Input
        }], appendOnSelection: [{
            type: Input
        }], disableDuringUpload: [{
            type: Input
        }], multiple: [{
            type: Input
        }], showSelectedFiles: [{
            type: Input
        }], showFileSize: [{
            type: Input
        }], showProgressPercentage: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.bento-file-selector-progress-percentage']
        }], _isDisabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }], _fileSelectorInProgress: [{
            type: HostBinding,
            args: ['class.bento-file-selector-in-progress']
        }], _onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], _draggedOver: [{
            type: HostBinding,
            args: ['class.dragover']
        }], _onDragEnter: [{
            type: HostListener,
            args: ['dragenter', ['$event']]
        }], _onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], _onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], _onFocusout: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], browseButtonLabel: [{
            type: Input
        }], dropFieldLabel: [{
            type: Input
        }], fileType: [{
            type: Input
        }], uploadProgress: [{
            type: Input
        }], _postRemovalMessage: [{
            type: ViewChild,
            args: ['postRemovalMessage', { static: true }]
        }] }); })();
    return BentoFileSelectorComponent;
}());
if (false) {
    /**
     * Event emitter when at least a file is selected from the browser, a `BentoFileSelectorEvent` object will be passed
     * into its callback
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.fileSelect;
    /**
     * Event emitter when at least a file has already been selected, a `BentoFileSelectorEvent` object will be passed
     * into its callback
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.duplicateSelect;
    /**
     * Event emitter when a file is removed from the file list, a `BentoFileSelectorEvent` object will be passed
     * into its callback
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.fileRemove;
    /**
     * File types that are allowed and displayed in file explorers. If the value of the type attribute is file,
     * this attribute indicates the types of files that the server accepts; otherwise it is ignored.
     * The value must be a comma-separated list of unique content type specifiers:
     *
     *   * A file extension starting with the STOP character (`U+002E`). (E.g.: `'.jpg,.png,.doc'`)
     *   * A valid MIME type with no extensions
     *   * `audio/*` representing sound files HTML5
     *   * `video/*` representing video files HTML5
     *   * `image/*` representing image files HTML5
     *
     * Note: The support of this attribute is browser specific.
     * Please refer to this [link](http://caniuse.com/#search=accept) for the browsers that it currently supports.
     *
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.accept;
    /**
     * Allow appending of files to current selection
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.appendOnSelection;
    /**
     * Text to override the default browse button 'Browse for File'
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.browseButtonLabel;
    /**
     * Disable file selector during upload.
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.disableDuringUpload;
    /**
     * Text to override the default drop field label 'Drag a File Here or'
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.dropFieldLabel;
    /**
     * Define allowed file types
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.fileType;
    /**
     * Allow multiple file selection
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.multiple;
    /**
     * Show selected files in File Selector Container
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.showSelectedFiles;
    /**
     * Show file size info
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.showFileSize;
    /**
     * show percentage label on the progress bar
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.showProgressPercentage;
    /**
     * Show visual feedback of upload progress. The array must be formatted in this fashion:
     * [{ file: myUploadingFile, position:uploadedBytes}, ...]
     *
     *   * file (file) - file blob object that is currently being uploaded
     *   * position (number) - bytes that has uploaded to the server
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.uploadProgress;
    /**
     * UID of this component
     * @type {?}
     */
    BentoFileSelectorComponent.prototype.uid;
    /**
     * Main file list of this component
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._fileList;
    /**
     * Model to gage the current upload percentage
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._uploadProgressPercentage;
    /**
     * Upload progress subscription
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._uploadProgressSubscription;
    /**
     * File name that has just been removed
     *
     * Used for screen reader
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._removedFilename;
    /**
     * List of currently disabled file objects
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._disabledFiles;
    /**
     * List of the file progress
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._fileProgressList;
    /**
     * File input HTMLElement
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._fileInput;
    /** @type {?} */
    BentoFileSelectorComponent.prototype._errorFiles;
    /**
     * Status to show of there is a dragover
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._draggedOver;
    /**
     * Sequence counter for animation
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._animateSquenceCounter;
    /**
     * Element reference to 'postRemovalMessage' DIV
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._postRemovalMessage;
    /**
     * Disabled flag
     * @type {?}
     */
    BentoFileSelectorComponent.prototype._isDisabled;
    /**
     * HTMLElement pointer of this component
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype._el;
    /**
     * NGB Progress Bar bar HTMLElement
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype._progressbarEl;
    /**
     * Current File input HTMLElement `change` subscription
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype._fileInputChangeSubscription;
    /**
     * Array that contains list of accepted file types
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype._accepted;
    /**
     * Control Value Accessor funcions
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype._changeFunction;
    /**
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype.touchedFunction;
    /**
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype.services;
    /**
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoFileSelectorComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/file-selector/file-progress.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Interface for file upload progress
 * @record
 */
function BentoFileProgress() { }
if (false) {
    /**
     * Reference to the file
     * @type {?}
     */
    BentoFileProgress.prototype.file;
    /**
     * Bytes that are uploaded / processed
     * @type {?}
     */
    BentoFileProgress.prototype.bytes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/file-selector/file-selector.event.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BentoFileSelectorEvent() { }
if (false) {
    /**
     * Main file list reference
     * @type {?}
     */
    BentoFileSelectorEvent.prototype.files;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/file-selector/file-selector.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoFileSelectorModule = /** @class */ (function () {
    function BentoFileSelectorModule() {
    }
BentoFileSelectorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoFileSelectorModule });
BentoFileSelectorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoFileSelectorModule_Factory(t) { return new (t || BentoFileSelectorModule)(); }, imports: [[
            FormsModule,
            CommonModule,
            // BrowserAnimationsModule,
            BentoTranslateModule,
            NgbProgressbarModule,
            BentoUtilsModule,
            BentoFocusMonitorModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoFileSelectorModule, { declarations: function () { return [BentoFileSelectorComponent]; }, imports: function () { return [FormsModule,
        CommonModule,
        BentoTranslateModule,
        NgbProgressbarModule,
        BentoUtilsModule,
        BentoFocusMonitorModule]; }, exports: function () { return [BentoFileSelectorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFileSelectorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    CommonModule,
                    // BrowserAnimationsModule,
                    BentoTranslateModule,
                    NgbProgressbarModule,
                    BentoUtilsModule,
                    BentoFocusMonitorModule
                ],
                declarations: [BentoFileSelectorComponent],
                exports: [BentoFileSelectorComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoFileSelectorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/global-header/global-header-change.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A directive to help with responsive behavior in Global Header.
 *
 * The directive will hide or show the global header's `.topbar-middle` element
 * depending on how narrow or wide the global header's dimensions are on browser resize.
 * Use the event payload's boolean property `menuHidden` to determine whether to
 * hide or display the off canvas menu button or take any other desired actions.
 *
 * To hide or display the menu button in the [Off Canvas Menu](/components/off-canvas-menu),
 * you can set its `menuButtonIsHidden` attribute to true or false.
 */
var BentoGlobalHeaderChangeDirective = /** @class */ (function () {
    function BentoGlobalHeaderChangeDirective(elementRef, bentoNotfication) {
        var _this = this;
        this.elementRef = elementRef;
        /**
         * Event emitter when header has resized. Payload returns an object with a
         * boolean property called `menuHidden` set to true if items in `.topbar-middle` elements
         * are hidden.
         */
        this.headerResize = new EventEmitter();
        this.totalWidth = 0;
        bentoNotfication.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () {
            _this.onResize();
        }));
    }
    /**
     * @return {?}
     */
    BentoGlobalHeaderChangeDirective.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var leftElement = _this.elementRef.nativeElement.querySelector('.topbar-left');
            /** @type {?} */
            var leftWidth = leftElement ? leftElement.getBoundingClientRect().width : 0;
            /** @type {?} */
            var rightElement = _this.elementRef.nativeElement.querySelector('.topbar-right');
            /** @type {?} */
            var rightWidth = rightElement ? rightElement.getBoundingClientRect().width : 0;
            _this.middleElement = _this.elementRef.nativeElement.querySelector('.topbar-middle');
            /** @type {?} */
            var middleWidth = _this.middleElement.getBoundingClientRect().width;
            _this.totalWidth = leftWidth + rightWidth + middleWidth;
            _this.onResize();
        }));
    };
    /**
     * @return {?}
     */
    BentoGlobalHeaderChangeDirective.prototype.onResize = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var elementWidth = this.elementRef.nativeElement.getBoundingClientRect().width;
        if (this.totalWidth > elementWidth) {
            this.hideMenu();
        }
        else {
            this.showMenu();
        }
    };
    /**
     * @return {?}
     */
    BentoGlobalHeaderChangeDirective.prototype.hideMenu = /**
     * @return {?}
     */
    function () {
        this.middleElement.classList.add('hidden');
        this.headerResize.emit({
            menuHidden: true
        });
    };
    /**
     * @return {?}
     */
    BentoGlobalHeaderChangeDirective.prototype.showMenu = /**
     * @return {?}
     */
    function () {
        this.middleElement.classList.remove('hidden');
        this.headerResize.emit({
            menuHidden: false
        });
    };
    /** @nocollapse */
    BentoGlobalHeaderChangeDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification }
    ]; };
    BentoGlobalHeaderChangeDirective.propDecorators = {
        headerResize: [{ type: Output, args: ['bentoGlobalHeaderChange',] }]
    };
BentoGlobalHeaderChangeDirective.ɵfac = function BentoGlobalHeaderChangeDirective_Factory(t) { return new (t || BentoGlobalHeaderChangeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification)); };
BentoGlobalHeaderChangeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoGlobalHeaderChangeDirective, selectors: [["", "bentoGlobalHeaderChange", ""]], outputs: { headerResize: "bentoGlobalHeaderChange" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoGlobalHeaderChangeDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoGlobalHeaderChange]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoNotification }]; }, { headerResize: [{
            type: Output,
            args: ['bentoGlobalHeaderChange']
        }] }); })();
    return BentoGlobalHeaderChangeDirective;
}());
if (false) {
    /**
     * Event emitter when header has resized. Payload returns an object with a
     * boolean property called `menuHidden` set to true if items in `.topbar-middle` elements
     * are hidden.
     * @type {?}
     */
    BentoGlobalHeaderChangeDirective.prototype.headerResize;
    /**
     * @type {?}
     * @private
     */
    BentoGlobalHeaderChangeDirective.prototype.middleElement;
    /**
     * @type {?}
     * @private
     */
    BentoGlobalHeaderChangeDirective.prototype.totalWidth;
    /**
     * @type {?}
     * @private
     */
    BentoGlobalHeaderChangeDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/global-header/global-header.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoGlobalHeaderModule = /** @class */ (function () {
    function BentoGlobalHeaderModule() {
    }
BentoGlobalHeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoGlobalHeaderModule });
BentoGlobalHeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoGlobalHeaderModule_Factory(t) { return new (t || BentoGlobalHeaderModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoGlobalHeaderModule, { declarations: [BentoGlobalHeaderChangeDirective], exports: [BentoGlobalHeaderChangeDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoGlobalHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [BentoGlobalHeaderChangeDirective],
                exports: [BentoGlobalHeaderChangeDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoGlobalHeaderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/megamenu/megamenu-default.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoMegamenuDefaultComponent = /** @class */ (function () {
    /**
     */
    function BentoMegamenuDefaultComponent(r, elementRef, bentoNotification, windowRef, dropdown) {
        this.r = r;
        this.bentoNotification = bentoNotification;
        this.dropdown = dropdown;
        /**
         * Main items data model to store Bento Megamenu content
         */
        this.items = [];
        this.document = windowRef.nativeDocument;
        this.el = elementRef.nativeElement;
    }
    Object.defineProperty(BentoMegamenuDefaultComponent.prototype, "widthElRef", {
        /**
         * Reference element is used to make this megamenu to be self aware on its width and
         */
        set: /**
         * Reference element is used to make this megamenu to be self aware on its width and
         * @param {?} elRef
         * @return {?}
         */
        function (elRef) {
            if (elRef) {
                this.widthRefEl = elRef.nativeElement ? elRef.nativeElement : elRef;
            }
            else {
                this.widthRefEl = this.document.querySelector('body');
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Implementation of AfterViewInit
     * Need to get the width reference element here
     */
    /**
     * Implementation of AfterViewInit
     * Need to get the width reference element here
     * @return {?}
     */
    BentoMegamenuDefaultComponent.prototype.ngAfterViewInit = /**
     * Implementation of AfterViewInit
     * Need to get the width reference element here
     * @return {?}
     */
    function () {
        this.parentEl = this.el.parentElement;
        // Default the widthRefEl
        if (!this.appendToEl) {
            this.widthRefEl = this.widthRefEl || this.document.querySelector('body');
            this.toggleEl = this.findToggleEl();
            this.maxWidth = !!this.maxWidth && this.maxWidth > 0 ? this.maxWidth : Number.POSITIVE_INFINITY;
        }
    };
    /**
     * Implement OnInit
     */
    /**
     * Implement OnInit
     * @return {?}
     */
    BentoMegamenuDefaultComponent.prototype.ngOnInit = /**
     * Implement OnInit
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.appendToEl) {
            // Only setup layout management when BentoAppendTo is not used
            this.r.addClass(this.el.parentElement, 'bento-megamenu-rendering');
            this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe((/**
             * @return {?}
             */
            function () {
                _this.updateMenuLayout();
            }));
            this.dropdownOpenSub = this.dropdown.openChange.subscribe((/**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                if (v) {
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this.updateMenuLayout();
                        _this.r.removeClass(_this.el.parentElement, 'bento-megamenu-rendering');
                    }));
                }
                else {
                    _this.r.setStyle(_this.el, 'left', 'auto');
                }
            }));
        }
    };
    /**
     * Implement OnDestroy
     */
    /**
     * Implement OnDestroy
     * @return {?}
     */
    BentoMegamenuDefaultComponent.prototype.ngOnDestroy = /**
     * Implement OnDestroy
     * @return {?}
     */
    function () {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
        if (this.dropdownOpenSub) {
            this.dropdownOpenSub.unsubscribe();
        }
    };
    /**
     * @param {?} e
     * @param {?} item
     * @param {?} column
     * @return {?}
     */
    BentoMegamenuDefaultComponent.prototype.onMenuClick = /**
     * @param {?} e
     * @param {?} item
     * @param {?} column
     * @return {?}
     */
    function (e, item, column) {
        if (item.disabled || column.disabled) {
            return;
        }
        // Call item click events
        if (item.action) {
            item.action(item);
        }
        if (!(item.anchor && item.anchor.href)) {
            e.preventDefault();
        }
    };
    /**
     * Update Megamenu layout based on widthRefEl width
     */
    /**
     * Update Megamenu layout based on widthRefEl width
     * @protected
     * @return {?}
     */
    BentoMegamenuDefaultComponent.prototype.updateMenuLayout = /**
     * Update Megamenu layout based on widthRefEl width
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var maxWidth = this.widthRefEl.clientWidth;
        this.r.setStyle(this.parentEl, 'max-width', maxWidth + 'px');
        this.parentEl.querySelector('.column-flex-container').setAttribute('style', 'display: flex;');
        if (this.widthRefEl.clientWidth <= this.parentEl.clientWidth + this.parentEl.getBoundingClientRect().left) {
            // The follow a11y code from task [BENTO-3575] generates regression on fundamental megamenu UI
            // leaving it out until further investigation
            // this.parentEl.querySelector('.column-flex-container').setAttribute('style', 'display: block;');
        }
    };
    /**
     * Since dropdown doesn't expose toggleElement, we need to manually look for it
     */
    /**
     * Since dropdown doesn't expose toggleElement, we need to manually look for it
     * @protected
     * @return {?}
     */
    BentoMegamenuDefaultComponent.prototype.findToggleEl = /**
     * Since dropdown doesn't expose toggleElement, we need to manually look for it
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var dEl;
        /** @type {?} */
        var elRef = this.el.parentElement;
        /** @type {?} */
        var counter = 0;
        // find ngbDropdown;
        while (elRef.parentElement && elRef.parentElement.tagName !== 'BODY' && counter < 20) {
            if (elRef.hasAttribute('ngbDropdown')) {
                dEl = elRef;
                break;
            }
            elRef = elRef.parentElement;
            counter++;
        }
        if (dEl) {
            return (/** @type {?} */ (dEl.querySelector('[ngbDropdownToggle]')));
        }
        else {
            throw new Error('Megamenu: [ngbDropdown] is missing');
        }
    };
    /** @nocollapse */
    BentoMegamenuDefaultComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: BentoNotification },
        { type: WindowRef },
        { type: NgbDropdown, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] }
    ]; };
    BentoMegamenuDefaultComponent.propDecorators = {
        items: [{ type: Input }],
        hTagRank: [{ type: Input }],
        widthElRef: [{ type: Input }],
        menuItems: [{ type: ViewChildren, args: [NgbDropdownItem,] }],
        maxWidth: [{ type: Input }],
        appendToEl: [{ type: Input }],
        isRtl: [{ type: Input }]
    };
BentoMegamenuDefaultComponent.ɵfac = function BentoMegamenuDefaultComponent_Factory(t) { return new (t || BentoMegamenuDefaultComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; })))); };
BentoMegamenuDefaultComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoMegamenuDefaultComponent, selectors: [["bento-megamenu-default"]], viewQuery: function BentoMegamenuDefaultComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbDropdownItem, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuItems = _t);
    } }, inputs: { items: "items", widthElRef: "widthElRef", maxWidth: "maxWidth", hTagRank: "hTagRank", appendToEl: "appendToEl", isRtl: "isRtl" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 2, vars: 1, consts: [["role", "menu", 1, "column-flex-container"], ["class", "column", "megamenuHTagRank", "", 3, "item", "hTagRank", 4, "ngFor", "ngForOf"], ["megamenuHTagRank", "", 1, "column", 3, "item", "hTagRank"], ["bentoMegamenuItem", "", "class", "dropdown-item", "role", "menuitem", 3, "active", "disabled", "click", 4, "ngFor", "ngForOf"], ["bentoMegamenuItem", "", "role", "menuitem", 1, "dropdown-item", 3, "click"], [3, "ngClass", 4, "ngIf"], [3, "innerHTML"], [3, "ngClass"]], template: function BentoMegamenuDefaultComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoMegamenuDefaultComponent_div_1_Template, 2, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: function () { return [ɵngcc7.NgForOf, BentoMegamenuHTagRankDirective,
        BentoFocusMonitorDirective,
        BentoMegaMenuItemDirective, ɵngcc7.NgIf, ɵngcc7.NgClass]; }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMegamenuDefaultComponent, [{
        type: Component,
        args: [{
                selector: 'bento-megamenu-default',
                template: "<div class=\"column-flex-container\" role=\"menu\">\n  <div *ngFor=\"let column of items\" class=\"column\" megamenuHTagRank [item]=\"column\" [hTagRank]=\"hTagRank\">\n    <a\n      bentoMegamenuItem\n      class=\"dropdown-item\"\n      role=\"menuitem\"\n      *ngFor=\"let item of column.menu; let itemIndex = index\"\n      [attr.id]=\"item.id ? item.id : null\"\n      [attr.href]=\"item.anchor?.href || '#'\"\n      [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n      (click)=\"onMenuClick($event, item, column)\"\n      [class.active]=\"item.active\"\n      [class.disabled]=\"item.disabled || column.disabled\"\n      [attr.aria-disabled]=\"item.disabled || column.disabled\"\n      [attr.aria-selected]=\"item.active\"\n      [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n    >\n      <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n      <span [innerHTML]=\"item.anchor?.text || item.label\"></span>\n    </a>\n  </div>\n</div>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: WindowRef }, { type: ɵngcc4.NgbDropdown, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }]; }, { items: [{
            type: Input
        }], widthElRef: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], hTagRank: [{
            type: Input
        }], menuItems: [{
            type: ViewChildren,
            args: [NgbDropdownItem]
        }], appendToEl: [{
            type: Input
        }], isRtl: [{
            type: Input
        }] }); })();
    return BentoMegamenuDefaultComponent;
}());
if (false) {
    /**
     * Main items data model to store Bento Megamenu content
     * @type {?}
     */
    BentoMegamenuDefaultComponent.prototype.items;
    /**
     * A11y: Specify the rank in which megamenu's heading must start.
     * Headings communicate the organization of the content on the page. Web
     * browsers, plug-ins, and assistive technologies can use them to provide
     * in-page navigation.
     * @type {?}
     */
    BentoMegamenuDefaultComponent.prototype.hTagRank;
    /** @type {?} */
    BentoMegamenuDefaultComponent.prototype.menuItems;
    /**
     * Maximum width of this layout
     * @type {?}
     */
    BentoMegamenuDefaultComponent.prototype.maxWidth;
    /**
     * To know if BentoAppendTo directive is used
     * @type {?}
     */
    BentoMegamenuDefaultComponent.prototype.appendToEl;
    /** @type {?} */
    BentoMegamenuDefaultComponent.prototype.isRtl;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.widthRefEl;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.toggleEl;
    /**
     * Native Bento Megamenu view element
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.parentEl;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuDefaultComponent.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuDefaultComponent.prototype.dropdownOpenSub;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.bentoNotification;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuDefaultComponent.prototype.dropdown;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/megamenu/megamenu-flow.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoMegaMenuFlowComponent = /** @class */ (function (_super) {
    __extends(BentoMegaMenuFlowComponent, _super);
    /**
     */
    function BentoMegaMenuFlowComponent(renderer, windowRef, elementRef, bentoNotification, dropdown) {
        var _this = _super.call(this, renderer, elementRef, bentoNotification, windowRef, dropdown) || this;
        _this.dropdown = dropdown;
        _this._computedColWidth = 140;
        return _this;
    }
    Object.defineProperty(BentoMegaMenuFlowComponent.prototype, "columnWidth", {
        /**
         * Column width
         */
        set: /**
         * Column width
         * @param {?} w
         * @return {?}
         */
        function (w) {
            if (!!w && w > 0) {
                this._computedColWidth = w - 1; // 1 is used as gap
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoMegaMenuFlowComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnInit.call(this);
        this.width = !!this.width && this.width > 0 ? this.width : Number.POSITIVE_INFINITY;
    };
    /**
     * Update Megamenu layout based on widthRefEl width
     */
    /**
     * Update Megamenu layout based on widthRefEl width
     * @protected
     * @return {?}
     */
    BentoMegaMenuFlowComponent.prototype.updateMenuLayout = /**
     * Update Megamenu layout based on widthRefEl width
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var maxWidth = this.widthRefEl.clientWidth;
        /** @type {?} */
        var computedStyle = getComputedStyle(this.el);
        /** @type {?} */
        var sidePaddings = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
        /** @type {?} */
        var megamenuWidth = Math.min(maxWidth, this.width + sidePaddings);
        this.r.setStyle(this.parentEl, 'width', megamenuWidth + 'px');
    };
    /** @nocollapse */
    BentoMegaMenuFlowComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: WindowRef },
        { type: ElementRef },
        { type: BentoNotification },
        { type: NgbDropdown, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] }
    ]; };
    BentoMegaMenuFlowComponent.propDecorators = {
        columnWidth: [{ type: Input }],
        width: [{ type: Input }],
        isRtl: [{ type: Input }],
        _computedColWidth: [{ type: HostBinding, args: ['style.column-width.px',] }]
    };
BentoMegaMenuFlowComponent.ɵfac = function BentoMegaMenuFlowComponent_Factory(t) { return new (t || BentoMegaMenuFlowComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; })))); };
BentoMegaMenuFlowComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoMegaMenuFlowComponent, selectors: [["bento-megamenu-flow"]], hostVars: 2, hostBindings: function BentoMegaMenuFlowComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("column-width", ctx._computedColWidth, "px");
    } }, inputs: { columnWidth: "columnWidth", width: "width", isRtl: "isRtl" }, features: [ɵngcc0.ɵɵProvidersFeature([
            BentoNotification,
            { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(( /**
                     * @return {?}
                     */function () { return BentoMegaMenuFlowComponent; })) }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "column", "role", "menu", "megamenuHTagRank", "", 3, "ngClass", "item", "hTagRank", 4, "ngFor", "ngForOf"], ["role", "menu", "megamenuHTagRank", "", 1, "column", 3, "ngClass", "item", "hTagRank"], ["bentoMegamenuItem", "", "class", "dropdown-item", "role", "menuitem", 3, "active", "disabled", "click", 4, "ngFor", "ngForOf"], ["bentoMegamenuItem", "", "role", "menuitem", 1, "dropdown-item", 3, "click"], [3, "ngClass", 4, "ngIf"], [3, "innerHTML"], [3, "ngClass"]], template: function BentoMegaMenuFlowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoMegaMenuFlowComponent_div_0_Template, 2, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: function () { return [ɵngcc7.NgForOf, BentoMegamenuHTagRankDirective, ɵngcc7.NgClass, BentoFocusMonitorDirective,
        BentoMegaMenuItemDirective, ɵngcc7.NgIf]; }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMegaMenuFlowComponent, [{
        type: Component,
        args: [{
                selector: 'bento-megamenu-flow',
                template: "<div\n  *ngFor=\"let column of items\"\n  class=\"column\"\n  role=\"menu\"\n  [ngClass]=\"column.label ? 'bento-megamenu-whole-column ' : ''\"\n  megamenuHTagRank\n  [item]=\"column\"\n  [hTagRank]=\"hTagRank\"\n>\n  <!-- <h5 *ngIf=\"column.label\">{{ column.label }}</h5> -->\n  <a\n    bentoMegamenuItem\n    class=\"dropdown-item\"\n    role=\"menuitem\"\n    *ngFor=\"let item of column.menu; let itemIndex = index\"\n    [attr.id]=\"item.id ? item.id : null\"\n    [attr.href]=\"item.anchor?.href || '#'\"\n    [attr.aria-describedby]=\"column.id && itemIndex === 0 ? column.id : null\"\n    (click)=\"onMenuClick($event, item, column)\"\n    [class.active]=\"item.active\"\n    [class.disabled]=\"item.disabled || column.disabled\"\n    [attr.aria-disabled]=\"item.disabled || column.disabled\"\n    [attr.aria-selected]=\"item.active\"\n    [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n  >\n    <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n    <span [innerHTML]=\"item.anchor?.text || item.label\"></span>\n  </a>\n</div>\n",
                providers: [
                    BentoNotification,
                    { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(( /**
                             * @return {?}
                             */function () { return BentoMegaMenuFlowComponent; })) }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: WindowRef }, { type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: ɵngcc4.NgbDropdown, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }]; }, { columnWidth: [{
            type: Input
        }], width: [{
            type: Input
        }], isRtl: [{
            type: Input
        }], _computedColWidth: [{
            type: HostBinding,
            args: ['style.column-width.px']
        }] }); })();
    return BentoMegaMenuFlowComponent;
}(BentoMegamenuDefaultComponent));
if (false) {
    /**
     * Define the default width of this component
     * @type {?}
     */
    BentoMegaMenuFlowComponent.prototype.width;
    /** @type {?} */
    BentoMegaMenuFlowComponent.prototype.isRtl;
    /** @type {?} */
    BentoMegaMenuFlowComponent.prototype._computedColWidth;
    /**
     * @type {?}
     * @protected
     */
    BentoMegaMenuFlowComponent.prototype.dropdown;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/megamenu/megamenu-htagrank.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoMegamenuHTagRankDirective = /** @class */ (function () {
    function BentoMegamenuHTagRankDirective(elementRef, r, sanitizer, dir) {
        this.r = r;
        this.sanitizer = sanitizer;
        this.isRtl = false;
        this.el = elementRef.nativeElement;
        this.isRtl = dir.value === 'rtl';
    }
    /**
     * @return {?}
     */
    BentoMegamenuHTagRankDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.item.label) {
            if (!this.hTagRank) {
                // default to 5 - as previous
                this.hTagRank = 5;
            }
            /** @type {?} */
            var headerEl = this.r.createElement('h' + this.hTagRank);
            /** @type {?} */
            var label = this.item.label;
            if (this.item.id) {
                this.r.setAttribute(headerEl, 'id', this.item.id);
            }
            if (this.item.icon) {
                label = "<i class=\"" + this.item.icon + " " + (this.isRtl ? 'ml-1' : 'mr-1') + "\"></i>" + label;
            }
            /**
             * .h5 class added by design. It is to preserve the design and UI while meet a11y requirements
             * when different heading levels are needed based on the location of the megamenu in a view
             */
            this.r.addClass(headerEl, 'h5');
            this.r.addClass(headerEl, 'bui-megamenu-column-header');
            this.r.setProperty(headerEl, 'innerHTML', this.sanitizer.sanitize(SecurityContext.HTML, label));
            this.r.insertBefore(this.el, headerEl, this.el.firstChild);
        }
    };
    /** @nocollapse */
    BentoMegamenuHTagRankDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: DomSanitizer },
        { type: Directionality }
    ]; };
    BentoMegamenuHTagRankDirective.propDecorators = {
        item: [{ type: Input }],
        hTagRank: [{ type: Input }]
    };
BentoMegamenuHTagRankDirective.ɵfac = function BentoMegamenuHTagRankDirective_Factory(t) { return new (t || BentoMegamenuHTagRankDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoMegamenuHTagRankDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoMegamenuHTagRankDirective, selectors: [["", "megamenuHTagRank", ""]], inputs: { hTagRank: "hTagRank", item: "item" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMegamenuHTagRankDirective, [{
        type: Directive,
        args: [{ selector: '[megamenuHTagRank]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc5.DomSanitizer }, { type: ɵngcc6.Directionality }]; }, { hTagRank: [{
            type: Input
        }], item: [{
            type: Input
        }] }); })();
    return BentoMegamenuHTagRankDirective;
}());
if (false) {
    /** @type {?} */
    BentoMegamenuHTagRankDirective.prototype.item;
    /**
     * A11y: Specify the rank in which megamenu's heading must start.
     * Headings communicate the organization of the content on the page. Web
     * browsers, plug-ins, and assistive technologies can use them to provide
     * in-page navigation.
     * @type {?}
     */
    BentoMegamenuHTagRankDirective.prototype.hTagRank;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuHTagRankDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuHTagRankDirective.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuHTagRankDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuHTagRankDirective.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/megamenu/megamenu-item.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoMegaMenuItemDirective = /** @class */ (function (_super) {
    __extends(BentoMegaMenuItemDirective, _super);
    function BentoMegaMenuItemDirective(elementRef) {
        var _this = _super.call(this, elementRef) || this;
        _this.elementRef = elementRef;
        return _this;
    }
    /** @nocollapse */
    BentoMegaMenuItemDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
BentoMegaMenuItemDirective.ɵfac = function BentoMegaMenuItemDirective_Factory(t) { return new (t || BentoMegaMenuItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoMegaMenuItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoMegaMenuItemDirective, selectors: [["", "bentoMegamenuItem", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NgbDropdownItem, useExisting: forwardRef(( /**
                         * @return {?}
                         */function () { return BentoMegaMenuItemDirective; })) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMegaMenuItemDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoMegamenuItem]',
                providers: [{ provide: NgbDropdownItem, useExisting: forwardRef(( /**
                                 * @return {?}
                                 */function () { return BentoMegaMenuItemDirective; })) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
    return BentoMegaMenuItemDirective;
}(NgbDropdownItem));
if (false) {
    /** @type {?} */
    BentoMegaMenuItemDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/megamenu/megamenu-takeover.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoMegamenuTakeoverComponent = /** @class */ (function (_super) {
    __extends(BentoMegamenuTakeoverComponent, _super);
    /**
     *
     */
    function BentoMegamenuTakeoverComponent(r, elementRef, bentoNotification, windowRef, dropdown) {
        var _this = _super.call(this, r, elementRef, bentoNotification, windowRef, dropdown) || this;
        _this.r = r;
        _this.elementRef = elementRef;
        _this.dropdown = dropdown;
        /**
         * Current sub-menu array
         */
        _this.currentMenu = [];
        _this.initialHeaderHeight = 0;
        _this.isHeaderClicked = false;
        return _this;
    }
    /**
     * Implement OnInit
     */
    /**
     * Implement OnInit
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.ngOnInit = /**
     * Implement OnInit
     * @return {?}
     */
    function () {
        var _this = this;
        this.openChangeSub = this.dropdown.openChange.subscribe((/**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v) {
                _this.updateMenuLayout();
            }
            else {
                _this.isHeaderClicked = false;
            }
        }));
        // Need to override NgbDropdown's positioning
        this.dropdown['_positionMenu'] = (/**
         * @return {?}
         */
        function () { });
    };
    /**
     * Implement OnDestroy
     */
    /**
     * Implement OnDestroy
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.ngOnDestroy = /**
     * Implement OnDestroy
     * @return {?}
     */
    function () {
        this.openChangeSub.unsubscribe();
    };
    /**
     * Callback when user hits arrow keys in the header menu
     */
    /**
     * Callback when user hits arrow keys in the header menu
     * @param {?} event
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.onHeaderKeydown = /**
     * Callback when user hits arrow keys in the header menu
     * @param {?} event
     * @return {?}
     */
    function (event) {
        switch (event.keyCode) {
            case Keyboard.RIGHT:
                /** @type {?} */
                var firstElement = this.takeoverMenus.nativeElement.querySelector('a');
                if (firstElement) {
                    firstElement.focus();
                }
                event.preventDefault();
                return;
            case Keyboard.UP:
                this.focusOnHeaderAtIndex(this.getCurrentHeaderIndex() - 1);
                event.preventDefault();
                return;
            case Keyboard.DOWN:
                this.focusOnHeaderAtIndex(this.getCurrentHeaderIndex() + 1);
                event.preventDefault();
                return;
        }
    };
    /**
     * Callback when user hits arrow keys in the sub menu
     */
    /**
     * Callback when user hits arrow keys in the sub menu
     * @param {?} event
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.onSubMenuKeydown = /**
     * Callback when user hits arrow keys in the sub menu
     * @param {?} event
     * @return {?}
     */
    function (event) {
        switch (event.keyCode) {
            case Keyboard.LEFT: // -> back to header menu
                this.focusOnHeaderAtIndex(this.getCurrentHeaderIndex());
                return;
            case Keyboard.UP:
                /** @type {?} */
                var pSibling = ((/** @type {?} */ (event.currentTarget))).previousElementSibling;
                if (pSibling) {
                    ((/** @type {?} */ (pSibling.querySelector('a')))).focus();
                }
                event.preventDefault();
                return;
            case Keyboard.DOWN:
                /** @type {?} */
                var nSibling = ((/** @type {?} */ (event.currentTarget))).nextElementSibling;
                if (nSibling) {
                    ((/** @type {?} */ (nSibling.querySelector('a')))).focus();
                }
                event.preventDefault();
                return;
        }
    };
    /**
     * Event listner to Click, Focus and MouseOver
     */
    /**
     * Event listner to Click, Focus and MouseOver
     * @param {?} event
     * @param {?} column
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.onHeaderFocus = /**
     * Event listner to Click, Focus and MouseOver
     * @param {?} event
     * @param {?} column
     * @return {?}
     */
    function (event, column) {
        event.stopPropagation();
        event.preventDefault();
        if (event.type === 'click' && typeof column.action === 'function') {
            // If there is an action assigned to the header, we fire its action
            column.action();
            if (!column.menu || !column.menu.length) {
                // Close the dropdown if there is no submenu
                this.dropdown.close();
            }
        }
        if (this.isHeaderClicked && event.type === 'mouseenter') {
            // Ignore all 'mouseenter' event when one of the headers is clicked already
            return;
        }
        if (event.type === 'click') {
            // Focus is taking care of the selection already
            // so we only register a click here
            this.isHeaderClicked = true;
            return;
        }
        if (column === this.currentColumn) {
            // Nothing is changed here
            return;
        }
        // Update the current column to render
        this.currentColumn = column;
        this.currentMenu = column.menu;
    };
    /**
     * Update Megamenu layout based on widthRefEl width
     */
    /**
     * Update Megamenu layout based on widthRefEl width
     * @protected
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.updateMenuLayout = /**
     * Update Megamenu layout based on widthRefEl width
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var maxWidth = this.widthRefEl.clientWidth;
        /** @type {?} */
        var toggleRect = this.toggleEl.getBoundingClientRect();
        /** @type {?} */
        var widthRefRect = this.widthRefEl.getBoundingClientRect();
        /** @type {?} */
        var toggleOffsetLeft = toggleRect.left - widthRefRect.left;
        this.r.setStyle(this.parentEl, 'width', maxWidth + 'px');
        // https://stackoverflow.com/a/49823129
        // tslint:disable-next-line no-bitwise
        /** @type {?} */
        var flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
        this.r.setStyle(this.parentEl, 'transform', "translateX(" + -toggleOffsetLeft + "px)", flags);
        this.r.setStyle(this.parentEl, 'right', 'auto');
        this.r.setStyle(this.parentEl, 'left', '0', flags);
        setTimeout((/**
         * @return {?}
         */
        function () { return _this.resizeSubmenu(); }));
    };
    /**
     * Need some dom resizing after rendering done
     */
    /**
     * Need some dom resizing after rendering done
     * @private
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.resizeSubmenu = /**
     * Need some dom resizing after rendering done
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var headersEl = this.takeoverHeaders.nativeElement;
        /** @type {?} */
        var headerHeight = headersEl.offsetHeight;
        /** @type {?} */
        var submenuEl = this.takeoverMenus.nativeElement;
        /** @type {?} */
        var nativeEl = this.elementRef.nativeElement;
        /** @type {?} */
        var nativeWidth = nativeEl.offsetWidth;
        if (this.initialHeaderHeight === 0) {
            this.initialHeaderHeight = headerHeight;
        }
        // Check if the submenu is overflowing
        /** @type {?} */
        var diff = nativeEl.scrollWidth - nativeEl.offsetWidth;
        if (diff > 0) {
            // Need change the submenu height with the same size in area
            /** @type {?} */
            var area = submenuEl.offsetHeight * (nativeWidth - headersEl.offsetWidth);
            /** @type {?} */
            var submenuVWidth = nativeWidth - diff - headersEl.offsetWidth;
            this.r.setStyle(submenuEl, 'height', area / submenuVWidth + 'px');
        }
        else {
            this.r.setStyle(submenuEl, 'height', this.initialHeaderHeight + 'px');
        }
    };
    /**
     * Get the current header index from the header
     */
    /**
     * Get the current header index from the header
     * @private
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.getCurrentHeaderIndex = /**
     * Get the current header index from the header
     * @private
     * @return {?}
     */
    function () {
        return this.items.indexOf(this.currentColumn);
    };
    /**
     * Focus on a header by its index
     */
    /**
     * Focus on a header by its index
     * @private
     * @param {?} index
     * @return {?}
     */
    BentoMegamenuTakeoverComponent.prototype.focusOnHeaderAtIndex = /**
     * Focus on a header by its index
     * @private
     * @param {?} index
     * @return {?}
     */
    function (index) {
        // out of bound
        if (index < 0) {
            return;
        }
        /** @type {?} */
        var children = this.takeoverHeaders.nativeElement.querySelectorAll('li a');
        // out of bound
        if (index >= children.length) {
            return;
        }
        ((/** @type {?} */ (children.item(index)))).focus();
    };
    /** @nocollapse */
    BentoMegamenuTakeoverComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: BentoNotification },
        { type: WindowRef },
        { type: NgbDropdown, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] }
    ]; };
    BentoMegamenuTakeoverComponent.propDecorators = {
        items: [{ type: Input }],
        isRtl: [{ type: Input }],
        takeoverMenus: [{ type: ViewChild, args: ['takeoverMenus', { static: true },] }],
        takeoverHeaders: [{ type: ViewChild, args: ['takeoverHeaders', { static: true },] }]
    };
BentoMegamenuTakeoverComponent.ɵfac = function BentoMegamenuTakeoverComponent_Factory(t) { return new (t || BentoMegamenuTakeoverComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; })))); };
BentoMegamenuTakeoverComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoMegamenuTakeoverComponent, selectors: [["bento-megamenu-takeover"]], viewQuery: function BentoMegamenuTakeoverComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c18, true);
        ɵngcc0.ɵɵstaticViewQuery(_c19, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.takeoverMenus = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.takeoverHeaders = _t.first);
    } }, inputs: { items: "items", isRtl: "isRtl" }, features: [ɵngcc0.ɵɵProvidersFeature([
            BentoNotification,
            { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(( /**
                     * @return {?}
                     */function () { return BentoMegamenuTakeoverComponent; })) }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 2, consts: [[1, "bento-megamenu-takeover-flex-container"], ["role", "menu", 1, "bento-megamenu-takeover-headers"], ["takeoverHeaders", ""], [3, "active", "keydown", 4, "ngFor", "ngForOf"], ["tabindex", "-1", "role", "menu", 1, "bento-megamenu-takeover-items"], ["takeoverMenus", ""], [3, "keydown", 4, "ngFor", "ngForOf"], [3, "keydown"], ["bentoMegamenuItem", "", "href", "#", "role", "menuitem", 1, "dropdown-item", 3, "click", "focus", "mouseenter"], ["class", "bento-icon-chevron-right", "aria-hidden", "true", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "innerHTML"], ["aria-hidden", "true", 1, "bento-icon-chevron-right"], [3, "ngClass"], ["href", "#", "role", "menuitem", 3, "click"]], template: function BentoMegamenuTakeoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1, 2);
        ɵngcc0.ɵɵtemplate(3, BentoMegamenuTakeoverComponent_li_3_Template, 6, 5, "li", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 4, 5);
        ɵngcc0.ɵɵtemplate(6, BentoMegamenuTakeoverComponent_li_6_Template, 4, 7, "li", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.currentMenu);
    } }, directives: [ɵngcc7.NgForOf, BentoFocusMonitorDirective,
        BentoMegaMenuItemDirective, ɵngcc7.NgIf, ɵngcc7.NgClass], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMegamenuTakeoverComponent, [{
        type: Component,
        args: [{
                selector: 'bento-megamenu-takeover',
                template: "<div class=\"bento-megamenu-takeover-flex-container\">\n  <ul #takeoverHeaders class=\"bento-megamenu-takeover-headers\" role=\"menu\">\n    <li *ngFor=\"let column of items\" [class.active]=\"currentColumn === column\" (keydown)=\"onHeaderKeydown($event)\">\n      <a\n        bentoMegamenuItem\n        class=\"dropdown-item\"\n        href=\"#\"\n        (click)=\"onHeaderFocus($event, column)\"\n        (focus)=\"onHeaderFocus($event, column)\"\n        (mouseenter)=\"onHeaderFocus($event, column)\"\n        role=\"menuitem\"\n      >\n        <i *ngIf=\"column.menu\" class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n        <span>\n          <i *ngIf=\"column.icon\" [ngClass]=\"column.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n          <span [innerHTML]=\"column.label\"></span>\n        </span>\n      </a>\n    </li>\n  </ul>\n  <ul #takeoverMenus tabindex=\"-1\" class=\"bento-megamenu-takeover-items\" role=\"menu\">\n    <li *ngFor=\"let item of currentMenu\" (keydown)=\"onSubMenuKeydown($event)\">\n      <a\n        href=\"#\"\n        (click)=\"onMenuClick($event, item, currentColumn)\"\n        [attr.href]=\"item.anchor?.href || '#'\"\n        role=\"menuitem\"\n        [class.disabled]=\"item.disabled || currentColumn.disabled\"\n        [attr.aria-disabled]=\"item.disabled || currentColumn.disabled\"\n        [attr.aria-current]=\"item.useAriaCurrent && item.active ? 'page' : null\"\n      >\n        <i *ngIf=\"item.icon\" [ngClass]=\"item.icon + (isRtl ? ' ml-1' : ' mr-1')\"></i>\n        <span [innerHTML]=\"item.anchor?.text || item.label\"></span>\n      </a>\n    </li>\n  </ul>\n</div>\n",
                providers: [
                    BentoNotification,
                    { provide: BentoMegamenuDefaultComponent, useExisting: forwardRef(( /**
                             * @return {?}
                             */function () { return BentoMegamenuTakeoverComponent; })) }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: WindowRef }, { type: ɵngcc4.NgbDropdown, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }]; }, { items: [{
            type: Input
        }], isRtl: [{
            type: Input
        }], takeoverMenus: [{
            type: ViewChild,
            args: ['takeoverMenus', { static: true }]
        }], takeoverHeaders: [{
            type: ViewChild,
            args: ['takeoverHeaders', { static: true }]
        }] }); })();
    return BentoMegamenuTakeoverComponent;
}(BentoMegamenuDefaultComponent));
if (false) {
    /**
     * Main menu data
     * @type {?}
     */
    BentoMegamenuTakeoverComponent.prototype.items;
    /** @type {?} */
    BentoMegamenuTakeoverComponent.prototype.isRtl;
    /**
     * Current sub-menu array
     * @type {?}
     */
    BentoMegamenuTakeoverComponent.prototype.currentMenu;
    /**
     * Current sub-menu object
     * @type {?}
     */
    BentoMegamenuTakeoverComponent.prototype.currentColumn;
    /**
     * Element reference of the two main containers in Takeover
     * @type {?}
     */
    BentoMegamenuTakeoverComponent.prototype.takeoverMenus;
    /** @type {?} */
    BentoMegamenuTakeoverComponent.prototype.takeoverHeaders;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuTakeoverComponent.prototype.initialHeaderHeight;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuTakeoverComponent.prototype.isHeaderClicked;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuTakeoverComponent.prototype.openChangeSub;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuTakeoverComponent.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuTakeoverComponent.prototype.elementRef;
    /**
     * @type {?}
     * @protected
     */
    BentoMegamenuTakeoverComponent.prototype.dropdown;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/megamenu/megamenu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable no-host-metadata-property*/
/**
 * This is an extension to [Dropdown](#/components/dropdown),
 * in which links are shown in multiple columns. Now horizontal space can
 * be full utilized to display a large quantity of links. All Dropdown
 * options apply to Megamenu as well, including `.dropup`
 */
var BentoMegamenuComponent = /** @class */ (function (_super) {
    __extends(BentoMegamenuComponent, _super);
    /**
     * Constructor
     */
    function BentoMegamenuComponent(dropdown, r, elementRef, dir, bentoUIDService) {
        var _this = _super.call(this, dropdown, elementRef) || this;
        _this.dropdown = dropdown;
        _this.r = r;
        _this.dir = dir;
        _this.bentoUIDService = bentoUIDService;
        /**
         * This property is **ONLY** applied when Megamenu is `type="flow"`
         */
        _this.flowColumnWidth = 150;
        // Private variables
        _this._items = [];
        _this._type = 'default';
        /**
         * Subscription to the Directionality change EventEmitter.
         */
        _this.dirChangeSubscription = Subscription.EMPTY;
        _this.el = elementRef.nativeElement;
        r.addClass(elementRef.nativeElement, 'dropdown-menu');
        _this.isRtl = _this.dir.value === 'rtl';
        _this.dirChangeSubscription = dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
        return _this;
    }
    Object.defineProperty(BentoMegamenuComponent.prototype, "items", {
        get: /**
         * @return {?}
         */
        function () {
            return this._items;
        },
        /**
         * Main items data model to store Bento Megamenu content
         */
        set: /**
         * Main items data model to store Bento Megamenu content
         * @param {?} items
         * @return {?}
         */
        function (items) {
            var _this = this;
            this._items = items.map((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                /** @type {?} */
                var id = item.id;
                if (item && !id) {
                    /** @type {?} */
                    var uniqueID = "megamenu-column-" + _this.bentoUIDService.generate();
                    return __assign(__assign({}, item), { id: uniqueID });
                }
                return item;
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoMegamenuComponent.prototype, "type", {
        get: /**
         * @return {?}
         */
        function () {
            return this._type;
        },
        /**
         * Indicates the type of this Megamenu: `default`, `takeover` and `flow`
         */
        set: /**
         * Indicates the type of this Megamenu: `default`, `takeover` and `flow`
         * @param {?} t
         * @return {?}
         */
        function (t) {
            this._type = t || 'default';
            this.setClass();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoMegamenuComponent.prototype, "menuItems", {
        /**
         * Menu Items that are used
         */
        get: /**
         * Menu Items that are used
         * @return {?}
         */
        function () {
            return this.menuComponent.menuItems;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            // In order to override, this method needs to be implemented
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Init lifecycle hook
     */
    /**
     * Init lifecycle hook
     * @return {?}
     */
    BentoMegamenuComponent.prototype.ngOnInit = /**
     * Init lifecycle hook
     * @return {?}
     */
    function () {
        this.setClass();
    };
    /**
     * Destroy lifecycle hook
     */
    /**
     * Destroy lifecycle hook
     * @return {?}
     */
    BentoMegamenuComponent.prototype.ngOnDestroy = /**
     * Destroy lifecycle hook
     * @return {?}
     */
    function () {
        this.dirChangeSubscription.unsubscribe();
    };
    /**
     * Set main container element CSS class
     */
    /**
     * Set main container element CSS class
     * @private
     * @return {?}
     */
    BentoMegamenuComponent.prototype.setClass = /**
     * Set main container element CSS class
     * @private
     * @return {?}
     */
    function () {
        this.r.removeClass(this.el, 'bento-megamenu-default');
        this.r.removeClass(this.el, 'bento-megamenu-takeover');
        this.r.removeClass(this.el, 'bento-megamenu-flow');
        this.r.addClass(this.el, 'bento-megamenu-' + this._type);
    };
    /**
     * @private
     * @return {?}
     */
    BentoMegamenuComponent.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
    };
    /** @nocollapse */
    BentoMegamenuComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] },
        { type: Renderer2 },
        { type: ElementRef },
        { type: Directionality },
        { type: BentoUidService }
    ]; };
    BentoMegamenuComponent.propDecorators = {
        items: [{ type: Input }],
        widthElRef: [{ type: Input }],
        maxWidth: [{ type: Input }],
        flowColumnWidth: [{ type: Input }],
        bentoAppendTo: [{ type: Input }],
        type: [{ type: Input }],
        menuComponent: [{ type: ViewChild, args: [BentoMegamenuDefaultComponent,] }],
        hTagRank: [{ type: Input }]
    };
BentoMegamenuComponent.ɵfac = function BentoMegamenuComponent_Factory(t) { return new (t || BentoMegamenuComponent)(ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; }))), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoMegamenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoMegamenuComponent, selectors: [["bento-megamenu"]], viewQuery: function BentoMegamenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoMegamenuDefaultComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuComponent = _t.first);
    } }, hostVars: 2, hostBindings: function BentoMegamenuComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("show", ctx.dropdown.isOpen());
    } }, inputs: { items: "items", type: "type", widthElRef: "widthElRef", maxWidth: "maxWidth", flowColumnWidth: "flowColumnWidth", bentoAppendTo: "bentoAppendTo", hTagRank: "hTagRank" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NgbDropdownMenu, useExisting: forwardRef(( /**
                         * @return {?}
                         */function () { return BentoMegamenuComponent; })) }, BentoUidService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [[3, "ngSwitch"], [3, "widthElRef", "items", "isRtl", "appendToEl", 4, "ngSwitchCase"], [3, "widthElRef", "width", "columnWidth", "items", "isRtl", "appendToEl", "hTagRank", 4, "ngSwitchCase"], [3, "widthElRef", "maxWidth", "items", "appendToEl", "isRtl", "hTagRank", 4, "ngSwitchDefault"], [3, "widthElRef", "items", "isRtl", "appendToEl"], [3, "widthElRef", "width", "columnWidth", "items", "isRtl", "appendToEl", "hTagRank"], [3, "widthElRef", "maxWidth", "items", "appendToEl", "isRtl", "hTagRank"]], template: function BentoMegamenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, BentoMegamenuComponent_bento_megamenu_takeover_1_Template, 1, 4, "bento-megamenu-takeover", 1);
        ɵngcc0.ɵɵtemplate(2, BentoMegamenuComponent_bento_megamenu_flow_2_Template, 1, 7, "bento-megamenu-flow", 2);
        ɵngcc0.ɵɵtemplate(3, BentoMegamenuComponent_bento_megamenu_default_3_Template, 1, 6, "bento-megamenu-default", 3);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "takeover");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "flow");
    } }, directives: [ɵngcc7.NgSwitch, ɵngcc7.NgSwitchCase, ɵngcc7.NgSwitchDefault, BentoMegamenuTakeoverComponent,
        BentoMegaMenuFlowComponent,
        BentoMegamenuDefaultComponent], styles: [".bento-toolbar bento-megamenu.dropdown-menu,bento-megamenu.dropdown-menu{overflow:auto;padding:0!important;max-height:none!important}.bento-toolbar bento-megamenu.dropdown-menu.bento-megamenu-rendering,bento-megamenu.dropdown-menu.bento-megamenu-rendering{opacity:0;box-shadow:none}.dropup .bento-toolbar bento-megamenu.dropdown-menu,.dropup bento-megamenu.dropdown-menu{bottom:auto}.bento-toolbar bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled,.bento-toolbar bento-megamenu.dropdown-menu .dropdown-item.disabled,bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled,bento-megamenu.dropdown-menu .dropdown-item.disabled{opacity:.5}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow,bento-megamenu.dropdown-menu>bento-megamenu-default,bento-megamenu.dropdown-menu>bento-megamenu-flow{margin:0;padding:.875rem .3125rem;display:block;max-width:100vw;-moz-column-gap:0;column-gap:0}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container,bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container{-ms-box-orient:horizontal;display:-moz-flex;display:flex;align-items:stretch}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column,bento-megamenu.dropdown-menu>bento-megamenu-default .column,bento-megamenu.dropdown-menu>bento-megamenu-flow .column{white-space:normal;padding:0 .3125rem;margin-bottom:.4375rem}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty,bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty{height:0;border:none;padding:0}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header,bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header{margin:0 0 .4375rem;padding:0 .3125rem;border:1px solid transparent}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{page-break-inside:avoid;-moz-column-break-inside:avoid;break-inside:avoid;text-align:left;display:block;cursor:pointer;padding:.375rem .3125rem;font-size:.9rem;line-height:1.2em!important;font-weight:400;height:auto;white-space:nowrap;background:0 0;border:1px solid transparent}[dir=rtl] .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,[dir=rtl] bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{text-align:right}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover,bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover{text-decoration:underline}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow,bento-megamenu.dropdown-menu>bento-megamenu-flow{box-sizing:content-box}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow a,bento-megamenu.dropdown-menu>bento-megamenu-flow a{white-space:normal!important}.bento-toolbar bento-megamenu.dropdown-menubento-megamenu-takeover,bento-megamenu.dropdown-menubento-megamenu-takeover{border:none}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column{background:inherit;margin-bottom:.4375rem}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a{background:0 0;padding:0 .375rem;height:auto;line-height:1.575rem!important}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a:hover,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a:hover{text-decoration:none}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover{display:block;max-width:100vw}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-flex-container{display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:stretch}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers{list-style-type:none;padding:.625rem 0;min-width:9.375rem;margin:0}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{display:block;padding:.4375rem 3.75rem .4375rem .9375rem;line-height:unset;height:auto;cursor:default;font-size:.9rem}[dir=rtl] .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{padding:.4375rem .9375rem .4375rem 3.75rem}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:focus,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:hover{text-decoration:none}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:right;margin-right:-2.8125rem}[dir=rtl] .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:left;margin-right:0;margin-left:-2.8125rem;transform:scaleX(-1)}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items{margin:0;padding:.75rem .625rem 0;list-style-type:none;display:flex;flex-flow:column wrap;justify-content:flex-start;align-items:stretch}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a{padding:0 .625rem;font-size:.9rem;line-height:1.875rem;height:1.875rem;background:0 0!important}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:focus,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:hover{outline:0;text-decoration:none}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMegamenuComponent, [{
        type: Component,
        args: [{
                selector: 'bento-megamenu',
                template: "<ng-container [ngSwitch]=\"type\">\n  <bento-megamenu-takeover\n    *ngSwitchCase=\"'takeover'\"\n    [widthElRef]=\"widthElRef\"\n    [items]=\"items\"\n    [isRtl]=\"isRtl\"\n    [appendToEl]=\"bentoAppendTo\"\n  ></bento-megamenu-takeover>\n  <bento-megamenu-flow\n    *ngSwitchCase=\"'flow'\"\n    [widthElRef]=\"widthElRef\"\n    [width]=\"maxWidth\"\n    [columnWidth]=\"flowColumnWidth\"\n    [items]=\"items\"\n    [isRtl]=\"isRtl\"\n    [appendToEl]=\"bentoAppendTo\"\n    [hTagRank]=\"hTagRank\"\n  ></bento-megamenu-flow>\n  <bento-megamenu-default\n    *ngSwitchDefault\n    [widthElRef]=\"widthElRef\"\n    [maxWidth]=\"maxWidth\"\n    [items]=\"items\"\n    [appendToEl]=\"bentoAppendTo\"\n    [isRtl]=\"isRtl\"\n    [hTagRank]=\"hTagRank\"\n  ></bento-megamenu-default>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None,
                host: { '[class.show]': 'dropdown.isOpen()' },
                providers: [{ provide: NgbDropdownMenu, useExisting: forwardRef(( /**
                                 * @return {?}
                                 */function () { return BentoMegamenuComponent; })) }, BentoUidService],
                styles: [".bento-toolbar bento-megamenu.dropdown-menu,bento-megamenu.dropdown-menu{overflow:auto;padding:0!important;max-height:none!important}.bento-toolbar bento-megamenu.dropdown-menu.bento-megamenu-rendering,bento-megamenu.dropdown-menu.bento-megamenu-rendering{opacity:0;box-shadow:none}.dropup .bento-toolbar bento-megamenu.dropdown-menu,.dropup bento-megamenu.dropdown-menu{bottom:auto}.bento-toolbar bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled,.bento-toolbar bento-megamenu.dropdown-menu .dropdown-item.disabled,bento-megamenu.dropdown-menu .bento-megamenu-takeover-items a.disabled,bento-megamenu.dropdown-menu .dropdown-item.disabled{opacity:.5}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow,bento-megamenu.dropdown-menu>bento-megamenu-default,bento-megamenu.dropdown-menu>bento-megamenu-flow{margin:0;padding:.875rem .3125rem;display:block;max-width:100vw;-moz-column-gap:0;column-gap:0}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container,bento-megamenu.dropdown-menu>bento-megamenu-default .column-flex-container,bento-megamenu.dropdown-menu>bento-megamenu-flow .column-flex-container{-ms-box-orient:horizontal;display:-moz-flex;display:flex;align-items:stretch}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column,bento-megamenu.dropdown-menu>bento-megamenu-default .column,bento-megamenu.dropdown-menu>bento-megamenu-flow .column{white-space:normal;padding:0 .3125rem;margin-bottom:.4375rem}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty,bento-megamenu.dropdown-menu>bento-megamenu-default .column:empty,bento-megamenu.dropdown-menu>bento-megamenu-flow .column:empty{height:0;border:none;padding:0}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header,bento-megamenu.dropdown-menu>bento-megamenu-default .column .bui-megamenu-column-header,bento-megamenu.dropdown-menu>bento-megamenu-flow .column .bui-megamenu-column-header{margin:0 0 .4375rem;padding:0 .3125rem;border:1px solid transparent}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{page-break-inside:avoid;-moz-column-break-inside:avoid;break-inside:avoid;text-align:left;display:block;cursor:pointer;padding:.375rem .3125rem;font-size:.9rem;line-height:1.2em!important;font-weight:400;height:auto;white-space:nowrap;background:0 0;border:1px solid transparent}[dir=rtl] .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] .bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a,[dir=rtl] bento-megamenu.dropdown-menu>bento-megamenu-default .column>a,[dir=rtl] bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a{text-align:right}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover,bento-megamenu.dropdown-menu>bento-megamenu-default .column>a:hover,bento-megamenu.dropdown-menu>bento-megamenu-flow .column>a:hover{text-decoration:underline}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow,bento-megamenu.dropdown-menu>bento-megamenu-flow{box-sizing:content-box}.bento-toolbar bento-megamenu.dropdown-menu>bento-megamenu-flow a,bento-megamenu.dropdown-menu>bento-megamenu-flow a{white-space:normal!important}.bento-toolbar bento-megamenu.dropdown-menubento-megamenu-takeover,bento-megamenu.dropdown-menubento-megamenu-takeover{border:none}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column{background:inherit;margin-bottom:.4375rem}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a{background:0 0;padding:0 .375rem;height:auto;line-height:1.575rem!important}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-default .column a:hover,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-flow .column a:hover{text-decoration:none}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover{display:block;max-width:100vw}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-flex-container{display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:stretch}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers{list-style-type:none;padding:.625rem 0;min-width:9.375rem;margin:0}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{display:block;padding:.4375rem 3.75rem .4375rem .9375rem;line-height:unset;height:auto;cursor:default;font-size:.9rem}[dir=rtl] .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a{padding:.4375rem .9375rem .4375rem 3.75rem}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:focus,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li a:hover{text-decoration:none}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:right;margin-right:-2.8125rem}[dir=rtl] .global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-headers li i.bento-icon-chevron-right{float:left;margin-right:0;margin-left:-2.8125rem;transform:scaleX(-1)}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items{margin:0;padding:.75rem .625rem 0;list-style-type:none;display:flex;flex-flow:column wrap;justify-content:flex-start;align-items:stretch}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a{padding:0 .625rem;font-size:.9rem;line-height:1.875rem;height:1.875rem;background:0 0!important}.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:focus,.global-subnav bento-megamenu.dropdown-menu>bento-megamenu-takeover .bento-megamenu-takeover-items a:hover{outline:0;text-decoration:none}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc6.Directionality }, { type: BentoUidService }]; }, { items: [{
            type: Input
        }], type: [{
            type: Input
        }], widthElRef: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], flowColumnWidth: [{
            type: Input
        }], bentoAppendTo: [{
            type: Input
        }], menuComponent: [{
            type: ViewChild,
            args: [BentoMegamenuDefaultComponent]
        }], hTagRank: [{
            type: Input
        }] }); })();
    return BentoMegamenuComponent;
}(NgbDropdownMenu));
if (false) {
    /**
     * Reference element is used to make this megamenu to be self aware on its width and
     * @type {?}
     */
    BentoMegamenuComponent.prototype.widthElRef;
    /**
     * Maximum width that is used for Default and Flow Megamenu layouts
     * @type {?}
     */
    BentoMegamenuComponent.prototype.maxWidth;
    /**
     * This property is **ONLY** applied when Megamenu is `type="flow"`
     * @type {?}
     */
    BentoMegamenuComponent.prototype.flowColumnWidth;
    /**
     * Property to know if Bento Append To is in place or not
     * @type {?}
     */
    BentoMegamenuComponent.prototype.bentoAppendTo;
    /** @type {?} */
    BentoMegamenuComponent.prototype.menuComponent;
    /**
     * A11y: Specify the rank in which megamenu's heading must start.
     * Headings communicate the organization of the content on the page. Web
     * browsers, plug-ins, and assistive technologies can use them to provide
     * in-page navigation.
     * @type {?}
     */
    BentoMegamenuComponent.prototype.hTagRank;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoMegamenuComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuComponent.prototype._items;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuComponent.prototype._type;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuComponent.prototype.el;
    /**
     * Subscription to the Directionality change EventEmitter.
     * @type {?}
     * @private
     */
    BentoMegamenuComponent.prototype.dirChangeSubscription;
    /** @type {?} */
    BentoMegamenuComponent.prototype.dropdown;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuComponent.prototype.dir;
    /**
     * @type {?}
     * @private
     */
    BentoMegamenuComponent.prototype.bentoUIDService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/megamenu/megamenu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoMegamenuModule = /** @class */ (function () {
    function BentoMegamenuModule() {
    }
BentoMegamenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoMegamenuModule });
BentoMegamenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoMegamenuModule_Factory(t) { return new (t || BentoMegamenuModule)(); }, providers: [NgbDropdown, BentoNgbDropdownAppendToDirective, BentoMegamenuHTagRankDirective], imports: [[CommonModule, FormsModule, BentoUtilsModule, BentoFocusMonitorModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoMegamenuModule, { declarations: function () { return [BentoMegamenuComponent,
        BentoMegamenuDefaultComponent,
        BentoMegamenuTakeoverComponent,
        BentoMegaMenuFlowComponent,
        BentoMegaMenuItemDirective,
        BentoMegamenuHTagRankDirective]; }, imports: function () { return [CommonModule, FormsModule,
        BentoUtilsModule,
        BentoFocusMonitorModule]; }, exports: function () { return [BentoMegamenuComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMegamenuModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, BentoUtilsModule, BentoFocusMonitorModule],
                declarations: [
                    BentoMegamenuComponent,
                    BentoMegamenuDefaultComponent,
                    BentoMegamenuTakeoverComponent,
                    BentoMegaMenuFlowComponent,
                    BentoMegaMenuItemDirective,
                    BentoMegamenuHTagRankDirective
                ],
                exports: [BentoMegamenuComponent],
                providers: [NgbDropdown, BentoNgbDropdownAppendToDirective, BentoMegamenuHTagRankDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoMegamenuModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-confirmation/modal-footer-tab-helper.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable directive-class-suffix */
var BentoFooterTabHelper = /** @class */ (function () {
    function BentoFooterTabHelper(elRef, winRef, r) {
        this.r = r;
        this.window = winRef.nativeWindow;
        this.document = winRef.nativeDocument;
        this.el = elRef.nativeElement;
    }
    /**
     * @return {?}
     */
    BentoFooterTabHelper.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // Need to wait one cycle for theme CSS to kick in
            /** @type {?} */
            var focusedEl = (/** @type {?} */ (_this.document.activeElement));
            /** @type {?} */
            var style = _this.window.getComputedStyle(_this.el);
            if (style.flexDirection === 'row-reverse') {
                // Some magic here to rever the element orders back with
                // CSS corrections so that Tabs should flow in the correct
                // order
                _this.r.setStyle(_this.el, 'flexDirection', 'row');
                /* Flip content alignment */
                if (style.justifyContent === 'flex-start') {
                    _this.r.setStyle(_this.el, 'justifyContent', 'flex-end');
                }
                else {
                    _this.r.setStyle(_this.el, 'justifyContent', 'flex-start');
                }
                // Reverse element order
                /** @type {?} */
                var children = Array.from(_this.el.children);
                for (var i = children.length - 1; i > -1; i--) {
                    _this.el.appendChild(children[i]);
                }
                // Make suer the focus is still at where
                // Ngb has originally assigned
                focusedEl.focus();
            }
        }));
    };
    /** @nocollapse */
    BentoFooterTabHelper.ctorParameters = function () { return [
        { type: ElementRef },
        { type: WindowRef },
        { type: Renderer2 }
    ]; };
BentoFooterTabHelper.ɵfac = function BentoFooterTabHelper_Factory(t) { return new (t || BentoFooterTabHelper)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BentoFooterTabHelper.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoFooterTabHelper, selectors: [["", "class", "modal-footer"]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFooterTabHelper, [{
        type: Directive,
        args: [{
                selector: '[class="modal-footer"]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return BentoFooterTabHelper;
}());
if (false) {
    /** @type {?} */
    BentoFooterTabHelper.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoFooterTabHelper.prototype.window;
    /**
     * @type {?}
     * @private
     */
    BentoFooterTabHelper.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoFooterTabHelper.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-confirmation/modal-confirmation.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * To provide default confirmation modal behaviors
 *
 * This class is used internally by the `BentoModalConfirmationService` injectable
 */
var BentoModalConfirmationComponent = /** @class */ (function () {
    function BentoModalConfirmationComponent(activeModal, win, platform, cd) {
        this.activeModal = activeModal;
        this.platform = platform;
        this.cd = cd;
        this.buttonType = 'primary';
        this.iconColorType = 'primary';
        this.cancelButtonText = 'Cancel';
        this.confirmButtonText = 'Confirm';
        this.confirmButtonType = 'primary';
        this.message = 'Are you sure?';
        this.title = 'Confirm';
        // tslint:disable no-unused-variable
        this.hasCustomTitle = false;
        this.enableCloseButton = true;
        this.window = win.nativeWindow;
    }
    /**
     * @return {?}
     */
    BentoModalConfirmationComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.platform.isBrowser) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                // We need to make sure that close button is not enabled if CSS is used to
                // hide close button
                /** @type {?} */
                var display = _this.window.getComputedStyle(_this.closeButtonElRef.nativeElement).display;
                if (display === 'none') {
                    _this.enableCloseButton = false;
                    _this.cancelButtonElRef.nativeElement.focus();
                    _this.cd.markForCheck();
                }
            }));
        }
    };
    /**
     * Configure how and what needs to be render in UI
     * @param message Message that is displayed in the modl
     * @param config configuration to customize text labels
     */
    /**
     * Configure how and what needs to be render in UI
     * @param {?} message Message that is displayed in the modl
     * @param {?=} config configuration to customize text labels
     * @return {?}
     */
    BentoModalConfirmationComponent.prototype.setConfig = /**
     * Configure how and what needs to be render in UI
     * @param {?} message Message that is displayed in the modl
     * @param {?=} config configuration to customize text labels
     * @return {?}
     */
    function (message, config) {
        if (config === void 0) { config = {}; }
        this.buttonType = config.buttonType || this.buttonType;
        this.iconName = config.iconName || this.iconName;
        this.iconColorType = config.iconColorType || this.iconColorType;
        this.closeButtonText = config.closeButtonText || this.closeButtonText;
        this.cancelButtonText = config.cancelButtonText || this.cancelButtonText;
        this.confirmButtonText = config.confirmButtonText || this.confirmButtonText;
        this.confirmButtonType = config.buttonType || this.confirmButtonType;
        this.message = message || this.message;
        this.title = config.titleText || this.title;
        this.hasCustomTitle = !!config.titleText;
    };
    /** @nocollapse */
    BentoModalConfirmationComponent.ctorParameters = function () { return [
        { type: NgbActiveModal },
        { type: WindowRef },
        { type: Platform },
        { type: ChangeDetectorRef }
    ]; };
    BentoModalConfirmationComponent.propDecorators = {
        hasCustomTitle: [{ type: HostBinding, args: ['class.bui-modal-has-title',] }],
        closeButtonElRef: [{ type: ViewChild, args: ['closeButton',] }],
        cancelButtonElRef: [{ type: ViewChild, args: ['cancelButton',] }]
    };
BentoModalConfirmationComponent.ɵfac = function BentoModalConfirmationComponent_Factory(t) { return new (t || BentoModalConfirmationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoModalConfirmationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoModalConfirmationComponent, selectors: [["bento-modal-confirmation"]], viewQuery: function BentoModalConfirmationComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c20, true);
        ɵngcc0.ɵɵviewQuery(_c21, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.closeButtonElRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cancelButtonElRef = _t.first);
    } }, hostVars: 2, hostBindings: function BentoModalConfirmationComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bui-modal-has-title", ctx.hasCustomTitle);
    } }, decls: 13, vars: 7, consts: [["type", "button", "class", "close", "ngbAutoFocus", "", "container", "body", 3, "ngbTooltip", "click", 4, "ngIf"], [1, "modal-header", "h2"], [1, "modal-body"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], [1, "modal-footer"], ["type", "button", 1, "btn", 3, "ngClass", "click"], ["type", "button", 1, "btn", "btn-outline-primary", 3, "click"], ["cancelButton", ""], ["type", "button", "ngbAutoFocus", "", "container", "body", 1, "close", 3, "ngbTooltip", "click"], ["closeButton", ""], ["aria-hidden", "true", 1, "bento-icon-close-x"], ["aria-hidden", "true"]], template: function BentoModalConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoModalConfirmationComponent_button_0_Template, 4, 4, "button", 0);
        ɵngcc0.ɵɵelementStart(1, "h3", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, BentoModalConfirmationComponent_i_4_Template, 1, 4, "i", 3);
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵlistener("click", function BentoModalConfirmationComponent_Template_button_click_8_listener() { return ctx.activeModal.close("Confirm"); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 6, 7);
        ɵngcc0.ɵɵlistener("click", function BentoModalConfirmationComponent_Template_button_click_10_listener() { return ctx.activeModal.close("Cancel"); });
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableCloseButton);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconName);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", "btn-" + ctx.buttonType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.confirmButtonText, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.cancelButtonText, " ");
    } }, directives: [ɵngcc7.NgIf, BentoFooterTabHelper,
        BentoFocusMonitorDirective, ɵngcc7.NgClass, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective], pipes: [BentoTranslatePipe], styles: [""], changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoModalConfirmationComponent, [{
        type: Component,
        args: [{
                selector: 'bento-modal-confirmation',
                template: "<button\n  #closeButton\n  type=\"button\"\n  class=\"close\"\n  ngbAutoFocus\n  (click)=\"activeModal.dismiss('Close')\"\n  ngbTooltip=\"{{ 'BENTO_UI_MODAL_CONFIRMATION_CLOSE' | bentoTranslate: closeButtonText }}\"\n  container=\"body\"\n  *ngIf=\"enableCloseButton\"\n>\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<h3 class=\"modal-header h2\">{{ title }}</h3>\n<div class=\"modal-body\">\n  <i *ngIf=\"iconName\" class=\"modal-confirmation-icon {{ iconName }} text-{{ iconColorType }}\" aria-hidden=\"true\"></i>\n  <div>{{ message }}</div>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn\" [ngClass]=\"'btn-' + buttonType\" (click)=\"activeModal.close('Confirm')\">\n    {{ confirmButtonText }}\n  </button>\n  <button #cancelButton type=\"button\" class=\"btn btn-outline-primary\" (click)=\"activeModal.close('Cancel')\">\n    {{ cancelButtonText }}\n  </button>\n</div>\n\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc4.NgbActiveModal }, { type: WindowRef }, { type: ɵngcc3.Platform }, { type: ɵngcc0.ChangeDetectorRef }]; }, { hasCustomTitle: [{
            type: HostBinding,
            args: ['class.bui-modal-has-title']
        }], closeButtonElRef: [{
            type: ViewChild,
            args: ['closeButton']
        }], cancelButtonElRef: [{
            type: ViewChild,
            args: ['cancelButton']
        }] }); })();
    return BentoModalConfirmationComponent;
}());
if (false) {
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.buttonType;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.iconName;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.iconColorType;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.cancelButtonText;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.closeButtonText;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.confirmButtonText;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.confirmButtonType;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.message;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.title;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.hasCustomTitle;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.closeButtonElRef;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.cancelButtonElRef;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.enableCloseButton;
    /**
     * @type {?}
     * @private
     */
    BentoModalConfirmationComponent.prototype.window;
    /** @type {?} */
    BentoModalConfirmationComponent.prototype.activeModal;
    /**
     * @type {?}
     * @private
     */
    BentoModalConfirmationComponent.prototype.platform;
    /**
     * @type {?}
     * @private
     */
    BentoModalConfirmationComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-confirmation/modal-confirmation.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var BentoModalConfirmationCloseReason = {
    /**
     * When modal is confirmed by an user
     */
    Confirm: "Confirm",
    /**
     * When modal confirmation is canceled by an user
     */
    Cancel: "Cancel",
};
/**
 * This is a helper service to provide a confirmation modal without implemeting templates
 * and other neccessary default behaviors
 */
var BentoModalConfirmationService = /** @class */ (function () {
    function BentoModalConfirmationService(modalService) {
        this.modalService = modalService;
    }
    /**
     * Opens a confirmation modal window
     */
    /**
     * Opens a confirmation modal window
     * @param {?=} message
     * @param {?=} config
     * @param {?=} modalConfig
     * @return {?}
     */
    BentoModalConfirmationService.prototype.open = /**
     * Opens a confirmation modal window
     * @param {?=} message
     * @param {?=} config
     * @param {?=} modalConfig
     * @return {?}
     */
    function (message, config, modalConfig) {
        // Create a default modal config or using the one that's provided by user
        /** @type {?} */
        var mConfig = modalConfig || { windowClass: '' };
        // Make sure to add our custom modal confirmation window class
        mConfig.windowClass = 'bui-modal-confirmation ' + mConfig.windowClass;
        /** @type {?} */
        var modalRef = this.modalService.open(BentoModalConfirmationComponent, mConfig);
        /** @type {?} */
        var instance = modalRef.componentInstance;
        instance.setConfig(message, config);
        return modalRef;
    };
    /** @nocollapse */
    BentoModalConfirmationService.ctorParameters = function () { return [
        { type: NgbModal }
    ]; };
BentoModalConfirmationService.ɵfac = function BentoModalConfirmationService_Factory(t) { return new (t || BentoModalConfirmationService)(ɵngcc0.ɵɵinject(ɵngcc4.NgbModal)); };
BentoModalConfirmationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoModalConfirmationService, factory: function (t) { return BentoModalConfirmationService.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoModalConfirmationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.NgbModal }]; }, null); })();
    return BentoModalConfirmationService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoModalConfirmationService.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-confirmation/modal-confirmation.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoModalConfirmationModule = /** @class */ (function () {
    function BentoModalConfirmationModule(modalConfig) {
        modalConfig.centered = true; // Default to vertically center aligned for Bento
    }
    /** @nocollapse */
    BentoModalConfirmationModule.ctorParameters = function () { return [
        { type: NgbModalConfig }
    ]; };
BentoModalConfirmationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoModalConfirmationModule });
BentoModalConfirmationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoModalConfirmationModule_Factory(t) { return new (t || BentoModalConfirmationModule)(ɵngcc0.ɵɵinject(ɵngcc4.NgbModalConfig)); }, providers: [BentoModalConfirmationService], imports: [[
            CommonModule,
            BentoFocusMonitorModule,
            NgbModalModule,
            A11yModule,
            BentoUtilsModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule,
            BentoTranslateModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoModalConfirmationModule, { declarations: function () { return [BentoModalConfirmationComponent,
        BentoFooterTabHelper]; }, imports: function () { return [CommonModule,
        BentoFocusMonitorModule,
        NgbModalModule,
        A11yModule,
        BentoUtilsModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule,
        BentoTranslateModule]; }, exports: function () { return [BentoFooterTabHelper]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoModalConfirmationModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoModalConfirmationComponent, BentoFooterTabHelper],
                imports: [
                    CommonModule,
                    BentoFocusMonitorModule,
                    NgbModalModule,
                    A11yModule,
                    BentoUtilsModule,
                    NgbTooltipModule,
                    BentoNgbTooltipSupportModule,
                    BentoTranslateModule
                ],
                exports: [BentoFooterTabHelper],
                providers: [BentoModalConfirmationService],
                entryComponents: [BentoModalConfirmationComponent]
            }]
    }], function () { return [{ type: ɵngcc4.NgbModalConfig }]; }, null); })();
    return BentoModalConfirmationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/multiselect-overlay/multiselect-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var Selection = {
    all: 0,
    selected: 1,
};
Selection[Selection.all] = 'all';
Selection[Selection.selected] = 'selected';
var BentoMultiselectListComponent = /** @class */ (function (_super) {
    __extends(BentoMultiselectListComponent, _super);
    function BentoMultiselectListComponent(bentoUid, logService) {
        var _this = _super.call(this) || this;
        _this.logService = logService;
        /**
         * Notify when the length of the main items data is changed
         */
        _this.lengthChange = new EventEmitter();
        /**
         * Notify when a row is clicked with an OS pointer
         */
        _this.rowClick = new EventEmitter();
        /**
         * List Height
         */
        _this._listHeight = 0;
        /**
         * List Width
         */
        _this._listWidth = 0;
        /**
         * Emit Data change
         */
        _this._dataChange = new EventEmitter();
        /**
         * Refernce to current datasize
         */
        _this._dataSize = 0;
        /**
         * Index to determine which item is active
         */
        _this._activeIndex = -1;
        _this.selectedListChange = new EventEmitter();
        /**
         * Selection to defines filtering of the list
         */
        _this._selection = Selection.all;
        /**
         * Select all row
         */
        _this._selectAllRow = {
            name: 'BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL',
            isSelectAll: true
        };
        /**
         * A status list to represent whether an item is checked or not
         */
        _this.checkStatusRef = new Map();
        _this._listOptions = { checkStatusRef: _this.checkStatusRef };
        _this._uid = bentoUid.generate();
        return _this;
    }
    Object.defineProperty(BentoMultiselectListComponent.prototype, "itemsObservable", {
        /**
         * Main Data seter
         */
        set: /**
         * Main Data seter
         * @param {?} observable
         * @return {?}
         */
        function (observable) {
            this._setDataObservable(observable);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoMultiselectListComponent.prototype, "height", {
        /**
         * Set the height of the list
         */
        set: /**
         * Set the height of the list
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._listHeight = v - this.topPanel.nativeElement.offsetHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoMultiselectListComponent.prototype, "width", {
        /**
         * Width setting to this component
         */
        set: /**
         * Width setting to this component
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._listWidth = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoMultiselectListComponent.prototype, "selectedList", {
        /**
         * selected list
         */
        get: /**
         * selected list
         * @return {?}
         */
        function () {
            var e_1, _a;
            /** @type {?} */
            var list = [];
            try {
                for (var _b = __values(this._data), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (this.checkStatusRef.get(item)) {
                        list.push(item);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return list;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoMultiselectListComponent.prototype, "_selectedList", {
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            var e_2, _a, e_3, _b;
            if (this._data) {
                /** @type {?} */
                var notIncluded = false;
                try {
                    // Check if ALL objects are in the main dataset
                    for (var v_1 = __values(v), v_1_1 = v_1.next(); !v_1_1.done; v_1_1 = v_1.next()) {
                        var row = v_1_1.value;
                        if (this._data.indexOf(row) === -1) {
                            notIncluded = true;
                            this.logService.warn('Bento Multiselect Overlay:', 'Object is not in the original dataset ->', row);
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (v_1_1 && !v_1_1.done && (_a = v_1.return)) _a.call(v_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                // Do not proceed when selected list does not qualify
                if (notIncluded) {
                    return;
                }
                // clear all checked status
                this.clearCheckStatus();
                try {
                    // update selected list
                    for (var v_2 = __values(v), v_2_1 = v_2.next(); !v_2_1.done; v_2_1 = v_2.next()) {
                        var listItem = v_2_1.value;
                        this.checkStatusRef.set(listItem, true);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (v_2_1 && !v_2_1.done && (_b = v_2.return)) _b.call(v_2);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                // update select all row checkbox
                this.checkAllSelected();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gain focus on the search field
     */
    /**
     * Gain focus on the search field
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.focusOnSearchField = /**
     * Gain focus on the search field
     * @return {?}
     */
    function () {
        var _this = this;
        // Focus back to search field
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.searchFieldRef.nativeElement.focus();
        }));
    };
    /**
     * Gain focus on the show all button
     */
    /**
     * Gain focus on the show all button
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.focusOnShowAllButton = /**
     * Gain focus on the show all button
     * @return {?}
     */
    function () {
        var _this = this;
        // Focus back to show all button
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.showAllRef.nativeElement.focus();
        }));
    };
    /**
     * Set list selection
     */
    /**
     * Set list selection
     * @param {?} s
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.show = /**
     * Set list selection
     * @param {?} s
     * @return {?}
     */
    function (s) {
        this._activeIndex = -1;
        this._selection = s;
        this.onSearch(this._searchTerm);
    };
    /**
     * Search and display the list based on search string `s`
     */
    /**
     * Search and display the list based on search string `s`
     * @param {?} s
     * @param {?=} isQuietUpdate
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.onSearch = /**
     * Search and display the list based on search string `s`
     * @param {?} s
     * @param {?=} isQuietUpdate
     * @return {?}
     */
    function (s, isQuietUpdate) {
        if (!s || s.length === 0) {
            if (this._selection === Selection.all) {
                this._filteredList = this.processDefaultFilteredList(this._data);
            }
            else {
                this._filteredList = this.selectedList;
            }
        }
        else {
            if (this._selection === Selection.all) {
                this._filteredList = this.processDefaultFilteredList(this.searchFromList(this._data, s));
            }
            else {
                this._filteredList = this.searchFromList(this.selectedList, s);
            }
        }
        this._dataSize = this._filteredList.length;
        // update select all row checkbox
        this.checkAllSelected();
        this._searchTerm = s;
        // Notify Bento List
        this._dataChange.emit(this._filteredList);
    };
    /**
     * Toggle the row that is clicked
     */
    /**
     * Toggle the row that is clicked
     * @param {?} row
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.toggleRowChecked = /**
     * Toggle the row that is clicked
     * @param {?} row
     * @return {?}
     */
    function (row) {
        var e_4, _a;
        // Flip checked state
        /** @type {?} */
        var checked = !this.checkStatusRef.get(row);
        this.checkStatusRef.set(row, checked);
        if (row.isSelectAll) {
            try {
                // Selecte all
                for (var _b = __values(this._filteredList), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var r = _c.value;
                    this.checkStatusRef.set(r, checked);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        this.checkAllSelected();
        // Emit changes
        this.selectedListChange.emit(this.selectedList);
    };
    /**
     * Search a string from an array
     */
    /**
     * Search a string from an array
     * @param {?} a
     * @param {?} s
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.searchFromList = /**
     * Search a string from an array
     * @param {?} a
     * @param {?} s
     * @return {?}
     */
    function (a, s) {
        var e_5, _a;
        /** @type {?} */
        var l = [];
        /** @type {?} */
        var searchCompare = this.searchCompare ||
            ((/**
             * @param {?} item
             * @param {?} search
             * @return {?}
             */
            function (item, search) {
                // Default search and compare function and only searches the name property
                return item.name.toLowerCase().indexOf(search) > -1;
            }));
        s = s.toLowerCase();
        try {
            for (var a_1 = __values(a), a_1_1 = a_1.next(); !a_1_1.done; a_1_1 = a_1.next()) {
                var row = a_1_1.value;
                if (searchCompare(row, s)) {
                    l.push(row);
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (a_1_1 && !a_1_1.done && (_a = a_1.return)) _a.call(a_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return l;
    };
    /**
     * When a row is clicked
     * ~@private
     */
    /**
     * When a row is clicked
     * ~\@private
     * @param {?} $event
     * @param {?} $row
     * @param {?} $index
     * @return {?}
     */
    BentoMultiselectListComponent.prototype._onRowClick = /**
     * When a row is clicked
     * ~\@private
     * @param {?} $event
     * @param {?} $row
     * @param {?} $index
     * @return {?}
     */
    function ($event, $row, $index) {
        this._activeIndex = $index;
        this.toggleRowChecked($row);
        // Emit row click
        this.rowClick.emit($event);
        this.focusOnSearchField();
        $event.preventDefault();
        $event.stopPropagation();
    };
    /**
     * When a keydown event is executed on the row
     */
    /**
     * When a keydown event is executed on the row
     * @param {?} e
     * @param {?} $row
     * @return {?}
     */
    BentoMultiselectListComponent.prototype._onRowKeydown = /**
     * When a keydown event is executed on the row
     * @param {?} e
     * @param {?} $row
     * @return {?}
     */
    function (e, $row) {
        switch (e.keyCode) {
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                this.toggleRowChecked($row);
                // Emit row click
                this.rowClick.emit(e);
                e.preventDefault();
                break;
        }
    };
    /**
     * Callback when BentoList gains focus
     */
    /**
     * Callback when BentoList gains focus
     * @param {?} e
     * @return {?}
     */
    BentoMultiselectListComponent.prototype._onListFocus = /**
     * Callback when BentoList gains focus
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this._activeIndex < 0) {
            this._activeIndex = 0;
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    BentoMultiselectListComponent.prototype._onListKeydown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var dataSize = this._filteredList.length;
        switch (e.keyCode) {
            case Keyboard.DOWN:
                this._activeIndex = (this._activeIndex + 1) % dataSize;
                this.list.showRowIndex(this._activeIndex);
                e.preventDefault();
                break;
            case Keyboard.UP:
                this._activeIndex = (this._activeIndex - 1 + dataSize) % dataSize;
                this.list.showRowIndex(this._activeIndex);
                e.preventDefault();
                break;
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                this.toggleRowChecked(this._filteredList[this._activeIndex]);
                // Emit row click
                this.rowClick.emit(e);
                e.preventDefault();
                break;
        }
    };
    /**
     * Override `BentoListSubscribable` method
     */
    /**
     * Override `BentoListSubscribable` method
     * @param {?} data
     * @return {?}
     */
    BentoMultiselectListComponent.prototype._onDataUpdate = /**
     * Override `BentoListSubscribable` method
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.updateCheckedStatusRef();
        this.lengthChange.emit(this._data.length);
        this.onSearch(this._searchTerm, true);
    };
    /**
     * Update checked status ref everytime when base data set is updated
     */
    /**
     * Update checked status ref everytime when base data set is updated
     * @private
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.updateCheckedStatusRef = /**
     * Update checked status ref everytime when base data set is updated
     * @private
     * @return {?}
     */
    function () {
        var e_6, _a;
        /** @type {?} */
        var newStatusRef = new Map();
        try {
            for (var _b = __values(this._data), _c = _b.next(); !_c.done; _c = _b.next()) {
                var listItem = _c.value;
                newStatusRef.set(listItem, this.checkStatusRef.get(listItem));
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        delete this.checkStatusRef;
        // Assign the new status reference
        this.checkStatusRef = newStatusRef;
        // Make sure to update the list options reference as well
        this._listOptions.checkStatusRef = newStatusRef;
    };
    /**
     * Check if all in the filtered list are selected
     */
    /**
     * Check if all in the filtered list are selected
     * @private
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.checkAllSelected = /**
     * Check if all in the filtered list are selected
     * @private
     * @return {?}
     */
    function () {
        var e_7, _a;
        /** @type {?} */
        var dataListToCheck;
        /** @type {?} */
        var allChecked = true;
        // There are selections
        if (Array.isArray(this._filteredList) && this._filteredList.length) {
            // only check where there is a filtered list
            dataListToCheck = this._filteredList;
        }
        else {
            dataListToCheck = this._data;
        }
        try {
            for (var dataListToCheck_1 = __values(dataListToCheck), dataListToCheck_1_1 = dataListToCheck_1.next(); !dataListToCheck_1_1.done; dataListToCheck_1_1 = dataListToCheck_1.next()) {
                var item = dataListToCheck_1_1.value;
                // Check and see if all items in the current list are checked
                if (!this.checkStatusRef.get(item) && item.name !== this._selectAllRow.name) {
                    // There is at least one that is not checked
                    allChecked = false;
                    break;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (dataListToCheck_1_1 && !dataListToCheck_1_1.done && (_a = dataListToCheck_1.return)) _a.call(dataListToCheck_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
        this.checkStatusRef.set(this._selectAllRow, allChecked);
    };
    /**
     * Format the list structure based on a filtered list
     */
    /**
     * Format the list structure based on a filtered list
     * @private
     * @param {?} list
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.processDefaultFilteredList = /**
     * Format the list structure based on a filtered list
     * @private
     * @param {?} list
     * @return {?}
     */
    function (list) {
        return list.length > 1 ? [this._selectAllRow].concat(list) : list;
    };
    /**
     * Clear all checked status
     */
    /**
     * Clear all checked status
     * @private
     * @return {?}
     */
    BentoMultiselectListComponent.prototype.clearCheckStatus = /**
     * Clear all checked status
     * @private
     * @return {?}
     */
    function () {
        this.checkStatusRef = new Map();
        delete this._listOptions.checkStatusRef;
        this._listOptions.checkStatusRef = this.checkStatusRef;
    };
    /** @nocollapse */
    BentoMultiselectListComponent.ctorParameters = function () { return [
        { type: BentoUidService },
        { type: BentoLogService }
    ]; };
    BentoMultiselectListComponent.propDecorators = {
        showAllText: [{ type: Input }],
        showSelectedText: [{ type: Input }],
        selectAllText: [{ type: Input }],
        searchLabelText: [{ type: Input }],
        itemsObservable: [{ type: Input }],
        height: [{ type: Input }],
        width: [{ type: Input }],
        listItemTemplate: [{ type: Input }],
        searchCompare: [{ type: Input }],
        lengthChange: [{ type: Output }],
        rowClick: [{ type: Output }],
        topPanel: [{ type: ViewChild, args: ['topPanel', { static: true },] }],
        list: [{ type: ViewChild, args: ['list', { static: true },] }],
        _selectedList: [{ type: Input, args: ['selectedList',] }],
        selectedListChange: [{ type: Output }],
        searchFieldRef: [{ type: ViewChild, args: ['searchField', { static: true },] }],
        showAllRef: [{ type: ViewChild, args: ['showAll', { static: true },] }]
    };
BentoMultiselectListComponent.ɵfac = function BentoMultiselectListComponent_Factory(t) { return new (t || BentoMultiselectListComponent)(ɵngcc0.ɵɵdirectiveInject(BentoUidService), ɵngcc0.ɵɵdirectiveInject(BentoLogService)); };
BentoMultiselectListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoMultiselectListComponent, selectors: [["bento-multiselect-list"]], viewQuery: function BentoMultiselectListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c22, true);
        ɵngcc0.ɵɵstaticViewQuery(_c23, true);
        ɵngcc0.ɵɵstaticViewQuery(_c24, true);
        ɵngcc0.ɵɵstaticViewQuery(_c25, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.topPanel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.list = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchFieldRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.showAllRef = _t.first);
    } }, inputs: { itemsObservable: "itemsObservable", height: "height", width: "width", _selectedList: ["selectedList", "_selectedList"], showAllText: "showAllText", showSelectedText: "showSelectedText", selectAllText: "selectAllText", searchLabelText: "searchLabelText", listItemTemplate: "listItemTemplate", searchCompare: "searchCompare" }, outputs: { lengthChange: "lengthChange", rowClick: "rowClick", selectedListChange: "selectedListChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 25, vars: 30, consts: [["role", "dialog", 1, "bento-multiselect-list-item", "bento-multiselect-search"], ["topPanel", ""], [1, "pills"], ["role", "tablist", 1, "nav", "nav-pills"], [3, "ngClass"], ["role", "tab", "type", "button", 3, "click"], ["showAll", ""], [1, "bento-search-label"], [1, "bento-search"], ["bentoReset", "", "type", "text", "aria-invalid", "false", 1, "form-control", 3, "ngModel", "ngModelChange"], ["searchField", ""], ["cdkMonitorElementFocus", "", "aria-hidden", "false", "role", "listbox", "aria-multiselectable", "true", "tabindex", "0", 3, "dataObservable", "options", "height", "width", "focus", "keydown"], ["list", ""], ["rowTemplate", ""], [4, "ngIf", "ngIfElse"], ["defaultListItemTemplate", ""], ["role", "option", 1, "bento-list-row", "bento-multiselect-list-item", 3, "click"], ["tabindex", "-1", 3, "ngModel"], [1, "bento-multiselect-list-item-label"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "option", 1, "bento-list-row", "bento-multiselect-list-item", 3, "ngClass", "click"]], template: function BentoMultiselectListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "ul", 3);
        ɵngcc0.ɵɵelementStart(4, "li", 4);
        ɵngcc0.ɵɵelementStart(5, "button", 5, 6);
        ɵngcc0.ɵɵlistener("click", function BentoMultiselectListComponent_Template_button_click_5_listener() { return ctx.show(0); });
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "li", 4);
        ɵngcc0.ɵɵelementStart(11, "button", 5);
        ɵngcc0.ɵɵlistener("click", function BentoMultiselectListComponent_Template_button_click_11_listener() { return ctx.show(1); });
        ɵngcc0.ɵɵelementStart(12, "span");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "label", 7);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 8);
        ɵngcc0.ɵɵelementStart(19, "input", 9, 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function BentoMultiselectListComponent_Template_input_ngModelChange_19_listener($event) { return ctx.onSearch($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "bento-list", 11, 12);
        ɵngcc0.ɵɵlistener("focus", function BentoMultiselectListComponent_Template_bento_list_focus_21_listener($event) { return ctx._onListFocus($event); })("keydown", function BentoMultiselectListComponent_Template_bento_list_keydown_21_listener($event) { return ctx._onListKeydown($event); });
        ɵngcc0.ɵɵtemplate(23, BentoMultiselectListComponent_ng_template_23_Template, 3, 2, "ng-template", null, 13, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ctx._selection == 0 ? "active " : "");
        ɵngcc0.ɵɵattribute("id", "show-all" + ctx._uid)("aria-controls", "show-all-panel" + ctx._uid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-selected", ctx._selection == 0 ? true : false);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(9, 21, "BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL", ctx.showAllText), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx._selection == 1 ? "active " : "");
        ɵngcc0.ɵɵattribute("id", "show-selected" + ctx._uid)("aria-controls", "show-selected-panel" + ctx._uid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-selected", ctx._selection == 1 ? true : false);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(14, 24, "BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED", ctx.showSelectedText), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("for", "multiselect-filter-items-" + ctx._uid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(17, 27, "BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL", ctx.searchLabelText), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx._searchTerm);
        ɵngcc0.ɵɵattribute("id", "multiselect-filter-items-" + ctx._uid);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("dataObservable", ctx._dataChange)("options", ctx._listOptions)("height", ctx._listHeight)("width", ctx._listWidth);
        ɵngcc0.ɵɵattribute("id", ctx._selection == 0 ? "show-all-panel" + ctx._uid : "show-selected-panel" + ctx._uid)("aria-labelledby", ctx._selection == 0 ? "show-all" + ctx._uid : "show-selected" + ctx._uid)("aria-activedescendant", "row" + ctx._uid + ctx._activeIndex);
    } }, directives: [ɵngcc7.NgClass, ɵngcc8.DefaultValueAccessor, BentoResetDirective, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, BentoListComponent, ɵngcc1.CdkMonitorFocus, ɵngcc7.NgIf, BentoCheckboxComponent, ɵngcc7.NgTemplateOutlet], pipes: [BentoTranslatePipe], styles: ["bento-multiselect-list{display:block;box-sizing:border-box;position:relative;height:100%}bento-multiselect-list bento-checkbox{pointer-events:none}bento-multiselect-list bento-list{border:none;position:relative;z-index:1}bento-multiselect-list bento-list:focus{outline:0}bento-multiselect-list .pills{margin:-10px -10px 10px;border-bottom-width:1px;border-bottom-style:solid}bento-multiselect-list .nav-pills{white-space:nowrap;padding:0}bento-multiselect-list .nav-pills>li{display:inline-block;width:50%;position:relative}bento-multiselect-list .nav-pills>li:before{content:\"\"}bento-multiselect-list .nav-pills>li+li{margin-left:0}bento-multiselect-list .nav-pills>li.active button{background-color:transparent}bento-multiselect-list .nav-pills>li button{border-bottom:4px solid transparent!important;width:100%;border-radius:0;border-width:0;text-align:center;padding:12px 15px 12px 10px;display:block;line-height:1}bento-multiselect-list .nav-pills>li button:focus{outline:0}bento-multiselect-list .nav-pills>li button:hover,bento-multiselect-list .nav-pills>li button:not(:active):focus{text-decoration:underline}bento-multiselect-list .bento-multiselect-list-item{cursor:pointer;display:flex;align-items:center;justify-content:flex-start;border:none;border-top-width:1px;border-top-style:solid;padding:0 10px;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-multiselect-list .bento-multiselect-list-item:last-of-type{border-bottom-width:1px;border-bottom-style:solid}bento-multiselect-list .bento-multiselect-list-item:first-child{border:none}bento-multiselect-list .bento-multiselect-list-item .nav-pills{margin:0}bento-multiselect-list .bento-multiselect-list-item .nav-pills>li>a{padding-top:0;padding-bottom:0}bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search{display:block;cursor:default;padding:10px;border-bottom-width:1px;border-bottom-style:solid}bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search>input{background:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' width='23.495px' height='23.495px' viewBox='0 0 23.495 23.495' enable-background='new 0 0 23.495 23.495' xml:space='preserve'%3E%3Cg id='search_1_'%3E%3Cpath fill='%23606060' d='M23.347 20.505l-5.878-5.879c0.956-1.481 1.521-3.24 1.521-5.132C18.99 4.3 14.7 0 9.5 0 C4.258 0 0 4.3 0 9.494c0 5.2 4.3 9.5 9.5 9.495c1.891 0 3.649-0.562 5.132-1.52l5.878 5.9 c0.195 0.2 0.5 0.2 0.7 0l2.132-2.132C23.544 21 23.5 20.7 23.3 20.505z M3.015 9.5 c0-3.571 2.906-6.479 6.479-6.479s6.479 2.9 6.5 6.479c0 3.573-2.904 6.479-6.479 6.479C5.921 16 3 13.1 3 9.5 z'/%3E%3C/g%3E%3C/svg%3E\") 9px center/20px no-repeat;-webkit-background-clip:padding-box;border-radius:0;box-sizing:border-box;margin:0;outline:0;padding-left:36px;border-width:1px;border-style:solid}bento-multiselect-list .bento-multiselect-list-item>i{margin-right:5px;top:.0714px}bento-multiselect-list .bento-multiselect-list-item-label{flex-basis:0;flex-grow:1;max-height:100%}[dir=rtl] bento-multiselect-list .bento-multiselect-list-item{text-align:right}[dir=rtl] bento-multiselect-list .bento-multiselect-list-item>i{margin-right:auto;margin-left:5px}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMultiselectListComponent, [{
        type: Component,
        args: [{
                selector: 'bento-multiselect-list',
                template: "<div #topPanel class=\"bento-multiselect-list-item bento-multiselect-search\" role=\"dialog\">\n  <div class=\"pills\">\n    <ul class=\"nav nav-pills\" role=\"tablist\">\n      <li\n        [attr.id]=\"'show-all' + _uid\"\n        [attr.aria-controls]=\"'show-all-panel' + _uid\"\n        [ngClass]=\"_selection == 0 ? 'active ' : ''\"\n      >\n        <button\n          role=\"tab\"\n          (click)=\"show(0)\"\n          [attr.aria-selected]=\"_selection == 0 ? true : false\"\n          type=\"button\"\n          #showAll\n        >\n          <span>\n            {{ 'BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL' | bentoTranslate: showAllText }}\n          </span>\n        </button>\n      </li>\n      <li\n        [attr.id]=\"'show-selected' + _uid\"\n        [attr.aria-controls]=\"'show-selected-panel' + _uid\"\n        [ngClass]=\"_selection == 1 ? 'active ' : ''\"\n      >\n        <button role=\"tab\" (click)=\"show(1)\" [attr.aria-selected]=\"_selection == 1 ? true : false\" type=\"button\">\n          <span>\n            {{ 'BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED' | bentoTranslate: showSelectedText }}\n          </span>\n        </button>\n      </li>\n    </ul>\n  </div>\n  <label class=\"bento-search-label\" [attr.for]=\"'multiselect-filter-items-' + _uid\">\n    {{ 'BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL' | bentoTranslate: searchLabelText }}\n  </label>\n  <div class=\"bento-search\">\n    <input\n      [attr.id]=\"'multiselect-filter-items-' + _uid\"\n      bentoReset\n      #searchField\n      type=\"text\"\n      [ngModel]=\"_searchTerm\"\n      (ngModelChange)=\"onSearch($event)\"\n      class=\"form-control\"\n      aria-invalid=\"false\"\n    />\n  </div>\n</div>\n\n<bento-list\n  #list\n  cdkMonitorElementFocus\n  [dataObservable]=\"_dataChange\"\n  [options]=\"_listOptions\"\n  [height]=\"_listHeight\"\n  [width]=\"_listWidth\"\n  [attr.id]=\"_selection == 0 ? 'show-all-panel' + _uid : 'show-selected-panel' + _uid\"\n  [attr.aria-labelledby]=\"_selection == 0 ? 'show-all' + _uid : 'show-selected' + _uid\"\n  (focus)=\"_onListFocus($event)\"\n  (keydown)=\"_onListKeydown($event)\"\n  aria-hidden=\"false\"\n  role=\"listbox\"\n  [attr.aria-activedescendant]=\"'row' + _uid + _activeIndex\"\n  aria-multiselectable=\"true\"\n  tabindex=\"0\"\n>\n  <ng-template #rowTemplate let-$index=\"index\" let-$row=\"row\" let-$o=\"options\">\n    <ng-container *ngIf=\"listItemTemplate && !$row.isSelectAll; else defaultListItemTemplate\">\n      <div\n        [attr.id]=\"'row' + _uid + $index\"\n        class=\"bento-list-row bento-multiselect-list-item\"\n        (click)=\"_onRowClick($event, $row, $index)\"\n        role=\"option\"\n        [attr.aria-selected]=\"!!$o.checkStatusRef.get($row)\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$index + 1\"\n      >\n        <bento-checkbox [ngModel]=\"$o.checkStatusRef.get($row)\" tabindex=\"-1\"></bento-checkbox>\n        <div class=\"bento-multiselect-list-item-label\">\n          <ng-container\n            *ngTemplateOutlet=\"listItemTemplate; context: {item: $row, index: $index, options: $o}\"\n          ></ng-container>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-template #defaultListItemTemplate>\n      <div\n        [attr.id]=\"'row' + _uid + $index\"\n        class=\"bento-list-row bento-multiselect-list-item\"\n        (click)=\"_onRowClick($event, $row, $index)\"\n        role=\"option\"\n        [attr.aria-selected]=\"!!$o.checkStatusRef.get($row)\"\n        [attr.aria-setsize]=\"_dataSize\"\n        [attr.aria-posinset]=\"$index + 1\"\n        [attr.title]=\"$row.isSelectAll ? '' : $row.name\"\n        [ngClass]=\"$index === _activeIndex ? 'focused ' : ''\"\n      >\n        <bento-checkbox [ngModel]=\"$o.checkStatusRef.get($row)\" tabindex=\"-1\"></bento-checkbox>\n        <div class=\"bento-multiselect-list-item-label\">\n          {{ $row.isSelectAll ? ($row.name | bentoTranslate: selectAllText) : $row.name }}\n        </div>\n      </div>\n    </ng-template>\n  </ng-template>\n</bento-list>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["bento-multiselect-list{display:block;box-sizing:border-box;position:relative;height:100%}bento-multiselect-list bento-checkbox{pointer-events:none}bento-multiselect-list bento-list{border:none;position:relative;z-index:1}bento-multiselect-list bento-list:focus{outline:0}bento-multiselect-list .pills{margin:-10px -10px 10px;border-bottom-width:1px;border-bottom-style:solid}bento-multiselect-list .nav-pills{white-space:nowrap;padding:0}bento-multiselect-list .nav-pills>li{display:inline-block;width:50%;position:relative}bento-multiselect-list .nav-pills>li:before{content:\"\"}bento-multiselect-list .nav-pills>li+li{margin-left:0}bento-multiselect-list .nav-pills>li.active button{background-color:transparent}bento-multiselect-list .nav-pills>li button{border-bottom:4px solid transparent!important;width:100%;border-radius:0;border-width:0;text-align:center;padding:12px 15px 12px 10px;display:block;line-height:1}bento-multiselect-list .nav-pills>li button:focus{outline:0}bento-multiselect-list .nav-pills>li button:hover,bento-multiselect-list .nav-pills>li button:not(:active):focus{text-decoration:underline}bento-multiselect-list .bento-multiselect-list-item{cursor:pointer;display:flex;align-items:center;justify-content:flex-start;border:none;border-top-width:1px;border-top-style:solid;padding:0 10px;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-multiselect-list .bento-multiselect-list-item:last-of-type{border-bottom-width:1px;border-bottom-style:solid}bento-multiselect-list .bento-multiselect-list-item:first-child{border:none}bento-multiselect-list .bento-multiselect-list-item .nav-pills{margin:0}bento-multiselect-list .bento-multiselect-list-item .nav-pills>li>a{padding-top:0;padding-bottom:0}bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search{display:block;cursor:default;padding:10px;border-bottom-width:1px;border-bottom-style:solid}bento-multiselect-list .bento-multiselect-list-item.bento-multiselect-search>input{background:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' width='23.495px' height='23.495px' viewBox='0 0 23.495 23.495' enable-background='new 0 0 23.495 23.495' xml:space='preserve'%3E%3Cg id='search_1_'%3E%3Cpath fill='%23606060' d='M23.347 20.505l-5.878-5.879c0.956-1.481 1.521-3.24 1.521-5.132C18.99 4.3 14.7 0 9.5 0 C4.258 0 0 4.3 0 9.494c0 5.2 4.3 9.5 9.5 9.495c1.891 0 3.649-0.562 5.132-1.52l5.878 5.9 c0.195 0.2 0.5 0.2 0.7 0l2.132-2.132C23.544 21 23.5 20.7 23.3 20.505z M3.015 9.5 c0-3.571 2.906-6.479 6.479-6.479s6.479 2.9 6.5 6.479c0 3.573-2.904 6.479-6.479 6.479C5.921 16 3 13.1 3 9.5 z'/%3E%3C/g%3E%3C/svg%3E\") 9px center/20px no-repeat;-webkit-background-clip:padding-box;border-radius:0;box-sizing:border-box;margin:0;outline:0;padding-left:36px;border-width:1px;border-style:solid}bento-multiselect-list .bento-multiselect-list-item>i{margin-right:5px;top:.0714px}bento-multiselect-list .bento-multiselect-list-item-label{flex-basis:0;flex-grow:1;max-height:100%}[dir=rtl] bento-multiselect-list .bento-multiselect-list-item{text-align:right}[dir=rtl] bento-multiselect-list .bento-multiselect-list-item>i{margin-right:auto;margin-left:5px}"]
            }]
    }], function () { return [{ type: BentoUidService }, { type: BentoLogService }]; }, { itemsObservable: [{
            type: Input
        }], height: [{
            type: Input
        }], width: [{
            type: Input
        }], _selectedList: [{
            type: Input,
            args: ['selectedList']
        }], showAllText: [{
            type: Input
        }], showSelectedText: [{
            type: Input
        }], selectAllText: [{
            type: Input
        }], searchLabelText: [{
            type: Input
        }], listItemTemplate: [{
            type: Input
        }], searchCompare: [{
            type: Input
        }], lengthChange: [{
            type: Output
        }], rowClick: [{
            type: Output
        }], topPanel: [{
            type: ViewChild,
            args: ['topPanel', { static: true }]
        }], list: [{
            type: ViewChild,
            args: ['list', { static: true }]
        }], selectedListChange: [{
            type: Output
        }], searchFieldRef: [{
            type: ViewChild,
            args: ['searchField', { static: true }]
        }], showAllRef: [{
            type: ViewChild,
            args: ['showAll', { static: true }]
        }] }); })();
    return BentoMultiselectListComponent;
}(BentoListSubscribable));
if (false) {
    /**
     * Replace "Show All" tab text other than default
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.showAllText;
    /**
     * Replace "Show Selected" tab text other than default
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.showSelectedText;
    /**
     * Replace "Select All" text other than default
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.selectAllText;
    /**
     * Replace search input field label default
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.searchLabelText;
    /**
     * Custom tempalte for list items except the checkbox elements
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.listItemTemplate;
    /**
     * An custom search and compare function to determine if a given item is a match to the search string
     * when an user starts to filter the list using the search input
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.searchCompare;
    /**
     * Notify when the length of the main items data is changed
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.lengthChange;
    /**
     * Notify when a row is clicked with an OS pointer
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.rowClick;
    /**
     * Reference to the top panel
     * @type {?}
     */
    BentoMultiselectListComponent.prototype.topPanel;
    /** @type {?} */
    BentoMultiselectListComponent.prototype.list;
    /**
     * List Height
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._listHeight;
    /**
     * List Width
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._listWidth;
    /**
     * List for filtered array
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._filteredList;
    /**
     * Search Term
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._searchTerm;
    /**
     * List options
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._listOptions;
    /**
     * Emit Data change
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._dataChange;
    /**
     * Refernce to current datasize
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._dataSize;
    /**
     * Index to determine which item is active
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._activeIndex;
    /** @type {?} */
    BentoMultiselectListComponent.prototype.selectedListChange;
    /**
     * Selection to defines filtering of the list
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._selection;
    /**
     * Select all row
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._selectAllRow;
    /**
     * Unique ID
     * @type {?}
     */
    BentoMultiselectListComponent.prototype._uid;
    /** @type {?} */
    BentoMultiselectListComponent.prototype.searchFieldRef;
    /** @type {?} */
    BentoMultiselectListComponent.prototype.showAllRef;
    /**
     * A status list to represent whether an item is checked or not
     * @type {?}
     * @private
     */
    BentoMultiselectListComponent.prototype.checkStatusRef;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectListComponent.prototype.logService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/multiselect-overlay/multiselect-overlay.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var OVERLAY_MARGIN = 20;
/** @type {?} */
var DEFAULT_MAX_HEIGHT = 600;
/** @type {?} */
var BENTO_MO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoMultiselectOverlayComponent; })),
    multi: true
};
/**
 * This component is used to make selections from a filtered list. It appears as an overlay,
 * attached to its trigger element via a pointer on either the left or right side.
 */
var BentoMultiselectOverlayComponent = /** @class */ (function () {
    function BentoMultiselectOverlayComponent(elRef, r, dir, windowRef, changeDetector) {
        var _this = this;
        this.elRef = elRef;
        this.r = r;
        this.changeDetector = changeDetector;
        /**
         * Set max height of the overlay in pixel. (Default `600`)
         */
        this.overlayMaxHeight = DEFAULT_MAX_HEIGHT;
        /**
         * Variable to keep custom translations that are defined specifically for this component instance
         */
        this.customTranslation = {};
        this._isOpen = false;
        this._showOverlay = false;
        /**
         * ngModel Variables
         */
        this.selectedList = [];
        this._preselectedList = [];
        this._disabled = false;
        this._side = 'right';
        this._listHeight = 0;
        this.isRTL = false;
        this.dirSubscription = Subscription.EMPTY;
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        this.onTouch = (/**
         * @return {?}
         */
        function () { });
        this.window = windowRef.nativeWindow;
        this.document = windowRef.nativeDocument;
        this.dirSubscription = dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRTL = dir.value === 'rtl';
            _this.changeDetector.markForCheck();
        }));
    }
    /**
     * ControlValueAccessor interface
     */
    /**
     * ControlValueAccessor interface
     * @param {?} v
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.writeValue = /**
     * ControlValueAccessor interface
     * @param {?} v
     * @return {?}
     */
    function (v) {
        if (this.selectedList === v) {
            return;
        }
        this.selectedList = v || [];
        this._preselectedList = this.selectedList.slice();
        this.changeDetector.markForCheck();
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onTouch = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.changeDetector.markForCheck();
        });
    };
    /**
     * @param {?} v
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.setDisabledState = /**
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._disabled = v;
        this.changeDetector.markForCheck();
    };
    /**
     * Custom translations can be set here.
     *
     * Translation labels that are used:
     * * `BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_CANCEL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_DONE`
     * * `BENTO_UI_MULTISELECT_OVERLAY_EDIT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL`
     */
    /**
     * Custom translations can be set here.
     *
     * Translation labels that are used:
     * * `BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_CANCEL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_DONE`
     * * `BENTO_UI_MULTISELECT_OVERLAY_EDIT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL`
     * @param {?} translation
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.setTranslation = /**
     * Custom translations can be set here.
     *
     * Translation labels that are used:
     * * `BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_CANCEL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_DONE`
     * * `BENTO_UI_MULTISELECT_OVERLAY_EDIT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED`
     * * `BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL`
     * @param {?} translation
     * @return {?}
     */
    function (translation) {
        this.customTranslation = translation;
        this.changeDetector.markForCheck();
    };
    /**
     * Garbage cleaning on destroy
     */
    /**
     * Garbage cleaning on destroy
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.ngOnDestroy = /**
     * Garbage cleaning on destroy
     * @return {?}
     */
    function () {
        this.changeDetector.detach();
        if (this._onWindowClickCancel) {
            this._onWindowClickCancel();
        }
        if (this._onWindowTouchCancel) {
            this._onWindowTouchCancel();
        }
        if (this._onWindowResizeCancel) {
            this._onWindowResizeCancel();
        }
        if (this._windowWheelCancel) {
            this._windowWheelCancel();
        }
        if (this._windowKeydownCancel) {
            this._windowKeydownCancel();
        }
        this.dirSubscription.unsubscribe();
    };
    /**
     * On window click
     */
    /**
     * On window click
     * @param {?} event
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._onWindowClick = /**
     * On window click
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.target.window || // Window object
            (!this.elRef.nativeElement.contains(event.target) && !this.containerWrapper.nativeElement.contains(event.target))) {
            this._onDoneClick(event, true);
            event.stopPropagation();
            event.preventDefault();
            this.changeDetector.markForCheck();
        }
    };
    /**
     * Prevent Wheel Scroll
     */
    /**
     * Prevent Wheel Scroll
     * @param {?} event
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._preventWheelScroll = /**
     * Prevent Wheel Scroll
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.containerWrapper.nativeElement.contains(event.target)) {
            event.stopPropagation();
            event.preventDefault();
        }
    };
    /**
     * Window keydown event listener
     */
    /**
     * Window keydown event listener
     * @param {?} e
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._onWindowKeydown = /**
     * Window keydown event listener
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var keysToPrevent = {};
        keysToPrevent[Keyboard.SPACE] = 0;
        keysToPrevent[Keyboard.PAGE_UP] = 1;
        keysToPrevent[Keyboard.PAGE_DOWN] = 1;
        keysToPrevent[Keyboard.END] = 1;
        keysToPrevent[Keyboard.HOME] = 1;
        keysToPrevent[Keyboard.ESC] = 1;
        if (keysToPrevent[e.keyCode]) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (e.keyCode === Keyboard.ESC) {
            this._onDoneClick(e, true);
            this.changeDetector.markForCheck();
        }
    };
    /**
     * Callback when selection is changed
     */
    /**
     * Callback when selection is changed
     * @param {?} selection
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._onSelectionChange = /**
     * Callback when selection is changed
     * @param {?} selection
     * @return {?}
     */
    function (selection) {
        this._preselectedList = selection;
    };
    /**
     * On Toggle button click
     */
    /**
     * On Toggle button click
     * @param {?} $event
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._onToggleClick = /**
     * On Toggle button click
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        if (!this._isOpen) {
            this._isOpen = true;
            // Reset Selection tab
            this.multiselectList.show(Selection.all);
            setTimeout((/**
             * @return {?}
             */
            function () {
                // `click` should not be used since the items clicked in the overlay could disappear before
                // the window recieves its event
                _this._onWindowClickCancel = _this.r.listen('window', 'mousedown', (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return _this._onWindowClick(e); }));
                _this._onWindowTouchCancel = _this.r.listen('window', 'touchstart', (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return _this._onWindowClick(e); }));
                // Render after the overlay is not hidden on stage
                _this._onWindowResizeCancel = _this.r.listen('window', 'resize', (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) { return _this._onWindowResize(e); }));
                _this.renderOverlay();
                // UX: focus on to the show all button
                _this.multiselectList.focusOnShowAllButton();
            }));
            this._windowWheelCancel = this.r.listen('window', 'wheel', (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                _this._preventWheelScroll(e);
            }));
            this._windowKeydownCancel = this.r.listen('window', 'keydown', (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                _this._onWindowKeydown(e);
            }));
        }
        else {
            this._onDoneClick($event);
        }
    };
    /**
     * When the done button is clicked
     * This is also used with the cancel button
     */
    /**
     * When the done button is clicked
     * This is also used with the cancel button
     * @param {?} event
     * @param {?=} isDismissal
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._onDoneClick = /**
     * When the done button is clicked
     * This is also used with the cancel button
     * @param {?} event
     * @param {?=} isDismissal
     * @return {?}
     */
    function (event, isDismissal) {
        var _this = this;
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        // Remove animation flag
        this.r.removeClass(this.containerWrapper.nativeElement, 'in');
        this.r.addClass(this.containerWrapper.nativeElement, 'out');
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._isOpen = false;
            _this._showOverlay = false;
            _this.r.removeClass(_this.containerWrapper.nativeElement, 'out');
            _this.r.appendChild(_this.overlay.nativeElement, _this.containerWrapper.nativeElement);
            _this.changeDetector.markForCheck();
        }), 200);
        if (this._windowWheelCancel) {
            this._windowWheelCancel();
        }
        if (this._windowKeydownCancel) {
            this._windowKeydownCancel();
        }
        // remove window listener
        if (this._onWindowClickCancel) {
            this._onWindowClickCancel();
        }
        if (this._onWindowTouchCancel) {
            this._onWindowTouchCancel();
        }
        // Render after the overlay is not hidden on stage
        if (this._onWindowResizeCancel) {
            this._onWindowResizeCancel();
        }
        if (this.revertSelectionsOnDismissal && isDismissal) {
            this._preselectedList = this.selectedList.slice();
        }
        else {
            this.selectedList = this._preselectedList.slice();
            this.onChange(this.selectedList);
        }
        if (this.selectedList.length === 0) {
            // focus back to the toggle button
            // since there is nothing that is selected
            this.toggleButton.nativeElement.focus();
        }
        else {
            // focus on the label for screen readers to broadcast
            setTimeout((/**
             * @return {?}
             */
            function () {
                // After rendering
                _this.label.nativeElement.focus();
            }));
        }
    };
    /**
     * Render overlay location
     */
    /**
     * Render overlay location
     * @private
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.renderOverlay = /**
     * Render overlay location
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var parentElement = this.containerWrapper.nativeElement;
        /** @type {?} */
        var overlayContainer = this.overlayContainer.nativeElement;
        /** @type {?} */
        var overlay = this.overlay.nativeElement;
        /** @type {?} */
        var toggleButton = this.toggleButton.nativeElement;
        /** @type {?} */
        var doneButton = this.doneButton.nativeElement;
        /** @type {?} */
        var overlayFooter = this.overlayFooter.nativeElement;
        /** @type {?} */
        var viewport = {
            width: Math.max(this.document.documentElement.clientWidth, this.window.innerWidth || 0),
            height: Math.max(this.document.documentElement.clientHeight, this.window.innerHeight || 0)
        };
        this._scrollableParent = this.getScrollableParent(this.elRef.nativeElement);
        if (viewport.width < 601 || viewport.height < 421) {
            this.r.addClass(parentElement, 'bento-side-overlay-container-wrapper-fixed');
            this.r.addClass(parentElement, 'open');
            this.r.appendChild(this.document.body, parentElement);
            this._listHeight = overlayContainer.offsetHeight - overlayFooter.offsetHeight - 2;
            this._listWidth = overlayContainer.offsetWidth - 2;
        }
        else {
            this.r.removeClass(parentElement, 'bento-side-overlay-container-wrapper-fixed');
            this.r.removeClass(parentElement, 'open');
            this.r.appendChild(overlay, this.containerWrapper.nativeElement);
            /** @type {?} */
            var maxOverlayHeight = Math.min(this.overlayMaxHeight, this._scrollableParent.offsetHeight - OVERLAY_MARGIN * 2);
            /** @type {?} */
            var overlayInnerHeight = 0;
            /** @type {?} */
            var toggleOffset = this._getElementOffsetFrom(toggleButton, this._scrollableParent);
            /** @type {?} */
            var toggleOffsetTop = toggleOffset.top - (this.document.documentElement.scrollTop || this.document.body.scrollTop);
            /** @type {?} */
            var toggleCenterOffsetTop = toggleOffsetTop + toggleButton.offsetHeight * 0.5;
            // check toggle button location and realign if needed
            // for better layout spacing
            /** @type {?} */
            var allowedTopSpacing = OVERLAY_MARGIN + 25;
            /** @type {?} */
            var overlayHeight = void 0;
            /** @type {?} */
            var targetOverlayTop = void 0;
            // adjust overlay height based on the scrollable container or body
            if (overlayInnerHeight > 0) {
                // overlayHeight is bigger than max-height
                if (overlayInnerHeight > maxOverlayHeight - overlayFooter.offsetHeight) {
                    overlayHeight = maxOverlayHeight;
                }
                else {
                    overlayHeight = overlayInnerHeight + overlayFooter.offsetHeight;
                }
            }
            else {
                overlayHeight = maxOverlayHeight;
            }
            this.r.setStyle(overlayContainer, 'height', overlayHeight + 'px');
            this._listHeight = maxOverlayHeight - overlayFooter.offsetHeight;
            this._listWidth = 0; // reset width
            // Get the overlay height of max is updated
            overlayHeight = overlayContainer.offsetHeight;
            // when the scrollable is <BODY>
            if (this._scrollableParent.tagName === 'HTML' || this._scrollableParent.tagName === 'BODY') {
                /** @type {?} */
                var scrollingElement = this.document.scrollingElement || this.document.documentElement;
                // We need to scroll up a little bit
                if (toggleCenterOffsetTop < allowedTopSpacing) {
                    this.r.setProperty(scrollingElement, 'scrollTop', toggleOffset.top - allowedTopSpacing);
                    toggleCenterOffsetTop = allowedTopSpacing + toggleButton.offsetHeight * 0.5;
                }
                else if (toggleCenterOffsetTop > this._scrollableParent.offsetHeight - allowedTopSpacing) {
                    // We need to scroll down a little
                    this.r.setProperty(scrollingElement, 'scrollTop', toggleOffset.top + toggleButton.offsetHeight - this._scrollableParent.offsetHeight + allowedTopSpacing);
                    toggleCenterOffsetTop =
                        this._scrollableParent.offsetHeight - allowedTopSpacing - toggleButton.offsetHeight * 0.5;
                }
                // Set default
                targetOverlayTop = -overlayHeight * 0.5;
                if (-targetOverlayTop > toggleCenterOffsetTop - OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the top
                    targetOverlayTop = -(toggleCenterOffsetTop - OVERLAY_MARGIN + toggleButton.offsetHeight * 0.25);
                }
                else if (overlayHeight + targetOverlayTop >
                    this._scrollableParent.offsetHeight - toggleCenterOffsetTop - OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the bottom
                    targetOverlayTop =
                        this._scrollableParent.offsetHeight -
                            toggleCenterOffsetTop -
                            OVERLAY_MARGIN -
                            overlayHeight -
                            toggleButton.offsetHeight * 0.25;
                }
            }
            else {
                // Scrollable is other
                if (toggleOffset.bottom < allowedTopSpacing) {
                    // We need to scroll up a little bit
                    this.r.setProperty(this._scrollableParent, 'scrollTop', this._scrollableParent.scrollTop + allowedTopSpacing - toggleOffset.bottom);
                }
                else if (toggleOffset.top < allowedTopSpacing) {
                    // We need to scroll down a little
                    this.r.setProperty(this._scrollableParent, 'scrollTop', this._scrollableParent.scrollTop - allowedTopSpacing - toggleOffset.top);
                }
                /** @type {?} */
                var overlayLocalRect = this._getElementOffsetFrom(overlayContainer, this._scrollableParent);
                // set default
                targetOverlayTop = -overlayContainer.offsetHeight * 0.5;
                if (targetOverlayTop < OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the top
                    targetOverlayTop = overlayContainer.offsetTop - overlayLocalRect.top + OVERLAY_MARGIN;
                }
                else if (overlayLocalRect.bottom + targetOverlayTop < OVERLAY_MARGIN) {
                    // Make sure the overlay is not overflowing the bottom
                    targetOverlayTop = overlayContainer.offsetTop + overlayLocalRect.bottom - OVERLAY_MARGIN;
                }
                if (targetOverlayTop > -doneButton.offsetHeight * 0.5 - OVERLAY_MARGIN) {
                    targetOverlayTop = -doneButton.offsetHeight * 0.5 - OVERLAY_MARGIN;
                }
                else if (targetOverlayTop + overlayLocalRect.height < doneButton.offsetHeight * 0.5 + OVERLAY_MARGIN) {
                    targetOverlayTop = -overlayLocalRect.height + doneButton.offsetHeight * 0.5 + OVERLAY_MARGIN;
                }
            }
            this.r.setStyle(overlayContainer, 'top', targetOverlayTop + 'px');
            this.r.setStyle(overlayContainer, 'transform-origin', (this.isRTL ? '100%' : '0%') + " " + Math.abs(targetOverlayTop / overlayContainer.offsetHeight) * 100 + "%");
            this.r.addClass(parentElement, 'in');
        }
        // animate in
        if (!this._showOverlay) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this._showOverlay = true;
                _this.changeDetector.markForCheck();
            }), 10);
        }
    };
    /**
     * Event Listener when the window is resizing
     */
    /**
     * Event Listener when the window is resizing
     * @param {?} e
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._onWindowResize = /**
     * Event Listener when the window is resizing
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        if (this._isOpen) {
            clearTimeout(this._windowResizeTimeoutID);
            if (this.elRef.nativeElement.contains(this.document.activeElement)) {
                this.activeElement = (/** @type {?} */ (this.document.activeElement));
            }
            this._windowResizeTimeoutID = setTimeout((/**
             * @return {?}
             */
            function () {
                _this.renderOverlay();
                if (_this.activeElement) {
                    _this.activeElement.focus();
                }
            }), 100);
        }
    };
    /**
     * Get offset of el1 from el2
     */
    /**
     * Get offset of el1 from el2
     * @param {?} el
     * @param {?} fromEl
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._getElementOffsetFrom = /**
     * Get offset of el1 from el2
     * @param {?} el
     * @param {?} fromEl
     * @return {?}
     */
    function (el, fromEl) {
        /** @type {?} */
        var parentRect = fromEl.getBoundingClientRect();
        /** @type {?} */
        var toggleRect = el.getBoundingClientRect();
        // Return the relative RECT of the toggle button to the given parent
        return {
            left: toggleRect.left - parentRect.left,
            right: parentRect.right - toggleRect.right,
            top: toggleRect.top - parentRect.top,
            bottom: parentRect.bottom - toggleRect.bottom,
            width: toggleRect.width,
            height: toggleRect.height
        };
    };
    /**
     * Monitor when this user blurs from this component
     */
    /**
     * Monitor when this user blurs from this component
     * @param {?} e
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._onFocusout = /**
     * Monitor when this user blurs from this component
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            if (!_this.elRef.nativeElement.contains(_this.document.activeElement)) {
                _this.onTouch();
            }
        }));
    };
    /**
     * Get the closest scrollable parent
     */
    /**
     * Get the closest scrollable parent
     * @private
     * @param {?} el
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype.getScrollableParent = /**
     * Get the closest scrollable parent
     * @private
     * @param {?} el
     * @return {?}
     */
    function (el) {
        if (el === null) {
            return;
        }
        /** @type {?} */
        var cStyle = this.window.getComputedStyle(el);
        /** @type {?} */
        var overflowY = cStyle.getPropertyValue('overflow-y');
        /** @type {?} */
        var overflow = cStyle.getPropertyValue('overflow');
        /** @type {?} */
        var display = cStyle.getPropertyValue('display');
        if ((display.indexOf('block') > -1 || display.indexOf('flex') > -1) &&
            (overflowY === 'auto' ||
                overflowY === 'scroll' ||
                overflow === 'auto' ||
                overflow === 'scroll' ||
                overflow === 'hidden' ||
                overflowY === 'hidden')) {
            return el;
        }
        else if (el.nodeName === 'HTML') {
            return el;
        }
        else {
            return this.getScrollableParent(el.parentElement);
        }
    };
    /**
     * Callback when the length of the items dataset is changed
     */
    /**
     * Callback when the length of the items dataset is changed
     * @param {?} v
     * @return {?}
     */
    BentoMultiselectOverlayComponent.prototype._itemsLengthChange = /**
     * Callback when the length of the items dataset is changed
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._itemsLength = v;
    };
    /** @nocollapse */
    BentoMultiselectOverlayComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: Directionality },
        { type: WindowRef },
        { type: ChangeDetectorRef }
    ]; };
    BentoMultiselectOverlayComponent.propDecorators = {
        selectButtonText: [{ type: Input }],
        editButtonText: [{ type: Input }],
        allSelectedInfoText: [{ type: Input }],
        selectedInfoText: [{ type: Input }],
        doneButtonText: [{ type: Input }],
        cancelButtonText: [{ type: Input }],
        searchLableText: [{ type: Input }],
        itemsObservable: [{ type: Input }],
        showAllText: [{ type: Input }],
        showSelectedText: [{ type: Input }],
        selectAllText: [{ type: Input }],
        revertSelectionsOnDismissal: [{ type: Input }],
        listItemTemplate: [{ type: Input }],
        overlayMaxHeight: [{ type: Input }],
        searchCompare: [{ type: Input }],
        overlay: [{ type: ViewChild, args: ['overlay', { static: true },] }],
        toggleButton: [{ type: ViewChild, args: ['toggleButton', { static: true },] }],
        containerWrapper: [{ type: ViewChild, args: ['containerWrapper', { static: true },] }],
        doneButton: [{ type: ViewChild, args: ['doneButton', { static: true },] }],
        cancelButton: [{ type: ViewChild, args: ['cancelButton',] }],
        overlayContainer: [{ type: ViewChild, args: ['overlayContainer', { static: true },] }],
        overlayFooter: [{ type: ViewChild, args: ['overlayFooter', { static: true },] }],
        label: [{ type: ViewChild, args: ['label', { static: true },] }],
        multiselectList: [{ type: ViewChild, args: [BentoMultiselectListComponent, { static: true },] }],
        _onFocusout: [{ type: HostListener, args: ['focusout', ['$event'],] }]
    };
BentoMultiselectOverlayComponent.ɵfac = function BentoMultiselectOverlayComponent_Factory(t) { return new (t || BentoMultiselectOverlayComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoMultiselectOverlayComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoMultiselectOverlayComponent, selectors: [["bento-multiselect-overlay"]], viewQuery: function BentoMultiselectOverlayComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c27, true);
        ɵngcc0.ɵɵstaticViewQuery(_c28, true);
        ɵngcc0.ɵɵstaticViewQuery(_c29, true);
        ɵngcc0.ɵɵstaticViewQuery(_c30, true);
        ɵngcc0.ɵɵviewQuery(_c21, true);
        ɵngcc0.ɵɵstaticViewQuery(_c31, true);
        ɵngcc0.ɵɵstaticViewQuery(_c32, true);
        ɵngcc0.ɵɵstaticViewQuery(_c33, true);
        ɵngcc0.ɵɵstaticViewQuery(BentoMultiselectListComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlay = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.containerWrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.doneButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cancelButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayFooter = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.label = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.multiselectList = _t.first);
    } }, hostBindings: function BentoMultiselectOverlayComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusout", function BentoMultiselectOverlayComponent_focusout_HostBindingHandler($event) { return ctx._onFocusout($event); });
    } }, inputs: { overlayMaxHeight: "overlayMaxHeight", selectButtonText: "selectButtonText", editButtonText: "editButtonText", allSelectedInfoText: "allSelectedInfoText", selectedInfoText: "selectedInfoText", doneButtonText: "doneButtonText", cancelButtonText: "cancelButtonText", searchLableText: "searchLableText", itemsObservable: "itemsObservable", showAllText: "showAllText", showSelectedText: "showSelectedText", selectAllText: "selectAllText", revertSelectionsOnDismissal: "revertSelectionsOnDismissal", listItemTemplate: "listItemTemplate", searchCompare: "searchCompare" }, features: [ɵngcc0.ɵɵProvidersFeature([BENTO_MO_VALUE_ACCESSOR])], decls: 33, vars: 42, consts: [[1, "bento-multiselect-overlay-inner"], ["tabindex", "-1", 1, "bento-side-overlay", 3, "ngClass"], ["overlay", ""], ["aria-haspopup", "true", "type", "button", 1, "bento-side-overlay-toggle", "btn", "btn-outline-primary", "btn-multiselect-overlay", 3, "disabled", "click"], ["toggleButton", ""], [1, "bui-bento-side-overlay-container-wrapper", "bento-side-overlay-container-wrapper", 3, "ngClass"], ["containerWrapper", ""], ["tabindex", "-1", "cdkTrapFocus", "", 1, "bento-side-overlay-container"], ["overlayContainer", ""], [1, "fill", 3, "itemsObservable", "height", "width", "showAllText", "showSelectedText", "selectAllText", "searchLabelText", "selectedList", "listItemTemplate", "searchCompare", "selectedListChange", "lengthChange"], [1, "bento-side-overlay-container-footer"], ["overlayFooter", ""], ["type", "button", 1, "btn", "bento-side-overlay-container-footer-done", 3, "ngClass", "click"], ["doneButton", ""], ["class", "btn btn-outline-primary bento-side-overlay-container-footer-cancel", "type", "button", 3, "click", 4, "ngIf"], [1, "bento-side-overlay-left-arrow"], ["height", "35", "width", "20"], ["points", "21,0 0.5,17.5 21,35", 1, "bento-side-overlay-triangle"], [1, "bento-side-overlay-right-arrow"], ["points", "-1,0 19.5,17.5 -1,35", 1, "bento-side-overlay-triangle"], ["tabindex", "-1", 1, "bento-multiselect-overlay-label", 3, "hidden"], ["label", ""], ["type", "button", 1, "btn", "btn-outline-primary", "bento-side-overlay-container-footer-cancel", 3, "click"], ["cancelButton", ""]], template: function BentoMultiselectOverlayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3, 4);
        ɵngcc0.ɵɵlistener("click", function BentoMultiselectOverlayComponent_Template_button_click_3_listener($event) { return ctx._onToggleClick($event); });
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "bentoTranslate");
        ɵngcc0.ɵɵpipe(7, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5, 6);
        ɵngcc0.ɵɵelementStart(10, "div", 7, 8);
        ɵngcc0.ɵɵelementStart(12, "bento-multiselect-list", 9);
        ɵngcc0.ɵɵlistener("selectedListChange", function BentoMultiselectOverlayComponent_Template_bento_multiselect_list_selectedListChange_12_listener($event) { return ctx._onSelectionChange($event); })("lengthChange", function BentoMultiselectOverlayComponent_Template_bento_multiselect_list_lengthChange_12_listener($event) { return ctx._itemsLengthChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 10, 11);
        ɵngcc0.ɵɵelementStart(15, "button", 12, 13);
        ɵngcc0.ɵɵlistener("click", function BentoMultiselectOverlayComponent_Template_button_click_15_listener($event) { return ctx._onDoneClick($event, false); });
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, BentoMultiselectOverlayComponent_button_19_Template, 4, 4, "button", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 15);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(21, "svg", 16);
        ɵngcc0.ɵɵelement(22, "polygon", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(23, "div", 18);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(24, "svg", 16);
        ɵngcc0.ɵɵelement(25, "polygon", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(26, "span", 20, 21);
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(30, "bentoTranslate");
        ɵngcc0.ɵɵpipe(31, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(32, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", (ctx._side == "right" ? "bento-side-overlay-right " : "") + (ctx._side == "left" ? "bento-side-overlay-left " : "") + (ctx._isOpen ? "open " : ""));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx._disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.selectedList.length === 0 ? ɵngcc0.ɵɵpipeBind2(6, 19, "BENTO_UI_MULTISELECT_OVERLAY_SELECT", ctx.selectButtonText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT) : ɵngcc0.ɵɵpipeBind2(7, 22, "BENTO_UI_MULTISELECT_OVERLAY_EDIT", ctx.editButtonText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_EDIT), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ctx._showOverlay ? "show-overlay " : "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("itemsObservable", ctx.itemsObservable)("height", ctx._listHeight)("width", ctx._listWidth)("showAllText", ctx.showAllText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL)("showSelectedText", ctx.showSelectedText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED)("selectAllText", ctx.selectAllText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL)("searchLabelText", ctx.searchLableText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL)("selectedList", ctx._preselectedList)("listItemTemplate", ctx.listItemTemplate)("searchCompare", ctx.searchCompare);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ctx.revertSelectionsOnDismissal ? "btn-primary" : "btn-outline-primary btn-multiselect-overlay");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(18, 25, "BENTO_UI_MULTISELECT_OVERLAY_DONE", ctx.doneButtonText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_DONE), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.revertSelectionsOnDismissal);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("hidden", ctx.selectedList.length === 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.selectedList.length === 1 ? ctx.selectedList[0].name : ctx.selectedList.length === ctx._itemsLength ? ɵngcc0.ɵɵpipeBind3(29, 28, ɵngcc0.ɵɵpipeBind2(30, 32, "BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO", ctx.allSelectedInfoText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO), "_NUMBER_", ctx.selectedList.length) : ɵngcc0.ɵɵpipeBind3(31, 35, ɵngcc0.ɵɵpipeBind2(32, 39, "BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO", ctx.selectedInfoText || ctx.customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO), "_NUMBER_", ctx.selectedList.length), " ");
    } }, directives: [ɵngcc7.NgClass, BentoFocusMonitorDirective, ɵngcc1.CdkTrapFocus, BentoMultiselectListComponent, ɵngcc7.NgIf], pipes: [BentoTranslatePipe,
        BentoStringReplacePipe], styles: ["bento-multiselect-overlay .bento-side-overlay{display:inline-block;position:relative}bento-multiselect-overlay .bento-side-overlay .btn{vertical-align:baseline}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-toggle{cursor:pointer;display:inline-block}bento-multiselect-overlay .bento-side-overlay:focus{outline:0}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{position:absolute;left:0;top:-21px}[dir=rtl] bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{display:none}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-right-arrow{position:absolute;right:0;top:-21px}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-container-wrapper{margin-left:5px}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:none}[dir=rtl] bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:block}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container-wrapper{margin-right:5px;margin-left:-100%}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-left-arrow{display:none}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container{left:auto;right:19px}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-container-wrapper{display:none;position:relative}bento-multiselect-overlay .bento-side-overlay.open .bento-side-overlay-container-wrapper{display:inline-block;left:auto;position:relative}.bui-bento-side-overlay-container-wrapper{opacity:0;transition:opacity .1s}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{position:absolute;font-size:.929rem;left:19px;height:500px;min-width:300px;padding:0;list-style:none;border-width:1px;border-style:solid;box-shadow:0 5px 10px rgba(0,0,0,.2);-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box}[dir=rtl] .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{right:19px;left:0}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .fill{position:relative;height:100%}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container:focus{outline:0}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-container-footer{position:absolute;left:0;right:0;bottom:0;width:auto;height:auto;padding:10px;text-align:center;border-top-width:1px;border-top-style:solid}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container{padding:20px;font-size:.95em;max-width:300px;border-top-width:1px;border-top-style:solid;white-space:normal}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container textarea{resize:none;box-sizing:border-box;width:100%;height:60px;font-size:.95em;margin:0}.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed{background-color:RGBA(0,0,0,.2);position:fixed;top:0;left:0;right:0;bottom:0}.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-left-arrow,.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-right-arrow{display:none}.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-container{top:25px!important;left:50%!important;transform:translateX(-50%);max-height:calc(100% - 50px)!important;max-width:450px;width:calc(100% - 50px)!important;height:calc(100% - 50px)!important}.bui-bento-side-overlay-container-wrapper.show-overlay{opacity:1}.bui-bento-side-overlay-container-wrapper.out{transition:opacity .2s;opacity:0}bento-multiselect-overlay .bento-side-overlay-triangle{stroke-width:1}", "bento-multiselect-overlay .bento-side-overlay-content{padding-bottom:50px}bento-multiselect-overlay .bento-multiselect-overlay-inner{display:inline-block}bento-multiselect-overlay .bento-side-overlay{float:left}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-content:focus{outline:0}bento-multiselect-overlay[disabled=disabled] .bento-multiselect-overlay-inner>span{opacity:.65}bento-multiselect-overlay .bento-multiselect-overlay-label{display:inline-block;margin-left:10px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMultiselectOverlayComponent, [{
        type: Component,
        args: [{
                selector: 'bento-multiselect-overlay',
                template: "<div class=\"bento-multiselect-overlay-inner\">\n  <div\n    #overlay\n    class=\"bento-side-overlay\"\n    [ngClass]=\"\n      (_side == 'right' ? 'bento-side-overlay-right ' : '') +\n      (_side == 'left' ? 'bento-side-overlay-left ' : '') +\n      (_isOpen ? 'open ' : '')\n    \"\n    tabindex=\"-1\"\n  >\n    <button\n      #toggleButton\n      class=\"bento-side-overlay-toggle btn btn-outline-primary btn-multiselect-overlay\"\n      [disabled]=\"_disabled\"\n      (click)=\"_onToggleClick($event)\"\n      aria-haspopup=\"true\"\n      type=\"button\"\n    >\n      {{\n        selectedList.length === 0\n          ? ('BENTO_UI_MULTISELECT_OVERLAY_SELECT'\n            | bentoTranslate: selectButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT)\n          : ('BENTO_UI_MULTISELECT_OVERLAY_EDIT'\n            | bentoTranslate: editButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_EDIT)\n      }}\n    </button>\n    <div\n      #containerWrapper\n      class=\"bui-bento-side-overlay-container-wrapper bento-side-overlay-container-wrapper\"\n      [ngClass]=\"_showOverlay ? 'show-overlay ' : ''\"\n    >\n      <div #overlayContainer class=\"bento-side-overlay-container\" tabindex=\"-1\" cdkTrapFocus>\n        <bento-multiselect-list\n          [itemsObservable]=\"itemsObservable\"\n          [height]=\"_listHeight\"\n          [width]=\"_listWidth\"\n          [showAllText]=\"showAllText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL\"\n          [showSelectedText]=\"showSelectedText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED\"\n          [selectAllText]=\"selectAllText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL\"\n          [searchLabelText]=\"searchLableText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL\"\n          [selectedList]=\"_preselectedList\"\n          (selectedListChange)=\"_onSelectionChange($event)\"\n          [listItemTemplate]=\"listItemTemplate\"\n          [searchCompare]=\"searchCompare\"\n          (lengthChange)=\"_itemsLengthChange($event)\"\n          class=\"fill\"\n        ></bento-multiselect-list>\n        <div #overlayFooter class=\"bento-side-overlay-container-footer\">\n          <button\n            #doneButton\n            class=\"btn bento-side-overlay-container-footer-done\"\n            [ngClass]=\"revertSelectionsOnDismissal ? 'btn-primary' : 'btn-outline-primary btn-multiselect-overlay'\"\n            type=\"button\"\n            (click)=\"_onDoneClick($event, false)\"\n          >\n            {{\n              'BENTO_UI_MULTISELECT_OVERLAY_DONE'\n                | bentoTranslate: doneButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_DONE\n            }}\n          </button>\n          <button\n            #cancelButton\n            class=\"btn btn-outline-primary bento-side-overlay-container-footer-cancel\"\n            type=\"button\"\n            *ngIf=\"revertSelectionsOnDismissal\"\n            (click)=\"_onDoneClick($event, true)\"\n          >\n            {{\n              'BENTO_UI_MULTISELECT_OVERLAY_CANCEL'\n                | bentoTranslate: cancelButtonText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_CANCEL\n            }}\n          </button>\n        </div>\n      </div>\n      <div class=\"bento-side-overlay-left-arrow\">\n        <svg height=\"35\" width=\"20\">\n          <polygon points=\"21,0 0.5,17.5 21,35\" class=\"bento-side-overlay-triangle\" />\n        </svg>\n      </div>\n      <div class=\"bento-side-overlay-right-arrow\">\n        <svg height=\"35\" width=\"20\">\n          <polygon points=\"-1,0 19.5,17.5 -1,35\" class=\"bento-side-overlay-triangle\" />\n        </svg>\n      </div>\n    </div>\n  </div>\n  <span #label class=\"bento-multiselect-overlay-label\" tabindex=\"-1\" [hidden]=\"selectedList.length === 0\">\n    {{\n      selectedList.length === 1\n        ? selectedList[0].name\n        : selectedList.length === _itemsLength\n        ? ('BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO'\n          | bentoTranslate: allSelectedInfoText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO\n          | bentoStringReplace: '_NUMBER_':selectedList.length)\n        : ('BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO'\n          | bentoTranslate: selectedInfoText || customTranslation.BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO\n          | bentoStringReplace: '_NUMBER_':selectedList.length)\n    }}\n  </span>\n</div>\n",
                providers: [BENTO_MO_VALUE_ACCESSOR],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-multiselect-overlay .bento-side-overlay{display:inline-block;position:relative}bento-multiselect-overlay .bento-side-overlay .btn{vertical-align:baseline}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-toggle{cursor:pointer;display:inline-block}bento-multiselect-overlay .bento-side-overlay:focus{outline:0}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{position:absolute;left:0;top:-21px}[dir=rtl] bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-left-arrow{display:none}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-right-arrow{position:absolute;right:0;top:-21px}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-container-wrapper{margin-left:5px}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:none}[dir=rtl] bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-right .bento-side-overlay-right-arrow{display:block}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container-wrapper{margin-right:5px;margin-left:-100%}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-left-arrow{display:none}bento-multiselect-overlay .bento-side-overlay.bento-side-overlay-left .bento-side-overlay-container{left:auto;right:19px}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-container-wrapper{display:none;position:relative}bento-multiselect-overlay .bento-side-overlay.open .bento-side-overlay-container-wrapper{display:inline-block;left:auto;position:relative}.bui-bento-side-overlay-container-wrapper{opacity:0;transition:opacity .1s}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{position:absolute;font-size:.929rem;left:19px;height:500px;min-width:300px;padding:0;list-style:none;border-width:1px;border-style:solid;box-shadow:0 5px 10px rgba(0,0,0,.2);-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box}[dir=rtl] .bui-bento-side-overlay-container-wrapper .bento-side-overlay-container{right:19px;left:0}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .fill{position:relative;height:100%}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container:focus{outline:0}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-container-footer{position:absolute;left:0;right:0;bottom:0;width:auto;height:auto;padding:10px;text-align:center;border-top-width:1px;border-top-style:solid}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container{padding:20px;font-size:.95em;max-width:300px;border-top-width:1px;border-top-style:solid;white-space:normal}.bui-bento-side-overlay-container-wrapper .bento-side-overlay-container .bento-side-overlay-lower-container textarea{resize:none;box-sizing:border-box;width:100%;height:60px;font-size:.95em;margin:0}.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed{background-color:RGBA(0,0,0,.2);position:fixed;top:0;left:0;right:0;bottom:0}.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-left-arrow,.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-right-arrow{display:none}.bui-bento-side-overlay-container-wrapper.bento-side-overlay-container-wrapper-fixed>.bento-side-overlay-container{top:25px!important;left:50%!important;transform:translateX(-50%);max-height:calc(100% - 50px)!important;max-width:450px;width:calc(100% - 50px)!important;height:calc(100% - 50px)!important}.bui-bento-side-overlay-container-wrapper.show-overlay{opacity:1}.bui-bento-side-overlay-container-wrapper.out{transition:opacity .2s;opacity:0}bento-multiselect-overlay .bento-side-overlay-triangle{stroke-width:1}", "bento-multiselect-overlay .bento-side-overlay-content{padding-bottom:50px}bento-multiselect-overlay .bento-multiselect-overlay-inner{display:inline-block}bento-multiselect-overlay .bento-side-overlay{float:left}bento-multiselect-overlay .bento-side-overlay .bento-side-overlay-content:focus{outline:0}bento-multiselect-overlay[disabled=disabled] .bento-multiselect-overlay-inner>span{opacity:.65}bento-multiselect-overlay .bento-multiselect-overlay-label{display:inline-block;margin-left:10px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc6.Directionality }, { type: WindowRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { overlayMaxHeight: [{
            type: Input
        }], _onFocusout: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], selectButtonText: [{
            type: Input
        }], editButtonText: [{
            type: Input
        }], allSelectedInfoText: [{
            type: Input
        }], selectedInfoText: [{
            type: Input
        }], doneButtonText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], searchLableText: [{
            type: Input
        }], itemsObservable: [{
            type: Input
        }], showAllText: [{
            type: Input
        }], showSelectedText: [{
            type: Input
        }], selectAllText: [{
            type: Input
        }], revertSelectionsOnDismissal: [{
            type: Input
        }], listItemTemplate: [{
            type: Input
        }], searchCompare: [{
            type: Input
        }], overlay: [{
            type: ViewChild,
            args: ['overlay', { static: true }]
        }], toggleButton: [{
            type: ViewChild,
            args: ['toggleButton', { static: true }]
        }], containerWrapper: [{
            type: ViewChild,
            args: ['containerWrapper', { static: true }]
        }], doneButton: [{
            type: ViewChild,
            args: ['doneButton', { static: true }]
        }], cancelButton: [{
            type: ViewChild,
            args: ['cancelButton']
        }], overlayContainer: [{
            type: ViewChild,
            args: ['overlayContainer', { static: true }]
        }], overlayFooter: [{
            type: ViewChild,
            args: ['overlayFooter', { static: true }]
        }], label: [{
            type: ViewChild,
            args: ['label', { static: true }]
        }], multiselectList: [{
            type: ViewChild,
            args: [BentoMultiselectListComponent, { static: true }]
        }] }); })();
    return BentoMultiselectOverlayComponent;
}());
if (false) {
    /**
     * Select button text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.selectButtonText;
    /**
     * Edit button text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.editButtonText;
    /**
     * All Selected info text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.allSelectedInfoText;
    /**
     * Selected info text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.selectedInfoText;
    /**
     * Done button text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.doneButtonText;
    /**
     * Cancel button text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.cancelButtonText;
    /**
     * Search input field label override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.searchLableText;
    /**
     * Main items dataset
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.itemsObservable;
    /**
     * Show All text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.showAllText;
    /**
     * Show Selected text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.showSelectedText;
    /**
     * Select All text override
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.selectAllText;
    /**
     * Flag to allow the component to revert selection when a selection session is dismissed
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.revertSelectionsOnDismissal;
    /**
     * Custom template for list items except the checkbox elements
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.listItemTemplate;
    /**
     * Set max height of the overlay in pixel. (Default `600`)
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.overlayMaxHeight;
    /**
     * An custom search and compare function to determine if a given item is a match to the search string
     * when an user starts to filter the list using the search input
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.searchCompare;
    /**
     * Variable to keep custom translations that are defined specifically for this component instance
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.customTranslation;
    /**
     * Not for public
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.overlay;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.toggleButton;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.containerWrapper;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.doneButton;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.cancelButton;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.overlayContainer;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.overlayFooter;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.label;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.multiselectList;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._isOpen;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._showOverlay;
    /**
     * ngModel Variables
     * @type {?}
     */
    BentoMultiselectOverlayComponent.prototype.selectedList;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._preselectedList;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.onChange;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype.onTouch;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._disabled;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._side;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._scrollableParent;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._listHeight;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._listWidth;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._itemsLength;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._onWindowResizeCancel;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._onWindowClickCancel;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._onWindowTouchCancel;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._windowWheelCancel;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._windowKeydownCancel;
    /** @type {?} */
    BentoMultiselectOverlayComponent.prototype._windowResizeTimeoutID;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.window;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.isRTL;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.activeElement;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.dirSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoMultiselectOverlayComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/multiselect-overlay/multiselect-overlay.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoMultiselectOverlayModule = /** @class */ (function () {
    function BentoMultiselectOverlayModule() {
    }
BentoMultiselectOverlayModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoMultiselectOverlayModule });
BentoMultiselectOverlayModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoMultiselectOverlayModule_Factory(t) { return new (t || BentoMultiselectOverlayModule)(); }, imports: [[
            CommonModule,
            BentoListModule,
            BentoResetModule,
            FormsModule,
            BentoUtilsModule,
            BentoTranslateModule,
            A11yModule,
            BentoFocusMonitorModule,
            BentoCheckboxModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoMultiselectOverlayModule, { declarations: function () { return [BentoMultiselectOverlayComponent,
        BentoMultiselectListComponent]; }, imports: function () { return [CommonModule,
        BentoListModule,
        BentoResetModule,
        FormsModule,
        BentoUtilsModule,
        BentoTranslateModule,
        A11yModule,
        BentoFocusMonitorModule,
        BentoCheckboxModule]; }, exports: function () { return [BentoMultiselectOverlayComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoMultiselectOverlayModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoListModule,
                    BentoResetModule,
                    FormsModule,
                    BentoUtilsModule,
                    BentoTranslateModule,
                    A11yModule,
                    BentoFocusMonitorModule,
                    BentoCheckboxModule
                ],
                declarations: [BentoMultiselectOverlayComponent, BentoMultiselectListComponent],
                exports: [BentoMultiselectOverlayComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoMultiselectOverlayModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dropdown/dropdown.animation.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable directive-selector */
var BentoNgbDropdownAnimationDirective = /** @class */ (function () {
    function BentoNgbDropdownAnimationDirective(r, dropdown, dropdownMenu, elementRef) {
        var _this = this;
        this.r = r;
        this.el = elementRef.nativeElement;
        // Override original dropdown open and close to support animations
        /** @type {?} */
        var dropdownOpen = dropdown.open;
        /** @type {?} */
        var dropdownClose = dropdown.close;
        dropdown.open = (/**
         * @return {?}
         */
        function () {
            clearTimeout(_this.timeoutID);
            dropdownOpen.call(dropdown);
            _this.r.removeClass(_this.el, 'out');
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.addClass(_this.el, 'in');
            }));
        });
        dropdown.close = (/**
         * @return {?}
         */
        function () {
            // delay close so that there is enough time to perform transition
            /** @type {?} */
            var toggleEl = dropdown['_anchor'].nativeElement;
            clearTimeout(_this.timeoutID);
            _this.r.removeClass(_this.el, 'in');
            _this.r.addClass(_this.el, 'out');
            _this.r.addClass(toggleEl, 'out');
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.removeClass(_this.el, 'out');
                _this.r.removeClass(toggleEl, 'out');
                _this.timeoutID = dropdownClose.call(dropdown);
            }), 200);
        });
    }
    /**
     * @return {?}
     */
    BentoNgbDropdownAnimationDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /** @nocollapse */
    BentoNgbDropdownAnimationDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: NgbDropdown, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] },
        { type: NgbDropdownMenu, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdownMenu; })),] }] },
        { type: ElementRef }
    ]; };
BentoNgbDropdownAnimationDirective.ɵfac = function BentoNgbDropdownAnimationDirective_Factory(t) { return new (t || BentoNgbDropdownAnimationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; }))), ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdownMenu; }))), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoNgbDropdownAnimationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoNgbDropdownAnimationDirective, selectors: [["", "ngbDropdownMenu", ""], ["bento-megamenu"]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNgbDropdownAnimationDirective, [{
        type: Directive,
        args: [{
                selector: '[ngbDropdownMenu], bento-megamenu'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc4.NgbDropdown, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }, { type: ɵngcc4.NgbDropdownMenu, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdownMenu; }))]
            }] }, { type: ɵngcc0.ElementRef }]; }, null); })();
    return BentoNgbDropdownAnimationDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoNgbDropdownAnimationDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoNgbDropdownAnimationDirective.prototype.timeoutID;
    /**
     * @type {?}
     * @private
     */
    BentoNgbDropdownAnimationDirective.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dropdown/dropdown.animation.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoNgbDropdownAnimationModule = /** @class */ (function () {
    function BentoNgbDropdownAnimationModule() {
    }
BentoNgbDropdownAnimationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoNgbDropdownAnimationModule });
BentoNgbDropdownAnimationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoNgbDropdownAnimationModule_Factory(t) { return new (t || BentoNgbDropdownAnimationModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoNgbDropdownAnimationModule, { declarations: function () { return [BentoNgbDropdownAnimationDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BentoNgbDropdownAnimationDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNgbDropdownAnimationModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoNgbDropdownAnimationDirective],
                imports: [CommonModule],
                exports: [BentoNgbDropdownAnimationDirective],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoNgbDropdownAnimationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/popover/popover.animation.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoNgbPopoverAnimationDirective = /** @class */ (function () {
    function BentoNgbPopoverAnimationDirective(popover, elementRef, windowRef, r) {
        var _this = this;
        this.popover = popover;
        this.shownSubscription = Subscription.EMPTY;
        this.shownSubscription = popover.shown.subscribe((/**
         * @return {?}
         */
        function () {
            setTimeout((/**
             * @return {?}
             */
            function () {
                // We need to use attrubite instead of CSS class since the windowRef uses host[class] bindings
                r.setAttribute(popover['_windowRef'].location.nativeElement, "in", 'true');
            }));
        }));
        /*
        Re-wire close to support fadeout for the popover window
        */
        this.close = popover.close;
        popover.close = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var popoverWindowRef = popover['_windowRef'];
            if (popoverWindowRef) {
                // Only perform close when popover windowRef exists
                r.removeAttribute(popoverWindowRef.location.nativeElement, "in");
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.close.call(popover);
                }), 200);
            }
        });
    }
    /**
     * @return {?}
     */
    BentoNgbPopoverAnimationDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    BentoNgbPopoverAnimationDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        // Called once, before the instance is destroyed.
        // Add 'implements OnDestroy' to the class.
        this.shownSubscription.unsubscribe();
        this.popover.close = (/**
         * @return {?}
         */
        function () { });
        this.close.call(this.popover);
    };
    /** @nocollapse */
    BentoNgbPopoverAnimationDirective.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbPopover; })),] }] },
        { type: ElementRef },
        { type: WindowRef },
        { type: Renderer2 }
    ]; };
BentoNgbPopoverAnimationDirective.ɵfac = function BentoNgbPopoverAnimationDirective_Factory(t) { return new (t || BentoNgbPopoverAnimationDirective)(ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbPopover; }))), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BentoNgbPopoverAnimationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoNgbPopoverAnimationDirective, selectors: [["", "ngbPopover", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNgbPopoverAnimationDirective, [{
        type: Directive,
        args: [{
                selector: '[ngbPopover]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbPopover; }))]
            }] }, { type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return BentoNgbPopoverAnimationDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoNgbPopoverAnimationDirective.prototype.shownSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoNgbPopoverAnimationDirective.prototype.close;
    /**
     * @type {?}
     * @private
     */
    BentoNgbPopoverAnimationDirective.prototype.popover;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/popover/popover.animation.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoNgbPopoverAnimationModule = /** @class */ (function () {
    function BentoNgbPopoverAnimationModule() {
    }
BentoNgbPopoverAnimationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoNgbPopoverAnimationModule });
BentoNgbPopoverAnimationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoNgbPopoverAnimationModule_Factory(t) { return new (t || BentoNgbPopoverAnimationModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoNgbPopoverAnimationModule, { declarations: function () { return [BentoNgbPopoverAnimationDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BentoNgbPopoverAnimationDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNgbPopoverAnimationModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoNgbPopoverAnimationDirective],
                imports: [CommonModule],
                exports: [BentoNgbPopoverAnimationDirective],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoNgbPopoverAnimationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/number-input/number-input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This is a custom number input component with up and down keys and keyboard control.
 * It supports localization when combined with either [Translate](#/components/translate)
 * or [Angular i18n](https://angular.io/docs/ts/latest/cookbook/i18n.html).
 *
 * TODO: make sure this i18n info is relevant
 */
var BentoNumberInputComponent = /** @class */ (function () {
    function BentoNumberInputComponent(elementRef, windowRef, uidGen, r, changeDetector, focusMonitor) {
        this.r = r;
        this.changeDetector = changeDetector;
        this.focusMonitor = focusMonitor;
        /**
         * Decimal Separator
         */
        this.decimalSeparator = '.';
        /**
         * Increment step for both arrow keys and buttons
         */
        this.step = 1;
        /**
         * Maximum value allowed
         */
        this.max = Number.POSITIVE_INFINITY;
        /**
         * Minimum value allowed
         */
        this.min = Number.NEGATIVE_INFINITY;
        /**
         * Flag to determine if the current input is pasted
         */
        this.isPasted = false;
        /**
         * Flag to determine if this component is disabled
         * \@
         */
        this._isDisabled = false;
        /**
         * Input field aria-live setting
         */
        this._ariaLivePolitenessSetting = 'off';
        /**
         * Variable that implements the BentoTranslatable
         */
        this.customTranslation = {};
        this.el = elementRef.nativeElement;
        /* istanbul ignore next */
        this._onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        /* istanbul ignore next */
        this._onTouch = (/**
         * @return {?}
         */
        function () { });
        this.uid = uidGen.generate();
        this.document = windowRef.nativeDocument;
        this.focusMonitor.monitor(this.el, true);
    }
    Object.defineProperty(BentoNumberInputComponent.prototype, "_id", {
        /**
         * ID of this element
         */
        set: /**
         * ID of this element
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.id = v;
            this.setupAria();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Used to update ngModel flag `touched`
     */
    /**
     * Used to update ngModel flag `touched`
     * @param {?} e
     * @return {?}
     */
    BentoNumberInputComponent.prototype.onHostFocusout = /**
     * Used to update ngModel flag `touched`
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            if (!_this.el.contains(_this.document.activeElement)) {
                _this._onTouch();
            }
        }));
    };
    /**
     * ControlValueAccessor interface function
     */
    /**
     * ControlValueAccessor interface function
     * @param {?} isDisabled
     * @return {?}
     */
    BentoNumberInputComponent.prototype.setDisabledState = /**
     * ControlValueAccessor interface function
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._isDisabled = isDisabled;
        this.changeDetector.markForCheck();
    };
    /**
     * @return {?}
     */
    BentoNumberInputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setupAria();
    };
    /**
     * @return {?}
     */
    BentoNumberInputComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.focusMonitor.stopMonitoring(this.el);
        this.changeDetector.detach();
    };
    /**
     * @return {?}
     */
    BentoNumberInputComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var buttonDownID = 'button-down-' + this.uid;
        /** @type {?} */
        var buttonUpID = 'button-up-' + this.uid;
        this.r.setAttribute(this.buttonDownRef.nativeElement, 'id', buttonDownID);
        this.r.setAttribute(this.buttonUpRef.nativeElement, 'id', buttonUpID);
    };
    /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     * * BENTO_UI_NUMBER_INPUT_INCREASE: 'Increase Number'
     * * BENTO_UI_NUMBER_INPUT_DECREASE: 'Decrease Number'
     */
    /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     * * BENTO_UI_NUMBER_INPUT_INCREASE: 'Increase Number'
     * * BENTO_UI_NUMBER_INPUT_DECREASE: 'Decrease Number'
     * @param {?} customTranslation
     * @return {?}
     */
    BentoNumberInputComponent.prototype.setTranslation = /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     * * BENTO_UI_NUMBER_INPUT_INCREASE: 'Increase Number'
     * * BENTO_UI_NUMBER_INPUT_DECREASE: 'Decrease Number'
     * @param {?} customTranslation
     * @return {?}
     */
    function (customTranslation) {
        this.customTranslation = customTranslation;
        this.changeDetector.detectChanges();
    };
    /**
     * ControlValueAccessor interface function
     */
    /**
     * ControlValueAccessor interface function
     * @param {?} v
     * @return {?}
     */
    BentoNumberInputComponent.prototype.writeValue = /**
     * ControlValueAccessor interface function
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this.value = Number(v);
        if (isNaN(this.value) || // v is not a number
            (!v && v !== 0) || // v is either `undefined` or `null`
            (typeof v === 'string' && v.trim().length === 0) // v is an empty string
        ) {
            // Invalid dev input
            this.value = null;
            this._stringValue = '';
        }
        else {
            // Valid dev input
            this._stringValue = this._encode(this.value);
        }
    };
    /**
     * ControlValueAccessor interface function
     */
    /**
     * ControlValueAccessor interface function
     * @param {?} fn
     * @return {?}
     */
    BentoNumberInputComponent.prototype.registerOnChange = /**
     * ControlValueAccessor interface function
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onChange = fn;
    };
    /**
     * ControlValueAccessor interface function
     */
    /**
     * ControlValueAccessor interface function
     * @param {?} fn
     * @return {?}
     */
    BentoNumberInputComponent.prototype.registerOnTouched = /**
     * ControlValueAccessor interface function
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this._onTouch = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.changeDetector.markForCheck();
        });
    };
    /**
     * FormControl Validator implementation
     */
    /**
     * FormControl Validator implementation
     * @param {?} formControl
     * @return {?}
     */
    BentoNumberInputComponent.prototype.validate = /**
     * FormControl Validator implementation
     * @param {?} formControl
     * @return {?}
     */
    function (formControl) {
        // Value to be validated
        /** @type {?} */
        var value = formControl.value;
        /** @type {?} */
        var validator = {};
        /** @type {?} */
        var isValid = true;
        if (typeof value === 'undefined' || value === null) {
            // NaN
            validator.isNaN = true;
            isValid = false;
        }
        else {
            // All other invalid inputs
            if (value > this.max) {
                // Out of boundary with the max number
                validator.max = { outOfBoundary: true, actualLength: value, requiredLength: this.max };
                isValid = false;
            }
            if (value < this.min) {
                // Out of boundary with teh min number
                validator.min = { outOfBoundary: true, actualLength: value, requiredLength: this.min };
                isValid = false;
            }
        }
        return isValid ? null : validator;
    };
    /**
     * Catch input event on the input for value validation
     */
    /**
     * Catch input event on the input for value validation
     * @param {?} e
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onInput = /**
     * Catch input event on the input for value validation
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this._validateAndSetValue(this._decode(((/** @type {?} */ (e.currentTarget))).value));
    };
    /**
     * Keydown callback on the input
     */
    /**
     * Keydown callback on the input
     * @param {?} e
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onKeydown = /**
     * Keydown callback on the input
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.keyCode === Keyboard.UP) {
            // Key UP
            this._setValue(this._updateValueWithStep(this.value, this.step));
            e.preventDefault();
            e.stopPropagation();
        }
        else if (e.keyCode === Keyboard.DOWN) {
            // Key DOWN
            this._setValue(this._updateValueWithStep(this.value, -this.step));
            e.preventDefault();
            e.stopPropagation();
        }
        else if (e.keyCode === Keyboard.SPACE) {
            // Ignore space character
            e.preventDefault();
            e.stopPropagation();
        }
    };
    /**
     * Keypress callback on the input
     *
     */
    /**
     * Keypress callback on the input
     *
     * @param {?} e
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onKeypress = /**
     * Keypress callback on the input
     *
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var char = String.fromCharCode(e.charCode);
        if (
        // tslint:disable-next-line max-line-length
        (isNaN(Number(char)) && e.charCode > 0 && char !== '-' && char !== this.decimalSeparator && e.charCode !== 13) || // Enter key on chrome
            (char === '-' && ((/** @type {?} */ (e.currentTarget))).selectionStart > 0)) {
            // Prevent non-number input keypress
            e.preventDefault();
            e.stopPropagation();
        }
    };
    /**
     * Keydown listener
     */
    /**
     * Keydown listener
     * @param {?} e
     * @param {?} direction
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onArrowKeydown = /**
     * Keydown listener
     * @param {?} e
     * @param {?} direction
     * @return {?}
     */
    function (e, direction) {
        if (e.keyCode === Keyboard.ENTER || e.keyCode === Keyboard.SPACE) {
            this._setValue(this._updateValueWithStep(this.value, direction));
        }
    };
    /**
     * Mouse/Touch down callback on the up and down arrow buttons
     */
    /**
     * Mouse/Touch down callback on the up and down arrow buttons
     * @param {?} e
     * @param {?} direction
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onArrowPointerDown = /**
     * Mouse/Touch down callback on the up and down arrow buttons
     * @param {?} e
     * @param {?} direction
     * @return {?}
     */
    function (e, direction) {
        /** @type {?} */
        var step = this.step * direction;
        /** @type {?} */
        var self = this;
        /** @type {?} */
        var delay = 1000;
        /** @type {?} */
        var slowInterval = 100;
        /** @type {?} */
        var fastInterval = 30;
        /** @type {?} */
        var speedUpCountThreshhold = 30;
        /** @type {?} */
        var speedJumpCountThreshhold = 180;
        /** @type {?} */
        var count = 0;
        // Tick counter
        /** @type {?} */
        var timeoutID;
        /** @type {?} */
        var unlistenWindowMouseUp = (/**
         * @return {?}
         */
        function () { });
        /** @type {?} */
        var unlistenWindowTouchEnd = (/**
         * @return {?}
         */
        function () { });
        if (e.type === 'mousedown') {
            /** @type {?} */
            var mouseEvent = (/** @type {?} */ (e));
            if (mouseEvent.button !== 0) {
                // Let the mouse down only takes the main click button
                return;
            }
            unlistenWindowMouseUp = this.r.listen('window', 'mouseup', onArrowPointerUp.bind(this));
        }
        else if (e.type === 'touchstart') {
            unlistenWindowTouchEnd = this.r.listen('window', 'touchend', onArrowPointerUp.bind(this));
        }
        // Call  function to start the tick
        updateValue();
        /**
         * Update the current value with step and direction
         * @return {?}
         */
        function updateValue() {
            self._setValue(self._updateValueWithStep(self.value, step));
            // Set timeout for the next tick
            timeoutID = setTimeout(updateValue, delay);
            // Tick counter
            count++;
            if (count === 1) {
                delay = slowInterval;
            }
            else if (count === speedUpCountThreshhold) {
                delay = fastInterval;
            }
            else if (count === speedJumpCountThreshhold) {
                step *= 10;
            }
        }
        /**
         * Mouse/Touch up callback on the window to terminate auto increment
         * @return {?}
         */
        function onArrowPointerUp() {
            clearTimeout(timeoutID);
            unlistenWindowMouseUp();
            unlistenWindowTouchEnd();
        }
    };
    /**
     * On up/down arrows focus
     */
    /**
     * On up/down arrows focus
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onArrowFocus = /**
     * On up/down arrows focus
     * @return {?}
     */
    function () {
        this._ariaLivePolitenessSetting = 'polite';
    };
    /**
     * On up/down arrows blur
     */
    /**
     * On up/down arrows blur
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onArrowBlur = /**
     * On up/down arrows blur
     * @return {?}
     */
    function () {
        this._ariaLivePolitenessSetting = 'off';
    };
    /**
     * Catch paste event on the input
     */
    /**
     * Catch paste event on the input
     * @param {?} e
     * @return {?}
     */
    BentoNumberInputComponent.prototype._onPaste = /**
     * Catch paste event on the input
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.isPasted = true;
    };
    /**
     * Update main ngModel value with a given number
     */
    /**
     * Update main ngModel value with a given number
     * @param {?} val
     * @param {?} step
     * @return {?}
     */
    BentoNumberInputComponent.prototype._updateValueWithStep = /**
     * Update main ngModel value with a given number
     * @param {?} val
     * @param {?} step
     * @return {?}
     */
    function (val, step) {
        /** @type {?} */
        var value = typeof val === 'undefined' ? 0 : val;
        // Since JS doesn't do additions precisely, float is needed
        value = Math.round((Number(value) + step) * 1000000000000) / 1000000000000;
        if (value > this.max) {
            value = this.max;
        }
        else if (value < this.min) {
            value = this.min;
        }
        return value;
    };
    /**
     * _encode a number to string with appropriate decimal separator
     */
    /**
     * _encode a number to string with appropriate decimal separator
     * @param {?} val
     * @return {?}
     */
    BentoNumberInputComponent.prototype._encode = /**
     * _encode a number to string with appropriate decimal separator
     * @param {?} val
     * @return {?}
     */
    function (val) {
        // when val is UNDEFINED or NULL
        if (val == null) {
            return '';
        }
        return String(val).replace('.', this.decimalSeparator);
    };
    /**
     * _decode a string back into a number
     */
    /**
     * _decode a string back into a number
     * @param {?} val
     * @return {?}
     */
    BentoNumberInputComponent.prototype._decode = /**
     * _decode a string back into a number
     * @param {?} val
     * @return {?}
     */
    function (val) {
        // when number is UNDEFINED or NULL
        if (!val) {
            return null;
        }
        return val.replace(this.decimalSeparator, '.');
    };
    Object.defineProperty(BentoNumberInputComponent.prototype, "_stringValue", {
        /**
         * Set input field value
         */
        set: /**
         * Set input field value
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.inputElRef.nativeElement.value = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set value and propagate changes to NgModel without validations
     * FAST
     */
    /**
     * Set value and propagate changes to NgModel without validations
     * FAST
     * @param {?} val
     * @return {?}
     */
    BentoNumberInputComponent.prototype._setValue = /**
     * Set value and propagate changes to NgModel without validations
     * FAST
     * @param {?} val
     * @return {?}
     */
    function (val) {
        this._previousValue = this.value = val;
        this._stringValue = !val && val !== 0 ? '' : this._encode(val);
        // update changes to the ngModel for parent controls
        this._onChange(val);
    };
    /**
     * Validate and set value then propagate changes to NgModel
     */
    /**
     * Validate and set value then propagate changes to NgModel
     * @param {?} inputVal
     * @return {?}
     */
    BentoNumberInputComponent.prototype._validateAndSetValue = /**
     * Validate and set value then propagate changes to NgModel
     * @param {?} inputVal
     * @return {?}
     */
    function (inputVal) {
        // No need to update the ngModel since there is no change in string
        if (Number(inputVal) === this._previousValue &&
            // Number('') results to 0 and it
            !(inputVal === '' && this._previousValue === 0)) {
            return;
        }
        this.isPasted = false;
        // Proceed with number validation
        /** @type {?} */
        var newValObj = this._validateValue(inputVal);
        if (typeof newValObj.numberString === 'undefined' || newValObj.numberString === null) {
            // There is a case where the returned value is undefined <string>
            // need to handle this special case from `_validateValue` and reset the input field
            this._setValue(null);
            return;
        }
        /** @type {?} */
        var newVal = newValObj.numberString === '-' ||
            newValObj.numberString === this.decimalSeparator ||
            newValObj.numberString === null
            ? null
            : Number(newValObj.numberString);
        /** @type {?} */
        var input = this.inputElRef.nativeElement;
        /** @type {?} */
        var caratPos = newValObj.isRollback ? input.selectionStart - 1 : input.selectionStart;
        this._setValue(newVal);
        // make sure to bring the selection back after setting the value after rendering
        input.setSelectionRange(caratPos, caratPos);
    };
    /**
     * Validate the current value and make corrections
     */
    /**
     * Validate the current value and make corrections
     * @param {?} stringVal
     * @return {?}
     */
    BentoNumberInputComponent.prototype._validateValue = /**
     * Validate the current value and make corrections
     * @param {?} stringVal
     * @return {?}
     */
    function (stringVal) {
        /** @type {?} */
        var vNum = Number(stringVal);
        /** @type {?} */
        var max = this.max;
        /** @type {?} */
        var min = this.min;
        /** @type {?} */
        var maxDigits = this.max !== Number.POSITIVE_INFINITY ? String(this.max).length : 20;
        /** @type {?} */
        var minDigits = this.min !== Number.NEGATIVE_INFINITY ? String(this.min).length : 21;
        /** @type {?} */
        var valueLength = stringVal ? stringVal.length : 0;
        /** @type {?} */
        var isRollback = false;
        /** @type {?} */
        var newNum = stringVal;
        if (stringVal == null || valueLength === 0) {
            newNum = null;
        }
        else if ((isNaN(vNum) && stringVal !== '-') || vNum > max || vNum < min) {
            if (this.isPasted) {
                // we need to do concat the value
                newNum = vNum > max ? stringVal.slice(0, maxDigits) : stringVal.slice(0, minDigits);
            }
            else if ((vNum > max && ((valueLength >= maxDigits && max >= 0) || valueLength >= minDigits)) ||
                (vNum < min && ((valueLength >= minDigits && min < 0) || valueLength >= maxDigits)) ||
                (min < 0 && max < 0 && vNum >= 0)) {
                // Rollback when out of bound
                newNum = !this._previousValue && this._previousValue !== 0 ? null : String(this._previousValue);
                isRollback = true;
            }
        }
        else if (stringVal.indexOf('-') === 0 || stringVal.indexOf('.') > -1) {
            if (min >= 0 && max >= 0 && stringVal.indexOf('-') > -1) {
                // Minus sign is used when max and min are all positive
                newNum = !this._previousValue && this._previousValue !== 0 ? null : String(this._previousValue);
                isRollback = true;
            }
            else {
                // OK to add both minus sign and default decimal separator
                newNum = stringVal.trim();
            }
        }
        return { numberString: newNum, isRollback: isRollback };
    };
    /**
     * Setup aria values
     */
    /**
     * Setup aria values
     * @private
     * @return {?}
     */
    BentoNumberInputComponent.prototype.setupAria = /**
     * Setup aria values
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var ariaAttribute = this.el.getAttribute('aria-label');
        this.ariaLabel = ariaAttribute ? ariaAttribute : this.ariaLabel;
        ariaAttribute = this.el.getAttribute('aria-describedby');
        this.ariaDescribedby = ariaAttribute ? ariaAttribute : this.ariaDescribedby;
        ariaAttribute = this.el.getAttribute('aria-labelledby');
        this.ariaLabelledby = ariaAttribute ? ariaAttribute : this.ariaLabelledby;
        if (!(typeof this.id === 'string' && this.id.length)) {
            this.id = 'bui-input-' + this.uid;
        }
        else {
            this.r.removeAttribute(this.el, 'id');
        }
        if (this.ariaLabel && this.ariaLabel.length) {
            // Move aria-label
            this.r.removeAttribute(this.el, 'aria-label');
        }
        if (this.ariaDescribedby && this.ariaDescribedby.length) {
            // Move aria-describedby
            this.r.removeAttribute(this.el, 'aria-describedby');
        }
        this._inputID = this.id;
        this.changeDetector.markForCheck();
    };
    /** @nocollapse */
    BentoNumberInputComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: WindowRef },
        { type: BentoUidService },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: FocusMonitor }
    ]; };
    BentoNumberInputComponent.propDecorators = {
        inputElRef: [{ type: ViewChild, args: ['input', { static: true },] }],
        decimalSeparator: [{ type: Input }],
        step: [{ type: Input }],
        max: [{ type: Input }],
        min: [{ type: Input }],
        _id: [{ type: Input, args: ['id',] }],
        buttonUpRef: [{ type: ViewChild, args: ['buttonUp', { static: true },] }],
        buttonDownRef: [{ type: ViewChild, args: ['buttonDown', { static: true },] }],
        onHostFocusout: [{ type: HostListener, args: ['focusout', ['$event'],] }]
    };
BentoNumberInputComponent.ɵfac = function BentoNumberInputComponent_Factory(t) { return new (t || BentoNumberInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoUidService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FocusMonitor)); };
BentoNumberInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoNumberInputComponent, selectors: [["bento-number-input"]], viewQuery: function BentoNumberInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c14, true);
        ɵngcc0.ɵɵstaticViewQuery(_c34, true);
        ɵngcc0.ɵɵstaticViewQuery(_c35, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonUpRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonDownRef = _t.first);
    } }, hostBindings: function BentoNumberInputComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusout", function BentoNumberInputComponent_focusout_HostBindingHandler($event) { return ctx.onHostFocusout($event); });
    } }, inputs: { decimalSeparator: "decimalSeparator", step: "step", max: "max", min: "min", _id: ["id", "_id"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            // Access ngModel
            { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(( /**
                     * @return {?}
                     */function () { return BentoNumberInputComponent; })), multi: true },
            // Activate Validator
            { provide: NG_VALIDATORS, useExisting: forwardRef(( /**
                     * @return {?}
                     */function () { return BentoNumberInputComponent; })), multi: true },
            // UID Generator
            BentoUidService
        ])], decls: 12, vars: 19, consts: [["type", "text", 1, "form-control", "bui-menu-item", 3, "disabled", "input", "keydown", "keypress", "paste"], ["input", ""], ["cdkMonitorElementFocus", "", "type", "button", 1, "bento-number-input-button", "bento-number-input-button-down", 3, "disabled", "mousedown", "touchstart", "keydown", "focus", "blur"], ["buttonDown", ""], ["aria-hidden", "true", 1, "bento-icon-chevron-down"], ["cdkMonitorElementFocus", "", "type", "button", 1, "bento-number-input-button", "bento-number-input-button-up", 3, "disabled", "mousedown", "touchstart", "keydown", "focus", "blur"], ["buttonUp", ""], ["aria-hidden", "true", 1, "bento-icon-chevron-up"], [1, "sr-only"]], template: function BentoNumberInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("input", function BentoNumberInputComponent_Template_input_input_0_listener($event) { return ctx._onInput($event); })("keydown", function BentoNumberInputComponent_Template_input_keydown_0_listener($event) { return ctx._onKeydown($event); })("keypress", function BentoNumberInputComponent_Template_input_keypress_0_listener($event) { return ctx._onKeypress($event); })("paste", function BentoNumberInputComponent_Template_input_paste_0_listener($event) { return ctx._onPaste($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "button", 2, 3);
        ɵngcc0.ɵɵlistener("mousedown", function BentoNumberInputComponent_Template_button_mousedown_2_listener($event) { return ctx._onArrowPointerDown($event, 0 - 1); })("touchstart", function BentoNumberInputComponent_Template_button_touchstart_2_listener($event) { return ctx._onArrowPointerDown($event, 0 - 1); })("keydown", function BentoNumberInputComponent_Template_button_keydown_2_listener($event) { return ctx._onArrowKeydown($event, 0 - 1); })("focus", function BentoNumberInputComponent_Template_button_focus_2_listener() { return ctx._onArrowFocus(); })("blur", function BentoNumberInputComponent_Template_button_blur_2_listener() { return ctx._onArrowBlur(); });
        ɵngcc0.ɵɵpipe(4, "bentoTranslate");
        ɵngcc0.ɵɵelement(5, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 5, 6);
        ɵngcc0.ɵɵlistener("mousedown", function BentoNumberInputComponent_Template_button_mousedown_6_listener($event) { return ctx._onArrowPointerDown($event, 1); })("touchstart", function BentoNumberInputComponent_Template_button_touchstart_6_listener($event) { return ctx._onArrowPointerDown($event, 1); })("keydown", function BentoNumberInputComponent_Template_button_keydown_6_listener($event) { return ctx._onArrowKeydown($event, 1); })("focus", function BentoNumberInputComponent_Template_button_focus_6_listener() { return ctx._onArrowFocus(); })("blur", function BentoNumberInputComponent_Template_button_blur_6_listener() { return ctx._onArrowBlur(); });
        ɵngcc0.ɵɵpipe(8, "bentoTranslate");
        ɵngcc0.ɵɵelement(9, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 8);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx._isDisabled);
        ɵngcc0.ɵɵattribute("id", ctx._inputID)("aria-label", ctx.ariaLabel ? ctx.ariaLabel : null)("aria-describedby", ctx.ariaDescribedby ? ctx.ariaDescribedby : null)("aria-labelledby", ctx.ariaLabelledby ? ctx.ariaLabelledby : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx._isDisabled || ctx.value === ctx.min);
        ɵngcc0.ɵɵattribute("aria-controls", ctx._inputID)("aria-label", ɵngcc0.ɵɵpipeBind2(4, 13, "BENTO_UI_NUMBER_INPUT_DECREASE", ctx.customTranslation["BENTO_UI_NUMBER_INPUT_DECREASE"]));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", ctx._isDisabled || ctx.value === ctx.max);
        ɵngcc0.ɵɵattribute("aria-controls", ctx._inputID)("aria-label", ɵngcc0.ɵɵpipeBind2(8, 16, "BENTO_UI_NUMBER_INPUT_INCREASE", ctx.customTranslation["BENTO_UI_NUMBER_INPUT_INCREASE"]));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵattribute("aria-live", ctx._ariaLivePolitenessSetting);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.value);
    } }, directives: [ɵngcc1.CdkMonitorFocus], pipes: [BentoTranslatePipe], styles: ["bento-number-input{display:inline-block;position:relative;vertical-align:middle;width:100%}bento-number-input input:disabled~.bento-number-input-button{pointer-events:none}bento-number-input>input.form-control{border-radius:0}[dir=rtl] bento-number-input>input.form-control{padding-right:11.9px}bento-number-input input[type=number]{-moz-appearance:textfield}bento-number-input input::-webkit-inner-spin-button,bento-number-input input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}bento-number-input.full-width{width:100%}bento-number-input.input-lg{padding:0}bento-number-input.input-lg .form-control{height:50px}[dir=rtl] bento-number-input.input-lg .bento-number-input-button.bento-number-input-button-down{right:auto}bento-number-input.input-sm{padding:0}[dir=rtl] bento-number-input.input-sm .bento-number-input-button.bento-number-input-button-down{right:auto}bento-number-input .bento-number-input-button{transition:border-color .2s;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;align-items:center;border-width:1px;border-style:solid;cursor:pointer;display:flex;font-size:18px;justify-content:center;padding:0;position:absolute;right:0;text-align:center;top:0;z-index:4}bento-number-input .bento-number-input-button.bento-number-input-button-down,bento-number-input .bento-number-input-button.bento-number-input-button-up{border-radius:0}bento-number-input .form-inline .bento-number-input-wrapper{display:inline-block}[dir=rtl] bento-number-input .bento-number-input-button{right:auto;left:0}bento-number-input .bento-number-input-button i{top:0;vertical-align:baseline}[dir=rtl] bento-number-input .bento-number-input-button.bento-number-input-button-down{right:auto}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNumberInputComponent, [{
        type: Component,
        args: [{
                selector: 'bento-number-input',
                template: "<input\n  #input\n  class=\"form-control bui-menu-item\"\n  type=\"text\"\n  (input)=\"_onInput($event)\"\n  (keydown)=\"_onKeydown($event)\"\n  (keypress)=\"_onKeypress($event)\"\n  (paste)=\"_onPaste($event)\"\n  [disabled]=\"_isDisabled\"\n  [attr.id]=\"_inputID\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n  [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n/>\n<button\n  #buttonDown\n  cdkMonitorElementFocus\n  class=\"bento-number-input-button bento-number-input-button-down\"\n  type=\"button\"\n  (mousedown)=\"_onArrowPointerDown($event, -1)\"\n  (touchstart)=\"_onArrowPointerDown($event, -1)\"\n  (keydown)=\"_onArrowKeydown($event, -1)\"\n  (focus)=\"_onArrowFocus()\"\n  (blur)=\"_onArrowBlur()\"\n  [disabled]=\"_isDisabled || value === min\"\n  [attr.aria-controls]=\"_inputID\"\n  [attr.aria-label]=\"\n    'BENTO_UI_NUMBER_INPUT_DECREASE' | bentoTranslate: customTranslation['BENTO_UI_NUMBER_INPUT_DECREASE']\n  \"\n>\n  <i class=\"bento-icon-chevron-down\" aria-hidden=\"true\"></i>\n</button>\n<button\n  #buttonUp\n  cdkMonitorElementFocus\n  class=\"bento-number-input-button bento-number-input-button-up\"\n  type=\"button\"\n  (mousedown)=\"_onArrowPointerDown($event, 1)\"\n  (touchstart)=\"_onArrowPointerDown($event, 1)\"\n  (keydown)=\"_onArrowKeydown($event, 1)\"\n  (focus)=\"_onArrowFocus()\"\n  (blur)=\"_onArrowBlur()\"\n  [disabled]=\"_isDisabled || value === max\"\n  [attr.aria-controls]=\"_inputID\"\n  [attr.aria-label]=\"\n    'BENTO_UI_NUMBER_INPUT_INCREASE' | bentoTranslate: customTranslation['BENTO_UI_NUMBER_INPUT_INCREASE']\n  \"\n>\n  <i class=\"bento-icon-chevron-up\" aria-hidden=\"true\"></i>\n</button>\n<span class=\"sr-only\" [attr.aria-live]=\"_ariaLivePolitenessSetting\">{{ this.value }}</span>\n",
                providers: [
                    // Access ngModel
                    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(( /**
                             * @return {?}
                             */function () { return BentoNumberInputComponent; })), multi: true },
                    // Activate Validator
                    { provide: NG_VALIDATORS, useExisting: forwardRef(( /**
                             * @return {?}
                             */function () { return BentoNumberInputComponent; })), multi: true },
                    // UID Generator
                    BentoUidService
                ],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-number-input{display:inline-block;position:relative;vertical-align:middle;width:100%}bento-number-input input:disabled~.bento-number-input-button{pointer-events:none}bento-number-input>input.form-control{border-radius:0}[dir=rtl] bento-number-input>input.form-control{padding-right:11.9px}bento-number-input input[type=number]{-moz-appearance:textfield}bento-number-input input::-webkit-inner-spin-button,bento-number-input input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}bento-number-input.full-width{width:100%}bento-number-input.input-lg{padding:0}bento-number-input.input-lg .form-control{height:50px}[dir=rtl] bento-number-input.input-lg .bento-number-input-button.bento-number-input-button-down{right:auto}bento-number-input.input-sm{padding:0}[dir=rtl] bento-number-input.input-sm .bento-number-input-button.bento-number-input-button-down{right:auto}bento-number-input .bento-number-input-button{transition:border-color .2s;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;align-items:center;border-width:1px;border-style:solid;cursor:pointer;display:flex;font-size:18px;justify-content:center;padding:0;position:absolute;right:0;text-align:center;top:0;z-index:4}bento-number-input .bento-number-input-button.bento-number-input-button-down,bento-number-input .bento-number-input-button.bento-number-input-button-up{border-radius:0}bento-number-input .form-inline .bento-number-input-wrapper{display:inline-block}[dir=rtl] bento-number-input .bento-number-input-button{right:auto;left:0}bento-number-input .bento-number-input-button i{top:0;vertical-align:baseline}[dir=rtl] bento-number-input .bento-number-input-button.bento-number-input-button-down{right:auto}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: BentoUidService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.FocusMonitor }]; }, { decimalSeparator: [{
            type: Input
        }], step: [{
            type: Input
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], _id: [{
            type: Input,
            args: ['id']
        }], onHostFocusout: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], inputElRef: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], buttonUpRef: [{
            type: ViewChild,
            args: ['buttonUp', { static: true }]
        }], buttonDownRef: [{
            type: ViewChild,
            args: ['buttonDown', { static: true }]
        }] }); })();
    return BentoNumberInputComponent;
}());
if (false) {
    /** @type {?} */
    BentoNumberInputComponent.prototype.inputElRef;
    /**
     * Decimal Separator
     * @type {?}
     */
    BentoNumberInputComponent.prototype.decimalSeparator;
    /**
     * Increment step for both arrow keys and buttons
     * @type {?}
     */
    BentoNumberInputComponent.prototype.step;
    /**
     * Maximum value allowed
     * @type {?}
     */
    BentoNumberInputComponent.prototype.max;
    /**
     * Minimum value allowed
     * @type {?}
     */
    BentoNumberInputComponent.prototype.min;
    /**
     * Element reference to the up button
     * @type {?}
     */
    BentoNumberInputComponent.prototype.buttonUpRef;
    /**
     * Element reference to the down button
     * @type {?}
     */
    BentoNumberInputComponent.prototype.buttonDownRef;
    /**
     * Main value of this component
     * @type {?}
     */
    BentoNumberInputComponent.prototype.value;
    /**
     * Flag to determine if the current input is pasted
     * @type {?}
     */
    BentoNumberInputComponent.prototype.isPasted;
    /**
     * A previous value used to rollback from invalid user inputs
     * @type {?}
     */
    BentoNumberInputComponent.prototype._previousValue;
    /**
     * Flag to determine if this component is disabled
     * \@
     * @type {?}
     */
    BentoNumberInputComponent.prototype._isDisabled;
    /**
     * Callback to ngModel change
     * @type {?}
     */
    BentoNumberInputComponent.prototype._onChange;
    /**
     * Callback to notify ngModel touched
     * @type {?}
     */
    BentoNumberInputComponent.prototype._onTouch;
    /**
     * HTMLElement ID for input element
     * @type {?}
     */
    BentoNumberInputComponent.prototype._inputID;
    /**
     * Input field aria-live setting
     * @type {?}
     */
    BentoNumberInputComponent.prototype._ariaLivePolitenessSetting;
    /** @type {?} */
    BentoNumberInputComponent.prototype.ariaLabel;
    /** @type {?} */
    BentoNumberInputComponent.prototype.ariaDescribedby;
    /** @type {?} */
    BentoNumberInputComponent.prototype.ariaLabelledby;
    /**
     * Component HTMLElement Ref
     * @type {?}
     * @private
     */
    BentoNumberInputComponent.prototype.el;
    /**
     * uid
     * @type {?}
     * @private
     */
    BentoNumberInputComponent.prototype.uid;
    /**
     *
     * @type {?}
     * @private
     */
    BentoNumberInputComponent.prototype.id;
    /**
     * Document object reference
     * @type {?}
     * @private
     */
    BentoNumberInputComponent.prototype.document;
    /**
     * Variable that implements the BentoTranslatable
     * @type {?}
     */
    BentoNumberInputComponent.prototype.customTranslation;
    /**
     * @type {?}
     * @private
     */
    BentoNumberInputComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoNumberInputComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoNumberInputComponent.prototype.focusMonitor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/number-input/number-input.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoNumberInputModule = /** @class */ (function () {
    function BentoNumberInputModule() {
    }
BentoNumberInputModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoNumberInputModule });
BentoNumberInputModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoNumberInputModule_Factory(t) { return new (t || BentoNumberInputModule)(); }, imports: [[CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, A11yModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoNumberInputModule, { declarations: function () { return [BentoNumberInputComponent]; }, imports: function () { return [CommonModule, FormsModule,
        BentoTranslateModule,
        BentoUtilsModule,
        A11yModule]; }, exports: function () { return [BentoNumberInputComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoNumberInputModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, A11yModule],
                declarations: [BentoNumberInputComponent],
                exports: [BentoNumberInputComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoNumberInputModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/off-canvas-menu/off-canvas-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var Side = {
    Left: 0,
    Right: 1,
};
Side[Side.Left] = 'Left';
Side[Side.Right] = 'Right';
/** @type {?} */
var DEFAULT_PANEL_WIDTH = 340;
/**
 * This component acts as a page template. It can be broadly used by HTML5/CSS3 compatible browsers.
 * It is responsive to different sizes of viewports and behaves differently based on window width.
 * In order to experience its responsive behavior on desktop, slowly drag the right side of your
 * browser window to narrow the viewport. Observe how the side menu and toolbar buttons react.
 * These alternate manifestations will be the default on mobile devices.
 *
 * TODO: the above statements are true of Bento 1.x, but not yet Bento NG.
 * RWD is currently not in place.
 * Also, "Tasks" button is not properly offset to appear centered.
 */
var BentoOffCanvasMenuComponent = /** @class */ (function () {
    function BentoOffCanvasMenuComponent(cd, tabService, r, platform, notification, dir, winRef, elRef) {
        var _this = this;
        this.cd = cd;
        this.tabService = tabService;
        this.r = r;
        this.platform = platform;
        this.winRef = winRef;
        this.elRef = elRef;
        /**
         * Defines how side nav behaves when it shows
         * * `'over'` Side nav comes in and overlaps the content
         * * `'push'` Side nav comes in and pushes the content to the other side without resizing
         * * `'side'` Side nav comes in and resize the main content so that both contents are visible
         */
        this.mode = 'push';
        /**
         * Emits when `isOpen` is changed
         */
        this.isOpenChange = new EventEmitter(true);
        /**
         * Flag to determine if the overlay is hidden when a side panel is out
         */
        this.hideOverlay = false;
        /**
         * Flag to determine if the right panel header and close button should be shown
         */
        this.showRightPanelHeader = false;
        /**
         * Emits when `rightIsOpen` is changed
         */
        this.rightIsOpenChange = new EventEmitter(true);
        /**
         * Hide/Show Hamburger menu button
         */
        this.menuButtonIsHidden = false;
        // Private but used by the template
        this._isAsideHidden = true;
        this._isRightAsideHidden = true;
        /**
         * Flag to determine if this component is responsive to window size
         */
        this.responsive = false;
        // Add state classes depending on opening direction
        this._isOpen = false;
        this._rightIsOpen = false;
        this._isPushOver = true;
        this._alwaysOpen = false;
        /**
         * [Private variables]
         */
        this._animationDuration = 200;
        this.dirChangeSubscription = Subscription.EMPTY;
        this.resizeSubscription = Subscription.EMPTY;
        this.windowScrollSubscription = Subscription.EMPTY;
        this.leftPanelWidth = DEFAULT_PANEL_WIDTH;
        this.rightPanelWidth = DEFAULT_PANEL_WIDTH;
        this.document = winRef.nativeDocument;
        this.dirChangeSubscription = dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this._isRTL = dir.value === 'rtl';
        }));
        this.resizeSubscription = notification.resizeNotification.subscribe(this.onWindowResize.bind(this));
        if (platform.isBrowser) {
            this.windowScrollSubscription = fromEvent(winRef.nativeWindow, 'scroll', { capture: true })
                .pipe(filter((/**
             * @return {?}
             */
            function () { return _this.tooltips.length > 0; })))
                .subscribe(this.onWindowScroll.bind(this));
        }
        this.el = this.elRef.nativeElement;
        // disable all transition during init
        this.r.addClass(this.el, 'bento-off-canvas-menu-rendering');
        this.leftPanelWrapperRef;
        this.rightPanelWrapperRef;
    }
    Object.defineProperty(BentoOffCanvasMenuComponent.prototype, "isOpen", {
        /**
         * Flag to determine open/close state of the left panel
         */
        set: /**
         * Flag to determine open/close state of the left panel
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null) {
                // Skip when `isOpen` is not defined
                return;
            }
            if (this._alwaysOpen && !value) {
                // alwaysOpen will ignore all program instructions
                // Revert value for parent component
                this.isOpenChange.emit(this._isOpen);
                return;
            }
            this._isOpen = value;
            this._togglePanel(Side.Left);
            this.isOpenChange.emit(value);
            if (this._rightIsOpen && value && !this.hideOverlay) {
                // Close the opposite side
                this.rightIsOpen = false;
            }
            this.setContentPanelLocation();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoOffCanvasMenuComponent.prototype, "rightIsOpen", {
        /**
         * Flag to determine open/close state of the right panel
         */
        set: /**
         * Flag to determine open/close state of the right panel
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._rightIsOpen = value;
            this._togglePanel(Side.Right);
            this.rightIsOpenChange.emit(value);
            if (this._isOpen && value && !this.hideOverlay) {
                // Close the opposite side
                this.isOpen = false;
            }
            this.setContentPanelLocation();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoOffCanvasMenuComponent.prototype, "leftPanelWidthPx", {
        /**
         * Specify the left panel width otherwise it will default to the theme specification
         */
        set: /**
         * Specify the left panel width otherwise it will default to the theme specification
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.leftPanelWidth = Math.abs(v || DEFAULT_PANEL_WIDTH);
            this.setLeftPanelSize(this.leftPanelWidth);
            this.setContentPanelLocation();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoOffCanvasMenuComponent.prototype, "rightPanelWidthPx", {
        /**
         * Specify the right panel width otherwise it will default to the theme specification
         */
        set: /**
         * Specify the right panel width otherwise it will default to the theme specification
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.rightPanelWidth = Math.abs(v || DEFAULT_PANEL_WIDTH);
            this.setRightPanelSize(this.rightPanelWidth);
            this.setContentPanelLocation();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoOffCanvasMenuComponent.prototype, "notResponsive", {
        get: /**
         * @return {?}
         */
        function () {
            return !this.responsive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoOffCanvasMenuComponent.prototype, "setDefaultClass", {
        /**
         * [Hostbindings]
         */
        // Adds default class to host element
        get: /**
         * [Hostbindings]
         * @return {?}
         */
        // Adds default class to host element
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.responsive) {
            // Need to add this class before rendering
            this.r.addClass(this.el, 'not-responsive');
        }
        this.onWindowResize();
    };
    /**
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.setLeftPanelSize(this.leftPanelWidth);
        this.setRightPanelSize(this.rightPanelWidth);
        this.setContentPanelLocation();
        // restore all transition properties
        this.r.removeClass(this.el, 'bento-off-canvas-menu-rendering');
    };
    /**
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.dirChangeSubscription.unsubscribe();
        this.resizeSubscription.unsubscribe();
        this.windowScrollSubscription.unsubscribe();
    };
    /**
     * Open left panel
     */
    /**
     * Open left panel
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype._toggleLeft = /**
     * Open left panel
     * @return {?}
     */
    function () {
        if (this.leftPanelRef) {
            this.isOpen = !this._isOpen;
        }
    };
    /**
     * [Toggle left(_isOpen) or right panel(_rightIsOpen)]
     */
    /**
     * [Toggle left(_isOpen) or right panel(_rightIsOpen)]
     * @param {?} side
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype._togglePanel = /**
     * [Toggle left(_isOpen) or right panel(_rightIsOpen)]
     * @param {?} side
     * @return {?}
     */
    function (side) {
        var _this = this;
        this.unsubscribeOverlayEvents();
        /** @type {?} */
        var isInitializing = this.el.classList.contains('bento-off-canvas-menu-rendering');
        if (this._isOpen && side === Side.Left) {
            // Clear timeout
            clearTimeout(this._menuTimer);
            // Show panel
            this._isAsideHidden = false;
            // Subscribe to escape and overlay click events
            this.subscribeOverlayEvents();
            // Select first focusable and tabbable element (close button)
            this._menuTimer = setTimeout((/**
             * @return {?}
             */
            function () {
                if (_this._alwaysOpen || _this.hideOverlay) {
                    _this.leftTrapFocus.enabled = false;
                }
                if (!isInitializing) {
                    // Only focus when this component is not initially rendering
                    _this.focusFirstTabbableElement(_this.leftPanelRef.nativeElement);
                }
                _this.cd.markForCheck();
            }), this._animationDuration);
        }
        else if (!this._isOpen) {
            // Close panel, reset focus to original trigger
            this._menuTimer = setTimeout((/**
             * @return {?}
             */
            function () {
                if (!_this._alwaysOpen) {
                    _this._isAsideHidden = true;
                    _this.cd.markForCheck();
                }
            }), this._animationDuration);
        }
        if (this._rightIsOpen && side === Side.Right) {
            this.lastActiveElement = (/** @type {?} */ (this.document.activeElement));
            // Clear timeout
            clearTimeout(this._rightMenuTimer);
            // Show panel
            this._isRightAsideHidden = false;
            // Subscribe to escape and overlay click events
            this.subscribeOverlayEvents();
            // Select first focusable and tabbable element
            this._rightMenuTimer = setTimeout((/**
             * @return {?}
             */
            function () {
                if (_this.hideOverlay) {
                    _this.rightTrapFocus.enabled = false;
                }
                if (!isInitializing) {
                    // Only focus when this component is not initially rendering
                    _this.focusFirstTabbableElement(_this.rightPanelRef.nativeElement);
                }
                _this.cd.markForCheck();
            }), this._animationDuration);
        }
        else if (!this._rightIsOpen) {
            // Close panel, reset focus to original trigger
            this._rightMenuTimer = setTimeout((/**
             * @return {?}
             */
            function () {
                var _a;
                _this._isRightAsideHidden = true;
                _this.cd.markForCheck();
                (_a = _this.lastActiveElement) === null || _a === void 0 ? void 0 : _a.focus();
                _this.lastActiveElement = null;
            }), this._animationDuration);
        }
    };
    /**
     * [Unsubscribe from user interaction events for closing panel]
     */
    /**
     * [Unsubscribe from user interaction events for closing panel]
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.unsubscribeOverlayEvents = /**
     * [Unsubscribe from user interaction events for closing panel]
     * @return {?}
     */
    function () {
        // [Unsubscribe from window overlay click events]
        if (this._windowClickSubscription) {
            this._windowClickSubscription.unsubscribe();
        }
        // [Unsubscribe from escape key press events]
        if (this._windowESCSubscription) {
            this._windowESCSubscription.unsubscribe();
        }
    };
    /**
     * [Subscribe to user interaction events for closing panel]
     */
    /**
     * [Subscribe to user interaction events for closing panel]
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.subscribeOverlayEvents = /**
     * [Subscribe to user interaction events for closing panel]
     * @return {?}
     */
    function () {
        var _this = this;
        // [Subscribe to window overlay click events]
        this._windowClickSubscription = fromEvent(window, 'click')
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        function (event) { return event.target === _this.overlay.nativeElement; })))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.isOpen = false;
            _this.rightIsOpen = false;
        }));
        // [Subscribe to escape key press events]
        this._windowESCSubscription = fromEvent(window, 'keydown')
            .pipe(filter((/**
         * @param {?} e
         * @return {?}
         */
        function (e) { return e.keyCode === Keyboard.ESC; })))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.isOpen = false;
            _this.rightIsOpen = false;
        }));
    };
    /**
     * [Set focus on first focusable and tabbable element ]
     */
    /**
     * [Set focus on first focusable and tabbable element ]
     * @private
     * @param {?} panel
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.focusFirstTabbableElement = /**
     * [Set focus on first focusable and tabbable element ]
     * @private
     * @param {?} panel
     * @return {?}
     */
    function (panel) {
        var _a;
        /** @type {?} */
        var tabbables = this.tabService.findTabbable(panel);
        // Pass focus onto close button or first tabbable element, first and last are the focus trap anchors
        (_a = tabbables[0]) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @private
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.onWindowResize = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.platform.isBrowser && this.responsive) {
            // Make sure that this is running in a browser
            /** @type {?} */
            var win = this.winRef.nativeWindow;
            /** @type {?} */
            var windowWidth = win.innerWidth;
            if (windowWidth > 1300) {
                if (!this._alwaysOpen) {
                    // set always open
                    this._alwaysOpen = true;
                    this.isOpen = true;
                }
            }
            else if (this._alwaysOpen) {
                this._alwaysOpen = false;
                this.isOpen = false;
                this.cd.markForCheck();
            }
        }
    };
    /**
     * @private
     * @param {?} v
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.setLeftPanelSize = /**
     * @private
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this.setPanelSize('left', v);
    };
    /**
     * @private
     * @param {?} v
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.setRightPanelSize = /**
     * @private
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this.setPanelSize('right', v);
    };
    /**
     * Set panel size based on its given side
     */
    /**
     * Set panel size based on its given side
     * @private
     * @param {?} side
     * @param {?} v
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.setPanelSize = /**
     * Set panel size based on its given side
     * @private
     * @param {?} side
     * @param {?} v
     * @return {?}
     */
    function (side, v) {
        /** @type {?} */
        var oppositeSide = side === 'right' ? 'left' : 'right';
        /** @type {?} */
        var panelRef = this[side + "PanelRef"].nativeElement;
        /** @type {?} */
        var panelWrapperRef = this[side + "PanelWrapperRef"].nativeElement;
        if (panelRef && v) {
            if (v > 0) {
                // Set manual size
                this.r.setAttribute(panelRef, 'style', "width:" + v + "px; " + (this._isRTL ? oppositeSide : side) + ":-" + v + "px");
                this.r.setAttribute(panelWrapperRef, 'style', "width:" + v + "px;");
            }
            else {
                this.r.removeAttribute(panelRef, 'style');
                this.r.removeAttribute(panelWrapperRef, 'style');
            }
        }
    };
    /**
     * Set content panel location and offset based on current status
     */
    /**
     * Set content panel location and offset based on current status
     * @private
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.setContentPanelLocation = /**
     * Set content panel location and offset based on current status
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        var _a;
        if (this.content.nativeElement) {
            // Set content panel and overlay location when available
            /** @type {?} */
            var style = '';
            /** @type {?} */
            var left = this._isRTL ? 'right' : 'left';
            /** @type {?} */
            var right = this._isRTL ? 'left' : 'right';
            /** @type {?} */
            var offset = void 0;
            /** @type {?} */
            var margin = void 0;
            if (this._isOpen && this.leftPanelRef) {
                offset = this.mode == 'over' ? 0 : this.leftPanelWidth;
                margin = this.calcRightMargin(this.leftPanelWidth);
                style = left + ":" + offset + "px; " + right + ":" + margin + "px";
            }
            else if (this._rightIsOpen && this.rightPanelRef) {
                offset = this.mode == 'over' ? 0 : this.rightPanelWidth;
                margin = this.calcLeftMargin(this.rightPanelWidth);
                style = right + ":" + offset + "px; " + left + ":" + margin + "px";
            }
            if (!margin && !offset) {
                if (this.el.style.overflow) {
                    // Content is filling up the viewport
                    // No need to adjust overflow
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this.r.removeStyle(_this.el, 'overflow');
                    }), 200);
                }
            }
            else if (!this.hideOverlay) {
                this.r.setStyle(this.el, 'overflow', 'hidden');
            }
            this.r.setAttribute(this.content.nativeElement, 'style', style);
            this.r.setAttribute(this.overlay.nativeElement, 'style', style);
            if ((_a = this.topbar) === null || _a === void 0 ? void 0 : _a.nativeElement) {
                this.r.setAttribute(this.topbar.nativeElement, 'style', style);
            }
        }
    };
    /**
     * Calculate right margin for the main content based on current open/close condition
     */
    /**
     * Calculate right margin for the main content based on current open/close condition
     * @private
     * @param {?} panelWidth
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.calcRightMargin = /**
     * Calculate right margin for the main content based on current open/close condition
     * @private
     * @param {?} panelWidth
     * @return {?}
     */
    function (panelWidth) {
        if (this.mode === 'side' || this._alwaysOpen) {
            if (this.rightPanelRef && this._rightIsOpen) {
                return this.rightPanelRef.nativeElement.offsetWidth;
            }
            return 0;
        }
        if (this.mode === 'push') {
            return -panelWidth;
        }
        return 0;
    };
    /**
     * Calculate left margin for the main content based on current open/close condition
     */
    /**
     * Calculate left margin for the main content based on current open/close condition
     * @private
     * @param {?} panelWidth
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.calcLeftMargin = /**
     * Calculate left margin for the main content based on current open/close condition
     * @private
     * @param {?} panelWidth
     * @return {?}
     */
    function (panelWidth) {
        if (this.mode === 'side' || this._alwaysOpen) {
            if (this.leftPanelRef && (this._isOpen || this._alwaysOpen)) {
                return this.leftPanelRef.nativeElement.offsetWidth;
            }
            return 0;
        }
        if (this.mode === 'push') {
            return -panelWidth;
        }
        return 0;
    };
    /**
     * Listener to handle window scroll
     */
    /**
     * Listener to handle window scroll
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoOffCanvasMenuComponent.prototype.onWindowScroll = /**
     * Listener to handle window scroll
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        // When tooltip is set to append to body scrolling breaks
        // Adding this empty callback seems to resolve this issue
        /** @type {?} */
        var tooltips = this.tooltips.toArray();
        tooltips.forEach((/**
         * @param {?} tooltip
         * @return {?}
         */
        function (tooltip) {
            tooltip.close();
        }));
    };
    /** @nocollapse */
    BentoOffCanvasMenuComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: BentoTabService },
        { type: Renderer2 },
        { type: Platform },
        { type: BentoNotification },
        { type: Directionality },
        { type: WindowRef },
        { type: ElementRef }
    ]; };
    BentoOffCanvasMenuComponent.propDecorators = {
        isOpen: [{ type: Input }],
        mode: [{ type: Input }],
        isOpenChange: [{ type: Output }],
        hideOverlay: [{ type: Input }, { type: HostBinding, args: ['class.bento-off-canvas-menu-hide-overlay',] }],
        showRightPanelHeader: [{ type: Input }],
        rightIsOpen: [{ type: Input }],
        rightIsOpenChange: [{ type: Output }],
        menuTitle: [{ type: Input }],
        rightMenuTitle: [{ type: Input }],
        leftPanelWidthPx: [{ type: Input }],
        rightPanelWidthPx: [{ type: Input }],
        menuButtonIsHidden: [{ type: Input }],
        responsive: [{ type: Input }],
        notResponsive: [{ type: HostBinding, args: ['class.not-responsive',] }],
        setDefaultClass: [{ type: HostBinding, args: ['class.bento-off-canvas-menu',] }],
        _isOpen: [{ type: HostBinding, args: ['class.open',] }],
        _rightIsOpen: [{ type: HostBinding, args: ['class.open-right',] }],
        _isPushOver: [{ type: HostBinding, args: ['class.push-over',] }],
        _alwaysOpen: [{ type: HostBinding, args: ['class.always-open',] }],
        overlay: [{ type: ViewChild, args: ['overlay', { static: true },] }],
        leftPanelRef: [{ type: ViewChild, args: ['leftPanel', { static: true },] }],
        rightPanelRef: [{ type: ViewChild, args: ['rightPanel', { static: true },] }],
        leftPanelWrapperRef: [{ type: ViewChild, args: ['leftPanelWrapper', { static: true },] }],
        rightPanelWrapperRef: [{ type: ViewChild, args: ['rightPanelWrapper', { static: true },] }],
        content: [{ type: ViewChild, args: ['content', { static: true },] }],
        topbar: [{ type: ViewChild, args: ['topbar', { static: true },] }],
        tooltips: [{ type: ViewChildren, args: [NgbTooltip,] }],
        leftTrapFocus: [{ type: ViewChild, args: ['leftPanelFocus', { read: CdkTrapFocus },] }],
        rightTrapFocus: [{ type: ViewChild, args: ['rightPanelFocus', { read: CdkTrapFocus },] }]
    };
BentoOffCanvasMenuComponent.ɵfac = function BentoOffCanvasMenuComponent_Factory(t) { return new (t || BentoOffCanvasMenuComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(BentoTabService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Platform), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoOffCanvasMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoOffCanvasMenuComponent, selectors: [["bento-off-canvas-menu"]], viewQuery: function BentoOffCanvasMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c27, true);
        ɵngcc0.ɵɵstaticViewQuery(_c36, true);
        ɵngcc0.ɵɵstaticViewQuery(_c37, true);
        ɵngcc0.ɵɵstaticViewQuery(_c38, true);
        ɵngcc0.ɵɵstaticViewQuery(_c39, true);
        ɵngcc0.ɵɵstaticViewQuery(_c40, true);
        ɵngcc0.ɵɵstaticViewQuery(_c41, true);
        ɵngcc0.ɵɵviewQuery(_c42, true, CdkTrapFocus);
        ɵngcc0.ɵɵviewQuery(_c43, true, CdkTrapFocus);
        ɵngcc0.ɵɵviewQuery(NgbTooltip, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlay = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.leftPanelRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rightPanelRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.leftPanelWrapperRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rightPanelWrapperRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.topbar = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.leftTrapFocus = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rightTrapFocus = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tooltips = _t);
    } }, hostVars: 14, hostBindings: function BentoOffCanvasMenuComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bento-off-canvas-menu-hide-overlay", ctx.hideOverlay)("open", ctx._isOpen)("open-right", ctx._rightIsOpen)("push-over", ctx._isPushOver)("always-open", ctx._alwaysOpen)("not-responsive", ctx.notResponsive)("bento-off-canvas-menu", ctx.setDefaultClass);
    } }, inputs: { mode: "mode", hideOverlay: "hideOverlay", showRightPanelHeader: "showRightPanelHeader", menuButtonIsHidden: "menuButtonIsHidden", responsive: "responsive", isOpen: "isOpen", rightIsOpen: "rightIsOpen", leftPanelWidthPx: "leftPanelWidthPx", rightPanelWidthPx: "rightPanelWidthPx", menuTitle: "menuTitle", rightMenuTitle: "rightMenuTitle" }, outputs: { isOpenChange: "isOpenChange", rightIsOpenChange: "rightIsOpenChange" }, ngContentSelectors: _c45, decls: 20, vars: 6, consts: [[1, "bento-off-canvas-menu-topbar", 3, "ngClass"], ["topbar", ""], ["class", "bento-off-canvas-menu-button", "type", "button", 3, "click", 4, "ngIf"], [1, "bento-off-canvas-menu-aside-wrapper"], ["leftPanelWrapper", ""], ["role", "region", "tabindex", "-1", 1, "bento-off-canvas-menu-aside"], ["leftPanel", ""], ["cdkTrapFocus", "", 3, "cdkTrapFocusAutoCapture", 4, "ngIf"], [1, "bento-off-canvas-menu-aside-bg"], [1, "bento-off-canvas-menu-aside-right-wrapper"], ["rightPanelWrapper", ""], ["role", "region", 1, "bento-off-canvas-menu-aside-right"], ["rightPanel", ""], ["cdkTrapFocus", "", 4, "ngIf"], [1, "bento-off-canvas-menu-content"], ["content", ""], [1, "bento-off-canvas-menu-content-overlay"], ["overlay", ""], ["type", "button", 1, "bento-off-canvas-menu-button", 3, "click"], ["aria-hidden", "true", 1, "bento-icon-hamburger-menu"], ["cdkTrapFocus", "", 3, "cdkTrapFocusAutoCapture"], ["leftPanelFocus", ""], [1, "bento-off-canvas-menu-header"], ["class", "bento-off-canvas-menu-close-button", "type", "button", "cdkMonitorElementFocus", "", "container", "body", 3, "ngbTooltip", "placement", "click", 4, "ngIf"], [1, "h5", "bento-off-canvas-menu-header-title"], ["leftPanelTitle", ""], ["type", "button", "cdkMonitorElementFocus", "", "container", "body", 1, "bento-off-canvas-menu-close-button", 3, "ngbTooltip", "placement", "click"], ["cdkTrapFocus", ""], ["rightPanelFocus", ""], ["class", "bento-off-canvas-menu-header", 4, "ngIf"], ["rightPanelTitle", ""]], template: function BentoOffCanvasMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c44);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, BentoOffCanvasMenuComponent_button_2_Template, 3, 3, "button", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3, 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5, 6);
        ɵngcc0.ɵɵtemplate(8, BentoOffCanvasMenuComponent_div_8_Template, 9, 6, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "div", 9, 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11, 12);
        ɵngcc0.ɵɵtemplate(14, BentoOffCanvasMenuComponent_div_14_Template, 4, 1, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 14, 15);
        ɵngcc0.ɵɵprojection(17, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(18, "div", 16, 17);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.menuButtonIsHidden ? "menu-button-is-hidden " : "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.menuButtonIsHidden);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵattribute("aria-expanded", ctx._isOpen);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx._isAsideHidden);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵattribute("aria-expanded", !ctx._isRightAsideHidden);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx._isRightAsideHidden);
    } }, directives: [ɵngcc7.NgClass, ɵngcc7.NgIf, ɵngcc1.CdkTrapFocus, ɵngcc1.CdkMonitorFocus, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective], pipes: [BentoTranslatePipe], styles: ["body.bento-off-canvas-menu-bg-color,html.bento-off-canvas-menu-bg-color{height:100%;margin:0;padding:0;position:relative}.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-color,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-right,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-right,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-content,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-content-overlay,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-topbar{transition:none!important}bento-off-canvas-menu{position:absolute;left:0;right:0;top:0;bottom:0;-webkit-overflow-scrolling:touch}bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar{width:auto}bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:24px}[dir=rtl] bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:auto;right:24px}bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-content-overlay{opacity:0}bento-off-canvas-menu>.bento-off-canvas-menu-topbar{position:absolute;left:0;top:0;right:0;box-shadow:0 0 10px 0 rgba(0,0,0,.2)}bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:0}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:auto;margin-right:0}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left{left:0}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left,bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:auto;right:0}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:0;right:auto}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{line-height:normal;padding:15px 15px 13px;box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;display:block;margin-top:0;float:left}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{float:right}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .btn-group{white-space:normal;font-size:1em}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .triangle-down{margin:5px 0 2px 4px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top-width:5px;border-top-style:solid;display:inline-block}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{text-transform:uppercase;padding-right:20px}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{padding-right:0;padding-left:20px}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;border:none;cursor:pointer;font-size:1.786rem;padding:0;opacity:.7;transition:.2s}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{left:auto;right:0}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:focus,bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:hover{opacity:1}bento-off-canvas-menu .bento-off-canvas-menu-header{border-bottom-width:1px;border-bottom-style:solid;position:absolute;left:0;top:0;width:100%;font-size:1.286rem;text-transform:uppercase;display:block}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-header{left:auto;right:0}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:right;margin-left:auto;margin-right:19px}bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:left;margin-left:19px;margin-top:25px;font-size:12px}bento-off-canvas-menu button.bento-off-canvas-menu-close-button{border:none;text-align:center;font-size:1rem;float:right;margin:0;transition:background-color .2s}[dir=rtl] bento-off-canvas-menu button.bento-off-canvas-menu-close-button{float:left}bento-off-canvas-menu .bento-off-canvas-menu-aside-right:focus,bento-off-canvas-menu .bento-off-canvas-menu-aside:focus,bento-off-canvas-menu button.bento-off-canvas-menu-close-button:focus{outline:0}bento-off-canvas-menu .bento-off-canvas-menu-aside hr{border-top-width:1px;border-top-style:solid;border-bottom:none;margin:0}bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right,bento-off-canvas-menu .bento-off-canvas-menu-aside-right{position:inherit;top:0;padding:0 0 40px;box-sizing:border-box;text-align:center;-webkit-box-sizing:border-box}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-right{right:auto}bento-off-canvas-menu .bento-off-canvas-menu-aside,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{position:absolute;top:0;box-sizing:border-box;text-align:center;-webkit-box-sizing:border-box}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}bento-off-canvas-menu .bento-off-canvas-menu-aside button,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button{margin-top:20px}bento-off-canvas-menu .bento-off-canvas-menu-aside button.bento-off-canvas-menu-close-button,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button.bento-off-canvas-menu-close-button{margin-top:0}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a:first-child,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a:first-child{border-top-style:solid;border-top-width:1px;border-bottom-style:solid;border-bottom-width:1px;margin-top:-1px;padding:18px 20px 16px 15px;width:100%}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li:last-child>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li:last-child>a{border-bottom:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a{position:relative}bento-off-canvas-menu .bento-off-canvas-menu-aside a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a{padding:8px 20px 0;display:block;font-size:.9em}bento-off-canvas-menu .bento-off-canvas-menu-aside a.menu-icon:hover,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a.menu-icon:hover{text-decoration:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{padding:0;margin:0;text-align:left;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{text-align:right}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta{margin-top:10px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li{padding:0 19px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a{padding:5px 19px;font-size:1em;border:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a:hover,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a:hover{text-decoration:underline}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li:last-child,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li:last-child{margin-bottom:10px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li{padding:0;margin:0;position:relative}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a{display:block;line-height:20px;font-size:1.286rem}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{padding:0;position:absolute;right:20px;min-width:20px;text-align:center;top:22px}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{right:auto;left:20px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a{z-index:2}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{content:\"\";display:block;position:absolute;width:5px;left:0;top:0;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{left:auto;right:0;border-right:none;border-left-width:1px;border-left-style:solid}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled],bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]{pointer-events:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]>a{cursor:default}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]:hover>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]:hover>a{background:0 0}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu>li:last-child,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu>li:last-child{border-bottom:none}bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{height:100%}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{height:100%}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{right:auto}bento-off-canvas-menu .bento-off-canvas-menu-content-overlay{z-index:-1000;position:absolute;opacity:0;left:0;right:0;bottom:0}bento-off-canvas-menu .bento-off-canvas-menu-content{position:absolute;left:0;right:0;padding:20px 20px 40px}bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-right-wapper .bento-off-canvas-menu-aside-right,bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside{overflow-y:auto;bottom:0}bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right,bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right{right:0!important}[dir=rtl] bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right,[dir=rtl] bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right{left:0!important;right:auto!important}bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{box-shadow:0 0 20px 0 rgba(0,0,0,.5)}[dir=rtl] bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content{left:auto}bento-off-canvas-menu.open-right.push-over{overflow-y:hidden}bento-off-canvas-menu.open-right.push-over>.bento-off-canvas-menu-content-overlay{top:0}bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color,bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside{left:0!important}[dir=rtl] bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color,[dir=rtl] bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside{left:auto!important;right:0!important}bento-off-canvas-menu.open>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{box-shadow:0 0 20px 0 rgba(0,0,0,.5)}bento-off-canvas-menu.open.push-over{overflow-y:hidden}bento-off-canvas-menu.open.push-over>.bento-off-canvas-menu-content-overlay{top:0}.bento-off-canvas-menu-aside-right-wrapper,.bento-off-canvas-menu-aside-wrapper{bottom:0;position:absolute;top:0;width:0;transition:width .2s;overflow:hidden}.bento-off-canvas-menu-aside-right-wrapper,[dir=rtl] .bento-off-canvas-menu-aside-wrapper{right:0}.bento-off-canvas-menu-aside-wrapper,[dir=rtl] .bento-off-canvas-menu-aside-right-wrapper{left:0}@media only screen and (min-width:1305px){bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar{padding:0}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:none}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{box-shadow:inset -15px 0 20px -20px #000;left:0}[dir=rtl] bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{left:auto;right:0}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;transition:none}[dir=rtl] bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{left:auto}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{right:0;width:auto}[dir=rtl] bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{left:auto}bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;left:auto;right:100%}[dir=rtl] bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{left:100%;right:auto}bento-off-canvas-menu:not(.not-responsive).open:not(.open-right) .bento-off-canvas-menu-content-overlay{display:none}}@media only screen and (max-width:1199px){.hide-on-ipad{display:none}bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{padding:0 15px;margin-left:-1px;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid;float:left}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{float:right;margin-left:0;margin-right:-1px}bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item:last-child{padding:0 15px;border-right:none}}bento-off-canvas-menu [bento-off-canvas-menu-content]>.global-subnav{margin:-20px -20px 20px;display:block;width:auto}.bento-off-canvas-menu-hide-overlay .bento-off-canvas-menu-content-overlay{display:none}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoOffCanvasMenuComponent, [{
        type: Component,
        args: [{
                selector: 'bento-off-canvas-menu',
                template: "<div #topbar class=\"bento-off-canvas-menu-topbar\" [ngClass]=\"menuButtonIsHidden ? 'menu-button-is-hidden ' : ''\">\n  <button\n    *ngIf=\"!menuButtonIsHidden\"\n    class=\"bento-off-canvas-menu-button\"\n    type=\"button\"\n    (click)=\"_toggleLeft()\"\n    [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_OPEN_BUTTON' | bentoTranslate\"\n  >\n    <i class=\"bento-icon-hamburger-menu\" aria-hidden=\"true\"></i>\n  </button>\n  <ng-content select=\"[bento-off-canvas-menu-topbar]\"></ng-content>\n</div>\n<div #leftPanelWrapper class=\"bento-off-canvas-menu-aside-wrapper\">\n  <div #leftPanel role=\"region\" [attr.aria-expanded]=\"_isOpen\" tabindex=\"-1\" class=\"bento-off-canvas-menu-aside\">\n    <div #leftPanelFocus cdkTrapFocus [cdkTrapFocusAutoCapture]=\"!_alwaysOpen\" *ngIf=\"!_isAsideHidden\">\n      <!-- cdkFocusInitial -->\n      <div class=\"bento-off-canvas-menu-header\">\n        <button\n          class=\"bento-off-canvas-menu-close-button\"\n          type=\"button\"\n          *ngIf=\"!_alwaysOpen\"\n          cdkMonitorElementFocus\n          (click)=\"isOpen = false\"\n          [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          container=\"body\"\n          [placement]=\"_isRTL ? 'right' : 'left'\"\n        ></button>\n        <h2 #leftPanelTitle class=\"h5 bento-off-canvas-menu-header-title\">\n          {{ 'BENTO_UI_OFF_CANVAS_MENU_ASIDE_TITLE ' | bentoTranslate: menuTitle }}\n        </h2>\n      </div>\n      <ng-content select=\"[bento-off-canvas-menu-aside]\"></ng-content>\n    </div>\n  </div>\n</div>\n<div class=\"bento-off-canvas-menu-aside-bg\"></div>\n<div #rightPanelWrapper class=\"bento-off-canvas-menu-aside-right-wrapper\">\n  <div #rightPanel role=\"region\" class=\"bento-off-canvas-menu-aside-right\" [attr.aria-expanded]=\"!_isRightAsideHidden\">\n    <div #rightPanelFocus *ngIf=\"!_isRightAsideHidden\" cdkTrapFocus>\n      <div class=\"bento-off-canvas-menu-header\" *ngIf=\"this.showRightPanelHeader\">\n        <button\n          class=\"bento-off-canvas-menu-close-button\"\n          type=\"button\"\n          cdkMonitorElementFocus\n          (click)=\"rightIsOpen = false\"\n          [attr.aria-label]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          [ngbTooltip]=\"'BENTO_UI_OFF_CANVAS_MENU_CLOSE_BUTTON' | bentoTranslate\"\n          container=\"body\"\n          [placement]=\"_isRTL ? 'right' : 'left'\"\n        ></button>\n        <h2 #rightPanelTitle class=\"h5 bento-off-canvas-menu-header-title\">\n          {{ 'BENTO_UI_OFF_CANVAS_MENU_RIGHT_ASIDE_TITLE' | bentoTranslate: rightMenuTitle }}\n        </h2>\n      </div>\n      <ng-content select=\"[bento-off-canvas-menu-aside-right]\"></ng-content>\n    </div>\n  </div>\n</div>\n\n<div #content class=\"bento-off-canvas-menu-content\">\n  <ng-content select=\"[bento-off-canvas-menu-content]\"></ng-content>\n</div>\n<div #overlay class=\"bento-off-canvas-menu-content-overlay\"></div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["body.bento-off-canvas-menu-bg-color,html.bento-off-canvas-menu-bg-color{height:100%;margin:0;padding:0;position:relative}.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-color,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-bg-right,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-aside-right,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-content,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-content-overlay,.bento-off-canvas-menu-rendering .bento-off-canvas-menu-topbar{transition:none!important}bento-off-canvas-menu{position:absolute;left:0;right:0;top:0;bottom:0;-webkit-overflow-scrolling:touch}bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar{width:auto}bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:24px}[dir=rtl] bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-topbar .global-header .topbar-left{left:auto;right:24px}bento-off-canvas-menu.always-open.open .bento-off-canvas-menu-content-overlay{opacity:0}bento-off-canvas-menu>.bento-off-canvas-menu-topbar{position:absolute;left:0;top:0;right:0;box-shadow:0 0 10px 0 rgba(0,0,0,.2)}bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:0}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar>.bento-off-canvas-menu-button+[bento-off-canvas-menu-topbar] .global-header-text .topbar-left{margin-left:auto;margin-right:0}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left{left:0}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .global-header .topbar-left,bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:auto;right:0}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .pull-right ul.dropdown-menu{left:0;right:auto}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{line-height:normal;padding:15px 15px 13px;box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;display:block;margin-top:0;float:left}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item{float:right}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .btn-group{white-space:normal;font-size:1em}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .item .triangle-down{margin:5px 0 2px 4px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top-width:5px;border-top-style:solid;display:inline-block}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{text-transform:uppercase;padding-right:20px}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .logo{padding-right:0;padding-left:20px}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;border:none;cursor:pointer;font-size:1.786rem;padding:0;opacity:.7;transition:.2s}[dir=rtl] bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{left:auto;right:0}bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:focus,bento-off-canvas-menu>.bento-off-canvas-menu-topbar .bento-off-canvas-menu-button:hover{opacity:1}bento-off-canvas-menu .bento-off-canvas-menu-header{border-bottom-width:1px;border-bottom-style:solid;position:absolute;left:0;top:0;width:100%;font-size:1.286rem;text-transform:uppercase;display:block}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-header{left:auto;right:0}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:right;margin-left:auto;margin-right:19px}bento-off-canvas-menu .bento-off-canvas-menu-header>h2{float:left;margin-left:19px;margin-top:25px;font-size:12px}bento-off-canvas-menu button.bento-off-canvas-menu-close-button{border:none;text-align:center;font-size:1rem;float:right;margin:0;transition:background-color .2s}[dir=rtl] bento-off-canvas-menu button.bento-off-canvas-menu-close-button{float:left}bento-off-canvas-menu .bento-off-canvas-menu-aside-right:focus,bento-off-canvas-menu .bento-off-canvas-menu-aside:focus,bento-off-canvas-menu button.bento-off-canvas-menu-close-button:focus{outline:0}bento-off-canvas-menu .bento-off-canvas-menu-aside hr{border-top-width:1px;border-top-style:solid;border-bottom:none;margin:0}bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right,bento-off-canvas-menu .bento-off-canvas-menu-aside-right{position:inherit;top:0;padding:0 0 40px;box-sizing:border-box;text-align:center;-webkit-box-sizing:border-box}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-right{right:auto}bento-off-canvas-menu .bento-off-canvas-menu-aside,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{position:absolute;top:0;box-sizing:border-box;text-align:center;-webkit-box-sizing:border-box}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}bento-off-canvas-menu .bento-off-canvas-menu-aside button,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button{margin-top:20px}bento-off-canvas-menu .bento-off-canvas-menu-aside button.bento-off-canvas-menu-close-button,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color button.bento-off-canvas-menu-close-button{margin-top:0}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a:first-child,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a:first-child{border-top-style:solid;border-top-width:1px;border-bottom-style:solid;border-bottom-width:1px;margin-top:-1px;padding:18px 20px 16px 15px;width:100%}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li:last-child>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li:last-child>a{border-bottom:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a{position:relative}bento-off-canvas-menu .bento-off-canvas-menu-aside a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a{padding:8px 20px 0;display:block;font-size:.9em}bento-off-canvas-menu .bento-off-canvas-menu-aside a.menu-icon:hover,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color a.menu-icon:hover{text-decoration:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{padding:0;margin:0;text-align:left;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul{text-align:right}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta{margin-top:10px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li{padding:0 19px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a{padding:5px 19px;font-size:1em;border:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li>a:hover,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li>a:hover{text-decoration:underline}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.meta li:last-child,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.meta li:last-child{margin-bottom:10px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li{padding:0;margin:0;position:relative}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a{display:block;line-height:20px;font-size:1.286rem}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{padding:0;position:absolute;right:20px;min-width:20px;text-align:center;top:22px}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li>a.menu-icon,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li>a.menu-icon{right:auto;left:20px}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a,bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a{z-index:2}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{content:\"\";display:block;position:absolute;width:5px;left:0;top:0;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.active>a:first-child:before,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li.selected>a:first-child:before,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.active>a:first-child:before,[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li.selected>a:first-child:before{left:auto;right:0;border-right:none;border-left-width:1px;border-left-style:solid}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled],bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]{pointer-events:none}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]>a{cursor:default}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu li[disabled=disabled]:hover>a,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu li[disabled=disabled]:hover>a{background:0 0}bento-off-canvas-menu .bento-off-canvas-menu-aside ul.menu>li:last-child,bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color ul.menu>li:last-child{border-bottom:none}bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{height:100%}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-color{left:auto}bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{height:100%}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-aside-bg-right{right:auto}bento-off-canvas-menu .bento-off-canvas-menu-content-overlay{z-index:-1000;position:absolute;opacity:0;left:0;right:0;bottom:0}bento-off-canvas-menu .bento-off-canvas-menu-content{position:absolute;left:0;right:0;padding:20px 20px 40px}bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-right-wapper .bento-off-canvas-menu-aside-right,bento-off-canvas-menu.push-over:not(.position-static)>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside{overflow-y:auto;bottom:0}bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right,bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right{right:0!important}[dir=rtl] bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right,[dir=rtl] bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-right-wrapper .bento-off-canvas-menu-aside-right{left:0!important;right:auto!important}bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}bento-off-canvas-menu.open-right>.bento-off-canvas-menu-aside-bg-right{box-shadow:0 0 20px 0 rgba(0,0,0,.5)}[dir=rtl] bento-off-canvas-menu.open-right>.bento-off-canvas-menu-content{left:auto}bento-off-canvas-menu.open-right.push-over{overflow-y:hidden}bento-off-canvas-menu.open-right.push-over>.bento-off-canvas-menu-content-overlay{top:0}bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color,bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside{left:0!important}[dir=rtl] bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color,[dir=rtl] bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-wrapper .bento-off-canvas-menu-aside{left:auto!important;right:0!important}bento-off-canvas-menu.open>.bento-off-canvas-menu-content-overlay{width:100%;opacity:.5}bento-off-canvas-menu.open>.bento-off-canvas-menu-aside-bg-color{box-shadow:0 0 20px 0 rgba(0,0,0,.5)}bento-off-canvas-menu.open.push-over{overflow-y:hidden}bento-off-canvas-menu.open.push-over>.bento-off-canvas-menu-content-overlay{top:0}.bento-off-canvas-menu-aside-right-wrapper,.bento-off-canvas-menu-aside-wrapper{bottom:0;position:absolute;top:0;width:0;transition:width .2s;overflow:hidden}.bento-off-canvas-menu-aside-right-wrapper,[dir=rtl] .bento-off-canvas-menu-aside-wrapper{right:0}.bento-off-canvas-menu-aside-wrapper,[dir=rtl] .bento-off-canvas-menu-aside-right-wrapper{left:0}@media only screen and (min-width:1305px){bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar{padding:0}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-topbar .bento-off-canvas-menu-button{display:none}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{box-shadow:inset -15px 0 20px -20px #000;left:0}[dir=rtl] bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside{left:auto;right:0}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;transition:none}[dir=rtl] bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-aside-bg-color{left:auto}bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{right:0;width:auto}[dir=rtl] bento-off-canvas-menu:not(.not-responsive) .bento-off-canvas-menu-content{left:auto}bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{box-shadow:inset -15px 0 20px -20px #000;left:auto;right:100%}[dir=rtl] bento-off-canvas-menu:not(.not-responsive).open .bento-off-canvas-menu-aside-bg-color{left:100%;right:auto}bento-off-canvas-menu:not(.not-responsive).open:not(.open-right) .bento-off-canvas-menu-content-overlay{display:none}}@media only screen and (max-width:1199px){.hide-on-ipad{display:none}bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{padding:0 15px;margin-left:-1px;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid;float:left}[dir=rtl] bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item{float:right;margin-left:0;margin-right:-1px}bento-off-canvas-menu .bento-off-canvas-menu-topbar .pull-right .item:last-child{padding:0 15px;border-right:none}}bento-off-canvas-menu [bento-off-canvas-menu-content]>.global-subnav{margin:-20px -20px 20px;display:block;width:auto}.bento-off-canvas-menu-hide-overlay .bento-off-canvas-menu-content-overlay{display:none}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: BentoTabService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc3.Platform }, { type: BentoNotification }, { type: ɵngcc6.Directionality }, { type: WindowRef }, { type: ɵngcc0.ElementRef }]; }, { mode: [{
            type: Input
        }], isOpenChange: [{
            type: Output
        }], hideOverlay: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.bento-off-canvas-menu-hide-overlay']
        }], showRightPanelHeader: [{
            type: Input
        }], rightIsOpenChange: [{
            type: Output
        }], menuButtonIsHidden: [{
            type: Input
        }], responsive: [{
            type: Input
        }], _isOpen: [{
            type: HostBinding,
            args: ['class.open']
        }], _rightIsOpen: [{
            type: HostBinding,
            args: ['class.open-right']
        }], _isPushOver: [{
            type: HostBinding,
            args: ['class.push-over']
        }], _alwaysOpen: [{
            type: HostBinding,
            args: ['class.always-open']
        }], isOpen: [{
            type: Input
        }], rightIsOpen: [{
            type: Input
        }], leftPanelWidthPx: [{
            type: Input
        }], rightPanelWidthPx: [{
            type: Input
        }], notResponsive: [{
            type: HostBinding,
            args: ['class.not-responsive']
        }], setDefaultClass: [{
            type: HostBinding,
            args: ['class.bento-off-canvas-menu']
        }], menuTitle: [{
            type: Input
        }], rightMenuTitle: [{
            type: Input
        }], overlay: [{
            type: ViewChild,
            args: ['overlay', { static: true }]
        }], leftPanelRef: [{
            type: ViewChild,
            args: ['leftPanel', { static: true }]
        }], rightPanelRef: [{
            type: ViewChild,
            args: ['rightPanel', { static: true }]
        }], leftPanelWrapperRef: [{
            type: ViewChild,
            args: ['leftPanelWrapper', { static: true }]
        }], rightPanelWrapperRef: [{
            type: ViewChild,
            args: ['rightPanelWrapper', { static: true }]
        }], content: [{
            type: ViewChild,
            args: ['content', { static: true }]
        }], topbar: [{
            type: ViewChild,
            args: ['topbar', { static: true }]
        }], tooltips: [{
            type: ViewChildren,
            args: [NgbTooltip]
        }], leftTrapFocus: [{
            type: ViewChild,
            args: ['leftPanelFocus', { read: CdkTrapFocus }]
        }], rightTrapFocus: [{
            type: ViewChild,
            args: ['rightPanelFocus', { read: CdkTrapFocus }]
        }] }); })();
    return BentoOffCanvasMenuComponent;
}());
if (false) {
    /**
     * Defines how side nav behaves when it shows
     * * `'over'` Side nav comes in and overlaps the content
     * * `'push'` Side nav comes in and pushes the content to the other side without resizing
     * * `'side'` Side nav comes in and resize the main content so that both contents are visible
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.mode;
    /**
     * Emits when `isOpen` is changed
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.isOpenChange;
    /**
     * Flag to determine if the overlay is hidden when a side panel is out
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.hideOverlay;
    /**
     * Flag to determine if the right panel header and close button should be shown
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.showRightPanelHeader;
    /**
     * Emits when `rightIsOpen` is changed
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.rightIsOpenChange;
    /**
     * Text to override the default left panel title
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.menuTitle;
    /**
     * Text to override the default right panel title
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.rightMenuTitle;
    /**
     * Hide/Show Hamburger menu button
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.menuButtonIsHidden;
    /** @type {?} */
    BentoOffCanvasMenuComponent.prototype._isAsideHidden;
    /** @type {?} */
    BentoOffCanvasMenuComponent.prototype._isRightAsideHidden;
    /** @type {?} */
    BentoOffCanvasMenuComponent.prototype._isRTL;
    /**
     * Flag to determine if this component is responsive to window size
     * @type {?}
     */
    BentoOffCanvasMenuComponent.prototype.responsive;
    /** @type {?} */
    BentoOffCanvasMenuComponent.prototype._isOpen;
    /** @type {?} */
    BentoOffCanvasMenuComponent.prototype._rightIsOpen;
    /** @type {?} */
    BentoOffCanvasMenuComponent.prototype._isPushOver;
    /** @type {?} */
    BentoOffCanvasMenuComponent.prototype._alwaysOpen;
    /**
     * [ElementReferences]
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.overlay;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.leftPanelRef;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.rightPanelRef;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.leftPanelWrapperRef;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.rightPanelWrapperRef;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.content;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.topbar;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.tooltips;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.leftTrapFocus;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.rightTrapFocus;
    /**
     * [Private variables]
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype._animationDuration;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype._windowClickSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype._windowESCSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype._menuTimer;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype._rightMenuTimer;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.lastActiveElement;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.dirChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.windowScrollSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.leftPanelWidth;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.rightPanelWidth;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.cd;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.tabService;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.platform;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.winRef;
    /**
     * @type {?}
     * @private
     */
    BentoOffCanvasMenuComponent.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/off-canvas-menu/off-canvas-menu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoOffCanvasMenuModule = /** @class */ (function () {
    function BentoOffCanvasMenuModule() {
    }
BentoOffCanvasMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoOffCanvasMenuModule });
BentoOffCanvasMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoOffCanvasMenuModule_Factory(t) { return new (t || BentoOffCanvasMenuModule)(); }, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            A11yModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoOffCanvasMenuModule, { declarations: function () { return [BentoOffCanvasMenuComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        A11yModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule]; }, exports: function () { return [BentoOffCanvasMenuComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoOffCanvasMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoTranslateModule,
                    BentoUtilsModule,
                    A11yModule,
                    NgbTooltipModule,
                    BentoNgbTooltipSupportModule
                ],
                declarations: [BentoOffCanvasMenuComponent],
                exports: [BentoOffCanvasMenuComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoOffCanvasMenuModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pagination/pagination.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This minimal pagination component provides previous/next functionality, jump-to-page input,
 * and amount of items per page. The 'Go' button, 'Page 1 of 18,' and '1 to 25 of 1000 Entries' labels
 * are i18n-ready. Translations are not provided by Bento.UI, they are at the discretion of your team.
 */
var BentoPaginationComponent = /** @class */ (function () {
    function BentoPaginationComponent(elRef, bentoNotification, changeDetector) {
        var _this = this;
        this.changeDetector = changeDetector;
        this.itemsPerPage = 25;
        /**
         * Flag to display the 'go to page' input field and button
         */
        this.goToLink = true;
        /**
         * Flag to hide/display the 'items per page' select input
         */
        this.hideItemsPerPage = false;
        this.boundaryLinks = true;
        this.userSetBoundaryLinks = true;
        // String
        // Options
        /**
         * Flag to show/hide direction links
         */
        this.directionLinks = true;
        /**
         * Option for the page item number selection dropdown.  This property is **immutable**
         */
        this.itemsArray = [10, 25, 50, 100];
        /**
         * Flag to set the current page always to `1`
         */
        this.pageOverride = false;
        /**
         * Accessibility guidelines encourages to use real words for buttons instead
         * of symbols and hidden text. Use this property to use strings instead of
         * symbols (<<, <, >, >>) for pagination component.
         * component.
         * By default this will be set to false, to make your product fully accessible,
         * set this to true when using pagination component.
         */
        this.useStrings = false;
        // Callbacks
        /**
         * Callback when the current page is changed
         */
        this.pageChange = new EventEmitter();
        /**
         * Callback when items per page is changed
         */
        this.itemsPerPageChange = new EventEmitter();
        /**
         * (Experimental) Callback when an internal event is dispatched within Bento Pagination
         */
        this.eventTracking = new EventEmitter();
        // Private variables
        /**
         * Flag to set the visibility of the 'Go' button
         */
        this.goIconVisible = false;
        /**
         * Flag to set the last button margin
         */
        this.lastButtonSmallMargin = false;
        /**
         * Current max page count
         */
        this.maxPage = 2;
        /**
         * Flag to the visibility of the 'Go' button
         */
        this.goBtnVisible = true;
        /**
         * go input field model
         */
        this.paginationInputModel = undefined;
        /**
         * Variable that implements the BentoTranslatable
         */
        this.customTranslation = {};
        this.nativeElement = elRef.nativeElement;
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._checkElementWidthAndRender(); }));
    }
    Object.defineProperty(BentoPaginationComponent.prototype, "_page", {
        /**
         * Current page number
         */
        set: /**
         * Current page number
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.page = this._normalizePageNumber(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoPaginationComponent.prototype, "_totalItems", {
        /**
         * Total number of items this pagination should display
         */
        set: /**
         * Total number of items this pagination should display
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.totalItems = value;
            this.maxPage = this._getTotalPages();
            // tracking
            this.eventTracking.emit({ eventName: 'total items changed', value: value });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoPaginationComponent.prototype, "_itemsPerPage", {
        /**
         * Number of item in a page
         */
        set: /**
         * Number of item in a page
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.itemsPerPage = value;
            this.maxPage = this._getTotalPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoPaginationComponent.prototype, "_boundaryLinks", {
        /**
         * Flag to display the first and last page links (buttons)
         */
        set: /**
         * Flag to display the first and last page links (buttons)
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (typeof value !== 'undefined') {
                this.userSetBoundaryLinks = value;
            }
            this._checkElementWidthAndRender();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Use method to refresh the rendering of the component when the container's width changes or was previously
     * `display:none`. (e.g. when pagination is used in modal, tabs, dropdowns, etc...)
     */
    /**
     * Use method to refresh the rendering of the component when the container's width changes or was previously
     * `display:none`. (e.g. when pagination is used in modal, tabs, dropdowns, etc...)
     * @return {?}
     */
    BentoPaginationComponent.prototype.refresh = /**
     * Use method to refresh the rendering of the component when the container's width changes or was previously
     * `display:none`. (e.g. when pagination is used in modal, tabs, dropdowns, etc...)
     * @return {?}
     */
    function () {
        this._checkElementWidthAndRender();
    };
    /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     *
     * * BENTO_UI_PAGINATION_GO_BUTTON: 'Go',
     * * BENTO_UI_PAGINATION_INFO_PAGE_TEXT: 'Page \_PAGE\_ of \_PAGES\_',
     * * BENTO_UI_PAGINATION_INFO_TEXT: '\_START\_ to \_END\_ of \_MAX\_',
     * * BENTO_UI_PAGINATION_A11Y_FIRST: 'Go to First Page',
     * * BENTO_UI_PAGINATION_A11Y_NEXT: 'Go to Next Page',
     * * BENTO_UI_PAGINATION_A11Y_PREVIOUS: 'Go to Previous Page',
     * * BENTO_UI_PAGINATION_A11Y_LAST: 'Go to Last Page',
     * * BENTO_UI_PAGINATION_A11Y_PAGE_NUM: 'Enter Page number to go to',
     * * BENTO_UI_PAGINATION_A11Y_GOTO_PAGE: 'Go to Page',
     * * BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items Per Page',
     *
     */
    /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     *
     * * BENTO_UI_PAGINATION_GO_BUTTON: 'Go',
     * * BENTO_UI_PAGINATION_INFO_PAGE_TEXT: 'Page \_PAGE\_ of \_PAGES\_',
     * * BENTO_UI_PAGINATION_INFO_TEXT: '\_START\_ to \_END\_ of \_MAX\_',
     * * BENTO_UI_PAGINATION_A11Y_FIRST: 'Go to First Page',
     * * BENTO_UI_PAGINATION_A11Y_NEXT: 'Go to Next Page',
     * * BENTO_UI_PAGINATION_A11Y_PREVIOUS: 'Go to Previous Page',
     * * BENTO_UI_PAGINATION_A11Y_LAST: 'Go to Last Page',
     * * BENTO_UI_PAGINATION_A11Y_PAGE_NUM: 'Enter Page number to go to',
     * * BENTO_UI_PAGINATION_A11Y_GOTO_PAGE: 'Go to Page',
     * * BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items Per Page',
     *
     * @param {?} customTranslation
     * @return {?}
     */
    BentoPaginationComponent.prototype.setTranslation = /**
     * This is used to set custom translations for this component instance
     * Note: it's is used per instance basis
     * The default values used in this component are the following:
     *
     * * BENTO_UI_PAGINATION_GO_BUTTON: 'Go',
     * * BENTO_UI_PAGINATION_INFO_PAGE_TEXT: 'Page \_PAGE\_ of \_PAGES\_',
     * * BENTO_UI_PAGINATION_INFO_TEXT: '\_START\_ to \_END\_ of \_MAX\_',
     * * BENTO_UI_PAGINATION_A11Y_FIRST: 'Go to First Page',
     * * BENTO_UI_PAGINATION_A11Y_NEXT: 'Go to Next Page',
     * * BENTO_UI_PAGINATION_A11Y_PREVIOUS: 'Go to Previous Page',
     * * BENTO_UI_PAGINATION_A11Y_LAST: 'Go to Last Page',
     * * BENTO_UI_PAGINATION_A11Y_PAGE_NUM: 'Enter Page number to go to',
     * * BENTO_UI_PAGINATION_A11Y_GOTO_PAGE: 'Go to Page',
     * * BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE: 'Items Per Page',
     *
     * @param {?} customTranslation
     * @return {?}
     */
    function (customTranslation) {
        this.customTranslation = customTranslation;
        this.changeDetector.markForCheck();
    };
    /**
     * Mathod to go to a page by it's number
     */
    /**
     * Mathod to go to a page by it's number
     * @param {?} page
     * @param {?} event
     * @return {?}
     */
    BentoPaginationComponent.prototype._goToPage = /**
     * Mathod to go to a page by it's number
     * @param {?} page
     * @param {?} event
     * @return {?}
     */
    function (page, event) {
        /** @type {?} */
        var pageNum = parseInt(page, 10);
        /** @type {?} */
        var targetPage;
        /** @type {?} */
        var keyCode;
        /** @type {?} */
        var isEnter;
        if (isNaN(pageNum) || pageNum < 1) {
            // User input is incorrect
            return;
        }
        targetPage = this._normalizePageNumber(pageNum);
        if (event.type === 'keypress') {
            keyCode = event.keyCode;
            isEnter = keyCode === Keyboard.ENTER;
        }
        if (isEnter || event.type === 'click') {
            event.target.value = this.page = targetPage;
            event.stopPropagation();
            event.preventDefault();
            // reset go input field
            this.paginationInputModel = undefined;
            this.pageChange.emit(Number(this.page));
            // tracking
            this.eventTracking.emit({
                eventName: 'current page value modification',
                value: 'input value => ' + page + ' value@ ' + this.page
            });
        }
    };
    /**
     * Get start index for current page
     */
    /**
     * Get start index for current page
     * @return {?}
     */
    BentoPaginationComponent.prototype._getStartIndex = /**
     * Get start index for current page
     * @return {?}
     */
    function () {
        return (this.page - 1) * this.itemsPerPage + 1;
    };
    /**
     * Get the end index for current page
     */
    /**
     * Get the end index for current page
     * @return {?}
     */
    BentoPaginationComponent.prototype._getEndIndex = /**
     * Get the end index for current page
     * @return {?}
     */
    function () {
        return this.totalItems < this.itemsPerPage * this.page ? this.totalItems : this.itemsPerPage * this.page;
    };
    /**
     * Callback when itemsPerPage changes in the select dropdown
     */
    /**
     * Callback when itemsPerPage changes in the select dropdown
     * @param {?} itemsPerPage
     * @return {?}
     */
    BentoPaginationComponent.prototype._onItemsPerPageChange = /**
     * Callback when itemsPerPage changes in the select dropdown
     * @param {?} itemsPerPage
     * @return {?}
     */
    function (itemsPerPage) {
        this._calculatePages(itemsPerPage);
        this.itemsPerPage = itemsPerPage;
        this.maxPage = this._getTotalPages();
        this.page = 1;
        // fire callbacks
        this.itemsPerPageChange.emit(Number(itemsPerPage));
        this.pageChange.emit(Number(this.page));
        // tracking
        this.eventTracking.emit({ eventName: 'items per page changed', value: itemsPerPage });
    };
    /**
     * Calculate number of pages in total
     */
    /**
     * Calculate number of pages in total
     * @return {?}
     */
    BentoPaginationComponent.prototype._getTotalPages = /**
     * Calculate number of pages in total
     * @return {?}
     */
    function () {
        return Math.ceil(this.totalItems / this.itemsPerPage);
    };
    /**
     * Called when this component is destroyed
     */
    /**
     * Called when this component is destroyed
     * @return {?}
     */
    BentoPaginationComponent.prototype.ngOnDestroy = /**
     * Called when this component is destroyed
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
    };
    /**
     * Calculate and set the current page
     */
    /**
     * Calculate and set the current page
     * @private
     * @param {?} newItemsPerPage
     * @return {?}
     */
    BentoPaginationComponent.prototype._calculatePages = /**
     * Calculate and set the current page
     * @private
     * @param {?} newItemsPerPage
     * @return {?}
     */
    function (newItemsPerPage) {
        this.page = this.pageOverride ? 1 : Math.ceil(this._getStartIndex() / newItemsPerPage);
    };
    /**
     * Calculate and change layout responsively
     */
    /**
     * Calculate and change layout responsively
     * @private
     * @return {?}
     */
    BentoPaginationComponent.prototype._checkElementWidthAndRender = /**
     * Calculate and change layout responsively
     * @private
     * @return {?}
     */
    function () {
        if (!this.element) {
            this.element = (/** @type {?} */ (this.nativeElement.children[0]));
        }
        /** @type {?} */
        var width = this.element.offsetWidth;
        /** @type {?} */
        var selectWidth = this.hideItemsPerPage ? 160 : 0;
        if (width < 550 - selectWidth) {
            this.lastButtonSmallMargin = true;
            if (width < 468 - selectWidth) {
                this.boundaryLinks = false;
                if (width < 290 - selectWidth) {
                    this.goBtnVisible = false;
                }
                else {
                    this.goIconVisible = true;
                    this.goBtnVisible = true;
                }
            }
            else {
                this.goIconVisible = false;
                this.goBtnVisible = true;
                this.boundaryLinks = this.userSetBoundaryLinks;
            }
        }
        else {
            this.goIconVisible = false;
            this.goBtnVisible = true;
            this.boundaryLinks = this.userSetBoundaryLinks;
            this.lastButtonSmallMargin = false;
        }
        this.changeDetector.markForCheck();
    };
    /**
     * Normalize the current page number
     */
    /**
     * Normalize the current page number
     * @private
     * @param {?} page
     * @return {?}
     */
    BentoPaginationComponent.prototype._normalizePageNumber = /**
     * Normalize the current page number
     * @private
     * @param {?} page
     * @return {?}
     */
    function (page) {
        /** @type {?} */
        var numPages = this._getTotalPages();
        /** @type {?} */
        var targetPage = page > numPages ? numPages : page;
        targetPage = targetPage < -1 ? 1 : targetPage;
        return targetPage;
    };
    /** @nocollapse */
    BentoPaginationComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification },
        { type: ChangeDetectorRef }
    ]; };
    BentoPaginationComponent.propDecorators = {
        _page: [{ type: Input, args: ['page',] }],
        _totalItems: [{ type: Input, args: ['totalItems',] }],
        _itemsPerPage: [{ type: Input, args: ['itemsPerPage',] }],
        goToLink: [{ type: Input }],
        hideItemsPerPage: [{ type: Input }],
        _boundaryLinks: [{ type: Input, args: ['boundaryLinks',] }],
        infoText: [{ type: Input }],
        infoPageText: [{ type: Input }],
        goToText: [{ type: Input }],
        directionLinks: [{ type: Input }],
        itemsArray: [{ type: Input }],
        pageOverride: [{ type: Input }],
        useStrings: [{ type: Input }],
        pageChange: [{ type: Output }],
        itemsPerPageChange: [{ type: Output }],
        eventTracking: [{ type: Output }]
    };
BentoPaginationComponent.ɵfac = function BentoPaginationComponent_Factory(t) { return new (t || BentoPaginationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoPaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoPaginationComponent, selectors: [["bento-pagination"]], inputs: { goToLink: "goToLink", hideItemsPerPage: "hideItemsPerPage", directionLinks: "directionLinks", itemsArray: "itemsArray", pageOverride: "pageOverride", useStrings: "useStrings", _page: ["page", "_page"], _totalItems: ["totalItems", "_totalItems"], _itemsPerPage: ["itemsPerPage", "_itemsPerPage"], _boundaryLinks: ["boundaryLinks", "_boundaryLinks"], infoText: "infoText", infoPageText: "infoPageText", goToText: "goToText" }, outputs: { pageChange: "pageChange", itemsPerPageChange: "itemsPerPageChange", eventTracking: "eventTracking" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 9, vars: 9, consts: [[1, "bento-pagination"], [1, "d-flex"], ["class", "paginate-button first first-button", 3, "disabled", 4, "ngIf"], ["class", "paginate-button previous", 3, "first-button", "disabled", 4, "ngIf"], ["class", "paginate-button next", 3, "last-button", "small_margin", "disabled", 4, "ngIf"], ["class", "paginate-button last last-button", 3, "disabled", "small_margin", 4, "ngIf"], ["class", "paginate-input-wrap", 4, "ngIf"], ["class", "paginate-bento-select ml-auto", 4, "ngIf"], ["class", "d-flex", 4, "ngIf"], [1, "paginate-button", "first", "first-button"], ["type", "button", "container", "body", "placement", "top", 1, "btn", "btn-outline-primary", "btn-icon", 3, "disabled", "ngbTooltip", "click"], ["class", "bento-icon-chevron-first-left", "aria-hidden", "true", 4, "ngIf", "ngIfElse"], ["showStrings", ""], ["aria-hidden", "true", 1, "bento-icon-chevron-first-left"], [1, "paginate-button", "previous"], ["type", "button", "container", "body", "placement", "top", "aria-label", "Go to previous page", 1, "btn", "btn-outline-primary", "btn-icon", 3, "disabled", "ngbTooltip", "click"], ["class", "bento-icon-chevron-left", "aria-hidden", "true", 4, "ngIf", "ngIfElse"], ["aria-hidden", "true", 1, "bento-icon-chevron-left"], [1, "paginate-button", "next"], ["class", "bento-icon-chevron-right", "aria-hidden", "true", 4, "ngIf", "ngIfElse"], ["aria-hidden", "true", 1, "bento-icon-chevron-right"], [1, "paginate-button", "last", "last-button"], ["class", "bento-icon-chevron-last-right", "aria-hidden", "true", 4, "ngIf", "ngIfElse"], ["aria-hidden", "true", 1, "bento-icon-chevron-last-right"], [1, "paginate-input-wrap"], [1, "input-group", "paginate-input-group"], ["container", "body", "placement", "top", 1, "form-control", 3, "placeholder", "ngModel", "ngbTooltip", "ngModelChange", "keypress"], ["paginationInput", ""], ["type", "button", "container", "body", "placement", "top", 1, "go", "btn", "btn-outline-primary", 3, "ngbTooltip", "click"], ["class", "bento-icon-arrow-curved-right", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "bento-icon-arrow-curved-right"], [1, "paginate-bento-select", "ml-auto"], ["bentoSelect", "", "container", "body", "placement", "top", "container", "body", 1, "form-control", 3, "ngModel", "ngbTooltip", "change"], ["bpSelect", ""], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "paginate-info", "mr-auto"], ["class", "paginate-info-select", 4, "ngIf"], [1, "paginate-info-select"]], template: function BentoPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, BentoPaginationComponent_div_2_Template, 7, 13, "div", 2);
        ɵngcc0.ɵɵtemplate(3, BentoPaginationComponent_div_3_Template, 7, 15, "div", 3);
        ɵngcc0.ɵɵtemplate(4, BentoPaginationComponent_div_4_Template, 7, 17, "div", 4);
        ɵngcc0.ɵɵtemplate(5, BentoPaginationComponent_div_5_Template, 7, 15, "div", 5);
        ɵngcc0.ɵɵtemplate(6, BentoPaginationComponent_div_6_Template, 13, 27, "div", 6);
        ɵngcc0.ɵɵtemplate(7, BentoPaginationComponent_div_7_Template, 5, 6, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, BentoPaginationComponent_div_8_Template, 8, 13, "div", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-narrow", ctx.goIconVisible);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.boundaryLinks !== false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.directionLinks !== false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.directionLinks !== false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.boundaryLinks !== false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.goToLink !== false && ctx.goBtnVisible && ctx.maxPage > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hideItemsPerPage !== true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxPage > 0);
    } }, directives: function () { return [ɵngcc7.NgIf, BentoFocusMonitorDirective, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective, ɵngcc8.DefaultValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, BentoSelectDirective, ɵngcc8.SelectControlValueAccessor, ɵngcc7.NgForOf, ɵngcc8.NgSelectOption, ɵngcc8.ɵangular_packages_forms_forms_x]; }, pipes: function () { return [BentoTranslatePipe,
        BentoStringReplacePipe]; }, styles: ["bento-pagination .bento-pagination{position:relative;padding:0;margin:20px 0;width:100%;text-align:right}bento-pagination .bento-pagination .go.btn{border-radius:0;margin-left:-1px;z-index:1;padding:0 7px;min-width:0}bento-pagination .bento-pagination .bento-select .btn>span{line-height:1.2em}bento-pagination .bento-pagination button{padding:0 1.6em;cursor:pointer;margin-right:-1px;border-radius:0;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-pagination .bento-pagination button:focus{position:relative;z-index:1}bento-pagination .bento-pagination .paginate-button.first>button,bento-pagination .bento-pagination .paginate-button.last>button,bento-pagination .bento-pagination .paginate-button.next>button,bento-pagination .bento-pagination .paginate-button.previous>button{padding:0 1em}bento-pagination .bento-pagination .paginate-button{margin-right:-1px}[dir=rtl] bento-pagination .bento-pagination .paginate-button{margin-right:0;margin-left:-1px}[dir=rtl] bento-pagination .bento-pagination .paginate-button button i{transform:scaleX(-1)}bento-pagination .bento-pagination .paginate-button.last-button{margin-right:40px}bento-pagination .bento-pagination .paginate-button.last-button.small-margin{margin-right:10px}[dir=rtl] bento-pagination .bento-pagination .paginate-button.last-button.small-margin{margin-right:0;margin-left:10px}[dir=rtl] bento-pagination .bento-pagination .paginate-button.last-button{margin-right:0;margin-left:40px}bento-pagination .bento-pagination .paginate-button.first-button>button{margin-left:0}[dir=rtl] bento-pagination .bento-pagination .paginate-button.first-button>button{margin-left:auto;margin-right:0}[dir=rtl] bento-pagination .bento-pagination .paginate-bento-select{margin-left:0!important;margin-right:auto}[dir=rtl] bento-pagination .bento-pagination .paginate-info{margin-right:0!important;margin-left:auto}bento-pagination .bento-pagination .paginate-info,bento-pagination .bento-pagination .paginate-info-select{margin-top:5px}bento-pagination .bento-pagination .paginate-info span,bento-pagination .bento-pagination .paginate-info-select span{line-height:2em;border:none;background:0 0}bento-pagination .bento-pagination .paginate-info span:hover,bento-pagination .bento-pagination .paginate-info-select span:hover{background:0 0}bento-pagination .bento-pagination .paginate-info{clear:both}bento-pagination .bento-pagination .paginate-input-wrap{width:auto;padding:0}bento-pagination .bento-pagination .paginate-input-wrap>span{padding:0;border:none;background:0 0;margin:0}bento-pagination .bento-pagination .paginate-input-wrap>span:active,bento-pagination .bento-pagination .paginate-input-wrap>span:hover{background:0 0}bento-pagination .bento-pagination .paginate-input-wrap .paginate-button-group{float:left;margin-right:40px}bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group,bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group .input-group-btn{float:left}bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control{box-shadow:none;display:inline;flex:none;min-width:70px;position:relative;text-align:center;width:70px;-webkit-box-shadow:none}bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control:hover{z-index:auto}bento-pagination .bento-pagination .paginate-input-wrap .dataTables-info{margin-right:20px}bento-pagination .bento-pagination.is-narrow .paginate-input-wrap .paginate-input-group input.form-control{width:60px}@-moz-document url-prefix(){bento-pagination .bento-pagination .bento-select select{padding-top:9px}}.bento-splitter-group-main-inner bento-pagination .bento-pagination{padding:0 10px}bento-pagination .bento-pagination.has-padding{padding:0 20px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'bento-pagination',
                template: "<div class=\"bento-pagination\" [class.is-narrow]=\"goIconVisible\">\n  <div class=\"d-flex\">\n    <div\n      *ngIf=\"boundaryLinks !== false\"\n      class=\"paginate-button first first-button\"\n      [class.disabled]=\"page === 1 || maxPage === 1\"\n    >\n      <button\n        type=\"button\"\n        (click)=\"_goToPage(1, $event)\"\n        [disabled]=\"page === 1 || maxPage === 1\"\n        container=\"body\"\n        class=\"btn btn-outline-primary btn-icon\"\n        placement=\"top\"\n        [ngbTooltip]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_FIRST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_FIRST'])\n            : ''\n        \"\n        [attr.aria-label]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_FIRST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_FIRST'])\n            : ''\n        \"\n      >\n        <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-first-left\" aria-hidden=\"true\"></i>\n        <ng-template #showStrings>\n          {{ 'BENTO_UI_PAGINATION_A11Y_FIRST_BUTTON' | bentoTranslate }}\n        </ng-template>\n      </button>\n    </div>\n    <div\n      *ngIf=\"directionLinks !== false\"\n      class=\"paginate-button previous\"\n      [class.first-button]=\"!boundaryLinks\"\n      [class.disabled]=\"page === 1 || maxPage === 1\"\n    >\n      <button\n        type=\"button\"\n        (click)=\"_goToPage(page - 1, $event)\"\n        [disabled]=\"page === 1 || maxPage === 1\"\n        container=\"body\"\n        class=\"btn btn-outline-primary btn-icon\"\n        placement=\"top\"\n        aria-label=\"Go to previous page\"\n        [ngbTooltip]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_PREVIOUS'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PREVIOUS'])\n            : ''\n        \"\n        [attr.aria-label]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_PREVIOUS'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PREVIOUS'])\n            : ''\n        \"\n      >\n        <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n        <ng-template #showStrings>\n          {{ 'BENTO_UI_PAGINATION_A11Y_PREVIOUS_BUTTON' | bentoTranslate }}\n        </ng-template>\n      </button>\n    </div>\n    <div\n      *ngIf=\"directionLinks !== false\"\n      class=\"paginate-button next\"\n      [class.last-button]=\"!boundaryLinks\"\n      [class.small_margin]=\"lastButtonSmallMargin\"\n      [class.disabled]=\"page === maxPage || maxPage <= 1\"\n    >\n      <button\n        type=\"button\"\n        (click)=\"_goToPage(page + 1, $event)\"\n        [disabled]=\"page === maxPage || maxPage <= 1\"\n        container=\"body\"\n        class=\"btn btn-outline-primary btn-icon\"\n        placement=\"top\"\n        [ngbTooltip]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_NEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_NEXT'])\n            : ''\n        \"\n        [attr.aria-label]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_NEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_NEXT'])\n            : ''\n        \"\n      >\n        <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n        <ng-template #showStrings>\n          {{ 'BENTO_UI_PAGINATION_A11Y_NEXT_BUTTON' | bentoTranslate }}\n        </ng-template>\n      </button>\n    </div>\n    <div\n      *ngIf=\"boundaryLinks !== false\"\n      class=\"paginate-button last last-button\"\n      [class.disabled]=\"page === maxPage || maxPage <= 1\"\n      [class.small_margin]=\"lastButtonSmallMargin\"\n    >\n      <button\n        type=\"button\"\n        (click)=\"_goToPage(_getTotalPages(), $event)\"\n        [disabled]=\"page === maxPage || maxPage <= 1\"\n        container=\"body\"\n        class=\"btn btn-outline-primary btn-icon\"\n        placement=\"top\"\n        [ngbTooltip]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_LAST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_LAST'])\n            : ''\n        \"\n        [attr.aria-label]=\"\n          !useStrings\n            ? ('BENTO_UI_PAGINATION_A11Y_LAST' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_LAST'])\n            : ''\n        \"\n      >\n        <i *ngIf=\"!useStrings; else showStrings\" class=\"bento-icon-chevron-last-right\" aria-hidden=\"true\"></i>\n        <ng-template #showStrings>\n          {{ 'BENTO_UI_PAGINATION_A11Y_LAST_BUTTON' | bentoTranslate }}\n        </ng-template>\n      </button>\n    </div>\n    <div class=\"paginate-input-wrap\" *ngIf=\"goToLink !== false && goBtnVisible && maxPage > 1\">\n      <span class=\"input-group paginate-input-group\">\n        <input\n          #paginationInput\n          class=\"form-control\"\n          container=\"body\"\n          placeholder=\"{{ page }}\"\n          [(ngModel)]=\"paginationInputModel\"\n          (keypress)=\"_goToPage($event.target.value, $event)\"\n          placement=\"top\"\n          [ngbTooltip]=\"\n            'BENTO_UI_PAGINATION_A11Y_PAGE_NUM' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_PAGE_NUM']\n          \"\n        />\n        <button\n          type=\"button\"\n          class=\"go btn btn-outline-primary\"\n          container=\"body\"\n          (click)=\"_goToPage(paginationInput.value, $event)\"\n          placement=\"top\"\n          [ngbTooltip]=\"\n            'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_GOTO_PAGE']\n              | bentoStringReplace: '_PAGE_':paginationInputModel || page\n          \"\n          [attr.aria-label]=\"\n            'BENTO_UI_PAGINATION_A11Y_GOTO_PAGE'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_GOTO_PAGE']\n              | bentoStringReplace: '_PAGE_':paginationInputModel || page\n          \"\n        >\n          <i class=\"bento-icon-arrow-curved-right\" *ngIf=\"goIconVisible\" aria-hidden=\"true\"></i>\n          {{\n            goIconVisible\n              ? ''\n              : goToText ||\n                ('BENTO_UI_PAGINATION_GO_BUTTON' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_GO_BUTTON'])\n          }}\n        </button>\n      </span>\n    </div>\n    <div class=\"paginate-bento-select ml-auto\" *ngIf=\"hideItemsPerPage !== true\">\n      <select\n        bentoSelect\n        #bpSelect\n        class=\"form-control\"\n        container=\"body\"\n        [ngModel]=\"itemsPerPage\"\n        (change)=\"_onItemsPerPageChange(bpSelect.value)\"\n        placement=\"top\"\n        [ngbTooltip]=\"\n          'BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE'\n            | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_A11Y_ITEMS_PER_PAGE']\n        \"\n        container=\"body\"\n      >\n        <option [value]=\"item\" *ngFor=\"let item of itemsArray\">{{ item }}</option>\n      </select>\n    </div>\n  </div>\n  <div *ngIf=\"maxPage > 0\" class=\"d-flex\">\n    <div class=\"paginate-info mr-auto\">\n      <span>\n        {{\n          infoPageText ||\n            ('BENTO_UI_PAGINATION_INFO_PAGE_TEXT'\n              | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_INFO_PAGE_TEXT'])\n            | bentoStringReplace: '_PAGE_':page\n            | bentoStringReplace: '_PAGES_':_getTotalPages()\n        }}\n      </span>\n    </div>\n    <div class=\"paginate-info-select\" *ngIf=\"hideItemsPerPage !== true\">\n      <span>\n        {{\n          infoText ||\n            ('BENTO_UI_PAGINATION_INFO_TEXT' | bentoTranslate: customTranslation['BENTO_UI_PAGINATION_INFO_TEXT'])\n            | bentoStringReplace: '_START_':_getStartIndex()\n            | bentoStringReplace: '_END_':_getEndIndex()\n            | bentoStringReplace: '_MAX_':totalItems\n        }}\n      </span>\n    </div>\n  </div>\n</div>\n",
                providers: [BentoNotification],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-pagination .bento-pagination{position:relative;padding:0;margin:20px 0;width:100%;text-align:right}bento-pagination .bento-pagination .go.btn{border-radius:0;margin-left:-1px;z-index:1;padding:0 7px;min-width:0}bento-pagination .bento-pagination .bento-select .btn>span{line-height:1.2em}bento-pagination .bento-pagination button{padding:0 1.6em;cursor:pointer;margin-right:-1px;border-radius:0;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-pagination .bento-pagination button:focus{position:relative;z-index:1}bento-pagination .bento-pagination .paginate-button.first>button,bento-pagination .bento-pagination .paginate-button.last>button,bento-pagination .bento-pagination .paginate-button.next>button,bento-pagination .bento-pagination .paginate-button.previous>button{padding:0 1em}bento-pagination .bento-pagination .paginate-button{margin-right:-1px}[dir=rtl] bento-pagination .bento-pagination .paginate-button{margin-right:0;margin-left:-1px}[dir=rtl] bento-pagination .bento-pagination .paginate-button button i{transform:scaleX(-1)}bento-pagination .bento-pagination .paginate-button.last-button{margin-right:40px}bento-pagination .bento-pagination .paginate-button.last-button.small-margin{margin-right:10px}[dir=rtl] bento-pagination .bento-pagination .paginate-button.last-button.small-margin{margin-right:0;margin-left:10px}[dir=rtl] bento-pagination .bento-pagination .paginate-button.last-button{margin-right:0;margin-left:40px}bento-pagination .bento-pagination .paginate-button.first-button>button{margin-left:0}[dir=rtl] bento-pagination .bento-pagination .paginate-button.first-button>button{margin-left:auto;margin-right:0}[dir=rtl] bento-pagination .bento-pagination .paginate-bento-select{margin-left:0!important;margin-right:auto}[dir=rtl] bento-pagination .bento-pagination .paginate-info{margin-right:0!important;margin-left:auto}bento-pagination .bento-pagination .paginate-info,bento-pagination .bento-pagination .paginate-info-select{margin-top:5px}bento-pagination .bento-pagination .paginate-info span,bento-pagination .bento-pagination .paginate-info-select span{line-height:2em;border:none;background:0 0}bento-pagination .bento-pagination .paginate-info span:hover,bento-pagination .bento-pagination .paginate-info-select span:hover{background:0 0}bento-pagination .bento-pagination .paginate-info{clear:both}bento-pagination .bento-pagination .paginate-input-wrap{width:auto;padding:0}bento-pagination .bento-pagination .paginate-input-wrap>span{padding:0;border:none;background:0 0;margin:0}bento-pagination .bento-pagination .paginate-input-wrap>span:active,bento-pagination .bento-pagination .paginate-input-wrap>span:hover{background:0 0}bento-pagination .bento-pagination .paginate-input-wrap .paginate-button-group{float:left;margin-right:40px}bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group,bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group .input-group-btn{float:left}bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control{box-shadow:none;display:inline;flex:none;min-width:70px;position:relative;text-align:center;width:70px;-webkit-box-shadow:none}bento-pagination .bento-pagination .paginate-input-wrap .paginate-input-group input.form-control:hover{z-index:auto}bento-pagination .bento-pagination .paginate-input-wrap .dataTables-info{margin-right:20px}bento-pagination .bento-pagination.is-narrow .paginate-input-wrap .paginate-input-group input.form-control{width:60px}@-moz-document url-prefix(){bento-pagination .bento-pagination .bento-select select{padding-top:9px}}.bento-splitter-group-main-inner bento-pagination .bento-pagination{padding:0 10px}bento-pagination .bento-pagination.has-padding{padding:0 20px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: ɵngcc0.ChangeDetectorRef }]; }, { goToLink: [{
            type: Input
        }], hideItemsPerPage: [{
            type: Input
        }], directionLinks: [{
            type: Input
        }], itemsArray: [{
            type: Input
        }], pageOverride: [{
            type: Input
        }], useStrings: [{
            type: Input
        }], pageChange: [{
            type: Output
        }], itemsPerPageChange: [{
            type: Output
        }], eventTracking: [{
            type: Output
        }], _page: [{
            type: Input,
            args: ['page']
        }], _totalItems: [{
            type: Input,
            args: ['totalItems']
        }], _itemsPerPage: [{
            type: Input,
            args: ['itemsPerPage']
        }], _boundaryLinks: [{
            type: Input,
            args: ['boundaryLinks']
        }], infoText: [{
            type: Input
        }], infoPageText: [{
            type: Input
        }], goToText: [{
            type: Input
        }] }); })();
    return BentoPaginationComponent;
}());
if (false) {
    /** @type {?} */
    BentoPaginationComponent.prototype.page;
    /** @type {?} */
    BentoPaginationComponent.prototype.totalItems;
    /** @type {?} */
    BentoPaginationComponent.prototype.itemsPerPage;
    /**
     * Flag to display the 'go to page' input field and button
     * @type {?}
     */
    BentoPaginationComponent.prototype.goToLink;
    /**
     * Flag to hide/display the 'items per page' select input
     * @type {?}
     */
    BentoPaginationComponent.prototype.hideItemsPerPage;
    /** @type {?} */
    BentoPaginationComponent.prototype.boundaryLinks;
    /** @type {?} */
    BentoPaginationComponent.prototype.userSetBoundaryLinks;
    /**
     * Text to override info of the right page selection.
     * Default: '_START_ to _END_ of _MAX_'
     * @type {?}
     */
    BentoPaginationComponent.prototype.infoText;
    /**
     * Text to override main pagination info.
     * Default: 'Page _PAGE_ of _PAGES_'
     * @type {?}
     */
    BentoPaginationComponent.prototype.infoPageText;
    /**
     * Text to override 'Go to' label.
     * Default: 'Go'
     * @type {?}
     */
    BentoPaginationComponent.prototype.goToText;
    /**
     * Flag to show/hide direction links
     * @type {?}
     */
    BentoPaginationComponent.prototype.directionLinks;
    /**
     * Option for the page item number selection dropdown.  This property is **immutable**
     * @type {?}
     */
    BentoPaginationComponent.prototype.itemsArray;
    /**
     * Flag to set the current page always to `1`
     * @type {?}
     */
    BentoPaginationComponent.prototype.pageOverride;
    /**
     * Accessibility guidelines encourages to use real words for buttons instead
     * of symbols and hidden text. Use this property to use strings instead of
     * symbols (<<, <, >, >>) for pagination component.
     * component.
     * By default this will be set to false, to make your product fully accessible,
     * set this to true when using pagination component.
     * @type {?}
     */
    BentoPaginationComponent.prototype.useStrings;
    /**
     * Callback when the current page is changed
     * @type {?}
     */
    BentoPaginationComponent.prototype.pageChange;
    /**
     * Callback when items per page is changed
     * @type {?}
     */
    BentoPaginationComponent.prototype.itemsPerPageChange;
    /**
     * (Experimental) Callback when an internal event is dispatched within Bento Pagination
     * @type {?}
     */
    BentoPaginationComponent.prototype.eventTracking;
    /**
     * Flag to set the visibility of the 'Go' button
     * @type {?}
     */
    BentoPaginationComponent.prototype.goIconVisible;
    /**
     * Flag to set the last button margin
     * @type {?}
     */
    BentoPaginationComponent.prototype.lastButtonSmallMargin;
    /**
     * Current max page count
     * @type {?}
     */
    BentoPaginationComponent.prototype.maxPage;
    /**
     * Flag to the visibility of the 'Go' button
     * @type {?}
     */
    BentoPaginationComponent.prototype.goBtnVisible;
    /**
     * Component native element
     * @type {?}
     */
    BentoPaginationComponent.prototype.nativeElement;
    /**
     * Main container element of this component
     * @type {?}
     */
    BentoPaginationComponent.prototype.element;
    /**
     * Subscription to page and parent container resize
     * @type {?}
     */
    BentoPaginationComponent.prototype.resizeSubscription;
    /**
     * go input field model
     * @type {?}
     */
    BentoPaginationComponent.prototype.paginationInputModel;
    /**
     * Variable that implements the BentoTranslatable
     * @type {?}
     */
    BentoPaginationComponent.prototype.customTranslation;
    /**
     * @type {?}
     * @private
     */
    BentoPaginationComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/select/select.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The `bentoSelect` directive gives the HTML `<select>` element consistent
 * visual signature across most browsers.
 */
var BentoSelectDirective = /** @class */ (function () {
    function BentoSelectDirective(elRef, r, windowRef) {
        this.r = r;
        this.windowRef = windowRef;
        this.el = elRef.nativeElement;
    }
    /**
     * @return {?}
     */
    BentoSelectDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.wrapperEl.parentElement) {
            this.wrapperEl.parentElement.removeChild(this.wrapperEl);
        }
    };
    /**
     * @return {?}
     */
    BentoSelectDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.render(this.el);
    };
    /**
     * Render layout
     */
    /**
     * Render layout
     * @private
     * @param {?} el
     * @return {?}
     */
    BentoSelectDirective.prototype.render = /**
     * Render layout
     * @private
     * @param {?} el
     * @return {?}
     */
    function (el) {
        /** @type {?} */
        var wrapper = this.r.createElement('div');
        /** @type {?} */
        var button = this.r.createElement('div');
        this.r.addClass(button, 'btn');
        this.r.addClass(button, 'btn-icon');
        this.r.setProperty(button, 'innerHTML', '<i class="bento-icon-caret-down-filled" aria-hidden="true"></i>');
        this.r.addClass(wrapper, 'bento-select');
        this.r.appendChild(el.parentElement, wrapper);
        this.r.appendChild(wrapper, el);
        // Move class to wrapper
        if (el.classList.contains('input-sm')) {
            this.r.removeClass(el, 'input-sm');
            this.r.addClass(wrapper, 'input-sm');
        }
        else if (el.classList.contains('input-lg')) {
            this.r.removeClass(el, 'input-lg');
            this.r.addClass(wrapper, 'input-lg');
        }
        // Firefox version for better UI look and feel
        if (this.windowRef.isFF) {
            this.r.addClass(wrapper, 'firefox');
            /** @type {?} */
            var border = this.r.createElement('div');
            this.r.addClass(border, 'bento-select-border');
            this.r.appendChild(wrapper, border);
        }
        this.r.appendChild(wrapper, button);
        this.wrapperEl = wrapper;
    };
    /** @nocollapse */
    BentoSelectDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: WindowRef }
    ]; };
BentoSelectDirective.ɵfac = function BentoSelectDirective_Factory(t) { return new (t || BentoSelectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoSelectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoSelectDirective, selectors: [["select", "bentoSelect", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSelectDirective, [{
        type: Directive,
        args: [{ selector: 'select[bentoSelect]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: WindowRef }]; }, null); })();
    return BentoSelectDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoSelectDirective.prototype.wrapperEl;
    /**
     * @type {?}
     * @private
     */
    BentoSelectDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoSelectDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoSelectDirective.prototype.windowRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/select/select.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoSelectModule = /** @class */ (function () {
    function BentoSelectModule() {
    }
BentoSelectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoSelectModule });
BentoSelectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoSelectModule_Factory(t) { return new (t || BentoSelectModule)(); }, imports: [[BentoUtilsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoSelectModule, { declarations: [BentoSelectDirective], imports: [BentoUtilsModule], exports: [BentoSelectDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoSelectDirective],
                imports: [BentoUtilsModule],
                exports: [BentoSelectDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoSelectModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pagination/pagination.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoPaginationModule = /** @class */ (function () {
    function BentoPaginationModule() {
    }
BentoPaginationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoPaginationModule });
BentoPaginationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoPaginationModule_Factory(t) { return new (t || BentoPaginationModule)(); }, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            FormsModule,
            BentoSelectModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoPaginationModule, { declarations: function () { return [BentoPaginationComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        FormsModule,
        BentoSelectModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule]; }, exports: function () { return [BentoPaginationComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoPaginationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoTranslateModule,
                    BentoUtilsModule,
                    FormsModule,
                    BentoSelectModule,
                    BentoFocusMonitorModule,
                    NgbTooltipModule,
                    BentoNgbTooltipSupportModule
                ],
                declarations: [BentoPaginationComponent],
                exports: [BentoPaginationComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoPaginationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/transition.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Transition utility to help custom transitions
 */
var ɵ0 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return t; }, ɵ1 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return t * t; }, ɵ2 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return t * (2 - t); }, ɵ3 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t); }, ɵ4 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return t * t * t; }, ɵ5 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return --t * t * t + 1; }, ɵ6 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1); }, ɵ7 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return t * t * t * t; }, ɵ8 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return 1 - --t * t * t * t; }, ɵ9 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return (t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t); }, ɵ10 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return t * t * t * t * t; }, ɵ11 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return 1 + --t * t * t * t * t; }, ɵ12 = /**
 * @param {?} t
 * @return {?}
 */
function (t) { return (t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t); };
/** @type {?} */
var EasingFunctions = {
    // no easing, no acceleration
    linear: (ɵ0),
    // accelerating from zero velocity
    easeInQuad: (ɵ1),
    // decelerating to zero velocity
    easeOutQuad: (ɵ2),
    // acceleration until halfway, then deceleration
    easeInOutQuad: (ɵ3),
    // accelerating from zero velocity
    easeInCubic: (ɵ4),
    // decelerating to zero velocity
    easeOutCubic: (ɵ5),
    // acceleration until halfway, then deceleration
    easeInOutCubic: (ɵ6),
    // accelerating from zero velocity
    easeInQuart: (ɵ7),
    // decelerating to zero velocity
    easeOutQuart: (ɵ8),
    // acceleration until halfway, then deceleration
    easeInOutQuart: (ɵ9),
    // accelerating from zero velocity
    easeInQuint: (ɵ10),
    // decelerating to zero velocity
    easeOutQuint: (ɵ11),
    // acceleration until halfway, then deceleration
    easeInOutQuint: (ɵ12)
};
var BentoTransition = /** @class */ (function () {
    function BentoTransition() {
        /**
         * Initial value before the transition starts
         */
        this.beginVal = 0;
        /**
         * Final value when the transition ends
         */
        this.endVal = 1;
        /**
         * Ease
         */
        this.ease = EasingFunctions.easeOutCubic;
        /**
         * Private variables
         */
        this._tickCallbackStack = [];
        this._doneCallbackStack = [];
        try {
            // Running in browsers
            this.window = window;
        }
        catch (e) {
            // Running in SSR mode
            // Polyfill with dummy here
            this.window = {
                cancelAnimationFrame: (/**
                 * @param {?} id
                 * @return {?}
                 */
                function (id) { }),
                requestAnimationFrame: (/**
                 * @param {?} func
                 * @return {?}
                 */
                function (func) {
                    return 0;
                })
            };
        }
    }
    /**
     * Start the transition
     */
    /**
     * Start the transition
     * @return {?}
     */
    BentoTransition.prototype.start = /**
     * Start the transition
     * @return {?}
     */
    function () {
        this._dVal = this.endVal - this.beginVal;
        this._startTime = null;
        this._tick();
    };
    /**
     * Stop the transition
     */
    /**
     * Stop the transition
     * @return {?}
     */
    BentoTransition.prototype.stop = /**
     * Stop the transition
     * @return {?}
     */
    function () {
        this.window.cancelAnimationFrame(this._rAFID);
    };
    /**
     * Add onTick callback function to this class
     */
    /**
     * Add onTick callback function to this class
     * @param {?} func
     * @return {?}
     */
    BentoTransition.prototype.onTick = /**
     * Add onTick callback function to this class
     * @param {?} func
     * @return {?}
     */
    function (func) {
        if (this._tickCallbackStack.indexOf(func) < 0) {
            this._tickCallbackStack.push(func);
        }
    };
    /**
     * Add onDone callback function to this class
     */
    /**
     * Add onDone callback function to this class
     * @param {?} func
     * @return {?}
     */
    BentoTransition.prototype.onDone = /**
     * Add onDone callback function to this class
     * @param {?} func
     * @return {?}
     */
    function (func) {
        if (this._doneCallbackStack.indexOf(func) < 0) {
            this._doneCallbackStack.push(func);
        }
    };
    /**
     * Tick function to call the position at the given time
     */
    /**
     * Tick function to call the position at the given time
     * @private
     * @param {?=} time
     * @return {?}
     */
    BentoTransition.prototype._tick = /**
     * Tick function to call the position at the given time
     * @private
     * @param {?=} time
     * @return {?}
     */
    function (time) {
        if (this._startTime == null && time != null) {
            this._startTime = time;
        }
        /** @type {?} */
        var dTime = (time || 0) - this._startTime;
        /** @type {?} */
        var vRatio = this.ease(Math.min(1, dTime / this.duration));
        /** @type {?} */
        var val;
        if (vRatio === 1) {
            // Done with the transition
            this.fireTickCallbacks(this.endVal);
            this.fireDoneCallbacks(this.endVal);
        }
        else {
            // Update the current val
            val = this.beginVal + this._dVal * vRatio;
            this.fireTickCallbacks(val);
            // Move to the next tick
            this._rAFID = this.window['requestAnimationFrameTest']
                ? // Made for testing
                    this.window['requestAnimationFrameTest'](this._tick.bind(this))
                : // The real thing
                    this.window.requestAnimationFrame(this._tick.bind(this));
        }
    };
    /**
     * Fire callback functions from the callback stack
     */
    /**
     * Fire callback functions from the callback stack
     * @private
     * @param {?} val
     * @return {?}
     */
    BentoTransition.prototype.fireTickCallbacks = /**
     * Fire callback functions from the callback stack
     * @private
     * @param {?} val
     * @return {?}
     */
    function (val) {
        for (var i = 0, len = this._tickCallbackStack.length; i < len; i++) {
            this._tickCallbackStack[i](val);
        }
    };
    /**
     * Fire callback functions from the callback stack
     */
    /**
     * Fire callback functions from the callback stack
     * @private
     * @param {?} val
     * @return {?}
     */
    BentoTransition.prototype.fireDoneCallbacks = /**
     * Fire callback functions from the callback stack
     * @private
     * @param {?} val
     * @return {?}
     */
    function (val) {
        for (var i = 0, len = this._doneCallbackStack.length; i < len; i++) {
            this._doneCallbackStack[i](val);
        }
    };
BentoTransition.ɵfac = function BentoTransition_Factory(t) { return new (t || BentoTransition)(); };
BentoTransition.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoTransition, factory: function (t) { return BentoTransition.ɵfac(t); } });

    return BentoTransition;
}());
if (false) {
    /**
     * Initial value before the transition starts
     * @type {?}
     */
    BentoTransition.prototype.beginVal;
    /**
     * Final value when the transition ends
     * @type {?}
     */
    BentoTransition.prototype.endVal;
    /**
     * Duration of the transition
     * @type {?}
     */
    BentoTransition.prototype.duration;
    /**
     * Ease
     * @type {?}
     */
    BentoTransition.prototype.ease;
    /**
     * Private variables
     * @type {?}
     * @private
     */
    BentoTransition.prototype._tickCallbackStack;
    /**
     * @type {?}
     * @private
     */
    BentoTransition.prototype._doneCallbackStack;
    /**
     * @type {?}
     * @private
     */
    BentoTransition.prototype._dVal;
    /**
     * @type {?}
     * @private
     */
    BentoTransition.prototype._startTime;
    /**
     * @type {?}
     * @private
     */
    BentoTransition.prototype._rAFID;
    /**
     * @type {?}
     * @private
     */
    BentoTransition.prototype.window;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/scrollable-bar/scrollable-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TRANSITON_DURATION = 750;
var BentoScrollableBarComponent = /** @class */ (function () {
    function BentoScrollableBarComponent(elRef, r, tween, bentoNotification, dir) {
        this.r = r;
        this.tween = tween;
        this.dir = dir;
        this.hasScroll = false;
        // Virtually private variables
        this._isLeftArrowDisabled = false;
        this._isRightArrowDisabled = false;
        this.el = elRef.nativeElement;
        // Bind `this` to listeners
        this.onInnerScroll = this.onInnerScroll.bind(this);
        this.renderUI = this.renderUI.bind(this);
        this.onMouseScroll = this.onMouseScroll.bind(this);
        // Add resize subscription
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe(this.renderUI);
        // Setup tween
        this.tween.onTick(this.onScrollTransitionTick.bind(this));
        this.tween.duration = TRANSITON_DURATION;
        this.tween.ease = EasingFunctions.easeOutQuint;
    }
    /**
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.innerEl = this.el.querySelector('.bento-scrollable-bar-inner');
        this.innerScrollSubscription = fromEvent(this.innerEl, 'scroll').subscribe(this.onInnerScroll);
        this.r.listen(this.innerEl, 'wheel', this.onMouseScroll);
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.renderUI((/**
             * @return {?}
             */
            function () {
                if (_this.dir.value === 'rtl') {
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        return _this.r.setProperty(_this.innerEl, 'scrollLeft', _this.innerEl.scrollWidth - _this.innerEl.offsetWidth);
                    }));
                }
            }));
        }));
    };
    /**
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
        this.innerScrollSubscription.unsubscribe();
    };
    /**
     * Scroll forward to the next half of screen
     */
    /**
     * Scroll forward to the next half of screen
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.scrollForward = /**
     * Scroll forward to the next half of screen
     * @return {?}
     */
    function () {
        /** @type {?} */
        var maxScroll = this.innerEl.scrollWidth - this.innerEl.offsetWidth;
        this.tween.stop();
        this.tween.beginVal = this.innerEl.scrollLeft;
        this.tween.endVal = this.innerEl.scrollLeft + this.innerEl.offsetWidth * 0.5;
        if (this.tween.endVal > maxScroll) {
            this.tween.endVal = maxScroll;
        }
        this.tween.start();
    };
    /**
     * Scroll back to the previous screen
     */
    /**
     * Scroll back to the previous screen
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.scrollBack = /**
     * Scroll back to the previous screen
     * @return {?}
     */
    function () {
        this.tween.stop();
        this.tween.beginVal = this.innerEl.scrollLeft;
        this.tween.endVal = this.innerEl.scrollLeft - this.innerEl.offsetWidth * 0.5;
        if (this.tween.endVal < 0) {
            this.tween.endVal = 0;
        }
        this.tween.start();
    };
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     */
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.refresh = /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     * @return {?}
     */
    function () {
        var _this = this;
        this.renderUI((/**
         * @return {?}
         */
        function () {
            if (_this.dir.value === 'rtl') {
                _this.r.setProperty(_this.innerEl, 'scrollLeft', _this.innerEl.scrollWidth - _this.innerEl.offsetWidth);
            }
            else {
                _this.r.setProperty(_this.innerEl, 'scrollLeft', 0);
            }
        }));
    };
    /**
     * Scroll content on mouse vertical scroll
     */
    /**
     * Scroll content on mouse vertical scroll
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.onMouseScroll = /**
     * Scroll content on mouse vertical scroll
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var delta;
        if (e.deltaX === 0) {
            delta = this.dir.value === 'rtl' ? -e.deltaY : e.deltaY;
        }
        else {
            delta = e.deltaX;
        }
        // Only apply to vertical scroll. eg Mouse wheels
        this.r.setProperty(this.innerEl, 'scrollLeft', this.innerEl.scrollLeft + delta);
        e.preventDefault();
        e.stopPropagation();
    };
    /**
     * Display scroll
     * @param val the value from the current transtion tick
     */
    /**
     * Display scroll
     * @private
     * @param {?} val the value from the current transtion tick
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.onScrollTransitionTick = /**
     * Display scroll
     * @private
     * @param {?} val the value from the current transtion tick
     * @return {?}
     */
    function (val) {
        this.r.setProperty(this.innerEl, 'scrollLeft', val);
    };
    /**
     * Callback when the inner container is scrolled
     * We will need to check the arrow states
     * @param e
     */
    /**
     * Callback when the inner container is scrolled
     * We will need to check the arrow states
     * @private
     * @param {?=} e
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.onInnerScroll = /**
     * Callback when the inner container is scrolled
     * We will need to check the arrow states
     * @private
     * @param {?=} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var scrollLeft = this.innerEl.scrollLeft;
        if (scrollLeft === 0) {
            this._isLeftArrowDisabled = true;
            this._isRightArrowDisabled = false;
        }
        else if (scrollLeft + this.innerEl.offsetWidth === this.innerEl.scrollWidth) {
            this._isLeftArrowDisabled = false;
            this._isRightArrowDisabled = true;
        }
        else {
            this._isLeftArrowDisabled = false;
            this._isRightArrowDisabled = false;
        }
    };
    /**
     * Render arrows and gradients based on the width of this bar
     */
    /**
     * Render arrows and gradients based on the width of this bar
     * @private
     * @param {?=} onComplete
     * @return {?}
     */
    BentoScrollableBarComponent.prototype.renderUI = /**
     * Render arrows and gradients based on the width of this bar
     * @private
     * @param {?=} onComplete
     * @return {?}
     */
    function (onComplete) {
        var _this = this;
        this.hasScroll = this.innerEl.scrollWidth > this.el.offsetWidth;
        if (this.hasScroll) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                if (typeof onComplete === 'function') {
                    onComplete();
                }
                _this.onInnerScroll();
            }));
        }
    };
    /** @nocollapse */
    BentoScrollableBarComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: BentoTransition },
        { type: BentoNotification },
        { type: Directionality }
    ]; };
    BentoScrollableBarComponent.propDecorators = {
        hasScroll: [{ type: HostBinding, args: ['class.bento-scroll-bar-has-scroll',] }]
    };
BentoScrollableBarComponent.ɵfac = function BentoScrollableBarComponent_Factory(t) { return new (t || BentoScrollableBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoTransition), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoScrollableBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoScrollableBarComponent, selectors: [["bento-scrollable-bar"]], hostVars: 2, hostBindings: function BentoScrollableBarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bento-scroll-bar-has-scroll", ctx.hasScroll);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification, BentoTransition, WindowRef])], ngContentSelectors: _c4, decls: 13, vars: 10, consts: [["type", "button", "cdkMonitorElementFocus", "", "aria-keyshortcuts", "left", 1, "bento-scrollable-bar-side-arrow", "left", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-left"], ["tabindex", "-1", 1, "bento-scrollable-bar-left-anchor"], [1, "bento-scrollable-bar-inner"], ["tabindex", "-1", 1, "bento-scrollable-bar-right-anchor"], ["type", "button", "cdkMonitorElementFocus", "", "aria-keyshortcuts", "right", 1, "bento-scrollable-bar-side-arrow", "right", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-right"], [1, "bento-scrollable-bar-cover", "left", 3, "hidden"], [1, "bento-scrollable-bar-cover", "right", 3, "hidden"]], template: function BentoScrollableBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function BentoScrollableBarComponent_Template_button_click_0_listener() { return ctx.scrollBack(); });
        ɵngcc0.ɵɵpipe(1, "bentoTranslate");
        ɵngcc0.ɵɵelement(2, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵlistener("click", function BentoScrollableBarComponent_Template_button_click_8_listener() { return ctx.scrollForward(); });
        ɵngcc0.ɵɵpipe(9, "bentoTranslate");
        ɵngcc0.ɵɵelement(10, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "div", 7);
        ɵngcc0.ɵɵelement(12, "div", 8);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx._isLeftArrowDisabled);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 6, "BENTO_UI_SCROLLABLE_BAR_SCROLL_LEFT"));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("disabled", ctx._isRightArrowDisabled);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(9, 8, "BENTO_UI_SCROLLABLE_BAR_SCROLL_RIGHT"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx._isLeftArrowDisabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx._isRightArrowDisabled);
    } }, directives: [ɵngcc1.CdkMonitorFocus], pipes: [BentoTranslatePipe], styles: ["bento-scrollable-bar{display:block;position:relative;width:100%}.bento-scrollable-bar-inner{width:100%;overflow:hidden;position:relative;-webkit-overflow-scrolling:touch;-ms-overflow-style:none}.bento-scrollable-bar-inner::-webkit-scrollbar{display:none}.bento-scrollable-bar-inner>div{min-width:100%;display:inline-block;white-space:nowrap}.bento-scrollable-bar-left-anchor,.bento-scrollable-bar-right-anchor{width:0;height:0;position:absolute}button.bento-scrollable-bar-side-arrow{font-size:1.2em;position:absolute;top:0;bottom:1px;background:0 0;border:none;display:none;z-index:1;padding:0;text-align:center;line-height:0;cursor:default;transition:opacity .1s}button.bento-scrollable-bar-side-arrow i{opacity:.7}button.bento-scrollable-bar-side-arrow.left{left:0}button.bento-scrollable-bar-side-arrow.right{right:0}button.bento-scrollable-bar-side-arrow:active i,button.bento-scrollable-bar-side-arrow:focus i,button.bento-scrollable-bar-side-arrow:hover i{opacity:1}button.bento-scrollable-bar-side-arrow:focus{outline:0}button.bento-scrollable-bar-side-arrow.disabled,button.bento-scrollable-bar-side-arrow[disabled]{background:0 0;opacity:.3}.bento-scroll-bar-has-scroll .bento-scrollable-bar-cover,.bento-scroll-bar-has-scroll button.bento-scrollable-bar-side-arrow{display:flex;align-items:center}.bento-scrollable-bar-cover{display:none;height:100%;position:absolute;pointer-events:none;top:0}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoScrollableBarComponent, [{
        type: Component,
        args: [{
                selector: 'bento-scrollable-bar',
                encapsulation: ViewEncapsulation.None,
                template: "<button\n  class=\"bento-scrollable-bar-side-arrow left\"\n  type=\"button\"\n  cdkMonitorElementFocus\n  [disabled]=\"_isLeftArrowDisabled\"\n  (click)=\"scrollBack()\"\n  aria-keyshortcuts=\"left\"\n  [attr.aria-label]=\"'BENTO_UI_SCROLLABLE_BAR_SCROLL_LEFT' | bentoTranslate\"\n>\n  <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-scrollable-bar-left-anchor\" tabindex=\"-1\"></div>\n<div class=\"bento-scrollable-bar-inner\">\n  <div>\n    <ng-content></ng-content>\n  </div>\n</div>\n<div class=\"bento-scrollable-bar-right-anchor\" tabindex=\"-1\"></div>\n<button\n  class=\"bento-scrollable-bar-side-arrow right\"\n  type=\"button\"\n  cdkMonitorElementFocus\n  [disabled]=\"_isRightArrowDisabled\"\n  (click)=\"scrollForward()\"\n  aria-keyshortcuts=\"right\"\n  [attr.aria-label]=\"'BENTO_UI_SCROLLABLE_BAR_SCROLL_RIGHT' | bentoTranslate\"\n>\n  <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-scrollable-bar-cover left\" [hidden]=\"_isLeftArrowDisabled\"></div>\n<div class=\"bento-scrollable-bar-cover right\" [hidden]=\"_isRightArrowDisabled\"></div>\n",
                providers: [BentoNotification, BentoTransition, WindowRef],
                styles: ["bento-scrollable-bar{display:block;position:relative;width:100%}.bento-scrollable-bar-inner{width:100%;overflow:hidden;position:relative;-webkit-overflow-scrolling:touch;-ms-overflow-style:none}.bento-scrollable-bar-inner::-webkit-scrollbar{display:none}.bento-scrollable-bar-inner>div{min-width:100%;display:inline-block;white-space:nowrap}.bento-scrollable-bar-left-anchor,.bento-scrollable-bar-right-anchor{width:0;height:0;position:absolute}button.bento-scrollable-bar-side-arrow{font-size:1.2em;position:absolute;top:0;bottom:1px;background:0 0;border:none;display:none;z-index:1;padding:0;text-align:center;line-height:0;cursor:default;transition:opacity .1s}button.bento-scrollable-bar-side-arrow i{opacity:.7}button.bento-scrollable-bar-side-arrow.left{left:0}button.bento-scrollable-bar-side-arrow.right{right:0}button.bento-scrollable-bar-side-arrow:active i,button.bento-scrollable-bar-side-arrow:focus i,button.bento-scrollable-bar-side-arrow:hover i{opacity:1}button.bento-scrollable-bar-side-arrow:focus{outline:0}button.bento-scrollable-bar-side-arrow.disabled,button.bento-scrollable-bar-side-arrow[disabled]{background:0 0;opacity:.3}.bento-scroll-bar-has-scroll .bento-scrollable-bar-cover,.bento-scroll-bar-has-scroll button.bento-scrollable-bar-side-arrow{display:flex;align-items:center}.bento-scrollable-bar-cover{display:none;height:100%;position:absolute;pointer-events:none;top:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: BentoTransition }, { type: BentoNotification }, { type: ɵngcc6.Directionality }]; }, { hasScroll: [{
            type: HostBinding,
            args: ['class.bento-scroll-bar-has-scroll']
        }] }); })();
    return BentoScrollableBarComponent;
}());
if (false) {
    /** @type {?} */
    BentoScrollableBarComponent.prototype.hasScroll;
    /** @type {?} */
    BentoScrollableBarComponent.prototype._isLeftArrowDisabled;
    /** @type {?} */
    BentoScrollableBarComponent.prototype._isRightArrowDisabled;
    /** @type {?} */
    BentoScrollableBarComponent.prototype.innerEl;
    /** @type {?} */
    BentoScrollableBarComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableBarComponent.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableBarComponent.prototype.innerScrollSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableBarComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableBarComponent.prototype.tween;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableBarComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/scrollable-bar/scrollable-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoScrollableBarModule = /** @class */ (function () {
    function BentoScrollableBarModule() {
    }
BentoScrollableBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoScrollableBarModule });
BentoScrollableBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoScrollableBarModule_Factory(t) { return new (t || BentoScrollableBarModule)(); }, imports: [[CommonModule, BentoTranslateModule, A11yModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoScrollableBarModule, { declarations: function () { return [BentoScrollableBarComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        A11yModule]; }, exports: function () { return [BentoScrollableBarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoScrollableBarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, BentoTranslateModule, A11yModule],
                declarations: [BentoScrollableBarComponent],
                exports: [BentoScrollableBarComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoScrollableBarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/scrollable-toolbar/scrollable-toolbar-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoScrollableToolbarItemComponent = /** @class */ (function () {
    function BentoScrollableToolbarItemComponent(r, elRef, bentoNotificaiton) {
        this.r = r;
        this.bentoNotificaiton = bentoNotificaiton;
        /**
         * Menu Item
         */
        this.item = {};
        this.el = elRef.nativeElement;
    }
    /**
     * @return {?}
     */
    BentoScrollableToolbarItemComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.dropdown) {
            // There is a dropdown
            // Need to wire tabs for better accessibility
            this.parentEl = this.el.parentElement;
            // V2 - using arrow keys etc...
            // Reference: https://www.w3.org/WAI/tutorials/menus/application-menus-code/
            this.resizeSubscription = this.bentoNotificaiton.resizeNotification.subscribe((/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                return _this.calculatePlacementSide(e);
            }));
            this.bentoNotificaiton = null;
            this.cancelParentElScrollLisnter = this.r.listen(this.parentEl, 'scroll', (/**
             * @param {?} e
             * @return {?}
             */
            function (e) { return _this.calculatePlacementSide(e); }));
            this.calculatePlacementSide();
        }
    };
    /**
     * @return {?}
     */
    BentoScrollableToolbarItemComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.dropdown) {
            this.dropdown.hide();
            this.cancelParentElScrollLisnter();
            this.resizeSubscription.unsubscribe();
        }
    };
    /**
     * To be called to calculate the current placement
     */
    /**
     * To be called to calculate the current placement
     * @param {?=} e
     * @return {?}
     */
    BentoScrollableToolbarItemComponent.prototype.calculatePlacementSide = /**
     * To be called to calculate the current placement
     * @param {?=} e
     * @return {?}
     */
    function (e) {
        clearTimeout(this.timeoutID);
        this.timeoutID = setTimeout((/**
         * @return {?}
         */
        function () { }), 100 // debounce the calling of calculation
        );
    };
    /** @nocollapse */
    BentoScrollableToolbarItemComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: BentoNotification }
    ]; };
    BentoScrollableToolbarItemComponent.propDecorators = {
        item: [{ type: Input }],
        appendTo: [{ type: Input }],
        dropdown: [{ type: ViewChild, args: [BentoNgbDropdownAppendToDirective,] }],
        ngbDropdown: [{ type: ViewChild, args: [NgbDropdown,] }]
    };
BentoScrollableToolbarItemComponent.ɵfac = function BentoScrollableToolbarItemComponent_Factory(t) { return new (t || BentoScrollableToolbarItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification)); };
BentoScrollableToolbarItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoScrollableToolbarItemComponent, selectors: [["bento-scrollable-toolbar-item"]], viewQuery: function BentoScrollableToolbarItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoNgbDropdownAppendToDirective, true);
        ɵngcc0.ɵɵviewQuery(NgbDropdown, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngbDropdown = _t.first);
    } }, inputs: { item: "item", appendTo: "appendTo" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], ngContentSelectors: _c4, decls: 7, vars: 2, consts: [["ngbDropdown", "", "bentoToolbarKeyboardSupport", "", "placement", "left", 4, "ngIf", "ngIfElse"], ["megamenu", ""], ["customTemplate", ""], ["buttonOnly", ""], ["ngbDropdown", "", "bentoToolbarKeyboardSupport", "", "placement", "left"], ["ngbDropdownToggle", "", "cdkMonitorElementFocus", "", "type", "button", "role", "menuitem", "aria-haspopup", "true", 1, "bui-menu-item", 3, "disabled", "click"], ["aria-hidden", "true", 4, "ngIf"], ["ngbDropdownMenu", "", "role", "menu", 1, "dropdown-menu", "bui-bento-scrollable-toolbar-dropdown-menu", 3, "bentoAppendTo", "autoRealign"], ["class", "dropdown-item", "cdkMonitorElementFocus", "", "role", "menuitem", "tabindex", "-1", 3, "click", 4, "ngFor", "ngForOf"], ["aria-hidden", "true"], ["cdkMonitorElementFocus", "", "role", "menuitem", "tabindex", "-1", 1, "dropdown-item", 3, "click"], [3, "bentoAppendTo", "autoRealign", "items", "type", "maxWidth", "flowColumnWidth", "widthElRef", "hTagRank", 4, "ngIf"], [3, "bentoAppendTo", "autoRealign", "items", "type", "maxWidth", "flowColumnWidth", "widthElRef", "hTagRank"], [4, "ngIf", "ngIfElse"], [1, "bento-toolbar-custom-item"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", "cdkMonitorElementFocus", "", "role", "menuitem", 1, "bui-menu-item", 3, "disabled", "click"]], template: function BentoScrollableToolbarItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, BentoScrollableToolbarItemComponent_div_0_Template, 6, 8, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoScrollableToolbarItemComponent_ng_template_1_Template, 1, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, BentoScrollableToolbarItemComponent_ng_template_3_Template, 1, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, BentoScrollableToolbarItemComponent_ng_template_5_Template, 3, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.item.dropdown)("ngIfElse", _r1);
    } }, directives: function () { return [ɵngcc7.NgIf, ɵngcc4.NgbDropdown, BentoToolbarKeyboardSupportDirective, ɵngcc4.NgbDropdownToggle, ɵngcc1.CdkMonitorFocus, BentoNgbDropdownAppendToDirective, ɵngcc4.NgbDropdownMenu, BentoNgbDropdownAnimationDirective, ɵngcc7.NgForOf, BentoFocusMonitorDirective,
        BentoMegamenuComponent,
        BentoAppendToDirective, ɵngcc7.NgTemplateOutlet]; }, styles: ["bento-scrollable-toolbar{display:block}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav,bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:1px 0;height:100%}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled,bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled]{background:0 0}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoScrollableToolbarItemComponent, [{
        type: Component,
        args: [{
                selector: 'bento-scrollable-toolbar-item',
                encapsulation: ViewEncapsulation.None,
                template: "<div ngbDropdown bentoToolbarKeyboardSupport placement=\"left\" *ngIf=\"item.dropdown; else megamenu\">\n  <button\n    ngbDropdownToggle\n    cdkMonitorElementFocus\n    type=\"button\"\n    role=\"menuitem\"\n    class=\"bui-menu-item\"\n    [attr.id]=\"'toggleDropdown' + item.label\"\n    aria-haspopup=\"true\"\n    (click)=\"item.action && item.action()\"\n    [disabled]=\"item.disabled\"\n  >\n    <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n    {{ item.label }}\n  </button>\n  <div\n    class=\"dropdown-menu bui-bento-scrollable-toolbar-dropdown-menu\"\n    ngbDropdownMenu\n    [bentoAppendTo]=\"appendTo\"\n    [autoRealign]=\"true\"\n    [attr.aria-labelledby]=\"'toggleDropdown' + item.label\"\n    role=\"menu\"\n  >\n    <button\n      class=\"dropdown-item\"\n      cdkMonitorElementFocus\n      role=\"menuitem\"\n      tabindex=\"-1\"\n      (click)=\"dropdownItem.action && dropdownItem.action()\"\n      *ngFor=\"let dropdownItem of item.dropdown\"\n    >\n      <i *ngIf=\"dropdownItem.icon\" [attr.class]=\"dropdownItem.icon\" aria-hidden=\"true\"></i>\n      {{ dropdownItem.label }}\n    </button>\n  </div>\n</div>\n\n<ng-template #megamenu>\n  <div ngbDropdown bentoToolbarKeyboardSupport placement=\"left\" *ngIf=\"item.megamenu; else customTemplate\">\n    <button\n      ngbDropdownToggle\n      cdkMonitorElementFocus\n      type=\"button\"\n      role=\"menuitem\"\n      [attr.id]=\"'toggleDropdown' + item.label\"\n      (click)=\"item.action && item.action()\"\n      aria-haspopup=\"true\"\n      class=\"bui-menu-item\"\n      [disabled]=\"item.disabled\"\n    >\n      <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n      {{ item.label }}\n    </button>\n    <bento-megamenu\n      *ngIf=\"item.megamenu\"\n      [bentoAppendTo]=\"appendTo\"\n      [autoRealign]=\"true\"\n      [items]=\"item.megamenu\"\n      [type]=\"item.type\"\n      [maxWidth]=\"item.maxWidth\"\n      [flowColumnWidth]=\"item.flowColumnWidth\"\n      [widthElRef]=\"appendTo\"\n      [hTagRank]=\"'3'\"\n      [attr.aria-label]=\"item.ariaLabel ? item.ariaLabel : null\"\n    ></bento-megamenu>\n  </div>\n</ng-template>\n\n<ng-template #customTemplate>\n  <ng-container *ngIf=\"item.templateRef; else buttonOnly\">\n    <div class=\"bento-toolbar-custom-item\">\n      <ng-content *ngTemplateOutlet=\"item.templateRef; context: {control: this.item.control}\"></ng-content>\n    </div>\n  </ng-container>\n</ng-template>\n\n<ng-template #buttonOnly>\n  <button\n    type=\"button\"\n    cdkMonitorElementFocus\n    role=\"menuitem\"\n    (click)=\"item.action && item.action()\"\n    [disabled]=\"item.disabled\"\n    class=\"bui-menu-item\"\n  >\n    <i *ngIf=\"item.icon\" [attr.class]=\"item.icon\" aria-hidden=\"true\"></i>\n    {{ item.label }}\n  </button>\n</ng-template>\n",
                providers: [BentoNotification],
                styles: ["bento-scrollable-toolbar{display:block}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav,bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:1px 0;height:100%}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled,bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled]{background:0 0}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: BentoNotification }]; }, { item: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: [BentoNgbDropdownAppendToDirective]
        }], ngbDropdown: [{
            type: ViewChild,
            args: [NgbDropdown]
        }] }); })();
    return BentoScrollableToolbarItemComponent;
}());
if (false) {
    /**
     * Menu Item
     * @type {?}
     */
    BentoScrollableToolbarItemComponent.prototype.item;
    /**
     * Parent ElementRef used to tell BentoAppendTo where to stick its element
     * @type {?}
     */
    BentoScrollableToolbarItemComponent.prototype.appendTo;
    /**
     * BentoAppendTo class object
     * @type {?}
     */
    BentoScrollableToolbarItemComponent.prototype.dropdown;
    /**
     * NgbDropdown class objest
     * @type {?}
     */
    BentoScrollableToolbarItemComponent.prototype.ngbDropdown;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarItemComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarItemComponent.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarItemComponent.prototype.cancelParentElScrollLisnter;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarItemComponent.prototype.parentEl;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarItemComponent.prototype.timeoutID;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarItemComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarItemComponent.prototype.bentoNotificaiton;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/scrollable-toolbar/scrollable-toolbar-keyboard-support.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Make NgbDropdown to support keyboard navigations
 */
var BentoToolbarKeyboardSupportDirective = /** @class */ (function () {
    function BentoToolbarKeyboardSupportDirective(elementRef, windowRef, r, dropdown) {
        this.r = r;
        this.dropdown = dropdown;
        this.document = windowRef.nativeDocument;
        this.el = elementRef.nativeElement;
        this.onToggleKeydown = this.onToggleKeydown.bind(this);
        this.onMenuKeydown = this.onMenuKeydown.bind(this);
        // Add a unique class called (b)ento (ui) (d)rop(d)own (k)eyboard (support)
        this.r.addClass(this.el, BentoToolbarKeyboardSupportDirective.CSS_CLASS_NAME);
    }
    /**
     * @return {?}
     */
    BentoToolbarKeyboardSupportDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.dropdownMenuEl = this.el.querySelector('.dropdown-menu');
        this.toggleEl = this.el.querySelector('.dropdown-toggle');
        this.r.listen(this.toggleEl, 'keydown', this.onToggleKeydown);
        this.r.listen(this.dropdownMenuEl, 'keydown', this.onMenuKeydown);
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoToolbarKeyboardSupportDirective.prototype.onMenuKeydown = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        // wip: This is just a temporary fix to get rid of the console error.
        // need to come up with a solution to address this.
        if (!this.menuItems) {
            return;
        }
        /** @type {?} */
        var currentFocusedIndex = this.menuItems.indexOf((/** @type {?} */ (this.document.activeElement)));
        /** @type {?} */
        var menuItemSize = this.menuItems.length;
        currentFocusedIndex = currentFocusedIndex < 0 ? 0 : currentFocusedIndex;
        switch (e.keyCode) {
            case Keyboard.UP:
                this.menuItems[(currentFocusedIndex - 1 + menuItemSize) % menuItemSize].focus();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.DOWN:
                this.menuItems[(currentFocusedIndex + 1) % menuItemSize].focus();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.ESC:
                this.toggleEl.focus();
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.dropdown.close(); }));
                break;
        }
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoToolbarKeyboardSupportDirective.prototype.onToggleKeydown = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        switch (e.keyCode) {
            case Keyboard.UP:
            case Keyboard.DOWN:
                this.showDropdown();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.dropdown.close(); }));
                break;
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoToolbarKeyboardSupportDirective.prototype.showDropdown = /**
     * @private
     * @return {?}
     */
    function () {
        this.menuItems = Array.from(this.dropdownMenuEl.querySelectorAll('[role="menuitem"]'));
        this.dropdown.open();
        this.menuItems[0].focus();
    };
    // Class name used to determine if the HTMLElement is initialized already or not
    // (B)ento (T)ool(B)ar (K)eyboard (Support)
    BentoToolbarKeyboardSupportDirective.CSS_CLASS_NAME = 'bui-tb-k-support';
    /** @nocollapse */
    BentoToolbarKeyboardSupportDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: WindowRef },
        { type: Renderer2 },
        { type: NgbDropdown, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] }
    ]; };
BentoToolbarKeyboardSupportDirective.ɵfac = function BentoToolbarKeyboardSupportDirective_Factory(t) { return new (t || BentoToolbarKeyboardSupportDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; })))); };
BentoToolbarKeyboardSupportDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoToolbarKeyboardSupportDirective, selectors: [["", "bentoToolbarKeyboardSupport", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToolbarKeyboardSupportDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoToolbarKeyboardSupport]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc4.NgbDropdown, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }]; }, null); })();
    return BentoToolbarKeyboardSupportDirective;
}());
if (false) {
    /** @type {?} */
    BentoToolbarKeyboardSupportDirective.CSS_CLASS_NAME;
    /** @type {?} */
    BentoToolbarKeyboardSupportDirective.prototype.toggleEl;
    /** @type {?} */
    BentoToolbarKeyboardSupportDirective.prototype.dropdownMenuEl;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarKeyboardSupportDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarKeyboardSupportDirective.prototype.menuItems;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarKeyboardSupportDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarKeyboardSupportDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarKeyboardSupportDirective.prototype.dropdown;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/event.trigger.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Function is used to trigger mouse events manually
 * https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent
 * @param {?} node
 * @param {?} eventType
 * @param {?=} mouseEventInit
 * @return {?}
 */
function triggerMouseEvent(node, eventType, mouseEventInit) {
    /** @type {?} */
    var event = new MouseEvent(eventType, mouseEventInit || { bubbles: true, cancelable: true });
    node.dispatchEvent(event);
}
/**
 * Function is used to trigger mouse events manually
 * https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent
 * @param {?} node
 * @param {?} eventType
 * @param {?=} pointerEventInit
 * @return {?}
 */
function triggerPointerEvent(node, eventType, pointerEventInit) {
    /** @type {?} */
    var event = new PointerEvent(eventType, pointerEventInit || { bubbles: true, cancelable: true });
    node.dispatchEvent(event);
}
/**
 * Function is used to trigger mouse events manually
 * https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent/TouchEvent
 *
 * Supported Browsers: https://caniuse.com/#search=touch
 * @param {?} node
 * @param {?} eventType
 * @param {?=} touchEventInit
 * @return {?}
 */
function triggerTouchEvent(node, eventType, touchEventInit) {
    /** @type {?} */
    var event = new TouchEvent(eventType, touchEventInit || { bubbles: true, cancelable: true });
    node.dispatchEvent(event);
}
/**
 * Function is used to trigger keyboard events manually
 *
 * @param {?} node
 * @param {?} eventType
 * @param {?} keyCode
 * @param {?=} altKey
 * @param {?=} ctrlKey
 * @param {?=} shiftKey
 * @param {?=} metaKey
 * @param {?=} bubbles
 * @return {?}
 */
function triggerKeyboardEvent(node, eventType, keyCode, altKey, ctrlKey, shiftKey, metaKey, bubbles) {
    if (altKey === void 0) { altKey = false; }
    if (ctrlKey === void 0) { ctrlKey = false; }
    if (shiftKey === void 0) { shiftKey = false; }
    if (metaKey === void 0) { metaKey = false; }
    if (bubbles === void 0) { bubbles = false; }
    /** @type {?} */
    var e;
    e = createNewEvent(eventType, bubbles);
    e.key = String.fromCharCode(keyCode); // just enter the char you want to send
    e.keyCode = keyCode;
    e.charCode = keyCode;
    e.which = keyCode;
    e.altKey = altKey;
    e.ctrlKey = ctrlKey;
    e.shiftKey = shiftKey;
    e.metaKey = metaKey;
    node.dispatchEvent(e);
    return (/** @type {?} */ (e));
}
/**
 * Gain focus then send a string into an inputfield and notify the inputfield on change
 * @param {?} input
 * @param {?} str
 * @return {?}
 */
function sendKeyValueToInputWithString(input, str) {
    /** @type {?} */
    var lastCharCode = str.charCodeAt(str.length - 1);
    input.focus();
    input.value = str;
    triggerKeyboardEvent(input, 'keydown', lastCharCode);
    triggerKeyboardEvent(input, 'keypress', lastCharCode);
    triggerKeyboardEvent(input, 'input', lastCharCode);
    triggerKeyboardEvent(input, 'keyup', lastCharCode);
}
/**
 * @param {?} eventName
 * @param {?} bubbles
 * @return {?}
 */
function createNewEvent(eventName, bubbles) {
    /** @type {?} */
    var newEvent;
    if (typeof Event === 'function') {
        newEvent = new Event(eventName, { bubbles: bubbles });
    }
    else {
        try {
            // for IE 11
            newEvent = document.createEvent('Event');
            newEvent.initEvent(eventName, bubbles, true);
        }
        catch (e) { }
    }
    return newEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/scrollable-toolbar/scrollable-toolbar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Scrollable Toolbar similar to [Bento Toolbar](#/components/toolbar)
 * takes inspiration from the
 * [Bootstrap Navbar](https://getbootstrap.com/docs/4.0/components/navbar/), but
 * take pains to go beyond that to include responsive behaviors, as well as
 * ARIA roles as we work toward WCAG 2.0 Level AA (Accessibility) conformance.
 *
 * The content that displays menu items becomes side scrollable when visible
 * area becomes limited.
 *
 */
var BentoScrollableToolbarComponent = /** @class */ (function () {
    function BentoScrollableToolbarComponent(elRef, dir) {
        this.dir = dir;
        /**
         * Items that takes both `BentoToolbarItem` for default bahaviors similar to Bento Toolbar, or using own templates
         * for custom toolbar items
         */
        this.items = [];
        this.el = elRef.nativeElement;
    }
    /**
     * Listen to the left and right arrow key events
     */
    /**
     * Listen to the left and right arrow key events
     * @param {?} e
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.onElKeydown = /**
     * Listen to the left and right arrow key events
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var isRTL = this.dir.value === 'rtl';
        switch (e.keyCode) {
            case Keyboard.LEFT:
                this.shiftItemFocus(isRTL ? 1 : -1, e);
                break;
            case Keyboard.RIGHT:
                this.shiftItemFocus(isRTL ? -1 : 1, e);
                break;
            case Keyboard.TAB:
                /** @type {?} */
                var item = void 0;
                /** @type {?} */
                var targetClassName = ((/** @type {?} */ (e.target))).className.trim();
                if (e.shiftKey && targetClassName === 'bento-scrollable-bar-side-arrow right') {
                    item = this.findVisibleMenuItem(false);
                }
                else if (targetClassName === 'bento-scrollable-bar-side-arrow left' && !e.shiftKey) {
                    item = this.findVisibleMenuItem();
                }
                if (item) {
                    item.focus();
                    e.preventDefault();
                }
                break;
        }
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.onElementFocus = /**
     * @param {?} el
     * @return {?}
     */
    function (el) {
        if (el.classList.contains('bui-menu-item')) {
            this.currentFocusedEl = el;
        }
    };
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     */
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.refresh = /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with `display:none;`
     * @return {?}
     */
    function () {
        this.scrollBar.refresh();
    };
    /**
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () { };
    /**
     * Keydown listener for the scrollable bar
     */
    /**
     * Keydown listener for the scrollable bar
     * @param {?} e
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype._onScrollableBarKeydown = /**
     * Keydown listener for the scrollable bar
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var target = (/** @type {?} */ (e.target));
        if (e.keyCode === Keyboard.TAB && !target.classList.contains('bento-scrollable-bar-side-arrow')) {
            /** @type {?} */
            var anchor = (/** @type {?} */ (this.scrollBar.el.querySelector(e.shiftKey ? '.bento-scrollable-bar-left-anchor' : '.bento-scrollable-bar-right-anchor')));
            anchor.focus();
        }
    };
    /**
     * Find visible menu in scrollable pane
     */
    /**
     * Find visible menu in scrollable pane
     * @private
     * @param {?=} fromLeft
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.findVisibleMenuItem = /**
     * Find visible menu in scrollable pane
     * @private
     * @param {?=} fromLeft
     * @return {?}
     */
    function (fromLeft) {
        if (fromLeft === void 0) { fromLeft = true; }
        /** @type {?} */
        var scrollEl = this.scrollBar.innerEl;
        /** @type {?} */
        var itemArray = Array.from(scrollEl.querySelectorAll('bento-scrollable-toolbar-item'));
        /** @type {?} */
        var itemArraySize = itemArray.length;
        /** @type {?} */
        var viewLeft = scrollEl.scrollLeft;
        /** @type {?} */
        var viewRight = viewLeft + scrollEl.offsetWidth;
        /** @type {?} */
        var itemToFocus;
        if (fromLeft) {
            for (var i = 0; i < itemArraySize; i++) {
                /** @type {?} */
                var item = itemArray[i];
                if ((itemToFocus = this.isItemInView(item, viewLeft, viewRight))) {
                    return itemToFocus;
                }
            }
        }
        else {
            for (var i = itemArraySize - 1; i >= 0; i--) {
                /** @type {?} */
                var item = itemArray[i];
                if ((itemToFocus = this.isItemInView(item, viewLeft, viewRight))) {
                    return itemToFocus;
                }
            }
        }
    };
    /**
     * @private
     * @param {?} el
     * @param {?} viewLeft
     * @param {?} viewRight
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.isItemInView = /**
     * @private
     * @param {?} el
     * @param {?} viewLeft
     * @param {?} viewRight
     * @return {?}
     */
    function (el, viewLeft, viewRight) {
        /** @type {?} */
        var elCenter = (el.offsetLeft * 2 + el.offsetWidth) * 0.5;
        /** @type {?} */
        var item = el.querySelector('.bui-menu-item:not(:disabled)');
        if (item && elCenter > viewLeft && elCenter < viewRight) {
            return item;
        }
        return null;
    };
    /**
     * Shift and focus to the next element based on the index
     */
    /**
     * Shift and focus to the next element based on the index
     * @private
     * @param {?} direction
     * @param {?} e
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.shiftItemFocus = /**
     * Shift and focus to the next element based on the index
     * @private
     * @param {?} direction
     * @param {?} e
     * @return {?}
     */
    function (direction, e) {
        if (this.currentFocusedEl.tagName === 'INPUT' && this.currentFocusedEl['type'] === 'text') {
            // For input type="text"
            /** @type {?} */
            var inputEl = (/** @type {?} */ (this.currentFocusedEl));
            /** @type {?} */
            var start = inputEl.selectionStart;
            /** @type {?} */
            var end = inputEl.selectionEnd;
            /** @type {?} */
            var inputLength = inputEl.value ? inputEl.value.length : 0;
            if (start === end) {
                if ((direction === 1 && start < inputLength) || (direction === -1 && start > 0)) {
                    return;
                }
            }
        }
        /** @type {?} */
        var els = this.getAriaHaspopupEl();
        /** @type {?} */
        var activeElIndex = els.indexOf(this.currentFocusedEl);
        /** @type {?} */
        var activeExpanded = this.currentFocusedEl
            ? this.currentFocusedEl.getAttribute('aria-expanded') === 'true'
            : false;
        /** @type {?} */
        var elToFocus = els[(activeElIndex + direction + els.length) % els.length];
        elToFocus.focus();
        e.preventDefault();
        if (activeExpanded && elToFocus.classList.contains('dropdown-toggle')) {
            // Manually trigger down arrow event for BentoDropdownKeyboardSupportDirective to catch the expansion
            triggerKeyboardEvent(elToFocus, 'keydown', Keyboard.DOWN);
        }
    };
    /**
     * All elements that are disabled with `.bui-menu-item` will be selected
     */
    /**
     * All elements that are disabled with `.bui-menu-item` will be selected
     * @private
     * @return {?}
     */
    BentoScrollableToolbarComponent.prototype.getAriaHaspopupEl = /**
     * All elements that are disabled with `.bui-menu-item` will be selected
     * @private
     * @return {?}
     */
    function () {
        return Array.from(this.el.querySelectorAll('.bui-menu-item:not(:disabled)'));
    };
    /** @nocollapse */
    BentoScrollableToolbarComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Directionality }
    ]; };
    BentoScrollableToolbarComponent.propDecorators = {
        items: [{ type: Input }],
        scrollBar: [{ type: ViewChild, args: [BentoScrollableBarComponent, { static: true },] }],
        onElKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
        onElementFocus: [{ type: HostListener, args: ['focusin', ['$event.target'],] }]
    };
BentoScrollableToolbarComponent.ɵfac = function BentoScrollableToolbarComponent_Factory(t) { return new (t || BentoScrollableToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoScrollableToolbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoScrollableToolbarComponent, selectors: [["bento-scrollable-toolbar"]], viewQuery: function BentoScrollableToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(BentoScrollableBarComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollBar = _t.first);
    } }, hostBindings: function BentoScrollableToolbarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function BentoScrollableToolbarComponent_keydown_HostBindingHandler($event) { return ctx.onElKeydown($event); })("focusin", function BentoScrollableToolbarComponent_focusin_HostBindingHandler($event) { return ctx.onElementFocus($event.target); });
    } }, inputs: { items: "items" }, ngContentSelectors: _c48, decls: 8, vars: 1, consts: [[1, "bento-scrollable-toolbar-wrapper", "bui-bento-toolbar", "bento-toolbar"], ["role", "menu", 1, "bento-scrollable-toolbar-inner"], [1, "navbar-nav"], [3, "keydown"], [1, "bento-scrollable-toolbar-inner-menu"], [4, "ngFor", "ngForOf"], [3, "item", "appendTo"]], template: function BentoScrollableToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c47);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "bento-scrollable-bar", 3);
        ɵngcc0.ɵɵlistener("keydown", function BentoScrollableToolbarComponent_Template_bento_scrollable_bar_keydown_4_listener($event) { return ctx._onScrollableBarKeydown($event); });
        ɵngcc0.ɵɵelementStart(5, "ul", 4);
        ɵngcc0.ɵɵtemplate(6, BentoScrollableToolbarComponent_li_6_Template, 2, 2, "li", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(7, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [BentoScrollableBarComponent, ɵngcc7.NgForOf, BentoScrollableToolbarItemComponent], styles: [".bui-bento-toolbar,bento-toolbar{border-style:solid;border-width:1px}.bui-bento-toolbar .bento-smart-badge,bento-toolbar .bento-smart-badge{position:relative;left:auto;right:auto;vertical-align:super;display:inline-block;bottom:4px;line-height:10px}.bui-bento-toolbar .navbar-nav,bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.bui-bento-toolbar .navbar-nav>li.transparent,bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,bento-toolbar .navbar-nav>li.transparent{opacity:0;height:1px}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav>li>a,.bui-bento-toolbar .navbar-nav>li>button,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav>li>a,bento-toolbar .navbar-nav>li>button{border:none;background:0 0;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav>li>a:focus,.bui-bento-toolbar .navbar-nav>li>button:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav>li>a:focus,bento-toolbar .navbar-nav>li>button:focus{outline:0}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,bento-toolbar .navbar-nav>li a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav>li a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.bui-bento-toolbar .divider,bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.bui-bento-toolbar .navbar-nav .dropdown-toggle span,bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.bui-bento-toolbar .navbar-nav .dropdown-toggle:after,bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .bui-bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.bui-bento-toolbar [ngbdropdown],bento-toolbar [ngbdropdown]{display:block;position:relative}.bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.bui-bento-toolbar [ngbdropdown] .dropdown-menu,bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu:after,.bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,bento-toolbar [ngbdropdown] .dropdown-menu:after,bento-toolbar [ngbdropdown] .dropdown-menu:before{content:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button,bento-toolbar [ngbdropdown] .dropdown-menu a,bento-toolbar [ngbdropdown] .dropdown-menu button{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-]{vertical-align:middle}[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu button{text-align:right;padding:0 15px 0 30px}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused{outline:0;border-width:1px;border-style:dashed}.bui-bento-toolbar [ngbdropdown] a.disabled:hover,.bui-bento-toolbar [ngbdropdown] a:disabled:hover,.bui-bento-toolbar [ngbdropdown] a[disabled]:hover,.bui-bento-toolbar [ngbdropdown] button.disabled:hover,.bui-bento-toolbar [ngbdropdown] button:disabled:hover,.bui-bento-toolbar [ngbdropdown] button[disabled]:hover,bento-toolbar [ngbdropdown] a.disabled:hover,bento-toolbar [ngbdropdown] a:disabled:hover,bento-toolbar [ngbdropdown] a[disabled]:hover,bento-toolbar [ngbdropdown] button.disabled:hover,bento-toolbar [ngbdropdown] button:disabled:hover,bento-toolbar [ngbdropdown] button[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown,bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.bui-bento-toolbar .open.toolbar-dropdown-menu,bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.bui-bento-toolbar .more-button,bento-toolbar .more-button{visibility:hidden}.bui-bento-toolbar .more-button.visible,bento-toolbar .more-button.visible{visibility:visible}.bui-bento-toolbar .toolbar-dropdown-toggle:after,bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .bui-bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled],bento-toolbar .toolbar-dropdown-toggle.disabled,bento-toolbar .toolbar-dropdown-toggle:disabled,bento-toolbar .toolbar-dropdown-toggle[disabled]{cursor:pointer}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,bento-toolbar .toolbar-dropdown-toggle.disabled:hover,bento-toolbar .toolbar-dropdown-toggle:disabled:hover,bento-toolbar .toolbar-dropdown-toggle[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown-menu,bento-toolbar .toolbar-dropdown-menu{transition:.3s ease-out;overflow:hidden;padding:0;list-style:none;max-height:0;visibility:hidden}.bui-bento-toolbar .toolbar-dropdown-menu .divider,bento-toolbar .toolbar-dropdown-menu .divider{display:block}.bui-bento-toolbar .toolbar-dropdown-menu>li>a,bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.bui-bento-toolbar.bg-faded,bento-toolbar.bg-faded{border:none}.bui-bento-toolbar .bento-toolbar-custom-item,bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.bui-bento-toolbar .bento-toolbar-custom-item label,bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .bui-bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}", "bento-scrollable-toolbar{display:block}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav,bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:1px 0;height:100%}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled,bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled]{background:0 0}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoScrollableToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'bento-scrollable-toolbar',
                encapsulation: ViewEncapsulation.None,
                template: "<div class=\"bento-scrollable-toolbar-wrapper bui-bento-toolbar bento-toolbar\">\n  <div class=\"bento-scrollable-toolbar-inner\" role=\"menu\">\n    <ng-content select=\".navbar-left\"></ng-content>\n    <div class=\"navbar-nav\">\n      <bento-scrollable-bar (keydown)=\"_onScrollableBarKeydown($event)\">\n        <ul class=\"bento-scrollable-toolbar-inner-menu\">\n          <li *ngFor=\"let item of items\">\n            <bento-scrollable-toolbar-item [item]=\"item\" [appendTo]=\"el\"></bento-scrollable-toolbar-item>\n          </li>\n        </ul>\n      </bento-scrollable-bar>\n    </div>\n    <ng-content select=\".navbar-right\"></ng-content>\n  </div>\n</div>\n",
                styles: [".bui-bento-toolbar,bento-toolbar{border-style:solid;border-width:1px}.bui-bento-toolbar .bento-smart-badge,bento-toolbar .bento-smart-badge{position:relative;left:auto;right:auto;vertical-align:super;display:inline-block;bottom:4px;line-height:10px}.bui-bento-toolbar .navbar-nav,bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.bui-bento-toolbar .navbar-nav>li.transparent,bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,bento-toolbar .navbar-nav>li.transparent{opacity:0;height:1px}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav>li>a,.bui-bento-toolbar .navbar-nav>li>button,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav>li>a,bento-toolbar .navbar-nav>li>button{border:none;background:0 0;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav>li>a:focus,.bui-bento-toolbar .navbar-nav>li>button:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav>li>a:focus,bento-toolbar .navbar-nav>li>button:focus{outline:0}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,bento-toolbar .navbar-nav>li a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav>li a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.bui-bento-toolbar .divider,bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.bui-bento-toolbar .navbar-nav .dropdown-toggle span,bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.bui-bento-toolbar .navbar-nav .dropdown-toggle:after,bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .bui-bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.bui-bento-toolbar [ngbdropdown],bento-toolbar [ngbdropdown]{display:block;position:relative}.bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.bui-bento-toolbar [ngbdropdown] .dropdown-menu,bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu:after,.bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,bento-toolbar [ngbdropdown] .dropdown-menu:after,bento-toolbar [ngbdropdown] .dropdown-menu:before{content:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button,bento-toolbar [ngbdropdown] .dropdown-menu a,bento-toolbar [ngbdropdown] .dropdown-menu button{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-]{vertical-align:middle}[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu button{text-align:right;padding:0 15px 0 30px}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused{outline:0;border-width:1px;border-style:dashed}.bui-bento-toolbar [ngbdropdown] a.disabled:hover,.bui-bento-toolbar [ngbdropdown] a:disabled:hover,.bui-bento-toolbar [ngbdropdown] a[disabled]:hover,.bui-bento-toolbar [ngbdropdown] button.disabled:hover,.bui-bento-toolbar [ngbdropdown] button:disabled:hover,.bui-bento-toolbar [ngbdropdown] button[disabled]:hover,bento-toolbar [ngbdropdown] a.disabled:hover,bento-toolbar [ngbdropdown] a:disabled:hover,bento-toolbar [ngbdropdown] a[disabled]:hover,bento-toolbar [ngbdropdown] button.disabled:hover,bento-toolbar [ngbdropdown] button:disabled:hover,bento-toolbar [ngbdropdown] button[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown,bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.bui-bento-toolbar .open.toolbar-dropdown-menu,bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.bui-bento-toolbar .more-button,bento-toolbar .more-button{visibility:hidden}.bui-bento-toolbar .more-button.visible,bento-toolbar .more-button.visible{visibility:visible}.bui-bento-toolbar .toolbar-dropdown-toggle:after,bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .bui-bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled],bento-toolbar .toolbar-dropdown-toggle.disabled,bento-toolbar .toolbar-dropdown-toggle:disabled,bento-toolbar .toolbar-dropdown-toggle[disabled]{cursor:pointer}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,bento-toolbar .toolbar-dropdown-toggle.disabled:hover,bento-toolbar .toolbar-dropdown-toggle:disabled:hover,bento-toolbar .toolbar-dropdown-toggle[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown-menu,bento-toolbar .toolbar-dropdown-menu{transition:.3s ease-out;overflow:hidden;padding:0;list-style:none;max-height:0;visibility:hidden}.bui-bento-toolbar .toolbar-dropdown-menu .divider,bento-toolbar .toolbar-dropdown-menu .divider{display:block}.bui-bento-toolbar .toolbar-dropdown-menu>li>a,bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.bui-bento-toolbar.bg-faded,bento-toolbar.bg-faded{border:none}.bui-bento-toolbar .bento-toolbar-custom-item,bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.bui-bento-toolbar .bento-toolbar-custom-item label,bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .bui-bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}", "bento-scrollable-toolbar{display:block}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left,bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav,bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{white-space:nowrap;display:table-cell;position:relative;height:100%;float:none;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-left{padding:0 10px}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right{padding-left:10px;float:none!important}bento-scrollable-toolbar .bui-bento-toolbar .navbar-right>li{float:none;display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar .navbar-nav{width:100%}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar{position:absolute;display:flex;align-items:center;top:-1px;left:-1px;right:-1px}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-bar .bento-scrollable-bar-inner{padding:1px;line-height:0;display:flex;align-items:center}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item{display:inline-block;vertical-align:middle}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .form-control,bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .input-group{display:inline-block}bento-scrollable-toolbar .bui-bento-toolbar bento-scrollable-toolbar-item .btn.btn-icon{vertical-align:bottom}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner{direction:ltr}[dir=rtl] bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-inner>div{direction:rtl}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow{border-style:solid;border-width:1px 0;height:100%}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.left{left:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.right{right:1px}bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow.disabled,bento-scrollable-toolbar .bui-bento-toolbar button.bento-scrollable-bar-side-arrow[disabled]{background:0 0}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-toggle:active{color:inherit}bento-scrollable-toolbar .bui-bento-toolbar .bento-scrollable-bar-cover{top:1px;height:calc(100% - 2px)}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item{padding:0 15px}bento-scrollable-toolbar .bui-bento-toolbar .dropdown-item label{width:100%;margin:0}ul.bento-scrollable-toolbar-inner-menu{margin:0;padding:0;white-space:nowrap}ul.bento-scrollable-toolbar-inner-menu>li{list-style:none;display:inline-block}.bento-scrollable-toolbar-wrapper.bui-bento-toolbar{display:table}.bui-bento-toolbar .bento-scrollable-toolbar-inner{display:table-row}.bui-bento-scrollable-toolbar-dropdown-menu button{padding-top:7.7px;padding-bottom:7.7px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item{padding:0 15px}.bui-bento-scrollable-toolbar-dropdown-menu .dropdown-item label{width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc6.Directionality }]; }, { items: [{
            type: Input
        }], onElKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], onElementFocus: [{
            type: HostListener,
            args: ['focusin', ['$event.target']]
        }], scrollBar: [{
            type: ViewChild,
            args: [BentoScrollableBarComponent, { static: true }]
        }] }); })();
    return BentoScrollableToolbarComponent;
}());
if (false) {
    /**
     * Items that takes both `BentoToolbarItem` for default bahaviors similar to Bento Toolbar, or using own templates
     * for custom toolbar items
     * @type {?}
     */
    BentoScrollableToolbarComponent.prototype.items;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarComponent.prototype.scrollBar;
    /** @type {?} */
    BentoScrollableToolbarComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarComponent.prototype.currentFocusedEl;
    /**
     * @type {?}
     * @private
     */
    BentoScrollableToolbarComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/scrollable-toolbar/scrollable-toolbar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoScrollableToolbarModule = /** @class */ (function () {
    function BentoScrollableToolbarModule() {
    }
BentoScrollableToolbarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoScrollableToolbarModule });
BentoScrollableToolbarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoScrollableToolbarModule_Factory(t) { return new (t || BentoScrollableToolbarModule)(); }, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoScrollableBarModule,
            BentoAppendToModule,
            NgbDropdownModule,
            BentoMegamenuModule,
            BentoFocusMonitorModule,
            A11yModule,
            BentoNgbDropdownAnimationModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoScrollableToolbarModule, { declarations: function () { return [BentoScrollableToolbarComponent,
        BentoScrollableToolbarItemComponent,
        BentoToolbarKeyboardSupportDirective]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        BentoScrollableBarModule,
        BentoAppendToModule,
        NgbDropdownModule,
        BentoMegamenuModule,
        BentoFocusMonitorModule,
        A11yModule,
        BentoNgbDropdownAnimationModule]; }, exports: function () { return [BentoScrollableToolbarComponent,
        BentoToolbarKeyboardSupportDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoScrollableToolbarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoTranslateModule,
                    BentoScrollableBarModule,
                    BentoAppendToModule,
                    NgbDropdownModule,
                    BentoMegamenuModule,
                    BentoFocusMonitorModule,
                    A11yModule,
                    BentoNgbDropdownAnimationModule
                ],
                declarations: [
                    BentoScrollableToolbarComponent,
                    BentoScrollableToolbarItemComponent,
                    BentoToolbarKeyboardSupportDirective
                ],
                exports: [BentoScrollableToolbarComponent, BentoToolbarKeyboardSupportDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoScrollableToolbarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/side-nav/side-nav.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BentoSideNavTemplateContext() { }
if (false) {
    /**
     * Side nav item data object that is used for this row
     * @type {?}
     */
    BentoSideNavTemplateContext.prototype.item;
}
var BentoSideNavComponent = /** @class */ (function () {
    function BentoSideNavComponent(r, elRef, uidGen) {
        /**
         * Item array that is used in component template
         */
        this._itemsForRender = [];
        /**
         * Flag to determine if category items are collapsible
         */
        this.collapsible = false;
        /**
         * Flag to determine if category items only serve as expand and collapse when clicked
         */
        this.categoryExpandOnly = false;
        /**
         * Flag to determine if category items are selectable or not
         */
        this.selectableCategories = true;
        /**
         * Flag to determine if the side navigation can be searched
         */
        this.searchable = false;
        /**
         * Value is used to update searches
         */
        this.searchValue = '';
        /**
         * Callback when an item is selected in the side navigation component
         */
        this.select = new EventEmitter();
        r.setAttribute(elRef.nativeElement, 'role', 'navigation');
        this.uid = "bui-" + uidGen.generate();
        this._self = this;
    }
    Object.defineProperty(BentoSideNavComponent.prototype, "_items", {
        /**
         * Side navigation menu item array
         */
        set: /**
         * Side navigation menu item array
         * @param {?} items
         * @return {?}
         */
        function (items) {
            this.items = items;
            this._itemsForRender = items;
            this.searchValue = '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set current side navigation item
     */
    /**
     * Set current side navigation item
     * @param {?} item
     * @param {?=} emitEvent
     * @return {?}
     */
    BentoSideNavComponent.prototype._setCurrentSideNavItem = /**
     * Set current side navigation item
     * @param {?} item
     * @param {?=} emitEvent
     * @return {?}
     */
    function (item, emitEvent) {
        if (emitEvent === void 0) { emitEvent = true; }
        if (this.currentItem === item) {
            return;
        }
        if (this.currentItem) {
            this.currentItem.selected = false;
        }
        this.currentItem = item;
        if (emitEvent) {
            this.select.emit(item);
            this._onSearchValueChange('');
        }
    };
    /**
     * Callback when the search field value changes
     */
    /**
     * Callback when the search field value changes
     * @param {?} v
     * @return {?}
     */
    BentoSideNavComponent.prototype._onSearchValueChange = /**
     * Callback when the search field value changes
     * @param {?} v
     * @return {?}
     */
    function (v) {
        var _this = this;
        this.searchValue = v == null ? '' : v.trim();
        if (this.bentoReset) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                // Need to align close button when and if the container height changes
                // with the appearance and diappearance of its vertical scrollbar
                _this.bentoReset.alignCloseButton();
            }));
        }
    };
    /** @nocollapse */
    BentoSideNavComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: BentoUidService }
    ]; };
    BentoSideNavComponent.propDecorators = {
        _items: [{ type: Input, args: ['items',] }],
        collapsible: [{ type: HostBinding, args: ['class.bui-side-nav-collapsible',] }, { type: Input }],
        categoryExpandOnly: [{ type: Input }],
        selectableCategories: [{ type: Input }],
        searchable: [{ type: Input }],
        itemTemplate: [{ type: Input }],
        filterCompareFunc: [{ type: Input }],
        select: [{ type: Output }],
        bentoReset: [{ type: ViewChild, args: [BentoResetDirective,] }]
    };
BentoSideNavComponent.ɵfac = function BentoSideNavComponent_Factory(t) { return new (t || BentoSideNavComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoSideNavComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSideNavComponent, selectors: [["bento-side-nav"]], viewQuery: function BentoSideNavComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoResetDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bentoReset = _t.first);
    } }, hostVars: 2, hostBindings: function BentoSideNavComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bui-side-nav-collapsible", ctx.collapsible);
    } }, inputs: { collapsible: "collapsible", categoryExpandOnly: "categoryExpandOnly", selectableCategories: "selectableCategories", searchable: "searchable", _items: ["items", "_items"], itemTemplate: "itemTemplate", filterCompareFunc: "filterCompareFunc" }, outputs: { select: "select" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoUidService])], decls: 4, vars: 3, consts: [["class", "sr-only", 4, "ngIf"], ["bentoReset", "", "class", "form-control", 3, "ngModel", "ngModelChange", 4, "ngIf"], ["bentoSideNavItem", "", 3, "item", "depth", "sideNav", "collapsible", "searchValue", 4, "ngFor", "ngForOf"], [1, "sr-only"], ["bentoReset", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["bentoSideNavItem", "", 3, "item", "depth", "sideNav", "collapsible", "searchValue"]], template: function BentoSideNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoSideNavComponent_label_0_Template, 3, 4, "label", 0);
        ɵngcc0.ɵɵtemplate(1, BentoSideNavComponent_input_1_Template, 2, 5, "input", 1);
        ɵngcc0.ɵɵelementStart(2, "ul");
        ɵngcc0.ɵɵtemplate(3, BentoSideNavComponent_li_3_Template, 1, 5, "li", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchable);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._itemsForRender);
    } }, directives: function () { return [ɵngcc7.NgIf, ɵngcc7.NgForOf, ɵngcc8.DefaultValueAccessor, BentoResetDirective, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, BentoSideNavItemComponent]; }, pipes: function () { return [BentoTranslatePipe]; }, styles: ["[_nghost-%COMP%]{padding:10px 0;display:block;position:relative;border-right-style:solid;border-right-width:1px}[_nghost-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}[_nghost-%COMP%] > .form-control[_ngcontent-%COMP%]{margin:0 10px 10px;width:calc(100% - 20px)}[dir=rtl][_nghost-%COMP%], [dir=rtl]   [_nghost-%COMP%]{border-right:none;border-left-style:solid;border-left-width:1px}"], changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSideNavComponent, [{
        type: Component,
        args: [{
                selector: 'bento-side-nav',
                template: "<label *ngIf=\"searchable\" class=\"sr-only\" [attr.for]=\"uid + '-input'\">\n  {{ 'BENTO_UI_SIDE_NAV_SEARCH' | bentoTranslate }}\n</label>\n<input\n  *ngIf=\"searchable\"\n  bentoReset\n  class=\"form-control\"\n  [attr.id]=\"uid + '-input'\"\n  [attr.placeholder]=\"'BENTO_UI_SIDE_NAV_SEARCH' | bentoTranslate\"\n  [ngModel]=\"searchValue\"\n  (ngModelChange)=\"_onSearchValueChange($event)\"\n/>\n<ul>\n  <li\n    bentoSideNavItem\n    *ngFor=\"let item of _itemsForRender\"\n    [item]=\"item\"\n    [depth]=\"0\"\n    [sideNav]=\"_self\"\n    [collapsible]=\"collapsible\"\n    [searchValue]=\"searchValue\"\n  ></li>\n</ul>\n",
                providers: [BentoUidService],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{padding:10px 0;display:block;position:relative;border-right-style:solid;border-right-width:1px}:host ul{padding:0}:host>.form-control{margin:0 10px 10px;width:calc(100% - 20px)}:host-context([dir=rtl]){border-right:none;border-left-style:solid;border-left-width:1px}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: BentoUidService }]; }, { collapsible: [{
            type: HostBinding,
            args: ['class.bui-side-nav-collapsible']
        }, {
            type: Input
        }], categoryExpandOnly: [{
            type: Input
        }], selectableCategories: [{
            type: Input
        }], searchable: [{
            type: Input
        }], select: [{
            type: Output
        }], _items: [{
            type: Input,
            args: ['items']
        }], itemTemplate: [{
            type: Input
        }], filterCompareFunc: [{
            type: Input
        }], bentoReset: [{
            type: ViewChild,
            args: [BentoResetDirective]
        }] }); })();
    return BentoSideNavComponent;
}());
if (false) {
    /**
     * Item array that is used in this side navigation
     * @type {?}
     */
    BentoSideNavComponent.prototype.items;
    /**
     * Item array that is used in component template
     * @type {?}
     */
    BentoSideNavComponent.prototype._itemsForRender;
    /**
     * Flag to determine if category items are collapsible
     * @type {?}
     */
    BentoSideNavComponent.prototype.collapsible;
    /**
     * Flag to determine if category items only serve as expand and collapse when clicked
     * @type {?}
     */
    BentoSideNavComponent.prototype.categoryExpandOnly;
    /**
     * Flag to determine if category items are selectable or not
     * @type {?}
     */
    BentoSideNavComponent.prototype.selectableCategories;
    /**
     * Flag to determine if the side navigation can be searched
     * @type {?}
     */
    BentoSideNavComponent.prototype.searchable;
    /**
     * Custom navigation item label template
     * @type {?}
     */
    BentoSideNavComponent.prototype.itemTemplate;
    /**
     * Custom filter compare function
     *
     * `type BentoSideNavFilterCompareFunc = (item: BentoSideNavItem, find: string) => boolean;`
     * @type {?}
     */
    BentoSideNavComponent.prototype.filterCompareFunc;
    /**
     * Value is used to update searches
     * @type {?}
     */
    BentoSideNavComponent.prototype.searchValue;
    /**
     * Callback when an item is selected in the side navigation component
     * @type {?}
     */
    BentoSideNavComponent.prototype.select;
    /**
     * UID of this side navigation component
     * @type {?}
     */
    BentoSideNavComponent.prototype.uid;
    /**
     * Reference to Bento Reset Directive
     * @type {?}
     * @private
     */
    BentoSideNavComponent.prototype.bentoReset;
    /**
     * Side Nav instance
     * @type {?}
     */
    BentoSideNavComponent.prototype._self;
    /**
     * Current selected side navigation item
     * @type {?}
     * @private
     */
    BentoSideNavComponent.prototype.currentItem;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/side-nav/side-nav-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable component-selector */
/**
 * Bento Side Navigation item component
 */
var BentoSideNavItemComponent = /** @class */ (function () {
    function BentoSideNavItemComponent(r, cd, router, uidGen, elRef, bidi, ngZone) {
        var _this = this;
        this.r = r;
        this.cd = cd;
        /**
         * Depth indicator to get the number of levels that it's away from the root item
         */
        this.depth = 0;
        /**
         * Flag to determine if this navigation item is collapsible
         */
        this.collapsible = false;
        /**
         * Select state change event emitter
         */
        this.selectedChange = new EventEmitter();
        /**
         * Flag to show if this item is a branch (aka category)
         */
        this.isBranch = false;
        /**
         * Flag to determine if this component is in a RTL environment
         */
        this.isRTL = false;
        /**
         * Flag to determine if the item data object has been initialized or not
         * to support rendering and event triggering
         */
        this.isDataInitialized = false;
        this.bidiSubscription = Subscription.EMPTY;
        this.routerEventSubscription = Subscription.EMPTY;
        this.el = elRef.nativeElement;
        this.uid = "bui-" + uidGen.generate();
        this.isRTL = bidi.value === 'rtl';
        this.bidiSubscription = bidi.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRTL = bidi.value === 'rtl';
            cd.markForCheck();
        }));
        this.r.setAttribute(this.el, 'id', this.uid + '-li');
        if (router) {
            this.routerEventSubscription = router.events.subscribe((/**
             * @param {?} event
             * @return {?}
             */
            function (event) {
                if (event instanceof NavigationEnd) {
                    _this.cd.markForCheck();
                }
            }));
        }
        /** @type {?} */
        var ngZoneSub = ngZone.onStable.subscribe((/**
         * @return {?}
         */
        function () {
            if (_this.rla && _this.rla.isActive && !_this.selected) {
                // When this component is dynamically recreated, we need to
                // have another round of change detection to make sure that
                // this.rla.isActive is properly updated and rendered with
                // the current `page` or `location` states
                _this.cd.markForCheck();
            }
            // Only execute this method once in the beginning
            ngZoneSub.unsubscribe();
        }));
    }
    Object.defineProperty(BentoSideNavItemComponent.prototype, "_item", {
        /**
         * Side navigation item data object that is used in this component
         */
        set: /**
         * Side navigation item data object that is used in this component
         * @param {?} item
         * @return {?}
         */
        function (item) {
            this.item = item;
            this.hookItemEvents(item);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSideNavItemComponent.prototype, "searchValue", {
        /**
         * Using template to forward search (aka filter) value that is entered by user
         */
        set: /**
         * Using template to forward search (aka filter) value that is entered by user
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v != null && this.sideNav) {
                // Only filter when the value `v` exists
                this.filter(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSideNavItemComponent.prototype, "_sideNav", {
        /**
         * Object reference to BentoSideNav component
         */
        set: /**
         * Object reference to BentoSideNav component
         * @param {?} sideNav
         * @return {?}
         */
        function (sideNav) {
            this.sideNav = sideNav;
            if (sideNav && this.selected) {
                this.sideNav._setCurrentSideNavItem(this.item, this.isDataInitialized);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSideNavItemComponent.prototype, "_viewItems", {
        /**
         * Get all the child items if there are some
         */
        set: /**
         * Get all the child items if there are some
         * @param {?} items
         * @return {?}
         */
        function (items) {
            this.viewItems = items.toArray();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSideNavItemComponent.prototype, "ariaCurrent", {
        get: /**
         * @return {?}
         */
        function () {
            return this._ariaCurrent;
        },
        set: /**
         * @param {?} c
         * @return {?}
         */
        function (c) {
            this._ariaCurrent = c;
            switch (c) {
                case 'page':
                    this.r.addClass(this.el, 'current-page');
                    this.r.removeClass(this.el, 'current-location');
                    break;
                case 'location':
                    this.r.addClass(this.el, 'current-location');
                    this.r.removeClass(this.el, 'current-page');
                    break;
                default:
                    this.r.removeClass(this.el, 'current-location');
                    this.r.removeClass(this.el, 'current-page');
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.setAriaExpandedAttribute();
        }));
    };
    /**
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.bidiSubscription.unsubscribe();
        this.routerEventSubscription.unsubscribe();
    };
    /**
     * Method to set this item as a branch (aka category) or not based on its property
     * @param v flag to determine if this item is going to be a branch (aka category) or not
     */
    /**
     * Method to set this item as a branch (aka category) or not based on its property
     * @param {?} v flag to determine if this item is going to be a branch (aka category) or not
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.setAsBranch = /**
     * Method to set this item as a branch (aka category) or not based on its property
     * @param {?} v flag to determine if this item is going to be a branch (aka category) or not
     * @return {?}
     */
    function (v) {
        this.isBranch = v;
        this.r.removeClass(this.el, 'bento-side-nav-leaf');
        this.r.removeClass(this.el, 'bento-side-nav-branch');
        this.r.addClass(this.el, v ? 'bento-side-nav-branch' : 'bento-side-nav-leaf');
    };
    /**
     * Callback when one of this item's children is selected
     * @param s Selected flag
     */
    /**
     * Callback when one of this item's children is selected
     * @param {?} s Selected flag
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.onChildSelectedChange = /**
     * Callback when one of this item's children is selected
     * @param {?} s Selected flag
     * @return {?}
     */
    function (s) {
        if (s) {
            this.ariaCurrent = 'location';
        }
        else {
            this.ariaCurrent = null;
        }
        this.selectedChange.emit(s);
        this.cd.detectChanges();
    };
    /**
     * Callback when the label of this navigation item is clicked
     * @param e Mouse event object
     */
    /**
     * Callback when the label of this navigation item is clicked
     * @param {?} e Mouse event object
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.onItemClick = /**
     * Callback when the label of this navigation item is clicked
     * @param {?} e Mouse event object
     * @return {?}
     */
    function (e) {
        if (this.disabled) {
            // No need to do anything when this item is disabled
            return;
        }
        if (this.isBranch && this.sideNav.categoryExpandOnly) {
            this.toggleCollapse();
        }
        else if (!this.selected && (!this.isBranch || this.sideNav.selectableCategories)) {
            this.item.selected = true;
        }
        if (this.item.action && this.selected) {
            // fire item action function callback if there is one
            this.item.action(e);
        }
    };
    /**
     * Toggle current collapsed state
     */
    /**
     * Toggle current collapsed state
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.toggleCollapse = /**
     * Toggle current collapsed state
     * @return {?}
     */
    function () {
        this.collapsed = !this.collapsed;
        this.setAriaExpandedAttribute();
    };
    /**
     * set collapsed attribute
     */
    /**
     * set collapsed attribute
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.setAriaExpandedAttribute = /**
     * set collapsed attribute
     * @return {?}
     */
    function () {
        if (this.isBranch && this.collapsible) {
            this.r.setAttribute(this.el, 'aria-expanded', String(!this.collapsed));
        }
    };
    /**
     * Filter this item and its offspring to findout if they should be shown in viewport
     * @param searchValue Actual filter string to be used
     */
    /**
     * Filter this item and its offspring to findout if they should be shown in viewport
     * @param {?} searchValue Actual filter string to be used
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.filter = /**
     * Filter this item and its offspring to findout if they should be shown in viewport
     * @param {?} searchValue Actual filter string to be used
     * @return {?}
     */
    function (searchValue) {
        var e_1, _a;
        /** @type {?} */
        var compareFunc = this.sideNav.filterCompareFunc || this.defaultCompareFunc;
        /** @type {?} */
        var hasMatch = compareFunc(this.item, searchValue);
        if (this.viewItems && this.viewItems.length) {
            /** @type {?} */
            var hasOffspringMatch = false;
            try {
                // Check child and see there is a match from filtering
                for (var _b = __values(this.viewItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    /** @type {?} */
                    var itemHasMatch = item.filter(searchValue);
                    hasOffspringMatch = itemHasMatch || hasOffspringMatch;
                    hasMatch = itemHasMatch || hasMatch;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (hasOffspringMatch) {
                // Automatically expand this parent node if one of its
                // offsrpings is a match
                this.collapsed = false;
                this.setAriaExpandedAttribute();
                this.cd.markForCheck();
            }
        }
        this.r.setProperty(this.el, 'hidden', !hasMatch);
        return hasMatch;
    };
    /**
     * Render aria-current for current item
     */
    /**
     * Render aria-current for current item
     * @param {?} rla
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.renderAriaCurrent = /**
     * Render aria-current for current item
     * @param {?} rla
     * @return {?}
     */
    function (rla) {
        if (rla) {
            if (rla.isActive !== this.selected) {
                this.item.selected = rla.isActive;
            }
        }
        return this._ariaCurrent;
    };
    /**
     * Update side nav item data model so it triggers when its data gets updated
     * @param item Vanilla BentoSideNavItem object to be converted with data change hooks
     */
    /**
     * Update side nav item data model so it triggers when its data gets updated
     * @private
     * @param {?} item Vanilla BentoSideNavItem object to be converted with data change hooks
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.hookItemEvents = /**
     * Update side nav item data model so it triggers when its data gets updated
     * @private
     * @param {?} item Vanilla BentoSideNavItem object to be converted with data change hooks
     * @return {?}
     */
    function (item) {
        var _this = this;
        /** @type {?} */
        var itemCollapsedDescriptor = Object.getOwnPropertyDescriptor(item, 'collapsed');
        if (!itemCollapsedDescriptor || itemCollapsedDescriptor.configurable) {
            delete item.collapsed;
            /** @type {?} */
            var tempItem = __assign({}, item);
            Object.defineProperties(item, {
                label: {
                    set: (/**
                     * @param {?} v
                     * @return {?}
                     */
                    function (v) {
                        _this.label = v;
                        _this.cd.markForCheck();
                    }),
                    get: (/**
                     * @return {?}
                     */
                    function () { return _this.label; })
                },
                collapsed: {
                    set: (/**
                     * @param {?} v
                     * @return {?}
                     */
                    function (v) {
                        _this.collapsed = v;
                        _this.setAriaExpandedAttribute();
                        _this.cd.markForCheck();
                    }),
                    get: (/**
                     * @return {?}
                     */
                    function () { return _this.collapsed; })
                },
                disabled: {
                    set: (/**
                     * @param {?} v
                     * @return {?}
                     */
                    function (v) {
                        _this.disabled = v;
                        _this.cd.markForCheck();
                    }),
                    get: (/**
                     * @return {?}
                     */
                    function () { return _this.disabled; })
                },
                selected: {
                    set: (/**
                     * @param {?} v
                     * @return {?}
                     */
                    function (v) {
                        if (typeof v !== 'boolean') {
                            return;
                        }
                        _this.selected = v;
                        if (v) {
                            setTimeout((/**
                             * @return {?}
                             */
                            function () {
                                var _a;
                                (_a = _this.sideNav) === null || _a === void 0 ? void 0 : _a._setCurrentSideNavItem(_this.item, _this.isDataInitialized);
                            }));
                            _this.ariaCurrent = 'page';
                            _this.r.addClass(_this.el, 'in');
                            setTimeout((/**
                             * @return {?}
                             */
                            function () {
                                _this.r.removeClass(_this.el, 'in');
                            }), 17); // 60fps wait for one frame
                        }
                        else {
                            _this.ariaCurrent = null;
                        }
                        _this.cd.markForCheck();
                        _this.selectedChange.emit(v);
                    }),
                    get: (/**
                     * @return {?}
                     */
                    function () { return _this.selected; })
                },
                items: {
                    set: (/**
                     * @param {?} v
                     * @return {?}
                     */
                    function (v) {
                        _this.items = v;
                        _this.setAsBranch(!!_this.item.items);
                        _this.cd.markForCheck();
                    }),
                    get: (/**
                     * @return {?}
                     */
                    function () { return _this.items; })
                }
            });
            this.item.label = tempItem.label;
            this.item.disabled = tempItem.disabled;
            this.item.selected = tempItem.selected;
            this.item.items = tempItem.items;
            this.item.collapsed = tempItem.collapsed;
            this.isDataInitialized = true;
        }
    };
    /**
     * The default method to compare an item against the filter string
     * @param item BentoSideNavItem object to be used for comparison
     * @param search The search string that is used for comparison
     */
    /**
     * The default method to compare an item against the filter string
     * @private
     * @param {?} item BentoSideNavItem object to be used for comparison
     * @param {?} search The search string that is used for comparison
     * @return {?}
     */
    BentoSideNavItemComponent.prototype.defaultCompareFunc = /**
     * The default method to compare an item against the filter string
     * @private
     * @param {?} item BentoSideNavItem object to be used for comparison
     * @param {?} search The search string that is used for comparison
     * @return {?}
     */
    function (item, search) {
        return search.length === 0 || item.label.toLowerCase().indexOf(search.toLowerCase()) > -1;
    };
    /** @nocollapse */
    BentoSideNavItemComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: Router, decorators: [{ type: Optional }] },
        { type: BentoUidService },
        { type: ElementRef },
        { type: Directionality },
        { type: NgZone }
    ]; };
    BentoSideNavItemComponent.propDecorators = {
        _item: [{ type: Input, args: ['item',] }],
        depth: [{ type: Input }],
        collapsible: [{ type: Input }],
        searchValue: [{ type: Input }],
        _sideNav: [{ type: Input, args: ['sideNav',] }],
        selectedChange: [{ type: Output }],
        _viewItems: [{ type: ViewChildren, args: [BentoSideNavItemComponent,] }],
        rla: [{ type: ViewChild, args: ['rla', { read: RouterLinkActive },] }]
    };
BentoSideNavItemComponent.ɵfac = function BentoSideNavItemComponent_Factory(t) { return new (t || BentoSideNavItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc10.Router, 8), ɵngcc0.ɵɵdirectiveInject(BentoUidService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
BentoSideNavItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSideNavItemComponent, selectors: [["li", "bentoSideNavItem", ""]], viewQuery: function BentoSideNavItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c49, true, RouterLinkActive);
        ɵngcc0.ɵɵviewQuery(BentoSideNavItemComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rla = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._viewItems = _t);
    } }, inputs: { depth: "depth", collapsible: "collapsible", _item: ["item", "_item"], searchValue: "searchValue", _sideNav: ["sideNav", "_sideNav"] }, outputs: { selectedChange: "selectedChange" }, attrs: _c50, decls: 8, vars: 8, consts: [["cdkMonitorElementFocus", "", "class", "btn-expand-collapse", "type", "button", 3, "left", "right", "click", 4, "ngIf"], [1, "label"], ["class", "d-block", "routerLinkActive", "", 3, "routerLink", "disabled", "rel", 4, "ngIf", "ngIfElse"], [3, "hidden", 4, "ngIf"], ["defaultLabel", ""], ["defaultLink", ""], ["cdkMonitorElementFocus", "", "type", "button", 1, "btn-expand-collapse", 3, "click"], ["aria-hidden", "true", 3, "ngClass"], ["routerLinkActive", "", 1, "d-block", 3, "routerLink", "rel"], ["rla", "routerLinkActive"], [4, "ngIf", "ngIfElse"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "hidden"], ["bentoSideNavItem", "", 3, "item", "depth", "sideNav", "collapsible", "selectedChange", 4, "ngFor", "ngForOf"], ["bentoSideNavItem", "", 3, "item", "depth", "sideNav", "collapsible", "selectedChange"], [3, "innerHTML"], [1, "d-block", 3, "click"]], template: function BentoSideNavItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoSideNavItemComponent_button_0_Template, 2, 8, "button", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, BentoSideNavItemComponent_a_2_Template, 3, 9, "a", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, BentoSideNavItemComponent_ul_3_Template, 2, 2, "ul", 3);
        ɵngcc0.ɵɵtemplate(4, BentoSideNavItemComponent_ng_template_4_Template, 2, 3, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, BentoSideNavItemComponent_ng_template_6_Template, 2, 9, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r5 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.collapsible && ctx.isBranch);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("padding-left", ctx.isRTL ? 0 : (ctx.collapsible ? ctx.depth * 16 + 16 : ctx.depth * 16) + 16, "px")("padding-right", ctx.isRTL ? (ctx.collapsible ? ctx.depth * 16 + 16 : ctx.depth * 16) + 16 : 0, "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.item == null ? null : ctx.item.routerLink == null ? null : ctx.item.routerLink.href) && !(ctx.isBranch && ctx.sideNav.categoryExpandOnly))("ngIfElse", _r5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.items);
    } }, directives: [ɵngcc7.NgIf, ɵngcc1.CdkMonitorFocus, ɵngcc7.NgClass, ɵngcc10.RouterLinkWithHref, ɵngcc10.RouterLinkActive, ɵngcc7.NgTemplateOutlet, ɵngcc7.NgForOf, BentoSideNavItemComponent], styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   ul[_ngcontent-%COMP%]{padding-left:0;padding-right:0}[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{position:relative;border-top-width:1px;border-bottom-width:1px;border-top-style:solid;border-bottom-style:solid}[_nghost-%COMP%]   .label[_ngcontent-%COMP%]:before{content:\"\";border-right-width:1px;border-right-style:solid;width:4px;height:100%;position:absolute;left:0}[_nghost-%COMP%]   a[_ngcontent-%COMP%]{font-size:1rem;line-height:1.2;padding:5px 0}[_nghost-%COMP%]   a[_ngcontent-%COMP%] > div[_ngcontent-%COMP%], [_nghost-%COMP%]   a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   a[aria-disabled=true][_ngcontent-%COMP%]{pointer-events:none}[_nghost-%COMP%]   a[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none}[_nghost-%COMP%]   a[href][_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   a[href][_ngcontent-%COMP%]:hover{text-decoration:underline}[_nghost-%COMP%]   a[_ngcontent-%COMP%]:before{display:block;content:\"\";position:absolute;left:0;right:0;top:0;bottom:0}.bui-side-nav-is-collapsible[_nghost-%COMP%]{padding-left:20px}[_nghost-%COMP%]   .btn-expand-collapse[_ngcontent-%COMP%]{background:0 0;border:none;width:20px;height:28px;position:absolute;padding:0;z-index:1}[_nghost-%COMP%]   .branch-root[_ngcontent-%COMP%]{font-weight:700}[dir=rtl][_nghost-%COMP%]   .label[_ngcontent-%COMP%]:before, [dir=rtl]   [_nghost-%COMP%]   .label[_ngcontent-%COMP%]:before{content:\"\";border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}"], changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSideNavItemComponent, [{
        type: Component,
        args: [{
                selector: 'li[bentoSideNavItem]',
                template: "<button\n  *ngIf=\"collapsible && isBranch\"\n  cdkMonitorElementFocus\n  class=\"btn-expand-collapse\"\n  type=\"button\"\n  [style.left.px]=\"isRTL ? 0 : depth * 16 + 6\"\n  [style.right.px]=\"isRTL ? depth * 16 + 6 : 0\"\n  [attr.aria-controls]=\"uid + '-li'\"\n  [attr.aria-expanded]=\"isBranch && collapsible ? !collapsed : null\"\n  [attr.aria-labelledby]=\"uid\"\n  (click)=\"toggleCollapse()\"\n>\n  <span [ngClass]=\"collapsed ? 'bento-icon-plus-plain ' : 'bento-icon-minus-plain '\" aria-hidden=\"true\"></span>\n</button>\n<div\n  class=\"label\"\n  [style.padding-left.px]=\"isRTL ? 0 : (collapsible ? depth * 16 + 16 : depth * 16) + 16\"\n  [style.padding-right.px]=\"isRTL ? (collapsible ? depth * 16 + 16 : depth * 16) + 16 : 0\"\n>\n  <a\n    *ngIf=\"item?.routerLink?.href && !(isBranch && sideNav.categoryExpandOnly); else defaultLink\"\n    #rla=\"routerLinkActive\"\n    class=\"d-block\"\n    [attr.id]=\"uid\"\n    [routerLink]=\"item?.routerLink.href\"\n    routerLinkActive\n    [class.disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-current]=\"renderAriaCurrent(rla)\"\n    [rel]=\"renderAriaCurrent(rla)\"\n  >\n    <span *ngIf=\"sideNav.itemTemplate; else defaultLabel\">\n      <ng-container *ngTemplateOutlet=\"sideNav.itemTemplate; context: {item: item}\"></ng-container>\n    </span>\n  </a>\n</div>\n<ul *ngIf=\"items\" [hidden]=\"collapsed\">\n  <li\n    bentoSideNavItem\n    *ngFor=\"let subItem of items\"\n    [item]=\"subItem\"\n    [depth]=\"depth + 1\"\n    [sideNav]=\"sideNav\"\n    [collapsible]=\"collapsible\"\n    (selectedChange)=\"onChildSelectedChange($event)\"\n  ></li>\n</ul>\n\n<ng-template #defaultLabel>\n  <span><span [innerHTML]=\"label\" [class.branch-root]=\"isBranch\"></span></span>\n</ng-template>\n\n<ng-template #defaultLink>\n  <a\n    class=\"d-block\"\n    [attr.id]=\"uid\"\n    [attr.href]=\"disabled || (isBranch && !sideNav.selectableCategories) ? null : '#'\"\n    [attr.aria-disabled]=\"disabled\"\n    (click)=\"$event.preventDefault(); onItemClick($event)\"\n    [class.disabled]=\"disabled\"\n    [attr.aria-current]=\"renderAriaCurrent(null)\"\n    [attr.aria-expanded]=\"isBranch && collapsible ? !collapsed : null\"\n  >\n    <span *ngIf=\"sideNav.itemTemplate; else defaultLabel\">\n      <ng-container *ngTemplateOutlet=\"sideNav.itemTemplate; context: {item: item}\"></ng-container>\n    </span>\n  </a>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block}:host ul{padding-left:0;padding-right:0}:host .label{position:relative;border-top-width:1px;border-bottom-width:1px;border-top-style:solid;border-bottom-style:solid}:host .label:before{content:\"\";border-right-width:1px;border-right-style:solid;width:4px;height:100%;position:absolute;left:0}:host a{font-size:1rem;line-height:1.2;padding:5px 0}:host a>div,:host a>span{position:relative}:host a[aria-disabled=true]{pointer-events:none}:host a:focus,:host a:hover{text-decoration:none}:host a[href]:focus,:host a[href]:hover{text-decoration:underline}:host a:before{display:block;content:\"\";position:absolute;left:0;right:0;top:0;bottom:0}:host.bui-side-nav-is-collapsible{padding-left:20px}:host .btn-expand-collapse{background:0 0;border:none;width:20px;height:28px;position:absolute;padding:0;z-index:1}:host .branch-root{font-weight:700}:host-context([dir=rtl]) .label:before{content:\"\";border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc10.Router, decorators: [{
                type: Optional
            }] }, { type: BentoUidService }, { type: ɵngcc0.ElementRef }, { type: ɵngcc6.Directionality }, { type: ɵngcc0.NgZone }]; }, { depth: [{
            type: Input
        }], collapsible: [{
            type: Input
        }], selectedChange: [{
            type: Output
        }], _item: [{
            type: Input,
            args: ['item']
        }], searchValue: [{
            type: Input
        }], _sideNav: [{
            type: Input,
            args: ['sideNav']
        }], _viewItems: [{
            type: ViewChildren,
            args: [BentoSideNavItemComponent]
        }], rla: [{
            type: ViewChild,
            args: ['rla', { read: RouterLinkActive }]
        }] }); })();
    return BentoSideNavItemComponent;
}());
if (false) {
    /** @type {?} */
    BentoSideNavItemComponent.prototype.item;
    /**
     * Depth indicator to get the number of levels that it's away from the root item
     * @type {?}
     */
    BentoSideNavItemComponent.prototype.depth;
    /**
     * Flag to determine if this navigation item is collapsible
     * @type {?}
     */
    BentoSideNavItemComponent.prototype.collapsible;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.sideNav;
    /**
     * Select state change event emitter
     * @type {?}
     */
    BentoSideNavItemComponent.prototype.selectedChange;
    /**
     * Flag to show if this item is a branch (aka category)
     * @type {?}
     */
    BentoSideNavItemComponent.prototype.isBranch;
    /**
     * Flag to determine if this component is in a RTL environment
     * @type {?}
     */
    BentoSideNavItemComponent.prototype.isRTL;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.rla;
    /**
     * @type {?}
     * @private
     */
    BentoSideNavItemComponent.prototype._ariaCurrent;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.viewItems;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.disabled;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.selected;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.collapsed;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.label;
    /** @type {?} */
    BentoSideNavItemComponent.prototype.items;
    /**
     * Unique ID of this navigation ID used for a11y
     * @type {?}
     */
    BentoSideNavItemComponent.prototype.uid;
    /**
     * @type {?}
     * @private
     */
    BentoSideNavItemComponent.prototype.el;
    /**
     * Flag to determine if the item data object has been initialized or not
     * to support rendering and event triggering
     * @type {?}
     * @private
     */
    BentoSideNavItemComponent.prototype.isDataInitialized;
    /**
     * @type {?}
     * @private
     */
    BentoSideNavItemComponent.prototype.bidiSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoSideNavItemComponent.prototype.routerEventSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoSideNavItemComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoSideNavItemComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/side-nav/side-nav.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoSideNavModule = /** @class */ (function () {
    function BentoSideNavModule() {
    }
BentoSideNavModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoSideNavModule });
BentoSideNavModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoSideNavModule_Factory(t) { return new (t || BentoSideNavModule)(); }, imports: [[CommonModule, FormsModule, BentoTranslateModule, BentoResetModule, RouterModule, A11yModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoSideNavModule, { declarations: function () { return [BentoSideNavComponent,
        BentoSideNavItemComponent]; }, imports: function () { return [CommonModule, FormsModule,
        BentoTranslateModule,
        BentoResetModule,
        RouterModule, A11yModule]; }, exports: function () { return [BentoSideNavComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSideNavModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, BentoTranslateModule, BentoResetModule, RouterModule, A11yModule],
                declarations: [BentoSideNavComponent, BentoSideNavItemComponent],
                exports: [BentoSideNavComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoSideNavModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/skip-links/skip-links.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A service provider to control the content of `<bento-skip-links></bento-skip-links>`
 * component and its behaviors
 */
var BentoSkipLinksService = /** @class */ (function () {
    function BentoSkipLinksService() {
    }
    Object.defineProperty(BentoSkipLinksService.prototype, "linkChange", {
        /**
         * Subscribable when links are changed
         */
        get: /**
         * Subscribable when links are changed
         * @return {?}
         */
        function () {
            return BentoSkipLinksService.linkChangeSubject;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Update skip links
     */
    /**
     * Update skip links
     * @param {?} links
     * @return {?}
     */
    BentoSkipLinksService.prototype.updateLinks = /**
     * Update skip links
     * @param {?} links
     * @return {?}
     */
    function (links) {
        BentoSkipLinksService.linkChangeSubject.next(links);
    };
    BentoSkipLinksService.linkChangeSubject = new BehaviorSubject(null);
    /** @nocollapse */
    BentoSkipLinksService.ctorParameters = function () { return []; };
BentoSkipLinksService.ɵfac = function BentoSkipLinksService_Factory(t) { return new (t || BentoSkipLinksService)(); };
BentoSkipLinksService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BentoSkipLinksService, factory: function (t) { return BentoSkipLinksService.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSkipLinksService, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return BentoSkipLinksService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoSkipLinksService.linkChangeSubject;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/skip-links/skip-links.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoSkipLinksComponent = /** @class */ (function () {
    function BentoSkipLinksComponent(changeDetector, location, r, skipLinksService, windowRef, elRef) {
        this.changeDetector = changeDetector;
        this.location = location;
        this.r = r;
        /**
         * Skip links update subscription
         */
        this.skipLinkUpdateSub = Subscription.EMPTY;
        this.skipLinkUpdateSub = skipLinksService.linkChange.subscribe(this.onSkipLinkUpdate.bind(this));
        this.document = windowRef.nativeDocument;
        this.el = elRef.nativeElement;
    }
    /**
     * @return {?}
     */
    BentoSkipLinksComponent.prototype.onFocusin = /**
     * @return {?}
     */
    function () {
        this.r.addClass(this.el, 'bui-focused');
    };
    /**
     * @return {?}
     */
    BentoSkipLinksComponent.prototype.onFocusout = /**
     * @return {?}
     */
    function () {
        if (!this.el.contains(this.document.activeElement)) {
            this.r.removeClass(this.el, 'bui-focused');
        }
    };
    /**
     * @return {?}
     */
    BentoSkipLinksComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    BentoSkipLinksComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.skipLinkUpdateSub.unsubscribe();
    };
    /**
     * Link click event listener
     * @param e mouse event that is passed in when user clicks the link
     * @param link the SkipLink that is associsated to this user click
     */
    /**
     * Link click event listener
     * @param {?} e mouse event that is passed in when user clicks the link
     * @param {?} link the SkipLink that is associsated to this user click
     * @return {?}
     */
    BentoSkipLinksComponent.prototype.onLinkClick = /**
     * Link click event listener
     * @param {?} e mouse event that is passed in when user clicks the link
     * @param {?} link the SkipLink that is associsated to this user click
     * @return {?}
     */
    function (e, link) {
        e.preventDefault();
        if (link.isHashAnchor) {
            // This is going to be a hash anchor using HTML5 anchorings using `id` attribute
            /** @type {?} */
            var path = this.location.path();
            /** @type {?} */
            var hashString = "#" + link.anchor;
            if (path.substr(path.length - hashString.length, hashString.length) !== hashString) {
                // Need make sure that if this hash has already been called
                // If so this is not going to fire again
                this.location.go(this.location.path() + "#" + link.anchor);
            }
        }
        else {
            // Brinng focus to a HTMLElemenet defined by its CSS selector
            /** @type {?} */
            var anchorEl = this.document.getElementById(link.anchor);
            if (anchorEl) {
                anchorEl.focus();
            }
            else {
                /* istanbul ignore next */
                throw new Error("Bento Skip Links - Cannot find element id=\"" + link.anchor + "\" in viewport");
            }
        }
    };
    /**
     * Subscription function for SkipLink links updates
     * @param links the new skip link objects that are used for rendering
     */
    /**
     * Subscription function for SkipLink links updates
     * @private
     * @param {?} links the new skip link objects that are used for rendering
     * @return {?}
     */
    BentoSkipLinksComponent.prototype.onSkipLinkUpdate = /**
     * Subscription function for SkipLink links updates
     * @private
     * @param {?} links the new skip link objects that are used for rendering
     * @return {?}
     */
    function (links) {
        this.links = links;
        this.changeDetector.markForCheck();
    };
    /** @nocollapse */
    BentoSkipLinksComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: Location },
        { type: Renderer2 },
        { type: BentoSkipLinksService },
        { type: WindowRef },
        { type: ElementRef }
    ]; };
    BentoSkipLinksComponent.propDecorators = {
        onFocusin: [{ type: HostListener, args: ['focusin',] }],
        onFocusout: [{ type: HostListener, args: ['focusout',] }]
    };
BentoSkipLinksComponent.ɵfac = function BentoSkipLinksComponent_Factory(t) { return new (t || BentoSkipLinksComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.Location), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoSkipLinksService), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoSkipLinksComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSkipLinksComponent, selectors: [["bento-skip-links"]], hostBindings: function BentoSkipLinksComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function BentoSkipLinksComponent_focusin_HostBindingHandler() { return ctx.onFocusin(); })("focusout", function BentoSkipLinksComponent_focusout_HostBindingHandler() { return ctx.onFocusout(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([Location])], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["class", "bui-skip-link-divider", 4, "ngIf"], ["href", "#", 3, "click"], [1, "bui-skip-link-divider"]], template: function BentoSkipLinksComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoSkipLinksComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.links);
    } }, directives: [ɵngcc7.NgForOf, ɵngcc7.NgIf], styles: ["bento-skip-links{display:inline-block;position:absolute;top:0;border-radius:5px;border-style:solid;border-width:1px;padding:10px;margin:0 1rem;transform:translate(0,-110%);transition:transform .2s,box-shadow .2s;box-shadow:0 0 5px transparent}bento-skip-links div{display:inline-block;vertical-align:top}bento-skip-links .bui-skip-link-divider{width:2px;height:1.5em;vertical-align:top;margin:0 5px}bento-skip-links.bui-focused{transform:translate(0,9px);box-shadow:0 0 5px #000}bento-skip-links a{display:inline-block;padding:0 10px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSkipLinksComponent, [{
        type: Component,
        args: [{
                selector: 'bento-skip-links',
                template: "<div *ngFor=\"let link of links; let i = index\">\n  <div class=\"bui-skip-link-divider\" *ngIf=\"i > 0\"></div>\n  <a href=\"#\" (click)=\"onLinkClick($event, link)\">{{ link.text }}</a>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [Location],
                styles: ["bento-skip-links{display:inline-block;position:absolute;top:0;border-radius:5px;border-style:solid;border-width:1px;padding:10px;margin:0 1rem;transform:translate(0,-110%);transition:transform .2s,box-shadow .2s;box-shadow:0 0 5px transparent}bento-skip-links div{display:inline-block;vertical-align:top}bento-skip-links .bui-skip-link-divider{width:2px;height:1.5em;vertical-align:top;margin:0 5px}bento-skip-links.bui-focused{transform:translate(0,9px);box-shadow:0 0 5px #000}bento-skip-links a{display:inline-block;padding:0 10px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc7.Location }, { type: ɵngcc0.Renderer2 }, { type: BentoSkipLinksService }, { type: WindowRef }, { type: ɵngcc0.ElementRef }]; }, { onFocusin: [{
            type: HostListener,
            args: ['focusin']
        }], onFocusout: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();
    return BentoSkipLinksComponent;
}());
if (false) {
    /**
     * Current links that are used for this component
     * @type {?}
     */
    BentoSkipLinksComponent.prototype.links;
    /**
     * Skip links update subscription
     * @type {?}
     * @private
     */
    BentoSkipLinksComponent.prototype.skipLinkUpdateSub;
    /**
     * @type {?}
     * @private
     */
    BentoSkipLinksComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoSkipLinksComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoSkipLinksComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoSkipLinksComponent.prototype.location;
    /**
     * @type {?}
     * @private
     */
    BentoSkipLinksComponent.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/skip-links/skip-link.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A skip link object to represent each link that is used in SkipLink component
 */
var  /**
 * A skip link object to represent each link that is used in SkipLink component
 */
SkipLink = /** @class */ (function () {
    /**
     * * `anchor` - The ID of the element where the link skips to
     * * `text` - The text of the link that is used
     * * `isHashAnchor` (default: `false`) - Flag to decide whether using an location hash `#` or directly focus
     * onto the element by its given HTMLElement ID
     */
    function SkipLink(anchor, text, isHashAnchor) {
        if (isHashAnchor === void 0) { isHashAnchor = false; }
        this.anchor = anchor;
        this.text = text;
        this.isHashAnchor = isHashAnchor;
    }
    return SkipLink;
}());
if (false) {
    /** @type {?} */
    SkipLink.prototype.anchor;
    /** @type {?} */
    SkipLink.prototype.text;
    /** @type {?} */
    SkipLink.prototype.isHashAnchor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/skip-links/skip-links.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoSkipLinksModule = /** @class */ (function () {
    function BentoSkipLinksModule() {
    }
BentoSkipLinksModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoSkipLinksModule });
BentoSkipLinksModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoSkipLinksModule_Factory(t) { return new (t || BentoSkipLinksModule)(); }, providers: [BentoSkipLinksService], imports: [[CommonModule, BentoUtilsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoSkipLinksModule, { declarations: function () { return [BentoSkipLinksComponent]; }, imports: function () { return [CommonModule,
        BentoUtilsModule]; }, exports: function () { return [BentoSkipLinksComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSkipLinksModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoSkipLinksComponent],
                imports: [CommonModule, BentoUtilsModule],
                exports: [BentoSkipLinksComponent],
                providers: [BentoSkipLinksService]
            }]
    }], function () { return []; }, null); })();
    return BentoSkipLinksModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/smart-badge/smart-badge-details.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var BentoSmartBadgeType = {
    digit: 0,
    dot: 1,
    icon: 2,
};
BentoSmartBadgeType[BentoSmartBadgeType.digit] = 'digit';
BentoSmartBadgeType[BentoSmartBadgeType.dot] = 'dot';
BentoSmartBadgeType[BentoSmartBadgeType.icon] = 'icon';
/** @enum {number} */
var BentoSmartBadgeStyle = {
    success: 1,
    info: 2,
    warning: 3,
    failure: 4,
};
BentoSmartBadgeStyle[BentoSmartBadgeStyle.success] = 'success';
BentoSmartBadgeStyle[BentoSmartBadgeStyle.info] = 'info';
BentoSmartBadgeStyle[BentoSmartBadgeStyle.warning] = 'warning';
BentoSmartBadgeStyle[BentoSmartBadgeStyle.failure] = 'failure';
/**
 * Interface for smart badge content
 * @record
 */
function BentoSmartBadgeContent() { }
if (false) {
    /**
     * Value to show up on the badge, it also takes `BentoSmartBadgeStyle`
     * @type {?}
     */
    BentoSmartBadgeContent.prototype.value;
}
/**
 * Smart Badge details
 *
 * **BREAKING CHANGE**: (v9.0.0) The Details object can no longer be
 * instantiated using `new BentoSmartBadgeDetails(...)`. Instead it is now
 * initialized only as an object literal.
 */
var  /**
 * Smart Badge details
 *
 * **BREAKING CHANGE**: (v9.0.0) The Details object can no longer be
 * instantiated using `new BentoSmartBadgeDetails(...)`. Instead it is now
 * initialized only as an object literal.
 */
BentoSmartBadgeDetails = /** @class */ (function () {
    function BentoSmartBadgeDetails(type, content, color, ariaLabel, hidden) {
        this.type = type;
        this.content = content;
        this.color = color;
        this.ariaLabel = ariaLabel;
        this.hidden = hidden;
        console.warn('BentoSmartBadgeDetails: Class instantiation is deprecated, please use JSON object directly');
    }
    return BentoSmartBadgeDetails;
}());
if (false) {
    /**
     * Represents the type of badge - digit, dot, icon
     *
     * **DEPRECATION**: (v9.0.1) The `dot` type is deprecated and
     * will be removed in v11.0.0. Instead use the `icon` type.
     * @type {?}
     */
    BentoSmartBadgeDetails.prototype.type;
    /**
     * Validate to the current string
     * @type {?}
     */
    BentoSmartBadgeDetails.prototype.content;
    /**
     * css color classes - bento-smart-badge-success, bento-smart-badge-info, bento-smart-badge-warning,
     * bento-smart-badge-failure,
     * @type {?}
     */
    BentoSmartBadgeDetails.prototype.color;
    /**
     * Aria label for the badge
     * @type {?}
     */
    BentoSmartBadgeDetails.prototype.ariaLabel;
    /**
     * Show/Hide smart badge
     * @type {?}
     */
    BentoSmartBadgeDetails.prototype.hidden;
    /**
     * Set this property to true, if there won't be any dynamic updates to smart-badge.
     * @type {?}
     */
    BentoSmartBadgeDetails.prototype.staticIndicator;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/smart-badge/smart-badge.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoSmartBadgeComponent = /** @class */ (function () {
    function BentoSmartBadgeComponent(r, bentoLogger, changeDetector) {
        this.r = r;
        this.bentoLogger = bentoLogger;
        this.changeDetector = changeDetector;
        this._badgeDynamicClass = 'd-none';
        this._badgeClassList = [];
        /**
         * Hide if there are no details for the smart badge
         */
        this._showBadgeContainer = false;
    }
    Object.defineProperty(BentoSmartBadgeComponent.prototype, "updateDetails", {
        /**
         * Details about the smart badge
         *
         * **BREAKING CHANGE**: (v9.0.0) `Observable` may no longer be used; all
         * properties are now dynamically updated.
         */
        set: /**
         * Details about the smart badge
         *
         * **BREAKING CHANGE**: (v9.0.0) `Observable` may no longer be used; all
         * properties are now dynamically updated.
         * @param {?} details
         * @return {?}
         */
        function (details) {
            if (!details) {
                this._showBadgeContainer = false;
                return;
            }
            this.details = details;
            this.defineDetailsSetters(details);
            if (this.details instanceof Observable) {
                this.bentoLogger.warn('Bento Smart Badge: The use of Observable is deprecated, please check documentation');
            }
            else if (details) {
                this.setBadgeDetails(details);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param badgeDetails: BentoSmartBadgeDetails
     *
     * Update badge details and convert it with setter and getters
     */
    /**
     *
     * @private
     * @param {?} badgeDetails
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.defineDetailsSetters = /**
     *
     * @private
     * @param {?} badgeDetails
     * @return {?}
     */
    function (badgeDetails) {
        var _this = this;
        this.type = badgeDetails.type;
        Object.defineProperty(badgeDetails, 'type', {
            set: (/**
             * @param {?} type
             * @return {?}
             */
            function (type) {
                _this.type = type;
                // Update type property and render
                _this.setBadgeType(type);
            }),
            get: (/**
             * @return {?}
             */
            function () {
                return _this.type;
            }),
            configurable: true
        });
        this.content = badgeDetails.content;
        Object.defineProperty(badgeDetails, 'content', {
            set: (/**
             * @param {?} content
             * @return {?}
             */
            function (content) {
                _this.content.value = content.value;
            }),
            get: (/**
             * @return {?}
             */
            function () {
                return _this.content;
            }),
            configurable: true
        });
        if (badgeDetails.content) {
            this.contentValue = badgeDetails.content.value;
            Object.defineProperty(badgeDetails.content, 'value', {
                set: (/**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) {
                    _this.contentValue = value;
                    // Update content property and render
                    _this.setBadgeContent({ value: value });
                }),
                get: (/**
                 * @return {?}
                 */
                function () {
                    return _this.contentValue;
                }),
                configurable: true
            });
        }
        this.color = badgeDetails.color;
        Object.defineProperty(badgeDetails, 'color', {
            set: (/**
             * @param {?} color
             * @return {?}
             */
            function (color) {
                _this.color = color;
                _this.setColor(color);
            }),
            get: (/**
             * @return {?}
             */
            function () {
                return _this.color;
            }),
            configurable: true
        });
        this.ariaLabel = badgeDetails.ariaLabel;
        Object.defineProperty(badgeDetails, 'ariaLabel', {
            set: (/**
             * @param {?} ariaLabel
             * @return {?}
             */
            function (ariaLabel) {
                _this.ariaLabel = ariaLabel;
                // Update ariaLabel property and render
                _this.setAriaLabel(ariaLabel);
            }),
            get: (/**
             * @return {?}
             */
            function () {
                return _this.ariaLabel;
            }),
            configurable: true
        });
        this.hidden = badgeDetails.hidden;
        Object.defineProperty(badgeDetails, 'hidden', {
            set: (/**
             * @param {?} hidden
             * @return {?}
             */
            function (hidden) {
                _this.hidden = hidden;
                // Update hidden property and render
                _this.showHideBadge(hidden);
            }),
            get: (/**
             * @return {?}
             */
            function () {
                return _this.hidden;
            }),
            // TypeError: Cannot redefine property: hidden
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cant_redefine_property
            configurable: true
        });
    };
    /**
     *
     * @param badgeDetails: BentoSmartBadgeDetails
     *
     * This method gets called whenever a new `details` object is assigned
     */
    /**
     *
     * @private
     * @param {?} badgeDetails
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.setBadgeDetails = /**
     *
     * @private
     * @param {?} badgeDetails
     * @return {?}
     */
    function (badgeDetails) {
        this.showHideBadge(badgeDetails.hidden);
        // reset css classlist
        this._badgeClassList = [];
        this._badgeDynamicClass = '';
        this._badgeClassList.push('bento-smart-badge');
        this._customStyle = '';
        // ICON badge
        if (badgeDetails.content && badgeDetails.type === BentoSmartBadgeType.icon) {
            this._badgeClassList.push('bento-smart-badge-dot-with-icon');
            /** @type {?} */
            var badgeStyleClass = this.getBadgeStyleClass(badgeDetails.content.value);
            badgeStyleClass += '-icon';
            this._badgeClassList.push(badgeStyleClass);
            this._badgeContent = '';
        }
        else if (badgeDetails.content && badgeDetails.type === BentoSmartBadgeType.digit) {
            // DIGIT badge
            this._badgeContent = badgeDetails.content.value + '';
            if (badgeDetails.content.value > 99) {
                this._badgeContent = '99+';
            }
            else if (badgeDetails.content.value <= 0) {
                this._badgeContent = '';
                this._badgeClassList.push('d-none');
            }
            if (badgeDetails.color && this._badgeContent.length) {
                /** @type {?} */
                var badgeStyleClass = this.getBadgeStyleClass(badgeDetails.color);
                this._badgeClassList.push(badgeStyleClass);
            }
            this._badgeClassList.push('bento-smart-digit');
            /** @type {?} */
            var badgeContentLengthClass = this.getContentLengthClass(this._badgeContent.length);
            this._badgeClassList.push(badgeContentLengthClass);
        }
        else if (badgeDetails.type === BentoSmartBadgeType.dot) {
            this.bentoLogger.warn('Dot type will be deprecated in the future release. Use icon (BentoSmartBadgeType.icon) type instead');
            // Simple DOT badge
            this._badgeContent = '';
            this._badgeClassList.push('bento-smart-badge-dot');
            if (badgeDetails.color) {
                /** @type {?} */
                var badgeStyleClass = this.getBadgeStyleClass(badgeDetails.color);
                this._badgeClassList.push(badgeStyleClass);
            }
        }
        // set aria label
        this.setAriaLabel(badgeDetails.ariaLabel);
        // convert the list to string of css classes
        this._badgeDynamicClass = this._badgeClassList.join(' ');
        this.changeDetector.markForCheck();
        // Update badge CSS Class
        this.smartBadgeHost && this.r.setProperty(this.smartBadgeHost.nativeElement, 'className', this._badgeDynamicClass);
    };
    /**
     *
     * @param badgeType: BentoSmartBadgeType
     *
     * Set only the badge type
     */
    /**
     *
     * @private
     * @param {?} badgeType
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.setBadgeType = /**
     *
     * @private
     * @param {?} badgeType
     * @return {?}
     */
    function (badgeType) {
        this._showBadgeContainer = true;
        /** @type {?} */
        var index = this._badgeClassList.indexOf('bento-smart-badge-dot-with-icon');
        if (index > -1) {
            this._badgeClassList.splice(index, 1);
        }
        index = this._badgeClassList.indexOf('bento-smart-badge-dot');
        if (index > -1) {
            this._badgeClassList.splice(index, 1);
        }
        // ICON badge
        if (badgeType === BentoSmartBadgeType.icon) {
            this._badgeClassList.push('bento-smart-badge-dot-with-icon');
        }
        else if (badgeType === BentoSmartBadgeType.dot) {
            this.bentoLogger.warn('Dot type will be deprecated in the future release. Use icon (BentoSmartBadgeType.icon) type instead');
            // DOT badge
            this._badgeContent = '';
            this._badgeClassList.push('bento-smart-badge-dot');
        }
        // convert the list to string of css classes
        this._badgeDynamicClass = this._badgeClassList.join(' ');
        this.changeDetector.markForCheck();
        // Update badge CSS Class
        this.smartBadgeHost && this.r.setProperty(this.smartBadgeHost.nativeElement, 'className', this._badgeDynamicClass);
    };
    /**
     *
     * @param badgeContent: BentoSmartBadgeContent
     *
     * Set the badge content
     */
    /**
     *
     * @private
     * @param {?} badgeContent
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.setBadgeContent = /**
     *
     * @private
     * @param {?} badgeContent
     * @return {?}
     */
    function (badgeContent) {
        // filter and remove previous css class list
        /** @type {?} */
        var removeList = [
            'd-none',
            'bento-smart-digit',
            'sm',
            'md',
            'lg',
            'bento-smart-badge-success-icon',
            'bento-smart-badge-info-icon',
            'bento-smart-badge-warning-icon',
            'bento-smart-badge-failure-icon'
        ];
        this._badgeClassList = this._badgeClassList.filter((/**
         * @param {?} cls
         * @return {?}
         */
        function (cls) {
            return removeList.indexOf(cls) === -1;
        }));
        // set new class list based on the value provided
        // ICON badge - type based on the content value
        if (badgeContent && this.type && this.type === BentoSmartBadgeType.icon) {
            /** @type {?} */
            var badgeStyleClass = this.getBadgeStyleClass(badgeContent.value);
            badgeStyleClass += '-icon';
            this._badgeClassList.push(badgeStyleClass);
            this._badgeContent = '';
        }
        else if (badgeContent && this.type === BentoSmartBadgeType.digit) {
            // DIGIT badge
            this._badgeContent = badgeContent.value + '';
            if (badgeContent.value > 99) {
                this._badgeContent = '99+';
            }
            else if (badgeContent.value <= 0) {
                this._badgeContent = '';
                this._badgeClassList.push('d-none');
            }
            this._badgeClassList.push('bento-smart-digit');
            /** @type {?} */
            var badgeContentLengthClass = this.getContentLengthClass(this._badgeContent.length);
            this._badgeClassList.push(badgeContentLengthClass);
            this._badgeDynamicClass = this._badgeClassList.join(' ');
            this.changeDetector.markForCheck();
        }
    };
    /**
     *
     * @param style: style type
     *
     * Get the css class based on the style type
     */
    /**
     *
     * @private
     * @param {?} style
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.getBadgeStyleClass = /**
     *
     * @private
     * @param {?} style
     * @return {?}
     */
    function (style) {
        /** @type {?} */
        var badgeClass = 'bento-smart-badge-';
        switch (style) {
            case BentoSmartBadgeStyle.success:
                badgeClass += 'success';
                break;
            case BentoSmartBadgeStyle.info:
                badgeClass += 'info';
                break;
            case BentoSmartBadgeStyle.warning:
                badgeClass += 'warning';
                break;
            case BentoSmartBadgeStyle.failure:
                badgeClass += 'failure';
                break;
        }
        return badgeClass;
    };
    /**
     *
     * @param length: digit type number length.
     * For example:
     * number 100 will have length of 3
     * number 20 will have length of 2
     * number 3 will have length of 1
     *
     * Get the css class based on the length
     */
    /**
     *
     * @private
     * @param {?} length
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.getContentLengthClass = /**
     *
     * @private
     * @param {?} length
     * @return {?}
     */
    function (length) {
        /** @type {?} */
        var badgeContentLengthClass = 'sm';
        switch (length) {
            case 1:
                badgeContentLengthClass = 'sm';
                break;
            case 2:
                badgeContentLengthClass = 'md';
                break;
            case 3:
                badgeContentLengthClass = 'lg';
                break;
        }
        return badgeContentLengthClass;
    };
    /**
     * @private
     * @param {?} color
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.setColor = /**
     * @private
     * @param {?} color
     * @return {?}
     */
    function (color) {
        /** @type {?} */
        var badgeStyleClass = this.getBadgeStyleClass(color);
        this._badgeClassList.push(badgeStyleClass);
        this._badgeDynamicClass = this._badgeClassList.join(' ');
        this.changeDetector.markForCheck();
    };
    /**
     * @private
     * @param {?} ariaLabel
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.setAriaLabel = /**
     * @private
     * @param {?} ariaLabel
     * @return {?}
     */
    function (ariaLabel) {
        // details aria label will override any ariaLabel supplied
        if (ariaLabel) {
            this.ariaLabel = ariaLabel;
        }
        if (!this.ariaLabel) {
            // warn the user
            this.bentoLogger.warn('Accessibility specification mandates to have ariaLabel for Smart badge', this.details);
        }
        this.changeDetector.markForCheck();
    };
    /**
     * @private
     * @param {?} hidden
     * @return {?}
     */
    BentoSmartBadgeComponent.prototype.showHideBadge = /**
     * @private
     * @param {?} hidden
     * @return {?}
     */
    function (hidden) {
        this._showBadgeContainer = hidden ? false : true;
        this.changeDetector.markForCheck();
    };
    /** @nocollapse */
    BentoSmartBadgeComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: BentoLogService },
        { type: ChangeDetectorRef }
    ]; };
    BentoSmartBadgeComponent.propDecorators = {
        ariaLabel: [{ type: Input, args: ['ariaLabel',] }],
        updateDetails: [{ type: Input, args: ['details',] }],
        smartBadgeHost: [{ type: ViewChild, args: ['smartBadgeHost', { static: true },] }]
    };
BentoSmartBadgeComponent.ɵfac = function BentoSmartBadgeComponent_Factory(t) { return new (t || BentoSmartBadgeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoLogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoSmartBadgeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSmartBadgeComponent, selectors: [["bento-smart-badge"], ["", "bentoSmartBadge", ""]], viewQuery: function BentoSmartBadgeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c52, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.smartBadgeHost = _t.first);
    } }, inputs: { updateDetails: ["details", "updateDetails"], ariaLabel: "ariaLabel" }, ngContentSelectors: _c4, decls: 2, vars: 1, consts: [["role", "text img", 3, "ngClass", "ngStyle", 4, "ngIf"], ["role", "text img", 3, "ngClass", "ngStyle"], ["smartBadgeHost", ""]], template: function BentoSmartBadgeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, BentoSmartBadgeComponent_span_1_Template, 3, 5, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._showBadgeContainer);
    } }, directives: [ɵngcc7.NgIf, ɵngcc7.NgClass, ɵngcc7.NgStyle], styles: ["[bentoSmartBadge],bento-smart-badge{display:inline-block;position:relative}.bento-smart-badge{position:absolute;border-width:1px;border-style:solid;left:calc(100% - 2px);bottom:calc(100% - 5px)}[dir=rtl] .bento-smart-badge{left:auto;right:calc(100% - 2px)}.bento-smart-badge-dot-with-icon{background-color:#fff}.bento-smart-badge-warning-icon{background-color:#000}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSmartBadgeComponent, [{
        type: Component,
        args: [{
                selector: 'bento-smart-badge, [bentoSmartBadge]',
                template: "<ng-content></ng-content>\n<span\n  *ngIf=\"_showBadgeContainer\"\n  [attr.aria-live]=\"!details.staticIndicator ? 'polite' : null\"\n  [ngClass]=\"_badgeDynamicClass\"\n  [ngStyle]=\"_customStyle\"\n  #smartBadgeHost\n  [attr.aria-label]=\"ariaLabel\"\n  role=\"text img\"\n>\n  {{ _badgeContent }}\n</span>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["[bentoSmartBadge],bento-smart-badge{display:inline-block;position:relative}.bento-smart-badge{position:absolute;border-width:1px;border-style:solid;left:calc(100% - 2px);bottom:calc(100% - 5px)}[dir=rtl] .bento-smart-badge{left:auto;right:calc(100% - 2px)}.bento-smart-badge-dot-with-icon{background-color:#fff}.bento-smart-badge-warning-icon{background-color:#000}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: BentoLogService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { updateDetails: [{
            type: Input,
            args: ['details']
        }], ariaLabel: [{
            type: Input,
            args: ['ariaLabel']
        }], smartBadgeHost: [{
            type: ViewChild,
            args: ['smartBadgeHost', { static: true }]
        }] }); })();
    return BentoSmartBadgeComponent;
}());
if (false) {
    /**
     * Details about the smart badge
     * @type {?}
     */
    BentoSmartBadgeComponent.prototype.details;
    /**
     * Aria label that can be provided to smart badge
     *
     * This label will be read by the screen readers when focused on it
     *
     * **DEPRECATION**: (v9.0.0) The `[ariaLabel]` property is deprecated and
     * will be removed in v11.0.0. Instead use the `ariaLabel` property of
     * `BentoSmartBadgeDetails`.
     * @type {?}
     */
    BentoSmartBadgeComponent.prototype.ariaLabel;
    /**
     * Represents the type of badge - digit, dot, icon
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.type;
    /**
     * Validate to the current content
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.content;
    /**
     * Value to show up on the badge (for dot type, this can be empty/undefined), it also takes `BentoSmartBadgeStyle`
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.contentValue;
    /**
     * css color classes - bento-smart-badge-success, bento-smart-badge-info, bento-smart-badge-warning,
     * bento-smart-badge-failure,
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.color;
    /**
     * Show/Hide smart badge
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.hidden;
    /**
     * Badge host element
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.smartBadgeHost;
    /** @type {?} */
    BentoSmartBadgeComponent.prototype._badgeDynamicClass;
    /** @type {?} */
    BentoSmartBadgeComponent.prototype._badgeClassList;
    /** @type {?} */
    BentoSmartBadgeComponent.prototype._customStyle;
    /** @type {?} */
    BentoSmartBadgeComponent.prototype._badgeContent;
    /**
     * Hide if there are no details for the smart badge
     * @type {?}
     */
    BentoSmartBadgeComponent.prototype._showBadgeContainer;
    /**
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.bentoLogger;
    /**
     * @type {?}
     * @private
     */
    BentoSmartBadgeComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/smart-badge/smart-badge.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoSmartBadgeModule = /** @class */ (function () {
    function BentoSmartBadgeModule() {
    }
BentoSmartBadgeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoSmartBadgeModule });
BentoSmartBadgeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoSmartBadgeModule_Factory(t) { return new (t || BentoSmartBadgeModule)(); }, imports: [[CommonModule, BentoUtilsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoSmartBadgeModule, { declarations: function () { return [BentoSmartBadgeComponent]; }, imports: function () { return [CommonModule,
        BentoUtilsModule]; }, exports: function () { return [BentoSmartBadgeComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSmartBadgeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, BentoUtilsModule],
                declarations: [BentoSmartBadgeComponent],
                exports: [BentoSmartBadgeComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoSmartBadgeModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group-side-panel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Splitter Group Side Panel Base Class
 */
var  /**
 * Bento Splitter Group Side Panel Base Class
 */
BentoSplitterGroupSideComponent = /** @class */ (function () {
    function BentoSplitterGroupSideComponent(elementRef, r, cd, windowRef, uidGen) {
        this.r = r;
        this.cd = cd;
        /**
         * Panel Aria Label
         */
        this.panelAriaLabel = 'BENTO_UI_SPLITTER_GROUP_SIDE_PANEL';
        /**
         * Bar Aria Label
         */
        this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_SIDE_PANEL';
        /**
         * Class name space
         */
        this.NS = 'bento-splitter';
        this.keydownSubscription = Subscription.EMPTY;
        this._isOpen = false;
        this.r.addClass(elementRef.nativeElement, this.NS + '-group-panel');
        this.window = windowRef.nativeWindow;
        this.el = elementRef.nativeElement;
        this.uid = "bui-" + uidGen.generate();
    }
    Object.defineProperty(BentoSplitterGroupSideComponent.prototype, "side", {
        /**
         * Capitalized string representation of the side
         */
        get: /**
         * Capitalized string representation of the side
         * @return {?}
         */
        function () {
            return this._side;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupSideComponent.prototype, "isOpen", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isOpen;
        },
        /**
         * Open status
         */
        set: /**
         * Open status
         * @param {?} v
         * @return {?}
         */
        function (v) {
            var _this = this;
            this._isOpen = v;
            if (this.isHiddenTimeoutID) {
                // Clear previous timeout when `isOpen` is called too frequently
                clearTimeout(this.isHiddenTimeoutID);
            }
            this.isHiddenTimeoutID = setTimeout((/**
             * @return {?}
             */
            function () {
                _this.isHidden = !v;
            }), v ? 0 : 100);
            this.cd.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoSplitterGroupSideComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this.applyListeners((/** @type {?} */ (this.el.querySelector('.bento-splitter-handle'))));
    };
    /**
     * @return {?}
     */
    BentoSplitterGroupSideComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.handlDownCancel();
        this.keydownSubscription.unsubscribe();
    };
    /**
     * @private
     * @param {?} el
     * @return {?}
     */
    BentoSplitterGroupSideComponent.prototype.applyListeners = /**
     * @private
     * @param {?} el
     * @return {?}
     */
    function (el) {
        var _this = this;
        /** @type {?} */
        var pointerDownEventName = !!this.window['PointerEvent']
            ? 'pointerdown'
            : !!this.window['TouchEvent']
                ? 'touchstart'
                : 'mousedown';
        this.handlDownCancel = this.r.listen(el, pointerDownEventName, (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            _this._onHandleDown(e);
        }));
        this.keydownSubscription = fromEvent(el, 'keydown').subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            switch (e.keyCode) {
                case Keyboard.ENTER:
                case Keyboard.SPACE:
                    _this.onEnterOrSpaceDown(_this);
                    break;
                case Keyboard.UP:
                case Keyboard.DOWN:
                    if (_this._side === 'Top' || _this._side === 'Bottom') {
                        // Only apply to top and bottom panels for up and down arrow keys
                        _this.onArrowKeysDown(e, _this, e.keyCode === Keyboard.UP ? -1 : 1);
                    }
                    e.preventDefault();
                    break;
                case Keyboard.LEFT:
                case Keyboard.RIGHT:
                    if (_this._side === 'Left' || _this._side === 'Right') {
                        // Only apply to left and right panels for up and down arrow keys
                        _this.onArrowKeysDown(e, _this, e.keyCode === Keyboard.LEFT ? -1 : 1);
                    }
                    e.preventDefault();
                    break;
            }
        }));
    };
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    BentoSplitterGroupSideComponent.prototype._onHandleDown = /**
     * @private
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.onHandleDown || !!event.button || event.ctrlKey) {
            return;
        }
        // fire callback
        this.onHandleDown(this, event);
    };
BentoSplitterGroupSideComponent.ɵfac = function BentoSplitterGroupSideComponent_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
BentoSplitterGroupSideComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoSplitterGroupSideComponent });

    return BentoSplitterGroupSideComponent;
}());
if (false) {
    /**
     * HTMLElement reference to this class
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.el;
    /**
     * Panel Aria Label
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.panelAriaLabel;
    /**
     * Bar Aria Label
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.barAriaLabel;
    /**
     * API of on handle mouse down
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.onHandleDown;
    /**
     * API of on handle keyboard ENTER or SPACE down
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.onEnterOrSpaceDown;
    /**
     * API of on handle keyboard arrow keys down
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.onArrowKeysDown;
    /**
     * Unique ID
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.uid;
    /**
     * Panel hidden property
     * @type {?}
     */
    BentoSplitterGroupSideComponent.prototype.isHidden;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupSideComponent.prototype._side;
    /**
     * Class name space
     * @type {?}
     * @protected
     */
    BentoSplitterGroupSideComponent.prototype.NS;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupSideComponent.prototype.handlDownCancel;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupSideComponent.prototype.keydownSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupSideComponent.prototype.window;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupSideComponent.prototype._isOpen;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupSideComponent.prototype.isHiddenTimeoutID;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupSideComponent.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupSideComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group-bottom.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Splitter Group Bottom Panel
 */
var BentoSplitterGroupBottomComponent = /** @class */ (function (_super) {
    __extends(BentoSplitterGroupBottomComponent, _super);
    function BentoSplitterGroupBottomComponent(elementRef, r, cd, windowRef, uidGen) {
        var _this = _super.call(this, elementRef, r, cd, windowRef, uidGen) || this;
        _this.r = r;
        _this.cd = cd;
        /**
         * Bar Aria Label
         */
        _this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_BOTTOM_BAR';
        _this._side = 'Bottom';
        r.addClass(elementRef.nativeElement, _this.NS + '-group-bottom');
        return _this;
    }
    /**
     * @return {?}
     */
    BentoSplitterGroupBottomComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-bottom');
    };
    /** @nocollapse */
    BentoSplitterGroupBottomComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: WindowRef },
        { type: BentoUidService }
    ]; };
    BentoSplitterGroupBottomComponent.propDecorators = {
        handle: [{ type: ViewChild, args: ['handle', { static: true },] }]
    };
BentoSplitterGroupBottomComponent.ɵfac = function BentoSplitterGroupBottomComponent_Factory(t) { return new (t || BentoSplitterGroupBottomComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoSplitterGroupBottomComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSplitterGroupBottomComponent, selectors: [["bento-splitter-group-bottom"]], viewQuery: function BentoSplitterGroupBottomComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c53, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.handle = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 22, vars: 16, consts: [["type", "button", 1, "bento-splitter-handle"], ["handle", ""], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-default"], ["d", "M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z", 1, "splitter-group-handle-border"], ["d", "M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z", 1, "splitter-group-handle-bg"], ["points", "3,32.4 8.3,36.5 3,40.6", 1, "splitter-group-handle-triangle"], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-move"], ["y", "15", "width", "13", "height", "43", 1, "splitter-group-handle-border"], ["y", "16", "width", "13", "height", "41", 1, "splitter-group-handle-bg"], ["points", "6,39.6 3,36.5 6,33.4", 1, "splitter-group-handle-triangle"], ["points", "7.1,33.4 10.1,36.5 7.1,39.6", 1, "splitter-group-handle-triangle"], [1, "bento-splitter-group-inner", 3, "hidden"]], template: function BentoSplitterGroupBottomComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵpipe(2, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(3, "bentoTranslate");
        ɵngcc0.ɵɵpipe(4, "bentoTranslate");
        ɵngcc0.ɵɵpipe(5, "bentoTranslate");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(6, "svg", 2);
        ɵngcc0.ɵɵelementStart(7, "g");
        ɵngcc0.ɵɵelementStart(8, "g");
        ɵngcc0.ɵɵelement(9, "path", 3);
        ɵngcc0.ɵɵelement(10, "path", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "polygon", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "svg", 6);
        ɵngcc0.ɵɵelementStart(13, "g");
        ɵngcc0.ɵɵelementStart(14, "g");
        ɵngcc0.ɵɵelement(15, "rect", 7);
        ɵngcc0.ɵɵelement(16, "rect", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "g");
        ɵngcc0.ɵɵelement(18, "polygon", 9);
        ɵngcc0.ɵɵelement(19, "polygon", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(20, "div", 11);
        ɵngcc0.ɵɵprojection(21);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen)("aria-controls", ctx.uid)("aria-label", ɵngcc0.ɵɵpipeBind3(2, 6, ɵngcc0.ɵɵpipeBind1(3, 10, ctx.barAriaLabel), "_ACTION_", ctx.isOpen ? ɵngcc0.ɵɵpipeBind1(4, 12, "BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE") : ɵngcc0.ɵɵpipeBind1(5, 14, "BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND")));
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("hidden", ctx.isHidden);
        ɵngcc0.ɵɵattribute("id", ctx.uid)("aria-hidden", !ctx.isOpen);
    } }, pipes: [BentoStringReplacePipe,
        BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSplitterGroupBottomComponent, [{
        type: Component,
        args: [{ selector: 'bento-splitter-group-bottom', template: "<button\n  #handle\n  type=\"button\"\n  class=\"bento-splitter-handle\"\n  [attr.aria-expanded]=\"isOpen\"\n  [attr.aria-controls]=\"uid\"\n  [attr.aria-label]=\"\n    barAriaLabel\n      | bentoTranslate\n      | bentoStringReplace\n        : '_ACTION_'\n        : (isOpen\n            ? ('BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE' | bentoTranslate)\n            : ('BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND' | bentoTranslate))\n  \"\n>\n  <svg\n    version=\"1.1\"\n    class=\"bento-splitter-handle-default\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <path\n          class=\"splitter-group-handle-border\"\n          d=\"M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z\"\n        />\n        <path\n          class=\"splitter-group-handle-bg\"\n          d=\"M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z\"\n        />\n      </g>\n      <polygon class=\"splitter-group-handle-triangle\" points=\"3,32.4 8.3,36.5 3,40.6\" />\n    </g>\n  </svg>\n  <svg\n    class=\"bento-splitter-handle-move\"\n    version=\"1.1\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <rect y=\"15\" class=\"splitter-group-handle-border\" width=\"13\" height=\"43\" />\n        <rect y=\"16\" class=\"splitter-group-handle-bg\" width=\"13\" height=\"41\" />\n      </g>\n      <g>\n        <polygon class=\"splitter-group-handle-triangle\" points=\"6,39.6 3,36.5 6,33.4\" />\n        <polygon class=\"splitter-group-handle-triangle\" points=\"7.1,33.4 10.1,36.5 7.1,39.6\" />\n      </g>\n    </g>\n  </svg>\n</button>\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: WindowRef }, { type: BentoUidService }]; }, { handle: [{
            type: ViewChild,
            args: ['handle', { static: true }]
        }] }); })();
    return BentoSplitterGroupBottomComponent;
}(BentoSplitterGroupSideComponent));
if (false) {
    /** @type {?} */
    BentoSplitterGroupBottomComponent.prototype.handle;
    /**
     * Bar Aria Label
     * @type {?}
     */
    BentoSplitterGroupBottomComponent.prototype.barAriaLabel;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupBottomComponent.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupBottomComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group-left.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Splitter Group Left Panel
 */
var BentoSplitterGroupLeftComponent = /** @class */ (function (_super) {
    __extends(BentoSplitterGroupLeftComponent, _super);
    function BentoSplitterGroupLeftComponent(elementRef, r, cd, windowRef, dir, uidGen) {
        var _this = _super.call(this, elementRef, r, cd, windowRef, uidGen) || this;
        _this.r = r;
        _this.cd = cd;
        /**
         * Bar Aria Label
         */
        _this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_LEFT_BAR';
        _this._side = dir.value === 'rtl' ? 'Right' : 'Left';
        _this.r.addClass(elementRef.nativeElement, _this.NS + '-group-' + _this._side.toLowerCase());
        return _this;
    }
    /**
     * @return {?}
     */
    BentoSplitterGroupLeftComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-' + this._side.toLowerCase());
    };
    /** @nocollapse */
    BentoSplitterGroupLeftComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: WindowRef },
        { type: Directionality },
        { type: BentoUidService }
    ]; };
    BentoSplitterGroupLeftComponent.propDecorators = {
        handle: [{ type: ViewChild, args: ['handle', { static: true },] }]
    };
BentoSplitterGroupLeftComponent.ɵfac = function BentoSplitterGroupLeftComponent_Factory(t) { return new (t || BentoSplitterGroupLeftComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoSplitterGroupLeftComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSplitterGroupLeftComponent, selectors: [["bento-splitter-group-left"]], viewQuery: function BentoSplitterGroupLeftComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c53, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.handle = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 22, vars: 16, consts: [["type", "button", 1, "bento-splitter-handle"], ["handle", ""], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-default"], ["d", "M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z", 1, "splitter-group-handle-border"], ["d", "M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z", 1, "splitter-group-handle-bg"], ["points", "3,32.4 8.3,36.5 3,40.6", 1, "splitter-group-handle-triangle"], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-move"], ["y", "15", "width", "13", "height", "43", 1, "splitter-group-handle-border"], ["y", "16", "width", "13", "height", "41", 1, "splitter-group-handle-bg"], ["points", "6,39.6 3,36.5 6,33.4", 1, "splitter-group-handle-triangle"], ["points", "7.1,33.4 10.1,36.5 7.1,39.6", 1, "splitter-group-handle-triangle"], [1, "bento-splitter-group-inner", 3, "hidden"]], template: function BentoSplitterGroupLeftComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵpipe(2, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(3, "bentoTranslate");
        ɵngcc0.ɵɵpipe(4, "bentoTranslate");
        ɵngcc0.ɵɵpipe(5, "bentoTranslate");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(6, "svg", 2);
        ɵngcc0.ɵɵelementStart(7, "g");
        ɵngcc0.ɵɵelementStart(8, "g");
        ɵngcc0.ɵɵelement(9, "path", 3);
        ɵngcc0.ɵɵelement(10, "path", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "polygon", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "svg", 6);
        ɵngcc0.ɵɵelementStart(13, "g");
        ɵngcc0.ɵɵelementStart(14, "g");
        ɵngcc0.ɵɵelement(15, "rect", 7);
        ɵngcc0.ɵɵelement(16, "rect", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "g");
        ɵngcc0.ɵɵelement(18, "polygon", 9);
        ɵngcc0.ɵɵelement(19, "polygon", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(20, "div", 11);
        ɵngcc0.ɵɵprojection(21);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen)("aria-controls", ctx.uid)("aria-label", ɵngcc0.ɵɵpipeBind3(2, 6, ɵngcc0.ɵɵpipeBind1(3, 10, ctx.barAriaLabel), "_ACTION_", ctx.isOpen ? ɵngcc0.ɵɵpipeBind1(4, 12, "BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE") : ɵngcc0.ɵɵpipeBind1(5, 14, "BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND")));
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("hidden", ctx.isHidden);
        ɵngcc0.ɵɵattribute("id", ctx.uid)("aria-hidden", !ctx.isOpen);
    } }, pipes: [BentoStringReplacePipe,
        BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSplitterGroupLeftComponent, [{
        type: Component,
        args: [{ selector: 'bento-splitter-group-left', template: "<button\n  #handle\n  type=\"button\"\n  class=\"bento-splitter-handle\"\n  [attr.aria-expanded]=\"isOpen\"\n  [attr.aria-controls]=\"uid\"\n  [attr.aria-label]=\"\n    barAriaLabel\n      | bentoTranslate\n      | bentoStringReplace\n        : '_ACTION_'\n        : (isOpen\n            ? ('BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE' | bentoTranslate)\n            : ('BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND' | bentoTranslate))\n  \"\n>\n  <svg\n    version=\"1.1\"\n    class=\"bento-splitter-handle-default\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <path\n          class=\"splitter-group-handle-border\"\n          d=\"M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z\"\n        />\n        <path\n          class=\"splitter-group-handle-bg\"\n          d=\"M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z\"\n        />\n      </g>\n      <polygon class=\"splitter-group-handle-triangle\" points=\"3,32.4 8.3,36.5 3,40.6\" />\n    </g>\n  </svg>\n  <svg\n    class=\"bento-splitter-handle-move\"\n    version=\"1.1\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <rect y=\"15\" class=\"splitter-group-handle-border\" width=\"13\" height=\"43\" />\n        <rect y=\"16\" class=\"splitter-group-handle-bg\" width=\"13\" height=\"41\" />\n      </g>\n      <g>\n        <polygon class=\"splitter-group-handle-triangle\" points=\"6,39.6 3,36.5 6,33.4\" />\n        <polygon class=\"splitter-group-handle-triangle\" points=\"7.1,33.4 10.1,36.5 7.1,39.6\" />\n      </g>\n    </g>\n  </svg>\n</button>\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: WindowRef }, { type: ɵngcc6.Directionality }, { type: BentoUidService }]; }, { handle: [{
            type: ViewChild,
            args: ['handle', { static: true }]
        }] }); })();
    return BentoSplitterGroupLeftComponent;
}(BentoSplitterGroupSideComponent));
if (false) {
    /** @type {?} */
    BentoSplitterGroupLeftComponent.prototype.handle;
    /**
     * Bar Aria Label
     * @type {?}
     */
    BentoSplitterGroupLeftComponent.prototype.barAriaLabel;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupLeftComponent.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupLeftComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group-main.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Splitter Group Main Panel
 */
var BentoSplitterGroupMainComponent = /** @class */ (function () {
    function BentoSplitterGroupMainComponent(elementRef, r) {
        this.el = elementRef.nativeElement;
        r.addClass(elementRef.nativeElement, 'bento-splitter-group-panel');
        r.addClass(elementRef.nativeElement, 'bento-splitter-group-main');
    }
    /** @nocollapse */
    BentoSplitterGroupMainComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
BentoSplitterGroupMainComponent.ɵfac = function BentoSplitterGroupMainComponent_Factory(t) { return new (t || BentoSplitterGroupMainComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BentoSplitterGroupMainComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSplitterGroupMainComponent, selectors: [["bento-splitter-group-main"]], ngContentSelectors: _c4, decls: 2, vars: 0, consts: [[1, "bento-splitter-group-inner"]], template: function BentoSplitterGroupMainComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSplitterGroupMainComponent, [{
        type: Component,
        args: [{ selector: 'bento-splitter-group-main', template: "<div class=\"bento-splitter-group-inner\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return BentoSplitterGroupMainComponent;
}());
if (false) {
    /**
     * HTMLElement reference to this class
     * @type {?}
     */
    BentoSplitterGroupMainComponent.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group-right.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Splitter Group Right Panel
 */
var BentoSplitterGroupRightComponent = /** @class */ (function (_super) {
    __extends(BentoSplitterGroupRightComponent, _super);
    function BentoSplitterGroupRightComponent(elementRef, r, cd, windowRef, dir, uidGen) {
        var _this = _super.call(this, elementRef, r, cd, windowRef, uidGen) || this;
        _this.r = r;
        _this.cd = cd;
        /**
         * Bar Aria Label
         */
        _this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_RIGHT_BAR';
        _this._side = dir.value === 'rtl' ? 'Left' : 'Right';
        _this.r.addClass(elementRef.nativeElement, _this.NS + '-group-' + _this._side.toLowerCase());
        return _this;
    }
    /**
     * @return {?}
     */
    BentoSplitterGroupRightComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-' + this._side.toLowerCase());
    };
    /** @nocollapse */
    BentoSplitterGroupRightComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: WindowRef },
        { type: Directionality },
        { type: BentoUidService }
    ]; };
    BentoSplitterGroupRightComponent.propDecorators = {
        handle: [{ type: ViewChild, args: ['handle', { static: true },] }]
    };
BentoSplitterGroupRightComponent.ɵfac = function BentoSplitterGroupRightComponent_Factory(t) { return new (t || BentoSplitterGroupRightComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoSplitterGroupRightComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSplitterGroupRightComponent, selectors: [["bento-splitter-group-right"]], viewQuery: function BentoSplitterGroupRightComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c53, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.handle = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 22, vars: 16, consts: [["type", "button", 1, "bento-splitter-handle"], ["handle", ""], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-default"], ["d", "M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z", 1, "splitter-group-handle-border"], ["d", "M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z", 1, "splitter-group-handle-bg"], ["points", "3,32.4 8.3,36.5 3,40.6", 1, "splitter-group-handle-triangle"], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-move"], ["y", "15", "width", "13", "height", "43", 1, "splitter-group-handle-border"], ["y", "16", "width", "13", "height", "41", 1, "splitter-group-handle-bg"], ["points", "6,39.6 3,36.5 6,33.4", 1, "splitter-group-handle-triangle"], ["points", "7.1,33.4 10.1,36.5 7.1,39.6", 1, "splitter-group-handle-triangle"], [1, "bento-splitter-group-inner", 3, "hidden"]], template: function BentoSplitterGroupRightComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵpipe(2, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(3, "bentoTranslate");
        ɵngcc0.ɵɵpipe(4, "bentoTranslate");
        ɵngcc0.ɵɵpipe(5, "bentoTranslate");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(6, "svg", 2);
        ɵngcc0.ɵɵelementStart(7, "g");
        ɵngcc0.ɵɵelementStart(8, "g");
        ɵngcc0.ɵɵelement(9, "path", 3);
        ɵngcc0.ɵɵelement(10, "path", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "polygon", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "svg", 6);
        ɵngcc0.ɵɵelementStart(13, "g");
        ɵngcc0.ɵɵelementStart(14, "g");
        ɵngcc0.ɵɵelement(15, "rect", 7);
        ɵngcc0.ɵɵelement(16, "rect", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "g");
        ɵngcc0.ɵɵelement(18, "polygon", 9);
        ɵngcc0.ɵɵelement(19, "polygon", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(20, "div", 11);
        ɵngcc0.ɵɵprojection(21);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen)("aria-controls", ctx.uid)("aria-label", ɵngcc0.ɵɵpipeBind3(2, 6, ɵngcc0.ɵɵpipeBind1(3, 10, ctx.barAriaLabel), "_ACTION_", ctx.isOpen ? ɵngcc0.ɵɵpipeBind1(4, 12, "BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE") : ɵngcc0.ɵɵpipeBind1(5, 14, "BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND")));
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("hidden", ctx.isHidden);
        ɵngcc0.ɵɵattribute("id", ctx.uid)("aria-hidden", !ctx.isOpen);
    } }, pipes: [BentoStringReplacePipe,
        BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSplitterGroupRightComponent, [{
        type: Component,
        args: [{ selector: 'bento-splitter-group-right', template: "<button\n  #handle\n  type=\"button\"\n  class=\"bento-splitter-handle\"\n  [attr.aria-expanded]=\"isOpen\"\n  [attr.aria-controls]=\"uid\"\n  [attr.aria-label]=\"\n    barAriaLabel\n      | bentoTranslate\n      | bentoStringReplace\n        : '_ACTION_'\n        : (isOpen\n            ? ('BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE' | bentoTranslate)\n            : ('BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND' | bentoTranslate))\n  \"\n>\n  <svg\n    version=\"1.1\"\n    class=\"bento-splitter-handle-default\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <path\n          class=\"splitter-group-handle-border\"\n          d=\"M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z\"\n        />\n        <path\n          class=\"splitter-group-handle-bg\"\n          d=\"M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z\"\n        />\n      </g>\n      <polygon class=\"splitter-group-handle-triangle\" points=\"3,32.4 8.3,36.5 3,40.6\" />\n    </g>\n  </svg>\n  <svg\n    class=\"bento-splitter-handle-move\"\n    version=\"1.1\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <rect y=\"15\" class=\"splitter-group-handle-border\" width=\"13\" height=\"43\" />\n        <rect y=\"16\" class=\"splitter-group-handle-bg\" width=\"13\" height=\"41\" />\n      </g>\n      <g>\n        <polygon class=\"splitter-group-handle-triangle\" points=\"6,39.6 3,36.5 6,33.4\" />\n        <polygon class=\"splitter-group-handle-triangle\" points=\"7.1,33.4 10.1,36.5 7.1,39.6\" />\n      </g>\n    </g>\n  </svg>\n</button>\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: WindowRef }, { type: ɵngcc6.Directionality }, { type: BentoUidService }]; }, { handle: [{
            type: ViewChild,
            args: ['handle', { static: true }]
        }] }); })();
    return BentoSplitterGroupRightComponent;
}(BentoSplitterGroupSideComponent));
if (false) {
    /** @type {?} */
    BentoSplitterGroupRightComponent.prototype.handle;
    /**
     * Bar Aria Label
     * @type {?}
     */
    BentoSplitterGroupRightComponent.prototype.barAriaLabel;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupRightComponent.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupRightComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group-top.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Splitter Group Top Panel
 */
var BentoSplitterGroupTopComponent = /** @class */ (function (_super) {
    __extends(BentoSplitterGroupTopComponent, _super);
    function BentoSplitterGroupTopComponent(elementRef, r, cd, windowRef, uidGen) {
        var _this = _super.call(this, elementRef, r, cd, windowRef, uidGen) || this;
        _this.r = r;
        _this.cd = cd;
        /**
         * Bar Aria Label
         */
        _this.barAriaLabel = 'BENTO_UI_SPLITTER_GROUP_TOP_BAR';
        _this._side = 'Top';
        _this.r.addClass(elementRef.nativeElement, _this.NS + '-group-top');
        return _this;
    }
    /**
     * @return {?}
     */
    BentoSplitterGroupTopComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.r.addClass(this.handle.nativeElement, this.NS + '-handle-top');
    };
    /** @nocollapse */
    BentoSplitterGroupTopComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: WindowRef },
        { type: BentoUidService }
    ]; };
    BentoSplitterGroupTopComponent.propDecorators = {
        handle: [{ type: ViewChild, args: ['handle', { static: true },] }]
    };
BentoSplitterGroupTopComponent.ɵfac = function BentoSplitterGroupTopComponent_Factory(t) { return new (t || BentoSplitterGroupTopComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoSplitterGroupTopComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSplitterGroupTopComponent, selectors: [["bento-splitter-group-top"]], viewQuery: function BentoSplitterGroupTopComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c53, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.handle = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 22, vars: 16, consts: [["type", "button", 1, "bento-splitter-handle"], ["handle", ""], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-default"], ["d", "M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z", 1, "splitter-group-handle-border"], ["d", "M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z", 1, "splitter-group-handle-bg"], ["points", "3,32.4 8.3,36.5 3,40.6", 1, "splitter-group-handle-triangle"], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 13 73", "enable-background", "new 0 0 13 73", 0, "xml", "space", "preserve", 1, "bento-splitter-handle-move"], ["y", "15", "width", "13", "height", "43", 1, "splitter-group-handle-border"], ["y", "16", "width", "13", "height", "41", 1, "splitter-group-handle-bg"], ["points", "6,39.6 3,36.5 6,33.4", 1, "splitter-group-handle-triangle"], ["points", "7.1,33.4 10.1,36.5 7.1,39.6", 1, "splitter-group-handle-triangle"], [1, "bento-splitter-group-inner", 3, "hidden"]], template: function BentoSplitterGroupTopComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵpipe(2, "bentoStringReplace");
        ɵngcc0.ɵɵpipe(3, "bentoTranslate");
        ɵngcc0.ɵɵpipe(4, "bentoTranslate");
        ɵngcc0.ɵɵpipe(5, "bentoTranslate");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(6, "svg", 2);
        ɵngcc0.ɵɵelementStart(7, "g");
        ɵngcc0.ɵɵelementStart(8, "g");
        ɵngcc0.ɵɵelement(9, "path", 3);
        ɵngcc0.ɵɵelement(10, "path", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "polygon", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "svg", 6);
        ɵngcc0.ɵɵelementStart(13, "g");
        ɵngcc0.ɵɵelementStart(14, "g");
        ɵngcc0.ɵɵelement(15, "rect", 7);
        ɵngcc0.ɵɵelement(16, "rect", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "g");
        ɵngcc0.ɵɵelement(18, "polygon", 9);
        ɵngcc0.ɵɵelement(19, "polygon", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(20, "div", 11);
        ɵngcc0.ɵɵprojection(21);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen)("aria-controls", ctx.uid)("aria-label", ɵngcc0.ɵɵpipeBind3(2, 6, ɵngcc0.ɵɵpipeBind1(3, 10, ctx.barAriaLabel), "_ACTION_", ctx.isOpen ? ɵngcc0.ɵɵpipeBind1(4, 12, "BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE") : ɵngcc0.ɵɵpipeBind1(5, 14, "BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND")));
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("hidden", ctx.isHidden);
        ɵngcc0.ɵɵattribute("id", ctx.uid)("aria-hidden", !ctx.isOpen);
    } }, pipes: [BentoStringReplacePipe,
        BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSplitterGroupTopComponent, [{
        type: Component,
        args: [{ selector: 'bento-splitter-group-top', template: "<button\n  #handle\n  type=\"button\"\n  class=\"bento-splitter-handle\"\n  [attr.aria-expanded]=\"isOpen\"\n  [attr.aria-controls]=\"uid\"\n  [attr.aria-label]=\"\n    barAriaLabel\n      | bentoTranslate\n      | bentoStringReplace\n        : '_ACTION_'\n        : (isOpen\n            ? ('BENTO_UI_SPLITTER_GROUP_ACTION_COLLAPSE' | bentoTranslate)\n            : ('BENTO_UI_SPLITTER_GROUP_ACTION_EXPAND' | bentoTranslate))\n  \"\n>\n  <svg\n    version=\"1.1\"\n    class=\"bento-splitter-handle-default\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <path\n          class=\"splitter-group-handle-border\"\n          d=\"M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62\n        C0,61.9,0,58.6,5.4,57.3z\"\n        />\n        <path\n          class=\"splitter-group-handle-bg\"\n          d=\"M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4\n      C0,58.9,0,56.9,4.8,55.8z\"\n        />\n      </g>\n      <polygon class=\"splitter-group-handle-triangle\" points=\"3,32.4 8.3,36.5 3,40.6\" />\n    </g>\n  </svg>\n  <svg\n    class=\"bento-splitter-handle-move\"\n    version=\"1.1\"\n    id=\"Layer_1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n    x=\"0px\"\n    y=\"0px\"\n    viewBox=\"0 0 13 73\"\n    enable-background=\"new 0 0 13 73\"\n    xml:space=\"preserve\"\n  >\n    <g>\n      <g>\n        <rect y=\"15\" class=\"splitter-group-handle-border\" width=\"13\" height=\"43\" />\n        <rect y=\"16\" class=\"splitter-group-handle-bg\" width=\"13\" height=\"41\" />\n      </g>\n      <g>\n        <polygon class=\"splitter-group-handle-triangle\" points=\"6,39.6 3,36.5 6,33.4\" />\n        <polygon class=\"splitter-group-handle-triangle\" points=\"7.1,33.4 10.1,36.5 7.1,39.6\" />\n      </g>\n    </g>\n  </svg>\n</button>\n<div class=\"bento-splitter-group-inner\" [attr.id]=\"uid\" [attr.aria-hidden]=\"!isOpen\" [hidden]=\"isHidden\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: WindowRef }, { type: BentoUidService }]; }, { handle: [{
            type: ViewChild,
            args: ['handle', { static: true }]
        }] }); })();
    return BentoSplitterGroupTopComponent;
}(BentoSplitterGroupSideComponent));
if (false) {
    /** @type {?} */
    BentoSplitterGroupTopComponent.prototype.handle;
    /**
     * Bar Aria Label
     * @type {?}
     */
    BentoSplitterGroupTopComponent.prototype.barAriaLabel;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupTopComponent.prototype.r;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupTopComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Interface for pointer coordinate
 * @record
 */
function Point() { }
if (false) {
    /** @type {?} */
    Point.prototype.x;
    /** @type {?} */
    Point.prototype.y;
}
/** @enum {number} */
var SizeUnit = {
    Px: 0,
    Percent: 1,
};
SizeUnit[SizeUnit.Px] = 'Px';
SizeUnit[SizeUnit.Percent] = 'Percent';
/**
 * This custom component allows collapsible panes in all four cardinal
 * directions. The splitter handles are draggable in desktop browsers, allowing
 * arbitrary resizing. When collapsed, the splitter retains a memory of the
 * width of its last open position; clicking the splitter handle will restore
 * that position.
 */
var BentoSplitterGroupComponent = /** @class */ (function () {
    function BentoSplitterGroupComponent(elementRef, bentoNotification, windowRef, r, dir) {
        var _this = this;
        this.bentoNotification = bentoNotification;
        this.windowRef = windowRef;
        this.r = r;
        this.dir = dir;
        /**
         * Maximum width of the left panel
         */
        this.leftMaxWidth = Number.POSITIVE_INFINITY;
        /**
         * Callback when the width of the left panel is changed
         */
        this.leftSizeChange = new EventEmitter();
        /**
         * Callback when flag `leftOpened` changes
         */
        this.leftOpenedChange = new EventEmitter();
        /**
         * Maximum width of the right panel
         */
        this.rightMaxWidth = Number.POSITIVE_INFINITY;
        /**
         * Callback when the width of the right panel is changed
         */
        this.rightSizeChange = new EventEmitter();
        /**
         * Callback when flag `rightOpened` changes
         */
        this.rightOpenedChange = new EventEmitter();
        /**
         * Maximum height of the top panel
         */
        this.topMaxHeight = Number.POSITIVE_INFINITY;
        /**
         * Callback when the height of the top panel is changed
         */
        this.topSizeChange = new EventEmitter();
        /**
         * Callback when flag `topOpened` changes
         */
        this.topOpenedChange = new EventEmitter();
        /**
         * Maximum height of the bottom panel
         */
        this.bottomMaxHeight = Number.POSITIVE_INFINITY;
        /**
         * Callback when the height of the bottom panel is changed
         */
        this.bottomSizeChange = new EventEmitter();
        /**
         * Callback when flag `bottomOpened` changes
         */
        this.bottomOpenedChange = new EventEmitter();
        this._isIE = false;
        /**
         * API related private variables
         */
        this._autoResize = false;
        this.leftSize = 200;
        this.rightSize = 200;
        this.topSize = 100;
        this.bottomSize = 100;
        /**
         * Default variables
         */
        this.defaultHandleWidth = 15;
        this.autoCloseThreshhold = 50;
        this.isLeftOpen = false;
        this.isRightOpen = false;
        this.isTopOpen = false;
        this.isBottomOpen = false;
        // Event names
        this.subPointerMove = Subscription.EMPTY;
        this.subPointerUp = Subscription.EMPTY;
        this.subPointerCancel = Subscription.EMPTY;
        this.subResize = Subscription.EMPTY;
        this.document = this.windowRef.nativeDocument;
        this.r.addClass(elementRef.nativeElement, 'bento-splitter-group');
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
        this._isIE = windowRef.isIEEdge;
        this.el = elementRef.nativeElement;
    }
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "autoResize", {
        /**
         * Auto Resize
         */
        set: /**
         * Auto Resize
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._autoResize = val;
            if (val) {
                this.r.addClass(this.el, 'bento-splitter-group-autoresize');
            }
            else {
                this.r.removeClass(this.el, 'bento-splitter-group-autoresize');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "noCollapse", {
        /**
         * Set to true for drag only behavior
         */
        set: /**
         * Set to true for drag only behavior
         * @param {?} val
         * @return {?}
         */
        function (val) {
            if (val) {
                this.r.addClass(this.el, 'no-collapse');
            }
            else {
                this.r.removeClass(this.el, 'no-collapse');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "leftWidth", {
        /**
         * Left panel width
         */
        set: /**
         * Left panel width
         * @param {?} size
         * @return {?}
         */
        function (size) {
            /** @type {?} */
            var s = Number(size);
            if ((this.isRtl && this.rightSize === s) || this.leftSize === s) {
                return;
            }
            if (this.isRtl) {
                this.rightSize = s;
            }
            else {
                this.leftSize = s;
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "leftOpened", {
        /**
         * Flag to open/collapse left panel
         */
        set: /**
         * Flag to open/collapse left panel
         * @param {?} val
         * @return {?}
         */
        function (val) {
            if (this.isRtl) {
                this.setRightOpen(val);
            }
            else {
                this.setLeftOpen(val);
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "rightWidth", {
        /**
         * Right panel width
         */
        set: /**
         * Right panel width
         * @param {?} size
         * @return {?}
         */
        function (size) {
            /** @type {?} */
            var s = Number(size);
            if ((this.isRtl && this.leftSize === s) || this.rightSize === s) {
                return;
            }
            if (this.isRtl) {
                this.leftSize = s;
            }
            else {
                this.rightSize = s;
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "rightOpened", {
        /**
         * Flag to open/collapse right panel
         */
        set: /**
         * Flag to open/collapse right panel
         * @param {?} val
         * @return {?}
         */
        function (val) {
            if (this.isRtl) {
                this.setLeftOpen(val);
            }
            else {
                this.setRightOpen(val);
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "topHeight", {
        /**
         * Top panel height
         */
        set: /**
         * Top panel height
         * @param {?} size
         * @return {?}
         */
        function (size) {
            /** @type {?} */
            var s = Number(size);
            if (this.topSize === s) {
                return;
            }
            this.topSize = s;
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "topOpened", {
        /**
         * Flag to open/collapse top panel
         */
        set: /**
         * Flag to open/collapse top panel
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.setTopOpen(val);
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "bottomHeight", {
        /**
         * Bottom panel height
         */
        set: /**
         * Bottom panel height
         * @param {?} size
         * @return {?}
         */
        function (size) {
            /** @type {?} */
            var s = Number(size);
            if (this.bottomSize === s) {
                return;
            }
            this.bottomSize = s;
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "bottomOpened", {
        /**
         * Flag to open/collapse bottom panel
         */
        set: /**
         * Flag to open/collapse bottom panel
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.setBottomOpen(val);
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "_leftPanel", {
        /**
         * Panel references
         */
        set: /**
         * Panel references
         * @param {?} panel
         * @return {?}
         */
        function (panel) {
            var _this = this;
            if (this.isRtl) {
                // Change side in RTL
                this.rightPanel = panel;
            }
            else {
                this.leftPanel = panel;
            }
            if (this.leftPanel) {
                // Hook callbacks
                this.leftPanel.isOpen = this.isLeftOpen || false;
                this.r.setStyle(panel.el, 'display', 'none');
                this.leftPanel.onHandleDown = (/**
                 * @param {?} side
                 * @param {?} event
                 * @return {?}
                 */
                function (side, event) {
                    _this.onSidePanelHandleDown(side, event);
                });
                this.leftPanel.onEnterOrSpaceDown = (/**
                 * @return {?}
                 */
                function () {
                    _this.setLeftOpen(!_this.isLeftOpen);
                    _this.render();
                    _this.leftOpenedChange.emit(_this.isLeftOpen);
                });
                this.leftPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
            }
            else {
                this.setLeftOpen(false);
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "_topPanel", {
        set: /**
         * @param {?} panel
         * @return {?}
         */
        function (panel) {
            var _this = this;
            this.topPanel = panel;
            if (this.topPanel) {
                // Hook callbacks
                this.topPanel.isOpen = this.isTopOpen || false;
                this.r.setStyle(panel.el, 'display', 'none');
                this.topPanel.onHandleDown = (/**
                 * @param {?} side
                 * @param {?} event
                 * @return {?}
                 */
                function (side, event) {
                    _this.onSidePanelHandleDown(side, event);
                });
                this.topPanel.onEnterOrSpaceDown = (/**
                 * @return {?}
                 */
                function () {
                    _this.setTopOpen(!_this.isTopOpen);
                    _this.topOpenedChange.emit(_this.isTopOpen);
                });
                this.topPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
            }
            else {
                this.setTopOpen(false);
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "_rightPanel", {
        set: /**
         * @param {?} panel
         * @return {?}
         */
        function (panel) {
            var _this = this;
            if (this.isRtl) {
                // Change side in RTL
                this.leftPanel = panel;
            }
            else {
                this.rightPanel = panel;
            }
            if (this.rightPanel) {
                // Hook callbacks
                this.rightPanel.isOpen = this.isRightOpen || false;
                this.r.setStyle(panel.el, 'display', 'none');
                this.rightPanel.onHandleDown = (/**
                 * @param {?} side
                 * @param {?} event
                 * @return {?}
                 */
                function (side, event) {
                    _this.onSidePanelHandleDown(side, event);
                });
                this.rightPanel.onEnterOrSpaceDown = (/**
                 * @return {?}
                 */
                function () {
                    _this.setRightOpen(!_this.isRightOpen);
                    _this.render();
                    _this.rightOpenedChange.emit(_this.isRightOpen);
                });
                this.rightPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
            }
            else {
                this.setRightOpen(false);
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoSplitterGroupComponent.prototype, "_bottomPanel", {
        set: /**
         * @param {?} panel
         * @return {?}
         */
        function (panel) {
            var _this = this;
            this.bottomPanel = panel;
            if (this.bottomPanel) {
                // Hook callbacks
                this.bottomPanel.isOpen = this.isBottomOpen || false;
                this.r.setStyle(panel.el, 'display', 'none');
                this.bottomPanel.onHandleDown = (/**
                 * @param {?} side
                 * @param {?} event
                 * @return {?}
                 */
                function (side, event) {
                    _this.onSidePanelHandleDown(side, event);
                });
                this.bottomPanel.onEnterOrSpaceDown = (/**
                 * @return {?}
                 */
                function () {
                    _this.setBottomOpen(!_this.isBottomOpen);
                    _this.bottomOpenedChange.emit(_this.isBottomOpen);
                });
                this.bottomPanel.onArrowKeysDown = this.onSideArrowDown.bind(this);
            }
            else {
                this.setBottomOpen(false);
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
    };
    /**
     * AfterContentInit interface method
     */
    /**
     * AfterContentInit interface method
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.ngAfterContentInit = /**
     * AfterContentInit interface method
     * @return {?}
     */
    function () {
        var _this = this;
        this.mainPanelInnerEl = (/** @type {?} */ (this.mainPanel.el.querySelector('.bento-splitter-group-inner')));
        this.r.setStyle(this.mainPanel.el, 'display', 'none');
        this.subResize = this.bentoNotification.resizeNotification.subscribe((/**
         * @param {?} object
         * @return {?}
         */
        function (object) {
            /** @type {?} */
            var isVisible = !(_this.el.offsetWidth === 0 && _this.el.offsetHeight === 0);
            if (object !== _this && isVisible) {
                // Only rerender when other related components resize
                /** @type {?} */
                var hasChange = false;
                /** @type {?} */
                var elWidth = _this.el.offsetWidth;
                /** @type {?} */
                var elHeight = _this.el.offsetHeight;
                // Normallize width
                if (_this.leftSize + _this.defaultHandleWidth > elWidth) {
                    _this.leftSize = elWidth - _this.defaultHandleWidth;
                    hasChange = true;
                }
                if (_this.rightSize + _this.defaultHandleWidth > elWidth) {
                    _this.rightSize = elWidth - _this.defaultHandleWidth;
                    hasChange = true;
                }
                if (_this.topSize + _this.defaultHandleWidth > elHeight) {
                    _this.topSize = elHeight - _this.defaultHandleWidth;
                    hasChange = true;
                }
                if (_this.bottomSize + _this.defaultHandleWidth > elHeight) {
                    _this.bottomSize = elHeight - _this.defaultHandleWidth;
                    hasChange = true;
                }
                // When there are two panels facing each other
                if (_this.leftPanel &&
                    _this.rightPanel &&
                    _this.leftSize + _this.rightSize + _this.defaultHandleWidth * 2 > elWidth) {
                    /** @type {?} */
                    var d = (_this.leftSize + _this.rightSize + _this.defaultHandleWidth * 2 - elWidth) * 0.5;
                    _this.leftSize -= d;
                    _this.rightSize -= d;
                    hasChange = true;
                }
                if (_this.topPanel &&
                    _this.bottomPanel &&
                    _this.topSize + _this.bottomSize + _this.defaultHandleWidth * 2 > elHeight) {
                    /** @type {?} */
                    var d = (_this.topSize + _this.bottomSize + _this.defaultHandleWidth * 2 - elHeight) * 0.5;
                    _this.topSize -= d;
                    _this.bottomSize -= d;
                    hasChange = true;
                }
                if (hasChange) {
                    _this.render();
                }
            }
        }));
        this.render();
    };
    /**
     * AfterViewChecked interface method
     */
    /**
     * AfterViewChecked interface method
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.ngAfterContentChecked = /**
     * AfterViewChecked interface method
     * @return {?}
     */
    function () {
        if (this._autoResize) {
            /** @type {?} */
            var height = this.mainPanelInnerEl.offsetHeight;
            if (this.topPanel) {
                height += this.topPanel.el.offsetHeight + this.topPanel.el.offsetTop;
            }
            if (this.bottomPanel) {
                height += this.bottomPanel.el.offsetHeight + parseFloat(this.bottomPanel.el.style.bottom);
            }
            this.r.setStyle(this.el, 'height', height + "px");
        }
    };
    /**
     * Destroy callback
     */
    /**
     * Destroy callback
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.ngOnDestroy = /**
     * Destroy callback
     * @return {?}
     */
    function () {
        this.unsubscribeListeners();
        this.subResize.unsubscribe();
    };
    /**
     * Render panels based on size values
     */
    /**
     * Render panels based on size values
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.render = /**
     * Render panels based on size values
     * @return {?}
     */
    function () {
        var _this = this;
        !this.isDragged && clearTimeout(this.renderDebounceTimeout);
        this.renderDebounceTimeout = setTimeout((/**
         * @return {?}
         */
        function () {
            /*
                    To avoid multiple resize notifications that are broadcasted
                    we are debouncing the calling of render()
                  */
            /** @type {?} */
            var tempVal;
            _this.r.removeStyle(_this.mainPanel.el, 'display');
            // Left Panel
            if (_this.leftPanel) {
                tempVal = _this.leftSize + _this.defaultHandleWidth;
                _this.r.setStyle(_this.leftPanel.el, 'width', tempVal + "px");
                _this.r.removeStyle(_this.leftPanel.el, 'display');
                if (_this.isLeftOpen) {
                    _this.r.setStyle(_this.mainPanel.el, 'left', tempVal + "px");
                    _this.r.setStyle(_this.leftPanel.el, 'left', '0');
                }
                else {
                    _this.r.setStyle(_this.leftPanel.el, 'left', -_this.leftSize - 1 + "px");
                }
            }
            if (!_this.isLeftOpen) {
                _this.r.setStyle(_this.mainPanel.el, 'left', (_this.leftPanel ? _this.defaultHandleWidth : 0) + "px");
            }
            // Right Panel
            if (_this.rightPanel) {
                tempVal = _this.rightSize + _this.defaultHandleWidth;
                _this.r.setStyle(_this.rightPanel.el, 'width', tempVal + "px");
                _this.r.removeStyle(_this.rightPanel.el, 'display');
                if (_this.isRightOpen) {
                    _this.r.setStyle(_this.mainPanel.el, 'right', tempVal + "px");
                    _this.r.setStyle(_this.rightPanel.el, 'right', '0');
                }
                else {
                    _this.r.setStyle(_this.mainPanel.el, 'right', _this.defaultHandleWidth + "px");
                    _this.r.setStyle(_this.rightPanel.el, 'right', -_this.rightSize - 1 + "px");
                }
            }
            if (!_this.isRightOpen) {
                _this.r.setStyle(_this.mainPanel.el, 'right', (_this.rightPanel ? _this.defaultHandleWidth : 0) + "px");
            }
            // Top Panel
            if (_this.topPanel) {
                tempVal = _this.topSize + _this.defaultHandleWidth;
                _this.r.setStyle(_this.topPanel.el, 'height', tempVal + "px");
                _this.r.removeStyle(_this.topPanel.el, 'display');
                if (_this.isTopOpen) {
                    _this.r.setStyle(_this.mainPanel.el, 'top', tempVal + "px");
                    _this.r.setStyle(_this.topPanel.el, 'top', '0');
                }
                else {
                    _this.r.setStyle(_this.topPanel.el, 'top', -_this.topSize - 1 + "px");
                }
                if (_this.isTopOpen) {
                    if (_this.leftPanel) {
                        _this.r.setStyle(_this.leftPanel.el, 'top', tempVal + "px");
                    }
                    if (_this.rightPanel) {
                        _this.r.setStyle(_this.rightPanel.el, 'top', tempVal + "px");
                    }
                }
                else {
                    if (_this.leftPanel) {
                        _this.r.setStyle(_this.leftPanel.el, 'top', _this.defaultHandleWidth - 1 + "px");
                    }
                    if (_this.rightPanel) {
                        _this.r.setStyle(_this.rightPanel.el, 'top', _this.defaultHandleWidth - 1 + "px");
                    }
                }
            }
            if (!_this.isTopOpen) {
                _this.r.setStyle(_this.mainPanel.el, 'top', (_this.topPanel ? _this.defaultHandleWidth : 0) + "px");
            }
            // Bottom Panel
            if (_this.bottomPanel) {
                tempVal = _this.bottomSize + _this.defaultHandleWidth;
                _this.r.setStyle(_this.bottomPanel.el, 'height', tempVal + "px");
                _this.r.removeStyle(_this.bottomPanel.el, 'display');
                if (_this.isBottomOpen) {
                    _this.r.setStyle(_this.mainPanel.el, 'bottom', tempVal + "px");
                    _this.r.setStyle(_this.bottomPanel.el, 'bottom', '0');
                }
                else {
                    _this.r.setStyle(_this.bottomPanel.el, 'bottom', -(_this.bottomSize + 1) + "px");
                }
                if (_this.isBottomOpen) {
                    if (_this.leftPanel) {
                        _this.r.setStyle(_this.leftPanel.el, 'bottom', tempVal + "px");
                    }
                    if (_this.rightPanel) {
                        _this.r.setStyle(_this.rightPanel.el, 'bottom', tempVal + "px");
                    }
                }
                else {
                    if (_this.leftPanel) {
                        _this.r.setStyle(_this.leftPanel.el, 'bottom', _this.defaultHandleWidth - 1 + "px");
                    }
                    if (_this.rightPanel) {
                        _this.r.setStyle(_this.rightPanel.el, 'bottom', _this.defaultHandleWidth - 1 + "px");
                    }
                }
            }
            if (!_this.isBottomOpen) {
                _this.r.setStyle(_this.mainPanel.el, 'bottom', (_this.bottomPanel ? _this.defaultHandleWidth : 0) + "px");
            }
            // Notify resize globally
            _this.bentoNotification.emitResize(_this);
        }), this.isDragged ? 0 : 10);
    };
    /**
     * Unsubscribe user interaction pointer listeners
     */
    /**
     * Unsubscribe user interaction pointer listeners
     * @private
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.unsubscribeListeners = /**
     * Unsubscribe user interaction pointer listeners
     * @private
     * @return {?}
     */
    function () {
        this.subPointerCancel.unsubscribe();
        this.subPointerMove.unsubscribe();
        this.subPointerUp.unsubscribe();
    };
    /**
     * Set left panel open flag
     */
    /**
     * Set left panel open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.setLeftOpen = /**
     * Set left panel open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    function (isOpen) {
        if (isOpen !== this.isLeftOpen) {
            this.isLeftOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-left');
            }
            else {
                this.r.removeClass(this.el, 'opened-left');
            }
            if (this.leftPanel) {
                this.leftPanel.isOpen = isOpen;
            }
        }
    };
    /**
     * Set right panel open flag
     */
    /**
     * Set right panel open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.setRightOpen = /**
     * Set right panel open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    function (isOpen) {
        if (isOpen !== this.isRightOpen) {
            this.isRightOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-right');
            }
            else {
                this.r.removeClass(this.el, 'opened-right');
            }
            if (this.rightPanel) {
                this.rightPanel.isOpen = isOpen;
            }
        }
    };
    /**
     * Set top panel open flag
     */
    /**
     * Set top panel open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.setTopOpen = /**
     * Set top panel open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    function (isOpen) {
        if (isOpen !== this.isTopOpen) {
            this.isTopOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-top');
            }
            else {
                this.r.removeClass(this.el, 'opened-top');
            }
            if (this.topPanel) {
                this.topPanel.isOpen = isOpen;
            }
            // Need renderer to resize the left and right panels
            this.render();
        }
    };
    /**
     * Set bottom open flag
     */
    /**
     * Set bottom open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.setBottomOpen = /**
     * Set bottom open flag
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    function (isOpen) {
        if (isOpen !== this.isBottomOpen) {
            this.isBottomOpen = isOpen;
            if (isOpen) {
                this.r.addClass(this.el, 'opened-bottom');
            }
            else {
                this.r.removeClass(this.el, 'opened-bottom');
            }
            if (this.bottomPanel) {
                this.bottomPanel.isOpen = isOpen;
            }
            // Need renderer to resize the left and right panels
            this.render();
        }
    };
    /**
     * Callback when a panel mousedown (touchstart) is fired
     *
     * This method contains other mouse or touch event listeners in order share
     * the same class reference
     *
     */
    /**
     * Callback when a panel mousedown (touchstart) is fired
     *
     * This method contains other mouse or touch event listeners in order share
     * the same class reference
     *
     * @private
     * @param {?} side
     * @param {?} event
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.onSidePanelHandleDown = /**
     * Callback when a panel mousedown (touchstart) is fired
     *
     * This method contains other mouse or touch event listeners in order share
     * the same class reference
     *
     * @private
     * @param {?} side
     * @param {?} event
     * @return {?}
     */
    function (side, event) {
        var _this = this;
        this.originalPoint = this.previousPoint = this.getPoint(event);
        this.isDragged = false;
        this.actionSide = side;
        this.actionSideStr = side.side;
        this.actionSideLowerCase = side.side.toLowerCase();
        this.previousOpenState = this["is" + this.actionSideStr + "Open"];
        if (event.type === 'pointerdown') {
            this.pointerMoveEventName = 'pointermove';
            this.pointerUpEventName = 'pointerup';
            this.pointerCancelEventName = 'pointercancel';
        }
        else if (event.type === 'touchstart') {
            this.pointerMoveEventName = 'touchmove';
            this.pointerUpEventName = 'touchend';
            this.pointerCancelEventName = 'touchcancel';
        }
        else {
            this.pointerMoveEventName = 'mousemove';
            this.pointerUpEventName = 'mouseup';
        }
        this.subPointerMove = fromEvent(this.document, this.pointerMoveEventName, {
            capture: true
        }).subscribe(this.onWindowPointerMove.bind(this));
        this.subPointerUp = fromEvent(this.document, this.pointerUpEventName).subscribe(this.onWindowPointerUp.bind(this));
        if (this.pointerCancelEventName) {
            this.subPointerCancel = fromEvent(this.document, this.pointerCancelEventName).subscribe(this.onWindowPointerUp.bind(this));
        }
        this.moveIndicatorTimeout = setTimeout((/**
         * @return {?}
         */
        function () {
            _this.r.addClass(_this.el, "dragging-" + _this.actionSideLowerCase);
        }), 500);
        this.originalSize =
            (side instanceof BentoSplitterGroupLeftComponent || side instanceof BentoSplitterGroupRightComponent
                ? side.el.offsetWidth
                : side.el.offsetHeight) - this.defaultHandleWidth;
    };
    /*
       Callback when pointer is moving
       */
    /*
         Callback when pointer is moving
         */
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.onWindowPointerMove = /*
         Callback when pointer is moving
         */
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var currentPoint = this.getPoint(e);
        /** @type {?} */
        var delta = { x: currentPoint.x - this.previousPoint.x, y: currentPoint.y - this.previousPoint.y };
        // const distance: Point = {x: currentPoint.x - this.originalPoint.x, y: currentPoint.y - this.originalPoint.y};
        if (Math.abs(currentPoint.x - this.originalPoint.x) + Math.abs(currentPoint.y - this.originalPoint.y) > 10) {
            // There is no movement but browser fires 'pointermove' somehow
            this.isDragged = true;
        }
        // Stop touch devices from scrolling
        e.preventDefault();
        // Check if the point leaves window
        if (!this.pointerCancelEventName) {
            if (e.button !== 0 || e.buttons !== 1) {
                this.onWindowPointerLeave(e);
            }
        }
        this.moveSidePanel(delta);
        this.previousPoint = currentPoint;
        this.render();
    };
    /*
     Callback when pointer is up
     */
    /*
       Callback when pointer is up
       */
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.onWindowPointerUp = /*
       Callback when pointer is up
       */
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var clEl = this.el;
        /** @type {?} */
        var cl = clEl.classList;
        /** @type {?} */
        var dSize;
        /** @type {?} */
        var offset;
        // Remove event listeners
        this.unsubscribeListeners();
        clearTimeout(this.moveIndicatorTimeout);
        if (cl.contains("dragging-" + this.actionSideLowerCase)) {
            this.r.removeClass(clEl, "dragging-" + this.actionSideLowerCase);
            if (this[this.actionSideLowerCase + "Size"] < this.autoCloseThreshhold) {
                this["set" + this.actionSideStr + "Open"](false);
                this[this.actionSideLowerCase + "Size"] = this.originalSize;
            }
        }
        /** @type {?} */
        var hasNoCollapse = cl.contains('no-collapse');
        if (!this.isDragged && !hasNoCollapse) {
            this["set" + this.actionSideStr + "Open"](!this["is" + this.actionSideStr + "Open"]);
        }
        // Adjust the opposite side of panels
        if (this.actionSideLowerCase === 'left' && this['isLeftOpen'] && this.rightPanel && !this['isRightOpen']) {
            // Left to Right
            dSize = this.rightPanel.el.offsetLeft - this.rightSize - 1 - this.leftSize - this.defaultHandleWidth;
            if (dSize < 0) {
                this.rightSize += dSize;
                if (this.isRtl) {
                    this.leftSizeChange.emit(this.rightSize);
                }
                else {
                    this.rightSizeChange.emit(this.rightSize);
                }
            }
        }
        else if (this.actionSideLowerCase === 'right' && this['isRightOpen'] && this.leftPanel && !this['isLeftOpen']) {
            // Right to Left
            offset = this.rightPanel.el.offsetLeft;
            dSize = offset - this.leftSize - this.defaultHandleWidth;
            if (dSize < 0) {
                this.leftSize = offset - this.defaultHandleWidth;
                if (this.isRtl) {
                    this.rightSizeChange.emit(this.leftSize);
                }
                else {
                    this.leftSizeChange.emit(this.leftSize);
                }
            }
        }
        else if (this.actionSideLowerCase === 'top' && this['isTopOpen'] && this.bottomPanel && !this['isBottomOpen']) {
            // Top to Bottom
            dSize = this.bottomPanel.el.offsetTop - this.bottomSize - 1 - this.topSize - this.defaultHandleWidth;
            if (dSize < 0) {
                this.bottomSize += dSize;
                this.bottomSizeChange.emit(this.bottomSize);
            }
        }
        else if (this.actionSideLowerCase === 'bottom' && this['isBottomOpen'] && this.topPanel && !this['isTopOpen']) {
            // Bottom to Top
            offset = this.bottomPanel.el.offsetTop;
            dSize = offset - this.topSize - this.defaultHandleWidth;
            if (dSize < 0) {
                this.topSize = offset - this.defaultHandleWidth;
                this.topSizeChange.emit(this.topSize);
            }
        }
        // Emit opened state change
        if (this.previousOpenState !== this["is" + this.actionSideStr + "Open"]) {
            /** @type {?} */
            var actionSide = void 0;
            if (this.isRtl && (this.actionSideStr === 'Left' || this.actionSideStr === 'Right')) {
                if (this.actionSideStr === 'Left') {
                    actionSide = 'right';
                }
                else {
                    actionSide = 'left';
                }
            }
            else {
                actionSide = this.actionSideLowerCase;
            }
            this[actionSide + "OpenedChange"].emit(this["is" + this.actionSideStr + "Open"]);
        }
        // Emit size change
        if (this[this.actionSideLowerCase + "Size"] !== this.originalSize) {
            /** @type {?} */
            var actionSide = void 0;
            if (this.isRtl && (this.actionSideStr === 'Left' || this.actionSideStr === 'Right')) {
                if (this.actionSideStr === 'Left') {
                    actionSide = 'right';
                }
                else {
                    actionSide = 'left';
                }
            }
            else {
                actionSide = this.actionSideLowerCase;
            }
            this[actionSide + "SizeChange"].emit(this[this.actionSideLowerCase + "Size"]);
        }
        this.render();
    };
    /*
     Callback when pointer leaves window
     */
    /*
       Callback when pointer leaves window
       */
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.onWindowPointerLeave = /*
       Callback when pointer leaves window
       */
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onWindowPointerUp(e);
    };
    /**
     * Move the current action side with a delta
     */
    /**
     * Move the current action side with a delta
     * @private
     * @param {?} delta
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.moveSidePanel = /**
     * Move the current action side with a delta
     * @private
     * @param {?} delta
     * @return {?}
     */
    function (delta) {
        switch (this.actionSide) {
            case this.leftPanel:
                this.leftSize = Math.max(0, Math.min(this.leftMaxWidth, this.leftSize + delta.x));
                if (this.rightPanel) {
                    this.leftSize = Math.min(this.rightPanel.el.offsetLeft - this.defaultHandleWidth, this.leftSize);
                }
                this.r.addClass(this.el, 'dragging-left');
                if (!this.isLeftOpen && Math.abs(delta.x) > 0) {
                    this.leftSize = delta.x;
                    if (this.isRtl) {
                        this.rightOpened = true;
                    }
                    else {
                        this.leftOpened = true;
                    }
                }
                break;
            case this.rightPanel:
                this.rightSize = Math.max(0, Math.min(this.rightMaxWidth, this.rightSize - delta.x));
                if (this.leftPanel) {
                    this.rightSize = Math.min(this.el.offsetWidth - this.leftPanel.el.offsetWidth - this.defaultHandleWidth, this.rightSize);
                }
                this.r.addClass(this.el, 'dragging-right');
                if (!this.isRightOpen) {
                    if (this.isRtl && delta.x > 0) {
                        this.leftOpened = true;
                        this.rightSize = delta.x;
                    }
                    else if (delta.x < 0) {
                        this.rightOpened = true;
                        this.rightSize = -delta.x;
                    }
                }
                break;
            case this.topPanel:
                this.topSize = Math.max(0, Math.min(this.topMaxHeight, this.topSize + delta.y));
                if (this.bottomPanel) {
                    this.topSize = Math.min(this.bottomPanel.el.offsetTop - this.defaultHandleWidth, this.topSize);
                }
                this.r.addClass(this.el, 'dragging-top');
                if (!this.isTopOpen && delta.y > 0) {
                    this.topSize = delta.y;
                    this.topOpened = true;
                }
                break;
            case this.bottomPanel:
                this.bottomSize = Math.max(0, Math.min(this.bottomMaxHeight, this.bottomSize - delta.y));
                if (this.topPanel) {
                    this.bottomSize = Math.min(this.el.offsetHeight - this.topPanel.el.offsetHeight - this.defaultHandleWidth, this.bottomSize);
                }
                this.r.addClass(this.el, 'dragging-bottom');
                if (!this.isBottomOpen && delta.y < 0) {
                    this.bottomSize = -delta.y;
                    this.bottomOpened = true;
                }
                break;
        }
    };
    /**
     * @private
     * @param {?} e
     * @param {?} sideComponent
     * @param {?} direction
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.onSideArrowDown = /**
     * @private
     * @param {?} e
     * @param {?} sideComponent
     * @param {?} direction
     * @return {?}
     */
    function (e, sideComponent, direction) {
        var _this = this;
        /** @type {?} */
        var sideLowerCase = sideComponent.side.toLowerCase();
        /** @type {?} */
        var wasSideOpen = this["is" + sideComponent.side + "Open"];
        /** @type {?} */
        var isClosing = ((sideComponent === this.leftPanel || sideComponent === this.topPanel) && direction < 0) ||
            ((sideComponent === this.rightPanel || sideComponent === this.bottomPanel) && direction > 0);
        /* Similar to some graphical applications, holding down shift key amplifies the momentum for each arrow step */
        /** @type {?} */
        var momentum = direction * (e.shiftKey ? 50 : 10);
        /** @type {?} */
        var delta = !isClosing && !wasSideOpen
            ? /* Using autoCloseThreshold for the first opened size when closed*/
                { x: direction * this.autoCloseThreshhold, y: direction * this.autoCloseThreshhold }
            : /* Otherwise use default momentum */
                { x: momentum, y: momentum };
        this.actionSide = sideComponent;
        this.moveSidePanel(delta);
        clearTimeout(this.moveIndicatorTimeout);
        if (isClosing && this[sideLowerCase + "Size"] < this.autoCloseThreshhold && this["is" + sideComponent.side + "Open"]) {
            // Auto snap to border
            this.r.removeClass(this.el, "dragging-" + sideLowerCase);
            this["set" + sideComponent.side + "Open"](false);
            this[sideLowerCase + "Size"] = this.originalSize;
            // Emit changes
            this[sideLowerCase + "OpenedChange"].emit(false);
            this.render();
        }
        else if (this["is" + sideComponent.side + "Open"]) {
            if (!wasSideOpen) {
                this["set" + sideComponent.side + "Open"](true);
                this[sideLowerCase + "OpenedChange"].emit(true);
            }
            // Fade out the drag indecator after some timeout
            this.moveIndicatorTimeout = setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.removeClass(_this.el, "dragging-" + sideLowerCase);
            }), 1000);
            this.render();
        }
    };
    /**
     * Retrieves current pointer coordinate
     */
    /**
     * Retrieves current pointer coordinate
     * @private
     * @param {?} event
     * @return {?}
     */
    BentoSplitterGroupComponent.prototype.getPoint = /**
     * Retrieves current pointer coordinate
     * @private
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.touches) {
            // This is a TouchEvent
            return { x: event.touches.item(0).screenX, y: event.touches.item(0).screenY };
        }
        else {
            // Cast event type
            return { x: event.pageX ? event.pageX : event.clientX, y: event.pageY ? event.pageY : event.clientY };
        }
    };
    /** @nocollapse */
    BentoSplitterGroupComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification },
        { type: WindowRef },
        { type: Renderer2 },
        { type: Directionality }
    ]; };
    BentoSplitterGroupComponent.propDecorators = {
        autoResize: [{ type: Input }],
        noCollapse: [{ type: Input }],
        leftWidth: [{ type: Input }],
        leftMaxWidth: [{ type: Input }],
        leftSizeChange: [{ type: Output, args: ['leftWidthChange',] }],
        leftOpened: [{ type: Input }],
        leftOpenedChange: [{ type: Output }],
        rightWidth: [{ type: Input }],
        rightMaxWidth: [{ type: Input }],
        rightSizeChange: [{ type: Output, args: ['rightWidthChange',] }],
        rightOpened: [{ type: Input }],
        rightOpenedChange: [{ type: Output }],
        topHeight: [{ type: Input }],
        topMaxHeight: [{ type: Input }],
        topSizeChange: [{ type: Output, args: ['topHeightChange',] }],
        topOpened: [{ type: Input }],
        topOpenedChange: [{ type: Output }],
        bottomHeight: [{ type: Input }],
        bottomMaxHeight: [{ type: Input }],
        bottomSizeChange: [{ type: Output, args: ['bottomHeightChange',] }],
        bottomOpened: [{ type: Input }],
        bottomOpenedChange: [{ type: Output }],
        _isIE: [{ type: HostBinding, args: ['class.isIE',] }],
        _leftPanel: [{ type: ContentChild, args: [BentoSplitterGroupLeftComponent,] }],
        _topPanel: [{ type: ContentChild, args: [BentoSplitterGroupTopComponent,] }],
        _rightPanel: [{ type: ContentChild, args: [BentoSplitterGroupRightComponent,] }],
        _bottomPanel: [{ type: ContentChild, args: [BentoSplitterGroupBottomComponent,] }],
        mainPanel: [{ type: ContentChild, args: [BentoSplitterGroupMainComponent, { static: true },] }]
    };
BentoSplitterGroupComponent.ɵfac = function BentoSplitterGroupComponent_Factory(t) { return new (t || BentoSplitterGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoSplitterGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoSplitterGroupComponent, selectors: [["bento-splitter-group"]], contentQueries: function BentoSplitterGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BentoSplitterGroupLeftComponent, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, BentoSplitterGroupTopComponent, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, BentoSplitterGroupRightComponent, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, BentoSplitterGroupBottomComponent, true);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, BentoSplitterGroupMainComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._leftPanel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._topPanel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._rightPanel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._bottomPanel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mainPanel = _t.first);
    } }, hostVars: 2, hostBindings: function BentoSplitterGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("isIE", ctx._isIE);
    } }, inputs: { leftMaxWidth: "leftMaxWidth", rightMaxWidth: "rightMaxWidth", topMaxHeight: "topMaxHeight", bottomMaxHeight: "bottomMaxHeight", autoResize: "autoResize", noCollapse: "noCollapse", leftWidth: "leftWidth", leftOpened: "leftOpened", rightWidth: "rightWidth", rightOpened: "rightOpened", topHeight: "topHeight", topOpened: "topOpened", bottomHeight: "bottomHeight", bottomOpened: "bottomOpened" }, outputs: { leftSizeChange: "leftWidthChange", leftOpenedChange: "leftOpenedChange", rightSizeChange: "rightWidthChange", rightOpenedChange: "rightOpenedChange", topSizeChange: "topHeightChange", topOpenedChange: "topOpenedChange", bottomSizeChange: "bottomHeightChange", bottomOpenedChange: "bottomOpenedChange" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], ngContentSelectors: _c4, decls: 1, vars: 0, template: function BentoSplitterGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["bento-splitter-group{box-sizing:border-box;position:absolute;min-height:400px;top:0;left:0;right:0;bottom:0;overflow:hidden}[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-default,[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-move,[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-default,[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-move{left:-50%}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{touch-action:none;position:absolute;cursor:pointer;padding:0;margin:0;box-sizing:border-box;border-width:0;z-index:2;overflow:hidden}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle svg{position:absolute;top:50%;left:50%}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle .bento-splitter-handle-move{display:none}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom,bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top{bottom:auto;top:auto;left:0;width:100%;border-top-width:1px;border-style:solid;border-bottom-width:1px}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{left:auto;right:auto;top:0;height:100%;border-left-width:1px;border-style:solid;border-right-width:1px}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top{bottom:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top svg{transform:translate(-50%,-50%) rotate(90deg)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{top:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom svg{transform:translate(-50%,-50%) rotate(-90deg)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left{right:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left svg{transform:translate(-50%,-50%)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{left:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right svg{transform:translate(-50%,-50%) rotate(180deg)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle:focus{outline:0}bento-splitter-group.unselectable b,bento-splitter-group.unselectable div,bento-splitter-group.unselectable h1,bento-splitter-group.unselectable h2,bento-splitter-group.unselectable h3,bento-splitter-group.unselectable h4,bento-splitter-group.unselectable h5,bento-splitter-group.unselectable h6,bento-splitter-group.unselectable i,bento-splitter-group.unselectable input,bento-splitter-group.unselectable p,bento-splitter-group.unselectable span,bento-splitter-group.unselectable strong,bento-splitter-group.unselectable tr{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-splitter-group.bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel,bento-splitter-group.dragging-bottom>.bento-splitter-group-panel,bento-splitter-group.dragging-left>.bento-splitter-group-panel,bento-splitter-group.dragging-right>.bento-splitter-group-panel,bento-splitter-group.dragging-top>.bento-splitter-group-panel{transition:none!important}bento-splitter-group .bento-splitter-group-bottom,bento-splitter-group .bento-splitter-group-left,bento-splitter-group .bento-splitter-group-main,bento-splitter-group .bento-splitter-group-right,bento-splitter-group .bento-splitter-group-top{background-color:transparent;margin:0;padding:0;position:absolute;overflow:hidden;box-sizing:border-box;z-index:0}bento-splitter-group .bento-splitter-group-bottom>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-main>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-right>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-top>.bento-splitter-group-inner{position:absolute;overflow:auto}bento-splitter-group .bento-splitter-group-bottom:focus,bento-splitter-group .bento-splitter-group-left:focus,bento-splitter-group .bento-splitter-group-main:focus,bento-splitter-group .bento-splitter-group-right:focus,bento-splitter-group .bento-splitter-group-top:focus{outline:0}bento-splitter-group .bento-splitter-group-left{top:0;bottom:0;transition:left .1s,width .1s,top .1s,bottom .1s}bento-splitter-group.opened-left>.bento-splitter-group-left>.bento-splitter-handle-left svg{transform:translate(-50%,-50%) rotate(180deg)}bento-splitter-group.opened-left>.bento-splitter-group-main{left:auto}bento-splitter-group .bento-splitter-group-right{top:0;bottom:0;transition:right .1s,width .1s,top .1s,bottom .1s}bento-splitter-group.opened-right>.bento-splitter-group-right>.bento-splitter-handle-right svg{transform:translate(-50%,-50%)}bento-splitter-group.opened-right>.bento-splitter-group-main{right:auto}bento-splitter-group .bento-splitter-group-top{left:0;right:0;transition:top .1s,height .1s}bento-splitter-group.opened-top>.bento-splitter-group-top>.bento-splitter-handle-top svg{transform:translate(-50%,-50%) rotate(-90deg)}bento-splitter-group.opened-top>.bento-splitter-group-main{top:0}bento-splitter-group .bento-splitter-group-bottom{right:0;left:0;transition:bottom .1s,height .1s}bento-splitter-group.opened-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom svg{transform:translate(-50%,-50%) rotate(90deg)}bento-splitter-group.opened-bottom>.bento-splitter-group-main{bottom:0}bento-splitter-group .bento-splitter-group-main{top:0;bottom:0;left:0;right:0;transition:left .1s,right .1s,top .1s,bottom .1s;overflow:hidden;z-index:1}bento-splitter-group.bento-splitter-group-autoresize{display:block;width:100%;position:relative}bento-splitter-group.bento-splitter-group-autoresize>.bento-splitter-group-main>.bento-splitter-group-inner{position:relative;margin:0;display:block;overflow-x:auto;overflow-y:visible;width:100%;height:auto}bento-splitter-group.dragging-left>.bento-splitter-group-left>.bento-splitter-handle-left,bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left{cursor:col-resize}bento-splitter-group.dragging-left>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-left>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-default{display:none}bento-splitter-group.dragging-top>.bento-splitter-group-top>.bento-splitter-handle-top,bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top{cursor:row-resize}bento-splitter-group.dragging-top>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-top>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-default{display:none}bento-splitter-group.dragging-right>.bento-splitter-group-right>.bento-splitter-handle-right,bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right{cursor:col-resize}bento-splitter-group.dragging-right>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-right>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-default{display:none}bento-splitter-group.dragging-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom,bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom{cursor:row-resize}bento-splitter-group.dragging-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-default{display:none}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSplitterGroupComponent, [{
        type: Component,
        args: [{
                selector: 'bento-splitter-group',
                template: "<ng-content></ng-content>\n",
                providers: [BentoNotification],
                encapsulation: ViewEncapsulation.None,
                styles: ["bento-splitter-group{box-sizing:border-box;position:absolute;min-height:400px;top:0;left:0;right:0;bottom:0;overflow:hidden}[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-default,[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-left .bento-splitter-handle-move,[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-default,[dir=rtl] bento-splitter-group.isIE .bento-splitter-handle-right .bento-splitter-handle-move{left:-50%}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{touch-action:none;position:absolute;cursor:pointer;padding:0;margin:0;box-sizing:border-box;border-width:0;z-index:2;overflow:hidden}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle svg{position:absolute;top:50%;left:50%}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle .bento-splitter-handle-move{display:none}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom,bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top{bottom:auto;top:auto;left:0;width:100%;border-top-width:1px;border-style:solid;border-bottom-width:1px}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left,bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{left:auto;right:auto;top:0;height:100%;border-left-width:1px;border-style:solid;border-right-width:1px}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top{bottom:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-top svg{transform:translate(-50%,-50%) rotate(90deg)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom{top:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-bottom svg{transform:translate(-50%,-50%) rotate(-90deg)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left{right:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left svg{transform:translate(-50%,-50%)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right{left:0}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-right svg{transform:translate(-50%,-50%) rotate(180deg)}bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle:focus{outline:0}bento-splitter-group.unselectable b,bento-splitter-group.unselectable div,bento-splitter-group.unselectable h1,bento-splitter-group.unselectable h2,bento-splitter-group.unselectable h3,bento-splitter-group.unselectable h4,bento-splitter-group.unselectable h5,bento-splitter-group.unselectable h6,bento-splitter-group.unselectable i,bento-splitter-group.unselectable input,bento-splitter-group.unselectable p,bento-splitter-group.unselectable span,bento-splitter-group.unselectable strong,bento-splitter-group.unselectable tr{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-splitter-group.bento-splitter-group-handle-pointer-down>.bento-splitter-group-panel,bento-splitter-group.dragging-bottom>.bento-splitter-group-panel,bento-splitter-group.dragging-left>.bento-splitter-group-panel,bento-splitter-group.dragging-right>.bento-splitter-group-panel,bento-splitter-group.dragging-top>.bento-splitter-group-panel{transition:none!important}bento-splitter-group .bento-splitter-group-bottom,bento-splitter-group .bento-splitter-group-left,bento-splitter-group .bento-splitter-group-main,bento-splitter-group .bento-splitter-group-right,bento-splitter-group .bento-splitter-group-top{background-color:transparent;margin:0;padding:0;position:absolute;overflow:hidden;box-sizing:border-box;z-index:0}bento-splitter-group .bento-splitter-group-bottom>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-main>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-right>.bento-splitter-group-inner,bento-splitter-group .bento-splitter-group-top>.bento-splitter-group-inner{position:absolute;overflow:auto}bento-splitter-group .bento-splitter-group-bottom:focus,bento-splitter-group .bento-splitter-group-left:focus,bento-splitter-group .bento-splitter-group-main:focus,bento-splitter-group .bento-splitter-group-right:focus,bento-splitter-group .bento-splitter-group-top:focus{outline:0}bento-splitter-group .bento-splitter-group-left{top:0;bottom:0;transition:left .1s,width .1s,top .1s,bottom .1s}bento-splitter-group.opened-left>.bento-splitter-group-left>.bento-splitter-handle-left svg{transform:translate(-50%,-50%) rotate(180deg)}bento-splitter-group.opened-left>.bento-splitter-group-main{left:auto}bento-splitter-group .bento-splitter-group-right{top:0;bottom:0;transition:right .1s,width .1s,top .1s,bottom .1s}bento-splitter-group.opened-right>.bento-splitter-group-right>.bento-splitter-handle-right svg{transform:translate(-50%,-50%)}bento-splitter-group.opened-right>.bento-splitter-group-main{right:auto}bento-splitter-group .bento-splitter-group-top{left:0;right:0;transition:top .1s,height .1s}bento-splitter-group.opened-top>.bento-splitter-group-top>.bento-splitter-handle-top svg{transform:translate(-50%,-50%) rotate(-90deg)}bento-splitter-group.opened-top>.bento-splitter-group-main{top:0}bento-splitter-group .bento-splitter-group-bottom{right:0;left:0;transition:bottom .1s,height .1s}bento-splitter-group.opened-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom svg{transform:translate(-50%,-50%) rotate(90deg)}bento-splitter-group.opened-bottom>.bento-splitter-group-main{bottom:0}bento-splitter-group .bento-splitter-group-main{top:0;bottom:0;left:0;right:0;transition:left .1s,right .1s,top .1s,bottom .1s;overflow:hidden;z-index:1}bento-splitter-group.bento-splitter-group-autoresize{display:block;width:100%;position:relative}bento-splitter-group.bento-splitter-group-autoresize>.bento-splitter-group-main>.bento-splitter-group-inner{position:relative;margin:0;display:block;overflow-x:auto;overflow-y:visible;width:100%;height:auto}bento-splitter-group.dragging-left>.bento-splitter-group-left>.bento-splitter-handle-left,bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left{cursor:col-resize}bento-splitter-group.dragging-left>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-left>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-left>.bento-splitter-handle-left .bento-splitter-handle-default{display:none}bento-splitter-group.dragging-top>.bento-splitter-group-top>.bento-splitter-handle-top,bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top{cursor:row-resize}bento-splitter-group.dragging-top>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-top>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-top>.bento-splitter-handle-top .bento-splitter-handle-default{display:none}bento-splitter-group.dragging-right>.bento-splitter-group-right>.bento-splitter-handle-right,bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right{cursor:col-resize}bento-splitter-group.dragging-right>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-right>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-right>.bento-splitter-handle-right .bento-splitter-handle-default{display:none}bento-splitter-group.dragging-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom,bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom{cursor:row-resize}bento-splitter-group.dragging-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-move,bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-move{display:block}bento-splitter-group.dragging-bottom>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-default,bento-splitter-group.no-collapse>.bento-splitter-group-bottom>.bento-splitter-handle-bottom .bento-splitter-handle-default{display:none}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: WindowRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc6.Directionality }]; }, { leftMaxWidth: [{
            type: Input
        }], leftSizeChange: [{
            type: Output,
            args: ['leftWidthChange']
        }], leftOpenedChange: [{
            type: Output
        }], rightMaxWidth: [{
            type: Input
        }], rightSizeChange: [{
            type: Output,
            args: ['rightWidthChange']
        }], rightOpenedChange: [{
            type: Output
        }], topMaxHeight: [{
            type: Input
        }], topSizeChange: [{
            type: Output,
            args: ['topHeightChange']
        }], topOpenedChange: [{
            type: Output
        }], bottomMaxHeight: [{
            type: Input
        }], bottomSizeChange: [{
            type: Output,
            args: ['bottomHeightChange']
        }], bottomOpenedChange: [{
            type: Output
        }], _isIE: [{
            type: HostBinding,
            args: ['class.isIE']
        }], autoResize: [{
            type: Input
        }], noCollapse: [{
            type: Input
        }], leftWidth: [{
            type: Input
        }], leftOpened: [{
            type: Input
        }], rightWidth: [{
            type: Input
        }], rightOpened: [{
            type: Input
        }], topHeight: [{
            type: Input
        }], topOpened: [{
            type: Input
        }], bottomHeight: [{
            type: Input
        }], bottomOpened: [{
            type: Input
        }], _leftPanel: [{
            type: ContentChild,
            args: [BentoSplitterGroupLeftComponent]
        }], _topPanel: [{
            type: ContentChild,
            args: [BentoSplitterGroupTopComponent]
        }], _rightPanel: [{
            type: ContentChild,
            args: [BentoSplitterGroupRightComponent]
        }], _bottomPanel: [{
            type: ContentChild,
            args: [BentoSplitterGroupBottomComponent]
        }], mainPanel: [{
            type: ContentChild,
            args: [BentoSplitterGroupMainComponent, { static: true }]
        }] }); })();
    return BentoSplitterGroupComponent;
}());
if (false) {
    /**
     * Maximum width of the left panel
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.leftMaxWidth;
    /**
     * Callback when the width of the left panel is changed
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.leftSizeChange;
    /**
     * Callback when flag `leftOpened` changes
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.leftOpenedChange;
    /**
     * Maximum width of the right panel
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.rightMaxWidth;
    /**
     * Callback when the width of the right panel is changed
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.rightSizeChange;
    /**
     * Callback when flag `rightOpened` changes
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.rightOpenedChange;
    /**
     * Maximum height of the top panel
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.topMaxHeight;
    /**
     * Callback when the height of the top panel is changed
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.topSizeChange;
    /**
     * Callback when flag `topOpened` changes
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.topOpenedChange;
    /**
     * Maximum height of the bottom panel
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.bottomMaxHeight;
    /**
     * Callback when the height of the bottom panel is changed
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.bottomSizeChange;
    /**
     * Callback when flag `bottomOpened` changes
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.bottomOpenedChange;
    /** @type {?} */
    BentoSplitterGroupComponent.prototype._isIE;
    /** @type {?} */
    BentoSplitterGroupComponent.prototype.mainPanel;
    /** @type {?} */
    BentoSplitterGroupComponent.prototype.topPanel;
    /** @type {?} */
    BentoSplitterGroupComponent.prototype.bottomPanel;
    /** @type {?} */
    BentoSplitterGroupComponent.prototype.leftPanel;
    /** @type {?} */
    BentoSplitterGroupComponent.prototype.rightPanel;
    /** @type {?} */
    BentoSplitterGroupComponent.prototype.el;
    /**
     * API related private variables
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype._autoResize;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.leftSize;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.rightSize;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.topSize;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.bottomSize;
    /**
     * Default variables
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.defaultHandleWidth;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.autoCloseThreshhold;
    /**
     * Handle drag related variables
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.originalSize;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.actionSide;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.isLeftOpen;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.isRightOpen;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.isTopOpen;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.isBottomOpen;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.actionSideStr;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.actionSideLowerCase;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.mainPanelInnerEl;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.originalPoint;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.previousPoint;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.moveIndicatorTimeout;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.previousOpenState;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.pointerMoveEventName;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.pointerUpEventName;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.pointerCancelEventName;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.isDragged;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.subPointerMove;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.subPointerUp;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.subPointerCancel;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.subResize;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.renderDebounceTimeout;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoSplitterGroupComponent.prototype.isRtl;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupComponent.prototype.bentoNotification;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupComponent.prototype.windowRef;
    /**
     * @type {?}
     * @protected
     */
    BentoSplitterGroupComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoSplitterGroupComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/splitter-group/splitter-group.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoSplitterGroupModule = /** @class */ (function () {
    function BentoSplitterGroupModule() {
    }
BentoSplitterGroupModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoSplitterGroupModule });
BentoSplitterGroupModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoSplitterGroupModule_Factory(t) { return new (t || BentoSplitterGroupModule)(); }, imports: [[BentoTranslateModule, BentoUtilsModule, A11yModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoSplitterGroupModule, { declarations: function () { return [BentoSplitterGroupComponent,
        BentoSplitterGroupLeftComponent,
        BentoSplitterGroupRightComponent,
        BentoSplitterGroupTopComponent,
        BentoSplitterGroupBottomComponent,
        BentoSplitterGroupMainComponent]; }, imports: function () { return [BentoTranslateModule,
        BentoUtilsModule,
        A11yModule]; }, exports: function () { return [BentoSplitterGroupComponent,
        BentoSplitterGroupLeftComponent,
        BentoSplitterGroupRightComponent,
        BentoSplitterGroupTopComponent,
        BentoSplitterGroupBottomComponent,
        BentoSplitterGroupMainComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoSplitterGroupModule, [{
        type: NgModule,
        args: [{
                imports: [BentoTranslateModule, BentoUtilsModule, A11yModule],
                declarations: [
                    BentoSplitterGroupComponent,
                    BentoSplitterGroupLeftComponent,
                    BentoSplitterGroupRightComponent,
                    BentoSplitterGroupTopComponent,
                    BentoSplitterGroupBottomComponent,
                    BentoSplitterGroupMainComponent
                ],
                exports: [
                    BentoSplitterGroupComponent,
                    BentoSplitterGroupLeftComponent,
                    BentoSplitterGroupRightComponent,
                    BentoSplitterGroupTopComponent,
                    BentoSplitterGroupBottomComponent,
                    BentoSplitterGroupMainComponent
                ]
            }]
    }], function () { return []; }, null); })();
    return BentoSplitterGroupModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sticky-bar/sticky-bar.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable no-unused-expression */
/**
 * A component to accomendate scroll panels location and sticks itself to the bottom to its parent scrolling panel
 */
var BentoStickyBarDirective = /** @class */ (function () {
    function BentoStickyBarDirective(r, elRef, winRef, tabService, bentoNotification, dir) {
        var _this = this;
        this.r = r;
        this.winRef = winRef;
        this.tabService = tabService;
        this.bentoNotification = bentoNotification;
        this.dir = dir;
        /**
         * Side where this element becomes sticky
         */
        this.side = 'bottom';
        /**
         * Determine if this component does full width of the scrollable when goes sticky
         */
        this.fullWidth = true;
        /**
         * Show this sticky bar only when a specified HTMLElement is visible
         */
        this.showOnElementVisible = null;
        this.resizeSubscription = Subscription.EMPTY;
        this.document = winRef.nativeDocument;
        this.window = winRef.nativeWindow;
        this.el = elRef.nativeElement;
        this.lastScrolled = performance.now();
        this.stickyEl = (/** @type {?} */ (this.r.createElement('div')));
        this.onWindowScroll = this.onWindowScroll.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        if (dir) {
            this.isRTL = dir.value === 'rtl';
            dir.change.subscribe((/**
             * @return {?}
             */
            function () {
                _this.flipDirection();
            }));
        }
    }
    /**
     * @private
     * @return {?}
     */
    BentoStickyBarDirective.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.isRTL = this.dir.value === 'rtl';
        this.checkAllocation();
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.alignBar();
        }));
    };
    /**
     * @return {?}
     */
    BentoStickyBarDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // Initialize sticky bar DOM
        this.r.addClass(this.stickyEl, 'bento-sticky-bar');
        this.stickyEl.addEventListener('keydown', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            _this.onStickyBarKeydown(e);
        }));
        this.document.addEventListener('scroll', this.onWindowScroll, true); // Have to use vanilla JS to utilize `useCapture`
        this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () {
            _this.onWindowResize();
        }));
        // Get reference visible element
        if (this.showOnElementVisible) {
            if (typeof this.showOnElementVisible === 'string') {
                this.showOnElementVisible = (/** @type {?} */ (this.document.querySelector(this.showOnElementVisible)));
            }
        }
    };
    /**
     * @return {?}
     */
    BentoStickyBarDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        // Remove all window listeners to prevent memory leak
        this.document.removeEventListener('scroll', this.onWindowScroll, true);
        this.resizeSubscription.unsubscribe();
        if (this.stickyEl.parentElement) {
            // Remove sticky element from any HTMLElement if there is one
            this.stickyEl.parentElement.removeChild(this.stickyEl);
            this.stickyEl = null;
        }
        if (this.placeholder) {
            if (this.placeholder.el.parentElement) {
                this.placeholder.el.parentElement.removeChild(this.placeholder.el);
            }
            if (this.placeholder.marker.parentElement) {
                this.placeholder.marker.parentElement.removeChild(this.placeholder.marker);
            }
        }
    };
    /**
     * @return {?}
     */
    BentoStickyBarDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // There are cases where UI elements are not renderred yet
            _this.checkAllocation();
        }));
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoStickyBarDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        // Update css
        if (changes.side) {
            if (changes.side.currentValue === 'top') {
                this.r.addClass(this.stickyEl, 'top');
            }
            else {
                this.r.removeClass(this.stickyEl, 'top');
            }
        }
    };
    /**
     * Method to align this component with the scrollable
     */
    /**
     * Method to align this component with the scrollable
     * @return {?}
     */
    BentoStickyBarDirective.prototype.alignBar = /**
     * Method to align this component with the scrollable
     * @return {?}
     */
    function () {
        if (this.stickyEl.parentElement) {
            /** @type {?} */
            var isFixed = this.stickyEl.classList.contains('fixed');
            // Make sure everything is aligned since the sticky bar is in the view
            /** @type {?} */
            var parentRect = isFixed
                ? // scrollParentEl is Document and there is no `getBoundingClientRect()` for Document object
                    {
                        top: 0,
                        left: 0,
                        right: this.viewSize.width,
                        bottom: this.viewSize.height,
                        width: this.viewSize.width,
                        height: this.viewSize.height
                    }
                : this.scrollParentEl.getBoundingClientRect();
            /** @type {?} */
            var left = 0;
            /** @type {?} */
            var top_1 = 0;
            /** @type {?} */
            var width = void 0;
            if (this.fullWidth) {
                left += this.scrollParentEl.offsetLeft;
                width = this.scrollParentEl.offsetWidth - this.winRef.scrollbarWidth;
            }
            else {
                /** @type {?} */
                var placeholderRect = this.placeholder.el.getBoundingClientRect();
                left = placeholderRect.left - parentRect.left;
                width = this.placeholder.el.offsetWidth;
            }
            if (this.isRTL) {
                left += this.winRef.scrollbarWidth;
            }
            if (this.winRef.isFF) {
                // Firefox has an additional 1px padding on the top left
                // It needs to be removed to avoid the extra pixel on the left
                left--;
            }
            this.r.setStyle(this.stickyEl, 'width', width + "px");
            this.r.setStyle(this.stickyEl, 'left', left + "px");
            if (isFixed) {
                // Not need to align vertically since this sticky bar is fixed either the
                // top of the viewport or this bottom
                return;
            }
            if (this.side === 'bottom') {
                /** @type {?} */
                var parentStyle = this.window.getComputedStyle(this.scrollParentEl);
                // Bottom alignment
                if (this.scrollParentEl.offsetWidth < this.scrollParentEl.scrollWidth &&
                    parentStyle.overflowX === 'auto' &&
                    parentStyle.overflowX === 'scroll') {
                    // There is horizontal scrollbar
                    top_1 =
                        this.scrollParentEl.offsetTop + parentRect.height - this.stickyEl.offsetHeight - this.winRef.scrollbarWidth;
                }
                else {
                    // There is no horizontal scrollbar
                    top_1 = this.scrollParentEl.offsetTop + parentRect.height - this.stickyEl.offsetHeight;
                }
            }
            else {
                // Top alignment
                top_1 = this.scrollParentEl.offsetTop;
            }
            if (this.winRef.isFF) {
                // Firefox has an additional 1px padding on the top left
                // It needs to be removed to avoid the extra pixel on the left
                top_1--;
            }
            this.r.setStyle(this.stickyEl, 'top', top_1 + "px");
        }
    };
    /**
     * A method/callback to check whether sticky bar should be displayed
     */
    /**
     * A method/callback to check whether sticky bar should be displayed
     * @param {?=} e
     * @return {?}
     */
    BentoStickyBarDirective.prototype.checkAllocation = /**
     * A method/callback to check whether sticky bar should be displayed
     * @param {?=} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        if (this.stickyEl == null) {
            // Looks like this item has already destroyed but the unsubscribe didn't catch up
            /* istanbul ignore next */
            return;
        }
        /** @type {?} */
        var timeScrolled = performance.now();
        /** @type {?} */
        var dTime = timeScrolled - this.lastScrolled;
        /** @type {?} */
        var elAtFooterLocation = this.placeholder ? this.placeholder.el : this.el;
        /** @type {?} */
        var elRect = elAtFooterLocation.getBoundingClientRect();
        /** @type {?} */
        var showOnRefElementRect = this.showOnElementVisible
            ? ((/** @type {?} */ (this.showOnElementVisible))).getBoundingClientRect()
            : null;
        /** @type {?} */
        var refElementInView = true;
        /** @type {?} */
        var parentRect;
        /** @type {?} */
        var offsetParent;
        this.lastScrolled = timeScrolled;
        if (dTime > 500 || !e) {
            this.scrollParentEl = this.getScrollParent(elAtFooterLocation);
            this.viewSize = this.getViewSize();
        }
        if (this.scrollParentEl === this.document) {
            if (showOnRefElementRect &&
                (showOnRefElementRect.top + elRect.height > this.viewSize.height || showOnRefElementRect.bottom < 0)) {
                // refElement is not visible in viewport
                refElementInView = false;
            }
            if (((Math.floor(elRect.bottom) > this.viewSize.height && this.side === 'bottom') ||
                (elRect.top < 0 && this.side === 'top')) &&
                refElementInView) {
                if (!this.placeholder) {
                    offsetParent = this.document.body;
                    this.stickyEl.classList.add('fixed');
                    offsetParent.appendChild(this.stickyEl);
                    this.placeholder = this.moveBarToSticky();
                    // Need directive to be able to receive focus
                    this.onElementFocusCancel = this.r.listen(this.placeholder.el, 'focus', (/**
                     * @param {?} event
                     * @return {?}
                     */
                    function (event) {
                        _this.onElFocus(event);
                    }));
                }
            }
            else if (this.stickyEl.parentElement) {
                this.stickyEl.parentElement.removeChild(this.stickyEl);
                this.restoreBarFromSticky();
                // Need directive to remove focus
                this.onElementFocusCancel();
            }
        }
        else if (!e || e.target === this.scrollParentEl) {
            parentRect = this.scrollParentEl.getBoundingClientRect();
            if (showOnRefElementRect &&
                (showOnRefElementRect.top + elRect.height > parentRect.bottom || showOnRefElementRect.bottom < parentRect.top)) {
                // refElement is not visible in viewport
                refElementInView = false;
            }
            if (((Math.floor(elRect.bottom) > parentRect.bottom && this.side === 'bottom') ||
                (elRect.top < parentRect.top && this.side === 'top')) &&
                refElementInView) {
                if (!this.stickyEl.offsetParent) {
                    // Append sticky
                    offsetParent = this.scrollParentEl.offsetParent;
                    this.placeholder = this.moveBarToSticky();
                    this.r.setStyle(this.stickyEl, 'visibility', 'hidden');
                    this.r.appendChild(offsetParent, this.stickyEl);
                    this.r.removeStyle(this.stickyEl, 'visibility');
                    // Need directive to be able to receive focus
                    this.onElementFocusCancel = this.r.listen(this.placeholder.el, 'focus', (/**
                     * @param {?} event
                     * @return {?}
                     */
                    function (event) {
                        _this.onElFocus(event);
                    }));
                    // adjust the top full time in case this content is pushed down but padding changes
                    this.alignBar();
                }
            }
            else {
                if (this.stickyEl && this.stickyEl.parentElement) {
                    this.stickyEl.parentElement.removeChild(this.stickyEl);
                    this.stickyEl.style.top = '-1000px'; // just in case
                    this.restoreBarFromSticky();
                    // Need directive to remove focus
                    this.el.removeAttribute('tabindex');
                    this.onElementFocusCancel();
                }
            }
        }
    };
    /**
     * Callback when window is resized
     */
    /**
     * Callback when window is resized
     * @private
     * @return {?}
     */
    BentoStickyBarDirective.prototype.onWindowResize = /**
     * Callback when window is resized
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.checkAllocation();
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.alignBar();
        }));
    };
    /**
     * Callback when there is a scrolling
     */
    /**
     * Callback when there is a scrolling
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoStickyBarDirective.prototype.onWindowScroll = /**
     * Callback when there is a scrolling
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.checkAllocation(e);
    };
    /**
     * Get viewport size (aka window size)
     */
    /**
     * Get viewport size (aka window size)
     * @private
     * @return {?}
     */
    BentoStickyBarDirective.prototype.getViewSize = /**
     * Get viewport size (aka window size)
     * @private
     * @return {?}
     */
    function () {
        return {
            width: this.window.innerWidth || this.document.body.clientWidth,
            height: this.window.innerHeight || this.document.body.clientHeight
        };
    };
    /**
     * Tasks to perform when el is focused
     */
    /**
     * Tasks to perform when el is focused
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoStickyBarDirective.prototype.onElFocus = /**
     * Tasks to perform when el is focused
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var tabbables = this.tabService.findTabbable(this.stickyEl);
        if (tabbables.length) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                tabbables[0].focus();
            }));
        }
    };
    /**
     * Used to catch Tab keys
     */
    /**
     * Used to catch Tab keys
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoStickyBarDirective.prototype.onStickyBarKeydown = /**
     * Used to catch Tab keys
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        // Tab: 9
        if (e.keyCode === Keyboard.TAB) {
            /** @type {?} */
            var tabbables = this.tabService.findTabbable(this.stickyEl);
            if (e.target === tabbables[0] && e.shiftKey) {
                // focus back
                if (this.placeholder) {
                    this.placeholder.marker.focus();
                }
            }
            else if (e.target === tabbables[tabbables.length - 1] && !e.shiftKey) {
                if (this.placeholder) {
                    ((/** @type {?} */ (this.placeholder.el.firstChild))).focus();
                }
            }
        }
    };
    /**
     * Move directive to the sticky bar
     */
    /**
     * Move directive to the sticky bar
     * @private
     * @return {?}
     */
    BentoStickyBarDirective.prototype.moveBarToSticky = /**
     * Move directive to the sticky bar
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var placeholder = this.r.createElement('div');
        /** @type {?} */
        var previousMarker = this.r.createElement('div');
        /** @type {?} */
        var bar = this.el;
        /** @type {?} */
        var parent = bar.parentElement;
        previousMarker.className = 'bento-sticky-bar-previous-marker';
        previousMarker.setAttribute('tabindex', '-1');
        placeholder.className = 'bento-sticky-bar-placeholder';
        placeholder.setAttribute('tabindex', '0');
        placeholder.innerHTML = '<div class="bento-sticky-bar-next-marker" tabindex="-1"></div>';
        // copy inner HTML
        parent.insertBefore(placeholder, bar);
        parent.insertBefore(previousMarker, placeholder);
        this.r.setStyle(placeholder, 'height', bar.offsetHeight + "px");
        this.stickyEl.innerHTML = '';
        this.stickyEl.appendChild(bar);
        return {
            el: placeholder,
            marker: previousMarker
        };
    };
    /**
     * Restore contents from sticky to bar
     */
    /**
     * Restore contents from sticky to bar
     * @private
     * @return {?}
     */
    BentoStickyBarDirective.prototype.restoreBarFromSticky = /**
     * Restore contents from sticky to bar
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var el = this.placeholder.el;
        /** @type {?} */
        var marker = this.placeholder.marker;
        /** @type {?} */
        var parent = el.parentElement;
        el.style.visibility = 'hidden';
        parent.insertBefore(this.el, el);
        if (el.parentElement) {
            el.parentElement.removeChild(el);
        }
        if (marker.parentElement) {
            marker.parentElement.removeChild(marker);
        }
        this.placeholder = null;
    };
    /**
     * Get a parent that scrolls
     */
    /**
     * Get a parent that scrolls
     * @private
     * @param {?} el
     * @return {?}
     */
    BentoStickyBarDirective.prototype.getScrollParent = /**
     * Get a parent that scrolls
     * @private
     * @param {?} el
     * @return {?}
     */
    function (el) {
        /** @type {?} */
        var parent = el.parentElement;
        while (parent) {
            if (parent.scrollHeight > parent.offsetHeight) {
                /** @type {?} */
                var style = this.window.getComputedStyle(parent);
                if (style.overflow === 'auto' ||
                    style.overflowY === 'auto' ||
                    style.overflow === 'scroll' ||
                    style.overflowY === 'scroll') {
                    return parent;
                }
            }
            parent = parent.parentElement;
        }
        return this.document;
    };
    /** @nocollapse */
    BentoStickyBarDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: WindowRef },
        { type: BentoTabService },
        { type: BentoNotification },
        { type: Directionality }
    ]; };
    BentoStickyBarDirective.propDecorators = {
        side: [{ type: Input }],
        fullWidth: [{ type: Input }],
        showOnElementVisible: [{ type: Input }]
    };
BentoStickyBarDirective.ɵfac = function BentoStickyBarDirective_Factory(t) { return new (t || BentoStickyBarDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoTabService), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoStickyBarDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoStickyBarDirective, selectors: [["", "bentoStickyBar", ""]], inputs: { side: "side", fullWidth: "fullWidth", showOnElementVisible: "showOnElementVisible" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoTabService, BentoNotification]), ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoStickyBarDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoStickyBar]',
                providers: [BentoTabService, BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: BentoTabService }, { type: BentoNotification }, { type: ɵngcc6.Directionality }]; }, { side: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], showOnElementVisible: [{
            type: Input
        }] }); })();
    return BentoStickyBarDirective;
}());
if (false) {
    /**
     * Side where this element becomes sticky
     * @type {?}
     */
    BentoStickyBarDirective.prototype.side;
    /**
     * Determine if this component does full width of the scrollable when goes sticky
     * @type {?}
     */
    BentoStickyBarDirective.prototype.fullWidth;
    /**
     * Show this sticky bar only when a specified HTMLElement is visible
     * @type {?}
     */
    BentoStickyBarDirective.prototype.showOnElementVisible;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.window;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.scrollParentEl;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.lastScrolled;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.stickyEl;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.viewSize;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.placeholder;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.onElementFocusCancel;
    /**
     * Use isRTL as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoStickyBarDirective.prototype.isRTL;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.winRef;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.tabService;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.bentoNotification;
    /**
     * @type {?}
     * @private
     */
    BentoStickyBarDirective.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sticky-bar/sticky-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoStickyBarModule = /** @class */ (function () {
    function BentoStickyBarModule() {
    }
BentoStickyBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoStickyBarModule });
BentoStickyBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoStickyBarModule_Factory(t) { return new (t || BentoStickyBarModule)(); }, providers: [], imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoStickyBarModule, { declarations: [BentoStickyBarDirective], exports: [BentoStickyBarDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoStickyBarModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [BentoStickyBarDirective],
                declarations: [BentoStickyBarDirective],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoStickyBarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sticky-footer/sticky-footer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable no-unused-expression */
/**
 * A component to accomendate scroll panels location and sticks itself to the bottom to its parent scrolling panel
 */
var BentoStickyFooterComponent = /** @class */ (function (_super) {
    __extends(BentoStickyFooterComponent, _super);
    function BentoStickyFooterComponent(r, elRef, winRef, tabService, bn, dir) {
        var _this = _super.call(this, r, elRef, winRef, tabService, bn, dir) || this;
        /**
         * Override super class
         */
        _this.side = 'bottom';
        r.addClass(elRef.nativeElement, 'bento-sticky-footer');
        return _this;
    }
    /** @nocollapse */
    BentoStickyFooterComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: WindowRef },
        { type: BentoTabService },
        { type: BentoNotification },
        { type: Directionality }
    ]; };
BentoStickyFooterComponent.ɵfac = function BentoStickyFooterComponent_Factory(t) { return new (t || BentoStickyFooterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoTabService), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoStickyFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoStickyFooterComponent, selectors: [["bento-sticky-footer"]], features: [ɵngcc0.ɵɵProvidersFeature([BentoTabService, BentoNotification]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 1, vars: 0, template: function BentoStickyFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["bento-sticky-footer{display:flex;clear:both}bento-sticky-footer:after{content:\" \";display:block;height:0;clear:both}.bento-sticky-bar bento-sticky-footer{padding:10px 15px;border-top-width:1px;border-top-style:solid}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoStickyFooterComponent, [{
        type: Component,
        args: [{
                selector: 'bento-sticky-footer',
                template: "<ng-content></ng-content>\n",
                providers: [BentoTabService, BentoNotification],
                encapsulation: ViewEncapsulation.None,
                styles: ["bento-sticky-footer{display:flex;clear:both}bento-sticky-footer:after{content:\" \";display:block;height:0;clear:both}.bento-sticky-bar bento-sticky-footer{padding:10px 15px;border-top-width:1px;border-top-style:solid}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: BentoTabService }, { type: BentoNotification }, { type: ɵngcc6.Directionality }]; }, null); })();
    return BentoStickyFooterComponent;
}(BentoStickyBarDirective));
if (false) {
    /**
     * Override super class
     * @type {?}
     */
    BentoStickyFooterComponent.prototype.side;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sticky-footer/sticky-footer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoStickyFooterModule = /** @class */ (function () {
    function BentoStickyFooterModule() {
    }
BentoStickyFooterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoStickyFooterModule });
BentoStickyFooterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoStickyFooterModule_Factory(t) { return new (t || BentoStickyFooterModule)(); }, providers: [], imports: [[BentoStickyBarModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoStickyFooterModule, { declarations: [BentoStickyFooterComponent], imports: [BentoStickyBarModule], exports: [BentoStickyFooterComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoStickyFooterModule, [{
        type: NgModule,
        args: [{
                imports: [BentoStickyBarModule],
                exports: [BentoStickyFooterComponent],
                declarations: [BentoStickyFooterComponent],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoStickyFooterModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tabs/tabs-label.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable directive-selector */
/**
 * A component that accommodates to Tabset tabs to allow text truncation and tooltip when a label is
 * truncated.
 *
 * **Note** Pills are not supported
 */
var BentoTabsLabelComponent = /** @class */ (function () {
    /**
     * Constructor
     */
    function BentoTabsLabelComponent(elRef, r, bentoNotification, focusMonitor) {
        var _this = this;
        this.focusMonitor = focusMonitor;
        /**
         * Sets the maximum width of this label before truncation starts, or omit to allow tabs to take maximum
         * possible width in the tabset
         */
        this.maxWidth = 'none';
        this._noTextTruncation = true;
        this._el = (/** @type {?} */ (elRef.nativeElement));
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () {
            _this.checkTextTruncation();
        }));
    }
    Object.defineProperty(BentoTabsLabelComponent.prototype, "label", {
        /**
         * Label of this component
         */
        get: /**
         * Label of this component
         * @return {?}
         */
        function () {
            return this._label;
        },
        /**
         * Text that goes into the tab.  HTML is allowed
         */
        set: /**
         * Text that goes into the tab.  HTML is allowed
         * @param {?} str
         * @return {?}
         */
        function (str) {
            this._label = str;
            this.checkTextTruncation();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Implements view init
     */
    /**
     * Implements view init
     * @return {?}
     */
    BentoTabsLabelComponent.prototype.ngAfterViewInit = /**
     * Implements view init
     * @return {?}
     */
    function () {
        var _this = this;
        this.checkTextTruncation();
        this.focusMonitor.monitor(this._el.parentElement).subscribe((/**
         * @param {?} origin
         * @return {?}
         */
        function (origin) {
            if (origin === null) {
                _this.truncatedTooltip && _this.truncatedTooltip.close();
            }
            else if (origin === 'keyboard') {
                _this.truncatedTooltip && _this.truncatedTooltip.open();
            }
        }));
    };
    /**
     * Implements OnDestroy
     */
    /**
     * Implements OnDestroy
     * @return {?}
     */
    BentoTabsLabelComponent.prototype.ngOnDestroy = /**
     * Implements OnDestroy
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
        this.focusMonitor.stopMonitoring(this._el.parentElement);
    };
    /**
     * Check if the label text is geting truncated
     */
    /**
     * Check if the label text is geting truncated
     * @private
     * @return {?}
     */
    BentoTabsLabelComponent.prototype.checkTextTruncation = /**
     * Check if the label text is geting truncated
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        // Use setTimeout to avoid change detection errors
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._noTextTruncation = _this._el.offsetWidth >= _this._el.scrollWidth;
        }));
    };
    /** @nocollapse */
    BentoTabsLabelComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: BentoNotification },
        { type: FocusMonitor }
    ]; };
    BentoTabsLabelComponent.propDecorators = {
        label: [{ type: Input }],
        maxWidth: [{ type: Input }, { type: HostBinding, args: ['style.maxWidth',] }],
        truncatedTooltip: [{ type: ViewChild, args: ['truncatedTooltip',] }]
    };
BentoTabsLabelComponent.ɵfac = function BentoTabsLabelComponent_Factory(t) { return new (t || BentoTabsLabelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FocusMonitor)); };
BentoTabsLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTabsLabelComponent, selectors: [["bento-tabs-label"]], viewQuery: function BentoTabsLabelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c54, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.truncatedTooltip = _t.first);
    } }, hostVars: 2, hostBindings: function BentoTabsLabelComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("max-width", ctx.maxWidth);
    } }, inputs: { maxWidth: "maxWidth", label: "label" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["withoutTooltip", ""], ["withTooltip", ""], [3, "innerHTML"], ["container", "body", 3, "ngbTooltip", "placement", "innerHTML"], ["truncatedTooltip", "ngbTooltip"]], template: function BentoTabsLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoTabsLabelComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoTabsLabelComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, BentoTabsLabelComponent_ng_template_3_Template, 2, 3, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(2);
        var _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx._noTextTruncation)("ngIfThen", _r1)("ngIfElse", _r3);
    } }, directives: [ɵngcc7.NgIf, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTabsLabelComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tabs-label',
                template: "<div *ngIf=\"_noTextTruncation; then withoutTooltip; else withTooltip\"></div>\n\n<ng-template #withoutTooltip>\n  <div [innerHTML]=\"label\"></div>\n</ng-template>\n\n<ng-template #withTooltip>\n  <div\n    #truncatedTooltip=\"ngbTooltip\"\n    [ngbTooltip]=\"label\"\n    container=\"body\"\n    [placement]=\"'top'\"\n    [innerHTML]=\"label\"\n  ></div>\n</ng-template>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: BentoNotification }, { type: ɵngcc1.FocusMonitor }]; }, { maxWidth: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['style.maxWidth']
        }], label: [{
            type: Input
        }], truncatedTooltip: [{
            type: ViewChild,
            args: ['truncatedTooltip']
        }] }); })();
    return BentoTabsLabelComponent;
}());
if (false) {
    /**
     * Sets the maximum width of this label before truncation starts, or omit to allow tabs to take maximum
     * possible width in the tabset
     * @type {?}
     */
    BentoTabsLabelComponent.prototype.maxWidth;
    /** @type {?} */
    BentoTabsLabelComponent.prototype._noTextTruncation;
    /** @type {?} */
    BentoTabsLabelComponent.prototype._el;
    /**
     * @type {?}
     * @private
     */
    BentoTabsLabelComponent.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTabsLabelComponent.prototype._label;
    /**
     * Tooltip reference for a tab that has long text. This can be
     * used to show/hide the tooltip when on focus/blur
     * @type {?}
     */
    BentoTabsLabelComponent.prototype.truncatedTooltip;
    /**
     * @type {?}
     * @private
     */
    BentoTabsLabelComponent.prototype.focusMonitor;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tabs/tabs-scroll.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Wrap this component around the <code>ngb-tabset</code> component to allow it to become responsive and scrollable.
 */
var BentoTabsScrollComponent = /** @class */ (function () {
    function BentoTabsScrollComponent(elRef, bentoNotification, renderer, changeDetector, dir, winRef) {
        var _this = this;
        this.renderer = renderer;
        this.changeDetector = changeDetector;
        this.dir = dir;
        /**
         * Disable Left Arrows
         */
        this.disableLeftArrows = true;
        /**
         * Disable Right Arrows
         */
        this.disableRightArrows = false;
        /**
         * Show Nav
         */
        this.showNav = false;
        // keep track of tab widths
        this.tabsWidthArray = [];
        // keep track of entire width of tabs
        this.totalTabsWidth = 0;
        /**
         * Current transform X position
         */
        this.currentPosition = 0;
        this.nativeElement = elRef.nativeElement;
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._checkElementWidthAndRender(); }));
        this.isRtl = dir.value === 'rtl';
        this.window = winRef.nativeWindow;
        this.setDirectionLabels();
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
            _this.setDirectionLabels();
            _this._checkElementWidthAndRender();
        }));
    }
    /**
     * Called when this component is initialized
     */
    /**
     * Called when this component is initialized
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.ngAfterViewInit = /**
     * Called when this component is initialized
     * @return {?}
     */
    function () {
        this._checkElementWidthAndRender();
    };
    /**
     * Called when this component is destroyed
     */
    /**
     * Called when this component is destroyed
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.ngOnDestroy = /**
     * Called when this component is destroyed
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
        this.changeDetector.detach();
    };
    /**
     * Call this method to manually refresh and render
     * this component with the latest tab count and
     * width calculations.
     */
    /**
     * Call this method to manually refresh and render
     * this component with the latest tab count and
     * width calculations.
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.refresh = /**
     * Call this method to manually refresh and render
     * this component with the latest tab count and
     * width calculations.
     * @return {?}
     */
    function () {
        this._checkElementWidthAndRender();
    };
    /**
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.onLeftMostClick = /**
     * @return {?}
     */
    function () {
        this._scrollToTab(false, true);
    };
    /**
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.onLeftClick = /**
     * @return {?}
     */
    function () {
        this._scrollToTab(false);
    };
    /**
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.onRightClick = /**
     * @return {?}
     */
    function () {
        this._scrollToTab(true);
    };
    /**
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.onRightMostClick = /**
     * @return {?}
     */
    function () {
        this._scrollToTab(true, true);
    };
    /**
     * @private
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.flipDirection = /**
     * @private
     * @return {?}
     */
    function () {
        this.isRtl = this.dir.value === 'rtl';
    };
    /**
     * @private
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.setDirectionLabels = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.isRtl) {
            this._scrollLeftLabel = 'BENTO_UI_TABSET_SCROLL_RIGHT';
            this._scrollRightLabel = 'BENTO_UI_TABSET_SCROLL_LEFT';
        }
        else {
            this._scrollLeftLabel = 'BENTO_UI_TABSET_SCROLL_LEFT';
            this._scrollRightLabel = 'BENTO_UI_TABSET_SCROLL_RIGHT';
        }
    };
    /**
     * Get transform position limit
     */
    /**
     * Get transform position limit
     * @private
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.getPositionLimit = /**
     * Get transform position limit
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var pad = 28;
        return this.isRtl
            ? this.totalTabsWidth - this.nativeElement.offsetWidth + pad
            : this.nativeElement.offsetWidth - this.totalTabsWidth - pad;
    };
    /**
     * scroll to the nearest tab with index of currentTab
     */
    /**
     * scroll to the nearest tab with index of currentTab
     * @private
     * @param {?} isToRight
     * @param {?=} isToEnd
     * @return {?}
     */
    BentoTabsScrollComponent.prototype._scrollToTab = /**
     * scroll to the nearest tab with index of currentTab
     * @private
     * @param {?} isToRight
     * @param {?=} isToEnd
     * @return {?}
     */
    function (isToRight, isToEnd) {
        if (isToEnd === void 0) { isToEnd = false; }
        if (this.navTabsElement) {
            /** @type {?} */
            var positionLimit = this.getPositionLimit();
            /** @type {?} */
            var sign = this.isRtl ? 1 : -1;
            if (isToRight) {
                // Scroll to right
                if (!isToEnd) {
                    for (var tabIndex in this.tabsWidthArray) {
                        if (sign * this.currentPosition < this.tabsWidthArray[tabIndex]) {
                            this.currentPosition = sign * this.tabsWidthArray[tabIndex];
                            break;
                        }
                    }
                }
                if (Math.abs(this.currentPosition) >= Math.abs(positionLimit) || isToEnd) {
                    // Position is over limit
                    this.currentPosition = positionLimit;
                }
            }
            else if (isToEnd) {
                this.currentPosition = 0;
            }
            else {
                // Scroll to left
                for (var tabIndex = this.tabsWidthArray.length - 1; tabIndex > -1; tabIndex--) {
                    if (sign * this.currentPosition > this.tabsWidthArray[tabIndex]) {
                        this.currentPosition = sign * this.tabsWidthArray[tabIndex];
                        break;
                    }
                }
            }
            this.renderer.setStyle(this.navTabsElement, 'transform', "translateX(" + this.currentPosition + "px)");
            this.updateArrows(positionLimit);
        }
    };
    /**
     * Disable and enable arrow
     */
    /**
     * Disable and enable arrow
     * @private
     * @param {?} positionLimit
     * @return {?}
     */
    BentoTabsScrollComponent.prototype.updateArrows = /**
     * Disable and enable arrow
     * @private
     * @param {?} positionLimit
     * @return {?}
     */
    function (positionLimit) {
        // disable / enable arrows
        if (this.currentPosition === 0) {
            this.disableLeftArrows = true;
            this.disableRightArrows = false;
        }
        else if (positionLimit === this.currentPosition) {
            this.disableLeftArrows = false;
            this.disableRightArrows = true;
        }
        else {
            this.disableLeftArrows = false;
            this.disableRightArrows = false;
        }
    };
    /**
     * Calculate and change layout responsively
     */
    /**
     * Calculate and change layout responsively
     * @private
     * @return {?}
     */
    BentoTabsScrollComponent.prototype._checkElementWidthAndRender = /**
     * Calculate and change layout responsively
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.element) {
            this.element = (/** @type {?} */ (this.nativeElement));
        }
        if (!this.navTabsElement) {
            this.navTabsElement = (/** @type {?} */ (this.element.querySelector('.nav.nav-tabs')));
        }
        /** @type {?} */
        var width = this.element.offsetWidth;
        /** @type {?} */
        var navTabsChildren = this.navTabsElement.children;
        this.totalTabsWidth = 0;
        for (var i = 0; i < navTabsChildren.length; i++) {
            this.tabsWidthArray[i] = this.totalTabsWidth;
            this.totalTabsWidth += this._getTotalWidth(navTabsChildren[i]) - 1;
        }
        /** @type {?} */
        var positionLimit = this.getPositionLimit();
        if (Math.abs(this.currentPosition) >= Math.abs(positionLimit)) {
            // Position is over limit
            this.currentPosition = positionLimit;
        }
        else if (this.isRtl === this.currentPosition < 0) {
            // If the current position is positive in LTR mode
            // OR
            // the current position is negative in RTL mode
            this.currentPosition = 0;
        }
        this.renderer.setStyle(this.navTabsElement, 'transform', "translateX(" + this.currentPosition + "px)");
        // check if necessary to show navigation
        if (width > this.totalTabsWidth) {
            this.showNav = false;
        }
        else {
            this.showNav = true;
            this.updateArrows(positionLimit);
            setTimeout((/**
             * @return {?}
             */
            function () {
                /** @type {?} */
                var navButton = _this.nativeElement.getElementsByClassName('bento-tabset-nav-button-container')[0];
                if (width < 400 && !!navButton) {
                    navButton.classList.add('tabset-scroll-nav-buttons');
                }
                else if (!!navButton) {
                    navButton.classList.remove('tabset-scroll-nav-buttons');
                }
            }));
        }
        this.changeDetector.detectChanges();
    };
    /**
     * Get total width of an element, including
     * it's padding and margins
     */
    /**
     * Get total width of an element, including
     * it's padding and margins
     * @private
     * @param {?} el
     * @return {?}
     */
    BentoTabsScrollComponent.prototype._getTotalWidth = /**
     * Get total width of an element, including
     * it's padding and margins
     * @private
     * @param {?} el
     * @return {?}
     */
    function (el) {
        if (!el) {
            return;
        }
        /** @type {?} */
        var style = this.window.getComputedStyle(el);
        return (Math.ceil(el.getBoundingClientRect().width) +
            parseFloat(style.paddingLeft) +
            parseFloat(style.paddingRight) +
            parseFloat(style.marginLeft !== 'auto' ? style.marginLeft : 0) +
            parseFloat(style.marginRight !== 'auto' ? style.marginRight : 0));
    };
    /** @nocollapse */
    BentoTabsScrollComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: Directionality },
        { type: WindowRef }
    ]; };
BentoTabsScrollComponent.ɵfac = function BentoTabsScrollComponent_Factory(t) { return new (t || BentoTabsScrollComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoTabsScrollComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTabsScrollComponent, selectors: [["bento-tabset-scroll"]], features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], ngContentSelectors: _c4, decls: 2, vars: 1, consts: [["class", "bento-tabset-nav-button-container ng-scope", 4, "ngIf"], [1, "bento-tabset-nav-button-container", "ng-scope"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-icon", "bento-tabset-nav-button", "left-most", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-first-left"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-icon", "bento-tabset-nav-button", "left", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-left"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-icon", "bento-tabset-nav-button", "right", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-right"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-icon", "bento-tabset-nav-button", "right-most", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-last-right"]], template: function BentoTabsScrollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, BentoTabsScrollComponent_div_0_Template, 13, 16, "div", 0);
        ɵngcc0.ɵɵprojection(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNav);
    } }, directives: [ɵngcc7.NgIf], pipes: [BentoTranslatePipe], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTabsScrollComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tabset-scroll',
                template: "<div *ngIf=\"showNav\" class=\"bento-tabset-nav-button-container ng-scope\">\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TABSET_SCROLL_LEFTMOST' | bentoTranslate\"\n    [disabled]=\"disableLeftArrows\"\n    (click)=\"onLeftMostClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button left-most\"\n  >\n    <i class=\"bento-icon-chevron-first-left\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"_scrollLeftLabel | bentoTranslate\"\n    [disabled]=\"disableLeftArrows\"\n    (click)=\"onLeftClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button left\"\n  >\n    <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"_scrollRightLabel | bentoTranslate\"\n    [disabled]=\"disableRightArrows\"\n    (click)=\"onRightClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button right\"\n  >\n    <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n  </button>\n  <button\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TABSET_SCROLL_RIGHTMOST' | bentoTranslate\"\n    [disabled]=\"disableRightArrows\"\n    (click)=\"onRightMostClick()\"\n    class=\"btn btn-outline-primary btn-icon bento-tabset-nav-button right-most\"\n  >\n    <i class=\"bento-icon-chevron-last-right\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n<ng-content></ng-content>\n",
                providers: [BentoNotification],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc6.Directionality }, { type: WindowRef }]; }, null); })();
    return BentoTabsScrollComponent;
}());
if (false) {
    /**
     * Component native element
     * @type {?}
     */
    BentoTabsScrollComponent.prototype.nativeElement;
    /**
     * Main container element of this component
     * @type {?}
     */
    BentoTabsScrollComponent.prototype.element;
    /**
     * Main container element of this component
     * @type {?}
     */
    BentoTabsScrollComponent.prototype.navTabsElement;
    /**
     * Subscription to page and parent container resize
     * @type {?}
     */
    BentoTabsScrollComponent.prototype.resizeSubscription;
    /**
     * Disable Left Arrows
     * @type {?}
     */
    BentoTabsScrollComponent.prototype.disableLeftArrows;
    /**
     * Disable Right Arrows
     * @type {?}
     */
    BentoTabsScrollComponent.prototype.disableRightArrows;
    /**
     * Show Nav
     * @type {?}
     */
    BentoTabsScrollComponent.prototype.showNav;
    /** @type {?} */
    BentoTabsScrollComponent.prototype._scrollLeftLabel;
    /** @type {?} */
    BentoTabsScrollComponent.prototype._scrollRightLabel;
    /**
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.tabsWidthArray;
    /**
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.totalTabsWidth;
    /**
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.isRtl;
    /**
     * Current transform X position
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.currentPosition;
    /**
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.window;
    /**
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoTabsScrollComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tabs/tabs.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTabsModule = /** @class */ (function () {
    function BentoTabsModule() {
    }
BentoTabsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTabsModule });
BentoTabsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTabsModule_Factory(t) { return new (t || BentoTabsModule)(); }, imports: [[CommonModule, NgbTooltipModule, BentoTranslateModule, BentoNgbTooltipSupportModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTabsModule, { declarations: function () { return [BentoTabsScrollComponent,
        BentoTabsLabelComponent]; }, imports: function () { return [CommonModule, NgbTooltipModule,
        BentoTranslateModule,
        BentoNgbTooltipSupportModule]; }, exports: function () { return [BentoTabsScrollComponent,
        BentoTabsLabelComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTabsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgbTooltipModule, BentoTranslateModule, BentoNgbTooltipSupportModule],
                declarations: [BentoTabsScrollComponent, BentoTabsLabelComponent],
                exports: [BentoTabsScrollComponent, BentoTabsLabelComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoTabsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tags-input/tags-input-event.class.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An event class that is associated with Bento Tags Input events
 */
var  /**
 * An event class that is associated with Bento Tags Input events
 */
BentoTagsInputEvent = /** @class */ (function () {
    /**
     * Event object constructor
     */
    function BentoTagsInputEvent(tag, cancel, errors) {
        this._isCancellable = false;
        this._errors = errors;
        this._tag = tag;
        if (cancel) {
            this._cancel = cancel;
            this._isCancellable = true;
        }
        else {
            // Default cancel dummy
            this._cancel = (/**
             * @return {?}
             */
            function () { });
        }
    }
    Object.defineProperty(BentoTagsInputEvent.prototype, "isCancellable", {
        /**
         * (Read-only) Check if this event is cancellabled or not
         */
        get: /**
         * (Read-only) Check if this event is cancellabled or not
         * @return {?}
         */
        function () {
            return this._isCancellable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputEvent.prototype, "hasErrors", {
        /**
         * (Read-only) Check if this event is has errors or not
         */
        get: /**
         * (Read-only) Check if this event is has errors or not
         * @return {?}
         */
        function () {
            return !!this._errors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputEvent.prototype, "tag", {
        /**
         * (Read-only) An tag object that is associated with this event
         */
        get: /**
         * (Read-only) An tag object that is associated with this event
         * @return {?}
         */
        function () {
            return this._tag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputEvent.prototype, "cancel", {
        /**
         * Method to cancel the current event *ONLY* if `event.isCancellable` is `true`
         */
        get: /**
         * Method to cancel the current event *ONLY* if `event.isCancellable` is `true`
         * @return {?}
         */
        function () {
            return this._cancel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputEvent.prototype, "errors", {
        /**
         * (Read-only) Errors that are associated with this event
         */
        get: /**
         * (Read-only) Errors that are associated with this event
         * @return {?}
         */
        function () {
            return this._errors;
        },
        enumerable: true,
        configurable: true
    });
    return BentoTagsInputEvent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputEvent.prototype._errors;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputEvent.prototype._tag;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputEvent.prototype._cancel;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputEvent.prototype._isCancellable;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tags-input/tags-input-util.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTagsInputUtil = /** @class */ (function () {
    function BentoTagsInputUtil() {
    }
    /**
     *  Help method to execute a `method` based on the existence and reply of the `callback` with a tag
     */
    /**
     *  Help method to execute a `method` based on the existence and reply of the `callback` with a tag
     * @param {?} componentRef
     * @param {?} eventEmitter
     * @param {?} method
     * @param {?} tag
     * @param {?=} data
     * @return {?}
     */
    BentoTagsInputUtil.exeTagMethodWithEventEmitter = /**
     *  Help method to execute a `method` based on the existence and reply of the `callback` with a tag
     * @param {?} componentRef
     * @param {?} eventEmitter
     * @param {?} method
     * @param {?} tag
     * @param {?=} data
     * @return {?}
     */
    function (componentRef, eventEmitter, method, tag, data) {
        /** @type {?} */
        var hasCancel = false;
        /** @type {?} */
        var cancelObservable;
        // There is a callback
        /** @type {?} */
        var e = new BentoTagsInputEvent(tag, (/**
         * @param {?} o
         * @return {?}
         */
        function (o) {
            if (o && o.subscribe) {
                cancelObservable = o;
            }
            else {
                hasCancel = true;
            }
        }));
        // Since this a synchronous emitter we can move on after it without using timeouts
        eventEmitter.emit(e);
        if (cancelObservable) {
            // This is a async reply
            /** @type {?} */
            var subscription_1 = cancelObservable.subscribe((/**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                if (v) {
                    // Delayed `true`
                    method.call(componentRef, tag, data);
                }
                // Don't forget to unsubscribe...
                subscription_1.unsubscribe();
                subscription_1 = null;
            }));
        }
        else if (!hasCancel) {
            // We have an instant reply
            method.call(componentRef, tag, data);
        }
    };
    return BentoTagsInputUtil;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tags-input/tags-input-pill.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BENTO_TAGS_INPUT_PILL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoTagsInputPillComponent; })),
    multi: true
};
/* tslint:disable no-host-metadata-property */
/**
 * Tags Input Pill Component
 */
var BentoTagsInputPillComponent = /** @class */ (function () {
    /**
     * Main component constructor
     */
    function BentoTagsInputPillComponent(elRef, r, bentoNotification, translate, changeDetector, sanitizer, windowRef) {
        this.elRef = elRef;
        this.r = r;
        this.bentoNotification = bentoNotification;
        this.translate = translate;
        this.changeDetector = changeDetector;
        this.sanitizer = sanitizer;
        /**
         * EventEmitter for typeahead selected item
         */
        this.typeaheadSelectItem = new EventEmitter();
        /**
         * Main object property name for label rendering
         */
        this.tagPropertyName = 'name';
        /**
         * Flag to disable this tag pill removal
         */
        this.disableRemove = false;
        /**
         * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         * A flag indicating if model values should be restricted to the ones selected from the popup only.
         */
        this.typeheadEditable = true;
        /**
         * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         * A flag indicating if the first match should automatically be focused as you type.
         */
        this.typeheadFocusFirst = false;
        /**
         * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         * Show hint when an option in the result list matches.
         */
        this.typeaheadShowHint = false;
        /**
         * API to support readonly
         */
        this.readonly = false;
        /**
         * Flag to show editing mode
         */
        this._isEditing = false;
        /**
         * Remove notification
         */
        this.remove = new EventEmitter();
        /**
         * Flag to validation of the input
         */
        this._invalid = false;
        /**
         * This is used to bypass the component ENTER key stroke when one of the
         * typeahead item is selected
         */
        this._isTypeaheadAction = false;
        /**
         * Flag the determine wheather need tooltip or not
         */
        this._noTextTruncation = true;
        this.resizeSubscription = Subscription.EMPTY;
        /** @type {?} */
        var el = this.elRef.nativeElement;
        this.document = windowRef.nativeDocument;
        this.r.addClass(el, 'ready');
    }
    /**
     * Implements AfterViewInit
     */
    /**
     * Implements AfterViewInit
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.ngAfterViewInit = /**
     * Implements AfterViewInit
     * @return {?}
     */
    function () {
        var _this = this;
        this.checkTextOverflow();
        this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () {
            // check text overflow on all kinds of layout resizing
            _this.checkTextOverflow();
            _this.changeDetector.markForCheck();
        }));
    };
    /**
     * Focus event handler
     */
    /**
     * Focus event handler
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.onHostElementFocus = /**
     * Focus event handler
     * @return {?}
     */
    function () {
        this.truncatedTooltip && this.truncatedTooltip.open();
    };
    /**
     * Focusout event handler
     */
    /**
     * Focusout event handler
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.onFocusout = /**
     * Focusout event handler
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            if (!_this.elRef.nativeElement.contains(_this.document.activeElement)) {
                _this._onTouchedCallback();
                _this.truncatedTooltip && _this.truncatedTooltip.close();
            }
        }));
    };
    /**
     * Implements ControlValueAccessor
     */
    /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.registerOnChange = /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * From ControlValueAccessor interface
     */
    /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.registerOnTouched = /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this._onTouchedCallback = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.changeDetector.markForCheck();
        });
    };
    /**
     * NgModel setter
     */
    /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.writeValue = /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    function (v) {
        if (v) {
            this._data = v;
        }
        else {
            /** @type {?} */
            var newValue = {};
            newValue[this.tagPropertyName] = '';
            this._data = newValue;
        }
        this.formattedValue = null;
        this.changeDetector.markForCheck();
    };
    /**
     * Set Disabled state for ngModel
     */
    /**
     * Set Disabled state for ngModel
     * @param {?} v
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.setDisabledState = /**
     * Set Disabled state for ngModel
     * @param {?} v
     * @return {?}
     */
    function (v) {
        /** @type {?} */
        var el = this.elRef.nativeElement;
        this.disabled = v;
        if (v) {
            this.r.removeAttribute(el, 'tabindex');
        }
        else {
            this.r.setAttribute(el, 'tabindex', '0');
        }
    };
    /**
     * Implements OnDestroy lifehook
     */
    /**
     * Implements OnDestroy lifehook
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.ngOnDestroy = /**
     * Implements OnDestroy lifehook
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
        this.changeDetector.detach();
    };
    /**
     * Main keydown event listener
     */
    /**
     * Main keydown event listener
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.onKeydown = /**
     * Main keydown event listener
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        if (this.disabled || this.readonly) {
            return;
        }
        /** @type {?} */
        var button = (/** @type {?} */ (e.target));
        /** @type {?} */
        var isButton = button.classList.contains('bento-tags-input-pill-close-icon') ||
            button.classList.contains('bento-tags-input-pill-edit-icon');
        if (isButton) {
            return;
        }
        switch (e.keyCode) {
            case Keyboard.DELETE:
            case Keyboard.BACKSPACE:
                // Use keyboard DELETE and BACKSPACE to remove the current pill
                // This can only executed when the pill is not in editing mode
                if (!this._isEditing && !this.disableRemove) {
                    this.remove.emit({
                        el: this.elRef.nativeElement,
                        tag: this._data,
                        // Optional
                        keyCode: e.keyCode
                    });
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
            case Keyboard.ENTER:
                if (this._isEditing && !this._isTypeaheadAction) {
                    // Fire keyboard enter
                    this._onKeyboardEnter();
                }
                else if (this.editable) {
                    // Enter edit mode
                    this._onEditClick(e);
                }
                // Prevent form submission
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.ESC:
                if (this._isEditing) {
                    this._toggleEditingMode();
                    this.tagEditCancel.emit(new BentoTagsInputEvent(this._data));
                    this.typeaheadPill && this.typeaheadPill.dismissPopup();
                    // reset invalid flag
                    this._invalid = false;
                    // during the edit process, if there are some error residuals, clear it
                    this.validations.isValidTag(this._data[this.tagPropertyName], this._data);
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.TAB:
                if (this._isEditing) {
                    this._commitEdit((
                    // Success
                    // Success
                    /**
                     * @return {?}
                     */
                    function () {
                        // focus on the next sibling
                        _this.elRef.nativeElement.nextElementSibling.focus();
                        // Check if there text overflow
                        _this.checkTextOverflow();
                    }), (
                    // Fail
                    // Fail
                    /**
                     * @return {?}
                     */
                    function () {
                        _this._inputEl.setSelectionRange(0, _this._inputText.length);
                    }));
                    // Stop Tab function first
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
        } // switch (e.keyCode)
    }; // @HostListener()
    /**
     * Callback when ENTER key is pressed
     */
    // @HostListener()
    /**
     * Callback when ENTER key is pressed
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onKeyboardEnter = 
    // @HostListener()
    /**
     * Callback when ENTER key is pressed
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this._inputText || this._inputText.length === 0) {
            // Bug Fix: before removing the pill, reset the editing flag. Without
            // reset, future edit is disabled.
            this._isEditing = false;
            // Fire remove event when the input tries to commit an empty string
            this.remove.emit({
                el: this.elRef.nativeElement,
                tag: this._data,
                // Optional
                // Use Delete button as an empty string commit
                keyCode: Keyboard.DELETE
            });
        }
        else {
            // Commit current change
            this._commitEdit((/**
             * @return {?}
             */
            function () {
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.elRef.nativeElement.focus();
                }));
                // Check if there text overflow
                _this.checkTextOverflow();
            }));
        }
    };
    /**
     * Fired when keypress event occurs on Edit icon
     * @param e - Key event
     */
    /**
     * Fired when keypress event occurs on Edit icon
     * @param {?} e - Key event
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onKeydownEdit = /**
     * Fired when keypress event occurs on Edit icon
     * @param {?} e - Key event
     * @return {?}
     */
    function (e) {
        if (e.keyCode === Keyboard.ENTER) {
            // Bug Fix: before removing the pill, reset the editing flag. Without
            // reset, future edit is disabled.
            this._isEditing = false;
            this._onEditClick(e);
            e.stopPropagation();
            e.preventDefault();
        }
    };
    /**
     * Fired when keypress event occurs on Close icon
     * @param e - Key event
     */
    /**
     * Fired when keypress event occurs on Close icon
     * @param {?} e - Key event
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onKeydownClose = /**
     * Fired when keypress event occurs on Close icon
     * @param {?} e - Key event
     * @return {?}
     */
    function (e) {
        if (e.keyCode === Keyboard.ENTER) {
            this._onCloseClick();
            e.stopPropagation();
            e.preventDefault();
        }
    };
    /**
     * Close button click
     */
    /**
     * Close button click
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onCloseClick = /**
     * Close button click
     * @return {?}
     */
    function () {
        if (this._isEditing && this.disableRemove) {
            return;
        }
        this.remove.emit({
            el: this.elRef.nativeElement,
            tag: this._data
        });
    };
    /**
     * Edit button click
     */
    /**
     * Edit button click
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onEditClick = /**
     * Edit button click
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        if (!this._isEditing) {
            this._toggleEditingMode();
        }
        else {
            this._commitEdit((/**
             * @return {?}
             */
            function () {
                _this.elRef.nativeElement.focus();
                // Check if there text overflow
                _this.checkTextOverflow();
            }));
        }
    };
    /**
     * Apply changes to the main object
     */
    /**
     * Apply changes to the main object
     * @param {?} success
     * @param {?=} fail
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._commitEdit = /**
     * Apply changes to the main object
     * @param {?} success
     * @param {?=} fail
     * @return {?}
     */
    function (success, fail) {
        var _this = this;
        this.formattedValue = this.validations.getFormattedString(this._inputText.trim());
        if (this.tagFormatter) {
            // Call app defined tag formatter for one more layer for text formatting
            this.formattedValue = this.tagFormatter(this.formattedValue);
        }
        if (this.formattedValue === this._data[this.tagPropertyName]) {
            this._toggleEditingMode();
            success.call(this);
        }
        else if (this.validations.isValidTag(String(this.formattedValue), this._data)) {
            this._invalid = false;
            // validation passed
            // now as user to proceed
            BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagEditStart, (/**
             * @param {?} tagString
             * @return {?}
             */
            function (tagString) {
                // only update tag when the input is valid
                _this._data[_this.tagPropertyName] = tagString;
                _this._toggleEditingMode();
                _this._onChangeCallback(_this._data);
                success.call(_this);
            }), this.formattedValue);
        }
        else {
            // Input is not valid
            this._invalid = true;
            // calling this, will set model onChange, which in turn will call the
            // validator function
            this._onChangeCallback(this._data);
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.setProperty(_this.pillEmptyInfo.nativeElement, 'innerHTML', _this.sanitizer.sanitize(SecurityContext.HTML, _this.translate.instantTranslate('BENTO_UI_TAGS_INPUT_EMPTY_PILL')));
            }));
            // Re-assign focus to the input field
            this._inputEl.focus();
            if (fail) {
                fail.call(this);
            }
        }
    };
    /**
     * Input field change callback
     */
    /**
     * Input field change callback
     * @param {?} v
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onInputChange = /**
     * Input field change callback
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._inputText = v;
        this._resizeInput();
    };
    /**
     * Toggle between editing mode
     */
    /**
     * Toggle between editing mode
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._toggleEditingMode = /**
     * Toggle between editing mode
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this._isEditing) {
            if (!this.validations.canEdit()) {
                // Indicates that this pill cannot be edited
                return;
            }
            /** @type {?} */
            var labelEl = this.elRef.nativeElement.querySelector('.bento-tags-input-pill-label');
            // Set editing mode to `true`
            this._isEditing = true;
            this._inputText = this._data[this.tagPropertyName];
            if (!this._inputEl) {
                this._inputEl = this.elRef.nativeElement.querySelector('input');
            }
            this._inputEl.style.width = labelEl.offsetWidth + 2 + 'px';
            setTimeout((/**
             * @return {?}
             */
            function () {
                if (!_this._inputBlurCancel) {
                    // Add input blur subscription
                    _this._inputBlurCancel = _this.r.listen('window', 'mousedown', (/**
                     * @param {?} e
                     * @return {?}
                     */
                    function (e) {
                        if (_this.elRef.nativeElement.contains(e.target)) {
                            // blurred within the pill
                            setTimeout((/**
                             * @return {?}
                             */
                            function () {
                                _this._inputEl.focus();
                            }));
                        }
                        else {
                            _this._commitEdit((
                            // Success
                            // Success
                            /**
                             * @return {?}
                             */
                            function () {
                                // Typeahead action is finished
                                _this._isTypeaheadAction = false;
                                // Check if there text overflow
                                _this.checkTextOverflow();
                            }), (
                            // Fail
                            // Fail
                            /**
                             * @return {?}
                             */
                            function () {
                                setTimeout((/**
                                 * @return {?}
                                 */
                                function () {
                                    // There is an error with the current input
                                    // We highlight it and do it over
                                    _this._inputEl.focus();
                                    _this._inputEl.setSelectionRange(0, _this._inputText.length);
                                    // Typeahead action is finished
                                    _this._isTypeaheadAction = false;
                                }));
                            }));
                        }
                    }));
                }
                // focus input
                _this._inputEl.focus();
                _this._inputEl.setSelectionRange(0, _this._inputText.length);
            }));
        }
        else {
            // Remove input blur subscription
            if (this._inputBlurCancel) {
                this._inputBlurCancel();
                this._inputBlurCancel = null;
            }
            // Reset HTMLElement reference for sizing
            this._inputSizeEl = null;
            this._isEditing = false;
        }
    };
    /**
     * Callback when a typeahead item is selected
     */
    /**
     * Callback when a typeahead item is selected
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onTypeaheadSelectItem = /**
     * Callback when a typeahead item is selected
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.typeaheadSelectItem.emit(e);
        // Flag globally to let the pill know that this is a typeahead action
        this._isTypeaheadAction = true;
        // Need to update the inputText before simulating keyboard enter
        this._inputText = this.typeaheadInputFormatter ? this.typeaheadInputFormatter(e.item) : e.item;
        // Fire keyboard enter
        this._onKeyboardEnter();
    };
    /**
     * Resize the input width according to its text inside
     */
    /**
     * Resize the input width according to its text inside
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._resizeInput = /**
     * Resize the input width according to its text inside
     * @return {?}
     */
    function () {
        if (!this._inputSizeEl) {
            // Since we are using *ngIf in the template
            // related html elements are created everytime
            // so the references are removed everytime when the pill is done with eidting
            this._inputSizeEl = this.elRef.nativeElement.querySelector('.bento-tags-input-pill-size-ref');
        }
        this._inputSizeEl.innerText = this._inputText;
        this._inputEl.style.width = this._inputSizeEl.offsetWidth + 3 + 'px';
    };
    /**
     * Format str based on the current tag format rules
     */
    /**
     * Format str based on the current tag format rules
     * @param {?} str
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._formatTag = /**
     * Format str based on the current tag format rules
     * @param {?} str
     * @return {?}
     */
    function (str) {
        if (!this.formattedValue) {
            this.formattedValue = this.tagFormatter ? this.tagFormatter(str) : str;
        }
        return this.formattedValue;
    };
    /**
     * Check to see if there is text overflow
     */
    /**
     * Check to see if there is text overflow
     * @private
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype.checkTextOverflow = /**
     * Check to see if there is text overflow
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var label = _this.elRef.nativeElement.querySelector('.bento-tags-input-pill-label');
            _this._noTextTruncation = label.scrollWidth <= label.offsetWidth;
        }));
    };
    /**
     * Catch double click events to start editing when in editor is enabled
     */
    /**
     * Catch double click events to start editing when in editor is enabled
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputPillComponent.prototype._onDoubleClick = /**
     * Catch double click events to start editing when in editor is enabled
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.editable && !this.disabled && !this.readonly) {
            this._onEditClick(e);
        }
    };
    /** @nocollapse */
    BentoTagsInputPillComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: BentoNotification },
        { type: BentoTranslate },
        { type: ChangeDetectorRef },
        { type: DomSanitizer },
        { type: WindowRef }
    ]; };
    BentoTagsInputPillComponent.propDecorators = {
        tagEditStart: [{ type: Input }],
        tagEditCancel: [{ type: Input }],
        typeaheadSelectItem: [{ type: Input }],
        tagPropertyName: [{ type: Input }],
        editable: [{ type: Input }],
        validations: [{ type: Input }],
        disableRemove: [{ type: Input }],
        tagFormatter: [{ type: Input }],
        typeahead: [{ type: Input }],
        typeheadEditable: [{ type: Input }],
        typeheadFocusFirst: [{ type: Input }],
        typeaheadInputFormatter: [{ type: Input }],
        typeaheadResultFormatter: [{ type: Input }],
        typeaheadShowHint: [{ type: Input }],
        readonly: [{ type: HostBinding, args: ['class.readonly',] }, { type: Input }],
        _isEditing: [{ type: HostBinding, args: ['class.edit',] }],
        remove: [{ type: Output }],
        _invalid: [{ type: HostBinding, args: ['class.invalid',] }],
        truncatedTooltip: [{ type: ViewChild, args: ['truncatedTooltip',] }],
        typeaheadPill: [{ type: ViewChild, args: ['typeaheadPill',] }],
        pillEmptyInfo: [{ type: ViewChild, args: ['pillEmptyInfo', { static: true },] }],
        onHostElementFocus: [{ type: HostListener, args: ['focus',] }],
        onFocusout: [{ type: HostListener, args: ['focusout',] }],
        onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
        _onDoubleClick: [{ type: HostListener, args: ['dblclick', ['$event'],] }]
    };
BentoTagsInputPillComponent.ɵfac = function BentoTagsInputPillComponent_Factory(t) { return new (t || BentoTagsInputPillComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(BentoTranslate), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoTagsInputPillComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTagsInputPillComponent, selectors: [["bento-tags-input-pill"]], viewQuery: function BentoTagsInputPillComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c54, true);
        ɵngcc0.ɵɵviewQuery(_c55, true);
        ɵngcc0.ɵɵstaticViewQuery(_c56, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.truncatedTooltip = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.typeaheadPill = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pillEmptyInfo = _t.first);
    } }, hostVars: 10, hostBindings: function BentoTagsInputPillComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function BentoTagsInputPillComponent_focus_HostBindingHandler() { return ctx.onHostElementFocus(); })("focusout", function BentoTagsInputPillComponent_focusout_HostBindingHandler() { return ctx.onFocusout(); })("keydown", function BentoTagsInputPillComponent_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); })("dblclick", function BentoTagsInputPillComponent_dblclick_HostBindingHandler($event) { return ctx._onDoubleClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("editable", ctx.editable && !ctx.disabled && !ctx.readonly)("disable-remove", ctx.disableRemove || ctx.disabled || ctx.readonly)("readonly", ctx.readonly)("edit", ctx._isEditing)("invalid", ctx._invalid);
    } }, inputs: { typeaheadSelectItem: "typeaheadSelectItem", tagPropertyName: "tagPropertyName", disableRemove: "disableRemove", typeheadEditable: "typeheadEditable", typeheadFocusFirst: "typeheadFocusFirst", typeaheadShowHint: "typeaheadShowHint", readonly: "readonly", tagEditStart: "tagEditStart", tagEditCancel: "tagEditCancel", editable: "editable", validations: "validations", tagFormatter: "tagFormatter", typeahead: "typeahead", typeaheadInputFormatter: "typeaheadInputFormatter", typeaheadResultFormatter: "typeaheadResultFormatter" }, outputs: { remove: "remove" }, features: [ɵngcc0.ɵɵProvidersFeature([BENTO_TAGS_INPUT_PILL_VALUE_ACCESSOR, BentoNotification])], decls: 10, vars: 7, consts: [[3, "hidden", 4, "ngIf"], ["aria-live", "polite", 1, "sr-only"], ["pillEmptyInfo", ""], ["class", "bento-tags-input-pill-label", 3, "hidden", 4, "ngIf", "ngIfElse"], ["labelWithTooltip", ""], ["class", "bento-tags-input-pill-edit-icon", "type", "button", 3, "mousedown", "keydown", 4, "ngIf"], ["class", "bento-tags-input-pill-close-icon", "type", "button", 3, "click", "keydown", 4, "ngIf"], ["class", "bento-tags-input-pill-size-ref", 4, "ngIf"], [3, "hidden"], [1, "bento-tags-input-field", 3, "hidden", "ngModel", "ngModelChange"], [1, "bento-tags-input-field", 3, "ngModel", "ngbTypeahead", "editable", "focusFirst", "inputFormatter", "resultFormatter", "showHint", "container", "ngModelChange", "selectItem"], ["typeaheadPill", "ngbTypeahead"], [1, "bento-tags-input-pill-label", 3, "hidden"], ["placement", "top", "container", "body", 1, "bento-tags-input-pill-label", 3, "hidden", "ngbTooltip"], ["truncatedTooltip", "ngbTooltip"], ["type", "button", 1, "bento-tags-input-pill-edit-icon", 3, "mousedown", "keydown"], ["aria-hidden", "true", 1, "bento-icon-edit"], ["type", "button", 1, "bento-tags-input-pill-close-icon", 3, "click", "keydown"], ["aria-hidden", "true", 1, "bento-icon-close-x"], [1, "bento-tags-input-pill-size-ref"]], template: function BentoTagsInputPillComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoTagsInputPillComponent_div_0_Template, 3, 8, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoTagsInputPillComponent_div_1_Template, 4, 14, "div", 0);
        ɵngcc0.ɵɵelement(2, "span", 1, 2);
        ɵngcc0.ɵɵtemplate(4, BentoTagsInputPillComponent_div_4_Template, 2, 2, "div", 3);
        ɵngcc0.ɵɵtemplate(5, BentoTagsInputPillComponent_ng_template_5_Template, 3, 3, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, BentoTagsInputPillComponent_button_7_Template, 4, 7, "button", 5);
        ɵngcc0.ɵɵtemplate(8, BentoTagsInputPillComponent_button_8_Template, 4, 7, "button", 6);
        ɵngcc0.ɵɵtemplate(9, BentoTagsInputPillComponent_div_9_Template, 1, 0, "div", 7);
    } if (rf & 2) {
        var _r4 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editable && !ctx.typeahead);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editable && ctx.typeahead);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx._noTextTruncation)("ngIfElse", _r4);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editable && !ctx.disabled && !ctx.readonly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disableRemove && !ctx.disabled && !ctx.readonly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._isEditing);
    } }, directives: [ɵngcc7.NgIf, ɵngcc8.DefaultValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, ɵngcc4.NgbTypeahead, ɵngcc4.NgbTooltip], pipes: [BentoTranslatePipe,
        BentoStringReplacePipe], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTagsInputPillComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tags-input-pill',
                template: "<div *ngIf=\"editable && !typeahead\" [hidden]=\"!_isEditing\">\n  <input\n    class=\"bento-tags-input-field\"\n    [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT_ELEMENT' | bentoTranslate\"\n    [hidden]=\"!_isEditing\"\n    [class.invalid]=\"_invalid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputChange($event)\"\n  />\n</div>\n\n<div *ngIf=\"editable && typeahead\" [hidden]=\"!_isEditing\">\n  <input\n    class=\"bento-tags-input-field\"\n    [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT_ELEMENT' | bentoTranslate\"\n    [class.invalid]=\"_invalid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputChange($event)\"\n    [ngbTypeahead]=\"typeahead\"\n    [editable]=\"typeheadEditable\"\n    [focusFirst]=\"typeheadFocusFirst\"\n    [inputFormatter]=\"typeaheadInputFormatter\"\n    [resultFormatter]=\"typeaheadResultFormatter\"\n    [showHint]=\"typeaheadShowHint\"\n    (selectItem)=\"_onTypeaheadSelectItem($event)\"\n    [container]=\"'body'\"\n    #typeaheadPill=\"ngbTypeahead\"\n  />\n</div>\n\n<span #pillEmptyInfo class=\"sr-only\" aria-live=\"polite\">\n  <!-- content will be updated with Javascript -->\n</span>\n\n<div [hidden]=\"_isEditing\" *ngIf=\"_noTextTruncation; else labelWithTooltip\" class=\"bento-tags-input-pill-label\">\n  {{ _formatTag(_data[tagPropertyName]) }}\n</div>\n\n<ng-template #labelWithTooltip>\n  <div\n    [hidden]=\"_isEditing\"\n    [ngbTooltip]=\"_formatTag(_data[tagPropertyName])\"\n    #truncatedTooltip=\"ngbTooltip\"\n    placement=\"top\"\n    container=\"body\"\n    class=\"bento-tags-input-pill-label\"\n  >\n    {{ _formatTag(_data[tagPropertyName]) }}\n  </div>\n</ng-template>\n\n<button\n  *ngIf=\"editable && !disabled && !readonly\"\n  class=\"bento-tags-input-pill-edit-icon\"\n  (mousedown)=\"_onEditClick($event)\"\n  (keydown)=\"_onKeydownEdit($event)\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_TAGS_INPUT_EDIT' | bentoTranslate | bentoStringReplace: '_LABEL_':_data[tagPropertyName]\"\n>\n  <i class=\"bento-icon-edit\" aria-hidden=\"true\"></i>\n</button>\n<button\n  *ngIf=\"!disableRemove && !disabled && !readonly\"\n  class=\"bento-tags-input-pill-close-icon\"\n  (click)=\"_onCloseClick()\"\n  (keydown)=\"_onKeydownClose($event)\"\n  type=\"button\"\n  [attr.aria-label]=\"\n    'BENTO_UI_TAGS_INPUT_CLOSE' | bentoTranslate | bentoStringReplace: '_LABEL_':_data[tagPropertyName]\n  \"\n>\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<div *ngIf=\"_isEditing\" class=\"bento-tags-input-pill-size-ref\"></div>\n",
                host: {
                    '[class.editable]': 'editable && !disabled && !readonly',
                    '[class.disable-remove]': 'disableRemove || disabled || readonly'
                },
                providers: [BENTO_TAGS_INPUT_PILL_VALUE_ACCESSOR, BentoNotification],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: BentoNotification }, { type: BentoTranslate }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc5.DomSanitizer }, { type: WindowRef }]; }, { typeaheadSelectItem: [{
            type: Input
        }], tagPropertyName: [{
            type: Input
        }], disableRemove: [{
            type: Input
        }], typeheadEditable: [{
            type: Input
        }], typeheadFocusFirst: [{
            type: Input
        }], typeaheadShowHint: [{
            type: Input
        }], readonly: [{
            type: HostBinding,
            args: ['class.readonly']
        }, {
            type: Input
        }], _isEditing: [{
            type: HostBinding,
            args: ['class.edit']
        }], remove: [{
            type: Output
        }], _invalid: [{
            type: HostBinding,
            args: ['class.invalid']
        }], onHostElementFocus: [{
            type: HostListener,
            args: ['focus']
        }], onFocusout: [{
            type: HostListener,
            args: ['focusout']
        }], onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], _onDoubleClick: [{
            type: HostListener,
            args: ['dblclick', ['$event']]
        }], tagEditStart: [{
            type: Input
        }], tagEditCancel: [{
            type: Input
        }], editable: [{
            type: Input
        }], validations: [{
            type: Input
        }], tagFormatter: [{
            type: Input
        }], typeahead: [{
            type: Input
        }], typeaheadInputFormatter: [{
            type: Input
        }], typeaheadResultFormatter: [{
            type: Input
        }], truncatedTooltip: [{
            type: ViewChild,
            args: ['truncatedTooltip']
        }], typeaheadPill: [{
            type: ViewChild,
            args: ['typeaheadPill']
        }], pillEmptyInfo: [{
            type: ViewChild,
            args: ['pillEmptyInfo', { static: true }]
        }] }); })();
    return BentoTagsInputPillComponent;
}());
if (false) {
    /**
     * EventEmitter for tag edit start
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.tagEditStart;
    /**
     * EventEmitter for tag edit cancel
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.tagEditCancel;
    /**
     * EventEmitter for typeahead selected item
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeaheadSelectItem;
    /**
     * Main object property name for label rendering
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.tagPropertyName;
    /**
     * Flag to enabling editable feature
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.editable;
    /**
     * Parent component validations object
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.validations;
    /**
     * Flag to disable this tag pill removal
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.disableRemove;
    /**
     * Function to format tags
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.tagFormatter;
    /**
     * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
     * Follow [ngbTypeahead Documentation]((https://ng-bootstrap.github.io/#/components/typeahead) for more details
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeahead;
    /**
     * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
     * A flag indicating if model values should be restricted to the ones selected from the popup only.
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeheadEditable;
    /**
     * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
     * A flag indicating if the first match should automatically be focused as you type.
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeheadFocusFirst;
    /**
     * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
     * A function to convert a given value into string to display in the input field
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeaheadInputFormatter;
    /**
     * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
     * A function to format a given result before display.
     * This function should return a formatted string without any HTML markup
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeaheadResultFormatter;
    /**
     * From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
     * Show hint when an option in the result list matches.
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeaheadShowHint;
    /**
     * API to support readonly
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.readonly;
    /**
     * Value Change callback
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._onChangeCallback;
    /**
     * Element touched callback
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._onTouchedCallback;
    /**
     * Main element disabled state flag
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.disabled;
    /**
     * Pill value
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._data;
    /**
     * Flag to show editing mode
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._isEditing;
    /**
     * Input text from the edit
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._inputText;
    /**
     * Remove notification
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.remove;
    /**
     * Pill Input field
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._inputEl;
    /**
     * Div reference to determine the input field width
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._inputSizeEl;
    /**
     * Input blur event subscription
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._inputBlurCancel;
    /**
     * Flag to validation of the input
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._invalid;
    /**
     * This is used to bypass the component ENTER key stroke when one of the
     * typeahead item is selected
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._isTypeaheadAction;
    /**
     * Flag the determine wheather need tooltip or not
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype._noTextTruncation;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.resizeSubscription;
    /**
     * Tooltip reference for a pill that has long text. This can be
     * used to show/hide the tooltip when on focus/blur
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.truncatedTooltip;
    /**
     * Typeahead reference, used when cancelling the edit.
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.typeaheadPill;
    /**
     * A11y: During edit process if user clears out the pill, it'll be visually
     * shown to the user with red border around the input. For A11y, this element
     * will be used to annouce the error
     * @type {?}
     */
    BentoTagsInputPillComponent.prototype.pillEmptyInfo;
    /**
     * Document object ref
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.formattedValue;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.bentoNotification;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputPillComponent.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tags-input/tags-input-errors.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class to contain Tags Input errors
 */
var BentoTagsInputErrors = /** @class */ (function () {
    function BentoTagsInputErrors() {
        /**
         * Stack to keep strack on the current errors
         */
        this._errorStack = [];
        /**
         * Error emitter to notify when there is an error
         */
        this._errorEmitter = new EventEmitter();
    }
    /**
     * Check if has error
     */
    /**
     * Check if has error
     * @return {?}
     */
    BentoTagsInputErrors.prototype.hasError = /**
     * Check if has error
     * @return {?}
     */
    function () {
        return this._errorStack.length > 0;
    };
    /**
     * Add an error to the error stack
     */
    /**
     * Add an error to the error stack
     * @param {?} error
     * @param {?=} tag
     * @return {?}
     */
    BentoTagsInputErrors.prototype.addError = /**
     * Add an error to the error stack
     * @param {?} error
     * @param {?=} tag
     * @return {?}
     */
    function (error, tag) {
        if (this._errorStack.indexOf(error) < 0) {
            this._errorStack.push(error);
            this._errorEmitter.emit({
                errors: this._errorStack.slice(),
                tag: tag
            });
        }
    };
    /**
     * Remove an error from the error stack
     */
    /**
     * Remove an error from the error stack
     * @param {?} error
     * @param {?=} tag
     * @return {?}
     */
    BentoTagsInputErrors.prototype.removeError = /**
     * Remove an error from the error stack
     * @param {?} error
     * @param {?=} tag
     * @return {?}
     */
    function (error, tag) {
        /** @type {?} */
        var index;
        if ((index = this._errorStack.indexOf(error)) > -1) {
            this._errorStack.splice(index, 1);
            this._errorEmitter.emit({
                errors: this._errorStack.slice(),
                tag: tag
            });
        }
    };
    /**
     * Reset errors
     */
    /**
     * Reset errors
     * @return {?}
     */
    BentoTagsInputErrors.prototype.reset = /**
     * Reset errors
     * @return {?}
     */
    function () {
        if (this._errorStack.length === 0) {
            return;
        }
        this._errorStack = [];
        this._errorEmitter.emit({
            errors: []
        });
    };
    Object.defineProperty(BentoTagsInputErrors.prototype, "errorNotification", {
        /**
         * Get error notification
         */
        get: /**
         * Get error notification
         * @return {?}
         */
        function () {
            return this._errorEmitter;
        },
        enumerable: true,
        configurable: true
    });
    BentoTagsInputErrors.DUPLICATE = 'Duplicated string';
    BentoTagsInputErrors.MINIMUM_LENGTH = 'Minimum length';
    return BentoTagsInputErrors;
}());
if (false) {
    /** @type {?} */
    BentoTagsInputErrors.DUPLICATE;
    /** @type {?} */
    BentoTagsInputErrors.MINIMUM_LENGTH;
    /**
     * Stack to keep strack on the current errors
     * @type {?}
     * @private
     */
    BentoTagsInputErrors.prototype._errorStack;
    /**
     * Error emitter to notify when there is an error
     * @type {?}
     * @private
     */
    BentoTagsInputErrors.prototype._errorEmitter;
}
/**
 * @record
 */
function BentoTagsInputErrorEvent() { }
if (false) {
    /** @type {?} */
    BentoTagsInputErrorEvent.prototype.errors;
    /** @type {?|undefined} */
    BentoTagsInputErrorEvent.prototype.tag;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tags-input/tags-input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var OPERATORS = '-+=/*%[]()!~&|<>';
/** @type {?} */
var BENTO_TAGS_INPUT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoTagsInputComponent; })),
    multi: true
};
// https://medium.com/@tarik.nzl/angular-2-custom-form-control-with-validation-json-input-2b4cf9bc2d73
/** @type {?} */
var BENTO_TAGS_INPUT_VALUE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoTagsInputComponent; })),
    multi: true
};
/**
 * A input field to generate an arbitrary number of pill-like or label-like Tags.
 * All Tags can be pre-added and deleted - both via keyboard (Delete or Backspace) and with mouse or touch.
 * `[rangeLength][formControlName]`, `[rangeLength][formControl]`, `[rangeLength][ngModel]`
 */
var BentoTagsInputComponent = /** @class */ (function () {
    /**
     * Component constructor
     */
    function BentoTagsInputComponent(_elementRef, r, windowRef, dir, uidGen, changeDetector, ngZone) {
        var _this = this;
        this._elementRef = _elementRef;
        this.r = r;
        this.dir = dir;
        this.uidGen = uidGen;
        this.changeDetector = changeDetector;
        this.ngZone = ngZone;
        /**
         * flag to add a tag with a comma
         */
        this.addOnComma = true;
        /**
         * flag to add a tag with enter key
         */
        this.addOnEnter = true;
        /**
         * flag to add a tag when space bar is pressed
         */
        this.addOnSpace = false;
        /**
         * Flag to make string comparison case insensitive
         */
        this.caseInsensitive = false;
        /**
         * flag to allow operator characters to be entered as a tag (eg. `=`)
         */
        this.useOperators = false;
        /**
         * Operators that are allowed in this string
         */
        this.allowedOperators = OPERATORS;
        /**
         * flag to disable keyboard input for text entries
         */
        this.disableInput = false;
        /**
         * flag to disable tag removals
         */
        this.disableTagRemove = false;
        /**
         * indicates the minimum characters are needed for a tag
         */
        this.minTagLength = 1;
        /**
         * A character with which to replace spaces in the label
         */
        this.replaceSpacesWith = ' ';
        /**
         * Property name to display each tag
         */
        this.tagPropertyName = 'name';
        /**
         * Set tag default variable type when created
         */
        this.tagDefaultType = 'auto';
        /**
         * API to support readonly state
         */
        this.readonly = false;
        /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * A flag indicating if the first match should automatically be focused as you type.
         */
        this.typeheadFocusFirst = false;
        /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * A flag indicating if model values should be restricted to the ones selected from the popup only.
         */
        this.typeheadEditable = true;
        /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * Show hint when an option in the result list matches.
         */
        this.typeaheadShowHint = false;
        /**
         * Callback when tag is about to be added. See `BentoTagsInputEvent` for payload details
         */
        this.tagAddStart = new EventEmitter();
        /**
         * Callback when a tag is added. See `BentoTagsInputEvent` for payload details
         */
        this.tagAdded = new EventEmitter();
        /**
         * Callback when a tag is being edited. See `BentoTagsInputEvent` for payload details
         */
        this.tagEditStart = new EventEmitter();
        /**
         * Callback when a tag is edited. See `BentoTagsInputEvent` for payload details
         */
        this.tagEdited = new EventEmitter();
        /**
         * Callback when the editing of a tag is cancelled. See `BentoTagsInputEvent` for payload details
         */
        this.tagEditCancel = new EventEmitter();
        /**
         * Callback when a tag is about to be removed. See `BentoTagsInputEvent` for payload details
         */
        this.tagRemoveStart = new EventEmitter();
        /**
         * Callback when a tag is removed. See `BentoTagsInputEvent` for payload details
         */
        this.tagRemoved = new EventEmitter();
        /**
         * Callback when there is an invalid input. See `BentoTagsInputEvent` for payload details
         */
        this.tagInvalidInput = new EventEmitter();
        /**
         * Callback when an item is selected in [NgbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead).
         * See `NgbTypeaheadSelectItemEvent` for payload details from
         * [NgbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
         */
        this.typeaheadSelectItem = new EventEmitter();
        /**
         * Main element disabled state flag
         */
        this._disabled = false;
        /**
         * Array to keep errors
         */
        this._errors = new BentoTagsInputErrors();
        /**
         * Flag to determin if the input is valid
         */
        this._isInputValid = true;
        /**
         * This is used to bypass the component ENTER key stroke when one of the
         * typeahead item is selected
         */
        this._isTypeaheadAction = false;
        /**
         * Placeholder value
         */
        this._placeholder = '';
        this.el = this._elementRef.nativeElement;
        this.document = windowRef.nativeDocument;
        this.bodyEl = this.document.body;
        this.isRtl = this.dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRtl = _this.dir.value === 'rtl';
            _this.changeDetector.markForCheck();
        }));
        // Setup pill validation logic
        this._validations = {
            // Tell the pill whether it can edit
            canEdit: (/**
             * @return {?}
             */
            function () { return !_this._errors.hasError(); }),
            // Check if the current string is valid
            isValidTag: (/**
             * @param {?} str
             * @param {?} tag
             * @return {?}
             */
            function (str, tag) {
                if (!str || String(str).trim().length === 0) {
                    return false;
                }
                // Reset Typeahead flag
                // This function is always called when an entry/selection is finished
                _this._isTypeaheadAction = false;
                /** @type {?} */
                var formattedStr = _this._validations.getFormattedString(str);
                if (_this.useOperators) {
                    // Duplicates are allowed with operators
                    // ex. (a) (+) (a) (*) (b) <= where (a) can be used more than 1x
                    return true;
                }
                else if (_this._hasDuplicate(formattedStr, tag)) {
                    // There is a duplicate
                    _this._errors.addError(BentoTagsInputErrors.DUPLICATE, tag);
                    return false;
                }
                else if (formattedStr.trim().length < _this.minTagLength) {
                    // Current string doesn't qualify minLength requirement
                    _this._errors.addError(BentoTagsInputErrors.MINIMUM_LENGTH, tag);
                    return false;
                }
                // There is no duplicate
                _this._errors.reset();
                // Call validate function when there is no error
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.callValidation(); }));
                return true;
            }),
            // Format a string based on the `replaceSpacesWith`
            getFormattedString: (/**
             * @param {?} str
             * @return {?}
             */
            function (str) { return String(str).replace(/ /gi, _this.replaceSpacesWith || ' '); })
        };
        // Register error status callback
        this._errorNotificationSubscription = this._errors.errorNotification.subscribe((/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            _this._onError(e);
        }));
        this.r.addClass(this.el, 'form-control');
        this.r.listen(this.el, 'focusin', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            if (!_this.el.classList.contains('bento-tags-input-focused')) {
                // only fire when it is not focued
                _this.onFocus(e);
            }
        }));
        this.r.listen(this.el, 'click', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            if (!_this.el.classList.contains('bento-tags-input-focused') && e.target === _this.el) {
                // only fire when it is not focued and user clicks on contents othan than the pills and input
                _this.onFocus(e);
                if (!_this.disableInput) {
                    // If the main input is not disabled bring focus to it
                    _this._inputEl.focus();
                }
                else {
                    // Focus on the first pill if there is one
                    /** @type {?} */
                    var pill = _this._elementRef.nativeElement.querySelector('bento-tags-input-pill');
                    if (pill) {
                        pill.focus();
                    }
                }
            }
        }));
        this.r.listen(this.el, 'focusout', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                if (e.relatedTarget) {
                    // Most of the browsers have FocusEvent.relatedTarget defined
                    if (!_this.el.contains(e.relatedTarget)) {
                        _this.onBlur(e);
                    }
                }
                else if (!_this.el.contains(_this.document.activeElement)) {
                    // But some don't!!
                    _this.onBlur(e);
                }
            }));
        }));
    }
    Object.defineProperty(BentoTagsInputComponent.prototype, "placeholder", {
        get: /**
         * @return {?}
         */
        function () {
            return this._placeholder;
        },
        /**
         * Placeholder for the input field
         */
        set: /**
         * Placeholder for the input field
         * @param {?} str
         * @return {?}
         */
        function (str) {
            this._placeholder = str || '';
            this.adjustInputEl();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputComponent.prototype, "tagMaxWidth", {
        get: /**
         * @return {?}
         */
        function () {
            return this._tagMaxWidth;
        },
        /**
         * Set the maximum width of the tags in pixel
         */
        set: /**
         * Set the maximum width of the tags in pixel
         * @param {?} value
         * @return {?}
         */
        function (value) {
            /** @type {?} */
            var trimmed = value ? value.trim() : '100%';
            // Auto should not be allowed
            this._tagMaxWidth = trimmed.toLowerCase().indexOf('auto') > -1 ? '100%' : trimmed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputComponent.prototype, "_id", {
        /**
         * ID of this element
         */
        set: /**
         * ID of this element
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.id = v;
            // setTimeout(() => this.setupAria(), 3000);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputComponent.prototype, "typeahead", {
        /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * Follow [ngbTypeahead Documentation](https://ng-bootstrap.github.io/#/components/typeahead) for more details
         */
        set: /**
         * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
         * Follow [ngbTypeahead Documentation](https://ng-bootstrap.github.io/#/components/typeahead) for more details
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._typeahead = fn;
            // Reset input el pointer since the observer can be null
            this._inputElPointer = null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputComponent.prototype, "editable", {
        /**
         * Flag to make all tags editable
         */
        set: /**
         * Flag to make all tags editable
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._editable = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTagsInputComponent.prototype, "_inputEl", {
        /**
         * Get current available main input element
         */
        get: /**
         * Get current available main input element
         * @return {?}
         */
        function () {
            this._inputElPointer = this._elementRef.nativeElement.querySelector('.bento-tags-input-field-main');
            return this._inputElPointer;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Implements ControlValueAccessor
     */
    /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    BentoTagsInputComponent.prototype.registerOnChange = /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * From ControlValueAccessor interface
     */
    /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    BentoTagsInputComponent.prototype.registerOnTouched = /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this._onTouchedCallback = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.changeDetector.markForCheck();
        });
    };
    /**
     * NgModel setter
     */
    /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    BentoTagsInputComponent.prototype.writeValue = /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    function (v) {
        var _this = this;
        this._data = v ? v.slice() : null;
        this.changeDetector.markForCheck();
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.adjustInputEl();
        }));
    };
    /**
     * Set Disabled state for ngModel
     */
    /**
     * Set Disabled state for ngModel
     * @param {?} v
     * @return {?}
     */
    BentoTagsInputComponent.prototype.setDisabledState = /**
     * Set Disabled state for ngModel
     * @param {?} v
     * @return {?}
     */
    function (v) {
        var _this = this;
        this._disabled = v;
        if (!v) {
            // When showing, bring placeholder up in the view after a local digest cycle
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.adjustInputEl();
            }));
        }
    };
    /**
     * @param {?} control
     * @return {?}
     */
    BentoTagsInputComponent.prototype.validate = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        if (this.validationErrors && this._errors.hasError()) {
            /** @type {?} */
            var returnValue = void 0;
            if (this.validationErrors.errors[0] === BentoTagsInputErrors.MINIMUM_LENGTH) {
                returnValue = { minlength: { actualLength: this._inputText.length, requiredLength: this.minTagLength } };
            }
            else if (this.validationErrors.errors[0] === BentoTagsInputErrors.DUPLICATE) {
                returnValue = { duplicate: { valid: false } };
            }
            return returnValue;
        }
        return null;
    };
    // Register callValidation function with registerOnValidatorChange().
    // Register callValidation function with registerOnValidatorChange().
    /**
     * @param {?} fn
     * @return {?}
     */
    BentoTagsInputComponent.prototype.registerOnValidatorChange = 
    // Register callValidation function with registerOnValidatorChange().
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.callValidation = fn;
    };
    /**
     * Init function
     */
    /**
     * Init function
     * @return {?}
     */
    BentoTagsInputComponent.prototype.ngOnInit = /**
     * Init function
     * @return {?}
     */
    function () { };
    /**
     * After View Init function
     */
    /**
     * After View Init function
     * @return {?}
     */
    BentoTagsInputComponent.prototype.ngAfterViewInit = /**
     * After View Init function
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () { return _this.setupAria(); }));
    };
    /**
     * To be called when this element is destroyed
     */
    /**
     * To be called when this element is destroyed
     * @return {?}
     */
    BentoTagsInputComponent.prototype.ngOnDestroy = /**
     * To be called when this element is destroyed
     * @return {?}
     */
    function () {
        this._errorNotificationSubscription.unsubscribe();
        this.mObserver && this.mObserver.disconnect();
        this.changeDetector.detach();
    };
    /**
     * Input `ngModel` change listener
     */
    /**
     * Input `ngModel` change listener
     * @param {?} value
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onInputTextChange = /**
     * Input `ngModel` change listener
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        /** @type {?} */
        var inputEl = this._inputEl;
        /** @type {?} */
        var refEl = this._inputSizeRef.nativeElement;
        if (!inputEl.value || inputEl.value.length === 0) {
            if (this._errors.hasError() && value !== this._inputText) {
                // This happens when typeahead is selecting an item that give an error
                this.r.setValue(inputEl, value);
                this._inputText = value;
            }
            else {
                // When this field is truly empty
                this._inputText = '';
                this.adjustInputEl();
                this._errors.reset();
            }
        }
        else {
            // Normal user entries
            this._inputText = value;
            this.r.setProperty(refEl, 'innerText', inputEl.value);
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.r.setStyle(inputEl, 'width', refEl.offsetWidth + 10 + 'px');
            }));
            this._errors.reset();
        }
    };
    /**
     * Main input `keydown` event listener
     */
    /**
     * Main input `keydown` event listener
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onInputKeydown = /**
     * Main input `keydown` event listener
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        /** @type {?} */
        var inputEl = this._inputEl;
        switch (e.keyCode) {
            // Erase the last pill on BACKSPACE
            case Keyboard.BACKSPACE:
                if (inputEl.selectionStart === 0 &&
                    inputEl.selectionEnd === 0 &&
                    !this.disableTagRemove &&
                    this._data.length > 0) {
                    // Execute pop
                    BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagRemoveStart, (/**
                     * @param {?} tag
                     * @return {?}
                     */
                    function (tag) {
                        _this._data.pop();
                        // Fire `ngModel` callback
                        _this._onChangeCallback(_this._data.slice());
                        // Fire event callback
                        _this.tagRemoved.emit(new BentoTagsInputEvent(tag));
                    }), this._data[this._data.length - 1]);
                }
                else if (!inputEl.value || (inputEl.value && inputEl.value.length <= 1)) {
                    // validate to show/hide new/previous error
                    setTimeout((/**
                     * @return {?}
                     */
                    function () { return _this.callValidation(); }));
                }
                break;
            case Keyboard.ENTER:
                if (this.addOnEnter && !this._isTypeaheadAction) {
                    this._addPill(this._inputText);
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.SPACE:
                if (this.addOnSpace) {
                    this._addPill(this._inputText);
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
            case Keyboard.COMMA:
                if (this.addOnComma) {
                    this._addPill(this._inputText);
                    e.stopPropagation();
                    e.preventDefault();
                }
                break;
            default:
                break;
        }
    };
    /**
     * Callback when the input box is blurred
     */
    /**
     * Callback when the input box is blurred
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onInputBlur = /**
     * Callback when the input box is blurred
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this._addPill(this._inputText);
    };
    /**
     * Callback when the input with typeahead blurred
     */
    /**
     * Callback when the input with typeahead blurred
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onInputBlurWithTypeahead = /**
     * Callback when the input with typeahead blurred
     * @param {?} e
     * @return {?}
     */
    function (e) {
        triggerKeyboardEvent(this._inputEl, 'keydown', Keyboard.ENTER);
    };
    /**
     * Callback when a typeahead item is selected
     */
    /**
     * Callback when a typeahead item is selected
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onTypeaheadSelectItem = /**
     * Callback when a typeahead item is selected
     * @param {?} e
     * @return {?}
     */
    function (e) {
        // Need to flag the typeahead action
        // since this happens prior to the enter keydown
        // we can stop the ENTER keydown being registered with the main input field
        this._isTypeaheadAction = true;
        if (this.typeaheadSelectItem) {
            this.typeaheadSelectItem.emit(e);
        }
        // We are adding a tag when an item is selected from the typeahead dropdown
        this._addPill(this.typeaheadInputFormatter ? this.typeaheadInputFormatter(e.item) : e.item);
        this._inputText = '';
        this.adjustInputEl();
    };
    /**
     * Force typeahead to display an empty string when an item is selected
     */
    /**
     * Force typeahead to display an empty string when an item is selected
     * @param {?} value
     * @return {?}
     */
    BentoTagsInputComponent.prototype._typeaheadTagsInputFieldFormatter = /**
     * Force typeahead to display an empty string when an item is selected
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return '';
    };
    /**
     * Callback function to pill update
     */
    /**
     * Callback function to pill update
     * @param {?} tag
     * @param {?} index
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onPillUpdate = /**
     * Callback function to pill update
     * @param {?} tag
     * @param {?} index
     * @return {?}
     */
    function (tag, index) {
        // Call validate function when the pill is done editing.
        this.callValidation();
        this.tagEdited.emit(new BentoTagsInputEvent(tag));
    };
    /**
     * Callback when a pill is removed
     */
    /**
     * Callback when a pill is removed
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onPillRemove = /**
     * Callback when a pill is removed
     * @param {?} e
     * @return {?}
     */
    function (e) {
        // Bug Fix: before removing the pill, reset error object. Without
        // reset, future edit is disabled.
        this.validationErrors = undefined;
        this._errors.reset();
        // Execute `_doRemove` based on `this.tagRemoveStart`
        BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagRemoveStart, this._doRemovePill, e.tag, e);
    };
    /**
     * Execute pill removal
     */
    /**
     * Execute pill removal
     * @param {?} tag
     * @param {?} data
     * @return {?}
     */
    BentoTagsInputComponent.prototype._doRemovePill = /**
     * Execute pill removal
     * @param {?} tag
     * @param {?} data
     * @return {?}
     */
    function (tag, data) {
        // Execute Tag removal
        /** @type {?} */
        var index = this._data.indexOf(tag);
        this._data.splice(index, 1);
        // Focus on to the previous/next el sibling to additional keyboard navigation
        if (data.keyCode && data.keyCode === Keyboard.BACKSPACE && data.el.previousElementSibling) {
            // focus on the previous sibling when Backspace is pressed
            data.el.previousElementSibling.focus();
        }
        else {
            data.el.nextElementSibling.focus();
        }
        // Notify ngFormController for changes
        this._onChangeCallback(this._data.slice());
        // Notify Tag removal
        this.tagRemoved.emit(new BentoTagsInputEvent(tag));
    };
    /**
     * Add and push a pill into the data
     */
    /**
     * Add and push a pill into the data
     * @param {?} str
     * @return {?}
     */
    BentoTagsInputComponent.prototype._addPill = /**
     * Add and push a pill into the data
     * @param {?} str
     * @return {?}
     */
    function (str) {
        if (!str) {
            return;
        }
        else if (str.trim().length === 0) {
            this._inputText = '';
            this.adjustInputEl();
            return;
        }
        /** @type {?} */
        var tag = this._makeTag(str);
        if (this._validations.isValidTag(tag[this.tagPropertyName], tag)) {
            // Execute `_doAddPill` based on `this.tagAddStart`
            BentoTagsInputUtil.exeTagMethodWithEventEmitter(this, this.tagAddStart, this._doAddPill, tag);
        }
        else {
            this._onChangeCallback(this._data.slice());
        }
    };
    /**
     * Execute adding a pill from a string
     */
    /**
     * Execute adding a pill from a string
     * @param {?} tag
     * @return {?}
     */
    BentoTagsInputComponent.prototype._doAddPill = /**
     * Execute adding a pill from a string
     * @param {?} tag
     * @return {?}
     */
    function (tag) {
        this._data.push(tag);
        this._onChangeCallback(this._data.slice());
        // Reset the main input field
        this._inputText = '';
        this.adjustInputEl();
        // Fire callback
        this.tagAdded.emit(new BentoTagsInputEvent(tag));
        // Reset typeahead action flag when pill adding is finished
        this._isTypeaheadAction = false;
    };
    /**
     * Make a tag object with a string
     */
    /**
     * Make a tag object with a string
     * @param {?} str
     * @return {?}
     */
    BentoTagsInputComponent.prototype._makeTag = /**
     * Make a tag object with a string
     * @param {?} str
     * @return {?}
     */
    function (str) {
        /** @type {?} */
        var tagStr;
        if (!str || (tagStr = String(str).trim()).length === 0) {
            return;
        }
        if (tagStr.length === 0) {
            return;
        }
        /** @type {?} */
        var num = this.tagDefaultType === 'auto' ? Number(tagStr) : Number.NaN;
        /** @type {?} */
        var tag = { type: 'string' };
        if (!isNaN(num)) {
            // Use formatter
            tag[this.tagPropertyName] = this.tagFormatter ? this.tagFormatter(num) : num;
            tag.type = 'number';
        }
        else if (this._isOperator(tagStr) && this.useOperators) {
            // Operators don't need tag formatters
            tag[this.tagPropertyName] = tagStr;
            tag.type = 'operator';
        }
        else {
            // Format tag
            tag[this.tagPropertyName] = this.tagFormatter
                ? this.tagFormatter(this._validations.getFormattedString(tagStr))
                : this._validations.getFormattedString(tagStr);
        }
        return tag;
    };
    /**
     * Check if the content of `str` has already entered in the pill array
     */
    /**
     * Check if the content of `str` has already entered in the pill array
     * @param {?} value
     * @param {?=} tag
     * @return {?}
     */
    BentoTagsInputComponent.prototype._hasDuplicate = /**
     * Check if the content of `str` has already entered in the pill array
     * @param {?} value
     * @param {?=} tag
     * @return {?}
     */
    function (value, tag) {
        /** @type {?} */
        var str;
        /** @type {?} */
        var dataTag;
        /** @type {?} */
        var tagStr;
        if (!value || (str = value.trim()).length === 0) {
            // There isn't a duplicate for an empty entry
            return false;
        }
        if (this.caseInsensitive) {
            str = str.toLowerCase();
        }
        for (var i = 0, len = this._data.length; i < len; i++) {
            dataTag = this._data[i];
            tagStr = this.caseInsensitive ? dataTag[this.tagPropertyName].toLowerCase() : dataTag[this.tagPropertyName];
            // Check value against each tag's propertyName
            if (tagStr === str && tag !== dataTag) {
                // Return immediately when a duplicate found
                return true;
            }
        }
        // No duplicates
        return false;
    };
    /**
     * Show placeholder when permitted
     */
    /**
     * Show placeholder when permitted
     * @private
     * @return {?}
     */
    BentoTagsInputComponent.prototype.adjustInputEl = /**
     * Show placeholder when permitted
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.ngZone.runOutsideAngular((/**
         * @return {?}
         */
        function () {
            if (!_this.disableInput && _this._inputSizeRef) {
                // Only execute this method only when the main input is not disabled
                /** @type {?} */
                var inputEl = _this._inputEl;
                /** @type {?} */
                var sizeRefEl = _this._inputSizeRef.nativeElement;
                if (_this.bodyEl.contains(sizeRefEl)) {
                    if (_this.mObserver) {
                        // Remove BODY MutationOberver when Tags Input component is in view
                        _this.mObserver.disconnect();
                        _this.mObserver = null;
                    }
                    /** @type {?} */
                    var inputWidth = 2;
                    // Default input width without anything
                    /** @type {?} */
                    var placeholderWidth = 0;
                    if (!!_this.placeholder && sizeRefEl) {
                        // Calculate place holder width
                        _this.r.setProperty(sizeRefEl, 'innerText', _this.placeholder);
                        placeholderWidth = Math.min(_this.el.offsetWidth - 16, sizeRefEl.offsetWidth + 6);
                    }
                    inputEl && _this.r.setStyle(inputEl, 'width', Math.max(inputWidth, placeholderWidth) + "px");
                }
                else if (!_this.mObserver) {
                    // Setup document DOM change listener
                    _this.mObserver = new MutationObserver(_this.onDocumentDOMChange.bind(_this));
                    // Only oberve childlist changes for Modal in Body
                    // The rest...? Will figure out later due to perfomance lags when `subtree: true` is used
                    _this.mObserver.observe(_this.bodyEl, { childList: true });
                }
            }
        }));
    };
    /**
     * Callback when error status is updated
     */
    /**
     * Callback when error status is updated
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onError = /**
     * Callback when error status is updated
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!(this._isInputValid = e.errors.length === 0)) {
            if (this.tagInvalidInput) {
                this.validationErrors = e;
                this.tagInvalidInput.emit(new BentoTagsInputEvent(e.tag, null, e.errors));
            }
        }
    };
    /**
     * Check if the current string is an operator
     */
    /**
     * Check if the current string is an operator
     * @param {?} str
     * @return {?}
     */
    BentoTagsInputComponent.prototype._isOperator = /**
     * Check if the current string is an operator
     * @param {?} str
     * @return {?}
     */
    function (str) {
        for (var i = 0, len = str.length; i < len; i++) {
            if (this.allowedOperators.indexOf(str.charAt(i)) < 0) {
                return false;
            }
        }
        return true;
    };
    /**
     * Event listner for navigational keystrokes
     */
    /**
     * Event listner for navigational keystrokes
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype._onTagsInputKeydown = /**
     * Event listner for navigational keystrokes
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var focusedEl = this.document.activeElement;
        /** @type {?} */
        var inputEl = this._inputEl;
        if (focusedEl.parentElement && focusedEl.parentElement.classList.contains('bento-typeahead')) {
            // If focus is on typeahead input element and contains wrapper element as parent, focus on parent element
            // to be able to reach previous sibling
            focusedEl = focusedEl.parentElement;
        }
        switch (e.keyCode) {
            // Left Key
            case Keyboard.LEFT:
                if (this.isRtl) {
                    this.selectNext(focusedEl, e);
                }
                else {
                    this.selectPrevious(focusedEl, inputEl);
                }
                break;
            // Right Key
            case Keyboard.RIGHT:
                if (this.isRtl) {
                    this.selectPrevious(focusedEl, inputEl);
                }
                else {
                    this.selectNext(focusedEl, e);
                }
                break;
        }
    };
    /**
     * @param {?} focusedEl
     * @param {?} inputEl
     * @return {?}
     */
    BentoTagsInputComponent.prototype.selectPrevious = /**
     * @param {?} focusedEl
     * @param {?} inputEl
     * @return {?}
     */
    function (focusedEl, inputEl) {
        if (focusedEl.previousElementSibling) {
            // Only execute when there is a pill before the current focused element
            if (inputEl === focusedEl) {
                // check the current selection range then decide if need to focus on the previous pill
                if (inputEl.selectionStart === 0 && inputEl.selectionEnd === 0) {
                    ((/** @type {?} */ (focusedEl.previousElementSibling))).focus();
                }
            }
            else {
                // Focus on the previous sibling if it exists
                ((/** @type {?} */ (focusedEl.previousElementSibling))).focus();
            }
        }
    };
    /**
     * @param {?} focusedEl
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype.selectNext = /**
     * @param {?} focusedEl
     * @param {?} e
     * @return {?}
     */
    function (focusedEl, e) {
        if (((/** @type {?} */ (e.target))).tagName !== 'INPUT') {
            // Only focus to the next sibling when the current focused element is NOT an input
            if (focusedEl.nextElementSibling.classList.contains('bento-typeahead')) {
                // if next sibling is a typeahead wrapper (needed for RTL) focus on actual input element
                ((/** @type {?} */ (focusedEl.nextElementSibling.firstChild))).focus();
            }
            else {
                ((/** @type {?} */ (focusedEl.nextElementSibling))).focus();
            }
        }
    };
    /**
     * Callback when BODY DOM is mutated
     * This only applies the children of the BODY element
     * DOES NOT apply to subtrees
     *
     * We are using this callback address when this component is
     * used in conjuction with Modal
     *
     * @param mutationList
     * @param observer
     */
    /**
     * Callback when BODY DOM is mutated
     * This only applies the children of the BODY element
     * DOES NOT apply to subtrees
     *
     * We are using this callback address when this component is
     * used in conjuction with Modal
     *
     * @private
     * @param {?} mutationList
     * @param {?} observer
     * @return {?}
     */
    BentoTagsInputComponent.prototype.onDocumentDOMChange = /**
     * Callback when BODY DOM is mutated
     * This only applies the children of the BODY element
     * DOES NOT apply to subtrees
     *
     * We are using this callback address when this component is
     * used in conjuction with Modal
     *
     * @private
     * @param {?} mutationList
     * @param {?} observer
     * @return {?}
     */
    function (mutationList, observer) {
        this.adjustInputEl();
    };
    /**
     * Callback for component focus events
     */
    /**
     * Callback for component focus events
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype.onFocus = /**
     * Callback for component focus events
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.r.addClass(this._elementRef.nativeElement, 'bento-tags-input-focused');
    };
    /**
     * Callback for component blur events
     */
    /**
     * Callback for component blur events
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoTagsInputComponent.prototype.onBlur = /**
     * Callback for component blur events
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.r.removeClass(this._elementRef.nativeElement, 'bento-tags-input-focused');
        this._onTouchedCallback();
    };
    /**
     * Setup aria values
     */
    /**
     * Setup aria values
     * @private
     * @return {?}
     */
    BentoTagsInputComponent.prototype.setupAria = /**
     * Setup aria values
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var ariaAttribute = this._elementRef.nativeElement.getAttribute('aria-label');
        this.ariaLabel = ariaAttribute ? ariaAttribute : this.ariaLabel;
        ariaAttribute = this._elementRef.nativeElement.getAttribute('aria-describedby');
        this.ariaDescribedby = ariaAttribute ? ariaAttribute : this.ariaDescribedby;
        ariaAttribute = this._elementRef.nativeElement.getAttribute('aria-labelledby');
        this.ariaLabelledby = ariaAttribute ? ariaAttribute : this.ariaLabelledby;
        if (!(typeof this.id === 'string' && this.id.length)) {
            this.id = 'bui-tags-input-' + this.uidGen.generate();
        }
        else {
            this.r.removeAttribute(this._elementRef.nativeElement, 'id');
        }
        if (this.ariaLabel && this.ariaLabel.length) {
            this.r.removeAttribute(this._elementRef.nativeElement, 'aria-label');
        }
        if (this.ariaDescribedby && this.ariaDescribedby.length) {
            this.r.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
        }
        this._inputID = this.id;
    };
    /** @nocollapse */
    BentoTagsInputComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: WindowRef },
        { type: Directionality },
        { type: BentoUidService },
        { type: ChangeDetectorRef },
        { type: NgZone }
    ]; };
    BentoTagsInputComponent.propDecorators = {
        addOnComma: [{ type: Input }],
        addOnEnter: [{ type: Input }],
        addOnSpace: [{ type: Input }],
        caseInsensitive: [{ type: Input }],
        placeholder: [{ type: Input }],
        useOperators: [{ type: Input }],
        allowedOperators: [{ type: Input }],
        disableInput: [{ type: Input }],
        disableTagRemove: [{ type: Input }],
        minTagLength: [{ type: Input }],
        replaceSpacesWith: [{ type: Input }],
        tagPropertyName: [{ type: Input }],
        tagDefaultType: [{ type: Input }],
        readonly: [{ type: Input }, { type: HostBinding, args: ['class.readonly',] }],
        tagFormatter: [{ type: Input }],
        tagMaxWidth: [{ type: Input }],
        _id: [{ type: Input, args: ['id',] }],
        typeheadFocusFirst: [{ type: Input }],
        typeheadEditable: [{ type: Input }],
        typeaheadInputFormatter: [{ type: Input }],
        typeaheadResultFormatter: [{ type: Input }],
        typeaheadShowHint: [{ type: Input }],
        tagAddStart: [{ type: Output }],
        tagAdded: [{ type: Output }],
        tagEditStart: [{ type: Output }],
        tagEdited: [{ type: Output }],
        tagEditCancel: [{ type: Output }],
        tagRemoveStart: [{ type: Output }],
        tagRemoved: [{ type: Output }],
        tagInvalidInput: [{ type: Output }],
        typeaheadSelectItem: [{ type: Output }],
        _inputSizeRef: [{ type: ViewChild, args: ['inputSizeRef', { static: true },] }],
        _disabled: [{ type: HostBinding, args: ['class.disabled',] }],
        typeahead: [{ type: Input }],
        editable: [{ type: Input }],
        _onTagsInputKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
    };
BentoTagsInputComponent.ɵfac = function BentoTagsInputComponent_Factory(t) { return new (t || BentoTagsInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(BentoUidService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
BentoTagsInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTagsInputComponent, selectors: [["bento-tags-input"]], viewQuery: function BentoTagsInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c57, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputSizeRef = _t.first);
    } }, hostVars: 4, hostBindings: function BentoTagsInputComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function BentoTagsInputComponent_keydown_HostBindingHandler($event) { return ctx._onTagsInputKeydown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("readonly", ctx.readonly)("disabled", ctx._disabled);
    } }, inputs: { addOnComma: "addOnComma", addOnEnter: "addOnEnter", addOnSpace: "addOnSpace", caseInsensitive: "caseInsensitive", useOperators: "useOperators", allowedOperators: "allowedOperators", disableInput: "disableInput", disableTagRemove: "disableTagRemove", minTagLength: "minTagLength", replaceSpacesWith: "replaceSpacesWith", tagPropertyName: "tagPropertyName", tagDefaultType: "tagDefaultType", readonly: "readonly", typeheadFocusFirst: "typeheadFocusFirst", typeheadEditable: "typeheadEditable", typeaheadShowHint: "typeaheadShowHint", placeholder: "placeholder", tagMaxWidth: "tagMaxWidth", _id: ["id", "_id"], typeahead: "typeahead", editable: "editable", tagFormatter: "tagFormatter", typeaheadInputFormatter: "typeaheadInputFormatter", typeaheadResultFormatter: "typeaheadResultFormatter" }, outputs: { tagAddStart: "tagAddStart", tagAdded: "tagAdded", tagEditStart: "tagEditStart", tagEdited: "tagEdited", tagEditCancel: "tagEditCancel", tagRemoveStart: "tagRemoveStart", tagRemoved: "tagRemoved", tagInvalidInput: "tagInvalidInput", typeaheadSelectItem: "typeaheadSelectItem" }, features: [ɵngcc0.ɵɵProvidersFeature([BENTO_TAGS_INPUT_VALUE_ACCESSOR, BENTO_TAGS_INPUT_VALUE_VALIDATOR, BentoUidService])], decls: 6, vars: 3, consts: [["tabindex", "0", 3, "max-width", "ngModel", "tagEditCancel", "tagEditStart", "disableRemove", "tagPropertyName", "editable", "validations", "tagFormatter", "typeahead", "typeheadEditable", "typeheadFocusFirst", "typeaheadInputFormatter", "typeaheadResultFormatter", "typeaheadShowHint", "typeaheadSelectItem", "disabled", "readonly", "ngModelChange", "remove", 4, "ngFor", "ngForOf"], ["class", "bento-tags-input-field bento-tags-input-field-main", 3, "hidden", "invalid", "ngModel", "placeholder", "ngModelChange", "keydown", "blur", 4, "ngIf"], ["class", "bento-typeahead", 4, "ngIf"], [1, "clearfix"], ["aria-hidden", "true", 1, "bento-tags-input-pill-size-ref"], ["inputSizeRef", ""], ["tabindex", "0", 3, "ngModel", "tagEditCancel", "tagEditStart", "disableRemove", "tagPropertyName", "editable", "validations", "tagFormatter", "typeahead", "typeheadEditable", "typeheadFocusFirst", "typeaheadInputFormatter", "typeaheadResultFormatter", "typeaheadShowHint", "typeaheadSelectItem", "disabled", "readonly", "ngModelChange", "remove"], [1, "bento-tags-input-field", "bento-tags-input-field-main", 3, "hidden", "ngModel", "placeholder", "ngModelChange", "keydown", "blur"], [1, "bento-typeahead"], [1, "bento-tags-input-field", "bento-tags-input-field-main", 3, "hidden", "ngModel", "placeholder", "ngbTypeahead", "editable", "focusFirst", "inputFormatter", "resultFormatter", "showHint", "ngModelChange", "keydown", "blur", "selectItem"]], template: function BentoTagsInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoTagsInputComponent_bento_tags_input_pill_0_Template, 1, 19, "bento-tags-input-pill", 0);
        ɵngcc0.ɵɵtemplate(1, BentoTagsInputComponent_input_1_Template, 1, 9, "input", 1);
        ɵngcc0.ɵɵtemplate(2, BentoTagsInputComponent_div_2_Template, 2, 15, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 4, 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx._data);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx._typeahead && !ctx._disabled && !ctx.readonly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._typeahead && !ctx._disabled && !ctx.readonly);
    } }, directives: [ɵngcc7.NgForOf, ɵngcc7.NgIf, BentoTagsInputPillComponent, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, ɵngcc8.DefaultValueAccessor, ɵngcc4.NgbTypeahead], styles: ["bento-tags-input.form-control{display:block;height:auto}bento-tags-input.form-control.disabled,bento-tags-input.form-control:disabled,bento-tags-input.form-control[disabled]{opacity:.5;pointer-events:none}bento-tags-input.form-control.no-border,bento-tags-input.form-control.readonly{border:none;padding-left:0;padding-right:0}[dir=rtl] bento-tags-input.form-control.no-border,[dir=rtl] bento-tags-input.form-control.readonly{margin-left:0}bento-tags-input.form-control .dropdown-menu{transform:none}bento-tags-input.form-control .dropdown-menu:after,bento-tags-input.form-control .dropdown-menu:before{content:\"\";width:0;height:0;border:none}bento-tags-input{cursor:text}bento-tags-input .bento-typeahead{float:left}[dir=rtl] bento-tags-input .bento-typeahead{float:right}bento-tags-input input.bento-tags-input-field{float:left;display:block;padding:0;border:none;box-sizing:border-box;width:0;min-width:1px;max-width:100%;letter-spacing:0}[dir=rtl] bento-tags-input input.bento-tags-input-field{float:right}bento-tags-input input.bento-tags-input-field:focus{outline:0}bento-tags-input input.bento-tags-input-field[disabled]{background:0 0}bento-tags-input .bento-tags-input-pill-size-ref{display:inline-block;padding:0 1px;position:fixed;top:-9999px;white-space:pre;width:auto;letter-spacing:0;opacity:0}bento-tags-input-pill{cursor:default;position:relative;float:left;overflow:hidden;font-size:1rem;border-width:1px;border-style:solid;opacity:0;transition:background .1s,color .1s,border-color .1s}[dir=rtl] bento-tags-input-pill{float:right}bento-tags-input-pill.disable-remove{padding-right:10px}[dir=rtl] bento-tags-input-pill.disable-remove{padding-left:10px}bento-tags-input-pill.disable-remove:after{width:13.3px}bento-tags-input-pill input.bento-tags-input-field{display:block;background:0 0;margin:0}bento-tags-input-pill.ready{opacity:1}bento-tags-input-pill .bento-tags-input-pill-size-ref,bento-tags-input-pill input{min-width:0}bento-tags-input-pill input{margin-right:5px}bento-tags-input-pill.edit{padding-right:25.5px}bento-tags-input-pill.edit .bento-tags-input-pill-close-icon{opacity:.2;transition:opacity .2s}bento-tags-input-pill.edit:after{display:none}bento-tags-input-pill:after{content:\" \";right:-1px;top:0;height:100%;pointer-events:none}[dir=rtl] bento-tags-input-pill:after{right:auto;left:0;transform:scaleX(-1)}bento-tags-input-pill .bento-tags-input-pill-label{display:block;width:100%;vertical-align:top;white-space:pre;word-break:normal;word-wrap:normal;cursor:default}bento-tags-input-pill .bento-tags-input-pill-close-icon,bento-tags-input-pill .bento-tags-input-pill-edit-icon{background-color:Transparent;border:none;display:flex}bento-tags-input-pill .bento-tags-input-pill-edit-icon i{top:0}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTagsInputComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tags-input',
                template: "<bento-tags-input-pill\n  *ngFor=\"let pill of _data; let i = index\"\n  [style.max-width]=\"tagMaxWidth\"\n  [ngModel]=\"pill\"\n  (ngModelChange)=\"_onPillUpdate($event, i)\"\n  (remove)=\"_onPillRemove($event)\"\n  [tagEditCancel]=\"tagEditCancel\"\n  [tagEditStart]=\"tagEditStart\"\n  [disableRemove]=\"disableTagRemove\"\n  [tagPropertyName]=\"tagPropertyName\"\n  [editable]=\"_editable\"\n  [validations]=\"_validations\"\n  [tagFormatter]=\"tagFormatter\"\n  [typeahead]=\"_typeahead\"\n  [typeheadEditable]=\"typeheadEditable\"\n  [typeheadFocusFirst]=\"typeheadFocusFirst\"\n  [typeaheadInputFormatter]=\"typeaheadInputFormatter\"\n  [typeaheadResultFormatter]=\"typeaheadResultFormatter\"\n  [typeaheadShowHint]=\"typeaheadShowHint\"\n  [typeaheadSelectItem]=\"typeaheadSelectItem\"\n  [disabled]=\"_disabled\"\n  [readonly]=\"readonly\"\n  tabindex=\"0\"\n></bento-tags-input-pill>\n\n<input\n  *ngIf=\"!_typeahead && !_disabled && !readonly\"\n  class=\"bento-tags-input-field bento-tags-input-field-main\"\n  [hidden]=\"disableInput\"\n  [class.invalid]=\"!_isInputValid\"\n  [ngModel]=\"_inputText\"\n  (ngModelChange)=\"_onInputTextChange($event)\"\n  (keydown)=\"_onInputKeydown($event)\"\n  (blur)=\"_onInputBlur($event)\"\n  placeholder=\"{{ placeholder }}\"\n  [attr.id]=\"_inputID\"\n  [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n  [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n/>\n\n<div *ngIf=\"_typeahead && !_disabled && !readonly\" class=\"bento-typeahead\">\n  <input\n    class=\"bento-tags-input-field bento-tags-input-field-main\"\n    [hidden]=\"disableInput\"\n    [class.invalid]=\"!_isInputValid\"\n    [ngModel]=\"_inputText\"\n    (ngModelChange)=\"_onInputTextChange($event)\"\n    (keydown)=\"_onInputKeydown($event)\"\n    (blur)=\"_onInputBlurWithTypeahead($event)\"\n    placeholder=\"{{ placeholder }}\"\n    [attr.id]=\"_inputID\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [attr.aria-describedby]=\"ariaDescribedby ? ariaDescribedby : null\"\n    [attr.aria-labelledby]=\"ariaLabelledby ? ariaLabelledby : null\"\n    [ngbTypeahead]=\"_typeahead\"\n    [editable]=\"typeheadEditable\"\n    [focusFirst]=\"typeheadFocusFirst\"\n    [inputFormatter]=\"_typeaheadTagsInputFieldFormatter\"\n    [resultFormatter]=\"typeaheadResultFormatter\"\n    [showHint]=\"typeaheadShowHint\"\n    (selectItem)=\"_onTypeaheadSelectItem($event)\"\n  />\n</div>\n<div class=\"clearfix\"></div>\n<div #inputSizeRef class=\"bento-tags-input-pill-size-ref\" aria-hidden=\"true\"></div>\n",
                providers: [BENTO_TAGS_INPUT_VALUE_ACCESSOR, BENTO_TAGS_INPUT_VALUE_VALIDATOR, BentoUidService],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-tags-input.form-control{display:block;height:auto}bento-tags-input.form-control.disabled,bento-tags-input.form-control:disabled,bento-tags-input.form-control[disabled]{opacity:.5;pointer-events:none}bento-tags-input.form-control.no-border,bento-tags-input.form-control.readonly{border:none;padding-left:0;padding-right:0}[dir=rtl] bento-tags-input.form-control.no-border,[dir=rtl] bento-tags-input.form-control.readonly{margin-left:0}bento-tags-input.form-control .dropdown-menu{transform:none}bento-tags-input.form-control .dropdown-menu:after,bento-tags-input.form-control .dropdown-menu:before{content:\"\";width:0;height:0;border:none}bento-tags-input{cursor:text}bento-tags-input .bento-typeahead{float:left}[dir=rtl] bento-tags-input .bento-typeahead{float:right}bento-tags-input input.bento-tags-input-field{float:left;display:block;padding:0;border:none;box-sizing:border-box;width:0;min-width:1px;max-width:100%;letter-spacing:0}[dir=rtl] bento-tags-input input.bento-tags-input-field{float:right}bento-tags-input input.bento-tags-input-field:focus{outline:0}bento-tags-input input.bento-tags-input-field[disabled]{background:0 0}bento-tags-input .bento-tags-input-pill-size-ref{display:inline-block;padding:0 1px;position:fixed;top:-9999px;white-space:pre;width:auto;letter-spacing:0;opacity:0}bento-tags-input-pill{cursor:default;position:relative;float:left;overflow:hidden;font-size:1rem;border-width:1px;border-style:solid;opacity:0;transition:background .1s,color .1s,border-color .1s}[dir=rtl] bento-tags-input-pill{float:right}bento-tags-input-pill.disable-remove{padding-right:10px}[dir=rtl] bento-tags-input-pill.disable-remove{padding-left:10px}bento-tags-input-pill.disable-remove:after{width:13.3px}bento-tags-input-pill input.bento-tags-input-field{display:block;background:0 0;margin:0}bento-tags-input-pill.ready{opacity:1}bento-tags-input-pill .bento-tags-input-pill-size-ref,bento-tags-input-pill input{min-width:0}bento-tags-input-pill input{margin-right:5px}bento-tags-input-pill.edit{padding-right:25.5px}bento-tags-input-pill.edit .bento-tags-input-pill-close-icon{opacity:.2;transition:opacity .2s}bento-tags-input-pill.edit:after{display:none}bento-tags-input-pill:after{content:\" \";right:-1px;top:0;height:100%;pointer-events:none}[dir=rtl] bento-tags-input-pill:after{right:auto;left:0;transform:scaleX(-1)}bento-tags-input-pill .bento-tags-input-pill-label{display:block;width:100%;vertical-align:top;white-space:pre;word-break:normal;word-wrap:normal;cursor:default}bento-tags-input-pill .bento-tags-input-pill-close-icon,bento-tags-input-pill .bento-tags-input-pill-edit-icon{background-color:Transparent;border:none;display:flex}bento-tags-input-pill .bento-tags-input-pill-edit-icon i{top:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: WindowRef }, { type: ɵngcc6.Directionality }, { type: BentoUidService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { addOnComma: [{
            type: Input
        }], addOnEnter: [{
            type: Input
        }], addOnSpace: [{
            type: Input
        }], caseInsensitive: [{
            type: Input
        }], useOperators: [{
            type: Input
        }], allowedOperators: [{
            type: Input
        }], disableInput: [{
            type: Input
        }], disableTagRemove: [{
            type: Input
        }], minTagLength: [{
            type: Input
        }], replaceSpacesWith: [{
            type: Input
        }], tagPropertyName: [{
            type: Input
        }], tagDefaultType: [{
            type: Input
        }], readonly: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.readonly']
        }], typeheadFocusFirst: [{
            type: Input
        }], typeheadEditable: [{
            type: Input
        }], typeaheadShowHint: [{
            type: Input
        }], tagAddStart: [{
            type: Output
        }], tagAdded: [{
            type: Output
        }], tagEditStart: [{
            type: Output
        }], tagEdited: [{
            type: Output
        }], tagEditCancel: [{
            type: Output
        }], tagRemoveStart: [{
            type: Output
        }], tagRemoved: [{
            type: Output
        }], tagInvalidInput: [{
            type: Output
        }], typeaheadSelectItem: [{
            type: Output
        }], _disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }], placeholder: [{
            type: Input
        }], tagMaxWidth: [{
            type: Input
        }], _id: [{
            type: Input,
            args: ['id']
        }], typeahead: [{
            type: Input
        }], editable: [{
            type: Input
        }], _onTagsInputKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], tagFormatter: [{
            type: Input
        }], typeaheadInputFormatter: [{
            type: Input
        }], typeaheadResultFormatter: [{
            type: Input
        }], _inputSizeRef: [{
            type: ViewChild,
            args: ['inputSizeRef', { static: true }]
        }] }); })();
    return BentoTagsInputComponent;
}());
if (false) {
    /**
     * flag to add a tag with a comma
     * @type {?}
     */
    BentoTagsInputComponent.prototype.addOnComma;
    /**
     * flag to add a tag with enter key
     * @type {?}
     */
    BentoTagsInputComponent.prototype.addOnEnter;
    /**
     * flag to add a tag when space bar is pressed
     * @type {?}
     */
    BentoTagsInputComponent.prototype.addOnSpace;
    /**
     * Flag to make string comparison case insensitive
     * @type {?}
     */
    BentoTagsInputComponent.prototype.caseInsensitive;
    /**
     * flag to allow operator characters to be entered as a tag (eg. `=`)
     * @type {?}
     */
    BentoTagsInputComponent.prototype.useOperators;
    /**
     * Operators that are allowed in this string
     * @type {?}
     */
    BentoTagsInputComponent.prototype.allowedOperators;
    /**
     * flag to disable keyboard input for text entries
     * @type {?}
     */
    BentoTagsInputComponent.prototype.disableInput;
    /**
     * flag to disable tag removals
     * @type {?}
     */
    BentoTagsInputComponent.prototype.disableTagRemove;
    /**
     * indicates the minimum characters are needed for a tag
     * @type {?}
     */
    BentoTagsInputComponent.prototype.minTagLength;
    /**
     * A character with which to replace spaces in the label
     * @type {?}
     */
    BentoTagsInputComponent.prototype.replaceSpacesWith;
    /**
     * Property name to display each tag
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagPropertyName;
    /**
     * Set tag default variable type when created
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagDefaultType;
    /**
     * API to support readonly state
     * @type {?}
     */
    BentoTagsInputComponent.prototype.readonly;
    /**
     * Function to format tags
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagFormatter;
    /** @type {?} */
    BentoTagsInputComponent.prototype.validationErrors;
    /**
     * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
     * A flag indicating if the first match should automatically be focused as you type.
     * @type {?}
     */
    BentoTagsInputComponent.prototype.typeheadFocusFirst;
    /**
     * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
     * A flag indicating if model values should be restricted to the ones selected from the popup only.
     * @type {?}
     */
    BentoTagsInputComponent.prototype.typeheadEditable;
    /**
     * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
     * A function to convert a given value into string to display in the input field
     * @type {?}
     */
    BentoTagsInputComponent.prototype.typeaheadInputFormatter;
    /**
     * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
     * A function to format a given result before display.
     * This function should return a formatted string without any HTML markup
     * @type {?}
     */
    BentoTagsInputComponent.prototype.typeaheadResultFormatter;
    /**
     * (From [ngbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead))
     * Show hint when an option in the result list matches.
     * @type {?}
     */
    BentoTagsInputComponent.prototype.typeaheadShowHint;
    /**
     * Callback when tag is about to be added. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagAddStart;
    /**
     * Callback when a tag is added. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagAdded;
    /**
     * Callback when a tag is being edited. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagEditStart;
    /**
     * Callback when a tag is edited. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagEdited;
    /**
     * Callback when the editing of a tag is cancelled. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagEditCancel;
    /**
     * Callback when a tag is about to be removed. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagRemoveStart;
    /**
     * Callback when a tag is removed. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagRemoved;
    /**
     * Callback when there is an invalid input. See `BentoTagsInputEvent` for payload details
     * @type {?}
     */
    BentoTagsInputComponent.prototype.tagInvalidInput;
    /**
     * Callback when an item is selected in [NgbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead).
     * See `NgbTypeaheadSelectItemEvent` for payload details from
     * [NgbTypeahead](https://ng-bootstrap.github.io/#/components/typeahead)
     * @type {?}
     */
    BentoTagsInputComponent.prototype.typeaheadSelectItem;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoTagsInputComponent.prototype.isRtl;
    /**
     * Element reference of the input size reference DIV
     * @type {?}
     */
    BentoTagsInputComponent.prototype._inputSizeRef;
    /**
     * Input text value
     * @type {?}
     */
    BentoTagsInputComponent.prototype._inputText;
    /**
     * Value Change callback
     * @type {?}
     */
    BentoTagsInputComponent.prototype._onChangeCallback;
    /**
     * Element touched callback
     * @type {?}
     */
    BentoTagsInputComponent.prototype._onTouchedCallback;
    /**
     * Main tags array
     * @type {?}
     */
    BentoTagsInputComponent.prototype._data;
    /**
     * HTMLElement ID for input element
     * @type {?}
     */
    BentoTagsInputComponent.prototype._inputID;
    /**
     * Main element disabled state flag
     * @type {?}
     */
    BentoTagsInputComponent.prototype._disabled;
    /**
     * Array to keep errors
     * @type {?}
     */
    BentoTagsInputComponent.prototype._errors;
    /**
     * Error notification subscription
     * @type {?}
     */
    BentoTagsInputComponent.prototype._errorNotificationSubscription;
    /**
     * Validation methods reference
     * @type {?}
     */
    BentoTagsInputComponent.prototype._validations;
    /**
     * Flag to determin if the input is valid
     * @type {?}
     */
    BentoTagsInputComponent.prototype._isInputValid;
    /**
     * This is used to bypass the component ENTER key stroke when one of the
     * typeahead item is selected
     * @type {?}
     */
    BentoTagsInputComponent.prototype._isTypeaheadAction;
    /**
     * Typeahead observable fn reference
     * @type {?}
     */
    BentoTagsInputComponent.prototype._typeahead;
    /**
     * Input element pointer that is currently used
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype._inputElPointer;
    /**
     * Editable flag
     * @type {?}
     */
    BentoTagsInputComponent.prototype._editable;
    /**
     * Placeholder value
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype._placeholder;
    /**
     * Tag max width
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype._tagMaxWidth;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.bodyEl;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.id;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.el;
    /** @type {?} */
    BentoTagsInputComponent.prototype.ariaLabel;
    /** @type {?} */
    BentoTagsInputComponent.prototype.ariaDescribedby;
    /** @type {?} */
    BentoTagsInputComponent.prototype.ariaLabelledby;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.callValidation;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.mObserver;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype._elementRef;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.dir;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.uidGen;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoTagsInputComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tags-input/tags-input.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTagsInputModule = /** @class */ (function () {
    function BentoTagsInputModule() {
    }
BentoTagsInputModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTagsInputModule });
BentoTagsInputModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTagsInputModule_Factory(t) { return new (t || BentoTagsInputModule)(); }, imports: [[CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, NgbTypeaheadModule, NgbTooltipModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTagsInputModule, { declarations: function () { return [BentoTagsInputComponent,
        BentoTagsInputPillComponent]; }, imports: function () { return [CommonModule, FormsModule,
        BentoTranslateModule,
        BentoUtilsModule,
        NgbTypeaheadModule, NgbTooltipModule]; }, exports: function () { return [BentoTagsInputComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTagsInputModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, BentoTranslateModule, BentoUtilsModule, NgbTypeaheadModule, NgbTooltipModule],
                declarations: [BentoTagsInputComponent, BentoTagsInputPillComponent],
                exports: [BentoTagsInputComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoTagsInputModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tile-ribbon/tile-ribbon.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Arrow paddings together on both sides in default layout
 * @type {?}
 */
var ARROW_PADDING = 40;
/**
 * Main parent component class that defines Bento Tile Ribbon
 */
var BentoTileRibbonComponent = /** @class */ (function () {
    function BentoTileRibbonComponent(r, windowRef, bentoNotification, transition, dir, elRef) {
        var _this = this;
        this.r = r;
        this.windowRef = windowRef;
        this.bentoNotification = bentoNotification;
        this.transition = transition;
        this.dir = dir;
        /**
         * Show / Hide collapse toggle button in default theme
         */
        this.showCollapseToggle = true;
        /**
         * Define tile minimum width
         */
        this.tileMinWidth = 260;
        /**
         * Current item width
         */
        this.itemWidth = this.tileMinWidth;
        /**
         * Flag to determine if the left arrow is disabled
         */
        this.disableLeftArrow = false;
        /**
         * Flag to determine if the right arrow is disabled
         */
        this.disableRightArrow = false;
        /**
         * Flag to determine if the ribbon is visible or not
         */
        this.ribbonHidden = false;
        /**
         * Unique class name to component to distinguish from Bento Modern Tile Ribbon
         */
        this.bentoTileRibbonCSSClass = true;
        this.el = elRef.nativeElement;
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.flipDirection();
        }));
    }
    /**
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.innerEl = this.innerElRef.nativeElement;
        this.panelEL = this.panelElRef.nativeElement;
        this.r.setStyle(this.innerEl, 'margin-bottom', "-" + this.windowRef.scrollbarWidth + "px");
        this.resizeSubscription = this.bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () {
            _this.alignItems();
        }));
        this.onInnerScroll = this.onInnerScroll.bind(this);
        this.r.listen(this.innerEl, 'scroll', this.onInnerScroll);
        this.r.listen(this.innerEl, 'wheel', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            if (e.deltaX === 0) {
                // Only apply to vertical scroll. eg Mouse wheels
                _this.r.setProperty(_this.innerEl, 'scrollLeft', _this.innerEl.scrollLeft + (_this.isRtl ? -e.deltaY : e.deltaY));
                e.preventDefault();
            }
        }));
    };
    /**
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.ngAfterViewChecked = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.items && this.items.length !== this.itemCount) {
            // Item counts are not aligned
            this.itemCount = this.items.length;
            setTimeout((/**
             * @return {?}
             */
            function () { return _this.alignItems(); }));
        }
    };
    /**
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
    };
    /**
     * Toggle ribbon's visibility.  Property `ribbonHidden` is used to determine ribbon's visibility
     */
    /**
     * Toggle ribbon's visibility.  Property `ribbonHidden` is used to determine ribbon's visibility
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.toggleVisibility = /**
     * Toggle ribbon's visibility.  Property `ribbonHidden` is used to determine ribbon's visibility
     * @return {?}
     */
    function () {
        this.ribbonHidden = !this.ribbonHidden;
    };
    /**
     * Callback when an arrow is clicked
     */
    /**
     * Callback when an arrow is clicked
     * @param {?} isRight
     * @return {?}
     */
    BentoTileRibbonComponent.prototype._onArrowClick = /**
     * Callback when an arrow is clicked
     * @param {?} isRight
     * @return {?}
     */
    function (isRight) {
        /** @type {?} */
        var scrollLeft = this.innerEl.scrollLeft;
        /** @type {?} */
        var itemWidth = this.itemWidth;
        /** @type {?} */
        var scrollToIndex = isRight ? Math.round(scrollLeft / itemWidth) + 1 : Math.round(scrollLeft / itemWidth) - 1;
        this.scrollTo(Math.round(scrollToIndex * itemWidth));
    };
    /**
     * Callback when a tile is selected
     */
    /**
     * Callback when a tile is selected
     * @param {?} tile
     * @return {?}
     */
    BentoTileRibbonComponent.prototype._onTileSelect = /**
     * Callback when a tile is selected
     * @param {?} tile
     * @return {?}
     */
    function (tile) {
        if (this.selectedTile) {
            this.selectedTile.deselect();
        }
        this.selectedTile = tile;
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.onInnerScroll = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        clearTimeout(this.checkArrowTimeout);
        this.checkArrowTimeout = setTimeout((/**
         * @return {?}
         */
        function () {
            _this.checkArrowStates();
        }), 500);
    };
    /**
     * @private
     * @param {?} scrollLeft
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.scrollTo = /**
     * @private
     * @param {?} scrollLeft
     * @return {?}
     */
    function (scrollLeft) {
        var _this = this;
        if (scrollLeft >= 0) {
            this.transition.stop();
            this.transition.duration = 100;
            this.transition.beginVal = this.innerEl.scrollLeft;
            this.transition.endVal = scrollLeft;
            this.transition.onTick((/**
             * @param {?} val
             * @return {?}
             */
            function (val) { return _this.r.setProperty(_this.innerEl, 'scrollLeft', val); }));
            this.transition.start();
        }
    };
    /**
     * Align tile items
     */
    /**
     * Align tile items
     * @private
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.alignItems = /**
     * Align tile items
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var elWidth = this.el.offsetWidth;
        /** @type {?} */
        var hasScroll = this.tileMinWidth * this.itemCount > elWidth;
        /** @type {?} */
        var innerWidth = hasScroll
            ? elWidth - (this.el.classList.contains('alt') ? ARROW_PADDING * 2 : ARROW_PADDING)
            : elWidth;
        /** @type {?} */
        var numColumnsToFitInner = hasScroll ? Math.floor(innerWidth / this.tileMinWidth) : this.itemCount;
        /** @type {?} */
        var adjustedItemWidth = innerWidth / numColumnsToFitInner;
        /** @type {?} */
        var panelWidth = adjustedItemWidth * this.itemCount;
        this.r.setStyle(this.panelEL, 'width', panelWidth + "px");
        if (hasScroll) {
            this.r.addClass(this.el, 'scroll');
        }
        else {
            this.r.removeClass(this.el, 'scroll');
        }
        this.itemWidth = adjustedItemWidth;
        this.checkArrowStates();
        // when the width is set on the panel the tiles are shifted, this loop
        // moves the tile to the start
        /** @type {?} */
        var scrollLeft = 0;
        // this can't loop more than the number of tiles.
        // on some browsers the element's scrollLeft (this.innerEl.scrollLeft)
        // isn't reflected immediately.
        // exitCondition is to mitigate infinite looping
        /** @type {?} */
        var exitCondition = this.itemCount - 1;
        while (exitCondition && scrollLeft + this.innerEl.offsetWidth < this.innerEl.scrollWidth) {
            exitCondition--;
            scrollLeft += this.innerEl.scrollLeft;
            /** @type {?} */
            var itemWidth = this.itemWidth;
            /** @type {?} */
            var scrollToIndex = this.isRtl
                ? Math.round(scrollLeft / itemWidth) + 1
                : Math.round(scrollLeft / itemWidth) - 1;
            this.r.setProperty(this.innerEl, 'scrollLeft', Math.round(scrollToIndex * itemWidth));
        }
    };
    /**
     * Check current state to decide whether to enable or disable arrows
     */
    /**
     * Check current state to decide whether to enable or disable arrows
     * @private
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.checkArrowStates = /**
     * Check current state to decide whether to enable or disable arrows
     * @private
     * @return {?}
     */
    function () {
        /* left arrow */
        this.disableLeftArrow = this.innerEl.scrollLeft === 0;
        /* right arrow */
        this.disableRightArrow = this.innerEl.scrollLeft === this.innerEl.scrollWidth - this.innerEl.offsetWidth;
    };
    /**
     * RTL
     */
    /**
     * RTL
     * @private
     * @return {?}
     */
    BentoTileRibbonComponent.prototype.flipDirection = /**
     * RTL
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.isRtl = this.dir.value === 'rtl';
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.alignItems();
        }), 50);
    };
    /** @nocollapse */
    BentoTileRibbonComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: WindowRef },
        { type: BentoNotification },
        { type: BentoTransition },
        { type: Directionality },
        { type: ElementRef }
    ]; };
    BentoTileRibbonComponent.propDecorators = {
        title: [{ type: HostBinding, args: ['attr.aria-label',] }, { type: Input }],
        items: [{ type: Input }],
        tileAriaLabel: [{ type: Input }],
        showCollapseToggle: [{ type: Input }],
        tileTemplate: [{ type: Input }],
        tileMinWidth: [{ type: Input }],
        ribbonHidden: [{ type: HostBinding, args: ['class.bento-tile-ribbon-hidden',] }],
        bentoTileRibbonCSSClass: [{ type: HostBinding, args: ['class.bui-bento-tile-ribbon',] }],
        innerElRef: [{ type: ViewChild, args: ['inner', { static: true },] }],
        panelElRef: [{ type: ViewChild, args: ['panel', { static: true },] }]
    };
BentoTileRibbonComponent.ɵfac = function BentoTileRibbonComponent_Factory(t) { return new (t || BentoTileRibbonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(BentoTransition), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoTileRibbonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTileRibbonComponent, selectors: [["bento-tile-ribbon"]], viewQuery: function BentoTileRibbonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c58, true);
        ɵngcc0.ɵɵstaticViewQuery(_c59, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.innerElRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelElRef = _t.first);
    } }, hostAttrs: ["role", "region"], hostVars: 5, hostBindings: function BentoTileRibbonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.title);
        ɵngcc0.ɵɵclassProp("bento-tile-ribbon-hidden", ctx.ribbonHidden)("bui-bento-tile-ribbon", ctx.bentoTileRibbonCSSClass);
    } }, inputs: { showCollapseToggle: "showCollapseToggle", tileMinWidth: "tileMinWidth", title: "title", items: "items", tileAriaLabel: "tileAriaLabel", tileTemplate: "tileTemplate" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification, BentoTransition, WindowRef])], decls: 16, vars: 15, consts: [["title", "", 1, "bento-tile-ribbon-header", 3, "ngClass"], ["class", "bento-tile-ribbon-header-title", 4, "ngIf"], ["type", "button", "class", "bento-tile-ribbon-visibility-toggle btn btn-link", 3, "click", 4, "ngIf"], ["title", "", 1, "bento-tile-ribbon-container"], ["type", "button", 1, "bento-tile-ribbon-arrow", "left", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-left"], [1, "bento-tile-ribbon-wrapper"], ["dir", "ltr", 1, "bento-tile-ribbon-inner"], ["inner", ""], [1, "bento-tile-ribbon-panel"], ["panel", ""], [3, "item", "width", "template", "select", 4, "ngFor", "ngForOf"], ["type", "button", 1, "bento-tile-ribbon-arrow", "right", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-right"], [1, "bento-tile-ribbon-header-title"], ["type", "button", 1, "bento-tile-ribbon-visibility-toggle", "btn", "btn-link", 3, "click"], ["aria-hidden", "true"], [3, "item", "width", "template", "select"]], template: function BentoTileRibbonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoTileRibbonComponent_h1_1_Template, 2, 1, "h1", 1);
        ɵngcc0.ɵɵtemplate(2, BentoTileRibbonComponent_button_2_Template, 5, 7, "button", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function BentoTileRibbonComponent_Template_button_click_4_listener() { return ctx._onArrowClick(false); });
        ɵngcc0.ɵɵpipe(5, "bentoTranslate");
        ɵngcc0.ɵɵelement(6, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7, 8);
        ɵngcc0.ɵɵelementStart(10, "div", 9, 10);
        ɵngcc0.ɵɵtemplate(12, BentoTileRibbonComponent_bento_ribbon_tile_12_Template, 2, 6, "bento-ribbon-tile", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "button", 12);
        ɵngcc0.ɵɵlistener("click", function BentoTileRibbonComponent_Template_button_click_13_listener() { return ctx._onArrowClick(true); });
        ɵngcc0.ɵɵpipe(14, "bentoTranslate");
        ɵngcc0.ɵɵelement(15, "i", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.title ? "btrh-title " : ctx.showCollapseToggle ? "btrh-collapse" : "btrh-hidden");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCollapseToggle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hidden", ctx.ribbonHidden);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disableLeftArrow);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(5, 11, "BENTO_UI_TILE_RIBBON_SCROLL_LEFT"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵattribute("dir", ctx.isRtl ? "rtl" : "ltr");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disableRightArrow);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(14, 13, "BENTO_UI_TILE_RIBBON_SCROLL_RIGHT"));
    } }, directives: function () { return [ɵngcc7.NgClass, ɵngcc7.NgIf, ɵngcc7.NgForOf, BentoRibbonTileComponent]; }, pipes: function () { return [BentoTranslatePipe]; }, styles: [".bui-bento-tile-ribbon{display:block;position:relative}.bui-bento-tile-ribbon.scroll .bento-tile-ribbon-arrow{display:block}.bui-bento-tile-ribbon.bento-tile-ribbon-hidden{padding:0}.bui-bento-tile-ribbon .bento-tile-ribbon-header{align-items:center;display:flex}.bui-bento-tile-ribbon .bento-tile-ribbon-header h1{display:inline-block;margin:0;padding:0}.bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-title{justify-content:space-between}.bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-collapse{justify-content:flex-end}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle{height:30px;line-height:30px;padding:0}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle i,.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle span{margin:0;text-decoration:none}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle i{margin-left:5px!important;margin-right:5px}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover{text-decoration:none}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover span{text-decoration:underline}.bui-bento-tile-ribbon .bento-tile-ribbon-container{overflow:hidden;position:relative}.bui-bento-tile-ribbon .bento-tile-ribbon-container.hidden{height:0;margin-top:0}.bui-bento-tile-ribbon .bento-tile-ribbon-wrapper{overflow:hidden}.bui-bento-tile-ribbon .bento-tile-ribbon-inner{overflow-x:scroll;position:relative;transition:opacity .2s}.bui-bento-tile-ribbon .bento-tile-ribbon-inner:focus{outline:0}.bui-bento-tile-ribbon .bento-tile-ribbon-panel{align-items:stretch;display:flex}.bui-bento-tile-ribbon bento-ribbon-tile{display:block;flex-grow:1;position:relative}.bui-bento-tile-ribbon bento-ribbon-tile:after{background-color:transparent;bottom:0;content:\" \";display:block;height:4px;position:absolute;transition:background-color .2s}.bui-bento-tile-ribbon bento-ribbon-tile.selected{z-index:1}.bui-bento-tile-ribbon bento-ribbon-tile.selected .bento-ribbon-tile-inner{border-width:1px;border-style:solid}.bui-bento-tile-ribbon .bento-ribbon-tile-inner{border-width:1px;border-style:solid;min-height:100%;position:relative}.bui-bento-tile-ribbon .bento-ribbon-tile-value{cursor:default;flex-grow:2;font-size:2.857rem;letter-spacing:-1px;line-height:1em;overflow:hidden;text-overflow:ellipsis;transition:color .2s;white-space:nowrap}.bui-bento-tile-ribbon .bento-ribbon-tile-link{cursor:pointer;flex-shrink:4;font-size:.8em;margin-top:8px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.bui-bento-tile-ribbon .bento-ribbon-tile-indicator{flex-shrink:0;margin-right:5px}[dir=rtl] .bui-bento-tile-ribbon .bento-ribbon-tile-indicator{margin-right:0;margin-left:5px}.bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class*=\" bento-icon-\"],.bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class^=bento-icon-]{vertical-align:baseline}.bui-bento-tile-ribbon .bento-ribbon-tile-value-wrapper{align-items:flex-start;display:flex;justify-content:space-between}.bui-bento-tile-ribbon .bento-ribbon-tile-header-wrapper{align-content:flex-start;align-items:center;display:flex}.bui-bento-tile-ribbon .bento-ribbon-tile-header{cursor:default;font-size:1.143rem;font-weight:700;letter-spacing:.5px;margin:0;overflow:hidden;padding:0;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.bui-bento-tile-ribbon .bento-ribbon-tile-header::first-letter{text-transform:uppercase}.bui-bento-tile-ribbon .bento-ribbon-tile-description{cursor:default;font-size:.857rem;letter-spacing:.3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bui-bento-tile-ribbon .bento-tile-ribbon-arrow{border:none;display:none;font-size:1.7em;height:100%;position:absolute;top:0;z-index:2}.bui-bento-tile-ribbon .bento-tile-ribbon-arrow.left{left:0}.bui-bento-tile-ribbon .bento-tile-ribbon-arrow.right{right:0}.bui-bento-tile-ribbon.alt{border-bottom-width:0;padding:0}.bui-bento-tile-ribbon.alt .bento-tile-ribbon-container{margin:0}.bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile{padding:0}.bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-right-width:0}[dir=rtl] .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-left-width:0;border-right-width:1px}.bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:0}[dir=rtl] .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:1px;border-right-width:0}.bui-bento-tile-ribbon.alt .bento-tile-ribbon-header.btrh-hidden{display:none}.bui-bento-tile-ribbon.alt bento-ribbon-tile{padding:0}.bui-bento-tile-ribbon.alt bento-ribbon-tile:after{left:0;right:0}.bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:0}[dir=rtl] .bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:-1px;margin-left:0}.bui-bento-tile-ribbon.alt .bento-tile-ribbon-arrow{border-width:1px;border-style:solid}.bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:-1px}[dir=rtl] .bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:0;margin-left:-1px}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTileRibbonComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tile-ribbon',
                template: "<div\n  class=\"bento-tile-ribbon-header\"\n  [ngClass]=\"title ? 'btrh-title ' : showCollapseToggle ? 'btrh-collapse' : 'btrh-hidden'\"\n  title\n>\n  <!-- intentionally empty title -->\n  <h1 *ngIf=\"title\" class=\"bento-tile-ribbon-header-title\">{{ title }}</h1>\n  <button\n    *ngIf=\"showCollapseToggle\"\n    type=\"button\"\n    class=\"bento-tile-ribbon-visibility-toggle btn btn-link\"\n    (click)=\"toggleVisibility()\"\n  >\n    <i\n      aria-hidden=\"true\"\n      [class.bento-icon-minus-plain]=\"!this.ribbonHidden\"\n      [class.bento-icon-plus-plain]=\"this.ribbonHidden\"\n    ></i>\n    <span>\n      {{ (ribbonHidden ? 'BENTO_UI_TILE_RIBBON_TOGGLE_SHOW' : 'BENTO_UI_TILE_RIBBON_TOGGLE_HIDE') | bentoTranslate }}\n    </span>\n  </button>\n</div>\n\n<div class=\"bento-tile-ribbon-container\" [class.hidden]=\"this.ribbonHidden\" title>\n  <!-- intentionally empty title -->\n  <button\n    class=\"bento-tile-ribbon-arrow left\"\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TILE_RIBBON_SCROLL_LEFT' | bentoTranslate\"\n    (click)=\"_onArrowClick(false)\"\n    [disabled]=\"disableLeftArrow\"\n  >\n    <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"bento-tile-ribbon-wrapper\">\n    <!-- \n      dir=\"ltr\" is intentional - to overcome scrollLeft value from different\n      browsers. Set the direction to ltr, this way scrollLeft calculation'll\n      be same for all browsers\n    -->\n    <div dir=\"ltr\" class=\"bento-tile-ribbon-inner\" #inner>\n      <!-- dir=\"ltr\" is intentional -->\n      <div class=\"bento-tile-ribbon-panel\" #panel [attr.dir]=\"isRtl ? 'rtl' : 'ltr'\">\n        <bento-ribbon-tile\n          *ngFor=\"let item of items\"\n          [item]=\"item\"\n          [width]=\"itemWidth\"\n          (select)=\"_onTileSelect($event)\"\n          [template]=\"tileTemplate\"\n          [attr.aria-label]=\"tileAriaLabel ? tileAriaLabel : ('tile' | bentoTranslate)\"\n        ></bento-ribbon-tile>\n      </div>\n    </div>\n  </div>\n  <button\n    class=\"bento-tile-ribbon-arrow right\"\n    type=\"button\"\n    [attr.aria-label]=\"'BENTO_UI_TILE_RIBBON_SCROLL_RIGHT' | bentoTranslate\"\n    (click)=\"_onArrowClick(true)\"\n    [disabled]=\"disableRightArrow\"\n  >\n    <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n",
                providers: [BentoNotification, BentoTransition, WindowRef],
                encapsulation: ViewEncapsulation.None,
                host: { role: 'region' },
                styles: [".bui-bento-tile-ribbon{display:block;position:relative}.bui-bento-tile-ribbon.scroll .bento-tile-ribbon-arrow{display:block}.bui-bento-tile-ribbon.bento-tile-ribbon-hidden{padding:0}.bui-bento-tile-ribbon .bento-tile-ribbon-header{align-items:center;display:flex}.bui-bento-tile-ribbon .bento-tile-ribbon-header h1{display:inline-block;margin:0;padding:0}.bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-title{justify-content:space-between}.bui-bento-tile-ribbon .bento-tile-ribbon-header.btrh-collapse{justify-content:flex-end}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle{height:30px;line-height:30px;padding:0}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle i,.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle span{margin:0;text-decoration:none}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle i{margin-left:5px!important;margin-right:5px}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover{text-decoration:none}.bui-bento-tile-ribbon .bento-tile-ribbon-header .bento-tile-ribbon-visibility-toggle:hover span{text-decoration:underline}.bui-bento-tile-ribbon .bento-tile-ribbon-container{overflow:hidden;position:relative}.bui-bento-tile-ribbon .bento-tile-ribbon-container.hidden{height:0;margin-top:0}.bui-bento-tile-ribbon .bento-tile-ribbon-wrapper{overflow:hidden}.bui-bento-tile-ribbon .bento-tile-ribbon-inner{overflow-x:scroll;position:relative;transition:opacity .2s}.bui-bento-tile-ribbon .bento-tile-ribbon-inner:focus{outline:0}.bui-bento-tile-ribbon .bento-tile-ribbon-panel{align-items:stretch;display:flex}.bui-bento-tile-ribbon bento-ribbon-tile{display:block;flex-grow:1;position:relative}.bui-bento-tile-ribbon bento-ribbon-tile:after{background-color:transparent;bottom:0;content:\" \";display:block;height:4px;position:absolute;transition:background-color .2s}.bui-bento-tile-ribbon bento-ribbon-tile.selected{z-index:1}.bui-bento-tile-ribbon bento-ribbon-tile.selected .bento-ribbon-tile-inner{border-width:1px;border-style:solid}.bui-bento-tile-ribbon .bento-ribbon-tile-inner{border-width:1px;border-style:solid;min-height:100%;position:relative}.bui-bento-tile-ribbon .bento-ribbon-tile-value{cursor:default;flex-grow:2;font-size:2.857rem;letter-spacing:-1px;line-height:1em;overflow:hidden;text-overflow:ellipsis;transition:color .2s;white-space:nowrap}.bui-bento-tile-ribbon .bento-ribbon-tile-link{cursor:pointer;flex-shrink:4;font-size:.8em;margin-top:8px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.bui-bento-tile-ribbon .bento-ribbon-tile-indicator{flex-shrink:0;margin-right:5px}[dir=rtl] .bui-bento-tile-ribbon .bento-ribbon-tile-indicator{margin-right:0;margin-left:5px}.bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class*=\" bento-icon-\"],.bui-bento-tile-ribbon .bento-ribbon-tile-indicator [class^=bento-icon-]{vertical-align:baseline}.bui-bento-tile-ribbon .bento-ribbon-tile-value-wrapper{align-items:flex-start;display:flex;justify-content:space-between}.bui-bento-tile-ribbon .bento-ribbon-tile-header-wrapper{align-content:flex-start;align-items:center;display:flex}.bui-bento-tile-ribbon .bento-ribbon-tile-header{cursor:default;font-size:1.143rem;font-weight:700;letter-spacing:.5px;margin:0;overflow:hidden;padding:0;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.bui-bento-tile-ribbon .bento-ribbon-tile-header::first-letter{text-transform:uppercase}.bui-bento-tile-ribbon .bento-ribbon-tile-description{cursor:default;font-size:.857rem;letter-spacing:.3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bui-bento-tile-ribbon .bento-tile-ribbon-arrow{border:none;display:none;font-size:1.7em;height:100%;position:absolute;top:0;z-index:2}.bui-bento-tile-ribbon .bento-tile-ribbon-arrow.left{left:0}.bui-bento-tile-ribbon .bento-tile-ribbon-arrow.right{right:0}.bui-bento-tile-ribbon.alt{border-bottom-width:0;padding:0}.bui-bento-tile-ribbon.alt .bento-tile-ribbon-container{margin:0}.bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile{padding:0}.bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-right-width:0}[dir=rtl] .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:last-child .bento-ribbon-tile-inner{border-left-width:0;border-right-width:1px}.bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:0}[dir=rtl] .bui-bento-tile-ribbon.alt.scroll bento-ribbon-tile:first-child .bento-ribbon-tile-inner{border-left-width:1px;border-right-width:0}.bui-bento-tile-ribbon.alt .bento-tile-ribbon-header.btrh-hidden{display:none}.bui-bento-tile-ribbon.alt bento-ribbon-tile{padding:0}.bui-bento-tile-ribbon.alt bento-ribbon-tile:after{left:0;right:0}.bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:0}[dir=rtl] .bui-bento-tile-ribbon.alt bento-ribbon-tile:last-child .bento-ribbon-tile-inner{margin-right:-1px;margin-left:0}.bui-bento-tile-ribbon.alt .bento-tile-ribbon-arrow{border-width:1px;border-style:solid}.bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:-1px}[dir=rtl] .bui-bento-tile-ribbon.alt .bento-ribbon-tile-inner{margin-right:0;margin-left:-1px}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: WindowRef }, { type: BentoNotification }, { type: BentoTransition }, { type: ɵngcc6.Directionality }, { type: ɵngcc0.ElementRef }]; }, { showCollapseToggle: [{
            type: Input
        }], tileMinWidth: [{
            type: Input
        }], ribbonHidden: [{
            type: HostBinding,
            args: ['class.bento-tile-ribbon-hidden']
        }], bentoTileRibbonCSSClass: [{
            type: HostBinding,
            args: ['class.bui-bento-tile-ribbon']
        }], title: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }, {
            type: Input
        }], items: [{
            type: Input
        }], tileAriaLabel: [{
            type: Input
        }], tileTemplate: [{
            type: Input
        }], innerElRef: [{
            type: ViewChild,
            args: ['inner', { static: true }]
        }], panelElRef: [{
            type: ViewChild,
            args: ['panel', { static: true }]
        }] }); })();
    return BentoTileRibbonComponent;
}());
if (false) {
    /**
     * Get the title of this component and make the aria-label of the component match the title
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.title;
    /**
     * Get the tile item array
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.items;
    /**
     * Get the aria-labels for individual tiles.
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.tileAriaLabel;
    /**
     * Show / Hide collapse toggle button in default theme
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.showCollapseToggle;
    /**
     * Custom template reference for tiles.  Use `let-item="item"` attribute on `ngTemplate` to utilize the `BentoRibbonTile` object
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.tileTemplate;
    /**
     * Define tile minimum width
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.tileMinWidth;
    /**
     * Current item width
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.itemWidth;
    /**
     * Flag to determine if the left arrow is disabled
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.disableLeftArrow;
    /**
     * Flag to determine if the right arrow is disabled
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.disableRightArrow;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.isRtl;
    /**
     * Flag to determine if the ribbon is visible or not
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.ribbonHidden;
    /**
     * Unique class name to component to distinguish from Bento Modern Tile Ribbon
     * @type {?}
     */
    BentoTileRibbonComponent.prototype.bentoTileRibbonCSSClass;
    /**
     * Component inner container
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.innerElRef;
    /**
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.innerEl;
    /**
     * Component panel container inside of inner
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.panelElRef;
    /**
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.panelEL;
    /**
     * Keep track on the current item count
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.itemCount;
    /**
     * Main component HTMLElement variable
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.el;
    /**
     * Resize subscription
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.resizeSubscription;
    /**
     * Variable to keep previous check arrow timeout
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.checkArrowTimeout;
    /**
     * Currently selected tile
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.selectedTile;
    /**
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.windowRef;
    /**
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.bentoNotification;
    /**
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.transition;
    /**
     * @type {?}
     * @private
     */
    BentoTileRibbonComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tile-ribbon/ribbon-tile.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class to declare Bento Ribbon Tile object to be used with Tile Ribbon
 */
var BentoRibbonTile = /** @class */ (function () {
    function BentoRibbonTile(value, header, description, onTileSelect, linkTitle, onLinkClick, indicator, selected, ariaLabel) {
        if (value === void 0) { value = ''; }
        if (header === void 0) { header = ''; }
        if (onTileSelect === void 0) { onTileSelect = (/**
         * @param {?} tile
         * @return {?}
         */
        function (tile) { }); }
        if (onLinkClick === void 0) { onLinkClick = (/**
         * @param {?} tile
         * @return {?}
         */
        function (tile) { }); }
        if (selected === void 0) { selected = false; }
        this.selectionCallbacks = [];
        this.deselectionCallbacks = [];
        this.value = value;
        this.header = header;
        this.description = description;
        this.selectionCallbacks.push(onTileSelect);
        this.linkTitle = linkTitle;
        this.onLinkClick = onLinkClick;
        this.indicator = indicator;
        this._selected = selected;
        this.ariaLabel = ariaLabel;
    }
    Object.defineProperty(BentoRibbonTile.prototype, "selected", {
        /**
         * State to indicate that if this item is selected or not
         */
        get: /**
         * State to indicate that if this item is selected or not
         * @return {?}
         */
        function () {
            return this._selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set item as selected
     */
    /**
     * Set item as selected
     * @return {?}
     */
    BentoRibbonTile.prototype.select = /**
     * Set item as selected
     * @return {?}
     */
    function () {
        if (!this._selected) {
            this._selected = true;
            this.dispatchSelectionCallbacks();
        }
    };
    /**
     * Set item as deselected
     */
    /**
     * Set item as deselected
     * @return {?}
     */
    BentoRibbonTile.prototype.deselect = /**
     * Set item as deselected
     * @return {?}
     */
    function () {
        if (this._selected) {
            this._selected = false;
            this.dispatchDeselectionCallbacks();
        }
    };
    /**
     * Add a selection callback.  The returned function is used to remove the current callback
     */
    /**
     * Add a selection callback.  The returned function is used to remove the current callback
     * @param {?} c
     * @return {?}
     */
    BentoRibbonTile.prototype.addSelectionCallback = /**
     * Add a selection callback.  The returned function is used to remove the current callback
     * @param {?} c
     * @return {?}
     */
    function (c) {
        var _this = this;
        this.selectionCallbacks.push(c);
        return (/**
         * @return {?}
         */
        function () {
            // Callback to remove the assigned one
            /** @type {?} */
            var i = _this.selectionCallbacks.indexOf(c);
            _this.selectionCallbacks.splice(i, 1);
        });
    };
    /**
     * Add a deselection callback.  The returned function is used to remove the current callback
     */
    /**
     * Add a deselection callback.  The returned function is used to remove the current callback
     * @param {?} c
     * @return {?}
     */
    BentoRibbonTile.prototype.addDeselectionCallback = /**
     * Add a deselection callback.  The returned function is used to remove the current callback
     * @param {?} c
     * @return {?}
     */
    function (c) {
        var _this = this;
        this.deselectionCallbacks.push(c);
        return (/**
         * @return {?}
         */
        function () {
            // Callback to remove the assigned one
            /** @type {?} */
            var i = _this.deselectionCallbacks.indexOf(c);
            _this.deselectionCallbacks.splice(i, 1);
        });
    };
    /**
     * Dispatch selection callbacks
     */
    /**
     * Dispatch selection callbacks
     * @private
     * @return {?}
     */
    BentoRibbonTile.prototype.dispatchSelectionCallbacks = /**
     * Dispatch selection callbacks
     * @private
     * @return {?}
     */
    function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.selectionCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c(this);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Dispatch deselection callbacks
     */
    /**
     * Dispatch deselection callbacks
     * @private
     * @return {?}
     */
    BentoRibbonTile.prototype.dispatchDeselectionCallbacks = /**
     * Dispatch deselection callbacks
     * @private
     * @return {?}
     */
    function () {
        var e_2, _a;
        try {
            for (var _b = __values(this.deselectionCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c(this);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    /**
     * Success state of the indicator
     */
    BentoRibbonTile.SUCCESS = { icon: 'bento-icon-save-solid', class: 'bento-tile-success', i18nLabel: 'BENTO_UI_TILE_SUCCESS' };
    /**
     * Info state of the indicator
     */
    BentoRibbonTile.INFO = { icon: 'bento-icon-info-filled', class: 'bento-tile-info', i18nLabel: 'BENTO_UI_TILE_INFO' };
    /**
     * Danger state of the indicator
     */
    BentoRibbonTile.DANGER = { icon: 'bento-icon-danger-filled', class: 'bento-tile-danger', i18nLabel: 'BENTO_UI_TILE_DANGER' };
    /**
     * Warning state of the indicator
     */
    BentoRibbonTile.WARNING = { icon: 'bento-icon-warning-filled', class: 'bento-tile-warning', i18nLabel: 'BENTO_UI_TILE_WARNING' };
    return BentoRibbonTile;
}());
if (false) {
    /**
     * Success state of the indicator
     * @type {?}
     */
    BentoRibbonTile.SUCCESS;
    /**
     * Info state of the indicator
     * @type {?}
     */
    BentoRibbonTile.INFO;
    /**
     * Danger state of the indicator
     * @type {?}
     */
    BentoRibbonTile.DANGER;
    /**
     * Warning state of the indicator
     * @type {?}
     */
    BentoRibbonTile.WARNING;
    /**
     * Main value of this tile
     * @type {?}
     */
    BentoRibbonTile.prototype.value;
    /**
     * Header of this tile
     * @type {?}
     */
    BentoRibbonTile.prototype.header;
    /**
     * Description of this tile
     * @type {?}
     */
    BentoRibbonTile.prototype.description;
    /**
     * Indicator type of this tile
     * @type {?}
     */
    BentoRibbonTile.prototype.indicator;
    /**
     * Aria-Label text
     * @type {?}
     */
    BentoRibbonTile.prototype.ariaLabel;
    /**
     * Title of the link
     * @type {?}
     */
    BentoRibbonTile.prototype.linkTitle;
    /**
     * Method to call when tile link is clicked
     * @type {?}
     */
    BentoRibbonTile.prototype.onLinkClick;
    /**
     * @type {?}
     * @private
     */
    BentoRibbonTile.prototype._selected;
    /**
     * @type {?}
     * @private
     */
    BentoRibbonTile.prototype.selectionCallbacks;
    /**
     * @type {?}
     * @private
     */
    BentoRibbonTile.prototype.deselectionCallbacks;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tile-ribbon/ribbon-tile.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoRibbonTileComponent = /** @class */ (function () {
    function BentoRibbonTileComponent(r, elRef) {
        this.r = r;
        this.elRef = elRef;
        /**
         * When this tile is selected
         */
        this.select = new EventEmitter();
        this.r.addClass(this.elRef.nativeElement, 'bento-ribbon-tile');
    }
    Object.defineProperty(BentoRibbonTileComponent.prototype, "width", {
        /**
         * Set width of this tile
         */
        set: /**
         * Set width of this tile
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._styleWidth = v + "px";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoRibbonTileComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.r.setAttribute(this.elRef.nativeElement.querySelector('.bento-ribbon-tile-inner'), 'tabindex', '0');
        this.onItemSelect = this.onItemSelect.bind(this);
        this.removeSelectionCallback = this.item.addSelectionCallback(this.onItemSelect);
        this.onItemDeselect = this.onItemDeselect.bind(this);
        this.removeDeselectionCallback = this.item.addDeselectionCallback(this.onItemDeselect);
        if (this.item.selected) {
            // Highlight if the item is pre-selected
            setTimeout((/**
             * @return {?}
             */
            function () { return _this.onItemSelect(_this.item); }));
        }
    };
    /**
     * @return {?}
     */
    BentoRibbonTileComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.removeSelectionCallback();
        this.removeDeselectionCallback();
    };
    /**
     * Link click callback
     */
    /**
     * Link click callback
     * @param {?} e
     * @return {?}
     */
    BentoRibbonTileComponent.prototype._onLinkclick = /**
     * Link click callback
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.item.onLinkClick) {
            this.item.onLinkClick(this.item);
        }
        e.stopPropagation();
        e.preventDefault();
    };
    /**
     * Callback on host element is clicked
     */
    /**
     * Callback on host element is clicked
     * @return {?}
     */
    BentoRibbonTileComponent.prototype._onHostClick = /**
     * Callback on host element is clicked
     * @return {?}
     */
    function () {
        this.item.select();
    };
    /**
     * Callback when an element is selected
     */
    /**
     * Callback when an element is selected
     * @private
     * @param {?} item
     * @return {?}
     */
    BentoRibbonTileComponent.prototype.onItemSelect = /**
     * Callback when an element is selected
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this._selected = true;
        this.select.emit(this.item);
    };
    /**
     * Callback when an element is selected
     */
    /**
     * Callback when an element is selected
     * @private
     * @param {?} item
     * @return {?}
     */
    BentoRibbonTileComponent.prototype.onItemDeselect = /**
     * Callback when an element is selected
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this._selected = false;
    };
    /** @nocollapse */
    BentoRibbonTileComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    BentoRibbonTileComponent.propDecorators = {
        item: [{ type: Input }],
        width: [{ type: Input }],
        template: [{ type: Input }],
        select: [{ type: Output }],
        _styleWidth: [{ type: HostBinding, args: ['style.width',] }],
        _selected: [{ type: HostBinding, args: ['class.selected',] }],
        _onHostClick: [{ type: HostListener, args: ['click',] }]
    };
BentoRibbonTileComponent.ɵfac = function BentoRibbonTileComponent_Factory(t) { return new (t || BentoRibbonTileComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoRibbonTileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoRibbonTileComponent, selectors: [["bento-ribbon-tile"]], hostVars: 4, hostBindings: function BentoRibbonTileComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function BentoRibbonTileComponent_click_HostBindingHandler() { return ctx._onHostClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx._styleWidth);
        ɵngcc0.ɵɵclassProp("selected", ctx._selected);
    } }, inputs: { width: "width", item: "item", template: "template" }, outputs: { select: "select" }, decls: 4, vars: 3, consts: [[1, "bento-ribbon-tile-inner"], [3, "ngIf", "ngIfElse"], ["customTemplate", ""], [1, "bento-ribbon-tile-value-wrapper"], [1, "bento-ribbon-tile-value"], ["class", "bento-ribbon-tile-link", "tabindex", "0", 3, "click", 4, "ngIf"], [1, "bento-ribbon-tile-header-wrapper"], ["class", "bento-ribbon-tile-indicator", "aria-live", "polite", 3, "ngClass", 4, "ngIf"], [1, "bento-ribbon-tile-header"], ["class", "bento-ribbon-tile-description", 4, "ngIf"], ["tabindex", "0", 1, "bento-ribbon-tile-link", 3, "click"], ["aria-live", "polite", 1, "bento-ribbon-tile-indicator", 3, "ngClass"], [1, "bento-ribbon-tile-description"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function BentoRibbonTileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoRibbonTileComponent_ng_template_1_Template, 9, 5, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, BentoRibbonTileComponent_ng_template_2_Template, 1, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵattribute("title", ctx.item.value ? ctx.item.value : ctx.item.header ? ctx.item.header : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.template)("ngIfElse", _r1);
    } }, directives: [ɵngcc7.NgIf, ɵngcc7.NgClass, ɵngcc7.NgTemplateOutlet], pipes: [BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoRibbonTileComponent, [{
        type: Component,
        args: [{
                selector: 'bento-ribbon-tile',
                template: "<div class=\"bento-ribbon-tile-inner\" [attr.title]=\"item.value ? item.value : item.header ? item.header : null\">\n  <ng-template [ngIf]=\"!template\" [ngIfElse]=\"customTemplate\">\n    <div class=\"bento-ribbon-tile-value-wrapper\">\n      <div class=\"bento-ribbon-tile-value\">{{ item.value }}</div>\n      <a *ngIf=\"item.linkTitle\" (click)=\"_onLinkclick($event)\" class=\"bento-ribbon-tile-link\" tabindex=\"0\">\n        {{ item.linkTitle }}\n      </a>\n    </div>\n    <div class=\"bento-ribbon-tile-header-wrapper\">\n      <div\n        *ngIf=\"item.indicator\"\n        class=\"bento-ribbon-tile-indicator\"\n        [ngClass]=\"[item.indicator.icon, item.indicator.class]\"\n        aria-live=\"polite\"\n        [attr.aria-label]=\"item.ariaLabel || (item.indicator.i18nLabel | bentoTranslate)\"\n      ></div>\n      <p class=\"bento-ribbon-tile-header\">{{ item.header }}</p>\n    </div>\n    <div *ngIf=\"item.description\" class=\"bento-ribbon-tile-description\">{{ item.description }}</div>\n  </ng-template>\n</div>\n<ng-template #customTemplate>\n  <ng-container *ngTemplateOutlet=\"template; context: {item: item}\"></ng-container>\n</ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { select: [{
            type: Output
        }], width: [{
            type: Input
        }], _onHostClick: [{
            type: HostListener,
            args: ['click']
        }], _selected: [{
            type: HostBinding,
            args: ['class.selected']
        }], item: [{
            type: Input
        }], template: [{
            type: Input
        }], _styleWidth: [{
            type: HostBinding,
            args: ['style.width']
        }] }); })();
    return BentoRibbonTileComponent;
}());
if (false) {
    /**
     * Tile item
     * @type {?}
     */
    BentoRibbonTileComponent.prototype.item;
    /**
     * Template reference for custom templates
     * @type {?}
     */
    BentoRibbonTileComponent.prototype.template;
    /**
     * When this tile is selected
     * @type {?}
     */
    BentoRibbonTileComponent.prototype.select;
    /**
     * Set width style based on use input
     * @type {?}
     */
    BentoRibbonTileComponent.prototype._styleWidth;
    /**
     * Set selection class when selected
     * @type {?}
     */
    BentoRibbonTileComponent.prototype._selected;
    /**
     * To remove selection callback
     * @type {?}
     * @private
     */
    BentoRibbonTileComponent.prototype.removeSelectionCallback;
    /**
     * To remove deselection callback
     * @type {?}
     * @private
     */
    BentoRibbonTileComponent.prototype.removeDeselectionCallback;
    /**
     * @type {?}
     * @private
     */
    BentoRibbonTileComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoRibbonTileComponent.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tile-ribbon/tile-ribbon.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTileRibbonModule = /** @class */ (function () {
    function BentoTileRibbonModule() {
    }
BentoTileRibbonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTileRibbonModule });
BentoTileRibbonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTileRibbonModule_Factory(t) { return new (t || BentoTileRibbonModule)(); }, imports: [[CommonModule, BentoTranslateModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTileRibbonModule, { declarations: function () { return [BentoTileRibbonComponent,
        BentoRibbonTileComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule]; }, exports: function () { return [BentoTileRibbonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTileRibbonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, BentoTranslateModule],
                declarations: [BentoTileRibbonComponent, BentoRibbonTileComponent],
                exports: [BentoTileRibbonComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoTileRibbonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/timepicker/timepicker.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable directive-selector */
var BentoTimepickerDirective = /** @class */ (function () {
    function BentoTimepickerDirective(elRef, r, timepicker, direction, translate) {
        var _this = this;
        this.r = r;
        this.timepicker = timepicker;
        this.translate = translate;
        this.directionSubscription = Subscription.EMPTY;
        this.translationChangeSubscription = Subscription.EMPTY;
        /** @type {?} */
        var oldNgOnChanges = this.timepicker.ngOnChanges;
        /** @type {?} */
        var oldSetDisabledState = this.timepicker.setDisabledState;
        this.el = elRef.nativeElement;
        this.isRTL = direction.value === 'rtl';
        this.directionSubscription = direction.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRTL = direction.value === 'rtl';
        }));
        // Add Bento.UI main component class
        r.addClass(this.el, 'bento-timepicker');
        /**
         * Override `onOnChanges`
         */
        this.timepicker.ngOnChanges = (/**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            oldNgOnChanges.call(_this.timepicker, changes);
            if (changes.meridian) {
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.setupMeridianButton(changes.meridian.currentValue); }));
            }
            if (changes.seconds) {
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.setupSecondInput(changes.seconds.currentValue); }));
            }
        });
        /**
         * Override `setDisabledState`
         */
        this.timepicker.setDisabledState = (/**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            oldSetDisabledState.call(_this.timepicker, isDisabled);
            if (isDisabled) {
                _this.r.addClass(_this.el, 'disabled');
            }
            else {
                _this.r.removeClass(_this.el, 'disabled');
            }
        });
    }
    /**
     * NG OnInit lifecycle hook
     */
    /**
     * NG OnInit lifecycle hook
     * @return {?}
     */
    BentoTimepickerDirective.prototype.ngOnInit = /**
     * NG OnInit lifecycle hook
     * @return {?}
     */
    function () {
        // hide spinners
        this.timepicker.spinners = false;
    };
    /**
     * Implements after view init
     */
    /**
     * Implements after view init
     * @return {?}
     */
    BentoTimepickerDirective.prototype.ngAfterViewInit = /**
     * Implements after view init
     * @return {?}
     */
    function () {
        var _this = this;
        this.hourEl = (/** @type {?} */ (this.el.querySelector('.ngb-tp-hour input')));
        this.minuteEl = (/** @type {?} */ (this.el.querySelector('.ngb-tp-minute input')));
        this.fs = this.el.querySelector('fieldset');
        // A11y: attach a legendEl inside fieldset
        this.legendEl = this.r.createElement('legend');
        this.r.addClass(this.legendEl, 'sr-only');
        this.r.setProperty(this.legendEl, 'innerText', this.translate.instantTranslate('BENTO_UI_TIMEPICKER_LEGEND'));
        this.r.insertBefore(this.fs, this.legendEl, this.fs.firstChild);
        // We need fieldset to be focusable
        this.r.setAttribute(this.fs, 'tabindex', '-1');
        this.setupHourInput();
        this.setupMinuteInput();
        this.translationChangeSubscription = this.translate.translationChange.subscribe((/**
         * @return {?}
         */
        function () {
            return _this.r.setProperty(_this.legendEl, 'innerText', _this.translate.instantTranslate('BENTO_UI_TIMEPICKER_LEGEND'));
        }));
    };
    /**
     * Remove listeners
     */
    /**
     * Remove listeners
     * @return {?}
     */
    BentoTimepickerDirective.prototype.ngOnDestroy = /**
     * Remove listeners
     * @return {?}
     */
    function () {
        // Cancel all listeners
        this.cancelHourInputListener();
        this.cancelMinuteInputListener();
        this.directionSubscription.unsubscribe();
        if (this.cancelSecondInputListener) {
            this.cancelSecondInputListener();
        }
        if (this.cancelMeridianListner) {
            this.cancelMeridianListner();
        }
        this.translationChangeSubscription.unsubscribe();
    };
    /**
     * Handle focus event
     */
    /**
     * Handle focus event
     * @param {?} target
     * @param {?} relatedTarget
     * @return {?}
     */
    BentoTimepickerDirective.prototype.onHostFocusin = /**
     * Handle focus event
     * @param {?} target
     * @param {?} relatedTarget
     * @return {?}
     */
    function (target, relatedTarget) {
        if (!this.el.contains(relatedTarget)) {
            this.r.addClass(this.el, 'has-focus');
        }
        if (target === this.fs) {
            // Focused into field set but none of the form elements is gaining focus
            // Now we need to manually assign focus to the hour input
            this.hourEl.focus();
            this.hourEl.setSelectionRange(0, 2);
        }
    };
    /**
     * Handle blur event
     */
    /**
     * Handle blur event
     * @param {?} relatedTarget
     * @return {?}
     */
    BentoTimepickerDirective.prototype.onHostFocusout = /**
     * Handle blur event
     * @param {?} relatedTarget
     * @return {?}
     */
    function (relatedTarget) {
        if (!this.el.contains(relatedTarget)) {
            this.r.removeClass(this.el, 'has-focus');
        }
    };
    /**
     * Setup hour input field
     */
    /**
     * Setup hour input field
     * @private
     * @return {?}
     */
    BentoTimepickerDirective.prototype.setupHourInput = /**
     * Setup hour input field
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.cancelHourInputListener = this.r.listen(this.hourEl, 'keydown', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            /** @type {?} */
            var RIGHT = Keyboard.RIGHT;
            /** @type {?} */
            var LEFT = Keyboard.LEFT;
            switch (e.keyCode) {
                case RIGHT:
                    // tslint:disable-next-line no-bitwise
                    if ((_this.hourEl.selectionStart & _this.hourEl.selectionEnd) === 2) {
                        _this.minuteEl.focus();
                        _this.minuteEl.setSelectionRange(0, 2);
                        e.preventDefault();
                    }
                    break;
                case LEFT:
                    // Only happens in RTL
                    // tslint:disable-next-line no-bitwise
                    if (_this.isRTL && (_this.minuteEl.selectionStart | _this.minuteEl.selectionEnd) === 0 && _this.meridianButton) {
                        _this.meridianButton.focus();
                    }
                    break;
                default:
                    break;
            }
        }));
    };
    /**
     * Setup minute input field
     */
    /**
     * Setup minute input field
     * @private
     * @return {?}
     */
    BentoTimepickerDirective.prototype.setupMinuteInput = /**
     * Setup minute input field
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.cancelMinuteInputListener = this.r.listen(this.minuteEl, 'keydown', (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            /** @type {?} */
            var LEFT = Keyboard.LEFT;
            /** @type {?} */
            var RIGHT = Keyboard.RIGHT;
            switch (e.keyCode) {
                case LEFT:
                    // tslint:disable-next-line no-bitwise
                    if ((_this.minuteEl.selectionStart | _this.minuteEl.selectionEnd) === 0) {
                        _this.hourEl.focus();
                        _this.hourEl.setSelectionRange(0, 2);
                        e.preventDefault();
                    }
                    break;
                case RIGHT:
                    // tslint:disable-next-line no-bitwise
                    if ((_this.minuteEl.selectionStart & _this.minuteEl.selectionEnd) === 2) {
                        if (_this.secondEl) {
                            _this.secondEl.focus();
                            _this.secondEl.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        else if (_this.meridianButton) {
                            _this.meridianButton.focus();
                        }
                    }
                    break;
                default:
                    break;
            }
        }));
    };
    /**
     * Setup second button based on its time
     */
    /**
     * Setup second button based on its time
     * @private
     * @param {?} show
     * @return {?}
     */
    BentoTimepickerDirective.prototype.setupSecondInput = /**
     * Setup second button based on its time
     * @private
     * @param {?} show
     * @return {?}
     */
    function (show) {
        var _this = this;
        if (show) {
            this.secondEl = (/** @type {?} */ (this.el.querySelector('.ngb-tp-second input')));
            if (!this.timepicker.model.second) {
                this.timepicker.updateSecond('00');
            }
            this.cancelSecondInputListener = this.r.listen(this.secondEl, 'keydown', (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                /** @type {?} */
                var LEFT = Keyboard.LEFT;
                /** @type {?} */
                var RIGHT = Keyboard.RIGHT;
                switch (e.keyCode) {
                    case LEFT:
                        // Focus to the "left" input field
                        // tslint:disable-next-line no-bitwise
                        if ((_this.secondEl.selectionStart | _this.secondEl.selectionEnd) === 0) {
                            _this.minuteEl.focus();
                            _this.minuteEl.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        break;
                    case RIGHT:
                        if (!_this.isRTL && _this.meridianButton) {
                            // Only focus on meridian button in LTR mode
                            _this.meridianButton.focus();
                        }
                        break;
                    default:
                        break;
                }
            }));
        }
        else {
            this.cancelSecondInputListener();
            this.cancelSecondInputListener = undefined;
            this.secondEl = undefined;
        }
    };
    /**
     * Setup meridian button based on its showing flag
     */
    /**
     * Setup meridian button based on its showing flag
     * @private
     * @param {?} show
     * @return {?}
     */
    BentoTimepickerDirective.prototype.setupMeridianButton = /**
     * Setup meridian button based on its showing flag
     * @private
     * @param {?} show
     * @return {?}
     */
    function (show) {
        var _this = this;
        if (show) {
            this.meridianButton = (/** @type {?} */ (this.el.querySelector('.ngb-tp-meridian .btn')));
            this.cancelMeridianListner = this.r.listen(this.meridianButton, 'keydown', (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                /** @type {?} */
                var LEFT = Keyboard.LEFT;
                /** @type {?} */
                var RIGHT = Keyboard.RIGHT;
                switch (e.keyCode) {
                    case Keyboard.UP:
                    case Keyboard.DOWN:
                        // Toggle meridian button when up or down key is pressed
                        _this.meridianButton.click();
                        e.preventDefault();
                        break;
                    case LEFT:
                        if (!_this.isRTL) {
                            // Can only move focus to the left input in LTR mode
                            // Focus to the "left" input field
                            /** @type {?} */
                            var input = _this.secondEl ? _this.secondEl : _this.minuteEl;
                            input.focus();
                            input.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        break;
                    case RIGHT:
                        if (_this.isRTL) {
                            // Can only move focus to the left input in LTR mode
                            // Focus to the "hour" input field
                            _this.hourEl.focus();
                            _this.hourEl.setSelectionRange(0, 2);
                            e.preventDefault();
                        }
                        break;
                    default:
                        break;
                }
            }));
        }
        else {
            this.cancelMeridianListner();
            this.cancelMeridianListner = undefined;
            this.meridianButton = undefined;
        }
    };
    /** @nocollapse */
    BentoTimepickerDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: NgbTimepicker, decorators: [{ type: Inject, args: [NgbTimepicker,] }] },
        { type: Directionality },
        { type: BentoTranslate }
    ]; };
    BentoTimepickerDirective.propDecorators = {
        onHostFocusin: [{ type: HostListener, args: ['focusin', ['$event.target', '$event.relatedTarget'],] }],
        onHostFocusout: [{ type: HostListener, args: ['focusout', ['$event.relatedTarget'],] }]
    };
BentoTimepickerDirective.ɵfac = function BentoTimepickerDirective_Factory(t) { return new (t || BentoTimepickerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(NgbTimepicker), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(BentoTranslate)); };
BentoTimepickerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoTimepickerDirective, selectors: [["ngb-timepicker", "bentoTimepicker", ""]], hostBindings: function BentoTimepickerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function BentoTimepickerDirective_focusin_HostBindingHandler($event) { return ctx.onHostFocusin($event.target, $event.relatedTarget); })("focusout", function BentoTimepickerDirective_focusout_HostBindingHandler($event) { return ctx.onHostFocusout($event.relatedTarget); });
    } } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTimepickerDirective, [{
        type: Directive,
        args: [{ selector: 'ngb-timepicker[bentoTimepicker]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc4.NgbTimepicker, decorators: [{
                type: Inject,
                args: [NgbTimepicker]
            }] }, { type: ɵngcc6.Directionality }, { type: BentoTranslate }]; }, { onHostFocusin: [{
            type: HostListener,
            args: ['focusin', ['$event.target', '$event.relatedTarget']]
        }], onHostFocusout: [{
            type: HostListener,
            args: ['focusout', ['$event.relatedTarget']]
        }] }); })();
    return BentoTimepickerDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.fs;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.hourEl;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.minuteEl;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.secondEl;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.meridianButton;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.isRTL;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.legendEl;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.cancelMeridianListner;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.cancelSecondInputListener;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.cancelHourInputListener;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.cancelMinuteInputListener;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.directionSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.translationChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.timepicker;
    /**
     * @type {?}
     * @private
     */
    BentoTimepickerDirective.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/timepicker/timepicker.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTimepickerModule = /** @class */ (function () {
    function BentoTimepickerModule() {
    }
BentoTimepickerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTimepickerModule });
BentoTimepickerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTimepickerModule_Factory(t) { return new (t || BentoTimepickerModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTimepickerModule, { declarations: function () { return [BentoTimepickerDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BentoTimepickerDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTimepickerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [BentoTimepickerDirective],
                exports: [BentoTimepickerDirective]
            }]
    }], function () { return []; }, null); })();
    return BentoTimepickerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast/toast-animation.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToastAnimationDirective = /** @class */ (function () {
    function BentoToastAnimationDirective(elRef, r) {
        setTimeout((/**
         * @return {?}
         */
        function () {
            r.addClass(elRef.nativeElement, 'in');
        }), 18);
    }
    /** @nocollapse */
    BentoToastAnimationDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
BentoToastAnimationDirective.ɵfac = function BentoToastAnimationDirective_Factory(t) { return new (t || BentoToastAnimationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BentoToastAnimationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoToastAnimationDirective, selectors: [["", "toastAnimation", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToastAnimationDirective, [{
        type: Directive,
        args: [{ selector: '[toastAnimation]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return BentoToastAnimationDirective;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast/toast-container.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Container that is compiled and append as one of the child from the BODY tag
 */
var BentoToastContainerComponent = /** @class */ (function () {
    function BentoToastContainerComponent(changeDetector, r, elRef) {
        this.changeDetector = changeDetector;
        this.r = r;
        this.toasts = [];
        this.el = elRef.nativeElement;
    }
    /**
     * @return {?}
     */
    BentoToastContainerComponent.prototype.refresh = /**
     * @return {?}
     */
    function () {
        this.changeDetector.markForCheck();
    };
    /**
     * @return {?}
     */
    BentoToastContainerComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        while (this.toasts && this.toasts.length) {
            this.toasts.pop().dismiss();
        }
        this.toasts = null;
    };
    Object.defineProperty(BentoToastContainerComponent.prototype, "placement", {
        get: /**
         * @return {?}
         */
        function () {
            return this.toastPlacement;
        },
        set: /**
         * @param {?} p
         * @return {?}
         */
        function (p) {
            this.toastPlacement = p;
            this.r.removeAttribute(this.el, 'class');
            if (p) {
                this.r.addClass(this.el, this.toastPlacement);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Dismiss a toast
     */
    /**
     * Dismiss a toast
     * @param {?} toast
     * @param {?=} byAction
     * @return {?}
     */
    BentoToastContainerComponent.prototype.dismiss = /**
     * Dismiss a toast
     * @param {?} toast
     * @param {?=} byAction
     * @return {?}
     */
    function (toast, byAction) {
        if (byAction === void 0) { byAction = false; }
        if (this.toasts) {
            /** @type {?} */
            var index = this.toasts.indexOf(toast);
            if (index > -1) {
                this.toasts.splice(index, 1);
                if (byAction) {
                    toast.dismissByAction();
                }
                else {
                    toast.dismiss();
                }
            }
        }
    };
    /** @nocollapse */
    BentoToastContainerComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
BentoToastContainerComponent.ɵfac = function BentoToastContainerComponent_Factory(t) { return new (t || BentoToastContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoToastContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoToastContainerComponent, selectors: [["bento-toast-container"]], decls: 2, vars: 1, consts: [["cdkTrapFocus", "", "aria-live", "polite", "aria-atomic", "true", 1, "bento-toast-container-inner"], ["toastAnimation", "", "tabindex", "-1", 3, "autohide", "delay", "ngClass", "hide", 4, "ngFor", "ngForOf"], ["toastAnimation", "", "tabindex", "-1", 3, "autohide", "delay", "ngClass", "hide"], [4, "ngIf", "ngIfElse"], ["defaultMessage", ""], ["class", "bento-toast-action-btn", "type", "button", 3, "ngClass", "click", 4, "ngIf"], ["type", "button", "cdkMonitorElementFocus", "", "class", "close", 3, "click", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "innerHTML"], ["type", "button", 1, "bento-toast-action-btn", 3, "ngClass", "click"], [1, "btn-text"], ["type", "button", "cdkMonitorElementFocus", "", 1, "close", 3, "click"], ["aria-hidden", "true", 1, "bui-toast-close-indicator"]], template: function BentoToastContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoToastContainerComponent_ngb_toast_1_Template, 6, 7, "ngb-toast", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.toasts);
    } }, directives: [ɵngcc1.CdkTrapFocus, ɵngcc7.NgForOf, ɵngcc4.NgbToast, BentoToastAnimationDirective, ɵngcc7.NgClass, ɵngcc7.NgIf, ɵngcc7.NgTemplateOutlet, ɵngcc1.CdkMonitorFocus], pipes: [BentoTranslatePipe], styles: ["[_nghost-%COMP%]{display:block;position:fixed}[_nghost-%COMP%]   button.close[_ngcontent-%COMP%]{align-items:center;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;text-align:center;text-shadow:none;width:24px}[_nghost-%COMP%]   button.close[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:bento-icons;font-style:normal;top:0}"], changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToastContainerComponent, [{
        type: Component,
        args: [{
                selector: 'bento-toast-container',
                template: "<div class=\"bento-toast-container-inner\" cdkTrapFocus aria-live=\"polite\" aria-atomic=\"true\">\n  <ngb-toast\n    toastAnimation\n    *ngFor=\"let toast of toasts\"\n    [autohide]=\"toast.instance.config.duration !== 0\"\n    [delay]=\"toast.instance.config.duration || 5000\"\n    [ngClass]=\"'bento-toast-' + toast.instance.config.type\"\n    (hide)=\"dismiss(toast)\"\n    tabindex=\"-1\"\n  >\n    <div *ngIf=\"toast.instance.config.template; else defaultMessage\">\n      <ng-container *ngTemplateOutlet=\"toast.instance.config.template; context: {toast: toast.instance}\"></ng-container>\n    </div>\n    <ng-template #defaultMessage>\n      <span [innerHTML]=\"toast.instance.message\"></span>\n    </ng-template>\n    <button\n      *ngIf=\"toast.instance.hasAction\"\n      class=\"bento-toast-action-btn\"\n      type=\"button\"\n      [ngClass]=\"'btn btn-outline-' + (toast.instance.config.type ? toast.instance.config.type : 'primary')\"\n      (click)=\"dismiss(toast, true)\"\n    >\n      <span class=\"btn-text\">{{ toast.instance.config.action }}</span>\n    </button>\n    <button\n      *ngIf=\"toast.instance.showClose\"\n      type=\"button\"\n      cdkMonitorElementFocus\n      class=\"close\"\n      (click)=\"dismiss(toast)\"\n      [attr.aria-label]=\"'BENTO_UI_TOAST_CLOSE_BUTTON' | bentoTranslate\"\n    >\n      <i class=\"bui-toast-close-indicator\" aria-hidden=\"true\"></i>\n    </button>\n  </ngb-toast>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;position:fixed}:host button.close{align-items:center;display:flex;font-size:.8em;height:24px;justify-content:center;line-height:.8em;opacity:1;padding:0;text-align:center;text-shadow:none;width:24px}:host button.close i{font-family:bento-icons;font-style:normal;top:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, null); })();
    return BentoToastContainerComponent;
}());
if (false) {
    /** @type {?} */
    BentoToastContainerComponent.prototype.toasts;
    /** @type {?} */
    BentoToastContainerComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoToastContainerComponent.prototype.toastPlacement;
    /**
     * @type {?}
     * @private
     */
    BentoToastContainerComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoToastContainerComponent.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast/toast.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Toast data class
 */
var  /**
 * Toast data class
 */
BentoToast = /** @class */ (function () {
    function BentoToast(message, config) {
        if (config === void 0) { config = {}; }
        this.message = message;
        this.config = config;
        this.hasAction = config.action && config.action.length > 0;
        this.showClose = !this.hasAction && ((config.duration <= 0 && config.close == null) || config.close);
    }
    return BentoToast;
}());
if (false) {
    /**
     * Message of this toast
     * @type {?}
     */
    BentoToast.prototype.message;
    /**
     * Label of the action button
     * @type {?}
     */
    BentoToast.prototype.action;
    /**
     * Flag to determine if this toast has an action button or not
     * @type {?}
     */
    BentoToast.prototype.hasAction;
    /**
     * Flag to determine if this toast needs to show the close button or not
     * @type {?}
     */
    BentoToast.prototype.showClose;
    /**
     * Config of this toast
     * @type {?}
     */
    BentoToast.prototype.config;
    /**
     * Bento Toast Reference
     * @type {?}
     */
    BentoToast.prototype.toastRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast/toast-ref.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Reference to a BentoToast dispatched from the Bento Toast service
 * @template T
 */
var  /**
 * Reference to a BentoToast dispatched from the Bento Toast service
 * @template T
 */
BentoToastRef = /** @class */ (function () {
    function BentoToastRef(instance) {
        var _this = this;
        this.instance = instance;
        this.afterDismissed = Observable.create((/**
         * @param {?} observer
         * @return {?}
         */
        function (observer) { return (_this.afterDismissedSubscriber = observer); }));
        this.afterOpened = new BehaviorSubject(undefined);
        this.onAction = Observable.create((/**
         * @param {?} observer
         * @return {?}
         */
        function (observer) { return (_this.onActionSubscriber = observer); }));
    }
    /**
     * Marks the dismissal of the toast
     */
    /**
     * Marks the dismissal of the toast
     * @return {?}
     */
    BentoToastRef.prototype.dismiss = /**
     * Marks the dismissal of the toast
     * @return {?}
     */
    function () {
        if (this.afterDismissedSubscriber) {
            this.afterDismissedSubscriber.next({ dismissedByAction: false });
        }
    };
    /**
     * Marks the dismissal of the toast with the action button
     */
    /**
     * Marks the dismissal of the toast with the action button
     * @return {?}
     */
    BentoToastRef.prototype.dismissByAction = /**
     * Marks the dismissal of the toast with the action button
     * @return {?}
     */
    function () {
        if (this.onActionSubscriber) {
            this.onActionSubscriber.next();
        }
        if (this.afterDismissedSubscriber) {
            this.afterDismissedSubscriber.next({ dismissedByAction: true });
        }
    };
    return BentoToastRef;
}());
if (false) {
    /**
     * The instance of the component that makes up the toast
     * @type {?}
     */
    BentoToastRef.prototype.instance;
    /**
     * An observable that is notified when the toast is dismissed
     * @type {?}
     */
    BentoToastRef.prototype.afterDismissed;
    /**
     * An observable that is notified when the toast is opened
     * @type {?}
     */
    BentoToastRef.prototype.afterOpened;
    /**
     * An observable that is notified when the action button is clicked
     * @type {?}
     */
    BentoToastRef.prototype.onAction;
    /**
     * @type {?}
     * @private
     */
    BentoToastRef.prototype.afterDismissedSubscriber;
    /**
     * @type {?}
     * @private
     */
    BentoToastRef.prototype.onActionSubscriber;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast/toast.service.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToastService = /** @class */ (function () {
    function BentoToastService(injector, factoryResolver, appRef, winRef) {
        this.injector = injector;
        this.factoryResolver = factoryResolver;
        this.appRef = appRef;
        this._multiple = false;
        // Create and inject `bento-toast-container` component into the `<body>` tag
        this.document = winRef.nativeDocument;
        // Only create container once to avoid memory leak
        /** @type {?} */
        var containerFactory = this.factoryResolver.resolveComponentFactory(BentoToastContainerComponent);
        /** @type {?} */
        var toastContainerRef = containerFactory.create(this.injector);
        this.appRef.attachView(toastContainerRef.hostView);
        this.document.body.appendChild(toastContainerRef.location.nativeElement);
        this.toastContainer = toastContainerRef.instance;
    }
    Object.defineProperty(BentoToastService.prototype, "multiple", {
        get: /**
         * @return {?}
         */
        function () {
            return this._multiple;
        },
        /**
         * Flag to determine if we show multiple Toast UI components at a time
         */
        set: /**
         * Flag to determine if we show multiple Toast UI components at a time
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (this._multiple !== v) {
                this._multiple = v;
                if (!v && this.toastContainer.toasts.length > 1) {
                    this.toastContainer.toasts = [this.toastContainer.toasts[0]];
                }
                this.toastContainer.refresh();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoToastService.prototype, "placement", {
        get: /**
         * @return {?}
         */
        function () {
            return this.toastContainer.placement;
        },
        /**
         * This preferred placement of Toast components
         *
         * Possible values are:
         *
         * `"top"`, `"bottom"`, `"start"`, `"end"`, `"top-start"`, `"top-end"`, `"bottom-start"`, `"bottom-end"`
         */
        set: /**
         * This preferred placement of Toast components
         *
         * Possible values are:
         *
         * `"top"`, `"bottom"`, `"start"`, `"end"`, `"top-start"`, `"top-end"`, `"bottom-start"`, `"bottom-end"`
         * @param {?} p
         * @return {?}
         */
        function (p) {
            this.toastContainer.placement = p;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoToastService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.document.body.removeChild(this.toastContainer.el);
        this.toastContainer.ngOnDestroy();
    };
    /**
     * Open a new toast
     *
     * `message` can be either in plain text or html.  Javascript and misc scripts will be automatically filterred
     */
    /**
     * Open a new toast
     *
     * `message` can be either in plain text or html.  Javascript and misc scripts will be automatically filterred
     * @param {?} message
     * @param {?=} config
     * @return {?}
     */
    BentoToastService.prototype.open = /**
     * Open a new toast
     *
     * `message` can be either in plain text or html.  Javascript and misc scripts will be automatically filterred
     * @param {?} message
     * @param {?=} config
     * @return {?}
     */
    function (message, config) {
        var _this = this;
        /** @type {?} */
        var toast = new BentoToast(message, config);
        /** @type {?} */
        var toastRef = new BentoToastRef(toast);
        toast.toastRef = toastRef;
        if (this.multiple) {
            this.toastContainer.toasts.push(toastRef);
        }
        else {
            this.dismissAll();
            this.toastContainer.toasts = [toastRef];
        }
        this.toastContainer.refresh();
        setTimeout((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var toastElArr = _this.toastContainer.el.querySelectorAll('ngb-toast');
            /** @type {?} */
            var lastToastEl = (/** @type {?} */ (toastElArr.item(toastElArr.length - 1)));
            if (lastToastEl) {
                lastToastEl.focus();
            }
        }));
        return toastRef;
    };
    /**
     * Dismiss a given toast by its reference
     *
     * All toasts will be dismissed if none is provided in `multiple` mode
     */
    /**
     * Dismiss a given toast by its reference
     *
     * All toasts will be dismissed if none is provided in `multiple` mode
     * @param {?=} toastRef
     * @return {?}
     */
    BentoToastService.prototype.dismiss = /**
     * Dismiss a given toast by its reference
     *
     * All toasts will be dismissed if none is provided in `multiple` mode
     * @param {?=} toastRef
     * @return {?}
     */
    function (toastRef) {
        if (toastRef) {
            toastRef.dismiss();
            /** @type {?} */
            var toasts = this.toastContainer.toasts;
            /** @type {?} */
            var index = toasts.indexOf(toastRef);
            if (index > -1) {
                toasts.splice(index, 1);
            }
        }
        else {
            this.dismissAll();
            this.toastContainer.toasts = [];
        }
        this.toastContainer.refresh();
    };
    /**
     * Mark all current toasts as dismiss
     */
    /**
     * Mark all current toasts as dismiss
     * @private
     * @return {?}
     */
    BentoToastService.prototype.dismissAll = /**
     * Mark all current toasts as dismiss
     * @private
     * @return {?}
     */
    function () {
        var e_1, _a;
        if (Array.isArray(this.toastContainer.toasts) && this.toastContainer.toasts.length) {
            try {
                for (var _b = __values(this.toastContainer.toasts), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var oldToastRef = _c.value;
                    // Need to fire dimiss events before disgarding them
                    oldToastRef.dismiss();
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    /** @nocollapse */
    BentoToastService.ctorParameters = function () { return [
        { type: Injector },
        { type: ComponentFactoryResolver },
        { type: ApplicationRef },
        { type: WindowRef }
    ]; };
    /** @nocollapse */ BentoToastService.ɵprov = ɵɵdefineInjectable({ factory: function BentoToastService_Factory() { return new BentoToastService(ɵɵinject(INJECTOR), ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(WindowRef)); }, token: BentoToastService, providedIn: "root" });
BentoToastService.ɵfac = function BentoToastService_Factory(t) { return new (t || BentoToastService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(WindowRef)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToastService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: WindowRef }]; }, null); })();
    return BentoToastService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoToastService.prototype._multiple;
    /**
     * @type {?}
     * @private
     */
    BentoToastService.prototype.toastContainer;
    /**
     * @type {?}
     * @private
     */
    BentoToastService.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoToastService.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    BentoToastService.prototype.factoryResolver;
    /**
     * @type {?}
     * @private
     */
    BentoToastService.prototype.appRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toast/toast.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToastModule = /** @class */ (function () {
    function BentoToastModule() {
    }
BentoToastModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoToastModule });
BentoToastModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoToastModule_Factory(t) { return new (t || BentoToastModule)(); }, providers: [BentoToastService, WindowRef], imports: [[CommonModule, BentoTranslateModule, A11yModule, NgbToastModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoToastModule, { declarations: function () { return [BentoToastContainerComponent,
        BentoToastAnimationDirective]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        A11yModule, NgbToastModule]; }, exports: function () { return [BentoToastContainerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToastModule, [{
        type: NgModule,
        args: [{
                declarations: [BentoToastContainerComponent, BentoToastAnimationDirective],
                imports: [CommonModule, BentoTranslateModule, A11yModule, NgbToastModule],
                exports: [BentoToastContainerComponent],
                providers: [BentoToastService, WindowRef],
                entryComponents: [BentoToastContainerComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoToastModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toggle/toggle.config.injectable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToggleConfig = /** @class */ (function () {
    function BentoToggleConfig() {
    }
    Object.defineProperty(BentoToggleConfig.prototype, "showLabels", {
        /**
         * Flag to show On/Off labels globally
         */
        get: /**
         * Flag to show On/Off labels globally
         * @return {?}
         */
        function () {
            return BentoToggleConfig._showLabels;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            /** @type {?} */
            var vType = typeof v;
            if (vType === 'boolean' && v !== BentoToggleConfig._showLabels) {
                BentoToggleConfig._showLabels = v;
                this.showLabelsChange.emit(v);
            }
            else {
                throw new Error("BentoToggleConfig: Invalid type " + vType + ", must be `boolean`");
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoToggleConfig.prototype, "showLabelsChange", {
        /**
         * Event emitter when variable `showLabels` changes
         */
        get: /**
         * Event emitter when variable `showLabels` changes
         * @return {?}
         */
        function () {
            if (BentoToggleConfig._onChange == null) {
                BentoToggleConfig._onChange = new EventEmitter();
            }
            return BentoToggleConfig._onChange;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Flag to determine whether to show labels
     */
    BentoToggleConfig._showLabels = false;
    /**
     * Event emitter when `showLabels` variable changes
     */
    BentoToggleConfig._onChange = null;
    /** @nocollapse */ BentoToggleConfig.ɵprov = ɵɵdefineInjectable({ factory: function BentoToggleConfig_Factory() { return new BentoToggleConfig(); }, token: BentoToggleConfig, providedIn: "root" });
BentoToggleConfig.ɵfac = function BentoToggleConfig_Factory(t) { return new (t || BentoToggleConfig)(); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToggleConfig, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();
    return BentoToggleConfig;
}());
if (false) {
    /**
     * Flag to determine whether to show labels
     * @type {?}
     * @private
     */
    BentoToggleConfig._showLabels;
    /**
     * Event emitter when `showLabels` variable changes
     * @type {?}
     * @private
     */
    BentoToggleConfig._onChange;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toggle/toggle.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BENTO_TOGGLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return BentoToggleComponent; })),
    multi: true
};
/**
 * A toggle component to switch between two states of a variable.
 */
var BentoToggleComponent = /** @class */ (function () {
    function BentoToggleComponent(elementRef, r, focusMonitor, changeDetector, pointerService, config, windowRef) {
        this.elementRef = elementRef;
        this.r = r;
        this.focusMonitor = focusMonitor;
        this.changeDetector = changeDetector;
        this.pointerService = pointerService;
        this.config = config;
        /**
         * Flag to lock the current state
         */
        this.readOnly = false;
        this.disabled = false;
        this.tabindex = '0';
        // The internal data model
        this._value = false;
        this.showLabelChangeSub = Subscription.EMPTY;
        this.nobMoveListenerCancel = (/**
         * @return {?}
         */
        function () { });
        this.nobUpListenerCancel = (/**
         * @return {?}
         */
        function () { });
        this.dirChangeSub = Subscription.EMPTY;
        this.el = (/** @type {?} */ (elementRef.nativeElement));
        r.addClass(this.el, 'bento-toggle');
        r.addClass(this.el, 'bui-menu-item');
        r.setAttribute(this.el, 'role', 'switch');
        focusMonitor.monitor(elementRef);
        this.document = windowRef.nativeDocument;
        this._onTouchedCallback = (/**
         * @return {?}
         */
        function () { });
        this._onChangeCallback = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
    }
    /**
     * @return {?}
     */
    BentoToggleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (typeof this.showLabels !== 'boolean') {
            // Only use global config when `showLabels` input is not
            // manually set for this instance
            this.showLabels = this.config.showLabels;
            this.showLabelChangeSub = this.config.showLabelsChange.subscribe((/**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                _this.showLabels = v;
                _this.changeDetector.markForCheck();
            }));
        }
        this.initNob();
    };
    /**
     * Implements ControlValueAccessor
     */
    /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    BentoToggleComponent.prototype.registerOnChange = /**
     * Implements ControlValueAccessor
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * From ControlValueAccessor interface
     */
    /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    BentoToggleComponent.prototype.registerOnTouched = /**
     * From ControlValueAccessor interface
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this._onTouchedCallback = (/**
         * @return {?}
         */
        function () {
            fn();
            _this.changeDetector.markForCheck();
        });
    };
    /**
     * NgModel setter
     */
    /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    BentoToggleComponent.prototype.writeValue = /**
     * NgModel setter
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this._value = v;
        this.changeDetector.markForCheck();
    };
    /**
     * Set Disabled state for ngModel
     */
    /**
     * Set Disabled state for ngModel
     * @param {?} isDisabled
     * @return {?}
     */
    BentoToggleComponent.prototype.setDisabledState = /**
     * Set Disabled state for ngModel
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.disabled = isDisabled;
        this.tabindex = isDisabled ? '-1' : '0';
        this.changeDetector.markForCheck();
    };
    Object.defineProperty(BentoToggleComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._value;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._value = v;
            this.changeDetector.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * On Use Keyboard down
     */
    /**
     * On Use Keyboard down
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype.onKeydown = /**
     * On Use Keyboard down
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.keyCode === Keyboard.ENTER || e.keyCode === Keyboard.SPACE) {
            this.toggle(e);
        }
    };
    /**
     * When an user clicks the toggle
     */
    /**
     * When an user clicks the toggle
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype._onToggleClick = /**
     * When an user clicks the toggle
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!this.isMoved) {
            this.toggle(e);
        }
        else {
            // The whole click event is finished
            // reset private flag
            this.isMoved = false;
        }
    };
    /**
     * When an user touches the toggle
     */
    /**
     * When an user touches the toggle
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype._onToggleTouchStart = /**
     * When an user touches the toggle
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!this.isMoved) {
            this.toggle(e);
        }
    };
    /**
     * When user leaves this component
     */
    /**
     * When user leaves this component
     * @return {?}
     */
    BentoToggleComponent.prototype._onToggleFocusout = /**
     * When user leaves this component
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            if (!_this.el.contains(_this.document.activeElement)) {
                _this._onTouchedCallback();
            }
        }));
    };
    /**
     * @return {?}
     */
    BentoToggleComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var cbEl = this.el.querySelector('input[type="checkbox"]');
        // Move id to the checkbox element
        if (this.el.hasAttribute('id')) {
            this.r.setAttribute(cbEl, 'id', this.el.getAttribute('id'));
            this.el.removeAttribute('id');
        }
    };
    /**
     * @return {?}
     */
    BentoToggleComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.focusMonitor.stopMonitoring(this.elementRef);
        this.showLabelChangeSub.unsubscribe();
        this.dirChangeSub.unsubscribe();
        this.changeDetector.detach();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    BentoToggleComponent.prototype.onCheckboxChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        if (!this.disabled) {
            this.el.focus();
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype.onCheckboxClick = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.readOnly || this.disabled || this.lockToState === this._value) {
            // prevent label clicking or direct component toggling when either
            // readonly, disabled or its value is at the locked state
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    };
    /**
     * Initialize nob interaction
     */
    /**
     * Initialize nob interaction
     * @private
     * @return {?}
     */
    BentoToggleComponent.prototype.initNob = /**
     * Initialize nob interaction
     * @private
     * @return {?}
     */
    function () {
        this.nobEl = this.el.querySelector('.bento-toggle-nob');
        this.pointerService.listenPointerDown(this.r, this.nobEl, this.onNobDown.bind(this));
    };
    /**
     * Listener when Nob is down
     */
    /**
     * Listener when Nob is down
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype.onNobDown = /**
     * Listener when Nob is down
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.isMoved = false;
        this.r.addClass(this.el, 'dragging');
        this.nobIsOnLeft = this.nobEl.offsetLeft <= 0;
        /** @type {?} */
        var elRect = this.el.getBoundingClientRect();
        this.elMidPoint = (elRect.right + elRect.left) * 0.5;
        this.nobMoveListenerCancel = this.pointerService.listenPointerMove(this.r, 'document', this.onNobMove.bind(this));
        this.nobUpListenerCancel = this.pointerService.listenPointerUp(this.r, 'document', this.onNobUp.bind(this));
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype.onNobUp = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.r.removeClass(this.el, 'dragging');
        this.nobMoveListenerCancel();
        this.nobUpListenerCancel();
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype.onNobMove = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        /** @type {?} */
        var pointerX = this.pointerService.getPointerXY(e).x;
        if ((this.nobIsOnLeft && pointerX > this.elMidPoint) || (!this.nobIsOnLeft && pointerX < this.elMidPoint)) {
            this.nobIsOnLeft = !this.nobIsOnLeft;
            this.toggle(e);
            setTimeout((/**
             * @return {?}
             */
            function () {
                // need to get the midpoint after rendering
                // in case the user is still dragging
                /** @type {?} */
                var elRect = _this.el.getBoundingClientRect();
                _this.elMidPoint = (elRect.right + elRect.left) * 0.5;
            }));
        }
        this.isMoved = true;
        e.preventDefault();
        e.stopPropagation();
    };
    /**
     * The actual toggle method that takes an either click or touch event
     */
    /**
     * The actual toggle method that takes an either click or touch event
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoToggleComponent.prototype.toggle = /**
     * The actual toggle method that takes an either click or touch event
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.readOnly || this.lockToState === this._value || this.disabled) {
            return;
        }
        /** @type {?} */
        var v = !this._value;
        this.writeValue(v);
        this._onChangeCallback(v);
        e.preventDefault();
        e.stopPropagation();
    };
    /** @nocollapse */
    BentoToggleComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: FocusMonitor },
        { type: ChangeDetectorRef },
        { type: BentoPointerService },
        { type: BentoToggleConfig },
        { type: WindowRef }
    ]; };
    BentoToggleComponent.propDecorators = {
        readOnly: [{ type: HostBinding, args: ['class.readonly',] }, { type: HostBinding, args: ['attr.aria-readonly',] }, { type: Input }],
        lockToState: [{ type: Input }],
        disabled: [{ type: HostBinding, args: ['class.disabled',] }, { type: HostBinding, args: ['attr.aria-disabled',] }],
        tabindex: [{ type: HostBinding, args: ['attr.tabindex',] }],
        showLabels: [{ type: Input }, { type: HostBinding, args: ['class.bento-toggle-show-labels',] }],
        value: [{ type: HostBinding, args: ['class.on',] }, { type: HostBinding, args: ['attr.aria-checked',] }],
        onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
        _onToggleClick: [{ type: HostListener, args: ['click', ['$event'],] }],
        _onToggleTouchStart: [{ type: HostListener, args: ['touchstart', ['$event'],] }],
        _onToggleFocusout: [{ type: HostListener, args: ['focusout',] }]
    };
BentoToggleComponent.ɵfac = function BentoToggleComponent_Factory(t) { return new (t || BentoToggleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FocusMonitor), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(BentoPointerService), ɵngcc0.ɵɵdirectiveInject(BentoToggleConfig), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoToggleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoToggleComponent, selectors: [["bento-toggle"]], hostVars: 12, hostBindings: function BentoToggleComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function BentoToggleComponent_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); })("click", function BentoToggleComponent_click_HostBindingHandler($event) { return ctx._onToggleClick($event); })("touchstart", function BentoToggleComponent_touchstart_HostBindingHandler($event) { return ctx._onToggleTouchStart($event); })("focusout", function BentoToggleComponent_focusout_HostBindingHandler() { return ctx._onToggleFocusout(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-readonly", ctx.readOnly)("aria-disabled", ctx.disabled)("tabindex", ctx.tabindex)("aria-checked", ctx.value);
        ɵngcc0.ɵɵclassProp("readonly", ctx.readOnly)("disabled", ctx.disabled)("bento-toggle-show-labels", ctx.showLabels)("on", ctx.value);
    } }, inputs: { readOnly: "readOnly", showLabels: "showLabels", lockToState: "lockToState" }, features: [ɵngcc0.ɵɵProvidersFeature([BENTO_TOGGLE_VALUE_ACCESSOR])], decls: 3, vars: 2, consts: [[1, "bento-toggle-a11y-labels"], [1, "bento-toggle-nob"], ["aria-hidden", "true", "tabindex", "-1", "type", "checkbox", 3, "ngModel", "disabled", "ngModelChange", "click"]], template: function BentoToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function BentoToggleComponent_Template_input_ngModelChange_2_listener($event) { return ctx.onCheckboxChange($event); })("click", function BentoToggleComponent_Template_input_click_2_listener($event) { return ctx.onCheckboxClick($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("disabled", ctx.disabled);
    } }, directives: [ɵngcc8.CheckboxControlValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.NgModel], styles: ["bento-toggle,bento-toggle.dropdown-item{display:inline-block;position:relative;box-sizing:border-box;vertical-align:middle;border-width:1px;border-style:solid;cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:border-color .1s,box-shadow .3s,background-color .2s}bento-toggle input[type=checkbox],bento-toggle.dropdown-item input[type=checkbox]{width:1px;height:1px;opacity:0;pointer-events:none}bento-toggle .bento-toggle-nob,bento-toggle.dropdown-item .bento-toggle-nob{position:absolute;border-width:1px;border-style:solid;top:-1px;left:-1px;transition:.2s}[dir=rtl] bento-toggle .bento-toggle-nob,[dir=rtl] bento-toggle.dropdown-item .bento-toggle-nob{left:auto;right:-1px}bento-toggle.dropdown-item.on,bento-toggle.on{transition:border-color .1s .2s,box-shadow .1s,background-color .5s .2s}[dir=rtl] bento-toggle.dropdown-item.on .bento-toggle-nob,[dir=rtl] bento-toggle.on .bento-toggle-nob{left:auto}bento-toggle.dropdown-item:focus,bento-toggle:focus{outline:0}bento-toggle.disabled,bento-toggle.dropdown-item.disabled,bento-toggle.dropdown-item.readonly,bento-toggle.readonly{opacity:.8;cursor:default;pointer-events:none}bento-toggle.disabled,bento-toggle.dropdown-item.disabled{opacity:.5}bento-toggle.skin-dot,bento-toggle.skin-dot.dropdown-item{vertical-align:middle;transition:.1s}bento-toggle.skin-dot .bento-toggle-nob,bento-toggle.skin-dot.dropdown-item .bento-toggle-nob{display:none}.bento-toggle-a11y-labels{display:none;position:absolute;width:100%;height:100%;top:0;left:0}.bento-toggle-show-labels .bento-toggle-a11y-labels{display:block}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToggleComponent, [{
        type: Component,
        args: [{
                selector: 'bento-toggle',
                template: "<div class=\"bento-toggle-a11y-labels\"></div>\n<div class=\"bento-toggle-nob\"></div>\n<input\n  aria-hidden=\"true\"\n  [ngModel]=\"value\"\n  (ngModelChange)=\"onCheckboxChange($event)\"\n  tabindex=\"-1\"\n  type=\"checkbox\"\n  [disabled]=\"disabled\"\n  (click)=\"onCheckboxClick($event)\"\n/>\n",
                providers: [BENTO_TOGGLE_VALUE_ACCESSOR],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-toggle,bento-toggle.dropdown-item{display:inline-block;position:relative;box-sizing:border-box;vertical-align:middle;border-width:1px;border-style:solid;cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:border-color .1s,box-shadow .3s,background-color .2s}bento-toggle input[type=checkbox],bento-toggle.dropdown-item input[type=checkbox]{width:1px;height:1px;opacity:0;pointer-events:none}bento-toggle .bento-toggle-nob,bento-toggle.dropdown-item .bento-toggle-nob{position:absolute;border-width:1px;border-style:solid;top:-1px;left:-1px;transition:.2s}[dir=rtl] bento-toggle .bento-toggle-nob,[dir=rtl] bento-toggle.dropdown-item .bento-toggle-nob{left:auto;right:-1px}bento-toggle.dropdown-item.on,bento-toggle.on{transition:border-color .1s .2s,box-shadow .1s,background-color .5s .2s}[dir=rtl] bento-toggle.dropdown-item.on .bento-toggle-nob,[dir=rtl] bento-toggle.on .bento-toggle-nob{left:auto}bento-toggle.dropdown-item:focus,bento-toggle:focus{outline:0}bento-toggle.disabled,bento-toggle.dropdown-item.disabled,bento-toggle.dropdown-item.readonly,bento-toggle.readonly{opacity:.8;cursor:default;pointer-events:none}bento-toggle.disabled,bento-toggle.dropdown-item.disabled{opacity:.5}bento-toggle.skin-dot,bento-toggle.skin-dot.dropdown-item{vertical-align:middle;transition:.1s}bento-toggle.skin-dot .bento-toggle-nob,bento-toggle.skin-dot.dropdown-item .bento-toggle-nob{display:none}.bento-toggle-a11y-labels{display:none;position:absolute;width:100%;height:100%;top:0;left:0}.bento-toggle-show-labels .bento-toggle-a11y-labels{display:block}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.FocusMonitor }, { type: ɵngcc0.ChangeDetectorRef }, { type: BentoPointerService }, { type: BentoToggleConfig }, { type: WindowRef }]; }, { readOnly: [{
            type: HostBinding,
            args: ['class.readonly']
        }, {
            type: HostBinding,
            args: ['attr.aria-readonly']
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }, {
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], tabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], showLabels: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.bento-toggle-show-labels']
        }], value: [{
            type: HostBinding,
            args: ['class.on']
        }, {
            type: HostBinding,
            args: ['attr.aria-checked']
        }], onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], _onToggleClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], _onToggleTouchStart: [{
            type: HostListener,
            args: ['touchstart', ['$event']]
        }], _onToggleFocusout: [{
            type: HostListener,
            args: ['focusout']
        }], lockToState: [{
            type: Input
        }] }); })();
    return BentoToggleComponent;
}());
if (false) {
    /**
     * Flag to lock the current state
     * @type {?}
     */
    BentoToggleComponent.prototype.readOnly;
    /**
     * Permanently lock to a state when toggled. When toggled to the state
     * specified, the user will be unable to change it. Alternatively, the toggle
     * may be locked into a specified state from its initial value.
     * @type {?}
     */
    BentoToggleComponent.prototype.lockToState;
    /** @type {?} */
    BentoToggleComponent.prototype.disabled;
    /** @type {?} */
    BentoToggleComponent.prototype.tabindex;
    /**
     * Flag to determine if we need to show the On/Off labels for a11y.
     * Setting this property **ingores** the global `BentoToggleConfig.showLabels` value
     * @type {?}
     */
    BentoToggleComponent.prototype.showLabels;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype._onTouchedCallback;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype._onChangeCallback;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype._value;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.showLabelChangeSub;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.nobEl;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.nobMoveListenerCancel;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.nobUpListenerCancel;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.dirChangeSub;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.isMoved;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.nobIsOnLeft;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.elMidPoint;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.focusMonitor;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.changeDetector;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.pointerService;
    /**
     * @type {?}
     * @private
     */
    BentoToggleComponent.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toggle/toggle.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToggleModule = /** @class */ (function () {
    function BentoToggleModule() {
    }
BentoToggleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoToggleModule });
BentoToggleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoToggleModule_Factory(t) { return new (t || BentoToggleModule)(); }, providers: [BentoToggleConfig], imports: [[CommonModule, FormsModule, BentoUtilsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoToggleModule, { declarations: function () { return [BentoToggleComponent]; }, imports: function () { return [CommonModule, FormsModule,
        BentoUtilsModule]; }, exports: function () { return [BentoToggleComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToggleModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, BentoUtilsModule],
                declarations: [BentoToggleComponent],
                exports: [BentoToggleComponent],
                providers: [BentoToggleConfig]
            }]
    }], function () { return []; }, null); })();
    return BentoToggleModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toolbar/toolbar-dropdown.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToolbarDropdownComponent = /** @class */ (function () {
    function BentoToolbarDropdownComponent(uidGen) {
        this.isOpen = false;
        this.closeMore = new EventEmitter();
        this.uniqueID = uidGen.generate();
    }
    Object.defineProperty(BentoToolbarDropdownComponent.prototype, "button", {
        set: /**
         * @param {?} button
         * @return {?}
         */
        function (button) {
            this.toolbarbutton = button;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} button
     * @return {?}
     */
    BentoToolbarDropdownComponent.prototype.toggle = /**
     * @param {?} button
     * @return {?}
     */
    function (button) {
        if (!button.disabled) {
            this.isOpen = !this.isOpen;
        }
    };
    /**
     * @param {?} subBtn
     * @return {?}
     */
    BentoToolbarDropdownComponent.prototype.clickAction = /**
     * @param {?} subBtn
     * @return {?}
     */
    function (subBtn) {
        subBtn.action();
        this.closeMore.emit({});
    };
    /** @nocollapse */
    BentoToolbarDropdownComponent.ctorParameters = function () { return [
        { type: BentoUidService }
    ]; };
    BentoToolbarDropdownComponent.propDecorators = {
        button: [{ type: Input }],
        closeMore: [{ type: Output }]
    };
BentoToolbarDropdownComponent.ɵfac = function BentoToolbarDropdownComponent_Factory(t) { return new (t || BentoToolbarDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoToolbarDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoToolbarDropdownComponent, selectors: [["", "bentoToolbarDropdown", ""]], inputs: { button: "button" }, outputs: { closeMore: "closeMore" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoUidService])], attrs: _c61, ngContentSelectors: _c4, decls: 6, vars: 10, consts: [["cdkMonitorElementFocus", "", "type", "button", "aria-haspopup", "true", 1, "toolbar-dropdown-toggle", 3, "disabled", "ngClass", "id", "click"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["bentoSmartBadge", "", 1, "smart-badge-host", 3, "details"], [3, "innerHTML"], ["role", "menu", 1, "toolbar-dropdown-menu", 3, "ngClass"], ["role", "none", 4, "ngFor", "ngForOf"], ["aria-hidden", "true"], ["role", "none"], ["class", "divider", "role", "separator", 4, "ngIf"], [4, "ngIf"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", "class", "smart-badge-host btn-toolbar", 3, "ngClass", "disabled", "active", "details", 4, "ngIf"], ["cdkMonitorElementFocus", "", "type", "button", "class", "btn-toolbar", 3, "ngClass", "disabled", "click", 4, "ngIf"], ["role", "separator", 1, "divider"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", 1, "smart-badge-host", "btn-toolbar", 3, "ngClass", "details"], ["cdkMonitorElementFocus", "", "type", "button", 1, "btn-toolbar", 3, "ngClass", "disabled", "click"]], template: function BentoToolbarDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function BentoToolbarDropdownComponent_Template_button_click_0_listener() { return ctx.toggle(ctx.toolbarbutton); });
        ɵngcc0.ɵɵtemplate(1, BentoToolbarDropdownComponent_i_1_Template, 1, 2, "i", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵtemplate(5, BentoToolbarDropdownComponent_li_5_Template, 5, 4, "li", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate1("id", "toggle-button-", ctx.uniqueID, "");
        ɵngcc0.ɵɵproperty("disabled", ctx.toolbarbutton.disabled)("ngClass", (ctx.toolbarbutton.disabled ? "disabled " : "") + (ctx.isOpen ? "open " : ""));
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.toolbarbutton.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("details", ctx.toolbarbutton.smartbadge);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.toolbarbutton.label, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isOpen ? "open " : "");
        ɵngcc0.ɵɵattribute("aria-labelledby", "toggle-button-" + ctx.uniqueID);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.toolbarbutton.dropdown);
    } }, directives: [ɵngcc1.CdkMonitorFocus, ɵngcc7.NgClass, ɵngcc7.NgIf, BentoSmartBadgeComponent, ɵngcc7.NgForOf, ɵngcc7.NgTemplateOutlet, BentoFocusMonitorDirective], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToolbarDropdownComponent, [{
        type: Component,
        args: [{
                selector: '[bentoToolbarDropdown]',
                template: "<button\n  cdkMonitorElementFocus\n  type=\"button\"\n  class=\"toolbar-dropdown-toggle\"\n  (click)=\"toggle(toolbarbutton)\"\n  [disabled]=\"toolbarbutton.disabled\"\n  [ngClass]=\"(toolbarbutton.disabled ? 'disabled ' : '') + (isOpen ? 'open ' : '')\"\n  aria-haspopup=\"true\"\n  [attr.aria-expanded]=\"isOpen\"\n  id=\"toggle-button-{{ uniqueID }}\"\n>\n  <i *ngIf=\"toolbarbutton.icon\" [class]=\"toolbarbutton.icon\" aria-hidden=\"true\"></i>\n  <span bentoSmartBadge [details]=\"toolbarbutton.smartbadge\" class=\"smart-badge-host\">\n    <span [innerHTML]=\"toolbarbutton.label\"></span>\n  </span>\n  <!-- <span [innerHTML]=\"toolbarbutton.label\"></span> -->\n</button>\n<ul\n  class=\"toolbar-dropdown-menu\"\n  [ngClass]=\"isOpen ? 'open ' : ''\"\n  role=\"menu\"\n  [attr.aria-labelledby]=\"'toggle-button-' + uniqueID\"\n>\n  <li role=\"none\" *ngFor=\"let subBtn of toolbarbutton.dropdown\">\n    <span *ngIf=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n    <ng-container *ngIf=\"subBtn.templateRef\">\n      <ng-content *ngTemplateOutlet=\"subBtn.templateRef; context: {control: subBtn.control}\"></ng-content>\n    </ng-container>\n    <a\n      *ngIf=\"subBtn.anchor\"\n      cdkMonitorElementFocus\n      [ngClass]=\"subBtn.class || subBtn.cssClass\"\n      [attr.href]=\"subBtn.disabled ? null : subBtn.anchor.href\"\n      [attr.target]=\"subBtn.anchor.target\"\n      [class.disabled]=\"subBtn.disabled\"\n      [class.active]=\"subBtn.active\"\n      [attr.id]=\"subBtn.id ? subBtn.id : null\"\n      bentoSmartBadge\n      [details]=\"subBtn.smartbadge\"\n      class=\"smart-badge-host btn-toolbar\"\n    >\n      <span [innerHTML]=\"subBtn.anchor.text || subBtn.label\"></span>\n    </a>\n    <button\n      cdkMonitorElementFocus\n      *ngIf=\"!subBtn.anchor && !subBtn.templateRef\"\n      type=\"button\"\n      (click)=\"clickAction(subBtn)\"\n      [ngClass]=\"subBtn.disabled ? 'disabled ' : ''\"\n      [disabled]=\"subBtn.disabled\"\n      class=\"btn-toolbar\"\n    >\n      <i *ngIf=\"subBtn.icon\" [class]=\"subBtn.icon\" aria-hidden=\"true\"></i>\n      <span bentoSmartBadge [details]=\"subBtn.smartbadge\" class=\"smart-badge-host\">\n        <span [innerHTML]=\"subBtn.label\"></span>\n      </span>\n      <!-- <span [innerHTML]=\"subBtn.label\"></span> -->\n    </button>\n  </li>\n</ul>\n",
                providers: [BentoUidService]
            }]
    }], function () { return [{ type: BentoUidService }]; }, { closeMore: [{
            type: Output
        }], button: [{
            type: Input
        }] }); })();
    return BentoToolbarDropdownComponent;
}());
if (false) {
    /** @type {?} */
    BentoToolbarDropdownComponent.prototype.isOpen;
    /** @type {?} */
    BentoToolbarDropdownComponent.prototype.toolbarbutton;
    /** @type {?} */
    BentoToolbarDropdownComponent.prototype.uniqueID;
    /** @type {?} */
    BentoToolbarDropdownComponent.prototype.closeMore;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toolbar/toolbar-item.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToolbarItemDirective = /** @class */ (function () {
    function BentoToolbarItemDirective(elRef, winRef, r) {
        this.r = r;
        this._nativeElement = elRef.nativeElement;
        this.window = winRef.nativeWindow;
    }
    /**
     * @return {?}
     */
    BentoToolbarItemDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        if (this._nativeElement) {
            this.refresh();
        }
    };
    /**
     * @return {?}
     */
    BentoToolbarItemDirective.prototype.refresh = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var width = this._getTotalWidth(this._nativeElement);
        this.r.setAttribute(this._nativeElement, 'data-button-width', String(width));
    };
    /**
     * @private
     * @param {?} el
     * @return {?}
     */
    BentoToolbarItemDirective.prototype._getTotalWidth = /**
     * @private
     * @param {?} el
     * @return {?}
     */
    function (el) {
        if (!el || !this.window.getComputedStyle) {
            return;
        }
        /** @type {?} */
        var style = this.window.getComputedStyle(el);
        return (Math.ceil(el.offsetWidth) +
            parseFloat(style.paddingLeft) +
            parseFloat(style.paddingRight) +
            parseFloat(style.marginLeft !== 'auto' ? style.marginLeft : 0) +
            parseFloat(style.marginRight !== 'auto' ? style.marginRight : 0));
    };
    /** @nocollapse */
    BentoToolbarItemDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: WindowRef },
        { type: Renderer2 }
    ]; };
BentoToolbarItemDirective.ɵfac = function BentoToolbarItemDirective_Factory(t) { return new (t || BentoToolbarItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BentoToolbarItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoToolbarItemDirective, selectors: [["", "bentoToolbarItem", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToolbarItemDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoToolbarItem]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return BentoToolbarItemDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoToolbarItemDirective.prototype._nativeElement;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarItemDirective.prototype.window;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarItemDirective.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toolbar/toolbar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var toolbarID = 0;
/**
 * Toolbar takes inspiration from the
 * [Bootstrap Navbar](https://getbootstrap.com/docs/4.0/components/navbar/), but
 * take pains to go beyond that to include responsive behaviors, as well as
 * ARIA roles as we work toward WCAG 2.0 Level AA (Accessibility) conformance.
 *
 * If you are using toolbar within a tabset or another hidden content area,
 * please note that you will need to call the `refresh` method to let the toolbar
 * know to resize itself when it's in view. See the
 * [Toolbars in Tabset](#/components/toolbar#tabs) demo for an example of this.
 *
 * As noted above, the toolbar is responsive and allows the content in the
 * `navbar-nav` element to collapse into a "More" dropdown. The `navbar-nav`
 * element will be generated by the directive with the `items` data
 * model. You can also add transcluded content such as a `navbar-right` element
 * to the toolbar directive. However, this content will be excluded from the
 * responsive behavior.
 */
var BentoToolbarComponent = /** @class */ (function () {
    /**
     * Constructor: set up resize notification
     */
    function BentoToolbarComponent(elRef, bentoNotification, r, dir, _changeDetector) {
        var _this = this;
        this.elRef = elRef;
        this.r = r;
        this._changeDetector = _changeDetector;
        /**
         * Array of data to populate toolbar
         */
        this.items = [];
        this.isGlobalSubnav = false;
        this.moreAvailable = true;
        this.moreVisible = false;
        this.moreIsLast = false;
        this.moreIsOpen = false;
        this.uniqueID = "bui-toolbar-" + toolbarID++;
        this._staticWidth = 0;
        this.dirChangeSubscription = Subscription.EMPTY;
        this.nativeElement = elRef.nativeElement;
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._adjustButtons(); }));
        this.isRTL = dir.value === 'rtl';
        this.dirChangeSubscription = dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRTL = dir.value === 'rtl';
            if (_this.openedDropdown) {
                _this.alignDropdownMenu(_this.openedDropdown);
            }
        }));
    }
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with display:none;
     */
    /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with display:none;
     * @return {?}
     */
    BentoToolbarComponent.prototype.refresh = /**
     * Call this method to refesh toolbar when it's displayed after it's been hidden with display:none;
     * @return {?}
     */
    function () {
        var _this = this;
        // setTimeout to initiate toolbar data
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._initToolbarData();
            // setTimeout again to set toolbar data
            // before calling initToolbar and adjustButtons
            setTimeout((/**
             * @return {?}
             */
            function () {
                if (_this.toolbarDirectives) {
                    _this.toolbarDirectives.forEach((/**
                     * @param {?} item
                     * @return {?}
                     */
                    function (item) {
                        item.refresh();
                    }));
                }
                _this._initToolbar();
                _this._adjustButtons();
            }));
        }));
    };
    /**
     * @return {?}
     */
    BentoToolbarComponent.prototype.closeMoreDropdown = /**
     * @return {?}
     */
    function () {
        this.moreIsOpen = false;
    };
    /**
     * @return {?}
     */
    BentoToolbarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._initToolbarData();
    };
    /**
     * @return {?}
     */
    BentoToolbarComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._initToolbar();
            _this._adjustButtons();
            if (_this.nativeElement.classList.contains('global-subnav')) {
                _this.isGlobalSubnav = true;
                /* Global subnav w/ role="navigation" should include a label to provide insight to consumer on what the navigation is for. */
                if (!_this.nativeElement.hasAttribute('aria-label') && !_this.nativeElement.hasAttribute('aria-labelledby')) {
                    /** @type {?} */
                    var errorString = "#globalSubnav must have either 'aria-labelledby' or 'aria-label'\n           attribute to to distinguish it from other navigation regions.\n            'aria-labelledby' specifies the ID of another element in the DOM as an element's accessible name.\n            'aria-label' specifies a text string to be used as the accessible name.\n            See label areas link for more details. https://www.w3.org/TR/wai-aria-practices-1.1/#aria_lh_step3";
                    console.warn(errorString);
                }
                // Move aria-label to the Nav element.
                /** @type {?} */
                var navElement = _this.nativeElement.querySelector('nav');
                if (navElement) {
                    /** @type {?} */
                    var ariaLabel = _this.nativeElement.getAttribute('aria-label');
                    _this.nativeElement.removeAttribute('aria-label');
                    _this.r.setAttribute(navElement, 'aria-label', ariaLabel);
                }
            }
            else {
                _this.r.setAttribute(_this.nativeElement, 'role', 'toolbar');
            }
        }));
    };
    /**
     * @return {?}
     */
    BentoToolbarComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    BentoToolbarComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._resizeSubscription.unsubscribe();
        this.dirChangeSubscription.unsubscribe();
    };
    /**
     * @param {?} i
     * @param {?} isOpen
     * @param {?} dropdown
     * @return {?}
     */
    BentoToolbarComponent.prototype.onDropdownOpenChange = /**
     * @param {?} i
     * @param {?} isOpen
     * @param {?} dropdown
     * @return {?}
     */
    function (i, isOpen, dropdown) {
        if (isOpen) {
            this.openedDropdown = dropdown;
            this.dropdowns.forEach((/**
             * @param {?} d
             * @return {?}
             */
            function (d) {
                // Check if dropdown element is same as the
                // one that trigger it. Close all other dropdowns
                // except the dropdown that just opened.
                if (d !== dropdown) {
                    d.close();
                }
            }));
            this.alignDropdownMenu(dropdown);
        }
        else {
            this.openedDropdown = null;
        }
    };
    /**
     * @private
     * @param {?} dropdown
     * @return {?}
     */
    BentoToolbarComponent.prototype.alignDropdownMenu = /**
     * @private
     * @param {?} dropdown
     * @return {?}
     */
    function (dropdown) {
        var _this = this;
        /** @type {?} */
        var menuEl = dropdown['_menu'].nativeElement;
        /** @type {?} */
        var toolbarWidth = this._getElementWidth();
        this.r.setStyle(menuEl, 'max-width', toolbarWidth + "px");
        this.r.removeStyle(menuEl, 'left');
        this.r.removeStyle(menuEl, 'right');
        this.r.setStyle(menuEl, 'visibility', "hidden");
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.r.setStyle(menuEl, 'visibility', "visible");
        }));
    };
    /**
     * [_getElementWidth return the width of the element]
     */
    /**
     * [_getElementWidth return the width of the element]
     * @private
     * @return {?}
     */
    BentoToolbarComponent.prototype._getElementWidth = /**
     * [_getElementWidth return the width of the element]
     * @private
     * @return {?}
     */
    function () {
        if (this.nativeElement) {
            return this.nativeElement.offsetWidth;
        }
        else {
            return 0;
        }
    };
    /**
     * [_initToolbarData - called during ngOnInit, sets visible and transparent property to items]
     */
    /**
     * [_initToolbarData - called during ngOnInit, sets visible and transparent property to items]
     * @private
     * @return {?}
     */
    BentoToolbarComponent.prototype._initToolbarData = /**
     * [_initToolbarData - called during ngOnInit, sets visible and transparent property to items]
     * @private
     * @return {?}
     */
    function () {
        this.moreVisible = false;
        if (!this.items || this.items.length === 0) {
            this.moreAvailable = false;
            return;
        }
        this.items.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            item.isVisible = true; // property to display item in main toolbar or more toolbar
            item.isTransparent = true; // property used to set opacity of toolbar item (to mediate FOUC)
            return item;
        }));
        this.moreAvailable = true;
        this._changeDetector.detectChanges();
    };
    /**
     * [_initToolbar - called during ngAfterView init. Grabs width of each item]
     */
    /**
     * [_initToolbar - called during ngAfterView init. Grabs width of each item]
     * @private
     * @return {?}
     */
    BentoToolbarComponent.prototype._initToolbar = /**
     * [_initToolbar - called during ngAfterView init. Grabs width of each item]
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.nativeElement || !this.items || this.items.length === 0) {
            return;
        }
        /** @type {?} */
        var navbarElement = (/** @type {?} */ (this.nativeElement.querySelector('ul.nav.navbar-nav')));
        if (this.toolbarDirectives) {
            this.toolbarDirectives.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                // item.refresh();
            }));
        }
        /** @type {?} */
        var navbarChildren = navbarElement.children;
        this.items.map((/**
         * @param {?} item
         * @param {?} index
         * @return {?}
         */
        function (item, index) {
            if (navbarChildren[index]) {
                item.width = navbarChildren[index].getAttribute('data-button-width');
                // keep track of static buttons width (buttons that won't merge into 'more' button)
                /** @type {?} */
                var isStatic = !!item.static || !!item.megamenu;
                if (isStatic) {
                    _this._staticWidth += +item.width;
                }
            }
            return item;
        }));
        this._changeDetector.detectChanges();
    };
    /**
     * [_adjustButtons - handler for onResize event, calculates whether item should be displayed in main toolbar or more
     * dropdown]
     */
    /**
     * [_adjustButtons - handler for onResize event, calculates whether item should be displayed in main toolbar or more
     * dropdown]
     * @private
     * @return {?}
     */
    BentoToolbarComponent.prototype._adjustButtons = /**
     * [_adjustButtons - handler for onResize event, calculates whether item should be displayed in main toolbar or more
     * dropdown]
     * @private
     * @return {?}
     */
    function () {
        if (!this.nativeElement || !this.items || this.items.length === 0) {
            return;
        }
        /** @type {?} */
        var totalWidth = 0;
        /** @type {?} */
        var elWidth = this._getElementWidth();
        /** @type {?} */
        var navBarHeader = (/** @type {?} */ (this.nativeElement.querySelector('.navbar-header')));
        /** @type {?} */
        var navBarLeft = (/** @type {?} */ (this.nativeElement.querySelector('.navbar-left')));
        /** @type {?} */
        var navBarRight = (/** @type {?} */ (this.nativeElement.querySelector('.navbar-right')));
        /** @type {?} */
        var navBarRightWidth = navBarRight ? +navBarRight.offsetWidth : 0;
        /** @type {?} */
        var navBarLeftWidth = navBarLeft ? +navBarLeft.offsetWidth : 0;
        /** @type {?} */
        var moreElement = (/** @type {?} */ (this.nativeElement.querySelector('.more-button')));
        /** @type {?} */
        var moreWidth = moreElement ? moreElement.offsetWidth : 100;
        /** @type {?} */
        var pad = 10;
        navBarLeftWidth += navBarHeader ? +navBarHeader.offsetWidth : 0;
        if (this.items) {
            /** @type {?} */
            var itemsInMainWidth = 0;
            /** @type {?} */
            var i = void 0;
            /** @type {?} */
            var il = this.items.length;
            // get static width
            /** @type {?} */
            var tempItem = void 0;
            for (i = 0; i < il; i++) {
                /** @type {?} */
                var td = (/** @type {?} */ (this.items[i]));
                // if hidden property is set to true,
                // do not add to cumulative width
                if (td.hidden) {
                    continue;
                }
                /** @type {?} */
                var isStatic = !!td.static || !!td.megamenu;
                // add button button width to total accumulative width
                // if it's not static (static width tally is already accounted for)
                if (!isStatic) {
                    totalWidth += +td.width;
                }
                /** @type {?} */
                var cumulativeWidth = totalWidth + moreWidth + pad + this._staticWidth + navBarLeftWidth + navBarRightWidth;
                /** @type {?} */
                var totalElementWidth = elWidth;
                // if items width accumulation is less than total width, show, otherwise hide
                if (cumulativeWidth < totalElementWidth) {
                    td.isVisible = true;
                    td.isTransparent = false;
                    itemsInMainWidth = cumulativeWidth;
                }
                else {
                    td.isVisible = false;
                    td.isTransparent = true;
                }
                // if item is static or megamenu, keep visible at all times in main menu
                if (isStatic) {
                    td.isVisible = true;
                    td.isTransparent = false;
                }
            }
            // more button is always true, unless the last button visibility is true.
            this.moreAvailable = true;
            tempItem = (/** @type {?} */ (this.items[il - 1]));
            if (tempItem.isVisible === true) {
                if (totalWidth + pad + navBarRightWidth + navBarLeftWidth < elWidth) {
                    this.moreAvailable = false;
                }
            }
            // decide whether to align 'more' dropdown menu to the right or left depending on space
            this.moreIsLast = false;
            if (itemsInMainWidth > 300) {
                this.moreIsLast = true;
            }
        }
        if (this.openedDropdown) {
            this.alignDropdownMenu(this.openedDropdown);
        }
        this.moreVisible = true;
        this._changeDetector.detectChanges();
    };
    /** @nocollapse */
    BentoToolbarComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoNotification },
        { type: Renderer2 },
        { type: Directionality },
        { type: ChangeDetectorRef }
    ]; };
    BentoToolbarComponent.propDecorators = {
        toolbarDirectives: [{ type: ViewChildren, args: [BentoToolbarItemDirective,] }],
        dropdowns: [{ type: ViewChildren, args: [NgbDropdown,] }],
        moreText: [{ type: Input }],
        items: [{ type: Input }]
    };
BentoToolbarComponent.ɵfac = function BentoToolbarComponent_Factory(t) { return new (t || BentoToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoToolbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoToolbarComponent, selectors: [["bento-toolbar"]], viewQuery: function BentoToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoToolbarItemDirective, true);
        ɵngcc0.ɵɵviewQuery(NgbDropdown, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toolbarDirectives = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdowns = _t);
    } }, inputs: { items: "items", moreText: "moreText" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], ngContentSelectors: _c64, decls: 9, vars: 5, consts: [[1, "nav", "navbar-nav"], ["bentoToolbarItem", "", 4, "ngFor", "ngForOf"], ["bentoToolbarItem", "", "class", "more-button", "data-more-buttons", "true", 3, "visible", 4, "ngIf"], [1, "clearfix"], ["bentoToolbarItem", ""], [4, "ngIf"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", "class", "smart-badge-host btn-toolbar", 3, "ngClass", "disabled", "active", "details", 4, "ngIf"], ["cdkMonitorElementFocus", "", "routerLinkActive", "router-link-active", "bentoSmartBadge", "", "class", "smart-badge-host btn-toolbar", 3, "ngClass", "routerLink", "queryParams", "fragment", "disabled", "active", "details", 4, "ngIf"], ["cdkMonitorElementFocus", "", "type", "button", "class", "btn-toolbar", 3, "ngClass", "disabled", "active", "click", 4, "ngIf"], ["ngbDropdown", "", "display", "static", "class", "dropdown", 3, "id", "placement", "megamenu-dropdown", "openChange", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", 1, "smart-badge-host", "btn-toolbar", 3, "ngClass", "details"], [3, "innerHTML"], ["cdkMonitorElementFocus", "", "routerLinkActive", "router-link-active", "bentoSmartBadge", "", 1, "smart-badge-host", "btn-toolbar", 3, "ngClass", "routerLink", "queryParams", "fragment", "details"], ["cdkMonitorElementFocus", "", "type", "button", 1, "btn-toolbar", 3, "ngClass", "disabled", "click"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["bentoSmartBadge", "", 1, "smart-badge-host", 3, "details"], ["aria-hidden", "true"], ["ngbDropdown", "", "display", "static", 1, "dropdown", 3, "id", "placement", "openChange"], ["dropdown", "ngbDropdown"], ["cdkMonitorElementFocus", "", "ngbDropdownToggle", "", "type", "button", 1, "btn-toolbar", 3, "ngClass", "disabled", "click"], ["ngbDropdownMenu", "", "class", "dropdown-menu", 3, "ngClass", "id", 4, "ngIf"], ["alignment", "bottom", "hTagRank", "3", 3, "bentoAppendTo", "autoVerticalAlignment", "autoHideOnContainerScroll", "autoRealign", "items", "type", "maxWidth", "ngClass", "flowColumnWidth", "widthElRef", 4, "ngIf"], ["ngbDropdownMenu", "", 1, "dropdown-menu", 3, "ngClass", "id"], ["ngbDropdownItem", "", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", ""], ["class", "divider", "role", "separator", 4, "ngIf"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", "class", "smart-badge-host", 3, "ngClass", "disabled", "active", "details", 4, "ngIf"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", "class", "smart-badge-host", 3, "ngClass", "routerLink", "queryParams", "fragment", "disabled", "active", "details", 4, "ngIf"], ["cdkMonitorElementFocus", "", "type", "button", 3, "ngClass", "disabled", "click", 4, "ngIf"], ["role", "separator", 1, "divider"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", 1, "smart-badge-host", 3, "ngClass", "details"], ["cdkMonitorElementFocus", "", "bentoSmartBadge", "", 1, "smart-badge-host", 3, "ngClass", "routerLink", "queryParams", "fragment", "details"], ["cdkMonitorElementFocus", "", "type", "button", 3, "ngClass", "disabled", "click"], ["alignment", "bottom", "hTagRank", "3", 3, "bentoAppendTo", "autoVerticalAlignment", "autoHideOnContainerScroll", "autoRealign", "items", "type", "maxWidth", "ngClass", "flowColumnWidth", "widthElRef"], ["bentoToolbarItem", "", "data-more-buttons", "true", 1, "more-button"], ["ngbDropdown", "", "display", "static", "placement", "bottom", 1, "dropdown", 3, "id", "autoClose", "open", "openChange"], ["moreDropdown", "ngbDropdown"], ["cdkMonitorElementFocus", "", "ngbDropdownToggle", "", "type", "button", 1, "btn-toolbar", 3, "id", "click"], ["ngbDropdownMenu", "", 1, "dropdown-menu", 3, "ngClass"], ["cdkMonitorElementFocus", "", "type", "button", 3, "ngClass", "disabled", "active", "click", 4, "ngIf"], ["bentoToolbarDropdown", "", "class", "toolbar-dropdown dropdown", 3, "button", "closeMore", 4, "ngIf"], ["bentoToolbarDropdown", "", 1, "toolbar-dropdown", "dropdown", 3, "button", "closeMore"]], template: function BentoToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c63);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵprojection(1, 1);
        ɵngcc0.ɵɵelementStart(2, "nav");
        ɵngcc0.ɵɵelementStart(3, "ul", 0);
        ɵngcc0.ɵɵtemplate(4, BentoToolbarComponent_li_4_Template, 6, 5, "li", 1);
        ɵngcc0.ɵɵpipe(5, "bentoToolbarFilter");
        ɵngcc0.ɵɵtemplate(6, BentoToolbarComponent_li_6_Template, 10, 16, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(7, 2);
        ɵngcc0.ɵɵelement(8, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(5, 2, ctx.items, true));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.moreAvailable);
    } }, directives: function () { return [ɵngcc7.NgForOf, ɵngcc7.NgIf, BentoToolbarItemDirective, ɵngcc7.NgTemplateOutlet, BentoFocusMonitorDirective, ɵngcc1.CdkMonitorFocus, BentoSmartBadgeComponent, ɵngcc7.NgClass, ɵngcc10.RouterLinkWithHref, ɵngcc10.RouterLinkActive, ɵngcc4.NgbDropdown, ɵngcc4.NgbDropdownToggle, ɵngcc4.NgbDropdownMenu, BentoNgbDropdownAnimationDirective, ɵngcc4.NgbDropdownItem, BentoMegamenuComponent,
        BentoNgbDropdownAppendToDirective,
        BentoAppendToDirective,
        BentoToolbarDropdownComponent]; }, pipes: function () { return [BentoToolbarFilterPipe,
        BentoTranslatePipe]; }, styles: [".bui-bento-toolbar,bento-toolbar{border-style:solid;border-width:1px}.bui-bento-toolbar .bento-smart-badge,bento-toolbar .bento-smart-badge{position:relative;left:auto;right:auto;vertical-align:super;display:inline-block;bottom:4px;line-height:10px}.bui-bento-toolbar .navbar-nav,bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.bui-bento-toolbar .navbar-nav>li.transparent,bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,bento-toolbar .navbar-nav>li.transparent{opacity:0;height:1px}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav>li>a,.bui-bento-toolbar .navbar-nav>li>button,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav>li>a,bento-toolbar .navbar-nav>li>button{border:none;background:0 0;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav>li>a:focus,.bui-bento-toolbar .navbar-nav>li>button:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav>li>a:focus,bento-toolbar .navbar-nav>li>button:focus{outline:0}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,bento-toolbar .navbar-nav>li a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav>li a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.bui-bento-toolbar .divider,bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.bui-bento-toolbar .navbar-nav .dropdown-toggle span,bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.bui-bento-toolbar .navbar-nav .dropdown-toggle:after,bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .bui-bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.bui-bento-toolbar [ngbdropdown],bento-toolbar [ngbdropdown]{display:block;position:relative}.bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.bui-bento-toolbar [ngbdropdown] .dropdown-menu,bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu:after,.bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,bento-toolbar [ngbdropdown] .dropdown-menu:after,bento-toolbar [ngbdropdown] .dropdown-menu:before{content:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button,bento-toolbar [ngbdropdown] .dropdown-menu a,bento-toolbar [ngbdropdown] .dropdown-menu button{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-]{vertical-align:middle}[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu button{text-align:right;padding:0 15px 0 30px}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused{outline:0;border-width:1px;border-style:dashed}.bui-bento-toolbar [ngbdropdown] a.disabled:hover,.bui-bento-toolbar [ngbdropdown] a:disabled:hover,.bui-bento-toolbar [ngbdropdown] a[disabled]:hover,.bui-bento-toolbar [ngbdropdown] button.disabled:hover,.bui-bento-toolbar [ngbdropdown] button:disabled:hover,.bui-bento-toolbar [ngbdropdown] button[disabled]:hover,bento-toolbar [ngbdropdown] a.disabled:hover,bento-toolbar [ngbdropdown] a:disabled:hover,bento-toolbar [ngbdropdown] a[disabled]:hover,bento-toolbar [ngbdropdown] button.disabled:hover,bento-toolbar [ngbdropdown] button:disabled:hover,bento-toolbar [ngbdropdown] button[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown,bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.bui-bento-toolbar .open.toolbar-dropdown-menu,bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.bui-bento-toolbar .more-button,bento-toolbar .more-button{visibility:hidden}.bui-bento-toolbar .more-button.visible,bento-toolbar .more-button.visible{visibility:visible}.bui-bento-toolbar .toolbar-dropdown-toggle:after,bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .bui-bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled],bento-toolbar .toolbar-dropdown-toggle.disabled,bento-toolbar .toolbar-dropdown-toggle:disabled,bento-toolbar .toolbar-dropdown-toggle[disabled]{cursor:pointer}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,bento-toolbar .toolbar-dropdown-toggle.disabled:hover,bento-toolbar .toolbar-dropdown-toggle:disabled:hover,bento-toolbar .toolbar-dropdown-toggle[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown-menu,bento-toolbar .toolbar-dropdown-menu{transition:.3s ease-out;overflow:hidden;padding:0;list-style:none;max-height:0;visibility:hidden}.bui-bento-toolbar .toolbar-dropdown-menu .divider,bento-toolbar .toolbar-dropdown-menu .divider{display:block}.bui-bento-toolbar .toolbar-dropdown-menu>li>a,bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.bui-bento-toolbar.bg-faded,bento-toolbar.bg-faded{border:none}.bui-bento-toolbar .bento-toolbar-custom-item,bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.bui-bento-toolbar .bento-toolbar-custom-item label,bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .bui-bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'bento-toolbar',
                template: "<ng-content select=\".navbar-header\"></ng-content>\n<ng-content select=\".navbar-left\"></ng-content>\n<nav>\n  <ul class=\"nav navbar-nav\">\n    <li bentoToolbarItem *ngFor=\"let button of items | bentoToolbarFilter: true; let i = index\">\n      <ng-container *ngIf=\"button.templateRef\">\n        <ng-content *ngTemplateOutlet=\"button.templateRef; context: {control: button.control}\"></ng-content>\n      </ng-container>\n      <a\n        cdkMonitorElementFocus\n        *ngIf=\"button.anchor\"\n        [ngClass]=\"button.class || button.cssClass\"\n        [attr.href]=\"button.disabled ? null : button.anchor.href\"\n        [attr.target]=\"button.anchor.target\"\n        [class.disabled]=\"button.disabled\"\n        [class.active]=\"button.active\"\n        [attr.aria-selected]=\"button.active\"\n        [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n        [attr.id]=\"button.id ? button.id : null\"\n        bentoSmartBadge\n        [details]=\"button.smartbadge\"\n        class=\"smart-badge-host btn-toolbar\"\n      >\n        <span [innerHTML]=\"button.anchor.text || button.label\"></span>\n      </a>\n      <a\n        cdkMonitorElementFocus\n        *ngIf=\"button.routerLink\"\n        routerLinkActive=\"router-link-active\"\n        [ngClass]=\"button.class || button.cssClass\"\n        [routerLink]=\"button.disabled ? null : button.routerLink.href\"\n        [queryParams]=\"button.routerLink.queryParams\"\n        [fragment]=\"button.routerLink.fragment\"\n        [class.disabled]=\"button.disabled\"\n        [class.active]=\"button.active\"\n        [attr.aria-selected]=\"button.active\"\n        [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n        [attr.id]=\"button.id ? button.id : null\"\n        bentoSmartBadge\n        [details]=\"button.smartbadge\"\n        class=\"smart-badge-host btn-toolbar\"\n      >\n        <span [innerHTML]=\"button.routerLink.text || button.label\"></span>\n      </a>\n      <button\n        cdkMonitorElementFocus\n        type=\"button\"\n        *ngIf=\"!button.templateRef && !button.anchor && !button.routerLink && !button.dropdown && !button.megamenu\"\n        (click)=\"button.action(); moreIsOpen = false\"\n        [ngClass]=\"button.class || button.cssClass\"\n        [class.disabled]=\"button.disabled\"\n        [class.active]=\"button.active\"\n        [attr.aria-selected]=\"button.active\"\n        [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n        [attr.id]=\"button.id ? button.id : null\"\n        [disabled]=\"button.disabled\"\n        class=\"btn-toolbar\"\n      >\n        <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n        <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n          <span [innerHTML]=\"button.label\"></span>\n        </span>\n      </button>\n      <div\n        ngbDropdown\n        #dropdown=\"ngbDropdown\"\n        id=\"dropdown-{{ uniqueID }}-{{ i }}\"\n        (openChange)=\"onDropdownOpenChange(i, $event, dropdown)\"\n        [placement]=\"isRTL ? 'bottom right' : 'bottom left'\"\n        display=\"static\"\n        *ngIf=\"button.dropdown || button.megamenu\"\n        class=\"dropdown\"\n        [class.megamenu-dropdown]=\"button.megamenu\"\n      >\n        <button\n          cdkMonitorElementFocus\n          ngbDropdownToggle\n          type=\"button\"\n          (click)=\"button.action ? button.action() : 0; moreIsOpen = false\"\n          [ngClass]=\"button.class || button.cssClass\"\n          [class.disabled]=\"button.disabled\"\n          [class.active]=\"button.active\"\n          [attr.aria-selected]=\"button.active\"\n          [attr.id]=\"button.id ? button.id : null\"\n          [disabled]=\"button.disabled\"\n          class=\"btn-toolbar\"\n        >\n          <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n          <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n            <span [innerHTML]=\"button.label\"></span>\n          </span>\n          <!-- <span class=\"smart-badge-host\" [innerHTML]=\"button.label\"></span> -->\n        </button>\n        <ul\n          *ngIf=\"button.dropdown\"\n          ngbDropdownMenu\n          class=\"dropdown-menu\"\n          [ngClass]=\"isRTL ? 'dropdown-menu-right ' : ''\"\n          id=\"dropdown-menu-{{ uniqueID }}-{{ i }}\"\n        >\n          <li ngbDropdownItem *ngFor=\"let subBtn of button.dropdown\">\n            <span *ngIf=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n            <ng-container *ngIf=\"subBtn.templateRef\">\n              <ng-content *ngTemplateOutlet=\"subBtn.templateRef; context: {control: subBtn.control}\"></ng-content>\n            </ng-container>\n            <a\n              cdkMonitorElementFocus\n              *ngIf=\"subBtn.anchor\"\n              [ngClass]=\"subBtn.class || subBtn.cssClass\"\n              [attr.href]=\"subBtn.disabled ? null : subBtn.anchor.href\"\n              [attr.target]=\"subBtn.anchor.target\"\n              [class.disabled]=\"subBtn.disabled\"\n              [class.active]=\"subBtn.active\"\n              [attr.aria-selected]=\"subBtn.active\"\n              [attr.id]=\"subBtn.id ? subBtn.id : null\"\n              bentoSmartBadge\n              [details]=\"subBtn.smartbadge\"\n              class=\"smart-badge-host\"\n            >\n              <span [innerHTML]=\"subBtn.anchor.text || subBtn.label\"></span>\n            </a>\n            <a\n              cdkMonitorElementFocus\n              *ngIf=\"subBtn.routerLink\"\n              [ngClass]=\"subBtn.class || subBtn.cssClass\"\n              [routerLink]=\"subBtn.disabled ? null : subBtn.routerLink.href\"\n              [queryParams]=\"subBtn.routerLink.queryParams\"\n              [fragment]=\"subBtn.routerLink.fragment\"\n              [class.disabled]=\"subBtn.disabled\"\n              [class.active]=\"subBtn.active\"\n              [attr.aria-selected]=\"subBtn.active\"\n              [attr.id]=\"subBtn.id ? subBtn.id : null\"\n              bentoSmartBadge\n              [details]=\"subBtn.smartbadge\"\n              class=\"smart-badge-host\"\n            >\n              <span [innerHTML]=\"subBtn.routerLink.text || subBtn.label\"></span>\n            </a>\n            <button\n              cdkMonitorElementFocus\n              type=\"button\"\n              *ngIf=\"!subBtn.anchor && !subBtn.routerLink && !subBtn.templateRef\"\n              (click)=\"subBtn.action()\"\n              [attr.id]=\"subBtn.id ? subBtn.id : null\"\n              [ngClass]=\"subBtn.class || {disabled: subBtn.disabled}\"\n              [disabled]=\"subBtn.disabled\"\n            >\n              <i *ngIf=\"subBtn.icon\" [class]=\"subBtn.icon\" aria-hidden=\"true\"></i>\n              <span bentoSmartBadge [details]=\"subBtn.smartbadge\" class=\"smart-badge-host\">\n                <span [innerHTML]=\"subBtn.label\"></span>\n              </span>\n              <!-- <span class=\"smart-badge-host\" [innerHTML]=\"subBtn.label\"></span> -->\n            </button>\n          </li>\n        </ul>\n        <bento-megamenu\n          *ngIf=\"button.megamenu\"\n          [bentoAppendTo]=\"button.type === 'takeover' ? null : elRef\"\n          [autoVerticalAlignment]=\"false\"\n          [autoHideOnContainerScroll]=\"false\"\n          alignment=\"bottom\"\n          [autoRealign]=\"true\"\n          [items]=\"button.megamenu\"\n          [type]=\"button.type\"\n          [maxWidth]=\"button.maxWidth\"\n          [ngClass]=\"isRTL ? 'dropdown-menu-right ' : ''\"\n          [flowColumnWidth]=\"button.flowColumnWidth\"\n          [widthElRef]=\"elRef\"\n          hTagRank=\"3\"\n          [attr.aria-label]=\"button.ariaLabel ? button.ariaLabel : null\"\n        ></bento-megamenu>\n      </div>\n    </li>\n    <li\n      bentoToolbarItem\n      *ngIf=\"moreAvailable\"\n      class=\"more-button\"\n      [class.visible]=\"moreVisible\"\n      data-more-buttons=\"true\"\n    >\n      <div\n        ngbDropdown\n        #moreDropdown=\"ngbDropdown\"\n        id=\"more-dropdown-{{ uniqueID }}\"\n        (openChange)=\"onDropdownOpenChange(uniqueID, $event, moreDropdown)\"\n        class=\"dropdown\"\n        display=\"static\"\n        placement=\"bottom\"\n        [autoClose]=\"'outside'\"\n        [open]=\"moreIsOpen\"\n      >\n        <button\n          cdkMonitorElementFocus\n          ngbDropdownToggle\n          type=\"button\"\n          id=\"more-button-{{ uniqueID }}\"\n          (click)=\"moreIsOpen = !moreIsOpen\"\n          class=\"btn-toolbar\"\n        >\n          <span>{{ 'BENTO_UI_NAV_TOOLBAR_MORE' | bentoTranslate: moreText }}</span>\n        </button>\n        <ul\n          class=\"dropdown-menu\"\n          ngbDropdownMenu\n          [ngClass]=\"moreIsLast && !isRTL ? 'dropdown-menu-right ' : ''\"\n          [attr.aria-labelledby]=\"'more-button-' + uniqueID\"\n        >\n          <li ngbDropdownItem *ngFor=\"let button of items | bentoToolbarFilter: false; let i = index; let last = last\">\n            <span *ngIf=\"button.separated && !(i === 0 && last)\" class=\"divider\" role=\"separator\"></span>\n            <ng-container *ngIf=\"button.templateRef\">\n              <ng-content *ngTemplateOutlet=\"button.templateRef; context: {control: button.control}\"></ng-content>\n            </ng-container>\n            <a\n              cdkMonitorElementFocus\n              *ngIf=\"button.anchor\"\n              [ngClass]=\"button.class || button.cssClass\"\n              [attr.href]=\"button.disabled ? null : button.anchor.href\"\n              [attr.target]=\"button.anchor.target\"\n              [class.disabled]=\"button.disabled\"\n              [class.active]=\"button.active\"\n              [attr.aria-selected]=\"button.active\"\n              [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n              [attr.id]=\"button.id ? button.id : null\"\n              bentoSmartBadge\n              [details]=\"button.smartbadge\"\n              class=\"smart-badge-host\"\n            >\n              <span [innerHTML]=\"button.anchor.text || button.label\"></span>\n            </a>\n            <a\n              cdkMonitorElementFocus\n              *ngIf=\"button.routerLink\"\n              [ngClass]=\"button.class || button.cssClass\"\n              [routerLink]=\"button.disabled ? null : button.routerLink.href\"\n              [queryParams]=\"button.routerLink.queryParams\"\n              [fragment]=\"button.routerLink.fragment\"\n              [class.disabled]=\"button.disabled\"\n              [class.active]=\"button.active\"\n              [attr.aria-selected]=\"button.active\"\n              [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n              [attr.id]=\"button.id ? button.id : null\"\n              bentoSmartBadge\n              [details]=\"button.smartbadge\"\n              class=\"smart-badge-host\"\n            >\n              <span [innerHTML]=\"button.routerLink.text || button.label\"></span>\n            </a>\n            <button\n              cdkMonitorElementFocus\n              *ngIf=\"!button.anchor && !button.routerLink && !button.dropdown && !button.templateRef\"\n              type=\"button\"\n              [ngClass]=\"button.class || button.cssClass\"\n              [class.disabled]=\"button.disabled\"\n              [class.active]=\"button.active\"\n              [attr.aria-selected]=\"button.active\"\n              [attr.aria-current]=\"button.useAriaCurrent && button.active ? 'page' : null\"\n              [disabled]=\"button.disabled\"\n              (click)=\"button.action(); moreIsOpen = false\"\n            >\n              <i *ngIf=\"button.icon\" [class]=\"button.icon\" aria-hidden=\"true\"></i>\n              <span bentoSmartBadge [details]=\"button.smartbadge\" class=\"smart-badge-host\">\n                <span [innerHTML]=\"button.label\"></span>\n              </span>\n              <!-- <span [innerHTML]=\"button.label\"></span> -->\n            </button>\n            <div\n              bentoToolbarDropdown\n              *ngIf=\"button.dropdown\"\n              [button]=\"button\"\n              (closeMore)=\"closeMoreDropdown()\"\n              class=\"toolbar-dropdown dropdown\"\n            ></div>\n          </li>\n        </ul>\n      </div>\n    </li>\n  </ul>\n</nav>\n<ng-content select=\".navbar-right\"></ng-content>\n<div class=\"clearfix\"></div>\n",
                providers: [BentoNotification],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".bui-bento-toolbar,bento-toolbar{border-style:solid;border-width:1px}.bui-bento-toolbar .bento-smart-badge,bento-toolbar .bento-smart-badge{position:relative;left:auto;right:auto;vertical-align:super;display:inline-block;bottom:4px;line-height:10px}.bui-bento-toolbar .navbar-nav,bento-toolbar .navbar-nav{flex-direction:row;float:left;flex:1 1 auto}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,.bui-bento-toolbar .navbar-nav>li.transparent,bento-toolbar .navbar-nav bento-scrollable-toolbar-item.transparent,bento-toolbar .navbar-nav>li.transparent{opacity:0;height:1px}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],.bui-bento-toolbar .navbar-nav>li>a,.bui-bento-toolbar .navbar-nav>li>button,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle],bento-toolbar .navbar-nav>li>a,bento-toolbar .navbar-nav>li>button{border:none;background:0 0;padding:0 15px;white-space:nowrap;display:flex;align-items:center}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,.bui-bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,.bui-bento-toolbar .navbar-nav>li>a:focus,.bui-bento-toolbar .navbar-nav>li>button:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>a:focus,bento-toolbar .navbar-nav bento-scrollable-toolbar-item>button:focus,bento-toolbar .navbar-nav>li>[ngbdropdown]>[ngbDropdownToggle]:focus,bento-toolbar .navbar-nav>li>a:focus,bento-toolbar .navbar-nav>li>button:focus{outline:0}.bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,.bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,bento-toolbar .navbar-nav>li a .bento-smart-badge{left:calc(100% - 15px)}[dir=rtl] .bui-bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] .bui-bento-toolbar .navbar-nav>li a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav bento-scrollable-toolbar-item a .bento-smart-badge,[dir=rtl] bento-toolbar .navbar-nav>li a .bento-smart-badge{left:auto;right:calc(100% - 15px)}.bui-bento-toolbar .divider,bento-toolbar .divider{display:block;margin:0;width:100%;height:1px}.bui-bento-toolbar .navbar-nav .dropdown-toggle span,bento-toolbar .navbar-nav .dropdown-toggle span{display:inline-block}.bui-bento-toolbar .navbar-nav .dropdown-toggle:after,bento-toolbar .navbar-nav .dropdown-toggle:after{content:\" \";border-width:4px}[dir=rtl] .bui-bento-toolbar .navbar-nav .dropdown-toggle:after,[dir=rtl] bento-toolbar .navbar-nav .dropdown-toggle:after{margin-right:4px;margin-left:0}.bui-bento-toolbar [ngbdropdown],bento-toolbar [ngbdropdown]{display:block;position:relative}.bui-bento-toolbar [ngbdropdown].megamenu-takeover-dropdown,bento-toolbar [ngbdropdown].megamenu-takeover-dropdown{position:static}.bui-bento-toolbar [ngbdropdown] .dropdown-menu,bento-toolbar [ngbdropdown] .dropdown-menu{position:absolute;max-height:400px;border-radius:0;overflow-y:auto;top:100%;transform:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu:after,.bui-bento-toolbar [ngbdropdown] .dropdown-menu:before,bento-toolbar [ngbdropdown] .dropdown-menu:after,bento-toolbar [ngbdropdown] .dropdown-menu:before{content:none}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button,bento-toolbar [ngbdropdown] .dropdown-menu a,bento-toolbar [ngbdropdown] .dropdown-menu button{border:1px solid transparent;width:100%;padding:0 30px 0 15px;white-space:nowrap;text-align:left;display:block;font-weight:400}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],.bui-bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu a [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu a [class^=bento-icon-],bento-toolbar [ngbdropdown] .dropdown-menu button [class*=\" bento-icon-\"],bento-toolbar [ngbdropdown] .dropdown-menu button [class^=bento-icon-]{vertical-align:middle}[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] .bui-bento-toolbar [ngbdropdown] .dropdown-menu button,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu a,[dir=rtl] bento-toolbar [ngbdropdown] .dropdown-menu button{text-align:right;padding:0 15px 0 30px}.bui-bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,.bui-bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu a .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu a.cdk-program-focused,bento-toolbar [ngbdropdown] .dropdown-menu button .btn.btn-primary:focus,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-keyboard-focused,bento-toolbar [ngbdropdown] .dropdown-menu button.cdk-program-focused{outline:0;border-width:1px;border-style:dashed}.bui-bento-toolbar [ngbdropdown] a.disabled:hover,.bui-bento-toolbar [ngbdropdown] a:disabled:hover,.bui-bento-toolbar [ngbdropdown] a[disabled]:hover,.bui-bento-toolbar [ngbdropdown] button.disabled:hover,.bui-bento-toolbar [ngbdropdown] button:disabled:hover,.bui-bento-toolbar [ngbdropdown] button[disabled]:hover,bento-toolbar [ngbdropdown] a.disabled:hover,bento-toolbar [ngbdropdown] a:disabled:hover,bento-toolbar [ngbdropdown] a[disabled]:hover,bento-toolbar [ngbdropdown] button.disabled:hover,bento-toolbar [ngbdropdown] button:disabled:hover,bento-toolbar [ngbdropdown] button[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown,bento-toolbar .toolbar-dropdown{border-bottom-width:1px;border-bottom-style:solid;width:100%;display:block}.bui-bento-toolbar .open.toolbar-dropdown-menu,bento-toolbar .open.toolbar-dropdown-menu{max-height:500px;visibility:visible}.bui-bento-toolbar .more-button,bento-toolbar .more-button{visibility:hidden}.bui-bento-toolbar .more-button.visible,bento-toolbar .more-button.visible{visibility:visible}.bui-bento-toolbar .toolbar-dropdown-toggle:after,bento-toolbar .toolbar-dropdown-toggle:after{font-family:bento-icons;position:absolute;right:10px}[dir=rtl] .bui-bento-toolbar .toolbar-dropdown-toggle:after,[dir=rtl] bento-toolbar .toolbar-dropdown-toggle:after{left:10px;right:auto}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled],bento-toolbar .toolbar-dropdown-toggle.disabled,bento-toolbar .toolbar-dropdown-toggle:disabled,bento-toolbar .toolbar-dropdown-toggle[disabled]{cursor:pointer}.bui-bento-toolbar .toolbar-dropdown-toggle.disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle:disabled:hover,.bui-bento-toolbar .toolbar-dropdown-toggle[disabled]:hover,bento-toolbar .toolbar-dropdown-toggle.disabled:hover,bento-toolbar .toolbar-dropdown-toggle:disabled:hover,bento-toolbar .toolbar-dropdown-toggle[disabled]:hover{background-color:transparent}.bui-bento-toolbar .toolbar-dropdown-menu,bento-toolbar .toolbar-dropdown-menu{transition:.3s ease-out;overflow:hidden;padding:0;list-style:none;max-height:0;visibility:hidden}.bui-bento-toolbar .toolbar-dropdown-menu .divider,bento-toolbar .toolbar-dropdown-menu .divider{display:block}.bui-bento-toolbar .toolbar-dropdown-menu>li>a,bento-toolbar .toolbar-dropdown-menu>li>a{display:block;text-decoration:none}.bui-bento-toolbar.bg-faded,bento-toolbar.bg-faded{border:none}.bui-bento-toolbar .bento-toolbar-custom-item,bento-toolbar .bento-toolbar-custom-item{padding:0 15px;display:flex;align-items:center}.bui-bento-toolbar .bento-toolbar-custom-item label,bento-toolbar .bento-toolbar-custom-item label{margin:0 5px 0 0}[dir=rtl] .bui-bento-toolbar .bento-toolbar-custom-item label,[dir=rtl] bento-toolbar .bento-toolbar-custom-item label{margin:0 0 0 5px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc6.Directionality }, { type: ɵngcc0.ChangeDetectorRef }]; }, { items: [{
            type: Input
        }], toolbarDirectives: [{
            type: ViewChildren,
            args: [BentoToolbarItemDirective]
        }], dropdowns: [{
            type: ViewChildren,
            args: [NgbDropdown]
        }], moreText: [{
            type: Input
        }] }); })();
    return BentoToolbarComponent;
}());
if (false) {
    /** @type {?} */
    BentoToolbarComponent.prototype.toolbarDirectives;
    /** @type {?} */
    BentoToolbarComponent.prototype.dropdowns;
    /**
     * Text to override "More" button
     * @type {?}
     */
    BentoToolbarComponent.prototype.moreText;
    /**
     * Array of data to populate toolbar
     * @type {?}
     */
    BentoToolbarComponent.prototype.items;
    /** @type {?} */
    BentoToolbarComponent.prototype.isGlobalSubnav;
    /** @type {?} */
    BentoToolbarComponent.prototype.moreAvailable;
    /** @type {?} */
    BentoToolbarComponent.prototype.moreVisible;
    /** @type {?} */
    BentoToolbarComponent.prototype.nativeElement;
    /** @type {?} */
    BentoToolbarComponent.prototype.moreIsLast;
    /** @type {?} */
    BentoToolbarComponent.prototype.moreIsOpen;
    /** @type {?} */
    BentoToolbarComponent.prototype.uniqueID;
    /** @type {?} */
    BentoToolbarComponent.prototype.isRTL;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarComponent.prototype._resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarComponent.prototype._staticWidth;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarComponent.prototype.dirChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarComponent.prototype.openedDropdown;
    /** @type {?} */
    BentoToolbarComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoToolbarComponent.prototype._changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toolbar/toolbar.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToolbarFilterPipe = /** @class */ (function () {
    function BentoToolbarFilterPipe() {
    }
    /**
     * @param {?} items
     * @param {?} arg
     * @return {?}
     */
    BentoToolbarFilterPipe.prototype.transform = /**
     * @param {?} items
     * @param {?} arg
     * @return {?}
     */
    function (items, arg) {
        if (!items) {
            return;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        // or the item is a megamenu dropdown
        return items.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            if (item.hasOwnProperty('hidden')) {
                return !item.hidden;
            }
            return item.isVisible === arg;
        }));
    };
BentoToolbarFilterPipe.ɵfac = function BentoToolbarFilterPipe_Factory(t) { return new (t || BentoToolbarFilterPipe)(); };
BentoToolbarFilterPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bentoToolbarFilter", type: BentoToolbarFilterPipe, pure: false });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToolbarFilterPipe, [{
        type: Pipe,
        args: [{
                name: 'bentoToolbarFilter',
                pure: false
            }]
    }], function () { return []; }, null); })();
    return BentoToolbarFilterPipe;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/toolbar/toolbar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoToolbarModule = /** @class */ (function () {
    function BentoToolbarModule() {
    }
BentoToolbarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoToolbarModule });
BentoToolbarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoToolbarModule_Factory(t) { return new (t || BentoToolbarModule)(); }, imports: [[
            CommonModule,
            RouterModule,
            NgbDropdownModule,
            BentoTranslateModule,
            BentoMegamenuModule,
            A11yModule,
            BentoNgbDropdownAnimationModule,
            BentoSmartBadgeModule,
            BentoFocusMonitorModule,
            BentoAppendToModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoToolbarModule, { declarations: function () { return [BentoToolbarComponent,
        BentoToolbarItemDirective,
        BentoToolbarDropdownComponent,
        BentoToolbarFilterPipe]; }, imports: function () { return [CommonModule,
        RouterModule,
        NgbDropdownModule,
        BentoTranslateModule,
        BentoMegamenuModule,
        A11yModule,
        BentoNgbDropdownAnimationModule,
        BentoSmartBadgeModule,
        BentoFocusMonitorModule,
        BentoAppendToModule]; }, exports: function () { return [BentoToolbarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoToolbarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    NgbDropdownModule,
                    BentoTranslateModule,
                    BentoMegamenuModule,
                    A11yModule,
                    BentoNgbDropdownAnimationModule,
                    BentoSmartBadgeModule,
                    BentoFocusMonitorModule,
                    BentoAppendToModule
                ],
                declarations: [
                    BentoToolbarComponent,
                    BentoToolbarItemDirective,
                    BentoToolbarDropdownComponent,
                    BentoToolbarFilterPipe
                ],
                exports: [BentoToolbarComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoToolbarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox-basic/transferlist.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTransferlistComponent = /** @class */ (function () {
    function BentoTransferlistComponent(elRef, r, translate, bentoUIDService, windowRef) {
        this.r = r;
        this.translate = translate;
        this.height = 500;
        this.infoShown = true;
        this.hidePagination = false;
        this.hideFilters = false;
        this.disableTransfer = false;
        this.boxID = '1';
        this.transferItems = new EventEmitter();
        this.itemsSource = undefined;
        this.renderData = undefined;
        this.filteredData = [];
        this.sortDirections = ['', 'asc', 'desc'];
        this.colHeaderSort = {};
        this.activeCol = undefined;
        this.activeColDirection = '';
        this.shiftPressed = false;
        this.selection = [];
        this.focusID = -1;
        this.hasSelection = false;
        this.totalSelected = 0;
        this.isIndeterminate = false;
        this.paginationHeight = 102;
        this.headerHeight = 88;
        this.gridHeight = this.height - this.headerHeight;
        this.gridHeightPagination = this.gridHeight - this.paginationHeight;
        this.totalSelectableItems = 0;
        this.config = {};
        this.tableStyle = { height: this.gridHeight + 'px' };
        this.pageInfo = { page: 1, totalItems: 0, pageSize: 25 };
        this._nativeElement = elRef.nativeElement;
        this.document = windowRef.nativeDocument;
        this.uniqueID = bentoUIDService.generate();
    }
    /**
     * @param {?} items
     * @return {?}
     */
    BentoTransferlistComponent.prototype.updateItemSource = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        this.itemsSource = items.slice();
        this.resetAll();
        this.showRenderedData();
        if (this.focusID >= this.renderData.length) {
            this.focusID = this.renderData.length - 1;
        }
    };
    // Multi-select - check if all items are selected
    // Multi-select - check if all items are selected
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.isAllSelected = 
    // Multi-select - check if all items are selected
    /**
     * @return {?}
     */
    function () {
        return false;
    };
    /**
     * @param {?} item
     * @param {?} i
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onRowClick = /**
     * @param {?} item
     * @param {?} i
     * @return {?}
     */
    function (item, i) {
        this.selection[item[this.columnKey]] = !this.selection[item[this.columnKey]];
        this.onCheckboxChange(item, i);
        /** @type {?} */
        var previousRowClicked = __assign({}, this.lastRowClicked);
        this.lastRowClicked = {
            id: i,
            selected: this.selection[item[this.columnKey]]
        };
        if (previousRowClicked !== null && this.shiftPressed) {
            this.selectAllBetween(previousRowClicked, this.lastRowClicked);
        }
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onFilterChange = /**
     * @return {?}
     */
    function () {
        this.showRenderedData();
    };
    /**
     * @param {?} item
     * @param {?} i
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onCheckboxChange = /**
     * @param {?} item
     * @param {?} i
     * @return {?}
     */
    function (item, i) {
        this.totalSelected = this.getSelectedCount();
        if (this.totalSelected > 0 && this.totalSelected !== this.itemsSource.length) {
            this.isIndeterminate = true;
            this.headerCheckboxModel = false;
        }
        else if (this.totalSelected > 0 && this.totalSelected === this.itemsSource.length) {
            this.isIndeterminate = false;
            this.headerCheckboxModel = true;
        }
        else {
            this.isIndeterminate = false;
            this.headerCheckboxModel = false;
        }
        this.focusRow(i);
        this.updateAria(item, i);
    };
    /**
     * @param {?} lastRowClicked
     * @param {?} nextRowClicked
     * @return {?}
     */
    BentoTransferlistComponent.prototype.selectAllBetween = /**
     * @param {?} lastRowClicked
     * @param {?} nextRowClicked
     * @return {?}
     */
    function (lastRowClicked, nextRowClicked) {
        /** @type {?} */
        var min = Math.min(lastRowClicked.id, nextRowClicked.id);
        /** @type {?} */
        var max = Math.max(lastRowClicked.id, nextRowClicked.id);
        /** @type {?} */
        var selected = lastRowClicked.selected;
        if (lastRowClicked.selected !== nextRowClicked.selected) {
            selected = nextRowClicked.selected;
        }
        for (var i = min; i <= max; i++) {
            this.selection[this.renderData[i][this.columnKey]] = selected;
        }
        this.totalSelected = this.getSelectedCount();
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.resetAll = /**
     * @return {?}
     */
    function () {
        this.selection = [];
        this.lastRowClicked = null;
        this.headerCheckboxModel = false;
        this.isIndeterminate = false;
        this.hasSelection = false;
        this.filterValue = '';
        this.activeCol = undefined;
        this.filteredData = [];
        this.totalSelected = 0;
        this.colHeaderSort = {};
    };
    /**
     * @param {?} item
     * @param {?} i
     * @return {?}
     */
    BentoTransferlistComponent.prototype.updateAria = /**
     * @param {?} item
     * @param {?} i
     * @return {?}
     */
    function (item, i) {
        if (this.totalSelected === 0) {
            this.activeDescendant = null;
        }
        else if (this.selection[item[this.columnKey]]) {
            this.updateActiveDescendant(i);
        }
        this.liveRegionMessage =
            this.title +
                ' ' +
                (this.totalSelected > 0
                    ? this.translate
                        .instantTranslate('BENTO_UI_TRANSFER_BOX_SUB_TITLE')
                        .replace('_SELECTED_', String(this.totalSelected))
                        .replace('_TOTAL_', this.pageInfo.totalItems)
                    : this.pageInfo.totalItems);
    };
    /**
     * @param {?} i
     * @return {?}
     */
    BentoTransferlistComponent.prototype.updateActiveDescendant = /**
     * @param {?} i
     * @return {?}
     */
    function (i) {
        this.activeDescendant = 'tb' + this.uniqueID + 'opt' + i;
    };
    /**
     * @param {?} col
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onHeaderClick = /**
     * @param {?} col
     * @return {?}
     */
    function (col) {
        this.activeCol = col.binding;
        // reset other sort
        for (var property in this.colHeaderSort) {
            if (this.colHeaderSort.hasOwnProperty(property)) {
                if (property !== this.activeCol) {
                    this.colHeaderSort[property] = undefined;
                }
            }
        }
        if (this.colHeaderSort[col.binding] === undefined) {
            this.colHeaderSort[col.binding] = { count: 0, sortDirection: '' };
        }
        this.colHeaderSort[col.binding].count++;
        this.colHeaderSort[col.binding].count = this.colHeaderSort[col.binding].count % 3;
        this.colHeaderSort[col.binding].sortDirection = this.sortDirections[this.colHeaderSort[col.binding].count];
        this.showRenderedData();
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.isFiltered = /**
     * @return {?}
     */
    function () {
        return this.filterValue && this.filterValue.length;
    };
    // Multi-select - check if all items are selected
    // Multi-select - check if all items are selected
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.getSelectedCount = 
    // Multi-select - check if all items are selected
    /**
     * @return {?}
     */
    function () {
        if (!this.itemsSource) {
            return;
        }
        if (this.selection.length === 0) {
            return;
        }
        /** @type {?} */
        var count = 0;
        for (var i = 0, ttl = this.selection.length; i < ttl; i++) {
            if (this.selection[i] === true) {
                count++;
            }
        }
        if (count > 0) {
            this.hasSelection = true;
        }
        else {
            this.hasSelection = false;
        }
        return count;
    };
    /**
     * @param {?=} forceTrue
     * @return {?}
     */
    BentoTransferlistComponent.prototype.toggleAll = /**
     * @param {?=} forceTrue
     * @return {?}
     */
    function (forceTrue) {
        this.headerCheckboxModel = forceTrue ? true : !this.headerCheckboxModel;
        this.isIndeterminate = false;
        this.checkAll();
    };
    // Multi-select - toggle all checkboxes
    // Multi-select - toggle all checkboxes
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.checkAll = 
    // Multi-select - toggle all checkboxes
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.itemsSource) {
            return;
        }
        if (!this.headerCheckboxModel) {
            this.selection = [];
            this.hasSelection = false;
            // vm.totalSelected = 0;
        }
        else if (this.isFiltered()) {
            this.selection = [];
            this.hasSelection = false;
            if (this.filteredData.length) {
                this.hasSelection = true;
            }
            this.filteredData.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                _this.selection[item[_this.columnKey]] = true;
            }));
        }
        else {
            if (this.itemsSource.length) {
                this.hasSelection = true;
            }
            this.itemsSource.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                _this.selection[item[_this.columnKey]] = true;
            }));
        }
        this.totalSelected = this.getSelectedCount();
    };
    // Transfer
    // Transfer
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.transferItemsClick = 
    // Transfer
    /**
     * @return {?}
     */
    function () {
        this.lastRowClicked = null;
        this.transferItems.emit();
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onFocus = /**
     * @return {?}
     */
    function () {
        if (this.renderData.length > 0 && this.focusID < 0) {
            this.focusRow(0);
        }
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.updateHeight();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    BentoTransferlistComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.hidePagination) {
            this.onTogglePagination();
        }
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var el;
            _this.boxAriaLabel = _this.title.replace(/\s/g, '');
            // add role, labelby & describeby attribute to the container
            _this.r.setAttribute(_this._nativeElement, 'aria-labelledby', 'tblabel' + _this.uniqueID);
            // give pagination button aria-label as per the BoxID
            /** @type {?} */
            var paginationButtonEls = _this._nativeElement.querySelectorAll('bento-pagination .paginate-button button');
            for (var i = 0; paginationButtonEls && i < paginationButtonEls.length; i++) {
                _this.updateLabel(paginationButtonEls[i]);
            }
            // give pagination combobox (items per page) aria-label as per the BoxID
            el = _this._nativeElement.querySelector('bento-pagination .paginate-bento-select select');
            el ? _this.updateLabel(el) : '';
        }));
    };
    /**
     * @param {?} el
     * @param {?=} overrideText
     * @return {?}
     */
    BentoTransferlistComponent.prototype.updateLabel = /**
     * @param {?} el
     * @param {?=} overrideText
     * @return {?}
     */
    function (el, overrideText) {
        if (overrideText) {
            this.r.setAttribute(el, 'aria-label', overrideText);
        }
        else {
            this.r.setAttribute(el, 'aria-describedby', 'tblabel' + this.uniqueID);
        }
    };
    /**
     * @param {?} index
     * @return {?}
     */
    BentoTransferlistComponent.prototype.trackByFn = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        return index;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onKeyup = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.keyCode === Keyboard.SHIFT) {
            this.shiftPressed = false;
            // this.lastRowClickedID = null;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onKeydown = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var focusedEl = this.document.activeElement;
        if (!focusedEl.classList.contains('bento-table-body')) {
            return;
        }
        if (event.keyCode === Keyboard.SHIFT) {
            this.shiftPressed = true;
        }
        if (this.totalSelected > 0) {
            switch (event.keyCode) {
                case Keyboard.ENTER:
                    if (this.boxID === '1') {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
                case Keyboard.DELETE:
                case Keyboard.BACKSPACE:
                    if (this.boxID === '2') {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
                case Keyboard.RIGHT:
                    if (event.altKey && ((this.boxID === '1' && !this.isRtl) || (this.boxID === '2' && this.isRtl))) {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
                case Keyboard.LEFT:
                    if (event.altKey && ((this.boxID === '2' && !this.isRtl) || (this.boxID === '1' && this.isRtl))) {
                        this.transferItemsClick();
                    }
                    event.preventDefault();
                    break;
            }
        }
        switch (event.keyCode) {
            case Keyboard.SPACE:
                if (this.focusID >= 0) {
                    this.selectRow();
                    event.preventDefault();
                }
                break;
            case Keyboard.UP:
                this.moveUpRow(event);
                event.preventDefault();
                break;
            case Keyboard.DOWN:
                this.moveDownRow(event);
                event.preventDefault();
                break;
            case Keyboard.HOME:
                this.focusFirstRow(event);
                event.preventDefault();
                break;
            case Keyboard.END:
                this.focusLastRow(event);
                event.preventDefault();
                break;
            // Character A
            case 65:
                if (event.ctrlKey) {
                    this.toggleAll();
                    event.preventDefault();
                }
                break;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BentoTransferlistComponent.prototype.focusFirstRow = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.shiftKey && event.ctrlKey) {
            for (var i = this.focusID; i >= 0; i--) {
                this.focusRow(i, true);
                this.selectRow(true);
            }
        }
        else {
            this.focusRow(0, true);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BentoTransferlistComponent.prototype.focusLastRow = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var pageSize = this.hidePagination ? this.renderData.length - 1 : this.pageInfo.pageSize - 1;
        pageSize = this.renderData.length - 1 < pageSize ? this.renderData.length - 1 : pageSize;
        if (event.shiftKey && event.ctrlKey) {
            for (var i = this.focusID; i <= pageSize; i++) {
                this.focusRow(i, true);
                this.selectRow(true);
            }
        }
        else {
            this.focusRow(pageSize, true);
        }
    };
    /**
     * @param {?} id
     * @param {?=} isKeyAction
     * @return {?}
     */
    BentoTransferlistComponent.prototype.focusRow = /**
     * @param {?} id
     * @param {?=} isKeyAction
     * @return {?}
     */
    function (id, isKeyAction) {
        /** @type {?} */
        var currentID = this.focusID;
        this.focusID = id;
        // const range = this.vScroll.measureRangeSize({start: 0, end: 16});
        /** @type {?} */
        var tableElement = (/** @type {?} */ (this._nativeElement.querySelector('.bento-table-body')));
        tableElement.focus();
        /** @type {?} */
        var rowElement = (/** @type {?} */ (this._nativeElement.querySelector('#tb' + this.uniqueID + 'opt' + id)));
        if (rowElement) {
            rowElement.focus();
        }
        if (isKeyAction) {
            /** @type {?} */
            var keyRange = this.vScroll.getRenderedRange();
            /** @type {?} */
            var pad = 5;
            if (id <= keyRange.start + pad || id >= keyRange.end - pad) {
                /** @type {?} */
                var scrollBehavior = Math.abs(currentID - id) < 100 ? 'smooth' : 'auto';
                this.vScroll.scrollToIndex(id, scrollBehavior);
            }
        }
        this.updateActiveDescendant(id);
    };
    /**
     * @param {?=} forceTrue
     * @return {?}
     */
    BentoTransferlistComponent.prototype.selectRow = /**
     * @param {?=} forceTrue
     * @return {?}
     */
    function (forceTrue) {
        /** @type {?} */
        var item = this.renderData[this.focusID];
        this.selection[item[this.columnKey]] = forceTrue ? true : !this.selection[item[this.columnKey]];
        this.onCheckboxChange(item, this.focusID);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BentoTransferlistComponent.prototype.moveUpRow = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.shiftKey) {
            this.selectRow(true);
        }
        /** @type {?} */
        var targetRow = this.focusID <= 0 ? 0 : this.focusID - 1;
        this.focusRow(targetRow, true);
        if (event.shiftKey) {
            this.selectRow(true);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BentoTransferlistComponent.prototype.moveDownRow = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.shiftKey) {
            this.selectRow(true);
        }
        /** @type {?} */
        var maxRow = this.hidePagination ? this.renderData.length : this.pageInfo.pageSize;
        /** @type {?} */
        var id = this.focusID >= maxRow - 1 ? maxRow - 1 : this.focusID + 1;
        this.focusRow(id, true);
        if (event.shiftKey) {
            this.selectRow(true);
        }
    };
    /** Returns a sorted copy of the data. */
    /**
     * Returns a sorted copy of the data.
     * @param {?} data
     * @param {?} colID
     * @param {?} sortDirection
     * @return {?}
     */
    BentoTransferlistComponent.prototype.sortData = /**
     * Returns a sorted copy of the data.
     * @param {?} data
     * @param {?} colID
     * @param {?} sortDirection
     * @return {?}
     */
    function (data, colID, sortDirection) {
        // return original data if sort reset
        if (!colID || !sortDirection || sortDirection === '') {
            return data;
        }
        // return a copy of the data sorted
        return this.heapSort(data.slice(), colID, sortDirection);
    };
    /**
     * @param {?} heaparray
     * @param {?} colID
     * @param {?} sortDirection
     * @return {?}
     */
    BentoTransferlistComponent.prototype.heapSort = /**
     * @param {?} heaparray
     * @param {?} colID
     * @param {?} sortDirection
     * @return {?}
     */
    function (heaparray, colID, sortDirection) {
        /**
         * @param {?} array
         * @param {?} index
         * @param {?} heapSize
         * @return {?}
         */
        function heapify(array, index, heapSize) {
            /** @type {?} */
            var left = 2 * index + 1;
            /** @type {?} */
            var right = 2 * index + 2;
            /** @type {?} */
            var largest = index;
            if (left < heapSize &&
                (sortDirection === 'asc' ? array[left][colID] > array[index][colID] : array[left][colID] < array[index][colID])) {
                largest = left;
            }
            if (right < heapSize &&
                (sortDirection === 'asc'
                    ? array[right][colID] > array[largest][colID]
                    : array[right][colID] < array[largest][colID])) {
                largest = right;
            }
            if (largest !== index) {
                /** @type {?} */
                var tmp = array[index];
                array[index] = array[largest];
                array[largest] = tmp;
                heapify(array, largest, heapSize);
            }
        }
        /**
         * @param {?} array
         * @return {?}
         */
        function buildMaxHeap(array) {
            for (var i = Math.floor(array.length / 2); i >= 0; i -= 1) {
                heapify(array, i, array.length);
            }
            return array;
        }
        /** @type {?} */
        var size = heaparray.length;
        /** @type {?} */
        var temp;
        buildMaxHeap(heaparray);
        for (var i = heaparray.length - 1; i > 0; i -= 1) {
            temp = heaparray[0];
            heaparray[0] = heaparray[i];
            heaparray[i] = temp;
            size -= 1;
            heapify(heaparray, 0, size);
        }
        return heaparray;
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.showRenderedData = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // var sortedData = ;
        this.lastRowClicked = null;
        /** @type {?} */
        var renderData = this.itemsSource;
        if (this.activeCol) {
            renderData = this.sortData(renderData, this.activeCol, this.colHeaderSort[this.activeCol].sortDirection);
        }
        // if filtered
        if (this.isFiltered()) {
            renderData = renderData.slice().filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                /** @type {?} */
                var searchStr = '';
                if (_this.columnDefinitions) {
                    _this.columnDefinitions.forEach((/**
                     * @param {?} colDef
                     * @return {?}
                     */
                    function (colDef) {
                        if (item[colDef.binding]) {
                            searchStr += String(item[colDef.binding]).toLowerCase();
                        }
                    }));
                }
                return searchStr.indexOf(_this.filterValue.toLowerCase()) !== -1;
            }));
            this.filteredData = renderData.slice();
        }
        else {
            this.filteredData = [];
        }
        this.pageInfo.totalItems = renderData.length;
        /** @type {?} */
        var startIndex = (this.pageInfo.page - 1) * this.pageInfo.pageSize;
        if (!this.hidePagination) {
            this.renderData = renderData.slice().splice(startIndex, this.pageInfo.pageSize);
        }
        else {
            this.renderData = renderData;
        }
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onPageChange = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.liveRegionMessage = _this._nativeElement.querySelector('.paginate-info span').innerHTML;
            _this.showRenderedData();
        }));
    };
    /**
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onItemsPerPageChange = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.liveRegionMessage = _this._nativeElement.querySelector('.paginate-info-select span').innerHTML;
            _this.showRenderedData();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferlistComponent.prototype.updateHeight = /**
     * @private
     * @return {?}
     */
    function () {
        this.gridHeight = this.height - this.headerHeight;
        this.gridHeightPagination = this.gridHeight - this.paginationHeight;
        this.tableStyle.height = this.hidePagination ? this.gridHeight + 'px' : this.gridHeightPagination + 'px';
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferlistComponent.prototype.onTogglePagination = /**
     * @private
     * @return {?}
     */
    function () {
        if (!this.itemsSource) {
            return;
        }
        this.updateHeight();
        this.showRenderedData();
    };
    /** @nocollapse */
    BentoTransferlistComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: BentoTranslate },
        { type: BentoUidService },
        { type: WindowRef }
    ]; };
    BentoTransferlistComponent.propDecorators = {
        filter: [{ type: ViewChild, args: ['filter', { static: true },] }],
        vScroll: [{ type: ViewChild, args: [CdkVirtualScrollViewport, { static: true },] }],
        height: [{ type: Input }],
        title: [{ type: Input }],
        infoShown: [{ type: Input }],
        subTitle: [{ type: Input }],
        columnDefinitions: [{ type: Input }],
        hidePagination: [{ type: Input }],
        hideFilters: [{ type: Input }],
        disableTransfer: [{ type: Input }],
        transferBtnText: [{ type: Input }],
        transferBoxDescriptionText: [{ type: Input }],
        searchText: [{ type: Input }],
        boxID: [{ type: Input }],
        columnKey: [{ type: Input }],
        isRtl: [{ type: Input }],
        transferItems: [{ type: Output }],
        onKeyup: [{ type: HostListener, args: ['keyup', ['$event'],] }],
        onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
    };
BentoTransferlistComponent.ɵfac = function BentoTransferlistComponent_Factory(t) { return new (t || BentoTransferlistComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoTranslate), ɵngcc0.ɵɵdirectiveInject(BentoUidService), ɵngcc0.ɵɵdirectiveInject(WindowRef)); };
BentoTransferlistComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTransferlistComponent, selectors: [["bento-transferlist"]], viewQuery: function BentoTransferlistComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c65, true);
        ɵngcc0.ɵɵstaticViewQuery(CdkVirtualScrollViewport, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filter = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.vScroll = _t.first);
    } }, hostBindings: function BentoTransferlistComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keyup", function BentoTransferlistComponent_keyup_HostBindingHandler($event) { return ctx.onKeyup($event); })("keydown", function BentoTransferlistComponent_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); });
    } }, inputs: { height: "height", infoShown: "infoShown", hidePagination: "hidePagination", hideFilters: "hideFilters", disableTransfer: "disableTransfer", boxID: "boxID", title: "title", subTitle: "subTitle", columnDefinitions: "columnDefinitions", transferBtnText: "transferBtnText", transferBoxDescriptionText: "transferBoxDescriptionText", searchText: "searchText", columnKey: "columnKey", isRtl: "isRtl" }, outputs: { transferItems: "transferItems" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 24, vars: 29, consts: [[1, "bento-toolbar"], ["class", "navbar-list", 4, "ngIf"], [1, "bento-filter"], [1, "sr-only", 3, "id"], ["bentoReset", "", "type", "text", 1, "form-control", 3, "id", "ngModel", "placeholder", "ngModelChange"], ["filter", ""], [1, "transferlist-header"], ["class", "transferlist-header-info", 4, "ngIf"], [1, "bento-table-grid"], [1, "bento-table-header-row"], [3, "id", "ngModel", "indeterminate", "ngModelChange", "change"], ["headerCheckbox", ""], ["class", "bento-table-column-header", 3, "click", 4, "ngFor", "ngForOf"], ["itemSize", "34", "tabindex", "0", "role", "listbox", "aria-multiselectable", "true", 1, "bento-table-body", 3, "ngStyle", "focus"], ["class", "example-item", "class", "bento-table-row", "role", "option", 3, "ngClass", "click", 4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy"], [3, "page", "goToLink", "directionLinks", "boundaryLinks", "totalItems", "itemsPerPage", "pageChange", "itemsPerPageChange", 4, "ngIf"], [1, "sr-only"], ["role", "status", "aria-atomic", "true", "aria-live", "polite"], [1, "navbar-list"], [1, "transferlist-btn", "btn", "btn-outline-primary", "transferbox-transfer-button", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-left"], [1, "btn-text"], ["aria-hidden", "true", 1, "bento-icon-chevron-right"], [1, "transferlist-header-info"], [1, "transferlist-header-title"], [1, "transferlist-select-info"], [1, "bento-table-column-header", 3, "click"], [1, "sort-icon", 3, "ngClass"], ["role", "option", 1, "bento-table-row", 3, "ngClass", "click"], [1, "bento-checkbox", 3, "id", "tabIndex", "ngModel", "click", "ngModelChange"], [4, "ngFor", "ngForOf"], [3, "page", "goToLink", "directionLinks", "boundaryLinks", "totalItems", "itemsPerPage", "pageChange", "itemsPerPageChange"], ["pagination", ""]], template: function BentoTransferlistComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoTransferlistComponent_ul_1_Template, 7, 8, "ul", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "input", 4, 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function BentoTransferlistComponent_Template_input_ngModelChange_6_listener($event) { return ctx.filterValue = $event; })("ngModelChange", function BentoTransferlistComponent_Template_input_ngModelChange_6_listener() { return ctx.onFilterChange(); });
        ɵngcc0.ɵɵpipe(8, "bentoTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, BentoTransferlistComponent_ul_9_Template, 7, 8, "ul", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵtemplate(11, BentoTransferlistComponent_div_11_Template, 8, 14, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵelementStart(13, "div", 9);
        ɵngcc0.ɵɵelementStart(14, "bento-checkbox", 10, 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function BentoTransferlistComponent_Template_bento_checkbox_ngModelChange_14_listener($event) { return ctx.headerCheckboxModel = $event; })("change", function BentoTransferlistComponent_Template_bento_checkbox_change_14_listener($event) { return $event ? ctx.checkAll() : null; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, BentoTransferlistComponent_span_16_Template, 4, 6, "span", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "cdk-virtual-scroll-viewport", 13);
        ɵngcc0.ɵɵlistener("focus", function BentoTransferlistComponent_Template_cdk_virtual_scroll_viewport_focus_17_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵtemplate(18, BentoTransferlistComponent_div_18_Template, 7, 18, "div", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, BentoTransferlistComponent_bento_pagination_19_Template, 2, 6, "bento-pagination", 15);
        ɵngcc0.ɵɵelementStart(20, "div", 16);
        ɵngcc0.ɵɵtext(21, " \"Last change: \" ");
        ɵngcc0.ɵɵelementStart(22, "span", 17);
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.boxID === "2");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "search", ctx.uniqueID, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate2(" ", ctx.title, " ", ɵngcc0.ɵɵpipeBind1(5, 24, ctx.searchText || "BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "search", ctx.uniqueID, "");
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind2(8, 26, "BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT", ctx.searchText));
        ɵngcc0.ɵɵproperty("ngModel", ctx.filterValue);
        ɵngcc0.ɵɵattribute("aria-labelledby", "search" + ctx.uniqueID);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.boxID === "1");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.infoShown);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "header-cb-", ctx.uniqueID, "");
        ɵngcc0.ɵɵproperty("ngModel", ctx.headerCheckboxModel)("indeterminate", ctx.isIndeterminate);
        ɵngcc0.ɵɵattribute("aria-describedby", "tblabel" + ctx.uniqueID);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.columnDefinitions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.tableStyle);
        ɵngcc0.ɵɵattribute("id", "tblist" + ctx.uniqueID)("aria-labelledby", "tblabel" + ctx.uniqueID)("aria-activedescendant", ctx.activeDescendant);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkVirtualForOf", ctx.renderData)("cdkVirtualForTrackBy", ctx.trackByFn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hidePagination);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("id", "tb_live_region" + ctx.uniqueID);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.liveRegionMessage, " ");
    } }, directives: [ɵngcc7.NgIf, ɵngcc8.DefaultValueAccessor, BentoResetDirective, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, BentoCheckboxComponent, ɵngcc7.NgForOf, ɵngcc9.CdkVirtualScrollViewport, ɵngcc9.CdkFixedSizeVirtualScroll, ɵngcc7.NgStyle, ɵngcc9.CdkVirtualForOf, BentoFocusMonitorDirective, ɵngcc7.NgClass, BentoPaginationComponent], pipes: [BentoTranslatePipe,
        BentoStringReplacePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTransferlistComponent, [{
        type: Component,
        args: [{
                selector: 'bento-transferlist',
                template: "<div class=\"bento-toolbar\">\n  <ul *ngIf=\"boxID === '2'\" class=\"navbar-list\">\n    <li>\n      <button\n        [attr.aria-keyshortcuts]=\"isRtl ? 'Alt+ArrowRight Enter' : 'Alt+ArrowLeft Enter'\"\n        class=\"transferlist-btn btn btn-outline-primary transferbox-transfer-button\"\n        (click)=\"transferItemsClick()\"\n        [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n        [attr.aria-disabled]=\"totalSelected === 0 || disableTransfer\"\n        [disabled]=\"totalSelected === 0 || disableTransfer\"\n      >\n        <i class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n        <span class=\"btn-text\">\n          {{ 'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_REMOVE' | bentoTranslate: transferBtnText }}\n        </span>\n      </button>\n    </li>\n  </ul>\n  <span class=\"bento-filter\">\n    <label class=\"sr-only\" id=\"search{{ uniqueID }}\">\n      {{ title }} {{ searchText || 'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate }}\n    </label>\n    <input\n      #filter\n      bentoReset\n      id=\"search{{ uniqueID }}\"\n      class=\"form-control\"\n      [attr.aria-labelledby]=\"'search' + uniqueID\"\n      [(ngModel)]=\"filterValue\"\n      (ngModelChange)=\"onFilterChange()\"\n      type=\"text\"\n      placeholder=\"{{ 'BENTO_UI_TRANSFER_BOX_BASIC_SEARCH_TEXT' | bentoTranslate: searchText }}\"\n    />\n  </span>\n  <ul *ngIf=\"boxID === '1'\" class=\"navbar-list\">\n    <li>\n      <button\n        [attr.aria-keyshortcuts]=\"!isRtl ? 'Alt+ArrowRight Enter' : 'Alt+ArrowLeft Enter'\"\n        class=\"transferlist-btn btn btn-outline-primary transferbox-transfer-button\"\n        (click)=\"transferItemsClick()\"\n        [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n        [attr.aria-disabled]=\"totalSelected === 0 || disableTransfer\"\n        [disabled]=\"totalSelected === 0 || disableTransfer\"\n      >\n        <span class=\"btn-text\">\n          {{ 'BENTO_UI_TRANSFER_BOX_BASIC_BTN_TEXT_ADD' | bentoTranslate: transferBtnText }}\n        </span>\n\n        <i class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n      </button>\n    </li>\n  </ul>\n</div>\n\n<div class=\"transferlist-header\">\n  <div class=\"transferlist-header-info\" *ngIf=\"infoShown\">\n    <p [attr.id]=\"'tblabel' + uniqueID\" class=\"transferlist-header-title\">\n      {{ title }}\n    </p>\n    <div class=\"transferlist-select-info\">\n      {{\n        totalSelected > 0\n          ? ('BENTO_UI_TRANSFER_BOX_SUB_TITLE'\n            | bentoTranslate: subTitle\n            | bentoStringReplace: '_SELECTED_':totalSelected\n            | bentoStringReplace: '_TOTAL_':pageInfo.totalItems)\n          : pageInfo.totalItems\n      }}\n    </div>\n  </div>\n</div>\n<!-- list -->\n<div class=\"bento-table-grid\">\n  <div class=\"bento-table-header-row\">\n    <bento-checkbox\n      #headerCheckbox\n      id=\"header-cb-{{ uniqueID }}\"\n      [(ngModel)]=\"headerCheckboxModel\"\n      (change)=\"$event ? checkAll() : null\"\n      [indeterminate]=\"isIndeterminate\"\n      [attr.aria-describedby]=\"'tblabel' + uniqueID\"\n    ></bento-checkbox>\n    <span *ngFor=\"let col of columnDefinitions\" class=\"bento-table-column-header\" (click)=\"onHeaderClick(col)\">\n      {{ col.header }}\n      <i\n        class=\"sort-icon\"\n        [ngClass]=\"\n          (colHeaderSort[col.binding]?.sortDirection === 'asc' ? 'bento-icon-chevron-up ' : '') +\n          (colHeaderSort[col.binding]?.sortDirection === 'desc' ? 'bento-icon-chevron-down ' : '')\n        \"\n        attr.aria-label=\"{{ 'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_SORT_BY' | bentoTranslate }} {{ col.header }}\"\n      ></i>\n    </span>\n  </div>\n  <cdk-virtual-scroll-viewport\n    itemSize=\"34\"\n    tabindex=\"0\"\n    role=\"listbox\"\n    class=\"bento-table-body\"\n    [attr.id]=\"'tblist' + uniqueID\"\n    [attr.aria-labelledby]=\"'tblabel' + uniqueID\"\n    [attr.aria-activedescendant]=\"activeDescendant\"\n    aria-multiselectable=\"true\"\n    (focus)=\"onFocus()\"\n    [ngStyle]=\"tableStyle\"\n  >\n    <div\n      *cdkVirtualFor=\"let item of renderData; let i = index; trackBy: trackByFn\"\n      class=\"example-item\"\n      class=\"bento-table-row\"\n      role=\"option\"\n      [attr.id]=\"'tb' + uniqueID + 'opt' + i\"\n      [attr.aria-selected]=\"!!selection[item[columnKey]]\"\n      [attr.aria-setsize]=\"renderData.length\"\n      [attr.aria-posinset]=\"i + 1\"\n      [ngClass]=\"(selection[item[columnKey]]?'selected ' : '') + (focusID === i?'focused ' : '')\"\n      (click)=\"onRowClick(item, i)\"\n    >\n      <label class=\"sr-only\" id=\"cb-{{ uniqueID }}-i\">\n        {{\n          'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_CHECKBOX_LABEL'\n            | bentoTranslate\n            | bentoStringReplace: '_ROW_ID_':item[columnKey]\n        }}\n      </label>\n      <bento-checkbox\n        class=\"bento-checkbox\"\n        id=\"cb-{{ uniqueID }}-i\"\n        [tabIndex]=\"-1\"\n        (click)=\"onRowClick(item, i)\"\n        [attr.aria-labelledby]=\"'cb' + uniqueID + '-i'\"\n        [(ngModel)]=\"selection[item[columnKey]]\"\n      ></bento-checkbox>\n      <span *ngFor=\"let col of columnDefinitions\">{{ item[col.binding] }}</span>\n    </div>\n  </cdk-virtual-scroll-viewport>\n</div>\n<bento-pagination\n  *ngIf=\"!hidePagination\"\n  #pagination\n  [(page)]=\"pageInfo.page\"\n  (pageChange)=\"onPageChange()\"\n  (itemsPerPageChange)=\"onItemsPerPageChange()\"\n  [goToLink]=\"false\"\n  [directionLinks]=\"true\"\n  [boundaryLinks]=\"false\"\n  [totalItems]=\"pageInfo.totalItems\"\n  [(itemsPerPage)]=\"pageInfo.pageSize\"\n></bento-pagination>\n<div class=\"sr-only\">\n  \"Last change: \"\n  <span role=\"status\" aria-atomic=\"true\" aria-live=\"polite\" [attr.id]=\"'tb_live_region' + uniqueID\">\n    {{ liveRegionMessage }}\n  </span>\n</div>\n",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: BentoTranslate }, { type: BentoUidService }, { type: WindowRef }]; }, { height: [{
            type: Input
        }], infoShown: [{
            type: Input
        }], hidePagination: [{
            type: Input
        }], hideFilters: [{
            type: Input
        }], disableTransfer: [{
            type: Input
        }], boxID: [{
            type: Input
        }], transferItems: [{
            type: Output
        }], onKeyup: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], filter: [{
            type: ViewChild,
            args: ['filter', { static: true }]
        }], vScroll: [{
            type: ViewChild,
            args: [CdkVirtualScrollViewport, { static: true }]
        }], title: [{
            type: Input
        }], subTitle: [{
            type: Input
        }], columnDefinitions: [{
            type: Input
        }], transferBtnText: [{
            type: Input
        }], transferBoxDescriptionText: [{
            type: Input
        }], searchText: [{
            type: Input
        }], columnKey: [{
            type: Input
        }], isRtl: [{
            type: Input
        }] }); })();
    return BentoTransferlistComponent;
}());
if (false) {
    /** @type {?} */
    BentoTransferlistComponent.prototype.filter;
    /** @type {?} */
    BentoTransferlistComponent.prototype.vScroll;
    /** @type {?} */
    BentoTransferlistComponent.prototype.height;
    /** @type {?} */
    BentoTransferlistComponent.prototype.title;
    /** @type {?} */
    BentoTransferlistComponent.prototype.infoShown;
    /** @type {?} */
    BentoTransferlistComponent.prototype.subTitle;
    /** @type {?} */
    BentoTransferlistComponent.prototype.columnDefinitions;
    /** @type {?} */
    BentoTransferlistComponent.prototype.hidePagination;
    /** @type {?} */
    BentoTransferlistComponent.prototype.hideFilters;
    /** @type {?} */
    BentoTransferlistComponent.prototype.disableTransfer;
    /** @type {?} */
    BentoTransferlistComponent.prototype.transferBtnText;
    /** @type {?} */
    BentoTransferlistComponent.prototype.transferBoxDescriptionText;
    /** @type {?} */
    BentoTransferlistComponent.prototype.searchText;
    /** @type {?} */
    BentoTransferlistComponent.prototype.boxID;
    /** @type {?} */
    BentoTransferlistComponent.prototype.columnKey;
    /** @type {?} */
    BentoTransferlistComponent.prototype.isRtl;
    /** @type {?} */
    BentoTransferlistComponent.prototype.transferItems;
    /** @type {?} */
    BentoTransferlistComponent.prototype.itemsSource;
    /** @type {?} */
    BentoTransferlistComponent.prototype.renderData;
    /** @type {?} */
    BentoTransferlistComponent.prototype.filteredData;
    /** @type {?} */
    BentoTransferlistComponent.prototype.sortDirections;
    /** @type {?} */
    BentoTransferlistComponent.prototype.boxItemSource;
    /** @type {?} */
    BentoTransferlistComponent.prototype.colHeaderSort;
    /** @type {?} */
    BentoTransferlistComponent.prototype.activeCol;
    /** @type {?} */
    BentoTransferlistComponent.prototype.activeColDirection;
    /** @type {?} */
    BentoTransferlistComponent.prototype.headerCheckboxModel;
    /** @type {?} */
    BentoTransferlistComponent.prototype.lastRowClicked;
    /** @type {?} */
    BentoTransferlistComponent.prototype.shiftPressed;
    /** @type {?} */
    BentoTransferlistComponent.prototype.selection;
    /** @type {?} */
    BentoTransferlistComponent.prototype.focusID;
    /** @type {?} */
    BentoTransferlistComponent.prototype.hasSelection;
    /** @type {?} */
    BentoTransferlistComponent.prototype.totalSelected;
    /** @type {?} */
    BentoTransferlistComponent.prototype.isIndeterminate;
    /** @type {?} */
    BentoTransferlistComponent.prototype.paginationHeight;
    /** @type {?} */
    BentoTransferlistComponent.prototype.headerHeight;
    /** @type {?} */
    BentoTransferlistComponent.prototype.gridHeight;
    /** @type {?} */
    BentoTransferlistComponent.prototype.gridHeightPagination;
    /** @type {?} */
    BentoTransferlistComponent.prototype.displayedColumns;
    /** @type {?} */
    BentoTransferlistComponent.prototype.totalSelectableItems;
    /** @type {?} */
    BentoTransferlistComponent.prototype.config;
    /** @type {?} */
    BentoTransferlistComponent.prototype.filterValue;
    /** @type {?} */
    BentoTransferlistComponent.prototype.tableStyle;
    /** @type {?} */
    BentoTransferlistComponent.prototype.pageInfo;
    /** @type {?} */
    BentoTransferlistComponent.prototype.boxAriaLabel;
    /** @type {?} */
    BentoTransferlistComponent.prototype.uniqueID;
    /** @type {?} */
    BentoTransferlistComponent.prototype.activeDescendant;
    /** @type {?} */
    BentoTransferlistComponent.prototype.liveRegionMessage;
    /**
     * @type {?}
     * @private
     */
    BentoTransferlistComponent.prototype._nativeElement;
    /**
     * @type {?}
     * @private
     */
    BentoTransferlistComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoTransferlistComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTransferlistComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox-basic/transferbox-basic.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable:max-line-length */
/**
 * The Transferbox is a tool to move items between two lists,
 * typically using the left side as the source for
 * a new list on the right.
 *
 * Please note, the transferbox data must include a column with unique keys.
 * The unique key column name should be provided to the grid using
 * the `columnKey` attribute.
 * This is to ensure that the selection feature works properly.
 * #### Keyboard Shortcuts
 * _Appropriate element must be focused, for shortcut to function._
 * | Key | Function |
 * | --- | -------- |
 * | <kbd>ENTER</kbd> _or_<br><kbd>ALT</kbd> + <kbd>RIGHT</kbd> | Send selected options to the destination box |
 * | <kbd>BACKSPACE</kbd> _or_<br><kbd>DELETE</kbd> _or_<br><kbd>ALT</kbd> + <kbd>LEFT ARROW</kbd> | Remove selected options from the destination box |
 * | <kbd>DOWN ARROW</kbd> | Move focus to the next option |
 * | <kbd>UP ARROW</kbd> | Move focus to the previous option |
 * | <kbd>HOME</kbd> | Move focus to the first option |
 * | <kbd>END</kbd> | Move focus to the last option |
 * | <kbd>SPACE</kbd> | Toggle the selection state of the focused option |
 * | <kbd>SHIFT</kbd> + <kbd>DOWN ARROW</kbd> | Move focus to the next option and select it |
 * | <kbd>SHIFT</kbd> + <kbd>UP ARROW</kbd> | Move focus to the previous option and select it |
 * | <kbd>SHIFT</kbd> + <kbd>Mouse Left-Click<kbd> | Selects/Deslects all rows between previous clicked row |
 * | <kbd>CONTROL</kbd> + <kbd>SHIFT</kbd> + <kbd>HOME</kbd> | Select from the focused option to the beginning of the list |
 * | <kbd>CONTROL</kbd> + <kbd>SHIFT</kbd> + <kbd>END</kbd> | Select from the focused option to the end of the list |
 * | <kbd>CONTROL</kbd> + <kbd>A</kbd> | Toggle Select All/Deselect All options in the list |
 */
var BentoTransferboxBasicComponent = /** @class */ (function () {
    function BentoTransferboxBasicComponent(elRef, translate, bentoUIDService, dir) {
        var _this = this;
        this.translate = translate;
        this.dir = dir;
        /**
         * Event handler for when a transfer action occurs. Returns
         * data collection for both grids as `gridDataOne` and `gridDataTwo`
         */
        this.transfer = new EventEmitter();
        /**
         * Set height of transferbox
         */
        this.height = 500;
        /**
         * Override default column key 'id' (Data must have a column with unique keys)
         */
        this.columnKey = 'id';
        /**
         * Toggle Pagination
         */
        this.hidePagination = false;
        this._nativeElement = elRef.nativeElement;
        this.uniqueID = bentoUIDService.generate();
        this.isRtl = this.dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRtl = _this.dir.value === 'rtl';
        }));
    }
    /**
     * @return {?}
     */
    BentoTransferboxBasicComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._transferItems();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BentoTransferboxBasicComponent.prototype.transferItemsOne = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var splitItems = this._splitItems(this.boxOneItemSource, this.boxOne);
        this.boxTwoItemSource = splitItems.selectedItems.concat(this.boxTwoItemSource);
        this.boxOneItemSource = splitItems.gridItems;
        this._transferItems();
        this._updateLiveRegion('add', splitItems.selectedItems.length);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BentoTransferboxBasicComponent.prototype.transferItemsTwo = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var splitItems = this._splitItems(this.boxTwoItemSource, this.boxTwo);
        this.boxOneItemSource = splitItems.selectedItems.concat(this.boxOneItemSource);
        this.boxTwoItemSource = splitItems.gridItems;
        this._transferItems();
        this._updateLiveRegion('remove', splitItems.selectedItems.length);
    };
    /**
     * @private
     * @return {?}
     */
    BentoTransferboxBasicComponent.prototype._transferItems = /**
     * @private
     * @return {?}
     */
    function () {
        this.boxOne.updateItemSource(this.boxOneItemSource);
        this.boxTwo.updateItemSource(this.boxTwoItemSource);
        this.transfer.emit({
            gridDataOne: this.boxOneItemSource,
            gridDataTwo: this.boxTwoItemSource
        });
    };
    /**
     * @private
     * @param {?} items
     * @param {?} transferlist
     * @return {?}
     */
    BentoTransferboxBasicComponent.prototype._splitItems = /**
     * @private
     * @param {?} items
     * @param {?} transferlist
     * @return {?}
     */
    function (items, transferlist) {
        /** @type {?} */
        var gridItems = [];
        /** @type {?} */
        var selectedItems = [];
        /** @type {?} */
        var sCount = 0;
        /** @type {?} */
        var gCount = 0;
        for (var i = 0, ttl = items.length; i < ttl; i++) {
            /** @type {?} */
            var item = items[i];
            if (transferlist.selection[item[this.columnKey]] === true) {
                selectedItems[sCount] = item;
                sCount++;
            }
            else {
                gridItems[gCount] = item;
                gCount++;
            }
        }
        return {
            gridItems: gridItems,
            selectedItems: selectedItems
        };
    };
    /**
     * @private
     * @param {?} msg
     * @param {?} amt
     * @return {?}
     */
    BentoTransferboxBasicComponent.prototype._updateLiveRegion = /**
     * @private
     * @param {?} msg
     * @param {?} amt
     * @return {?}
     */
    function (msg, amt) {
        /** @type {?} */
        var translateMsg = msg === 'add'
            ? 'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_ADDED'
            : 'BENTO_UI_TRANSFER_BOX_BASIC_A11Y_LIVE_REGION_REMOVED';
        translateMsg = this.translate.instantTranslate(translateMsg);
        translateMsg = translateMsg.replace('_NUMBER_', String(amt)).replace('_LABEL_', this.boxTwoTitle);
        this.liveRegionMessage = translateMsg;
    };
    /** @nocollapse */
    BentoTransferboxBasicComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoTranslate },
        { type: BentoUidService },
        { type: Directionality }
    ]; };
    BentoTransferboxBasicComponent.propDecorators = {
        boxOne: [{ type: ViewChild, args: ['boxOne', { static: true },] }],
        boxTwo: [{ type: ViewChild, args: ['boxTwo', { static: true },] }],
        transfer: [{ type: Output }],
        height: [{ type: Input }],
        boxOneItemSource: [{ type: Input }],
        boxTwoItemSource: [{ type: Input }],
        columnDefinitions: [{ type: Input }],
        boxOneTitle: [{ type: Input }],
        boxTwoTitle: [{ type: Input }],
        boxOneSubTitle: [{ type: Input }],
        boxTwoSubTitle: [{ type: Input }],
        searchText: [{ type: Input }],
        disableTransfer: [{ type: Input }],
        boxOneTransferBtnText: [{ type: Input }],
        boxTwoTransferBtnText: [{ type: Input }],
        columnKey: [{ type: Input }],
        hidePagination: [{ type: Input }]
    };
BentoTransferboxBasicComponent.ɵfac = function BentoTransferboxBasicComponent_Factory(t) { return new (t || BentoTransferboxBasicComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoTranslate), ɵngcc0.ɵɵdirectiveInject(BentoUidService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoTransferboxBasicComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTransferboxBasicComponent, selectors: [["bento-transferbox-basic"]], viewQuery: function BentoTransferboxBasicComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c66, true);
        ɵngcc0.ɵɵstaticViewQuery(_c67, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.boxOne = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.boxTwo = _t.first);
    } }, inputs: { height: "height", columnKey: "columnKey", hidePagination: "hidePagination", boxTwoItemSource: "boxTwoItemSource", boxOneItemSource: "boxOneItemSource", columnDefinitions: "columnDefinitions", boxOneTitle: "boxOneTitle", boxTwoTitle: "boxTwoTitle", boxOneSubTitle: "boxOneSubTitle", boxTwoSubTitle: "boxTwoSubTitle", searchText: "searchText", disableTransfer: "disableTransfer", boxOneTransferBtnText: "boxOneTransferBtnText", boxTwoTransferBtnText: "boxTwoTransferBtnText" }, outputs: { transfer: "transfer" }, decls: 9, vars: 26, consts: [[1, "bento-transferlist-container", 3, "ngStyle"], [1, "transferlist", 3, "height", "title", "columnDefinitions", "subTitle", "searchText", "transferBtnText", "disableTransfer", "hidePagination", "columnKey", "isRtl", "transferItems"], ["boxOne", ""], [1, "transferlist", 3, "height", "title", "columnDefinitions", "subTitle", "searchText", "transferBtnText", "disableTransfer", "hidePagination", "columnKey", "boxID", "isRtl", "transferItems"], ["boxTwo", ""], [1, "sr-only"], ["role", "status", "aria-atomic", "true", "aria-live", "polite"]], template: function BentoTransferboxBasicComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "bento-transferlist", 1, 2);
        ɵngcc0.ɵɵlistener("transferItems", function BentoTransferboxBasicComponent_Template_bento_transferlist_transferItems_1_listener($event) { return ctx.transferItemsOne($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "bento-transferlist", 3, 4);
        ɵngcc0.ɵɵlistener("transferItems", function BentoTransferboxBasicComponent_Template_bento_transferlist_transferItems_3_listener($event) { return ctx.transferItemsTwo($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtext(6, " \"Last change: \" ");
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(24, _c68, ctx.height + "px"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("height", ctx.height)("title", ctx.boxOneTitle)("columnDefinitions", ctx.columnDefinitions)("subTitle", ctx.boxOneSubTitle)("searchText", ctx.searchText)("transferBtnText", ctx.boxOneTransferBtnText)("disableTransfer", ctx.disableTransfer)("hidePagination", ctx.hidePagination)("columnKey", ctx.columnKey)("isRtl", ctx.isRtl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("height", ctx.height)("title", ctx.boxTwoTitle)("columnDefinitions", ctx.columnDefinitions)("subTitle", ctx.boxTwoSubTitle)("searchText", ctx.searchText)("transferBtnText", ctx.boxTwoTransferBtnText)("disableTransfer", ctx.disableTransfer)("hidePagination", ctx.hidePagination)("columnKey", ctx.columnKey)("boxID", "2")("isRtl", ctx.isRtl);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵattribute("id", "tb_live_region" + ctx.uniqueID);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.liveRegionMessage, " ");
    } }, directives: [ɵngcc7.NgStyle, BentoTransferlistComponent], styles: ["bento-transferbox-basic bento-checkbox{margin:0 12px}bento-transferbox-basic bento-checkbox.disabled{background:0 0;opacity:.5}bento-transferbox-basic bento-checkbox.disabled input{cursor:not-allowed}[dir=rtl] bento-transferbox-basic bento-checkbox{margin:0 12px}bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox,bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox input{pointer-events:none}bento-transferbox-basic .bento-transferlist-container{display:flex}bento-transferbox-basic .transferlist{position:relative;flex:1;min-width:324px;display:inline-block;vertical-align:top}bento-transferbox-basic .transferlist:first-child{margin-right:30px}[dir=rtl] bento-transferbox-basic .transferlist:first-child{margin-right:0;margin-left:30px}bento-transferbox-basic .sort-icon{margin:0 5px;line-height:1em}bento-transferbox-basic .transferlist-header{position:absolute;right:10px;text-align:right;z-index:2;display:flex;align-items:center;height:44px}[dir=rtl] bento-transferbox-basic .transferlist-header{right:auto;left:10px;text-align:left}bento-transferbox-basic .transferlist-header .transferlist-header-title{margin:0;font-weight:700;font-size:.929rem;line-height:1.2}bento-transferbox-basic .bento-toolbar{display:flex;align-items:center;padding:10px;justify-content:space-between}bento-transferbox-basic .bento-transferlist-table{border-bottom-width:1px;border-bottom-style:solid;margin-top:43px}bento-transferbox-basic .bento-transferlist-table-header{position:absolute;z-index:0;overflow:hidden}bento-transferbox-basic .bento-transferlist-table-header .cdk-header-cell{font-size:.929rem}bento-transferbox-basic .bento-transferlist-table .cdk-column-select,bento-transferbox-basic .bento-transferlist-table-header .cdk-column-select{max-width:26px;padding:0 10px}bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{font-size:1em}[dir=rtl] bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{margin:0!important;transform:scaleX(-1)}bento-transferbox-basic .transferlist-search{position:relative;display:block}bento-transferbox-basic .transferlist-search .bento-icon-search{margin:0 0 0 8px;position:absolute;top:50%;transform:translateY(-50%)}[dir=rtl] bento-transferbox-basic .transferlist-search .bento-icon-search{margin:0 8px 0 0}bento-transferbox-basic .transferlist-search .bento-reset-close-button i:before{font-size:1rem;margin-right:-10px}[dir=rtl] bento-transferbox-basic .transferlist-search .bento-reset-close-button i:before{margin-left:-10px;margin-right:0}bento-transferbox-basic .transferlist-search .transferlist-search-input{max-width:180px;padding:0 30px;height:28px}bento-transferbox-basic .transferlist-search .transferlist-search-input:focus{outline:0}[dir=rtl] bento-transferbox-basic .transferlist-search .transferlist-search-input:focus{padding:0 30px}bento-transferbox-basic .transferlist-search .transferlist-search-input::-moz-placeholder{font-style:italic}bento-transferbox-basic .transferlist-search .transferlist-search-input::-ms-input-placeholder{font-style:italic}bento-transferbox-basic .transferlist-search .transferlist-search-input::placeholder{font-style:italic}bento-transferbox-basic .transferlist-search .transferlist-search-input:-ms-input-placeholder{font-style:italic}bento-transferbox-basic .bento-table-grid{border-bottom:none;border-top:none}bento-transferbox-basic .bento-table-grid:after{content:\" \";height:1px;width:100%;display:block;position:absolute;margin-top:-1px;left:0}bento-transferbox-basic .bento-table-column-header{line-height:44px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}bento-transferbox-basic .bento-table-column-header:focus{outline:0}bento-transferbox-basic .bento-table-header-row{height:44px;display:flex;align-items:center;font-size:.929rem;font-weight:700}bento-transferbox-basic .bento-table-body{overflow-y:auto;padding:0;margin:0}bento-transferbox-basic .bento-table-row{height:34px;list-style-type:none;display:flex;align-items:center;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-transferbox-basic .bento-table-row:focus{outline:0!important}bento-transferbox-basic .bento-table-row.focused:after{content:\" \";display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;border:1px dotted;pointer-events:none}bento-transferbox-basic .bento-table-header-row span,bento-transferbox-basic .bento-table-row span{min-width:80px}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTransferboxBasicComponent, [{
        type: Component,
        args: [{
                selector: 'bento-transferbox-basic',
                template: "<div [ngStyle]=\"{height: height + 'px'}\" class=\"bento-transferlist-container\">\n  <bento-transferlist\n    #boxOne\n    class=\"transferlist\"\n    [height]=\"height\"\n    [title]=\"boxOneTitle\"\n    [columnDefinitions]=\"columnDefinitions\"\n    [subTitle]=\"boxOneSubTitle\"\n    [searchText]=\"searchText\"\n    [transferBtnText]=\"boxOneTransferBtnText\"\n    [disableTransfer]=\"disableTransfer\"\n    (transferItems)=\"transferItemsOne($event)\"\n    [hidePagination]=\"hidePagination\"\n    [columnKey]=\"columnKey\"\n    [isRtl]=\"isRtl\"\n  ></bento-transferlist>\n  <bento-transferlist\n    #boxTwo\n    class=\"transferlist\"\n    [height]=\"height\"\n    [title]=\"boxTwoTitle\"\n    [columnDefinitions]=\"columnDefinitions\"\n    [subTitle]=\"boxTwoSubTitle\"\n    [searchText]=\"searchText\"\n    [transferBtnText]=\"boxTwoTransferBtnText\"\n    [disableTransfer]=\"disableTransfer\"\n    (transferItems)=\"transferItemsTwo($event)\"\n    [hidePagination]=\"hidePagination\"\n    [columnKey]=\"columnKey\"\n    [boxID]=\"'2'\"\n    [isRtl]=\"isRtl\"\n  ></bento-transferlist>\n</div>\n<div class=\"sr-only\">\n  \"Last change: \"\n  <span role=\"status\" aria-atomic=\"true\" aria-live=\"polite\" [attr.id]=\"'tb_live_region' + uniqueID\">\n    {{ liveRegionMessage }}\n  </span>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["bento-transferbox-basic bento-checkbox{margin:0 12px}bento-transferbox-basic bento-checkbox.disabled{background:0 0;opacity:.5}bento-transferbox-basic bento-checkbox.disabled input{cursor:not-allowed}[dir=rtl] bento-transferbox-basic bento-checkbox{margin:0 12px}bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox,bento-transferbox-basic .bento-table-grid bento-checkbox.bento-checkbox input{pointer-events:none}bento-transferbox-basic .bento-transferlist-container{display:flex}bento-transferbox-basic .transferlist{position:relative;flex:1;min-width:324px;display:inline-block;vertical-align:top}bento-transferbox-basic .transferlist:first-child{margin-right:30px}[dir=rtl] bento-transferbox-basic .transferlist:first-child{margin-right:0;margin-left:30px}bento-transferbox-basic .sort-icon{margin:0 5px;line-height:1em}bento-transferbox-basic .transferlist-header{position:absolute;right:10px;text-align:right;z-index:2;display:flex;align-items:center;height:44px}[dir=rtl] bento-transferbox-basic .transferlist-header{right:auto;left:10px;text-align:left}bento-transferbox-basic .transferlist-header .transferlist-header-title{margin:0;font-weight:700;font-size:.929rem;line-height:1.2}bento-transferbox-basic .bento-toolbar{display:flex;align-items:center;padding:10px;justify-content:space-between}bento-transferbox-basic .bento-transferlist-table{border-bottom-width:1px;border-bottom-style:solid;margin-top:43px}bento-transferbox-basic .bento-transferlist-table-header{position:absolute;z-index:0;overflow:hidden}bento-transferbox-basic .bento-transferlist-table-header .cdk-header-cell{font-size:.929rem}bento-transferbox-basic .bento-transferlist-table .cdk-column-select,bento-transferbox-basic .bento-transferlist-table-header .cdk-column-select{max-width:26px;padding:0 10px}bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{font-size:1em}[dir=rtl] bento-transferbox-basic .transferlist-btn.btn [class^=bento-icon-]{margin:0!important;transform:scaleX(-1)}bento-transferbox-basic .transferlist-search{position:relative;display:block}bento-transferbox-basic .transferlist-search .bento-icon-search{margin:0 0 0 8px;position:absolute;top:50%;transform:translateY(-50%)}[dir=rtl] bento-transferbox-basic .transferlist-search .bento-icon-search{margin:0 8px 0 0}bento-transferbox-basic .transferlist-search .bento-reset-close-button i:before{font-size:1rem;margin-right:-10px}[dir=rtl] bento-transferbox-basic .transferlist-search .bento-reset-close-button i:before{margin-left:-10px;margin-right:0}bento-transferbox-basic .transferlist-search .transferlist-search-input{max-width:180px;padding:0 30px;height:28px}bento-transferbox-basic .transferlist-search .transferlist-search-input:focus{outline:0}[dir=rtl] bento-transferbox-basic .transferlist-search .transferlist-search-input:focus{padding:0 30px}bento-transferbox-basic .transferlist-search .transferlist-search-input::-moz-placeholder{font-style:italic}bento-transferbox-basic .transferlist-search .transferlist-search-input::-ms-input-placeholder{font-style:italic}bento-transferbox-basic .transferlist-search .transferlist-search-input::placeholder{font-style:italic}bento-transferbox-basic .transferlist-search .transferlist-search-input:-ms-input-placeholder{font-style:italic}bento-transferbox-basic .bento-table-grid{border-bottom:none;border-top:none}bento-transferbox-basic .bento-table-grid:after{content:\" \";height:1px;width:100%;display:block;position:absolute;margin-top:-1px;left:0}bento-transferbox-basic .bento-table-column-header{line-height:44px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}bento-transferbox-basic .bento-table-column-header:focus{outline:0}bento-transferbox-basic .bento-table-header-row{height:44px;display:flex;align-items:center;font-size:.929rem;font-weight:700}bento-transferbox-basic .bento-table-body{overflow-y:auto;padding:0;margin:0}bento-transferbox-basic .bento-table-row{height:34px;list-style-type:none;display:flex;align-items:center;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-transferbox-basic .bento-table-row:focus{outline:0!important}bento-transferbox-basic .bento-table-row.focused:after{content:\" \";display:block;position:absolute;top:0;left:0;right:0;width:100%;height:100%;border:1px dotted;pointer-events:none}bento-transferbox-basic .bento-table-header-row span,bento-transferbox-basic .bento-table-row span{min-width:80px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoTranslate }, { type: BentoUidService }, { type: ɵngcc6.Directionality }]; }, { transfer: [{
            type: Output
        }], height: [{
            type: Input
        }], columnKey: [{
            type: Input
        }], hidePagination: [{
            type: Input
        }], boxTwoItemSource: [{
            type: Input
        }], boxOneItemSource: [{
            type: Input
        }], boxOne: [{
            type: ViewChild,
            args: ['boxOne', { static: true }]
        }], boxTwo: [{
            type: ViewChild,
            args: ['boxTwo', { static: true }]
        }], columnDefinitions: [{
            type: Input
        }], boxOneTitle: [{
            type: Input
        }], boxTwoTitle: [{
            type: Input
        }], boxOneSubTitle: [{
            type: Input
        }], boxTwoSubTitle: [{
            type: Input
        }], searchText: [{
            type: Input
        }], disableTransfer: [{
            type: Input
        }], boxOneTransferBtnText: [{
            type: Input
        }], boxTwoTransferBtnText: [{
            type: Input
        }] }); })();
    return BentoTransferboxBasicComponent;
}());
if (false) {
    /** @type {?} */
    BentoTransferboxBasicComponent.prototype.boxOne;
    /** @type {?} */
    BentoTransferboxBasicComponent.prototype.boxTwo;
    /**
     * Event handler for when a transfer action occurs. Returns
     * data collection for both grids as `gridDataOne` and `gridDataTwo`
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.transfer;
    /**
     * Set height of transferbox
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.height;
    /**
     * Data collection for box one
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxOneItemSource;
    /**
     * Data collection for box two
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxTwoItemSource;
    /**
     * Column definitions for rendering in the Transferbox
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.columnDefinitions;
    /**
     * Title for box one
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxOneTitle;
    /**
     * Title for box two
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxTwoTitle;
    /**
     * Sub-title for box one where `_SELECTED_` is replaced by number of
     * items selected and `_TOTAL_` is number of total items available.
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxOneSubTitle;
    /**
     * Sub-title for box two where `_SELECTED_` is replaced by number of
     * items selected and `_TOTAL_` is number of total items available.
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxTwoSubTitle;
    /**
     * Placeholder text for search input
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.searchText;
    /**
     * Option to disable transfer buttons
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.disableTransfer;
    /**
     * Option to override transfer button text 'Add'
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxOneTransferBtnText;
    /**
     * Option to override transfer button text 'Remove'
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.boxTwoTransferBtnText;
    /**
     * Override default column key 'id' (Data must have a column with unique keys)
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.columnKey;
    /**
     * Toggle Pagination
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.hidePagination;
    /**
     * Component native element
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype._nativeElement;
    /**
     * Main container element of this component
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.element;
    /** @type {?} */
    BentoTransferboxBasicComponent.prototype.uniqueID;
    /** @type {?} */
    BentoTransferboxBasicComponent.prototype.liveRegionMessage;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoTransferboxBasicComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxBasicComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    BentoTransferboxBasicComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox-basic/transferbox-basic.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BentoTransferboxBasicColumnDefinitions() { }
if (false) {
    /**
     * text displayed in column header.
     * @type {?}
     */
    BentoTransferboxBasicColumnDefinitions.prototype.header;
    /**
     * the name of property to bind column to.
     * @type {?}
     */
    BentoTransferboxBasicColumnDefinitions.prototype.binding;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/transferbox-basic/transferbox-basic.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTransferboxBasicModule = /** @class */ (function () {
    function BentoTransferboxBasicModule() {
    }
BentoTransferboxBasicModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTransferboxBasicModule });
BentoTransferboxBasicModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTransferboxBasicModule_Factory(t) { return new (t || BentoTransferboxBasicModule)(); }, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            FormsModule,
            BentoPaginationModule,
            BentoCheckboxModule,
            BentoResetModule,
            ScrollingModule,
            BentoFocusMonitorModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTransferboxBasicModule, { declarations: function () { return [BentoTransferboxBasicComponent,
        BentoTransferlistComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        FormsModule,
        BentoPaginationModule,
        BentoCheckboxModule,
        BentoResetModule,
        ScrollingModule,
        BentoFocusMonitorModule]; }, exports: function () { return [BentoTransferboxBasicComponent,
        BentoTransferlistComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTransferboxBasicModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoTranslateModule,
                    BentoUtilsModule,
                    FormsModule,
                    BentoPaginationModule,
                    BentoCheckboxModule,
                    BentoResetModule,
                    ScrollingModule,
                    BentoFocusMonitorModule
                ],
                declarations: [BentoTransferboxBasicComponent, BentoTransferlistComponent],
                exports: [BentoTransferboxBasicComponent, BentoTransferlistComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoTransferboxBasicModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tree/tree-branch.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
BentoTreeBranch = /** @class */ (function () {
    function BentoTreeBranch() {
        /**
         * Flag to only expand or collapse a tree branch
         */
        this.itemExpandOnly = false;
        /**
         * Flag to a tree item click is considered as a checkbox click
         */
        this.selectAsCheck = false;
        /**
         * Flag to show all checkbobox components
         */
        this.showCheckboxes = true;
    }
    /**
     * API to fire item select callback on tree root
     */
    /**
     * API to fire item select callback on tree root
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeBranch.prototype._emitItemSelect = /**
     * API to fire item select callback on tree root
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    function (item, silent) {
        if (silent === void 0) { silent = false; }
    };
    /**
     * API to fire item expand callback on tree root
     */
    /**
     * API to fire item expand callback on tree root
     * @param {?} event
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeBranch.prototype._emitItemExpand = /**
     * API to fire item expand callback on tree root
     * @param {?} event
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    function (event, item, silent) {
        if (silent === void 0) { silent = false; }
    };
    /**
     * API to fire item checkd state
     */
    /**
     * API to fire item checkd state
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeBranch.prototype._emitItemCheck = /**
     * API to fire item checkd state
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    function (item, silent) {
        if (silent === void 0) { silent = false; }
    };
    /**
     * API to fire when tree item is destroyed
     */
    /**
     * API to fire when tree item is destroyed
     * @param {?} item
     * @return {?}
     */
    BentoTreeBranch.prototype._removeTreeItemRef = /**
     * API to fire when tree item is destroyed
     * @param {?} item
     * @return {?}
     */
    function (item) { };
    return BentoTreeBranch;
}());
if (false) {
    /**
     * ID is defined by HTML "id" attribute or an UID will be assigned by the BentoUidService
     * @type {?}
     */
    BentoTreeBranch.prototype.id;
    /**
     * Property name to define tree branch children array reference
     * @type {?}
     */
    BentoTreeBranch.prototype.itemChildrenProp;
    /**
     * Flag to only expand or collapse a tree branch
     * @type {?}
     */
    BentoTreeBranch.prototype.itemExpandOnly;
    /**
     * Property name to define tree item icon class name
     * @type {?}
     */
    BentoTreeBranch.prototype.itemIconProp;
    /**
     * Flag to a tree item click is considered as a checkbox click
     * @type {?}
     */
    BentoTreeBranch.prototype.selectAsCheck;
    /**
     * Flag to show all checkbobox components
     * @type {?}
     */
    BentoTreeBranch.prototype.showCheckboxes;
    /**
     * List of children
     * @type {?}
     */
    BentoTreeBranch.prototype.children;
    /**
     * Reference of self HTMLElement
     * @type {?}
     */
    BentoTreeBranch.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tree/tree-item-option.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An class for Bento Tree item options prior or during runtime to be declared to each tree item.
 * This is property can be initialized as a static JSON when the tree is initialized, then it will
 * be automatically converted into a new object with the follow API capabilities.
 *
 * Variable `treeId` represents the `id` of its corresponding HTMLElement.
 */
var  /**
 * An class for Bento Tree item options prior or during runtime to be declared to each tree item.
 * This is property can be initialized as a static JSON when the tree is initialized, then it will
 * be automatically converted into a new object with the follow API capabilities.
 *
 * Variable `treeId` represents the `id` of its corresponding HTMLElement.
 */
BentoTreeItemOption = /** @class */ (function () {
    /**
     * Construct BentoTreeItemOption object
     */
    function BentoTreeItemOption(checked, selected, collapsed, indeterminate, hideCheckbox, preventSelection, isHidden, isDisabled, level, siblings, index, parent) {
        if (checked === void 0) { checked = false; }
        if (selected === void 0) { selected = false; }
        if (collapsed === void 0) { collapsed = false; }
        if (indeterminate === void 0) { indeterminate = false; }
        if (hideCheckbox === void 0) { hideCheckbox = false; }
        if (preventSelection === void 0) { preventSelection = false; }
        if (isHidden === void 0) { isHidden = false; }
        if (isDisabled === void 0) { isDisabled = false; }
        if (level === void 0) { level = 0; }
        if (siblings === void 0) { siblings = []; }
        /**
         * Emits checked change
         */
        this._checkedChange = new EventEmitter();
        /**
         * Emits collapsed change
         */
        this._collapsedChange = new EventEmitter();
        /**
         * Emits indeterminate change
         */
        this._indeterminateChange = new EventEmitter();
        /**
         * Emits is hidden change
         */
        this._isHiddenChange = new EventEmitter();
        /**
         * To emit child/children being appended to the current item
         */
        this._itemAppend = new EventEmitter();
        /* Private variables */
        // @ts-ignore
        this._checked = false;
        // @ts-ignore
        this._collapsed = false;
        // @ts-ignore
        this._selected = false;
        // @ts-ignore
        this._indeterminate = false;
        // @ts-ignore
        this._isHidden = false;
        this._isDisabled = false;
        // @ts-ignore
        this._checkedMap = {};
        // @ts-ignore
        this._collapsedMap = {};
        // @ts-ignore
        this._selectedMap = {};
        // @ts-ignore
        this._indeterminateMap = {};
        // @ts-ignore
        this._isHiddenMap = {};
        this._checked = checked;
        this._selectedChange = new BehaviorSubject({ v: selected });
        this._selected = selected;
        this._collapsed = collapsed;
        this._indeterminate = indeterminate;
        this.hideCheckbox = hideCheckbox;
        this.preventSelection = preventSelection;
        this._isHidden = isHidden;
        this._disabledChange = new BehaviorSubject(isDisabled);
        this._isDisabled = isDisabled;
        this.level = level;
        this.parent = parent;
        this.siblings = siblings;
        this.siblingSize = siblings ? siblings.length : 0;
        this.index = index + 1;
    }
    /**
     * Append item(s), single or array, to the current tree item
     * This feature *only* applies to *Bento Tree View* component
     */
    /**
     * Append item(s), single or array, to the current tree item
     * This feature *only* applies to *Bento Tree View* component
     * @param {?} data
     * @return {?}
     */
    BentoTreeItemOption.prototype.appendItems = /**
     * Append item(s), single or array, to the current tree item
     * This feature *only* applies to *Bento Tree View* component
     * @param {?} data
     * @return {?}
     */
    function (data) {
        // Only need to emit to forward this to each subscribers
        this._itemAppend.emit(data);
    };
    Object.defineProperty(BentoTreeItemOption.prototype, "checked", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getChecked();
        },
        /**
         * Flag to determine if this item is checked
         */
        set: /**
         * Flag to determine if this item is checked
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.setChecked(v, undefined, true);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set `checked` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Set `checked` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @param {?=} bubble
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeItemOption.prototype.setChecked = /**
     * Set `checked` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @param {?=} bubble
     * @param {?=} silent
     * @return {?}
     */
    function (v, treeId, bubble, silent) {
        if (bubble === void 0) { bubble = true; }
        if (silent === void 0) { silent = false; }
        if (this.hideCheckbox) {
            // Don't even bother
            return;
        }
        this._setValueOf('_indeterminate', false, treeId);
        if (this._isSameValue('_checked', v, treeId)) {
            // Same value -> no need to update
            return;
        }
        this._setValueOf('_checked', v, treeId);
        // When slient, do not emit changes
        this._checkedChange.emit({ v: v, treeId: treeId, bubble: bubble, silent: silent });
    };
    /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     */
    /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype.getChecked = /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    function (treeId) {
        return this._getValueOf('_checked', treeId).value;
    };
    Object.defineProperty(BentoTreeItemOption.prototype, "collapsed", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getCollapsed();
        },
        /**
         * Flag to determine if this item is collapsed
         */
        set: /**
         * Flag to determine if this item is collapsed
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.setCollapsed(v);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeItemOption.prototype.setCollapsed = /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @param {?=} silent
     * @return {?}
     */
    function (v, treeId, silent) {
        if (silent === void 0) { silent = false; }
        if (this._isSameValue('_collapsed', v, treeId)) {
            return;
        }
        this._setValueOf('_collapsed', v, treeId);
        if (!silent) {
            this._collapsedChange.emit({ v: v, treeId: treeId });
        }
    };
    /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype.getCollapsed = /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    function (treeId) {
        return this._getValueOf('_collapsed', treeId).value;
    };
    Object.defineProperty(BentoTreeItemOption.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isDisabled;
        },
        /**
         * Set disabled state
         */
        set: /**
         * Set disabled state
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v !== this._isDisabled) {
                this._isDisabled = v;
                this._disabledChange.next(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTreeItemOption.prototype, "selected", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getSelected();
        },
        /**
         * Flag to determine if this item is selected
         */
        set: /**
         * Flag to determine if this item is selected
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.setSelected(v);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set `selected` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Set `selected` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype.setSelected = /**
     * Set `selected` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @return {?}
     */
    function (v, treeId) {
        if (this._isSameValue('_selected', v, treeId)) {
            return;
        }
        this._setValueOf('_selected', v, treeId);
        this._selectedChange.next({ v: v, treeId: treeId });
    };
    /**
     * Get `selected` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Get `selected` variable with its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype.getSelected = /**
     * Get `selected` variable with its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    function (treeId) {
        return this._getValueOf('_selected', treeId).value;
    };
    Object.defineProperty(BentoTreeItemOption.prototype, "indeterminate", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getIndeterminate();
        },
        /**
         * Flag to determine if this item is indeterminate
         */
        set: /**
         * Flag to determine if this item is indeterminate
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.setIndeterminate(v);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype.setIndeterminate = /**
     * Set `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @return {?}
     */
    function (v, treeId) {
        if (this._isSameValue('_indeterminate', v, treeId)) {
            return;
        }
        this._setValueOf('_indeterminate', v, treeId);
        if (v) {
            this._setValueOf('_checked', false, treeId);
        }
        this._indeterminateChange.emit({ v: v, treeId: treeId });
    };
    /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype.getIndeterminate = /**
     * Get `collapsed` variable with its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    function (treeId) {
        return this._getValueOf('_indeterminate', treeId).value;
    };
    Object.defineProperty(BentoTreeItemOption.prototype, "isHidden", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getIsHidden();
        },
        /**
         * Flag to determine if this item is hidden
         */
        set: /**
         * Flag to determine if this item is hidden
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this.setIsHidden(v, undefined, true);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Set `hidden` variable with its Bento Tree HTMLElement ID
     */
    /**
     * Set `hidden` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @param {?=} bubble
     * @return {?}
     */
    BentoTreeItemOption.prototype.setIsHidden = /**
     * Set `hidden` variable with its Bento Tree HTMLElement ID
     * @param {?} v
     * @param {?=} treeId
     * @param {?=} bubble
     * @return {?}
     */
    function (v, treeId, bubble) {
        if (bubble === void 0) { bubble = true; }
        if (this._isSameValue('_isHidden', v, treeId)) {
            return;
        }
        this._setValueOf('_isHidden', v, treeId);
        this._isHiddenChange.emit({ v: v, treeId: treeId, bubble: bubble });
    };
    /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     */
    /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype.getIsHidden = /**
     * Get `checked` value based on its Bento Tree HTMLElement ID
     * @param {?=} treeId
     * @return {?}
     */
    function (treeId) {
        return this._getValueOf('_isHidden', treeId).value;
    };
    /**
     * Set the variable name with value on the map with treeId
     * If treeId is specified, all values of this variable will be updated
     */
    /**
     * Set the variable name with value on the map with treeId
     * If treeId is specified, all values of this variable will be updated
     * @private
     * @param {?} varName
     * @param {?} v
     * @param {?} withTreeId
     * @return {?}
     */
    BentoTreeItemOption.prototype._setValueOf = /**
     * Set the variable name with value on the map with treeId
     * If treeId is specified, all values of this variable will be updated
     * @private
     * @param {?} varName
     * @param {?} v
     * @param {?} withTreeId
     * @return {?}
     */
    function (varName, v, withTreeId) {
        if (withTreeId != null) {
            this[varName + 'Map'][withTreeId] = v;
        }
        else {
            this[varName] = v;
            /** @type {?} */
            var map = this[varName + 'Map'];
            if (!map) {
                // Wrong value in `varName`
                return;
            }
            /* tslint:disable */
            for (var label in map) {
                map[label] = v;
            }
            /* tslint:enable */
        }
    };
    /**
     * Get the value from varName with its treeId
     */
    /**
     * Get the value from varName with its treeId
     * @private
     * @param {?} varName
     * @param {?} withTreeId
     * @return {?}
     */
    BentoTreeItemOption.prototype._getValueOf = /**
     * Get the value from varName with its treeId
     * @private
     * @param {?} varName
     * @param {?} withTreeId
     * @return {?}
     */
    function (varName, withTreeId) {
        if (withTreeId != null) {
            /** @type {?} */
            var varNameMap = varName + 'Map';
            if (this[varNameMap].hasOwnProperty(withTreeId)) {
                return { value: this[varNameMap][withTreeId], hasMixedValues: false };
            }
            else {
                return { value: this[varName], hasMixedValues: false };
            }
        }
        else {
            /** @type {?} */
            var hasMixedValues = false;
            /** @type {?} */
            var v = this[varName];
            /** @type {?} */
            var map = this[varName + 'Map'];
            /* tslint:disable */
            for (var label in map) {
                if (map[label] !== v) {
                    hasMixedValues = true;
                    break;
                }
            }
            /* tslint:enable */
            return { value: this[varName], hasMixedValues: hasMixedValues };
        }
    };
    /**
     * Check if the value `v` is the same as the given varName
     */
    /**
     * Check if the value `v` is the same as the given varName
     * @private
     * @param {?} varName
     * @param {?} v
     * @param {?} treeId
     * @return {?}
     */
    BentoTreeItemOption.prototype._isSameValue = /**
     * Check if the value `v` is the same as the given varName
     * @private
     * @param {?} varName
     * @param {?} v
     * @param {?} treeId
     * @return {?}
     */
    function (varName, v, treeId) {
        /** @type {?} */
        var valueObj = this._getValueOf(varName, treeId);
        return valueObj.value === v && !valueObj.hasMixedValues;
    };
    return BentoTreeItemOption;
}());
if (false) {
    /**
     * Flag to hide checkbox of the current item
     * @type {?}
     */
    BentoTreeItemOption.prototype.hideCheckbox;
    /**
     * Prevent this item from being selected
     * @type {?}
     */
    BentoTreeItemOption.prototype.preventSelection;
    /**
     * Tree Item Level from the root (level 0)
     * @type {?}
     */
    BentoTreeItemOption.prototype.level;
    /**
     * Parent item of the item
     * @type {?}
     */
    BentoTreeItemOption.prototype.parent;
    /**
     * All siblings from the same parent item includes self
     * @type {?}
     */
    BentoTreeItemOption.prototype.siblings;
    /**
     * Current Index
     * @type {?}
     */
    BentoTreeItemOption.prototype.index;
    /**
     * Size of siblings
     * @type {?}
     */
    BentoTreeItemOption.prototype.siblingSize;
    /**
     * Emits checked change
     * @type {?}
     */
    BentoTreeItemOption.prototype._checkedChange;
    /**
     * Emits collapsed change
     * @type {?}
     */
    BentoTreeItemOption.prototype._collapsedChange;
    /**
     * Emits disabled state
     * @type {?}
     */
    BentoTreeItemOption.prototype._disabledChange;
    /**
     * Emits selected change
     * Private API
     * @type {?}
     */
    BentoTreeItemOption.prototype._selectedChange;
    /**
     * Emits indeterminate change
     * @type {?}
     */
    BentoTreeItemOption.prototype._indeterminateChange;
    /**
     * Emits is hidden change
     * @type {?}
     */
    BentoTreeItemOption.prototype._isHiddenChange;
    /**
     * To emit child/children being appended to the current item
     * @type {?}
     */
    BentoTreeItemOption.prototype._itemAppend;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._checked;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._collapsed;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._selected;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._indeterminate;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._isHidden;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._isDisabled;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._checkedMap;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._collapsedMap;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._selectedMap;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._indeterminateMap;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemOption.prototype._isHiddenMap;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tree/tree-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var idCounter = 0;
var BentoTreeItemComponent = /** @class */ (function () {
    function BentoTreeItemComponent(elRef, r, dir, changeDetector) {
        this.r = r;
        this.dir = dir;
        this.changeDetector = changeDetector;
        /**
         * Check of this node is the last in its sibling array
         */
        this.isLast = false;
        /**
         * Flag to determine if should show checkboxes
         */
        this.showCheckbox = true;
        /*
           * For A11y
           */
        this.ariaLevel = 0;
        this.ariaIndex = 0;
        this.siblingSize = 0;
        /**
         * Notify when a item checkbox is changed
         */
        this.itemCheckChange = new EventEmitter();
        // UID for this node
        this.uid = "bui-tree-item-" + idCounter++;
        /* Private variables */
        this.isDisabled = false;
        this.checkedSubscription = Subscription.EMPTY;
        this.selectedSubscription = Subscription.EMPTY;
        this.collapsedSubscription = Subscription.EMPTY;
        this.indeterminateSubscription = Subscription.EMPTY;
        this.isHiddenSubscription = Subscription.EMPTY;
        this.isDisabledSubscription = Subscription.EMPTY;
        this.self = this;
    }
    Object.defineProperty(BentoTreeItemComponent.prototype, "_ariaSiblings", {
        set: /**
         * @param {?} a
         * @return {?}
         */
        function (a) {
            this.siblingSize = a.length;
            this.ariaSiblings = a;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Expand all items
     */
    /**
     * Expand all items
     * @return {?}
     */
    BentoTreeItemComponent.prototype.expandAll = /**
     * Expand all items
     * @return {?}
     */
    function () {
        var e_1, _a;
        /** @type {?} */
        var children = this.children.toArray();
        if (children && children.length > 0) {
            this.options.setCollapsed(false, this.root.id);
            try {
                for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                    var child = children_1_1.value;
                    child.expandAll();
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // Make sure it checks the changes for rendering
        this.changeDetector.markForCheck();
    };
    /**
     * Collapse all items
     */
    /**
     * Collapse all items
     * @return {?}
     */
    BentoTreeItemComponent.prototype.collapseAll = /**
     * Collapse all items
     * @return {?}
     */
    function () {
        /** @type {?} */
        var children = this.children.toArray();
        if (children) {
            this.options.setCollapsed(true, this.root.id);
            if (children.length > 0) {
                // Collapse children if the children array isn't empty
                for (var i = 0, len = children.length; i < len; i++) {
                    children[i].collapseAll();
                }
            }
        }
        // Make sure it checks the changes for rendering
        this.changeDetector.markForCheck();
    };
    /**
     * Focus on this tree item
     */
    /**
     * Focus on this tree item
     * @return {?}
     */
    BentoTreeItemComponent.prototype.focus = /**
     * Focus on this tree item
     * @return {?}
     */
    function () {
        this.itemLabelElRef.nativeElement.focus();
    };
    /**
     * After view init
     */
    /**
     * After view init
     * @return {?}
     */
    BentoTreeItemComponent.prototype.ngAfterViewInit = /**
     * After view init
     * @return {?}
     */
    function () { };
    /**
     * Init
     */
    /**
     * Init
     * @return {?}
     */
    BentoTreeItemComponent.prototype.ngOnInit = /**
     * Init
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var selectInitialized = false;
        this.itemLabelString = this.treeItem[((/** @type {?} */ (this.root))).itemLabelProp];
        this.options = ((/** @type {?} */ (this.treeItem.$bentoTreeItemOption))) || new BentoTreeItemOption();
        if (!(this.options instanceof BentoTreeItemOption)) {
            // Options is a simple Object need to convert it to Class
            this.options = new BentoTreeItemOption(this.treeItem.$bentoTreeItemOption.checked, this.treeItem.$bentoTreeItemOption.selected, this.treeItem.$bentoTreeItemOption.collapsed, this.treeItem.$bentoTreeItemOption.indeterminate, this.treeItem.$bentoTreeItemOption.hideCheckbox, this.treeItem.$bentoTreeItemOption.preventSelection, this.treeItem.$bentoTreeItemOption.isHidden, this.treeItem.$bentoTreeItemOption.disabled);
        }
        this.treeItem.$bentoTreeItemOption = this.options;
        // update main Bento Tree data model if this tree item is initially selected
        if (this.options.getSelected(this.root.id)) {
            // Add to selection queue
            this.root._emitItemSelect(this.treeItem, true);
        }
        // selected subscription
        this.selectedSubscription = this.options._selectedChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.root.id) {
                if (res.v) {
                    _this.r.addClass(_this.componentElRef.nativeElement, 'selected');
                    if (selectInitialized) {
                        // Use timeout for selections after initialized to show animations
                        setTimeout((/**
                         * @return {?}
                         */
                        function () {
                            _this.r.addClass(_this.componentElRef.nativeElement, 'in');
                        }), 34);
                    }
                    else {
                        _this.r.addClass(_this.componentElRef.nativeElement, 'in');
                    }
                }
                else {
                    _this.r.removeClass(_this.componentElRef.nativeElement, 'selected');
                    _this.r.removeClass(_this.componentElRef.nativeElement, 'in');
                    _this.r.addClass(_this.componentElRef.nativeElement, 'out');
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this.r.removeClass(_this.componentElRef.nativeElement, 'out');
                    }));
                }
                _this.root._emitItemSelect(_this.treeItem, !selectInitialized);
            }
            // Make sure it checks the changes for rendering
            _this.changeDetector.markForCheck();
        }));
        selectInitialized = true;
        // collapsed subscription
        this.collapsedSubscription = this.options._collapsedChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.root.id) {
                _this.root._emitItemExpand({ expanded: !res.v, item: _this.treeItem }, _this);
            }
        }));
        // update main Bento Tree data model if this tree item is initially checked
        if (this.options.getChecked(this.root.id)) {
            // set children check status
            this.checkChildren(this.options.getChecked(this.root.id));
            // Add to selection queue
            this.root._emitItemCheck(this.treeItem, true);
        }
        // check subscription
        this.checkedSubscription = this.options._checkedChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.root.id || // a check change targeting this tree with a treeId
                res.treeId == null // wildcard on treeId
            ) {
                if (res.bubble) {
                    // Only emit item check change when it needs to bubble up
                    _this.itemCheckChange.emit();
                }
                // Notify the root silently
                _this.root._emitItemCheck(_this.treeItem, true);
                if (!_this.options.getIndeterminate(_this.root.id)) {
                    // Set check status on children only when the dataModel of this tree item does not
                    // have indeterminate state
                    _this.checkChildren(res.v);
                }
            }
            // Make sure it checks the changes for rendering
            _this.changeDetector.markForCheck();
        }));
        // disabled
        this.isDisabledSubscription = this.options._disabledChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.isDisabled = res;
            // Make sure it checks the changes for rendering
            _this.changeDetector.markForCheck();
        }));
        // indeterminate
        this.indeterminateSubscription = this.options._indeterminateChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.root.id) {
                _this.itemCheckChange.emit();
            }
            // Make sure it checks the changes for rendering
            _this.changeDetector.markForCheck();
        }));
        // isHidden
        this.isHiddenSubscription = this.options._isHiddenChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.root.id) {
                _this.itemCheckChange.emit();
            }
            // Make sure it checks the changes for rendering
            _this.changeDetector.markForCheck();
        }));
    };
    /**
     * Check all parent indeterminate relationships
     */
    /**
     * Check all parent indeterminate relationships
     * @return {?}
     */
    BentoTreeItemComponent.prototype.onChildItemCheckChange = /**
     * Check all parent indeterminate relationships
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var allChecked = true;
        /** @type {?} */
        var allUnchecked = true;
        /** @type {?} */
        var hasIndeterminate = false;
        /** @type {?} */
        var hasChildren = false;
        // Use data model to determine if this item has to be indeterminate or not
        this.treeItem[this.root.itemChildrenProp].forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            /** @type {?} */
            var option = (/** @type {?} */ (item.$bentoTreeItemOption));
            if (!option || option.isHidden) {
                return;
            }
            hasChildren = true;
            if (!option.hideCheckbox) {
                if (option.getChecked(_this.root.id)) {
                    allUnchecked = false;
                }
                else {
                    allChecked = false;
                }
            }
            if (option.getIndeterminate(_this.root.id)) {
                hasIndeterminate = true;
            }
        }));
        if (hasChildren && allChecked && !hasIndeterminate) {
            this.options.setChecked(true, this.root.id);
        }
        else if (allUnchecked && !hasIndeterminate) {
            this.options.setChecked(false, this.root.id);
            this.options.setIndeterminate(false, this.root.id);
        }
        else {
            this.options.setIndeterminate(true, this.root.id);
        }
    };
    /**
     * Called when a folder is expanded
     */
    /**
     * Called when a folder is expanded
     * @param {?} event
     * @return {?}
     */
    BentoTreeItemComponent.prototype.onExpandClick = /**
     * Called when a folder is expanded
     * @param {?} event
     * @return {?}
     */
    function (event) {
        // Only enable the expand when there is a data model
        // at least to simulate even when there the children array has no children
        // as long as there is a children array object assigned to `treeData`
        if (this.treeItem[this.root.itemChildrenProp]) {
            /** @type {?} */
            var flippedCollapsed = !this.options.getCollapsed(this.root.id);
            this.options.setCollapsed(flippedCollapsed, this.root.id);
        }
    };
    /**
     * Called when a item is clicked
     */
    /**
     * Called when a item is clicked
     * @param {?} event
     * @return {?}
     */
    BentoTreeItemComponent.prototype.onItemClick = /**
     * Called when a item is clicked
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.root.itemExpandOnly && this.treeItem[this.root.itemChildrenProp]) {
            this.onExpandClick(event);
        }
        else if (this.root.selectAsCheck) {
            this.onCheckChanged(!this.checkbox.value);
        }
        else if (!this.options.preventSelection) {
            this.options.setSelected(!this.options.getSelected(this.root.id), this.root.id);
        }
    };
    /**
     * Called with Keyboard Event
     */
    /**
     * Called with Keyboard Event
     * @param {?} event
     * @return {?}
     */
    BentoTreeItemComponent.prototype.onItemKeydown = /**
     * Called with Keyboard Event
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var isRTL = this.dir.value === 'rtl';
        switch (event.which) {
            // Enter or Space
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                this.onItemClick(null);
                event.preventDefault();
                event.stopPropagation();
                return;
            // Left key
            case Keyboard.LEFT:
                if (isRTL) {
                    this.walkDownTreeItems();
                }
                else {
                    this.walkUpTreeItems();
                }
                event.preventDefault();
                event.stopPropagation();
                return;
            // Up key
            case Keyboard.UP:
                this.focusOnPreviousItem();
                event.preventDefault();
                event.stopPropagation();
                return;
            // Right key
            case Keyboard.RIGHT:
                if (isRTL) {
                    this.walkUpTreeItems();
                }
                else {
                    this.walkDownTreeItems();
                }
                event.preventDefault();
                event.stopPropagation();
                return;
            // Down key
            case Keyboard.DOWN:
                this.focusOnNextItem();
                event.preventDefault();
                event.stopPropagation();
                return;
            default:
        }
    };
    /**
     * Focus to the next available item
     */
    /**
     * Focus to the next available item
     * @return {?}
     */
    BentoTreeItemComponent.prototype.focusOnNextItem = /**
     * Focus to the next available item
     * @return {?}
     */
    function () {
        /** @type {?} */
        var CTAs = this.activeCTAs;
        /** @type {?} */
        var currentCTAIndex = CTAs.indexOf(this.itemLabelElRef.nativeElement);
        CTAs[(currentCTAIndex + 1) % CTAs.length].focus();
    };
    /**
     * Find and focus on the available previous item
     */
    /**
     * Find and focus on the available previous item
     * @return {?}
     */
    BentoTreeItemComponent.prototype.focusOnPreviousItem = /**
     * Find and focus on the available previous item
     * @return {?}
     */
    function () {
        /** @type {?} */
        var CTAs = this.activeCTAs;
        /** @type {?} */
        var currentCTAIndex = CTAs.indexOf(this.itemLabelElRef.nativeElement);
        CTAs[(currentCTAIndex - 1 + CTAs.length) % CTAs.length].focus();
    };
    /**
     * Callback when the checkbox changes its value
     */
    /**
     * Callback when the checkbox changes its value
     * @param {?} v
     * @return {?}
     */
    BentoTreeItemComponent.prototype.onCheckChanged = /**
     * Callback when the checkbox changes its value
     * @param {?} v
     * @return {?}
     */
    function (v) {
        this.options.setChecked(v, this.root.id);
        // Not going to update children when checkbox is in indeterminate state
        if (this.checkbox.indeterminate) {
            return;
        }
        this.root._emitItemCheck(this.treeItem);
    };
    /**
     * Check all children
     */
    /**
     * Check all children
     * @param {?} v
     * @return {?}
     */
    BentoTreeItemComponent.prototype.checkChildren = /**
     * Check all children
     * @param {?} v
     * @return {?}
     */
    function (v) {
        var _this = this;
        /** @type {?} */
        var children = this.childrenModelArray;
        if (children && children.length > 0 && !this.options.getIndeterminate(this.root.id)) {
            // Propagate current check state to children
            // This is only used when view is not ready
            children.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.$bentoTreeItemOption instanceof BentoTreeItemOption) {
                    // options is defined as an instance of BentoTreeItemOption
                    if (item.$bentoTreeItemOption.getChecked(_this.root.id) !== v &&
                        !item.$bentoTreeItemOption.getIsHidden(_this.root.id)) {
                        item.$bentoTreeItemOption.setChecked(v, _this.root.id, false);
                    }
                }
                else if (item.$bentoTreeItemOption && !item.$bentoTreeItemOption.isHidden) {
                    // option is simply a JSON
                    item.$bentoTreeItemOption.checked = v;
                }
                else {
                    // option doesn't exist
                    item.$bentoTreeItemOption = { checked: v };
                }
            }));
        }
    };
    /**
     * @return {?}
     */
    BentoTreeItemComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        // Clean data object
        if (this.treeItem) {
            this.root._removeTreeItemRef(this.treeItem);
        }
        // Unsbscribe item states
        this.checkedSubscription.unsubscribe();
        this.selectedSubscription.unsubscribe();
        this.collapsedSubscription.unsubscribe();
        this.indeterminateSubscription.unsubscribe();
        this.isHiddenSubscription.unsubscribe();
        this.isDisabledSubscription.unsubscribe();
    };
    /**
     * Walk down the item tree expand if needed
     */
    /**
     * Walk down the item tree expand if needed
     * @private
     * @return {?}
     */
    BentoTreeItemComponent.prototype.walkDownTreeItems = /**
     * Walk down the item tree expand if needed
     * @private
     * @return {?}
     */
    function () {
        if (this.options.getCollapsed(this.root.id)) {
            this.onExpandClick(null);
        }
        else if (this.children && this.children.length > 0) {
            this.focusOnNextItem();
        }
    };
    /**
     * Walk up the hirachy collapse if needed
     */
    /**
     * Walk up the hirachy collapse if needed
     * @private
     * @return {?}
     */
    BentoTreeItemComponent.prototype.walkUpTreeItems = /**
     * Walk up the hirachy collapse if needed
     * @private
     * @return {?}
     */
    function () {
        if (!this.options.getCollapsed(this.root.id) && this.treeItem[this.root.itemChildrenProp]) {
            this.onExpandClick(null);
        }
        else if (this.parent) {
            this.parent.focus();
        }
    };
    Object.defineProperty(BentoTreeItemComponent.prototype, "activeCTAs", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            var e_2, _a;
            /** @type {?} */
            var CTAs = Array.from(this.root.el.querySelectorAll('.bento-tree-item-cta'));
            /** @type {?} */
            var disabledCTAs = Array.from(this.root.el.querySelectorAll('.bento-tree-disabled .bento-tree-item-cta'));
            /** @type {?} */
            var activeCTAs = [];
            try {
                for (var CTAs_1 = __values(CTAs), CTAs_1_1 = CTAs_1.next(); !CTAs_1_1.done; CTAs_1_1 = CTAs_1.next()) {
                    var item = CTAs_1_1.value;
                    if (disabledCTAs.indexOf(item) < 0) {
                        activeCTAs.push(item);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (CTAs_1_1 && !CTAs_1_1.done && (_a = CTAs_1.return)) _a.call(CTAs_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return activeCTAs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoTreeItemComponent.prototype, "childrenModelArray", {
        /**
         * Get the children of this tree item
         */
        get: /**
         * Get the children of this tree item
         * @private
         * @return {?}
         */
        function () {
            return this.treeItem[this.root.itemChildrenProp];
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */
    BentoTreeItemComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: Directionality },
        { type: ChangeDetectorRef }
    ]; };
    BentoTreeItemComponent.propDecorators = {
        treeItem: [{ type: Input }],
        parent: [{ type: Input }],
        root: [{ type: Input }],
        labelTemplateRef: [{ type: Input }],
        isLast: [{ type: Input }],
        showCheckbox: [{ type: Input }],
        ariaLevel: [{ type: Input }],
        ariaIndex: [{ type: Input }],
        _ariaSiblings: [{ type: Input, args: ['ariaSiblings',] }],
        itemCheckChange: [{ type: Output }],
        children: [{ type: ViewChildren, args: [BentoTreeItemComponent,] }],
        checkbox: [{ type: ViewChild, args: [BentoCheckboxComponent,] }],
        itemLabelElRef: [{ type: ViewChild, args: ['itemLabel', { static: true },] }],
        componentElRef: [{ type: ViewChild, args: ['componentEl', { static: true },] }],
        isDisabled: [{ type: HostBinding, args: ['class.bento-tree-disabled',] }]
    };
BentoTreeItemComponent.ɵfac = function BentoTreeItemComponent_Factory(t) { return new (t || BentoTreeItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoTreeItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTreeItemComponent, selectors: [["bento-tree-item"]], viewQuery: function BentoTreeItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoCheckboxComponent, true);
        ɵngcc0.ɵɵstaticViewQuery(_c69, true);
        ɵngcc0.ɵɵstaticViewQuery(_c70, true);
        ɵngcc0.ɵɵviewQuery(BentoTreeItemComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemLabelElRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.componentElRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.children = _t);
    } }, hostVars: 2, hostBindings: function BentoTreeItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("bento-tree-disabled", ctx.isDisabled);
    } }, inputs: { isLast: "isLast", showCheckbox: "showCheckbox", ariaLevel: "ariaLevel", ariaIndex: "ariaIndex", _ariaSiblings: ["ariaSiblings", "_ariaSiblings"], treeItem: "treeItem", parent: "parent", root: "root", labelTemplateRef: "labelTemplateRef" }, outputs: { itemCheckChange: "itemCheckChange" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoUidService])], decls: 10, vars: 15, consts: [["role", "treeitem"], ["componentEl", ""], ["type", "button", "class", "expand-button-compiled", 3, "disabled", "ngbTooltip", "click", 4, "ngIf"], ["class", "tree-item-checkbox", 3, "ngModel", "indeterminate", "disabled", "ngModelChange", 4, "ngIf"], ["aria-hidden", "true", 3, "class", "click", 4, "ngIf"], ["role", "treeitem", 1, "bento-tree-item-cta", 3, "click", "keydown"], ["itemLabel", ""], [1, "bento-tree-item-cta-wrapper"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "bento-tree-branch", 3, "hidden", 4, "ngIf"], ["type", "button", 1, "expand-button-compiled", 3, "disabled", "ngbTooltip", "click"], ["aria-hidden", "true", 3, "ngClass"], [1, "tree-item-checkbox", 3, "ngModel", "indeterminate", "disabled", "ngModelChange"], ["aria-hidden", "true", 3, "click"], [1, "bento-tree-branch", 3, "hidden"], [1, "bento-tree-branch-base"], ["ngFor", "", 3, "ngForOf"], [3, "hidden", "root", "parent", "treeItem", "labelTemplateRef", "isLast", "showCheckbox", "ariaLevel", "ariaIndex", "ariaSiblings", "itemCheckChange"]], template: function BentoTreeItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, BentoTreeItemComponent_button_2_Template, 8, 20, "button", 2);
        ɵngcc0.ɵɵtemplate(3, BentoTreeItemComponent_bento_checkbox_3_Template, 1, 5, "bento-checkbox", 3);
        ɵngcc0.ɵɵtemplate(4, BentoTreeItemComponent_i_4_Template, 1, 2, "i", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5, 6);
        ɵngcc0.ɵɵlistener("click", function BentoTreeItemComponent_Template_div_click_5_listener($event) { return ctx.onItemClick($event); })("keydown", function BentoTreeItemComponent_Template_div_keydown_5_listener($event) { return ctx.onItemKeydown($event); });
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵtemplate(8, BentoTreeItemComponent_ng_container_8_Template, 1, 0, "ng-container", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, BentoTreeItemComponent_div_9_Template, 3, 2, "div", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-level", ctx.ariaLevel)("aria-posinset", ctx.ariaIndex)("aria-setsize", ctx.siblingSize);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.treeItem[ctx.root.itemChildrenProp]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCheckbox && !ctx.options.hideCheckbox);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.treeItem[ctx.root.itemIconProp]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("tabindex", ctx.options.preventSelection || ctx.options.disabled ? 0 - 1 : 0)("aria-disabled", ctx.options.disabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.labelTemplateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(11, _c71, ctx.treeItem, ctx.uid, ctx.root));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.treeItem[ctx.root.itemChildrenProp] && ctx.treeItem[ctx.root.itemChildrenProp].length > 0);
    } }, directives: [ɵngcc7.NgIf, ɵngcc7.NgTemplateOutlet, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective, ɵngcc7.NgClass, BentoCheckboxComponent, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, ɵngcc7.NgForOf, BentoTreeItemComponent], pipes: [BentoStringReplacePipe,
        BentoTranslatePipe], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTreeItemComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tree-item',
                template: "<div\n  #componentEl\n  role=\"treeitem\"\n  [attr.aria-level]=\"ariaLevel\"\n  [attr.aria-posinset]=\"ariaIndex\"\n  [attr.aria-setsize]=\"siblingSize\"\n>\n  <button\n    type=\"button\"\n    class=\"expand-button-compiled\"\n    *ngIf=\"treeItem[root.itemChildrenProp]\"\n    (click)=\"onExpandClick($event)\"\n    [disabled]=\"options.disabled\"\n    [attr.aria-label]=\"\n      (options.getCollapsed(root.id)\n        ? ('BENTO_UI_TREE_EXPAND' | bentoTranslate)\n        : ('BENTO_UI_TREE_COLLAPSE' | bentoTranslate)\n      ) | bentoStringReplace: '_LABEL_':itemLabelString\n    \"\n    ngbTooltip=\"{{\n      (options.getCollapsed(root.id)\n        ? ('BENTO_UI_TREE_EXPAND' | bentoTranslate)\n        : ('BENTO_UI_TREE_COLLAPSE' | bentoTranslate)\n      ) | bentoStringReplace: '_LABEL_':itemLabelString\n    }}\"\n  >\n    <i\n      aria-hidden=\"true\"\n      [ngClass]=\"options.getCollapsed(root.id) ? 'bento-icon-plus-plain' : 'bento-icon-minus-plain'\"\n    ></i>\n  </button>\n  <bento-checkbox\n    class=\"tree-item-checkbox\"\n    [ngModel]=\"options.getChecked(root.id)\"\n    (ngModelChange)=\"onCheckChanged($event)\"\n    [indeterminate]=\"options.getIndeterminate(root.id)\"\n    [attr.id]=\"'checkbox-' + uid\"\n    [disabled]=\"options.disabled\"\n    [attr.aria-describedby]=\"'label-' + uid\"\n    *ngIf=\"showCheckbox && !options.hideCheckbox\"\n  ></bento-checkbox>\n  <i\n    [class]=\"treeItem[root.itemIconProp]\"\n    *ngIf=\"treeItem[root.itemIconProp]\"\n    (click)=\"onItemClick($event)\"\n    aria-hidden=\"true\"\n  ></i>\n  <div\n    class=\"bento-tree-item-cta\"\n    (click)=\"onItemClick($event)\"\n    (keydown)=\"onItemKeydown($event)\"\n    [attr.tabindex]=\"options.preventSelection || options.disabled ? -1 : 0\"\n    [attr.aria-disabled]=\"options.disabled\"\n    role=\"treeitem\"\n    #itemLabel\n  >\n    <div class=\"bento-tree-item-cta-wrapper\">\n      <ng-container\n        *ngTemplateOutlet=\"labelTemplateRef; context: {item: treeItem, itemUID: uid, treeRoot: root}\"\n      ></ng-container>\n    </div>\n  </div>\n  <div\n    class=\"bento-tree-branch\"\n    *ngIf=\"treeItem[root.itemChildrenProp] && treeItem[root.itemChildrenProp].length > 0\"\n    [hidden]=\"options.getCollapsed(root.id)\"\n  >\n    <div class=\"bento-tree-branch-base\">\n      <ng-template ngFor let-item [ngForOf]=\"treeItem[root.itemChildrenProp]\" let-isLast=\"last\" let-i=\"index\">\n        <bento-tree-item\n          [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n          [root]=\"root\"\n          [parent]=\"self\"\n          [treeItem]=\"item\"\n          [labelTemplateRef]=\"labelTemplateRef\"\n          [isLast]=\"isLast\"\n          [showCheckbox]=\"showCheckbox\"\n          (itemCheckChange)=\"onChildItemCheckChange()\"\n          [ariaLevel]=\"ariaLevel + 1\"\n          [ariaIndex]=\"i + 1\"\n          [ariaSiblings]=\"treeItem[root.itemChildrenProp]\"\n        ></bento-tree-item>\n      </ng-template>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [BentoUidService]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc6.Directionality }, { type: ɵngcc0.ChangeDetectorRef }]; }, { isLast: [{
            type: Input
        }], showCheckbox: [{
            type: Input
        }], ariaLevel: [{
            type: Input
        }], ariaIndex: [{
            type: Input
        }], itemCheckChange: [{
            type: Output
        }], isDisabled: [{
            type: HostBinding,
            args: ['class.bento-tree-disabled']
        }], _ariaSiblings: [{
            type: Input,
            args: ['ariaSiblings']
        }], treeItem: [{
            type: Input
        }], parent: [{
            type: Input
        }], root: [{
            type: Input
        }], labelTemplateRef: [{
            type: Input
        }], children: [{
            type: ViewChildren,
            args: [BentoTreeItemComponent]
        }], checkbox: [{
            type: ViewChild,
            args: [BentoCheckboxComponent]
        }], itemLabelElRef: [{
            type: ViewChild,
            args: ['itemLabel', { static: true }]
        }], componentElRef: [{
            type: ViewChild,
            args: ['componentEl', { static: true }]
        }] }); })();
    return BentoTreeItemComponent;
}());
if (false) {
    /**
     * This Setter will set the current TreeItem data and append a $bentoTreeItemOption API object to the data so that
     * the status of this item can be modified from outside of the BentoTreeComponent class
     * @type {?}
     */
    BentoTreeItemComponent.prototype.treeItem;
    /**
     * Reference to the parent Bento Tree Item object
     * @type {?}
     */
    BentoTreeItemComponent.prototype.parent;
    /**
     * Reference to the Bento Tree root data object
     * @type {?}
     */
    BentoTreeItemComponent.prototype.root;
    /**
     * Reference to custom label template
     * @type {?}
     */
    BentoTreeItemComponent.prototype.labelTemplateRef;
    /**
     * Check of this node is the last in its sibling array
     * @type {?}
     */
    BentoTreeItemComponent.prototype.isLast;
    /**
     * Flag to determine if should show checkboxes
     * @type {?}
     */
    BentoTreeItemComponent.prototype.showCheckbox;
    /** @type {?} */
    BentoTreeItemComponent.prototype.ariaLevel;
    /** @type {?} */
    BentoTreeItemComponent.prototype.ariaIndex;
    /** @type {?} */
    BentoTreeItemComponent.prototype.siblingSize;
    /** @type {?} */
    BentoTreeItemComponent.prototype.ariaSiblings;
    /**
     * Notify when a item checkbox is changed
     * @type {?}
     */
    BentoTreeItemComponent.prototype.itemCheckChange;
    /** @type {?} */
    BentoTreeItemComponent.prototype.children;
    /** @type {?} */
    BentoTreeItemComponent.prototype.checkbox;
    /** @type {?} */
    BentoTreeItemComponent.prototype.itemLabelElRef;
    /** @type {?} */
    BentoTreeItemComponent.prototype.componentElRef;
    /** @type {?} */
    BentoTreeItemComponent.prototype.self;
    /** @type {?} */
    BentoTreeItemComponent.prototype.options;
    /** @type {?} */
    BentoTreeItemComponent.prototype.itemLabelString;
    /** @type {?} */
    BentoTreeItemComponent.prototype.uid;
    /** @type {?} */
    BentoTreeItemComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.checkedSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.selectedSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.collapsedSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.indeterminateSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.isHiddenSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.isDisabledSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.dir;
    /**
     * @type {?}
     * @private
     */
    BentoTreeItemComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tree/tree.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var BentoTreeItemCheckStatus = {
    Checked: 0,
    Unchecked: 1,
    Indeterminate: 2,
};
BentoTreeItemCheckStatus[BentoTreeItemCheckStatus.Checked] = 'Checked';
BentoTreeItemCheckStatus[BentoTreeItemCheckStatus.Unchecked] = 'Unchecked';
BentoTreeItemCheckStatus[BentoTreeItemCheckStatus.Indeterminate] = 'Indeterminate';
/**
 * The tree view creates a hierarchical view of items in a collection.
 * Users can expand/collapse items in the tree to view the content of the children items,
 * and they can also select individual items.
 */
var BentoTreeComponent = /** @class */ (function (_super) {
    __extends(BentoTreeComponent, _super);
    function BentoTreeComponent(elRef, uidService) {
        var _this = _super.call(this) || this;
        /**
         * Flag to multiple tree items can be selected
         */
        _this.multiSelect = false;
        /**
         * Flag to only expand or collapse a tree branch
         */
        _this.itemExpandOnly = false;
        /**
         * Flag to a tree item click is considered as a checkbox click
         */
        _this.selectAsCheck = false;
        /**
         * Flag to show all checkbobox components
         */
        _this.showCheckboxes = true;
        /**
         * Flag to show the expand and collapse all buttons
         */
        _this.showExpandCollapseAllButtons = false;
        // Event Emitters
        /**
         * Callback to when a item is selected
         */
        _this.itemSelect = new EventEmitter();
        /**
         * Callback to when a tree item is expanded or collapsed
         */
        _this.itemExpandCollapse = new EventEmitter();
        /**
         * Callback to when a item is checked
         */
        _this.itemCheck = new EventEmitter();
        _this.api = {};
        _this.isInitiated = false;
        _this.id = elRef.nativeElement.id || undefined;
        _this.uid = uidService.generate();
        _this._self = _this;
        _this.el = elRef.nativeElement;
        return _this;
    }
    Object.defineProperty(BentoTreeComponent.prototype, "items", {
        /**
         * Main Bento Tree data
         */
        set: /**
         * Main Bento Tree data
         * @param {?} items
         * @return {?}
         */
        function (items) {
            this.updateItems(items);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoTreeComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.isInitiated = true;
        this.updateItems(this.treeItems);
    };
    /**
     * Expand all items
     */
    /**
     * Expand all items
     * @return {?}
     */
    BentoTreeComponent.prototype.expandAll = /**
     * Expand all items
     * @return {?}
     */
    function () {
        /** @type {?} */
        var children = this.children.toArray();
        if (children && children.length > 0) {
            for (var i = 0, len = children.length; i < len; i++) {
                children[i].expandAll();
            }
        }
    };
    /**
     * Collapse all items
     */
    /**
     * Collapse all items
     * @return {?}
     */
    BentoTreeComponent.prototype.collapseAll = /**
     * Collapse all items
     * @return {?}
     */
    function () {
        /** @type {?} */
        var children = this.children.toArray();
        if (children && children.length > 0) {
            for (var i = 0, len = children.length; i < len; i++) {
                children[i].collapseAll();
            }
        }
    };
    /**
     * API to fire item expand callback on tree root
     */
    /**
     * API to fire item expand callback on tree root
     * @param {?} event
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeComponent.prototype._emitItemExpand = /**
     * API to fire item expand callback on tree root
     * @param {?} event
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    function (event, item, silent) {
        if (silent === void 0) { silent = false; }
        // Fire callback if not silent
        if (!silent) {
            this.itemExpandCollapse.emit(event);
        }
    };
    /**
     * API to fire item select callback on tree root
     */
    /**
     * API to fire item select callback on tree root
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeComponent.prototype._emitItemSelect = /**
     * API to fire item select callback on tree root
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    function (item, silent) {
        var _this = this;
        if (silent === void 0) { silent = false; }
        if (!this.selectedItems) {
            this.selectedItems = [];
        }
        /** @type {?} */
        var index = this.selectedItems.indexOf(item);
        /** @type {?} */
        var tempItem;
        if (item.$bentoTreeItemOption.getSelected(this.id)) {
            // Do the following when a item is selected
            if (!this.multiSelect) {
                // Single Select
                // Pop everything else
                tempItem = this.selectedItems.pop();
                while (tempItem) {
                    if (item !== tempItem) {
                        tempItem.$bentoTreeItemOption.setSelected(false, this.id);
                    }
                    tempItem = this.selectedItems.pop();
                }
                // Add the current selected item
                this.selectedItems.push(item);
            }
            else {
                // Multiselect
                if (index === -1) {
                    this.selectedItems.push(item);
                }
            }
        }
        else if (index > -1) {
            // When a item is deselected
            this.selectedItems.splice(index, 1);
        }
        // Bubble event
        if (!silent) {
            this.itemSelect.emit({
                items: this.selectedItems.slice(),
                cancel: (/**
                 * @return {?}
                 */
                function () {
                    item.$bentoTreeItemOption.setSelected(false, _this.id);
                })
            });
        }
    };
    /**
     * API to fire item checkd state
     */
    /**
     * API to fire item checkd state
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeComponent.prototype._emitItemCheck = /**
     * API to fire item checkd state
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    function (item, silent) {
        if (silent === void 0) { silent = false; }
        if (!this.checkedItems) {
            this.checkedItems = [];
        }
        /** @type {?} */
        var index = this.checkedItems.indexOf(item);
        /** @type {?} */
        var checked = item.$bentoTreeItemOption.getChecked(this.id);
        /** @type {?} */
        var indeterminate = item.$bentoTreeItemOption.getIndeterminate(this.id);
        if (checked && !indeterminate && index === -1) {
            this.checkedItems.push(item);
        }
        else if ((!checked || indeterminate) && index > -1) {
            this.checkedItems.splice(index, 1);
        }
        // Bubble event
        if (!silent) {
            this.itemCheck.emit({ items: this.checkedItems.slice() });
        }
    };
    /**
     * API to fire item destroy state
     */
    /**
     * API to fire item destroy state
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    BentoTreeComponent.prototype._destroyTreeItem = /**
     * API to fire item destroy state
     * @param {?} item
     * @param {?=} silent
     * @return {?}
     */
    function (item, silent) {
        if (silent === void 0) { silent = false; }
        if (this.selectedItems) {
            /** @type {?} */
            var index = this.selectedItems.indexOf(item);
            if (index > -1) {
                this.selectedItems.splice(index, 1);
            }
        }
        if (this.checkedItems) {
            /** @type {?} */
            var index = this.checkedItems.indexOf(item);
            if (index > -1) {
                this.checkedItems.splice(index, 1);
            }
        }
    };
    /**
     * @private
     * @param {?} items
     * @return {?}
     */
    BentoTreeComponent.prototype.updateItems = /**
     * @private
     * @param {?} items
     * @return {?}
     */
    function (items) {
        var _this = this;
        if (Array.isArray(items)) {
            this.treeItems = items;
            if (this.isInitiated) {
                // Only update items when Tree is ready with all properties assigned
                // Update each item status based on its children statuses
                items.forEach((/**
                 * @param {?} item
                 * @return {?}
                 */
                function (item) {
                    _this.updateTreeItemStatus(item);
                }));
                // clean checked and selected items list
                this.checkedItems = [];
                this.selectedItems = [];
            }
        }
    };
    /**
     * Update Tree item data status
     */
    /**
     * Update Tree item data status
     * @private
     * @param {?} item
     * @return {?}
     */
    BentoTreeComponent.prototype.updateTreeItemStatus = /**
     * Update Tree item data status
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        /** @type {?} */
        var itemOption = (/** @type {?} */ (item.$bentoTreeItemOption));
        if (itemOption) {
            // There are predefined options
            if (itemOption.getIndeterminate && itemOption.getIndeterminate(this.id)) {
                return BentoTreeItemCheckStatus.Indeterminate;
            }
            else if (itemOption.getChecked) {
                if (itemOption.getChecked(this.id)) {
                    // This item is checked by default
                    return BentoTreeItemCheckStatus.Checked;
                }
            }
            else if (itemOption.checked) {
                // This item is checked by default
                return BentoTreeItemCheckStatus.Checked;
            }
            else if (itemOption.hideCheckbox) {
                // We return the checkbox as checked when the checkbox is not visible
                return BentoTreeItemCheckStatus.Checked;
            }
        }
        /** @type {?} */
        var children = item[this.itemChildrenProp];
        if (!children || children.length === 0) {
            // No child under this item
            return BentoTreeItemCheckStatus.Unchecked;
        }
        /** @type {?} */
        var allChecked = true;
        /** @type {?} */
        var allUnchecked = true;
        /** @type {?} */
        var allEmpty = true;
        /** @type {?} */
        var hasIndeterminate = false;
        /** @type {?} */
        var status;
        children.forEach((/**
         * @param {?} childItem
         * @return {?}
         */
        function (childItem) {
            if (childItem.$bentoTreeItemOption && childItem.$bentoTreeItemOption.hideCheckbox) {
                // This item doesn't do anything with the checkbox
                // move to the next checkbox
            }
            else {
                status = _this.updateTreeItemStatus(childItem);
                allEmpty = false;
                if (status === BentoTreeItemCheckStatus.Indeterminate) {
                    hasIndeterminate = true;
                }
                else if (status === BentoTreeItemCheckStatus.Checked) {
                    allUnchecked = false;
                }
                else if (status === BentoTreeItemCheckStatus.Unchecked) {
                    allChecked = false;
                }
            }
        }));
        item.$bentoTreeItemOption = item.$bentoTreeItemOption || new BentoTreeItemOption();
        if (hasIndeterminate || !(allUnchecked || allChecked)) {
            if (item.$bentoTreeItemOption.setIndeterminate) {
                item.$bentoTreeItemOption.setIndeterminate(true, this.id);
            }
            else {
                item.$bentoTreeItemOption.indeterminate = true;
            }
            return BentoTreeItemCheckStatus.Indeterminate;
        }
        else if (allChecked && !allEmpty) {
            if (item.$bentoTreeItemOption.setChecked) {
                item.$bentoTreeItemOption.setChecked(true, this.id);
            }
            else {
                item.$bentoTreeItemOption.checked = true;
            }
            return BentoTreeItemCheckStatus.Checked;
        }
        else {
            if (item.$bentoTreeItemOption.setChecked) {
                item.$bentoTreeItemOption.setChecked(false, this.id);
            }
            else {
                item.$bentoTreeItemOption.checked = false;
            }
            return BentoTreeItemCheckStatus.Unchecked;
        }
    };
    /** @nocollapse */
    BentoTreeComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: BentoUidService }
    ]; };
    BentoTreeComponent.propDecorators = {
        items: [{ type: Input }],
        multiSelect: [{ type: Input }],
        itemIconProp: [{ type: Input }],
        itemChildrenProp: [{ type: Input }],
        itemLabelProp: [{ type: Input }],
        itemExpandOnly: [{ type: Input }],
        selectAsCheck: [{ type: Input }],
        showCheckboxes: [{ type: Input }],
        showExpandCollapseAllButtons: [{ type: Input }],
        itemLabelTemplate: [{ type: Input }],
        itemSelect: [{ type: Output }],
        itemExpandCollapse: [{ type: Output }],
        itemCheck: [{ type: Output }],
        children: [{ type: ViewChildren, args: [forwardRef((/**
                     * @return {?}
                     */
                    function () { return BentoTreeItemComponent; })),] }],
        defaultItemLabelTemplate: [{ type: ViewChild, args: ['defaultItemLabelTemplate', { static: true },] }]
    };
BentoTreeComponent.ɵfac = function BentoTreeComponent_Factory(t) { return new (t || BentoTreeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoUidService)); };
BentoTreeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTreeComponent, selectors: [["bento-tree"]], viewQuery: function BentoTreeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c72, true);
        ɵngcc0.ɵɵviewQuery(BentoTreeItemComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultItemLabelTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.children = _t);
    } }, inputs: { items: "items", multiSelect: "multiSelect", itemIconProp: "itemIconProp", itemChildrenProp: "itemChildrenProp", itemLabelProp: "itemLabelProp", itemExpandOnly: "itemExpandOnly", selectAsCheck: "selectAsCheck", showCheckboxes: "showCheckboxes", showExpandCollapseAllButtons: "showExpandCollapseAllButtons", itemLabelTemplate: "itemLabelTemplate" }, outputs: { itemSelect: "itemSelect", itemExpandCollapse: "itemExpandCollapse", itemCheck: "itemCheck" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoUidService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [[3, "expandAllTitle", "collapseAllTitle", "expand", "collapse", 4, "ngIf"], ["class", "bento-tree-branch bento-tree-root", 4, "ngIf"], ["defaultItemLabelTemplate", ""], [3, "expandAllTitle", "collapseAllTitle", "expand", "collapse"], [1, "bento-tree-branch", "bento-tree-root"], [1, "bento-tree-branch-base"], [3, "hidden", "root", "treeItem", "showCheckbox", "labelTemplateRef", "ariaLevel", "ariaIndex", "ariaSiblings", 4, "ngFor", "ngForOf"], [3, "hidden", "root", "treeItem", "showCheckbox", "labelTemplateRef", "ariaLevel", "ariaIndex", "ariaSiblings"], [1, "bento-tree-item-label"]], template: function BentoTreeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoTreeComponent_bento_expand_collapse_button_group_0_Template, 3, 6, "bento-expand-collapse-button-group", 0);
        ɵngcc0.ɵɵtemplate(1, BentoTreeComponent_div_1_Template, 3, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, BentoTreeComponent_ng_template_2_Template, 2, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showExpandCollapseAllButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.treeItems && ctx.treeItems.length > 0);
    } }, directives: [ɵngcc7.NgIf, BentoExpandCollapseButtonGroupComponent, ɵngcc7.NgForOf, BentoTreeItemComponent], pipes: [BentoTranslatePipe], styles: ["bento-tree{display:block}bento-tree .bento-tree-branch-base{padding-left:24px;display:block;width:100%;font-size:.879rem}[dir=rtl] bento-tree .bento-tree-branch-base{padding-left:0;padding-right:24px}[dir=rtl] bento-tree .bento-tree-root>.bento-tree-branch-base{padding-left:0}bento-tree-item{list-style:none;white-space:nowrap;display:flex;align-content:stretch;margin-top:-1px;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-tree-item>div:before{display:block;position:absolute;box-sizing:border-box;content:\"\";width:100%;left:0;background:0 0}[dir=rtl] bento-tree-item>div:before{left:auto;right:0}bento-tree-item>div{width:100%}.bento-tree-alt bento-tree-item>div:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.bento-tree-alt bento-tree-item .selected:before{z-index:2}bento-tree-item .tree-item-checkbox{position:relative;z-index:2}bento-tree-item .selected:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}bento-tree-item [class*=\" bento-icon-\"],bento-tree-item [class^=bento-icon-],bento-tree-item i{font-size:1rem;margin-right:4px;line-height:1;z-index:2}[dir=rtl] bento-tree-item [class*=\" bento-icon-\"],[dir=rtl] bento-tree-item [class^=bento-icon-],[dir=rtl] bento-tree-item i{margin-right:0;margin-left:4px}bento-tree-item i.bui-checkbox-checked,bento-tree-item i.bui-checkbox-indeterminate,bento-tree-item i.bui-checkbox-unchecked{margin-right:0}[dir=rtl] bento-tree-item .bento-icon-checkbox,[dir=rtl] bento-tree-item .bento-icon-checkbox-filled,[dir=rtl] bento-tree-item .bento-icon-collapse,[dir=rtl] bento-tree-item i.bui-checkbox-checked,[dir=rtl] bento-tree-item i.bui-checkbox-indeterminate,[dir=rtl] bento-tree-item i.bui-checkbox-unchecked{margin-left:0}bento-tree-item .expand-button-compiled{display:flex;align-items:center;justify-content:center;position:relative;margin-left:-30px;z-index:2;float:left;cursor:default;text-align:center;background:0 0;border:none;padding:0;opacity:.8}[dir=rtl] bento-tree-item .expand-button-compiled{margin-left:0;margin-right:-30px;float:right}bento-tree-item .expand-button-compiled:focus,bento-tree-item .expand-button-compiled:hover{outline:0}bento-tree-item .expand-button-compiled .bento-tree-icon{font-size:1.1em}bento-tree-item .expand-button-compiled~.bento-tree-item-cta,bento-tree-item .expand-button-compiled~.bento-tree-item-cta .bento-tree-item-label{font-weight:700}bento-tree-item .expand-button-compiled:hover{opacity:1}bento-tree-item .bento-tree-icon{padding-left:28px;line-height:16px;vertical-align:middle}[dir=rtl] bento-tree-item .bento-tree-icon{padding-left:0;padding-right:28px}bento-tree-item .bento-tree-icon.second-tree-icon{padding:0;width:auto;margin:0;top:0;vertical-align:text-top}bento-tree-item .bento-tree-icon:before{font-size:1.143rem;line-height:16px;left:1px}.bento-tree-disabled{pointer-events:none}bento-tree .bento-tree-branch.bento-tree-root>.bento-tree-branch-base{margin-top:0;position:relative}.bento-tree-item-cta{display:inline-flex;align-items:center;line-height:14px;cursor:default;background-color:transparent;vertical-align:top}.bento-tree-item-cta:focus,.bento-tree-item-cta:hover{outline:0}.bento-tree-item-cta:focus .bento-tree-item-cta-wrapper,.bento-tree-item-cta:focus .bento-tree-item-cta-wrapper label,.bento-tree-item-cta:hover .bento-tree-item-cta-wrapper,.bento-tree-item-cta:hover .bento-tree-item-cta-wrapper label{text-decoration:underline}.bento-tree-item-cta:before{content:\" \";position:absolute;left:0;width:100%;background:0 0;z-index:0}[dir=rtl] .bento-tree-item-cta:before{left:auto;right:0}bento-checkbox+.bento-tree-item-cta{width:calc(100% - 22px)}i+.bento-tree-item-cta{width:calc(100% - 44px)}.selected>.bento-tree-item-cta .bento-tree-item-cta-wrapper{position:relative;z-index:2}.selected>.bento-tree-item-cta:before{content:\"\";display:block;position:absolute;z-index:2;width:4px;left:0;border-right-style:solid;border-right-width:1px;border-top:1px solid;border-bottom:1px solid}[dir=rtl] .selected>.bento-tree-item-cta:before{border-right-width:0;border-right-style:solid;border-left-style:solid;border-left-width:1px;left:auto;right:0}.bento-tree-item-cta-wrapper{width:100%;overflow:hidden;text-overflow:ellipsis;position:relative;z-index:1}.bento-tree-item-cta-wrapper label{margin-bottom:0}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTreeComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tree',
                template: "<bento-expand-collapse-button-group\n  *ngIf=\"showExpandCollapseAllButtons\"\n  [expandAllTitle]=\"'BENTO_UI_TREE_EXPAND_ALL' | bentoTranslate\"\n  [collapseAllTitle]=\"'BENTO_UI_TREE_COLLAPSE_ALL' | bentoTranslate\"\n  (expand)=\"expandAll()\"\n  (collapse)=\"collapseAll()\"\n></bento-expand-collapse-button-group>\n<div class=\"bento-tree-branch bento-tree-root\" *ngIf=\"treeItems && treeItems.length > 0\">\n  <div class=\"bento-tree-branch-base\">\n    <bento-tree-item\n      *ngFor=\"let item of treeItems; index as i\"\n      [hidden]=\"item.$bentoTreeItemOption && item.$bentoTreeItemOption.isHidden\"\n      [root]=\"_self\"\n      [treeItem]=\"item\"\n      [showCheckbox]=\"showCheckboxes\"\n      [labelTemplateRef]=\"itemLabelTemplate || defaultItemLabelTemplate\"\n      [ariaLevel]=\"1\"\n      [ariaIndex]=\"i + 1\"\n      [ariaSiblings]=\"treeItems\"\n    ></bento-tree-item>\n  </div>\n</div>\n<ng-template #defaultItemLabelTemplate let-n=\"item\" let-r=\"treeRoot\" let-uid=\"itemUID\">\n  <label class=\"bento-tree-item-label\" [attr.id]=\"'label-' + uid\">\n    {{ n[r.itemLabelProp] }}\n  </label>\n</ng-template>\n",
                providers: [BentoUidService],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-tree{display:block}bento-tree .bento-tree-branch-base{padding-left:24px;display:block;width:100%;font-size:.879rem}[dir=rtl] bento-tree .bento-tree-branch-base{padding-left:0;padding-right:24px}[dir=rtl] bento-tree .bento-tree-root>.bento-tree-branch-base{padding-left:0}bento-tree-item{list-style:none;white-space:nowrap;display:flex;align-content:stretch;margin-top:-1px;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-tree-item>div:before{display:block;position:absolute;box-sizing:border-box;content:\"\";width:100%;left:0;background:0 0}[dir=rtl] bento-tree-item>div:before{left:auto;right:0}bento-tree-item>div{width:100%}.bento-tree-alt bento-tree-item>div:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}.bento-tree-alt bento-tree-item .selected:before{z-index:2}bento-tree-item .tree-item-checkbox{position:relative;z-index:2}bento-tree-item .selected:before{border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid}bento-tree-item [class*=\" bento-icon-\"],bento-tree-item [class^=bento-icon-],bento-tree-item i{font-size:1rem;margin-right:4px;line-height:1;z-index:2}[dir=rtl] bento-tree-item [class*=\" bento-icon-\"],[dir=rtl] bento-tree-item [class^=bento-icon-],[dir=rtl] bento-tree-item i{margin-right:0;margin-left:4px}bento-tree-item i.bui-checkbox-checked,bento-tree-item i.bui-checkbox-indeterminate,bento-tree-item i.bui-checkbox-unchecked{margin-right:0}[dir=rtl] bento-tree-item .bento-icon-checkbox,[dir=rtl] bento-tree-item .bento-icon-checkbox-filled,[dir=rtl] bento-tree-item .bento-icon-collapse,[dir=rtl] bento-tree-item i.bui-checkbox-checked,[dir=rtl] bento-tree-item i.bui-checkbox-indeterminate,[dir=rtl] bento-tree-item i.bui-checkbox-unchecked{margin-left:0}bento-tree-item .expand-button-compiled{display:flex;align-items:center;justify-content:center;position:relative;margin-left:-30px;z-index:2;float:left;cursor:default;text-align:center;background:0 0;border:none;padding:0;opacity:.8}[dir=rtl] bento-tree-item .expand-button-compiled{margin-left:0;margin-right:-30px;float:right}bento-tree-item .expand-button-compiled:focus,bento-tree-item .expand-button-compiled:hover{outline:0}bento-tree-item .expand-button-compiled .bento-tree-icon{font-size:1.1em}bento-tree-item .expand-button-compiled~.bento-tree-item-cta,bento-tree-item .expand-button-compiled~.bento-tree-item-cta .bento-tree-item-label{font-weight:700}bento-tree-item .expand-button-compiled:hover{opacity:1}bento-tree-item .bento-tree-icon{padding-left:28px;line-height:16px;vertical-align:middle}[dir=rtl] bento-tree-item .bento-tree-icon{padding-left:0;padding-right:28px}bento-tree-item .bento-tree-icon.second-tree-icon{padding:0;width:auto;margin:0;top:0;vertical-align:text-top}bento-tree-item .bento-tree-icon:before{font-size:1.143rem;line-height:16px;left:1px}.bento-tree-disabled{pointer-events:none}bento-tree .bento-tree-branch.bento-tree-root>.bento-tree-branch-base{margin-top:0;position:relative}.bento-tree-item-cta{display:inline-flex;align-items:center;line-height:14px;cursor:default;background-color:transparent;vertical-align:top}.bento-tree-item-cta:focus,.bento-tree-item-cta:hover{outline:0}.bento-tree-item-cta:focus .bento-tree-item-cta-wrapper,.bento-tree-item-cta:focus .bento-tree-item-cta-wrapper label,.bento-tree-item-cta:hover .bento-tree-item-cta-wrapper,.bento-tree-item-cta:hover .bento-tree-item-cta-wrapper label{text-decoration:underline}.bento-tree-item-cta:before{content:\" \";position:absolute;left:0;width:100%;background:0 0;z-index:0}[dir=rtl] .bento-tree-item-cta:before{left:auto;right:0}bento-checkbox+.bento-tree-item-cta{width:calc(100% - 22px)}i+.bento-tree-item-cta{width:calc(100% - 44px)}.selected>.bento-tree-item-cta .bento-tree-item-cta-wrapper{position:relative;z-index:2}.selected>.bento-tree-item-cta:before{content:\"\";display:block;position:absolute;z-index:2;width:4px;left:0;border-right-style:solid;border-right-width:1px;border-top:1px solid;border-bottom:1px solid}[dir=rtl] .selected>.bento-tree-item-cta:before{border-right-width:0;border-right-style:solid;border-left-style:solid;border-left-width:1px;left:auto;right:0}.bento-tree-item-cta-wrapper{width:100%;overflow:hidden;text-overflow:ellipsis;position:relative;z-index:1}.bento-tree-item-cta-wrapper label{margin-bottom:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: BentoUidService }]; }, { items: [{
            type: Input
        }], multiSelect: [{
            type: Input
        }], itemIconProp: [{
            type: Input
        }], itemChildrenProp: [{
            type: Input
        }], itemLabelProp: [{
            type: Input
        }], itemExpandOnly: [{
            type: Input
        }], selectAsCheck: [{
            type: Input
        }], showCheckboxes: [{
            type: Input
        }], showExpandCollapseAllButtons: [{
            type: Input
        }], itemLabelTemplate: [{
            type: Input
        }], itemSelect: [{
            type: Output
        }], itemExpandCollapse: [{
            type: Output
        }], itemCheck: [{
            type: Output
        }], children: [{
            type: ViewChildren,
            args: [forwardRef(( /**
                             * @return {?}
                             */function () { return BentoTreeItemComponent; }))]
        }], defaultItemLabelTemplate: [{
            type: ViewChild,
            args: ['defaultItemLabelTemplate', { static: true }]
        }] }); })();
    return BentoTreeComponent;
}(BentoTreeBranch));
if (false) {
    /**
     * Main collection to render this tree
     * @type {?}
     */
    BentoTreeComponent.prototype.treeItems;
    /**
     * Flag to multiple tree items can be selected
     * @type {?}
     */
    BentoTreeComponent.prototype.multiSelect;
    /**
     * Property name to define tree item icon class name
     * @type {?}
     */
    BentoTreeComponent.prototype.itemIconProp;
    /**
     * Property name to define tree branch children array reference
     * @type {?}
     */
    BentoTreeComponent.prototype.itemChildrenProp;
    /**
     * Property name to define the value of a tree item
     * @type {?}
     */
    BentoTreeComponent.prototype.itemLabelProp;
    /**
     * Flag to only expand or collapse a tree branch
     * @type {?}
     */
    BentoTreeComponent.prototype.itemExpandOnly;
    /**
     * Flag to a tree item click is considered as a checkbox click
     * @type {?}
     */
    BentoTreeComponent.prototype.selectAsCheck;
    /**
     * Flag to show all checkbobox components
     * @type {?}
     */
    BentoTreeComponent.prototype.showCheckboxes;
    /**
     * Flag to show the expand and collapse all buttons
     * @type {?}
     */
    BentoTreeComponent.prototype.showExpandCollapseAllButtons;
    /**
     * Custom label template to be applied to each tree item
     * @type {?}
     */
    BentoTreeComponent.prototype.itemLabelTemplate;
    /**
     * Callback to when a item is selected
     * @type {?}
     */
    BentoTreeComponent.prototype.itemSelect;
    /**
     * Callback to when a tree item is expanded or collapsed
     * @type {?}
     */
    BentoTreeComponent.prototype.itemExpandCollapse;
    /**
     * Callback to when a item is checked
     * @type {?}
     */
    BentoTreeComponent.prototype.itemCheck;
    /** @type {?} */
    BentoTreeComponent.prototype.children;
    /** @type {?} */
    BentoTreeComponent.prototype._self;
    /** @type {?} */
    BentoTreeComponent.prototype.checkedItems;
    /** @type {?} */
    BentoTreeComponent.prototype.selectedItems;
    /** @type {?} */
    BentoTreeComponent.prototype.defaultItemLabelTemplate;
    /** @type {?} */
    BentoTreeComponent.prototype.api;
    /**
     * ID is defined by HTML "id" attribute or an UID will be assigned by the BentoUidService
     * @type {?}
     */
    BentoTreeComponent.prototype.id;
    /**
     * HTMLElement of this component
     * @type {?}
     */
    BentoTreeComponent.prototype.el;
    /**
     * Unique ID Generated by this tree
     * @type {?}
     */
    BentoTreeComponent.prototype.uid;
    /**
     * @type {?}
     * @private
     */
    BentoTreeComponent.prototype.isInitiated;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tree/tree-view.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DEFAULT_PADDING_LEFT = 25;
/** @type {?} */
var BENTO_TREE_ITEM_OPTION = '$bentoTreeItemOption';
/** @type {?} */
var counterId = 0;
/**
 * Tree view that creates a hierarchical view of items in a collection in a panel.
 * Users can expand/collapse items in the tree to view the content of the children items,
 * and they can also select individual items.
 *
 * #### Keyboard Shortcuts
 * _One of the tree items must be focused, for shortcut to function._
 * | Key | Function |
 * | --- | -------- |
 * | <kbd>UP ARROW</kbd> | Select the previous visible tree item.
 * | <kbd>DOWN ARROW</kbd> | Select next visible tree item |
 * | <kbd>LEFT ARROW</kbd> | Collapse the currently selected parent item if it is expanded. Move to the previous parent
 * node (if possible) when the current parent item is collapsed. Move to the previous element in a tree item| |
 * <kbd>RIGHT ARROW</kbd> | Expand the currently selected parent item and move to the first child list item. Move to the
 * previous element in a tree item | | <kbd>HOME</kbd> | Select the root parent node of the tree | | <kbd>END</kbd> |
 * Select the last visible node of the tree | | <kbd>TAB</kbd> | Navigate away from tree | | <kbd>*</kbd> (requires
 * numeric keypad) | Expand all group items |
 *
 */
var BentoTreeViewComponent = /** @class */ (function () {
    function BentoTreeViewComponent(winRef, elRef, resizeNotification, directionality, r, changeDetector) {
        var _this = this;
        this.r = r;
        this.changeDetector = changeDetector;
        /**
         * Flag to determine of the items are collapsed when initially added/appended to the Tree View component
         */
        this.collapseItemsOnAdd = false;
        /**
         * Flag to multiple tree items can be selected
         */
        this.multiSelect = false;
        /**
         * Flag to only expand or collapse a tree branch
         */
        this.itemExpandOnly = false;
        /**
         * Flag to a tree item click is considered as a checkbox click
         */
        this.selectAsCheck = false;
        /**
         * Flag to show all checkbobox components
         */
        this.showCheckboxes = true;
        /**
         * Flag to disable tree node selection
         */
        this.disableSelection = false;
        /**
         * Flag to show the expand and collapse all buttons
         */
        this.showExpandCollapseAllButtons = false;
        /**
         * Make checkboxes to be independent from hierachical relationships
         */
        this.independentCheckbox = false;
        /**
         * Disable HTML focus on leaf items to accomondate custom templates
         */
        this.disableFocusOnLeaves = false;
        /**
         * Callback to when a item is checked
         */
        this.itemCheck = new EventEmitter();
        /**
         * Callback to when a tree item is expanded or collapsed
         */
        this.itemExpandCollapse = new EventEmitter();
        /**
         * Callback to when a item is selected
         */
        this.itemSelect = new EventEmitter();
        /**
         * Default row height
         */
        this.rowHeight = 30;
        /**
         * Flag to determine if APP is in RTL mode
         */
        this.isRTL = false;
        /**
         * Padding left of each level
         */
        this._paddingLeft = DEFAULT_PADDING_LEFT;
        this.uid = "bui-treeview-" + counterId++;
        this.selectedItems = [];
        this.checkedItems = [];
        this.resizeSubscription = Subscription.EMPTY;
        /**
         * NodeList index where the current focus is assigned to within a tree item row HTMLElement.
         */
        this.activeRowFocusIndex = 0;
        this.directionChangeSubscription = Subscription.EMPTY;
        this.componentInitialized = false;
        this.itemSubscriptions = [];
        // Init some values
        this.document = winRef.nativeDocument;
        this.el = elRef.nativeElement;
        this.isRTL = directionality.value === 'rtl';
        // Subscribe to resize and direction change
        this.resizeSubscription = resizeNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this.checkViewportSize(); }));
        this.directionChangeSubscription = directionality.change.subscribe((/**
         * @param {?} dir
         * @return {?}
         */
        function (dir) {
            _this.isRTL = dir === 'rtl';
            _this.changeDetector.markForCheck();
        }));
    }
    Object.defineProperty(BentoTreeViewComponent.prototype, "items", {
        /**
         * Main Bento Tree data
         */
        set: /**
         * Main Bento Tree data
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                this.itemsData = data;
                if (this.componentInitialized) {
                    this.initData(data);
                }
            }
            else {
                // Do there is no tree data yet
                this._itemsFlatData = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoTreeViewComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.componentInitialized = true;
        if (this.itemsData) {
            this.initData(this.itemsData);
        }
    };
    /**
     * @return {?}
     */
    BentoTreeViewComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
        this.directionChangeSubscription.unsubscribe();
        this.unsubscribeAllItems();
    };
    /**
     * Expand all nodes
     */
    /**
     * Expand all nodes
     * @return {?}
     */
    BentoTreeViewComponent.prototype.expandAllGroups = /**
     * Expand all nodes
     * @return {?}
     */
    function () {
        var e_1, _a;
        try {
            // Only there are children
            for (var _b = __values(this.itemsData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                // expand each child
                this.setAllItemCollapsedState(item, false);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.checkViewportSize();
    };
    /**
     * Collapse all nodes
     */
    /**
     * Collapse all nodes
     * @return {?}
     */
    BentoTreeViewComponent.prototype.collapseAllGroups = /**
     * Collapse all nodes
     * @return {?}
     */
    function () {
        var e_2, _a;
        try {
            // Only there are children
            for (var _b = __values(this.itemsData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                // expand each child
                this.setAllItemCollapsedState(item, true);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.checkViewportSize();
    };
    /**
     * Check tree viewport size and re-render
     */
    /**
     * Check tree viewport size and re-render
     * @return {?}
     */
    BentoTreeViewComponent.prototype.checkViewportSize = /**
     * Check tree viewport size and re-render
     * @return {?}
     */
    function () {
        this.cdkViewport.checkViewportSize();
    };
    /**
     * When expand/collapse button is clicked
     */
    /**
     * When expand/collapse button is clicked
     * @param {?} item
     * @return {?}
     */
    BentoTreeViewComponent.prototype._onExpandCollapseClick = /**
     * When expand/collapse button is clicked
     * @param {?} item
     * @return {?}
     */
    function (item) {
        /** @type {?} */
        var children = (/** @type {?} */ (item[this.itemChildrenProp]));
        if (!Array.isArray(children)) {
            // This item is not a root of a branch
            return;
        }
        /** @type {?} */
        var option = item[BENTO_TREE_ITEM_OPTION];
        /** @type {?} */
        var isCollapsed = option.getCollapsed(this.id);
        // Update status
        option.setCollapsed(!isCollapsed, this.id);
    };
    /**
     * @param {?} v
     * @param {?} item
     * @return {?}
     */
    BentoTreeViewComponent.prototype._onCheckChanged = /**
     * @param {?} v
     * @param {?} item
     * @return {?}
     */
    function (v, item) {
        /** @type {?} */
        var options = item[BENTO_TREE_ITEM_OPTION];
        options.setChecked(v, this.id);
        this.itemCheck.emit({ items: this.checkedItems.slice() });
    };
    /**
     * @param {?} target
     * @param {?} item
     * @return {?}
     */
    BentoTreeViewComponent.prototype._onItemCTAClick = /**
     * @param {?} target
     * @param {?} item
     * @return {?}
     */
    function (target, item) {
        var _this = this;
        /** @type {?} */
        var options = item[BENTO_TREE_ITEM_OPTION];
        /** @type {?} */
        var activeRowID = this.getFocusedGroupID();
        if (activeRowID == null) {
            // There is no activeRow
            /* istanbul ignore next */
            return;
        }
        /** @type {?} */
        var groupFocusables = this.getFocusableElements(activeRowID);
        // Set the active row item index for up/down keyboard supprot
        this.activeRowFocusIndex = Math.max(0, groupFocusables ? groupFocusables.indexOf(target) : 0);
        if (this.selectAsCheck) {
            this._onCheckChanged(!options.getChecked(this.id), item);
        }
        else if (this.itemExpandOnly) {
            this._onExpandCollapseClick(item);
        }
        else {
            if (!this.disableSelection) {
                /** @type {?} */
                var nextSelectionStatus_1 = !options.getSelected(this.id);
                options.setSelected(nextSelectionStatus_1, this.id);
                if (nextSelectionStatus_1) {
                    this.animateSelectionFeedback(target);
                }
                this.itemSelect.emit({
                    items: this.selectedItems,
                    cancel: (/**
                     * @return {?}
                     */
                    function () {
                        // Revert previous selection
                        options.setSelected(!nextSelectionStatus_1, _this.id);
                    })
                });
            }
        }
    };
    /**
     * Forward focus onto the first focusable item in the tree
     */
    /**
     * Forward focus onto the first focusable item in the tree
     * @return {?}
     */
    BentoTreeViewComponent.prototype._onCDKViewportFocus = /**
     * Forward focus onto the first focusable item in the tree
     * @return {?}
     */
    function () {
        /** @type {?} */
        var focusableEls = this.getFocusableElements(Math.ceil(this.cdkViewport.measureScrollOffset('top') / this.rowHeight));
        if (focusableEls.length) {
            focusableEls[0].focus();
        }
    };
    /**
     * Making sure that the flattened tree items are rendered in order correctly
     */
    /**
     * Making sure that the flattened tree items are rendered in order correctly
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    BentoTreeViewComponent.prototype._itemOrderTrackBy = /**
     * Making sure that the flattened tree items are rendered in order correctly
     * @param {?} index
     * @param {?} item
     * @return {?}
     */
    function (index, item) {
        return index;
    };
    /**
     * @param {?} e
     * @param {?} keyCode
     * @return {?}
     */
    BentoTreeViewComponent.prototype.onTreeKeydown = /**
     * @param {?} e
     * @param {?} keyCode
     * @return {?}
     */
    function (e, keyCode) {
        /** @type {?} */
        var activeRowID = this.getFocusedGroupID();
        if (activeRowID == null) {
            // Do nothing when there is no active row
            /* istanbul ignore next */
            return;
        }
        /** @type {?} */
        var activeEl = (/** @type {?} */ (this.document.activeElement));
        /** @type {?} */
        var focusableElements = this.getFocusableElements(activeRowID);
        /** @type {?} */
        var item = this._itemsFlatData[activeRowID];
        /** @type {?} */
        var options = item[BENTO_TREE_ITEM_OPTION];
        /** @type {?} */
        var activeElementFocusIndex = focusableElements.indexOf(activeEl);
        switch (keyCode) {
            case Keyboard.UP: // Arrow up
                if (activeRowID > 0) {
                    this.focusToCTA(activeRowID - 1, this.activeRowFocusIndex);
                }
                e.preventDefault();
                break;
            case Keyboard.DOWN: // Arrow Down
                this.focusToCTA(activeRowID + 1, this.activeRowFocusIndex);
                e.preventDefault();
                break;
            case Keyboard.RIGHT:
            case Keyboard.LEFT:
                if ((keyCode === Keyboard.RIGHT && !this.isRTL) || (keyCode === Keyboard.LEFT && this.isRTL)) {
                    // RIGHT in LTR or LEFT in RTL
                    if (Array.isArray(item[this.itemChildrenProp]) && activeElementFocusIndex === focusableElements.length - 1) {
                        if (options.getCollapsed(this.id)) {
                            // Expand this item if its collapsed
                            options.setCollapsed(false, this.id);
                        }
                        else if (item[this.itemChildrenProp].length > 0) {
                            // Move focus to the next row in CDK
                            this.focusToCTA(activeRowID + 1, this.activeRowFocusIndex);
                        }
                    }
                    else {
                        // Move focus to next focusable sibling element
                        this.activeRowFocusIndex = Math.min(focusableElements.length - 1, activeElementFocusIndex + 1);
                        focusableElements[this.activeRowFocusIndex].focus();
                    }
                }
                else {
                    // Left in LTR or RIGHT in RTL
                    if (activeElementFocusIndex === 0) {
                        if (Array.isArray(item[this.itemChildrenProp]) && !options.getCollapsed(this.id)) {
                            // This item has children and is expanded
                            // so we collapse it
                            options.setCollapsed(true, this.id);
                        }
                        else {
                            // This item is either collapsed or doesn't have children
                            // We move up to its parent node
                            /** @type {?} */
                            var parent_1 = options.parent;
                            if (parent_1) {
                                /** @type {?} */
                                var parentIndex = this._itemsFlatData.indexOf(parent_1);
                                // The current item could be root
                                this.showRowIndex(this._itemsFlatData.indexOf(parent_1));
                                // Looks like the index doesn't show right away
                                this.focusToCTA(parentIndex, this.activeRowFocusIndex);
                            }
                        }
                    }
                    else {
                        // Move focus to previous focusable sibling element
                        focusableElements[(this.activeRowFocusIndex = activeElementFocusIndex - 1)].focus();
                    }
                }
                e.preventDefault();
                break;
            case Keyboard.HOME: // Focus on the first root
                this.showRowIndex(0);
                this.focusToCTA(0, (this.activeRowFocusIndex = 0));
                e.preventDefault();
                break;
            case Keyboard.END: // Focus on the last item in viewport
                // Focus on the last item in viewport
                /** @type {?} */
                var lastIndex = this._itemsFlatData.length - 1;
                this.showRowIndex(lastIndex);
                this.focusToCTA(lastIndex, 100);
                e.preventDefault();
                break;
            case Keyboard.NUM_ASTERISK: // Expand all nodes
                this.expandAllGroups();
                e.preventDefault();
                break;
            case Keyboard.ENTER:
            case Keyboard.SPACE:
                if (!this.disableFocusOnLeaves && activeEl.classList.contains('bui-tree-item-cta')) {
                    // Only applies to CTA
                    this._onItemCTAClick(activeEl, item);
                    e.preventDefault();
                }
                break;
        }
    };
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    BentoTreeViewComponent.prototype.initData = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var e_3, _a;
        this.unsubscribeAllItems();
        this.processItemTreeCollection(null, data);
        if (!this.independentCheckbox && this.showCheckboxes) {
            if (Array.isArray(data)) {
                try {
                    for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                        var item = data_1_1.value;
                        this.updateCheckedState(item);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        this.changeDetector.markForCheck();
    };
    /**
     * Get focuable elements by its rowID within CTA label
     * Will return CTA label element only if there is no focusable children
     */
    /**
     * Get focuable elements by its rowID within CTA label
     * Will return CTA label element only if there is no focusable children
     * @private
     * @param {?} rowID
     * @return {?}
     */
    BentoTreeViewComponent.prototype.getFocusableElements = /**
     * Get focuable elements by its rowID within CTA label
     * Will return CTA label element only if there is no focusable children
     * @private
     * @param {?} rowID
     * @return {?}
     */
    function (rowID) {
        /** @type {?} */
        var treeItemEl = (/** @type {?} */ (this.el.querySelector("#" + (this.id || this.uid) + "-" + rowID)));
        /** @type {?} */
        var focusSelectorStr = 'button:not(:disabled):not(.bui-tree-view-expand-collapse-btn),' +
            'a[href]:not(:disabled), [tabindex]:not(.bui-tree-view-expand-collapse-btn), input:not(:disabled)';
        return (/** @type {?} */ (Array.from(treeItemEl.querySelectorAll(focusSelectorStr))));
    };
    /**
     * Get tree item ID from the currently focused element
     */
    /**
     * Get tree item ID from the currently focused element
     * @private
     * @return {?}
     */
    BentoTreeViewComponent.prototype.getFocusedGroupID = /**
     * Get tree item ID from the currently focused element
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var cdkScrollEl = this.cdkViewport.getElementRef().nativeElement;
        /** @type {?} */
        var activeEl = this.document.activeElement;
        if (cdkScrollEl.contains(activeEl)) {
            /** @type {?} */
            var treeItemIDBase = (this.id || this.uid) + "-";
            // Only get rowID when the focus is in the CDKScrollable
            /** @type {?} */
            var parent_2 = activeEl.parentElement;
            while (!parent_2.hasAttribute('id') || parent_2.getAttribute('id').indexOf(treeItemIDBase) < 0) {
                parent_2 = parent_2.parentElement;
                if (parent_2 == null) {
                    // just in case
                    /* istanbul ignore next */
                    return null;
                }
            }
            return parseInt(parent_2
                .getAttribute('id')
                .split('-')
                .pop(), 10);
        }
    };
    /**
     * Append child/children to an item
     */
    /**
     * Append child/children to an item
     * @private
     * @param {?} children
     * @param {?} item
     * @return {?}
     */
    BentoTreeViewComponent.prototype.appendChildrenToItem = /**
     * Append child/children to an item
     * @private
     * @param {?} children
     * @param {?} item
     * @return {?}
     */
    function (children, item) {
        var e_4, _a;
        /** @type {?} */
        var itemsToAppend = Array.isArray(children) ? children : [children];
        /** @type {?} */
        var itemChildren = item[this.itemChildrenProp];
        /** @type {?} */
        var options = item[BENTO_TREE_ITEM_OPTION];
        if (itemChildren) {
            // There are already children, we concact the two arrays
            item[this.itemChildrenProp] = itemChildren.concat(itemsToAppend);
        }
        else {
            // No children
            item[this.itemChildrenProp] = itemsToAppend;
        }
        if (!options.getCollapsed(this.id)) {
            // Remove descendants first
            this.removeDescendants(item);
        }
        // Only process the items that are new
        this.processItemTreeCollection(item, item[this.itemChildrenProp], item[BENTO_TREE_ITEM_OPTION].level + 1);
        // Need to refresh the view
        this._itemsFlatData = this._itemsFlatData.slice();
        if (!this.independentCheckbox && this.showCheckboxes) {
            try {
                // Again
                // Check all checkboxes
                for (var _b = __values(this.itemsData), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var treeItem = _c.value;
                    this.updateCheckedState(treeItem);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        this.changeDetector.markForCheck();
    };
    /**
     * @private
     * @param {?} item
     * @param {?} state
     * @return {?}
     */
    BentoTreeViewComponent.prototype.checkChildren = /**
     * @private
     * @param {?} item
     * @param {?} state
     * @return {?}
     */
    function (item, state) {
        var e_5, _a;
        /** @type {?} */
        var children = item[this.itemChildrenProp];
        if (Array.isArray(children)) {
            try {
                for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                    var child = children_1_1.value;
                    child[BENTO_TREE_ITEM_OPTION].setChecked(state, this.id, false); // Do not bubble
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
    };
    /**
     * Focus to an element by its given id
     */
    /**
     * Focus to an element by its given id
     * @private
     * @param {?} rowIndex
     * @param {?} index
     * @return {?}
     */
    BentoTreeViewComponent.prototype.focusToCTA = /**
     * Focus to an element by its given id
     * @private
     * @param {?} rowIndex
     * @param {?} index
     * @return {?}
     */
    function (rowIndex, index) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var elements = _this.getFocusableElements(rowIndex);
            if (elements) {
                elements[Math.min(index, elements.length - 1)].focus();
            }
        }), 100);
    };
    /**
     * Insert all the descendants of a parent in to the flattened array
     */
    /**
     * Insert all the descendants of a parent in to the flattened array
     * @private
     * @param {?} parent
     * @return {?}
     */
    BentoTreeViewComponent.prototype.insertDescendants = /**
     * Insert all the descendants of a parent in to the flattened array
     * @private
     * @param {?} parent
     * @return {?}
     */
    function (parent) {
        var _a, e_6, _b;
        /** @type {?} */
        var option = parent[BENTO_TREE_ITEM_OPTION];
        if (option.getCollapsed(this.id)) {
            // This node is collapsed so there is no need to insert its children
            return;
        }
        /** @type {?} */
        var children = parent[this.itemChildrenProp];
        if (Array.isArray(children)) {
            // Get the index where the current parent is located in the flatArray
            // Insert its children after the index
            /** @type {?} */
            var index = this._itemsFlatData.indexOf(parent) + 1;
            (_a = this._itemsFlatData).splice.apply(_a, __spread([index, 0], children));
            try {
                for (var children_2 = __values(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
                    var child = children_2_1.value;
                    // Do the same to each child
                    this.insertDescendants(child);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (children_2_1 && !children_2_1.done && (_b = children_2.return)) _b.call(children_2);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        this._itemsFlatData = this._itemsFlatData.slice();
    };
    /**
     * Process an item's ComboboxOption property
     * @param item Tree node item
     */
    /**
     * Process an item's ComboboxOption property
     * @private
     * @param {?} item Tree node item
     * @param {?} parent
     * @param {?} siblings
     * @param {?} index
     * @param {?} level
     * @return {?}
     */
    BentoTreeViewComponent.prototype.processItemOption = /**
     * Process an item's ComboboxOption property
     * @private
     * @param {?} item Tree node item
     * @param {?} parent
     * @param {?} siblings
     * @param {?} index
     * @param {?} level
     * @return {?}
     */
    function (item, parent, siblings, index, level) {
        var _this = this;
        /** @type {?} */
        var options = ((/** @type {?} */ (item[BENTO_TREE_ITEM_OPTION]))) ||
            new BentoTreeItemOption(undefined, undefined, this.collapseItemsOnAdd, undefined, undefined, undefined, undefined, undefined, level, siblings, index, parent);
        if (!(options instanceof BentoTreeItemOption)) {
            // Options is a simple Object need to convert it to Class
            options = new BentoTreeItemOption(((/** @type {?} */ (options))).checked, ((/** @type {?} */ (options))).selected, ((/** @type {?} */ (options))).collapsed == null ? this.collapseItemsOnAdd : ((/** @type {?} */ (options))).collapsed, ((/** @type {?} */ (options))).indeterminate, ((/** @type {?} */ (options))).hideCheckbox, ((/** @type {?} */ (options))).preventSelection, ((/** @type {?} */ (options))).isHidden, ((/** @type {?} */ (options))).disabled, level, siblings, index, parent);
        }
        if (options.selected) {
            this.selectedItems.push(item);
        }
        item[BENTO_TREE_ITEM_OPTION] = options;
        /** @type {?} */
        var subs = this.itemSubscriptions;
        subs[subs.length] = options._itemAppend.subscribe((/**
         * @param {?} children
         * @return {?}
         */
        function (children) { return _this.appendChildrenToItem(children, item); }));
        // selected subscription
        subs[subs.length] = options._selectedChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId == _this.id) {
                if (res.v) {
                    // Update selection
                    _this.updateSelections(item);
                }
                else {
                    /** @type {?} */
                    var itemIndex = _this.selectedItems.indexOf(item);
                    if (itemIndex > -1) {
                        _this.selectedItems.splice(itemIndex, 1);
                    }
                }
            }
        }));
        // collapsed subscription
        // this.collapsedSubscription =
        subs[subs.length] = options._collapsedChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.id) {
                /** @type {?} */
                var children = item[_this.itemChildrenProp];
                /** @type {?} */
                var cancel_1 = false;
                /** @type {?} */
                var changed_1 = false;
                if (!Array.isArray(children)) {
                    // No need to remove or add descendants from the viewport array
                    return;
                }
                _this.itemExpandCollapse.emit({
                    item: item,
                    cancel: (/**
                     * @return {?}
                     */
                    function () {
                        cancel_1 = true;
                        // If the collapse state chaneg has already executed revert it
                        // otherwise revert it silently with disturbing the UI
                        options.setCollapsed(!options.getCollapsed(_this.id), _this.id, !changed_1);
                    })
                });
                if (!cancel_1) {
                    if (_this._itemsFlatData.indexOf(item) > -1) {
                        // Update view
                        if (res.v) {
                            // Will remove its descendants
                            _this.removeDescendants(item);
                        }
                        else {
                            // Will insert its descendants
                            _this.insertDescendants(item);
                        }
                    }
                    _this.checkViewportSize();
                    changed_1 = true;
                }
            }
        }));
        // check subscription
        subs[subs.length] = options._checkedChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.id || // a check change targeting this tree with a treeId
                res.treeId == null // wildcard on treeId
            ) {
                if (res.bubble) {
                    // Only emit item check change when it needs to bubble up
                    if (item[BENTO_TREE_ITEM_OPTION].parent &&
                        !_this.independentCheckbox // There is no parent-child relationship for checkbox
                    ) {
                        _this.updateParentCheckState(item[BENTO_TREE_ITEM_OPTION].parent);
                    }
                }
                // Get Iten index
                /** @type {?} */
                var itemIndex = _this.checkedItems.indexOf(item);
                if (res.v && itemIndex === -1) {
                    // If item is checked and is not in `checkedItem` array
                    _this.checkedItems.push(item);
                }
                else if (!res.v && itemIndex > -1) {
                    // If item is NOT checked and is in `checkedItem` array
                    _this.checkedItems.splice(itemIndex, 1);
                }
                if (!options.getIndeterminate(_this.id) &&
                    !res.silent &&
                    !_this.independentCheckbox // There is no parent-child relationship for checkbox
                ) {
                    // Set check status on children only when the dataModel of this tree item does not
                    // have indeterminate state
                    _this.checkChildren(item, res.v);
                }
            }
        }));
        // // indeterminate
        subs[subs.length] = options._indeterminateChange.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            if (res.treeId === _this.id || res.treeId == null) {
                _this.updateParentCheckState(options.parent);
            }
        }));
    };
    /**
     * Flatten a tree structed array for view
     */
    /**
     * Flatten a tree structed array for view
     * @private
     * @param {?} parent
     * @param {?} children
     * @param {?=} level
     * @return {?}
     */
    BentoTreeViewComponent.prototype.processItemTreeCollection = /**
     * Flatten a tree structed array for view
     * @private
     * @param {?} parent
     * @param {?} children
     * @param {?=} level
     * @return {?}
     */
    function (parent, children, level) {
        if (level === void 0) { level = 1; }
        if (parent == null) {
            // This is the root of the tree so we start fresh
            this._itemsFlatData = children.slice();
        }
        else {
            // Look for parent's index in flattened data array and insert its children
            /** @type {?} */
            var fData = this._itemsFlatData;
            /** @type {?} */
            var parentOptions = parent[BENTO_TREE_ITEM_OPTION];
            // Insert children into fData only if parend is expanded
            if (!parentOptions.getCollapsed(this.id)) {
                /** @type {?} */
                var index = fData.indexOf(parent);
                if (index > -1) {
                    // Parent exists in view
                    fData.splice.apply(fData, __spread([index + 1, 0], children));
                }
            }
        }
        for (var i = 0; i < children.length; i++) {
            /** @type {?} */
            var item = children[i];
            /** @type {?} */
            var itemChildren = item[this.itemChildrenProp];
            this.processItemOption(item, parent, children, i, level);
            if (Array.isArray(itemChildren)) {
                // Process children
                this.processItemTreeCollection(item, itemChildren, level + 1);
            }
        }
    };
    /**
     * Remove all descendants of the parent from the flattened array
     */
    /**
     * Remove all descendants of the parent from the flattened array
     * @private
     * @param {?} parent
     * @return {?}
     */
    BentoTreeViewComponent.prototype.removeDescendants = /**
     * Remove all descendants of the parent from the flattened array
     * @private
     * @param {?} parent
     * @return {?}
     */
    function (parent) {
        /** @type {?} */
        var startIndex = this._itemsFlatData.indexOf(parent) + 1;
        /** @type {?} */
        var endIndex = -1;
        /** @type {?} */
        var me = parent;
        while (endIndex < 0) {
            /** @type {?} */
            var option = me[BENTO_TREE_ITEM_OPTION];
            if (option.index < option.siblingSize) {
                // Found! There is a younger sibling
                // 1 based indexing
                endIndex = this._itemsFlatData.indexOf(option.siblings[option.index]);
            }
            else if (option.parent) {
                // Nope! Need to find itemMarkers parent's younger sibling
                me = option.parent;
            }
            else {
                // This `parent` is the last parent here
                // remove the reset
                endIndex = this._itemsFlatData.length;
            }
        }
        // Now we remove
        this._itemsFlatData.splice(startIndex, endIndex - startIndex);
        this._itemsFlatData = this._itemsFlatData.slice();
    };
    /**
     * Expand or collapse all item and its descendants
     */
    /**
     * Expand or collapse all item and its descendants
     * @private
     * @param {?} item
     * @param {?} state
     * @return {?}
     */
    BentoTreeViewComponent.prototype.setAllItemCollapsedState = /**
     * Expand or collapse all item and its descendants
     * @private
     * @param {?} item
     * @param {?} state
     * @return {?}
     */
    function (item, state) {
        var e_7, _a;
        /** @type {?} */
        var children;
        children = item[this.itemChildrenProp];
        if (Array.isArray(children)) {
            ((/** @type {?} */ (item[BENTO_TREE_ITEM_OPTION]))).setCollapsed(state, this.id);
        }
        if (children && children.length > 0) {
            try {
                // Only there are children
                for (var children_3 = __values(children), children_3_1 = children_3.next(); !children_3_1.done; children_3_1 = children_3.next()) {
                    var child = children_3_1.value;
                    // expand each child
                    this.setAllItemCollapsedState(child, state);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (children_3_1 && !children_3_1.done && (_a = children_3.return)) _a.call(children_3);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
    };
    /**
     * Make a row visible in thescroll pane by its index
     */
    /**
     * Make a row visible in thescroll pane by its index
     * @private
     * @param {?} index
     * @return {?}
     */
    BentoTreeViewComponent.prototype.showRowIndex = /**
     * Make a row visible in thescroll pane by its index
     * @private
     * @param {?} index
     * @return {?}
     */
    function (index) {
        /** @type {?} */
        var rowOffsetTop = index * this.rowHeight;
        /** @type {?} */
        var viewportEl = this.cdkViewport.getElementRef().nativeElement;
        /** @type {?} */
        var listHeight = viewportEl.offsetHeight;
        /** @type {?} */
        var scrollTop = viewportEl.scrollTop;
        if (rowOffsetTop + this.rowHeight > listHeight + scrollTop) {
            this.cdkViewport.scrollTo({ top: rowOffsetTop - listHeight + this.rowHeight });
        }
        else if (rowOffsetTop < scrollTop) {
            this.cdkViewport.scrollTo({ top: rowOffsetTop });
        }
        this.cdkViewport.checkViewportSize();
    };
    /**
     * Update checkbox status based on their relationships
     */
    /**
     * Update checkbox status based on their relationships
     * @private
     * @param {?} item
     * @return {?}
     */
    BentoTreeViewComponent.prototype.updateCheckedState = /**
     * Update checkbox status based on their relationships
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var e_8, _a;
        /** @type {?} */
        var option = item[BENTO_TREE_ITEM_OPTION];
        /** @type {?} */
        var isChecked = option.getChecked(this.id);
        if (isChecked) {
            this.checkChildren(item, true);
        }
        else {
            /** @type {?} */
            var children = item[this.itemChildrenProp];
            if (children) {
                /** @type {?} */
                var allChecked = true;
                /** @type {?} */
                var allUnChecked = true;
                /** @type {?} */
                var hasIndeterminate = false;
                try {
                    for (var children_4 = __values(children), children_4_1 = children_4.next(); !children_4_1.done; children_4_1 = children_4.next()) {
                        var child = children_4_1.value;
                        /** @type {?} */
                        var indetermiate = this.updateCheckedState(child);
                        /** @type {?} */
                        var childIsChecked = child[BENTO_TREE_ITEM_OPTION].getChecked(this.id);
                        if (indetermiate) {
                            hasIndeterminate = true;
                        }
                        else if (childIsChecked) {
                            allUnChecked = false;
                        }
                        else if (!childIsChecked) {
                            allChecked = false;
                        }
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (children_4_1 && !children_4_1.done && (_a = children_4.return)) _a.call(children_4);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
                if (hasIndeterminate || !(allChecked || allUnChecked)) {
                    option.setIndeterminate(true, this.id);
                    return true;
                }
                else if (allChecked) {
                    option.setChecked(true, this.id, false, true);
                }
                else if (allUnChecked) {
                    option.setChecked(false, this.id, false, true);
                }
                return false;
            }
            else {
                // Not indetermindate
                return false;
            }
        }
    };
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    BentoTreeViewComponent.prototype.updateParentCheckState = /**
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var e_9, _a;
        if (!item) {
            // There is nothing to check
            return;
        }
        /** @type {?} */
        var allChecked = true;
        /** @type {?} */
        var allUnChecked = true;
        /** @type {?} */
        var hasIndeterminate = false;
        /** @type {?} */
        var children = item[this.itemChildrenProp];
        /** @type {?} */
        var options = item[BENTO_TREE_ITEM_OPTION];
        try {
            for (var children_5 = __values(children), children_5_1 = children_5.next(); !children_5_1.done; children_5_1 = children_5.next()) {
                var child = children_5_1.value;
                /** @type {?} */
                var childOptions = child[BENTO_TREE_ITEM_OPTION];
                if (!childOptions.hideCheckbox) {
                    /** @type {?} */
                    var isChecked = childOptions.getChecked(this.id);
                    /** @type {?} */
                    var isIndeterminate = childOptions.getIndeterminate(this.id);
                    if (isIndeterminate || !(allChecked || allUnChecked)) {
                        hasIndeterminate = true;
                        break;
                    }
                    else if (allUnChecked && allChecked) {
                        allChecked = isChecked;
                        allUnChecked = !isChecked;
                    }
                    else if ((allChecked && !isChecked) || (allUnChecked && isChecked)) {
                        hasIndeterminate = true;
                        break;
                    }
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (children_5_1 && !children_5_1.done && (_a = children_5.return)) _a.call(children_5);
            }
            finally { if (e_9) throw e_9.error; }
        }
        if (hasIndeterminate) {
            options.setIndeterminate(true, this.id);
        }
        else if (allChecked) {
            options.setChecked(true, this.id, true, true);
        }
        else if (allUnChecked) {
            options.setChecked(false, this.id, true, true);
        }
    };
    /**
     * @private
     * @param {?} el
     * @return {?}
     */
    BentoTreeViewComponent.prototype.animateSelectionFeedback = /**
     * @private
     * @param {?} el
     * @return {?}
     */
    function (el) {
        var _this = this;
        /** @type {?} */
        var ctaEl = el.parentElement;
        this.r.addClass(ctaEl, 'in');
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.r.removeClass(ctaEl, 'in');
        }), 34);
    };
    /**
     * Update already selected item(s) based on configuration with currently selected Item
     */
    /**
     * Update already selected item(s) based on configuration with currently selected Item
     * @private
     * @param {?} selectedItem
     * @return {?}
     */
    BentoTreeViewComponent.prototype.updateSelections = /**
     * Update already selected item(s) based on configuration with currently selected Item
     * @private
     * @param {?} selectedItem
     * @return {?}
     */
    function (selectedItem) {
        var e_10, _a;
        if (this.multiSelect) {
            this.selectedItems.push(selectedItem);
        }
        else {
            /** @type {?} */
            var oldSelections = this.selectedItems;
            this.selectedItems = [selectedItem];
            try {
                for (var oldSelections_1 = __values(oldSelections), oldSelections_1_1 = oldSelections_1.next(); !oldSelections_1_1.done; oldSelections_1_1 = oldSelections_1.next()) {
                    var item = oldSelections_1_1.value;
                    if (item !== selectedItem) {
                        item[BENTO_TREE_ITEM_OPTION].setSelected(false, this.id);
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (oldSelections_1_1 && !oldSelections_1_1.done && (_a = oldSelections_1.return)) _a.call(oldSelections_1);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
    };
    /**
     * Unsubscribe all options from items
     */
    /**
     * Unsubscribe all options from items
     * @private
     * @return {?}
     */
    BentoTreeViewComponent.prototype.unsubscribeAllItems = /**
     * Unsubscribe all options from items
     * @private
     * @return {?}
     */
    function () {
        while (this.itemSubscriptions.length) {
            // unsubscribe all option changes
            this.itemSubscriptions.pop().unsubscribe();
        }
    };
    /** @nocollapse */
    BentoTreeViewComponent.ctorParameters = function () { return [
        { type: WindowRef },
        { type: ElementRef },
        { type: BentoNotification },
        { type: Directionality },
        { type: Renderer2 },
        { type: ChangeDetectorRef }
    ]; };
    BentoTreeViewComponent.propDecorators = {
        items: [{ type: Input }],
        collapseItemsOnAdd: [{ type: Input }],
        id: [{ type: Input }],
        multiSelect: [{ type: Input }],
        itemIconProp: [{ type: Input }],
        itemChildrenProp: [{ type: Input }],
        itemLabelProp: [{ type: Input }],
        itemExpandOnly: [{ type: Input }],
        selectAsCheck: [{ type: Input }],
        showCheckboxes: [{ type: Input }],
        disableSelection: [{ type: Input }],
        showExpandCollapseAllButtons: [{ type: Input }],
        itemLabelTemplate: [{ type: Input }],
        independentCheckbox: [{ type: Input }],
        disableFocusOnLeaves: [{ type: Input }],
        itemCheck: [{ type: Output }],
        itemExpandCollapse: [{ type: Output }],
        itemSelect: [{ type: Output }],
        cdkViewport: [{ type: ViewChild, args: ['viewport', { static: true },] }],
        onTreeKeydown: [{ type: HostListener, args: ['keydown', ['$event', '$event.keyCode'],] }]
    };
BentoTreeViewComponent.ɵfac = function BentoTreeViewComponent_Factory(t) { return new (t || BentoTreeViewComponent)(ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoTreeViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoTreeViewComponent, selectors: [["bento-tree-view"]], viewQuery: function BentoTreeViewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c73, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cdkViewport = _t.first);
    } }, hostBindings: function BentoTreeViewComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function BentoTreeViewComponent_keydown_HostBindingHandler($event) { return ctx.onTreeKeydown($event, $event.keyCode); });
    } }, inputs: { collapseItemsOnAdd: "collapseItemsOnAdd", multiSelect: "multiSelect", itemExpandOnly: "itemExpandOnly", selectAsCheck: "selectAsCheck", showCheckboxes: "showCheckboxes", disableSelection: "disableSelection", showExpandCollapseAllButtons: "showExpandCollapseAllButtons", independentCheckbox: "independentCheckbox", disableFocusOnLeaves: "disableFocusOnLeaves", items: "items", id: "id", itemIconProp: "itemIconProp", itemChildrenProp: "itemChildrenProp", itemLabelProp: "itemLabelProp", itemLabelTemplate: "itemLabelTemplate" }, outputs: { itemCheck: "itemCheck", itemExpandCollapse: "itemExpandCollapse", itemSelect: "itemSelect" }, decls: 6, vars: 6, consts: [[3, "expandAllTitle", "collapseAllTitle", "expand", "collapse", 4, "ngIf"], ["role", "tree", "tabindex", "0", 1, "bui-tree-view-viewport", 3, "minBufferPx", "maxBufferPx", "itemSize", "focus"], ["viewport", ""], [4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTrackBy"], ["row", ""], [3, "expandAllTitle", "collapseAllTitle", "expand", "collapse"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "treeitem", 1, "bui-tree-item", 3, "ngClass"], ["type", "button", "tabindex", "-1", "class", "bui-tree-view-expand-collapse-btn", "container", "body", 3, "disabled", "ngbTooltip", "click", 4, "ngIf"], [1, "sr-only"], ["class", "bui-tree-item-checkbox", "tabindex", "-1", 3, "ngModel", "indeterminate", "disabled", "ngModelChange", 4, "ngIf"], [1, "bui-tree-item-cta", "col", 3, "click"], ["aria-hidden", "true", 3, "ngClass", 4, "ngIf"], ["class", "bui-tree-item-custom-template", 4, "ngIf", "ngIfElse"], ["ctaDefaultTemplate", ""], ["type", "button", "tabindex", "-1", "container", "body", 1, "bui-tree-view-expand-collapse-btn", 3, "disabled", "ngbTooltip", "click"], ["aria-hidden", "true", 3, "ngClass"], ["tabindex", "-1", 1, "bui-tree-item-checkbox", 3, "ngModel", "indeterminate", "disabled", "ngModelChange"], [1, "bui-tree-item-custom-template"], [1, "bui-underline-on-hover-focus", "bui-tree-item-cta-default-label"]], template: function BentoTreeViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BentoTreeViewComponent_bento_expand_collapse_button_group_0_Template, 3, 6, "bento-expand-collapse-button-group", 0);
        ɵngcc0.ɵɵelementStart(1, "cdk-virtual-scroll-viewport", 1, 2);
        ɵngcc0.ɵɵlistener("focus", function BentoTreeViewComponent_Template_cdk_virtual_scroll_viewport_focus_1_listener() { return ctx._onCDKViewportFocus(); });
        ɵngcc0.ɵɵtemplate(3, BentoTreeViewComponent_ng_container_3_Template, 2, 7, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, BentoTreeViewComponent_ng_template_4_Template, 10, 22, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showExpandCollapseAllButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("minBufferPx", 100)("maxBufferPx", ctx.rowHeight * 10)("itemSize", ctx.rowHeight);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdkVirtualForOf", ctx._itemsFlatData)("cdkVirtualForTrackBy", ctx._itemOrderTrackBy);
    } }, directives: [ɵngcc7.NgIf, ɵngcc9.CdkVirtualScrollViewport, ɵngcc9.CdkFixedSizeVirtualScroll, ɵngcc9.CdkVirtualForOf, BentoExpandCollapseButtonGroupComponent, ɵngcc7.NgTemplateOutlet, ɵngcc7.NgClass, ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective,
        BentoCheckboxComponent, ɵngcc8.NgControlStatus, ɵngcc8.NgModel], pipes: [BentoTranslatePipe], styles: ["bento-tree-view{display:flex;position:relative;flex-direction:column;height:400px}bento-tree-view bento-expand-collapse-button-group{flex:auto;flex-grow:0;margin-bottom:-1px}.bui-tree-view-viewport{flex-basis:0;flex-grow:1;max-height:100%}.bui-tree-item{position:relative;display:flex;height:30px}.bui-tree-item bento-checkbox{z-index:2}.bui-tree-item.selected .bui-tree-item-cta:after{content:\"\";position:absolute;left:0;width:4px;top:1px;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] .bui-tree-item.selected .bui-tree-item-cta:after{border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}.bui-tree-item:last-of-type .bui-tree-item-cta:before{bottom:0}.bui-tree-item-cta:before{border-color:transparent;border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid;content:\" \";display:block;color:grey;position:absolute;left:0;width:100%;top:0;bottom:-1px;z-index:0}.bui-tree-view-expand-collapse-btn{display:flex;align-items:center;justify-content:center;width:25px;height:30px;background:0 0;border:none;padding:0;margin-left:-25px;position:relative;z-index:1;cursor:default;opacity:.8}[dir=rtl] .bui-tree-view-expand-collapse-btn{margin-left:0;margin-right:-20px}.bui-tree-view-expand-collapse-btn:focus,.bui-tree-view-expand-collapse-btn:hover{outline:0}.bui-tree-view-expand-collapse-btn .bento-tree-icon{font-size:1em}.bui-tree-view-expand-collapse-btn:hover{opacity:1}.bui-tree-view-expand-collapse-btn~.bui-tree-item-cta,.bui-tree-view-expand-collapse-btn~.bui-tree-item-cta .bento-tree-item-label{font-weight:700}.bui-tree-item-checkbox{margin-top:8px}.bui-tree-item-cta-icon{margin-right:5px;margin-left:auto}[dir=rtl] .bui-tree-item-cta-icon{margin-right:auto;margin-left:5px}.bui-tree-item-cta{display:inline-flex;line-height:14px;font-size:.879rem;cursor:default;background-color:transparent;position:static}.bui-tree-item-cta.col{padding:0}.bui-tree-item-cta>div{padding:8px 0;width:100%;position:relative;display:flex;align-items:flex-start;z-index:1}.bui-tree-item-cta:focus,.bui-tree-item-cta:hover{outline:0}.bui-tree-item-cta:focus .bui-underline-on-hover-focus,.bui-tree-item-cta:hover .bui-underline-on-hover-focus{text-decoration:underline;vertical-align:baseline}.bui-tree-item-cta [class*=bento-icon]{font-size:1.2em}.bui-tree-item-cta .btn.btn-link{height:auto;font-size:.879rem;line-height:1.25em;padding:0;letter-spacing:0;justify-content:flex-start}[dir=rtl] .bui-tree-item-cta:before{left:auto;right:0}.bui-tree-item-cta-default-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bui-tree-item-custom-template{display:flex;flex-wrap:wrap}.bui-tree-item-custom-template .col-auto:not(button),.bui-tree-item-custom-template .col:not(button){padding:0}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTreeViewComponent, [{
        type: Component,
        args: [{
                selector: 'bento-tree-view',
                template: "<bento-expand-collapse-button-group\n  *ngIf=\"showExpandCollapseAllButtons\"\n  [expandAllTitle]=\"'BENTO_UI_TREE_VIEW_EXPAND_ALL' | bentoTranslate\"\n  [collapseAllTitle]=\"'BENTO_UI_TREE_VIEW_COLLAPSE_ALL' | bentoTranslate\"\n  (expand)=\"expandAllGroups()\"\n  (collapse)=\"collapseAllGroups()\"\n></bento-expand-collapse-button-group>\n<cdk-virtual-scroll-viewport\n  #viewport\n  [minBufferPx]=\"100\"\n  [maxBufferPx]=\"rowHeight * 10\"\n  (focus)=\"_onCDKViewportFocus()\"\n  class=\"bui-tree-view-viewport\"\n  [itemSize]=\"rowHeight\"\n  role=\"tree\"\n  tabindex=\"0\"\n>\n  <ng-container *cdkVirtualFor=\"let item of _itemsFlatData; let i = index; trackBy: _itemOrderTrackBy\">\n    <ng-container\n      *ngTemplateOutlet=\"row; context: {item: item, options: item.$bentoTreeItemOption, index: i, rowID: uid + '-' + i}\"\n    ></ng-container>\n  </ng-container>\n</cdk-virtual-scroll-viewport>\n\n<ng-template #row let-item=\"item\" let-options=\"options\" let-rowID=\"rowID\">\n  <div\n    class=\"bui-tree-item\"\n    [ngClass]=\"options.getSelected(id) ? 'selected' : ''\"\n    [style.paddingLeft.px]=\"!isRTL ? options.level * _paddingLeft : 0\"\n    [style.paddingRight.px]=\"isRTL ? options.level * _paddingLeft : 0\"\n    [attr.id]=\"rowID\"\n    [attr.aria-checked]=\"showCheckboxes ? options.getChecked(id) : null\"\n    [attr.aria-selected]=\"options.getSelected(id) ? options.getSelected(id) : null\"\n    [attr.aria-expanded]=\"item[itemChildrenProp] ? !options.getCollapsed(id) : null\"\n    [attr.aria-level]=\"options.level\"\n    role=\"treeitem\"\n    [attr.aria-posinset]=\"options.index\"\n    [attr.aria-setsize]=\"options.siblingSize\"\n  >\n    <button\n      type=\"button\"\n      tabindex=\"-1\"\n      class=\"bui-tree-view-expand-collapse-btn\"\n      *ngIf=\"item[itemChildrenProp]\"\n      (click)=\"_onExpandCollapseClick(item)\"\n      [disabled]=\"options.disabled\"\n      [attr.aria-label]=\"\n        options.getCollapsed(id)\n          ? ('BENTO_UI_TREE_VIEW_EXPAND' | bentoTranslate)\n          : ('BENTO_UI_TREE_VIEW_COLLAPSE' | bentoTranslate)\n      \"\n      [attr.aria-describedby]=\"'label-' + rowID\"\n      [ngbTooltip]=\"\n        options.getCollapsed(id)\n          ? ('BENTO_UI_TREE_VIEW_EXPAND' | bentoTranslate)\n          : ('BENTO_UI_TREE_VIEW_COLLAPSE' | bentoTranslate)\n      \"\n      container=\"body\"\n    >\n      <i\n        aria-hidden=\"true\"\n        [ngClass]=\"options.getCollapsed(id) ? 'bento-icon-plus-plain' : 'bento-icon-minus-plain'\"\n      ></i>\n    </button>\n\n    <label class=\"sr-only\" [attr.id]=\"'label-' + rowID\" [attr.for]=\"'checkbox-' + rowID\">\n      {{ item[itemLabelProp] }}\n    </label>\n    <bento-checkbox\n      class=\"bui-tree-item-checkbox\"\n      [ngModel]=\"options.getChecked(id)\"\n      (ngModelChange)=\"_onCheckChanged($event, item)\"\n      [indeterminate]=\"options.getIndeterminate(id)\"\n      [attr.id]=\"'checkbox-' + rowID\"\n      [disabled]=\"options.disabled\"\n      tabindex=\"-1\"\n      *ngIf=\"showCheckboxes && !options.hideCheckbox\"\n    ></bento-checkbox>\n    <div\n      class=\"bui-tree-item-cta col\"\n      [attr.id]=\"'cta-' + rowID\"\n      (click)=\"_onItemCTAClick($event.target, item)\"\n      [attr.tabindex]=\"disableFocusOnLeaves && !item[itemChildrenProp] ? null : '-1'\"\n    >\n      <i [ngClass]=\"['bui-tree-item-cta-icon', item[itemIconProp]]\" *ngIf=\"item[itemIconProp]\" aria-hidden=\"true\"></i>\n      <div *ngIf=\"itemLabelTemplate; else ctaDefaultTemplate\" class=\"bui-tree-item-custom-template\">\n        <ng-container\n          *ngTemplateOutlet=\"itemLabelTemplate; context: {item: item, options: options, rowID: rowID}\"\n        ></ng-container>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #ctaDefaultTemplate>\n    <div class=\"bui-underline-on-hover-focus bui-tree-item-cta-default-label\">\n      {{ item[itemLabelProp] }}\n    </div>\n  </ng-template>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["bento-tree-view{display:flex;position:relative;flex-direction:column;height:400px}bento-tree-view bento-expand-collapse-button-group{flex:auto;flex-grow:0;margin-bottom:-1px}.bui-tree-view-viewport{flex-basis:0;flex-grow:1;max-height:100%}.bui-tree-item{position:relative;display:flex;height:30px}.bui-tree-item bento-checkbox{z-index:2}.bui-tree-item.selected .bui-tree-item-cta:after{content:\"\";position:absolute;left:0;width:4px;top:1px;bottom:0;border-right-width:1px;border-right-style:solid}[dir=rtl] .bui-tree-item.selected .bui-tree-item-cta:after{border-left-width:1px;border-left-style:solid;border-right-width:0;left:auto;right:0}.bui-tree-item:last-of-type .bui-tree-item-cta:before{bottom:0}.bui-tree-item-cta:before{border-color:transparent;border-bottom-width:1px;border-bottom-style:solid;border-top-width:1px;border-top-style:solid;content:\" \";display:block;color:grey;position:absolute;left:0;width:100%;top:0;bottom:-1px;z-index:0}.bui-tree-view-expand-collapse-btn{display:flex;align-items:center;justify-content:center;width:25px;height:30px;background:0 0;border:none;padding:0;margin-left:-25px;position:relative;z-index:1;cursor:default;opacity:.8}[dir=rtl] .bui-tree-view-expand-collapse-btn{margin-left:0;margin-right:-20px}.bui-tree-view-expand-collapse-btn:focus,.bui-tree-view-expand-collapse-btn:hover{outline:0}.bui-tree-view-expand-collapse-btn .bento-tree-icon{font-size:1em}.bui-tree-view-expand-collapse-btn:hover{opacity:1}.bui-tree-view-expand-collapse-btn~.bui-tree-item-cta,.bui-tree-view-expand-collapse-btn~.bui-tree-item-cta .bento-tree-item-label{font-weight:700}.bui-tree-item-checkbox{margin-top:8px}.bui-tree-item-cta-icon{margin-right:5px;margin-left:auto}[dir=rtl] .bui-tree-item-cta-icon{margin-right:auto;margin-left:5px}.bui-tree-item-cta{display:inline-flex;line-height:14px;font-size:.879rem;cursor:default;background-color:transparent;position:static}.bui-tree-item-cta.col{padding:0}.bui-tree-item-cta>div{padding:8px 0;width:100%;position:relative;display:flex;align-items:flex-start;z-index:1}.bui-tree-item-cta:focus,.bui-tree-item-cta:hover{outline:0}.bui-tree-item-cta:focus .bui-underline-on-hover-focus,.bui-tree-item-cta:hover .bui-underline-on-hover-focus{text-decoration:underline;vertical-align:baseline}.bui-tree-item-cta [class*=bento-icon]{font-size:1.2em}.bui-tree-item-cta .btn.btn-link{height:auto;font-size:.879rem;line-height:1.25em;padding:0;letter-spacing:0;justify-content:flex-start}[dir=rtl] .bui-tree-item-cta:before{left:auto;right:0}.bui-tree-item-cta-default-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bui-tree-item-custom-template{display:flex;flex-wrap:wrap}.bui-tree-item-custom-template .col-auto:not(button),.bui-tree-item-custom-template .col:not(button){padding:0}"]
            }]
    }], function () { return [{ type: WindowRef }, { type: ɵngcc0.ElementRef }, { type: BentoNotification }, { type: ɵngcc6.Directionality }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { collapseItemsOnAdd: [{
            type: Input
        }], multiSelect: [{
            type: Input
        }], itemExpandOnly: [{
            type: Input
        }], selectAsCheck: [{
            type: Input
        }], showCheckboxes: [{
            type: Input
        }], disableSelection: [{
            type: Input
        }], showExpandCollapseAllButtons: [{
            type: Input
        }], independentCheckbox: [{
            type: Input
        }], disableFocusOnLeaves: [{
            type: Input
        }], itemCheck: [{
            type: Output
        }], itemExpandCollapse: [{
            type: Output
        }], itemSelect: [{
            type: Output
        }], items: [{
            type: Input
        }], onTreeKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event', '$event.keyCode']]
        }], id: [{
            type: Input
        }], itemIconProp: [{
            type: Input
        }], itemChildrenProp: [{
            type: Input
        }], itemLabelProp: [{
            type: Input
        }], itemLabelTemplate: [{
            type: Input
        }], cdkViewport: [{
            type: ViewChild,
            args: ['viewport', { static: true }]
        }] }); })();
    return BentoTreeViewComponent;
}());
if (false) {
    /**
     * Flag to determine of the items are collapsed when initially added/appended to the Tree View component
     * @type {?}
     */
    BentoTreeViewComponent.prototype.collapseItemsOnAdd;
    /**
     * HTML ID of this element
     * @type {?}
     */
    BentoTreeViewComponent.prototype.id;
    /**
     * Flag to multiple tree items can be selected
     * @type {?}
     */
    BentoTreeViewComponent.prototype.multiSelect;
    /**
     * Property name to define tree item icon class name
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemIconProp;
    /**
     * Property name to define tree branch children array reference
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemChildrenProp;
    /**
     * Property name to define the value of a tree item
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemLabelProp;
    /**
     * Flag to only expand or collapse a tree branch
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemExpandOnly;
    /**
     * Flag to a tree item click is considered as a checkbox click
     * @type {?}
     */
    BentoTreeViewComponent.prototype.selectAsCheck;
    /**
     * Flag to show all checkbobox components
     * @type {?}
     */
    BentoTreeViewComponent.prototype.showCheckboxes;
    /**
     * Flag to disable tree node selection
     * @type {?}
     */
    BentoTreeViewComponent.prototype.disableSelection;
    /**
     * Flag to show the expand and collapse all buttons
     * @type {?}
     */
    BentoTreeViewComponent.prototype.showExpandCollapseAllButtons;
    /**
     * Custom label template to be applied to each tree item
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemLabelTemplate;
    /**
     * Make checkboxes to be independent from hierachical relationships
     * @type {?}
     */
    BentoTreeViewComponent.prototype.independentCheckbox;
    /**
     * Disable HTML focus on leaf items to accomondate custom templates
     * @type {?}
     */
    BentoTreeViewComponent.prototype.disableFocusOnLeaves;
    /**
     * Callback to when a item is checked
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemCheck;
    /**
     * Callback to when a tree item is expanded or collapsed
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemExpandCollapse;
    /**
     * Callback to when a item is selected
     * @type {?}
     */
    BentoTreeViewComponent.prototype.itemSelect;
    /**
     * Default row height
     * @type {?}
     */
    BentoTreeViewComponent.prototype.rowHeight;
    /**
     * Flag to determine if APP is in RTL mode
     * @type {?}
     */
    BentoTreeViewComponent.prototype.isRTL;
    /**
     * Flattened data array from the items tree
     * @type {?}
     */
    BentoTreeViewComponent.prototype._itemsFlatData;
    /**
     * Padding left of each level
     * @type {?}
     */
    BentoTreeViewComponent.prototype._paddingLeft;
    /** @type {?} */
    BentoTreeViewComponent.prototype.cdkViewport;
    /** @type {?} */
    BentoTreeViewComponent.prototype.uid;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.selectedItems;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.checkedItems;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.itemsData;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.resizeSubscription;
    /**
     * NodeList index where the current focus is assigned to within a tree item row HTMLElement.
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.activeRowFocusIndex;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.directionChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.componentInitialized;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.itemSubscriptions;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoTreeViewComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/tree/tree.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoTreeModule = /** @class */ (function () {
    function BentoTreeModule() {
    }
BentoTreeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoTreeModule });
BentoTreeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoTreeModule_Factory(t) { return new (t || BentoTreeModule)(); }, imports: [[
            CommonModule,
            BentoCheckboxModule,
            FormsModule,
            BentoTranslateModule,
            BentoExpandCollapseButtonGroupModule,
            BentoUtilsModule,
            ScrollingModule,
            // ExperimentalScrollingModule
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoTreeModule, { declarations: function () { return [BentoTreeComponent,
        BentoTreeItemComponent,
        BentoTreeViewComponent]; }, imports: function () { return [CommonModule,
        BentoCheckboxModule,
        FormsModule,
        BentoTranslateModule,
        BentoExpandCollapseButtonGroupModule,
        BentoUtilsModule,
        ScrollingModule,
        // ExperimentalScrollingModule
        NgbTooltipModule,
        BentoNgbTooltipSupportModule]; }, exports: function () { return [BentoTreeComponent,
        BentoTreeViewComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoTreeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoCheckboxModule,
                    FormsModule,
                    BentoTranslateModule,
                    BentoExpandCollapseButtonGroupModule,
                    BentoUtilsModule,
                    ScrollingModule,
                    // ExperimentalScrollingModule
                    NgbTooltipModule,
                    BentoNgbTooltipSupportModule
                ],
                declarations: [BentoTreeComponent, BentoTreeItemComponent, BentoTreeViewComponent],
                exports: [BentoTreeComponent, BentoTreeViewComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoTreeModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter-dropdown/universe-filter-dropdown-ellipsis.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoUniverseFilterDropdownEllipsisDirective = /** @class */ (function () {
    function BentoUniverseFilterDropdownEllipsisDirective(elRef, sanitizer) {
        this.sanitizer = sanitizer;
        this._nativeElement = elRef.nativeElement;
    }
    Object.defineProperty(BentoUniverseFilterDropdownEllipsisDirective.prototype, "bentoEllipsisText", {
        set: /**
         * @param {?} text
         * @return {?}
         */
        function (text) {
            this._eText = text;
            this.checkEllipsis();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoUniverseFilterDropdownEllipsisDirective.prototype.checkEllipsis = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var txtElem = this._nativeElement;
        txtElem.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this._eText);
        txtElem.style.pointerEvents = '';
        if (txtElem.offsetWidth > txtElem.scrollWidth) {
            // disable tooltip if full display of label
            txtElem.style.pointerEvents = 'none';
        }
    };
    /** @nocollapse */
    BentoUniverseFilterDropdownEllipsisDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: DomSanitizer }
    ]; };
    BentoUniverseFilterDropdownEllipsisDirective.propDecorators = {
        bentoEllipsisText: [{ type: Input }]
    };
BentoUniverseFilterDropdownEllipsisDirective.ɵfac = function BentoUniverseFilterDropdownEllipsisDirective_Factory(t) { return new (t || BentoUniverseFilterDropdownEllipsisDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
BentoUniverseFilterDropdownEllipsisDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoUniverseFilterDropdownEllipsisDirective, selectors: [["", "bentoUniverseFilterDropdownEllipsis", ""]], inputs: { bentoEllipsisText: "bentoEllipsisText" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterDropdownEllipsisDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoUniverseFilterDropdownEllipsis]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc5.DomSanitizer }]; }, { bentoEllipsisText: [{
            type: Input
        }] }); })();
    return BentoUniverseFilterDropdownEllipsisDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownEllipsisDirective.prototype._nativeElement;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownEllipsisDirective.prototype._eText;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownEllipsisDirective.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter-dropdown/universe-filter-dropdown-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoUniverseFilterDropdownMenuComponent = /** @class */ (function () {
    /**
     * [constructor get NgbModal service, listen to window resize notifcation]
     */
    function BentoUniverseFilterDropdownMenuComponent(_vr, bentoNotification) {
        var _this = this;
        this._vr = _vr;
        this.onClose = new EventEmitter();
        this.onSelect = new EventEmitter();
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
    }
    /**
     * @return {?}
     */
    BentoUniverseFilterDropdownMenuComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._resizeSubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    BentoUniverseFilterDropdownMenuComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var template = this.item.modalTemplateUrl || this.item.templateUrl || this.defaultTemplate;
        /** @type {?} */
        var context = {
            ctrl: this,
            close: (/**
             * @return {?}
             */
            function () {
                _this.onClose.emit(_this.menuindex);
            }),
            filterItem: this.item,
            selectItem: (/**
             * @param {?} selectedItem
             * @return {?}
             */
            function (selectedItem) {
                _this.onSelect.emit({
                    index: _this.menuindex,
                    selectedItem: selectedItem
                });
            })
        };
        this._vr.createEmbeddedView(template, context);
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseFilterDropdownMenuComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () { };
    /** @nocollapse */
    BentoUniverseFilterDropdownMenuComponent.ctorParameters = function () { return [
        { type: ViewContainerRef },
        { type: BentoNotification }
    ]; };
    BentoUniverseFilterDropdownMenuComponent.propDecorators = {
        item: [{ type: Input }],
        menuindex: [{ type: Input }],
        defaultTemplate: [{ type: Input }],
        onClose: [{ type: Output }],
        onSelect: [{ type: Output }]
    };
BentoUniverseFilterDropdownMenuComponent.ɵfac = function BentoUniverseFilterDropdownMenuComponent_Factory(t) { return new (t || BentoUniverseFilterDropdownMenuComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(BentoNotification)); };
BentoUniverseFilterDropdownMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoUniverseFilterDropdownMenuComponent, selectors: [["bento-universe-filter-dropdown-menu"]], inputs: { item: "item", menuindex: "menuindex", defaultTemplate: "defaultTemplate" }, outputs: { onClose: "onClose", onSelect: "onSelect" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 0, vars: 0, template: function BentoUniverseFilterDropdownMenuComponent_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterDropdownMenuComponent, [{
        type: Component,
        args: [{
                selector: 'bento-universe-filter-dropdown-menu',
                template: "",
                providers: [BentoNotification]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: BentoNotification }]; }, { onClose: [{
            type: Output
        }], onSelect: [{
            type: Output
        }], item: [{
            type: Input
        }], menuindex: [{
            type: Input
        }], defaultTemplate: [{
            type: Input
        }] }); })();
    return BentoUniverseFilterDropdownMenuComponent;
}());
if (false) {
    /**
     * Filter item data array
     * @type {?}
     */
    BentoUniverseFilterDropdownMenuComponent.prototype.item;
    /** @type {?} */
    BentoUniverseFilterDropdownMenuComponent.prototype.menuindex;
    /** @type {?} */
    BentoUniverseFilterDropdownMenuComponent.prototype.defaultTemplate;
    /** @type {?} */
    BentoUniverseFilterDropdownMenuComponent.prototype.bentoUniverseFilterCtrl;
    /** @type {?} */
    BentoUniverseFilterDropdownMenuComponent.prototype.onClose;
    /** @type {?} */
    BentoUniverseFilterDropdownMenuComponent.prototype.onSelect;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownMenuComponent.prototype._resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownMenuComponent.prototype._vr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter-dropdown/universe-filter-dropdown-position.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoUniverseDropdownPositionDirective = /** @class */ (function () {
    function BentoUniverseDropdownPositionDirective(dropdown, elementRef, windowRef, logService) {
        var _this = this;
        this.dropdown = dropdown;
        this.elementRef = elementRef;
        this.logService = logService;
        /**
         * Input to get the reference of the container that this element is appended to
         */
        this.bentoUniverseFilterDropdownPosition = false;
        this.window = windowRef.nativeWindow;
        this.document = windowRef.nativeDocument;
        this.onChangeSubscription = this.dropdown.openChange.subscribe((/**
         * @param {?} open
         * @return {?}
         */
        function (open) {
            if (!open) {
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.removeMenuFromBody();
                }), 0);
            }
            else {
                _this.menuWrapper.appendChild(_this.menuRef.nativeElement);
                if (!_this.isInBody()) {
                    _this.appendMenuToBody();
                }
            }
        }));
    }
    /**
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.oldParent = ((/** @type {?} */ (this.menuRef.nativeElement))).parentElement;
        this.findAppendToEl();
        this.createWrapper();
        // override dropdown private method for positioning dropdown menu
        /** @type {?} */
        var dropdown = (/** @type {?} */ (this.dropdown));
        dropdown._positionMenu = (/**
         * @return {?}
         */
        function () {
            _this.positionDropdown();
        });
    };
    /**
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.positionDropdown = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var triggerEl = this.elementRef.nativeElement;
        // get rect of button
        /** @type {?} */
        var triggerRect = triggerEl.getBoundingClientRect();
        // get rect of filter
        /** @type {?} */
        var elementRect = this._appendToEl.getBoundingClientRect();
        // get rect of dropdown
        /** @type {?} */
        var menuRect = this.menuRef.nativeElement.getBoundingClientRect();
        this.menuRef.nativeElement.style.position = 'absolute';
        this.menuRef.nativeElement.style.minWidth = Math.ceil(triggerRect.width) + 'px';
        this.menuRef.nativeElement.style.left = 'auto';
        this.menuRef.nativeElement.style.right = 'auto';
        if (menuRect.width + triggerRect.left - (elementRect.width + elementRect.left) >= 0) {
            this.menuRef.nativeElement.style.right = '0';
        }
        else {
            this.menuRef.nativeElement.style.left = Math.ceil(triggerRect.left - elementRect.left) - 1 + 'px';
        }
    };
    /**
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.removeMenuFromBody();
        if (this.onChangeSubscription) {
            this.onChangeSubscription.unsubscribe();
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.findAppendToEl = /**
     * @private
     * @return {?}
     */
    function () {
        if (this._appendToEl) {
            // append to Parent is initiated already
            return;
        }
        // Assign `_appendToEl` reference for appending
        if (!this.bentoUniverseFilterDropdownPosition || this.bentoUniverseFilterDropdownPosition === '') {
            this._appendToEl = this.document.body;
        }
        else if (typeof this.bentoUniverseFilterDropdownPosition === 'string') {
            this._appendToEl = (/** @type {?} */ (this.document.querySelector(this.bentoUniverseFilterDropdownPosition)));
            if (!this._appendToEl) {
                this.logService.error('[bentoDropdownPosition]: Selector', this.bentoUniverseFilterDropdownPosition, 'does not exit in the DOM structure.');
                return;
            }
        }
        else if (this.isHTMLElement(this.bentoUniverseFilterDropdownPosition)) {
            this._appendToEl = (/** @type {?} */ (this.bentoUniverseFilterDropdownPosition));
        }
        else {
            this._appendToEl = ((/** @type {?} */ (this.bentoUniverseFilterDropdownPosition))).nativeElement;
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.isInBody = /**
     * @private
     * @return {?}
     */
    function () {
        return this.menuWrapper.parentNode === this._appendToEl;
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.removeMenuFromBody = /**
     * @private
     * @return {?}
     */
    function () {
        // this.menuRef.nativeElement.style.display = 'none';
        if (this.isInBody()) {
            if (this.oldParent) {
                this.oldParent.appendChild(this.menuWrapper);
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.appendMenuToBody = /**
     * @private
     * @return {?}
     */
    function () {
        this.findAppendToEl();
        this._appendToEl.appendChild(this.menuWrapper);
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.createWrapper = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.menuWrapper = this.document.createElement('div');
        this.menuWrapper.style.zIndex = '1000';
        this.menuWrapper.style.display = 'block';
        this.menuWrapper.className += 'dropdown-menu-wrapper';
        this.menuWrapper.addEventListener('keyup', (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.keyCode === 27) {
                _this.dropdown.close();
            }
        }));
        this.menuWrapper.appendChild(this.menuRef.nativeElement);
    };
    /**
     * @private
     * @param {?} obj
     * @return {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.isHTMLElement = /**
     * @private
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        try {
            return obj instanceof HTMLElement;
        }
        catch (e) {
            // Browsers not supporting W3 DOM2.
            return (typeof obj === 'object' &&
                obj.nodeType === 1 &&
                typeof obj.style === 'object' &&
                typeof obj.ownerDocument === 'object');
        }
    };
    /** @nocollapse */
    BentoUniverseDropdownPositionDirective.ctorParameters = function () { return [
        { type: NgbDropdown, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] },
        { type: ElementRef },
        { type: WindowRef },
        { type: BentoLogService }
    ]; };
    BentoUniverseDropdownPositionDirective.propDecorators = {
        bentoUniverseFilterDropdownPosition: [{ type: Input }],
        menuRef: [{ type: ContentChild, args: ['dropdownMenu', { read: ElementRef },] }]
    };
BentoUniverseDropdownPositionDirective.ɵfac = function BentoUniverseDropdownPositionDirective_Factory(t) { return new (t || BentoUniverseDropdownPositionDirective)(ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; }))), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(BentoLogService)); };
BentoUniverseDropdownPositionDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoUniverseDropdownPositionDirective, selectors: [["", "bentoUniverseFilterDropdownPosition", ""]], contentQueries: function BentoUniverseDropdownPositionDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c77, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuRef = _t.first);
    } }, inputs: { bentoUniverseFilterDropdownPosition: "bentoUniverseFilterDropdownPosition" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseDropdownPositionDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoUniverseFilterDropdownPosition]'
            }]
    }], function () { return [{ type: ɵngcc4.NgbDropdown, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }, { type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: BentoLogService }]; }, { bentoUniverseFilterDropdownPosition: [{
            type: Input
        }], menuRef: [{
            type: ContentChild,
            args: ['dropdownMenu', { read: ElementRef }]
        }] }); })();
    return BentoUniverseDropdownPositionDirective;
}());
if (false) {
    /**
     * Input to get the reference of the container that this element is appended to
     * @type {?}
     */
    BentoUniverseDropdownPositionDirective.prototype.bentoUniverseFilterDropdownPosition;
    /**
     * Parent element to be appended to
     * @type {?}
     */
    BentoUniverseDropdownPositionDirective.prototype._appendToEl;
    /**
     * Window and document reference
     * @type {?}
     * @protected
     */
    BentoUniverseDropdownPositionDirective.prototype.window;
    /**
     * @type {?}
     * @protected
     */
    BentoUniverseDropdownPositionDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseDropdownPositionDirective.prototype.menuRef;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseDropdownPositionDirective.prototype.oldParent;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseDropdownPositionDirective.prototype.menuWrapper;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseDropdownPositionDirective.prototype.onChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseDropdownPositionDirective.prototype.dropdown;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseDropdownPositionDirective.prototype.elementRef;
    /**
     * @type {?}
     * @protected
     */
    BentoUniverseDropdownPositionDirective.prototype.logService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter-dropdown/universe-filter-dropdown.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The universe filter bar is usually positioned under the global header navbar
 * and contains the most widely used filter sets. When an item is clicked, a
 * dropdowm menu opens whereupon a filter selection is made. The dropdown menu
 * can be customized with a template. The universe filter bar is currently
 * limited to four items.
 *
 */
var BentoUniverseFilterDropdownComponent = /** @class */ (function () {
    /**
     * [constructor get NgbModal service, listen to window resize notifcation]
     */
    function BentoUniverseFilterDropdownComponent(bentoNotification, dir) {
        var _this = this;
        this.dir = dir;
        /**
         * Event handler for back button click. Omit this attribute to hide the back button.
         */
        this.onBackButtonClick = new EventEmitter();
        /**
         * Event handler when a filter item is selected. Returns the selected item object (please see
         * BentoUniverseFilterDropdownItemOptions).
         */
        this.onFilterItemChanged = new EventEmitter();
        /**
         * Event handler when the filter is open or closed
         */
        this.openChange = new EventEmitter();
        this.hasBackBtn = false;
        this.isOpen = false;
        this.isOpenArr = [];
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
        this.isRtl = this.dir.value === 'rtl';
        dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRtl = _this.dir.value === 'rtl';
        }));
    }
    /**
     * @return {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this._dropdownComponents.forEach((/**
         * @param {?} dropdown
         * @return {?}
         */
        function (dropdown) {
            dropdown.close();
        }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.onSelect = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.items[$event.index].selectedName = $event.selectedItem.title;
        this.onFilterItemChanged.emit(this.items[$event.index]);
        this.close();
    };
    /**
     * @param {?} open
     * @param {?} i
     * @return {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.onOpenChange = /**
     * @param {?} open
     * @param {?} i
     * @return {?}
     */
    function (open, i) {
        var _this = this;
        this.isOpenArr[i] = open;
        this.isOpen = false;
        this.isOpenArr.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            if (item) {
                _this.isOpen = true;
            }
        }));
        this.openChange.emit(this.isOpen);
    };
    /**
     * @return {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._resizeSubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.hasBackBtn = this.onBackButtonClick.observers.length > 0;
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseFilterDropdownComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () {
        // update ellipsis tooltip trigger
        this._ellipsisText.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            item.checkEllipsis();
        }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BentoUniverseFilterDropdownComponent.prototype._onBackButtonClick = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.onBackButtonClick.emit($event);
    };
    /** @nocollapse */
    BentoUniverseFilterDropdownComponent.ctorParameters = function () { return [
        { type: BentoNotification },
        { type: Directionality }
    ]; };
    BentoUniverseFilterDropdownComponent.propDecorators = {
        items: [{ type: Input }],
        selectText: [{ type: Input }],
        backBtnDisabled: [{ type: Input }],
        onBackButtonClick: [{ type: Output }],
        onFilterItemChanged: [{ type: Output }],
        openChange: [{ type: Output }],
        _dropdownComponents: [{ type: ViewChildren, args: [NgbDropdown,] }],
        _ellipsisText: [{ type: ViewChildren, args: [BentoUniverseFilterDropdownEllipsisDirective,] }],
        menuItems: [{ type: ViewChildren, args: [NgbDropdownItem,] }]
    };
BentoUniverseFilterDropdownComponent.ɵfac = function BentoUniverseFilterDropdownComponent_Factory(t) { return new (t || BentoUniverseFilterDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality)); };
BentoUniverseFilterDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoUniverseFilterDropdownComponent, selectors: [["bento-universe-filter-dropdown"]], viewQuery: function BentoUniverseFilterDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbDropdown, true);
        ɵngcc0.ɵɵviewQuery(BentoUniverseFilterDropdownEllipsisDirective, true);
        ɵngcc0.ɵɵviewQuery(NgbDropdownItem, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._dropdownComponents = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._ellipsisText = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuItems = _t);
    } }, inputs: { items: "items", selectText: "selectText", backBtnDisabled: "backBtnDisabled" }, outputs: { onBackButtonClick: "onBackButtonClick", onFilterItemChanged: "onFilterItemChanged", openChange: "openChange" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 8, vars: 7, consts: [[1, "bento-uni-filter", "row", 3, "ngClass"], ["filterElRef", ""], ["type", "button", "class", "bento-uni-filter_back-btn", "tabindex", "0", 3, "disabled", "click", "keypress", 4, "ngIf"], ["class", "bento-uni-filter_item dropdown", "ngbDropdown", "", "bentoUniverseFilterKeyboardSupport", "", 3, "ngClass", "autoClose", "bentoUniverseFilterDropdownPosition", "openChange", 4, "ngFor", "ngForOf"], [1, "bento-uni-filter_back-drop"], ["bentoUniFilterTemplate", ""], ["type", "button", "tabindex", "0", 1, "bento-uni-filter_back-btn", 3, "disabled", "click", "keypress"], ["class", "bento-icon-arrow-left", "aria-hidden", "true", 4, "ngIf"], ["class", "bento-icon-arrow-right", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "bento-icon-arrow-left"], ["aria-hidden", "true", 1, "bento-icon-arrow-right"], ["ngbDropdown", "", "bentoUniverseFilterKeyboardSupport", "", 1, "bento-uni-filter_item", "dropdown", 3, "ngClass", "autoClose", "bentoUniverseFilterDropdownPosition", "openChange"], ["ngbDropdownToggle", "", "role", "menuitem", 1, "bento-uni-filter_dropdown-toggle"], [1, "bento-uni-filter_item-header"], ["bentoUniverseFilterDropdownEllipsis", "", "placement", "bottom", 1, "bento-uni-filter_item-text", 3, "ngbTooltip", "bentoEllipsisText"], [1, "bento-uni-filter_carat", "bento-icon-caret-down-filled"], ["ngbDropdownMenu", "", 1, "bento-uni-filter_dropdown-menu", "dropdown-menu"], ["dropdownMenu", ""], [3, "item", "menuindex", "defaultTemplate", "onClose", "onSelect"], [1, "bento-uni-filter_dropdown-list"], ["tabindex", "-1", "role", "menuitem", 3, "ngClass", "click", "keydown", 4, "ngFor", "ngForOf"], ["tabindex", "-1", "role", "menuitem", 3, "ngClass", "click", "keydown"]], template: function BentoUniverseFilterDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, BentoUniverseFilterDropdownComponent_button_2_Template, 4, 6, "button", 2);
        ɵngcc0.ɵɵtemplate(3, BentoUniverseFilterDropdownComponent_div_3_Template, 11, 15, "div", 3);
        ɵngcc0.ɵɵpipe(4, "slice");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, BentoUniverseFilterDropdownComponent_ng_template_6_Template, 2, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", (ctx.hasBackBtn ? "has-back-btn " : "") + (ctx.isOpen ? "open " : ""));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasBackBtn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(4, 3, ctx.items, 0, 4));
    } }, directives: function () { return [ɵngcc7.NgClass, ɵngcc7.NgIf, ɵngcc7.NgForOf, ɵngcc4.NgbDropdown, BentoUniverseFilterKeyboardSupportDirective,
        BentoUniverseDropdownPositionDirective, ɵngcc4.NgbDropdownToggle, BentoUniverseFilterDropdownEllipsisDirective, ɵngcc4.NgbTooltip, ɵngcc4.NgbDropdownMenu, BentoNgbDropdownAnimationDirective,
        BentoUniverseFilterDropdownMenuComponent]; }, pipes: function () { return [ɵngcc7.SlicePipe, BentoTranslatePipe]; }, styles: ["bento-universe-filter .bento-uni-filter,bento-universe-filter-dropdown .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}bento-universe-filter .bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}bento-universe-filter .bento-uni-filter.has-back-btn,bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter.has-back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 52px 0 0}bento-universe-filter .bento-uni-filter_back-btn,bento-universe-filter-dropdown .bento-uni-filter_back-btn{width:52px;margin:0 0 0 -52px;float:left;border:none;min-height:52px;text-align:center;font-size:1.429rem;position:relative;padding:0;cursor:pointer;transition:background-color .2s}[dir=rtl] bento-universe-filter .bento-uni-filter_back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_back-btn{margin:0 -52px 0 0}bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-],bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_back-btn:focus,bento-universe-filter .bento-uni-filter_back-btn:hover,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover{outline:0}bento-universe-filter .bento-uni-filter_back-btn:focus:after,bento-universe-filter .bento-uni-filter_back-btn:hover:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}bento-universe-filter .bento-uni-filter_back-btn[disabled],bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled]{pointer-events:none;opacity:.2}bento-universe-filter .bento-uni-filter_dropdown-toggle,bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}bento-universe-filter .bento-uni-filter_dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translateX(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px rgba(0,0,0,.3)}bento-universe-filter .bento-uni-filter_dropdown-menu:after,bento-universe-filter .bento-uni-filter_dropdown-menu:before,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before{content:none}bento-universe-filter .bento-uni-filter_dropdown-menu.full-width,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}bento-universe-filter .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter .bento-uni-filter.align-right .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu{transform:none}bento-universe-filter .bento-uni-filter.full-width .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}bento-universe-filter .bento-uni-filter_item,bento-universe-filter-dropdown .bento-uni-filter_item{min-height:82px;cursor:pointer;transition:background-color .2s}bento-universe-filter .bento-uni-filter_item.open,bento-universe-filter .bento-uni-filter_item.selected,bento-universe-filter .bento-uni-filter_item.show,bento-universe-filter .bento-uni-filter_item:focus,bento-universe-filter .bento-uni-filter_item:hover,bento-universe-filter-dropdown .bento-uni-filter_item.open,bento-universe-filter-dropdown .bento-uni-filter_item.selected,bento-universe-filter-dropdown .bento-uni-filter_item.show,bento-universe-filter-dropdown .bento-uni-filter_item:focus,bento-universe-filter-dropdown .bento-uni-filter_item:hover{outline:0}bento-universe-filter .bento-uni-filter_item.open:before,bento-universe-filter .bento-uni-filter_item.selected:before,bento-universe-filter .bento-uni-filter_item.show:before,bento-universe-filter .bento-uni-filter_item:focus:before,bento-universe-filter .bento-uni-filter_item:hover:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{left:0;right:-1px}bento-universe-filter .bento-uni-filter_item.open:last-child:before,bento-universe-filter .bento-uni-filter_item.selected:last-child:before,bento-universe-filter .bento-uni-filter_item.show:last-child:before,bento-universe-filter .bento-uni-filter_item:focus:last-child:before,bento-universe-filter .bento-uni-filter_item:hover:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before{border-right:none}bento-universe-filter .bento-uni-filter_item.open:after,bento-universe-filter .bento-uni-filter_item.show:after,bento-universe-filter-dropdown .bento-uni-filter_item.open:after,bento-universe-filter-dropdown .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}bento-universe-filter .bento-uni-filter_item-header,bento-universe-filter-dropdown .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:.786rem;width:100%;letter-spacing:.1em}bento-universe-filter .bento-uni-filter_item-text,bento-universe-filter-dropdown .bento-uni-filter_item-text{padding:8px 20px 8px 10px;line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] bento-universe-filter .bento-uni-filter_item-text,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}bento-universe-filter .bento-uni-filter_carat,bento-universe-filter-dropdown .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:1rem;line-height:20px}[dir=rtl] bento-universe-filter .bento-uni-filter_carat,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_carat{right:auto;left:20px;text-align:left}bento-universe-filter .bento-uni-filter_modal.modal,bento-universe-filter-dropdown .bento-uni-filter_modal.modal{display:flex!important;padding:0}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog{width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:.929rem;width:100%;letter-spacing:.15em}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}bento-universe-filter .bento-uni-filter_modal.modal button.close,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}bento-universe-filter .bento-uni-filter_modal.modal button.close i,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_modal-list,bento-universe-filter-dropdown .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_modal-list>li,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}bento-universe-filter .bento-uni-filter_modal-list>li.selected,bento-universe-filter .bento-uni-filter_modal-list>li:focus,bento-universe-filter .bento-uni-filter_modal-list>li:hover,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover{outline:0}bento-universe-filter .bento-uni-filter_dropdown-list,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_dropdown-list>li,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}bento-universe-filter .bento-uni-filter .tooltip-inner,bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner{text-align:left}bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper,bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content bento-universe-filter .bento-uni-filter,.bento-off-canvas-menu-content bento-universe-filter-dropdown .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'bento-universe-filter-dropdown',
                template: "<div\n  #filterElRef\n  class=\"bento-uni-filter row\"\n  [ngClass]=\"(hasBackBtn ? 'has-back-btn ' : '') + (isOpen ? 'open ' : '')\"\n>\n  <button\n    type=\"button\"\n    class=\"bento-uni-filter_back-btn\"\n    *ngIf=\"hasBackBtn\"\n    [disabled]=\"backBtnDisabled\"\n    (click)=\"_onBackButtonClick($event)\"\n    (keypress)=\"$event.which === 13 ? _onBackButtonClick($event) : 0\"\n    tabindex=\"0\"\n    attr.aria-label=\"{{ 'BENTO_UI_UNIVERSAL_FILTER_BACK' | bentoTranslate }}\"\n  >\n    <i class=\"bento-icon-arrow-left\" *ngIf=\"!isRtl\" aria-hidden=\"true\"></i>\n    <i class=\"bento-icon-arrow-right\" *ngIf=\"isRtl\" aria-hidden=\"true\"></i>\n  </button>\n  <div\n    class=\"bento-uni-filter_item dropdown\"\n    *ngFor=\"let i = index; let item; of: items | slice: 0:4\"\n    [ngClass]=\"\n      (selectedName === item.title ? 'selected ' : '') +\n      (items.length >= 4 ? 'col-3' : items.length === 3 ? 'col-4' : items.length === 2 ? 'col-6' : 'col-12')\n    \"\n    (openChange)=\"onOpenChange($event, i)\"\n    [autoClose]=\"'outside'\"\n    ngbDropdown\n    [bentoUniverseFilterDropdownPosition]=\"filterElRef\"\n    bentoUniverseFilterKeyboardSupport\n  >\n    <div class=\"bento-uni-filter_dropdown-toggle\" ngbDropdownToggle role=\"menuitem\">\n      <div class=\"bento-uni-filter_item-header\">{{ item.title }}</div>\n      <button\n        class=\"bento-uni-filter_item-text\"\n        ngbTooltip=\"{{ item.selectedName || selectText || 'Select' }}\"\n        bentoUniverseFilterDropdownEllipsis\n        bentoEllipsisText=\"{{ item.selectedName || item.selectText || selectText || 'Select' }}\"\n        placement=\"bottom\"\n      ></button>\n      <i\n        attr.aria-label=\"{{\n          isOpenArr[i]\n            ? ('BENTO_UI_UNIVERSAL_FILTER_COLLAPSE' | bentoTranslate)\n            : ('BENTO_UI_UNIVERSAL_FILTER_EXPAND' | bentoTranslate)\n        }} {{ item.title }}\"\n        class=\"bento-uni-filter_carat bento-icon-caret-down-filled\"\n      ></i>\n    </div>\n    <div class=\"bento-uni-filter_dropdown-menu dropdown-menu\" #dropdownMenu ngbDropdownMenu>\n      <bento-universe-filter-dropdown-menu\n        [item]=\"item\"\n        [menuindex]=\"i\"\n        (onClose)=\"close()\"\n        (onSelect)=\"onSelect($event)\"\n        [defaultTemplate]=\"bentoUniFilterTemplate\"\n      ></bento-universe-filter-dropdown-menu>\n    </div>\n  </div>\n</div>\n<div class=\"bento-uni-filter_back-drop\"></div>\n<ng-template #bentoUniFilterTemplate let-c=\"close\" let-s=\"selectItem\" let-i=\"filterItem\">\n  <ul class=\"bento-uni-filter_dropdown-list\">\n    <li\n      *ngFor=\"let item of i.items\"\n      (click)=\"s(item)\"\n      (keydown)=\"$event.which === 13 ? s(item) : 0\"\n      [ngClass]=\"item.title === i.selectedName ? 'selected' : ''\"\n      tabindex=\"-1\"\n      role=\"menuitem\"\n    >\n      {{ item.title }}\n    </li>\n  </ul>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [BentoNotification],
                styles: ["bento-universe-filter .bento-uni-filter,bento-universe-filter-dropdown .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}bento-universe-filter .bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}bento-universe-filter .bento-uni-filter.has-back-btn,bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter.has-back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 52px 0 0}bento-universe-filter .bento-uni-filter_back-btn,bento-universe-filter-dropdown .bento-uni-filter_back-btn{width:52px;margin:0 0 0 -52px;float:left;border:none;min-height:52px;text-align:center;font-size:1.429rem;position:relative;padding:0;cursor:pointer;transition:background-color .2s}[dir=rtl] bento-universe-filter .bento-uni-filter_back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_back-btn{margin:0 -52px 0 0}bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-],bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_back-btn:focus,bento-universe-filter .bento-uni-filter_back-btn:hover,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover{outline:0}bento-universe-filter .bento-uni-filter_back-btn:focus:after,bento-universe-filter .bento-uni-filter_back-btn:hover:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}bento-universe-filter .bento-uni-filter_back-btn[disabled],bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled]{pointer-events:none;opacity:.2}bento-universe-filter .bento-uni-filter_dropdown-toggle,bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}bento-universe-filter .bento-uni-filter_dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translateX(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px rgba(0,0,0,.3)}bento-universe-filter .bento-uni-filter_dropdown-menu:after,bento-universe-filter .bento-uni-filter_dropdown-menu:before,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before{content:none}bento-universe-filter .bento-uni-filter_dropdown-menu.full-width,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}bento-universe-filter .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter .bento-uni-filter.align-right .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu{transform:none}bento-universe-filter .bento-uni-filter.full-width .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}bento-universe-filter .bento-uni-filter_item,bento-universe-filter-dropdown .bento-uni-filter_item{min-height:82px;cursor:pointer;transition:background-color .2s}bento-universe-filter .bento-uni-filter_item.open,bento-universe-filter .bento-uni-filter_item.selected,bento-universe-filter .bento-uni-filter_item.show,bento-universe-filter .bento-uni-filter_item:focus,bento-universe-filter .bento-uni-filter_item:hover,bento-universe-filter-dropdown .bento-uni-filter_item.open,bento-universe-filter-dropdown .bento-uni-filter_item.selected,bento-universe-filter-dropdown .bento-uni-filter_item.show,bento-universe-filter-dropdown .bento-uni-filter_item:focus,bento-universe-filter-dropdown .bento-uni-filter_item:hover{outline:0}bento-universe-filter .bento-uni-filter_item.open:before,bento-universe-filter .bento-uni-filter_item.selected:before,bento-universe-filter .bento-uni-filter_item.show:before,bento-universe-filter .bento-uni-filter_item:focus:before,bento-universe-filter .bento-uni-filter_item:hover:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{left:0;right:-1px}bento-universe-filter .bento-uni-filter_item.open:last-child:before,bento-universe-filter .bento-uni-filter_item.selected:last-child:before,bento-universe-filter .bento-uni-filter_item.show:last-child:before,bento-universe-filter .bento-uni-filter_item:focus:last-child:before,bento-universe-filter .bento-uni-filter_item:hover:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before{border-right:none}bento-universe-filter .bento-uni-filter_item.open:after,bento-universe-filter .bento-uni-filter_item.show:after,bento-universe-filter-dropdown .bento-uni-filter_item.open:after,bento-universe-filter-dropdown .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}bento-universe-filter .bento-uni-filter_item-header,bento-universe-filter-dropdown .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:.786rem;width:100%;letter-spacing:.1em}bento-universe-filter .bento-uni-filter_item-text,bento-universe-filter-dropdown .bento-uni-filter_item-text{padding:8px 20px 8px 10px;line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] bento-universe-filter .bento-uni-filter_item-text,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}bento-universe-filter .bento-uni-filter_carat,bento-universe-filter-dropdown .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:1rem;line-height:20px}[dir=rtl] bento-universe-filter .bento-uni-filter_carat,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_carat{right:auto;left:20px;text-align:left}bento-universe-filter .bento-uni-filter_modal.modal,bento-universe-filter-dropdown .bento-uni-filter_modal.modal{display:flex!important;padding:0}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog{width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:.929rem;width:100%;letter-spacing:.15em}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}bento-universe-filter .bento-uni-filter_modal.modal button.close,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}bento-universe-filter .bento-uni-filter_modal.modal button.close i,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_modal-list,bento-universe-filter-dropdown .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_modal-list>li,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}bento-universe-filter .bento-uni-filter_modal-list>li.selected,bento-universe-filter .bento-uni-filter_modal-list>li:focus,bento-universe-filter .bento-uni-filter_modal-list>li:hover,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover{outline:0}bento-universe-filter .bento-uni-filter_dropdown-list,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_dropdown-list>li,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}bento-universe-filter .bento-uni-filter .tooltip-inner,bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner{text-align:left}bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper,bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content bento-universe-filter .bento-uni-filter,.bento-off-canvas-menu-content bento-universe-filter-dropdown .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}"]
            }]
    }], function () { return [{ type: BentoNotification }, { type: ɵngcc6.Directionality }]; }, { onBackButtonClick: [{
            type: Output
        }], onFilterItemChanged: [{
            type: Output
        }], openChange: [{
            type: Output
        }], items: [{
            type: Input
        }], selectText: [{
            type: Input
        }], backBtnDisabled: [{
            type: Input
        }], _dropdownComponents: [{
            type: ViewChildren,
            args: [NgbDropdown]
        }], _ellipsisText: [{
            type: ViewChildren,
            args: [BentoUniverseFilterDropdownEllipsisDirective]
        }], menuItems: [{
            type: ViewChildren,
            args: [NgbDropdownItem]
        }] }); })();
    return BentoUniverseFilterDropdownComponent;
}());
if (false) {
    /**
     * Filter item data array
     * @type {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.items;
    /**
     * Select text override
     * @type {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.selectText;
    /**
     * Disable/enable the back button
     * @type {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.backBtnDisabled;
    /**
     * Event handler for back button click. Omit this attribute to hide the back button.
     * @type {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.onBackButtonClick;
    /**
     * Event handler when a filter item is selected. Returns the selected item object (please see
     * BentoUniverseFilterDropdownItemOptions).
     * @type {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.onFilterItemChanged;
    /**
     * Event handler when the filter is open or closed
     * @type {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.openChange;
    /** @type {?} */
    BentoUniverseFilterDropdownComponent.prototype.modalFilterItem;
    /** @type {?} */
    BentoUniverseFilterDropdownComponent.prototype.hasBackBtn;
    /** @type {?} */
    BentoUniverseFilterDropdownComponent.prototype.isOpen;
    /** @type {?} */
    BentoUniverseFilterDropdownComponent.prototype.isOpenArr;
    /** @type {?} */
    BentoUniverseFilterDropdownComponent.prototype.selectedName;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownComponent.prototype._dropdownComponents;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownComponent.prototype._ellipsisText;
    /** @type {?} */
    BentoUniverseFilterDropdownComponent.prototype.menuItems;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownComponent.prototype._resizeSubscription;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoUniverseFilterDropdownComponent.prototype.isRtl;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterDropdownComponent.prototype.dir;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter-dropdown/universe-filter-keyboard-support.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Make NgbDropdown to support keyboard navigations
 */
var BentoUniverseFilterKeyboardSupportDirective = /** @class */ (function () {
    function BentoUniverseFilterKeyboardSupportDirective(elementRef, windowRef, r, dropdown) {
        this.r = r;
        this.dropdown = dropdown;
        this.el = elementRef.nativeElement;
        this.onToggleKeydown = this.onToggleKeydown.bind(this);
        this.onMenuKeydown = this.onMenuKeydown.bind(this);
        // Add a unique class called (b)ento (ui) (d)rop(d)own (k)eyboard (support)
        this.r.addClass(this.el, BentoUniverseFilterKeyboardSupportDirective.CSS_CLASS_NAME);
    }
    /**
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dropdownMenuEl = this.dropdownMenu.nativeElement;
        // this.dropdownMenuEl = this.el.querySelector('.dropdown-menu');
        this.dropdownButtonEl = this.el.querySelector('.bento-uni-filter_item-text');
        this.toggleEl = this.el.querySelector('.dropdown-toggle');
        this.r.listen(this.toggleEl, 'keydown', this.onToggleKeydown);
        this.r.listen(this.dropdownMenuEl, 'keydown', this.onMenuKeydown);
        this.onChangeSubscription = this.dropdown.openChange.subscribe((/**
         * @param {?} open
         * @return {?}
         */
        function (open) {
            _this.isOpen = open;
            if (open) {
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.dropdownSelectionIndex = 0;
                    // this.dropdownMenuEl.classList.add('show');
                    _this.menuItems = Array.from(_this.dropdownMenuEl.querySelectorAll('[role="menuitem"]'));
                    _this.menuItems[0].focus();
                    /** @type {?} */
                    var action = _this.getAction(_this.menuItems[0].tagName);
                    _this.menuItems[0][action]();
                }), 0);
            }
            else {
                // this.dropdownMenuEl.classList.remove('show');
            }
        }));
    };
    /**
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.onChangeSubscription) {
            this.onChangeSubscription.unsubscribe();
        }
    };
    /**
     * @private
     * @param {?} tagName
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.getAction = /**
     * @private
     * @param {?} tagName
     * @return {?}
     */
    function (tagName) {
        /** @type {?} */
        var action;
        switch (tagName) {
            case 'INPUT':
                action = 'click';
                break;
            default:
                action = 'focus';
                break;
        }
        return action;
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.incrementDropdownSelectionIndex = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.dropdownSelectionIndex < this.menuItems.length - 1) {
            this.dropdownSelectionIndex++;
        }
        return this.dropdownSelectionIndex;
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.decrementDropdownSelectionIndex = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.dropdownSelectionIndex > 0) {
            this.dropdownSelectionIndex--;
        }
        return this.dropdownSelectionIndex;
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.onMenuKeydown = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        // let currentFocusedIndex = this.menuItems.indexOf(this.document.activeElement as HTMLElement);
        // const menuItemSize = this.menuItems.length;
        // currentFocusedIndex = currentFocusedIndex < 0 ? 0 : currentFocusedIndex;
        var _this = this;
        switch (e.keyCode) {
            case Keyboard.ENTER:
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.dropdownButtonEl.focus(); }));
                break;
            case Keyboard.UP:
                {
                    this.decrementDropdownSelectionIndex();
                    /** @type {?} */
                    var action = this.getAction(this.menuItems[this.dropdownSelectionIndex].tagName);
                    this.menuItems[this.dropdownSelectionIndex][action]();
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.DOWN:
                {
                    this.incrementDropdownSelectionIndex();
                    /** @type {?} */
                    var action = this.getAction(this.menuItems[this.dropdownSelectionIndex].tagName);
                    this.menuItems[this.dropdownSelectionIndex][action]();
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.ESC:
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.dropdownButtonEl.focus(); }));
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.dropdown.close();
                    _this.dropdownButtonEl.focus();
                }));
                break;
        }
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.onToggleKeydown = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        switch (e.keyCode) {
            case Keyboard.ENTER:
                if (this.isOpen) {
                    setTimeout((/**
                     * @return {?}
                     */
                    function () { return _this.dropdown.close(); }));
                }
                else {
                    this.showDropdown();
                }
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.UP:
            case Keyboard.DOWN:
                this.showDropdown();
                e.stopPropagation();
                e.preventDefault();
                break;
            case Keyboard.LEFT:
            case Keyboard.RIGHT:
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.dropdown.close(); }));
                break;
        }
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.showDropdown = /**
     * @private
     * @return {?}
     */
    function () {
        if (!this.isOpen) {
            this.dropdown.open();
        }
    };
    // Class name used to determine if the HTMLElement is initialized already or not
    // (B)ento (T)ool(B)ar (K)eyboard (Support)
    BentoUniverseFilterKeyboardSupportDirective.CSS_CLASS_NAME = 'bui-tb-k-support';
    /** @nocollapse */
    BentoUniverseFilterKeyboardSupportDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: WindowRef },
        { type: Renderer2 },
        { type: NgbDropdown, decorators: [{ type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return NgbDropdown; })),] }] }
    ]; };
    BentoUniverseFilterKeyboardSupportDirective.propDecorators = {
        dropdownMenu: [{ type: ContentChild, args: ['dropdownMenu', { static: true },] }]
    };
BentoUniverseFilterKeyboardSupportDirective.ɵfac = function BentoUniverseFilterKeyboardSupportDirective_Factory(t) { return new (t || BentoUniverseFilterKeyboardSupportDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(WindowRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(forwardRef(( /**
                 * @return {?}
                 */function () { return NgbDropdown; })))); };
BentoUniverseFilterKeyboardSupportDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoUniverseFilterKeyboardSupportDirective, selectors: [["", "bentoUniverseFilterKeyboardSupport", ""]], contentQueries: function BentoUniverseFilterKeyboardSupportDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c77, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownMenu = _t.first);
    } } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterKeyboardSupportDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoUniverseFilterKeyboardSupport]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: WindowRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc4.NgbDropdown, decorators: [{
                type: Inject,
                args: [forwardRef(( /**
                                     * @return {?}
                                     */function () { return NgbDropdown; }))]
            }] }]; }, { dropdownMenu: [{
            type: ContentChild,
            args: ['dropdownMenu', { static: true }]
        }] }); })();
    return BentoUniverseFilterKeyboardSupportDirective;
}());
if (false) {
    /** @type {?} */
    BentoUniverseFilterKeyboardSupportDirective.CSS_CLASS_NAME;
    /** @type {?} */
    BentoUniverseFilterKeyboardSupportDirective.prototype.toggleEl;
    /** @type {?} */
    BentoUniverseFilterKeyboardSupportDirective.prototype.dropdownMenuEl;
    /** @type {?} */
    BentoUniverseFilterKeyboardSupportDirective.prototype.dropdownButtonEl;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.menuItems;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.onChangeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.isOpen;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.dropdownSelectionIndex;
    /** @type {?} */
    BentoUniverseFilterKeyboardSupportDirective.prototype.dropdownMenu;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterKeyboardSupportDirective.prototype.dropdown;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter-dropdown/universe-filter-dropdown.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoUniverseFilterDropdownModule = /** @class */ (function () {
    function BentoUniverseFilterDropdownModule() {
    }
BentoUniverseFilterDropdownModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoUniverseFilterDropdownModule });
BentoUniverseFilterDropdownModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoUniverseFilterDropdownModule_Factory(t) { return new (t || BentoUniverseFilterDropdownModule)(); }, imports: [[
            CommonModule,
            NgbDropdownModule,
            NgbTooltipModule,
            BentoAppendToModule,
            BentoTranslateModule,
            BentoNgbDropdownAnimationModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoUniverseFilterDropdownModule, { declarations: function () { return [BentoUniverseFilterDropdownMenuComponent,
        BentoUniverseFilterDropdownComponent,
        BentoUniverseDropdownPositionDirective,
        BentoUniverseFilterDropdownEllipsisDirective,
        BentoUniverseFilterKeyboardSupportDirective]; }, imports: function () { return [CommonModule,
        NgbDropdownModule,
        NgbTooltipModule,
        BentoAppendToModule,
        BentoTranslateModule,
        BentoNgbDropdownAnimationModule]; }, exports: function () { return [BentoUniverseFilterDropdownComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterDropdownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NgbDropdownModule,
                    NgbTooltipModule,
                    BentoAppendToModule,
                    BentoTranslateModule,
                    BentoNgbDropdownAnimationModule
                ],
                declarations: [
                    BentoUniverseFilterDropdownMenuComponent,
                    BentoUniverseFilterDropdownComponent,
                    BentoUniverseDropdownPositionDirective,
                    BentoUniverseFilterDropdownEllipsisDirective,
                    BentoUniverseFilterKeyboardSupportDirective
                ],
                exports: [BentoUniverseFilterDropdownComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoUniverseFilterDropdownModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter/universe-filter-ellipsis.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoUniverseFilterEllipsisDirective = /** @class */ (function () {
    function BentoUniverseFilterEllipsisDirective(elRef, sanitizer) {
        this.sanitizer = sanitizer;
        this._nativeElement = elRef.nativeElement;
    }
    Object.defineProperty(BentoUniverseFilterEllipsisDirective.prototype, "bentoEllipsisText", {
        set: /**
         * @param {?} text
         * @return {?}
         */
        function (text) {
            this._eText = text;
            this.checkEllipsis();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoUniverseFilterEllipsisDirective.prototype.checkEllipsis = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var txtElem = this._nativeElement;
        /** @type {?} */
        var str = this.sanitizer.sanitize(SecurityContext.HTML, this._eText);
        txtElem.innerHTML = str;
        txtElem.style.pointerEvents = '';
        if (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
            while (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
                /** @type {?} */
                var lastIndex = str.lastIndexOf(' ');
                str = str.substring(0, lastIndex);
                txtElem.innerHTML = str + '&hellip;';
                if (lastIndex <= 1) {
                    break;
                }
            }
        }
        else {
            // disable tooltip if full display of label
            txtElem.style.pointerEvents = 'none';
        }
    };
    /** @nocollapse */
    BentoUniverseFilterEllipsisDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: DomSanitizer }
    ]; };
    BentoUniverseFilterEllipsisDirective.propDecorators = {
        bentoEllipsisText: [{ type: Input }]
    };
BentoUniverseFilterEllipsisDirective.ɵfac = function BentoUniverseFilterEllipsisDirective_Factory(t) { return new (t || BentoUniverseFilterEllipsisDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
BentoUniverseFilterEllipsisDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoUniverseFilterEllipsisDirective, selectors: [["", "bentoUniverseFilterEllipsis", ""]], inputs: { bentoEllipsisText: "bentoEllipsisText" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterEllipsisDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoUniverseFilterEllipsis]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc5.DomSanitizer }]; }, { bentoEllipsisText: [{
            type: Input
        }] }); })();
    return BentoUniverseFilterEllipsisDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterEllipsisDirective.prototype._nativeElement;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterEllipsisDirective.prototype._eText;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterEllipsisDirective.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter/universe-filter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The universe filter bar is usually positioned under the global header navbar
 * and contains the most widely used filter sets. When an item is clicked, a
 * modal window opens whereupon a filter selection is made. The modal window
 * can be customized with a template. The universe filter bar is currently
 * limited to four items.
 *
 */
var BentoUniverseFilterComponent = /** @class */ (function () {
    /**
     * [constructor get NgbModal service, listen to window resize notifcation]
     */
    function BentoUniverseFilterComponent(modalService, bentoNotification, bentoLogService) {
        var _this = this;
        this.modalService = modalService;
        /**
         * Event handler for back button click. Omit this attribute to hide the back button.
         */
        this.onBackButtonClick = new EventEmitter();
        /**
         * Event handler when a filter item is selected. Returns the selected item object (please see
         * BentoUniverseFilterItemChangedEvent).
         */
        this.onFilterItemChanged = new EventEmitter();
        this.hasBackBtn = false;
        /** @type {?} */
        var warnMsg = "Deprecation Notice:\n    The Bento Universe Filter component will be removed in Bento NG 9.0.0.\n    Please switch to use Bento Universe Filter Dropdown component instead.";
        bentoLogService.warn(warnMsg);
        this._resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
    }
    /**
     * @return {?}
     */
    BentoUniverseFilterComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._resizeSubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    BentoUniverseFilterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.hasBackBtn = this.onBackButtonClick.observers.length > 0;
    };
    /**
     * @param {?} content
     * @param {?} filterItem
     * @param {?} filterItems
     * @return {?}
     */
    BentoUniverseFilterComponent.prototype._openModal = /**
     * @param {?} content
     * @param {?} filterItem
     * @param {?} filterItems
     * @return {?}
     */
    function (content, filterItem, filterItems) {
        var _this = this;
        // populate template with content
        this.modalFilterItem = filterItem;
        // grab NgbModalRef
        /** @type {?} */
        var modalTemplateRef = filterItem.modalTemplateUrl || content;
        /** @type {?} */
        var modalContent = filterItem.modalComponent || modalTemplateRef;
        /** @type {?} */
        var modalOptions = { windowClass: 'bento-uni-filter_modal' };
        this._modalRef = this.modalService.open(modalContent, modalOptions);
        if (this._modalRef.componentInstance) {
            this._modalRef.componentInstance.filterItem = filterItem;
            this._modalRef.componentInstance.filterItems = filterItems;
        }
        // add Result actions
        this._modalRef.result.then((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.onFilterItemChanged.emit({ selectedItem: filterItem });
        }));
    };
    /**
     * @param {?} item
     * @param {?} modalFilterItem
     * @return {?}
     */
    BentoUniverseFilterComponent.prototype._modalSelectItem = /**
     * @param {?} item
     * @param {?} modalFilterItem
     * @return {?}
     */
    function (item, modalFilterItem) {
        // select item and close modal
        modalFilterItem.selectedName = item.title;
        this._modalRef.close();
    };
    /**
     * @private
     * @return {?}
     */
    BentoUniverseFilterComponent.prototype._onResize = /**
     * @private
     * @return {?}
     */
    function () {
        // iterate through ellipsis items and update text
        this._ellipsisComponents.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.checkEllipsis(); }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    BentoUniverseFilterComponent.prototype._onBackButtonClick = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.onBackButtonClick.emit($event);
    };
    /** @nocollapse */
    BentoUniverseFilterComponent.ctorParameters = function () { return [
        { type: NgbModal },
        { type: BentoNotification },
        { type: BentoLogService }
    ]; };
    BentoUniverseFilterComponent.propDecorators = {
        items: [{ type: Input }],
        selectText: [{ type: Input }],
        backBtnDisabled: [{ type: Input }],
        onBackButtonClick: [{ type: Output }],
        onFilterItemChanged: [{ type: Output }],
        _ellipsisComponents: [{ type: ViewChildren, args: [BentoUniverseFilterEllipsisDirective,] }]
    };
BentoUniverseFilterComponent.ɵfac = function BentoUniverseFilterComponent_Factory(t) { return new (t || BentoUniverseFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(BentoLogService)); };
BentoUniverseFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoUniverseFilterComponent, selectors: [["bento-universe-filter"]], viewQuery: function BentoUniverseFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoUniverseFilterEllipsisDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._ellipsisComponents = _t);
    } }, inputs: { items: "items", selectText: "selectText", backBtnDisabled: "backBtnDisabled" }, outputs: { onBackButtonClick: "onBackButtonClick", onFilterItemChanged: "onFilterItemChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification])], decls: 6, vars: 7, consts: [[1, "bento-uni-filter", "row", 3, "ngClass"], ["type", "button", "class", "bento-uni-filter_back-btn", "tabindex", "0", 3, "disabled", "click", "keypress", 4, "ngIf"], ["class", "bento-uni-filter_item", "tabindex", "0", 3, "ngClass", "click", "keypress", 4, "ngFor", "ngForOf"], ["bentoUniFilterModal", ""], ["type", "button", "tabindex", "0", 1, "bento-uni-filter_back-btn", 3, "disabled", "click", "keypress"], ["aria-hidden", "true", 1, "bento-icon-arrow-left"], ["tabindex", "0", 1, "bento-uni-filter_item", 3, "ngClass", "click", "keypress"], [1, "bento-uni-filter_item-header"], ["bentoUniverseFilterEllipsis", "", "placement", "bottom", 1, "bento-uni-filter_item-text", 3, "bentoEllipsisText", "ngbTooltip"], ["aria-hidden", "true", 1, "bento-uni-filter_carat", "bento-icon-caret-down"], ["type", "button", "aria-hidden", "true", "tabindex", "0", 1, "close", 3, "click", "keypress"], ["aria-hidden", "true", 1, "bento-icon-close-x"], [1, "modal-header"], [1, "modal-body"], [1, "bento-uni-filter_modal-list"], ["tabindex", "0", 3, "click", "keypress", 4, "ngFor", "ngForOf"], ["tabindex", "0", 3, "click", "keypress"]], template: function BentoUniverseFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BentoUniverseFilterComponent_button_1_Template, 2, 1, "button", 1);
        ɵngcc0.ɵɵtemplate(2, BentoUniverseFilterComponent_div_2_Template, 5, 4, "div", 2);
        ɵngcc0.ɵɵpipe(3, "slice");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, BentoUniverseFilterComponent_ng_template_4_Template, 7, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.hasBackBtn ? "has-back-btn" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasBackBtn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(3, 3, ctx.items, 0, 4));
    } }, directives: [ɵngcc7.NgClass, ɵngcc7.NgIf, ɵngcc7.NgForOf, BentoUniverseFilterEllipsisDirective, ɵngcc4.NgbTooltip], pipes: [ɵngcc7.SlicePipe], styles: ["bento-universe-filter .bento-uni-filter,bento-universe-filter-dropdown .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}bento-universe-filter .bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}bento-universe-filter .bento-uni-filter.has-back-btn,bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter.has-back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 52px 0 0}bento-universe-filter .bento-uni-filter_back-btn,bento-universe-filter-dropdown .bento-uni-filter_back-btn{width:52px;margin:0 0 0 -52px;float:left;border:none;min-height:52px;text-align:center;font-size:1.429rem;position:relative;padding:0;cursor:pointer;transition:background-color .2s}[dir=rtl] bento-universe-filter .bento-uni-filter_back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_back-btn{margin:0 -52px 0 0}bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-],bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_back-btn:focus,bento-universe-filter .bento-uni-filter_back-btn:hover,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover{outline:0}bento-universe-filter .bento-uni-filter_back-btn:focus:after,bento-universe-filter .bento-uni-filter_back-btn:hover:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}bento-universe-filter .bento-uni-filter_back-btn[disabled],bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled]{pointer-events:none;opacity:.2}bento-universe-filter .bento-uni-filter_dropdown-toggle,bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}bento-universe-filter .bento-uni-filter_dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translateX(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px rgba(0,0,0,.3)}bento-universe-filter .bento-uni-filter_dropdown-menu:after,bento-universe-filter .bento-uni-filter_dropdown-menu:before,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before{content:none}bento-universe-filter .bento-uni-filter_dropdown-menu.full-width,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}bento-universe-filter .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter .bento-uni-filter.align-right .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu{transform:none}bento-universe-filter .bento-uni-filter.full-width .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}bento-universe-filter .bento-uni-filter_item,bento-universe-filter-dropdown .bento-uni-filter_item{min-height:82px;cursor:pointer;transition:background-color .2s}bento-universe-filter .bento-uni-filter_item.open,bento-universe-filter .bento-uni-filter_item.selected,bento-universe-filter .bento-uni-filter_item.show,bento-universe-filter .bento-uni-filter_item:focus,bento-universe-filter .bento-uni-filter_item:hover,bento-universe-filter-dropdown .bento-uni-filter_item.open,bento-universe-filter-dropdown .bento-uni-filter_item.selected,bento-universe-filter-dropdown .bento-uni-filter_item.show,bento-universe-filter-dropdown .bento-uni-filter_item:focus,bento-universe-filter-dropdown .bento-uni-filter_item:hover{outline:0}bento-universe-filter .bento-uni-filter_item.open:before,bento-universe-filter .bento-uni-filter_item.selected:before,bento-universe-filter .bento-uni-filter_item.show:before,bento-universe-filter .bento-uni-filter_item:focus:before,bento-universe-filter .bento-uni-filter_item:hover:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{left:0;right:-1px}bento-universe-filter .bento-uni-filter_item.open:last-child:before,bento-universe-filter .bento-uni-filter_item.selected:last-child:before,bento-universe-filter .bento-uni-filter_item.show:last-child:before,bento-universe-filter .bento-uni-filter_item:focus:last-child:before,bento-universe-filter .bento-uni-filter_item:hover:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before{border-right:none}bento-universe-filter .bento-uni-filter_item.open:after,bento-universe-filter .bento-uni-filter_item.show:after,bento-universe-filter-dropdown .bento-uni-filter_item.open:after,bento-universe-filter-dropdown .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}bento-universe-filter .bento-uni-filter_item-header,bento-universe-filter-dropdown .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:.786rem;width:100%;letter-spacing:.1em}bento-universe-filter .bento-uni-filter_item-text,bento-universe-filter-dropdown .bento-uni-filter_item-text{padding:8px 20px 8px 10px;line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] bento-universe-filter .bento-uni-filter_item-text,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}bento-universe-filter .bento-uni-filter_carat,bento-universe-filter-dropdown .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:1rem;line-height:20px}[dir=rtl] bento-universe-filter .bento-uni-filter_carat,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_carat{right:auto;left:20px;text-align:left}bento-universe-filter .bento-uni-filter_modal.modal,bento-universe-filter-dropdown .bento-uni-filter_modal.modal{display:flex!important;padding:0}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog{width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:.929rem;width:100%;letter-spacing:.15em}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}bento-universe-filter .bento-uni-filter_modal.modal button.close,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}bento-universe-filter .bento-uni-filter_modal.modal button.close i,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_modal-list,bento-universe-filter-dropdown .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_modal-list>li,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}bento-universe-filter .bento-uni-filter_modal-list>li.selected,bento-universe-filter .bento-uni-filter_modal-list>li:focus,bento-universe-filter .bento-uni-filter_modal-list>li:hover,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover{outline:0}bento-universe-filter .bento-uni-filter_dropdown-list,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_dropdown-list>li,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}bento-universe-filter .bento-uni-filter .tooltip-inner,bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner{text-align:left}bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper,bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content bento-universe-filter .bento-uni-filter,.bento-off-canvas-menu-content bento-universe-filter-dropdown .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterComponent, [{
        type: Component,
        args: [{
                selector: 'bento-universe-filter',
                template: "<div class=\"bento-uni-filter row\" [ngClass]=\"hasBackBtn ? 'has-back-btn' : ''\">\n  <button\n    type=\"button\"\n    class=\"bento-uni-filter_back-btn\"\n    *ngIf=\"hasBackBtn\"\n    [disabled]=\"backBtnDisabled\"\n    (click)=\"_onBackButtonClick($event)\"\n    (keypress)=\"$event.which === 13 ? _onBackButtonClick($event) : 0\"\n    tabindex=\"0\"\n  >\n    <i class=\"bento-icon-arrow-left\" aria-hidden=\"true\"></i>\n  </button>\n  <div\n    class=\"bento-uni-filter_item\"\n    *ngFor=\"let item of items | slice: 0:4\"\n    [ngClass]=\"\n      (selectedName === item.title ? 'selected ' : '') +\n      (items.length >= 4 ? 'col-3' : items.length === 3 ? 'col-4' : items.length === 2 ? 'col-6' : 'col-12')\n    \"\n    (click)=\"_openModal(bentoUniFilterModal, item, items)\"\n    (keypress)=\"$event.which === 13 ? _openModal(bentoUniFilterModal, item, items) : 0\"\n    tabindex=\"0\"\n  >\n    <div class=\"bento-uni-filter_item-header\">{{ item.title }}</div>\n    <div\n      class=\"bento-uni-filter_item-text\"\n      bentoUniverseFilterEllipsis\n      bentoEllipsisText=\"{{ item.selectedName || item.selectText || selectText || 'Select' }}\"\n      ngbTooltip=\"{{ item.selectedName || selectText || 'Select' }}\"\n      placement=\"bottom\"\n    ></div>\n    <i class=\"bento-uni-filter_carat bento-icon-caret-down\" aria-hidden=\"true\"></i>\n  </div>\n</div>\n<ng-template #bentoUniFilterModal let-c=\"close\" let-d=\"dismiss\">\n  <button\n    type=\"button\"\n    class=\"close\"\n    aria-hidden=\"true\"\n    (click)=\"d()\"\n    (keypress)=\"$event.which === 13 ? d() : 0\"\n    tabindex=\"0\"\n  >\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n  </button>\n  <div class=\"modal-header\">Select {{ modalFilterItem.title }}</div>\n  <div class=\"modal-body\">\n    <ul class=\"bento-uni-filter_modal-list\">\n      <li\n        *ngFor=\"let item of modalFilterItem.items\"\n        (click)=\"_modalSelectItem(item, modalFilterItem)\"\n        (keypress)=\"$event.which === 13 ? _modalSelectItem(item, modalFilterItem) : 0\"\n        tabindex=\"0\"\n      >\n        {{ item.title }}\n      </li>\n    </ul>\n  </div>\n</ng-template>\n",
                providers: [BentoNotification],
                encapsulation: ViewEncapsulation.None,
                styles: ["bento-universe-filter .bento-uni-filter,bento-universe-filter-dropdown .bento-uni-filter{position:relative;display:flex;margin:0;border-width:1px;border-style:solid;border-left:none;z-index:11}bento-universe-filter .bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter_back-drop{position:absolute;left:0;right:0;bottom:0;top:0;display:none;z-index:10}bento-universe-filter .bento-uni-filter.has-back-btn,bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 0 0 52px;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter.has-back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter.has-back-btn{padding:0 52px 0 0}bento-universe-filter .bento-uni-filter_back-btn,bento-universe-filter-dropdown .bento-uni-filter_back-btn{width:52px;margin:0 0 0 -52px;float:left;border:none;min-height:52px;text-align:center;font-size:1.429rem;position:relative;padding:0;cursor:pointer;transition:background-color .2s}[dir=rtl] bento-universe-filter .bento-uni-filter_back-btn,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_back-btn{margin:0 -52px 0 0}bento-universe-filter .bento-uni-filter_back-btn>i[class*=bento-icon-],bento-universe-filter-dropdown .bento-uni-filter_back-btn>i[class*=bento-icon-]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_back-btn:focus,bento-universe-filter .bento-uni-filter_back-btn:hover,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover{outline:0}bento-universe-filter .bento-uni-filter_back-btn:focus:after,bento-universe-filter .bento-uni-filter_back-btn:hover:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:focus:after,bento-universe-filter-dropdown .bento-uni-filter_back-btn:hover:after{content:\" \";display:block;position:absolute;width:1px;height:100%;right:0;top:0}bento-universe-filter .bento-uni-filter_back-btn[disabled],bento-universe-filter-dropdown .bento-uni-filter_back-btn[disabled]{pointer-events:none;opacity:.2}bento-universe-filter .bento-uni-filter_dropdown-toggle,bento-universe-filter-dropdown .bento-uni-filter_dropdown-toggle{display:block;height:100%;margin-left:-15px;margin-right:-15px;padding:0 15px}bento-universe-filter .bento-uni-filter_dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu{top:calc(100% - 1px)!important;border-top:none;transform:translateX(-1px)!important;max-height:350px;overflow:auto;padding:0;max-width:100%;box-shadow:0 8px 8px rgba(0,0,0,.3)}bento-universe-filter .bento-uni-filter_dropdown-menu:after,bento-universe-filter .bento-uni-filter_dropdown-menu:before,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:after,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu:before{content:none}bento-universe-filter .bento-uni-filter_dropdown-menu.full-width,bento-universe-filter-dropdown .bento-uni-filter_dropdown-menu.full-width{width:calc(100% - 30px);margin-left:15px}bento-universe-filter .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.uib-dropdown-open+.bento-uni-filter_back-drop{display:block}bento-universe-filter .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter .bento-uni-filter.align-right .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-left .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.align-right .dropdown-menu{transform:none}bento-universe-filter .bento-uni-filter.full-width .dropdown-menu,bento-universe-filter-dropdown .bento-uni-filter.full-width .dropdown-menu{left:15px!important;right:15px!important;transform:none}bento-universe-filter .bento-uni-filter_item,bento-universe-filter-dropdown .bento-uni-filter_item{min-height:82px;cursor:pointer;transition:background-color .2s}bento-universe-filter .bento-uni-filter_item.open,bento-universe-filter .bento-uni-filter_item.selected,bento-universe-filter .bento-uni-filter_item.show,bento-universe-filter .bento-uni-filter_item:focus,bento-universe-filter .bento-uni-filter_item:hover,bento-universe-filter-dropdown .bento-uni-filter_item.open,bento-universe-filter-dropdown .bento-uni-filter_item.selected,bento-universe-filter-dropdown .bento-uni-filter_item.show,bento-universe-filter-dropdown .bento-uni-filter_item:focus,bento-universe-filter-dropdown .bento-uni-filter_item:hover{outline:0}bento-universe-filter .bento-uni-filter_item.open:before,bento-universe-filter .bento-uni-filter_item.selected:before,bento-universe-filter .bento-uni-filter_item.show:before,bento-universe-filter .bento-uni-filter_item:focus:before,bento-universe-filter .bento-uni-filter_item:hover:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{content:\"\";pointer-events:none;position:absolute;height:100%;top:0;left:-1px;right:0;display:block;box-sizing:border-box;border-right-width:1px;border-right-style:solid;border-left-width:1px;border-left-style:solid}[dir=rtl] bento-universe-filter .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter .bento-uni-filter_item:hover:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.open:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.selected:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item.show:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:focus:before,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item:hover:before{left:0;right:-1px}bento-universe-filter .bento-uni-filter_item.open:last-child:before,bento-universe-filter .bento-uni-filter_item.selected:last-child:before,bento-universe-filter .bento-uni-filter_item.show:last-child:before,bento-universe-filter .bento-uni-filter_item:focus:last-child:before,bento-universe-filter .bento-uni-filter_item:hover:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.open:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.selected:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item.show:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:focus:last-child:before,bento-universe-filter-dropdown .bento-uni-filter_item:hover:last-child:before{border-right:none}bento-universe-filter .bento-uni-filter_item.open:after,bento-universe-filter .bento-uni-filter_item.show:after,bento-universe-filter-dropdown .bento-uni-filter_item.open:after,bento-universe-filter-dropdown .bento-uni-filter_item.show:after{content:\"\";position:absolute;height:2px;width:calc(100% - 1px);bottom:-2px;left:0}bento-universe-filter .bento-uni-filter_item-header,bento-universe-filter-dropdown .bento-uni-filter_item-header{padding:8px 0 0;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:.786rem;width:100%;letter-spacing:.1em}bento-universe-filter .bento-uni-filter_item-text,bento-universe-filter-dropdown .bento-uni-filter_item-text{padding:8px 20px 8px 10px;line-height:16px;max-height:35px;overflow:hidden;margin-bottom:10px;width:100%;float:left;border-width:1px;border-style:solid;border-radius:4px;margin-top:5px;white-space:nowrap;text-overflow:ellipsis;text-align:left}[dir=rtl] bento-universe-filter .bento-uni-filter_item-text,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_item-text{text-align:right;padding:8px 10px 8px 20px}bento-universe-filter .bento-uni-filter_carat,bento-universe-filter-dropdown .bento-uni-filter_carat{position:absolute;top:35px;right:20px;width:25px;text-align:right;font-size:1rem;line-height:20px}[dir=rtl] bento-universe-filter .bento-uni-filter_carat,[dir=rtl] bento-universe-filter-dropdown .bento-uni-filter_carat{right:auto;left:20px;text-align:left}bento-universe-filter .bento-uni-filter_modal.modal,bento-universe-filter-dropdown .bento-uni-filter_modal.modal{display:flex!important;padding:0}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog{width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content{padding:0;display:inline-block;text-align:left;width:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-header{padding:20px 70px 20px 30px;text-transform:uppercase;font-size:.929rem;width:100%;letter-spacing:.15em}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body{padding:0;margin:0;max-height:calc(100vh - 120px);overflow-y:auto}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-body.modal-body-has-footer{max-height:calc(100vh - 200px)}bento-universe-filter .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer,bento-universe-filter-dropdown .bento-uni-filter_modal.modal .modal-dialog .modal-content .modal-footer{padding:15px}bento-universe-filter .bento-uni-filter_modal.modal button.close,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close{width:58px;height:58px;position:absolute;right:0;opacity:1;top:0}bento-universe-filter .bento-uni-filter_modal.modal button.close i,bento-universe-filter-dropdown .bento-uni-filter_modal.modal button.close i{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}bento-universe-filter .bento-uni-filter_modal-list,bento-universe-filter-dropdown .bento-uni-filter_modal-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_modal-list>li,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li{margin:0;padding:10px 30px;cursor:pointer}bento-universe-filter .bento-uni-filter_modal-list>li.selected,bento-universe-filter .bento-uni-filter_modal-list>li:focus,bento-universe-filter .bento-uni-filter_modal-list>li:hover,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li.selected,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:focus,bento-universe-filter-dropdown .bento-uni-filter_modal-list>li:hover{outline:0}bento-universe-filter .bento-uni-filter_dropdown-list,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list{padding:0;margin:0;list-style:none}bento-universe-filter .bento-uni-filter_dropdown-list>li,bento-universe-filter-dropdown .bento-uni-filter_dropdown-list>li{margin:0;padding:10px 15px;cursor:pointer}bento-universe-filter .bento-uni-filter .tooltip-inner,bento-universe-filter-dropdown .bento-uni-filter .tooltip-inner{text-align:left}bento-universe-filter .bento-uni-filter .dropdown-menu-wrapper,bento-universe-filter-dropdown .bento-uni-filter .dropdown-menu-wrapper{position:absolute;top:83px;right:0;left:0;z-index:1000}bento-universe-filter .bento-uni-filter.open+.bento-uni-filter_back-drop,bento-universe-filter-dropdown .bento-uni-filter.open+.bento-uni-filter_back-drop{display:block}.bento-off-canvas-menu-content bento-universe-filter .bento-uni-filter,.bento-off-canvas-menu-content bento-universe-filter-dropdown .bento-uni-filter{width:auto;border-top:none;border-right:none;border-left:none}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgbModal }, { type: BentoNotification }, { type: BentoLogService }]; }, { onBackButtonClick: [{
            type: Output
        }], onFilterItemChanged: [{
            type: Output
        }], items: [{
            type: Input
        }], selectText: [{
            type: Input
        }], backBtnDisabled: [{
            type: Input
        }], _ellipsisComponents: [{
            type: ViewChildren,
            args: [BentoUniverseFilterEllipsisDirective]
        }] }); })();
    return BentoUniverseFilterComponent;
}());
if (false) {
    /**
     * Filter item data array
     * @type {?}
     */
    BentoUniverseFilterComponent.prototype.items;
    /**
     * Select text override
     * @type {?}
     */
    BentoUniverseFilterComponent.prototype.selectText;
    /**
     * Disable/enable the back button
     * @type {?}
     */
    BentoUniverseFilterComponent.prototype.backBtnDisabled;
    /**
     * Event handler for back button click. Omit this attribute to hide the back button.
     * @type {?}
     */
    BentoUniverseFilterComponent.prototype.onBackButtonClick;
    /**
     * Event handler when a filter item is selected. Returns the selected item object (please see
     * BentoUniverseFilterItemChangedEvent).
     * @type {?}
     */
    BentoUniverseFilterComponent.prototype.onFilterItemChanged;
    /** @type {?} */
    BentoUniverseFilterComponent.prototype.modalFilterItem;
    /** @type {?} */
    BentoUniverseFilterComponent.prototype.hasBackBtn;
    /** @type {?} */
    BentoUniverseFilterComponent.prototype.selectedName;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterComponent.prototype._ellipsisComponents;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterComponent.prototype._modalRef;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterComponent.prototype._resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoUniverseFilterComponent.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter/universe-filter.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoUniverseFilterModule = /** @class */ (function () {
    function BentoUniverseFilterModule() {
    }
BentoUniverseFilterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoUniverseFilterModule });
BentoUniverseFilterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoUniverseFilterModule_Factory(t) { return new (t || BentoUniverseFilterModule)(); }, imports: [[CommonModule, NgbModalModule, NgbTooltipModule, BentoTranslateModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoUniverseFilterModule, { declarations: function () { return [BentoUniverseFilterComponent,
        BentoUniverseFilterEllipsisDirective]; }, imports: function () { return [CommonModule, NgbModalModule, NgbTooltipModule,
        BentoTranslateModule]; }, exports: function () { return [BentoUniverseFilterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoUniverseFilterModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgbModalModule, NgbTooltipModule, BentoTranslateModule],
                declarations: [BentoUniverseFilterComponent, BentoUniverseFilterEllipsisDirective],
                exports: [BentoUniverseFilterComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoUniverseFilterModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wizard/wizard-event.class.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An event class to handle Bento Wizard Component events
 */
var  /**
 * An event class to handle Bento Wizard Component events
 */
BentoWizardComponentEvent = /** @class */ (function () {
    /**
     * Constructor
     */
    function BentoWizardComponentEvent(step, oldStep, stopPropagation) {
        this.step = step;
        this.oldStep = oldStep;
        this.stopPropagation = stopPropagation;
    }
    return BentoWizardComponentEvent;
}());
if (false) {
    /**
     * The index of the new step that is related to this event
     * @type {?}
     */
    BentoWizardComponentEvent.prototype.step;
    /**
     * The index of the old step that is related to this event
     * @type {?}
     */
    BentoWizardComponentEvent.prototype.oldStep;
    /**
     * Prevent propagation to proceed to next step
     * A parameter `Subscribable<boolean>` can be used to stop from proceeding asynchronously
     * @type {?}
     */
    BentoWizardComponentEvent.prototype.stopPropagation;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wizard/wizard-step.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Bento Wizard Nav Step Component
 */
var BentoWizardStepComponent = /** @class */ (function () {
    function BentoWizardStepComponent(elRef) {
        /**
         * Title of the current Step component in Bento Wizard nav element
         */
        this.title = '';
        /**
         * Description of the current Step component in Bento Wizard nav element
         */
        this.description = '';
        /**
         * Flag to set the current Step component as disabled
         */
        this.disabled = false;
        /**
         * Flag to show and hide the completed indicator for this step
         */
        this.completed = false;
        this.el = elRef.nativeElement;
    }
    /**
     * Hide current step (only applies to rendering)
     */
    /**
     * Hide current step (only applies to rendering)
     * @return {?}
     */
    BentoWizardStepComponent.prototype.hide = /**
     * Hide current step (only applies to rendering)
     * @return {?}
     */
    function () {
        this.el.style.display = 'none';
    };
    /**
     * Show current step (only applies to rendering)
     */
    /**
     * Show current step (only applies to rendering)
     * @return {?}
     */
    BentoWizardStepComponent.prototype.show = /**
     * Show current step (only applies to rendering)
     * @return {?}
     */
    function () {
        this.el.style.display = 'block';
    };
    /** @nocollapse */
    BentoWizardStepComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    BentoWizardStepComponent.propDecorators = {
        title: [{ type: Input }],
        description: [{ type: Input }],
        disabled: [{ type: Input }],
        completed: [{ type: Input }]
    };
BentoWizardStepComponent.ɵfac = function BentoWizardStepComponent_Factory(t) { return new (t || BentoWizardStepComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BentoWizardStepComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoWizardStepComponent, selectors: [["bento-wizard-step"]], inputs: { title: "title", description: "description", disabled: "disabled", completed: "completed" }, ngContentSelectors: _c4, decls: 2, vars: 0, consts: [[1, "wizard-step-content"]], template: function BentoWizardStepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoWizardStepComponent, [{
        type: Component,
        args: [{
                selector: 'bento-wizard-step',
                template: "\n    <div class=\"wizard-step-content\">\n      <ng-content></ng-content>\n    </div>\n  "
                // changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { title: [{
            type: Input
        }], description: [{
            type: Input
        }], disabled: [{
            type: Input
        }], completed: [{
            type: Input
        }] }); })();
    return BentoWizardStepComponent;
}());
if (false) {
    /**
     * Title of the current Step component in Bento Wizard nav element
     * @type {?}
     */
    BentoWizardStepComponent.prototype.title;
    /**
     * Description of the current Step component in Bento Wizard nav element
     * @type {?}
     */
    BentoWizardStepComponent.prototype.description;
    /**
     * Flag to set the current Step component as disabled
     * @type {?}
     */
    BentoWizardStepComponent.prototype.disabled;
    /**
     * Flag to show and hide the completed indicator for this step
     * @type {?}
     */
    BentoWizardStepComponent.prototype.completed;
    /** @type {?} */
    BentoWizardStepComponent.prototype.el;
    /** @type {?} */
    BentoWizardStepComponent.prototype.isCompleted;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wizard/wizard.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A simple directive which renders a responsive wizard template. The DOM
 * object flows to 100% of its parent object's width. The 'Previous,' 'Next,'
 * and 'Done' buttons are i18n-ready.
 */
var BentoWizardComponent = /** @class */ (function () {
    /**
     * Main constructor
     */
    function BentoWizardComponent(elRef, r) {
        this.r = r;
        // Component Properties
        /**
         * Flag to hide default buttons including 'Previous', 'Next' and 'Done'
         */
        this.hideDefaultButtons = false;
        /**
         * Flag to only hide 'Previous' button
         */
        this.hidePreviousButton = false;
        /**
         * Flag to only hide 'Next' button
         */
        this.hideNextButton = false;
        /**
         * Flag to only hide 'Done' button
         */
        this.hideDoneButton = false;
        /**
         * Flag to show 'Cancel' button
         */
        this.showCancelButton = false;
        /**
         * Flag to use Bento Sticky Footer
         */
        this.useStickyFooter = false;
        /**
         * Flag to show if the Bento Sticky Footer in full width of its scrolling panel or align to the Wizard width
         */
        this.stickyFooterFullWidth = true;
        /**
         * A11y: Specify header tag for wizard's Title. The header tag's rank must be
         * in hierarchical order to the page in which the component is used.
         * Headings communicate the organization of the content on the page. Web
         * browsers, plug-ins, and assistive technologies can use them to provide
         * in-page navigation.
         */
        this.hTag = 'h1';
        this._currentStep = 0;
        /**
         * Callback when the current step of a Bento Wizard component is changed
         *
         * This callback will return the index number of the new step
         */
        this.currentStepChange = new EventEmitter();
        // Event Emitters
        /**
         * Callback when the current step of a Bento Wizard component is about to change
         *
         * A `BentoWizardComponentEvent` object is passed in for event-handling
         */
        this.currentStepChanging = new EventEmitter();
        /**
         * Callback when 'Cancel' button is clicked
         */
        this.cancel = new EventEmitter();
        /**
         * Callback when 'Done' button is clicked
         */
        this.done = new EventEmitter();
        this._stepsChangeEventEmitter = new EventEmitter();
        this._stepUIDs = [];
        this._hasCancellable = false;
        this._el = elRef.nativeElement;
    }
    Object.defineProperty(BentoWizardComponent.prototype, "currentStep", {
        /**
         * Sets the current step of a Bento Wizard component
         */
        set: /**
         * Sets the current step of a Bento Wizard component
         * @param {?} step
         * @return {?}
         */
        function (step) {
            /** @type {?} */
            var _step = !!step ? step : 0;
            if ((this._steps && this._steps.length <= step) || step < 0) {
                return;
            }
            if (this._steps) {
                // Only call this when _steps is ready
                this._onStepChange(_step);
            }
            else {
                // Initialization state, we wait for the content to be ready
                this._initStep = _step;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Callback when content is initialized
     */
    /**
     * Callback when content is initialized
     * @return {?}
     */
    BentoWizardComponent.prototype.ngAfterContentInit = /**
     * Callback when content is initialized
     * @return {?}
     */
    function () {
        var _this = this;
        this._onStepsUpdate();
        this._steps.changes.subscribe((/**
         * @return {?}
         */
        function () {
            _this._onStepsUpdate();
        }));
        // See if we need to pre-select a step defined by devs
        if (typeof this._initStep !== 'undefined') {
            this._onStepChange(this._initStep);
            this._initStep = null;
        }
    };
    /**
     * @return {?}
     */
    BentoWizardComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.wizardStepElements = this._el.querySelectorAll('.bento-wizard-steps .steps button.bento-wizard-step');
    };
    // Forward the Bento Step Strip to the user
    /**
     * This method is called when the Bento Wizard Strip is about to make changes
     * The Event is forward to the user then let it to decide whether it should call
     * the `_onStepChange(step)` for the actual change
     */
    // Forward the Bento Step Strip to the user
    /**
     * This method is called when the Bento Wizard Strip is about to make changes
     * The Event is forward to the user then let it to decide whether it should call
     * the `_onStepChange(step)` for the actual change
     * @param {?} event
     * @return {?}
     */
    BentoWizardComponent.prototype._onStripStepChanging = 
    // Forward the Bento Step Strip to the user
    /**
     * This method is called when the Bento Wizard Strip is about to make changes
     * The Event is forward to the user then let it to decide whether it should call
     * the `_onStepChange(step)` for the actual change
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.currentStepChanging.emit(event);
    };
    /**
     * Callback from the 'Previous' and 'Next' buttons
     */
    /**
     * Callback from the 'Previous' and 'Next' buttons
     * @param {?} $event
     * @param {?} step
     * @return {?}
     */
    BentoWizardComponent.prototype._onButtonStepChanging = /**
     * Callback from the 'Previous' and 'Next' buttons
     * @param {?} $event
     * @param {?} step
     * @return {?}
     */
    function ($event, step) {
        var _this = this;
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.currentStepChanging.emit(new BentoWizardComponentEvent(step, this._currentStep, (/**
         * @param {?=} cancellable
         * @return {?}
         */
        function (cancellable) {
            _this._hasCancellable = true;
            if (cancellable) {
                /** @type {?} */
                var subscription_1 = cancellable.subscribe((/**
                 * @param {?} response
                 * @return {?}
                 */
                function (response) {
                    if (response) {
                        _this._onStepChange(step);
                    }
                    // unsubscribe from the EventEmitter
                    subscription_1.unsubscribe();
                }));
            }
        })));
        if (!this._hasCancellable) {
            this._onStepChange(step);
        }
        else {
            // Reset the variable for the next step change
            this._hasCancellable = false;
        }
    };
    /**
     * Callback to fire the actual step change of the wizard
     */
    /**
     * Callback to fire the actual step change of the wizard
     * @param {?} step
     * @return {?}
     */
    BentoWizardComponent.prototype._onStepChange = /**
     * Callback to fire the actual step change of the wizard
     * @param {?} step
     * @return {?}
     */
    function (step) {
        // Steps are not ready
        if (typeof step === 'undefined' ||
            step === this._currentStep ||
            (step === 0 && typeof this._currentStep === 'undefined') ||
            !this._stepsArray ||
            this._stepsArray.length === 0) {
            return;
        }
        this._currentStep = step;
        this._updateViews();
        this.currentStepChange.emit(step);
        if (this.stickyFooter) {
            this.stickyFooter.checkAllocation();
        }
    };
    /**
     * Callback when done button is clicked
     */
    /**
     * Callback when done button is clicked
     * @param {?} $event
     * @return {?}
     */
    BentoWizardComponent.prototype._onDoneClick = /**
     * Callback when done button is clicked
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.done.emit();
    };
    /**
     * Callback when cancel button is clicked
     */
    /**
     * Callback when cancel button is clicked
     * @param {?} $event
     * @return {?}
     */
    BentoWizardComponent.prototype._onCancelClick = /**
     * Callback when cancel button is clicked
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.cancel.emit(this._currentStep);
    };
    // Private methods
    /**
     * Update and render views
     */
    // Private methods
    /**
     * Update and render views
     * @return {?}
     */
    BentoWizardComponent.prototype._updateViews = 
    // Private methods
    /**
     * Update and render views
     * @return {?}
     */
    function () {
        // Step can be out of range when some steps are hidden during the process
        this._currentStep = this._currentStep >= this._stepsArray.length ? this._stepsArray.length - 1 : this._currentStep;
        // Skip update view when `_currentStep` is not ready
        /** @type {?} */
        var step = typeof this._currentStep === 'undefined' ? 0 : this._currentStep;
        for (var i = 0; i < this._stepsArray.length; i++) {
            if (i !== step) {
                this._stepsArray[i].hide();
            }
        }
        this._stepsArray[step].show();
        if (this.wizardStepElements && this.wizardStepElements.length && step <= this.wizardStepElements.length) {
            /** @type {?} */
            var wizardStepEl = (/** @type {?} */ (this.wizardStepElements[step]));
            wizardStepEl.focus();
        }
    };
    /**
     * Callback when steps container is updated with a new layout
     */
    /**
     * Callback when steps container is updated with a new layout
     * @param {?=} emit
     * @return {?}
     */
    BentoWizardComponent.prototype._onStepsUpdate = /**
     * Callback when steps container is updated with a new layout
     * @param {?=} emit
     * @return {?}
     */
    function (emit) {
        if (emit === void 0) { emit = true; }
        if (this._steps && this._steps.length) {
            this.r.removeClass(this._el, 'bento-wizard-no-data');
            this._stepsArray = this._steps.toArray();
            this._updateViews();
            if (emit) {
                this._stepsChangeEventEmitter.emit(this._steps);
            }
        }
        else {
            // There is no data
            this.r.addClass(this._el, 'bento-wizard-no-data');
        }
    };
    /**
     * Callback when UIDs are given by the stip
     */
    /**
     * Callback when UIDs are given by the stip
     * @param {?} uids
     * @return {?}
     */
    BentoWizardComponent.prototype._onStepUIDsChange = /**
     * Callback when UIDs are given by the stip
     * @param {?} uids
     * @return {?}
     */
    function (uids) {
        this._stepUIDs = uids;
    };
    /** @nocollapse */
    BentoWizardComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    BentoWizardComponent.propDecorators = {
        hideDefaultButtons: [{ type: Input }],
        hidePreviousButton: [{ type: Input }],
        hideNextButton: [{ type: Input }],
        hideDoneButton: [{ type: Input }],
        showCancelButton: [{ type: Input }],
        useStickyFooter: [{ type: Input }],
        stickyFooterFullWidth: [{ type: Input }],
        currentStep: [{ type: Input }],
        hTag: [{ type: Input }],
        currentStepChange: [{ type: Output }],
        currentStepChanging: [{ type: Output }],
        cancel: [{ type: Output }],
        done: [{ type: Output }],
        stickyFooter: [{ type: ViewChild, args: [BentoStickyFooterComponent,] }],
        _steps: [{ type: ContentChildren, args: [BentoWizardStepComponent,] }]
    };
BentoWizardComponent.ɵfac = function BentoWizardComponent_Factory(t) { return new (t || BentoWizardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BentoWizardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoWizardComponent, selectors: [["bento-wizard"]], contentQueries: function BentoWizardComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BentoWizardStepComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._steps = _t);
    } }, viewQuery: function BentoWizardComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoStickyFooterComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stickyFooter = _t.first);
    } }, inputs: { hideDefaultButtons: "hideDefaultButtons", hidePreviousButton: "hidePreviousButton", hideNextButton: "hideNextButton", hideDoneButton: "hideDoneButton", showCancelButton: "showCancelButton", useStickyFooter: "useStickyFooter", stickyFooterFullWidth: "stickyFooterFullWidth", hTag: "hTag", currentStep: "currentStep" }, outputs: { currentStepChange: "currentStepChange", currentStepChanging: "currentStepChanging", cancel: "cancel", done: "done" }, ngContentSelectors: _c79, decls: 10, vars: 8, consts: [[1, "bento-wizard"], [3, "steps", "stepsObservable", "currentStep", "hTag", "currentStepChanging", "currentStepChange", "stepUIDsChange"], ["tabindex", "0", "cdkMonitorElementFocus", "", "role", "tabpanel", 1, "bento-wizard-contents", "container-fluid"], [4, "ngIf", "ngIfElse"], ["defaultFooter", ""], ["defaultButtons", ""], [1, "clearfix"], [3, "showOnElementVisible", "fullWidth"], [1, "bento-wizard-sticky-footer-content"], [3, "ngTemplateOutlet"], ["class", "btn btn-outline-primary bento-wizard-prev-button", "type", "button", 3, "disabled", "click", 4, "ngIf"], ["class", "btn btn-primary bento-wizard-next-button", "type", "button", 3, "disabled", "click", 4, "ngIf"], ["class", "btn btn-primary bento-wizard-done-button", "type", "button", 3, "click", 4, "ngIf"], ["class", "btn btn-outline-primary bento-wizard-cancel-button", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-outline-primary", "bento-wizard-prev-button", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-left"], [1, "btn-text"], ["type", "button", 1, "btn", "btn-primary", "bento-wizard-next-button", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-right"], ["type", "button", 1, "btn", "btn-primary", "bento-wizard-done-button", 3, "click"], ["type", "button", 1, "btn", "btn-outline-primary", "bento-wizard-cancel-button", 3, "click"]], template: function BentoWizardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c78);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "bento-wizard-strip", 1);
        ɵngcc0.ɵɵlistener("currentStepChanging", function BentoWizardComponent_Template_bento_wizard_strip_currentStepChanging_1_listener($event) { return ctx._onStripStepChanging($event); })("currentStepChange", function BentoWizardComponent_Template_bento_wizard_strip_currentStepChange_1_listener($event) { return ctx._onStepChange($event); })("stepUIDsChange", function BentoWizardComponent_Template_bento_wizard_strip_stepUIDsChange_1_listener($event) { return ctx._onStepUIDsChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, BentoWizardComponent_ng_container_4_Template, 4, 3, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(5, BentoWizardComponent_ng_template_5_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, BentoWizardComponent_ng_template_7_Template, 5, 4, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelement(9, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("steps", ctx._steps)("stepsObservable", ctx._stepsChangeEventEmitter)("currentStep", ctx._currentStep)("hTag", ctx.hTag);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", "tab-" + ctx._stepUIDs[ctx._currentStep])("aria-labeledby", ctx._stepUIDs[ctx._currentStep]);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useStickyFooter)("ngIfElse", _r1);
    } }, directives: function () { return [BentoWizardComponentStripComponent, ɵngcc1.CdkMonitorFocus, ɵngcc7.NgIf, BentoStickyFooterComponent, ɵngcc7.NgTemplateOutlet, BentoFocusMonitorDirective]; }, pipes: function () { return [BentoTranslatePipe]; }, styles: ["@charset \"UTF-8\";.html{padding:0;margin:0}bento-wizard .bento-wizard{position:relative;margin-bottom:20px;width:100%}bento-wizard .bento-wizard .arrow-bg-color,bento-wizard .bento-wizard-no-data{display:none}bento-wizard .bento-wizard bento-sticky-footer .btn,bento-wizard .bento-wizard bento-wizard-custom-button-group .btn,bento-wizard .bento-wizard>.btn{margin:10px 10px 0 0;float:left}[dir=rtl] bento-wizard .bento-wizard bento-sticky-footer .btn,[dir=rtl] bento-wizard .bento-wizard bento-wizard-custom-button-group .btn,[dir=rtl] bento-wizard .bento-wizard>.btn{float:right}bento-wizard .bento-wizard bento-sticky-footer .btn:last-child,bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:last-child,bento-wizard .bento-wizard>.btn:last-child{margin-right:0}bento-wizard .bento-wizard bento-sticky-footer .btn.float-right,bento-wizard .bento-wizard bento-wizard-custom-button-group .btn.float-right,bento-wizard .bento-wizard>.btn.float-right{margin-right:10px;margin-left:0}bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:left;margin-left:0;margin-right:10px}[dir=rtl] bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:right}[dir=rtl] bento-wizard .bento-wizard>.btn.bento-wizard-prev-button i:before{content:\"\uE646\"}[dir=rtl] bento-wizard .bento-wizard>.btn.bento-wizard-next-button i:before{content:\"\uE641\"}bento-wizard .bento-wizard .bento-wizard-done-button,bento-wizard .bento-wizard .bento-wizard-next-button{float:left}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-done-button,[dir=rtl] bento-wizard .bento-wizard .bento-wizard-next-button,bento-wizard .bento-wizard .bento-wizard-cancel-button{float:right}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-cancel-button{float:left}bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:first-child{margin-left:0}bento-wizard .bento-wizard>.btn.pull-right{margin-left:10px;margin-right:0}bento-wizard .bento-wizard bento-wizard-strip{display:block;width:100%;position:relative;z-index:1;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-wizard .bento-wizard bento-wizard-strip.side-arrows{position:relative}bento-wizard .bento-wizard bento-wizard-strip.side-arrows>.wizard-arrow{display:flex;z-index:1}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow{display:none;position:absolute;align-items:center;justify-content:center;top:0;padding:0;border-width:1px;border-style:solid;box-sizing:border-box;font-size:1.714rem}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:active,bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:focus{outline:0}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:0}[dir=rtl] bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:auto;right:0;transform:rotate(180deg)}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:0}[dir=rtl] bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:auto;left:0;transform:rotate(180deg)}bento-wizard .bento-wizard .bento-wizard-contents{width:100%;border-bottom-width:1px;border-bottom-style:solid;min-height:200px}bento-wizard .bento-wizard .bento-wizard-contents bento-wizard-step{padding:1px 25px 25px;z-index:2}bento-wizard .bento-wizard .bento-wizard-contents:focus{outline:0}bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-keyboard-focused bento-wizard-step,bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-program-focused bento-wizard-step{outline:dashed 1px}bento-wizard .bento-wizard .bento-wizard-steps{position:relative;top:0;width:100%;overflow:hidden;border-right-width:1px;border-right-style:solid}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps{border-right-width:1px;border-left-width:1px;border-left-style:solid}bento-wizard .bento-wizard .bento-wizard-steps:before{content:\"\";width:100%;height:100%;position:absolute;border-width:1px;border-style:solid;border-right:none}bento-wizard .bento-wizard .bento-wizard-steps .bento-wizard-step{position:relative}bento-wizard .bento-wizard .bento-wizard-steps .steps{counter-reset:wizardstepcount;margin:0;padding:0;display:block;float:left;white-space:nowrap}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps{float:right}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{display:inline-block;vertical-align:top;white-space:normal;cursor:pointer;position:relative;padding:15px 15px 5px;list-style:none;min-height:45px;text-overflow:ellipsis;text-align:left;border-left:none;border-right:none;border-top-width:1px;border-top-style:solid;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{float:right}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus{outline:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]).selected:first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]):first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]).selected:first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]):first-child:after{display:none}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step[disabled]{cursor:not-allowed}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:first-child{margin-left:0;border-left-width:1px;border-left-style:solid}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{content:\"\";position:absolute;height:100%;top:0;width:25px;left:100%;pointer-events:none;z-index:1}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{right:100%}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:30px}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:15px;padding-right:30px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .title{font-size:1.071rem;line-height:16px;display:block;font-weight:700}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .description{display:block;clear:both;margin:12px 0 0;float:left;font-size:.857rem;line-height:15px;width:100%;padding:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .title{line-height:14px;margin-bottom:4px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .description{width:auto;clear:none;border:none;margin:0;padding:0;line-height:1.2em;max-height:2.4em;overflow:hidden;float:none}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .bento-wizard-step-count:before{margin-bottom:30px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{position:absolute;left:0;top:-1px}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{right:-1px;transform:scaleX(-1)}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:first-child:after{background:0 0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow{padding:10px 15px 5px 10px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .title{line-height:16px;padding-top:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .description{margin-top:0;padding-top:8px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .bento-wizard-step-count:before{margin-bottom:10px;padding-bottom:8px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover{padding:9px 15px 5px 10px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:first-child,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover:first-child{padding-left:9px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.disabled{pointer-events:none;cursor:default}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{display:block;float:left}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{float:right}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{content:counter(wizardstepcount);counter-increment:wizardstepcount;display:block;float:left;padding:10px 12px 8px 0;box-sizing:border-box;margin-right:12px;font-weight:700;font-size:3rem;line-height:14px;border-right-width:1px;border-right-style:solid}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{float:right;padding:10px 0 8px 12px;border-left-style:solid;border-left-width:1px;border-right:none;margin-left:12px;margin-right:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{top:-1px;right:1px;content:\"\";position:absolute;width:25px;height:100px;pointer-events:none}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{right:auto;left:1px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover{cursor:default;padding-top:15px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child{padding-left:15px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child:after{background:0 0}bento-wizard .bento-wizard .wizard-title{margin-top:auto}.bento-sticky-bar .bento-wizard-sticky-footer-content{margin:0 -10px}.bento-sticky-bar .bento-wizard-sticky-footer-content .btn{margin-left:10px}.bento-sticky-bar .bento-wizard-sticky-footer-content .btn.float-right{margin-left:0;margin-right:10px}.bento-wizard-step-complete-icon{display:none}.completed>.wizard-title .bento-wizard-step-complete-icon{display:inline-block;vertical-align:bottom}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoWizardComponent, [{
        type: Component,
        args: [{
                selector: 'bento-wizard',
                template: "<div class=\"bento-wizard\">\n  <bento-wizard-strip\n    [steps]=\"_steps\"\n    [stepsObservable]=\"_stepsChangeEventEmitter\"\n    [currentStep]=\"_currentStep\"\n    [hTag]=\"hTag\"\n    (currentStepChanging)=\"_onStripStepChanging($event)\"\n    (currentStepChange)=\"_onStepChange($event)\"\n    (stepUIDsChange)=\"_onStepUIDsChange($event)\"\n  ></bento-wizard-strip>\n  <div\n    class=\"bento-wizard-contents container-fluid\"\n    [attr.id]=\"'tab-' + _stepUIDs[_currentStep]\"\n    [attr.aria-labeledby]=\"_stepUIDs[_currentStep]\"\n    tabindex=\"0\"\n    cdkMonitorElementFocus\n    role=\"tabpanel\"\n  >\n    <ng-content select=\"bento-wizard-step\"></ng-content>\n  </div>\n\n  <ng-container *ngIf=\"useStickyFooter; else defaultFooter\">\n    <bento-sticky-footer [showOnElementVisible]=\"_el\" [fullWidth]=\"stickyFooterFullWidth\">\n      <div class=\"bento-wizard-sticky-footer-content\">\n        <ng-container [ngTemplateOutlet]=\"defaultButtons\"></ng-container>\n      </div>\n    </bento-sticky-footer>\n  </ng-container>\n\n  <ng-template #defaultFooter>\n    <ng-container [ngTemplateOutlet]=\"defaultButtons\"></ng-container>\n  </ng-template>\n\n  <ng-template #defaultButtons>\n    <button\n      class=\"btn btn-outline-primary bento-wizard-prev-button\"\n      type=\"button\"\n      *ngIf=\"_currentStep > 0 && !hideDefaultButtons && !hidePreviousButton\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION' | bentoTranslate\"\n      (click)=\"_onButtonStepChanging($event, _currentStep - 1)\"\n      [disabled]=\"_stepsArray && _stepsArray[_currentStep - 1].disabled\"\n    >\n      <i class=\"bento-icon-chevron-left\" aria-hidden=\"true\"></i>\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_PREVIOUS' | bentoTranslate }}</span>\n    </button>\n    <button\n      class=\"btn btn-primary bento-wizard-next-button\"\n      *ngIf=\"_currentStep < _steps.length - 1 && !hideDefaultButtons && !hideNextButton\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION' | bentoTranslate\"\n      (click)=\"_onButtonStepChanging($event, _currentStep + 1)\"\n      [disabled]=\"_stepsArray && _stepsArray[_currentStep + 1].disabled\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_NEXT' | bentoTranslate }}</span>\n      <i class=\"bento-icon-chevron-right\" aria-hidden=\"true\"></i>\n    </button>\n    <button\n      class=\"btn btn-primary bento-wizard-done-button\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION' | bentoTranslate\"\n      *ngIf=\"_currentStep === _steps.length - 1 && !hideDefaultButtons && !hideDoneButton\"\n      (click)=\"_onDoneClick($event)\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_DONE' | bentoTranslate }}</span>\n    </button>\n    <button\n      class=\"btn btn-outline-primary bento-wizard-cancel-button\"\n      type=\"button\"\n      [attr.aria-label]=\"'BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION' | bentoTranslate\"\n      *ngIf=\"showCancelButton\"\n      (click)=\"_onCancelClick($event)\"\n    >\n      <span class=\"btn-text\">{{ 'BENTO_UI_WIZARD_BUTTON_CANCEL' | bentoTranslate }}</span>\n    </button>\n    <ng-content select=\"bento-wizard-custom-button-group\"></ng-content>\n  </ng-template>\n  <div class=\"clearfix\"></div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["@charset \"UTF-8\";.html{padding:0;margin:0}bento-wizard .bento-wizard{position:relative;margin-bottom:20px;width:100%}bento-wizard .bento-wizard .arrow-bg-color,bento-wizard .bento-wizard-no-data{display:none}bento-wizard .bento-wizard bento-sticky-footer .btn,bento-wizard .bento-wizard bento-wizard-custom-button-group .btn,bento-wizard .bento-wizard>.btn{margin:10px 10px 0 0;float:left}[dir=rtl] bento-wizard .bento-wizard bento-sticky-footer .btn,[dir=rtl] bento-wizard .bento-wizard bento-wizard-custom-button-group .btn,[dir=rtl] bento-wizard .bento-wizard>.btn{float:right}bento-wizard .bento-wizard bento-sticky-footer .btn:last-child,bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:last-child,bento-wizard .bento-wizard>.btn:last-child{margin-right:0}bento-wizard .bento-wizard bento-sticky-footer .btn.float-right,bento-wizard .bento-wizard bento-wizard-custom-button-group .btn.float-right,bento-wizard .bento-wizard>.btn.float-right{margin-right:10px;margin-left:0}bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:left;margin-left:0;margin-right:10px}[dir=rtl] bento-wizard .bento-wizard .btn.bento-wizard-prev-button{float:right}[dir=rtl] bento-wizard .bento-wizard>.btn.bento-wizard-prev-button i:before{content:\"\uE646\"}[dir=rtl] bento-wizard .bento-wizard>.btn.bento-wizard-next-button i:before{content:\"\uE641\"}bento-wizard .bento-wizard .bento-wizard-done-button,bento-wizard .bento-wizard .bento-wizard-next-button{float:left}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-done-button,[dir=rtl] bento-wizard .bento-wizard .bento-wizard-next-button,bento-wizard .bento-wizard .bento-wizard-cancel-button{float:right}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-cancel-button{float:left}bento-wizard .bento-wizard bento-wizard-custom-button-group .btn:first-child{margin-left:0}bento-wizard .bento-wizard>.btn.pull-right{margin-left:10px;margin-right:0}bento-wizard .bento-wizard bento-wizard-strip{display:block;width:100%;position:relative;z-index:1;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}bento-wizard .bento-wizard bento-wizard-strip.side-arrows{position:relative}bento-wizard .bento-wizard bento-wizard-strip.side-arrows>.wizard-arrow{display:flex;z-index:1}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow{display:none;position:absolute;align-items:center;justify-content:center;top:0;padding:0;border-width:1px;border-style:solid;box-sizing:border-box;font-size:1.714rem}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:active,bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow:focus{outline:0}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:0}[dir=rtl] bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-left{left:auto;right:0;transform:rotate(180deg)}bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:0}[dir=rtl] bento-wizard .bento-wizard bento-wizard-strip>.wizard-arrow.arrow-right{right:auto;left:0;transform:rotate(180deg)}bento-wizard .bento-wizard .bento-wizard-contents{width:100%;border-bottom-width:1px;border-bottom-style:solid;min-height:200px}bento-wizard .bento-wizard .bento-wizard-contents bento-wizard-step{padding:1px 25px 25px;z-index:2}bento-wizard .bento-wizard .bento-wizard-contents:focus{outline:0}bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-keyboard-focused bento-wizard-step,bento-wizard .bento-wizard .bento-wizard-contents:focus.cdk-program-focused bento-wizard-step{outline:dashed 1px}bento-wizard .bento-wizard .bento-wizard-steps{position:relative;top:0;width:100%;overflow:hidden;border-right-width:1px;border-right-style:solid}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps{border-right-width:1px;border-left-width:1px;border-left-style:solid}bento-wizard .bento-wizard .bento-wizard-steps:before{content:\"\";width:100%;height:100%;position:absolute;border-width:1px;border-style:solid;border-right:none}bento-wizard .bento-wizard .bento-wizard-steps .bento-wizard-step{position:relative}bento-wizard .bento-wizard .bento-wizard-steps .steps{counter-reset:wizardstepcount;margin:0;padding:0;display:block;float:left;white-space:nowrap}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps{float:right}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{display:inline-block;vertical-align:top;white-space:normal;cursor:pointer;position:relative;padding:15px 15px 5px;list-style:none;min-height:45px;text-overflow:ellipsis;text-align:left;border-left:none;border-right:none;border-top-width:1px;border-top-style:solid;border-bottom-width:1px;border-bottom-style:solid}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step{float:right}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus{outline:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]).selected:first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:focus:not([disabled]):first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]).selected:first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:hover:focus:not([disabled]):first-child:after{display:none}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step[disabled]{cursor:not-allowed}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:first-child{margin-left:0;border-left-width:1px;border-left-style:solid}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{content:\"\";position:absolute;height:100%;top:0;width:25px;left:100%;pointer-events:none;z-index:1}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:last-child:before{right:100%}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:30px}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:not(:first-child){padding-left:15px;padding-right:30px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .title{font-size:1.071rem;line-height:16px;display:block;font-weight:700}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .description{display:block;clear:both;margin:12px 0 0;float:left;font-size:.857rem;line-height:15px;width:100%;padding:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .title{line-height:14px;margin-bottom:4px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .description{width:auto;clear:none;border:none;margin:0;padding:0;line-height:1.2em;max-height:2.4em;overflow:hidden;float:none}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat .bento-wizard-step-count:before{margin-bottom:30px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{position:absolute;left:0;top:-1px}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:after{right:-1px;transform:scaleX(-1)}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.flat:first-child:after{background:0 0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow{padding:10px 15px 5px 10px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .title{line-height:16px;padding-top:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .description{margin-top:0;padding-top:8px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow .bento-wizard-step-count:before{margin-bottom:10px;padding-bottom:8px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover{padding:9px 15px 5px 10px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:first-child,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.narrow.selected:hover:first-child{padding-left:9px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.disabled{pointer-events:none;cursor:default}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{display:block;float:left}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count{float:right}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{content:counter(wizardstepcount);counter-increment:wizardstepcount;display:block;float:left;padding:10px 12px 8px 0;box-sizing:border-box;margin-right:12px;font-weight:700;font-size:3rem;line-height:14px;border-right-width:1px;border-right-style:solid}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step .bento-wizard-step-count:before{float:right;padding:10px 0 8px 12px;border-left-style:solid;border-left-width:1px;border-right:none;margin-left:12px;margin-right:0}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{top:-1px;right:1px;content:\"\";position:absolute;width:25px;height:100px;pointer-events:none}[dir=rtl] bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step:after{right:auto;left:1px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover{cursor:default;padding-top:15px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child{padding-left:15px}bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:first-child:after,bento-wizard .bento-wizard .bento-wizard-steps .steps>.bento-wizard-step.selected:hover:first-child:after{background:0 0}bento-wizard .bento-wizard .wizard-title{margin-top:auto}.bento-sticky-bar .bento-wizard-sticky-footer-content{margin:0 -10px}.bento-sticky-bar .bento-wizard-sticky-footer-content .btn{margin-left:10px}.bento-sticky-bar .bento-wizard-sticky-footer-content .btn.float-right{margin-left:0;margin-right:10px}.bento-wizard-step-complete-icon{display:none}.completed>.wizard-title .bento-wizard-step-complete-icon{display:inline-block;vertical-align:bottom}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { hideDefaultButtons: [{
            type: Input
        }], hidePreviousButton: [{
            type: Input
        }], hideNextButton: [{
            type: Input
        }], hideDoneButton: [{
            type: Input
        }], showCancelButton: [{
            type: Input
        }], useStickyFooter: [{
            type: Input
        }], stickyFooterFullWidth: [{
            type: Input
        }], hTag: [{
            type: Input
        }], currentStepChange: [{
            type: Output
        }], currentStepChanging: [{
            type: Output
        }], cancel: [{
            type: Output
        }], done: [{
            type: Output
        }], currentStep: [{
            type: Input
        }], stickyFooter: [{
            type: ViewChild,
            args: [BentoStickyFooterComponent]
        }], _steps: [{
            type: ContentChildren,
            args: [BentoWizardStepComponent]
        }] }); })();
    return BentoWizardComponent;
}());
if (false) {
    /**
     * Flag to hide default buttons including 'Previous', 'Next' and 'Done'
     * @type {?}
     */
    BentoWizardComponent.prototype.hideDefaultButtons;
    /**
     * Flag to only hide 'Previous' button
     * @type {?}
     */
    BentoWizardComponent.prototype.hidePreviousButton;
    /**
     * Flag to only hide 'Next' button
     * @type {?}
     */
    BentoWizardComponent.prototype.hideNextButton;
    /**
     * Flag to only hide 'Done' button
     * @type {?}
     */
    BentoWizardComponent.prototype.hideDoneButton;
    /**
     * Flag to show 'Cancel' button
     * @type {?}
     */
    BentoWizardComponent.prototype.showCancelButton;
    /**
     * Flag to use Bento Sticky Footer
     * @type {?}
     */
    BentoWizardComponent.prototype.useStickyFooter;
    /**
     * Flag to show if the Bento Sticky Footer in full width of its scrolling panel or align to the Wizard width
     * @type {?}
     */
    BentoWizardComponent.prototype.stickyFooterFullWidth;
    /**
     * A11y: Specify header tag for wizard's Title. The header tag's rank must be
     * in hierarchical order to the page in which the component is used.
     * Headings communicate the organization of the content on the page. Web
     * browsers, plug-ins, and assistive technologies can use them to provide
     * in-page navigation.
     * @type {?}
     */
    BentoWizardComponent.prototype.hTag;
    /** @type {?} */
    BentoWizardComponent.prototype._currentStep;
    /**
     * Callback when the current step of a Bento Wizard component is changed
     *
     * This callback will return the index number of the new step
     * @type {?}
     */
    BentoWizardComponent.prototype.currentStepChange;
    /**
     * Callback when the current step of a Bento Wizard component is about to change
     *
     * A `BentoWizardComponentEvent` object is passed in for event-handling
     * @type {?}
     */
    BentoWizardComponent.prototype.currentStepChanging;
    /**
     * Callback when 'Cancel' button is clicked
     * @type {?}
     */
    BentoWizardComponent.prototype.cancel;
    /**
     * Callback when 'Done' button is clicked
     * @type {?}
     */
    BentoWizardComponent.prototype.done;
    /** @type {?} */
    BentoWizardComponent.prototype.stickyFooter;
    /** @type {?} */
    BentoWizardComponent.prototype._steps;
    /** @type {?} */
    BentoWizardComponent.prototype._stepsChangeEventEmitter;
    /** @type {?} */
    BentoWizardComponent.prototype._stepsArray;
    /** @type {?} */
    BentoWizardComponent.prototype._el;
    /** @type {?} */
    BentoWizardComponent.prototype._stepUIDs;
    /** @type {?} */
    BentoWizardComponent.prototype.wizardStepElements;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponent.prototype._initStep;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponent.prototype._hasCancellable;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponent.prototype.r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wizard/wizard-custom-button-group.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoWizardComponentCustomButtonGroupComponent = /** @class */ (function () {
    function BentoWizardComponentCustomButtonGroupComponent() {
    }
BentoWizardComponentCustomButtonGroupComponent.ɵfac = function BentoWizardComponentCustomButtonGroupComponent_Factory(t) { return new (t || BentoWizardComponentCustomButtonGroupComponent)(); };
BentoWizardComponentCustomButtonGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoWizardComponentCustomButtonGroupComponent, selectors: [["bento-wizard-custom-button-group"]], ngContentSelectors: _c4, decls: 1, vars: 0, template: function BentoWizardComponentCustomButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoWizardComponentCustomButtonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'bento-wizard-custom-button-group',
                template: "\n    <ng-content></ng-content>\n  "
            }]
    }], function () { return []; }, null); })();
    return BentoWizardComponentCustomButtonGroupComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wizard/wizard-ellipsis.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoWizardComponentEllipsisDirective = /** @class */ (function () {
    function BentoWizardComponentEllipsisDirective(elRef, sanitizer) {
        this.sanitizer = sanitizer;
        this._nativeElement = elRef.nativeElement;
    }
    Object.defineProperty(BentoWizardComponentEllipsisDirective.prototype, "bentoEllipsisText", {
        set: /**
         * @param {?} text
         * @return {?}
         */
        function (text) {
            this._eText = text;
            this.checkEllipsis();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Implements OnInit
     */
    /**
     * Implements OnInit
     * @return {?}
     */
    BentoWizardComponentEllipsisDirective.prototype.ngOnInit = /**
     * Implements OnInit
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscription = this.bentoWizardComponentEllipsis.subscribe((/**
         * @return {?}
         */
        function () {
            _this.checkEllipsis();
        }));
    };
    /**
     * Implements OnDestroy
     */
    /**
     * Implements OnDestroy
     * @return {?}
     */
    BentoWizardComponentEllipsisDirective.prototype.ngOnDestroy = /**
     * Implements OnDestroy
     * @return {?}
     */
    function () {
        this.subscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    BentoWizardComponentEllipsisDirective.prototype.checkEllipsis = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var txtElem = this._nativeElement;
        /** @type {?} */
        var str = this.sanitizer.sanitize(SecurityContext.HTML, this._eText);
        txtElem.innerHTML = str;
        txtElem.style.pointerEvents = '';
        if (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
            while (txtElem.scrollHeight - 1 > txtElem.clientHeight) {
                /** @type {?} */
                var lastIndex = str.lastIndexOf(' ');
                str = str.substring(0, lastIndex);
                txtElem.innerHTML = str + '&hellip;';
                if (lastIndex <= 1) {
                    break;
                }
            }
        }
    };
    /** @nocollapse */
    BentoWizardComponentEllipsisDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: DomSanitizer }
    ]; };
    BentoWizardComponentEllipsisDirective.propDecorators = {
        bentoEllipsisText: [{ type: Input }],
        bentoWizardComponentEllipsis: [{ type: Input }]
    };
BentoWizardComponentEllipsisDirective.ɵfac = function BentoWizardComponentEllipsisDirective_Factory(t) { return new (t || BentoWizardComponentEllipsisDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
BentoWizardComponentEllipsisDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoWizardComponentEllipsisDirective, selectors: [["", "bentoWizardComponentEllipsis", ""]], inputs: { bentoEllipsisText: "bentoEllipsisText", bentoWizardComponentEllipsis: "bentoWizardComponentEllipsis" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoWizardComponentEllipsisDirective, [{
        type: Directive,
        args: [{
                selector: '[bentoWizardComponentEllipsis]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc5.DomSanitizer }]; }, { bentoEllipsisText: [{
            type: Input
        }], bentoWizardComponentEllipsis: [{
            type: Input
        }] }); })();
    return BentoWizardComponentEllipsisDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentEllipsisDirective.prototype._nativeElement;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentEllipsisDirective.prototype._eText;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentEllipsisDirective.prototype.subscription;
    /** @type {?} */
    BentoWizardComponentEllipsisDirective.prototype.bentoWizardComponentEllipsis;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentEllipsisDirective.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wizard/wizard-step-strip.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoWizardComponentStripComponent = /** @class */ (function () {
    function BentoWizardComponentStripComponent(elRef, r, bentoNotification, logService, dir, uidGen, changeDetector) {
        var _this = this;
        this.r = r;
        this.logService = logService;
        this.uidGen = uidGen;
        this.changeDetector = changeDetector;
        // in pixels
        /**
         * Callback when the current step is changing
         * ~\@private
         */
        this.currentStepChanging = new EventEmitter();
        /**
         * Callback when the current step is changed
         * ~\@private
         */
        this.currentStepChange = new EventEmitter();
        this.stepUIDsChange = new EventEmitter();
        /**
         * Flag to determine if the side arrows should be rendered
         */
        this._useSideArrows = true;
        /**
         * Emit when ellipsis needs to be checked
         */
        this.checkEllipsis = new EventEmitter(true);
        this.isLeftArrowDisabled = false;
        this.isRightArrowDisabled = false;
        this.numSteps = 0;
        this.displayCount = 0;
        this.leftIndex = 0;
        this.resizeSubscription = Subscription.EMPTY;
        this.stepsSubscription = Subscription.EMPTY;
        this.bidiSubscription = Subscription.EMPTY;
        this.el = elRef.nativeElement;
        this.resizeSubscription = bentoNotification.resizeNotification.subscribe((/**
         * @return {?}
         */
        function () { return _this._onResize(); }));
        this.isRTL = dir.value === 'rtl';
        this.bidiSubscription = dir.change.subscribe((/**
         * @return {?}
         */
        function () {
            _this.isRTL = dir.value === 'rtl';
        }));
    }
    Object.defineProperty(BentoWizardComponentStripComponent.prototype, "_steps", {
        /**
         * Used to update the first set of steps
         */
        set: /**
         * Used to update the first set of steps
         * @param {?} s
         * @return {?}
         */
        function (s) {
            this.steps = s;
            this.stepsArray = s.toArray();
            this.stepUIDs = [];
            if (s) {
                for (var i = 0; i < s.length; i++) {
                    this.stepUIDs[i] = this.uidGen.generate();
                }
            }
            this.stepUIDsChange.emit(this.stepUIDs.slice());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoWizardComponentStripComponent.prototype, "currentStep", {
        /**
         * Current step setter
         */
        set: /**
         * Current step setter
         * @param {?} step
         * @return {?}
         */
        function (step) {
            // Bypass if the value is out of boundary or the steps aren't even ready to render
            if (!this.steps || (step && step >= this.steps.length) || step < 0) {
                this.logService.warn('Bento Wizard: ' +
                    'Trying to assign `currentStep` but contents and steps are not ready. ' +
                    ' Try to assign during `ngAfterViewInit` or similar life hooks.');
                return;
            }
            // if(step === 0 && this.isRTL) {
            //   // for RTL reset the currentStep to the last step
            //   this._currentStep = this.steps.length - 1;
            // } else {
            //   this._currentStep = step;
            // }
            this._currentStep = step;
            this.showStep(step);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BentoWizardComponentStripComponent.prototype, "useSideArrows", {
        set: /**
         * @param {?} bool
         * @return {?}
         */
        function (bool) {
            this._useSideArrows = bool;
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Callback for any resize events for re-rendering
     */
    /**
     * Callback for any resize events for re-rendering
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype._onResize = /**
     * Callback for any resize events for re-rendering
     * @return {?}
     */
    function () {
        this.render();
    };
    /**
     * Need to handle memory cleanup
     */
    /**
     * Need to handle memory cleanup
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.ngOnDestroy = /**
     * Need to handle memory cleanup
     * @return {?}
     */
    function () {
        this.resizeSubscription.unsubscribe();
        this.stepsSubscription.unsubscribe();
        this.bidiSubscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.stepsObservable) {
            this.logService.error('Bento Wizard: [stepsObsersable] is missing');
        }
        else {
            // Subscribe to steps data change
            this.stepsSubscription = this.stepsObservable.subscribe((/**
             * @param {?} steps
             * @return {?}
             */
            function (steps) {
                _this.steps = steps;
                _this.stepsArray = steps.toArray();
                _this.render();
                // Default to the first step
                if (typeof _this._currentStep === 'undefined') {
                    _this._onStepClick(0, false, true);
                }
            }));
        }
    };
    /**
     * Fire first render when the view is ready
     */
    /**
     * Fire first render when the view is ready
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.ngAfterViewInit = /**
     * Fire first render when the view is ready
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.marginSide = _this.isRTL ? 'marginRight' : 'marginLeft';
            _this.render();
        }));
    };
    /**
     * render this strip
     */
    /**
     * render this strip
     * @param {?=} updateArrows
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.render = /**
     * render this strip
     * @param {?=} updateArrows
     * @return {?}
     */
    function (updateArrows) {
        var _this = this;
        if (updateArrows === void 0) { updateArrows = true; }
        if (!this.container) {
            this.container = (/** @type {?} */ (this.el.querySelector('.bento-wizard-steps')));
            this.ol = (/** @type {?} */ (this.container.querySelector('.steps')));
        }
        this.numSteps = this.steps.length;
        if (this.numSteps === 0) {
            // There is no step to render
            return;
        }
        /** @type {?} */
        var width = this.el.offsetWidth;
        // Set the total step object to be displayed
        // in wizard viewport based on its width
        this.displayCount = this.numSteps > 4 ? 4 : this.numSteps; // Default step count
        // Refine displayCount based on the width and numSteps
        if (width < 360 && this.displayCount > 1) {
            this.displayCount = 1;
        }
        else if (width < 720 && this.displayCount > 2) {
            this.displayCount = 2;
        }
        else if (width < 960 && this.displayCount > 3) {
            this.displayCount = 3;
        }
        else if (BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH * this.displayCount +
            (this.displayCount - 1) * BentoWizardComponentStripComponent.STEP_PADDING <
            width &&
            this.numSteps > this.displayCount) {
            this.displayCount = Math.ceil(width / BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH);
        }
        if (this._useSideArrows) {
            if (this.displayCount < this.numSteps) {
                this.r.addClass(this.el, 'side-arrows');
                width -= BentoWizardComponentStripComponent.GAP * 2;
            }
            else {
                this.r.removeClass(this.el, 'side-arrows');
            }
        }
        else {
            this.r.removeClass(this.el, 'side-arrows');
        }
        // Set list container width based on the total step count
        // and their widths
        this._boxWidth =
            (width - (this.displayCount - 1) * BentoWizardComponentStripComponent.STEP_PADDING) / this.displayCount;
        // Cap the step box width
        this._boxWidth =
            this._boxWidth > BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH
                ? BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH
                : this._boxWidth;
        this.r.setStyle(this.ol, 'width', this.numSteps * (this._boxWidth + BentoWizardComponentStripComponent.STEP_PADDING) + 'px');
        if (this._currentStep >= this.numSteps) {
            this._currentStep = this.numSteps - 1;
        }
        this._updateStepContainerOffset(updateArrows);
        setTimeout((/**
         * @return {?}
         */
        function () { return _this.checkEllipsis.emit(); }));
        this.changeDetector.markForCheck();
    };
    // Update step location
    // Update step location
    /**
     * @param {?=} updateArrows
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype._updateStepContainerOffset = 
    // Update step location
    /**
     * @param {?=} updateArrows
     * @return {?}
     */
    function (updateArrows) {
        if (updateArrows === void 0) { updateArrows = true; }
        // Variables to be used for calculation
        /** @type {?} */
        var stepArray = this.ol.children;
        // find the left index
        this.leftIndex = 0;
        if (this.displayCount < this.numSteps) {
            for (var i = 0; i < stepArray.length; i++) {
                /** @type {?} */
                var step = (/** @type {?} */ (stepArray[i]));
                if (step.offsetLeft <= 0 && step.offsetLeft + step.offsetWidth > 0) {
                    this.leftIndex = i;
                    break;
                }
            }
            if (this._currentStep < this.leftIndex) {
                this.leftIndex = this._currentStep;
            }
            else if (this._currentStep > this.leftIndex + this.displayCount) {
                this.leftIndex = this._currentStep - this.displayCount + 1;
            }
            else if (this.leftIndex + this.displayCount > this.numSteps - 1) {
                this.leftIndex = this.numSteps - this.displayCount;
            }
            if (updateArrows) {
                this._updateLeftRightArrows();
            }
        }
        this.r.setStyle(this.ol, this.marginSide, -(this._boxWidth * this.leftIndex) + 'px');
    };
    /**
     * Handle
     */
    /**
     * Handle
     * @param {?} step
     * @param {?=} disabled
     * @param {?=} skipChangingCallback
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype._onStepClick = /**
     * Handle
     * @param {?} step
     * @param {?=} disabled
     * @param {?=} skipChangingCallback
     * @return {?}
     */
    function (step, disabled, skipChangingCallback) {
        var _this = this;
        if (disabled === void 0) { disabled = false; }
        if (skipChangingCallback === void 0) { skipChangingCallback = false; }
        // For browsers still capture clicks
        if (disabled || this._currentStep === step) {
            return;
        }
        /** @type {?} */
        var hasCancellable = false;
        if (!skipChangingCallback) {
            this.currentStepChanging.emit(new BentoWizardComponentEvent(step, this._currentStep, (/**
             * @param {?=} cancellable
             * @return {?}
             */
            function (cancellable) {
                hasCancellable = true;
                if (!!cancellable && cancellable.subscribe) {
                    cancellable.subscribe((/**
                     * @param {?} response
                     * @return {?}
                     */
                    function (response) {
                        if (response) {
                            _this._currentStep = step;
                            _this.currentStepChange.emit(step);
                        }
                    }));
                }
            })));
        }
        if (!hasCancellable) {
            this._currentStep = step;
            this.currentStepChange.emit(step);
        }
    };
    /**
     * Callback when a step has a keydown
     */
    /**
     * Callback when a step has a keydown
     * @param {?} event
     * @param {?} step
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype._onKeydown = /**
     * Callback when a step has a keydown
     * @param {?} event
     * @param {?} step
     * @return {?}
     */
    function (event, step) {
        /** @type {?} */
        var el = (/** @type {?} */ (event.currentTarget));
        switch (event.keyCode) {
            case Keyboard.LEFT:
                if (this.isRTL) {
                    this.focusNextSibling(el, step);
                }
                else {
                    this.focusPreviousSibling(el, step);
                }
                event.stopPropagation();
                event.preventDefault();
                break;
            case Keyboard.RIGHT:
                if (this.isRTL) {
                    this.focusPreviousSibling(el, step);
                }
                else {
                    this.focusNextSibling(el, step);
                }
                event.stopPropagation();
                event.preventDefault();
                break;
            case Keyboard.HOME:
                this.focusToStepEl((/** @type {?} */ (el.parentElement.firstElementChild)), 0);
                event.stopPropagation();
                event.preventDefault();
                break;
            case Keyboard.END:
                this.focusToStepEl((/** @type {?} */ (el.parentElement.lastElementChild)), this.numSteps - 1);
                event.stopPropagation();
                event.preventDefault();
                break;
        }
    };
    /**
     * Callback when left arrow is clicked
     */
    /**
     * Callback when left arrow is clicked
     * @param {?} $event
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype._onLeftArrowClick = /**
     * Callback when left arrow is clicked
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.leftIndex = Math.max(0, this.displayCount === 2 ? this.leftIndex - 1 : this.leftIndex - this.displayCount);
        this.r.setStyle(this.ol, this.marginSide, -this.leftIndex * this._boxWidth + 'px');
        this._updateLeftRightArrows();
    };
    /**
     * Callback when right arrow is clicked
     */
    /**
     * Callback when right arrow is clicked
     * @param {?} $event
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype._onRightArrowClick = /**
     * Callback when right arrow is clicked
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        // Prevent the <button> component from form submission
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        this.leftIndex = Math.min(this.displayCount === 2 ? this.leftIndex + 1 : this.leftIndex + this.displayCount, this.numSteps - this.displayCount);
        this.r.setStyle(this.ol, this.marginSide, -this.leftIndex * this._boxWidth + 'px');
        this._updateLeftRightArrows();
    };
    /**
     * Update the side arrows based on the current scroll
     */
    /**
     * Update the side arrows based on the current scroll
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype._updateLeftRightArrows = /**
     * Update the side arrows based on the current scroll
     * @return {?}
     */
    function () {
        if (typeof this.displayCount === 'undefined') {
            return;
        }
        this.isLeftArrowDisabled = this.leftIndex === 0;
        this.isRightArrowDisabled = this.leftIndex + this.displayCount >= this.numSteps;
    };
    /**
     * @private
     * @param {?} el
     * @param {?} step
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.focusPreviousSibling = /**
     * @private
     * @param {?} el
     * @param {?} step
     * @return {?}
     */
    function (el, step) {
        /** @type {?} */
        var nextStepToShow = (this.numSteps - 1 + step) % this.numSteps;
        if (el.previousElementSibling) {
            this.focusToStepEl((/** @type {?} */ (el.previousElementSibling)), nextStepToShow);
        }
        else {
            this.focusToStepEl((/** @type {?} */ (el.parentElement.lastElementChild)), nextStepToShow);
        }
    };
    /**
     * @private
     * @param {?} el
     * @param {?} step
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.focusNextSibling = /**
     * @private
     * @param {?} el
     * @param {?} step
     * @return {?}
     */
    function (el, step) {
        /** @type {?} */
        var nextStepToShow = (1 + step) % this.numSteps;
        if (el.nextElementSibling) {
            this.focusToStepEl((/** @type {?} */ (el.nextElementSibling)), nextStepToShow);
        }
        else {
            this.focusToStepEl((/** @type {?} */ (el.parentElement.firstElementChild)), nextStepToShow);
        }
    };
    /**
     * @private
     * @param {?} el
     * @param {?} step
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.focusToStepEl = /**
     * @private
     * @param {?} el
     * @param {?} step
     * @return {?}
     */
    function (el, step) {
        setTimeout((/**
         * @return {?}
         */
        function () {
            el.focus();
        }), 200 // There is a .2s transition
        );
        this.showStep(step);
    };
    /**
     * @private
     * @param {?} step
     * @return {?}
     */
    BentoWizardComponentStripComponent.prototype.showStep = /**
     * @private
     * @param {?} step
     * @return {?}
     */
    function (step) {
        if (this.displayCount === 2) {
            if (step < this.leftIndex) {
                this.leftIndex = step;
            }
            else if (step >= this.leftIndex + this.displayCount) {
                this.leftIndex = step - this.displayCount + 1;
            }
            else if (step === this.leftIndex && step !== 0) {
                this.leftIndex--;
            }
            else if (step === this.leftIndex + 1 && step !== this.numSteps - 1) {
                this.leftIndex++;
            }
        }
        else if (this.displayCount > 2) {
            if (step === 0) {
                this.leftIndex = 0;
            }
            else if (step === this.numSteps - 1) {
                // Sometimes `displayCounter` can be bigger than `numSteps`
                // so `leftIndex` has to be >= 0
                this.leftIndex = Math.max(this.numSteps - this.displayCount, 0);
            }
            else if (step < this.leftIndex) {
                this.leftIndex = step - 1;
            }
            else if (step >= this.leftIndex + this.displayCount) {
                this.leftIndex = step - this.displayCount + 2;
            }
            else if (step === this.leftIndex + this.displayCount - 1) {
                this.leftIndex++;
            }
            else if (step === this.leftIndex) {
                this.leftIndex--;
            }
        }
        // Make if the DOM is ready then move boxes
        if (this.ol) {
            this.r.setStyle(this.ol, this.marginSide, -this.leftIndex * this._boxWidth + 'px');
        }
        this._updateLeftRightArrows();
    };
    BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH = 350;
    BentoWizardComponentStripComponent.STEP_PADDING = 0;
    BentoWizardComponentStripComponent.GAP = 37;
    /** @nocollapse */
    BentoWizardComponentStripComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: BentoNotification },
        { type: BentoLogService },
        { type: Directionality },
        { type: BentoUidService },
        { type: ChangeDetectorRef }
    ]; };
    BentoWizardComponentStripComponent.propDecorators = {
        currentStepChanging: [{ type: Output }],
        currentStepChange: [{ type: Output }],
        stepsObservable: [{ type: Input }],
        _steps: [{ type: Input, args: ['steps',] }],
        hTag: [{ type: Input }],
        stepUIDsChange: [{ type: Output }],
        currentStep: [{ type: Input }],
        useSideArrows: [{ type: Input }]
    };
BentoWizardComponentStripComponent.ɵfac = function BentoWizardComponentStripComponent_Factory(t) { return new (t || BentoWizardComponentStripComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoNotification), ɵngcc0.ɵɵdirectiveInject(BentoLogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Directionality), ɵngcc0.ɵɵdirectiveInject(BentoUidService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BentoWizardComponentStripComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BentoWizardComponentStripComponent, selectors: [["bento-wizard-strip"]], inputs: { _steps: ["steps", "_steps"], currentStep: "currentStep", useSideArrows: "useSideArrows", stepsObservable: "stepsObservable", hTag: "hTag" }, outputs: { currentStepChanging: "currentStepChanging", currentStepChange: "currentStepChange", stepUIDsChange: "stepUIDsChange" }, features: [ɵngcc0.ɵɵProvidersFeature([BentoNotification]
        // changeDetection: ChangeDetectionStrategy.OnPush
        )], decls: 11, vars: 15, consts: [["type", "button", 1, "wizard-arrow", "arrow-left", "flat", 3, "disabled", "ngbTooltip", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-left"], ["type", "button", 1, "wizard-arrow", "arrow-right", "flat", 3, "disabled", "ngbTooltip", "click"], ["aria-hidden", "true", 1, "bento-icon-chevron-large-right"], [1, "bento-wizard-steps"], ["role", "tablist", 1, "steps"], ["class", "bento-wizard-step flat", "role", "tab", 3, "ngClass", "disabled", "width", "keydown", "click", 4, "ngFor", "ngForOf"], ["role", "tab", 1, "bento-wizard-step", "flat", 3, "ngClass", "disabled", "keydown", "click"], [1, "bento-wizard-step-count"], ["class", "title h5 wizard-title", 4, "replaceTag"], [1, "description", 3, "bentoWizardComponentEllipsis", "bentoEllipsisText"], [1, "bentop-wizard-step-selection-indicator"], [1, "title", "h5", "wizard-title"], ["role", "img", 1, "bento-icon-", "bento-wizard-step-complete-icon"]], template: function BentoWizardComponentStripComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function BentoWizardComponentStripComponent_Template_button_click_0_listener($event) { return ctx._onLeftArrowClick($event); });
        ɵngcc0.ɵɵpipe(1, "bentoTranslate");
        ɵngcc0.ɵɵpipe(2, "bentoTranslate");
        ɵngcc0.ɵɵelement(3, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵlistener("click", function BentoWizardComponentStripComponent_Template_button_click_4_listener($event) { return ctx._onRightArrowClick($event); });
        ɵngcc0.ɵɵpipe(5, "bentoTranslate");
        ɵngcc0.ɵɵpipe(6, "bentoTranslate");
        ɵngcc0.ɵɵelement(7, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵtemplate(10, BentoWizardComponentStripComponent_button_10_Template, 5, 11, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind1(2, 9, "BENTO_UI_WIZARD_LEFT"));
        ɵngcc0.ɵɵproperty("disabled", ctx.isLeftArrowDisabled);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 7, "BENTO_UI_WIZARD_LEFT"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind1(6, 13, "BENTO_UI_WIZARD_RIGHT"));
        ɵngcc0.ɵɵproperty("disabled", ctx.isRightArrowDisabled);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(5, 11, "BENTO_UI_WIZARD_RIGHT"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.stepsArray);
    } }, directives: [ɵngcc4.NgbTooltip, BentoNgbTooltipSupportDirective, ɵngcc7.NgForOf, ɵngcc7.NgClass, BentoReplaceTagDirective,
        BentoWizardComponentEllipsisDirective], pipes: [BentoTranslatePipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoWizardComponentStripComponent, [{
        type: Component,
        args: [{
                selector: 'bento-wizard-strip',
                template: "<button\n  class=\"wizard-arrow arrow-left flat\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_WIZARD_LEFT' | bentoTranslate\"\n  [disabled]=\"isLeftArrowDisabled\"\n  (click)=\"_onLeftArrowClick($event)\"\n  ngbTooltip=\"{{ 'BENTO_UI_WIZARD_LEFT' | bentoTranslate }}\"\n>\n  <i class=\"bento-icon-chevron-large-left\" aria-hidden=\"true\"></i>\n</button>\n<button\n  class=\"wizard-arrow arrow-right flat\"\n  type=\"button\"\n  [attr.aria-label]=\"'BENTO_UI_WIZARD_RIGHT' | bentoTranslate\"\n  [disabled]=\"isRightArrowDisabled\"\n  (click)=\"_onRightArrowClick($event)\"\n  ngbTooltip=\"{{ 'BENTO_UI_WIZARD_RIGHT' | bentoTranslate }}\"\n>\n  <i class=\"bento-icon-chevron-large-right\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"bento-wizard-steps\">\n  <div class=\"steps\" role=\"tablist\">\n    <button\n      *ngFor=\"let step of stepsArray; let i = index\"\n      class=\"bento-wizard-step flat\"\n      role=\"tab\"\n      [attr.tabindex]=\"i === _currentStep ? '0' : '-1'\"\n      [attr.aria-selected]=\"i === _currentStep\"\n      [ngClass]=\"\n        (i === _currentStep ? 'selected ' : '') +\n        (step.disabled ? 'disabled ' : '') +\n        (step.completed ? 'completed ' : '')\n      \"\n      [disabled]=\"step.disabled\"\n      (keydown)=\"_onKeydown($event, i)\"\n      (click)=\"_onStepClick(i, step.disabled)\"\n      [style.width.px]=\"_boxWidth\"\n      [attr.id]=\"stepUIDs[i]\"\n      [attr.aria-controls]=\"'tab-' + stepUIDs[i]\"\n    >\n      <div class=\"bento-wizard-step-count\"></div>\n      <span *replaceTag=\"hTag\" class=\"title h5 wizard-title\">\n        <i\n          role=\"img\"\n          class=\"bento-icon- bento-wizard-step-complete-icon\"\n          [attr.aria-label]=\"'BENTO_UI_WIZARD_COMPLETE_LABEL' | bentoTranslate\"\n        ></i>\n        {{ step.title }}\n      </span>\n      <span\n        class=\"description\"\n        [bentoWizardComponentEllipsis]=\"checkEllipsis\"\n        [bentoEllipsisText]=\"step.description\"\n      ></span>\n      <div class=\"bentop-wizard-step-selection-indicator\"></div>\n    </button>\n  </div>\n</div>\n",
                providers: [BentoNotification]
                // changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: BentoNotification }, { type: BentoLogService }, { type: ɵngcc6.Directionality }, { type: BentoUidService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { currentStepChanging: [{
            type: Output
        }], currentStepChange: [{
            type: Output
        }], stepUIDsChange: [{
            type: Output
        }], _steps: [{
            type: Input,
            args: ['steps']
        }], currentStep: [{
            type: Input
        }], useSideArrows: [{
            type: Input
        }], stepsObservable: [{
            type: Input
        }], hTag: [{
            type: Input
        }] }); })();
    return BentoWizardComponentStripComponent;
}());
if (false) {
    /** @type {?} */
    BentoWizardComponentStripComponent.MAX_STEP_BOX_WIDTH;
    /** @type {?} */
    BentoWizardComponentStripComponent.STEP_PADDING;
    /** @type {?} */
    BentoWizardComponentStripComponent.GAP;
    /**
     * Callback when the current step is changing
     * ~\@private
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype.currentStepChanging;
    /**
     * Callback when the current step is changed
     * ~\@private
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype.currentStepChange;
    /**
     * Steps observable
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype.stepsObservable;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.steps;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.stepsArray;
    /**
     * A11y: Specify header tag for wizard's Title. The header tag's rank must be
     * in hierarchical order to the page in which the component is used.
     * Headings communicate the organization of the content on the page. Web
     * browsers, plug-ins, and assistive technologies can use them to provide
     * in-page navigation.
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype.hTag;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.stepUIDsChange;
    /**
     * Main internal step tracker
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype._currentStep;
    /**
     * Flag to determine if the side arrows should be rendered
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype._useSideArrows;
    /**
     * Emit when ellipsis needs to be checked
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype.checkEllipsis;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.container;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.el;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.isLeftArrowDisabled;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.isRightArrowDisabled;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.ol;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype.stepUIDs;
    /** @type {?} */
    BentoWizardComponentStripComponent.prototype._boxWidth;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.numSteps;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.displayCount;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.leftIndex;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.stepsSubscription;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.marginSide;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.bidiSubscription;
    /**
     * Use isRtl as flag to determine if in RTL mode or not
     * @type {?}
     */
    BentoWizardComponentStripComponent.prototype.isRTL;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.logService;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.uidGen;
    /**
     * @type {?}
     * @private
     */
    BentoWizardComponentStripComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wizard/wizard.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoWizardComponentModule = /** @class */ (function () {
    function BentoWizardComponentModule() {
    }
BentoWizardComponentModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoWizardComponentModule });
BentoWizardComponentModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoWizardComponentModule_Factory(t) { return new (t || BentoWizardComponentModule)(); }, imports: [[
            CommonModule,
            BentoTranslateModule,
            BentoUtilsModule,
            BentoStickyFooterModule,
            A11yModule,
            BentoFocusMonitorModule,
            NgbTooltipModule,
            BentoNgbTooltipSupportModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoWizardComponentModule, { declarations: function () { return [BentoWizardComponent,
        BentoWizardStepComponent,
        BentoWizardComponentStripComponent,
        BentoWizardComponentEllipsisDirective,
        BentoWizardComponentCustomButtonGroupComponent]; }, imports: function () { return [CommonModule,
        BentoTranslateModule,
        BentoUtilsModule,
        BentoStickyFooterModule,
        A11yModule,
        BentoFocusMonitorModule,
        NgbTooltipModule,
        BentoNgbTooltipSupportModule]; }, exports: function () { return [BentoWizardComponent,
        BentoWizardStepComponent,
        BentoWizardComponentCustomButtonGroupComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoWizardComponentModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BentoTranslateModule,
                    BentoUtilsModule,
                    BentoStickyFooterModule,
                    A11yModule,
                    BentoFocusMonitorModule,
                    NgbTooltipModule,
                    BentoNgbTooltipSupportModule
                ],
                declarations: [
                    BentoWizardComponent,
                    BentoWizardStepComponent,
                    BentoWizardComponentStripComponent,
                    BentoWizardComponentEllipsisDirective,
                    BentoWizardComponentCustomButtonGroupComponent
                ],
                exports: [BentoWizardComponent, BentoWizardStepComponent, BentoWizardComponentCustomButtonGroupComponent]
            }]
    }], function () { return []; }, null); })();
    return BentoWizardComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form/input-group-prepend.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A directive to render Bootstraps `.input-group-prepend` element when used with Bento
 * form controls such as Number Input and Combobox components.
 */
var BentoInputGroupPrependDirective = /** @class */ (function () {
    function BentoInputGroupPrependDirective(elRef, sanitizer, r, logger) {
        this.sanitizer = sanitizer;
        this.r = r;
        this.logger = logger;
        this.el = elRef.nativeElement;
        this.prependEl = this.r.createElement('div');
        this.r.addClass(this.prependEl, 'input-group-prepend');
    }
    Object.defineProperty(BentoInputGroupPrependDirective.prototype, "inputGroupPrepend", {
        get: /**
         * @return {?}
         */
        function () {
            return this.prependHTML;
        },
        /**
         * Static HTML/Text that defines the content of an input group prepend element
         */
        set: /**
         * Static HTML/Text that defines the content of an input group prepend element
         * @param {?} html
         * @return {?}
         */
        function (html) {
            this.prependHTML = "<div class=\"input-group-text\">" + this.sanitizer.sanitize(SecurityContext.HTML, html) + "</div>";
            this.r.setProperty(this.prependEl, 'innerHTML', this.prependHTML);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BentoInputGroupPrependDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.injectPrependEl();
    };
    /**
     * @private
     * @return {?}
     */
    BentoInputGroupPrependDirective.prototype.injectPrependEl = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var inputEl = this.el.tagName === 'INPUT' ? this.el : this.el.querySelector('input.form-control');
        if (inputEl && inputEl.classList.contains('form-control')) {
            /** @type {?} */
            var wrapperEl = inputEl.parentElement;
            this.r.addClass(wrapperEl, 'input-group');
            wrapperEl.insertBefore(this.prependEl, inputEl);
        }
        else {
            this.logger.warn('BentoInputGroupPrependDirective: Missing `input.form-control`');
        }
    };
    /** @nocollapse */
    BentoInputGroupPrependDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: DomSanitizer },
        { type: Renderer2 },
        { type: BentoLogService }
    ]; };
    BentoInputGroupPrependDirective.propDecorators = {
        inputGroupPrepend: [{ type: Input }]
    };
BentoInputGroupPrependDirective.ɵfac = function BentoInputGroupPrependDirective_Factory(t) { return new (t || BentoInputGroupPrependDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BentoLogService)); };
BentoInputGroupPrependDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BentoInputGroupPrependDirective, selectors: [["", "inputGroupPrepend", "", 3, "type", "slider", 3, "type", "checkbox", 3, "type", "radio", 3, "type", "file", 3, "type", "button", 3, "type", "range"]], inputs: { inputGroupPrepend: "inputGroupPrepend" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoInputGroupPrependDirective, [{
        type: Directive,
        args: [{
                selector: ':not([type=slider]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=button]):not([type=range])[inputGroupPrepend]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc5.DomSanitizer }, { type: ɵngcc0.Renderer2 }, { type: BentoLogService }]; }, { inputGroupPrepend: [{
            type: Input
        }] }); })();
    return BentoInputGroupPrependDirective;
}());
if (false) {
    /** @type {?} */
    BentoInputGroupPrependDirective.prototype.prependEl;
    /** @type {?} */
    BentoInputGroupPrependDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    BentoInputGroupPrependDirective.prototype.prependHTML;
    /**
     * @type {?}
     * @private
     */
    BentoInputGroupPrependDirective.prototype.sanitizer;
    /**
     * @type {?}
     * @private
     */
    BentoInputGroupPrependDirective.prototype.r;
    /**
     * @type {?}
     * @private
     */
    BentoInputGroupPrependDirective.prototype.logger;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form/form.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BentoFormModule = /** @class */ (function () {
    function BentoFormModule() {
    }
BentoFormModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoFormModule });
BentoFormModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoFormModule_Factory(t) { return new (t || BentoFormModule)(); }, providers: [], imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoFormModule, { declarations: [BentoInputGroupPrependDirective], exports: [BentoInputGroupPrependDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoFormModule, [{
        type: NgModule,
        args: [{
                imports: [],
                exports: [BentoInputGroupPrependDirective],
                declarations: [BentoInputGroupPrependDirective],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return BentoFormModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker-mask/datepicker-config.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * DatepickerConfig. This is used for input for the BentoDatepickerConfigDirective.
 * @record
 */
function DatepickerConfig() { }
if (false) {
    /**
     * Date type. Can be 'recent' or 'dob'
     * When type is 'recent', a '20' is inserted at the beginning of the year
     * if the user types in 2 digits for year.
     * When type is 'dob', a '19' is inserted at the beginning if the two digits
     * are greater than or equal to the last two digits of the current year + 1.
     * Otherwise, a '20' is inserted.
     * For example, if '05/25/21' is entered, then '05/25/1921' will be entered
     * when leaving the field.
     * @type {?}
     */
    DatepickerConfig.prototype.type;
    /**
     * Date format. Can be 'mm/dd/yyyy', 'dd/mm/yyyy', 'yyyy-mm-dd', 'yy-mm-dd'.
     * 'yy-mm-dd' corresponds to Canadian date format.
     * @type {?}
     */
    DatepickerConfig.prototype.format;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter/universe-filter.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BentoUniverseFilterItemOptions() { }
if (false) {
    /**
     * Title of filter item
     * @type {?}
     */
    BentoUniverseFilterItemOptions.prototype.title;
    /**
     * Template override
     * @type {?|undefined}
     */
    BentoUniverseFilterItemOptions.prototype.modalTemplateUrl;
    /**
     * Custom Modal Component (overrides modalTemplateUrl and default template).
     * Within the component template, use `filterItem` to access the selected filter
     * item and `filterItems` to access the entire items in the Universe Filter.
     * @type {?|undefined}
     */
    BentoUniverseFilterItemOptions.prototype.modalComponent;
    /**
     * Override for default sub-title text. Typically it is an actionable text, where the default value is 'Select'
     * @type {?|undefined}
     */
    BentoUniverseFilterItemOptions.prototype.selectText;
    /**
     * Array of items to select from
     * @type {?|undefined}
     */
    BentoUniverseFilterItemOptions.prototype.items;
    /**
     * This property is set when an item is selected. You can also use it to pre-select the filter.
     * @type {?|undefined}
     */
    BentoUniverseFilterItemOptions.prototype.selectedName;
}
/**
 * @record
 */
function BentoUniverseFilterItem() { }
if (false) {
    /**
     * Title of item
     * @type {?}
     */
    BentoUniverseFilterItem.prototype.title;
    /* Skipping unhandled member: [name: string]: any;*/
}
/**
 * emitted object from onFilterItemChanged event
 * @record
 */
function BentoUniverseFilterItemChangedEvent() { }
if (false) {
    /**
     * Selected item
     * @type {?}
     */
    BentoUniverseFilterItemChangedEvent.prototype.selectedItem;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/universe-filter-dropdown/universe-filter-dropdown.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BentoUniverseFilterDropdownItemOptions() { }
if (false) {
    /**
     * Title of filter item
     * @type {?}
     */
    BentoUniverseFilterDropdownItemOptions.prototype.title;
    /**
     * Template override
     * @type {?|undefined}
     */
    BentoUniverseFilterDropdownItemOptions.prototype.templateUrl;
    /**
     * Override for default sub-title text. Typically it is an actionable text, where the default value is 'Select'
     * @type {?|undefined}
     */
    BentoUniverseFilterDropdownItemOptions.prototype.selectText;
    /**
     * Array of items to select from
     * @type {?|undefined}
     */
    BentoUniverseFilterDropdownItemOptions.prototype.items;
    /**
     * This property is set when an item is selected. You can also use it to pre-select the filter.
     * @type {?|undefined}
     */
    BentoUniverseFilterDropdownItemOptions.prototype.selectedName;
    /* Skipping unhandled member: [name: string]: any;*/
}
/**
 * @record
 */
function BentoUniverseFilterDropdownItem() { }
if (false) {
    /**
     * Title of item
     * @type {?}
     */
    BentoUniverseFilterDropdownItem.prototype.title;
    /* Skipping unhandled member: [name: string]: any;*/
}
/**
 * emitted object from onFilterItemChanged event
 * @record
 */
function BentoUniverseFilterDropdownItemChangedEvent() { }
if (false) {
    /**
     * Selected item
     * @type {?}
     */
    BentoUniverseFilterDropdownItemChangedEvent.prototype.selectedItem;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// version number placeholder
/** @type {?} */
var BENTO_NG_VERSION = new Version('10.3.1');
var BentoModule = /** @class */ (function () {
    function BentoModule(appRef, rFactory) {
        /** @type {?} */
        var s = appRef.isStable.subscribe((/**
         * @param {?} isStable
         * @return {?}
         */
        function (isStable) {
            if (appRef.components[0] && isStable) {
                // When Application is bootstrapped
                /** @type {?} */
                var rootComponentRef = appRef.components[0];
                /** @type {?} */
                var appEl = rootComponentRef.location.nativeElement;
                // Assign Bento NG full version to app element's attribute
                /** @type {?} */
                var r = rFactory.createRenderer(appEl, null);
                r.setAttribute(appEl, 'bento-ng-version', BENTO_NG_VERSION.full);
                s.unsubscribe();
                r = null;
                s = null;
            }
        }));
    }
    /** @nocollapse */
    BentoModule.ctorParameters = function () { return [
        { type: ApplicationRef },
        { type: RendererFactory2 }
    ]; };
BentoModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BentoModule });
BentoModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BentoModule_Factory(t) { return new (t || BentoModule)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2)); }, imports: [BentoAlertModule,
        BentoBadgeModule,
        BentoBusyLoaderModule,
        BentoCheckboxModule,
        BentoDatepickerToggleModule,
        BentoDatepickerAccessibilityModule,
        BentoDatepickerMaskModule,
        BentoFileSelectorModule,
        BentoGlobalHeaderModule,
        BentoListModule,
        BentoMegamenuModule,
        BentoMultiselectOverlayModule,
        BentoNumberInputModule,
        BentoOffCanvasMenuModule,
        BentoPaginationModule,
        BentoResetModule,
        BentoSelectModule,
        BentoSideNavModule,
        BentoSplitterGroupModule,
        BentoTabsModule,
        BentoTagsInputModule,
        BentoToggleModule,
        BentoToolbarModule,
        BentoTreeModule,
        BentoTransferboxBasicModule,
        BentoTranslateModule,
        BentoUtilsModule,
        BentoWizardComponentModule,
        BentoUniverseFilterDropdownModule,
        BentoUniverseFilterModule,
        BentoComboboxModule,
        BentoContextualHeaderModule,
        BentoAppendToModule,
        BentoExpandCollapseButtonGroupModule,
        BentoTimepickerModule,
        BentoSkipLinksModule,
        BentoStickyFooterModule,
        BentoStickyBarModule,
        BentoTileRibbonModule,
        BentoScrollableToolbarModule,
        BentoSmartBadgeModule,
        BentoFocusMonitorModule,
        BentoNgbTooltipSupportModule,
        BentoNgbDropdownAnimationModule,
        BentoNgbPopoverAnimationModule,
        BentoToastModule,
        BentoModalConfirmationModule,
        BentoFormModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BentoModule, { exports: [BentoAlertModule,
        BentoBadgeModule,
        BentoBusyLoaderModule,
        BentoCheckboxModule,
        BentoDatepickerToggleModule,
        BentoDatepickerAccessibilityModule,
        BentoDatepickerMaskModule,
        BentoFileSelectorModule,
        BentoGlobalHeaderModule,
        BentoListModule,
        BentoMegamenuModule,
        BentoMultiselectOverlayModule,
        BentoNumberInputModule,
        BentoOffCanvasMenuModule,
        BentoPaginationModule,
        BentoResetModule,
        BentoSelectModule,
        BentoSideNavModule,
        BentoSplitterGroupModule,
        BentoTabsModule,
        BentoTagsInputModule,
        BentoToggleModule,
        BentoToolbarModule,
        BentoTreeModule,
        BentoTransferboxBasicModule,
        BentoTranslateModule,
        BentoUtilsModule,
        BentoWizardComponentModule,
        BentoUniverseFilterDropdownModule,
        BentoUniverseFilterModule,
        BentoComboboxModule,
        BentoContextualHeaderModule,
        BentoAppendToModule,
        BentoExpandCollapseButtonGroupModule,
        BentoTimepickerModule,
        BentoSkipLinksModule,
        BentoStickyFooterModule,
        BentoStickyBarModule,
        BentoTileRibbonModule,
        BentoScrollableToolbarModule,
        BentoSmartBadgeModule,
        BentoFocusMonitorModule,
        BentoNgbTooltipSupportModule,
        BentoNgbDropdownAnimationModule,
        BentoNgbPopoverAnimationModule,
        BentoToastModule,
        BentoModalConfirmationModule,
        BentoFormModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BentoModule, [{
        type: NgModule,
        args: [{
                exports: [
                    BentoAlertModule,
                    BentoBadgeModule,
                    BentoBusyLoaderModule,
                    BentoCheckboxModule,
                    BentoDatepickerToggleModule,
                    BentoDatepickerAccessibilityModule,
                    BentoDatepickerMaskModule,
                    BentoFileSelectorModule,
                    BentoGlobalHeaderModule,
                    BentoListModule,
                    BentoMegamenuModule,
                    BentoMultiselectOverlayModule,
                    BentoNumberInputModule,
                    BentoOffCanvasMenuModule,
                    BentoPaginationModule,
                    BentoResetModule,
                    BentoSelectModule,
                    BentoSideNavModule,
                    BentoSplitterGroupModule,
                    BentoTabsModule,
                    BentoTagsInputModule,
                    BentoToggleModule,
                    BentoToolbarModule,
                    BentoTreeModule,
                    BentoTransferboxBasicModule,
                    BentoTranslateModule,
                    BentoUtilsModule,
                    BentoWizardComponentModule,
                    BentoUniverseFilterDropdownModule,
                    BentoUniverseFilterModule,
                    BentoComboboxModule,
                    BentoContextualHeaderModule,
                    BentoAppendToModule,
                    BentoExpandCollapseButtonGroupModule,
                    BentoTimepickerModule,
                    BentoSkipLinksModule,
                    BentoStickyFooterModule,
                    BentoStickyBarModule,
                    BentoTileRibbonModule,
                    BentoScrollableToolbarModule,
                    BentoSmartBadgeModule,
                    BentoFocusMonitorModule,
                    BentoNgbTooltipSupportModule,
                    BentoNgbDropdownAnimationModule,
                    BentoNgbPopoverAnimationModule,
                    BentoToastModule,
                    BentoModalConfirmationModule,
                    BentoFormModule
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.RendererFactory2 }]; }, null); })();
    return BentoModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: bento-bento-ng.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BENTO_NG_VERSION, BentoActionableItem, BentoAlertComponent, BentoAlertItemComponent, BentoAlertModule, BentoAppendToDirective, BentoAppendToModule, BentoBadgeComponent, BentoBadgeModule, BentoBusyLoaderDirective, BentoBusyLoaderModule, BentoCheckboxComponent, BentoCheckboxModule, BentoComboboxComponent, BentoComboboxListComponent, BentoComboboxModule, BentoComboboxSearchEvent, BentoContextualHeaderComponent, BentoContextualHeaderItem, BentoContextualHeaderModule, BentoDatepickerAccessibilityDirective, BentoDatepickerAccessibilityModule, BentoDatepickerConfigDirective, BentoDatepickerMaskModule, BentoDatepickerToggleDirective, BentoDatepickerToggleModule, BentoExpandCollapseButtonGroupComponent, BentoExpandCollapseButtonGroupModule, BentoFileSelectorComponent, BentoFileSelectorModule, BentoFileSizePipe, BentoFocusMonitorDirective, BentoFocusMonitorModule, BentoFooterTabHelper, BentoGlobalHeaderChangeDirective, BentoGlobalHeaderModule, BentoListComponent, BentoListModule, BentoLogService, BentoMegaMenuFlowComponent, BentoMegamenuComponent, BentoMegamenuDefaultComponent, BentoMegamenuModule, BentoMegamenuTakeoverComponent, BentoModalConfirmationCloseReason, BentoModalConfirmationModule, BentoModalConfirmationService, BentoModule, BentoMultiselectListComponent, BentoMultiselectOverlayComponent, BentoMultiselectOverlayModule, BentoNgbDropdownAnimationDirective, BentoNgbDropdownAnimationModule, BentoNgbDropdownAppendToDirective, BentoNgbPopoverAnimationDirective, BentoNgbPopoverAnimationModule, BentoNgbTooltipSupportDirective, BentoNgbTooltipSupportModule, BentoNotification, BentoNumberInputComponent, BentoNumberInputModule, BentoOffCanvasMenuComponent, BentoOffCanvasMenuModule, BentoPaginationComponent, BentoPaginationModule, BentoPositioning, BentoRefreshNotifierDirective, BentoReplaceTagDirective, BentoResetDirective, BentoResetModule, BentoRibbonTile, BentoRibbonTileComponent, BentoScrollableBarComponent, BentoScrollableBarModule, BentoScrollableToolbarComponent, BentoScrollableToolbarModule, BentoSelectDirective, BentoSelectModule, BentoSideNavComponent, BentoSideNavModule, BentoSkipLinksComponent, BentoSkipLinksModule, BentoSkipLinksService, BentoSmartBadgeComponent, BentoSmartBadgeDetails, BentoSmartBadgeModule, BentoSmartBadgeStyle, BentoSmartBadgeType, BentoSplitterGroupBottomComponent, BentoSplitterGroupComponent, BentoSplitterGroupLeftComponent, BentoSplitterGroupMainComponent, BentoSplitterGroupModule, BentoSplitterGroupRightComponent, BentoSplitterGroupSideComponent, BentoSplitterGroupTopComponent, BentoStickyBarDirective, BentoStickyBarModule, BentoStickyFooterComponent, BentoStickyFooterModule, BentoStringReplacePipe, BentoTabService, BentoTabsLabelComponent, BentoTabsModule, BentoTabsScrollComponent, BentoTagsInputComponent, BentoTagsInputEvent, BentoTagsInputModule, BentoTagsInputPillComponent, BentoTileRibbonComponent, BentoTileRibbonModule, BentoTimepickerDirective, BentoTimepickerModule, BentoToast, BentoToastContainerComponent, BentoToastModule, BentoToastRef, BentoToastService, BentoToggleComponent, BentoToggleConfig, BentoToggleModule, BentoToolbarComponent, BentoToolbarKeyboardSupportDirective, BentoToolbarModule, BentoTransferboxBasicComponent, BentoTransferboxBasicModule, BentoTransferlistComponent, BentoTransition, BentoTranslate, BentoTranslateModule, BentoTranslatePipe, BentoTreeComponent, BentoTreeItemCheckStatus, BentoTreeItemComponent, BentoTreeItemOption, BentoTreeModule, BentoTreeViewComponent, BentoUidService, BentoUniverseFilterComponent, BentoUniverseFilterDropdownComponent, BentoUniverseFilterDropdownModule, BentoUniverseFilterModule, BentoUtilsModule, BentoWizardComponent, BentoWizardComponentCustomButtonGroupComponent, BentoWizardComponentEllipsisDirective, BentoWizardComponentEvent, BentoWizardComponentModule, BentoWizardComponentStripComponent, BentoWizardStepComponent, BusyLoader, DEFAULT_LIST_HEIGHT, DEFAULT_LIST_MAX_HEIGHT, DEFAULT_LIST_WIDTH, DEFAULT_ROW_HEIGHT, EasingFunctions, FadeInOut, FadeInOutFunc, FadeInOutLong, Keyboard, Selection, SizeUnit, SkipLink, WindowRef, BentoPointerService as ɵa, BentoDatePickerConfig as ɵb, BentoDefaultNgbDateParserFormatter as ɵc, BentoFileSelectorComponentServices as ɵd, BentoListSubscribable as ɵe, BentoMegaMenuItemDirective as ɵf, BentoMegamenuHTagRankDirective as ɵg, BentoSideNavItemComponent as ɵh, BentoToolbarItemDirective as ɵi, BentoToolbarDropdownComponent as ɵj, BentoToolbarFilterPipe as ɵk, BentoTreeBranch as ɵl, BentoUniverseFilterDropdownMenuComponent as ɵm, BentoUniverseFilterDropdownEllipsisDirective as ɵn, BentoUniverseDropdownPositionDirective as ɵo, BentoUniverseFilterKeyboardSupportDirective as ɵp, BentoUniverseFilterEllipsisDirective as ɵq, BentoScrollableToolbarItemComponent as ɵr, BentoToastAnimationDirective as ɵs, BentoModalConfirmationComponent as ɵt, BentoFormModule as ɵu, BentoInputGroupPrependDirective as ɵv };

//# sourceMappingURL=bento-bento-ng.js.map